var ni = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Z2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function gt(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
function Cr(e) {
  return e && e.default || e;
}
function xe(e) {
  return (xe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(e);
}
function We(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function hy(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Xe(e, t, n) {
  return t && hy(e.prototype, t), n && hy(e, n), e;
}
function Fn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function dy(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Sa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dy(Object(n), !0).forEach(function(r) {
      Fn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dy(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $t(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && tf(e, t);
}
function rt(e) {
  return (rt = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(e);
}
function tf(e, t) {
  return (tf = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  })(e, t);
}
function g0(e, t, n) {
  return (g0 = function() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }() ? Reflect.construct : function(r, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var o = new (Function.bind.apply(r, s))();
    return a && tf(o, a.prototype), o;
  }).apply(null, arguments);
}
function eE(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return (eE = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1))
      return n;
    var r;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n))
        return t.get(n);
      t.set(n, i);
    }
    function i() {
      return g0(n, arguments, rt(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), tf(i, n);
  })(e);
}
function tE(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Gt(e, t) {
  return !t || typeof t != "object" && typeof t != "function" ? tE(e) : t;
}
function Yn(e, t, n) {
  return (Yn = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(r, i, a) {
    var s = function(u, c) {
      for (; !Object.prototype.hasOwnProperty.call(u, c) && (u = rt(u)) !== null; )
        ;
      return u;
    }(r, i);
    if (s) {
      var o = Object.getOwnPropertyDescriptor(s, i);
      return o.get ? o.get.call(a) : o.value;
    }
  })(e, t, n || e);
}
function bn(e, t) {
  return nE(e) || function(n, r) {
    if (Symbol.iterator in Object(n) || Object.prototype.toString.call(n) === "[object Arguments]") {
      var i = [], a = !0, s = !1, o = void 0;
      try {
        for (var u, c = n[Symbol.iterator](); !(a = (u = c.next()).done) && (i.push(u.value), !r || i.length !== r); a = !0)
          ;
      } catch (f) {
        s = !0, o = f;
      } finally {
        try {
          a || c.return == null || c.return();
        } finally {
          if (s)
            throw o;
        }
      }
      return i;
    }
  }(e, t) || iE();
}
function Mt(e) {
  return function(t) {
    if (Array.isArray(t)) {
      for (var n = 0, r = new Array(t.length); n < t.length; n++)
        r[n] = t[n];
      return r;
    }
  }(e) || rE(e) || function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}
function nE(e) {
  if (Array.isArray(e))
    return e;
}
function rE(e) {
  if (Symbol.iterator in Object(e) || Object.prototype.toString.call(e) === "[object Arguments]")
    return Array.from(e);
}
function iE() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var Re = gt(function(e) {
  var t = e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t);
}), v6 = {}.hasOwnProperty, At = function(e, t) {
  return v6.call(e, t);
}, pt = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, rn = !pt(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), hn = gt(function(e) {
  var t = e.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t);
}), ht = (hn.version, function(e) {
  return xe(e) === "object" ? e !== null : typeof e == "function";
}), Ct = function(e) {
  if (!ht(e))
    throw TypeError(e + " is not an object!");
  return e;
}, hm = Re.document, x6 = ht(hm) && ht(hm.createElement), bp = function(e) {
  return x6 ? hm.createElement(e) : {};
}, aE = !rn && !pt(function() {
  return Object.defineProperty(bp("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), Gi = function(e, t) {
  if (!ht(e))
    return e;
  var n, r;
  if (t && typeof (n = e.toString) == "function" && !ht(r = n.call(e)) || typeof (n = e.valueOf) == "function" && !ht(r = n.call(e)) || !t && typeof (n = e.toString) == "function" && !ht(r = n.call(e)))
    return r;
  throw TypeError("Can't convert object to primitive value");
}, b6 = Object.defineProperty, En = { f: rn ? Object.defineProperty : function(e, t, n) {
  if (Ct(e), t = Gi(t, !0), Ct(n), aE)
    try {
      return b6(e, t, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw TypeError("Accessors not supported!");
  return "value" in n && (e[t] = n.value), e;
} }, $i = function(e, t) {
  return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
}, Pn = rn ? function(e, t, n) {
  return En.f(e, t, $i(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, E6 = 0, C6 = Math.random(), to = function(e) {
  return "Symbol(".concat(e === void 0 ? "" : e, ")_", (++E6 + C6).toString(36));
}, Js = gt(function(e) {
  var t = Re["__core-js_shared__"] || (Re["__core-js_shared__"] = {});
  (e.exports = function(n, r) {
    return t[n] || (t[n] = r !== void 0 ? r : {});
  })("versions", []).push({ version: hn.version, mode: "global", copyright: "© 2019 Denis Pushkarev (zloirock.ru)" });
}), Bh = Js("native-function-to-string", Function.toString), Er = gt(function(e) {
  var t = to("src"), n = ("" + Bh).split("toString");
  hn.inspectSource = function(r) {
    return Bh.call(r);
  }, (e.exports = function(r, i, a, s) {
    var o = typeof a == "function";
    o && (At(a, "name") || Pn(a, "name", i)), r[i] !== a && (o && (At(a, t) || Pn(a, t, r[i] ? "" + r[i] : n.join(String(i)))), r === Re ? r[i] = a : s ? r[i] ? r[i] = a : Pn(r, i, a) : (delete r[i], Pn(r, i, a)));
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && this[t] || Bh.call(this);
  });
}), oi = function(e) {
  if (typeof e != "function")
    throw TypeError(e + " is not a function!");
  return e;
}, In = function(e, t, n) {
  if (oi(e), t === void 0)
    return e;
  switch (n) {
    case 1:
      return function(r) {
        return e.call(t, r);
      };
    case 2:
      return function(r, i) {
        return e.call(t, r, i);
      };
    case 3:
      return function(r, i, a) {
        return e.call(t, r, i, a);
      };
  }
  return function() {
    return e.apply(t, arguments);
  };
}, pa = function e(t, n, r) {
  var i, a, s, o, u = t & e.F, c = t & e.G, f = t & e.P, p = t & e.B, d = c ? Re : t & e.S ? Re[n] || (Re[n] = {}) : (Re[n] || {}).prototype, m = c ? hn : hn[n] || (hn[n] = {}), y = m.prototype || (m.prototype = {});
  for (i in c && (r = n), r)
    s = ((a = !u && d && d[i] !== void 0) ? d : r)[i], o = p && a ? In(s, Re) : f && typeof s == "function" ? In(Function.call, s) : s, d && Er(d, i, s, t & e.U), m[i] != s && Pn(m, i, o), f && y[i] != s && (y[i] = s);
};
Re.core = hn, pa.F = 1, pa.G = 2, pa.S = 4, pa.P = 8, pa.B = 16, pa.W = 32, pa.U = 64, pa.R = 128;
var H = pa, br = gt(function(e) {
  var t = to("meta"), n = En.f, r = 0, i = Object.isExtensible || function() {
    return !0;
  }, a = !pt(function() {
    return i(Object.preventExtensions({}));
  }), s = function(u) {
    n(u, t, { value: { i: "O" + ++r, w: {} } });
  }, o = e.exports = { KEY: t, NEED: !1, fastKey: function(u, c) {
    if (!ht(u))
      return xe(u) == "symbol" ? u : (typeof u == "string" ? "S" : "P") + u;
    if (!At(u, t)) {
      if (!i(u))
        return "F";
      if (!c)
        return "E";
      s(u);
    }
    return u[t].i;
  }, getWeak: function(u, c) {
    if (!At(u, t)) {
      if (!i(u))
        return !0;
      if (!c)
        return !1;
      s(u);
    }
    return u[t].w;
  }, onFreeze: function(u) {
    return a && o.NEED && i(u) && !At(u, t) && s(u), u;
  } };
}), Ut = (br.KEY, br.NEED, br.fastKey, br.getWeak, br.onFreeze, gt(function(e) {
  var t = Js("wks"), n = Re.Symbol, r = typeof n == "function";
  (e.exports = function(i) {
    return t[i] || (t[i] = r && n[i] || (r ? n : to)("Symbol." + i));
  }).store = t;
})), S6 = En.f, my = Ut("toStringTag"), ka = function(e, t, n) {
  e && !At(e = n ? e : e.prototype, my) && S6(e, my, { configurable: !0, value: t });
}, y0 = { f: Ut }, k6 = En.f, oE = function(e) {
  var t = hn.Symbol || (hn.Symbol = Re.Symbol || {});
  e.charAt(0) == "_" || e in t || k6(t, e, { value: y0.f(e) });
}, D6 = {}.toString, si = function(e) {
  return D6.call(e).slice(8, -1);
}, yc = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
  return si(e) == "String" ? e.split("") : Object(e);
}, Ta = function(e) {
  if (e == null)
    throw TypeError("Can't call method on  " + e);
  return e;
}, lr = function(e) {
  return yc(Ta(e));
}, F6 = Math.ceil, w6 = Math.floor, zi = function(e) {
  return isNaN(e = +e) ? 0 : (e > 0 ? w6 : F6)(e);
}, A6 = Math.min, sn = function(e) {
  return e > 0 ? A6(zi(e), 9007199254740991) : 0;
}, _6 = Math.max, T6 = Math.min, ai = function(e, t) {
  return (e = zi(e)) < 0 ? _6(e + t, 0) : T6(e, t);
}, nf = function(e) {
  return function(t, n, r) {
    var i, a = lr(t), s = sn(a.length), o = ai(r, s);
    if (e && n != n) {
      for (; s > o; )
        if ((i = a[o++]) != i)
          return !0;
    } else
      for (; s > o; o++)
        if ((e || o in a) && a[o] === n)
          return e || o || 0;
    return !e && -1;
  };
}, gy = Js("keys"), v0 = function(e) {
  return gy[e] || (gy[e] = to(e));
}, P6 = nf(!1), I6 = v0("IE_PROTO"), sE = function(e, t) {
  var n, r = lr(e), i = 0, a = [];
  for (n in r)
    n != I6 && At(r, n) && a.push(n);
  for (; t.length > i; )
    At(r, n = t[i++]) && (~P6(a, n) || a.push(n));
  return a;
}, Ep = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), no = Object.keys || function(e) {
  return sE(e, Ep);
}, Uo = { f: Object.getOwnPropertySymbols }, vc = { f: {}.propertyIsEnumerable }, ic = Array.isArray || function(e) {
  return si(e) == "Array";
}, Zn = function(e) {
  return Object(Ta(e));
}, uE = rn ? Object.defineProperties : function(e, t) {
  Ct(e);
  for (var n, r = no(t), i = r.length, a = 0; i > a; )
    En.f(e, n = r[a++], t[n]);
  return e;
}, yy = Re.document, ac = yy && yy.documentElement, B6 = v0("IE_PROTO"), Oh = function() {
}, tp = function() {
  var e, t = bp("iframe"), n = Ep.length;
  for (t.style.display = "none", ac.appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), tp = e.F; n--; )
    delete tp.prototype[Ep[n]];
  return tp();
}, Ei = Object.create || function(e, t) {
  var n;
  return e !== null ? (Oh.prototype = Ct(e), n = new Oh(), Oh.prototype = null, n[B6] = e) : n = tp(), t === void 0 ? n : uE(n, t);
}, O6 = Ep.concat("length", "prototype"), qo = { f: Object.getOwnPropertyNames || function(e) {
  return sE(e, O6);
} }, vy = qo.f, L6 = {}.toString, xy = (typeof window > "u" ? "undefined" : xe(window)) == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], x0 = { f: function(e) {
  return xy && L6.call(e) == "[object Window]" ? function(t) {
    try {
      return vy(t);
    } catch {
      return xy.slice();
    }
  }(e) : vy(lr(e));
} }, by = Object.getOwnPropertyDescriptor, ui = { f: rn ? by : function(e, t) {
  if (e = lr(e), t = Gi(t, !0), aE)
    try {
      return by(e, t);
    } catch {
    }
  if (At(e, t))
    return $i(!vc.f.call(e, t), e[t]);
} }, N6 = br.KEY, cE = ui.f, _o = En.f, lE = x0.f, Nr = Re.Symbol, Cp = Re.JSON, bl = Cp && Cp.stringify, vr = Ut("_hidden"), Ey = Ut("toPrimitive"), j6 = {}.propertyIsEnumerable, yu = Js("symbol-registry"), wa = Js("symbols"), xc = Js("op-symbols"), ri = Object.prototype, Ns = typeof Nr == "function" && !!Uo.f, Lh = Re.QObject, dm = !Lh || !Lh.prototype || !Lh.prototype.findChild, mm = rn && pt(function() {
  return Ei(_o({}, "a", { get: function() {
    return _o(this, "a", { value: 7 }).a;
  } })).a != 7;
}) ? function(e, t, n) {
  var r = cE(ri, t);
  r && delete ri[t], _o(e, t, n), r && e !== ri && _o(ri, t, r);
} : _o, Cy = function(e) {
  var t = wa[e] = Ei(Nr.prototype);
  return t._k = e, t;
}, gm = Ns && xe(Nr.iterator) == "symbol" ? function(e) {
  return xe(e) == "symbol";
} : function(e) {
  return e instanceof Nr;
}, rf = function(e, t, n) {
  return e === ri && rf(xc, t, n), Ct(e), t = Gi(t, !0), Ct(n), At(wa, t) ? (n.enumerable ? (At(e, vr) && e[vr][t] && (e[vr][t] = !1), n = Ei(n, { enumerable: $i(0, !1) })) : (At(e, vr) || _o(e, vr, $i(1, {})), e[vr][t] = !0), mm(e, t, n)) : _o(e, t, n);
}, Sy = function(e, t) {
  Ct(e);
  for (var n, r = function(s) {
    var o = no(s), u = Uo.f;
    if (u)
      for (var c, f = u(s), p = vc.f, d = 0; f.length > d; )
        p.call(s, c = f[d++]) && o.push(c);
    return o;
  }(t = lr(t)), i = 0, a = r.length; a > i; )
    rf(e, n = r[i++], t[n]);
  return e;
}, ky = function(e) {
  var t = j6.call(this, e = Gi(e, !0));
  return !(this === ri && At(wa, e) && !At(xc, e)) && (!(t || !At(this, e) || !At(wa, e) || At(this, vr) && this[vr][e]) || t);
}, pE = function(e, t) {
  if (e = lr(e), t = Gi(t, !0), e !== ri || !At(wa, t) || At(xc, t)) {
    var n = cE(e, t);
    return !n || !At(wa, t) || At(e, vr) && e[vr][t] || (n.enumerable = !0), n;
  }
}, fE = function(e) {
  for (var t, n = lE(lr(e)), r = [], i = 0; n.length > i; )
    At(wa, t = n[i++]) || t == vr || t == N6 || r.push(t);
  return r;
}, hE = function(e) {
  for (var t, n = e === ri, r = lE(n ? xc : lr(e)), i = [], a = 0; r.length > a; )
    !At(wa, t = r[a++]) || n && !At(ri, t) || i.push(wa[t]);
  return i;
};
Ns || (Er((Nr = function() {
  if (this instanceof Nr)
    throw TypeError("Symbol is not a constructor!");
  var e = to(arguments.length > 0 ? arguments[0] : void 0), t = function n(r) {
    this === ri && n.call(xc, r), At(this, vr) && At(this[vr], e) && (this[vr][e] = !1), mm(this, e, $i(1, r));
  };
  return rn && dm && mm(ri, e, { configurable: !0, set: t }), Cy(e);
}).prototype, "toString", function() {
  return this._k;
}), ui.f = pE, En.f = rf, qo.f = x0.f = fE, vc.f = ky, Uo.f = hE, rn && Er(ri, "propertyIsEnumerable", ky, !0), y0.f = function(e) {
  return Cy(Ut(e));
}), H(H.G + H.W + H.F * !Ns, { Symbol: Nr });
for (var Dy = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), Fy = 0; Dy.length > Fy; )
  Ut(Dy[Fy++]);
for (var wy = no(Ut.store), Ay = 0; wy.length > Ay; )
  oE(wy[Ay++]);
H(H.S + H.F * !Ns, "Symbol", { for: function(e) {
  return At(yu, e += "") ? yu[e] : yu[e] = Nr(e);
}, keyFor: function(e) {
  if (!gm(e))
    throw TypeError(e + " is not a symbol!");
  for (var t in yu)
    if (yu[t] === e)
      return t;
}, useSetter: function() {
  dm = !0;
}, useSimple: function() {
  dm = !1;
} }), H(H.S + H.F * !Ns, "Object", { create: function(e, t) {
  return t === void 0 ? Ei(e) : Sy(Ei(e), t);
}, defineProperty: rf, defineProperties: Sy, getOwnPropertyDescriptor: pE, getOwnPropertyNames: fE, getOwnPropertySymbols: hE });
var R6 = pt(function() {
  Uo.f(1);
});
H(H.S + H.F * R6, "Object", { getOwnPropertySymbols: function(e) {
  return Uo.f(Zn(e));
} }), Cp && H(H.S + H.F * (!Ns || pt(function() {
  var e = Nr();
  return bl([e]) != "[null]" || bl({ a: e }) != "{}" || bl(Object(e)) != "{}";
})), "JSON", { stringify: function(e) {
  for (var t, n, r = [e], i = 1; arguments.length > i; )
    r.push(arguments[i++]);
  if (n = t = r[1], (ht(t) || e !== void 0) && !gm(e))
    return ic(t) || (t = function(a, s) {
      if (typeof n == "function" && (s = n.call(this, a, s)), !gm(s))
        return s;
    }), r[1] = t, bl.apply(Cp, r);
} }), Nr.prototype[Ey] || Pn(Nr.prototype, Ey, Nr.prototype.valueOf), ka(Nr, "Symbol"), ka(Math, "Math", !0), ka(Re.JSON, "JSON", !0), H(H.S, "Object", { create: Ei }), H(H.S + H.F * !rn, "Object", { defineProperty: En.f }), H(H.S + H.F * !rn, "Object", { defineProperties: uE });
var Ui = function(e, t) {
  var n = (hn.Object || {})[e] || Object[e], r = {};
  r[e] = t(n), H(H.S + H.F * pt(function() {
    n(1);
  }), "Object", r);
}, M6 = ui.f;
Ui("getOwnPropertyDescriptor", function() {
  return function(e, t) {
    return M6(lr(e), t);
  };
});
var _y = v0("IE_PROTO"), V6 = Object.prototype, No = Object.getPrototypeOf || function(e) {
  return e = Zn(e), At(e, _y) ? e[_y] : typeof e.constructor == "function" && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? V6 : null;
};
Ui("getPrototypeOf", function() {
  return function(e) {
    return No(Zn(e));
  };
}), Ui("keys", function() {
  return function(e) {
    return no(Zn(e));
  };
}), Ui("getOwnPropertyNames", function() {
  return x0.f;
});
var U6 = br.onFreeze;
Ui("freeze", function(e) {
  return function(t) {
    return e && ht(t) ? e(U6(t)) : t;
  };
});
var q6 = br.onFreeze;
Ui("seal", function(e) {
  return function(t) {
    return e && ht(t) ? e(q6(t)) : t;
  };
});
var W6 = br.onFreeze;
Ui("preventExtensions", function(e) {
  return function(t) {
    return e && ht(t) ? e(W6(t)) : t;
  };
}), Ui("isFrozen", function(e) {
  return function(t) {
    return !ht(t) || !!e && e(t);
  };
}), Ui("isSealed", function(e) {
  return function(t) {
    return !ht(t) || !!e && e(t);
  };
}), Ui("isExtensible", function(e) {
  return function(t) {
    return !!ht(t) && (!e || e(t));
  };
});
var El = Object.assign, dE = !El || pt(function() {
  var e = {}, t = {}, n = Symbol(), r = "abcdefghijklmnopqrst";
  return e[n] = 7, r.split("").forEach(function(i) {
    t[i] = i;
  }), El({}, e)[n] != 7 || Object.keys(El({}, t)).join("") != r;
}) ? function(e, t) {
  for (var n = Zn(e), r = arguments.length, i = 1, a = Uo.f, s = vc.f; r > i; )
    for (var o, u = yc(arguments[i++]), c = a ? no(u).concat(a(u)) : no(u), f = c.length, p = 0; f > p; )
      o = c[p++], rn && !s.call(u, o) || (n[o] = u[o]);
  return n;
} : El;
H(H.S + H.F, "Object", { assign: dE });
var ym = Object.is || function(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
};
H(H.S, "Object", { is: ym });
var Ty = function(e, t) {
  if (Ct(e), !ht(t) && t !== null)
    throw TypeError(t + ": can't set as prototype!");
}, Qu = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(e, t, n) {
  try {
    (n = In(Function.call, ui.f(Object.prototype, "__proto__").set, 2))(e, []), t = !(e instanceof Array);
  } catch {
    t = !0;
  }
  return function(r, i) {
    return Ty(r, i), t ? r.__proto__ = i : n(r, i), r;
  };
}({}, !1) : void 0), check: Ty };
H(H.S, "Object", { setPrototypeOf: Qu.set });
var $6 = Ut("toStringTag"), G6 = si(function() {
  return arguments;
}()) == "Arguments", bc = function(e) {
  var t, n, r;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = function(i, a) {
    try {
      return i[a];
    } catch {
    }
  }(t = Object(e), $6)) == "string" ? n : G6 ? si(t) : (r = si(t)) == "Object" && typeof t.callee == "function" ? "Arguments" : r;
}, Py = {};
Py[Ut("toStringTag")] = "z", Py + "" != "[object z]" && Er(Object.prototype, "toString", function() {
  return "[object " + bc(this) + "]";
}, !0);
var mE = function(e, t, n) {
  var r = n === void 0;
  switch (t.length) {
    case 0:
      return r ? e() : e.call(n);
    case 1:
      return r ? e(t[0]) : e.call(n, t[0]);
    case 2:
      return r ? e(t[0], t[1]) : e.call(n, t[0], t[1]);
    case 3:
      return r ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);
    case 4:
      return r ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3]);
  }
  return e.apply(n, t);
}, Iy = [].slice, Nh = {}, z6 = function(e, t, n) {
  if (!(t in Nh)) {
    for (var r = [], i = 0; i < t; i++)
      r[i] = "a[" + i + "]";
    Nh[t] = Function("F,a", "return new F(" + r.join(",") + ")");
  }
  return Nh[t](e, n);
}, gE = Function.bind || function(e) {
  var t = oi(this), n = Iy.call(arguments, 1), r = function i() {
    var a = n.concat(Iy.call(arguments));
    return this instanceof i ? z6(t, a.length, a) : mE(t, a, e);
  };
  return ht(t.prototype) && (r.prototype = t.prototype), r;
};
H(H.P, "Function", { bind: gE });
var H6 = En.f, By = Function.prototype, K6 = /^\s*function ([^ (]*)/;
"name" in By || rn && H6(By, "name", { configurable: !0, get: function() {
  try {
    return ("" + this).match(K6)[1];
  } catch {
    return "";
  }
} });
var Oy = Ut("hasInstance"), Ly = Function.prototype;
Oy in Ly || En.f(Ly, Oy, { value: function(e) {
  if (typeof this != "function" || !ht(e))
    return !1;
  if (!ht(this.prototype))
    return e instanceof this;
  for (; e = No(e); )
    if (this.prototype === e)
      return !0;
  return !1;
} });
var js = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`, Sp = "[" + js + "]", J6 = RegExp("^" + Sp + Sp + "*"), Q6 = RegExp(Sp + Sp + "*$"), yE = function(e, t, n) {
  var r = {}, i = pt(function() {
    return !!js[e]() || "​"[e]() != "​";
  }), a = r[e] = i ? t(X6) : js[e];
  n && (r[n] = a), H(H.P + H.F * i, "String", r);
}, X6 = yE.trim = function(e, t) {
  return e = String(Ta(e)), 1 & t && (e = e.replace(J6, "")), 2 & t && (e = e.replace(Q6, "")), e;
}, Qs = yE, Cl = Re.parseInt, Y6 = Qs.trim, Z6 = /^[-+]?0[xX]/, kp = Cl(js + "08") !== 8 || Cl(js + "0x16") !== 22 ? function(e, t) {
  var n = Y6(String(e), 3);
  return Cl(n, t >>> 0 || (Z6.test(n) ? 16 : 10));
} : Cl;
H(H.G + H.F * (parseInt != kp), { parseInt: kp });
var jh = Re.parseFloat, e7 = Qs.trim, Dp = 1 / jh(js + "-0") != -1 / 0 ? function(e) {
  var t = e7(String(e), 3), n = jh(t);
  return n === 0 && t.charAt(0) == "-" ? -0 : n;
} : jh;
H(H.G + H.F * (parseFloat != Dp), { parseFloat: Dp });
var Ny = Qu.set, b0 = function(e, t, n) {
  var r, i = t.constructor;
  return i !== n && typeof i == "function" && (r = i.prototype) !== n.prototype && ht(r) && Ny && Ny(e, r), e;
}, t7 = qo.f, n7 = ui.f, r7 = En.f, i7 = Qs.trim, Br = Re.Number, Sl = Br, np = Br.prototype, a7 = si(Ei(np)) == "Number", o7 = "trim" in String.prototype, jy = function(e) {
  var t = Gi(e, !1);
  if (typeof t == "string" && t.length > 2) {
    var n, r, i, a = (t = o7 ? t.trim() : i7(t, 3)).charCodeAt(0);
    if (a === 43 || a === 45) {
      if ((n = t.charCodeAt(2)) === 88 || n === 120)
        return NaN;
    } else if (a === 48) {
      switch (t.charCodeAt(1)) {
        case 66:
        case 98:
          r = 2, i = 49;
          break;
        case 79:
        case 111:
          r = 8, i = 55;
          break;
        default:
          return +t;
      }
      for (var s, o = t.slice(2), u = 0, c = o.length; u < c; u++)
        if ((s = o.charCodeAt(u)) < 48 || s > i)
          return NaN;
      return parseInt(o, r);
    }
  }
  return +t;
};
if (!Br(" 0o1") || !Br("0b1") || Br("+0x1")) {
  Br = function(e) {
    var t = arguments.length < 1 ? 0 : e, n = this;
    return n instanceof Br && (a7 ? pt(function() {
      np.valueOf.call(n);
    }) : si(n) != "Number") ? b0(new Sl(jy(t)), n, Br) : jy(t);
  };
  for (var kl, Ry = rn ? t7(Sl) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), Rh = 0; Ry.length > Rh; Rh++)
    At(Sl, kl = Ry[Rh]) && !At(Br, kl) && r7(Br, kl, n7(Sl, kl));
  Br.prototype = np, np.constructor = Br, Er(Re, "Number", Br);
}
var vE = function(e, t) {
  if (typeof e != "number" && si(e) != "Number")
    throw TypeError(t);
  return +e;
}, oc = function(e) {
  var t = String(Ta(this)), n = "", r = zi(e);
  if (r < 0 || r == 1 / 0)
    throw RangeError("Count can't be negative");
  for (; r > 0; (r >>>= 1) && (t += t))
    1 & r && (n += t);
  return n;
}, My = 1 .toFixed, xE = Math.floor, Rs = [0, 0, 0, 0, 0, 0], Vy = "Number.toFixed: incorrect invocation!", ss = function(e, t) {
  for (var n = -1, r = t; ++n < 6; )
    r += e * Rs[n], Rs[n] = r % 1e7, r = xE(r / 1e7);
}, Mh = function(e) {
  for (var t = 6, n = 0; --t >= 0; )
    n += Rs[t], Rs[t] = xE(n / e), n = n % e * 1e7;
}, Uy = function() {
  for (var e = 6, t = ""; --e >= 0; )
    if (t !== "" || e === 0 || Rs[e] !== 0) {
      var n = String(Rs[e]);
      t = t === "" ? n : t + oc.call("0", 7 - n.length) + n;
    }
  return t;
}, Dl = function e(t, n, r) {
  return n === 0 ? r : n % 2 == 1 ? e(t, n - 1, r * t) : e(t * t, n / 2, r);
};
H(H.P + H.F * (!!My && (8e-5.toFixed(3) !== "0.000" || 0.9.toFixed(0) !== "1" || 1.255.toFixed(2) !== "1.25" || 1000000000000000100 .toFixed(0) !== "1000000000000000128") || !pt(function() {
  My.call({});
})), "Number", { toFixed: function(e) {
  var t, n, r, i, a = vE(this, Vy), s = zi(e), o = "", u = "0";
  if (s < 0 || s > 20)
    throw RangeError(Vy);
  if (a != a)
    return "NaN";
  if (a <= -1e21 || a >= 1e21)
    return String(a);
  if (a < 0 && (o = "-", a = -a), a > 1e-21)
    if (n = (t = function(c) {
      for (var f = 0, p = c; p >= 4096; )
        f += 12, p /= 4096;
      for (; p >= 2; )
        f += 1, p /= 2;
      return f;
    }(a * Dl(2, 69, 1)) - 69) < 0 ? a * Dl(2, -t, 1) : a / Dl(2, t, 1), n *= 4503599627370496, (t = 52 - t) > 0) {
      for (ss(0, n), r = s; r >= 7; )
        ss(1e7, 0), r -= 7;
      for (ss(Dl(10, r, 1), 0), r = t - 1; r >= 23; )
        Mh(1 << 23), r -= 23;
      Mh(1 << r), ss(1, 1), Mh(2), u = Uy();
    } else
      ss(0, n), ss(1 << -t, 0), u = Uy() + oc.call("0", s);
  return u = s > 0 ? o + ((i = u.length) <= s ? "0." + oc.call("0", s - i) + u : u.slice(0, i - s) + "." + u.slice(i - s)) : o + u;
} });
var Fl = 1 .toPrecision;
H(H.P + H.F * (pt(function() {
  return Fl.call(1, void 0) !== "1";
}) || !pt(function() {
  Fl.call({});
})), "Number", { toPrecision: function(e) {
  var t = vE(this, "Number#toPrecision: incorrect invocation!");
  return e === void 0 ? Fl.call(t) : Fl.call(t, e);
} }), H(H.S, "Number", { EPSILON: Math.pow(2, -52) });
var s7 = Re.isFinite;
H(H.S, "Number", { isFinite: function(e) {
  return typeof e == "number" && s7(e);
} });
var u7 = Math.floor, bE = function(e) {
  return !ht(e) && isFinite(e) && u7(e) === e;
};
H(H.S, "Number", { isInteger: bE }), H(H.S, "Number", { isNaN: function(e) {
  return e != e;
} });
var c7 = Math.abs;
H(H.S, "Number", { isSafeInteger: function(e) {
  return bE(e) && c7(e) <= 9007199254740991;
} }), H(H.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 }), H(H.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 }), H(H.S + H.F * (Number.parseFloat != Dp), "Number", { parseFloat: Dp }), H(H.S + H.F * (Number.parseInt != kp), "Number", { parseInt: kp });
var EE = Math.log1p || function(e) {
  return (e = +e) > -1e-8 && e < 1e-8 ? e - e * e / 2 : Math.log(1 + e);
}, qy = Math.sqrt, Vh = Math.acosh;
H(H.S + H.F * !(Vh && Math.floor(Vh(Number.MAX_VALUE)) == 710 && Vh(1 / 0) == 1 / 0), "Math", { acosh: function(e) {
  return (e = +e) < 1 ? NaN : e > 9490626562425156e-8 ? Math.log(e) + Math.LN2 : EE(e - 1 + qy(e - 1) * qy(e + 1));
} });
var Wy = Math.asinh;
H(H.S + H.F * !(Wy && 1 / Wy(0) > 0), "Math", { asinh: function e(t) {
  return isFinite(t = +t) && t != 0 ? t < 0 ? -e(-t) : Math.log(t + Math.sqrt(t * t + 1)) : t;
} });
var $y = Math.atanh;
H(H.S + H.F * !($y && 1 / $y(-0) < 0), "Math", { atanh: function(e) {
  return (e = +e) == 0 ? e : Math.log((1 + e) / (1 - e)) / 2;
} });
var E0 = Math.sign || function(e) {
  return (e = +e) == 0 || e != e ? e : e < 0 ? -1 : 1;
};
H(H.S, "Math", { cbrt: function(e) {
  return E0(e = +e) * Math.pow(Math.abs(e), 1 / 3);
} }), H(H.S, "Math", { clz32: function(e) {
  return (e >>>= 0) ? 31 - Math.floor(Math.log(e + 0.5) * Math.LOG2E) : 32;
} });
var Gy = Math.exp;
H(H.S, "Math", { cosh: function(e) {
  return (Gy(e = +e) + Gy(-e)) / 2;
} });
var vu = Math.expm1, Ms = !vu || vu(10) > 22025.465794806718 || vu(10) < 22025.465794806718 || vu(-2e-17) != -2e-17 ? function(e) {
  return (e = +e) == 0 ? e : e > -1e-6 && e < 1e-6 ? e + e * e / 2 : Math.exp(e) - 1;
} : vu;
H(H.S + H.F * (Ms != Math.expm1), "Math", { expm1: Ms });
var af = Math.pow, Uh = af(2, -52), rp = af(2, -23), l7 = af(2, 127) * (2 - rp), qh = af(2, -126), p7 = Math.fround || function(e) {
  var t, n, r = Math.abs(e), i = E0(e);
  return r < qh ? i * (r / qh / rp + 1 / Uh - 1 / Uh) * qh * rp : (n = (t = (1 + rp / Uh) * r) - (t - r)) > l7 || n != n ? i * (1 / 0) : i * n;
};
H(H.S, "Math", { fround: p7 });
var f7 = Math.abs;
H(H.S, "Math", { hypot: function(e, t) {
  for (var n, r, i = 0, a = 0, s = arguments.length, o = 0; a < s; )
    o < (n = f7(arguments[a++])) ? (i = i * (r = o / n) * r + 1, o = n) : i += n > 0 ? (r = n / o) * r : n;
  return o === 1 / 0 ? 1 / 0 : o * Math.sqrt(i);
} });
var zy = Math.imul;
H(H.S + H.F * pt(function() {
  return zy(4294967295, 5) != -5 || zy.length != 2;
}), "Math", { imul: function(e, t) {
  var n = +e, r = +t, i = 65535 & n, a = 65535 & r;
  return 0 | i * a + ((65535 & n >>> 16) * a + i * (65535 & r >>> 16) << 16 >>> 0);
} }), H(H.S, "Math", { log10: function(e) {
  return Math.log(e) * Math.LOG10E;
} }), H(H.S, "Math", { log1p: EE }), H(H.S, "Math", { log2: function(e) {
  return Math.log(e) / Math.LN2;
} }), H(H.S, "Math", { sign: E0 });
var Hy = Math.exp;
H(H.S + H.F * pt(function() {
  return !Math.sinh(-2e-17) != -2e-17;
}), "Math", { sinh: function(e) {
  return Math.abs(e = +e) < 1 ? (Ms(e) - Ms(-e)) / 2 : (Hy(e - 1) - Hy(-e - 1)) * (Math.E / 2);
} });
var Ky = Math.exp;
H(H.S, "Math", { tanh: function(e) {
  var t = Ms(e = +e), n = Ms(-e);
  return t == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (t - n) / (Ky(e) + Ky(-e));
} }), H(H.S, "Math", { trunc: function(e) {
  return (e > 0 ? Math.floor : Math.ceil)(e);
} });
var Jy = String.fromCharCode, Qy = String.fromCodePoint;
H(H.S + H.F * (!!Qy && Qy.length != 1), "String", { fromCodePoint: function(e) {
  for (var t, n = [], r = arguments.length, i = 0; r > i; ) {
    if (t = +arguments[i++], ai(t, 1114111) !== t)
      throw RangeError(t + " is not a valid code point");
    n.push(t < 65536 ? Jy(t) : Jy(55296 + ((t -= 65536) >> 10), t % 1024 + 56320));
  }
  return n.join("");
} }), H(H.S, "String", { raw: function(e) {
  for (var t = lr(e.raw), n = sn(t.length), r = arguments.length, i = [], a = 0; n > a; )
    i.push(String(t[a++])), a < r && i.push(String(arguments[a]));
  return i.join("");
} }), Qs("trim", function(e) {
  return function() {
    return e(this, 3);
  };
});
var C0 = function(e) {
  return function(t, n) {
    var r, i, a = String(Ta(t)), s = zi(n), o = a.length;
    return s < 0 || s >= o ? e ? "" : void 0 : (r = a.charCodeAt(s)) < 55296 || r > 56319 || s + 1 === o || (i = a.charCodeAt(s + 1)) < 56320 || i > 57343 ? e ? a.charAt(s) : r : e ? a.slice(s, s + 2) : i - 56320 + (r - 55296 << 10) + 65536;
  };
}, Aa = {}, CE = {};
Pn(CE, Ut("iterator"), function() {
  return this;
});
var SE = function(e, t, n) {
  e.prototype = Ei(CE, { next: $i(1, n) }), ka(e, t + " Iterator");
}, xu = Ut("iterator"), Wh = !([].keys && "next" in [].keys()), Xy = function() {
  return this;
}, S0 = function(e, t, n, r, i, a, s) {
  SE(n, t, r);
  var o, u, c, f = function(k) {
    if (!Wh && k in y)
      return y[k];
    switch (k) {
      case "keys":
      case "values":
        return function() {
          return new n(this, k);
        };
    }
    return function() {
      return new n(this, k);
    };
  }, p = t + " Iterator", d = i == "values", m = !1, y = e.prototype, v = y[xu] || y["@@iterator"] || i && y[i], b = v || f(i), x = i ? d ? f("entries") : b : void 0, C = t == "Array" && y.entries || v;
  if (C && (c = No(C.call(new e()))) !== Object.prototype && c.next && (ka(c, p, !0), typeof c[xu] != "function" && Pn(c, xu, Xy)), d && v && v.name !== "values" && (m = !0, b = function() {
    return v.call(this);
  }), (Wh || m || !y[xu]) && Pn(y, xu, b), Aa[t] = b, Aa[p] = Xy, i)
    if (o = { values: d ? b : f("values"), keys: a ? b : f("keys"), entries: x }, s)
      for (u in o)
        u in y || Er(y, u, o[u]);
    else
      H(H.P + H.F * (Wh || m), t, o);
  return o;
}, h7 = C0(!0);
S0(String, "String", function(e) {
  this._t = String(e), this._i = 0;
}, function() {
  var e, t = this._t, n = this._i;
  return n >= t.length ? { value: void 0, done: !0 } : (e = h7(t, n), this._i += e.length, { value: e, done: !1 });
});
var d7 = C0(!1);
H(H.P, "String", { codePointAt: function(e) {
  return d7(this, e);
} });
var m7 = Ut("match"), k0 = function(e) {
  var t;
  return ht(e) && ((t = e[m7]) !== void 0 ? !!t : si(e) == "RegExp");
}, D0 = function(e, t, n) {
  if (k0(t))
    throw TypeError("String#" + n + " doesn't accept regex!");
  return String(Ta(e));
}, g7 = Ut("match"), F0 = function(e) {
  var t = /./;
  try {
    "/./"[e](t);
  } catch {
    try {
      return t[g7] = !1, !"/./"[e](t);
    } catch {
    }
  }
  return !0;
}, Yy = "".endsWith;
H(H.P + H.F * F0("endsWith"), "String", { endsWith: function(e) {
  var t = D0(this, e, "endsWith"), n = arguments.length > 1 ? arguments[1] : void 0, r = sn(t.length), i = n === void 0 ? r : Math.min(sn(n), r), a = String(e);
  return Yy ? Yy.call(t, a, i) : t.slice(i - a.length, i) === a;
} });
H(H.P + H.F * F0("includes"), "String", { includes: function(e) {
  return !!~D0(this, e, "includes").indexOf(e, arguments.length > 1 ? arguments[1] : void 0);
} }), H(H.P, "String", { repeat: oc });
var Zy = "".startsWith;
H(H.P + H.F * F0("startsWith"), "String", { startsWith: function(e) {
  var t = D0(this, e, "startsWith"), n = sn(Math.min(arguments.length > 1 ? arguments[1] : void 0, t.length)), r = String(e);
  return Zy ? Zy.call(t, r, n) : t.slice(n, n + r.length) === r;
} });
var y7 = /"/g, v7 = function(e, t, n, r) {
  var i = String(Ta(e)), a = "<" + t;
  return n !== "" && (a += " " + n + '="' + String(r).replace(y7, "&quot;") + '"'), a + ">" + i + "</" + t + ">";
}, Tr = function(e, t) {
  var n = {};
  n[e] = t(v7), H(H.P + H.F * pt(function() {
    var r = ""[e]('"');
    return r !== r.toLowerCase() || r.split('"').length > 3;
  }), "String", n);
};
Tr("anchor", function(e) {
  return function(t) {
    return e(this, "a", "name", t);
  };
}), Tr("big", function(e) {
  return function() {
    return e(this, "big", "", "");
  };
}), Tr("blink", function(e) {
  return function() {
    return e(this, "blink", "", "");
  };
}), Tr("bold", function(e) {
  return function() {
    return e(this, "b", "", "");
  };
}), Tr("fixed", function(e) {
  return function() {
    return e(this, "tt", "", "");
  };
}), Tr("fontcolor", function(e) {
  return function(t) {
    return e(this, "font", "color", t);
  };
}), Tr("fontsize", function(e) {
  return function(t) {
    return e(this, "font", "size", t);
  };
}), Tr("italics", function(e) {
  return function() {
    return e(this, "i", "", "");
  };
}), Tr("link", function(e) {
  return function(t) {
    return e(this, "a", "href", t);
  };
}), Tr("small", function(e) {
  return function() {
    return e(this, "small", "", "");
  };
}), Tr("strike", function(e) {
  return function() {
    return e(this, "strike", "", "");
  };
}), Tr("sub", function(e) {
  return function() {
    return e(this, "sub", "", "");
  };
}), Tr("sup", function(e) {
  return function() {
    return e(this, "sup", "", "");
  };
}), H(H.S, "Date", { now: function() {
  return (/* @__PURE__ */ new Date()).getTime();
} }), H(H.P + H.F * pt(function() {
  return (/* @__PURE__ */ new Date(NaN)).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
    return 1;
  } }) !== 1;
}), "Date", { toJSON: function(e) {
  var t = Zn(this), n = Gi(t);
  return typeof n != "number" || isFinite(n) ? t.toISOString() : null;
} });
var x7 = Date.prototype.getTime, $h = Date.prototype.toISOString, us = function(e) {
  return e > 9 ? e : "0" + e;
}, ev = pt(function() {
  return $h.call(new Date(-5e13 - 1)) != "0385-07-25T07:06:39.999Z";
}) || !pt(function() {
  $h.call(/* @__PURE__ */ new Date(NaN));
}) ? function() {
  if (!isFinite(x7.call(this)))
    throw RangeError("Invalid time value");
  var e = this, t = e.getUTCFullYear(), n = e.getUTCMilliseconds(), r = t < 0 ? "-" : t > 9999 ? "+" : "";
  return r + ("00000" + Math.abs(t)).slice(r ? -6 : -4) + "-" + us(e.getUTCMonth() + 1) + "-" + us(e.getUTCDate()) + "T" + us(e.getUTCHours()) + ":" + us(e.getUTCMinutes()) + ":" + us(e.getUTCSeconds()) + "." + (n > 99 ? n : "0" + us(n)) + "Z";
} : $h;
H(H.P + H.F * (Date.prototype.toISOString !== ev), "Date", { toISOString: ev });
var w0 = Date.prototype, b7 = w0.toString, E7 = w0.getTime;
/* @__PURE__ */ new Date(NaN) + "" != "Invalid Date" && Er(w0, "toString", function() {
  var e = E7.call(this);
  return e == e ? b7.call(this) : "Invalid Date";
});
var tv = Ut("toPrimitive"), nv = Date.prototype;
tv in nv || Pn(nv, tv, function(e) {
  if (e !== "string" && e !== "number" && e !== "default")
    throw TypeError("Incorrect hint");
  return Gi(Ct(this), e != "number");
}), H(H.S, "Array", { isArray: ic });
var kE = function(e, t, n, r) {
  try {
    return r ? t(Ct(n)[0], n[1]) : t(n);
  } catch (a) {
    var i = e.return;
    throw i !== void 0 && Ct(i.call(e)), a;
  }
}, C7 = Ut("iterator"), S7 = Array.prototype, A0 = function(e) {
  return e !== void 0 && (Aa.Array === e || S7[C7] === e);
}, ip = function(e, t, n) {
  t in e ? En.f(e, t, $i(0, n)) : e[t] = n;
}, k7 = Ut("iterator"), _0 = hn.getIteratorMethod = function(e) {
  if (e != null)
    return e[k7] || e["@@iterator"] || Aa[bc(e)];
}, vm = Ut("iterator"), DE = !1;
try {
  var rv = [7][vm]();
  rv.return = function() {
    DE = !0;
  }, Array.from(rv, function() {
    throw 2;
  });
} catch {
}
var of = function(e, t) {
  if (!t && !DE)
    return !1;
  var n = !1;
  try {
    var r = [7], i = r[vm]();
    i.next = function() {
      return { done: n = !0 };
    }, r[vm] = function() {
      return i;
    }, e(r);
  } catch {
  }
  return n;
};
H(H.S + H.F * !of(function(e) {
  Array.from(e);
}), "Array", { from: function(e) {
  var t, n, r, i, a = Zn(e), s = typeof this == "function" ? this : Array, o = arguments.length, u = o > 1 ? arguments[1] : void 0, c = u !== void 0, f = 0, p = _0(a);
  if (c && (u = In(u, o > 2 ? arguments[2] : void 0, 2)), p == null || s == Array && A0(p))
    for (n = new s(t = sn(a.length)); t > f; f++)
      ip(n, f, c ? u(a[f], f) : a[f]);
  else
    for (i = p.call(a), n = new s(); !(r = i.next()).done; f++)
      ip(n, f, c ? kE(i, u, [r.value, f], !0) : r.value);
  return n.length = f, n;
} }), H(H.S + H.F * pt(function() {
  function e() {
  }
  return !(Array.of.call(e) instanceof e);
}), "Array", { of: function() {
  for (var e = 0, t = arguments.length, n = new (typeof this == "function" ? this : Array)(t); t > e; )
    ip(n, e, arguments[e++]);
  return n.length = t, n;
} });
var Ci = function(e, t) {
  return !!e && pt(function() {
    t ? e.call(null, function() {
    }, 1) : e.call(null);
  });
}, iv = [].join;
H(H.P + H.F * (yc != Object || !Ci(iv)), "Array", { join: function(e) {
  return iv.call(lr(this), e === void 0 ? "," : e);
} });
var av = [].slice;
H(H.P + H.F * pt(function() {
  ac && av.call(ac);
}), "Array", { slice: function(e, t) {
  var n = sn(this.length), r = si(this);
  if (t = t === void 0 ? n : t, r == "Array")
    return av.call(this, e, t);
  for (var i = ai(e, n), a = ai(t, n), s = sn(a - i), o = new Array(s), u = 0; u < s; u++)
    o[u] = r == "String" ? this.charAt(i + u) : this[i + u];
  return o;
} });
var Gh = [].sort, ov = [1, 2, 3];
H(H.P + H.F * (pt(function() {
  ov.sort(void 0);
}) || !pt(function() {
  ov.sort(null);
}) || !Ci(Gh)), "Array", { sort: function(e) {
  return e === void 0 ? Gh.call(Zn(this)) : Gh.call(Zn(this), oi(e));
} });
var D7 = Ut("species"), FE = function(e, t) {
  return new (function(n) {
    var r;
    return ic(n) && (typeof (r = n.constructor) != "function" || r !== Array && !ic(r.prototype) || (r = void 0), ht(r) && (r = r[D7]) === null && (r = void 0)), r === void 0 ? Array : r;
  }(e))(t);
}, Si = function(e, t) {
  var n = e == 1, r = e == 2, i = e == 3, a = e == 4, s = e == 6, o = e == 5 || s, u = t || FE;
  return function(c, f, p) {
    for (var d, m, y = Zn(c), v = yc(y), b = In(f, p, 3), x = sn(v.length), C = 0, k = n ? u(c, x) : r ? u(c, 0) : void 0; x > C; C++)
      if ((o || C in v) && (m = b(d = v[C], C, y), e)) {
        if (n)
          k[C] = m;
        else if (m)
          switch (e) {
            case 3:
              return !0;
            case 5:
              return d;
            case 6:
              return C;
            case 2:
              k.push(d);
          }
        else if (a)
          return !1;
      }
    return s ? -1 : i || a ? a : k;
  };
}, F7 = Si(0), w7 = Ci([].forEach, !0);
H(H.P + H.F * !w7, "Array", { forEach: function(e) {
  return F7(this, e, arguments[1]);
} });
var A7 = Si(1);
H(H.P + H.F * !Ci([].map, !0), "Array", { map: function(e) {
  return A7(this, e, arguments[1]);
} });
var _7 = Si(2);
H(H.P + H.F * !Ci([].filter, !0), "Array", { filter: function(e) {
  return _7(this, e, arguments[1]);
} });
var T7 = Si(3);
H(H.P + H.F * !Ci([].some, !0), "Array", { some: function(e) {
  return T7(this, e, arguments[1]);
} });
var P7 = Si(4);
H(H.P + H.F * !Ci([].every, !0), "Array", { every: function(e) {
  return P7(this, e, arguments[1]);
} });
var sv = function(e, t, n, r, i) {
  oi(t);
  var a = Zn(e), s = yc(a), o = sn(a.length), u = i ? o - 1 : 0, c = i ? -1 : 1;
  if (n < 2)
    for (; ; ) {
      if (u in s) {
        r = s[u], u += c;
        break;
      }
      if (u += c, i ? u < 0 : o <= u)
        throw TypeError("Reduce of empty array with no initial value");
    }
  for (; i ? u >= 0 : o > u; u += c)
    u in s && (r = t(r, s[u], u, a));
  return r;
};
H(H.P + H.F * !Ci([].reduce, !0), "Array", { reduce: function(e) {
  return sv(this, e, arguments.length, arguments[1], !1);
} }), H(H.P + H.F * !Ci([].reduceRight, !0), "Array", { reduceRight: function(e) {
  return sv(this, e, arguments.length, arguments[1], !0);
} });
var I7 = nf(!1), xm = [].indexOf, uv = !!xm && 1 / [1].indexOf(1, -0) < 0;
H(H.P + H.F * (uv || !Ci(xm)), "Array", { indexOf: function(e) {
  return uv ? xm.apply(this, arguments) || 0 : I7(this, e, arguments[1]);
} });
var bm = [].lastIndexOf, cv = !!bm && 1 / [1].lastIndexOf(1, -0) < 0;
H(H.P + H.F * (cv || !Ci(bm)), "Array", { lastIndexOf: function(e) {
  if (cv)
    return bm.apply(this, arguments) || 0;
  var t = lr(this), n = sn(t.length), r = n - 1;
  for (arguments.length > 1 && (r = Math.min(r, zi(arguments[1]))), r < 0 && (r = n + r); r >= 0; r--)
    if (r in t && t[r] === e)
      return r || 0;
  return -1;
} });
var wE = [].copyWithin || function(e, t) {
  var n = Zn(this), r = sn(n.length), i = ai(e, r), a = ai(t, r), s = arguments.length > 2 ? arguments[2] : void 0, o = Math.min((s === void 0 ? r : ai(s, r)) - a, r - i), u = 1;
  for (a < i && i < a + o && (u = -1, a += o - 1, i += o - 1); o-- > 0; )
    a in n ? n[i] = n[a] : delete n[i], i += u, a += u;
  return n;
}, Em = Ut("unscopables"), Cm = Array.prototype;
Cm[Em] == null && Pn(Cm, Em, {});
var Da = function(e) {
  Cm[Em][e] = !0;
};
H(H.P, "Array", { copyWithin: wE }), Da("copyWithin");
var T0 = function(e) {
  for (var t = Zn(this), n = sn(t.length), r = arguments.length, i = ai(r > 1 ? arguments[1] : void 0, n), a = r > 2 ? arguments[2] : void 0, s = a === void 0 ? n : ai(a, n); s > i; )
    t[i++] = e;
  return t;
};
H(H.P, "Array", { fill: T0 }), Da("fill");
var B7 = Si(5), lv = !0;
"find" in [] && Array(1).find(function() {
  lv = !1;
}), H(H.P + H.F * lv, "Array", { find: function(e) {
  return B7(this, e, arguments.length > 1 ? arguments[1] : void 0);
} }), Da("find");
var O7 = Si(6), pv = !0;
"findIndex" in [] && Array(1).findIndex(function() {
  pv = !1;
}), H(H.P + H.F * pv, "Array", { findIndex: function(e) {
  return O7(this, e, arguments.length > 1 ? arguments[1] : void 0);
} }), Da("findIndex");
var fv = Ut("species"), Xs = function(e) {
  var t = Re[e];
  rn && t && !t[fv] && En.f(t, fv, { configurable: !0, get: function() {
    return this;
  } });
};
Xs("Array");
var Fp = function(e, t) {
  return { value: t, done: !!e };
}, Sm = S0(Array, "Array", function(e, t) {
  this._t = lr(e), this._i = 0, this._k = t;
}, function() {
  var e = this._t, t = this._k, n = this._i++;
  return !e || n >= e.length ? (this._t = void 0, Fp(1)) : Fp(0, t == "keys" ? n : t == "values" ? e[n] : [n, e[n]]);
}, "values");
Aa.Arguments = Aa.Array, Da("keys"), Da("values"), Da("entries");
var sf = function() {
  var e = Ct(this), t = "";
  return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
}, L7 = En.f, N7 = qo.f, Xn = Re.RegExp, bu = Xn, zh = Xn.prototype, Xu = /a/g, Hh = /a/g, hv = new Xn(Xu) !== Xu;
if (rn && (!hv || pt(function() {
  return Hh[Ut("match")] = !1, Xn(Xu) != Xu || Xn(Hh) == Hh || Xn(Xu, "i") != "/a/i";
}))) {
  Xn = function(e, t) {
    var n = this instanceof Xn, r = k0(e), i = t === void 0;
    return !n && r && e.constructor === Xn && i ? e : b0(hv ? new bu(r && !i ? e.source : e, t) : bu((r = e instanceof Xn) ? e.source : e, r && i ? sf.call(e) : t), n ? this : zh, Xn);
  };
  for (var j7 = function(e) {
    e in Xn || L7(Xn, e, { configurable: !0, get: function() {
      return bu[e];
    }, set: function(t) {
      bu[e] = t;
    } });
  }, dv = N7(bu), mv = 0; dv.length > mv; )
    j7(dv[mv++]);
  zh.constructor = Xn, Xn.prototype = zh, Er(Re, "RegExp", Xn);
}
Xs("RegExp");
var wp = RegExp.prototype.exec, R7 = String.prototype.replace, AE = wp, Kh = function() {
  var e = /a/, t = /b*/g;
  return wp.call(e, "a"), wp.call(t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
}(), Jh = /()??/.exec("")[1] !== void 0;
(Kh || Jh) && (AE = function(e) {
  var t, n, r, i, a = this;
  return Jh && (n = new RegExp("^" + a.source + "$(?!\\s)", sf.call(a))), Kh && (t = a.lastIndex), r = wp.call(a, e), Kh && r && (a.lastIndex = a.global ? r.index + r[0].length : t), Jh && r && r.length > 1 && R7.call(r[0], n, function() {
    for (i = 1; i < arguments.length - 2; i++)
      arguments[i] === void 0 && (r[i] = void 0);
  }), r;
});
var Ap = AE;
H({ target: "RegExp", proto: !0, forced: Ap !== /./.exec }, { exec: Ap }), rn && /./g.flags != "g" && En.f(RegExp.prototype, "flags", { configurable: !0, get: sf });
var Qh = /./.toString, gv = function(e) {
  Er(RegExp.prototype, "toString", e, !0);
};
pt(function() {
  return Qh.call({ source: "a", flags: "b" }) != "/a/b";
}) ? gv(function() {
  var e = Ct(this);
  return "/".concat(e.source, "/", "flags" in e ? e.flags : !rn && e instanceof RegExp ? sf.call(e) : void 0);
}) : Qh.name != "toString" && gv(function() {
  return Qh.call(this);
});
var M7 = C0(!0), P0 = function(e, t, n) {
  return t + (n ? M7(e, t).length : 1);
}, V7 = RegExp.prototype.exec, Vs = function(e, t) {
  var n = e.exec;
  if (typeof n == "function") {
    var r = n.call(e, t);
    if (xe(r) !== "object")
      throw new TypeError("RegExp exec method returned something other than an Object or null");
    return r;
  }
  if (bc(e) !== "RegExp")
    throw new TypeError("RegExp#exec called on incompatible receiver");
  return V7.call(e, t);
}, U7 = Ut("species"), q7 = !pt(function() {
  var e = /./;
  return e.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(e, "$<a>") !== "7";
}), W7 = function() {
  var e = /(?:)/, t = e.exec;
  e.exec = function() {
    return t.apply(this, arguments);
  };
  var n = "ab".split(e);
  return n.length === 2 && n[0] === "a" && n[1] === "b";
}(), _p = function(e, t, n) {
  var r = Ut(e), i = !pt(function() {
    var f = {};
    return f[r] = function() {
      return 7;
    }, ""[e](f) != 7;
  }), a = i ? !pt(function() {
    var f = !1, p = /a/;
    return p.exec = function() {
      return f = !0, null;
    }, e === "split" && (p.constructor = {}, p.constructor[U7] = function() {
      return p;
    }), p[r](""), !f;
  }) : void 0;
  if (!i || !a || e === "replace" && !q7 || e === "split" && !W7) {
    var s = /./[r], o = n(Ta, r, ""[e], function(f, p, d, m, y) {
      return p.exec === Ap ? i && !y ? { done: !0, value: s.call(p, d, m) } : { done: !0, value: f.call(d, p, m) } : { done: !1 };
    }), u = o[0], c = o[1];
    Er(String.prototype, e, u), Pn(RegExp.prototype, r, t == 2 ? function(f, p) {
      return c.call(f, this, p);
    } : function(f) {
      return c.call(f, this);
    });
  }
};
_p("match", 1, function(e, t, n, r) {
  return [function(i) {
    var a = e(this), s = i == null ? void 0 : i[t];
    return s !== void 0 ? s.call(i, a) : new RegExp(i)[t](String(a));
  }, function(i) {
    var a = r(n, i, this);
    if (a.done)
      return a.value;
    var s = Ct(i), o = String(this);
    if (!s.global)
      return Vs(s, o);
    var u = s.unicode;
    s.lastIndex = 0;
    for (var c, f = [], p = 0; (c = Vs(s, o)) !== null; ) {
      var d = String(c[0]);
      f[p] = d, d === "" && (s.lastIndex = P0(o, sn(s.lastIndex), u)), p++;
    }
    return p === 0 ? null : f;
  }];
});
var $7 = Math.max, G7 = Math.min, z7 = Math.floor, H7 = /\$([$&`']|\d\d?|<[^>]*>)/g, K7 = /\$([$&`']|\d\d?)/g;
_p("replace", 2, function(e, t, n, r) {
  return [function(a, s) {
    var o = e(this), u = a == null ? void 0 : a[t];
    return u !== void 0 ? u.call(a, o, s) : n.call(String(o), a, s);
  }, function(a, s) {
    var o = r(n, a, this, s);
    if (o.done)
      return o.value;
    var u = Ct(a), c = String(this), f = typeof s == "function";
    f || (s = String(s));
    var p = u.global;
    if (p) {
      var d = u.unicode;
      u.lastIndex = 0;
    }
    for (var m = []; ; ) {
      var y = Vs(u, c);
      if (y === null || (m.push(y), !p))
        break;
      String(y[0]) === "" && (u.lastIndex = P0(c, sn(u.lastIndex), d));
    }
    for (var v, b = "", x = 0, C = 0; C < m.length; C++) {
      y = m[C];
      for (var k = String(y[0]), F = $7(G7(zi(y.index), c.length), 0), B = [], O = 1; O < y.length; O++)
        B.push((v = y[O]) === void 0 ? v : String(v));
      var S = y.groups;
      if (f) {
        var w = [k].concat(B, F, c);
        S !== void 0 && w.push(S);
        var D = String(s.apply(void 0, w));
      } else
        D = i(k, c, F, B, S, s);
      F >= x && (b += c.slice(x, F) + D, x = F + k.length);
    }
    return b + c.slice(x);
  }];
  function i(a, s, o, u, c, f) {
    var p = o + a.length, d = u.length, m = K7;
    return c !== void 0 && (c = Zn(c), m = H7), n.call(f, m, function(y, v) {
      var b;
      switch (v.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return a;
        case "`":
          return s.slice(0, o);
        case "'":
          return s.slice(p);
        case "<":
          b = c[v.slice(1, -1)];
          break;
        default:
          var x = +v;
          if (x === 0)
            return y;
          if (x > d) {
            var C = z7(x / 10);
            return C === 0 ? y : C <= d ? u[C - 1] === void 0 ? v.charAt(1) : u[C - 1] + v.charAt(1) : y;
          }
          b = u[x - 1];
      }
      return b === void 0 ? "" : b;
    });
  }
}), _p("search", 1, function(e, t, n, r) {
  return [function(i) {
    var a = e(this), s = i == null ? void 0 : i[t];
    return s !== void 0 ? s.call(i, a) : new RegExp(i)[t](String(a));
  }, function(i) {
    var a = r(n, i, this);
    if (a.done)
      return a.value;
    var s = Ct(i), o = String(this), u = s.lastIndex;
    ym(u, 0) || (s.lastIndex = 0);
    var c = Vs(s, o);
    return ym(s.lastIndex, u) || (s.lastIndex = u), c === null ? -1 : c.index;
  }];
});
var J7 = Ut("species"), Ec = function(e, t) {
  var n, r = Ct(e).constructor;
  return r === void 0 || (n = Ct(r)[J7]) == null ? t : oi(n);
}, Q7 = Math.min, X7 = [].push, Eu = !pt(function() {
  RegExp(4294967295, "y");
});
_p("split", 2, function(e, t, n, r) {
  var i;
  return i = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(a, s) {
    var o = String(this);
    if (a === void 0 && s === 0)
      return [];
    if (!k0(a))
      return n.call(o, a, s);
    for (var u, c, f, p = [], d = (a.ignoreCase ? "i" : "") + (a.multiline ? "m" : "") + (a.unicode ? "u" : "") + (a.sticky ? "y" : ""), m = 0, y = s === void 0 ? 4294967295 : s >>> 0, v = new RegExp(a.source, d + "g"); (u = Ap.call(v, o)) && !((c = v.lastIndex) > m && (p.push(o.slice(m, u.index)), u.length > 1 && u.index < o.length && X7.apply(p, u.slice(1)), f = u[0].length, m = c, p.length >= y)); )
      v.lastIndex === u.index && v.lastIndex++;
    return m === o.length ? !f && v.test("") || p.push("") : p.push(o.slice(m)), p.length > y ? p.slice(0, y) : p;
  } : "0".split(void 0, 0).length ? function(a, s) {
    return a === void 0 && s === 0 ? [] : n.call(this, a, s);
  } : n, [function(a, s) {
    var o = e(this), u = a == null ? void 0 : a[t];
    return u !== void 0 ? u.call(a, o, s) : i.call(String(o), a, s);
  }, function(a, s) {
    var o = r(i, a, this, s, i !== n);
    if (o.done)
      return o.value;
    var u = Ct(a), c = String(this), f = Ec(u, RegExp), p = u.unicode, d = (u.ignoreCase ? "i" : "") + (u.multiline ? "m" : "") + (u.unicode ? "u" : "") + (Eu ? "y" : "g"), m = new f(Eu ? u : "^(?:" + u.source + ")", d), y = s === void 0 ? 4294967295 : s >>> 0;
    if (y === 0)
      return [];
    if (c.length === 0)
      return Vs(m, c) === null ? [c] : [];
    for (var v = 0, b = 0, x = []; b < c.length; ) {
      m.lastIndex = Eu ? b : 0;
      var C, k = Vs(m, Eu ? c : c.slice(b));
      if (k === null || (C = Q7(sn(m.lastIndex + (Eu ? 0 : b)), c.length)) === v)
        b = P0(c, b, p);
      else {
        if (x.push(c.slice(v, b)), x.length === y)
          return x;
        for (var F = 1; F <= k.length - 1; F++)
          if (x.push(k[F]), x.length === y)
            return x;
        b = v = C;
      }
    }
    return x.push(c.slice(v)), x;
  }];
});
var cs, yv, Xh, xa = function(e, t, n, r) {
  if (!(e instanceof t) || r !== void 0 && r in e)
    throw TypeError(n + ": incorrect invocation!");
  return e;
}, sc = gt(function(e) {
  var t = {}, n = {}, r = e.exports = function(i, a, s, o, u) {
    var c, f, p, d, m = u ? function() {
      return i;
    } : _0(i), y = In(s, o, a ? 2 : 1), v = 0;
    if (typeof m != "function")
      throw TypeError(i + " is not iterable!");
    if (A0(m)) {
      for (c = sn(i.length); c > v; v++)
        if ((d = a ? y(Ct(f = i[v])[0], f[1]) : y(i[v])) === t || d === n)
          return d;
    } else
      for (p = m.call(i); !(f = p.next()).done; )
        if ((d = kE(p, y, f.value, a)) === t || d === n)
          return d;
  };
  r.BREAK = t, r.RETURN = n;
}), vv = Re.process, km = Re.setImmediate, Dm = Re.clearImmediate, xv = Re.MessageChannel, Yh = Re.Dispatch, Zh = 0, Yu = {}, Nu = function() {
  var e = +this;
  if (Yu.hasOwnProperty(e)) {
    var t = Yu[e];
    delete Yu[e], t();
  }
}, bv = function(e) {
  Nu.call(e.data);
};
km && Dm || (km = function(e) {
  for (var t = [], n = 1; arguments.length > n; )
    t.push(arguments[n++]);
  return Yu[++Zh] = function() {
    mE(typeof e == "function" ? e : Function(e), t);
  }, cs(Zh), Zh;
}, Dm = function(e) {
  delete Yu[e];
}, si(vv) == "process" ? cs = function(e) {
  vv.nextTick(In(Nu, e, 1));
} : Yh && Yh.now ? cs = function(e) {
  Yh.now(In(Nu, e, 1));
} : xv ? (Xh = (yv = new xv()).port2, yv.port1.onmessage = bv, cs = In(Xh.postMessage, Xh, 1)) : Re.addEventListener && typeof postMessage == "function" && !Re.importScripts ? (cs = function(e) {
  Re.postMessage(e + "", "*");
}, Re.addEventListener("message", bv, !1)) : cs = "onreadystatechange" in bp("script") ? function(e) {
  ac.appendChild(bp("script")).onreadystatechange = function() {
    ac.removeChild(this), Nu.call(e);
  };
} : function(e) {
  setTimeout(In(Nu, e, 1), 0);
});
var Tp = { set: km, clear: Dm }, Y7 = Tp.set, Ev = Re.MutationObserver || Re.WebKitMutationObserver, Fm = Re.process, ed = Re.Promise, Cv = si(Fm) == "process";
function Z7(e) {
  var t, n;
  this.promise = new e(function(r, i) {
    if (t !== void 0 || n !== void 0)
      throw TypeError("Bad Promise constructor");
    t = r, n = i;
  }), this.resolve = oi(t), this.reject = oi(n);
}
var td, _E, Sv, kv, I0 = { f: function(e) {
  return new Z7(e);
} }, wm = function(e) {
  try {
    return { e: !1, v: e() };
  } catch (t) {
    return { e: !0, v: t };
  }
}, Dv = Re.navigator, uf = Dv && Dv.userAgent || "", Am = function(e, t) {
  if (Ct(e), ht(t) && t.constructor === e)
    return t;
  var n = I0.f(e);
  return (0, n.resolve)(t), n.promise;
}, jo = function(e, t, n) {
  for (var r in t)
    Er(e, r, t[r], n);
  return e;
}, TE = Tp.set, PE = function() {
  var e, t, n, r = function() {
    var o, u;
    for (Cv && (o = Fm.domain) && o.exit(); e; ) {
      u = e.fn, e = e.next;
      try {
        u();
      } catch (c) {
        throw e ? n() : t = void 0, c;
      }
    }
    t = void 0, o && o.enter();
  };
  if (Cv)
    n = function() {
      Fm.nextTick(r);
    };
  else if (!Ev || Re.navigator && Re.navigator.standalone)
    if (ed && ed.resolve) {
      var i = ed.resolve(void 0);
      n = function() {
        i.then(r);
      };
    } else
      n = function() {
        Y7.call(Re, r);
      };
  else {
    var a = !0, s = document.createTextNode("");
    new Ev(r).observe(s, { characterData: !0 }), n = function() {
      s.data = a = !a;
    };
  }
  return function(o) {
    var u = { fn: o, next: void 0 };
    t && (t.next = u), e || (e = u, n()), t = u;
  };
}(), IE = Re.TypeError, Us = Re.process, Fv = Us && Us.versions, e4 = Fv && Fv.v8 || "", fa = Re.Promise, uc = bc(Us) == "process", ap = function() {
}, Cu = _E = I0.f, Su = !!function() {
  try {
    var e = fa.resolve(1), t = (e.constructor = {})[Ut("species")] = function(n) {
      n(ap, ap);
    };
    return (uc || typeof PromiseRejectionEvent == "function") && e.then(ap) instanceof t && e4.indexOf("6.6") !== 0 && uf.indexOf("Chrome/66") === -1;
  } catch {
  }
}(), BE = function(e) {
  var t;
  return !(!ht(e) || typeof (t = e.then) != "function") && t;
}, B0 = function(e, t) {
  if (!e._n) {
    e._n = !0;
    var n = e._c;
    PE(function() {
      for (var r = e._v, i = e._s == 1, a = 0, s = function(o) {
        var u, c, f, p = i ? o.ok : o.fail, d = o.resolve, m = o.reject, y = o.domain;
        try {
          p ? (i || (e._h == 2 && n4(e), e._h = 1), p === !0 ? u = r : (y && y.enter(), u = p(r), y && (y.exit(), f = !0)), u === o.promise ? m(IE("Promise-chain cycle")) : (c = BE(u)) ? c.call(u, d, m) : d(u)) : m(r);
        } catch (v) {
          y && !f && y.exit(), m(v);
        }
      }; n.length > a; )
        s(n[a++]);
      e._c = [], e._n = !1, t && !e._h && t4(e);
    });
  }
}, t4 = function(e) {
  TE.call(Re, function() {
    var t, n, r, i = e._v, a = wv(e);
    if (a && (t = wm(function() {
      uc ? Us.emit("unhandledRejection", i, e) : (n = Re.onunhandledrejection) ? n({ promise: e, reason: i }) : (r = Re.console) && r.error && r.error("Unhandled promise rejection", i);
    }), e._h = uc || wv(e) ? 2 : 1), e._a = void 0, a && t.e)
      throw t.v;
  });
}, wv = function(e) {
  return e._h !== 1 && (e._a || e._c).length === 0;
}, n4 = function(e) {
  TE.call(Re, function() {
    var t;
    uc ? Us.emit("rejectionHandled", e) : (t = Re.onrejectionhandled) && t({ promise: e, reason: e._v });
  });
}, ws = function(e) {
  var t = this;
  t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), B0(t, !0));
}, Av = function e(t) {
  var n, r = this;
  if (!r._d) {
    r._d = !0, r = r._w || r;
    try {
      if (r === t)
        throw IE("Promise can't be resolved itself");
      (n = BE(t)) ? PE(function() {
        var i = { _w: r, _d: !1 };
        try {
          n.call(t, In(e, i, 1), In(ws, i, 1));
        } catch (a) {
          ws.call(i, a);
        }
      }) : (r._v = t, r._s = 1, B0(r, !1));
    } catch (i) {
      ws.call({ _w: r, _d: !1 }, i);
    }
  }
};
Su || (fa = function(e) {
  xa(this, fa, "Promise", "_h"), oi(e), td.call(this);
  try {
    e(In(Av, this, 1), In(ws, this, 1));
  } catch (t) {
    ws.call(this, t);
  }
}, (td = function(e) {
  this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
}).prototype = jo(fa.prototype, { then: function(e, t) {
  var n = Cu(Ec(this, fa));
  return n.ok = typeof e != "function" || e, n.fail = typeof t == "function" && t, n.domain = uc ? Us.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && B0(this, !1), n.promise;
}, catch: function(e) {
  return this.then(void 0, e);
} }), Sv = function() {
  var e = new td();
  this.promise = e, this.resolve = In(Av, e, 1), this.reject = In(ws, e, 1);
}, I0.f = Cu = function(e) {
  return e === fa || e === kv ? new Sv(e) : _E(e);
}), H(H.G + H.W + H.F * !Su, { Promise: fa }), ka(fa, "Promise"), Xs("Promise"), kv = hn.Promise, H(H.S + H.F * !Su, "Promise", { reject: function(e) {
  var t = Cu(this);
  return (0, t.reject)(e), t.promise;
} }), H(H.S + H.F * !Su, "Promise", { resolve: function(e) {
  return Am(this, e);
} }), H(H.S + H.F * !(Su && of(function(e) {
  fa.all(e).catch(ap);
})), "Promise", { all: function(e) {
  var t = this, n = Cu(t), r = n.resolve, i = n.reject, a = wm(function() {
    var s = [], o = 0, u = 1;
    sc(e, !1, function(c) {
      var f = o++, p = !1;
      s.push(void 0), u++, t.resolve(c).then(function(d) {
        p || (p = !0, s[f] = d, --u || r(s));
      }, i);
    }), --u || r(s);
  });
  return a.e && i(a.v), n.promise;
}, race: function(e) {
  var t = this, n = Cu(t), r = n.reject, i = wm(function() {
    sc(e, !1, function(a) {
      t.resolve(a).then(n.resolve, r);
    });
  });
  return i.e && r(i.v), n.promise;
} });
var cr = function(e, t) {
  if (!ht(e) || e._t !== t)
    throw TypeError("Incompatible receiver, " + t + " required!");
  return e;
}, r4 = En.f, OE = br.fastKey, ku = rn ? "_s" : "size", wl = function(e, t) {
  var n, r = OE(t);
  if (r !== "F")
    return e._i[r];
  for (n = e._f; n; n = n.n)
    if (n.k == t)
      return n;
}, Du = { getConstructor: function(e, t, n, r) {
  var i = e(function(a, s) {
    xa(a, i, t, "_i"), a._t = t, a._i = Ei(null), a._f = void 0, a._l = void 0, a[ku] = 0, s != null && sc(s, n, a[r], a);
  });
  return jo(i.prototype, { clear: function() {
    for (var a = cr(this, t), s = a._i, o = a._f; o; o = o.n)
      o.r = !0, o.p && (o.p = o.p.n = void 0), delete s[o.i];
    a._f = a._l = void 0, a[ku] = 0;
  }, delete: function(a) {
    var s = cr(this, t), o = wl(s, a);
    if (o) {
      var u = o.n, c = o.p;
      delete s._i[o.i], o.r = !0, c && (c.n = u), u && (u.p = c), s._f == o && (s._f = u), s._l == o && (s._l = c), s[ku]--;
    }
    return !!o;
  }, forEach: function(a) {
    cr(this, t);
    for (var s, o = In(a, arguments.length > 1 ? arguments[1] : void 0, 3); s = s ? s.n : this._f; )
      for (o(s.v, s.k, this); s && s.r; )
        s = s.p;
  }, has: function(a) {
    return !!wl(cr(this, t), a);
  } }), rn && r4(i.prototype, "size", { get: function() {
    return cr(this, t)[ku];
  } }), i;
}, def: function(e, t, n) {
  var r, i, a = wl(e, t);
  return a ? a.v = n : (e._l = a = { i: i = OE(t, !0), k: t, v: n, p: r = e._l, n: void 0, r: !1 }, e._f || (e._f = a), r && (r.n = a), e[ku]++, i !== "F" && (e._i[i] = a)), e;
}, getEntry: wl, setStrong: function(e, t, n) {
  S0(e, t, function(r, i) {
    this._t = cr(r, t), this._k = i, this._l = void 0;
  }, function() {
    for (var r = this._k, i = this._l; i && i.r; )
      i = i.p;
    return this._t && (this._l = i = i ? i.n : this._t._f) ? Fp(0, r == "keys" ? i.k : r == "values" ? i.v : [i.k, i.v]) : (this._t = void 0, Fp(1));
  }, n ? "entries" : "values", !n, !0), Xs(t);
} }, Pp = function(e, t, n, r, i, a) {
  var s = Re[e], o = s, u = i ? "set" : "add", c = o && o.prototype, f = {}, p = function(x) {
    var C = c[x];
    Er(c, x, x == "delete" ? function(k) {
      return !(a && !ht(k)) && C.call(this, k === 0 ? 0 : k);
    } : x == "has" ? function(k) {
      return !(a && !ht(k)) && C.call(this, k === 0 ? 0 : k);
    } : x == "get" ? function(k) {
      return a && !ht(k) ? void 0 : C.call(this, k === 0 ? 0 : k);
    } : x == "add" ? function(k) {
      return C.call(this, k === 0 ? 0 : k), this;
    } : function(k, F) {
      return C.call(this, k === 0 ? 0 : k, F), this;
    });
  };
  if (typeof o == "function" && (a || c.forEach && !pt(function() {
    new o().entries().next();
  }))) {
    var d = new o(), m = d[u](a ? {} : -0, 1) != d, y = pt(function() {
      d.has(1);
    }), v = of(function(x) {
      new o(x);
    }), b = !a && pt(function() {
      for (var x = new o(), C = 5; C--; )
        x[u](C, C);
      return !x.has(-0);
    });
    v || ((o = t(function(x, C) {
      xa(x, o, e);
      var k = b0(new s(), x, o);
      return C != null && sc(C, i, k[u], k), k;
    })).prototype = c, c.constructor = o), (y || b) && (p("delete"), p("has"), i && p("get")), (b || m) && p(u), a && c.clear && delete c.clear;
  } else
    o = r.getConstructor(t, e, i, u), jo(o.prototype, n), br.NEED = !0;
  return ka(o, e), f[e] = o, H(H.G + H.W + H.F * (o != s), f), a || r.setStrong(o, e, i), o;
}, nd = (Pp("Map", function(e) {
  return function() {
    return e(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { get: function(e) {
  var t = Du.getEntry(cr(this, "Map"), e);
  return t && t.v;
}, set: function(e, t) {
  return Du.def(cr(this, "Map"), e === 0 ? 0 : e, t);
} }, Du, !0), Pp("Set", function(e) {
  return function() {
    return e(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e) {
  return Du.def(cr(this, "Set"), e = e === 0 ? 0 : e, e);
} }, Du), br.getWeak), i4 = Si(5), a4 = Si(6), o4 = 0, Al = function(e) {
  return e._l || (e._l = new LE());
}, LE = function() {
  this.a = [];
}, rd = function(e, t) {
  return i4(e.a, function(n) {
    return n[0] === t;
  });
};
LE.prototype = { get: function(e) {
  var t = rd(this, e);
  if (t)
    return t[1];
}, has: function(e) {
  return !!rd(this, e);
}, set: function(e, t) {
  var n = rd(this, e);
  n ? n[1] = t : this.a.push([e, t]);
}, delete: function(e) {
  var t = a4(this.a, function(n) {
    return n[0] === e;
  });
  return ~t && this.a.splice(t, 1), !!~t;
} };
var Ss = { getConstructor: function(e, t, n, r) {
  var i = e(function(a, s) {
    xa(a, i, t, "_i"), a._t = t, a._i = o4++, a._l = void 0, s != null && sc(s, n, a[r], a);
  });
  return jo(i.prototype, { delete: function(a) {
    if (!ht(a))
      return !1;
    var s = nd(a);
    return s === !0 ? Al(cr(this, t)).delete(a) : s && At(s, this._i) && delete s[this._i];
  }, has: function(a) {
    if (!ht(a))
      return !1;
    var s = nd(a);
    return s === !0 ? Al(cr(this, t)).has(a) : s && At(s, this._i);
  } }), i;
}, def: function(e, t, n) {
  var r = nd(Ct(t), !0);
  return r === !0 ? Al(e).set(t, n) : r[e._i] = n, e;
}, ufstore: Al };
gt(function(e) {
  var t, n = Si(0), r = cr, i = !Re.ActiveXObject && "ActiveXObject" in Re, a = br.getWeak, s = Object.isExtensible, o = Ss.ufstore, u = function(p) {
    return function() {
      return p(this, arguments.length > 0 ? arguments[0] : void 0);
    };
  }, c = { get: function(p) {
    if (ht(p)) {
      var d = a(p);
      return d === !0 ? o(cr(this, "WeakMap")).get(p) : d ? d[this._i] : void 0;
    }
  }, set: function(p, d) {
    return Ss.def(cr(this, "WeakMap"), p, d);
  } }, f = e.exports = Pp("WeakMap", u, c, Ss, !0, !0);
  r && i && (t = Ss.getConstructor(u, "WeakMap"), dE(t.prototype, c), br.NEED = !0, n(["delete", "has", "get", "set"], function(p) {
    var d = f.prototype, m = d[p];
    Er(d, p, function(y, v) {
      if (ht(y) && !s(y)) {
        this._f || (this._f = new t());
        var b = this._f[p](y, v);
        return p == "set" ? this : b;
      }
      return m.call(this, y, v);
    });
  }));
});
Pp("WeakSet", function(e) {
  return function() {
    return e(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e) {
  return Ss.def(cr(this, "WeakSet"), e, !0);
} }, Ss, !1, !0);
for (var id, NE = to("typed_array"), jE = to("view"), RE = !(!Re.ArrayBuffer || !Re.DataView), ME = RE, _v = 0, s4 = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); _v < 9; )
  (id = Re[s4[_v++]]) ? (Pn(id.prototype, NE, !0), Pn(id.prototype, jE, !0)) : ME = !1;
var Ro = { ABV: RE, CONSTR: ME, TYPED: NE, VIEW: jE }, ju = function(e) {
  if (e === void 0)
    return 0;
  var t = zi(e), n = sn(t);
  if (t !== n)
    throw RangeError("Wrong length!");
  return n;
}, cf = gt(function(e, t) {
  var n = qo.f, r = En.f, i = "prototype", a = "Wrong index!", s = Re.ArrayBuffer, o = Re.DataView, u = Re.Math, c = Re.RangeError, f = Re.Infinity, p = s, d = u.abs, m = u.pow, y = u.floor, v = u.log, b = u.LN2, x = rn ? "_b" : "buffer", C = rn ? "_l" : "byteLength", k = rn ? "_o" : "byteOffset";
  function F(M, ne, de) {
    var he, j, ie, fe = new Array(de), ge = 8 * de - ne - 1, Fe = (1 << ge) - 1, Pe = Fe >> 1, _ = ne === 23 ? m(2, -24) - m(2, -77) : 0, Q = 0, Y = M < 0 || M === 0 && 1 / M < 0 ? 1 : 0;
    for ((M = d(M)) != M || M === f ? (j = M != M ? 1 : 0, he = Fe) : (he = y(v(M) / b), M * (ie = m(2, -he)) < 1 && (he--, ie *= 2), (M += he + Pe >= 1 ? _ / ie : _ * m(2, 1 - Pe)) * ie >= 2 && (he++, ie /= 2), he + Pe >= Fe ? (j = 0, he = Fe) : he + Pe >= 1 ? (j = (M * ie - 1) * m(2, ne), he += Pe) : (j = M * m(2, Pe - 1) * m(2, ne), he = 0)); ne >= 8; fe[Q++] = 255 & j, j /= 256, ne -= 8)
      ;
    for (he = he << ne | j, ge += ne; ge > 0; fe[Q++] = 255 & he, he /= 256, ge -= 8)
      ;
    return fe[--Q] |= 128 * Y, fe;
  }
  function B(M, ne, de) {
    var he, j = 8 * de - ne - 1, ie = (1 << j) - 1, fe = ie >> 1, ge = j - 7, Fe = de - 1, Pe = M[Fe--], _ = 127 & Pe;
    for (Pe >>= 7; ge > 0; _ = 256 * _ + M[Fe], Fe--, ge -= 8)
      ;
    for (he = _ & (1 << -ge) - 1, _ >>= -ge, ge += ne; ge > 0; he = 256 * he + M[Fe], Fe--, ge -= 8)
      ;
    if (_ === 0)
      _ = 1 - fe;
    else {
      if (_ === ie)
        return he ? NaN : Pe ? -f : f;
      he += m(2, ne), _ -= fe;
    }
    return (Pe ? -1 : 1) * he * m(2, _ - ne);
  }
  function O(M) {
    return M[3] << 24 | M[2] << 16 | M[1] << 8 | M[0];
  }
  function S(M) {
    return [255 & M];
  }
  function w(M) {
    return [255 & M, M >> 8 & 255];
  }
  function D(M) {
    return [255 & M, M >> 8 & 255, M >> 16 & 255, M >> 24 & 255];
  }
  function I(M) {
    return F(M, 52, 8);
  }
  function L(M) {
    return F(M, 23, 4);
  }
  function V(M, ne, de) {
    r(M[i], ne, { get: function() {
      return this[de];
    } });
  }
  function K(M, ne, de, he) {
    var j = ju(+de);
    if (j + ne > M[C])
      throw c(a);
    var ie = M[x]._b, fe = j + M[k], ge = ie.slice(fe, fe + ne);
    return he ? ge : ge.reverse();
  }
  function W(M, ne, de, he, j, ie) {
    var fe = ju(+de);
    if (fe + ne > M[C])
      throw c(a);
    for (var ge = M[x]._b, Fe = fe + M[k], Pe = he(+j), _ = 0; _ < ne; _++)
      ge[Fe + _] = Pe[ie ? _ : ne - _ - 1];
  }
  if (Ro.ABV) {
    if (!pt(function() {
      s(1);
    }) || !pt(function() {
      new s(-1);
    }) || pt(function() {
      return new s(), new s(1.5), new s(NaN), s.name != "ArrayBuffer";
    })) {
      for (var R, q = (s = function(M) {
        return xa(this, s), new p(ju(M));
      })[i] = p[i], J = n(p), X = 0; J.length > X; )
        (R = J[X++]) in s || Pn(s, R, p[R]);
      q.constructor = s;
    }
    var ce = new o(new s(2)), A = o[i].setInt8;
    ce.setInt8(0, 2147483648), ce.setInt8(1, 2147483649), !ce.getInt8(0) && ce.getInt8(1) || jo(o[i], { setInt8: function(M, ne) {
      A.call(this, M, ne << 24 >> 24);
    }, setUint8: function(M, ne) {
      A.call(this, M, ne << 24 >> 24);
    } }, !0);
  } else
    s = function(M) {
      xa(this, s, "ArrayBuffer");
      var ne = ju(M);
      this._b = T0.call(new Array(ne), 0), this[C] = ne;
    }, o = function(M, ne, de) {
      xa(this, o, "DataView"), xa(M, s, "DataView");
      var he = M[C], j = zi(ne);
      if (j < 0 || j > he)
        throw c("Wrong offset!");
      if (j + (de = de === void 0 ? he - j : sn(de)) > he)
        throw c("Wrong length!");
      this[x] = M, this[k] = j, this[C] = de;
    }, rn && (V(s, "byteLength", "_l"), V(o, "buffer", "_b"), V(o, "byteLength", "_l"), V(o, "byteOffset", "_o")), jo(o[i], { getInt8: function(M) {
      return K(this, 1, M)[0] << 24 >> 24;
    }, getUint8: function(M) {
      return K(this, 1, M)[0];
    }, getInt16: function(M) {
      var ne = K(this, 2, M, arguments[1]);
      return (ne[1] << 8 | ne[0]) << 16 >> 16;
    }, getUint16: function(M) {
      var ne = K(this, 2, M, arguments[1]);
      return ne[1] << 8 | ne[0];
    }, getInt32: function(M) {
      return O(K(this, 4, M, arguments[1]));
    }, getUint32: function(M) {
      return O(K(this, 4, M, arguments[1])) >>> 0;
    }, getFloat32: function(M) {
      return B(K(this, 4, M, arguments[1]), 23, 4);
    }, getFloat64: function(M) {
      return B(K(this, 8, M, arguments[1]), 52, 8);
    }, setInt8: function(M, ne) {
      W(this, 1, M, S, ne);
    }, setUint8: function(M, ne) {
      W(this, 1, M, S, ne);
    }, setInt16: function(M, ne) {
      W(this, 2, M, w, ne, arguments[2]);
    }, setUint16: function(M, ne) {
      W(this, 2, M, w, ne, arguments[2]);
    }, setInt32: function(M, ne) {
      W(this, 4, M, D, ne, arguments[2]);
    }, setUint32: function(M, ne) {
      W(this, 4, M, D, ne, arguments[2]);
    }, setFloat32: function(M, ne) {
      W(this, 4, M, L, ne, arguments[2]);
    }, setFloat64: function(M, ne) {
      W(this, 8, M, I, ne, arguments[2]);
    } });
  ka(s, "ArrayBuffer"), ka(o, "DataView"), Pn(o[i], Ro.VIEW, !0), t.ArrayBuffer = s, t.DataView = o;
}), VE = Re.ArrayBuffer, Ru = cf.ArrayBuffer, Tv = cf.DataView, Pv = Ro.ABV && VE.isView, Iv = Ru.prototype.slice, u4 = Ro.VIEW;
H(H.G + H.W + H.F * (VE !== Ru), { ArrayBuffer: Ru }), H(H.S + H.F * !Ro.CONSTR, "ArrayBuffer", { isView: function(e) {
  return Pv && Pv(e) || ht(e) && u4 in e;
} }), H(H.P + H.U + H.F * pt(function() {
  return !new Ru(2).slice(1, void 0).byteLength;
}), "ArrayBuffer", { slice: function(e, t) {
  if (Iv !== void 0 && t === void 0)
    return Iv.call(Ct(this), e);
  for (var n = Ct(this).byteLength, r = ai(e, n), i = ai(t === void 0 ? n : t, n), a = new (Ec(this, Ru))(sn(i - r)), s = new Tv(this), o = new Tv(a), u = 0; r < i; )
    o.setUint8(u++, s.getUint8(r++));
  return a;
} }), Xs("ArrayBuffer"), H(H.G + H.W + H.F * !Ro.ABV, { DataView: cf.DataView });
var oa = gt(function(e) {
  if (rn) {
    var t = Re, n = pt, r = H, i = Ro, a = cf, s = In, o = xa, u = $i, c = Pn, f = jo, p = zi, d = sn, m = ju, y = ai, v = Gi, b = At, x = bc, C = ht, k = Zn, F = A0, B = Ei, O = No, S = qo.f, w = _0, D = to, I = Ut, L = Si, V = nf, K = Ec, W = Sm, R = Aa, q = of, J = Xs, X = T0, ce = wE, A = En, M = ui, ne = A.f, de = M.f, he = t.RangeError, j = t.TypeError, ie = t.Uint8Array, fe = Array.prototype, ge = a.ArrayBuffer, Fe = a.DataView, Pe = L(0), _ = L(2), Q = L(3), Y = L(4), ae = L(5), ue = L(6), De = V(!0), Ee = V(!1), _e = W.values, Oe = W.keys, Ye = W.entries, _t = fe.lastIndexOf, Kt = fe.reduce, Jt = fe.reduceRight, zt = fe.join, wn = fe.sort, Z = fe.slice, ee = fe.toString, oe = fe.toLocaleString, le = I("iterator"), we = I("toStringTag"), Me = D("typed_constructor"), Ve = D("def_constructor"), $e = i.CONSTR, yt = i.TYPED, ze = i.VIEW, vt = L(1, function(Ie, je) {
      return jt(K(Ie, Ie[Ve]), je);
    }), Nt = n(function() {
      return new ie(new Uint16Array([1]).buffer)[0] === 1;
    }), Qt = !!ie && !!ie.prototype.set && n(function() {
      new ie(1).set({});
    }), bt = function(Ie, je) {
      var Ze = p(Ie);
      if (Ze < 0 || Ze % je)
        throw he("Wrong offset!");
      return Ze;
    }, at = function(Ie) {
      if (C(Ie) && yt in Ie)
        return Ie;
      throw j(Ie + " is not a typed array!");
    }, jt = function(Ie, je) {
      if (!(C(Ie) && Me in Ie))
        throw j("It is not a typed array constructor!");
      return new Ie(je);
    }, dn = function(Ie, je) {
      return Rn(K(Ie, Ie[Ve]), je);
    }, Rn = function(Ie, je) {
      for (var Ze = 0, an = je.length, Rt = jt(Ie, an); an > Ze; )
        Rt[Ze] = je[Ze++];
      return Rt;
    }, qn = function(Ie, je, Ze) {
      ne(Ie, je, { get: function() {
        return this._d[Ze];
      } });
    }, Sr = function(Ie) {
      var je, Ze, an, Rt, wi, Wo, ot = k(Ie), Mn = arguments.length, Ji = Mn > 1 ? arguments[1] : void 0, uo = Ji !== void 0, Qi = w(ot);
      if (Qi != null && !F(Qi)) {
        for (Wo = Qi.call(ot), an = [], je = 0; !(wi = Wo.next()).done; je++)
          an.push(wi.value);
        ot = an;
      }
      for (uo && Mn > 2 && (Ji = s(Ji, arguments[2], 2)), je = 0, Ze = d(ot.length), Rt = jt(this, Ze); Ze > je; je++)
        Rt[je] = uo ? Ji(ot[je], je) : ot[je];
      return Rt;
    }, pi = function() {
      for (var Ie = 0, je = arguments.length, Ze = jt(this, je); je > Ie; )
        Ze[Ie] = arguments[Ie++];
      return Ze;
    }, Bn = !!ie && n(function() {
      oe.call(new ie(1));
    }), er = function() {
      return oe.apply(Bn ? Z.call(at(this)) : at(this), arguments);
    }, fi = { copyWithin: function(Ie, je) {
      return ce.call(at(this), Ie, je, arguments.length > 2 ? arguments[2] : void 0);
    }, every: function(Ie) {
      return Y(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, fill: function(Ie) {
      return X.apply(at(this), arguments);
    }, filter: function(Ie) {
      return dn(this, _(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0));
    }, find: function(Ie) {
      return ae(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, findIndex: function(Ie) {
      return ue(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, forEach: function(Ie) {
      Pe(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, indexOf: function(Ie) {
      return Ee(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, includes: function(Ie) {
      return De(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, join: function(Ie) {
      return zt.apply(at(this), arguments);
    }, lastIndexOf: function(Ie) {
      return _t.apply(at(this), arguments);
    }, map: function(Ie) {
      return vt(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, reduce: function(Ie) {
      return Kt.apply(at(this), arguments);
    }, reduceRight: function(Ie) {
      return Jt.apply(at(this), arguments);
    }, reverse: function() {
      for (var Ie, je = at(this).length, Ze = Math.floor(je / 2), an = 0; an < Ze; )
        Ie = this[an], this[an++] = this[--je], this[je] = Ie;
      return this;
    }, some: function(Ie) {
      return Q(at(this), Ie, arguments.length > 1 ? arguments[1] : void 0);
    }, sort: function(Ie) {
      return wn.call(at(this), Ie);
    }, subarray: function(Ie, je) {
      var Ze = at(this), an = Ze.length, Rt = y(Ie, an);
      return new (K(Ze, Ze[Ve]))(Ze.buffer, Ze.byteOffset + Rt * Ze.BYTES_PER_ELEMENT, d((je === void 0 ? an : y(je, an)) - Rt));
    } }, kr = function(Ie, je) {
      return dn(this, Z.call(at(this), Ie, je));
    }, oo = function(Ie) {
      at(this);
      var je = bt(arguments[1], 1), Ze = this.length, an = k(Ie), Rt = d(an.length), wi = 0;
      if (Rt + je > Ze)
        throw he("Wrong length!");
      for (; wi < Rt; )
        this[je + wi] = an[wi++];
    }, Fi = { entries: function() {
      return Ye.call(at(this));
    }, keys: function() {
      return Oe.call(at(this));
    }, values: function() {
      return _e.call(at(this));
    } }, so = function(Ie, je) {
      return C(Ie) && Ie[yt] && xe(je) != "symbol" && je in Ie && String(+je) == String(je);
    }, Hi = function(Ie, je) {
      return so(Ie, je = v(je, !0)) ? u(2, Ie[je]) : de(Ie, je);
    }, Ki = function(Ie, je, Ze) {
      return !(so(Ie, je = v(je, !0)) && C(Ze) && b(Ze, "value")) || b(Ze, "get") || b(Ze, "set") || Ze.configurable || b(Ze, "writable") && !Ze.writable || b(Ze, "enumerable") && !Ze.enumerable ? ne(Ie, je, Ze) : (Ie[je] = Ze.value, Ie);
    };
    $e || (M.f = Hi, A.f = Ki), r(r.S + r.F * !$e, "Object", { getOwnPropertyDescriptor: Hi, defineProperty: Ki }), n(function() {
      ee.call({});
    }) && (ee = oe = function() {
      return zt.call(this);
    });
    var Wn = f({}, fi);
    f(Wn, Fi), c(Wn, le, Fi.values), f(Wn, { slice: kr, set: oo, constructor: function() {
    }, toString: ee, toLocaleString: er }), qn(Wn, "buffer", "b"), qn(Wn, "byteOffset", "o"), qn(Wn, "byteLength", "l"), qn(Wn, "length", "e"), ne(Wn, we, { get: function() {
      return this[yt];
    } }), e.exports = function(Ie, je, Ze, an) {
      var Rt = Ie + ((an = !!an) ? "Clamped" : "") + "Array", wi = "get" + Ie, Wo = "set" + Ie, ot = t[Rt], Mn = ot || {}, Ji = ot && O(ot), uo = !ot || !i.ABV, Qi = {}, On = ot && ot.prototype, Fc = function($n, Ht) {
        ne($n, Ht, { get: function() {
          return function(Dr, Vr) {
            var Gn = Dr._d;
            return Gn.v[wi](Vr * je + Gn.o, Nt);
          }(this, Ht);
        }, set: function(Dr) {
          return function(Vr, Gn, zn) {
            var tr = Vr._d;
            an && (zn = (zn = Math.round(zn)) < 0 ? 0 : zn > 255 ? 255 : 255 & zn), tr.v[Wo](Gn * je + tr.o, zn, Nt);
          }(this, Ht, Dr);
        }, enumerable: !0 });
      };
      uo ? (ot = Ze(function($n, Ht, Dr, Vr) {
        o($n, ot, Rt, "_d");
        var Gn, zn, tr, tu, Ac = 0, co = 0;
        if (C(Ht)) {
          if (!(Ht instanceof ge || (tu = x(Ht)) == "ArrayBuffer" || tu == "SharedArrayBuffer"))
            return yt in Ht ? Rn(ot, Ht) : Sr.call(ot, Ht);
          Gn = Ht, co = bt(Dr, je);
          var Go = Ht.byteLength;
          if (Vr === void 0) {
            if (Go % je || (zn = Go - co) < 0)
              throw he("Wrong length!");
          } else if ((zn = d(Vr) * je) + co > Go)
            throw he("Wrong length!");
          tr = zn / je;
        } else
          tr = m(Ht), Gn = new ge(zn = tr * je);
        for (c($n, "_d", { b: Gn, o: co, l: zn, e: tr, v: new Fe(Gn) }); Ac < tr; )
          Fc($n, Ac++);
      }), On = ot.prototype = B(Wn), c(On, "constructor", ot)) : n(function() {
        ot(1);
      }) && n(function() {
        new ot(-1);
      }) && q(function($n) {
        new ot(), new ot(null), new ot(1.5), new ot($n);
      }, !0) || (ot = Ze(function($n, Ht, Dr, Vr) {
        var Gn;
        return o($n, ot, Rt), C(Ht) ? Ht instanceof ge || (Gn = x(Ht)) == "ArrayBuffer" || Gn == "SharedArrayBuffer" ? Vr !== void 0 ? new Mn(Ht, bt(Dr, je), Vr) : Dr !== void 0 ? new Mn(Ht, bt(Dr, je)) : new Mn(Ht) : yt in Ht ? Rn(ot, Ht) : Sr.call(ot, Ht) : new Mn(m(Ht));
      }), Pe(Ji !== Function.prototype ? S(Mn).concat(S(Ji)) : S(Mn), function($n) {
        $n in ot || c(ot, $n, Mn[$n]);
      }), ot.prototype = On, On.constructor = ot);
      var Xi = On[le], $o = !!Xi && (Xi.name == "values" || Xi.name == null), wc = Fi.values;
      c(ot, Me, !0), c(On, yt, Rt), c(On, ze, !0), c(On, Ve, ot), (an ? new ot(1)[we] == Rt : we in On) || ne(On, we, { get: function() {
        return Rt;
      } }), Qi[Rt] = ot, r(r.G + r.W + r.F * (ot != Mn), Qi), r(r.S, Rt, { BYTES_PER_ELEMENT: je }), r(r.S + r.F * n(function() {
        Mn.of.call(ot, 1);
      }), Rt, { from: Sr, of: pi }), "BYTES_PER_ELEMENT" in On || c(On, "BYTES_PER_ELEMENT", je), r(r.P, Rt, fi), J(Rt), r(r.P + r.F * Qt, Rt, { set: oo }), r(r.P + r.F * !$o, Rt, Fi), On.toString != ee && (On.toString = ee), r(r.P + r.F * n(function() {
        new ot(1).slice();
      }), Rt, { slice: kr }), r(r.P + r.F * (n(function() {
        return [1, 2].toLocaleString() != new ot([1, 2]).toLocaleString();
      }) || !n(function() {
        On.toLocaleString.call([1, 2]);
      })), Rt, { toLocaleString: er }), R[Rt] = $o ? Xi : wc, $o || c(On, le, wc);
    };
  } else
    e.exports = function() {
    };
});
oa("Int8", 1, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Uint8", 1, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Uint8", 1, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}, !0), oa("Int16", 2, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Uint16", 2, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Int32", 4, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Uint32", 4, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Float32", 4, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
}), oa("Float64", 8, function(e) {
  return function(t, n, r) {
    return e(this, t, n, r);
  };
});
var ad = (Re.Reflect || {}).apply, c4 = Function.apply;
H(H.S + H.F * !pt(function() {
  ad(function() {
  });
}), "Reflect", { apply: function(e, t, n) {
  var r = oi(e), i = Ct(n);
  return ad ? ad(r, t, i) : c4.call(r, t, i);
} });
var O0 = (Re.Reflect || {}).construct, Bv = pt(function() {
  function e() {
  }
  return !(O0(function() {
  }, [], e) instanceof e);
}), Ov = !pt(function() {
  O0(function() {
  });
});
H(H.S + H.F * (Bv || Ov), "Reflect", { construct: function(e, t) {
  oi(e), Ct(t);
  var n = arguments.length < 3 ? e : oi(arguments[2]);
  if (Ov && !Bv)
    return O0(e, t, n);
  if (e == n) {
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
    }
    var r = [null];
    return r.push.apply(r, t), new (gE.apply(e, r))();
  }
  var i = n.prototype, a = Ei(ht(i) ? i : Object.prototype), s = Function.apply.call(e, a, t);
  return ht(s) ? s : a;
} }), H(H.S + H.F * pt(function() {
  Reflect.defineProperty(En.f({}, 1, { value: 1 }), 1, { value: 2 });
}), "Reflect", { defineProperty: function(e, t, n) {
  Ct(e), t = Gi(t, !0), Ct(n);
  try {
    return En.f(e, t, n), !0;
  } catch {
    return !1;
  }
} });
var l4 = ui.f;
H(H.S, "Reflect", { deleteProperty: function(e, t) {
  var n = l4(Ct(e), t);
  return !(n && !n.configurable) && delete e[t];
} });
var Lv = function(e) {
  this._t = Ct(e), this._i = 0;
  var t, n = this._k = [];
  for (t in e)
    n.push(t);
};
SE(Lv, "Object", function() {
  var e, t = this._k;
  do
    if (this._i >= t.length)
      return { value: void 0, done: !0 };
  while (!((e = t[this._i++]) in this._t));
  return { value: e, done: !1 };
}), H(H.S, "Reflect", { enumerate: function(e) {
  return new Lv(e);
} }), H(H.S, "Reflect", { get: function e(t, n) {
  var r, i, a = arguments.length < 3 ? t : arguments[2];
  return Ct(t) === a ? t[n] : (r = ui.f(t, n)) ? At(r, "value") ? r.value : r.get !== void 0 ? r.get.call(a) : void 0 : ht(i = No(t)) ? e(i, n, a) : void 0;
} }), H(H.S, "Reflect", { getOwnPropertyDescriptor: function(e, t) {
  return ui.f(Ct(e), t);
} }), H(H.S, "Reflect", { getPrototypeOf: function(e) {
  return No(Ct(e));
} }), H(H.S, "Reflect", { has: function(e, t) {
  return t in e;
} });
var Nv = Object.isExtensible;
H(H.S, "Reflect", { isExtensible: function(e) {
  return Ct(e), !Nv || Nv(e);
} });
var jv = Re.Reflect, UE = jv && jv.ownKeys || function(e) {
  var t = qo.f(Ct(e)), n = Uo.f;
  return n ? t.concat(n(e)) : t;
};
H(H.S, "Reflect", { ownKeys: UE });
var Rv = Object.preventExtensions;
H(H.S, "Reflect", { preventExtensions: function(e) {
  Ct(e);
  try {
    return Rv && Rv(e), !0;
  } catch {
    return !1;
  }
} }), H(H.S, "Reflect", { set: function e(t, n, r) {
  var i, a, s = arguments.length < 4 ? t : arguments[3], o = ui.f(Ct(t), n);
  if (!o) {
    if (ht(a = No(t)))
      return e(a, n, r, s);
    o = $i(0);
  }
  if (At(o, "value")) {
    if (o.writable === !1 || !ht(s))
      return !1;
    if (i = ui.f(s, n)) {
      if (i.get || i.set || i.writable === !1)
        return !1;
      i.value = r, En.f(s, n, i);
    } else
      En.f(s, n, $i(0, r));
    return !0;
  }
  return o.set !== void 0 && (o.set.call(s, r), !0);
} }), Qu && H(H.S, "Reflect", { setPrototypeOf: function(e, t) {
  Qu.check(e, t);
  try {
    return Qu.set(e, t), !0;
  } catch {
    return !1;
  }
} });
var p4 = nf(!0);
H(H.P, "Array", { includes: function(e) {
  return p4(this, e, arguments.length > 1 ? arguments[1] : void 0);
} }), Da("includes");
hn.Array.includes;
var f4 = Ut("isConcatSpreadable"), h4 = function e(t, n, r, i, a, s, o, u) {
  for (var c, f, p = a, d = 0, m = !!o && In(o, u, 3); d < i; ) {
    if (d in r) {
      if (c = m ? m(r[d], d, n) : r[d], f = !1, ht(c) && (f = (f = c[f4]) !== void 0 ? !!f : ic(c)), f && s > 0)
        p = e(t, n, c, sn(c.length), p, s - 1) - 1;
      else {
        if (p >= 9007199254740991)
          throw TypeError();
        t[p] = c;
      }
      p++;
    }
    d++;
  }
  return p;
};
H(H.P, "Array", { flatMap: function(e) {
  var t, n, r = Zn(this);
  return oi(e), t = sn(r.length), n = FE(r, 0), h4(n, r, r, t, 0, 1, e, arguments[1]), n;
} }), Da("flatMap");
hn.Array.flatMap;
var qE = function(e, t, n, r) {
  var i = String(Ta(e)), a = i.length, s = n === void 0 ? " " : String(n), o = sn(t);
  if (o <= a || s == "")
    return i;
  var u = o - a, c = oc.call(s, Math.ceil(u / s.length));
  return c.length > u && (c = c.slice(0, u)), r ? c + i : i + c;
}, d4 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(uf);
H(H.P + H.F * d4, "String", { padStart: function(e) {
  return qE(this, e, arguments.length > 1 ? arguments[1] : void 0, !0);
} });
hn.String.padStart;
var m4 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(uf);
H(H.P + H.F * m4, "String", { padEnd: function(e) {
  return qE(this, e, arguments.length > 1 ? arguments[1] : void 0, !1);
} });
hn.String.padEnd;
Qs("trimLeft", function(e) {
  return function() {
    return e(this, 1);
  };
}, "trimStart");
hn.String.trimLeft;
Qs("trimRight", function(e) {
  return function() {
    return e(this, 2);
  };
}, "trimEnd");
hn.String.trimRight;
oE("asyncIterator");
y0.f("asyncIterator");
H(H.S, "Object", { getOwnPropertyDescriptors: function(e) {
  for (var t, n, r = lr(e), i = ui.f, a = UE(r), s = {}, o = 0; a.length > o; )
    (n = i(r, t = a[o++])) !== void 0 && ip(s, t, n);
  return s;
} });
hn.Object.getOwnPropertyDescriptors;
var g4 = vc.f, WE = function(e) {
  return function(t) {
    for (var n, r = lr(t), i = no(r), a = i.length, s = 0, o = []; a > s; )
      n = i[s++], rn && !g4.call(r, n) || o.push(e ? [n, r[n]] : r[n]);
    return o;
  };
}, y4 = WE(!1);
H(H.S, "Object", { values: function(e) {
  return y4(e);
} });
hn.Object.values;
var v4 = WE(!0);
H(H.S, "Object", { entries: function(e) {
  return v4(e);
} });
hn.Object.entries;
H(H.P + H.R, "Promise", { finally: function(e) {
  var t = Ec(this, hn.Promise || Re.Promise), n = typeof e == "function";
  return this.then(n ? function(r) {
    return Am(t, e()).then(function() {
      return r;
    });
  } : e, n ? function(r) {
    return Am(t, e()).then(function() {
      throw r;
    });
  } : e);
} });
hn.Promise.finally;
var x4 = [].slice, b4 = /MSIE .\./.test(uf), Mv = function(e) {
  return function(t, n) {
    var r = arguments.length > 2, i = !!r && x4.call(arguments, 2);
    return e(r ? function() {
      (typeof t == "function" ? t : Function(t)).apply(this, i);
    } : t, n);
  };
};
H(H.G + H.B + H.F * b4, { setTimeout: Mv(Re.setTimeout), setInterval: Mv(Re.setInterval) }), H(H.G + H.B, { setImmediate: Tp.set, clearImmediate: Tp.clear });
for (var Vv = Ut("iterator"), Uv = Ut("toStringTag"), qv = Aa.Array, Wv = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, $v = no(Wv), od = 0; od < $v.length; od++) {
  var _l, Tl = $v[od], E4 = Wv[Tl], Gv = Re[Tl], xo = Gv && Gv.prototype;
  if (xo && (xo[Vv] || Pn(xo, Vv, qv), xo[Uv] || Pn(xo, Uv, Tl), Aa[Tl] = qv, E4))
    for (_l in Sm)
      xo[_l] || Er(xo, _l, Sm[_l], !0);
}
gt(function(e) {
  var t = function(n) {
    var r, i = Object.prototype, a = i.hasOwnProperty, s = typeof Symbol == "function" ? Symbol : {}, o = s.iterator || "@@iterator", u = s.asyncIterator || "@@asyncIterator", c = s.toStringTag || "@@toStringTag";
    function f(q, J, X, ce) {
      var A = J && J.prototype instanceof x ? J : x, M = Object.create(A.prototype), ne = new K(ce || []);
      return M._invoke = function(de, he, j) {
        var ie = d;
        return function(fe, ge) {
          if (ie === y)
            throw new Error("Generator is already running");
          if (ie === v) {
            if (fe === "throw")
              throw ge;
            return R();
          }
          for (j.method = fe, j.arg = ge; ; ) {
            var Fe = j.delegate;
            if (Fe) {
              var Pe = I(Fe, j);
              if (Pe) {
                if (Pe === b)
                  continue;
                return Pe;
              }
            }
            if (j.method === "next")
              j.sent = j._sent = j.arg;
            else if (j.method === "throw") {
              if (ie === d)
                throw ie = v, j.arg;
              j.dispatchException(j.arg);
            } else
              j.method === "return" && j.abrupt("return", j.arg);
            ie = y;
            var _ = p(de, he, j);
            if (_.type === "normal") {
              if (ie = j.done ? v : m, _.arg === b)
                continue;
              return { value: _.arg, done: j.done };
            }
            _.type === "throw" && (ie = v, j.method = "throw", j.arg = _.arg);
          }
        };
      }(q, X, ne), M;
    }
    function p(q, J, X) {
      try {
        return { type: "normal", arg: q.call(J, X) };
      } catch (ce) {
        return { type: "throw", arg: ce };
      }
    }
    n.wrap = f;
    var d = "suspendedStart", m = "suspendedYield", y = "executing", v = "completed", b = {};
    function x() {
    }
    function C() {
    }
    function k() {
    }
    var F = {};
    F[o] = function() {
      return this;
    };
    var B = Object.getPrototypeOf, O = B && B(B(W([])));
    O && O !== i && a.call(O, o) && (F = O);
    var S = k.prototype = x.prototype = Object.create(F);
    function w(q) {
      ["next", "throw", "return"].forEach(function(J) {
        q[J] = function(X) {
          return this._invoke(J, X);
        };
      });
    }
    function D(q) {
      var J;
      this._invoke = function(X, ce) {
        function A() {
          return new Promise(function(M, ne) {
            (function de(he, j, ie, fe) {
              var ge = p(q[he], q, j);
              if (ge.type !== "throw") {
                var Fe = ge.arg, Pe = Fe.value;
                return Pe && xe(Pe) === "object" && a.call(Pe, "__await") ? Promise.resolve(Pe.__await).then(function(_) {
                  de("next", _, ie, fe);
                }, function(_) {
                  de("throw", _, ie, fe);
                }) : Promise.resolve(Pe).then(function(_) {
                  Fe.value = _, ie(Fe);
                }, function(_) {
                  return de("throw", _, ie, fe);
                });
              }
              fe(ge.arg);
            })(X, ce, M, ne);
          });
        }
        return J = J ? J.then(A, A) : A();
      };
    }
    function I(q, J) {
      var X = q.iterator[J.method];
      if (X === r) {
        if (J.delegate = null, J.method === "throw") {
          if (q.iterator.return && (J.method = "return", J.arg = r, I(q, J), J.method === "throw"))
            return b;
          J.method = "throw", J.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return b;
      }
      var ce = p(X, q.iterator, J.arg);
      if (ce.type === "throw")
        return J.method = "throw", J.arg = ce.arg, J.delegate = null, b;
      var A = ce.arg;
      return A ? A.done ? (J[q.resultName] = A.value, J.next = q.nextLoc, J.method !== "return" && (J.method = "next", J.arg = r), J.delegate = null, b) : A : (J.method = "throw", J.arg = new TypeError("iterator result is not an object"), J.delegate = null, b);
    }
    function L(q) {
      var J = { tryLoc: q[0] };
      1 in q && (J.catchLoc = q[1]), 2 in q && (J.finallyLoc = q[2], J.afterLoc = q[3]), this.tryEntries.push(J);
    }
    function V(q) {
      var J = q.completion || {};
      J.type = "normal", delete J.arg, q.completion = J;
    }
    function K(q) {
      this.tryEntries = [{ tryLoc: "root" }], q.forEach(L, this), this.reset(!0);
    }
    function W(q) {
      if (q) {
        var J = q[o];
        if (J)
          return J.call(q);
        if (typeof q.next == "function")
          return q;
        if (!isNaN(q.length)) {
          var X = -1, ce = function A() {
            for (; ++X < q.length; )
              if (a.call(q, X))
                return A.value = q[X], A.done = !1, A;
            return A.value = r, A.done = !0, A;
          };
          return ce.next = ce;
        }
      }
      return { next: R };
    }
    function R() {
      return { value: r, done: !0 };
    }
    return C.prototype = S.constructor = k, k.constructor = C, k[c] = C.displayName = "GeneratorFunction", n.isGeneratorFunction = function(q) {
      var J = typeof q == "function" && q.constructor;
      return !!J && (J === C || (J.displayName || J.name) === "GeneratorFunction");
    }, n.mark = function(q) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(q, k) : (q.__proto__ = k, c in q || (q[c] = "GeneratorFunction")), q.prototype = Object.create(S), q;
    }, n.awrap = function(q) {
      return { __await: q };
    }, w(D.prototype), D.prototype[u] = function() {
      return this;
    }, n.AsyncIterator = D, n.async = function(q, J, X, ce) {
      var A = new D(f(q, J, X, ce));
      return n.isGeneratorFunction(J) ? A : A.next().then(function(M) {
        return M.done ? M.value : A.next();
      });
    }, w(S), S[c] = "Generator", S[o] = function() {
      return this;
    }, S.toString = function() {
      return "[object Generator]";
    }, n.keys = function(q) {
      var J = [];
      for (var X in q)
        J.push(X);
      return J.reverse(), function ce() {
        for (; J.length; ) {
          var A = J.pop();
          if (A in q)
            return ce.value = A, ce.done = !1, ce;
        }
        return ce.done = !0, ce;
      };
    }, n.values = W, K.prototype = { constructor: K, reset: function(q) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = r, this.done = !1, this.delegate = null, this.method = "next", this.arg = r, this.tryEntries.forEach(V), !q)
        for (var J in this)
          J.charAt(0) === "t" && a.call(this, J) && !isNaN(+J.slice(1)) && (this[J] = r);
    }, stop: function() {
      this.done = !0;
      var q = this.tryEntries[0].completion;
      if (q.type === "throw")
        throw q.arg;
      return this.rval;
    }, dispatchException: function(q) {
      if (this.done)
        throw q;
      var J = this;
      function X(he, j) {
        return M.type = "throw", M.arg = q, J.next = he, j && (J.method = "next", J.arg = r), !!j;
      }
      for (var ce = this.tryEntries.length - 1; ce >= 0; --ce) {
        var A = this.tryEntries[ce], M = A.completion;
        if (A.tryLoc === "root")
          return X("end");
        if (A.tryLoc <= this.prev) {
          var ne = a.call(A, "catchLoc"), de = a.call(A, "finallyLoc");
          if (ne && de) {
            if (this.prev < A.catchLoc)
              return X(A.catchLoc, !0);
            if (this.prev < A.finallyLoc)
              return X(A.finallyLoc);
          } else if (ne) {
            if (this.prev < A.catchLoc)
              return X(A.catchLoc, !0);
          } else {
            if (!de)
              throw new Error("try statement without catch or finally");
            if (this.prev < A.finallyLoc)
              return X(A.finallyLoc);
          }
        }
      }
    }, abrupt: function(q, J) {
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var ce = this.tryEntries[X];
        if (ce.tryLoc <= this.prev && a.call(ce, "finallyLoc") && this.prev < ce.finallyLoc) {
          var A = ce;
          break;
        }
      }
      A && (q === "break" || q === "continue") && A.tryLoc <= J && J <= A.finallyLoc && (A = null);
      var M = A ? A.completion : {};
      return M.type = q, M.arg = J, A ? (this.method = "next", this.next = A.finallyLoc, b) : this.complete(M);
    }, complete: function(q, J) {
      if (q.type === "throw")
        throw q.arg;
      return q.type === "break" || q.type === "continue" ? this.next = q.arg : q.type === "return" ? (this.rval = this.arg = q.arg, this.method = "return", this.next = "end") : q.type === "normal" && J && (this.next = J), b;
    }, finish: function(q) {
      for (var J = this.tryEntries.length - 1; J >= 0; --J) {
        var X = this.tryEntries[J];
        if (X.finallyLoc === q)
          return this.complete(X.completion, X.afterLoc), V(X), b;
      }
    }, catch: function(q) {
      for (var J = this.tryEntries.length - 1; J >= 0; --J) {
        var X = this.tryEntries[J];
        if (X.tryLoc === q) {
          var ce = X.completion;
          if (ce.type === "throw") {
            var A = ce.arg;
            V(X);
          }
          return A;
        }
      }
      throw new Error("illegal catch attempt");
    }, delegateYield: function(q, J, X) {
      return this.delegate = { iterator: W(q), resultName: J, nextLoc: X }, this.method === "next" && (this.arg = r), b;
    } }, n;
  }(e.exports);
  try {
    regeneratorRuntime = t;
  } catch {
    Function("r", "regeneratorRuntime = r")(t);
  }
});
var ks = gt(function(e) {
  var t = e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t);
}), Zu = gt(function(e) {
  var t = e.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t);
}), zv = (Zu.version, function(e, t, n) {
  if (function(r) {
    if (typeof r != "function")
      throw TypeError(r + " is not a function!");
  }(e), t === void 0)
    return e;
  switch (n) {
    case 1:
      return function(r) {
        return e.call(t, r);
      };
    case 2:
      return function(r, i) {
        return e.call(t, r, i);
      };
    case 3:
      return function(r, i, a) {
        return e.call(t, r, i, a);
      };
  }
  return function() {
    return e.apply(t, arguments);
  };
}), Io = function(e) {
  return xe(e) === "object" ? e !== null : typeof e == "function";
}, Hv = function(e) {
  if (!Io(e))
    throw TypeError(e + " is not an object!");
  return e;
}, $E = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, L0 = !$E(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), _m = ks.document, C4 = Io(_m) && Io(_m.createElement), S4 = !L0 && !$E(function() {
  return Object.defineProperty((e = "div", C4 ? _m.createElement(e) : {}), "a", { get: function() {
    return 7;
  } }).a != 7;
  var e;
}), k4 = Object.defineProperty, D4 = { f: L0 ? Object.defineProperty : function(e, t, n) {
  if (Hv(e), t = function(r, i) {
    if (!Io(r))
      return r;
    var a, s;
    if (i && typeof (a = r.toString) == "function" && !Io(s = a.call(r)) || typeof (a = r.valueOf) == "function" && !Io(s = a.call(r)) || !i && typeof (a = r.toString) == "function" && !Io(s = a.call(r)))
      return s;
    throw TypeError("Can't convert object to primitive value");
  }(t, !0), Hv(n), S4)
    try {
      return k4(e, t, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw TypeError("Accessors not supported!");
  return "value" in n && (e[t] = n.value), e;
} }, F4 = L0 ? function(e, t, n) {
  return D4.f(e, t, function(r, i) {
    return { enumerable: !(1 & r), configurable: !(2 & r), writable: !(4 & r), value: i };
  }(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, w4 = {}.hasOwnProperty, A4 = function(e, t) {
  return w4.call(e, t);
}, ji = function e(t, n, r) {
  var i, a, s, o = t & e.F, u = t & e.G, c = t & e.S, f = t & e.P, p = t & e.B, d = t & e.W, m = u ? Zu : Zu[n] || (Zu[n] = {}), y = m.prototype, v = u ? ks : c ? ks[n] : (ks[n] || {}).prototype;
  for (i in u && (r = n), r)
    (a = !o && v && v[i] !== void 0) && A4(m, i) || (s = a ? v[i] : r[i], m[i] = u && typeof v[i] != "function" ? r[i] : p && a ? zv(s, ks) : d && v[i] == s ? function(b) {
      var x = function(C, k, F) {
        if (this instanceof b) {
          switch (arguments.length) {
            case 0:
              return new b();
            case 1:
              return new b(C);
            case 2:
              return new b(C, k);
          }
          return new b(C, k, F);
        }
        return b.apply(this, arguments);
      };
      return x.prototype = b.prototype, x;
    }(s) : f && typeof s == "function" ? zv(Function.call, s) : s, f && ((m.virtual || (m.virtual = {}))[i] = s, t & e.R && y && !y[i] && F4(y, i, s)));
};
ji.F = 1, ji.G = 2, ji.S = 4, ji.P = 8, ji.B = 16, ji.W = 32, ji.U = 64, ji.R = 128;
ji(ji.G, { global: ks });
var _4 = Zu.global;
function GE(e, t) {
  for (var n = 0, r = e.length - 1; r >= 0; r--) {
    var i = e[r];
    i === "." ? e.splice(r, 1) : i === ".." ? (e.splice(r, 1), n++) : n && (e.splice(r, 1), n--);
  }
  if (t)
    for (; n--; n)
      e.unshift("..");
  return e;
}
Z2(gt(function(e) {
  var t, n = (t = _4) && t.__esModule ? t : { default: t };
  n.default._babelPolyfill && typeof console < "u" && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), n.default._babelPolyfill = !0;
}));
var T4 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, sd = function(e) {
  return T4.exec(e).slice(1);
};
function ud() {
  for (var e = "", t = !1, n = arguments.length - 1; n >= -1 && !t; n--) {
    var r = n >= 0 ? arguments[n] : "/";
    if (typeof r != "string")
      throw new TypeError("Arguments to path.resolve must be strings");
    r && (e = r + "/" + e, t = r.charAt(0) === "/");
  }
  return (t ? "/" : "") + (e = GE(N0(e.split("/"), function(i) {
    return !!i;
  }), !t).join("/")) || ".";
}
function Kv(e) {
  var t = zE(e), n = I4(e, -1) === "/";
  return (e = GE(N0(e.split("/"), function(r) {
    return !!r;
  }), !t).join("/")) || t || (e = "."), e && n && (e += "/"), (t ? "/" : "") + e;
}
function zE(e) {
  return e.charAt(0) === "/";
}
var P4 = { extname: function(e) {
  return sd(e)[3];
}, basename: function(e, t) {
  var n = sd(e)[2];
  return t && n.substr(-1 * t.length) === t && (n = n.substr(0, n.length - t.length)), n;
}, dirname: function(e) {
  var t = sd(e), n = t[0], r = t[1];
  return n || r ? (r && (r = r.substr(0, r.length - 1)), n + r) : ".";
}, sep: "/", delimiter: ":", relative: function(e, t) {
  function n(c) {
    for (var f = 0; f < c.length && c[f] === ""; f++)
      ;
    for (var p = c.length - 1; p >= 0 && c[p] === ""; p--)
      ;
    return f > p ? [] : c.slice(f, p - f + 1);
  }
  e = ud(e).substr(1), t = ud(t).substr(1);
  for (var r = n(e.split("/")), i = n(t.split("/")), a = Math.min(r.length, i.length), s = a, o = 0; o < a; o++)
    if (r[o] !== i[o]) {
      s = o;
      break;
    }
  var u = [];
  for (o = s; o < r.length; o++)
    u.push("..");
  return (u = u.concat(i.slice(s))).join("/");
}, join: function() {
  return Kv(N0(Array.prototype.slice.call(arguments, 0), function(e, t) {
    if (typeof e != "string")
      throw new TypeError("Arguments to path.join must be strings");
    return e;
  }).join("/"));
}, isAbsolute: zE, normalize: Kv, resolve: ud };
function N0(e, t) {
  if (e.filter)
    return e.filter(t);
  for (var n = [], r = 0; r < e.length; r++)
    t(e[r], r, e) && n.push(e[r]);
  return n;
}
var I4 = "ab".substr(-1) === "b" ? function(e, t, n) {
  return e.substr(t, n);
} : function(e, t, n) {
  return t < 0 && (t = e.length + t), e.substr(t, n);
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function Mu(e) {
  return e != null && (!!e._isBuffer || Jv(e) || function(t) {
    return typeof t.readFloatLE == "function" && typeof t.slice == "function" && Jv(t.slice(0, 0));
  }(e));
}
function Jv(e) {
  return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
var HE = typeof Object.create == "function" ? function(e, t) {
  e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
} : function(e, t) {
  e.super_ = t;
  var n = function() {
  };
  n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
}, B4 = /%[sdj%]/g;
function cd(e) {
  if (!Bp(e)) {
    for (var t = [], n = 0; n < arguments.length; n++)
      t.push(Wi(arguments[n]));
    return t.join(" ");
  }
  n = 1;
  for (var r = arguments, i = r.length, a = String(e).replace(B4, function(o) {
    if (o === "%%")
      return "%";
    if (n >= i)
      return o;
    switch (o) {
      case "%s":
        return String(r[n++]);
      case "%d":
        return Number(r[n++]);
      case "%j":
        try {
          return JSON.stringify(r[n++]);
        } catch {
          return "[Circular]";
        }
      default:
        return o;
    }
  }), s = r[n]; n < i; s = r[++n])
    lf(s) || !Ys(s) ? a += " " + s : a += " " + Wi(s);
  return a;
}
var ld, Pl = {};
function Wi(e, t) {
  var n = { seen: [], stylize: L4 };
  return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), j0(t) ? n.showHidden = t : t && QE(n, t), ba(n.showHidden) && (n.showHidden = !1), ba(n.depth) && (n.depth = 2), ba(n.colors) && (n.colors = !1), ba(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = O4), Ip(n, e, n.depth);
}
function O4(e, t) {
  var n = Wi.styles[t];
  return n ? "\x1B[" + Wi.colors[n][0] + "m" + e + "\x1B[" + Wi.colors[n][1] + "m" : e;
}
function L4(e, t) {
  return e;
}
function Ip(e, t, n) {
  if (e.customInspect && t && _s(t.inspect) && t.inspect !== Wi && (!t.constructor || t.constructor.prototype !== t)) {
    var r = t.inspect(n, e);
    return Bp(r) || (r = Ip(e, r, n)), r;
  }
  var i = function(d, m) {
    if (ba(m))
      return d.stylize("undefined", "undefined");
    if (Bp(m)) {
      var y = "'" + JSON.stringify(m).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return d.stylize(y, "string");
    }
    if (JE(m))
      return d.stylize("" + m, "number");
    if (j0(m))
      return d.stylize("" + m, "boolean");
    if (lf(m))
      return d.stylize("null", "null");
  }(e, t);
  if (i)
    return i;
  var a = Object.keys(t), s = function(d) {
    var m = {};
    return d.forEach(function(y, v) {
      m[y] = !0;
    }), m;
  }(a);
  if (e.showHidden && (a = Object.getOwnPropertyNames(t)), ec(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0))
    return pd(t);
  if (a.length === 0) {
    if (_s(t)) {
      var o = t.name ? ": " + t.name : "";
      return e.stylize("[Function" + o + "]", "special");
    }
    if (As(t))
      return e.stylize(RegExp.prototype.toString.call(t), "regexp");
    if (cc(t))
      return e.stylize(Date.prototype.toString.call(t), "date");
    if (ec(t))
      return pd(t);
  }
  var u, c = "", f = !1, p = ["{", "}"];
  return KE(t) && (f = !0, p = ["[", "]"]), _s(t) && (c = " [Function" + (t.name ? ": " + t.name : "") + "]"), As(t) && (c = " " + RegExp.prototype.toString.call(t)), cc(t) && (c = " " + Date.prototype.toUTCString.call(t)), ec(t) && (c = " " + pd(t)), a.length !== 0 || f && t.length != 0 ? n < 0 ? As(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), u = f ? function(d, m, y, v, b) {
    for (var x = [], C = 0, k = m.length; C < k; ++C)
      XE(m, String(C)) ? x.push(fd(d, m, y, v, String(C), !0)) : x.push("");
    return b.forEach(function(F) {
      F.match(/^\d+$/) || x.push(fd(d, m, y, v, F, !0));
    }), x;
  }(e, t, n, s, a) : a.map(function(d) {
    return fd(e, t, n, s, d, f);
  }), e.seen.pop(), function(d, m, y) {
    return d.reduce(function(v, b) {
      return b.indexOf(`
`), v + b.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0) > 60 ? y[0] + (m === "" ? "" : m + `
 `) + " " + d.join(`,
  `) + " " + y[1] : y[0] + m + " " + d.join(", ") + " " + y[1];
  }(u, c, p)) : p[0] + c + p[1];
}
function pd(e) {
  return "[" + Error.prototype.toString.call(e) + "]";
}
function fd(e, t, n, r, i, a) {
  var s, o, u;
  if ((u = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] }).get ? o = u.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : u.set && (o = e.stylize("[Setter]", "special")), XE(r, i) || (s = "[" + i + "]"), o || (e.seen.indexOf(u.value) < 0 ? (o = lf(n) ? Ip(e, u.value, null) : Ip(e, u.value, n - 1)).indexOf(`
`) > -1 && (o = a ? o.split(`
`).map(function(c) {
    return "  " + c;
  }).join(`
`).substr(2) : `
` + o.split(`
`).map(function(c) {
    return "   " + c;
  }).join(`
`)) : o = e.stylize("[Circular]", "special")), ba(s)) {
    if (a && i.match(/^\d+$/))
      return o;
    (s = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
  }
  return s + ": " + o;
}
function KE(e) {
  return Array.isArray(e);
}
function j0(e) {
  return typeof e == "boolean";
}
function lf(e) {
  return e === null;
}
function JE(e) {
  return typeof e == "number";
}
function Bp(e) {
  return typeof e == "string";
}
function ba(e) {
  return e === void 0;
}
function As(e) {
  return Ys(e) && R0(e) === "[object RegExp]";
}
function Ys(e) {
  return xe(e) === "object" && e !== null;
}
function cc(e) {
  return Ys(e) && R0(e) === "[object Date]";
}
function ec(e) {
  return Ys(e) && (R0(e) === "[object Error]" || e instanceof Error);
}
function _s(e) {
  return typeof e == "function";
}
function Tm(e) {
  return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || xe(e) === "symbol" || e === void 0;
}
function R0(e) {
  return Object.prototype.toString.call(e);
}
function hd(e) {
  return e < 10 ? "0" + e.toString(10) : e.toString(10);
}
Wi.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, Wi.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" };
var N4 = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function QE(e, t) {
  if (!t || !Ys(t))
    return e;
  for (var n = Object.keys(t), r = n.length; r--; )
    e[n[r]] = t[n[r]];
  return e;
}
function XE(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var j4 = { inherits: HE, _extend: QE, log: function() {
  console.log("%s - %s", function() {
    var e = /* @__PURE__ */ new Date(), t = [hd(e.getHours()), hd(e.getMinutes()), hd(e.getSeconds())].join(":");
    return [e.getDate(), N4[e.getMonth()], t].join(" ");
  }(), cd.apply(null, arguments));
}, isBuffer: function(e) {
  return Buffer.isBuffer(e);
}, isPrimitive: Tm, isFunction: _s, isError: ec, isDate: cc, isObject: Ys, isRegExp: As, isUndefined: ba, isSymbol: function(e) {
  return xe(e) === "symbol";
}, isString: Bp, isNumber: JE, isNullOrUndefined: function(e) {
  return e == null;
}, isNull: lf, isBoolean: j0, isArray: KE, inspect: Wi, deprecate: function e(t, n) {
  if (ba(global.process))
    return function() {
      return e(t, n).apply(this, arguments);
    };
  var r = !1;
  return function() {
    return r || (console.error(n), r = !0), t.apply(this, arguments);
  };
}, format: cd, debuglog: function(e) {
  return ba(ld) && (ld = ""), e = e.toUpperCase(), !Pl[e] && (new RegExp("\\b" + e + "\\b", "i").test(ld) ? Pl[e] = function() {
    var t = cd.apply(null, arguments);
    console.error("%s %d: %s", e, 0, t);
  } : Pl[e] = function() {
  }), Pl[e];
} };
function Qv(e, t) {
  if (e === t)
    return 0;
  for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i)
    if (e[i] !== t[i]) {
      n = e[i], r = t[i];
      break;
    }
  return n < r ? -1 : r < n ? 1 : 0;
}
var dd, R4 = Object.prototype.hasOwnProperty, Xv = Object.keys || function(e) {
  var t = [];
  for (var n in e)
    R4.call(e, n) && t.push(n);
  return t;
}, Yv = Array.prototype.slice;
function YE() {
  return dd !== void 0 ? dd : dd = (function() {
  }).name === "foo";
}
function Zv(e) {
  return Object.prototype.toString.call(e);
}
function ex(e) {
  return !Mu(e) && typeof global.ArrayBuffer == "function" && (typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : !!e && (e instanceof DataView || !!(e.buffer && e.buffer instanceof ArrayBuffer)));
}
function xn(e, t) {
  e || yr(e, !0, t, "==", M0);
}
var M4 = /\s*function\s+([^\(\s]*)\s*/;
function ZE(e) {
  if (_s(e)) {
    if (YE())
      return e.name;
    var t = e.toString().match(M4);
    return t && t[1];
  }
}
function Pm(e) {
  this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = function(o) {
    return tx(nx(o.actual), 128) + " " + o.operator + " " + tx(nx(o.expected), 128);
  }(this), this.generatedMessage = !0);
  var t = e.stackStartFunction || yr;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, t);
  else {
    var n = new Error();
    if (n.stack) {
      var r = n.stack, i = ZE(t), a = r.indexOf(`
` + i);
      if (a >= 0) {
        var s = r.indexOf(`
`, a + 1);
        r = r.substring(s + 1);
      }
      this.stack = r;
    }
  }
}
function tx(e, t) {
  return typeof e == "string" ? e.length < t ? e : e.slice(0, t) : e;
}
function nx(e) {
  if (YE() || !_s(e))
    return Wi(e);
  var t = ZE(e);
  return "[Function" + (t ? ": " + t : "") + "]";
}
function yr(e, t, n, r, i) {
  throw new Pm({ message: n, actual: e, expected: t, operator: r, stackStartFunction: i });
}
function M0(e, t) {
  e || yr(e, !0, t, "==", M0);
}
function Ds(e, t, n, r) {
  if (e === t)
    return !0;
  if (Mu(e) && Mu(t))
    return Qv(e, t) === 0;
  if (cc(e) && cc(t))
    return e.getTime() === t.getTime();
  if (As(e) && As(t))
    return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;
  if (e !== null && xe(e) === "object" || t !== null && xe(t) === "object") {
    if (ex(e) && ex(t) && Zv(e) === Zv(t) && !(e instanceof Float32Array || e instanceof Float64Array))
      return Qv(new Uint8Array(e.buffer), new Uint8Array(t.buffer)) === 0;
    if (Mu(e) !== Mu(t))
      return !1;
    var i = (r = r || { actual: [], expected: [] }).actual.indexOf(e);
    return i !== -1 && i === r.expected.indexOf(t) || (r.actual.push(e), r.expected.push(t), function(a, s, o, u) {
      if (a == null || s == null)
        return !1;
      if (Tm(a) || Tm(s))
        return a === s;
      if (o && Object.getPrototypeOf(a) !== Object.getPrototypeOf(s))
        return !1;
      var c = rx(a), f = rx(s);
      if (c && !f || !c && f)
        return !1;
      if (c)
        return a = Yv.call(a), s = Yv.call(s), Ds(a, s, o);
      var p, d, m = Xv(a), y = Xv(s);
      if (m.length !== y.length)
        return !1;
      for (m.sort(), y.sort(), d = m.length - 1; d >= 0; d--)
        if (m[d] !== y[d])
          return !1;
      for (d = m.length - 1; d >= 0; d--)
        if (p = m[d], !Ds(a[p], s[p], o, u))
          return !1;
      return !0;
    }(e, t, n, r));
  }
  return n ? e === t : e == t;
}
function rx(e) {
  return Object.prototype.toString.call(e) == "[object Arguments]";
}
function ix(e, t) {
  if (!e || !t)
    return !1;
  if (Object.prototype.toString.call(t) == "[object RegExp]")
    return t.test(e);
  try {
    if (e instanceof t)
      return !0;
  } catch {
  }
  return !Error.isPrototypeOf(t) && t.call({}, e) === !0;
}
function ax(e, t, n, r) {
  var i;
  if (typeof t != "function")
    throw new TypeError('"block" argument must be a function');
  typeof n == "string" && (r = n, n = null), i = function(o) {
    var u;
    try {
      o();
    } catch (c) {
      u = c;
    }
    return u;
  }(t), r = (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : "."), e && !i && yr(i, n, "Missing expected exception" + r);
  var a = typeof r == "string", s = !e && i && !n;
  if ((!e && ec(i) && a && ix(i, n) || s) && yr(i, n, "Got unwanted exception" + r), e && i && n && !ix(i, n) || !e && i)
    throw i;
}
xn.AssertionError = Pm, HE(Pm, Error), xn.fail = yr, xn.ok = M0, xn.equal = function e(t, n, r) {
  t != n && yr(t, n, r, "==", e);
}, xn.notEqual = function e(t, n, r) {
  t == n && yr(t, n, r, "!=", e);
}, xn.deepEqual = function e(t, n, r) {
  Ds(t, n, !1) || yr(t, n, r, "deepEqual", e);
}, xn.deepStrictEqual = function e(t, n, r) {
  Ds(t, n, !0) || yr(t, n, r, "deepStrictEqual", e);
}, xn.notDeepEqual = function e(t, n, r) {
  Ds(t, n, !1) && yr(t, n, r, "notDeepEqual", e);
}, xn.notDeepStrictEqual = function e(t, n, r) {
  Ds(t, n, !0) && yr(t, n, r, "notDeepStrictEqual", e);
}, xn.strictEqual = function e(t, n, r) {
  t !== n && yr(t, n, r, "===", e);
}, xn.notStrictEqual = function e(t, n, r) {
  t === n && yr(t, n, r, "!==", e);
}, xn.throws = function(e, t, n) {
  ax(!0, e, t, n);
}, xn.doesNotThrow = function(e, t, n) {
  ax(!1, e, t, n);
}, xn.ifError = function(e) {
  if (e)
    throw e;
};
var eC = "ECMAScript JS AST traversal functions", tC = "https://github.com/estools/estraverse", nC = "estraverse.js", rC = { node: ">=4.0" }, iC = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "http://github.com/Constellation" }], aC = { type: "git", url: "http://github.com/estools/estraverse.git" }, oC = { "babel-preset-env": "^1.6.1", "babel-register": "^6.3.13", chai: "^2.1.1", espree: "^1.11.0", gulp: "^3.8.10", "gulp-bump": "^0.2.2", "gulp-filter": "^2.0.0", "gulp-git": "^1.0.1", "gulp-tag-version": "^1.3.0", jshint: "^2.5.6", mocha: "^2.1.0" }, sC = { test: "npm run-script lint && npm run-script unit-test", lint: "jshint estraverse.js", "unit-test": "mocha --compilers js:babel-register" }, V4 = { name: "estraverse", description: eC, homepage: tC, main: nC, version: "4.3.0", engines: rC, maintainers: iC, repository: aC, devDependencies: oC, license: "BSD-2-Clause", scripts: sC }, U4 = Cr(Object.freeze({ __proto__: null, name: "estraverse", description: eC, homepage: tC, main: nC, version: "4.3.0", engines: rC, maintainers: iC, repository: aC, devDependencies: oC, license: "BSD-2-Clause", scripts: sC, default: V4 })), Cc = gt(function(e, t) {
  (function n(r) {
    var i, a, s, o, u, c;
    function f(C) {
      var k, F, B = {};
      for (k in C)
        C.hasOwnProperty(k) && (xe(F = C[k]) === "object" && F !== null ? B[k] = f(F) : B[k] = F);
      return B;
    }
    function p(C, k) {
      this.parent = C, this.key = k;
    }
    function d(C, k, F, B) {
      this.node = C, this.path = k, this.wrap = F, this.ref = B;
    }
    function m() {
    }
    function y(C) {
      return C != null && xe(C) === "object" && typeof C.type == "string";
    }
    function v(C, k) {
      return (C === i.ObjectExpression || C === i.ObjectPattern) && k === "properties";
    }
    function b(C, k) {
      return new m().traverse(C, k);
    }
    function x(C, k) {
      var F;
      return F = function(B, O) {
        var S, w, D, I;
        for (w = B.length, D = 0; w; )
          O(B[I = D + (S = w >>> 1)]) ? w = S : (D = I + 1, w -= S + 1);
        return D;
      }(k, function(B) {
        return B.range[0] > C.range[0];
      }), C.extendedRange = [C.range[0], C.range[1]], F !== k.length && (C.extendedRange[1] = k[F].range[0]), (F -= 1) >= 0 && (C.extendedRange[0] = k[F].range[1]), C;
    }
    return i = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ComprehensionBlock: "ComprehensionBlock", ComprehensionExpression: "ComprehensionExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DebuggerStatement: "DebuggerStatement", DirectiveStatement: "DirectiveStatement", DoWhileStatement: "DoWhileStatement", EmptyStatement: "EmptyStatement", ExportAllDeclaration: "ExportAllDeclaration", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportSpecifier: "ExportSpecifier", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", GeneratorExpression: "GeneratorExpression", Identifier: "Identifier", IfStatement: "IfStatement", ImportExpression: "ImportExpression", ImportDeclaration: "ImportDeclaration", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier", ImportSpecifier: "ImportSpecifier", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", ModuleSpecifier: "ModuleSpecifier", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchStatement: "SwitchStatement", SwitchCase: "SwitchCase", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression" }, s = { AssignmentExpression: ["left", "right"], AssignmentPattern: ["left", "right"], ArrayExpression: ["elements"], ArrayPattern: ["elements"], ArrowFunctionExpression: ["params", "body"], AwaitExpression: ["argument"], BlockStatement: ["body"], BinaryExpression: ["left", "right"], BreakStatement: ["label"], CallExpression: ["callee", "arguments"], CatchClause: ["param", "body"], ClassBody: ["body"], ClassDeclaration: ["id", "superClass", "body"], ClassExpression: ["id", "superClass", "body"], ComprehensionBlock: ["left", "right"], ComprehensionExpression: ["blocks", "filter", "body"], ConditionalExpression: ["test", "consequent", "alternate"], ContinueStatement: ["label"], DebuggerStatement: [], DirectiveStatement: [], DoWhileStatement: ["body", "test"], EmptyStatement: [], ExportAllDeclaration: ["source"], ExportDefaultDeclaration: ["declaration"], ExportNamedDeclaration: ["declaration", "specifiers", "source"], ExportSpecifier: ["exported", "local"], ExpressionStatement: ["expression"], ForStatement: ["init", "test", "update", "body"], ForInStatement: ["left", "right", "body"], ForOfStatement: ["left", "right", "body"], FunctionDeclaration: ["id", "params", "body"], FunctionExpression: ["id", "params", "body"], GeneratorExpression: ["blocks", "filter", "body"], Identifier: [], IfStatement: ["test", "consequent", "alternate"], ImportExpression: ["source"], ImportDeclaration: ["specifiers", "source"], ImportDefaultSpecifier: ["local"], ImportNamespaceSpecifier: ["local"], ImportSpecifier: ["imported", "local"], Literal: [], LabeledStatement: ["label", "body"], LogicalExpression: ["left", "right"], MemberExpression: ["object", "property"], MetaProperty: ["meta", "property"], MethodDefinition: ["key", "value"], ModuleSpecifier: [], NewExpression: ["callee", "arguments"], ObjectExpression: ["properties"], ObjectPattern: ["properties"], Program: ["body"], Property: ["key", "value"], RestElement: ["argument"], ReturnStatement: ["argument"], SequenceExpression: ["expressions"], SpreadElement: ["argument"], Super: [], SwitchStatement: ["discriminant", "cases"], SwitchCase: ["test", "consequent"], TaggedTemplateExpression: ["tag", "quasi"], TemplateElement: [], TemplateLiteral: ["quasis", "expressions"], ThisExpression: [], ThrowStatement: ["argument"], TryStatement: ["block", "handler", "finalizer"], UnaryExpression: ["argument"], UpdateExpression: ["argument"], VariableDeclaration: ["declarations"], VariableDeclarator: ["id", "init"], WhileStatement: ["test", "body"], WithStatement: ["object", "body"], YieldExpression: ["argument"] }, a = { Break: o = {}, Skip: u = {}, Remove: c = {} }, p.prototype.replace = function(C) {
      this.parent[this.key] = C;
    }, p.prototype.remove = function() {
      return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), !0) : (this.replace(null), !1);
    }, m.prototype.path = function() {
      var C, k, F, B, O;
      function S(w, D) {
        if (Array.isArray(D))
          for (F = 0, B = D.length; F < B; ++F)
            w.push(D[F]);
        else
          w.push(D);
      }
      if (!this.__current.path)
        return null;
      for (O = [], C = 2, k = this.__leavelist.length; C < k; ++C)
        S(O, this.__leavelist[C].path);
      return S(O, this.__current.path), O;
    }, m.prototype.type = function() {
      return this.current().type || this.__current.wrap;
    }, m.prototype.parents = function() {
      var C, k, F;
      for (F = [], C = 1, k = this.__leavelist.length; C < k; ++C)
        F.push(this.__leavelist[C].node);
      return F;
    }, m.prototype.current = function() {
      return this.__current.node;
    }, m.prototype.__execute = function(C, k) {
      var F, B;
      return B = void 0, F = this.__current, this.__current = k, this.__state = null, C && (B = C.call(this, k.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = F, B;
    }, m.prototype.notify = function(C) {
      this.__state = C;
    }, m.prototype.skip = function() {
      this.notify(u);
    }, m.prototype.break = function() {
      this.notify(o);
    }, m.prototype.remove = function() {
      this.notify(c);
    }, m.prototype.__initialize = function(C, k) {
      this.visitor = k, this.root = C, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, k.fallback === "iteration" ? this.__fallback = Object.keys : typeof k.fallback == "function" && (this.__fallback = k.fallback), this.__keys = s, k.keys && (this.__keys = Object.assign(Object.create(this.__keys), k.keys));
    }, m.prototype.traverse = function(C, k) {
      var F, B, O, S, w, D, I, L, V, K, W, R;
      for (this.__initialize(C, k), R = {}, F = this.__worklist, B = this.__leavelist, F.push(new d(C, null, null, null)), B.push(new d(null, null, null, null)); F.length; )
        if ((O = F.pop()) !== R) {
          if (O.node) {
            if (D = this.__execute(k.enter, O), this.__state === o || D === o)
              return;
            if (F.push(R), B.push(O), this.__state === u || D === u)
              continue;
            if (w = (S = O.node).type || O.wrap, !(K = this.__keys[w])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + w + ".");
              K = this.__fallback(S);
            }
            for (L = K.length; (L -= 1) >= 0; )
              if (W = S[I = K[L]])
                if (Array.isArray(W)) {
                  for (V = W.length; (V -= 1) >= 0; )
                    if (W[V]) {
                      if (v(w, K[L]))
                        O = new d(W[V], [I, V], "Property", null);
                      else {
                        if (!y(W[V]))
                          continue;
                        O = new d(W[V], [I, V], null, null);
                      }
                      F.push(O);
                    }
                } else
                  y(W) && F.push(new d(W, I, null, null));
          }
        } else if (O = B.pop(), D = this.__execute(k.leave, O), this.__state === o || D === o)
          return;
    }, m.prototype.replace = function(C, k) {
      var F, B, O, S, w, D, I, L, V, K, W, R, q;
      function J(X) {
        var ce, A, M, ne;
        if (X.ref.remove()) {
          for (A = X.ref.key, ne = X.ref.parent, ce = F.length; ce--; )
            if ((M = F[ce]).ref && M.ref.parent === ne) {
              if (M.ref.key < A)
                break;
              --M.ref.key;
            }
        }
      }
      for (this.__initialize(C, k), W = {}, F = this.__worklist, B = this.__leavelist, D = new d(C, null, null, new p(R = { root: C }, "root")), F.push(D), B.push(D); F.length; )
        if ((D = F.pop()) !== W) {
          if ((w = this.__execute(k.enter, D)) !== void 0 && w !== o && w !== u && w !== c && (D.ref.replace(w), D.node = w), this.__state !== c && w !== c || (J(D), D.node = null), this.__state === o || w === o)
            return R.root;
          if ((O = D.node) && (F.push(W), B.push(D), this.__state !== u && w !== u)) {
            if (S = O.type || D.wrap, !(V = this.__keys[S])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + S + ".");
              V = this.__fallback(O);
            }
            for (I = V.length; (I -= 1) >= 0; )
              if (K = O[q = V[I]])
                if (Array.isArray(K)) {
                  for (L = K.length; (L -= 1) >= 0; )
                    if (K[L]) {
                      if (v(S, V[I]))
                        D = new d(K[L], [q, L], "Property", new p(K, L));
                      else {
                        if (!y(K[L]))
                          continue;
                        D = new d(K[L], [q, L], null, new p(K, L));
                      }
                      F.push(D);
                    }
                } else
                  y(K) && F.push(new d(K, q, null, new p(O, q)));
          }
        } else if (D = B.pop(), (w = this.__execute(k.leave, D)) !== void 0 && w !== o && w !== u && w !== c && D.ref.replace(w), this.__state !== c && w !== c || J(D), this.__state === o || w === o)
          return R.root;
      return R.root;
    }, r.version = U4.version, r.Syntax = i, r.traverse = b, r.replace = function(C, k) {
      return new m().replace(C, k);
    }, r.attachComments = function(C, k, F) {
      var B, O, S, w, D = [];
      if (!C.range)
        throw new Error("attachComments needs range information");
      if (!F.length) {
        if (k.length) {
          for (S = 0, O = k.length; S < O; S += 1)
            (B = f(k[S])).extendedRange = [0, C.range[0]], D.push(B);
          C.leadingComments = D;
        }
        return C;
      }
      for (S = 0, O = k.length; S < O; S += 1)
        D.push(x(f(k[S]), F));
      return w = 0, b(C, { enter: function(I) {
        for (var L; w < D.length && !((L = D[w]).extendedRange[1] > I.range[0]); )
          L.extendedRange[1] === I.range[0] ? (I.leadingComments || (I.leadingComments = []), I.leadingComments.push(L), D.splice(w, 1)) : w += 1;
        return w === D.length ? a.Break : D[w].extendedRange[0] > I.range[1] ? a.Skip : void 0;
      } }), w = 0, b(C, { leave: function(I) {
        for (var L; w < D.length && (L = D[w], !(I.range[1] < L.extendedRange[0])); )
          I.range[1] === L.extendedRange[0] ? (I.trailingComments || (I.trailingComments = []), I.trailingComments.push(L), D.splice(w, 1)) : w += 1;
        return w === D.length ? a.Break : D[w].extendedRange[0] > I.range[1] ? a.Skip : void 0;
      } }), C;
    }, r.VisitorKeys = s, r.VisitorOption = a, r.Controller = m, r.cloneEnvironment = function() {
      return n({});
    }, r;
  })(t);
}), op = function() {
  function e(t, n, r, i, a, s, o) {
    We(this, e), this.identifier = t, this.from = n, this.tainted = !1, this.resolved = null, this.flag = r, this.isWrite() && (this.writeExpr = i, this.partial = s, this.init = o), this.__maybeImplicitGlobal = a;
  }
  return Xe(e, [{ key: "isStatic", value: function() {
    return !this.tainted && this.resolved && this.resolved.scope.isStatic();
  } }, { key: "isWrite", value: function() {
    return !!(this.flag & e.WRITE);
  } }, { key: "isRead", value: function() {
    return !!(this.flag & e.READ);
  } }, { key: "isReadOnly", value: function() {
    return this.flag === e.READ;
  } }, { key: "isWriteOnly", value: function() {
    return this.flag === e.WRITE;
  } }, { key: "isReadWrite", value: function() {
    return this.flag === e.RW;
  } }]), e;
}();
op.READ = 1, op.WRITE = 2, op.RW = 3;
var Ri = op, Ha = function e(t, n) {
  We(this, e), this.name = t, this.identifiers = [], this.references = [], this.defs = [], this.tainted = !1, this.stack = !0, this.scope = n;
};
Ha.CatchClause = "CatchClause", Ha.Parameter = "Parameter", Ha.FunctionName = "FunctionName", Ha.ClassName = "ClassName", Ha.Variable = "Variable", Ha.ImportBinding = "ImportBinding", Ha.ImplicitGlobalVariable = "ImplicitGlobalVariable";
var jr = Ha, ox = function e(t, n, r, i, a, s) {
  We(this, e), this.type = t, this.name = n, this.node = r, this.parent = i, this.index = a, this.kind = s;
}, V0 = { ParameterDefinition: function(e) {
  function t(n, r, i, a) {
    var s;
    return We(this, t), (s = Gt(this, rt(t).call(this, jr.Parameter, n, r, null, i, null))).rest = a, s;
  }
  return $t(t, ox), t;
}(), Definition: ox }, ti = Cc.Syntax, sx = V0.Definition;
function q4(e) {
  return e.type === jr.ClassName || e.type === jr.Variable && e.parent.kind !== "var";
}
var gi = function() {
  function e(t, n, r, i, a) {
    We(this, e), this.type = n, this.set = /* @__PURE__ */ new Map(), this.taints = /* @__PURE__ */ new Map(), this.dynamic = this.type === "global" || this.type === "with", this.block = i, this.through = [], this.variables = [], this.references = [], this.variableScope = this.type === "global" || this.type === "function" || this.type === "module" ? this : r.variableScope, this.functionExpressionScope = !1, this.directCallToEvalScope = !1, this.thisFound = !1, this.__left = [], this.upper = r, this.isStrict = function(s, o, u, c) {
      var f;
      if (s.upper && s.upper.isStrict || u || s.type === "class" || s.type === "module")
        return !0;
      if (s.type === "block" || s.type === "switch")
        return !1;
      if (s.type === "function") {
        if (o.type === ti.ArrowFunctionExpression && o.body.type !== ti.BlockStatement || !(f = o.type === ti.Program ? o : o.body))
          return !1;
      } else {
        if (s.type !== "global")
          return !1;
        f = o;
      }
      if (c)
        for (var p = 0, d = f.body.length; p < d; ++p) {
          var m = f.body[p];
          if (m.type !== ti.DirectiveStatement)
            break;
          if (m.raw === '"use strict"' || m.raw === "'use strict'")
            return !0;
        }
      else
        for (var y = 0, v = f.body.length; y < v; ++y) {
          var b = f.body[y];
          if (b.type !== ti.ExpressionStatement)
            break;
          var x = b.expression;
          if (x.type !== ti.Literal || typeof x.value != "string")
            break;
          if (x.raw !== null && x.raw !== void 0) {
            if (x.raw === '"use strict"' || x.raw === "'use strict'")
              return !0;
          } else if (x.value === "use strict")
            return !0;
        }
      return !1;
    }(this, i, a, t.__useDirective()), this.childScopes = [], this.upper && this.upper.childScopes.push(this), this.__declaredVariables = t.__declaredVariables, function(s, o) {
      s.scopes.push(o);
      var u = s.__nodeToScope.get(o.block);
      u ? u.push(o) : s.__nodeToScope.set(o.block, [o]);
    }(t, this);
  }
  return Xe(e, [{ key: "__shouldStaticallyClose", value: function(t) {
    return !this.dynamic || t.__isOptimistic();
  } }, { key: "__shouldStaticallyCloseForGlobal", value: function(t) {
    var n = t.identifier.name;
    if (!this.set.has(n))
      return !1;
    var r = this.set.get(n).defs;
    return r.length > 0 && r.every(q4);
  } }, { key: "__staticCloseRef", value: function(t) {
    this.__resolve(t) || this.__delegateToUpperScope(t);
  } }, { key: "__dynamicCloseRef", value: function(t) {
    var n = this;
    do
      n.through.push(t), n = n.upper;
    while (n);
  } }, { key: "__globalCloseRef", value: function(t) {
    this.__shouldStaticallyCloseForGlobal(t) ? this.__staticCloseRef(t) : this.__dynamicCloseRef(t);
  } }, { key: "__close", value: function(t) {
    var n;
    n = this.__shouldStaticallyClose(t) ? this.__staticCloseRef : this.type !== "global" ? this.__dynamicCloseRef : this.__globalCloseRef;
    for (var r = 0, i = this.__left.length; r < i; ++r) {
      var a = this.__left[r];
      n.call(this, a);
    }
    return this.__left = null, this.upper;
  } }, { key: "__isValidResolution", value: function(t, n) {
    return !0;
  } }, { key: "__resolve", value: function(t) {
    var n = t.identifier.name;
    if (!this.set.has(n))
      return !1;
    var r = this.set.get(n);
    return !!this.__isValidResolution(t, r) && (r.references.push(t), r.stack = r.stack && t.from.variableScope === this.variableScope, t.tainted && (r.tainted = !0, this.taints.set(r.name, !0)), t.resolved = r, !0);
  } }, { key: "__delegateToUpperScope", value: function(t) {
    this.upper && this.upper.__left.push(t), this.through.push(t);
  } }, { key: "__addDeclaredVariablesOfNode", value: function(t, n) {
    if (n != null) {
      var r = this.__declaredVariables.get(n);
      r == null && (r = [], this.__declaredVariables.set(n, r)), r.indexOf(t) === -1 && r.push(t);
    }
  } }, { key: "__defineGeneric", value: function(t, n, r, i, a) {
    var s;
    (s = n.get(t)) || (s = new jr(t, this), n.set(t, s), r.push(s)), a && (s.defs.push(a), this.__addDeclaredVariablesOfNode(s, a.node), this.__addDeclaredVariablesOfNode(s, a.parent)), i && s.identifiers.push(i);
  } }, { key: "__define", value: function(t, n) {
    t && t.type === ti.Identifier && this.__defineGeneric(t.name, this.set, this.variables, t, n);
  } }, { key: "__referencing", value: function(t, n, r, i, a, s) {
    if (t && t.type === ti.Identifier && t.name !== "super") {
      var o = new Ri(t, this, n || Ri.READ, r, i, !!a, !!s);
      this.references.push(o), this.__left.push(o);
    }
  } }, { key: "__detectEval", value: function() {
    var t = this;
    this.directCallToEvalScope = !0;
    do
      t.dynamic = !0, t = t.upper;
    while (t);
  } }, { key: "__detectThis", value: function() {
    this.thisFound = !0;
  } }, { key: "__isClosed", value: function() {
    return this.__left === null;
  } }, { key: "resolve", value: function(t) {
    var n, r, i;
    for (xn(this.__isClosed(), "Scope should be closed."), xn(t.type === ti.Identifier, "Target should be identifier."), r = 0, i = this.references.length; r < i; ++r)
      if ((n = this.references[r]).identifier === t)
        return n;
    return null;
  } }, { key: "isStatic", value: function() {
    return !this.dynamic;
  } }, { key: "isArgumentsMaterialized", value: function() {
    return !0;
  } }, { key: "isThisMaterialized", value: function() {
    return !0;
  } }, { key: "isUsedName", value: function(t) {
    if (this.set.has(t))
      return !0;
    for (var n = 0, r = this.through.length; n < r; ++n)
      if (this.through[n].identifier.name === t)
        return !0;
    return !1;
  } }]), e;
}(), ki = { Scope: gi, GlobalScope: function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, n, "global", null, r, !1))).implicit = { set: /* @__PURE__ */ new Map(), variables: [], left: [] }, i;
  }
  return $t(t, gi), Xe(t, [{ key: "__close", value: function(n) {
    for (var r = [], i = 0, a = this.__left.length; i < a; ++i) {
      var s = this.__left[i];
      s.__maybeImplicitGlobal && !this.set.has(s.identifier.name) && r.push(s.__maybeImplicitGlobal);
    }
    for (var o = 0, u = r.length; o < u; ++o) {
      var c = r[o];
      this.__defineImplicit(c.pattern, new sx(jr.ImplicitGlobalVariable, c.pattern, c.node, null, null, null));
    }
    return this.implicit.left = this.__left, Yn(rt(t.prototype), "__close", this).call(this, n);
  } }, { key: "__defineImplicit", value: function(n, r) {
    n && n.type === ti.Identifier && this.__defineGeneric(n.name, this.implicit.set, this.implicit.variables, n, r);
  } }]), t;
}(), ModuleScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "module", r, i, !1));
  }
  return $t(t, gi), t;
}(), FunctionExpressionNameScope: function(e) {
  function t(n, r, i) {
    var a;
    return We(this, t), (a = Gt(this, rt(t).call(this, n, "function-expression-name", r, i, !1))).__define(i.id, new sx(jr.FunctionName, i.id, i, null, null, null)), a.functionExpressionScope = !0, a;
  }
  return $t(t, gi), t;
}(), CatchScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "catch", r, i, !1));
  }
  return $t(t, gi), t;
}(), WithScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "with", r, i, !1));
  }
  return $t(t, gi), Xe(t, [{ key: "__close", value: function(n) {
    if (this.__shouldStaticallyClose(n))
      return Yn(rt(t.prototype), "__close", this).call(this, n);
    for (var r = 0, i = this.__left.length; r < i; ++r) {
      var a = this.__left[r];
      a.tainted = !0, this.__delegateToUpperScope(a);
    }
    return this.__left = null, this.upper;
  } }]), t;
}(), BlockScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "block", r, i, !1));
  }
  return $t(t, gi), t;
}(), SwitchScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "switch", r, i, !1));
  }
  return $t(t, gi), t;
}(), FunctionScope: function(e) {
  function t(n, r, i, a) {
    var s;
    return We(this, t), (s = Gt(this, rt(t).call(this, n, "function", r, i, a))).block.type !== ti.ArrowFunctionExpression && s.__defineArguments(), s;
  }
  return $t(t, gi), Xe(t, [{ key: "isArgumentsMaterialized", value: function() {
    if (this.block.type === ti.ArrowFunctionExpression)
      return !1;
    if (!this.isStatic())
      return !0;
    var n = this.set.get("arguments");
    return xn(n, "Always have arguments variable."), n.tainted || n.references.length !== 0;
  } }, { key: "isThisMaterialized", value: function() {
    return !this.isStatic() || this.thisFound;
  } }, { key: "__defineArguments", value: function() {
    this.__defineGeneric("arguments", this.set, this.variables, null, null), this.taints.set("arguments", !0);
  } }, { key: "__isValidResolution", value: function(n, r) {
    if (this.block.type === "Program")
      return !0;
    var i = this.block.body.range[0];
    return !(r.scope === this && n.identifier.range[0] < i && r.defs.every(function(a) {
      return a.name.range[0] >= i;
    }));
  } }]), t;
}(), ForScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "for", r, i, !1));
  }
  return $t(t, gi), t;
}(), ClassScope: function(e) {
  function t(n, r, i) {
    return We(this, t), Gt(this, rt(t).call(this, n, "class", r, i, !1));
  }
  return $t(t, gi), t;
}() }, ux = ki.GlobalScope, W4 = ki.CatchScope, $4 = ki.WithScope, G4 = ki.ModuleScope, z4 = ki.ClassScope, H4 = ki.SwitchScope, K4 = ki.FunctionScope, J4 = ki.ForScope, Q4 = ki.FunctionExpressionNameScope, X4 = ki.BlockScope, cx = function() {
  function e(t) {
    We(this, e), this.scopes = [], this.globalScope = null, this.__nodeToScope = /* @__PURE__ */ new WeakMap(), this.__currentScope = null, this.__options = t, this.__declaredVariables = /* @__PURE__ */ new WeakMap();
  }
  return Xe(e, [{ key: "__useDirective", value: function() {
    return this.__options.directive;
  } }, { key: "__isOptimistic", value: function() {
    return this.__options.optimistic;
  } }, { key: "__ignoreEval", value: function() {
    return this.__options.ignoreEval;
  } }, { key: "__isNodejsScope", value: function() {
    return this.__options.nodejsScope;
  } }, { key: "isModule", value: function() {
    return this.__options.sourceType === "module";
  } }, { key: "isImpliedStrict", value: function() {
    return this.__options.impliedStrict;
  } }, { key: "isStrictModeSupported", value: function() {
    return this.__options.ecmaVersion >= 5;
  } }, { key: "__get", value: function(t) {
    return this.__nodeToScope.get(t);
  } }, { key: "getDeclaredVariables", value: function(t) {
    return this.__declaredVariables.get(t) || [];
  } }, { key: "acquire", value: function(t, n) {
    function r(f) {
      return f.type !== "function" || !f.functionExpressionScope;
    }
    var i = this.__get(t);
    if (!i || i.length === 0)
      return null;
    if (i.length === 1)
      return i[0];
    if (n)
      for (var a = i.length - 1; a >= 0; --a) {
        var s = i[a];
        if (r(s))
          return s;
      }
    else
      for (var o = 0, u = i.length; o < u; ++o) {
        var c = i[o];
        if (r(c))
          return c;
      }
    return null;
  } }, { key: "acquireAll", value: function(t) {
    return this.__get(t);
  } }, { key: "release", value: function(t, n) {
    var r = this.__get(t);
    if (r && r.length) {
      var i = r[0].upper;
      return i ? this.acquire(i.block, n) : null;
    }
    return null;
  } }, { key: "attach", value: function() {
  } }, { key: "detach", value: function() {
  } }, { key: "__nestScope", value: function(t) {
    return t instanceof ux && (xn(this.__currentScope === null), this.globalScope = t), this.__currentScope = t, t;
  } }, { key: "__nestGlobalScope", value: function(t) {
    return this.__nestScope(new ux(this, t));
  } }, { key: "__nestBlockScope", value: function(t) {
    return this.__nestScope(new X4(this, this.__currentScope, t));
  } }, { key: "__nestFunctionScope", value: function(t, n) {
    return this.__nestScope(new K4(this, this.__currentScope, t, n));
  } }, { key: "__nestForScope", value: function(t) {
    return this.__nestScope(new J4(this, this.__currentScope, t));
  } }, { key: "__nestCatchScope", value: function(t) {
    return this.__nestScope(new W4(this, this.__currentScope, t));
  } }, { key: "__nestWithScope", value: function(t) {
    return this.__nestScope(new $4(this, this.__currentScope, t));
  } }, { key: "__nestClassScope", value: function(t) {
    return this.__nestScope(new z4(this, this.__currentScope, t));
  } }, { key: "__nestSwitchScope", value: function(t) {
    return this.__nestScope(new H4(this, this.__currentScope, t));
  } }, { key: "__nestModuleScope", value: function(t) {
    return this.__nestScope(new G4(this, this.__currentScope, t));
  } }, { key: "__nestFunctionExpressionNameScope", value: function(t) {
    return this.__nestScope(new Q4(this, this.__currentScope, t));
  } }, { key: "__isES6", value: function() {
    return this.__options.ecmaVersion >= 6;
  } }]), e;
}(), uC = "https://github.com/estools/esrecurse", cC = { node: ">=4.0" }, lC = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], pC = { type: "git", url: "https://github.com/estools/esrecurse.git" }, fC = { estraverse: "^4.1.0" }, hC = { "babel-cli": "^6.24.1", "babel-eslint": "^7.2.3", "babel-preset-es2015": "^6.24.1", "babel-register": "^6.24.1", chai: "^4.0.2", esprima: "^4.0.0", gulp: "^3.9.0", "gulp-bump": "^2.7.0", "gulp-eslint": "^4.0.0", "gulp-filter": "^5.0.0", "gulp-git": "^2.4.1", "gulp-mocha": "^4.3.1", "gulp-tag-version": "^1.2.1", jsdoc: "^3.3.0-alpha10", minimist: "^1.1.0" }, dC = { test: "gulp travis", "unit-test": "gulp test", lint: "gulp lint" }, mC = { presets: ["es2015"] }, Y4 = { name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: uC, main: "esrecurse.js", version: "4.2.1", engines: cC, maintainers: lC, repository: pC, dependencies: fC, devDependencies: hC, license: "BSD-2-Clause", scripts: dC, babel: mC }, Z4 = Cr(Object.freeze({ __proto__: null, name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: uC, main: "esrecurse.js", version: "4.2.1", engines: cC, maintainers: lC, repository: pC, dependencies: fC, devDependencies: hC, license: "BSD-2-Clause", scripts: dC, babel: mC, default: Y4 })), Ts = gt(function(e, t) {
  (function() {
    var n = Cc;
    function r(s) {
      return s != null && xe(s) === "object" && typeof s.type == "string";
    }
    function i(s, o) {
      return (s === n.Syntax.ObjectExpression || s === n.Syntax.ObjectPattern) && o === "properties";
    }
    function a(s, o) {
      o = o || {}, this.__visitor = s || this, this.__childVisitorKeys = o.childVisitorKeys ? Object.assign({}, n.VisitorKeys, o.childVisitorKeys) : n.VisitorKeys, o.fallback === "iteration" ? this.__fallback = Object.keys : typeof o.fallback == "function" && (this.__fallback = o.fallback);
    }
    a.prototype.visitChildren = function(s) {
      var o, u, c, f, p, d, m;
      if (s != null) {
        if (o = s.type || n.Syntax.Property, !(u = this.__childVisitorKeys[o])) {
          if (!this.__fallback)
            throw new Error("Unknown node type " + o + ".");
          u = this.__fallback(s);
        }
        for (c = 0, f = u.length; c < f; ++c)
          if (m = s[u[c]])
            if (Array.isArray(m))
              for (p = 0, d = m.length; p < d; ++p)
                m[p] && (r(m[p]) || i(o, u[c])) && this.visit(m[p]);
            else
              r(m) && this.visit(m);
      }
    }, a.prototype.visit = function(s) {
      var o;
      s != null && (o = s.type || n.Syntax.Property, this.__visitor[o] ? this.__visitor[o].call(this, s) : this.visitChildren(s));
    }, t.version = Z4.version, t.Visitor = a, t.visit = function(s, o, u) {
      new a(o, u).visit(s);
    };
  })();
}), ls = (Ts.version, Ts.Visitor, Ts.visit, Cc.Syntax), md = function(e) {
  function t(n, r, i) {
    var a;
    return We(this, t), (a = Gt(this, rt(t).call(this, null, n))).rootPattern = r, a.callback = i, a.assignments = [], a.rightHandNodes = [], a.restElements = [], a;
  }
  return $t(t, Ts.Visitor), Xe(t, null, [{ key: "isPattern", value: function(n) {
    var r = n.type;
    return r === ls.Identifier || r === ls.ObjectPattern || r === ls.ArrayPattern || r === ls.SpreadElement || r === ls.RestElement || r === ls.AssignmentPattern;
  } }]), Xe(t, [{ key: "Identifier", value: function(n) {
    var r, i = (r = this.restElements)[r.length - 1] || null;
    this.callback(n, { topLevel: n === this.rootPattern, rest: i != null && i.argument === n, assignments: this.assignments });
  } }, { key: "Property", value: function(n) {
    n.computed && this.rightHandNodes.push(n.key), this.visit(n.value);
  } }, { key: "ArrayPattern", value: function(n) {
    for (var r = 0, i = n.elements.length; r < i; ++r) {
      var a = n.elements[r];
      this.visit(a);
    }
  } }, { key: "AssignmentPattern", value: function(n) {
    this.assignments.push(n), this.visit(n.left), this.rightHandNodes.push(n.right), this.assignments.pop();
  } }, { key: "RestElement", value: function(n) {
    this.restElements.push(n), this.visit(n.argument), this.restElements.pop();
  } }, { key: "MemberExpression", value: function(n) {
    n.computed && this.rightHandNodes.push(n.property), this.rightHandNodes.push(n.object);
  } }, { key: "SpreadElement", value: function(n) {
    this.visit(n.argument);
  } }, { key: "ArrayExpression", value: function(n) {
    n.elements.forEach(this.visit, this);
  } }, { key: "AssignmentExpression", value: function(n) {
    this.assignments.push(n), this.visit(n.left), this.rightHandNodes.push(n.right), this.assignments.pop();
  } }, { key: "CallExpression", value: function(n) {
    var r = this;
    n.arguments.forEach(function(i) {
      r.rightHandNodes.push(i);
    }), this.visit(n.callee);
  } }]), t;
}(), sa = Cc.Syntax, lx = V0.ParameterDefinition, ds = V0.Definition, e9 = function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, null, r.options))).declaration = n, i.referencer = r, i;
  }
  return $t(t, Ts.Visitor), Xe(t, [{ key: "visitImport", value: function(n, r) {
    var i = this;
    this.referencer.visitPattern(n, function(a) {
      i.referencer.currentScope().__define(a, new ds(jr.ImportBinding, a, r, i.declaration, null, null));
    });
  } }, { key: "ImportNamespaceSpecifier", value: function(n) {
    var r = n.local || n.id;
    r && this.visitImport(r, n);
  } }, { key: "ImportDefaultSpecifier", value: function(n) {
    var r = n.local || n.id;
    this.visitImport(r, n);
  } }, { key: "ImportSpecifier", value: function(n) {
    var r = n.local || n.id;
    n.name ? this.visitImport(n.name, n) : this.visitImport(r, n);
  } }]), t;
}(), t9 = function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, null, n))).options = n, i.scopeManager = r, i.parent = null, i.isInnerMethodDefinition = !1, i;
  }
  return $t(t, Ts.Visitor), Xe(t, [{ key: "currentScope", value: function() {
    return this.scopeManager.__currentScope;
  } }, { key: "close", value: function(n) {
    for (; this.currentScope() && n === this.currentScope().block; )
      this.scopeManager.__currentScope = this.currentScope().__close(this.scopeManager);
  } }, { key: "pushInnerMethodDefinition", value: function(n) {
    var r = this.isInnerMethodDefinition;
    return this.isInnerMethodDefinition = n, r;
  } }, { key: "popInnerMethodDefinition", value: function(n) {
    this.isInnerMethodDefinition = n;
  } }, { key: "referencingDefaultValue", value: function(n, r, i, a) {
    var s = this.currentScope();
    r.forEach(function(o) {
      s.__referencing(n, Ri.WRITE, o.right, i, n !== o.left, a);
    });
  } }, { key: "visitPattern", value: function(n, r, i) {
    var a = r, s = i;
    typeof r == "function" && (s = r, a = { processRightHandNodes: !1 }), function(o, u, c, f) {
      var p = new md(o, u, f);
      p.visit(u), c != null && p.rightHandNodes.forEach(c.visit, c);
    }(this.options, n, a.processRightHandNodes ? this : null, s);
  } }, { key: "visitFunction", value: function(n) {
    var r, i, a = this;
    n.type === sa.FunctionDeclaration && this.currentScope().__define(n.id, new ds(jr.FunctionName, n.id, n, null, null, null)), n.type === sa.FunctionExpression && n.id && this.scopeManager.__nestFunctionExpressionNameScope(n), this.scopeManager.__nestFunctionScope(n, this.isInnerMethodDefinition);
    var s = this;
    function o(u, c) {
      s.currentScope().__define(u, new lx(u, n, r, c.rest)), s.referencingDefaultValue(u, c.assignments, null, !0);
    }
    for (r = 0, i = n.params.length; r < i; ++r)
      this.visitPattern(n.params[r], { processRightHandNodes: !0 }, o);
    n.rest && this.visitPattern({ type: "RestElement", argument: n.rest }, function(u) {
      a.currentScope().__define(u, new lx(u, n, n.params.length, !0));
    }), n.body && (n.body.type === sa.BlockStatement ? this.visitChildren(n.body) : this.visit(n.body)), this.close(n);
  } }, { key: "visitClass", value: function(n) {
    n.type === sa.ClassDeclaration && this.currentScope().__define(n.id, new ds(jr.ClassName, n.id, n, null, null, null)), this.visit(n.superClass), this.scopeManager.__nestClassScope(n), n.id && this.currentScope().__define(n.id, new ds(jr.ClassName, n.id, n)), this.visit(n.body), this.close(n);
  } }, { key: "visitProperty", value: function(n) {
    var r;
    n.computed && this.visit(n.key);
    var i = n.type === sa.MethodDefinition;
    i && (r = this.pushInnerMethodDefinition(!0)), this.visit(n.value), i && this.popInnerMethodDefinition(r);
  } }, { key: "visitForIn", value: function(n) {
    var r = this;
    n.left.type === sa.VariableDeclaration && n.left.kind !== "var" && this.scopeManager.__nestForScope(n), n.left.type === sa.VariableDeclaration ? (this.visit(n.left), this.visitPattern(n.left.declarations[0].id, function(i) {
      r.currentScope().__referencing(i, Ri.WRITE, n.right, null, !0, !0);
    })) : this.visitPattern(n.left, { processRightHandNodes: !0 }, function(i, a) {
      var s = null;
      r.currentScope().isStrict || (s = { pattern: i, node: n }), r.referencingDefaultValue(i, a.assignments, s, !1), r.currentScope().__referencing(i, Ri.WRITE, n.right, s, !0, !1);
    }), this.visit(n.right), this.visit(n.body), this.close(n);
  } }, { key: "visitVariableDeclaration", value: function(n, r, i, a) {
    var s = this, o = i.declarations[a], u = o.init;
    this.visitPattern(o.id, { processRightHandNodes: !0 }, function(c, f) {
      n.__define(c, new ds(r, c, o, i, a, i.kind)), s.referencingDefaultValue(c, f.assignments, null, !0), u && s.currentScope().__referencing(c, Ri.WRITE, u, null, !f.topLevel, !0);
    });
  } }, { key: "AssignmentExpression", value: function(n) {
    var r = this;
    md.isPattern(n.left) ? n.operator === "=" ? this.visitPattern(n.left, { processRightHandNodes: !0 }, function(i, a) {
      var s = null;
      r.currentScope().isStrict || (s = { pattern: i, node: n }), r.referencingDefaultValue(i, a.assignments, s, !1), r.currentScope().__referencing(i, Ri.WRITE, n.right, s, !a.topLevel, !1);
    }) : this.currentScope().__referencing(n.left, Ri.RW, n.right) : this.visit(n.left), this.visit(n.right);
  } }, { key: "CatchClause", value: function(n) {
    var r = this;
    this.scopeManager.__nestCatchScope(n), this.visitPattern(n.param, { processRightHandNodes: !0 }, function(i, a) {
      r.currentScope().__define(i, new ds(jr.CatchClause, n.param, n, null, null, null)), r.referencingDefaultValue(i, a.assignments, null, !0);
    }), this.visit(n.body), this.close(n);
  } }, { key: "Program", value: function(n) {
    this.scopeManager.__nestGlobalScope(n), this.scopeManager.__isNodejsScope() && (this.currentScope().isStrict = !1, this.scopeManager.__nestFunctionScope(n, !1)), this.scopeManager.__isES6() && this.scopeManager.isModule() && this.scopeManager.__nestModuleScope(n), this.scopeManager.isStrictModeSupported() && this.scopeManager.isImpliedStrict() && (this.currentScope().isStrict = !0), this.visitChildren(n), this.close(n);
  } }, { key: "Identifier", value: function(n) {
    this.currentScope().__referencing(n);
  } }, { key: "UpdateExpression", value: function(n) {
    md.isPattern(n.argument) ? this.currentScope().__referencing(n.argument, Ri.RW, null) : this.visitChildren(n);
  } }, { key: "MemberExpression", value: function(n) {
    this.visit(n.object), n.computed && this.visit(n.property);
  } }, { key: "Property", value: function(n) {
    this.visitProperty(n);
  } }, { key: "MethodDefinition", value: function(n) {
    this.visitProperty(n);
  } }, { key: "BreakStatement", value: function() {
  } }, { key: "ContinueStatement", value: function() {
  } }, { key: "LabeledStatement", value: function(n) {
    this.visit(n.body);
  } }, { key: "ForStatement", value: function(n) {
    n.init && n.init.type === sa.VariableDeclaration && n.init.kind !== "var" && this.scopeManager.__nestForScope(n), this.visitChildren(n), this.close(n);
  } }, { key: "ClassExpression", value: function(n) {
    this.visitClass(n);
  } }, { key: "ClassDeclaration", value: function(n) {
    this.visitClass(n);
  } }, { key: "CallExpression", value: function(n) {
    this.scopeManager.__ignoreEval() || n.callee.type !== sa.Identifier || n.callee.name !== "eval" || this.currentScope().variableScope.__detectEval(), this.visitChildren(n);
  } }, { key: "BlockStatement", value: function(n) {
    this.scopeManager.__isES6() && this.scopeManager.__nestBlockScope(n), this.visitChildren(n), this.close(n);
  } }, { key: "ThisExpression", value: function() {
    this.currentScope().variableScope.__detectThis();
  } }, { key: "WithStatement", value: function(n) {
    this.visit(n.object), this.scopeManager.__nestWithScope(n), this.visit(n.body), this.close(n);
  } }, { key: "VariableDeclaration", value: function(n) {
    for (var r = n.kind === "var" ? this.currentScope().variableScope : this.currentScope(), i = 0, a = n.declarations.length; i < a; ++i) {
      var s = n.declarations[i];
      this.visitVariableDeclaration(r, jr.Variable, n, i), s.init && this.visit(s.init);
    }
  } }, { key: "SwitchStatement", value: function(n) {
    this.visit(n.discriminant), this.scopeManager.__isES6() && this.scopeManager.__nestSwitchScope(n);
    for (var r = 0, i = n.cases.length; r < i; ++r)
      this.visit(n.cases[r]);
    this.close(n);
  } }, { key: "FunctionDeclaration", value: function(n) {
    this.visitFunction(n);
  } }, { key: "FunctionExpression", value: function(n) {
    this.visitFunction(n);
  } }, { key: "ForOfStatement", value: function(n) {
    this.visitForIn(n);
  } }, { key: "ForInStatement", value: function(n) {
    this.visitForIn(n);
  } }, { key: "ArrowFunctionExpression", value: function(n) {
    this.visitFunction(n);
  } }, { key: "ImportDeclaration", value: function(n) {
    xn(this.scopeManager.__isES6() && this.scopeManager.isModule(), "ImportDeclaration should appear when the mode is ES6 and in the module context."), new e9(n, this).visit(n);
  } }, { key: "visitExportDeclaration", value: function(n) {
    n.source || (n.declaration ? this.visit(n.declaration) : this.visitChildren(n));
  } }, { key: "ExportDeclaration", value: function(n) {
    this.visitExportDeclaration(n);
  } }, { key: "ExportNamedDeclaration", value: function(n) {
    this.visitExportDeclaration(n);
  } }, { key: "ExportSpecifier", value: function(n) {
    var r = n.id || n.local;
    this.visit(r);
  } }, { key: "MetaProperty", value: function() {
  } }]), t;
}(), gC = "http://github.com/eslint/eslint-scope", yC = { node: ">=8.0.0" }, vC = { url: "https://github.com/eslint/eslint-scope/issues" }, xC = { test: "node Makefile.js test", lint: "node Makefile.js lint", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, bC = ["LICENSE", "README.md", "lib"], EC = { esrecurse: "^4.1.0", estraverse: "^4.1.1" }, CC = { "@typescript-eslint/parser": "^1.11.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", espree: "^6.0.0", istanbul: "^0.4.5", mocha: "^6.1.4", "npm-license": "^0.3.3", shelljs: "^0.8.3", typescript: "^3.5.2" }, n9 = { name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: gC, main: "lib/index.js", version: "5.0.0", engines: yC, repository: "eslint/eslint-scope", bugs: vC, license: "BSD-2-Clause", scripts: xC, files: bC, dependencies: EC, devDependencies: CC }, r9 = Cr(Object.freeze({ __proto__: null, name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: gC, main: "lib/index.js", version: "5.0.0", engines: yC, repository: "eslint/eslint-scope", bugs: vC, license: "BSD-2-Clause", scripts: xC, files: bC, dependencies: EC, devDependencies: CC, default: n9 })), i9 = ki.Scope, a9 = { version: r9.version, Reference: Ri, Variable: jr, Scope: i9, ScopeManager: cx, analyze: function(e, t) {
  var n = function i(a, s) {
    function o(f) {
      return xe(f) === "object" && f instanceof Object && !(f instanceof Array) && !(f instanceof RegExp);
    }
    for (var u in s)
      if (Object.prototype.hasOwnProperty.call(s, u)) {
        var c = s[u];
        o(c) ? o(a[u]) ? i(a[u], c) : a[u] = i({}, c) : a[u] = c;
      }
    return a;
  }({ optimistic: !1, directive: !1, nodejsScope: !1, impliedStrict: !1, sourceType: "script", ecmaVersion: 5, childVisitorKeys: null, fallback: "iteration" }, t), r = new cx(n);
  return new t9(n, r).visit(e), xn(r.__currentScope === null, "currentScope should be null."), r;
} }, SC = ["left", "right"], kC = ["left", "right"], DC = ["elements"], FC = ["elements"], wC = ["params", "body"], AC = ["argument"], _C = ["body"], TC = ["left", "right"], PC = ["label"], IC = ["callee", "arguments"], BC = ["param", "body"], OC = ["body"], LC = ["id", "superClass", "body"], NC = ["id", "superClass", "body"], jC = ["test", "consequent", "alternate"], RC = ["label"], MC = [], VC = ["body", "test"], UC = [], qC = ["source"], WC = ["declaration"], $C = ["declaration", "specifiers", "source"], GC = ["exported", "local"], zC = ["expression"], HC = ["argument"], KC = ["argument"], JC = ["init", "test", "update", "body"], QC = ["left", "right", "body"], XC = ["left", "right", "body"], YC = ["id", "params", "body"], ZC = ["id", "params", "body"], eS = [], tS = ["test", "consequent", "alternate"], nS = ["specifiers", "source"], rS = ["local"], iS = ["source"], aS = ["local"], oS = ["imported", "local"], sS = ["name", "value"], uS = ["name"], cS = ["openingElement", "children", "closingElement"], lS = [], pS = ["expression"], fS = [], hS = ["object", "property"], dS = ["namespace", "name"], mS = ["name", "attributes"], gS = ["argument"], yS = [], vS = ["openingFragment", "children", "closingFragment"], xS = [], bS = ["label", "body"], ES = ["left", "right"], CS = ["object", "property"], SS = ["meta", "property"], kS = ["key", "value"], DS = ["callee", "arguments"], FS = ["properties"], wS = ["properties"], AS = ["body"], _S = ["key", "value"], TS = ["argument"], PS = ["argument"], IS = ["expressions"], BS = ["argument"], OS = [], LS = ["discriminant", "cases"], NS = ["test", "consequent"], jS = ["tag", "quasi"], RS = [], MS = ["quasis", "expressions"], VS = [], US = ["argument"], qS = ["block", "handler", "finalizer"], WS = ["argument"], $S = ["argument"], GS = ["declarations"], zS = ["id", "init"], HS = ["test", "body"], KS = ["object", "body"], JS = ["argument"], o9 = { AssignmentExpression: SC, AssignmentPattern: kC, ArrayExpression: DC, ArrayPattern: FC, ArrowFunctionExpression: wC, AwaitExpression: AC, BlockStatement: _C, BinaryExpression: TC, BreakStatement: PC, CallExpression: IC, CatchClause: BC, ClassBody: OC, ClassDeclaration: LC, ClassExpression: NC, ConditionalExpression: jC, ContinueStatement: RC, DebuggerStatement: MC, DoWhileStatement: VC, EmptyStatement: UC, ExportAllDeclaration: qC, ExportDefaultDeclaration: WC, ExportNamedDeclaration: $C, ExportSpecifier: GC, ExpressionStatement: zC, ExperimentalRestProperty: HC, ExperimentalSpreadProperty: KC, ForStatement: JC, ForInStatement: QC, ForOfStatement: XC, FunctionDeclaration: YC, FunctionExpression: ZC, Identifier: eS, IfStatement: tS, ImportDeclaration: nS, ImportDefaultSpecifier: rS, ImportExpression: iS, ImportNamespaceSpecifier: aS, ImportSpecifier: oS, JSXAttribute: sS, JSXClosingElement: uS, JSXElement: cS, JSXEmptyExpression: lS, JSXExpressionContainer: pS, JSXIdentifier: fS, JSXMemberExpression: hS, JSXNamespacedName: dS, JSXOpeningElement: mS, JSXSpreadAttribute: gS, JSXText: yS, JSXFragment: vS, Literal: xS, LabeledStatement: bS, LogicalExpression: ES, MemberExpression: CS, MetaProperty: SS, MethodDefinition: kS, NewExpression: DS, ObjectExpression: FS, ObjectPattern: wS, Program: AS, Property: _S, RestElement: TS, ReturnStatement: PS, SequenceExpression: IS, SpreadElement: BS, Super: OS, SwitchStatement: LS, SwitchCase: NS, TaggedTemplateExpression: jS, TemplateElement: RS, TemplateLiteral: MS, ThisExpression: VS, ThrowStatement: US, TryStatement: qS, UnaryExpression: WS, UpdateExpression: $S, VariableDeclaration: GS, VariableDeclarator: zS, WhileStatement: HS, WithStatement: KS, YieldExpression: JS }, lc = Cr(Object.freeze({ __proto__: null, AssignmentExpression: SC, AssignmentPattern: kC, ArrayExpression: DC, ArrayPattern: FC, ArrowFunctionExpression: wC, AwaitExpression: AC, BlockStatement: _C, BinaryExpression: TC, BreakStatement: PC, CallExpression: IC, CatchClause: BC, ClassBody: OC, ClassDeclaration: LC, ClassExpression: NC, ConditionalExpression: jC, ContinueStatement: RC, DebuggerStatement: MC, DoWhileStatement: VC, EmptyStatement: UC, ExportAllDeclaration: qC, ExportDefaultDeclaration: WC, ExportNamedDeclaration: $C, ExportSpecifier: GC, ExpressionStatement: zC, ExperimentalRestProperty: HC, ExperimentalSpreadProperty: KC, ForStatement: JC, ForInStatement: QC, ForOfStatement: XC, FunctionDeclaration: YC, FunctionExpression: ZC, Identifier: eS, IfStatement: tS, ImportDeclaration: nS, ImportDefaultSpecifier: rS, ImportExpression: iS, ImportNamespaceSpecifier: aS, ImportSpecifier: oS, JSXAttribute: sS, JSXClosingElement: uS, JSXElement: cS, JSXEmptyExpression: lS, JSXExpressionContainer: pS, JSXIdentifier: fS, JSXMemberExpression: hS, JSXNamespacedName: dS, JSXOpeningElement: mS, JSXSpreadAttribute: gS, JSXText: yS, JSXFragment: vS, Literal: xS, LabeledStatement: bS, LogicalExpression: ES, MemberExpression: CS, MetaProperty: SS, MethodDefinition: kS, NewExpression: DS, ObjectExpression: FS, ObjectPattern: wS, Program: AS, Property: _S, RestElement: TS, ReturnStatement: PS, SequenceExpression: IS, SpreadElement: BS, Super: OS, SwitchStatement: LS, SwitchCase: NS, TaggedTemplateExpression: jS, TemplateElement: RS, TemplateLiteral: MS, ThisExpression: VS, ThrowStatement: US, TryStatement: qS, UnaryExpression: WS, UpdateExpression: $S, VariableDeclaration: GS, VariableDeclarator: zS, WhileStatement: HS, WithStatement: KS, YieldExpression: JS, default: o9 })), s9 = Object.freeze(Object.keys(lc)), gd = !0, px = !1, fx = void 0;
try {
  for (var hx, yd = s9[Symbol.iterator](); !(gd = (hx = yd.next()).done); gd = !0) {
    var u9 = hx.value;
    Object.freeze(lc[u9]);
  }
} catch (e) {
  px = !0, fx = e;
} finally {
  try {
    gd || yd.return == null || yd.return();
  } finally {
    if (px)
      throw fx;
  }
}
Object.freeze(lc);
var c9 = /* @__PURE__ */ new Set(["parent", "leadingComments", "trailingComments"]);
function l9(e) {
  return !c9.has(e) && e[0] !== "_";
}
var pf = Object.freeze({ KEYS: lc, getKeys: function(e) {
  return Object.keys(e).filter(l9);
}, unionWith: function(e) {
  for (var t = Object.assign({}, lc), n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    if (t.hasOwnProperty(i)) {
      var a = new Set(e[i]), s = !0, o = !1, u = void 0;
      try {
        for (var c, f = t[i][Symbol.iterator](); !(s = (c = f.next()).done); s = !0) {
          var p = c.value;
          a.add(p);
        }
      } catch (d) {
        o = !0, u = d;
      } finally {
        try {
          s || f.return == null || f.return();
        } finally {
          if (o)
            throw u;
        }
      }
      t[i] = Object.freeze(Array.from(a));
    } else
      t[i] = Object.freeze(Array.from(e[i]));
  }
  return Object.freeze(t);
} }), vd = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, xd = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", p9 = { 5: xd, "5module": xd + " export import", 6: xd + " const class extends export import super" }, f9 = /^in(stanceof)?$/, U0 = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࢽऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿯ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-Ᶎꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭧꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", QS = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࣓-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ංඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠐-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷹᷻-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿", h9 = new RegExp("[" + U0 + "]"), d9 = new RegExp("[" + U0 + QS + "]");
U0 = QS = null;
var XS = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], m9 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function Im(e, t) {
  for (var n = 65536, r = 0; r < t.length; r += 2) {
    if ((n += t[r]) > e)
      return !1;
    if ((n += t[r + 1]) >= e)
      return !0;
  }
}
function Ea(e, t) {
  return e < 65 ? e === 36 : e < 91 || (e < 97 ? e === 95 : e < 123 || (e <= 65535 ? e >= 170 && h9.test(String.fromCharCode(e)) : t !== !1 && Im(e, XS)));
}
function Mo(e, t) {
  return e < 48 ? e === 36 : e < 58 || !(e < 65) && (e < 91 || (e < 97 ? e === 95 : e < 123 || (e <= 65535 ? e >= 170 && d9.test(String.fromCharCode(e)) : t !== !1 && (Im(e, XS) || Im(e, m9)))));
}
var Ot = function(e, t) {
  t === void 0 && (t = {}), this.label = e, this.keyword = t.keyword, this.beforeExpr = !!t.beforeExpr, this.startsExpr = !!t.startsExpr, this.isLoop = !!t.isLoop, this.isAssign = !!t.isAssign, this.prefix = !!t.prefix, this.postfix = !!t.postfix, this.binop = t.binop || null, this.updateContext = null;
};
function yi(e, t) {
  return new Ot(e, { beforeExpr: !0, binop: t });
}
var Jr = { beforeExpr: !0 }, Pr = { startsExpr: !0 }, ff = {};
function kt(e, t) {
  return t === void 0 && (t = {}), t.keyword = e, ff[e] = new Ot(e, t);
}
var $ = { num: new Ot("num", Pr), regexp: new Ot("regexp", Pr), string: new Ot("string", Pr), name: new Ot("name", Pr), eof: new Ot("eof"), bracketL: new Ot("[", { beforeExpr: !0, startsExpr: !0 }), bracketR: new Ot("]"), braceL: new Ot("{", { beforeExpr: !0, startsExpr: !0 }), braceR: new Ot("}"), parenL: new Ot("(", { beforeExpr: !0, startsExpr: !0 }), parenR: new Ot(")"), comma: new Ot(",", Jr), semi: new Ot(";", Jr), colon: new Ot(":", Jr), dot: new Ot("."), question: new Ot("?", Jr), arrow: new Ot("=>", Jr), template: new Ot("template"), invalidTemplate: new Ot("invalidTemplate"), ellipsis: new Ot("...", Jr), backQuote: new Ot("`", Pr), dollarBraceL: new Ot("${", { beforeExpr: !0, startsExpr: !0 }), eq: new Ot("=", { beforeExpr: !0, isAssign: !0 }), assign: new Ot("_=", { beforeExpr: !0, isAssign: !0 }), incDec: new Ot("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }), prefix: new Ot("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), logicalOR: yi("||", 1), logicalAND: yi("&&", 2), bitwiseOR: yi("|", 3), bitwiseXOR: yi("^", 4), bitwiseAND: yi("&", 5), equality: yi("==/!=/===/!==", 6), relational: yi("</>/<=/>=", 7), bitShift: yi("<</>>/>>>", 8), plusMin: new Ot("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }), modulo: yi("%", 10), star: yi("*", 10), slash: yi("/", 10), starstar: new Ot("**", { beforeExpr: !0 }), _break: kt("break"), _case: kt("case", Jr), _catch: kt("catch"), _continue: kt("continue"), _debugger: kt("debugger"), _default: kt("default", Jr), _do: kt("do", { isLoop: !0, beforeExpr: !0 }), _else: kt("else", Jr), _finally: kt("finally"), _for: kt("for", { isLoop: !0 }), _function: kt("function", Pr), _if: kt("if"), _return: kt("return", Jr), _switch: kt("switch"), _throw: kt("throw", Jr), _try: kt("try"), _var: kt("var"), _const: kt("const"), _while: kt("while", { isLoop: !0 }), _with: kt("with"), _new: kt("new", { beforeExpr: !0, startsExpr: !0 }), _this: kt("this", Pr), _super: kt("super", Pr), _class: kt("class", Pr), _extends: kt("extends", Jr), _export: kt("export"), _import: kt("import", Pr), _null: kt("null", Pr), _true: kt("true", Pr), _false: kt("false", Pr), _in: kt("in", { beforeExpr: !0, binop: 7 }), _instanceof: kt("instanceof", { beforeExpr: !0, binop: 7 }), _typeof: kt("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), _void: kt("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), _delete: kt("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 }) }, ci = /\r\n?|\n|\u2028|\u2029/, qs = new RegExp(ci.source, "g");
function Ws(e, t) {
  return e === 10 || e === 13 || !t && (e === 8232 || e === 8233);
}
var q0 = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Mi = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, YS = Object.prototype, g9 = YS.hasOwnProperty, y9 = YS.toString;
function hf(e, t) {
  return g9.call(e, t);
}
var dx = Array.isArray || function(e) {
  return y9.call(e) === "[object Array]";
};
function Bo(e) {
  return new RegExp("^(?:" + e.replace(/ /g, "|") + ")$");
}
var $s = function(e, t) {
  this.line = e, this.column = t;
};
$s.prototype.offset = function(e) {
  return new $s(this.line, this.column + e);
};
var Sc = function(e, t, n) {
  this.start = t, this.end = n, e.sourceFile !== null && (this.source = e.sourceFile);
};
function W0(e, t) {
  for (var n = 1, r = 0; ; ) {
    qs.lastIndex = r;
    var i = qs.exec(e);
    if (!(i && i.index < t))
      return new $s(n, t - r);
    ++n, r = i.index + i[0].length;
  }
}
var Op = { ecmaVersion: 10, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: !1, allowImportExportEverywhere: !1, allowAwaitOutsideFunction: !1, allowHashBang: !1, locations: !1, onToken: null, onComment: null, ranges: !1, program: null, sourceFile: null, directSourceFile: null, preserveParens: !1 };
function v9(e) {
  var t = {};
  for (var n in Op)
    t[n] = e && hf(e, n) ? e[n] : Op[n];
  if (t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), t.allowReserved == null && (t.allowReserved = t.ecmaVersion < 5), dx(t.onToken)) {
    var r = t.onToken;
    t.onToken = function(i) {
      return r.push(i);
    };
  }
  return dx(t.onComment) && (t.onComment = function(i, a) {
    return function(s, o, u, c, f, p) {
      var d = { type: s ? "Block" : "Line", value: o, start: u, end: c };
      i.locations && (d.loc = new Sc(this, f, p)), i.ranges && (d.range = [u, c]), a.push(d);
    };
  }(t, t.onComment)), t;
}
var pc = 2, bd = 1 | pc, ZS = 4, ek = 8;
function Bm(e, t) {
  return pc | (e ? ZS : 0) | (t ? ek : 0);
}
var pn = function(e, t, n) {
  this.options = e = v9(e), this.sourceFile = e.sourceFile, this.keywords = Bo(p9[e.ecmaVersion >= 6 ? 6 : e.sourceType === "module" ? "5module" : 5]);
  var r = "";
  if (e.allowReserved !== !0) {
    for (var i = e.ecmaVersion; !(r = vd[i]); i--)
      ;
    e.sourceType === "module" && (r += " await");
  }
  this.reservedWords = Bo(r);
  var a = (r ? r + " " : "") + vd.strict;
  this.reservedWordsStrict = Bo(a), this.reservedWordsStrictBind = Bo(a + " " + vd.strictBind), this.input = String(t), this.containsEsc = !1, n ? (this.pos = n, this.lineStart = this.input.lastIndexOf(`
`, n - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(ci).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = $.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = e.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, bo = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 } };
pn.prototype.parse = function() {
  var e = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e);
}, bo.inFunction.get = function() {
  return (this.currentVarScope().flags & pc) > 0;
}, bo.inGenerator.get = function() {
  return (this.currentVarScope().flags & ek) > 0;
}, bo.inAsync.get = function() {
  return (this.currentVarScope().flags & ZS) > 0;
}, bo.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, bo.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, bo.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, pn.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & pc) > 0;
}, pn.extend = function() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  for (var n = this, r = 0; r < e.length; r++)
    n = e[r](n);
  return n;
}, pn.parse = function(e, t) {
  return new this(t, e).parse();
}, pn.parseExpressionAt = function(e, t, n) {
  var r = new this(n, e, t);
  return r.nextToken(), r.parseExpression();
}, pn.tokenizer = function(e, t) {
  return new this(t, e);
}, Object.defineProperties(pn.prototype, bo);
var ar = pn.prototype, x9 = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function Vu() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
ar.strictDirective = function(e) {
  for (; ; ) {
    Mi.lastIndex = e, e += Mi.exec(this.input)[0].length;
    var t = x9.exec(this.input.slice(e));
    if (!t)
      return !1;
    if ((t[1] || t[2]) === "use strict")
      return !0;
    e += t[0].length, Mi.lastIndex = e, e += Mi.exec(this.input)[0].length, this.input[e] === ";" && e++;
  }
}, ar.eat = function(e) {
  return this.type === e && (this.next(), !0);
}, ar.isContextual = function(e) {
  return this.type === $.name && this.value === e && !this.containsEsc;
}, ar.eatContextual = function(e) {
  return !!this.isContextual(e) && (this.next(), !0);
}, ar.expectContextual = function(e) {
  this.eatContextual(e) || this.unexpected();
}, ar.canInsertSemicolon = function() {
  return this.type === $.eof || this.type === $.braceR || ci.test(this.input.slice(this.lastTokEnd, this.start));
}, ar.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
}, ar.semicolon = function() {
  this.eat($.semi) || this.insertSemicolon() || this.unexpected();
}, ar.afterTrailingComma = function(e, t) {
  if (this.type === e)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
}, ar.expect = function(e) {
  this.eat(e) || this.unexpected();
}, ar.unexpected = function(e) {
  this.raise(e ?? this.start, "Unexpected token");
}, ar.checkPatternErrors = function(e, t) {
  if (e) {
    e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, "Comma is not permitted after the rest element");
    var n = t ? e.parenthesizedAssign : e.parenthesizedBind;
    n > -1 && this.raiseRecoverable(n, "Parenthesized pattern");
  }
}, ar.checkExpressionErrors = function(e, t) {
  if (!e)
    return !1;
  var n = e.shorthandAssign, r = e.doubleProto;
  if (!t)
    return n >= 0 || r >= 0;
  n >= 0 && this.raise(n, "Shorthand property assignments are valid only in destructuring patterns"), r >= 0 && this.raiseRecoverable(r, "Redefinition of __proto__ property");
}, ar.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, ar.isSimpleAssignTarget = function(e) {
  return e.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e.expression) : e.type === "Identifier" || e.type === "MemberExpression";
};
var ct = pn.prototype;
ct.parseTopLevel = function(e) {
  var t = {};
  for (e.body || (e.body = []); this.type !== $.eof; ) {
    var n = this.parseStatement(null, !0, t);
    e.body.push(n);
  }
  if (this.inModule)
    for (var r = 0, i = Object.keys(this.undefinedExports); r < i.length; r += 1) {
      var a = i[r];
      this.raiseRecoverable(this.undefinedExports[a].start, "Export '" + a + "' is not defined");
    }
  return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType, this.finishNode(e, "Program");
};
var Om = { kind: "loop" }, b9 = { kind: "switch" };
ct.isLet = function(e) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  Mi.lastIndex = this.pos;
  var t = Mi.exec(this.input), n = this.pos + t[0].length, r = this.input.charCodeAt(n);
  if (r === 91)
    return !0;
  if (e)
    return !1;
  if (r === 123)
    return !0;
  if (Ea(r, !0)) {
    for (var i = n + 1; Mo(this.input.charCodeAt(i), !0); )
      ++i;
    var a = this.input.slice(n, i);
    if (!f9.test(a))
      return !0;
  }
  return !1;
}, ct.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  Mi.lastIndex = this.pos;
  var e = Mi.exec(this.input), t = this.pos + e[0].length;
  return !(ci.test(this.input.slice(this.pos, t)) || this.input.slice(t, t + 8) !== "function" || t + 8 !== this.input.length && Mo(this.input.charAt(t + 8)));
}, ct.parseStatement = function(e, t, n) {
  var r, i = this.type, a = this.startNode();
  switch (this.isLet(e) && (i = $._var, r = "let"), i) {
    case $._break:
    case $._continue:
      return this.parseBreakContinueStatement(a, i.keyword);
    case $._debugger:
      return this.parseDebuggerStatement(a);
    case $._do:
      return this.parseDoStatement(a);
    case $._for:
      return this.parseForStatement(a);
    case $._function:
      return e && (this.strict || e !== "if" && e !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !e);
    case $._class:
      return e && this.unexpected(), this.parseClass(a, !0);
    case $._if:
      return this.parseIfStatement(a);
    case $._return:
      return this.parseReturnStatement(a);
    case $._switch:
      return this.parseSwitchStatement(a);
    case $._throw:
      return this.parseThrowStatement(a);
    case $._try:
      return this.parseTryStatement(a);
    case $._const:
    case $._var:
      return r = r || this.value, e && r !== "var" && this.unexpected(), this.parseVarStatement(a, r);
    case $._while:
      return this.parseWhileStatement(a);
    case $._with:
      return this.parseWithStatement(a);
    case $.braceL:
      return this.parseBlock(!0, a);
    case $.semi:
      return this.parseEmptyStatement(a);
    case $._export:
    case $._import:
      if (this.options.ecmaVersion > 10 && i === $._import) {
        Mi.lastIndex = this.pos;
        var s = Mi.exec(this.input), o = this.pos + s[0].length;
        if (this.input.charCodeAt(o) === 40)
          return this.parseExpressionStatement(a, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === $._import ? this.parseImport(a) : this.parseExport(a, n);
    default:
      if (this.isAsyncFunction())
        return e && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !e);
      var u = this.value, c = this.parseExpression();
      return i === $.name && c.type === "Identifier" && this.eat($.colon) ? this.parseLabeledStatement(a, u, c, e) : this.parseExpressionStatement(a, c);
  }
}, ct.parseBreakContinueStatement = function(e, t) {
  var n = t === "break";
  this.next(), this.eat($.semi) || this.insertSemicolon() ? e.label = null : this.type !== $.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
  for (var r = 0; r < this.labels.length; ++r) {
    var i = this.labels[r];
    if ((e.label == null || i.name === e.label.name) && (i.kind != null && (n || i.kind === "loop") || e.label && n))
      break;
  }
  return r === this.labels.length && this.raise(e.start, "Unsyntactic " + t), this.finishNode(e, n ? "BreakStatement" : "ContinueStatement");
}, ct.parseDebuggerStatement = function(e) {
  return this.next(), this.semicolon(), this.finishNode(e, "DebuggerStatement");
}, ct.parseDoStatement = function(e) {
  return this.next(), this.labels.push(Om), e.body = this.parseStatement("do"), this.labels.pop(), this.expect($._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat($.semi) : this.semicolon(), this.finishNode(e, "DoWhileStatement");
}, ct.parseForStatement = function(e) {
  this.next();
  var t = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Om), this.enterScope(0), this.expect($.parenL), this.type === $.semi)
    return t > -1 && this.unexpected(t), this.parseFor(e, null);
  var n = this.isLet();
  if (this.type === $._var || this.type === $._const || n) {
    var r = this.startNode(), i = n ? "let" : this.value;
    return this.next(), this.parseVar(r, !0, i), this.finishNode(r, "VariableDeclaration"), (this.type === $._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && r.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === $._in ? t > -1 && this.unexpected(t) : e.await = t > -1), this.parseForIn(e, r)) : (t > -1 && this.unexpected(t), this.parseFor(e, r));
  }
  var a = new Vu(), s = this.parseExpression(!0, a);
  return this.type === $._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === $._in ? t > -1 && this.unexpected(t) : e.await = t > -1), this.toAssignable(s, !1, a), this.checkLVal(s), this.parseForIn(e, s)) : (this.checkExpressionErrors(a, !0), t > -1 && this.unexpected(t), this.parseFor(e, s));
}, ct.parseFunctionStatement = function(e, t, n) {
  return this.next(), this.parseFunction(e, Uu | (n ? 0 : Lm), !1, t);
}, ct.parseIfStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement("if"), e.alternate = this.eat($._else) ? this.parseStatement("if") : null, this.finishNode(e, "IfStatement");
}, ct.parseReturnStatement = function(e) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat($.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, "ReturnStatement");
}, ct.parseSwitchStatement = function(e) {
  var t;
  this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect($.braceL), this.labels.push(b9), this.enterScope(0);
  for (var n = !1; this.type !== $.braceR; )
    if (this.type === $._case || this.type === $._default) {
      var r = this.type === $._case;
      t && this.finishNode(t, "SwitchCase"), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), r ? t.test = this.parseExpression() : (n && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n = !0, t.test = null), this.expect($.colon);
    } else
      t || this.unexpected(), t.consequent.push(this.parseStatement(null));
  return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e, "SwitchStatement");
}, ct.parseThrowStatement = function(e) {
  return this.next(), ci.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, "ThrowStatement");
};
var E9 = [];
ct.parseTryStatement = function(e) {
  if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === $._catch) {
    var t = this.startNode();
    if (this.next(), this.eat($.parenL)) {
      t.param = this.parseBindingAtom();
      var n = t.param.type === "Identifier";
      this.enterScope(n ? 32 : 0), this.checkLVal(t.param, n ? 4 : 2), this.expect($.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0);
    t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, "CatchClause");
  }
  return e.finalizer = this.eat($._finally) ? this.parseBlock() : null, e.handler || e.finalizer || this.raise(e.start, "Missing catch or finally clause"), this.finishNode(e, "TryStatement");
}, ct.parseVarStatement = function(e, t) {
  return this.next(), this.parseVar(e, !1, t), this.semicolon(), this.finishNode(e, "VariableDeclaration");
}, ct.parseWhileStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), this.labels.push(Om), e.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e, "WhileStatement");
}, ct.parseWithStatement = function(e) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement("with"), this.finishNode(e, "WithStatement");
}, ct.parseEmptyStatement = function(e) {
  return this.next(), this.finishNode(e, "EmptyStatement");
}, ct.parseLabeledStatement = function(e, t, n, r) {
  for (var i = 0, a = this.labels; i < a.length; i += 1)
    a[i].name === t && this.raise(n.start, "Label '" + t + "' is already declared");
  for (var s = this.type.isLoop ? "loop" : this.type === $._switch ? "switch" : null, o = this.labels.length - 1; o >= 0; o--) {
    var u = this.labels[o];
    if (u.statementStart !== e.start)
      break;
    u.statementStart = this.start, u.kind = s;
  }
  return this.labels.push({ name: t, kind: s, statementStart: this.start }), e.body = this.parseStatement(r ? r.indexOf("label") === -1 ? r + "label" : r : "label"), this.labels.pop(), e.label = n, this.finishNode(e, "LabeledStatement");
}, ct.parseExpressionStatement = function(e, t) {
  return e.expression = t, this.semicolon(), this.finishNode(e, "ExpressionStatement");
}, ct.parseBlock = function(e, t) {
  for (e === void 0 && (e = !0), t === void 0 && (t = this.startNode()), t.body = [], this.expect($.braceL), e && this.enterScope(0); !this.eat($.braceR); ) {
    var n = this.parseStatement(null);
    t.body.push(n);
  }
  return e && this.exitScope(), this.finishNode(t, "BlockStatement");
}, ct.parseFor = function(e, t) {
  return e.init = t, this.expect($.semi), e.test = this.type === $.semi ? null : this.parseExpression(), this.expect($.semi), e.update = this.type === $.parenR ? null : this.parseExpression(), this.expect($.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, "ForStatement");
}, ct.parseForIn = function(e, t) {
  var n = this.type === $._in;
  return this.next(), t.type === "VariableDeclaration" && t.declarations[0].init != null && (!n || this.options.ecmaVersion < 8 || this.strict || t.kind !== "var" || t.declarations[0].id.type !== "Identifier") ? this.raise(t.start, (n ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t.type === "AssignmentPattern" && this.raise(t.start, "Invalid left-hand side in for-loop"), e.left = t, e.right = n ? this.parseExpression() : this.parseMaybeAssign(), this.expect($.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, n ? "ForInStatement" : "ForOfStatement");
}, ct.parseVar = function(e, t, n) {
  for (e.declarations = [], e.kind = n; ; ) {
    var r = this.startNode();
    if (this.parseVarId(r, n), this.eat($.eq) ? r.init = this.parseMaybeAssign(t) : n !== "const" || this.type === $._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? r.id.type === "Identifier" || t && (this.type === $._in || this.isContextual("of")) ? r.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e.declarations.push(this.finishNode(r, "VariableDeclarator")), !this.eat($.comma))
      break;
  }
  return e;
}, ct.parseVarId = function(e, t) {
  e.id = this.parseBindingAtom(), this.checkLVal(e.id, t === "var" ? 1 : 2, !1);
};
var Uu = 1, Lm = 2;
ct.parseFunction = function(e, t, n, r) {
  this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !r) && (this.type === $.star && t & Lm && this.unexpected(), e.generator = this.eat($.star)), this.options.ecmaVersion >= 8 && (e.async = !!r), t & Uu && (e.id = 4 & t && this.type !== $.name ? null : this.parseIdent(), !e.id || t & Lm || this.checkLVal(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i = this.yieldPos, a = this.awaitPos, s = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Bm(e.async, e.generator)), t & Uu || (e.id = this.type === $.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, n, !1), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = s, this.finishNode(e, t & Uu ? "FunctionDeclaration" : "FunctionExpression");
}, ct.parseFunctionParams = function(e) {
  this.expect($.parenL), e.params = this.parseBindingList($.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, ct.parseClass = function(e, t) {
  this.next();
  var n = this.strict;
  this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
  var r = this.startNode(), i = !1;
  for (r.body = [], this.expect($.braceL); !this.eat($.braceR); ) {
    var a = this.parseClassElement(e.superClass !== null);
    a && (r.body.push(a), a.type === "MethodDefinition" && a.kind === "constructor" && (i && this.raise(a.start, "Duplicate constructor in the same class"), i = !0));
  }
  return e.body = this.finishNode(r, "ClassBody"), this.strict = n, this.finishNode(e, t ? "ClassDeclaration" : "ClassExpression");
}, ct.parseClassElement = function(e) {
  var t = this;
  if (this.eat($.semi))
    return null;
  var n = this.startNode(), r = function(u, c) {
    c === void 0 && (c = !1);
    var f = t.start, p = t.startLoc;
    return !!t.eatContextual(u) && (!(t.type === $.parenL || c && t.canInsertSemicolon()) || (n.key && t.unexpected(), n.computed = !1, n.key = t.startNodeAt(f, p), n.key.name = u, t.finishNode(n.key, "Identifier"), !1));
  };
  n.kind = "method", n.static = r("static");
  var i = this.eat($.star), a = !1;
  i || (this.options.ecmaVersion >= 8 && r("async", !0) ? (a = !0, i = this.options.ecmaVersion >= 9 && this.eat($.star)) : r("get") ? n.kind = "get" : r("set") && (n.kind = "set")), n.key || this.parsePropertyName(n);
  var s = n.key, o = !1;
  return n.computed || n.static || !(s.type === "Identifier" && s.name === "constructor" || s.type === "Literal" && s.value === "constructor") ? n.static && s.type === "Identifier" && s.name === "prototype" && this.raise(s.start, "Classes may not have a static property named prototype") : (n.kind !== "method" && this.raise(s.start, "Constructor can't have get/set modifier"), i && this.raise(s.start, "Constructor can't be a generator"), a && this.raise(s.start, "Constructor can't be an async method"), n.kind = "constructor", o = e), this.parseClassMethod(n, i, a, o), n.kind === "get" && n.value.params.length !== 0 && this.raiseRecoverable(n.value.start, "getter should have no params"), n.kind === "set" && n.value.params.length !== 1 && this.raiseRecoverable(n.value.start, "setter should have exactly one param"), n.kind === "set" && n.value.params[0].type === "RestElement" && this.raiseRecoverable(n.value.params[0].start, "Setter cannot use rest params"), n;
}, ct.parseClassMethod = function(e, t, n, r) {
  return e.value = this.parseMethod(t, n, r), this.finishNode(e, "MethodDefinition");
}, ct.parseClassId = function(e, t) {
  this.type === $.name ? (e.id = this.parseIdent(), t && this.checkLVal(e.id, 2, !1)) : (t === !0 && this.unexpected(), e.id = null);
}, ct.parseClassSuper = function(e) {
  e.superClass = this.eat($._extends) ? this.parseExprSubscripts() : null;
}, ct.parseExport = function(e, t) {
  if (this.next(), this.eat($.star))
    return this.expectContextual("from"), this.type !== $.string && this.unexpected(), e.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e, "ExportAllDeclaration");
  if (this.eat($._default)) {
    var n;
    if (this.checkExport(t, "default", this.lastTokStart), this.type === $._function || (n = this.isAsyncFunction())) {
      var r = this.startNode();
      this.next(), n && this.next(), e.declaration = this.parseFunction(r, 4 | Uu, !1, n);
    } else if (this.type === $._class) {
      var i = this.startNode();
      e.declaration = this.parseClass(i, "nullableID");
    } else
      e.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e.declaration = this.parseStatement(null), e.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id.name, e.declaration.id.start), e.specifiers = [], e.source = null;
  else {
    if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from"))
      this.type !== $.string && this.unexpected(), e.source = this.parseExprAtom();
    else {
      for (var a = 0, s = e.specifiers; a < s.length; a += 1) {
        var o = s[a];
        this.checkUnreserved(o.local), this.checkLocalExport(o.local);
      }
      e.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e, "ExportNamedDeclaration");
}, ct.checkExport = function(e, t, n) {
  e && (hf(e, t) && this.raiseRecoverable(n, "Duplicate export '" + t + "'"), e[t] = !0);
}, ct.checkPatternExport = function(e, t) {
  var n = t.type;
  if (n === "Identifier")
    this.checkExport(e, t.name, t.start);
  else if (n === "ObjectPattern")
    for (var r = 0, i = t.properties; r < i.length; r += 1) {
      var a = i[r];
      this.checkPatternExport(e, a);
    }
  else if (n === "ArrayPattern")
    for (var s = 0, o = t.elements; s < o.length; s += 1) {
      var u = o[s];
      u && this.checkPatternExport(e, u);
    }
  else
    n === "Property" ? this.checkPatternExport(e, t.value) : n === "AssignmentPattern" ? this.checkPatternExport(e, t.left) : n === "RestElement" ? this.checkPatternExport(e, t.argument) : n === "ParenthesizedExpression" && this.checkPatternExport(e, t.expression);
}, ct.checkVariableExport = function(e, t) {
  if (e)
    for (var n = 0, r = t; n < r.length; n += 1) {
      var i = r[n];
      this.checkPatternExport(e, i.id);
    }
}, ct.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, ct.parseExportSpecifiers = function(e) {
  var t = [], n = !0;
  for (this.expect($.braceL); !this.eat($.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect($.comma), this.afterTrailingComma($.braceR))
      break;
    var r = this.startNode();
    r.local = this.parseIdent(!0), r.exported = this.eatContextual("as") ? this.parseIdent(!0) : r.local, this.checkExport(e, r.exported.name, r.exported.start), t.push(this.finishNode(r, "ExportSpecifier"));
  }
  return t;
}, ct.parseImport = function(e) {
  return this.next(), this.type === $.string ? (e.specifiers = E9, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e.source = this.type === $.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e, "ImportDeclaration");
}, ct.parseImportSpecifiers = function() {
  var e = [], t = !0;
  if (this.type === $.name) {
    var n = this.startNode();
    if (n.local = this.parseIdent(), this.checkLVal(n.local, 2), e.push(this.finishNode(n, "ImportDefaultSpecifier")), !this.eat($.comma))
      return e;
  }
  if (this.type === $.star) {
    var r = this.startNode();
    return this.next(), this.expectContextual("as"), r.local = this.parseIdent(), this.checkLVal(r.local, 2), e.push(this.finishNode(r, "ImportNamespaceSpecifier")), e;
  }
  for (this.expect($.braceL); !this.eat($.braceR); ) {
    if (t)
      t = !1;
    else if (this.expect($.comma), this.afterTrailingComma($.braceR))
      break;
    var i = this.startNode();
    i.imported = this.parseIdent(!0), this.eatContextual("as") ? i.local = this.parseIdent() : (this.checkUnreserved(i.imported), i.local = i.imported), this.checkLVal(i.local, 2), e.push(this.finishNode(i, "ImportSpecifier"));
  }
  return e;
}, ct.adaptDirectivePrologue = function(e) {
  for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
    e[t].directive = e[t].expression.raw.slice(1, -1);
}, ct.isDirectiveCandidate = function(e) {
  return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && (this.input[e.start] === '"' || this.input[e.start] === "'");
};
var ua = pn.prototype;
ua.toAssignable = function(e, t, n) {
  if (this.options.ecmaVersion >= 6 && e)
    switch (e.type) {
      case "Identifier":
        this.inAsync && e.name === "await" && this.raise(e.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e.type = "ObjectPattern", n && this.checkPatternErrors(n, !0);
        for (var r = 0, i = e.properties; r < i.length; r += 1) {
          var a = i[r];
          this.toAssignable(a, t), a.type !== "RestElement" || a.argument.type !== "ArrayPattern" && a.argument.type !== "ObjectPattern" || this.raise(a.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e.kind !== "init" && this.raise(e.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e.value, t);
        break;
      case "ArrayExpression":
        e.type = "ArrayPattern", n && this.checkPatternErrors(n, !0), this.toAssignableList(e.elements, t);
        break;
      case "SpreadElement":
        e.type = "RestElement", this.toAssignable(e.argument, t), e.argument.type === "AssignmentPattern" && this.raise(e.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e.operator !== "=" && this.raise(e.left.end, "Only '=' operator can be used for specifying default value."), e.type = "AssignmentPattern", delete e.operator, this.toAssignable(e.left, t);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e.expression, t, n);
        break;
      case "MemberExpression":
        if (!t)
          break;
      default:
        this.raise(e.start, "Assigning to rvalue");
    }
  else
    n && this.checkPatternErrors(n, !0);
  return e;
}, ua.toAssignableList = function(e, t) {
  for (var n = e.length, r = 0; r < n; r++) {
    var i = e[r];
    i && this.toAssignable(i, t);
  }
  if (n) {
    var a = e[n - 1];
    this.options.ecmaVersion === 6 && t && a && a.type === "RestElement" && a.argument.type !== "Identifier" && this.unexpected(a.argument.start);
  }
  return e;
}, ua.parseSpread = function(e) {
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, "SpreadElement");
}, ua.parseRestBinding = function() {
  var e = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== $.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, "RestElement");
}, ua.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case $.bracketL:
        var e = this.startNode();
        return this.next(), e.elements = this.parseBindingList($.bracketR, !0, !0), this.finishNode(e, "ArrayPattern");
      case $.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
}, ua.parseBindingList = function(e, t, n) {
  for (var r = [], i = !0; !this.eat(e); )
    if (i ? i = !1 : this.expect($.comma), t && this.type === $.comma)
      r.push(null);
    else {
      if (n && this.afterTrailingComma(e))
        break;
      if (this.type === $.ellipsis) {
        var a = this.parseRestBinding();
        this.parseBindingListItem(a), r.push(a), this.type === $.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e);
        break;
      }
      var s = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(s), r.push(s);
    }
  return r;
}, ua.parseBindingListItem = function(e) {
  return e;
}, ua.parseMaybeDefault = function(e, t, n) {
  if (n = n || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat($.eq))
    return n;
  var r = this.startNodeAt(e, t);
  return r.left = n, r.right = this.parseMaybeAssign(), this.finishNode(r, "AssignmentPattern");
}, ua.checkLVal = function(e, t, n) {
  switch (t === void 0 && (t = 0), e.type) {
    case "Identifier":
      t === 2 && e.name === "let" && this.raiseRecoverable(e.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (t ? "Binding " : "Assigning to ") + e.name + " in strict mode"), n && (hf(n, e.name) && this.raiseRecoverable(e.start, "Argument name clash"), n[e.name] = !0), t !== 0 && t !== 5 && this.declareName(e.name, t, e.start);
      break;
    case "MemberExpression":
      t && this.raiseRecoverable(e.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var r = 0, i = e.properties; r < i.length; r += 1) {
        var a = i[r];
        this.checkLVal(a, t, n);
      }
      break;
    case "Property":
      this.checkLVal(e.value, t, n);
      break;
    case "ArrayPattern":
      for (var s = 0, o = e.elements; s < o.length; s += 1) {
        var u = o[s];
        u && this.checkLVal(u, t, n);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e.left, t, n);
      break;
    case "RestElement":
      this.checkLVal(e.argument, t, n);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e.expression, t, n);
      break;
    default:
      this.raise(e.start, (t ? "Binding" : "Assigning to") + " rvalue");
  }
};
var xt = pn.prototype;
xt.checkPropClash = function(e, t, n) {
  if (!(this.options.ecmaVersion >= 9 && e.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
    var r, i = e.key;
    switch (i.type) {
      case "Identifier":
        r = i.name;
        break;
      case "Literal":
        r = String(i.value);
        break;
      default:
        return;
    }
    var a = e.kind;
    if (this.options.ecmaVersion >= 6)
      r === "__proto__" && a === "init" && (t.proto && (n && n.doubleProto < 0 ? n.doubleProto = i.start : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t.proto = !0);
    else {
      var s = t[r = "$" + r];
      s ? (a === "init" ? this.strict && s.init || s.get || s.set : s.init || s[a]) && this.raiseRecoverable(i.start, "Redefinition of property") : s = t[r] = { init: !1, get: !1, set: !1 }, s[a] = !0;
    }
  }
}, xt.parseExpression = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseMaybeAssign(e, t);
  if (this.type === $.comma) {
    var a = this.startNodeAt(n, r);
    for (a.expressions = [i]; this.eat($.comma); )
      a.expressions.push(this.parseMaybeAssign(e, t));
    return this.finishNode(a, "SequenceExpression");
  }
  return i;
}, xt.parseMaybeAssign = function(e, t, n) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e);
    this.exprAllowed = !1;
  }
  var r = !1, i = -1, a = -1, s = -1;
  t ? (i = t.parenthesizedAssign, a = t.trailingComma, s = t.shorthandAssign, t.parenthesizedAssign = t.trailingComma = t.shorthandAssign = -1) : (t = new Vu(), r = !0);
  var o = this.start, u = this.startLoc;
  this.type !== $.parenL && this.type !== $.name || (this.potentialArrowAt = this.start);
  var c = this.parseMaybeConditional(e, t);
  if (n && (c = n.call(this, c, o, u)), this.type.isAssign) {
    var f = this.startNodeAt(o, u);
    return f.operator = this.value, f.left = this.type === $.eq ? this.toAssignable(c, !1, t) : c, r || Vu.call(t), t.shorthandAssign = -1, this.checkLVal(c), this.next(), f.right = this.parseMaybeAssign(e), this.finishNode(f, "AssignmentExpression");
  }
  return r && this.checkExpressionErrors(t, !0), i > -1 && (t.parenthesizedAssign = i), a > -1 && (t.trailingComma = a), s > -1 && (t.shorthandAssign = s), c;
}, xt.parseMaybeConditional = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseExprOps(e, t);
  if (this.checkExpressionErrors(t))
    return i;
  if (this.eat($.question)) {
    var a = this.startNodeAt(n, r);
    return a.test = i, a.consequent = this.parseMaybeAssign(), this.expect($.colon), a.alternate = this.parseMaybeAssign(e), this.finishNode(a, "ConditionalExpression");
  }
  return i;
}, xt.parseExprOps = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseMaybeUnary(t, !1);
  return this.checkExpressionErrors(t) || i.start === n && i.type === "ArrowFunctionExpression" ? i : this.parseExprOp(i, n, r, -1, e);
}, xt.parseExprOp = function(e, t, n, r, i) {
  var a = this.type.binop;
  if (a != null && (!i || this.type !== $._in) && a > r) {
    var s = this.type === $.logicalOR || this.type === $.logicalAND, o = this.value;
    this.next();
    var u = this.start, c = this.startLoc, f = this.parseExprOp(this.parseMaybeUnary(null, !1), u, c, a, i), p = this.buildBinary(t, n, e, f, o, s);
    return this.parseExprOp(p, t, n, r, i);
  }
  return e;
}, xt.buildBinary = function(e, t, n, r, i, a) {
  var s = this.startNodeAt(e, t);
  return s.left = n, s.operator = i, s.right = r, this.finishNode(s, a ? "LogicalExpression" : "BinaryExpression");
}, xt.parseMaybeUnary = function(e, t) {
  var n, r = this.start, i = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    n = this.parseAwait(), t = !0;
  else if (this.type.prefix) {
    var a = this.startNode(), s = this.type === $.incDec;
    a.operator = this.value, a.prefix = !0, this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(e, !0), s ? this.checkLVal(a.argument) : this.strict && a.operator === "delete" && a.argument.type === "Identifier" ? this.raiseRecoverable(a.start, "Deleting local variable in strict mode") : t = !0, n = this.finishNode(a, s ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (n = this.parseExprSubscripts(e), this.checkExpressionErrors(e))
      return n;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var o = this.startNodeAt(r, i);
      o.operator = this.value, o.prefix = !1, o.argument = n, this.checkLVal(n), this.next(), n = this.finishNode(o, "UpdateExpression");
    }
  }
  return !t && this.eat($.starstar) ? this.buildBinary(r, i, n, this.parseMaybeUnary(null, !1), "**", !1) : n;
}, xt.parseExprSubscripts = function(e) {
  var t = this.start, n = this.startLoc, r = this.parseExprAtom(e), i = r.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e) || i)
    return r;
  var a = this.parseSubscripts(r, t, n);
  return e && a.type === "MemberExpression" && (e.parenthesizedAssign >= a.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= a.start && (e.parenthesizedBind = -1)), a;
}, xt.parseSubscripts = function(e, t, n, r) {
  for (var i = this.options.ecmaVersion >= 8 && e.type === "Identifier" && e.name === "async" && this.lastTokEnd === e.end && !this.canInsertSemicolon() && this.input.slice(e.start, e.end) === "async"; ; ) {
    var a = this.parseSubscript(e, t, n, r, i);
    if (a === e || a.type === "ArrowFunctionExpression")
      return a;
    e = a;
  }
}, xt.parseSubscript = function(e, t, n, r, i) {
  var a = this.eat($.bracketL);
  if (a || this.eat($.dot)) {
    var s = this.startNodeAt(t, n);
    s.object = e, s.property = a ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), s.computed = !!a, a && this.expect($.bracketR), e = this.finishNode(s, "MemberExpression");
  } else if (!r && this.eat($.parenL)) {
    var o = new Vu(), u = this.yieldPos, c = this.awaitPos, f = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p = this.parseExprList($.parenR, this.options.ecmaVersion >= 8, !1, o);
    if (i && !this.canInsertSemicolon() && this.eat($.arrow))
      return this.checkPatternErrors(o, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u, this.awaitPos = c, this.awaitIdentPos = f, this.parseArrowExpression(this.startNodeAt(t, n), p, !0);
    this.checkExpressionErrors(o, !0), this.yieldPos = u || this.yieldPos, this.awaitPos = c || this.awaitPos, this.awaitIdentPos = f || this.awaitIdentPos;
    var d = this.startNodeAt(t, n);
    d.callee = e, d.arguments = p, e = this.finishNode(d, "CallExpression");
  } else if (this.type === $.backQuote) {
    var m = this.startNodeAt(t, n);
    m.tag = e, m.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(m, "TaggedTemplateExpression");
  }
  return e;
}, xt.parseExprAtom = function(e) {
  this.type === $.slash && this.readRegexp();
  var t, n = this.potentialArrowAt === this.start;
  switch (this.type) {
    case $._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t = this.startNode(), this.next(), this.type !== $.parenL || this.allowDirectSuper || this.raise(t.start, "super() call outside constructor of a subclass"), this.type !== $.dot && this.type !== $.bracketL && this.type !== $.parenL && this.unexpected(), this.finishNode(t, "Super");
    case $._this:
      return t = this.startNode(), this.next(), this.finishNode(t, "ThisExpression");
    case $.name:
      var r = this.start, i = this.startLoc, a = this.containsEsc, s = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !a && s.name === "async" && !this.canInsertSemicolon() && this.eat($._function))
        return this.parseFunction(this.startNodeAt(r, i), 0, !1, !0);
      if (n && !this.canInsertSemicolon()) {
        if (this.eat($.arrow))
          return this.parseArrowExpression(this.startNodeAt(r, i), [s], !1);
        if (this.options.ecmaVersion >= 8 && s.name === "async" && this.type === $.name && !a)
          return s = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat($.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(r, i), [s], !0);
      }
      return s;
    case $.regexp:
      var o = this.value;
      return (t = this.parseLiteral(o.value)).regex = { pattern: o.pattern, flags: o.flags }, t;
    case $.num:
    case $.string:
      return this.parseLiteral(this.value);
    case $._null:
    case $._true:
    case $._false:
      return (t = this.startNode()).value = this.type === $._null ? null : this.type === $._true, t.raw = this.type.keyword, this.next(), this.finishNode(t, "Literal");
    case $.parenL:
      var u = this.start, c = this.parseParenAndDistinguishExpression(n);
      return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c) && (e.parenthesizedAssign = u), e.parenthesizedBind < 0 && (e.parenthesizedBind = u)), c;
    case $.bracketL:
      return t = this.startNode(), this.next(), t.elements = this.parseExprList($.bracketR, !0, !0, e), this.finishNode(t, "ArrayExpression");
    case $.braceL:
      return this.parseObj(!1, e);
    case $._function:
      return t = this.startNode(), this.next(), this.parseFunction(t, 0);
    case $._class:
      return this.parseClass(this.startNode(), !1);
    case $._new:
      return this.parseNew();
    case $.backQuote:
      return this.parseTemplate();
    case $._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, xt.parseExprImport = function() {
  var e = this.startNode();
  switch (this.next(), this.type) {
    case $.parenL:
      return this.parseDynamicImport(e);
    default:
      this.unexpected();
  }
}, xt.parseDynamicImport = function(e) {
  if (this.next(), e.source = this.parseMaybeAssign(), !this.eat($.parenR)) {
    var t = this.start;
    this.eat($.comma) && this.eat($.parenR) ? this.raiseRecoverable(t, "Trailing comma is not allowed in import()") : this.unexpected(t);
  }
  return this.finishNode(e, "ImportExpression");
}, xt.parseLiteral = function(e) {
  var t = this.startNode();
  return t.value = e, t.raw = this.input.slice(this.start, this.end), t.raw.charCodeAt(t.raw.length - 1) === 110 && (t.bigint = t.raw.slice(0, -1)), this.next(), this.finishNode(t, "Literal");
}, xt.parseParenExpression = function() {
  this.expect($.parenL);
  var e = this.parseExpression();
  return this.expect($.parenR), e;
}, xt.parseParenAndDistinguishExpression = function(e) {
  var t, n = this.start, r = this.startLoc, i = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a, s = this.start, o = this.startLoc, u = [], c = !0, f = !1, p = new Vu(), d = this.yieldPos, m = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== $.parenR; ) {
      if (c ? c = !1 : this.expect($.comma), i && this.afterTrailingComma($.parenR, !0)) {
        f = !0;
        break;
      }
      if (this.type === $.ellipsis) {
        a = this.start, u.push(this.parseParenItem(this.parseRestBinding())), this.type === $.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u.push(this.parseMaybeAssign(!1, p, this.parseParenItem));
    }
    var y = this.start, v = this.startLoc;
    if (this.expect($.parenR), e && !this.canInsertSemicolon() && this.eat($.arrow))
      return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d, this.awaitPos = m, this.parseParenArrowList(n, r, u);
    u.length && !f || this.unexpected(this.lastTokStart), a && this.unexpected(a), this.checkExpressionErrors(p, !0), this.yieldPos = d || this.yieldPos, this.awaitPos = m || this.awaitPos, u.length > 1 ? ((t = this.startNodeAt(s, o)).expressions = u, this.finishNodeAt(t, "SequenceExpression", y, v)) : t = u[0];
  } else
    t = this.parseParenExpression();
  if (this.options.preserveParens) {
    var b = this.startNodeAt(n, r);
    return b.expression = t, this.finishNode(b, "ParenthesizedExpression");
  }
  return t;
}, xt.parseParenItem = function(e) {
  return e;
}, xt.parseParenArrowList = function(e, t, n) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n);
};
var C9 = [];
xt.parseNew = function() {
  var e = this.startNode(), t = this.parseIdent(!0);
  if (this.options.ecmaVersion >= 6 && this.eat($.dot)) {
    e.meta = t;
    var n = this.containsEsc;
    return e.property = this.parseIdent(!0), (e.property.name !== "target" || n) && this.raiseRecoverable(e.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e.start, "new.target can only be used in functions"), this.finishNode(e, "MetaProperty");
  }
  var r = this.start, i = this.startLoc, a = this.type === $._import;
  return e.callee = this.parseSubscripts(this.parseExprAtom(), r, i, !0), a && e.callee.type === "ImportExpression" && this.raise(r, "Cannot use new with import()"), this.eat($.parenL) ? e.arguments = this.parseExprList($.parenR, this.options.ecmaVersion >= 8, !1) : e.arguments = C9, this.finishNode(e, "NewExpression");
}, xt.parseTemplateElement = function(e) {
  var t = e.isTagged, n = this.startNode();
  return this.type === $.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n.value = { raw: this.value, cooked: null }) : n.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`), cooked: this.value }, this.next(), n.tail = this.type === $.backQuote, this.finishNode(n, "TemplateElement");
}, xt.parseTemplate = function(e) {
  e === void 0 && (e = {});
  var t = e.isTagged;
  t === void 0 && (t = !1);
  var n = this.startNode();
  this.next(), n.expressions = [];
  var r = this.parseTemplateElement({ isTagged: t });
  for (n.quasis = [r]; !r.tail; )
    this.type === $.eof && this.raise(this.pos, "Unterminated template literal"), this.expect($.dollarBraceL), n.expressions.push(this.parseExpression()), this.expect($.braceR), n.quasis.push(r = this.parseTemplateElement({ isTagged: t }));
  return this.next(), this.finishNode(n, "TemplateLiteral");
}, xt.isAsyncProp = function(e) {
  return !e.computed && e.key.type === "Identifier" && e.key.name === "async" && (this.type === $.name || this.type === $.num || this.type === $.string || this.type === $.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === $.star) && !ci.test(this.input.slice(this.lastTokEnd, this.start));
}, xt.parseObj = function(e, t) {
  var n = this.startNode(), r = !0, i = {};
  for (n.properties = [], this.next(); !this.eat($.braceR); ) {
    if (r)
      r = !1;
    else if (this.expect($.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma($.braceR))
      break;
    var a = this.parseProperty(e, t);
    e || this.checkPropClash(a, i, t), n.properties.push(a);
  }
  return this.finishNode(n, e ? "ObjectPattern" : "ObjectExpression");
}, xt.parseProperty = function(e, t) {
  var n, r, i, a, s = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat($.ellipsis))
    return e ? (s.argument = this.parseIdent(!1), this.type === $.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(s, "RestElement")) : (this.type === $.parenL && t && (t.parenthesizedAssign < 0 && (t.parenthesizedAssign = this.start), t.parenthesizedBind < 0 && (t.parenthesizedBind = this.start)), s.argument = this.parseMaybeAssign(!1, t), this.type === $.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(s, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (s.method = !1, s.shorthand = !1, (e || t) && (i = this.start, a = this.startLoc), e || (n = this.eat($.star)));
  var o = this.containsEsc;
  return this.parsePropertyName(s), !e && !o && this.options.ecmaVersion >= 8 && !n && this.isAsyncProp(s) ? (r = !0, n = this.options.ecmaVersion >= 9 && this.eat($.star), this.parsePropertyName(s, t)) : r = !1, this.parsePropertyValue(s, e, n, r, i, a, t, o), this.finishNode(s, "Property");
}, xt.parsePropertyValue = function(e, t, n, r, i, a, s, o) {
  if ((n || r) && this.type === $.colon && this.unexpected(), this.eat($.colon))
    e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, s), e.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === $.parenL)
    t && this.unexpected(), e.kind = "init", e.method = !0, e.value = this.parseMethod(n, r);
  else if (t || o || !(this.options.ecmaVersion >= 5) || e.computed || e.key.type !== "Identifier" || e.key.name !== "get" && e.key.name !== "set" || this.type === $.comma || this.type === $.braceR)
    this.options.ecmaVersion >= 6 && !e.computed && e.key.type === "Identifier" ? ((n || r) && this.unexpected(), this.checkUnreserved(e.key), e.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i), e.kind = "init", t ? e.value = this.parseMaybeDefault(i, a, e.key) : this.type === $.eq && s ? (s.shorthandAssign < 0 && (s.shorthandAssign = this.start), e.value = this.parseMaybeDefault(i, a, e.key)) : e.value = e.key, e.shorthand = !0) : this.unexpected();
  else {
    (n || r) && this.unexpected(), e.kind = e.key.name, this.parsePropertyName(e), e.value = this.parseMethod(!1);
    var u = e.kind === "get" ? 0 : 1;
    if (e.value.params.length !== u) {
      var c = e.value.start;
      e.kind === "get" ? this.raiseRecoverable(c, "getter should have no params") : this.raiseRecoverable(c, "setter should have exactly one param");
    } else
      e.kind === "set" && e.value.params[0].type === "RestElement" && this.raiseRecoverable(e.value.params[0].start, "Setter cannot use rest params");
  }
}, xt.parsePropertyName = function(e) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat($.bracketL))
      return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect($.bracketR), e.key;
    e.computed = !1;
  }
  return e.key = this.type === $.num || this.type === $.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, xt.initFunction = function(e) {
  e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
}, xt.parseMethod = function(e, t, n) {
  var r = this.startNode(), i = this.yieldPos, a = this.awaitPos, s = this.awaitIdentPos;
  return this.initFunction(r), this.options.ecmaVersion >= 6 && (r.generator = e), this.options.ecmaVersion >= 8 && (r.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | Bm(t, r.generator) | (n ? 128 : 0)), this.expect($.parenL), r.params = this.parseBindingList($.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(r, !1, !0), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = s, this.finishNode(r, "FunctionExpression");
}, xt.parseArrowExpression = function(e, t, n) {
  var r = this.yieldPos, i = this.awaitPos, a = this.awaitIdentPos;
  return this.enterScope(16 | Bm(n, !1)), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!n), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1), this.yieldPos = r, this.awaitPos = i, this.awaitIdentPos = a, this.finishNode(e, "ArrowFunctionExpression");
}, xt.parseFunctionBody = function(e, t, n) {
  var r = t && this.type !== $.braceL, i = this.strict, a = !1;
  if (r)
    e.body = this.parseMaybeAssign(), e.expression = !0, this.checkParams(e, !1);
  else {
    var s = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
    i && !s || (a = this.strictDirective(this.end)) && s && this.raiseRecoverable(e.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var o = this.labels;
    this.labels = [], a && (this.strict = !0), this.checkParams(e, !i && !a && !t && !n && this.isSimpleParamList(e.params)), e.body = this.parseBlock(!1), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = o;
  }
  this.exitScope(), this.strict && e.id && this.checkLVal(e.id, 5), this.strict = i;
}, xt.isSimpleParamList = function(e) {
  for (var t = 0, n = e; t < n.length; t += 1)
    if (n[t].type !== "Identifier")
      return !1;
  return !0;
}, xt.checkParams = function(e, t) {
  for (var n = {}, r = 0, i = e.params; r < i.length; r += 1) {
    var a = i[r];
    this.checkLVal(a, 1, t ? null : n);
  }
}, xt.parseExprList = function(e, t, n, r) {
  for (var i = [], a = !0; !this.eat(e); ) {
    if (a)
      a = !1;
    else if (this.expect($.comma), t && this.afterTrailingComma(e))
      break;
    var s = void 0;
    n && this.type === $.comma ? s = null : this.type === $.ellipsis ? (s = this.parseSpread(r), r && this.type === $.comma && r.trailingComma < 0 && (r.trailingComma = this.start)) : s = this.parseMaybeAssign(!1, r), i.push(s);
  }
  return i;
}, xt.checkUnreserved = function(e) {
  var t = e.start, n = e.end, r = e.name;
  this.inGenerator && r === "yield" && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && r === "await" && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(r) && this.raise(t, "Unexpected keyword '" + r + "'"), this.options.ecmaVersion < 6 && this.input.slice(t, n).indexOf("\\") !== -1 || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(r) && (this.inAsync || r !== "await" || this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + r + "' is reserved"));
}, xt.parseIdent = function(e, t) {
  var n = this.startNode();
  return this.type === $.name ? n.name = this.value : this.type.keyword ? (n.name = this.type.keyword, n.name !== "class" && n.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(n, "Identifier"), e || (this.checkUnreserved(n), n.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = n.start)), n;
}, xt.parseYield = function(e) {
  this.yieldPos || (this.yieldPos = this.start);
  var t = this.startNode();
  return this.next(), this.type === $.semi || this.canInsertSemicolon() || this.type !== $.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat($.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, "YieldExpression");
}, xt.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e = this.startNode();
  return this.next(), e.argument = this.parseMaybeUnary(null, !0), this.finishNode(e, "AwaitExpression");
};
var Il = pn.prototype;
Il.raise = function(e, t) {
  var n = W0(this.input, e);
  t += " (" + n.line + ":" + n.column + ")";
  var r = new SyntaxError(t);
  throw r.pos = e, r.loc = n, r.raisedAt = this.pos, r;
}, Il.raiseRecoverable = Il.raise, Il.curPosition = function() {
  if (this.options.locations)
    return new $s(this.curLine, this.pos - this.lineStart);
};
var qa = pn.prototype, S9 = function(e) {
  this.flags = e, this.var = [], this.lexical = [], this.functions = [];
};
qa.enterScope = function(e) {
  this.scopeStack.push(new S9(e));
}, qa.exitScope = function() {
  this.scopeStack.pop();
}, qa.treatFunctionsAsVarInScope = function(e) {
  return e.flags & pc || !this.inModule && 1 & e.flags;
}, qa.declareName = function(e, t, n) {
  var r = !1;
  if (t === 2) {
    var i = this.currentScope();
    r = i.lexical.indexOf(e) > -1 || i.functions.indexOf(e) > -1 || i.var.indexOf(e) > -1, i.lexical.push(e), this.inModule && 1 & i.flags && delete this.undefinedExports[e];
  } else if (t === 4)
    this.currentScope().lexical.push(e);
  else if (t === 3) {
    var a = this.currentScope();
    r = this.treatFunctionsAsVar ? a.lexical.indexOf(e) > -1 : a.lexical.indexOf(e) > -1 || a.var.indexOf(e) > -1, a.functions.push(e);
  } else
    for (var s = this.scopeStack.length - 1; s >= 0; --s) {
      var o = this.scopeStack[s];
      if (o.lexical.indexOf(e) > -1 && !(32 & o.flags && o.lexical[0] === e) || !this.treatFunctionsAsVarInScope(o) && o.functions.indexOf(e) > -1) {
        r = !0;
        break;
      }
      if (o.var.push(e), this.inModule && 1 & o.flags && delete this.undefinedExports[e], o.flags & bd)
        break;
    }
  r && this.raiseRecoverable(n, "Identifier '" + e + "' has already been declared");
}, qa.checkLocalExport = function(e) {
  this.scopeStack[0].lexical.indexOf(e.name) === -1 && this.scopeStack[0].var.indexOf(e.name) === -1 && (this.undefinedExports[e.name] = e);
}, qa.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, qa.currentVarScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & bd)
      return t;
  }
}, qa.currentThisScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & bd && !(16 & t.flags))
      return t;
  }
};
var Lp = function(e, t, n) {
  this.type = "", this.start = t, this.end = 0, e.options.locations && (this.loc = new Sc(e, n)), e.options.directSourceFile && (this.sourceFile = e.options.directSourceFile), e.options.ranges && (this.range = [t, 0]);
}, Bl = pn.prototype;
function mx(e, t, n, r) {
  return e.type = t, e.end = n, this.options.locations && (e.loc.end = r), this.options.ranges && (e.range[1] = n), e;
}
Bl.startNode = function() {
  return new Lp(this, this.start, this.startLoc);
}, Bl.startNodeAt = function(e, t) {
  return new Lp(this, e, t);
}, Bl.finishNode = function(e, t) {
  return mx.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
}, Bl.finishNodeAt = function(e, t, n, r) {
  return mx.call(this, e, t, n, r);
};
var Zr = function(e, t, n, r, i) {
  this.token = e, this.isExpr = !!t, this.preserveSpace = !!n, this.override = r, this.generator = !!i;
}, gn = { b_stat: new Zr("{", !1), b_expr: new Zr("{", !0), b_tmpl: new Zr("${", !1), p_stat: new Zr("(", !1), p_expr: new Zr("(", !0), q_tmpl: new Zr("`", !0, !0, function(e) {
  return e.tryReadTemplateToken();
}), f_stat: new Zr("function", !1), f_expr: new Zr("function", !0), f_expr_gen: new Zr("function", !0, !1, null, !0), f_gen: new Zr("function", !1, !1, null, !0) }, Ol = pn.prototype;
Ol.initialContext = function() {
  return [gn.b_stat];
}, Ol.braceIsBlock = function(e) {
  var t = this.curContext();
  return t === gn.f_expr || t === gn.f_stat || (e !== $.colon || t !== gn.b_stat && t !== gn.b_expr ? e === $._return || e === $.name && this.exprAllowed ? ci.test(this.input.slice(this.lastTokEnd, this.start)) : e === $._else || e === $.semi || e === $.eof || e === $.parenR || e === $.arrow || (e === $.braceL ? t === gn.b_stat : e !== $._var && e !== $._const && e !== $.name && !this.exprAllowed) : !t.isExpr);
}, Ol.inGeneratorContext = function() {
  for (var e = this.context.length - 1; e >= 1; e--) {
    var t = this.context[e];
    if (t.token === "function")
      return t.generator;
  }
  return !1;
}, Ol.updateContext = function(e) {
  var t, n = this.type;
  n.keyword && e === $.dot ? this.exprAllowed = !1 : (t = n.updateContext) ? t.call(this, e) : this.exprAllowed = n.beforeExpr;
}, $.parenR.updateContext = $.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e = this.context.pop();
    e === gn.b_stat && this.curContext().token === "function" && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
  } else
    this.exprAllowed = !0;
}, $.braceL.updateContext = function(e) {
  this.context.push(this.braceIsBlock(e) ? gn.b_stat : gn.b_expr), this.exprAllowed = !0;
}, $.dollarBraceL.updateContext = function() {
  this.context.push(gn.b_tmpl), this.exprAllowed = !0;
}, $.parenL.updateContext = function(e) {
  var t = e === $._if || e === $._for || e === $._with || e === $._while;
  this.context.push(t ? gn.p_stat : gn.p_expr), this.exprAllowed = !0;
}, $.incDec.updateContext = function() {
}, $._function.updateContext = $._class.updateContext = function(e) {
  !e.beforeExpr || e === $.semi || e === $._else || e === $._return && ci.test(this.input.slice(this.lastTokEnd, this.start)) || (e === $.colon || e === $.braceL) && this.curContext() === gn.b_stat ? this.context.push(gn.f_stat) : this.context.push(gn.f_expr), this.exprAllowed = !1;
}, $.backQuote.updateContext = function() {
  this.curContext() === gn.q_tmpl ? this.context.pop() : this.context.push(gn.q_tmpl), this.exprAllowed = !1;
}, $.star.updateContext = function(e) {
  if (e === $._function) {
    var t = this.context.length - 1;
    this.context[t] === gn.f_expr ? this.context[t] = gn.f_expr_gen : this.context[t] = gn.f_gen;
  }
  this.exprAllowed = !0;
}, $.name.updateContext = function(e) {
  var t = !1;
  this.options.ecmaVersion >= 6 && e !== $.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
};
var tk = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", k9 = tk + " Extended_Pictographic", D9 = { 9: tk, 10: k9, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, gx = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", nk = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", F9 = nk + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", w9 = { 9: nk, 10: F9, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, rk = {};
function Ed(e) {
  var t = rk[e] = { binary: Bo(D9[e] + " " + gx), nonBinary: { General_Category: Bo(gx), Script: Bo(w9[e]) } };
  t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
}
Ed(9), Ed(10), Ed(11);
var He = pn.prototype, ha = function(e) {
  this.parser = e, this.validFlags = "gim" + (e.options.ecmaVersion >= 6 ? "uy" : "") + (e.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = rk[e.options.ecmaVersion >= 11 ? 11 : e.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function Ll(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
function yx(e) {
  return e === 36 || e >= 40 && e <= 43 || e === 46 || e === 63 || e >= 91 && e <= 94 || e >= 123 && e <= 125;
}
function ik(e) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function ak(e) {
  return ik(e) || e === 95;
}
function A9(e) {
  return ak(e) || sp(e);
}
function sp(e) {
  return e >= 48 && e <= 57;
}
function vx(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function xx(e) {
  return e >= 65 && e <= 70 ? e - 65 + 10 : e >= 97 && e <= 102 ? e - 97 + 10 : e - 48;
}
function bx(e) {
  return e >= 48 && e <= 55;
}
ha.prototype.reset = function(e, t, n) {
  var r = n.indexOf("u") !== -1;
  this.start = 0 | e, this.source = t + "", this.flags = n, this.switchU = r && this.parser.options.ecmaVersion >= 6, this.switchN = r && this.parser.options.ecmaVersion >= 9;
}, ha.prototype.raise = function(e) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e);
}, ha.prototype.at = function(e) {
  var t = this.source, n = t.length;
  if (e >= n)
    return -1;
  var r = t.charCodeAt(e);
  return !this.switchU || r <= 55295 || r >= 57344 || e + 1 >= n ? r : (r << 10) + t.charCodeAt(e + 1) - 56613888;
}, ha.prototype.nextIndex = function(e) {
  var t = this.source, n = t.length;
  if (e >= n)
    return n;
  var r = t.charCodeAt(e);
  return !this.switchU || r <= 55295 || r >= 57344 || e + 1 >= n ? e + 1 : e + 2;
}, ha.prototype.current = function() {
  return this.at(this.pos);
}, ha.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, ha.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, ha.prototype.eat = function(e) {
  return this.current() === e && (this.advance(), !0);
}, He.validateRegExpFlags = function(e) {
  for (var t = e.validFlags, n = e.flags, r = 0; r < n.length; r++) {
    var i = n.charAt(r);
    t.indexOf(i) === -1 && this.raise(e.start, "Invalid regular expression flag"), n.indexOf(i, r + 1) > -1 && this.raise(e.start, "Duplicate regular expression flag");
  }
}, He.validateRegExpPattern = function(e) {
  this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && e.groupNames.length > 0 && (e.switchN = !0, this.regexp_pattern(e));
}, He.regexp_pattern = function(e) {
  e.pos = 0, e.lastIntValue = 0, e.lastStringValue = "", e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames.length = 0, e.backReferenceNames.length = 0, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(41) && e.raise("Unmatched ')'"), (e.eat(93) || e.eat(125)) && e.raise("Lone quantifier brackets")), e.maxBackReference > e.numCapturingParens && e.raise("Invalid escape");
  for (var t = 0, n = e.backReferenceNames; t < n.length; t += 1) {
    var r = n[t];
    e.groupNames.indexOf(r) === -1 && e.raise("Invalid named capture referenced");
  }
}, He.regexp_disjunction = function(e) {
  for (this.regexp_alternative(e); e.eat(124); )
    this.regexp_alternative(e);
  this.regexp_eatQuantifier(e, !0) && e.raise("Nothing to repeat"), e.eat(123) && e.raise("Lone quantifier brackets");
}, He.regexp_alternative = function(e) {
  for (; e.pos < e.source.length && this.regexp_eatTerm(e); )
    ;
}, He.regexp_eatTerm = function(e) {
  return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise("Invalid quantifier"), !0) : !(e.switchU ? !this.regexp_eatAtom(e) : !this.regexp_eatExtendedAtom(e)) && (this.regexp_eatQuantifier(e), !0);
}, He.regexp_eatAssertion = function(e) {
  var t = e.pos;
  if (e.lastAssertionIsQuantifiable = !1, e.eat(94) || e.eat(36))
    return !0;
  if (e.eat(92)) {
    if (e.eat(66) || e.eat(98))
      return !0;
    e.pos = t;
  }
  if (e.eat(40) && e.eat(63)) {
    var n = !1;
    if (this.options.ecmaVersion >= 9 && (n = e.eat(60)), e.eat(61) || e.eat(33))
      return this.regexp_disjunction(e), e.eat(41) || e.raise("Unterminated group"), e.lastAssertionIsQuantifiable = !n, !0;
  }
  return e.pos = t, !1;
}, He.regexp_eatQuantifier = function(e, t) {
  return t === void 0 && (t = !1), !!this.regexp_eatQuantifierPrefix(e, t) && (e.eat(63), !0);
}, He.regexp_eatQuantifierPrefix = function(e, t) {
  return e.eat(42) || e.eat(43) || e.eat(63) || this.regexp_eatBracedQuantifier(e, t);
}, He.regexp_eatBracedQuantifier = function(e, t) {
  var n = e.pos;
  if (e.eat(123)) {
    var r = 0, i = -1;
    if (this.regexp_eatDecimalDigits(e) && (r = e.lastIntValue, e.eat(44) && this.regexp_eatDecimalDigits(e) && (i = e.lastIntValue), e.eat(125)))
      return i !== -1 && i < r && !t && e.raise("numbers out of order in {} quantifier"), !0;
    e.switchU && !t && e.raise("Incomplete quantifier"), e.pos = n;
  }
  return !1;
}, He.regexp_eatAtom = function(e) {
  return this.regexp_eatPatternCharacters(e) || e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
}, He.regexp_eatReverseSolidusAtomEscape = function(e) {
  var t = e.pos;
  if (e.eat(92)) {
    if (this.regexp_eatAtomEscape(e))
      return !0;
    e.pos = t;
  }
  return !1;
}, He.regexp_eatUncapturingGroup = function(e) {
  var t = e.pos;
  if (e.eat(40)) {
    if (e.eat(63) && e.eat(58)) {
      if (this.regexp_disjunction(e), e.eat(41))
        return !0;
      e.raise("Unterminated group");
    }
    e.pos = t;
  }
  return !1;
}, He.regexp_eatCapturingGroup = function(e) {
  if (e.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : e.current() === 63 && e.raise("Invalid group"), this.regexp_disjunction(e), e.eat(41))
      return e.numCapturingParens += 1, !0;
    e.raise("Unterminated group");
  }
  return !1;
}, He.regexp_eatExtendedAtom = function(e) {
  return e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
}, He.regexp_eatInvalidBracedQuantifier = function(e) {
  return this.regexp_eatBracedQuantifier(e, !0) && e.raise("Nothing to repeat"), !1;
}, He.regexp_eatSyntaxCharacter = function(e) {
  var t = e.current();
  return !!yx(t) && (e.lastIntValue = t, e.advance(), !0);
}, He.regexp_eatPatternCharacters = function(e) {
  for (var t = e.pos, n = 0; (n = e.current()) !== -1 && !yx(n); )
    e.advance();
  return e.pos !== t;
}, He.regexp_eatExtendedPatternCharacter = function(e) {
  var t = e.current();
  return !(t === -1 || t === 36 || t >= 40 && t <= 43 || t === 46 || t === 63 || t === 91 || t === 94 || t === 124) && (e.advance(), !0);
}, He.regexp_groupSpecifier = function(e) {
  if (e.eat(63)) {
    if (this.regexp_eatGroupName(e))
      return e.groupNames.indexOf(e.lastStringValue) !== -1 && e.raise("Duplicate capture group name"), void e.groupNames.push(e.lastStringValue);
    e.raise("Invalid group");
  }
}, He.regexp_eatGroupName = function(e) {
  if (e.lastStringValue = "", e.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e) && e.eat(62))
      return !0;
    e.raise("Invalid capture group name");
  }
  return !1;
}, He.regexp_eatRegExpIdentifierName = function(e) {
  if (e.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e)) {
    for (e.lastStringValue += Ll(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e); )
      e.lastStringValue += Ll(e.lastIntValue);
    return !0;
  }
  return !1;
}, He.regexp_eatRegExpIdentifierStart = function(e) {
  var t = e.pos, n = e.current();
  return e.advance(), n === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e) && (n = e.lastIntValue), function(r) {
    return Ea(r, !0) || r === 36 || r === 95;
  }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
}, He.regexp_eatRegExpIdentifierPart = function(e) {
  var t = e.pos, n = e.current();
  return e.advance(), n === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e) && (n = e.lastIntValue), function(r) {
    return Mo(r, !0) || r === 36 || r === 95 || r === 8204 || r === 8205;
  }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
}, He.regexp_eatAtomEscape = function(e) {
  return !!(this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e)) || (e.switchU && (e.current() === 99 && e.raise("Invalid unicode escape"), e.raise("Invalid escape")), !1);
}, He.regexp_eatBackReference = function(e) {
  var t = e.pos;
  if (this.regexp_eatDecimalEscape(e)) {
    var n = e.lastIntValue;
    if (e.switchU)
      return n > e.maxBackReference && (e.maxBackReference = n), !0;
    if (n <= e.numCapturingParens)
      return !0;
    e.pos = t;
  }
  return !1;
}, He.regexp_eatKGroupName = function(e) {
  if (e.eat(107)) {
    if (this.regexp_eatGroupName(e))
      return e.backReferenceNames.push(e.lastStringValue), !0;
    e.raise("Invalid named reference");
  }
  return !1;
}, He.regexp_eatCharacterEscape = function(e) {
  return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
}, He.regexp_eatCControlLetter = function(e) {
  var t = e.pos;
  if (e.eat(99)) {
    if (this.regexp_eatControlLetter(e))
      return !0;
    e.pos = t;
  }
  return !1;
}, He.regexp_eatZero = function(e) {
  return e.current() === 48 && !sp(e.lookahead()) && (e.lastIntValue = 0, e.advance(), !0);
}, He.regexp_eatControlEscape = function(e) {
  var t = e.current();
  return t === 116 ? (e.lastIntValue = 9, e.advance(), !0) : t === 110 ? (e.lastIntValue = 10, e.advance(), !0) : t === 118 ? (e.lastIntValue = 11, e.advance(), !0) : t === 102 ? (e.lastIntValue = 12, e.advance(), !0) : t === 114 && (e.lastIntValue = 13, e.advance(), !0);
}, He.regexp_eatControlLetter = function(e) {
  var t = e.current();
  return !!ik(t) && (e.lastIntValue = t % 32, e.advance(), !0);
}, He.regexp_eatRegExpUnicodeEscapeSequence = function(e) {
  var t, n = e.pos;
  if (e.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e, 4)) {
      var r = e.lastIntValue;
      if (e.switchU && r >= 55296 && r <= 56319) {
        var i = e.pos;
        if (e.eat(92) && e.eat(117) && this.regexp_eatFixedHexDigits(e, 4)) {
          var a = e.lastIntValue;
          if (a >= 56320 && a <= 57343)
            return e.lastIntValue = 1024 * (r - 55296) + (a - 56320) + 65536, !0;
        }
        e.pos = i, e.lastIntValue = r;
      }
      return !0;
    }
    if (e.switchU && e.eat(123) && this.regexp_eatHexDigits(e) && e.eat(125) && (t = e.lastIntValue) >= 0 && t <= 1114111)
      return !0;
    e.switchU && e.raise("Invalid unicode escape"), e.pos = n;
  }
  return !1;
}, He.regexp_eatIdentityEscape = function(e) {
  if (e.switchU)
    return !!this.regexp_eatSyntaxCharacter(e) || !!e.eat(47) && (e.lastIntValue = 47, !0);
  var t = e.current();
  return !(t === 99 || e.switchN && t === 107) && (e.lastIntValue = t, e.advance(), !0);
}, He.regexp_eatDecimalEscape = function(e) {
  e.lastIntValue = 0;
  var t = e.current();
  if (t >= 49 && t <= 57) {
    do
      e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
    while ((t = e.current()) >= 48 && t <= 57);
    return !0;
  }
  return !1;
}, He.regexp_eatCharacterClassEscape = function(e) {
  var t = e.current();
  if (function(n) {
    return n === 100 || n === 68 || n === 115 || n === 83 || n === 119 || n === 87;
  }(t))
    return e.lastIntValue = -1, e.advance(), !0;
  if (e.switchU && this.options.ecmaVersion >= 9 && (t === 80 || t === 112)) {
    if (e.lastIntValue = -1, e.advance(), e.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e) && e.eat(125))
      return !0;
    e.raise("Invalid property name");
  }
  return !1;
}, He.regexp_eatUnicodePropertyValueExpression = function(e) {
  var t = e.pos;
  if (this.regexp_eatUnicodePropertyName(e) && e.eat(61)) {
    var n = e.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e)) {
      var r = e.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e, n, r), !0;
    }
  }
  if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
    var i = e.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e, i), !0;
  }
  return !1;
}, He.regexp_validateUnicodePropertyNameAndValue = function(e, t, n) {
  hf(e.unicodeProperties.nonBinary, t) || e.raise("Invalid property name"), e.unicodeProperties.nonBinary[t].test(n) || e.raise("Invalid property value");
}, He.regexp_validateUnicodePropertyNameOrValue = function(e, t) {
  e.unicodeProperties.binary.test(t) || e.raise("Invalid property name");
}, He.regexp_eatUnicodePropertyName = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; ak(t = e.current()); )
    e.lastStringValue += Ll(t), e.advance();
  return e.lastStringValue !== "";
}, He.regexp_eatUnicodePropertyValue = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; A9(t = e.current()); )
    e.lastStringValue += Ll(t), e.advance();
  return e.lastStringValue !== "";
}, He.regexp_eatLoneUnicodePropertyNameOrValue = function(e) {
  return this.regexp_eatUnicodePropertyValue(e);
}, He.regexp_eatCharacterClass = function(e) {
  if (e.eat(91)) {
    if (e.eat(94), this.regexp_classRanges(e), e.eat(93))
      return !0;
    e.raise("Unterminated character class");
  }
  return !1;
}, He.regexp_classRanges = function(e) {
  for (; this.regexp_eatClassAtom(e); ) {
    var t = e.lastIntValue;
    if (e.eat(45) && this.regexp_eatClassAtom(e)) {
      var n = e.lastIntValue;
      !e.switchU || t !== -1 && n !== -1 || e.raise("Invalid character class"), t !== -1 && n !== -1 && t > n && e.raise("Range out of order in character class");
    }
  }
}, He.regexp_eatClassAtom = function(e) {
  var t = e.pos;
  if (e.eat(92)) {
    if (this.regexp_eatClassEscape(e))
      return !0;
    if (e.switchU) {
      var n = e.current();
      (n === 99 || bx(n)) && e.raise("Invalid class escape"), e.raise("Invalid escape");
    }
    e.pos = t;
  }
  var r = e.current();
  return r !== 93 && (e.lastIntValue = r, e.advance(), !0);
}, He.regexp_eatClassEscape = function(e) {
  var t = e.pos;
  if (e.eat(98))
    return e.lastIntValue = 8, !0;
  if (e.switchU && e.eat(45))
    return e.lastIntValue = 45, !0;
  if (!e.switchU && e.eat(99)) {
    if (this.regexp_eatClassControlLetter(e))
      return !0;
    e.pos = t;
  }
  return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
}, He.regexp_eatClassControlLetter = function(e) {
  var t = e.current();
  return !(!sp(t) && t !== 95) && (e.lastIntValue = t % 32, e.advance(), !0);
}, He.regexp_eatHexEscapeSequence = function(e) {
  var t = e.pos;
  if (e.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e, 2))
      return !0;
    e.switchU && e.raise("Invalid escape"), e.pos = t;
  }
  return !1;
}, He.regexp_eatDecimalDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; sp(n = e.current()); )
    e.lastIntValue = 10 * e.lastIntValue + (n - 48), e.advance();
  return e.pos !== t;
}, He.regexp_eatHexDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; vx(n = e.current()); )
    e.lastIntValue = 16 * e.lastIntValue + xx(n), e.advance();
  return e.pos !== t;
}, He.regexp_eatLegacyOctalEscapeSequence = function(e) {
  if (this.regexp_eatOctalDigit(e)) {
    var t = e.lastIntValue;
    if (this.regexp_eatOctalDigit(e)) {
      var n = e.lastIntValue;
      t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = 64 * t + 8 * n + e.lastIntValue : e.lastIntValue = 8 * t + n;
    } else
      e.lastIntValue = t;
    return !0;
  }
  return !1;
}, He.regexp_eatOctalDigit = function(e) {
  var t = e.current();
  return bx(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
}, He.regexp_eatFixedHexDigits = function(e, t) {
  var n = e.pos;
  e.lastIntValue = 0;
  for (var r = 0; r < t; ++r) {
    var i = e.current();
    if (!vx(i))
      return e.pos = n, !1;
    e.lastIntValue = 16 * e.lastIntValue + xx(i), e.advance();
  }
  return !0;
};
var Np = function(e) {
  this.type = e.type, this.value = e.value, this.start = e.start, this.end = e.end, e.options.locations && (this.loc = new Sc(e, e.startLoc, e.endLoc)), e.options.ranges && (this.range = [e.start, e.end]);
}, Ft = pn.prototype;
function Nm(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
Ft.next = function() {
  this.options.onToken && this.options.onToken(new Np(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, Ft.getToken = function() {
  return this.next(), new Np(this);
}, typeof Symbol < "u" && (Ft[Symbol.iterator] = function() {
  var e = this;
  return { next: function() {
    var t = e.getToken();
    return { done: t.type === $.eof, value: t };
  } };
}), Ft.curContext = function() {
  return this.context[this.context.length - 1];
}, Ft.nextToken = function() {
  var e = this.curContext();
  return e && e.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken($.eof) : e.override ? e.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, Ft.readToken = function(e) {
  return Ea(e, this.options.ecmaVersion >= 6) || e === 92 ? this.readWord() : this.getTokenFromCode(e);
}, Ft.fullCharCodeAtPos = function() {
  var e = this.input.charCodeAt(this.pos);
  return e <= 55295 || e >= 57344 ? e : (e << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, Ft.skipBlockComment = function() {
  var e, t = this.options.onComment && this.curPosition(), n = this.pos, r = this.input.indexOf("*/", this.pos += 2);
  if (r === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = r + 2, this.options.locations)
    for (qs.lastIndex = n; (e = qs.exec(this.input)) && e.index < this.pos; )
      ++this.curLine, this.lineStart = e.index + e[0].length;
  this.options.onComment && this.options.onComment(!0, this.input.slice(n + 2, r), n, this.pos, t, this.curPosition());
}, Ft.skipLineComment = function(e) {
  for (var t = this.pos, n = this.options.onComment && this.curPosition(), r = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !Ws(r); )
    r = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(!1, this.input.slice(t + e, this.pos), t, this.pos, n, this.curPosition());
}, Ft.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e = this.input.charCodeAt(this.pos);
      switch (e) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e > 8 && e < 14 || e >= 5760 && q0.test(String.fromCharCode(e))))
            break e;
          ++this.pos;
      }
    }
}, Ft.finishToken = function(e, t) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n = this.type;
  this.type = e, this.value = t, this.updateContext(n);
}, Ft.readToken_dot = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  if (e >= 48 && e <= 57)
    return this.readNumber(!0);
  var t = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e === 46 && t === 46 ? (this.pos += 3, this.finishToken($.ellipsis)) : (++this.pos, this.finishToken($.dot));
}, Ft.readToken_slash = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e === 61 ? this.finishOp($.assign, 2) : this.finishOp($.slash, 1);
}, Ft.readToken_mult_modulo_exp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1, r = e === 42 ? $.star : $.modulo;
  return this.options.ecmaVersion >= 7 && e === 42 && t === 42 && (++n, r = $.starstar, t = this.input.charCodeAt(this.pos + 2)), t === 61 ? this.finishOp($.assign, n + 1) : this.finishOp(r, n);
}, Ft.readToken_pipe_amp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? this.finishOp(e === 124 ? $.logicalOR : $.logicalAND, 2) : t === 61 ? this.finishOp($.assign, 2) : this.finishOp(e === 124 ? $.bitwiseOR : $.bitwiseAND, 1);
}, Ft.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp($.assign, 2) : this.finishOp($.bitwiseXOR, 1);
}, Ft.readToken_plus_min = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? t !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !ci.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp($.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t === 61 ? this.finishOp($.assign, 2) : this.finishOp($.plusMin, 1);
}, Ft.readToken_lt_gt = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1;
  return t === e ? (n = e === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n) === 61 ? this.finishOp($.assign, n + 1) : this.finishOp($.bitShift, n)) : t !== 33 || e !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t === 61 && (n = 2), this.finishOp($.relational, n)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, Ft.readToken_eq_excl = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === 61 ? this.finishOp($.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e === 61 && t === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken($.arrow)) : this.finishOp(e === 61 ? $.eq : $.prefix, 1);
}, Ft.getTokenFromCode = function(e) {
  switch (e) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken($.parenL);
    case 41:
      return ++this.pos, this.finishToken($.parenR);
    case 59:
      return ++this.pos, this.finishToken($.semi);
    case 44:
      return ++this.pos, this.finishToken($.comma);
    case 91:
      return ++this.pos, this.finishToken($.bracketL);
    case 93:
      return ++this.pos, this.finishToken($.bracketR);
    case 123:
      return ++this.pos, this.finishToken($.braceL);
    case 125:
      return ++this.pos, this.finishToken($.braceR);
    case 58:
      return ++this.pos, this.finishToken($.colon);
    case 63:
      return ++this.pos, this.finishToken($.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken($.backQuote);
    case 48:
      var t = this.input.charCodeAt(this.pos + 1);
      if (t === 120 || t === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t === 111 || t === 79)
          return this.readRadixNumber(8);
        if (t === 98 || t === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    case 34:
    case 39:
      return this.readString(e);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e);
    case 60:
    case 62:
      return this.readToken_lt_gt(e);
    case 61:
    case 33:
      return this.readToken_eq_excl(e);
    case 126:
      return this.finishOp($.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + Nm(e) + "'");
}, Ft.finishOp = function(e, t) {
  var n = this.input.slice(this.pos, this.pos + t);
  return this.pos += t, this.finishToken(e, n);
}, Ft.readRegexp = function() {
  for (var e, t, n = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n, "Unterminated regular expression");
    var r = this.input.charAt(this.pos);
    if (ci.test(r) && this.raise(n, "Unterminated regular expression"), e)
      e = !1;
    else {
      if (r === "[")
        t = !0;
      else if (r === "]" && t)
        t = !1;
      else if (r === "/" && !t)
        break;
      e = r === "\\";
    }
    ++this.pos;
  }
  var i = this.input.slice(n, this.pos);
  ++this.pos;
  var a = this.pos, s = this.readWord1();
  this.containsEsc && this.unexpected(a);
  var o = this.regexpState || (this.regexpState = new ha(this));
  o.reset(n, i, s), this.validateRegExpFlags(o), this.validateRegExpPattern(o);
  var u = null;
  try {
    u = new RegExp(i, s);
  } catch {
  }
  return this.finishToken($.regexp, { pattern: i, flags: s, value: u });
}, Ft.readInt = function(e, t) {
  for (var n = this.pos, r = 0, i = 0, a = t ?? 1 / 0; i < a; ++i) {
    var s = this.input.charCodeAt(this.pos), o = void 0;
    if ((o = s >= 97 ? s - 97 + 10 : s >= 65 ? s - 65 + 10 : s >= 48 && s <= 57 ? s - 48 : 1 / 0) >= e)
      break;
    ++this.pos, r = r * e + o;
  }
  return this.pos === n || t != null && this.pos - n !== t ? null : r;
}, Ft.readRadixNumber = function(e) {
  var t = this.pos;
  this.pos += 2;
  var n = this.readInt(e);
  return n == null && this.raise(this.start + 2, "Expected number in radix " + e), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n = typeof BigInt < "u" ? BigInt(this.input.slice(t, this.pos)) : null, ++this.pos) : Ea(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken($.num, n);
}, Ft.readNumber = function(e) {
  var t = this.pos;
  e || this.readInt(10) !== null || this.raise(t, "Invalid number");
  var n = this.pos - t >= 2 && this.input.charCodeAt(t) === 48;
  n && this.strict && this.raise(t, "Invalid number"), n && /[89]/.test(this.input.slice(t, this.pos)) && (n = !1);
  var r = this.input.charCodeAt(this.pos);
  if (!n && !e && this.options.ecmaVersion >= 11 && r === 110) {
    var i = this.input.slice(t, this.pos), a = typeof BigInt < "u" ? BigInt(i) : null;
    return ++this.pos, Ea(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken($.num, a);
  }
  r !== 46 || n || (++this.pos, this.readInt(10), r = this.input.charCodeAt(this.pos)), r !== 69 && r !== 101 || n || ((r = this.input.charCodeAt(++this.pos)) !== 43 && r !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t, "Invalid number")), Ea(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var s = this.input.slice(t, this.pos), o = n ? parseInt(s, 8) : parseFloat(s);
  return this.finishToken($.num, o);
}, Ft.readCodePoint = function() {
  var e;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t = ++this.pos;
    e = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e > 1114111 && this.invalidStringToken(t, "Code point out of bounds");
  } else
    e = this.readHexChar(4);
  return e;
}, Ft.readString = function(e) {
  for (var t = "", n = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var r = this.input.charCodeAt(this.pos);
    if (r === e)
      break;
    r === 92 ? (t += this.input.slice(n, this.pos), t += this.readEscapedChar(!1), n = this.pos) : (Ws(r, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t += this.input.slice(n, this.pos++), this.finishToken($.string, t);
};
var Ex = {};
Ft.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (e) {
    if (e !== Ex)
      throw e;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = !1;
}, Ft.invalidStringToken = function(e, t) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw Ex;
  this.raise(e, t);
}, Ft.readTmplToken = function() {
  for (var e = "", t = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n = this.input.charCodeAt(this.pos);
    if (n === 96 || n === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== $.template && this.type !== $.invalidTemplate ? (e += this.input.slice(t, this.pos), this.finishToken($.template, e)) : n === 36 ? (this.pos += 2, this.finishToken($.dollarBraceL)) : (++this.pos, this.finishToken($.backQuote));
    if (n === 92)
      e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
    else if (Ws(n)) {
      switch (e += this.input.slice(t, this.pos), ++this.pos, n) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e += `
`;
          break;
        default:
          e += String.fromCharCode(n);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
    } else
      ++this.pos;
  }
}, Ft.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken($.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, Ft.readEscapedChar = function(e) {
  var t = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t) {
    case 110:
      return `
`;
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return Nm(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t >= 48 && t <= 55) {
        var n = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r = parseInt(n, 8);
        return r > 255 && (n = n.slice(0, -1), r = parseInt(n, 8)), this.pos += n.length - 1, t = this.input.charCodeAt(this.pos), n === "0" && t !== 56 && t !== 57 || !this.strict && !e || this.invalidStringToken(this.pos - 1 - n.length, e ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r);
      }
      return Ws(t) ? "" : String.fromCharCode(t);
  }
}, Ft.readHexChar = function(e) {
  var t = this.pos, n = this.readInt(16, e);
  return n === null && this.invalidStringToken(t, "Bad character escape sequence"), n;
}, Ft.readWord1 = function() {
  this.containsEsc = !1;
  for (var e = "", t = !0, n = this.pos, r = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i = this.fullCharCodeAtPos();
    if (Mo(i, r))
      this.pos += i <= 65535 ? 1 : 2;
    else {
      if (i !== 92)
        break;
      this.containsEsc = !0, e += this.input.slice(n, this.pos);
      var a = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var s = this.readCodePoint();
      (t ? Ea : Mo)(s, r) || this.invalidStringToken(a, "Invalid Unicode escape"), e += Nm(s), n = this.pos;
    }
    t = !1;
  }
  return e + this.input.slice(n, this.pos);
}, Ft.readWord = function() {
  var e = this.readWord1(), t = $.name;
  return this.keywords.test(e) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e), t = ff[e]), this.finishToken(t, e);
};
pn.acorn = { Parser: pn, version: "7.1.0", defaultOptions: Op, Position: $s, SourceLocation: Sc, getLineInfo: W0, Node: Lp, TokenType: Ot, tokTypes: $, keywordTypes: ff, TokContext: Zr, tokContexts: gn, isIdentifierChar: Mo, isIdentifierStart: Ea, Token: Np, isNewLine: Ws, lineBreak: ci, lineBreakG: qs, nonASCIIwhitespace: q0 };
var _9 = Object.freeze({ __proto__: null, Node: Lp, Parser: pn, Position: $s, SourceLocation: Sc, TokContext: Zr, Token: Np, TokenType: Ot, defaultOptions: Op, getLineInfo: W0, isIdentifierChar: Mo, isIdentifierStart: Ea, isNewLine: Ws, keywordTypes: ff, lineBreak: ci, lineBreakG: qs, nonASCIIwhitespace: q0, parse: function(e, t) {
  return pn.parse(e, t);
}, parseExpressionAt: function(e, t, n) {
  return pn.parseExpressionAt(e, t, n);
}, tokContexts: gn, tokTypes: $, tokenizer: function(e, t) {
  return pn.tokenizer(e, t);
}, version: "7.1.0" }), T9 = { quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: " ", iexcl: "¡", cent: "¢", pound: "£", curren: "¤", yen: "¥", brvbar: "¦", sect: "§", uml: "¨", copy: "©", ordf: "ª", laquo: "«", not: "¬", shy: "­", reg: "®", macr: "¯", deg: "°", plusmn: "±", sup2: "²", sup3: "³", acute: "´", micro: "µ", para: "¶", middot: "·", cedil: "¸", sup1: "¹", ordm: "º", raquo: "»", frac14: "¼", frac12: "½", frac34: "¾", iquest: "¿", Agrave: "À", Aacute: "Á", Acirc: "Â", Atilde: "Ã", Auml: "Ä", Aring: "Å", AElig: "Æ", Ccedil: "Ç", Egrave: "È", Eacute: "É", Ecirc: "Ê", Euml: "Ë", Igrave: "Ì", Iacute: "Í", Icirc: "Î", Iuml: "Ï", ETH: "Ð", Ntilde: "Ñ", Ograve: "Ò", Oacute: "Ó", Ocirc: "Ô", Otilde: "Õ", Ouml: "Ö", times: "×", Oslash: "Ø", Ugrave: "Ù", Uacute: "Ú", Ucirc: "Û", Uuml: "Ü", Yacute: "Ý", THORN: "Þ", szlig: "ß", agrave: "à", aacute: "á", acirc: "â", atilde: "ã", auml: "ä", aring: "å", aelig: "æ", ccedil: "ç", egrave: "è", eacute: "é", ecirc: "ê", euml: "ë", igrave: "ì", iacute: "í", icirc: "î", iuml: "ï", eth: "ð", ntilde: "ñ", ograve: "ò", oacute: "ó", ocirc: "ô", otilde: "õ", ouml: "ö", divide: "÷", oslash: "ø", ugrave: "ù", uacute: "ú", ucirc: "û", uuml: "ü", yacute: "ý", thorn: "þ", yuml: "ÿ", OElig: "Œ", oelig: "œ", Scaron: "Š", scaron: "š", Yuml: "Ÿ", fnof: "ƒ", circ: "ˆ", tilde: "˜", Alpha: "Α", Beta: "Β", Gamma: "Γ", Delta: "Δ", Epsilon: "Ε", Zeta: "Ζ", Eta: "Η", Theta: "Θ", Iota: "Ι", Kappa: "Κ", Lambda: "Λ", Mu: "Μ", Nu: "Ν", Xi: "Ξ", Omicron: "Ο", Pi: "Π", Rho: "Ρ", Sigma: "Σ", Tau: "Τ", Upsilon: "Υ", Phi: "Φ", Chi: "Χ", Psi: "Ψ", Omega: "Ω", alpha: "α", beta: "β", gamma: "γ", delta: "δ", epsilon: "ε", zeta: "ζ", eta: "η", theta: "θ", iota: "ι", kappa: "κ", lambda: "λ", mu: "μ", nu: "ν", xi: "ξ", omicron: "ο", pi: "π", rho: "ρ", sigmaf: "ς", sigma: "σ", tau: "τ", upsilon: "υ", phi: "φ", chi: "χ", psi: "ψ", omega: "ω", thetasym: "ϑ", upsih: "ϒ", piv: "ϖ", ensp: " ", emsp: " ", thinsp: " ", zwnj: "‌", zwj: "‍", lrm: "‎", rlm: "‏", ndash: "–", mdash: "—", lsquo: "‘", rsquo: "’", sbquo: "‚", ldquo: "“", rdquo: "”", bdquo: "„", dagger: "†", Dagger: "‡", bull: "•", hellip: "…", permil: "‰", prime: "′", Prime: "″", lsaquo: "‹", rsaquo: "›", oline: "‾", frasl: "⁄", euro: "€", image: "ℑ", weierp: "℘", real: "ℜ", trade: "™", alefsym: "ℵ", larr: "←", uarr: "↑", rarr: "→", darr: "↓", harr: "↔", crarr: "↵", lArr: "⇐", uArr: "⇑", rArr: "⇒", dArr: "⇓", hArr: "⇔", forall: "∀", part: "∂", exist: "∃", empty: "∅", nabla: "∇", isin: "∈", notin: "∉", ni: "∋", prod: "∏", sum: "∑", minus: "−", lowast: "∗", radic: "√", prop: "∝", infin: "∞", ang: "∠", and: "∧", or: "∨", cap: "∩", cup: "∪", int: "∫", there4: "∴", sim: "∼", cong: "≅", asymp: "≈", ne: "≠", equiv: "≡", le: "≤", ge: "≥", sub: "⊂", sup: "⊃", nsub: "⊄", sube: "⊆", supe: "⊇", oplus: "⊕", otimes: "⊗", perp: "⊥", sdot: "⋅", lceil: "⌈", rceil: "⌉", lfloor: "⌊", rfloor: "⌋", lang: "〈", rang: "〉", loz: "◊", spades: "♠", clubs: "♣", hearts: "♥", diams: "♦" }, Cd = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, Sd = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", P9 = { 5: Sd, "5module": Sd + " export import", 6: Sd + " const class extends export import super" }, I9 = /^in(stanceof)?$/, $0 = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࢠ-ࢴࢶ-ࢽऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿯ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞿꟂ-Ᶎꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭧꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", ok = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࣓-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ංඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-ໍ໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜔ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠐-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷹᷻-᷿‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿", B9 = new RegExp("[" + $0 + "]"), O9 = new RegExp("[" + $0 + ok + "]");
$0 = ok = null;
var sk = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], L9 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function jm(e, t) {
  for (var n = 65536, r = 0; r < t.length; r += 2) {
    if ((n += t[r]) > e)
      return !1;
    if ((n += t[r + 1]) >= e)
      return !0;
  }
}
function Ca(e, t) {
  return e < 65 ? e === 36 : e < 91 || (e < 97 ? e === 95 : e < 123 || (e <= 65535 ? e >= 170 && B9.test(String.fromCharCode(e)) : t !== !1 && jm(e, sk)));
}
function Vo(e, t) {
  return e < 48 ? e === 36 : e < 58 || !(e < 65) && (e < 91 || (e < 97 ? e === 95 : e < 123 || (e <= 65535 ? e >= 170 && O9.test(String.fromCharCode(e)) : t !== !1 && (jm(e, sk) || jm(e, L9)))));
}
var Lt = function(e, t) {
  t === void 0 && (t = {}), this.label = e, this.keyword = t.keyword, this.beforeExpr = !!t.beforeExpr, this.startsExpr = !!t.startsExpr, this.isLoop = !!t.isLoop, this.isAssign = !!t.isAssign, this.prefix = !!t.prefix, this.postfix = !!t.postfix, this.binop = t.binop || null, this.updateContext = null;
};
function vi(e, t) {
  return new Lt(e, { beforeExpr: !0, binop: t });
}
var Qr = { beforeExpr: !0 }, Ir = { startsExpr: !0 }, df = {};
function Dt(e, t) {
  return t === void 0 && (t = {}), t.keyword = e, df[e] = new Lt(e, t);
}
var G = { num: new Lt("num", Ir), regexp: new Lt("regexp", Ir), string: new Lt("string", Ir), name: new Lt("name", Ir), eof: new Lt("eof"), bracketL: new Lt("[", { beforeExpr: !0, startsExpr: !0 }), bracketR: new Lt("]"), braceL: new Lt("{", { beforeExpr: !0, startsExpr: !0 }), braceR: new Lt("}"), parenL: new Lt("(", { beforeExpr: !0, startsExpr: !0 }), parenR: new Lt(")"), comma: new Lt(",", Qr), semi: new Lt(";", Qr), colon: new Lt(":", Qr), dot: new Lt("."), question: new Lt("?", Qr), arrow: new Lt("=>", Qr), template: new Lt("template"), invalidTemplate: new Lt("invalidTemplate"), ellipsis: new Lt("...", Qr), backQuote: new Lt("`", Ir), dollarBraceL: new Lt("${", { beforeExpr: !0, startsExpr: !0 }), eq: new Lt("=", { beforeExpr: !0, isAssign: !0 }), assign: new Lt("_=", { beforeExpr: !0, isAssign: !0 }), incDec: new Lt("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }), prefix: new Lt("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), logicalOR: vi("||", 1), logicalAND: vi("&&", 2), bitwiseOR: vi("|", 3), bitwiseXOR: vi("^", 4), bitwiseAND: vi("&", 5), equality: vi("==/!=/===/!==", 6), relational: vi("</>/<=/>=", 7), bitShift: vi("<</>>/>>>", 8), plusMin: new Lt("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }), modulo: vi("%", 10), star: vi("*", 10), slash: vi("/", 10), starstar: new Lt("**", { beforeExpr: !0 }), _break: Dt("break"), _case: Dt("case", Qr), _catch: Dt("catch"), _continue: Dt("continue"), _debugger: Dt("debugger"), _default: Dt("default", Qr), _do: Dt("do", { isLoop: !0, beforeExpr: !0 }), _else: Dt("else", Qr), _finally: Dt("finally"), _for: Dt("for", { isLoop: !0 }), _function: Dt("function", Ir), _if: Dt("if"), _return: Dt("return", Qr), _switch: Dt("switch"), _throw: Dt("throw", Qr), _try: Dt("try"), _var: Dt("var"), _const: Dt("const"), _while: Dt("while", { isLoop: !0 }), _with: Dt("with"), _new: Dt("new", { beforeExpr: !0, startsExpr: !0 }), _this: Dt("this", Ir), _super: Dt("super", Ir), _class: Dt("class", Ir), _extends: Dt("extends", Qr), _export: Dt("export"), _import: Dt("import", Ir), _null: Dt("null", Ir), _true: Dt("true", Ir), _false: Dt("false", Ir), _in: Dt("in", { beforeExpr: !0, binop: 7 }), _instanceof: Dt("instanceof", { beforeExpr: !0, binop: 7 }), _typeof: Dt("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), _void: Dt("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }), _delete: Dt("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 }) }, li = /\r\n?|\n|\u2028|\u2029/, Gs = new RegExp(li.source, "g");
function zs(e, t) {
  return e === 10 || e === 13 || !t && (e === 8232 || e === 8233);
}
var G0 = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Vi = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, uk = Object.prototype, N9 = uk.hasOwnProperty, j9 = uk.toString;
function mf(e, t) {
  return N9.call(e, t);
}
var Cx = Array.isArray || function(e) {
  return j9.call(e) === "[object Array]";
};
function Oo(e) {
  return new RegExp("^(?:" + e.replace(/ /g, "|") + ")$");
}
var Hs = function(e, t) {
  this.line = e, this.column = t;
};
Hs.prototype.offset = function(e) {
  return new Hs(this.line, this.column + e);
};
var kc = function(e, t, n) {
  this.start = t, this.end = n, e.sourceFile !== null && (this.source = e.sourceFile);
};
function z0(e, t) {
  for (var n = 1, r = 0; ; ) {
    Gs.lastIndex = r;
    var i = Gs.exec(e);
    if (!(i && i.index < t))
      return new Hs(n, t - r);
    ++n, r = i.index + i[0].length;
  }
}
var jp = { ecmaVersion: 9, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: !1, allowImportExportEverywhere: !1, allowAwaitOutsideFunction: !1, allowHashBang: !1, locations: !1, onToken: null, onComment: null, ranges: !1, program: null, sourceFile: null, directSourceFile: null, preserveParens: !1 };
function R9(e) {
  var t = {};
  for (var n in jp)
    t[n] = e && mf(e, n) ? e[n] : jp[n];
  if (t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), t.allowReserved == null && (t.allowReserved = t.ecmaVersion < 5), Cx(t.onToken)) {
    var r = t.onToken;
    t.onToken = function(i) {
      return r.push(i);
    };
  }
  return Cx(t.onComment) && (t.onComment = function(i, a) {
    return function(s, o, u, c, f, p) {
      var d = { type: s ? "Block" : "Line", value: o, start: u, end: c };
      i.locations && (d.loc = new kc(this, f, p)), i.ranges && (d.range = [u, c]), a.push(d);
    };
  }(t, t.onComment)), t;
}
var fc = 2, kd = 1 | fc, ck = 4, lk = 8;
function Rm(e, t) {
  return fc | (e ? ck : 0) | (t ? lk : 0);
}
var fn = function(e, t, n) {
  this.options = e = R9(e), this.sourceFile = e.sourceFile, this.keywords = Oo(P9[e.ecmaVersion >= 6 ? 6 : e.sourceType === "module" ? "5module" : 5]);
  var r = "";
  if (e.allowReserved !== !0) {
    for (var i = e.ecmaVersion; !(r = Cd[i]); i--)
      ;
    e.sourceType === "module" && (r += " await");
  }
  this.reservedWords = Oo(r);
  var a = (r ? r + " " : "") + Cd.strict;
  this.reservedWordsStrict = Oo(a), this.reservedWordsStrictBind = Oo(a + " " + Cd.strictBind), this.input = String(t), this.containsEsc = !1, n ? (this.pos = n, this.lineStart = this.input.lastIndexOf(`
`, n - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(li).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = G.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = e.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, Eo = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 } };
fn.prototype.parse = function() {
  var e = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e);
}, Eo.inFunction.get = function() {
  return (this.currentVarScope().flags & fc) > 0;
}, Eo.inGenerator.get = function() {
  return (this.currentVarScope().flags & lk) > 0;
}, Eo.inAsync.get = function() {
  return (this.currentVarScope().flags & ck) > 0;
}, Eo.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, Eo.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, Eo.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, fn.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & fc) > 0;
}, fn.extend = function() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  for (var n = this, r = 0; r < e.length; r++)
    n = e[r](n);
  return n;
}, fn.parse = function(e, t) {
  return new this(t, e).parse();
}, fn.parseExpressionAt = function(e, t, n) {
  var r = new this(n, e, t);
  return r.nextToken(), r.parseExpression();
}, fn.tokenizer = function(e, t) {
  return new this(t, e);
}, Object.defineProperties(fn.prototype, Eo);
var or = fn.prototype, M9 = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function qu() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
or.strictDirective = function(e) {
  for (; ; ) {
    Vi.lastIndex = e, e += Vi.exec(this.input)[0].length;
    var t = M9.exec(this.input.slice(e));
    if (!t)
      return !1;
    if ((t[1] || t[2]) === "use strict")
      return !0;
    e += t[0].length, Vi.lastIndex = e, e += Vi.exec(this.input)[0].length, this.input[e] === ";" && e++;
  }
}, or.eat = function(e) {
  return this.type === e && (this.next(), !0);
}, or.isContextual = function(e) {
  return this.type === G.name && this.value === e && !this.containsEsc;
}, or.eatContextual = function(e) {
  return !!this.isContextual(e) && (this.next(), !0);
}, or.expectContextual = function(e) {
  this.eatContextual(e) || this.unexpected();
}, or.canInsertSemicolon = function() {
  return this.type === G.eof || this.type === G.braceR || li.test(this.input.slice(this.lastTokEnd, this.start));
}, or.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
}, or.semicolon = function() {
  this.eat(G.semi) || this.insertSemicolon() || this.unexpected();
}, or.afterTrailingComma = function(e, t) {
  if (this.type === e)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
}, or.expect = function(e) {
  this.eat(e) || this.unexpected();
}, or.unexpected = function(e) {
  this.raise(e ?? this.start, "Unexpected token");
}, or.checkPatternErrors = function(e, t) {
  if (e) {
    e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, "Comma is not permitted after the rest element");
    var n = t ? e.parenthesizedAssign : e.parenthesizedBind;
    n > -1 && this.raiseRecoverable(n, "Parenthesized pattern");
  }
}, or.checkExpressionErrors = function(e, t) {
  if (!e)
    return !1;
  var n = e.shorthandAssign, r = e.doubleProto;
  if (!t)
    return n >= 0 || r >= 0;
  n >= 0 && this.raise(n, "Shorthand property assignments are valid only in destructuring patterns"), r >= 0 && this.raiseRecoverable(r, "Redefinition of __proto__ property");
}, or.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, or.isSimpleAssignTarget = function(e) {
  return e.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e.expression) : e.type === "Identifier" || e.type === "MemberExpression";
};
var lt = fn.prototype;
lt.parseTopLevel = function(e) {
  var t = {};
  for (e.body || (e.body = []); this.type !== G.eof; ) {
    var n = this.parseStatement(null, !0, t);
    e.body.push(n);
  }
  if (this.inModule)
    for (var r = 0, i = Object.keys(this.undefinedExports); r < i.length; r += 1) {
      var a = i[r];
      this.raiseRecoverable(this.undefinedExports[a].start, "Export '" + a + "' is not defined");
    }
  return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType, this.finishNode(e, "Program");
};
var Mm = { kind: "loop" }, V9 = { kind: "switch" };
lt.isLet = function(e) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  Vi.lastIndex = this.pos;
  var t = Vi.exec(this.input), n = this.pos + t[0].length, r = this.input.charCodeAt(n);
  if (r === 91)
    return !0;
  if (e)
    return !1;
  if (r === 123)
    return !0;
  if (Ca(r, !0)) {
    for (var i = n + 1; Vo(this.input.charCodeAt(i), !0); )
      ++i;
    var a = this.input.slice(n, i);
    if (!I9.test(a))
      return !0;
  }
  return !1;
}, lt.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  Vi.lastIndex = this.pos;
  var e = Vi.exec(this.input), t = this.pos + e[0].length;
  return !(li.test(this.input.slice(this.pos, t)) || this.input.slice(t, t + 8) !== "function" || t + 8 !== this.input.length && Vo(this.input.charAt(t + 8)));
}, lt.parseStatement = function(e, t, n) {
  var r, i = this.type, a = this.startNode();
  switch (this.isLet(e) && (i = G._var, r = "let"), i) {
    case G._break:
    case G._continue:
      return this.parseBreakContinueStatement(a, i.keyword);
    case G._debugger:
      return this.parseDebuggerStatement(a);
    case G._do:
      return this.parseDoStatement(a);
    case G._for:
      return this.parseForStatement(a);
    case G._function:
      return e && (this.strict || e !== "if" && e !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !e);
    case G._class:
      return e && this.unexpected(), this.parseClass(a, !0);
    case G._if:
      return this.parseIfStatement(a);
    case G._return:
      return this.parseReturnStatement(a);
    case G._switch:
      return this.parseSwitchStatement(a);
    case G._throw:
      return this.parseThrowStatement(a);
    case G._try:
      return this.parseTryStatement(a);
    case G._const:
    case G._var:
      return r = r || this.value, e && r !== "var" && this.unexpected(), this.parseVarStatement(a, r);
    case G._while:
      return this.parseWhileStatement(a);
    case G._with:
      return this.parseWithStatement(a);
    case G.braceL:
      return this.parseBlock(!0, a);
    case G.semi:
      return this.parseEmptyStatement(a);
    case G._export:
    case G._import:
      if (this.options.ecmaVersion > 10 && i === G._import) {
        Vi.lastIndex = this.pos;
        var s = Vi.exec(this.input), o = this.pos + s[0].length;
        if (this.input.charCodeAt(o) === 40)
          return this.parseExpressionStatement(a, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i === G._import ? this.parseImport(a) : this.parseExport(a, n);
    default:
      if (this.isAsyncFunction())
        return e && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !e);
      var u = this.value, c = this.parseExpression();
      return i === G.name && c.type === "Identifier" && this.eat(G.colon) ? this.parseLabeledStatement(a, u, c, e) : this.parseExpressionStatement(a, c);
  }
}, lt.parseBreakContinueStatement = function(e, t) {
  var n = t === "break";
  this.next(), this.eat(G.semi) || this.insertSemicolon() ? e.label = null : this.type !== G.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
  for (var r = 0; r < this.labels.length; ++r) {
    var i = this.labels[r];
    if ((e.label == null || i.name === e.label.name) && (i.kind != null && (n || i.kind === "loop") || e.label && n))
      break;
  }
  return r === this.labels.length && this.raise(e.start, "Unsyntactic " + t), this.finishNode(e, n ? "BreakStatement" : "ContinueStatement");
}, lt.parseDebuggerStatement = function(e) {
  return this.next(), this.semicolon(), this.finishNode(e, "DebuggerStatement");
}, lt.parseDoStatement = function(e) {
  return this.next(), this.labels.push(Mm), e.body = this.parseStatement("do"), this.labels.pop(), this.expect(G._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(G.semi) : this.semicolon(), this.finishNode(e, "DoWhileStatement");
}, lt.parseForStatement = function(e) {
  this.next();
  var t = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Mm), this.enterScope(0), this.expect(G.parenL), this.type === G.semi)
    return t > -1 && this.unexpected(t), this.parseFor(e, null);
  var n = this.isLet();
  if (this.type === G._var || this.type === G._const || n) {
    var r = this.startNode(), i = n ? "let" : this.value;
    return this.next(), this.parseVar(r, !0, i), this.finishNode(r, "VariableDeclaration"), (this.type === G._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && r.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === G._in ? t > -1 && this.unexpected(t) : e.await = t > -1), this.parseForIn(e, r)) : (t > -1 && this.unexpected(t), this.parseFor(e, r));
  }
  var a = new qu(), s = this.parseExpression(!0, a);
  return this.type === G._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === G._in ? t > -1 && this.unexpected(t) : e.await = t > -1), this.toAssignable(s, !1, a), this.checkLVal(s), this.parseForIn(e, s)) : (this.checkExpressionErrors(a, !0), t > -1 && this.unexpected(t), this.parseFor(e, s));
}, lt.parseFunctionStatement = function(e, t, n) {
  return this.next(), this.parseFunction(e, Wu | (n ? 0 : Vm), !1, t);
}, lt.parseIfStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement("if"), e.alternate = this.eat(G._else) ? this.parseStatement("if") : null, this.finishNode(e, "IfStatement");
}, lt.parseReturnStatement = function(e) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(G.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, "ReturnStatement");
}, lt.parseSwitchStatement = function(e) {
  var t;
  this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect(G.braceL), this.labels.push(V9), this.enterScope(0);
  for (var n = !1; this.type !== G.braceR; )
    if (this.type === G._case || this.type === G._default) {
      var r = this.type === G._case;
      t && this.finishNode(t, "SwitchCase"), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), r ? t.test = this.parseExpression() : (n && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), n = !0, t.test = null), this.expect(G.colon);
    } else
      t || this.unexpected(), t.consequent.push(this.parseStatement(null));
  return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e, "SwitchStatement");
}, lt.parseThrowStatement = function(e) {
  return this.next(), li.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, "ThrowStatement");
};
var U9 = [];
lt.parseTryStatement = function(e) {
  if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === G._catch) {
    var t = this.startNode();
    if (this.next(), this.eat(G.parenL)) {
      t.param = this.parseBindingAtom();
      var n = t.param.type === "Identifier";
      this.enterScope(n ? 32 : 0), this.checkLVal(t.param, n ? 4 : 2), this.expect(G.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0);
    t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, "CatchClause");
  }
  return e.finalizer = this.eat(G._finally) ? this.parseBlock() : null, e.handler || e.finalizer || this.raise(e.start, "Missing catch or finally clause"), this.finishNode(e, "TryStatement");
}, lt.parseVarStatement = function(e, t) {
  return this.next(), this.parseVar(e, !1, t), this.semicolon(), this.finishNode(e, "VariableDeclaration");
}, lt.parseWhileStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), this.labels.push(Mm), e.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e, "WhileStatement");
}, lt.parseWithStatement = function(e) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement("with"), this.finishNode(e, "WithStatement");
}, lt.parseEmptyStatement = function(e) {
  return this.next(), this.finishNode(e, "EmptyStatement");
}, lt.parseLabeledStatement = function(e, t, n, r) {
  for (var i = 0, a = this.labels; i < a.length; i += 1)
    a[i].name === t && this.raise(n.start, "Label '" + t + "' is already declared");
  for (var s = this.type.isLoop ? "loop" : this.type === G._switch ? "switch" : null, o = this.labels.length - 1; o >= 0; o--) {
    var u = this.labels[o];
    if (u.statementStart !== e.start)
      break;
    u.statementStart = this.start, u.kind = s;
  }
  return this.labels.push({ name: t, kind: s, statementStart: this.start }), e.body = this.parseStatement(r ? r.indexOf("label") === -1 ? r + "label" : r : "label"), this.labels.pop(), e.label = n, this.finishNode(e, "LabeledStatement");
}, lt.parseExpressionStatement = function(e, t) {
  return e.expression = t, this.semicolon(), this.finishNode(e, "ExpressionStatement");
}, lt.parseBlock = function(e, t) {
  for (e === void 0 && (e = !0), t === void 0 && (t = this.startNode()), t.body = [], this.expect(G.braceL), e && this.enterScope(0); !this.eat(G.braceR); ) {
    var n = this.parseStatement(null);
    t.body.push(n);
  }
  return e && this.exitScope(), this.finishNode(t, "BlockStatement");
}, lt.parseFor = function(e, t) {
  return e.init = t, this.expect(G.semi), e.test = this.type === G.semi ? null : this.parseExpression(), this.expect(G.semi), e.update = this.type === G.parenR ? null : this.parseExpression(), this.expect(G.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, "ForStatement");
}, lt.parseForIn = function(e, t) {
  var n = this.type === G._in;
  return this.next(), t.type === "VariableDeclaration" && t.declarations[0].init != null && (!n || this.options.ecmaVersion < 8 || this.strict || t.kind !== "var" || t.declarations[0].id.type !== "Identifier") ? this.raise(t.start, (n ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t.type === "AssignmentPattern" && this.raise(t.start, "Invalid left-hand side in for-loop"), e.left = t, e.right = n ? this.parseExpression() : this.parseMaybeAssign(), this.expect(G.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, n ? "ForInStatement" : "ForOfStatement");
}, lt.parseVar = function(e, t, n) {
  for (e.declarations = [], e.kind = n; ; ) {
    var r = this.startNode();
    if (this.parseVarId(r, n), this.eat(G.eq) ? r.init = this.parseMaybeAssign(t) : n !== "const" || this.type === G._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? r.id.type === "Identifier" || t && (this.type === G._in || this.isContextual("of")) ? r.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e.declarations.push(this.finishNode(r, "VariableDeclarator")), !this.eat(G.comma))
      break;
  }
  return e;
}, lt.parseVarId = function(e, t) {
  e.id = this.parseBindingAtom(), this.checkLVal(e.id, t === "var" ? 1 : 2, !1);
};
var Wu = 1, Vm = 2;
lt.parseFunction = function(e, t, n, r) {
  this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !r) && (this.type === G.star && t & Vm && this.unexpected(), e.generator = this.eat(G.star)), this.options.ecmaVersion >= 8 && (e.async = !!r), t & Wu && (e.id = 4 & t && this.type !== G.name ? null : this.parseIdent(), !e.id || t & Vm || this.checkLVal(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i = this.yieldPos, a = this.awaitPos, s = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Rm(e.async, e.generator)), t & Wu || (e.id = this.type === G.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, n, !1), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = s, this.finishNode(e, t & Wu ? "FunctionDeclaration" : "FunctionExpression");
}, lt.parseFunctionParams = function(e) {
  this.expect(G.parenL), e.params = this.parseBindingList(G.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, lt.parseClass = function(e, t) {
  this.next();
  var n = this.strict;
  this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
  var r = this.startNode(), i = !1;
  for (r.body = [], this.expect(G.braceL); !this.eat(G.braceR); ) {
    var a = this.parseClassElement(e.superClass !== null);
    a && (r.body.push(a), a.type === "MethodDefinition" && a.kind === "constructor" && (i && this.raise(a.start, "Duplicate constructor in the same class"), i = !0));
  }
  return e.body = this.finishNode(r, "ClassBody"), this.strict = n, this.finishNode(e, t ? "ClassDeclaration" : "ClassExpression");
}, lt.parseClassElement = function(e) {
  var t = this;
  if (this.eat(G.semi))
    return null;
  var n = this.startNode(), r = function(u, c) {
    c === void 0 && (c = !1);
    var f = t.start, p = t.startLoc;
    return !!t.eatContextual(u) && (!(t.type === G.parenL || c && t.canInsertSemicolon()) || (n.key && t.unexpected(), n.computed = !1, n.key = t.startNodeAt(f, p), n.key.name = u, t.finishNode(n.key, "Identifier"), !1));
  };
  n.kind = "method", n.static = r("static");
  var i = this.eat(G.star), a = !1;
  i || (this.options.ecmaVersion >= 8 && r("async", !0) ? (a = !0, i = this.options.ecmaVersion >= 9 && this.eat(G.star)) : r("get") ? n.kind = "get" : r("set") && (n.kind = "set")), n.key || this.parsePropertyName(n);
  var s = n.key, o = !1;
  return n.computed || n.static || !(s.type === "Identifier" && s.name === "constructor" || s.type === "Literal" && s.value === "constructor") ? n.static && s.type === "Identifier" && s.name === "prototype" && this.raise(s.start, "Classes may not have a static property named prototype") : (n.kind !== "method" && this.raise(s.start, "Constructor can't have get/set modifier"), i && this.raise(s.start, "Constructor can't be a generator"), a && this.raise(s.start, "Constructor can't be an async method"), n.kind = "constructor", o = e), this.parseClassMethod(n, i, a, o), n.kind === "get" && n.value.params.length !== 0 && this.raiseRecoverable(n.value.start, "getter should have no params"), n.kind === "set" && n.value.params.length !== 1 && this.raiseRecoverable(n.value.start, "setter should have exactly one param"), n.kind === "set" && n.value.params[0].type === "RestElement" && this.raiseRecoverable(n.value.params[0].start, "Setter cannot use rest params"), n;
}, lt.parseClassMethod = function(e, t, n, r) {
  return e.value = this.parseMethod(t, n, r), this.finishNode(e, "MethodDefinition");
}, lt.parseClassId = function(e, t) {
  this.type === G.name ? (e.id = this.parseIdent(), t && this.checkLVal(e.id, 2, !1)) : (t === !0 && this.unexpected(), e.id = null);
}, lt.parseClassSuper = function(e) {
  e.superClass = this.eat(G._extends) ? this.parseExprSubscripts() : null;
}, lt.parseExport = function(e, t) {
  if (this.next(), this.eat(G.star))
    return this.expectContextual("from"), this.type !== G.string && this.unexpected(), e.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e, "ExportAllDeclaration");
  if (this.eat(G._default)) {
    var n;
    if (this.checkExport(t, "default", this.lastTokStart), this.type === G._function || (n = this.isAsyncFunction())) {
      var r = this.startNode();
      this.next(), n && this.next(), e.declaration = this.parseFunction(r, 4 | Wu, !1, n);
    } else if (this.type === G._class) {
      var i = this.startNode();
      e.declaration = this.parseClass(i, "nullableID");
    } else
      e.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e.declaration = this.parseStatement(null), e.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id.name, e.declaration.id.start), e.specifiers = [], e.source = null;
  else {
    if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from"))
      this.type !== G.string && this.unexpected(), e.source = this.parseExprAtom();
    else {
      for (var a = 0, s = e.specifiers; a < s.length; a += 1) {
        var o = s[a];
        this.checkUnreserved(o.local), this.checkLocalExport(o.local);
      }
      e.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e, "ExportNamedDeclaration");
}, lt.checkExport = function(e, t, n) {
  e && (mf(e, t) && this.raiseRecoverable(n, "Duplicate export '" + t + "'"), e[t] = !0);
}, lt.checkPatternExport = function(e, t) {
  var n = t.type;
  if (n === "Identifier")
    this.checkExport(e, t.name, t.start);
  else if (n === "ObjectPattern")
    for (var r = 0, i = t.properties; r < i.length; r += 1) {
      var a = i[r];
      this.checkPatternExport(e, a);
    }
  else if (n === "ArrayPattern")
    for (var s = 0, o = t.elements; s < o.length; s += 1) {
      var u = o[s];
      u && this.checkPatternExport(e, u);
    }
  else
    n === "Property" ? this.checkPatternExport(e, t.value) : n === "AssignmentPattern" ? this.checkPatternExport(e, t.left) : n === "RestElement" ? this.checkPatternExport(e, t.argument) : n === "ParenthesizedExpression" && this.checkPatternExport(e, t.expression);
}, lt.checkVariableExport = function(e, t) {
  if (e)
    for (var n = 0, r = t; n < r.length; n += 1) {
      var i = r[n];
      this.checkPatternExport(e, i.id);
    }
}, lt.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, lt.parseExportSpecifiers = function(e) {
  var t = [], n = !0;
  for (this.expect(G.braceL); !this.eat(G.braceR); ) {
    if (n)
      n = !1;
    else if (this.expect(G.comma), this.afterTrailingComma(G.braceR))
      break;
    var r = this.startNode();
    r.local = this.parseIdent(!0), r.exported = this.eatContextual("as") ? this.parseIdent(!0) : r.local, this.checkExport(e, r.exported.name, r.exported.start), t.push(this.finishNode(r, "ExportSpecifier"));
  }
  return t;
}, lt.parseImport = function(e) {
  return this.next(), this.type === G.string ? (e.specifiers = U9, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e.source = this.type === G.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e, "ImportDeclaration");
}, lt.parseImportSpecifiers = function() {
  var e = [], t = !0;
  if (this.type === G.name) {
    var n = this.startNode();
    if (n.local = this.parseIdent(), this.checkLVal(n.local, 2), e.push(this.finishNode(n, "ImportDefaultSpecifier")), !this.eat(G.comma))
      return e;
  }
  if (this.type === G.star) {
    var r = this.startNode();
    return this.next(), this.expectContextual("as"), r.local = this.parseIdent(), this.checkLVal(r.local, 2), e.push(this.finishNode(r, "ImportNamespaceSpecifier")), e;
  }
  for (this.expect(G.braceL); !this.eat(G.braceR); ) {
    if (t)
      t = !1;
    else if (this.expect(G.comma), this.afterTrailingComma(G.braceR))
      break;
    var i = this.startNode();
    i.imported = this.parseIdent(!0), this.eatContextual("as") ? i.local = this.parseIdent() : (this.checkUnreserved(i.imported), i.local = i.imported), this.checkLVal(i.local, 2), e.push(this.finishNode(i, "ImportSpecifier"));
  }
  return e;
}, lt.adaptDirectivePrologue = function(e) {
  for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
    e[t].directive = e[t].expression.raw.slice(1, -1);
}, lt.isDirectiveCandidate = function(e) {
  return e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && (this.input[e.start] === '"' || this.input[e.start] === "'");
};
var ca = fn.prototype;
ca.toAssignable = function(e, t, n) {
  if (this.options.ecmaVersion >= 6 && e)
    switch (e.type) {
      case "Identifier":
        this.inAsync && e.name === "await" && this.raise(e.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e.type = "ObjectPattern", n && this.checkPatternErrors(n, !0);
        for (var r = 0, i = e.properties; r < i.length; r += 1) {
          var a = i[r];
          this.toAssignable(a, t), a.type !== "RestElement" || a.argument.type !== "ArrayPattern" && a.argument.type !== "ObjectPattern" || this.raise(a.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e.kind !== "init" && this.raise(e.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e.value, t);
        break;
      case "ArrayExpression":
        e.type = "ArrayPattern", n && this.checkPatternErrors(n, !0), this.toAssignableList(e.elements, t);
        break;
      case "SpreadElement":
        e.type = "RestElement", this.toAssignable(e.argument, t), e.argument.type === "AssignmentPattern" && this.raise(e.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e.operator !== "=" && this.raise(e.left.end, "Only '=' operator can be used for specifying default value."), e.type = "AssignmentPattern", delete e.operator, this.toAssignable(e.left, t);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e.expression, t, n);
        break;
      case "MemberExpression":
        if (!t)
          break;
      default:
        this.raise(e.start, "Assigning to rvalue");
    }
  else
    n && this.checkPatternErrors(n, !0);
  return e;
}, ca.toAssignableList = function(e, t) {
  for (var n = e.length, r = 0; r < n; r++) {
    var i = e[r];
    i && this.toAssignable(i, t);
  }
  if (n) {
    var a = e[n - 1];
    this.options.ecmaVersion === 6 && t && a && a.type === "RestElement" && a.argument.type !== "Identifier" && this.unexpected(a.argument.start);
  }
  return e;
}, ca.parseSpread = function(e) {
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, "SpreadElement");
}, ca.parseRestBinding = function() {
  var e = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== G.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, "RestElement");
}, ca.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case G.bracketL:
        var e = this.startNode();
        return this.next(), e.elements = this.parseBindingList(G.bracketR, !0, !0), this.finishNode(e, "ArrayPattern");
      case G.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
}, ca.parseBindingList = function(e, t, n) {
  for (var r = [], i = !0; !this.eat(e); )
    if (i ? i = !1 : this.expect(G.comma), t && this.type === G.comma)
      r.push(null);
    else {
      if (n && this.afterTrailingComma(e))
        break;
      if (this.type === G.ellipsis) {
        var a = this.parseRestBinding();
        this.parseBindingListItem(a), r.push(a), this.type === G.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e);
        break;
      }
      var s = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(s), r.push(s);
    }
  return r;
}, ca.parseBindingListItem = function(e) {
  return e;
}, ca.parseMaybeDefault = function(e, t, n) {
  if (n = n || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(G.eq))
    return n;
  var r = this.startNodeAt(e, t);
  return r.left = n, r.right = this.parseMaybeAssign(), this.finishNode(r, "AssignmentPattern");
}, ca.checkLVal = function(e, t, n) {
  switch (t === void 0 && (t = 0), e.type) {
    case "Identifier":
      t === 2 && e.name === "let" && this.raiseRecoverable(e.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (t ? "Binding " : "Assigning to ") + e.name + " in strict mode"), n && (mf(n, e.name) && this.raiseRecoverable(e.start, "Argument name clash"), n[e.name] = !0), t !== 0 && t !== 5 && this.declareName(e.name, t, e.start);
      break;
    case "MemberExpression":
      t && this.raiseRecoverable(e.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var r = 0, i = e.properties; r < i.length; r += 1) {
        var a = i[r];
        this.checkLVal(a, t, n);
      }
      break;
    case "Property":
      this.checkLVal(e.value, t, n);
      break;
    case "ArrayPattern":
      for (var s = 0, o = e.elements; s < o.length; s += 1) {
        var u = o[s];
        u && this.checkLVal(u, t, n);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e.left, t, n);
      break;
    case "RestElement":
      this.checkLVal(e.argument, t, n);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e.expression, t, n);
      break;
    default:
      this.raise(e.start, (t ? "Binding" : "Assigning to") + " rvalue");
  }
};
var Et = fn.prototype;
Et.checkPropClash = function(e, t, n) {
  if (!(this.options.ecmaVersion >= 9 && e.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
    var r, i = e.key;
    switch (i.type) {
      case "Identifier":
        r = i.name;
        break;
      case "Literal":
        r = String(i.value);
        break;
      default:
        return;
    }
    var a = e.kind;
    if (this.options.ecmaVersion >= 6)
      r === "__proto__" && a === "init" && (t.proto && (n && n.doubleProto < 0 ? n.doubleProto = i.start : this.raiseRecoverable(i.start, "Redefinition of __proto__ property")), t.proto = !0);
    else {
      var s = t[r = "$" + r];
      s ? (a === "init" ? this.strict && s.init || s.get || s.set : s.init || s[a]) && this.raiseRecoverable(i.start, "Redefinition of property") : s = t[r] = { init: !1, get: !1, set: !1 }, s[a] = !0;
    }
  }
}, Et.parseExpression = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseMaybeAssign(e, t);
  if (this.type === G.comma) {
    var a = this.startNodeAt(n, r);
    for (a.expressions = [i]; this.eat(G.comma); )
      a.expressions.push(this.parseMaybeAssign(e, t));
    return this.finishNode(a, "SequenceExpression");
  }
  return i;
}, Et.parseMaybeAssign = function(e, t, n) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e);
    this.exprAllowed = !1;
  }
  var r = !1, i = -1, a = -1, s = -1;
  t ? (i = t.parenthesizedAssign, a = t.trailingComma, s = t.shorthandAssign, t.parenthesizedAssign = t.trailingComma = t.shorthandAssign = -1) : (t = new qu(), r = !0);
  var o = this.start, u = this.startLoc;
  this.type !== G.parenL && this.type !== G.name || (this.potentialArrowAt = this.start);
  var c = this.parseMaybeConditional(e, t);
  if (n && (c = n.call(this, c, o, u)), this.type.isAssign) {
    var f = this.startNodeAt(o, u);
    return f.operator = this.value, f.left = this.type === G.eq ? this.toAssignable(c, !1, t) : c, r || qu.call(t), t.shorthandAssign = -1, this.checkLVal(c), this.next(), f.right = this.parseMaybeAssign(e), this.finishNode(f, "AssignmentExpression");
  }
  return r && this.checkExpressionErrors(t, !0), i > -1 && (t.parenthesizedAssign = i), a > -1 && (t.trailingComma = a), s > -1 && (t.shorthandAssign = s), c;
}, Et.parseMaybeConditional = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseExprOps(e, t);
  if (this.checkExpressionErrors(t))
    return i;
  if (this.eat(G.question)) {
    var a = this.startNodeAt(n, r);
    return a.test = i, a.consequent = this.parseMaybeAssign(), this.expect(G.colon), a.alternate = this.parseMaybeAssign(e), this.finishNode(a, "ConditionalExpression");
  }
  return i;
}, Et.parseExprOps = function(e, t) {
  var n = this.start, r = this.startLoc, i = this.parseMaybeUnary(t, !1);
  return this.checkExpressionErrors(t) || i.start === n && i.type === "ArrowFunctionExpression" ? i : this.parseExprOp(i, n, r, -1, e);
}, Et.parseExprOp = function(e, t, n, r, i) {
  var a = this.type.binop;
  if (a != null && (!i || this.type !== G._in) && a > r) {
    var s = this.type === G.logicalOR || this.type === G.logicalAND, o = this.value;
    this.next();
    var u = this.start, c = this.startLoc, f = this.parseExprOp(this.parseMaybeUnary(null, !1), u, c, a, i), p = this.buildBinary(t, n, e, f, o, s);
    return this.parseExprOp(p, t, n, r, i);
  }
  return e;
}, Et.buildBinary = function(e, t, n, r, i, a) {
  var s = this.startNodeAt(e, t);
  return s.left = n, s.operator = i, s.right = r, this.finishNode(s, a ? "LogicalExpression" : "BinaryExpression");
}, Et.parseMaybeUnary = function(e, t) {
  var n, r = this.start, i = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    n = this.parseAwait(), t = !0;
  else if (this.type.prefix) {
    var a = this.startNode(), s = this.type === G.incDec;
    a.operator = this.value, a.prefix = !0, this.next(), a.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(e, !0), s ? this.checkLVal(a.argument) : this.strict && a.operator === "delete" && a.argument.type === "Identifier" ? this.raiseRecoverable(a.start, "Deleting local variable in strict mode") : t = !0, n = this.finishNode(a, s ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (n = this.parseExprSubscripts(e), this.checkExpressionErrors(e))
      return n;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var o = this.startNodeAt(r, i);
      o.operator = this.value, o.prefix = !1, o.argument = n, this.checkLVal(n), this.next(), n = this.finishNode(o, "UpdateExpression");
    }
  }
  return !t && this.eat(G.starstar) ? this.buildBinary(r, i, n, this.parseMaybeUnary(null, !1), "**", !1) : n;
}, Et.parseExprSubscripts = function(e) {
  var t = this.start, n = this.startLoc, r = this.parseExprAtom(e), i = r.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e) || i)
    return r;
  var a = this.parseSubscripts(r, t, n);
  return e && a.type === "MemberExpression" && (e.parenthesizedAssign >= a.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= a.start && (e.parenthesizedBind = -1)), a;
}, Et.parseSubscripts = function(e, t, n, r) {
  for (var i = this.options.ecmaVersion >= 8 && e.type === "Identifier" && e.name === "async" && this.lastTokEnd === e.end && !this.canInsertSemicolon() && this.input.slice(e.start, e.end) === "async"; ; ) {
    var a = this.parseSubscript(e, t, n, r, i);
    if (a === e || a.type === "ArrowFunctionExpression")
      return a;
    e = a;
  }
}, Et.parseSubscript = function(e, t, n, r, i) {
  var a = this.eat(G.bracketL);
  if (a || this.eat(G.dot)) {
    var s = this.startNodeAt(t, n);
    s.object = e, s.property = a ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), s.computed = !!a, a && this.expect(G.bracketR), e = this.finishNode(s, "MemberExpression");
  } else if (!r && this.eat(G.parenL)) {
    var o = new qu(), u = this.yieldPos, c = this.awaitPos, f = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p = this.parseExprList(G.parenR, this.options.ecmaVersion >= 8 && e.type !== "Import", !1, o);
    if (i && !this.canInsertSemicolon() && this.eat(G.arrow))
      return this.checkPatternErrors(o, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u, this.awaitPos = c, this.awaitIdentPos = f, this.parseArrowExpression(this.startNodeAt(t, n), p, !0);
    this.checkExpressionErrors(o, !0), this.yieldPos = u || this.yieldPos, this.awaitPos = c || this.awaitPos, this.awaitIdentPos = f || this.awaitIdentPos;
    var d = this.startNodeAt(t, n);
    if (d.callee = e, d.arguments = p, d.callee.type === "Import") {
      d.arguments.length !== 1 && this.raise(d.start, "import() requires exactly one argument");
      var m = d.arguments[0];
      m && m.type === "SpreadElement" && this.raise(m.start, "... is not allowed in import()");
    }
    e = this.finishNode(d, "CallExpression");
  } else if (this.type === G.backQuote) {
    var y = this.startNodeAt(t, n);
    y.tag = e, y.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(y, "TaggedTemplateExpression");
  }
  return e;
}, Et.parseExprAtom = function(e) {
  this.type === G.slash && this.readRegexp();
  var t, n = this.potentialArrowAt === this.start;
  switch (this.type) {
    case G._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t = this.startNode(), this.next(), this.type !== G.parenL || this.allowDirectSuper || this.raise(t.start, "super() call outside constructor of a subclass"), this.type !== G.dot && this.type !== G.bracketL && this.type !== G.parenL && this.unexpected(), this.finishNode(t, "Super");
    case G._this:
      return t = this.startNode(), this.next(), this.finishNode(t, "ThisExpression");
    case G.name:
      var r = this.start, i = this.startLoc, a = this.containsEsc, s = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !a && s.name === "async" && !this.canInsertSemicolon() && this.eat(G._function))
        return this.parseFunction(this.startNodeAt(r, i), 0, !1, !0);
      if (n && !this.canInsertSemicolon()) {
        if (this.eat(G.arrow))
          return this.parseArrowExpression(this.startNodeAt(r, i), [s], !1);
        if (this.options.ecmaVersion >= 8 && s.name === "async" && this.type === G.name && !a)
          return s = this.parseIdent(!1), !this.canInsertSemicolon() && this.eat(G.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(r, i), [s], !0);
      }
      return s;
    case G.regexp:
      var o = this.value;
      return (t = this.parseLiteral(o.value)).regex = { pattern: o.pattern, flags: o.flags }, t;
    case G.num:
    case G.string:
      return this.parseLiteral(this.value);
    case G._null:
    case G._true:
    case G._false:
      return (t = this.startNode()).value = this.type === G._null ? null : this.type === G._true, t.raw = this.type.keyword, this.next(), this.finishNode(t, "Literal");
    case G.parenL:
      var u = this.start, c = this.parseParenAndDistinguishExpression(n);
      return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c) && (e.parenthesizedAssign = u), e.parenthesizedBind < 0 && (e.parenthesizedBind = u)), c;
    case G.bracketL:
      return t = this.startNode(), this.next(), t.elements = this.parseExprList(G.bracketR, !0, !0, e), this.finishNode(t, "ArrayExpression");
    case G.braceL:
      return this.parseObj(!1, e);
    case G._function:
      return t = this.startNode(), this.next(), this.parseFunction(t, 0);
    case G._class:
      return this.parseClass(this.startNode(), !1);
    case G._new:
      return this.parseNew();
    case G.backQuote:
      return this.parseTemplate();
    case G._import:
      return this.options.ecmaVersion > 10 ? this.parseDynamicImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, Et.parseDynamicImport = function() {
  var e = this.startNode();
  return this.next(), this.type !== G.parenL && this.unexpected(), this.finishNode(e, "Import");
}, Et.parseLiteral = function(e) {
  var t = this.startNode();
  return t.value = e, t.raw = this.input.slice(this.start, this.end), t.raw.charCodeAt(t.raw.length - 1) === 110 && (t.bigint = t.raw.slice(0, -1)), this.next(), this.finishNode(t, "Literal");
}, Et.parseParenExpression = function() {
  this.expect(G.parenL);
  var e = this.parseExpression();
  return this.expect(G.parenR), e;
}, Et.parseParenAndDistinguishExpression = function(e) {
  var t, n = this.start, r = this.startLoc, i = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a, s = this.start, o = this.startLoc, u = [], c = !0, f = !1, p = new qu(), d = this.yieldPos, m = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== G.parenR; ) {
      if (c ? c = !1 : this.expect(G.comma), i && this.afterTrailingComma(G.parenR, !0)) {
        f = !0;
        break;
      }
      if (this.type === G.ellipsis) {
        a = this.start, u.push(this.parseParenItem(this.parseRestBinding())), this.type === G.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u.push(this.parseMaybeAssign(!1, p, this.parseParenItem));
    }
    var y = this.start, v = this.startLoc;
    if (this.expect(G.parenR), e && !this.canInsertSemicolon() && this.eat(G.arrow))
      return this.checkPatternErrors(p, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = d, this.awaitPos = m, this.parseParenArrowList(n, r, u);
    u.length && !f || this.unexpected(this.lastTokStart), a && this.unexpected(a), this.checkExpressionErrors(p, !0), this.yieldPos = d || this.yieldPos, this.awaitPos = m || this.awaitPos, u.length > 1 ? ((t = this.startNodeAt(s, o)).expressions = u, this.finishNodeAt(t, "SequenceExpression", y, v)) : t = u[0];
  } else
    t = this.parseParenExpression();
  if (this.options.preserveParens) {
    var b = this.startNodeAt(n, r);
    return b.expression = t, this.finishNode(b, "ParenthesizedExpression");
  }
  return t;
}, Et.parseParenItem = function(e) {
  return e;
}, Et.parseParenArrowList = function(e, t, n) {
  return this.parseArrowExpression(this.startNodeAt(e, t), n);
};
var q9 = [];
Et.parseNew = function() {
  var e = this.startNode(), t = this.parseIdent(!0);
  if (this.options.ecmaVersion >= 6 && this.eat(G.dot)) {
    e.meta = t;
    var n = this.containsEsc;
    return e.property = this.parseIdent(!0), (e.property.name !== "target" || n) && this.raiseRecoverable(e.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e.start, "new.target can only be used in functions"), this.finishNode(e, "MetaProperty");
  }
  var r = this.start, i = this.startLoc;
  return e.callee = this.parseSubscripts(this.parseExprAtom(), r, i, !0), this.options.ecmaVersion > 10 && e.callee.type === "Import" && this.raise(e.callee.start, "Cannot use new with import(...)"), this.eat(G.parenL) ? e.arguments = this.parseExprList(G.parenR, this.options.ecmaVersion >= 8 && e.callee.type !== "Import", !1) : e.arguments = q9, this.finishNode(e, "NewExpression");
}, Et.parseTemplateElement = function(e) {
  var t = e.isTagged, n = this.startNode();
  return this.type === G.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), n.value = { raw: this.value, cooked: null }) : n.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`), cooked: this.value }, this.next(), n.tail = this.type === G.backQuote, this.finishNode(n, "TemplateElement");
}, Et.parseTemplate = function(e) {
  e === void 0 && (e = {});
  var t = e.isTagged;
  t === void 0 && (t = !1);
  var n = this.startNode();
  this.next(), n.expressions = [];
  var r = this.parseTemplateElement({ isTagged: t });
  for (n.quasis = [r]; !r.tail; )
    this.type === G.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(G.dollarBraceL), n.expressions.push(this.parseExpression()), this.expect(G.braceR), n.quasis.push(r = this.parseTemplateElement({ isTagged: t }));
  return this.next(), this.finishNode(n, "TemplateLiteral");
}, Et.isAsyncProp = function(e) {
  return !e.computed && e.key.type === "Identifier" && e.key.name === "async" && (this.type === G.name || this.type === G.num || this.type === G.string || this.type === G.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === G.star) && !li.test(this.input.slice(this.lastTokEnd, this.start));
}, Et.parseObj = function(e, t) {
  var n = this.startNode(), r = !0, i = {};
  for (n.properties = [], this.next(); !this.eat(G.braceR); ) {
    if (r)
      r = !1;
    else if (this.expect(G.comma), this.afterTrailingComma(G.braceR))
      break;
    var a = this.parseProperty(e, t);
    e || this.checkPropClash(a, i, t), n.properties.push(a);
  }
  return this.finishNode(n, e ? "ObjectPattern" : "ObjectExpression");
}, Et.parseProperty = function(e, t) {
  var n, r, i, a, s = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat(G.ellipsis))
    return e ? (s.argument = this.parseIdent(!1), this.type === G.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(s, "RestElement")) : (this.type === G.parenL && t && (t.parenthesizedAssign < 0 && (t.parenthesizedAssign = this.start), t.parenthesizedBind < 0 && (t.parenthesizedBind = this.start)), s.argument = this.parseMaybeAssign(!1, t), this.type === G.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(s, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (s.method = !1, s.shorthand = !1, (e || t) && (i = this.start, a = this.startLoc), e || (n = this.eat(G.star)));
  var o = this.containsEsc;
  return this.parsePropertyName(s), !e && !o && this.options.ecmaVersion >= 8 && !n && this.isAsyncProp(s) ? (r = !0, n = this.options.ecmaVersion >= 9 && this.eat(G.star), this.parsePropertyName(s, t)) : r = !1, this.parsePropertyValue(s, e, n, r, i, a, t, o), this.finishNode(s, "Property");
}, Et.parsePropertyValue = function(e, t, n, r, i, a, s, o) {
  if ((n || r) && this.type === G.colon && this.unexpected(), this.eat(G.colon))
    e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, s), e.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === G.parenL)
    t && this.unexpected(), e.kind = "init", e.method = !0, e.value = this.parseMethod(n, r);
  else if (t || o || !(this.options.ecmaVersion >= 5) || e.computed || e.key.type !== "Identifier" || e.key.name !== "get" && e.key.name !== "set" || this.type === G.comma || this.type === G.braceR)
    this.options.ecmaVersion >= 6 && !e.computed && e.key.type === "Identifier" ? ((n || r) && this.unexpected(), this.checkUnreserved(e.key), e.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i), e.kind = "init", t ? e.value = this.parseMaybeDefault(i, a, e.key) : this.type === G.eq && s ? (s.shorthandAssign < 0 && (s.shorthandAssign = this.start), e.value = this.parseMaybeDefault(i, a, e.key)) : e.value = e.key, e.shorthand = !0) : this.unexpected();
  else {
    (n || r) && this.unexpected(), e.kind = e.key.name, this.parsePropertyName(e), e.value = this.parseMethod(!1);
    var u = e.kind === "get" ? 0 : 1;
    if (e.value.params.length !== u) {
      var c = e.value.start;
      e.kind === "get" ? this.raiseRecoverable(c, "getter should have no params") : this.raiseRecoverable(c, "setter should have exactly one param");
    } else
      e.kind === "set" && e.value.params[0].type === "RestElement" && this.raiseRecoverable(e.value.params[0].start, "Setter cannot use rest params");
  }
}, Et.parsePropertyName = function(e) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(G.bracketL))
      return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect(G.bracketR), e.key;
    e.computed = !1;
  }
  return e.key = this.type === G.num || this.type === G.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, Et.initFunction = function(e) {
  e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
}, Et.parseMethod = function(e, t, n) {
  var r = this.startNode(), i = this.yieldPos, a = this.awaitPos, s = this.awaitIdentPos;
  return this.initFunction(r), this.options.ecmaVersion >= 6 && (r.generator = e), this.options.ecmaVersion >= 8 && (r.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | Rm(t, r.generator) | (n ? 128 : 0)), this.expect(G.parenL), r.params = this.parseBindingList(G.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(r, !1, !0), this.yieldPos = i, this.awaitPos = a, this.awaitIdentPos = s, this.finishNode(r, "FunctionExpression");
}, Et.parseArrowExpression = function(e, t, n) {
  var r = this.yieldPos, i = this.awaitPos, a = this.awaitIdentPos;
  return this.enterScope(16 | Rm(n, !1)), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!n), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1), this.yieldPos = r, this.awaitPos = i, this.awaitIdentPos = a, this.finishNode(e, "ArrowFunctionExpression");
}, Et.parseFunctionBody = function(e, t, n) {
  var r = t && this.type !== G.braceL, i = this.strict, a = !1;
  if (r)
    e.body = this.parseMaybeAssign(), e.expression = !0, this.checkParams(e, !1);
  else {
    var s = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
    i && !s || (a = this.strictDirective(this.end)) && s && this.raiseRecoverable(e.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var o = this.labels;
    this.labels = [], a && (this.strict = !0), this.checkParams(e, !i && !a && !t && !n && this.isSimpleParamList(e.params)), e.body = this.parseBlock(!1), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = o;
  }
  this.exitScope(), this.strict && e.id && this.checkLVal(e.id, 5), this.strict = i;
}, Et.isSimpleParamList = function(e) {
  for (var t = 0, n = e; t < n.length; t += 1)
    if (n[t].type !== "Identifier")
      return !1;
  return !0;
}, Et.checkParams = function(e, t) {
  for (var n = {}, r = 0, i = e.params; r < i.length; r += 1) {
    var a = i[r];
    this.checkLVal(a, 1, t ? null : n);
  }
}, Et.parseExprList = function(e, t, n, r) {
  for (var i = [], a = !0; !this.eat(e); ) {
    if (a)
      a = !1;
    else if (this.expect(G.comma), t && this.afterTrailingComma(e))
      break;
    var s = void 0;
    n && this.type === G.comma ? s = null : this.type === G.ellipsis ? (s = this.parseSpread(r), r && this.type === G.comma && r.trailingComma < 0 && (r.trailingComma = this.start)) : s = this.parseMaybeAssign(!1, r), i.push(s);
  }
  return i;
}, Et.checkUnreserved = function(e) {
  var t = e.start, n = e.end, r = e.name;
  this.inGenerator && r === "yield" && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && r === "await" && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(r) && this.raise(t, "Unexpected keyword '" + r + "'"), this.options.ecmaVersion < 6 && this.input.slice(t, n).indexOf("\\") !== -1 || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(r) && (this.inAsync || r !== "await" || this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + r + "' is reserved"));
}, Et.parseIdent = function(e, t) {
  var n = this.startNode();
  return this.type === G.name ? n.name = this.value : this.type.keyword ? (n.name = this.type.keyword, n.name !== "class" && n.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(n, "Identifier"), e || (this.checkUnreserved(n), n.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = n.start)), n;
}, Et.parseYield = function(e) {
  this.yieldPos || (this.yieldPos = this.start);
  var t = this.startNode();
  return this.next(), this.type === G.semi || this.canInsertSemicolon() || this.type !== G.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(G.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, "YieldExpression");
}, Et.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e = this.startNode();
  return this.next(), e.argument = this.parseMaybeUnary(null, !0), this.finishNode(e, "AwaitExpression");
};
var Nl = fn.prototype;
Nl.raise = function(e, t) {
  var n = z0(this.input, e);
  t += " (" + n.line + ":" + n.column + ")";
  var r = new SyntaxError(t);
  throw r.pos = e, r.loc = n, r.raisedAt = this.pos, r;
}, Nl.raiseRecoverable = Nl.raise, Nl.curPosition = function() {
  if (this.options.locations)
    return new Hs(this.curLine, this.pos - this.lineStart);
};
var Wa = fn.prototype, W9 = function(e) {
  this.flags = e, this.var = [], this.lexical = [], this.functions = [];
};
Wa.enterScope = function(e) {
  this.scopeStack.push(new W9(e));
}, Wa.exitScope = function() {
  this.scopeStack.pop();
}, Wa.treatFunctionsAsVarInScope = function(e) {
  return e.flags & fc || !this.inModule && 1 & e.flags;
}, Wa.declareName = function(e, t, n) {
  var r = !1;
  if (t === 2) {
    var i = this.currentScope();
    r = i.lexical.indexOf(e) > -1 || i.functions.indexOf(e) > -1 || i.var.indexOf(e) > -1, i.lexical.push(e), this.inModule && 1 & i.flags && delete this.undefinedExports[e];
  } else if (t === 4)
    this.currentScope().lexical.push(e);
  else if (t === 3) {
    var a = this.currentScope();
    r = this.treatFunctionsAsVar ? a.lexical.indexOf(e) > -1 : a.lexical.indexOf(e) > -1 || a.var.indexOf(e) > -1, a.functions.push(e);
  } else
    for (var s = this.scopeStack.length - 1; s >= 0; --s) {
      var o = this.scopeStack[s];
      if (o.lexical.indexOf(e) > -1 && !(32 & o.flags && o.lexical[0] === e) || !this.treatFunctionsAsVarInScope(o) && o.functions.indexOf(e) > -1) {
        r = !0;
        break;
      }
      if (o.var.push(e), this.inModule && 1 & o.flags && delete this.undefinedExports[e], o.flags & kd)
        break;
    }
  r && this.raiseRecoverable(n, "Identifier '" + e + "' has already been declared");
}, Wa.checkLocalExport = function(e) {
  this.scopeStack[0].lexical.indexOf(e.name) === -1 && this.scopeStack[0].var.indexOf(e.name) === -1 && (this.undefinedExports[e.name] = e);
}, Wa.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, Wa.currentVarScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & kd)
      return t;
  }
}, Wa.currentThisScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & kd && !(16 & t.flags))
      return t;
  }
};
var Rp = function(e, t, n) {
  this.type = "", this.start = t, this.end = 0, e.options.locations && (this.loc = new kc(e, n)), e.options.directSourceFile && (this.sourceFile = e.options.directSourceFile), e.options.ranges && (this.range = [t, 0]);
}, jl = fn.prototype;
function Sx(e, t, n, r) {
  return e.type = t, e.end = n, this.options.locations && (e.loc.end = r), this.options.ranges && (e.range[1] = n), e;
}
jl.startNode = function() {
  return new Rp(this, this.start, this.startLoc);
}, jl.startNodeAt = function(e, t) {
  return new Rp(this, e, t);
}, jl.finishNode = function(e, t) {
  return Sx.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
}, jl.finishNodeAt = function(e, t, n, r) {
  return Sx.call(this, e, t, n, r);
};
var ei = function(e, t, n, r, i) {
  this.token = e, this.isExpr = !!t, this.preserveSpace = !!n, this.override = r, this.generator = !!i;
}, yn = { b_stat: new ei("{", !1), b_expr: new ei("{", !0), b_tmpl: new ei("${", !1), p_stat: new ei("(", !1), p_expr: new ei("(", !0), q_tmpl: new ei("`", !0, !0, function(e) {
  return e.tryReadTemplateToken();
}), f_stat: new ei("function", !1), f_expr: new ei("function", !0), f_expr_gen: new ei("function", !0, !1, null, !0), f_gen: new ei("function", !1, !1, null, !0) }, Rl = fn.prototype;
Rl.initialContext = function() {
  return [yn.b_stat];
}, Rl.braceIsBlock = function(e) {
  var t = this.curContext();
  return t === yn.f_expr || t === yn.f_stat || (e !== G.colon || t !== yn.b_stat && t !== yn.b_expr ? e === G._return || e === G.name && this.exprAllowed ? li.test(this.input.slice(this.lastTokEnd, this.start)) : e === G._else || e === G.semi || e === G.eof || e === G.parenR || e === G.arrow || (e === G.braceL ? t === yn.b_stat : e !== G._var && e !== G._const && e !== G.name && !this.exprAllowed) : !t.isExpr);
}, Rl.inGeneratorContext = function() {
  for (var e = this.context.length - 1; e >= 1; e--) {
    var t = this.context[e];
    if (t.token === "function")
      return t.generator;
  }
  return !1;
}, Rl.updateContext = function(e) {
  var t, n = this.type;
  n.keyword && e === G.dot ? this.exprAllowed = !1 : (t = n.updateContext) ? t.call(this, e) : this.exprAllowed = n.beforeExpr;
}, G.parenR.updateContext = G.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e = this.context.pop();
    e === yn.b_stat && this.curContext().token === "function" && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
  } else
    this.exprAllowed = !0;
}, G.braceL.updateContext = function(e) {
  this.context.push(this.braceIsBlock(e) ? yn.b_stat : yn.b_expr), this.exprAllowed = !0;
}, G.dollarBraceL.updateContext = function() {
  this.context.push(yn.b_tmpl), this.exprAllowed = !0;
}, G.parenL.updateContext = function(e) {
  var t = e === G._if || e === G._for || e === G._with || e === G._while;
  this.context.push(t ? yn.p_stat : yn.p_expr), this.exprAllowed = !0;
}, G.incDec.updateContext = function() {
}, G._function.updateContext = G._class.updateContext = function(e) {
  !e.beforeExpr || e === G.semi || e === G._else || e === G._return && li.test(this.input.slice(this.lastTokEnd, this.start)) || (e === G.colon || e === G.braceL) && this.curContext() === yn.b_stat ? this.context.push(yn.f_stat) : this.context.push(yn.f_expr), this.exprAllowed = !1;
}, G.backQuote.updateContext = function() {
  this.curContext() === yn.q_tmpl ? this.context.pop() : this.context.push(yn.q_tmpl), this.exprAllowed = !1;
}, G.star.updateContext = function(e) {
  if (e === G._function) {
    var t = this.context.length - 1;
    this.context[t] === yn.f_expr ? this.context[t] = yn.f_expr_gen : this.context[t] = yn.f_gen;
  }
  this.exprAllowed = !0;
}, G.name.updateContext = function(e) {
  var t = !1;
  this.options.ecmaVersion >= 6 && e !== G.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
};
var pk = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", $9 = pk + " Extended_Pictographic", G9 = { 9: pk, 10: $9, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, kx = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", fk = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", z9 = fk + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", H9 = { 9: fk, 10: z9, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, hk = {};
function Dd(e) {
  var t = hk[e] = { binary: Oo(G9[e] + " " + kx), nonBinary: { General_Category: Oo(kx), Script: Oo(H9[e]) } };
  t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
}
Dd(9), Dd(10), Dd(11);
var Ke = fn.prototype, da = function(e) {
  this.parser = e, this.validFlags = "gim" + (e.options.ecmaVersion >= 6 ? "uy" : "") + (e.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = hk[e.options.ecmaVersion >= 11 ? 11 : e.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function Ml(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
function Dx(e) {
  return e === 36 || e >= 40 && e <= 43 || e === 46 || e === 63 || e >= 91 && e <= 94 || e >= 123 && e <= 125;
}
function dk(e) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function mk(e) {
  return dk(e) || e === 95;
}
function K9(e) {
  return mk(e) || up(e);
}
function up(e) {
  return e >= 48 && e <= 57;
}
function Fx(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function wx(e) {
  return e >= 65 && e <= 70 ? e - 65 + 10 : e >= 97 && e <= 102 ? e - 97 + 10 : e - 48;
}
function Ax(e) {
  return e >= 48 && e <= 55;
}
da.prototype.reset = function(e, t, n) {
  var r = n.indexOf("u") !== -1;
  this.start = 0 | e, this.source = t + "", this.flags = n, this.switchU = r && this.parser.options.ecmaVersion >= 6, this.switchN = r && this.parser.options.ecmaVersion >= 9;
}, da.prototype.raise = function(e) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e);
}, da.prototype.at = function(e) {
  var t = this.source, n = t.length;
  if (e >= n)
    return -1;
  var r = t.charCodeAt(e);
  return !this.switchU || r <= 55295 || r >= 57344 || e + 1 >= n ? r : (r << 10) + t.charCodeAt(e + 1) - 56613888;
}, da.prototype.nextIndex = function(e) {
  var t = this.source, n = t.length;
  if (e >= n)
    return n;
  var r = t.charCodeAt(e);
  return !this.switchU || r <= 55295 || r >= 57344 || e + 1 >= n ? e + 1 : e + 2;
}, da.prototype.current = function() {
  return this.at(this.pos);
}, da.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, da.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, da.prototype.eat = function(e) {
  return this.current() === e && (this.advance(), !0);
}, Ke.validateRegExpFlags = function(e) {
  for (var t = e.validFlags, n = e.flags, r = 0; r < n.length; r++) {
    var i = n.charAt(r);
    t.indexOf(i) === -1 && this.raise(e.start, "Invalid regular expression flag"), n.indexOf(i, r + 1) > -1 && this.raise(e.start, "Duplicate regular expression flag");
  }
}, Ke.validateRegExpPattern = function(e) {
  this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && e.groupNames.length > 0 && (e.switchN = !0, this.regexp_pattern(e));
}, Ke.regexp_pattern = function(e) {
  e.pos = 0, e.lastIntValue = 0, e.lastStringValue = "", e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames.length = 0, e.backReferenceNames.length = 0, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(41) && e.raise("Unmatched ')'"), (e.eat(93) || e.eat(125)) && e.raise("Lone quantifier brackets")), e.maxBackReference > e.numCapturingParens && e.raise("Invalid escape");
  for (var t = 0, n = e.backReferenceNames; t < n.length; t += 1) {
    var r = n[t];
    e.groupNames.indexOf(r) === -1 && e.raise("Invalid named capture referenced");
  }
}, Ke.regexp_disjunction = function(e) {
  for (this.regexp_alternative(e); e.eat(124); )
    this.regexp_alternative(e);
  this.regexp_eatQuantifier(e, !0) && e.raise("Nothing to repeat"), e.eat(123) && e.raise("Lone quantifier brackets");
}, Ke.regexp_alternative = function(e) {
  for (; e.pos < e.source.length && this.regexp_eatTerm(e); )
    ;
}, Ke.regexp_eatTerm = function(e) {
  return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise("Invalid quantifier"), !0) : !(e.switchU ? !this.regexp_eatAtom(e) : !this.regexp_eatExtendedAtom(e)) && (this.regexp_eatQuantifier(e), !0);
}, Ke.regexp_eatAssertion = function(e) {
  var t = e.pos;
  if (e.lastAssertionIsQuantifiable = !1, e.eat(94) || e.eat(36))
    return !0;
  if (e.eat(92)) {
    if (e.eat(66) || e.eat(98))
      return !0;
    e.pos = t;
  }
  if (e.eat(40) && e.eat(63)) {
    var n = !1;
    if (this.options.ecmaVersion >= 9 && (n = e.eat(60)), e.eat(61) || e.eat(33))
      return this.regexp_disjunction(e), e.eat(41) || e.raise("Unterminated group"), e.lastAssertionIsQuantifiable = !n, !0;
  }
  return e.pos = t, !1;
}, Ke.regexp_eatQuantifier = function(e, t) {
  return t === void 0 && (t = !1), !!this.regexp_eatQuantifierPrefix(e, t) && (e.eat(63), !0);
}, Ke.regexp_eatQuantifierPrefix = function(e, t) {
  return e.eat(42) || e.eat(43) || e.eat(63) || this.regexp_eatBracedQuantifier(e, t);
}, Ke.regexp_eatBracedQuantifier = function(e, t) {
  var n = e.pos;
  if (e.eat(123)) {
    var r = 0, i = -1;
    if (this.regexp_eatDecimalDigits(e) && (r = e.lastIntValue, e.eat(44) && this.regexp_eatDecimalDigits(e) && (i = e.lastIntValue), e.eat(125)))
      return i !== -1 && i < r && !t && e.raise("numbers out of order in {} quantifier"), !0;
    e.switchU && !t && e.raise("Incomplete quantifier"), e.pos = n;
  }
  return !1;
}, Ke.regexp_eatAtom = function(e) {
  return this.regexp_eatPatternCharacters(e) || e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
}, Ke.regexp_eatReverseSolidusAtomEscape = function(e) {
  var t = e.pos;
  if (e.eat(92)) {
    if (this.regexp_eatAtomEscape(e))
      return !0;
    e.pos = t;
  }
  return !1;
}, Ke.regexp_eatUncapturingGroup = function(e) {
  var t = e.pos;
  if (e.eat(40)) {
    if (e.eat(63) && e.eat(58)) {
      if (this.regexp_disjunction(e), e.eat(41))
        return !0;
      e.raise("Unterminated group");
    }
    e.pos = t;
  }
  return !1;
}, Ke.regexp_eatCapturingGroup = function(e) {
  if (e.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : e.current() === 63 && e.raise("Invalid group"), this.regexp_disjunction(e), e.eat(41))
      return e.numCapturingParens += 1, !0;
    e.raise("Unterminated group");
  }
  return !1;
}, Ke.regexp_eatExtendedAtom = function(e) {
  return e.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
}, Ke.regexp_eatInvalidBracedQuantifier = function(e) {
  return this.regexp_eatBracedQuantifier(e, !0) && e.raise("Nothing to repeat"), !1;
}, Ke.regexp_eatSyntaxCharacter = function(e) {
  var t = e.current();
  return !!Dx(t) && (e.lastIntValue = t, e.advance(), !0);
}, Ke.regexp_eatPatternCharacters = function(e) {
  for (var t = e.pos, n = 0; (n = e.current()) !== -1 && !Dx(n); )
    e.advance();
  return e.pos !== t;
}, Ke.regexp_eatExtendedPatternCharacter = function(e) {
  var t = e.current();
  return !(t === -1 || t === 36 || t >= 40 && t <= 43 || t === 46 || t === 63 || t === 91 || t === 94 || t === 124) && (e.advance(), !0);
}, Ke.regexp_groupSpecifier = function(e) {
  if (e.eat(63)) {
    if (this.regexp_eatGroupName(e))
      return e.groupNames.indexOf(e.lastStringValue) !== -1 && e.raise("Duplicate capture group name"), void e.groupNames.push(e.lastStringValue);
    e.raise("Invalid group");
  }
}, Ke.regexp_eatGroupName = function(e) {
  if (e.lastStringValue = "", e.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e) && e.eat(62))
      return !0;
    e.raise("Invalid capture group name");
  }
  return !1;
}, Ke.regexp_eatRegExpIdentifierName = function(e) {
  if (e.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e)) {
    for (e.lastStringValue += Ml(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e); )
      e.lastStringValue += Ml(e.lastIntValue);
    return !0;
  }
  return !1;
}, Ke.regexp_eatRegExpIdentifierStart = function(e) {
  var t = e.pos, n = e.current();
  return e.advance(), n === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e) && (n = e.lastIntValue), function(r) {
    return Ca(r, !0) || r === 36 || r === 95;
  }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
}, Ke.regexp_eatRegExpIdentifierPart = function(e) {
  var t = e.pos, n = e.current();
  return e.advance(), n === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e) && (n = e.lastIntValue), function(r) {
    return Vo(r, !0) || r === 36 || r === 95 || r === 8204 || r === 8205;
  }(n) ? (e.lastIntValue = n, !0) : (e.pos = t, !1);
}, Ke.regexp_eatAtomEscape = function(e) {
  return !!(this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e)) || (e.switchU && (e.current() === 99 && e.raise("Invalid unicode escape"), e.raise("Invalid escape")), !1);
}, Ke.regexp_eatBackReference = function(e) {
  var t = e.pos;
  if (this.regexp_eatDecimalEscape(e)) {
    var n = e.lastIntValue;
    if (e.switchU)
      return n > e.maxBackReference && (e.maxBackReference = n), !0;
    if (n <= e.numCapturingParens)
      return !0;
    e.pos = t;
  }
  return !1;
}, Ke.regexp_eatKGroupName = function(e) {
  if (e.eat(107)) {
    if (this.regexp_eatGroupName(e))
      return e.backReferenceNames.push(e.lastStringValue), !0;
    e.raise("Invalid named reference");
  }
  return !1;
}, Ke.regexp_eatCharacterEscape = function(e) {
  return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
}, Ke.regexp_eatCControlLetter = function(e) {
  var t = e.pos;
  if (e.eat(99)) {
    if (this.regexp_eatControlLetter(e))
      return !0;
    e.pos = t;
  }
  return !1;
}, Ke.regexp_eatZero = function(e) {
  return e.current() === 48 && !up(e.lookahead()) && (e.lastIntValue = 0, e.advance(), !0);
}, Ke.regexp_eatControlEscape = function(e) {
  var t = e.current();
  return t === 116 ? (e.lastIntValue = 9, e.advance(), !0) : t === 110 ? (e.lastIntValue = 10, e.advance(), !0) : t === 118 ? (e.lastIntValue = 11, e.advance(), !0) : t === 102 ? (e.lastIntValue = 12, e.advance(), !0) : t === 114 && (e.lastIntValue = 13, e.advance(), !0);
}, Ke.regexp_eatControlLetter = function(e) {
  var t = e.current();
  return !!dk(t) && (e.lastIntValue = t % 32, e.advance(), !0);
}, Ke.regexp_eatRegExpUnicodeEscapeSequence = function(e) {
  var t, n = e.pos;
  if (e.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e, 4)) {
      var r = e.lastIntValue;
      if (e.switchU && r >= 55296 && r <= 56319) {
        var i = e.pos;
        if (e.eat(92) && e.eat(117) && this.regexp_eatFixedHexDigits(e, 4)) {
          var a = e.lastIntValue;
          if (a >= 56320 && a <= 57343)
            return e.lastIntValue = 1024 * (r - 55296) + (a - 56320) + 65536, !0;
        }
        e.pos = i, e.lastIntValue = r;
      }
      return !0;
    }
    if (e.switchU && e.eat(123) && this.regexp_eatHexDigits(e) && e.eat(125) && (t = e.lastIntValue) >= 0 && t <= 1114111)
      return !0;
    e.switchU && e.raise("Invalid unicode escape"), e.pos = n;
  }
  return !1;
}, Ke.regexp_eatIdentityEscape = function(e) {
  if (e.switchU)
    return !!this.regexp_eatSyntaxCharacter(e) || !!e.eat(47) && (e.lastIntValue = 47, !0);
  var t = e.current();
  return !(t === 99 || e.switchN && t === 107) && (e.lastIntValue = t, e.advance(), !0);
}, Ke.regexp_eatDecimalEscape = function(e) {
  e.lastIntValue = 0;
  var t = e.current();
  if (t >= 49 && t <= 57) {
    do
      e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
    while ((t = e.current()) >= 48 && t <= 57);
    return !0;
  }
  return !1;
}, Ke.regexp_eatCharacterClassEscape = function(e) {
  var t = e.current();
  if (function(n) {
    return n === 100 || n === 68 || n === 115 || n === 83 || n === 119 || n === 87;
  }(t))
    return e.lastIntValue = -1, e.advance(), !0;
  if (e.switchU && this.options.ecmaVersion >= 9 && (t === 80 || t === 112)) {
    if (e.lastIntValue = -1, e.advance(), e.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e) && e.eat(125))
      return !0;
    e.raise("Invalid property name");
  }
  return !1;
}, Ke.regexp_eatUnicodePropertyValueExpression = function(e) {
  var t = e.pos;
  if (this.regexp_eatUnicodePropertyName(e) && e.eat(61)) {
    var n = e.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e)) {
      var r = e.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e, n, r), !0;
    }
  }
  if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
    var i = e.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e, i), !0;
  }
  return !1;
}, Ke.regexp_validateUnicodePropertyNameAndValue = function(e, t, n) {
  mf(e.unicodeProperties.nonBinary, t) || e.raise("Invalid property name"), e.unicodeProperties.nonBinary[t].test(n) || e.raise("Invalid property value");
}, Ke.regexp_validateUnicodePropertyNameOrValue = function(e, t) {
  e.unicodeProperties.binary.test(t) || e.raise("Invalid property name");
}, Ke.regexp_eatUnicodePropertyName = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; mk(t = e.current()); )
    e.lastStringValue += Ml(t), e.advance();
  return e.lastStringValue !== "";
}, Ke.regexp_eatUnicodePropertyValue = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; K9(t = e.current()); )
    e.lastStringValue += Ml(t), e.advance();
  return e.lastStringValue !== "";
}, Ke.regexp_eatLoneUnicodePropertyNameOrValue = function(e) {
  return this.regexp_eatUnicodePropertyValue(e);
}, Ke.regexp_eatCharacterClass = function(e) {
  if (e.eat(91)) {
    if (e.eat(94), this.regexp_classRanges(e), e.eat(93))
      return !0;
    e.raise("Unterminated character class");
  }
  return !1;
}, Ke.regexp_classRanges = function(e) {
  for (; this.regexp_eatClassAtom(e); ) {
    var t = e.lastIntValue;
    if (e.eat(45) && this.regexp_eatClassAtom(e)) {
      var n = e.lastIntValue;
      !e.switchU || t !== -1 && n !== -1 || e.raise("Invalid character class"), t !== -1 && n !== -1 && t > n && e.raise("Range out of order in character class");
    }
  }
}, Ke.regexp_eatClassAtom = function(e) {
  var t = e.pos;
  if (e.eat(92)) {
    if (this.regexp_eatClassEscape(e))
      return !0;
    if (e.switchU) {
      var n = e.current();
      (n === 99 || Ax(n)) && e.raise("Invalid class escape"), e.raise("Invalid escape");
    }
    e.pos = t;
  }
  var r = e.current();
  return r !== 93 && (e.lastIntValue = r, e.advance(), !0);
}, Ke.regexp_eatClassEscape = function(e) {
  var t = e.pos;
  if (e.eat(98))
    return e.lastIntValue = 8, !0;
  if (e.switchU && e.eat(45))
    return e.lastIntValue = 45, !0;
  if (!e.switchU && e.eat(99)) {
    if (this.regexp_eatClassControlLetter(e))
      return !0;
    e.pos = t;
  }
  return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
}, Ke.regexp_eatClassControlLetter = function(e) {
  var t = e.current();
  return !(!up(t) && t !== 95) && (e.lastIntValue = t % 32, e.advance(), !0);
}, Ke.regexp_eatHexEscapeSequence = function(e) {
  var t = e.pos;
  if (e.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e, 2))
      return !0;
    e.switchU && e.raise("Invalid escape"), e.pos = t;
  }
  return !1;
}, Ke.regexp_eatDecimalDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; up(n = e.current()); )
    e.lastIntValue = 10 * e.lastIntValue + (n - 48), e.advance();
  return e.pos !== t;
}, Ke.regexp_eatHexDigits = function(e) {
  var t = e.pos, n = 0;
  for (e.lastIntValue = 0; Fx(n = e.current()); )
    e.lastIntValue = 16 * e.lastIntValue + wx(n), e.advance();
  return e.pos !== t;
}, Ke.regexp_eatLegacyOctalEscapeSequence = function(e) {
  if (this.regexp_eatOctalDigit(e)) {
    var t = e.lastIntValue;
    if (this.regexp_eatOctalDigit(e)) {
      var n = e.lastIntValue;
      t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = 64 * t + 8 * n + e.lastIntValue : e.lastIntValue = 8 * t + n;
    } else
      e.lastIntValue = t;
    return !0;
  }
  return !1;
}, Ke.regexp_eatOctalDigit = function(e) {
  var t = e.current();
  return Ax(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
}, Ke.regexp_eatFixedHexDigits = function(e, t) {
  var n = e.pos;
  e.lastIntValue = 0;
  for (var r = 0; r < t; ++r) {
    var i = e.current();
    if (!Fx(i))
      return e.pos = n, !1;
    e.lastIntValue = 16 * e.lastIntValue + wx(i), e.advance();
  }
  return !0;
};
var Mp = function(e) {
  this.type = e.type, this.value = e.value, this.start = e.start, this.end = e.end, e.options.locations && (this.loc = new kc(e, e.startLoc, e.endLoc)), e.options.ranges && (this.range = [e.start, e.end]);
}, wt = fn.prototype;
function Um(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e)));
}
wt.next = function() {
  this.options.onToken && this.options.onToken(new Mp(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, wt.getToken = function() {
  return this.next(), new Mp(this);
}, typeof Symbol < "u" && (wt[Symbol.iterator] = function() {
  var e = this;
  return { next: function() {
    var t = e.getToken();
    return { done: t.type === G.eof, value: t };
  } };
}), wt.curContext = function() {
  return this.context[this.context.length - 1];
}, wt.nextToken = function() {
  var e = this.curContext();
  return e && e.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(G.eof) : e.override ? e.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, wt.readToken = function(e) {
  return Ca(e, this.options.ecmaVersion >= 6) || e === 92 ? this.readWord() : this.getTokenFromCode(e);
}, wt.fullCharCodeAtPos = function() {
  var e = this.input.charCodeAt(this.pos);
  return e <= 55295 || e >= 57344 ? e : (e << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, wt.skipBlockComment = function() {
  var e, t = this.options.onComment && this.curPosition(), n = this.pos, r = this.input.indexOf("*/", this.pos += 2);
  if (r === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = r + 2, this.options.locations)
    for (Gs.lastIndex = n; (e = Gs.exec(this.input)) && e.index < this.pos; )
      ++this.curLine, this.lineStart = e.index + e[0].length;
  this.options.onComment && this.options.onComment(!0, this.input.slice(n + 2, r), n, this.pos, t, this.curPosition());
}, wt.skipLineComment = function(e) {
  for (var t = this.pos, n = this.options.onComment && this.curPosition(), r = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !zs(r); )
    r = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(!1, this.input.slice(t + e, this.pos), t, this.pos, n, this.curPosition());
}, wt.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e = this.input.charCodeAt(this.pos);
      switch (e) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e > 8 && e < 14 || e >= 5760 && G0.test(String.fromCharCode(e))))
            break e;
          ++this.pos;
      }
    }
}, wt.finishToken = function(e, t) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var n = this.type;
  this.type = e, this.value = t, this.updateContext(n);
}, wt.readToken_dot = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  if (e >= 48 && e <= 57)
    return this.readNumber(!0);
  var t = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e === 46 && t === 46 ? (this.pos += 3, this.finishToken(G.ellipsis)) : (++this.pos, this.finishToken(G.dot));
}, wt.readToken_slash = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e === 61 ? this.finishOp(G.assign, 2) : this.finishOp(G.slash, 1);
}, wt.readToken_mult_modulo_exp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1, r = e === 42 ? G.star : G.modulo;
  return this.options.ecmaVersion >= 7 && e === 42 && t === 42 && (++n, r = G.starstar, t = this.input.charCodeAt(this.pos + 2)), t === 61 ? this.finishOp(G.assign, n + 1) : this.finishOp(r, n);
}, wt.readToken_pipe_amp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? this.finishOp(e === 124 ? G.logicalOR : G.logicalAND, 2) : t === 61 ? this.finishOp(G.assign, 2) : this.finishOp(e === 124 ? G.bitwiseOR : G.bitwiseAND, 1);
}, wt.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp(G.assign, 2) : this.finishOp(G.bitwiseXOR, 1);
}, wt.readToken_plus_min = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? t !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !li.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(G.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t === 61 ? this.finishOp(G.assign, 2) : this.finishOp(G.plusMin, 1);
}, wt.readToken_lt_gt = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), n = 1;
  return t === e ? (n = e === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + n) === 61 ? this.finishOp(G.assign, n + 1) : this.finishOp(G.bitShift, n)) : t !== 33 || e !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t === 61 && (n = 2), this.finishOp(G.relational, n)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, wt.readToken_eq_excl = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === 61 ? this.finishOp(G.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e === 61 && t === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(G.arrow)) : this.finishOp(e === 61 ? G.eq : G.prefix, 1);
}, wt.getTokenFromCode = function(e) {
  switch (e) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken(G.parenL);
    case 41:
      return ++this.pos, this.finishToken(G.parenR);
    case 59:
      return ++this.pos, this.finishToken(G.semi);
    case 44:
      return ++this.pos, this.finishToken(G.comma);
    case 91:
      return ++this.pos, this.finishToken(G.bracketL);
    case 93:
      return ++this.pos, this.finishToken(G.bracketR);
    case 123:
      return ++this.pos, this.finishToken(G.braceL);
    case 125:
      return ++this.pos, this.finishToken(G.braceR);
    case 58:
      return ++this.pos, this.finishToken(G.colon);
    case 63:
      return ++this.pos, this.finishToken(G.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(G.backQuote);
    case 48:
      var t = this.input.charCodeAt(this.pos + 1);
      if (t === 120 || t === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t === 111 || t === 79)
          return this.readRadixNumber(8);
        if (t === 98 || t === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    case 34:
    case 39:
      return this.readString(e);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e);
    case 60:
    case 62:
      return this.readToken_lt_gt(e);
    case 61:
    case 33:
      return this.readToken_eq_excl(e);
    case 126:
      return this.finishOp(G.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + Um(e) + "'");
}, wt.finishOp = function(e, t) {
  var n = this.input.slice(this.pos, this.pos + t);
  return this.pos += t, this.finishToken(e, n);
}, wt.readRegexp = function() {
  for (var e, t, n = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(n, "Unterminated regular expression");
    var r = this.input.charAt(this.pos);
    if (li.test(r) && this.raise(n, "Unterminated regular expression"), e)
      e = !1;
    else {
      if (r === "[")
        t = !0;
      else if (r === "]" && t)
        t = !1;
      else if (r === "/" && !t)
        break;
      e = r === "\\";
    }
    ++this.pos;
  }
  var i = this.input.slice(n, this.pos);
  ++this.pos;
  var a = this.pos, s = this.readWord1();
  this.containsEsc && this.unexpected(a);
  var o = this.regexpState || (this.regexpState = new da(this));
  o.reset(n, i, s), this.validateRegExpFlags(o), this.validateRegExpPattern(o);
  var u = null;
  try {
    u = new RegExp(i, s);
  } catch {
  }
  return this.finishToken(G.regexp, { pattern: i, flags: s, value: u });
}, wt.readInt = function(e, t) {
  for (var n = this.pos, r = 0, i = 0, a = t ?? 1 / 0; i < a; ++i) {
    var s = this.input.charCodeAt(this.pos), o = void 0;
    if ((o = s >= 97 ? s - 97 + 10 : s >= 65 ? s - 65 + 10 : s >= 48 && s <= 57 ? s - 48 : 1 / 0) >= e)
      break;
    ++this.pos, r = r * e + o;
  }
  return this.pos === n || t != null && this.pos - n !== t ? null : r;
}, wt.readRadixNumber = function(e) {
  var t = this.pos;
  this.pos += 2;
  var n = this.readInt(e);
  return n == null && this.raise(this.start + 2, "Expected number in radix " + e), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (n = typeof BigInt < "u" ? BigInt(this.input.slice(t, this.pos)) : null, ++this.pos) : Ca(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(G.num, n);
}, wt.readNumber = function(e) {
  var t = this.pos;
  e || this.readInt(10) !== null || this.raise(t, "Invalid number");
  var n = this.pos - t >= 2 && this.input.charCodeAt(t) === 48;
  n && this.strict && this.raise(t, "Invalid number"), n && /[89]/.test(this.input.slice(t, this.pos)) && (n = !1);
  var r = this.input.charCodeAt(this.pos);
  if (!n && !e && this.options.ecmaVersion >= 11 && r === 110) {
    var i = this.input.slice(t, this.pos), a = typeof BigInt < "u" ? BigInt(i) : null;
    return ++this.pos, Ca(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(G.num, a);
  }
  r !== 46 || n || (++this.pos, this.readInt(10), r = this.input.charCodeAt(this.pos)), r !== 69 && r !== 101 || n || ((r = this.input.charCodeAt(++this.pos)) !== 43 && r !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t, "Invalid number")), Ca(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var s = this.input.slice(t, this.pos), o = n ? parseInt(s, 8) : parseFloat(s);
  return this.finishToken(G.num, o);
}, wt.readCodePoint = function() {
  var e;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t = ++this.pos;
    e = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e > 1114111 && this.invalidStringToken(t, "Code point out of bounds");
  } else
    e = this.readHexChar(4);
  return e;
}, wt.readString = function(e) {
  for (var t = "", n = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var r = this.input.charCodeAt(this.pos);
    if (r === e)
      break;
    r === 92 ? (t += this.input.slice(n, this.pos), t += this.readEscapedChar(!1), n = this.pos) : (zs(r, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t += this.input.slice(n, this.pos++), this.finishToken(G.string, t);
};
var _x = {};
wt.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (e) {
    if (e !== _x)
      throw e;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = !1;
}, wt.invalidStringToken = function(e, t) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw _x;
  this.raise(e, t);
}, wt.readTmplToken = function() {
  for (var e = "", t = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var n = this.input.charCodeAt(this.pos);
    if (n === 96 || n === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== G.template && this.type !== G.invalidTemplate ? (e += this.input.slice(t, this.pos), this.finishToken(G.template, e)) : n === 36 ? (this.pos += 2, this.finishToken(G.dollarBraceL)) : (++this.pos, this.finishToken(G.backQuote));
    if (n === 92)
      e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
    else if (zs(n)) {
      switch (e += this.input.slice(t, this.pos), ++this.pos, n) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e += `
`;
          break;
        default:
          e += String.fromCharCode(n);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
    } else
      ++this.pos;
  }
}, wt.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken(G.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, wt.readEscapedChar = function(e) {
  var t = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t) {
    case 110:
      return `
`;
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return Um(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t >= 48 && t <= 55) {
        var n = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], r = parseInt(n, 8);
        return r > 255 && (n = n.slice(0, -1), r = parseInt(n, 8)), this.pos += n.length - 1, t = this.input.charCodeAt(this.pos), n === "0" && t !== 56 && t !== 57 || !this.strict && !e || this.invalidStringToken(this.pos - 1 - n.length, e ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(r);
      }
      return zs(t) ? "" : String.fromCharCode(t);
  }
}, wt.readHexChar = function(e) {
  var t = this.pos, n = this.readInt(16, e);
  return n === null && this.invalidStringToken(t, "Bad character escape sequence"), n;
}, wt.readWord1 = function() {
  this.containsEsc = !1;
  for (var e = "", t = !0, n = this.pos, r = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i = this.fullCharCodeAtPos();
    if (Vo(i, r))
      this.pos += i <= 65535 ? 1 : 2;
    else {
      if (i !== 92)
        break;
      this.containsEsc = !0, e += this.input.slice(n, this.pos);
      var a = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var s = this.readCodePoint();
      (t ? Ca : Vo)(s, r) || this.invalidStringToken(a, "Invalid Unicode escape"), e += Um(s), n = this.pos;
    }
    t = !1;
  }
  return e + this.input.slice(n, this.pos);
}, wt.readWord = function() {
  var e = this.readWord1(), t = G.name;
  return this.keywords.test(e) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e), t = df[e]), this.finishToken(t, e);
};
fn.acorn = { Parser: fn, version: "6.4.0", defaultOptions: jp, Position: Hs, SourceLocation: kc, getLineInfo: z0, Node: Rp, TokenType: Lt, tokTypes: G, keywordTypes: df, TokContext: ei, tokContexts: yn, isIdentifierChar: Vo, isIdentifierStart: Ca, Token: Mp, isNewLine: zs, lineBreak: li, lineBreakG: Gs, nonASCIIwhitespace: G0 };
var Tx = Cr(Object.freeze({ __proto__: null, Node: Rp, Parser: fn, Position: Hs, SourceLocation: kc, TokContext: ei, Token: Mp, TokenType: Lt, defaultOptions: jp, getLineInfo: z0, isIdentifierChar: Vo, isIdentifierStart: Ca, isNewLine: zs, keywordTypes: df, lineBreak: li, lineBreakG: Gs, nonASCIIwhitespace: G0, parse: function(e, t) {
  return fn.parse(e, t);
}, parseExpressionAt: function(e, t, n) {
  return fn.parseExpressionAt(e, t, n);
}, tokContexts: yn, tokTypes: G, tokenizer: function(e, t) {
  return fn.tokenizer(e, t);
}, version: "6.4.0" })), J9 = gt(function(e) {
  var t = /^[\da-fA-F]+$/, n = /^\d+$/, r = /* @__PURE__ */ new WeakMap();
  function i(s) {
    s = s.Parser.acorn || s;
    var o = r.get(s);
    if (!o) {
      var u = s.tokTypes, c = s.TokContext, f = s.TokenType, p = new c("<tag", !1), d = new c("</tag", !1), m = new c("<tag>...</tag>", !0, !0), y = { tc_oTag: p, tc_cTag: d, tc_expr: m }, v = { jsxName: new f("jsxName"), jsxText: new f("jsxText", { beforeExpr: !0 }), jsxTagStart: new f("jsxTagStart"), jsxTagEnd: new f("jsxTagEnd") };
      v.jsxTagStart.updateContext = function() {
        this.context.push(m), this.context.push(p), this.exprAllowed = !1;
      }, v.jsxTagEnd.updateContext = function(b) {
        var x = this.context.pop();
        x === p && b === u.slash || x === d ? (this.context.pop(), this.exprAllowed = this.curContext() === m) : this.exprAllowed = !0;
      }, o = { tokContexts: y, tokTypes: v }, r.set(s, o);
    }
    return o;
  }
  function a(s) {
    return s && (s.type === "JSXIdentifier" ? s.name : s.type === "JSXNamespacedName" ? s.namespace.name + ":" + s.name.name : s.type === "JSXMemberExpression" ? a(s.object) + "." + a(s.property) : void 0);
  }
  e.exports = function(s) {
    return s = s || {}, function(o) {
      return function(u, c) {
        var f = c.acorn || Tx, p = i(f), d = f.tokTypes, m = p.tokTypes, y = f.tokContexts, v = p.tokContexts.tc_oTag, b = p.tokContexts.tc_cTag, x = p.tokContexts.tc_expr, C = f.isNewLine, k = f.isIdentifierStart, F = f.isIdentifierChar;
        return function(B) {
          function O() {
            return We(this, O), Gt(this, rt(O).apply(this, arguments));
          }
          return $t(O, B), Xe(O, [{ key: "jsx_readToken", value: function() {
            for (var S = "", w = this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
              var D = this.input.charCodeAt(this.pos);
              switch (D) {
                case 60:
                case 123:
                  return this.pos === this.start ? D === 60 && this.exprAllowed ? (++this.pos, this.finishToken(m.jsxTagStart)) : this.getTokenFromCode(D) : (S += this.input.slice(w, this.pos), this.finishToken(m.jsxText, S));
                case 38:
                  S += this.input.slice(w, this.pos), S += this.jsx_readEntity(), w = this.pos;
                  break;
                default:
                  C(D) ? (S += this.input.slice(w, this.pos), S += this.jsx_readNewLine(!0), w = this.pos) : ++this.pos;
              }
            }
          } }, { key: "jsx_readNewLine", value: function(S) {
            var w, D = this.input.charCodeAt(this.pos);
            return ++this.pos, D === 13 && this.input.charCodeAt(this.pos) === 10 ? (++this.pos, w = S ? `
` : `\r
`) : w = String.fromCharCode(D), this.options.locations && (++this.curLine, this.lineStart = this.pos), w;
          } }, { key: "jsx_readString", value: function(S) {
            for (var w = "", D = ++this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
              var I = this.input.charCodeAt(this.pos);
              if (I === S)
                break;
              I === 38 ? (w += this.input.slice(D, this.pos), w += this.jsx_readEntity(), D = this.pos) : C(I) ? (w += this.input.slice(D, this.pos), w += this.jsx_readNewLine(!1), D = this.pos) : ++this.pos;
            }
            return w += this.input.slice(D, this.pos++), this.finishToken(d.string, w);
          } }, { key: "jsx_readEntity", value: function() {
            var S, w = "", D = 0, I = this.input[this.pos];
            I !== "&" && this.raise(this.pos, "Entity must start with an ampersand");
            for (var L = ++this.pos; this.pos < this.input.length && D++ < 10; ) {
              if ((I = this.input[this.pos++]) === ";") {
                w[0] === "#" ? w[1] === "x" ? (w = w.substr(2), t.test(w) && (S = String.fromCharCode(parseInt(w, 16)))) : (w = w.substr(1), n.test(w) && (S = String.fromCharCode(parseInt(w, 10)))) : S = T9[w];
                break;
              }
              w += I;
            }
            return S || (this.pos = L, "&");
          } }, { key: "jsx_readWord", value: function() {
            var S, w = this.pos;
            do
              S = this.input.charCodeAt(++this.pos);
            while (F(S) || S === 45);
            return this.finishToken(m.jsxName, this.input.slice(w, this.pos));
          } }, { key: "jsx_parseIdentifier", value: function() {
            var S = this.startNode();
            return this.type === m.jsxName ? S.name = this.value : this.type.keyword ? S.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(S, "JSXIdentifier");
          } }, { key: "jsx_parseNamespacedName", value: function() {
            var S = this.start, w = this.startLoc, D = this.jsx_parseIdentifier();
            if (!u.allowNamespaces || !this.eat(d.colon))
              return D;
            var I = this.startNodeAt(S, w);
            return I.namespace = D, I.name = this.jsx_parseIdentifier(), this.finishNode(I, "JSXNamespacedName");
          } }, { key: "jsx_parseElementName", value: function() {
            if (this.type === m.jsxTagEnd)
              return "";
            var S = this.start, w = this.startLoc, D = this.jsx_parseNamespacedName();
            for (this.type !== d.dot || D.type !== "JSXNamespacedName" || u.allowNamespacedObjects || this.unexpected(); this.eat(d.dot); ) {
              var I = this.startNodeAt(S, w);
              I.object = D, I.property = this.jsx_parseIdentifier(), D = this.finishNode(I, "JSXMemberExpression");
            }
            return D;
          } }, { key: "jsx_parseAttributeValue", value: function() {
            switch (this.type) {
              case d.braceL:
                var S = this.jsx_parseExpressionContainer();
                return S.expression.type === "JSXEmptyExpression" && this.raise(S.start, "JSX attributes must only be assigned a non-empty expression"), S;
              case m.jsxTagStart:
              case d.string:
                return this.parseExprAtom();
              default:
                this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
            }
          } }, { key: "jsx_parseEmptyExpression", value: function() {
            var S = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
            return this.finishNodeAt(S, "JSXEmptyExpression", this.start, this.startLoc);
          } }, { key: "jsx_parseExpressionContainer", value: function() {
            var S = this.startNode();
            return this.next(), S.expression = this.type === d.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(d.braceR), this.finishNode(S, "JSXExpressionContainer");
          } }, { key: "jsx_parseAttribute", value: function() {
            var S = this.startNode();
            return this.eat(d.braceL) ? (this.expect(d.ellipsis), S.argument = this.parseMaybeAssign(), this.expect(d.braceR), this.finishNode(S, "JSXSpreadAttribute")) : (S.name = this.jsx_parseNamespacedName(), S.value = this.eat(d.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(S, "JSXAttribute"));
          } }, { key: "jsx_parseOpeningElementAt", value: function(S, w) {
            var D = this.startNodeAt(S, w);
            D.attributes = [];
            var I = this.jsx_parseElementName();
            for (I && (D.name = I); this.type !== d.slash && this.type !== m.jsxTagEnd; )
              D.attributes.push(this.jsx_parseAttribute());
            return D.selfClosing = this.eat(d.slash), this.expect(m.jsxTagEnd), this.finishNode(D, I ? "JSXOpeningElement" : "JSXOpeningFragment");
          } }, { key: "jsx_parseClosingElementAt", value: function(S, w) {
            var D = this.startNodeAt(S, w), I = this.jsx_parseElementName();
            return I && (D.name = I), this.expect(m.jsxTagEnd), this.finishNode(D, I ? "JSXClosingElement" : "JSXClosingFragment");
          } }, { key: "jsx_parseElementAt", value: function(S, w) {
            var D = this.startNodeAt(S, w), I = [], L = this.jsx_parseOpeningElementAt(S, w), V = null;
            if (!L.selfClosing) {
              e:
                for (; ; )
                  switch (this.type) {
                    case m.jsxTagStart:
                      if (S = this.start, w = this.startLoc, this.next(), this.eat(d.slash)) {
                        V = this.jsx_parseClosingElementAt(S, w);
                        break e;
                      }
                      I.push(this.jsx_parseElementAt(S, w));
                      break;
                    case m.jsxText:
                      I.push(this.parseExprAtom());
                      break;
                    case d.braceL:
                      I.push(this.jsx_parseExpressionContainer());
                      break;
                    default:
                      this.unexpected();
                  }
              a(V.name) !== a(L.name) && this.raise(V.start, "Expected corresponding JSX closing tag for <" + a(L.name) + ">");
            }
            var K = L.name ? "Element" : "Fragment";
            return D["opening" + K] = L, D["closing" + K] = V, D.children = I, this.type === d.relational && this.value === "<" && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(D, "JSX" + K);
          } }, { key: "jsx_parseText", value: function(S) {
            var w = this.parseLiteral(S);
            return w.type = "JSXText", w;
          } }, { key: "jsx_parseElement", value: function() {
            var S = this.start, w = this.startLoc;
            return this.next(), this.jsx_parseElementAt(S, w);
          } }, { key: "parseExprAtom", value: function(S) {
            return this.type === m.jsxText ? this.jsx_parseText(this.value) : this.type === m.jsxTagStart ? this.jsx_parseElement() : Yn(rt(O.prototype), "parseExprAtom", this).call(this, S);
          } }, { key: "readToken", value: function(S) {
            var w = this.curContext();
            if (w === x)
              return this.jsx_readToken();
            if (w === v || w === b) {
              if (k(S))
                return this.jsx_readWord();
              if (S == 62)
                return ++this.pos, this.finishToken(m.jsxTagEnd);
              if ((S === 34 || S === 39) && w == v)
                return this.jsx_readString(S);
            }
            return S === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33 ? (++this.pos, this.finishToken(m.jsxTagStart)) : Yn(rt(O.prototype), "readToken", this).call(this, S);
          } }, { key: "updateContext", value: function(S) {
            if (this.type == d.braceL) {
              var w = this.curContext();
              w == v ? this.context.push(y.b_expr) : w == x ? this.context.push(y.b_tmpl) : Yn(rt(O.prototype), "updateContext", this).call(this, S), this.exprAllowed = !0;
            } else {
              if (this.type !== d.slash || S !== m.jsxTagStart)
                return Yn(rt(O.prototype), "updateContext", this).call(this, S);
              this.context.length -= 2, this.context.push(b), this.exprAllowed = !1;
            }
          } }], [{ key: "acornJsx", get: function() {
            return p;
          } }]), O;
        }(c);
      }({ allowNamespaces: s.allowNamespaces !== !1, allowNamespacedObjects: !!s.allowNamespacedObjects }, o);
    };
  }, Object.defineProperty(e.exports, "tokTypes", { get: function() {
    return i(Tx).tokTypes;
  }, configurable: !0, enumerable: !0 });
}), Fd = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DoWhileStatement: "DoWhileStatement", DebuggerStatement: "DebuggerStatement", EmptyStatement: "EmptyStatement", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", Identifier: "Identifier", IfStatement: "IfStatement", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchCase: "SwitchCase", SwitchStatement: "SwitchStatement", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression", JSXIdentifier: "JSXIdentifier", JSXNamespacedName: "JSXNamespacedName", JSXMemberExpression: "JSXMemberExpression", JSXEmptyExpression: "JSXEmptyExpression", JSXExpressionContainer: "JSXExpressionContainer", JSXElement: "JSXElement", JSXClosingElement: "JSXClosingElement", JSXOpeningElement: "JSXOpeningElement", JSXAttribute: "JSXAttribute", JSXSpreadAttribute: "JSXSpreadAttribute", JSXText: "JSXText", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportAllDeclaration: "ExportAllDeclaration", ExportSpecifier: "ExportSpecifier", ImportDeclaration: "ImportDeclaration", ImportSpecifier: "ImportSpecifier", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier" }, mr = { Boolean: "Boolean", EOF: "<end>", Identifier: "Identifier", Keyword: "Keyword", Null: "Null", Numeric: "Numeric", Punctuator: "Punctuator", String: "String", RegularExpression: "RegularExpression", Template: "Template", JSXIdentifier: "JSXIdentifier", JSXText: "JSXText" };
function qm(e, t) {
  this._acornTokTypes = e, this._tokens = [], this._curlyBrace = null, this._code = t;
}
qm.prototype = { constructor: qm, translate: function(e, t) {
  var n = e.type, r = this._acornTokTypes;
  if (n === r.name)
    e.type = mr.Identifier, e.value === "static" && (e.type = mr.Keyword), t.ecmaVersion > 5 && (e.value === "yield" || e.value === "let") && (e.type = mr.Keyword);
  else if (n === r.semi || n === r.comma || n === r.parenL || n === r.parenR || n === r.braceL || n === r.braceR || n === r.dot || n === r.bracketL || n === r.colon || n === r.question || n === r.bracketR || n === r.ellipsis || n === r.arrow || n === r.jsxTagStart || n === r.incDec || n === r.starstar || n === r.jsxTagEnd || n === r.prefix || n.binop && !n.keyword || n.isAssign)
    e.type = mr.Punctuator, e.value = this._code.slice(e.start, e.end);
  else if (n === r.jsxName)
    e.type = mr.JSXIdentifier;
  else if (n.label === "jsxText" || n === r.jsxAttrValueToken)
    e.type = mr.JSXText;
  else if (n.keyword)
    n.keyword === "true" || n.keyword === "false" ? e.type = mr.Boolean : n.keyword === "null" ? e.type = mr.Null : e.type = mr.Keyword;
  else if (n === r.num)
    e.type = mr.Numeric, e.value = this._code.slice(e.start, e.end);
  else if (n === r.string)
    t.jsxAttrValueToken ? (t.jsxAttrValueToken = !1, e.type = mr.JSXText) : e.type = mr.String, e.value = this._code.slice(e.start, e.end);
  else if (n === r.regexp) {
    e.type = mr.RegularExpression;
    var i = e.value;
    e.regex = { flags: i.flags, pattern: i.pattern }, e.value = "/".concat(i.pattern, "/").concat(i.flags);
  }
  return e;
}, onToken: function(e, t) {
  var n = this, r = this._acornTokTypes, i = t.tokens, a = this._tokens;
  function s() {
    i.push(function(o, u) {
      var c = o[0], f = o[o.length - 1], p = { type: mr.Template, value: u.slice(c.start, f.end) };
      return c.loc && (p.loc = { start: c.loc.start, end: f.loc.end }), c.range && (p.start = c.range[0], p.end = f.range[1], p.range = [p.start, p.end]), p;
    }(n._tokens, n._code)), n._tokens = [];
  }
  if (e.type !== r.eof) {
    if (e.type === r.backQuote)
      return this._curlyBrace && (i.push(this.translate(this._curlyBrace, t)), this._curlyBrace = null), a.push(e), void (a.length > 1 && s());
    if (e.type === r.dollarBraceL)
      return a.push(e), void s();
    if (e.type === r.braceR)
      return this._curlyBrace && i.push(this.translate(this._curlyBrace, t)), void (this._curlyBrace = e);
    if (e.type === r.template || e.type === r.invalidTemplate)
      return this._curlyBrace && (a.push(this._curlyBrace), this._curlyBrace = null), void a.push(e);
    this._curlyBrace && (i.push(this.translate(this._curlyBrace, t)), this._curlyBrace = null), i.push(this.translate(e, t));
  } else
    this._curlyBrace && i.push(this.translate(this._curlyBrace, t));
} };
var Q9 = qm, X9 = 5, la = Symbol("espree's internal state"), wd = Symbol("espree's esprimaFinishNode");
function Y9(e) {
  var t = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : X9;
    if (typeof a != "number")
      throw new Error("ecmaVersion must be a number. Received value of type ".concat(xe(a), " instead."));
    var s = a;
    switch (s >= 2015 && (s -= 2009), s) {
      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        return s;
    }
    throw new Error("Invalid ecmaVersion.");
  }(e.ecmaVersion), n = function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "script";
    if (a === "script" || a === "module")
      return a;
    throw new Error("Invalid sourceType.");
  }(e.sourceType), r = e.range === !0, i = e.loc === !0;
  if (n === "module" && t < 6)
    throw new Error("sourceType 'module' is not supported when ecmaVersion < 2015. Consider adding `{ ecmaVersion: 2015 }` to the parser options.");
  return Object.assign({}, e, { ecmaVersion: t, sourceType: n, ranges: r, locations: i });
}
var Px = function() {
  return function(e) {
    var t = Object.assign({}, e.acorn.tokTypes);
    return e.acornJsx && Object.assign(t, e.acornJsx.tokTypes), function(n) {
      function r(i, a) {
        var s;
        We(this, r), xe(i) === "object" && i !== null || (i = {}), typeof a == "string" || a instanceof String || (a = String(a));
        var o = Y9(i), u = o.ecmaFeatures || {}, c = o.tokens === !0 ? new Q9(t, a) : null;
        return (s = Gt(this, rt(r).call(this, { ecmaVersion: o.ecmaVersion, sourceType: o.sourceType, ranges: o.ranges, locations: o.locations, allowReturnOutsideFunction: !!u.globalReturn, onToken: function(f) {
          c && c.onToken(f, s[la]), f.type !== t.eof && (s[la].lastToken = f);
        }, onComment: function(f, p, d, m, y, v) {
          if (s[la].comments) {
            var b = function(x, C, k, F, B, O) {
              var S = { type: x ? "Block" : "Line", value: C };
              return typeof k == "number" && (S.start = k, S.end = F, S.range = [k, F]), xe(B) === "object" && (S.loc = { start: B, end: O }), S;
            }(f, p, d, m, y, v);
            s[la].comments.push(b);
          }
        } }, a)))[la] = { tokens: c ? [] : null, comments: o.comment === !0 ? [] : null, impliedStrict: u.impliedStrict === !0 && s.options.ecmaVersion >= 5, ecmaVersion: s.options.ecmaVersion, jsxAttrValueToken: !1, lastToken: null }, s;
      }
      return $t(r, n), Xe(r, [{ key: "tokenize", value: function() {
        do
          this.next();
        while (this.type !== t.eof);
        this.next();
        var i = this[la], a = i.tokens;
        return i.comments && (a.comments = i.comments), a;
      } }, { key: "finishNode", value: function() {
        for (var i, a = arguments.length, s = new Array(a), o = 0; o < a; o++)
          s[o] = arguments[o];
        var u = (i = Yn(rt(r.prototype), "finishNode", this)).call.apply(i, [this].concat(s));
        return this[wd](u);
      } }, { key: "finishNodeAt", value: function() {
        for (var i, a = arguments.length, s = new Array(a), o = 0; o < a; o++)
          s[o] = arguments[o];
        var u = (i = Yn(rt(r.prototype), "finishNodeAt", this)).call.apply(i, [this].concat(s));
        return this[wd](u);
      } }, { key: "parse", value: function() {
        var i = this[la], a = Yn(rt(r.prototype), "parse", this).call(this);
        return a.sourceType = this.options.sourceType, i.comments && (a.comments = i.comments), i.tokens && (a.tokens = i.tokens), a.range && (a.range[0] = a.body.length ? a.body[0].range[0] : a.range[0], a.range[1] = i.lastToken ? i.lastToken.range[1] : a.range[1]), a.loc && (a.loc.start = a.body.length ? a.body[0].loc.start : a.loc.start, a.loc.end = i.lastToken ? i.lastToken.loc.end : a.loc.end), a;
      } }, { key: "parseTopLevel", value: function(i) {
        return this[la].impliedStrict && (this.strict = !0), Yn(rt(r.prototype), "parseTopLevel", this).call(this, i);
      } }, { key: "raise", value: function(i, a) {
        var s = e.acorn.getLineInfo(this.input, i), o = new SyntaxError(a);
        throw o.index = i, o.lineNumber = s.line, o.column = s.column + 1, o;
      } }, { key: "raiseRecoverable", value: function(i, a) {
        this.raise(i, a);
      } }, { key: "unexpected", value: function(i) {
        var a = "Unexpected token";
        if (i != null) {
          if (this.pos = i, this.options.locations)
            for (; this.pos < this.lineStart; )
              this.lineStart = this.input.lastIndexOf(`
`, this.lineStart - 2) + 1, --this.curLine;
          this.nextToken();
        }
        this.end > this.start && (a += " ".concat(this.input.slice(this.start, this.end))), this.raise(this.start, a);
      } }, { key: "jsx_readString", value: function(i) {
        var a = Yn(rt(r.prototype), "jsx_readString", this).call(this, i);
        return this.type === t.string && (this[la].jsxAttrValueToken = !0), a;
      } }, { key: wd, value: function(i) {
        if (i.type === "TemplateElement") {
          var a = this.input.slice(i.end, i.end + 2) === "${";
          i.range && (i.range[0]--, i.range[1] += a ? 2 : 1), i.loc && (i.loc.start.column--, i.loc.end.column += a ? 2 : 1);
        }
        return i.type.indexOf("Function") > -1 && !i.generator && (i.generator = !1), i;
      } }]), r;
    }(e);
  };
}, gk = "An Esprima-compatible JavaScript parser built on Acorn", yk = "Nicholas C. Zakas <nicholas+npm@nczconsulting.com>", vk = "https://github.com/eslint/espree", xk = ["lib", "espree.js"], bk = { node: ">=6.0.0" }, Ek = { url: "http://github.com/eslint/espree.git" }, Ck = { acorn: "^7.1.0", "acorn-jsx": "^5.1.0", "eslint-visitor-keys": "^1.1.0" }, Sk = { browserify: "^16.5.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", esprima: "latest", "esprima-fb": "^8001.2001.0-dev-harmony-fb", "json-diff": "^0.5.4", leche: "^2.3.0", mocha: "^6.2.0", nyc: "^14.1.1", regenerate: "^1.4.0", shelljs: "^0.3.0", "shelljs-nodecli": "^0.1.1", "unicode-6.3.0": "^0.7.5" }, kk = ["ast", "ecmascript", "javascript", "parser", "syntax", "acorn"], Dk = { "generate-regex": "node tools/generate-identifier-regex.js", test: "npm run-script lint && node Makefile.js test", lint: "node Makefile.js lint", browserify: "node Makefile.js browserify", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, Z9 = { name: "espree", description: gk, author: yk, homepage: vk, main: "espree.js", version: "6.1.2", files: xk, engines: bk, repository: "eslint/espree", bugs: Ek, license: "BSD-2-Clause", dependencies: Ck, devDependencies: Sk, keywords: kk, scripts: Dk }, e8 = Object.freeze({ __proto__: null, name: "espree", description: gk, author: yk, homepage: vk, main: "espree.js", version: "6.1.2", files: xk, engines: bk, repository: "eslint/espree", bugs: Ek, license: "BSD-2-Clause", dependencies: Ck, devDependencies: Sk, keywords: kk, scripts: Dk, default: Z9 }), Ix = Cr(_9), t8 = Cr(e8), Bx = { _regular: null, _jsx: null, get regular() {
  return this._regular === null && (this._regular = Ix.Parser.extend(Px())), this._regular;
}, get jsx() {
  return this._jsx === null && (this._jsx = Ix.Parser.extend(J9(), Px())), this._jsx;
}, get: function(e) {
  return e && e.ecmaFeatures && e.ecmaFeatures.jsx ? this.jsx : this.regular;
} }, n8 = { version: t8.version, tokenize: function(e, t) {
  var n = Bx.get(t);
  return t && t.tokens === !0 || (t = Object.assign({}, t, { tokens: !0 })), new n(t, e).tokenize();
}, parse: function(e, t) {
  return new (Bx.get(t))(t, e).parse();
}, Syntax: function() {
  var e, t = {};
  for (e in typeof Object.create == "function" && (t = /* @__PURE__ */ Object.create(null)), Fd)
    Object.hasOwnProperty.call(Fd, e) && (t[e] = Fd[e]);
  return typeof Object.freeze == "function" && Object.freeze(t), t;
}(), VisitorKeys: pf.KEYS }, r8 = gt(function(e, t) {
  (function() {
    var n, r = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "__lodash_hash_undefined__", o = 500, u = "__lodash_placeholder__", c = 1, f = 2, p = 4, d = 1, m = 2, y = 1, v = 2, b = 4, x = 8, C = 16, k = 32, F = 64, B = 128, O = 256, S = 512, w = 30, D = "...", I = 800, L = 16, V = 1, K = 2, W = 1 / 0, R = 9007199254740991, q = 17976931348623157e292, J = NaN, X = 4294967295, ce = X - 1, A = X >>> 1, M = [["ary", B], ["bind", y], ["bindKey", v], ["curry", x], ["curryRight", C], ["flip", S], ["partial", k], ["partialRight", F], ["rearg", O]], ne = "[object Arguments]", de = "[object Array]", he = "[object AsyncFunction]", j = "[object Boolean]", ie = "[object Date]", fe = "[object DOMException]", ge = "[object Error]", Fe = "[object Function]", Pe = "[object GeneratorFunction]", _ = "[object Map]", Q = "[object Number]", Y = "[object Null]", ae = "[object Object]", ue = "[object Proxy]", De = "[object RegExp]", Ee = "[object Set]", _e = "[object String]", Oe = "[object Symbol]", Ye = "[object Undefined]", _t = "[object WeakMap]", Kt = "[object WeakSet]", Jt = "[object ArrayBuffer]", zt = "[object DataView]", wn = "[object Float32Array]", Z = "[object Float64Array]", ee = "[object Int8Array]", oe = "[object Int16Array]", le = "[object Int32Array]", we = "[object Uint8Array]", Me = "[object Uint8ClampedArray]", Ve = "[object Uint16Array]", $e = "[object Uint32Array]", yt = /\b__p \+= '';/g, ze = /\b(__p \+=) '' \+/g, vt = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Nt = /&(?:amp|lt|gt|quot|#39);/g, Qt = /[&<>"']/g, bt = RegExp(Nt.source), at = RegExp(Qt.source), jt = /<%-([\s\S]+?)%>/g, dn = /<%([\s\S]+?)%>/g, Rn = /<%=([\s\S]+?)%>/g, qn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Sr = /^\w*$/, pi = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Bn = /[\\^$.*+?()[\]{}|]/g, er = RegExp(Bn.source), fi = /^\s+|\s+$/g, kr = /^\s+/, oo = /\s+$/, Fi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, so = /\{\n\/\* \[wrapped with (.+)\] \*/, Hi = /,? & /, Ki = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Wn = /\\(\\)?/g, Ie = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, je = /\w*$/, Ze = /^[-+]0x[0-9a-f]+$/i, an = /^0b[01]+$/i, Rt = /^\[object .+?Constructor\]$/, wi = /^0o[0-7]+$/i, Wo = /^(?:0|[1-9]\d*)$/, ot = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Mn = /($^)/, Ji = /['\n\r\u2028\u2029\\]/g, uo = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Qi = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", On = "[\\ud800-\\udfff]", Fc = "[" + Qi + "]", Xi = "[" + uo + "]", $o = "\\d+", wc = "[\\u2700-\\u27bf]", $n = "[a-z\\xdf-\\xf6\\xf8-\\xff]", Ht = "[^\\ud800-\\udfff" + Qi + $o + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]", Dr = "\\ud83c[\\udffb-\\udfff]", Vr = "[^\\ud800-\\udfff]", Gn = "(?:\\ud83c[\\udde6-\\uddff]){2}", zn = "[\\ud800-\\udbff][\\udc00-\\udfff]", tr = "[A-Z\\xc0-\\xd6\\xd8-\\xde]", tu = "(?:" + $n + "|" + Ht + ")", Ac = "(?:" + tr + "|" + Ht + ")", co = "(?:" + Xi + "|" + Dr + ")?", Go = "[\\ufe0e\\ufe0f]?" + co + ("(?:\\u200d(?:" + [Vr, Gn, zn].join("|") + ")[\\ufe0e\\ufe0f]?" + co + ")*"), JA = "(?:" + [wc, Gn, zn].join("|") + ")" + Go, QA = "(?:" + [Vr + Xi + "?", Xi, Gn, zn, On].join("|") + ")", XA = RegExp("['’]", "g"), YA = RegExp(Xi, "g"), Df = RegExp(Dr + "(?=" + Dr + ")|" + QA + Go, "g"), ZA = RegExp([tr + "?" + $n + "+(?:['’](?:d|ll|m|re|s|t|ve))?(?=" + [Fc, tr, "$"].join("|") + ")", Ac + "+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=" + [Fc, tr + tu, "$"].join("|") + ")", tr + "?" + tu + "+(?:['’](?:d|ll|m|re|s|t|ve))?", tr + "+(?:['’](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $o, JA].join("|"), "g"), e3 = RegExp("[\\u200d\\ud800-\\udfff" + uo + "\\ufe0e\\ufe0f]"), t3 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, n3 = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], r3 = -1, Zt = {};
    Zt[wn] = Zt[Z] = Zt[ee] = Zt[oe] = Zt[le] = Zt[we] = Zt[Me] = Zt[Ve] = Zt[$e] = !0, Zt[ne] = Zt[de] = Zt[Jt] = Zt[j] = Zt[zt] = Zt[ie] = Zt[ge] = Zt[Fe] = Zt[_] = Zt[Q] = Zt[ae] = Zt[De] = Zt[Ee] = Zt[_e] = Zt[_t] = !1;
    var Xt = {};
    Xt[ne] = Xt[de] = Xt[Jt] = Xt[zt] = Xt[j] = Xt[ie] = Xt[wn] = Xt[Z] = Xt[ee] = Xt[oe] = Xt[le] = Xt[_] = Xt[Q] = Xt[ae] = Xt[De] = Xt[Ee] = Xt[_e] = Xt[Oe] = Xt[we] = Xt[Me] = Xt[Ve] = Xt[$e] = !0, Xt[ge] = Xt[Fe] = Xt[_t] = !1;
    var i3 = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, a3 = parseFloat, o3 = parseInt, cg = xe(ni) == "object" && ni && ni.Object === Object && ni, s3 = (typeof self > "u" ? "undefined" : xe(self)) == "object" && self && self.Object === Object && self, Vn = cg || s3 || Function("return this")(), Ff = t && !t.nodeType && t, lo = Ff && e && !e.nodeType && e, lg = lo && lo.exports === Ff, wf = lg && cg.process, Ur = function() {
      try {
        var pe = lo && lo.require && lo.require("util").types;
        return pe || wf && wf.binding && wf.binding("util");
      } catch {
      }
    }(), pg = Ur && Ur.isArrayBuffer, fg = Ur && Ur.isDate, hg = Ur && Ur.isMap, dg = Ur && Ur.isRegExp, mg = Ur && Ur.isSet, gg = Ur && Ur.isTypedArray;
    function Fr(pe, ke, Ce) {
      switch (Ce.length) {
        case 0:
          return pe.call(ke);
        case 1:
          return pe.call(ke, Ce[0]);
        case 2:
          return pe.call(ke, Ce[0], Ce[1]);
        case 3:
          return pe.call(ke, Ce[0], Ce[1], Ce[2]);
      }
      return pe.apply(ke, Ce);
    }
    function u3(pe, ke, Ce, Ne) {
      for (var it = -1, Pt = pe == null ? 0 : pe.length; ++it < Pt; ) {
        var An = pe[it];
        ke(Ne, An, Ce(An), pe);
      }
      return Ne;
    }
    function qr(pe, ke) {
      for (var Ce = -1, Ne = pe == null ? 0 : pe.length; ++Ce < Ne && ke(pe[Ce], Ce, pe) !== !1; )
        ;
      return pe;
    }
    function c3(pe, ke) {
      for (var Ce = pe == null ? 0 : pe.length; Ce-- && ke(pe[Ce], Ce, pe) !== !1; )
        ;
      return pe;
    }
    function yg(pe, ke) {
      for (var Ce = -1, Ne = pe == null ? 0 : pe.length; ++Ce < Ne; )
        if (!ke(pe[Ce], Ce, pe))
          return !1;
      return !0;
    }
    function Pa(pe, ke) {
      for (var Ce = -1, Ne = pe == null ? 0 : pe.length, it = 0, Pt = []; ++Ce < Ne; ) {
        var An = pe[Ce];
        ke(An, Ce, pe) && (Pt[it++] = An);
      }
      return Pt;
    }
    function _c(pe, ke) {
      return !!(pe != null && pe.length) && zo(pe, ke, 0) > -1;
    }
    function Af(pe, ke, Ce) {
      for (var Ne = -1, it = pe == null ? 0 : pe.length; ++Ne < it; )
        if (Ce(ke, pe[Ne]))
          return !0;
      return !1;
    }
    function un(pe, ke) {
      for (var Ce = -1, Ne = pe == null ? 0 : pe.length, it = Array(Ne); ++Ce < Ne; )
        it[Ce] = ke(pe[Ce], Ce, pe);
      return it;
    }
    function Ia(pe, ke) {
      for (var Ce = -1, Ne = ke.length, it = pe.length; ++Ce < Ne; )
        pe[it + Ce] = ke[Ce];
      return pe;
    }
    function _f(pe, ke, Ce, Ne) {
      var it = -1, Pt = pe == null ? 0 : pe.length;
      for (Ne && Pt && (Ce = pe[++it]); ++it < Pt; )
        Ce = ke(Ce, pe[it], it, pe);
      return Ce;
    }
    function l3(pe, ke, Ce, Ne) {
      var it = pe == null ? 0 : pe.length;
      for (Ne && it && (Ce = pe[--it]); it--; )
        Ce = ke(Ce, pe[it], it, pe);
      return Ce;
    }
    function Tf(pe, ke) {
      for (var Ce = -1, Ne = pe == null ? 0 : pe.length; ++Ce < Ne; )
        if (ke(pe[Ce], Ce, pe))
          return !0;
      return !1;
    }
    var p3 = Pf("length");
    function vg(pe, ke, Ce) {
      var Ne;
      return Ce(pe, function(it, Pt, An) {
        if (ke(it, Pt, An))
          return Ne = Pt, !1;
      }), Ne;
    }
    function Tc(pe, ke, Ce, Ne) {
      for (var it = pe.length, Pt = Ce + (Ne ? 1 : -1); Ne ? Pt-- : ++Pt < it; )
        if (ke(pe[Pt], Pt, pe))
          return Pt;
      return -1;
    }
    function zo(pe, ke, Ce) {
      return ke == ke ? function(Ne, it, Pt) {
        for (var An = Pt - 1, Ai = Ne.length; ++An < Ai; )
          if (Ne[An] === it)
            return An;
        return -1;
      }(pe, ke, Ce) : Tc(pe, xg, Ce);
    }
    function f3(pe, ke, Ce, Ne) {
      for (var it = Ce - 1, Pt = pe.length; ++it < Pt; )
        if (Ne(pe[it], ke))
          return it;
      return -1;
    }
    function xg(pe) {
      return pe != pe;
    }
    function bg(pe, ke) {
      var Ce = pe == null ? 0 : pe.length;
      return Ce ? Bf(pe, ke) / Ce : J;
    }
    function Pf(pe) {
      return function(ke) {
        return ke == null ? n : ke[pe];
      };
    }
    function If(pe) {
      return function(ke) {
        return pe == null ? n : pe[ke];
      };
    }
    function Eg(pe, ke, Ce, Ne, it) {
      return it(pe, function(Pt, An, Ai) {
        Ce = Ne ? (Ne = !1, Pt) : ke(Ce, Pt, An, Ai);
      }), Ce;
    }
    function Bf(pe, ke) {
      for (var Ce, Ne = -1, it = pe.length; ++Ne < it; ) {
        var Pt = ke(pe[Ne]);
        Pt !== n && (Ce = Ce === n ? Pt : Ce + Pt);
      }
      return Ce;
    }
    function Of(pe, ke) {
      for (var Ce = -1, Ne = Array(pe); ++Ce < pe; )
        Ne[Ce] = ke(Ce);
      return Ne;
    }
    function wr(pe) {
      return function(ke) {
        return pe(ke);
      };
    }
    function Lf(pe, ke) {
      return un(ke, function(Ce) {
        return pe[Ce];
      });
    }
    function nu(pe, ke) {
      return pe.has(ke);
    }
    function Cg(pe, ke) {
      for (var Ce = -1, Ne = pe.length; ++Ce < Ne && zo(ke, pe[Ce], 0) > -1; )
        ;
      return Ce;
    }
    function Sg(pe, ke) {
      for (var Ce = pe.length; Ce-- && zo(ke, pe[Ce], 0) > -1; )
        ;
      return Ce;
    }
    var h3 = If({ À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" }), d3 = If({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" });
    function m3(pe) {
      return "\\" + i3[pe];
    }
    function Ho(pe) {
      return e3.test(pe);
    }
    function Nf(pe) {
      var ke = -1, Ce = Array(pe.size);
      return pe.forEach(function(Ne, it) {
        Ce[++ke] = [it, Ne];
      }), Ce;
    }
    function kg(pe, ke) {
      return function(Ce) {
        return pe(ke(Ce));
      };
    }
    function Ba(pe, ke) {
      for (var Ce = -1, Ne = pe.length, it = 0, Pt = []; ++Ce < Ne; ) {
        var An = pe[Ce];
        An !== ke && An !== u || (pe[Ce] = u, Pt[it++] = Ce);
      }
      return Pt;
    }
    function Pc(pe) {
      var ke = -1, Ce = Array(pe.size);
      return pe.forEach(function(Ne) {
        Ce[++ke] = Ne;
      }), Ce;
    }
    function g3(pe) {
      var ke = -1, Ce = Array(pe.size);
      return pe.forEach(function(Ne) {
        Ce[++ke] = [Ne, Ne];
      }), Ce;
    }
    function Ko(pe) {
      return Ho(pe) ? function(ke) {
        for (var Ce = Df.lastIndex = 0; Df.test(ke); )
          ++Ce;
        return Ce;
      }(pe) : p3(pe);
    }
    function hi(pe) {
      return Ho(pe) ? function(ke) {
        return ke.match(Df) || [];
      }(pe) : function(ke) {
        return ke.split("");
      }(pe);
    }
    var y3 = If({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }), Jo = function pe(ke) {
      var Ce, Ne = (ke = ke == null ? Vn : Jo.defaults(Vn.Object(), ke, Jo.pick(Vn, n3))).Array, it = ke.Date, Pt = ke.Error, An = ke.Function, Ai = ke.Math, en = ke.Object, jf = ke.RegExp, v3 = ke.String, Wr = ke.TypeError, Ic = Ne.prototype, x3 = An.prototype, Qo = en.prototype, Bc = ke["__core-js_shared__"], Oc = x3.toString, qt = Qo.hasOwnProperty, b3 = 0, Dg = (Ce = /[^.]+$/.exec(Bc && Bc.keys && Bc.keys.IE_PROTO || "")) ? "Symbol(src)_1." + Ce : "", Lc = Qo.toString, E3 = Oc.call(en), C3 = Vn._, S3 = jf("^" + Oc.call(qt).replace(Bn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Nc = lg ? ke.Buffer : n, Oa = ke.Symbol, jc = ke.Uint8Array, Fg = Nc ? Nc.allocUnsafe : n, Rc = kg(en.getPrototypeOf, en), wg = en.create, Ag = Qo.propertyIsEnumerable, Mc = Ic.splice, _g = Oa ? Oa.isConcatSpreadable : n, ru = Oa ? Oa.iterator : n, po = Oa ? Oa.toStringTag : n, Vc = function() {
        try {
          var h = go(en, "defineProperty");
          return h({}, "", {}), h;
        } catch {
        }
      }(), k3 = ke.clearTimeout !== Vn.clearTimeout && ke.clearTimeout, D3 = it && it.now !== Vn.Date.now && it.now, F3 = ke.setTimeout !== Vn.setTimeout && ke.setTimeout, Uc = Ai.ceil, qc = Ai.floor, Rf = en.getOwnPropertySymbols, w3 = Nc ? Nc.isBuffer : n, Tg = ke.isFinite, A3 = Ic.join, _3 = kg(en.keys, en), _n = Ai.max, Hn = Ai.min, T3 = it.now, P3 = ke.parseInt, Pg = Ai.random, I3 = Ic.reverse, Mf = go(ke, "DataView"), iu = go(ke, "Map"), Vf = go(ke, "Promise"), Xo = go(ke, "Set"), au = go(ke, "WeakMap"), ou = go(en, "create"), Wc = au && new au(), Yo = {}, B3 = yo(Mf), O3 = yo(iu), L3 = yo(Vf), N3 = yo(Xo), j3 = yo(au), $c = Oa ? Oa.prototype : n, su = $c ? $c.valueOf : n, Ig = $c ? $c.toString : n;
      function U(h) {
        if (mn(h) && !st(h) && !(h instanceof St)) {
          if (h instanceof $r)
            return h;
          if (qt.call(h, "__wrapped__"))
            return B1(h);
        }
        return new $r(h);
      }
      var Zo = function() {
        function h() {
        }
        return function(g) {
          if (!cn(g))
            return {};
          if (wg)
            return wg(g);
          h.prototype = g;
          var E = new h();
          return h.prototype = n, E;
        };
      }();
      function Gc() {
      }
      function $r(h, g) {
        this.__wrapped__ = h, this.__actions__ = [], this.__chain__ = !!g, this.__index__ = 0, this.__values__ = n;
      }
      function St(h) {
        this.__wrapped__ = h, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = X, this.__views__ = [];
      }
      function fo(h) {
        var g = -1, E = h == null ? 0 : h.length;
        for (this.clear(); ++g < E; ) {
          var T = h[g];
          this.set(T[0], T[1]);
        }
      }
      function Yi(h) {
        var g = -1, E = h == null ? 0 : h.length;
        for (this.clear(); ++g < E; ) {
          var T = h[g];
          this.set(T[0], T[1]);
        }
      }
      function Zi(h) {
        var g = -1, E = h == null ? 0 : h.length;
        for (this.clear(); ++g < E; ) {
          var T = h[g];
          this.set(T[0], T[1]);
        }
      }
      function ho(h) {
        var g = -1, E = h == null ? 0 : h.length;
        for (this.__data__ = new Zi(); ++g < E; )
          this.add(h[g]);
      }
      function di(h) {
        var g = this.__data__ = new Yi(h);
        this.size = g.size;
      }
      function Bg(h, g) {
        var E = st(h), T = !E && vo(h), N = !E && !T && Ma(h), z = !E && !T && !N && is(h), te = E || T || N || z, re = te ? Of(h.length, v3) : [], se = re.length;
        for (var be in h)
          !g && !qt.call(h, be) || te && (be == "length" || N && (be == "offset" || be == "parent") || z && (be == "buffer" || be == "byteLength" || be == "byteOffset") || ra(be, se)) || re.push(be);
        return re;
      }
      function Og(h) {
        var g = h.length;
        return g ? h[Xf(0, g - 1)] : n;
      }
      function R3(h, g) {
        return al(pr(h), mo(g, 0, h.length));
      }
      function M3(h) {
        return al(pr(h));
      }
      function Uf(h, g, E) {
        (E === n || mi(h[g], E)) && (E !== n || g in h) || ea(h, g, E);
      }
      function uu(h, g, E) {
        var T = h[g];
        qt.call(h, g) && mi(T, E) && (E !== n || g in h) || ea(h, g, E);
      }
      function zc(h, g) {
        for (var E = h.length; E--; )
          if (mi(h[E][0], g))
            return E;
        return -1;
      }
      function V3(h, g, E, T) {
        return La(h, function(N, z, te) {
          g(T, N, E(N), te);
        }), T;
      }
      function Lg(h, g) {
        return h && Ti(g, Ln(g), h);
      }
      function ea(h, g, E) {
        g == "__proto__" && Vc ? Vc(h, g, { configurable: !0, enumerable: !0, value: E, writable: !0 }) : h[g] = E;
      }
      function qf(h, g) {
        for (var E = -1, T = g.length, N = Ne(T), z = h == null; ++E < T; )
          N[E] = z ? n : Ch(h, g[E]);
        return N;
      }
      function mo(h, g, E) {
        return h == h && (E !== n && (h = h <= E ? h : E), g !== n && (h = h >= g ? h : g)), h;
      }
      function Gr(h, g, E, T, N, z) {
        var te, re = g & c, se = g & f, be = g & p;
        if (E && (te = N ? E(h, T, N, z) : E(h)), te !== n)
          return te;
        if (!cn(h))
          return h;
        var ve = st(h);
        if (ve) {
          if (te = function(Se) {
            var Te = Se.length, et = new Se.constructor(Te);
            return Te && typeof Se[0] == "string" && qt.call(Se, "index") && (et.index = Se.index, et.input = Se.input), et;
          }(h), !re)
            return pr(h, te);
        } else {
          var Ae = Kn(h), Ue = Ae == Fe || Ae == Pe;
          if (Ma(h))
            return a1(h, re);
          if (Ae == ae || Ae == ne || Ue && !N) {
            if (te = se || Ue ? {} : k1(h), !re)
              return se ? function(Se, Te) {
                return Ti(Se, C1(Se), Te);
              }(h, function(Se, Te) {
                return Se && Ti(Te, hr(Te), Se);
              }(te, h)) : function(Se, Te) {
                return Ti(Se, ph(Se), Te);
              }(h, Lg(te, h));
          } else {
            if (!Xt[Ae])
              return N ? h : {};
            te = function(Se, Te, et) {
              var Le = Se.constructor;
              switch (Te) {
                case Jt:
                  return ih(Se);
                case j:
                case ie:
                  return new Le(+Se);
                case zt:
                  return function(nt, Bt) {
                    var Ge = Bt ? ih(nt.buffer) : nt.buffer;
                    return new nt.constructor(Ge, nt.byteOffset, nt.byteLength);
                  }(Se, et);
                case wn:
                case Z:
                case ee:
                case oe:
                case le:
                case we:
                case Me:
                case Ve:
                case $e:
                  return o1(Se, et);
                case _:
                  return new Le();
                case Q:
                case _e:
                  return new Le(Se);
                case De:
                  return function(nt) {
                    var Bt = new nt.constructor(nt.source, je.exec(nt));
                    return Bt.lastIndex = nt.lastIndex, Bt;
                  }(Se);
                case Ee:
                  return new Le();
                case Oe:
                  return ut = Se, su ? en(su.call(ut)) : {};
              }
              var ut;
            }(h, Ae, re);
          }
        }
        z || (z = new di());
        var qe = z.get(h);
        if (qe)
          return qe;
        z.set(h, te), X1(h) ? h.forEach(function(Se) {
          te.add(Gr(Se, g, E, Se, h, z));
        }) : J1(h) && h.forEach(function(Se, Te) {
          te.set(Te, Gr(Se, g, E, Te, h, z));
        });
        var Qe = ve ? n : (be ? se ? uh : sh : se ? hr : Ln)(h);
        return qr(Qe || h, function(Se, Te) {
          Qe && (Se = h[Te = Se]), uu(te, Te, Gr(Se, g, E, Te, h, z));
        }), te;
      }
      function Ng(h, g, E) {
        var T = E.length;
        if (h == null)
          return !T;
        for (h = en(h); T--; ) {
          var N = E[T], z = g[N], te = h[N];
          if (te === n && !(N in h) || !z(te))
            return !1;
        }
        return !0;
      }
      function jg(h, g, E) {
        if (typeof h != "function")
          throw new Wr(a);
        return mu(function() {
          h.apply(n, E);
        }, g);
      }
      function cu(h, g, E, T) {
        var N = -1, z = _c, te = !0, re = h.length, se = [], be = g.length;
        if (!re)
          return se;
        E && (g = un(g, wr(E))), T ? (z = Af, te = !1) : g.length >= r && (z = nu, te = !1, g = new ho(g));
        e:
          for (; ++N < re; ) {
            var ve = h[N], Ae = E == null ? ve : E(ve);
            if (ve = T || ve !== 0 ? ve : 0, te && Ae == Ae) {
              for (var Ue = be; Ue--; )
                if (g[Ue] === Ae)
                  continue e;
              se.push(ve);
            } else
              z(g, Ae, T) || se.push(ve);
          }
        return se;
      }
      U.templateSettings = { escape: jt, evaluate: dn, interpolate: Rn, variable: "", imports: { _: U } }, U.prototype = Gc.prototype, U.prototype.constructor = U, $r.prototype = Zo(Gc.prototype), $r.prototype.constructor = $r, St.prototype = Zo(Gc.prototype), St.prototype.constructor = St, fo.prototype.clear = function() {
        this.__data__ = ou ? ou(null) : {}, this.size = 0;
      }, fo.prototype.delete = function(h) {
        var g = this.has(h) && delete this.__data__[h];
        return this.size -= g ? 1 : 0, g;
      }, fo.prototype.get = function(h) {
        var g = this.__data__;
        if (ou) {
          var E = g[h];
          return E === s ? n : E;
        }
        return qt.call(g, h) ? g[h] : n;
      }, fo.prototype.has = function(h) {
        var g = this.__data__;
        return ou ? g[h] !== n : qt.call(g, h);
      }, fo.prototype.set = function(h, g) {
        var E = this.__data__;
        return this.size += this.has(h) ? 0 : 1, E[h] = ou && g === n ? s : g, this;
      }, Yi.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
      }, Yi.prototype.delete = function(h) {
        var g = this.__data__, E = zc(g, h);
        return !(E < 0) && (E == g.length - 1 ? g.pop() : Mc.call(g, E, 1), --this.size, !0);
      }, Yi.prototype.get = function(h) {
        var g = this.__data__, E = zc(g, h);
        return E < 0 ? n : g[E][1];
      }, Yi.prototype.has = function(h) {
        return zc(this.__data__, h) > -1;
      }, Yi.prototype.set = function(h, g) {
        var E = this.__data__, T = zc(E, h);
        return T < 0 ? (++this.size, E.push([h, g])) : E[T][1] = g, this;
      }, Zi.prototype.clear = function() {
        this.size = 0, this.__data__ = { hash: new fo(), map: new (iu || Yi)(), string: new fo() };
      }, Zi.prototype.delete = function(h) {
        var g = il(this, h).delete(h);
        return this.size -= g ? 1 : 0, g;
      }, Zi.prototype.get = function(h) {
        return il(this, h).get(h);
      }, Zi.prototype.has = function(h) {
        return il(this, h).has(h);
      }, Zi.prototype.set = function(h, g) {
        var E = il(this, h), T = E.size;
        return E.set(h, g), this.size += E.size == T ? 0 : 1, this;
      }, ho.prototype.add = ho.prototype.push = function(h) {
        return this.__data__.set(h, s), this;
      }, ho.prototype.has = function(h) {
        return this.__data__.has(h);
      }, di.prototype.clear = function() {
        this.__data__ = new Yi(), this.size = 0;
      }, di.prototype.delete = function(h) {
        var g = this.__data__, E = g.delete(h);
        return this.size = g.size, E;
      }, di.prototype.get = function(h) {
        return this.__data__.get(h);
      }, di.prototype.has = function(h) {
        return this.__data__.has(h);
      }, di.prototype.set = function(h, g) {
        var E = this.__data__;
        if (E instanceof Yi) {
          var T = E.__data__;
          if (!iu || T.length < r - 1)
            return T.push([h, g]), this.size = ++E.size, this;
          E = this.__data__ = new Zi(T);
        }
        return E.set(h, g), this.size = E.size, this;
      };
      var La = l1(_i), Rg = l1($f, !0);
      function U3(h, g) {
        var E = !0;
        return La(h, function(T, N, z) {
          return E = !!g(T, N, z);
        }), E;
      }
      function Hc(h, g, E) {
        for (var T = -1, N = h.length; ++T < N; ) {
          var z = h[T], te = g(z);
          if (te != null && (re === n ? te == te && !_r(te) : E(te, re)))
            var re = te, se = z;
        }
        return se;
      }
      function Mg(h, g) {
        var E = [];
        return La(h, function(T, N, z) {
          g(T, N, z) && E.push(T);
        }), E;
      }
      function Un(h, g, E, T, N) {
        var z = -1, te = h.length;
        for (E || (E = Z3), N || (N = []); ++z < te; ) {
          var re = h[z];
          g > 0 && E(re) ? g > 1 ? Un(re, g - 1, E, T, N) : Ia(N, re) : T || (N[N.length] = re);
        }
        return N;
      }
      var Wf = p1(), Vg = p1(!0);
      function _i(h, g) {
        return h && Wf(h, g, Ln);
      }
      function $f(h, g) {
        return h && Vg(h, g, Ln);
      }
      function Kc(h, g) {
        return Pa(g, function(E) {
          return ia(h[E]);
        });
      }
      function es(h, g) {
        for (var E = 0, T = (g = ja(g, h)).length; h != null && E < T; )
          h = h[Pi(g[E++])];
        return E && E == T ? h : n;
      }
      function Ug(h, g, E) {
        var T = g(h);
        return st(h) ? T : Ia(T, E(h));
      }
      function nr(h) {
        return h == null ? h === n ? Ye : Y : po && po in en(h) ? function(g) {
          var E = qt.call(g, po), T = g[po];
          try {
            g[po] = n;
            var N = !0;
          } catch {
          }
          var z = Lc.call(g);
          return N && (E ? g[po] = T : delete g[po]), z;
        }(h) : function(g) {
          return Lc.call(g);
        }(h);
      }
      function Gf(h, g) {
        return h > g;
      }
      function q3(h, g) {
        return h != null && qt.call(h, g);
      }
      function W3(h, g) {
        return h != null && g in en(h);
      }
      function zf(h, g, E) {
        for (var T = E ? Af : _c, N = h[0].length, z = h.length, te = z, re = Ne(z), se = 1 / 0, be = []; te--; ) {
          var ve = h[te];
          te && g && (ve = un(ve, wr(g))), se = Hn(ve.length, se), re[te] = !E && (g || N >= 120 && ve.length >= 120) ? new ho(te && ve) : n;
        }
        ve = h[0];
        var Ae = -1, Ue = re[0];
        e:
          for (; ++Ae < N && be.length < se; ) {
            var qe = ve[Ae], Qe = g ? g(qe) : qe;
            if (qe = E || qe !== 0 ? qe : 0, !(Ue ? nu(Ue, Qe) : T(be, Qe, E))) {
              for (te = z; --te; ) {
                var Se = re[te];
                if (!(Se ? nu(Se, Qe) : T(h[te], Qe, E)))
                  continue e;
              }
              Ue && Ue.push(Qe), be.push(qe);
            }
          }
        return be;
      }
      function lu(h, g, E) {
        var T = (h = A1(h, g = ja(g, h))) == null ? h : h[Pi(Hr(g))];
        return T == null ? n : Fr(T, h, E);
      }
      function qg(h) {
        return mn(h) && nr(h) == ne;
      }
      function pu(h, g, E, T, N) {
        return h === g || (h == null || g == null || !mn(h) && !mn(g) ? h != h && g != g : function(z, te, re, se, be, ve) {
          var Ae = st(z), Ue = st(te), qe = Ae ? de : Kn(z), Qe = Ue ? de : Kn(te), Se = (qe = qe == ne ? ae : qe) == ae, Te = (Qe = Qe == ne ? ae : Qe) == ae, et = qe == Qe;
          if (et && Ma(z)) {
            if (!Ma(te))
              return !1;
            Ae = !0, Se = !1;
          }
          if (et && !Se)
            return ve || (ve = new di()), Ae || is(z) ? E1(z, te, re, se, be, ve) : function(Ge, tt, Tn, Sn, ir, tn, Jn) {
              switch (Tn) {
                case zt:
                  if (Ge.byteLength != tt.byteLength || Ge.byteOffset != tt.byteOffset)
                    return !1;
                  Ge = Ge.buffer, tt = tt.buffer;
                case Jt:
                  return !(Ge.byteLength != tt.byteLength || !tn(new jc(Ge), new jc(tt)));
                case j:
                case ie:
                case Q:
                  return mi(+Ge, +tt);
                case ge:
                  return Ge.name == tt.name && Ge.message == tt.message;
                case De:
                case _e:
                  return Ge == tt + "";
                case _:
                  var Ii = Nf;
                case Ee:
                  var Va = Sn & d;
                  if (Ii || (Ii = Pc), Ge.size != tt.size && !Va)
                    return !1;
                  var dl = Jn.get(Ge);
                  if (dl)
                    return dl == tt;
                  Sn |= m, Jn.set(Ge, tt);
                  var os = E1(Ii(Ge), Ii(tt), Sn, ir, tn, Jn);
                  return Jn.delete(Ge), os;
                case Oe:
                  if (su)
                    return su.call(Ge) == su.call(tt);
              }
              return !1;
            }(z, te, qe, re, se, be, ve);
          if (!(re & d)) {
            var Le = Se && qt.call(z, "__wrapped__"), ut = Te && qt.call(te, "__wrapped__");
            if (Le || ut) {
              var nt = Le ? z.value() : z, Bt = ut ? te.value() : te;
              return ve || (ve = new di()), be(nt, Bt, re, se, ve);
            }
          }
          return et ? (ve || (ve = new di()), function(Ge, tt, Tn, Sn, ir, tn) {
            var Jn = Tn & d, Ii = sh(Ge), Va = Ii.length, dl = sh(tt).length;
            if (Va != dl && !Jn)
              return !1;
            for (var os = Va; os--; ) {
              var Ua = Ii[os];
              if (!(Jn ? Ua in tt : qt.call(tt, Ua)))
                return !1;
            }
            var py = tn.get(Ge);
            if (py && tn.get(tt))
              return py == tt;
            var ml = !0;
            tn.set(Ge, tt), tn.set(tt, Ge);
            for (var Ih = Jn; ++os < Va; ) {
              Ua = Ii[os];
              var gl = Ge[Ua], yl = tt[Ua];
              if (Sn)
                var fy = Jn ? Sn(yl, gl, Ua, tt, Ge, tn) : Sn(gl, yl, Ua, Ge, tt, tn);
              if (!(fy === n ? gl === yl || ir(gl, yl, Tn, Sn, tn) : fy)) {
                ml = !1;
                break;
              }
              Ih || (Ih = Ua == "constructor");
            }
            if (ml && !Ih) {
              var vl = Ge.constructor, xl = tt.constructor;
              vl != xl && "constructor" in Ge && "constructor" in tt && !(typeof vl == "function" && vl instanceof vl && typeof xl == "function" && xl instanceof xl) && (ml = !1);
            }
            return tn.delete(Ge), tn.delete(tt), ml;
          }(z, te, re, se, be, ve)) : !1;
        }(h, g, E, T, pu, N));
      }
      function Hf(h, g, E, T) {
        var N = E.length, z = N, te = !T;
        if (h == null)
          return !z;
        for (h = en(h); N--; ) {
          var re = E[N];
          if (te && re[2] ? re[1] !== h[re[0]] : !(re[0] in h))
            return !1;
        }
        for (; ++N < z; ) {
          var se = (re = E[N])[0], be = h[se], ve = re[1];
          if (te && re[2]) {
            if (be === n && !(se in h))
              return !1;
          } else {
            var Ae = new di();
            if (T)
              var Ue = T(be, ve, se, h, g, Ae);
            if (!(Ue === n ? pu(ve, be, d | m, T, Ae) : Ue))
              return !1;
          }
        }
        return !0;
      }
      function Wg(h) {
        return !(!cn(h) || (g = h, Dg && Dg in g)) && (ia(h) ? S3 : Rt).test(yo(h));
        var g;
      }
      function $g(h) {
        return typeof h == "function" ? h : h == null ? dr : xe(h) == "object" ? st(h) ? Hg(h[0], h[1]) : zg(h) : ly(h);
      }
      function Kf(h) {
        if (!du(h))
          return _3(h);
        var g = [];
        for (var E in en(h))
          qt.call(h, E) && E != "constructor" && g.push(E);
        return g;
      }
      function $3(h) {
        if (!cn(h))
          return function(N) {
            var z = [];
            if (N != null)
              for (var te in en(N))
                z.push(te);
            return z;
          }(h);
        var g = du(h), E = [];
        for (var T in h)
          (T != "constructor" || !g && qt.call(h, T)) && E.push(T);
        return E;
      }
      function Jf(h, g) {
        return h < g;
      }
      function Gg(h, g) {
        var E = -1, T = fr(h) ? Ne(h.length) : [];
        return La(h, function(N, z, te) {
          T[++E] = g(N, z, te);
        }), T;
      }
      function zg(h) {
        var g = lh(h);
        return g.length == 1 && g[0][2] ? F1(g[0][0], g[0][1]) : function(E) {
          return E === h || Hf(E, h, g);
        };
      }
      function Hg(h, g) {
        return fh(h) && D1(g) ? F1(Pi(h), g) : function(E) {
          var T = Ch(E, h);
          return T === n && T === g ? Sh(E, h) : pu(g, T, d | m);
        };
      }
      function Jc(h, g, E, T, N) {
        h !== g && Wf(g, function(z, te) {
          if (N || (N = new di()), cn(z))
            (function(se, be, ve, Ae, Ue, qe, Qe) {
              var Se = dh(se, ve), Te = dh(be, ve), et = Qe.get(Te);
              if (et)
                return void Uf(se, ve, et);
              var Le = qe ? qe(Se, Te, ve + "", se, be, Qe) : n, ut = Le === n;
              if (ut) {
                var nt = st(Te), Bt = !nt && Ma(Te), Ge = !nt && !Bt && is(Te);
                Le = Te, nt || Bt || Ge ? st(Se) ? Le = Se : Cn(Se) ? Le = pr(Se) : Bt ? (ut = !1, Le = a1(Te, !0)) : Ge ? (ut = !1, Le = o1(Te, !0)) : Le = [] : gu(Te) || vo(Te) ? (Le = Se, vo(Se) ? Le = ey(Se) : cn(Se) && !ia(Se) || (Le = k1(Te))) : ut = !1;
              }
              ut && (Qe.set(Te, Le), Ue(Le, Te, Ae, qe, Qe), Qe.delete(Te)), Uf(se, ve, Le);
            })(h, g, te, E, Jc, T, N);
          else {
            var re = T ? T(dh(h, te), z, te + "", h, g, N) : n;
            re === n && (re = z), Uf(h, te, re);
          }
        }, hr);
      }
      function Kg(h, g) {
        var E = h.length;
        if (E)
          return ra(g += g < 0 ? E : 0, E) ? h[g] : n;
      }
      function Jg(h, g, E) {
        var T = -1;
        return g = un(g.length ? g : [dr], wr(Je())), function(N, z) {
          var te = N.length;
          for (N.sort(z); te--; )
            N[te] = N[te].value;
          return N;
        }(Gg(h, function(N, z, te) {
          return { criteria: un(g, function(re) {
            return re(N);
          }), index: ++T, value: N };
        }), function(N, z) {
          return function(te, re, se) {
            for (var be = -1, ve = te.criteria, Ae = re.criteria, Ue = ve.length, qe = se.length; ++be < Ue; ) {
              var Qe = s1(ve[be], Ae[be]);
              if (Qe) {
                if (be >= qe)
                  return Qe;
                var Se = se[be];
                return Qe * (Se == "desc" ? -1 : 1);
              }
            }
            return te.index - re.index;
          }(N, z, E);
        });
      }
      function Qg(h, g, E) {
        for (var T = -1, N = g.length, z = {}; ++T < N; ) {
          var te = g[T], re = es(h, te);
          E(re, te) && fu(z, ja(te, h), re);
        }
        return z;
      }
      function Qf(h, g, E, T) {
        var N = T ? f3 : zo, z = -1, te = g.length, re = h;
        for (h === g && (g = pr(g)), E && (re = un(h, wr(E))); ++z < te; )
          for (var se = 0, be = g[z], ve = E ? E(be) : be; (se = N(re, ve, se, T)) > -1; )
            re !== h && Mc.call(re, se, 1), Mc.call(h, se, 1);
        return h;
      }
      function Xg(h, g) {
        for (var E = h ? g.length : 0, T = E - 1; E--; ) {
          var N = g[E];
          if (E == T || N !== z) {
            var z = N;
            ra(N) ? Mc.call(h, N, 1) : eh(h, N);
          }
        }
        return h;
      }
      function Xf(h, g) {
        return h + qc(Pg() * (g - h + 1));
      }
      function Yf(h, g) {
        var E = "";
        if (!h || g < 1 || g > R)
          return E;
        do
          g % 2 && (E += h), (g = qc(g / 2)) && (h += h);
        while (g);
        return E;
      }
      function mt(h, g) {
        return mh(w1(h, g, dr), h + "");
      }
      function G3(h) {
        return Og(as(h));
      }
      function z3(h, g) {
        var E = as(h);
        return al(E, mo(g, 0, E.length));
      }
      function fu(h, g, E, T) {
        if (!cn(h))
          return h;
        for (var N = -1, z = (g = ja(g, h)).length, te = z - 1, re = h; re != null && ++N < z; ) {
          var se = Pi(g[N]), be = E;
          if (N != te) {
            var ve = re[se];
            (be = T ? T(ve, se, re) : n) === n && (be = cn(ve) ? ve : ra(g[N + 1]) ? [] : {});
          }
          uu(re, se, be), re = re[se];
        }
        return h;
      }
      var Yg = Wc ? function(h, g) {
        return Wc.set(h, g), h;
      } : dr, H3 = Vc ? function(h, g) {
        return Vc(h, "toString", { configurable: !0, enumerable: !1, value: Dh(g), writable: !0 });
      } : dr;
      function K3(h) {
        return al(as(h));
      }
      function zr(h, g, E) {
        var T = -1, N = h.length;
        g < 0 && (g = -g > N ? 0 : N + g), (E = E > N ? N : E) < 0 && (E += N), N = g > E ? 0 : E - g >>> 0, g >>>= 0;
        for (var z = Ne(N); ++T < N; )
          z[T] = h[T + g];
        return z;
      }
      function J3(h, g) {
        var E;
        return La(h, function(T, N, z) {
          return !(E = g(T, N, z));
        }), !!E;
      }
      function Qc(h, g, E) {
        var T = 0, N = h == null ? T : h.length;
        if (typeof g == "number" && g == g && N <= A) {
          for (; T < N; ) {
            var z = T + N >>> 1, te = h[z];
            te !== null && !_r(te) && (E ? te <= g : te < g) ? T = z + 1 : N = z;
          }
          return N;
        }
        return Zf(h, g, dr, E);
      }
      function Zf(h, g, E, T) {
        g = E(g);
        for (var N = 0, z = h == null ? 0 : h.length, te = g != g, re = g === null, se = _r(g), be = g === n; N < z; ) {
          var ve = qc((N + z) / 2), Ae = E(h[ve]), Ue = Ae !== n, qe = Ae === null, Qe = Ae == Ae, Se = _r(Ae);
          if (te)
            var Te = T || Qe;
          else
            Te = be ? Qe && (T || Ue) : re ? Qe && Ue && (T || !qe) : se ? Qe && Ue && !qe && (T || !Se) : !qe && !Se && (T ? Ae <= g : Ae < g);
          Te ? N = ve + 1 : z = ve;
        }
        return Hn(z, ce);
      }
      function Zg(h, g) {
        for (var E = -1, T = h.length, N = 0, z = []; ++E < T; ) {
          var te = h[E], re = g ? g(te) : te;
          if (!E || !mi(re, se)) {
            var se = re;
            z[N++] = te === 0 ? 0 : te;
          }
        }
        return z;
      }
      function e1(h) {
        return typeof h == "number" ? h : _r(h) ? J : +h;
      }
      function Ar(h) {
        if (typeof h == "string")
          return h;
        if (st(h))
          return un(h, Ar) + "";
        if (_r(h))
          return Ig ? Ig.call(h) : "";
        var g = h + "";
        return g == "0" && 1 / h == -W ? "-0" : g;
      }
      function Na(h, g, E) {
        var T = -1, N = _c, z = h.length, te = !0, re = [], se = re;
        if (E)
          te = !1, N = Af;
        else if (z >= r) {
          var be = g ? null : X3(h);
          if (be)
            return Pc(be);
          te = !1, N = nu, se = new ho();
        } else
          se = g ? [] : re;
        e:
          for (; ++T < z; ) {
            var ve = h[T], Ae = g ? g(ve) : ve;
            if (ve = E || ve !== 0 ? ve : 0, te && Ae == Ae) {
              for (var Ue = se.length; Ue--; )
                if (se[Ue] === Ae)
                  continue e;
              g && se.push(Ae), re.push(ve);
            } else
              N(se, Ae, E) || (se !== re && se.push(Ae), re.push(ve));
          }
        return re;
      }
      function eh(h, g) {
        return (h = A1(h, g = ja(g, h))) == null || delete h[Pi(Hr(g))];
      }
      function t1(h, g, E, T) {
        return fu(h, g, E(es(h, g)), T);
      }
      function Xc(h, g, E, T) {
        for (var N = h.length, z = T ? N : -1; (T ? z-- : ++z < N) && g(h[z], z, h); )
          ;
        return E ? zr(h, T ? 0 : z, T ? z + 1 : N) : zr(h, T ? z + 1 : 0, T ? N : z);
      }
      function n1(h, g) {
        var E = h;
        return E instanceof St && (E = E.value()), _f(g, function(T, N) {
          return N.func.apply(N.thisArg, Ia([T], N.args));
        }, E);
      }
      function th(h, g, E) {
        var T = h.length;
        if (T < 2)
          return T ? Na(h[0]) : [];
        for (var N = -1, z = Ne(T); ++N < T; )
          for (var te = h[N], re = -1; ++re < T; )
            re != N && (z[N] = cu(z[N] || te, h[re], g, E));
        return Na(Un(z, 1), g, E);
      }
      function r1(h, g, E) {
        for (var T = -1, N = h.length, z = g.length, te = {}; ++T < N; ) {
          var re = T < z ? g[T] : n;
          E(te, h[T], re);
        }
        return te;
      }
      function nh(h) {
        return Cn(h) ? h : [];
      }
      function rh(h) {
        return typeof h == "function" ? h : dr;
      }
      function ja(h, g) {
        return st(h) ? h : fh(h, g) ? [h] : I1(Vt(h));
      }
      var Q3 = mt;
      function Ra(h, g, E) {
        var T = h.length;
        return E = E === n ? T : E, !g && E >= T ? h : zr(h, g, E);
      }
      var i1 = k3 || function(h) {
        return Vn.clearTimeout(h);
      };
      function a1(h, g) {
        if (g)
          return h.slice();
        var E = h.length, T = Fg ? Fg(E) : new h.constructor(E);
        return h.copy(T), T;
      }
      function ih(h) {
        var g = new h.constructor(h.byteLength);
        return new jc(g).set(new jc(h)), g;
      }
      function o1(h, g) {
        var E = g ? ih(h.buffer) : h.buffer;
        return new h.constructor(E, h.byteOffset, h.length);
      }
      function s1(h, g) {
        if (h !== g) {
          var E = h !== n, T = h === null, N = h == h, z = _r(h), te = g !== n, re = g === null, se = g == g, be = _r(g);
          if (!re && !be && !z && h > g || z && te && se && !re && !be || T && te && se || !E && se || !N)
            return 1;
          if (!T && !z && !be && h < g || be && E && N && !T && !z || re && E && N || !te && N || !se)
            return -1;
        }
        return 0;
      }
      function u1(h, g, E, T) {
        for (var N = -1, z = h.length, te = E.length, re = -1, se = g.length, be = _n(z - te, 0), ve = Ne(se + be), Ae = !T; ++re < se; )
          ve[re] = g[re];
        for (; ++N < te; )
          (Ae || N < z) && (ve[E[N]] = h[N]);
        for (; be--; )
          ve[re++] = h[N++];
        return ve;
      }
      function c1(h, g, E, T) {
        for (var N = -1, z = h.length, te = -1, re = E.length, se = -1, be = g.length, ve = _n(z - re, 0), Ae = Ne(ve + be), Ue = !T; ++N < ve; )
          Ae[N] = h[N];
        for (var qe = N; ++se < be; )
          Ae[qe + se] = g[se];
        for (; ++te < re; )
          (Ue || N < z) && (Ae[qe + E[te]] = h[N++]);
        return Ae;
      }
      function pr(h, g) {
        var E = -1, T = h.length;
        for (g || (g = Ne(T)); ++E < T; )
          g[E] = h[E];
        return g;
      }
      function Ti(h, g, E, T) {
        var N = !E;
        E || (E = {});
        for (var z = -1, te = g.length; ++z < te; ) {
          var re = g[z], se = T ? T(E[re], h[re], re, E, h) : n;
          se === n && (se = h[re]), N ? ea(E, re, se) : uu(E, re, se);
        }
        return E;
      }
      function Yc(h, g) {
        return function(E, T) {
          var N = st(E) ? u3 : V3, z = g ? g() : {};
          return N(E, h, Je(T, 2), z);
        };
      }
      function ts(h) {
        return mt(function(g, E) {
          var T = -1, N = E.length, z = N > 1 ? E[N - 1] : n, te = N > 2 ? E[2] : n;
          for (z = h.length > 3 && typeof z == "function" ? (N--, z) : n, te && rr(E[0], E[1], te) && (z = N < 3 ? n : z, N = 1), g = en(g); ++T < N; ) {
            var re = E[T];
            re && h(g, re, T, z);
          }
          return g;
        });
      }
      function l1(h, g) {
        return function(E, T) {
          if (E == null)
            return E;
          if (!fr(E))
            return h(E, T);
          for (var N = E.length, z = g ? N : -1, te = en(E); (g ? z-- : ++z < N) && T(te[z], z, te) !== !1; )
            ;
          return E;
        };
      }
      function p1(h) {
        return function(g, E, T) {
          for (var N = -1, z = en(g), te = T(g), re = te.length; re--; ) {
            var se = te[h ? re : ++N];
            if (E(z[se], se, z) === !1)
              break;
          }
          return g;
        };
      }
      function f1(h) {
        return function(g) {
          var E = Ho(g = Vt(g)) ? hi(g) : n, T = E ? E[0] : g.charAt(0), N = E ? Ra(E, 1).join("") : g.slice(1);
          return T[h]() + N;
        };
      }
      function ns(h) {
        return function(g) {
          return _f(uy(sy(g).replace(XA, "")), h, "");
        };
      }
      function hu(h) {
        return function() {
          var g = arguments;
          switch (g.length) {
            case 0:
              return new h();
            case 1:
              return new h(g[0]);
            case 2:
              return new h(g[0], g[1]);
            case 3:
              return new h(g[0], g[1], g[2]);
            case 4:
              return new h(g[0], g[1], g[2], g[3]);
            case 5:
              return new h(g[0], g[1], g[2], g[3], g[4]);
            case 6:
              return new h(g[0], g[1], g[2], g[3], g[4], g[5]);
            case 7:
              return new h(g[0], g[1], g[2], g[3], g[4], g[5], g[6]);
          }
          var E = Zo(h.prototype), T = h.apply(E, g);
          return cn(T) ? T : E;
        };
      }
      function h1(h) {
        return function(g, E, T) {
          var N = en(g);
          if (!fr(g)) {
            var z = Je(E, 3);
            g = Ln(g), E = function(re) {
              return z(N[re], re, N);
            };
          }
          var te = h(g, E, T);
          return te > -1 ? N[z ? g[te] : te] : n;
        };
      }
      function d1(h) {
        return na(function(g) {
          var E = g.length, T = E, N = $r.prototype.thru;
          for (h && g.reverse(); T--; ) {
            var z = g[T];
            if (typeof z != "function")
              throw new Wr(a);
            if (N && !te && rl(z) == "wrapper")
              var te = new $r([], !0);
          }
          for (T = te ? T : E; ++T < E; ) {
            var re = rl(z = g[T]), se = re == "wrapper" ? ch(z) : n;
            te = se && hh(se[0]) && se[1] == (B | x | k | O) && !se[4].length && se[9] == 1 ? te[rl(se[0])].apply(te, se[3]) : z.length == 1 && hh(z) ? te[re]() : te.thru(z);
          }
          return function() {
            var be = arguments, ve = be[0];
            if (te && be.length == 1 && st(ve))
              return te.plant(ve).value();
            for (var Ae = 0, Ue = E ? g[Ae].apply(this, be) : ve; ++Ae < E; )
              Ue = g[Ae].call(this, Ue);
            return Ue;
          };
        });
      }
      function Zc(h, g, E, T, N, z, te, re, se, be) {
        var ve = g & B, Ae = g & y, Ue = g & v, qe = g & (x | C), Qe = g & S, Se = Ue ? n : hu(h);
        return function Te() {
          for (var et = arguments.length, Le = Ne(et), ut = et; ut--; )
            Le[ut] = arguments[ut];
          if (qe)
            var nt = rs(Te), Bt = function(Sn, ir) {
              for (var tn = Sn.length, Jn = 0; tn--; )
                Sn[tn] === ir && ++Jn;
              return Jn;
            }(Le, nt);
          if (T && (Le = u1(Le, T, N, qe)), z && (Le = c1(Le, z, te, qe)), et -= Bt, qe && et < be) {
            var Ge = Ba(Le, nt);
            return y1(h, g, Zc, Te.placeholder, E, Le, Ge, re, se, be - et);
          }
          var tt = Ae ? E : this, Tn = Ue ? tt[h] : h;
          return et = Le.length, re ? Le = function(Sn, ir) {
            for (var tn = Sn.length, Jn = Hn(ir.length, tn), Ii = pr(Sn); Jn--; ) {
              var Va = ir[Jn];
              Sn[Jn] = ra(Va, tn) ? Ii[Va] : n;
            }
            return Sn;
          }(Le, re) : Qe && et > 1 && Le.reverse(), ve && se < et && (Le.length = se), this && this !== Vn && this instanceof Te && (Tn = Se || hu(Tn)), Tn.apply(tt, Le);
        };
      }
      function m1(h, g) {
        return function(E, T) {
          return function(N, z, te, re) {
            return _i(N, function(se, be, ve) {
              z(re, te(se), be, ve);
            }), re;
          }(E, h, g(T), {});
        };
      }
      function el(h, g) {
        return function(E, T) {
          var N;
          if (E === n && T === n)
            return g;
          if (E !== n && (N = E), T !== n) {
            if (N === n)
              return T;
            typeof E == "string" || typeof T == "string" ? (E = Ar(E), T = Ar(T)) : (E = e1(E), T = e1(T)), N = h(E, T);
          }
          return N;
        };
      }
      function ah(h) {
        return na(function(g) {
          return g = un(g, wr(Je())), mt(function(E) {
            var T = this;
            return h(g, function(N) {
              return Fr(N, T, E);
            });
          });
        });
      }
      function tl(h, g) {
        var E = (g = g === n ? " " : Ar(g)).length;
        if (E < 2)
          return E ? Yf(g, h) : g;
        var T = Yf(g, Uc(h / Ko(g)));
        return Ho(g) ? Ra(hi(T), 0, h).join("") : T.slice(0, h);
      }
      function g1(h) {
        return function(g, E, T) {
          return T && typeof T != "number" && rr(g, E, T) && (E = T = n), g = aa(g), E === n ? (E = g, g = 0) : E = aa(E), function(N, z, te, re) {
            for (var se = -1, be = _n(Uc((z - N) / (te || 1)), 0), ve = Ne(be); be--; )
              ve[re ? be : ++se] = N, N += te;
            return ve;
          }(g, E, T = T === n ? g < E ? 1 : -1 : aa(T), h);
        };
      }
      function nl(h) {
        return function(g, E) {
          return typeof g == "string" && typeof E == "string" || (g = Kr(g), E = Kr(E)), h(g, E);
        };
      }
      function y1(h, g, E, T, N, z, te, re, se, be) {
        var ve = g & x;
        g |= ve ? k : F, (g &= ~(ve ? F : k)) & b || (g &= ~(y | v));
        var Ae = [h, g, N, ve ? z : n, ve ? te : n, ve ? n : z, ve ? n : te, re, se, be], Ue = E.apply(n, Ae);
        return hh(h) && _1(Ue, Ae), Ue.placeholder = T, T1(Ue, h, g);
      }
      function oh(h) {
        var g = Ai[h];
        return function(E, T) {
          if (E = Kr(E), (T = T == null ? 0 : Hn(ft(T), 292)) && Tg(E)) {
            var N = (Vt(E) + "e").split("e");
            return +((N = (Vt(g(N[0] + "e" + (+N[1] + T))) + "e").split("e"))[0] + "e" + (+N[1] - T));
          }
          return g(E);
        };
      }
      var X3 = Xo && 1 / Pc(new Xo([, -0]))[1] == W ? function(h) {
        return new Xo(h);
      } : Ah;
      function v1(h) {
        return function(g) {
          var E = Kn(g);
          return E == _ ? Nf(g) : E == Ee ? g3(g) : function(T, N) {
            return un(N, function(z) {
              return [z, T[z]];
            });
          }(g, h(g));
        };
      }
      function ta(h, g, E, T, N, z, te, re) {
        var se = g & v;
        if (!se && typeof h != "function")
          throw new Wr(a);
        var be = T ? T.length : 0;
        if (be || (g &= ~(k | F), T = N = n), te = te === n ? te : _n(ft(te), 0), re = re === n ? re : ft(re), be -= N ? N.length : 0, g & F) {
          var ve = T, Ae = N;
          T = N = n;
        }
        var Ue = se ? n : ch(h), qe = [h, g, E, T, N, ve, Ae, z, te, re];
        if (Ue && function(Se, Te) {
          var et = Se[1], Le = Te[1], ut = et | Le, nt = ut < (y | v | B), Bt = Le == B && et == x || Le == B && et == O && Se[7].length <= Te[8] || Le == (B | O) && Te[7].length <= Te[8] && et == x;
          if (!nt && !Bt)
            return Se;
          Le & y && (Se[2] = Te[2], ut |= et & y ? 0 : b);
          var Ge = Te[3];
          if (Ge) {
            var tt = Se[3];
            Se[3] = tt ? u1(tt, Ge, Te[4]) : Ge, Se[4] = tt ? Ba(Se[3], u) : Te[4];
          }
          (Ge = Te[5]) && (tt = Se[5], Se[5] = tt ? c1(tt, Ge, Te[6]) : Ge, Se[6] = tt ? Ba(Se[5], u) : Te[6]), (Ge = Te[7]) && (Se[7] = Ge), Le & B && (Se[8] = Se[8] == null ? Te[8] : Hn(Se[8], Te[8])), Se[9] == null && (Se[9] = Te[9]), Se[0] = Te[0], Se[1] = ut;
        }(qe, Ue), h = qe[0], g = qe[1], E = qe[2], T = qe[3], N = qe[4], !(re = qe[9] = qe[9] === n ? se ? 0 : h.length : _n(qe[9] - be, 0)) && g & (x | C) && (g &= ~(x | C)), g && g != y)
          Qe = g == x || g == C ? function(Se, Te, et) {
            var Le = hu(Se);
            return function ut() {
              for (var nt = arguments.length, Bt = Ne(nt), Ge = nt, tt = rs(ut); Ge--; )
                Bt[Ge] = arguments[Ge];
              var Tn = nt < 3 && Bt[0] !== tt && Bt[nt - 1] !== tt ? [] : Ba(Bt, tt);
              return (nt -= Tn.length) < et ? y1(Se, Te, Zc, ut.placeholder, n, Bt, Tn, n, n, et - nt) : Fr(this && this !== Vn && this instanceof ut ? Le : Se, this, Bt);
            };
          }(h, g, re) : g != k && g != (y | k) || N.length ? Zc.apply(n, qe) : function(Se, Te, et, Le) {
            var ut = Te & y, nt = hu(Se);
            return function Bt() {
              for (var Ge = -1, tt = arguments.length, Tn = -1, Sn = Le.length, ir = Ne(Sn + tt), tn = this && this !== Vn && this instanceof Bt ? nt : Se; ++Tn < Sn; )
                ir[Tn] = Le[Tn];
              for (; tt--; )
                ir[Tn++] = arguments[++Ge];
              return Fr(tn, ut ? et : this, ir);
            };
          }(h, g, E, T);
        else
          var Qe = function(Se, Te, et) {
            var Le = Te & y, ut = hu(Se);
            return function nt() {
              return (this && this !== Vn && this instanceof nt ? ut : Se).apply(Le ? et : this, arguments);
            };
          }(h, g, E);
        return T1((Ue ? Yg : _1)(Qe, qe), h, g);
      }
      function x1(h, g, E, T) {
        return h === n || mi(h, Qo[E]) && !qt.call(T, E) ? g : h;
      }
      function b1(h, g, E, T, N, z) {
        return cn(h) && cn(g) && (z.set(g, h), Jc(h, g, n, b1, z), z.delete(g)), h;
      }
      function Y3(h) {
        return gu(h) ? n : h;
      }
      function E1(h, g, E, T, N, z) {
        var te = E & d, re = h.length, se = g.length;
        if (re != se && !(te && se > re))
          return !1;
        var be = z.get(h);
        if (be && z.get(g))
          return be == g;
        var ve = -1, Ae = !0, Ue = E & m ? new ho() : n;
        for (z.set(h, g), z.set(g, h); ++ve < re; ) {
          var qe = h[ve], Qe = g[ve];
          if (T)
            var Se = te ? T(Qe, qe, ve, g, h, z) : T(qe, Qe, ve, h, g, z);
          if (Se !== n) {
            if (Se)
              continue;
            Ae = !1;
            break;
          }
          if (Ue) {
            if (!Tf(g, function(Te, et) {
              if (!nu(Ue, et) && (qe === Te || N(qe, Te, E, T, z)))
                return Ue.push(et);
            })) {
              Ae = !1;
              break;
            }
          } else if (qe !== Qe && !N(qe, Qe, E, T, z)) {
            Ae = !1;
            break;
          }
        }
        return z.delete(h), z.delete(g), Ae;
      }
      function na(h) {
        return mh(w1(h, n, N1), h + "");
      }
      function sh(h) {
        return Ug(h, Ln, ph);
      }
      function uh(h) {
        return Ug(h, hr, C1);
      }
      var ch = Wc ? function(h) {
        return Wc.get(h);
      } : Ah;
      function rl(h) {
        for (var g = h.name + "", E = Yo[g], T = qt.call(Yo, g) ? E.length : 0; T--; ) {
          var N = E[T], z = N.func;
          if (z == null || z == h)
            return N.name;
        }
        return g;
      }
      function rs(h) {
        return (qt.call(U, "placeholder") ? U : h).placeholder;
      }
      function Je() {
        var h = U.iteratee || Fh;
        return h = h === Fh ? $g : h, arguments.length ? h(arguments[0], arguments[1]) : h;
      }
      function il(h, g) {
        var E = h.__data__;
        return function(T) {
          var N = xe(T);
          return N == "string" || N == "number" || N == "symbol" || N == "boolean" ? T !== "__proto__" : T === null;
        }(g) ? E[typeof g == "string" ? "string" : "hash"] : E.map;
      }
      function lh(h) {
        for (var g = Ln(h), E = g.length; E--; ) {
          var T = g[E], N = h[T];
          g[E] = [T, N, D1(N)];
        }
        return g;
      }
      function go(h, g) {
        var E = function(T, N) {
          return T == null ? n : T[N];
        }(h, g);
        return Wg(E) ? E : n;
      }
      var ph = Rf ? function(h) {
        return h == null ? [] : (h = en(h), Pa(Rf(h), function(g) {
          return Ag.call(h, g);
        }));
      } : _h, C1 = Rf ? function(h) {
        for (var g = []; h; )
          Ia(g, ph(h)), h = Rc(h);
        return g;
      } : _h, Kn = nr;
      function S1(h, g, E) {
        for (var T = -1, N = (g = ja(g, h)).length, z = !1; ++T < N; ) {
          var te = Pi(g[T]);
          if (!(z = h != null && E(h, te)))
            break;
          h = h[te];
        }
        return z || ++T != N ? z : !!(N = h == null ? 0 : h.length) && pl(N) && ra(te, N) && (st(h) || vo(h));
      }
      function k1(h) {
        return typeof h.constructor != "function" || du(h) ? {} : Zo(Rc(h));
      }
      function Z3(h) {
        return st(h) || vo(h) || !!(_g && h && h[_g]);
      }
      function ra(h, g) {
        var E = xe(h);
        return !!(g = g ?? R) && (E == "number" || E != "symbol" && Wo.test(h)) && h > -1 && h % 1 == 0 && h < g;
      }
      function rr(h, g, E) {
        if (!cn(E))
          return !1;
        var T = xe(g);
        return !!(T == "number" ? fr(E) && ra(g, E.length) : T == "string" && g in E) && mi(E[g], h);
      }
      function fh(h, g) {
        if (st(h))
          return !1;
        var E = xe(h);
        return !(E != "number" && E != "symbol" && E != "boolean" && h != null && !_r(h)) || Sr.test(h) || !qn.test(h) || g != null && h in en(g);
      }
      function hh(h) {
        var g = rl(h), E = U[g];
        if (typeof E != "function" || !(g in St.prototype))
          return !1;
        if (h === E)
          return !0;
        var T = ch(E);
        return !!T && h === T[0];
      }
      (Mf && Kn(new Mf(new ArrayBuffer(1))) != zt || iu && Kn(new iu()) != _ || Vf && Kn(Vf.resolve()) != "[object Promise]" || Xo && Kn(new Xo()) != Ee || au && Kn(new au()) != _t) && (Kn = function(h) {
        var g = nr(h), E = g == ae ? h.constructor : n, T = E ? yo(E) : "";
        if (T)
          switch (T) {
            case B3:
              return zt;
            case O3:
              return _;
            case L3:
              return "[object Promise]";
            case N3:
              return Ee;
            case j3:
              return _t;
          }
        return g;
      });
      var e_ = Bc ? ia : Th;
      function du(h) {
        var g = h && h.constructor;
        return h === (typeof g == "function" && g.prototype || Qo);
      }
      function D1(h) {
        return h == h && !cn(h);
      }
      function F1(h, g) {
        return function(E) {
          return E != null && E[h] === g && (g !== n || h in en(E));
        };
      }
      function w1(h, g, E) {
        return g = _n(g === n ? h.length - 1 : g, 0), function() {
          for (var T = arguments, N = -1, z = _n(T.length - g, 0), te = Ne(z); ++N < z; )
            te[N] = T[g + N];
          N = -1;
          for (var re = Ne(g + 1); ++N < g; )
            re[N] = T[N];
          return re[g] = E(te), Fr(h, this, re);
        };
      }
      function A1(h, g) {
        return g.length < 2 ? h : es(h, zr(g, 0, -1));
      }
      function dh(h, g) {
        if ((g !== "constructor" || typeof h[g] != "function") && g != "__proto__")
          return h[g];
      }
      var _1 = P1(Yg), mu = F3 || function(h, g) {
        return Vn.setTimeout(h, g);
      }, mh = P1(H3);
      function T1(h, g, E) {
        var T = g + "";
        return mh(h, function(N, z) {
          var te = z.length;
          if (!te)
            return N;
          var re = te - 1;
          return z[re] = (te > 1 ? "& " : "") + z[re], z = z.join(te > 2 ? ", " : " "), N.replace(Fi, `{
/* [wrapped with ` + z + `] */
`);
        }(T, function(N, z) {
          return qr(M, function(te) {
            var re = "_." + te[0];
            z & te[1] && !_c(N, re) && N.push(re);
          }), N.sort();
        }(function(N) {
          var z = N.match(so);
          return z ? z[1].split(Hi) : [];
        }(T), E)));
      }
      function P1(h) {
        var g = 0, E = 0;
        return function() {
          var T = T3(), N = L - (T - E);
          if (E = T, N > 0) {
            if (++g >= I)
              return arguments[0];
          } else
            g = 0;
          return h.apply(n, arguments);
        };
      }
      function al(h, g) {
        var E = -1, T = h.length, N = T - 1;
        for (g = g === n ? T : g; ++E < g; ) {
          var z = Xf(E, N), te = h[z];
          h[z] = h[E], h[E] = te;
        }
        return h.length = g, h;
      }
      var I1 = function(h) {
        var g = cl(h, function(T) {
          return E.size === o && E.clear(), T;
        }), E = g.cache;
        return g;
      }(function(h) {
        var g = [];
        return h.charCodeAt(0) === 46 && g.push(""), h.replace(pi, function(E, T, N, z) {
          g.push(N ? z.replace(Wn, "$1") : T || E);
        }), g;
      });
      function Pi(h) {
        if (typeof h == "string" || _r(h))
          return h;
        var g = h + "";
        return g == "0" && 1 / h == -W ? "-0" : g;
      }
      function yo(h) {
        if (h != null) {
          try {
            return Oc.call(h);
          } catch {
          }
          try {
            return h + "";
          } catch {
          }
        }
        return "";
      }
      function B1(h) {
        if (h instanceof St)
          return h.clone();
        var g = new $r(h.__wrapped__, h.__chain__);
        return g.__actions__ = pr(h.__actions__), g.__index__ = h.__index__, g.__values__ = h.__values__, g;
      }
      var t_ = mt(function(h, g) {
        return Cn(h) ? cu(h, Un(g, 1, Cn, !0)) : [];
      }), n_ = mt(function(h, g) {
        var E = Hr(g);
        return Cn(E) && (E = n), Cn(h) ? cu(h, Un(g, 1, Cn, !0), Je(E, 2)) : [];
      }), r_ = mt(function(h, g) {
        var E = Hr(g);
        return Cn(E) && (E = n), Cn(h) ? cu(h, Un(g, 1, Cn, !0), n, E) : [];
      });
      function O1(h, g, E) {
        var T = h == null ? 0 : h.length;
        if (!T)
          return -1;
        var N = E == null ? 0 : ft(E);
        return N < 0 && (N = _n(T + N, 0)), Tc(h, Je(g, 3), N);
      }
      function L1(h, g, E) {
        var T = h == null ? 0 : h.length;
        if (!T)
          return -1;
        var N = T - 1;
        return E !== n && (N = ft(E), N = E < 0 ? _n(T + N, 0) : Hn(N, T - 1)), Tc(h, Je(g, 3), N, !0);
      }
      function N1(h) {
        return h != null && h.length ? Un(h, 1) : [];
      }
      function j1(h) {
        return h && h.length ? h[0] : n;
      }
      var i_ = mt(function(h) {
        var g = un(h, nh);
        return g.length && g[0] === h[0] ? zf(g) : [];
      }), a_ = mt(function(h) {
        var g = Hr(h), E = un(h, nh);
        return g === Hr(E) ? g = n : E.pop(), E.length && E[0] === h[0] ? zf(E, Je(g, 2)) : [];
      }), o_ = mt(function(h) {
        var g = Hr(h), E = un(h, nh);
        return (g = typeof g == "function" ? g : n) && E.pop(), E.length && E[0] === h[0] ? zf(E, n, g) : [];
      });
      function Hr(h) {
        var g = h == null ? 0 : h.length;
        return g ? h[g - 1] : n;
      }
      var s_ = mt(R1);
      function R1(h, g) {
        return h && h.length && g && g.length ? Qf(h, g) : h;
      }
      var u_ = na(function(h, g) {
        var E = h == null ? 0 : h.length, T = qf(h, g);
        return Xg(h, un(g, function(N) {
          return ra(N, E) ? +N : N;
        }).sort(s1)), T;
      });
      function gh(h) {
        return h == null ? h : I3.call(h);
      }
      var c_ = mt(function(h) {
        return Na(Un(h, 1, Cn, !0));
      }), l_ = mt(function(h) {
        var g = Hr(h);
        return Cn(g) && (g = n), Na(Un(h, 1, Cn, !0), Je(g, 2));
      }), p_ = mt(function(h) {
        var g = Hr(h);
        return g = typeof g == "function" ? g : n, Na(Un(h, 1, Cn, !0), n, g);
      });
      function yh(h) {
        if (!h || !h.length)
          return [];
        var g = 0;
        return h = Pa(h, function(E) {
          if (Cn(E))
            return g = _n(E.length, g), !0;
        }), Of(g, function(E) {
          return un(h, Pf(E));
        });
      }
      function M1(h, g) {
        if (!h || !h.length)
          return [];
        var E = yh(h);
        return g == null ? E : un(E, function(T) {
          return Fr(g, n, T);
        });
      }
      var f_ = mt(function(h, g) {
        return Cn(h) ? cu(h, g) : [];
      }), h_ = mt(function(h) {
        return th(Pa(h, Cn));
      }), d_ = mt(function(h) {
        var g = Hr(h);
        return Cn(g) && (g = n), th(Pa(h, Cn), Je(g, 2));
      }), m_ = mt(function(h) {
        var g = Hr(h);
        return g = typeof g == "function" ? g : n, th(Pa(h, Cn), n, g);
      }), g_ = mt(yh), y_ = mt(function(h) {
        var g = h.length, E = g > 1 ? h[g - 1] : n;
        return E = typeof E == "function" ? (h.pop(), E) : n, M1(h, E);
      });
      function V1(h) {
        var g = U(h);
        return g.__chain__ = !0, g;
      }
      function ol(h, g) {
        return g(h);
      }
      var v_ = na(function(h) {
        var g = h.length, E = g ? h[0] : 0, T = this.__wrapped__, N = function(z) {
          return qf(z, h);
        };
        return !(g > 1 || this.__actions__.length) && T instanceof St && ra(E) ? ((T = T.slice(E, +E + (g ? 1 : 0))).__actions__.push({ func: ol, args: [N], thisArg: n }), new $r(T, this.__chain__).thru(function(z) {
          return g && !z.length && z.push(n), z;
        })) : this.thru(N);
      }), x_ = Yc(function(h, g, E) {
        qt.call(h, E) ? ++h[E] : ea(h, E, 1);
      }), b_ = h1(O1), E_ = h1(L1);
      function U1(h, g) {
        return (st(h) ? qr : La)(h, Je(g, 3));
      }
      function q1(h, g) {
        return (st(h) ? c3 : Rg)(h, Je(g, 3));
      }
      var C_ = Yc(function(h, g, E) {
        qt.call(h, E) ? h[E].push(g) : ea(h, E, [g]);
      }), S_ = mt(function(h, g, E) {
        var T = -1, N = typeof g == "function", z = fr(h) ? Ne(h.length) : [];
        return La(h, function(te) {
          z[++T] = N ? Fr(g, te, E) : lu(te, g, E);
        }), z;
      }), k_ = Yc(function(h, g, E) {
        ea(h, E, g);
      });
      function sl(h, g) {
        return (st(h) ? un : Gg)(h, Je(g, 3));
      }
      var D_ = Yc(function(h, g, E) {
        h[E ? 0 : 1].push(g);
      }, function() {
        return [[], []];
      }), F_ = mt(function(h, g) {
        if (h == null)
          return [];
        var E = g.length;
        return E > 1 && rr(h, g[0], g[1]) ? g = [] : E > 2 && rr(g[0], g[1], g[2]) && (g = [g[0]]), Jg(h, Un(g, 1), []);
      }), ul = D3 || function() {
        return Vn.Date.now();
      };
      function W1(h, g, E) {
        return g = E ? n : g, g = h && g == null ? h.length : g, ta(h, B, n, n, n, n, g);
      }
      function $1(h, g) {
        var E;
        if (typeof g != "function")
          throw new Wr(a);
        return h = ft(h), function() {
          return --h > 0 && (E = g.apply(this, arguments)), h <= 1 && (g = n), E;
        };
      }
      var vh = mt(function(h, g, E) {
        var T = y;
        if (E.length) {
          var N = Ba(E, rs(vh));
          T |= k;
        }
        return ta(h, T, g, E, N);
      }), G1 = mt(function(h, g, E) {
        var T = y | v;
        if (E.length) {
          var N = Ba(E, rs(G1));
          T |= k;
        }
        return ta(g, T, h, E, N);
      });
      function z1(h, g, E) {
        var T, N, z, te, re, se, be = 0, ve = !1, Ae = !1, Ue = !0;
        if (typeof h != "function")
          throw new Wr(a);
        function qe(Le) {
          var ut = T, nt = N;
          return T = N = n, be = Le, te = h.apply(nt, ut);
        }
        function Qe(Le) {
          var ut = Le - se;
          return se === n || ut >= g || ut < 0 || Ae && Le - be >= z;
        }
        function Se() {
          var Le = ul();
          if (Qe(Le))
            return Te(Le);
          re = mu(Se, function(ut) {
            var nt = g - (ut - se);
            return Ae ? Hn(nt, z - (ut - be)) : nt;
          }(Le));
        }
        function Te(Le) {
          return re = n, Ue && T ? qe(Le) : (T = N = n, te);
        }
        function et() {
          var Le = ul(), ut = Qe(Le);
          if (T = arguments, N = this, se = Le, ut) {
            if (re === n)
              return function(nt) {
                return be = nt, re = mu(Se, g), ve ? qe(nt) : te;
              }(se);
            if (Ae)
              return i1(re), re = mu(Se, g), qe(se);
          }
          return re === n && (re = mu(Se, g)), te;
        }
        return g = Kr(g) || 0, cn(E) && (ve = !!E.leading, z = (Ae = "maxWait" in E) ? _n(Kr(E.maxWait) || 0, g) : z, Ue = "trailing" in E ? !!E.trailing : Ue), et.cancel = function() {
          re !== n && i1(re), be = 0, T = se = N = re = n;
        }, et.flush = function() {
          return re === n ? te : Te(ul());
        }, et;
      }
      var w_ = mt(function(h, g) {
        return jg(h, 1, g);
      }), A_ = mt(function(h, g, E) {
        return jg(h, Kr(g) || 0, E);
      });
      function cl(h, g) {
        if (typeof h != "function" || g != null && typeof g != "function")
          throw new Wr(a);
        var E = function T() {
          var N = arguments, z = g ? g.apply(this, N) : N[0], te = T.cache;
          if (te.has(z))
            return te.get(z);
          var re = h.apply(this, N);
          return T.cache = te.set(z, re) || te, re;
        };
        return E.cache = new (cl.Cache || Zi)(), E;
      }
      function ll(h) {
        if (typeof h != "function")
          throw new Wr(a);
        return function() {
          var g = arguments;
          switch (g.length) {
            case 0:
              return !h.call(this);
            case 1:
              return !h.call(this, g[0]);
            case 2:
              return !h.call(this, g[0], g[1]);
            case 3:
              return !h.call(this, g[0], g[1], g[2]);
          }
          return !h.apply(this, g);
        };
      }
      cl.Cache = Zi;
      var __ = Q3(function(h, g) {
        var E = (g = g.length == 1 && st(g[0]) ? un(g[0], wr(Je())) : un(Un(g, 1), wr(Je()))).length;
        return mt(function(T) {
          for (var N = -1, z = Hn(T.length, E); ++N < z; )
            T[N] = g[N].call(this, T[N]);
          return Fr(h, this, T);
        });
      }), xh = mt(function(h, g) {
        var E = Ba(g, rs(xh));
        return ta(h, k, n, g, E);
      }), H1 = mt(function(h, g) {
        var E = Ba(g, rs(H1));
        return ta(h, F, n, g, E);
      }), T_ = na(function(h, g) {
        return ta(h, O, n, n, n, g);
      });
      function mi(h, g) {
        return h === g || h != h && g != g;
      }
      var P_ = nl(Gf), I_ = nl(function(h, g) {
        return h >= g;
      }), vo = qg(function() {
        return arguments;
      }()) ? qg : function(h) {
        return mn(h) && qt.call(h, "callee") && !Ag.call(h, "callee");
      }, st = Ne.isArray, B_ = pg ? wr(pg) : function(h) {
        return mn(h) && nr(h) == Jt;
      };
      function fr(h) {
        return h != null && pl(h.length) && !ia(h);
      }
      function Cn(h) {
        return mn(h) && fr(h);
      }
      var Ma = w3 || Th, O_ = fg ? wr(fg) : function(h) {
        return mn(h) && nr(h) == ie;
      };
      function bh(h) {
        if (!mn(h))
          return !1;
        var g = nr(h);
        return g == ge || g == fe || typeof h.message == "string" && typeof h.name == "string" && !gu(h);
      }
      function ia(h) {
        if (!cn(h))
          return !1;
        var g = nr(h);
        return g == Fe || g == Pe || g == he || g == ue;
      }
      function K1(h) {
        return typeof h == "number" && h == ft(h);
      }
      function pl(h) {
        return typeof h == "number" && h > -1 && h % 1 == 0 && h <= R;
      }
      function cn(h) {
        var g = xe(h);
        return h != null && (g == "object" || g == "function");
      }
      function mn(h) {
        return h != null && xe(h) == "object";
      }
      var J1 = hg ? wr(hg) : function(h) {
        return mn(h) && Kn(h) == _;
      };
      function Q1(h) {
        return typeof h == "number" || mn(h) && nr(h) == Q;
      }
      function gu(h) {
        if (!mn(h) || nr(h) != ae)
          return !1;
        var g = Rc(h);
        if (g === null)
          return !0;
        var E = qt.call(g, "constructor") && g.constructor;
        return typeof E == "function" && E instanceof E && Oc.call(E) == E3;
      }
      var Eh = dg ? wr(dg) : function(h) {
        return mn(h) && nr(h) == De;
      }, X1 = mg ? wr(mg) : function(h) {
        return mn(h) && Kn(h) == Ee;
      };
      function fl(h) {
        return typeof h == "string" || !st(h) && mn(h) && nr(h) == _e;
      }
      function _r(h) {
        return xe(h) == "symbol" || mn(h) && nr(h) == Oe;
      }
      var is = gg ? wr(gg) : function(h) {
        return mn(h) && pl(h.length) && !!Zt[nr(h)];
      }, L_ = nl(Jf), N_ = nl(function(h, g) {
        return h <= g;
      });
      function Y1(h) {
        if (!h)
          return [];
        if (fr(h))
          return fl(h) ? hi(h) : pr(h);
        if (ru && h[ru])
          return function(E) {
            for (var T, N = []; !(T = E.next()).done; )
              N.push(T.value);
            return N;
          }(h[ru]());
        var g = Kn(h);
        return (g == _ ? Nf : g == Ee ? Pc : as)(h);
      }
      function aa(h) {
        return h ? (h = Kr(h)) === W || h === -W ? (h < 0 ? -1 : 1) * q : h == h ? h : 0 : h === 0 ? h : 0;
      }
      function ft(h) {
        var g = aa(h), E = g % 1;
        return g == g ? E ? g - E : g : 0;
      }
      function Z1(h) {
        return h ? mo(ft(h), 0, X) : 0;
      }
      function Kr(h) {
        if (typeof h == "number")
          return h;
        if (_r(h))
          return J;
        if (cn(h)) {
          var g = typeof h.valueOf == "function" ? h.valueOf() : h;
          h = cn(g) ? g + "" : g;
        }
        if (typeof h != "string")
          return h === 0 ? h : +h;
        h = h.replace(fi, "");
        var E = an.test(h);
        return E || wi.test(h) ? o3(h.slice(2), E ? 2 : 8) : Ze.test(h) ? J : +h;
      }
      function ey(h) {
        return Ti(h, hr(h));
      }
      function Vt(h) {
        return h == null ? "" : Ar(h);
      }
      var j_ = ts(function(h, g) {
        if (du(g) || fr(g))
          Ti(g, Ln(g), h);
        else
          for (var E in g)
            qt.call(g, E) && uu(h, E, g[E]);
      }), ty = ts(function(h, g) {
        Ti(g, hr(g), h);
      }), hl = ts(function(h, g, E, T) {
        Ti(g, hr(g), h, T);
      }), R_ = ts(function(h, g, E, T) {
        Ti(g, Ln(g), h, T);
      }), M_ = na(qf), V_ = mt(function(h, g) {
        h = en(h);
        var E = -1, T = g.length, N = T > 2 ? g[2] : n;
        for (N && rr(g[0], g[1], N) && (T = 1); ++E < T; )
          for (var z = g[E], te = hr(z), re = -1, se = te.length; ++re < se; ) {
            var be = te[re], ve = h[be];
            (ve === n || mi(ve, Qo[be]) && !qt.call(h, be)) && (h[be] = z[be]);
          }
        return h;
      }), U_ = mt(function(h) {
        return h.push(n, b1), Fr(ny, n, h);
      });
      function Ch(h, g, E) {
        var T = h == null ? n : es(h, g);
        return T === n ? E : T;
      }
      function Sh(h, g) {
        return h != null && S1(h, g, W3);
      }
      var q_ = m1(function(h, g, E) {
        g != null && typeof g.toString != "function" && (g = Lc.call(g)), h[g] = E;
      }, Dh(dr)), W_ = m1(function(h, g, E) {
        g != null && typeof g.toString != "function" && (g = Lc.call(g)), qt.call(h, g) ? h[g].push(E) : h[g] = [E];
      }, Je), $_ = mt(lu);
      function Ln(h) {
        return fr(h) ? Bg(h) : Kf(h);
      }
      function hr(h) {
        return fr(h) ? Bg(h, !0) : $3(h);
      }
      var G_ = ts(function(h, g, E) {
        Jc(h, g, E);
      }), ny = ts(function(h, g, E, T) {
        Jc(h, g, E, T);
      }), z_ = na(function(h, g) {
        var E = {};
        if (h == null)
          return E;
        var T = !1;
        g = un(g, function(z) {
          return z = ja(z, h), T || (T = z.length > 1), z;
        }), Ti(h, uh(h), E), T && (E = Gr(E, c | f | p, Y3));
        for (var N = g.length; N--; )
          eh(E, g[N]);
        return E;
      }), H_ = na(function(h, g) {
        return h == null ? {} : function(E, T) {
          return Qg(E, T, function(N, z) {
            return Sh(E, z);
          });
        }(h, g);
      });
      function ry(h, g) {
        if (h == null)
          return {};
        var E = un(uh(h), function(T) {
          return [T];
        });
        return g = Je(g), Qg(h, E, function(T, N) {
          return g(T, N[0]);
        });
      }
      var iy = v1(Ln), ay = v1(hr);
      function as(h) {
        return h == null ? [] : Lf(h, Ln(h));
      }
      var K_ = ns(function(h, g, E) {
        return g = g.toLowerCase(), h + (E ? oy(g) : g);
      });
      function oy(h) {
        return kh(Vt(h).toLowerCase());
      }
      function sy(h) {
        return (h = Vt(h)) && h.replace(ot, h3).replace(YA, "");
      }
      var J_ = ns(function(h, g, E) {
        return h + (E ? "-" : "") + g.toLowerCase();
      }), Q_ = ns(function(h, g, E) {
        return h + (E ? " " : "") + g.toLowerCase();
      }), X_ = f1("toLowerCase"), Y_ = ns(function(h, g, E) {
        return h + (E ? "_" : "") + g.toLowerCase();
      }), Z_ = ns(function(h, g, E) {
        return h + (E ? " " : "") + kh(g);
      }), e6 = ns(function(h, g, E) {
        return h + (E ? " " : "") + g.toUpperCase();
      }), kh = f1("toUpperCase");
      function uy(h, g, E) {
        return h = Vt(h), (g = E ? n : g) === n ? function(T) {
          return t3.test(T);
        }(h) ? function(T) {
          return T.match(ZA) || [];
        }(h) : function(T) {
          return T.match(Ki) || [];
        }(h) : h.match(g) || [];
      }
      var cy = mt(function(h, g) {
        try {
          return Fr(h, n, g);
        } catch (E) {
          return bh(E) ? E : new Pt(E);
        }
      }), t6 = na(function(h, g) {
        return qr(g, function(E) {
          E = Pi(E), ea(h, E, vh(h[E], h));
        }), h;
      });
      function Dh(h) {
        return function() {
          return h;
        };
      }
      var n6 = d1(), r6 = d1(!0);
      function dr(h) {
        return h;
      }
      function Fh(h) {
        return $g(typeof h == "function" ? h : Gr(h, c));
      }
      var i6 = mt(function(h, g) {
        return function(E) {
          return lu(E, h, g);
        };
      }), a6 = mt(function(h, g) {
        return function(E) {
          return lu(h, E, g);
        };
      });
      function wh(h, g, E) {
        var T = Ln(g), N = Kc(g, T);
        E != null || cn(g) && (N.length || !T.length) || (E = g, g = h, h = this, N = Kc(g, Ln(g)));
        var z = !(cn(E) && "chain" in E && !E.chain), te = ia(h);
        return qr(N, function(re) {
          var se = g[re];
          h[re] = se, te && (h.prototype[re] = function() {
            var be = this.__chain__;
            if (z || be) {
              var ve = h(this.__wrapped__), Ae = ve.__actions__ = pr(this.__actions__);
              return Ae.push({ func: se, args: arguments, thisArg: h }), ve.__chain__ = be, ve;
            }
            return se.apply(h, Ia([this.value()], arguments));
          });
        }), h;
      }
      function Ah() {
      }
      var o6 = ah(un), s6 = ah(yg), u6 = ah(Tf);
      function ly(h) {
        return fh(h) ? Pf(Pi(h)) : function(g) {
          return function(E) {
            return es(E, g);
          };
        }(h);
      }
      var c6 = g1(), l6 = g1(!0);
      function _h() {
        return [];
      }
      function Th() {
        return !1;
      }
      var p6 = el(function(h, g) {
        return h + g;
      }, 0), f6 = oh("ceil"), h6 = el(function(h, g) {
        return h / g;
      }, 1), d6 = oh("floor"), Ph, m6 = el(function(h, g) {
        return h * g;
      }, 1), g6 = oh("round"), y6 = el(function(h, g) {
        return h - g;
      }, 0);
      return U.after = function(h, g) {
        if (typeof g != "function")
          throw new Wr(a);
        return h = ft(h), function() {
          if (--h < 1)
            return g.apply(this, arguments);
        };
      }, U.ary = W1, U.assign = j_, U.assignIn = ty, U.assignInWith = hl, U.assignWith = R_, U.at = M_, U.before = $1, U.bind = vh, U.bindAll = t6, U.bindKey = G1, U.castArray = function() {
        if (!arguments.length)
          return [];
        var h = arguments[0];
        return st(h) ? h : [h];
      }, U.chain = V1, U.chunk = function(h, g, E) {
        g = (E ? rr(h, g, E) : g === n) ? 1 : _n(ft(g), 0);
        var T = h == null ? 0 : h.length;
        if (!T || g < 1)
          return [];
        for (var N = 0, z = 0, te = Ne(Uc(T / g)); N < T; )
          te[z++] = zr(h, N, N += g);
        return te;
      }, U.compact = function(h) {
        for (var g = -1, E = h == null ? 0 : h.length, T = 0, N = []; ++g < E; ) {
          var z = h[g];
          z && (N[T++] = z);
        }
        return N;
      }, U.concat = function() {
        var h = arguments.length;
        if (!h)
          return [];
        for (var g = Ne(h - 1), E = arguments[0], T = h; T--; )
          g[T - 1] = arguments[T];
        return Ia(st(E) ? pr(E) : [E], Un(g, 1));
      }, U.cond = function(h) {
        var g = h == null ? 0 : h.length, E = Je();
        return h = g ? un(h, function(T) {
          if (typeof T[1] != "function")
            throw new Wr(a);
          return [E(T[0]), T[1]];
        }) : [], mt(function(T) {
          for (var N = -1; ++N < g; ) {
            var z = h[N];
            if (Fr(z[0], this, T))
              return Fr(z[1], this, T);
          }
        });
      }, U.conforms = function(h) {
        return function(g) {
          var E = Ln(g);
          return function(T) {
            return Ng(T, g, E);
          };
        }(Gr(h, c));
      }, U.constant = Dh, U.countBy = x_, U.create = function(h, g) {
        var E = Zo(h);
        return g == null ? E : Lg(E, g);
      }, U.curry = function h(g, E, T) {
        var N = ta(g, x, n, n, n, n, n, E = T ? n : E);
        return N.placeholder = h.placeholder, N;
      }, U.curryRight = function h(g, E, T) {
        var N = ta(g, C, n, n, n, n, n, E = T ? n : E);
        return N.placeholder = h.placeholder, N;
      }, U.debounce = z1, U.defaults = V_, U.defaultsDeep = U_, U.defer = w_, U.delay = A_, U.difference = t_, U.differenceBy = n_, U.differenceWith = r_, U.drop = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        return T ? zr(h, (g = E || g === n ? 1 : ft(g)) < 0 ? 0 : g, T) : [];
      }, U.dropRight = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        return T ? zr(h, 0, (g = T - (g = E || g === n ? 1 : ft(g))) < 0 ? 0 : g) : [];
      }, U.dropRightWhile = function(h, g) {
        return h && h.length ? Xc(h, Je(g, 3), !0, !0) : [];
      }, U.dropWhile = function(h, g) {
        return h && h.length ? Xc(h, Je(g, 3), !0) : [];
      }, U.fill = function(h, g, E, T) {
        var N = h == null ? 0 : h.length;
        return N ? (E && typeof E != "number" && rr(h, g, E) && (E = 0, T = N), function(z, te, re, se) {
          var be = z.length;
          for ((re = ft(re)) < 0 && (re = -re > be ? 0 : be + re), (se = se === n || se > be ? be : ft(se)) < 0 && (se += be), se = re > se ? 0 : Z1(se); re < se; )
            z[re++] = te;
          return z;
        }(h, g, E, T)) : [];
      }, U.filter = function(h, g) {
        return (st(h) ? Pa : Mg)(h, Je(g, 3));
      }, U.flatMap = function(h, g) {
        return Un(sl(h, g), 1);
      }, U.flatMapDeep = function(h, g) {
        return Un(sl(h, g), W);
      }, U.flatMapDepth = function(h, g, E) {
        return E = E === n ? 1 : ft(E), Un(sl(h, g), E);
      }, U.flatten = N1, U.flattenDeep = function(h) {
        return h != null && h.length ? Un(h, W) : [];
      }, U.flattenDepth = function(h, g) {
        return h != null && h.length ? Un(h, g = g === n ? 1 : ft(g)) : [];
      }, U.flip = function(h) {
        return ta(h, S);
      }, U.flow = n6, U.flowRight = r6, U.fromPairs = function(h) {
        for (var g = -1, E = h == null ? 0 : h.length, T = {}; ++g < E; ) {
          var N = h[g];
          T[N[0]] = N[1];
        }
        return T;
      }, U.functions = function(h) {
        return h == null ? [] : Kc(h, Ln(h));
      }, U.functionsIn = function(h) {
        return h == null ? [] : Kc(h, hr(h));
      }, U.groupBy = C_, U.initial = function(h) {
        return h != null && h.length ? zr(h, 0, -1) : [];
      }, U.intersection = i_, U.intersectionBy = a_, U.intersectionWith = o_, U.invert = q_, U.invertBy = W_, U.invokeMap = S_, U.iteratee = Fh, U.keyBy = k_, U.keys = Ln, U.keysIn = hr, U.map = sl, U.mapKeys = function(h, g) {
        var E = {};
        return g = Je(g, 3), _i(h, function(T, N, z) {
          ea(E, g(T, N, z), T);
        }), E;
      }, U.mapValues = function(h, g) {
        var E = {};
        return g = Je(g, 3), _i(h, function(T, N, z) {
          ea(E, N, g(T, N, z));
        }), E;
      }, U.matches = function(h) {
        return zg(Gr(h, c));
      }, U.matchesProperty = function(h, g) {
        return Hg(h, Gr(g, c));
      }, U.memoize = cl, U.merge = G_, U.mergeWith = ny, U.method = i6, U.methodOf = a6, U.mixin = wh, U.negate = ll, U.nthArg = function(h) {
        return h = ft(h), mt(function(g) {
          return Kg(g, h);
        });
      }, U.omit = z_, U.omitBy = function(h, g) {
        return ry(h, ll(Je(g)));
      }, U.once = function(h) {
        return $1(2, h);
      }, U.orderBy = function(h, g, E, T) {
        return h == null ? [] : (st(g) || (g = g == null ? [] : [g]), st(E = T ? n : E) || (E = E == null ? [] : [E]), Jg(h, g, E));
      }, U.over = o6, U.overArgs = __, U.overEvery = s6, U.overSome = u6, U.partial = xh, U.partialRight = H1, U.partition = D_, U.pick = H_, U.pickBy = ry, U.property = ly, U.propertyOf = function(h) {
        return function(g) {
          return h == null ? n : es(h, g);
        };
      }, U.pull = s_, U.pullAll = R1, U.pullAllBy = function(h, g, E) {
        return h && h.length && g && g.length ? Qf(h, g, Je(E, 2)) : h;
      }, U.pullAllWith = function(h, g, E) {
        return h && h.length && g && g.length ? Qf(h, g, n, E) : h;
      }, U.pullAt = u_, U.range = c6, U.rangeRight = l6, U.rearg = T_, U.reject = function(h, g) {
        return (st(h) ? Pa : Mg)(h, ll(Je(g, 3)));
      }, U.remove = function(h, g) {
        var E = [];
        if (!h || !h.length)
          return E;
        var T = -1, N = [], z = h.length;
        for (g = Je(g, 3); ++T < z; ) {
          var te = h[T];
          g(te, T, h) && (E.push(te), N.push(T));
        }
        return Xg(h, N), E;
      }, U.rest = function(h, g) {
        if (typeof h != "function")
          throw new Wr(a);
        return mt(h, g = g === n ? g : ft(g));
      }, U.reverse = gh, U.sampleSize = function(h, g, E) {
        return g = (E ? rr(h, g, E) : g === n) ? 1 : ft(g), (st(h) ? R3 : z3)(h, g);
      }, U.set = function(h, g, E) {
        return h == null ? h : fu(h, g, E);
      }, U.setWith = function(h, g, E, T) {
        return T = typeof T == "function" ? T : n, h == null ? h : fu(h, g, E, T);
      }, U.shuffle = function(h) {
        return (st(h) ? M3 : K3)(h);
      }, U.slice = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        return T ? (E && typeof E != "number" && rr(h, g, E) ? (g = 0, E = T) : (g = g == null ? 0 : ft(g), E = E === n ? T : ft(E)), zr(h, g, E)) : [];
      }, U.sortBy = F_, U.sortedUniq = function(h) {
        return h && h.length ? Zg(h) : [];
      }, U.sortedUniqBy = function(h, g) {
        return h && h.length ? Zg(h, Je(g, 2)) : [];
      }, U.split = function(h, g, E) {
        return E && typeof E != "number" && rr(h, g, E) && (g = E = n), (E = E === n ? X : E >>> 0) ? (h = Vt(h)) && (typeof g == "string" || g != null && !Eh(g)) && !(g = Ar(g)) && Ho(h) ? Ra(hi(h), 0, E) : h.split(g, E) : [];
      }, U.spread = function(h, g) {
        if (typeof h != "function")
          throw new Wr(a);
        return g = g == null ? 0 : _n(ft(g), 0), mt(function(E) {
          var T = E[g], N = Ra(E, 0, g);
          return T && Ia(N, T), Fr(h, this, N);
        });
      }, U.tail = function(h) {
        var g = h == null ? 0 : h.length;
        return g ? zr(h, 1, g) : [];
      }, U.take = function(h, g, E) {
        return h && h.length ? zr(h, 0, (g = E || g === n ? 1 : ft(g)) < 0 ? 0 : g) : [];
      }, U.takeRight = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        return T ? zr(h, (g = T - (g = E || g === n ? 1 : ft(g))) < 0 ? 0 : g, T) : [];
      }, U.takeRightWhile = function(h, g) {
        return h && h.length ? Xc(h, Je(g, 3), !1, !0) : [];
      }, U.takeWhile = function(h, g) {
        return h && h.length ? Xc(h, Je(g, 3)) : [];
      }, U.tap = function(h, g) {
        return g(h), h;
      }, U.throttle = function(h, g, E) {
        var T = !0, N = !0;
        if (typeof h != "function")
          throw new Wr(a);
        return cn(E) && (T = "leading" in E ? !!E.leading : T, N = "trailing" in E ? !!E.trailing : N), z1(h, g, { leading: T, maxWait: g, trailing: N });
      }, U.thru = ol, U.toArray = Y1, U.toPairs = iy, U.toPairsIn = ay, U.toPath = function(h) {
        return st(h) ? un(h, Pi) : _r(h) ? [h] : pr(I1(Vt(h)));
      }, U.toPlainObject = ey, U.transform = function(h, g, E) {
        var T = st(h), N = T || Ma(h) || is(h);
        if (g = Je(g, 4), E == null) {
          var z = h && h.constructor;
          E = N ? T ? new z() : [] : cn(h) && ia(z) ? Zo(Rc(h)) : {};
        }
        return (N ? qr : _i)(h, function(te, re, se) {
          return g(E, te, re, se);
        }), E;
      }, U.unary = function(h) {
        return W1(h, 1);
      }, U.union = c_, U.unionBy = l_, U.unionWith = p_, U.uniq = function(h) {
        return h && h.length ? Na(h) : [];
      }, U.uniqBy = function(h, g) {
        return h && h.length ? Na(h, Je(g, 2)) : [];
      }, U.uniqWith = function(h, g) {
        return g = typeof g == "function" ? g : n, h && h.length ? Na(h, n, g) : [];
      }, U.unset = function(h, g) {
        return h == null || eh(h, g);
      }, U.unzip = yh, U.unzipWith = M1, U.update = function(h, g, E) {
        return h == null ? h : t1(h, g, rh(E));
      }, U.updateWith = function(h, g, E, T) {
        return T = typeof T == "function" ? T : n, h == null ? h : t1(h, g, rh(E), T);
      }, U.values = as, U.valuesIn = function(h) {
        return h == null ? [] : Lf(h, hr(h));
      }, U.without = f_, U.words = uy, U.wrap = function(h, g) {
        return xh(rh(g), h);
      }, U.xor = h_, U.xorBy = d_, U.xorWith = m_, U.zip = g_, U.zipObject = function(h, g) {
        return r1(h || [], g || [], uu);
      }, U.zipObjectDeep = function(h, g) {
        return r1(h || [], g || [], fu);
      }, U.zipWith = y_, U.entries = iy, U.entriesIn = ay, U.extend = ty, U.extendWith = hl, wh(U, U), U.add = p6, U.attempt = cy, U.camelCase = K_, U.capitalize = oy, U.ceil = f6, U.clamp = function(h, g, E) {
        return E === n && (E = g, g = n), E !== n && (E = (E = Kr(E)) == E ? E : 0), g !== n && (g = (g = Kr(g)) == g ? g : 0), mo(Kr(h), g, E);
      }, U.clone = function(h) {
        return Gr(h, p);
      }, U.cloneDeep = function(h) {
        return Gr(h, c | p);
      }, U.cloneDeepWith = function(h, g) {
        return Gr(h, c | p, g = typeof g == "function" ? g : n);
      }, U.cloneWith = function(h, g) {
        return Gr(h, p, g = typeof g == "function" ? g : n);
      }, U.conformsTo = function(h, g) {
        return g == null || Ng(h, g, Ln(g));
      }, U.deburr = sy, U.defaultTo = function(h, g) {
        return h == null || h != h ? g : h;
      }, U.divide = h6, U.endsWith = function(h, g, E) {
        h = Vt(h), g = Ar(g);
        var T = h.length, N = E = E === n ? T : mo(ft(E), 0, T);
        return (E -= g.length) >= 0 && h.slice(E, N) == g;
      }, U.eq = mi, U.escape = function(h) {
        return (h = Vt(h)) && at.test(h) ? h.replace(Qt, d3) : h;
      }, U.escapeRegExp = function(h) {
        return (h = Vt(h)) && er.test(h) ? h.replace(Bn, "\\$&") : h;
      }, U.every = function(h, g, E) {
        var T = st(h) ? yg : U3;
        return E && rr(h, g, E) && (g = n), T(h, Je(g, 3));
      }, U.find = b_, U.findIndex = O1, U.findKey = function(h, g) {
        return vg(h, Je(g, 3), _i);
      }, U.findLast = E_, U.findLastIndex = L1, U.findLastKey = function(h, g) {
        return vg(h, Je(g, 3), $f);
      }, U.floor = d6, U.forEach = U1, U.forEachRight = q1, U.forIn = function(h, g) {
        return h == null ? h : Wf(h, Je(g, 3), hr);
      }, U.forInRight = function(h, g) {
        return h == null ? h : Vg(h, Je(g, 3), hr);
      }, U.forOwn = function(h, g) {
        return h && _i(h, Je(g, 3));
      }, U.forOwnRight = function(h, g) {
        return h && $f(h, Je(g, 3));
      }, U.get = Ch, U.gt = P_, U.gte = I_, U.has = function(h, g) {
        return h != null && S1(h, g, q3);
      }, U.hasIn = Sh, U.head = j1, U.identity = dr, U.includes = function(h, g, E, T) {
        h = fr(h) ? h : as(h), E = E && !T ? ft(E) : 0;
        var N = h.length;
        return E < 0 && (E = _n(N + E, 0)), fl(h) ? E <= N && h.indexOf(g, E) > -1 : !!N && zo(h, g, E) > -1;
      }, U.indexOf = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        if (!T)
          return -1;
        var N = E == null ? 0 : ft(E);
        return N < 0 && (N = _n(T + N, 0)), zo(h, g, N);
      }, U.inRange = function(h, g, E) {
        return g = aa(g), E === n ? (E = g, g = 0) : E = aa(E), function(T, N, z) {
          return T >= Hn(N, z) && T < _n(N, z);
        }(h = Kr(h), g, E);
      }, U.invoke = $_, U.isArguments = vo, U.isArray = st, U.isArrayBuffer = B_, U.isArrayLike = fr, U.isArrayLikeObject = Cn, U.isBoolean = function(h) {
        return h === !0 || h === !1 || mn(h) && nr(h) == j;
      }, U.isBuffer = Ma, U.isDate = O_, U.isElement = function(h) {
        return mn(h) && h.nodeType === 1 && !gu(h);
      }, U.isEmpty = function(h) {
        if (h == null)
          return !0;
        if (fr(h) && (st(h) || typeof h == "string" || typeof h.splice == "function" || Ma(h) || is(h) || vo(h)))
          return !h.length;
        var g = Kn(h);
        if (g == _ || g == Ee)
          return !h.size;
        if (du(h))
          return !Kf(h).length;
        for (var E in h)
          if (qt.call(h, E))
            return !1;
        return !0;
      }, U.isEqual = function(h, g) {
        return pu(h, g);
      }, U.isEqualWith = function(h, g, E) {
        var T = (E = typeof E == "function" ? E : n) ? E(h, g) : n;
        return T === n ? pu(h, g, n, E) : !!T;
      }, U.isError = bh, U.isFinite = function(h) {
        return typeof h == "number" && Tg(h);
      }, U.isFunction = ia, U.isInteger = K1, U.isLength = pl, U.isMap = J1, U.isMatch = function(h, g) {
        return h === g || Hf(h, g, lh(g));
      }, U.isMatchWith = function(h, g, E) {
        return E = typeof E == "function" ? E : n, Hf(h, g, lh(g), E);
      }, U.isNaN = function(h) {
        return Q1(h) && h != +h;
      }, U.isNative = function(h) {
        if (e_(h))
          throw new Pt(i);
        return Wg(h);
      }, U.isNil = function(h) {
        return h == null;
      }, U.isNull = function(h) {
        return h === null;
      }, U.isNumber = Q1, U.isObject = cn, U.isObjectLike = mn, U.isPlainObject = gu, U.isRegExp = Eh, U.isSafeInteger = function(h) {
        return K1(h) && h >= -R && h <= R;
      }, U.isSet = X1, U.isString = fl, U.isSymbol = _r, U.isTypedArray = is, U.isUndefined = function(h) {
        return h === n;
      }, U.isWeakMap = function(h) {
        return mn(h) && Kn(h) == _t;
      }, U.isWeakSet = function(h) {
        return mn(h) && nr(h) == Kt;
      }, U.join = function(h, g) {
        return h == null ? "" : A3.call(h, g);
      }, U.kebabCase = J_, U.last = Hr, U.lastIndexOf = function(h, g, E) {
        var T = h == null ? 0 : h.length;
        if (!T)
          return -1;
        var N = T;
        return E !== n && (N = (N = ft(E)) < 0 ? _n(T + N, 0) : Hn(N, T - 1)), g == g ? function(z, te, re) {
          for (var se = re + 1; se--; )
            if (z[se] === te)
              return se;
          return se;
        }(h, g, N) : Tc(h, xg, N, !0);
      }, U.lowerCase = Q_, U.lowerFirst = X_, U.lt = L_, U.lte = N_, U.max = function(h) {
        return h && h.length ? Hc(h, dr, Gf) : n;
      }, U.maxBy = function(h, g) {
        return h && h.length ? Hc(h, Je(g, 2), Gf) : n;
      }, U.mean = function(h) {
        return bg(h, dr);
      }, U.meanBy = function(h, g) {
        return bg(h, Je(g, 2));
      }, U.min = function(h) {
        return h && h.length ? Hc(h, dr, Jf) : n;
      }, U.minBy = function(h, g) {
        return h && h.length ? Hc(h, Je(g, 2), Jf) : n;
      }, U.stubArray = _h, U.stubFalse = Th, U.stubObject = function() {
        return {};
      }, U.stubString = function() {
        return "";
      }, U.stubTrue = function() {
        return !0;
      }, U.multiply = m6, U.nth = function(h, g) {
        return h && h.length ? Kg(h, ft(g)) : n;
      }, U.noConflict = function() {
        return Vn._ === this && (Vn._ = C3), this;
      }, U.noop = Ah, U.now = ul, U.pad = function(h, g, E) {
        h = Vt(h);
        var T = (g = ft(g)) ? Ko(h) : 0;
        if (!g || T >= g)
          return h;
        var N = (g - T) / 2;
        return tl(qc(N), E) + h + tl(Uc(N), E);
      }, U.padEnd = function(h, g, E) {
        h = Vt(h);
        var T = (g = ft(g)) ? Ko(h) : 0;
        return g && T < g ? h + tl(g - T, E) : h;
      }, U.padStart = function(h, g, E) {
        h = Vt(h);
        var T = (g = ft(g)) ? Ko(h) : 0;
        return g && T < g ? tl(g - T, E) + h : h;
      }, U.parseInt = function(h, g, E) {
        return E || g == null ? g = 0 : g && (g = +g), P3(Vt(h).replace(kr, ""), g || 0);
      }, U.random = function(h, g, E) {
        if (E && typeof E != "boolean" && rr(h, g, E) && (g = E = n), E === n && (typeof g == "boolean" ? (E = g, g = n) : typeof h == "boolean" && (E = h, h = n)), h === n && g === n ? (h = 0, g = 1) : (h = aa(h), g === n ? (g = h, h = 0) : g = aa(g)), h > g) {
          var T = h;
          h = g, g = T;
        }
        if (E || h % 1 || g % 1) {
          var N = Pg();
          return Hn(h + N * (g - h + a3("1e-" + ((N + "").length - 1))), g);
        }
        return Xf(h, g);
      }, U.reduce = function(h, g, E) {
        var T = st(h) ? _f : Eg, N = arguments.length < 3;
        return T(h, Je(g, 4), E, N, La);
      }, U.reduceRight = function(h, g, E) {
        var T = st(h) ? l3 : Eg, N = arguments.length < 3;
        return T(h, Je(g, 4), E, N, Rg);
      }, U.repeat = function(h, g, E) {
        return g = (E ? rr(h, g, E) : g === n) ? 1 : ft(g), Yf(Vt(h), g);
      }, U.replace = function() {
        var h = arguments, g = Vt(h[0]);
        return h.length < 3 ? g : g.replace(h[1], h[2]);
      }, U.result = function(h, g, E) {
        var T = -1, N = (g = ja(g, h)).length;
        for (N || (N = 1, h = n); ++T < N; ) {
          var z = h == null ? n : h[Pi(g[T])];
          z === n && (T = N, z = E), h = ia(z) ? z.call(h) : z;
        }
        return h;
      }, U.round = g6, U.runInContext = pe, U.sample = function(h) {
        return (st(h) ? Og : G3)(h);
      }, U.size = function(h) {
        if (h == null)
          return 0;
        if (fr(h))
          return fl(h) ? Ko(h) : h.length;
        var g = Kn(h);
        return g == _ || g == Ee ? h.size : Kf(h).length;
      }, U.snakeCase = Y_, U.some = function(h, g, E) {
        var T = st(h) ? Tf : J3;
        return E && rr(h, g, E) && (g = n), T(h, Je(g, 3));
      }, U.sortedIndex = function(h, g) {
        return Qc(h, g);
      }, U.sortedIndexBy = function(h, g, E) {
        return Zf(h, g, Je(E, 2));
      }, U.sortedIndexOf = function(h, g) {
        var E = h == null ? 0 : h.length;
        if (E) {
          var T = Qc(h, g);
          if (T < E && mi(h[T], g))
            return T;
        }
        return -1;
      }, U.sortedLastIndex = function(h, g) {
        return Qc(h, g, !0);
      }, U.sortedLastIndexBy = function(h, g, E) {
        return Zf(h, g, Je(E, 2), !0);
      }, U.sortedLastIndexOf = function(h, g) {
        if (h != null && h.length) {
          var E = Qc(h, g, !0) - 1;
          if (mi(h[E], g))
            return E;
        }
        return -1;
      }, U.startCase = Z_, U.startsWith = function(h, g, E) {
        return h = Vt(h), E = E == null ? 0 : mo(ft(E), 0, h.length), g = Ar(g), h.slice(E, E + g.length) == g;
      }, U.subtract = y6, U.sum = function(h) {
        return h && h.length ? Bf(h, dr) : 0;
      }, U.sumBy = function(h, g) {
        return h && h.length ? Bf(h, Je(g, 2)) : 0;
      }, U.template = function(h, g, E) {
        var T = U.templateSettings;
        E && rr(h, g, E) && (g = n), h = Vt(h), g = hl({}, g, T, x1);
        var N, z, te = hl({}, g.imports, T.imports, x1), re = Ln(te), se = Lf(te, re), be = 0, ve = g.interpolate || Mn, Ae = "__p += '", Ue = jf((g.escape || Mn).source + "|" + ve.source + "|" + (ve === Rn ? Ie : Mn).source + "|" + (g.evaluate || Mn).source + "|$", "g"), qe = "//# sourceURL=" + (qt.call(g, "sourceURL") ? (g.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++r3 + "]") + `
`;
        h.replace(Ue, function(Te, et, Le, ut, nt, Bt) {
          return Le || (Le = ut), Ae += h.slice(be, Bt).replace(Ji, m3), et && (N = !0, Ae += `' +
__e(` + et + `) +
'`), nt && (z = !0, Ae += `';
` + nt + `;
__p += '`), Le && (Ae += `' +
((__t = (` + Le + `)) == null ? '' : __t) +
'`), be = Bt + Te.length, Te;
        }), Ae += `';
`;
        var Qe = qt.call(g, "variable") && g.variable;
        Qe || (Ae = `with (obj) {
` + Ae + `
}
`), Ae = (z ? Ae.replace(yt, "") : Ae).replace(ze, "$1").replace(vt, "$1;"), Ae = "function(" + (Qe || "obj") + `) {
` + (Qe ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (N ? ", __e = _.escape" : "") + (z ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ae + `return __p
}`;
        var Se = cy(function() {
          return An(re, qe + "return " + Ae).apply(n, se);
        });
        if (Se.source = Ae, bh(Se))
          throw Se;
        return Se;
      }, U.times = function(h, g) {
        if ((h = ft(h)) < 1 || h > R)
          return [];
        var E = X, T = Hn(h, X);
        g = Je(g), h -= X;
        for (var N = Of(T, g); ++E < h; )
          g(E);
        return N;
      }, U.toFinite = aa, U.toInteger = ft, U.toLength = Z1, U.toLower = function(h) {
        return Vt(h).toLowerCase();
      }, U.toNumber = Kr, U.toSafeInteger = function(h) {
        return h ? mo(ft(h), -R, R) : h === 0 ? h : 0;
      }, U.toString = Vt, U.toUpper = function(h) {
        return Vt(h).toUpperCase();
      }, U.trim = function(h, g, E) {
        if ((h = Vt(h)) && (E || g === n))
          return h.replace(fi, "");
        if (!h || !(g = Ar(g)))
          return h;
        var T = hi(h), N = hi(g);
        return Ra(T, Cg(T, N), Sg(T, N) + 1).join("");
      }, U.trimEnd = function(h, g, E) {
        if ((h = Vt(h)) && (E || g === n))
          return h.replace(oo, "");
        if (!h || !(g = Ar(g)))
          return h;
        var T = hi(h);
        return Ra(T, 0, Sg(T, hi(g)) + 1).join("");
      }, U.trimStart = function(h, g, E) {
        if ((h = Vt(h)) && (E || g === n))
          return h.replace(kr, "");
        if (!h || !(g = Ar(g)))
          return h;
        var T = hi(h);
        return Ra(T, Cg(T, hi(g))).join("");
      }, U.truncate = function(h, g) {
        var E = w, T = D;
        if (cn(g)) {
          var N = "separator" in g ? g.separator : N;
          E = "length" in g ? ft(g.length) : E, T = "omission" in g ? Ar(g.omission) : T;
        }
        var z = (h = Vt(h)).length;
        if (Ho(h)) {
          var te = hi(h);
          z = te.length;
        }
        if (E >= z)
          return h;
        var re = E - Ko(T);
        if (re < 1)
          return T;
        var se = te ? Ra(te, 0, re).join("") : h.slice(0, re);
        if (N === n)
          return se + T;
        if (te && (re += se.length - re), Eh(N)) {
          if (h.slice(re).search(N)) {
            var be, ve = se;
            for (N.global || (N = jf(N.source, Vt(je.exec(N)) + "g")), N.lastIndex = 0; be = N.exec(ve); )
              var Ae = be.index;
            se = se.slice(0, Ae === n ? re : Ae);
          }
        } else if (h.indexOf(Ar(N), re) != re) {
          var Ue = se.lastIndexOf(N);
          Ue > -1 && (se = se.slice(0, Ue));
        }
        return se + T;
      }, U.unescape = function(h) {
        return (h = Vt(h)) && bt.test(h) ? h.replace(Nt, y3) : h;
      }, U.uniqueId = function(h) {
        var g = ++b3;
        return Vt(h) + g;
      }, U.upperCase = e6, U.upperFirst = kh, U.each = U1, U.eachRight = q1, U.first = j1, wh(U, (Ph = {}, _i(U, function(h, g) {
        qt.call(U.prototype, g) || (Ph[g] = h);
      }), Ph), { chain: !1 }), U.VERSION = "4.17.15", qr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(h) {
        U[h].placeholder = U;
      }), qr(["drop", "take"], function(h, g) {
        St.prototype[h] = function(E) {
          E = E === n ? 1 : _n(ft(E), 0);
          var T = this.__filtered__ && !g ? new St(this) : this.clone();
          return T.__filtered__ ? T.__takeCount__ = Hn(E, T.__takeCount__) : T.__views__.push({ size: Hn(E, X), type: h + (T.__dir__ < 0 ? "Right" : "") }), T;
        }, St.prototype[h + "Right"] = function(E) {
          return this.reverse()[h](E).reverse();
        };
      }), qr(["filter", "map", "takeWhile"], function(h, g) {
        var E = g + 1, T = E == V || E == 3;
        St.prototype[h] = function(N) {
          var z = this.clone();
          return z.__iteratees__.push({ iteratee: Je(N, 3), type: E }), z.__filtered__ = z.__filtered__ || T, z;
        };
      }), qr(["head", "last"], function(h, g) {
        var E = "take" + (g ? "Right" : "");
        St.prototype[h] = function() {
          return this[E](1).value()[0];
        };
      }), qr(["initial", "tail"], function(h, g) {
        var E = "drop" + (g ? "" : "Right");
        St.prototype[h] = function() {
          return this.__filtered__ ? new St(this) : this[E](1);
        };
      }), St.prototype.compact = function() {
        return this.filter(dr);
      }, St.prototype.find = function(h) {
        return this.filter(h).head();
      }, St.prototype.findLast = function(h) {
        return this.reverse().find(h);
      }, St.prototype.invokeMap = mt(function(h, g) {
        return typeof h == "function" ? new St(this) : this.map(function(E) {
          return lu(E, h, g);
        });
      }), St.prototype.reject = function(h) {
        return this.filter(ll(Je(h)));
      }, St.prototype.slice = function(h, g) {
        h = ft(h);
        var E = this;
        return E.__filtered__ && (h > 0 || g < 0) ? new St(E) : (h < 0 ? E = E.takeRight(-h) : h && (E = E.drop(h)), g !== n && (E = (g = ft(g)) < 0 ? E.dropRight(-g) : E.take(g - h)), E);
      }, St.prototype.takeRightWhile = function(h) {
        return this.reverse().takeWhile(h).reverse();
      }, St.prototype.toArray = function() {
        return this.take(X);
      }, _i(St.prototype, function(h, g) {
        var E = /^(?:filter|find|map|reject)|While$/.test(g), T = /^(?:head|last)$/.test(g), N = U[T ? "take" + (g == "last" ? "Right" : "") : g], z = T || /^find/.test(g);
        N && (U.prototype[g] = function() {
          var te = this.__wrapped__, re = T ? [1] : arguments, se = te instanceof St, be = re[0], ve = se || st(te), Ae = function(et) {
            var Le = N.apply(U, Ia([et], re));
            return T && Ue ? Le[0] : Le;
          };
          ve && E && typeof be == "function" && be.length != 1 && (se = ve = !1);
          var Ue = this.__chain__, qe = !!this.__actions__.length, Qe = z && !Ue, Se = se && !qe;
          if (!z && ve) {
            te = Se ? te : new St(this);
            var Te = h.apply(te, re);
            return Te.__actions__.push({ func: ol, args: [Ae], thisArg: n }), new $r(Te, Ue);
          }
          return Qe && Se ? h.apply(this, re) : (Te = this.thru(Ae), Qe ? T ? Te.value()[0] : Te.value() : Te);
        });
      }), qr(["pop", "push", "shift", "sort", "splice", "unshift"], function(h) {
        var g = Ic[h], E = /^(?:push|sort|unshift)$/.test(h) ? "tap" : "thru", T = /^(?:pop|shift)$/.test(h);
        U.prototype[h] = function() {
          var N = arguments;
          if (T && !this.__chain__) {
            var z = this.value();
            return g.apply(st(z) ? z : [], N);
          }
          return this[E](function(te) {
            return g.apply(st(te) ? te : [], N);
          });
        };
      }), _i(St.prototype, function(h, g) {
        var E = U[g];
        if (E) {
          var T = E.name + "";
          qt.call(Yo, T) || (Yo[T] = []), Yo[T].push({ name: g, func: E });
        }
      }), Yo[Zc(n, v).name] = [{ name: "wrapper", func: n }], St.prototype.clone = function() {
        var h = new St(this.__wrapped__);
        return h.__actions__ = pr(this.__actions__), h.__dir__ = this.__dir__, h.__filtered__ = this.__filtered__, h.__iteratees__ = pr(this.__iteratees__), h.__takeCount__ = this.__takeCount__, h.__views__ = pr(this.__views__), h;
      }, St.prototype.reverse = function() {
        if (this.__filtered__) {
          var h = new St(this);
          h.__dir__ = -1, h.__filtered__ = !0;
        } else
          (h = this.clone()).__dir__ *= -1;
        return h;
      }, St.prototype.value = function() {
        var h = this.__wrapped__.value(), g = this.__dir__, E = st(h), T = g < 0, N = E ? h.length : 0, z = function(Bt, Ge, tt) {
          for (var Tn = -1, Sn = tt.length; ++Tn < Sn; ) {
            var ir = tt[Tn], tn = ir.size;
            switch (ir.type) {
              case "drop":
                Bt += tn;
                break;
              case "dropRight":
                Ge -= tn;
                break;
              case "take":
                Ge = Hn(Ge, Bt + tn);
                break;
              case "takeRight":
                Bt = _n(Bt, Ge - tn);
            }
          }
          return { start: Bt, end: Ge };
        }(0, N, this.__views__), te = z.start, re = z.end, se = re - te, be = T ? re : te - 1, ve = this.__iteratees__, Ae = ve.length, Ue = 0, qe = Hn(se, this.__takeCount__);
        if (!E || !T && N == se && qe == se)
          return n1(h, this.__actions__);
        var Qe = [];
        e:
          for (; se-- && Ue < qe; ) {
            for (var Se = -1, Te = h[be += g]; ++Se < Ae; ) {
              var et = ve[Se], Le = et.iteratee, ut = et.type, nt = Le(Te);
              if (ut == K)
                Te = nt;
              else if (!nt) {
                if (ut == V)
                  continue e;
                break e;
              }
            }
            Qe[Ue++] = Te;
          }
        return Qe;
      }, U.prototype.at = v_, U.prototype.chain = function() {
        return V1(this);
      }, U.prototype.commit = function() {
        return new $r(this.value(), this.__chain__);
      }, U.prototype.next = function() {
        this.__values__ === n && (this.__values__ = Y1(this.value()));
        var h = this.__index__ >= this.__values__.length;
        return { done: h, value: h ? n : this.__values__[this.__index__++] };
      }, U.prototype.plant = function(h) {
        for (var g, E = this; E instanceof Gc; ) {
          var T = B1(E);
          T.__index__ = 0, T.__values__ = n, g ? N.__wrapped__ = T : g = T;
          var N = T;
          E = E.__wrapped__;
        }
        return N.__wrapped__ = h, g;
      }, U.prototype.reverse = function() {
        var h = this.__wrapped__;
        if (h instanceof St) {
          var g = h;
          return this.__actions__.length && (g = new St(this)), (g = g.reverse()).__actions__.push({ func: ol, args: [gh], thisArg: n }), new $r(g, this.__chain__);
        }
        return this.thru(gh);
      }, U.prototype.toJSON = U.prototype.valueOf = U.prototype.value = function() {
        return n1(this.__wrapped__, this.__actions__);
      }, U.prototype.first = U.prototype.head, ru && (U.prototype[ru] = function() {
        return this;
      }), U;
    }();
    lo ? ((lo.exports = Jo)._ = Jo, Ff._ = Jo) : Vn._ = Jo;
  }).call(ni);
}), Fk = { Array: !1, ArrayBuffer: !1, Atomics: !1, BigInt: !1, BigInt64Array: !1, BigUint64Array: !1, Boolean: !1, constructor: !1, DataView: !1, Date: !1, decodeURI: !1, decodeURIComponent: !1, encodeURI: !1, encodeURIComponent: !1, Error: !1, escape: !1, eval: !1, EvalError: !1, Float32Array: !1, Float64Array: !1, Function: !1, globalThis: !1, hasOwnProperty: !1, Infinity: !1, Int16Array: !1, Int32Array: !1, Int8Array: !1, isFinite: !1, isNaN: !1, isPrototypeOf: !1, JSON: !1, Map: !1, Math: !1, NaN: !1, Number: !1, Object: !1, parseFloat: !1, parseInt: !1, Promise: !1, propertyIsEnumerable: !1, Proxy: !1, RangeError: !1, ReferenceError: !1, Reflect: !1, RegExp: !1, Set: !1, SharedArrayBuffer: !1, String: !1, Symbol: !1, SyntaxError: !1, toLocaleString: !1, toString: !1, TypeError: !1, Uint16Array: !1, Uint32Array: !1, Uint8Array: !1, Uint8ClampedArray: !1, undefined: !1, unescape: !1, URIError: !1, valueOf: !1, WeakMap: !1, WeakSet: !1 }, wk = { Array: !1, Boolean: !1, constructor: !1, Date: !1, decodeURI: !1, decodeURIComponent: !1, encodeURI: !1, encodeURIComponent: !1, Error: !1, escape: !1, eval: !1, EvalError: !1, Function: !1, hasOwnProperty: !1, Infinity: !1, isFinite: !1, isNaN: !1, isPrototypeOf: !1, JSON: !1, Math: !1, NaN: !1, Number: !1, Object: !1, parseFloat: !1, parseInt: !1, propertyIsEnumerable: !1, RangeError: !1, ReferenceError: !1, RegExp: !1, String: !1, SyntaxError: !1, toLocaleString: !1, toString: !1, TypeError: !1, undefined: !1, unescape: !1, URIError: !1, valueOf: !1 }, Ak = { Array: !1, ArrayBuffer: !1, Boolean: !1, constructor: !1, DataView: !1, Date: !1, decodeURI: !1, decodeURIComponent: !1, encodeURI: !1, encodeURIComponent: !1, Error: !1, escape: !1, eval: !1, EvalError: !1, Float32Array: !1, Float64Array: !1, Function: !1, hasOwnProperty: !1, Infinity: !1, Int16Array: !1, Int32Array: !1, Int8Array: !1, isFinite: !1, isNaN: !1, isPrototypeOf: !1, JSON: !1, Map: !1, Math: !1, NaN: !1, Number: !1, Object: !1, parseFloat: !1, parseInt: !1, Promise: !1, propertyIsEnumerable: !1, Proxy: !1, RangeError: !1, ReferenceError: !1, Reflect: !1, RegExp: !1, Set: !1, String: !1, Symbol: !1, SyntaxError: !1, toLocaleString: !1, toString: !1, TypeError: !1, Uint16Array: !1, Uint32Array: !1, Uint8Array: !1, Uint8ClampedArray: !1, undefined: !1, unescape: !1, URIError: !1, valueOf: !1, WeakMap: !1, WeakSet: !1 }, _k = { Array: !1, ArrayBuffer: !1, Atomics: !1, Boolean: !1, constructor: !1, DataView: !1, Date: !1, decodeURI: !1, decodeURIComponent: !1, encodeURI: !1, encodeURIComponent: !1, Error: !1, escape: !1, eval: !1, EvalError: !1, Float32Array: !1, Float64Array: !1, Function: !1, hasOwnProperty: !1, Infinity: !1, Int16Array: !1, Int32Array: !1, Int8Array: !1, isFinite: !1, isNaN: !1, isPrototypeOf: !1, JSON: !1, Map: !1, Math: !1, NaN: !1, Number: !1, Object: !1, parseFloat: !1, parseInt: !1, Promise: !1, propertyIsEnumerable: !1, Proxy: !1, RangeError: !1, ReferenceError: !1, Reflect: !1, RegExp: !1, Set: !1, SharedArrayBuffer: !1, String: !1, Symbol: !1, SyntaxError: !1, toLocaleString: !1, toString: !1, TypeError: !1, Uint16Array: !1, Uint32Array: !1, Uint8Array: !1, Uint8ClampedArray: !1, undefined: !1, unescape: !1, URIError: !1, valueOf: !1, WeakMap: !1, WeakSet: !1 }, Tk = { AbortController: !1, AbortSignal: !1, addEventListener: !1, alert: !1, AnalyserNode: !1, Animation: !1, AnimationEffectReadOnly: !1, AnimationEffectTiming: !1, AnimationEffectTimingReadOnly: !1, AnimationEvent: !1, AnimationPlaybackEvent: !1, AnimationTimeline: !1, applicationCache: !1, ApplicationCache: !1, ApplicationCacheErrorEvent: !1, atob: !1, Attr: !1, Audio: !1, AudioBuffer: !1, AudioBufferSourceNode: !1, AudioContext: !1, AudioDestinationNode: !1, AudioListener: !1, AudioNode: !1, AudioParam: !1, AudioProcessingEvent: !1, AudioScheduledSourceNode: !1, "AudioWorkletGlobalScope ": !1, AudioWorkletNode: !1, AudioWorkletProcessor: !1, BarProp: !1, BaseAudioContext: !1, BatteryManager: !1, BeforeUnloadEvent: !1, BiquadFilterNode: !1, Blob: !1, BlobEvent: !1, blur: !1, BroadcastChannel: !1, btoa: !1, BudgetService: !1, ByteLengthQueuingStrategy: !1, Cache: !1, caches: !1, CacheStorage: !1, cancelAnimationFrame: !1, cancelIdleCallback: !1, CanvasCaptureMediaStreamTrack: !1, CanvasGradient: !1, CanvasPattern: !1, CanvasRenderingContext2D: !1, ChannelMergerNode: !1, ChannelSplitterNode: !1, CharacterData: !1, clearInterval: !1, clearTimeout: !1, clientInformation: !1, ClipboardEvent: !1, close: !1, closed: !1, CloseEvent: !1, Comment: !1, CompositionEvent: !1, confirm: !1, console: !1, ConstantSourceNode: !1, ConvolverNode: !1, CountQueuingStrategy: !1, createImageBitmap: !1, Credential: !1, CredentialsContainer: !1, crypto: !1, Crypto: !1, CryptoKey: !1, CSS: !1, CSSConditionRule: !1, CSSFontFaceRule: !1, CSSGroupingRule: !1, CSSImportRule: !1, CSSKeyframeRule: !1, CSSKeyframesRule: !1, CSSMediaRule: !1, CSSNamespaceRule: !1, CSSPageRule: !1, CSSRule: !1, CSSRuleList: !1, CSSStyleDeclaration: !1, CSSStyleRule: !1, CSSStyleSheet: !1, CSSSupportsRule: !1, CustomElementRegistry: !1, customElements: !1, CustomEvent: !1, DataTransfer: !1, DataTransferItem: !1, DataTransferItemList: !1, defaultstatus: !1, defaultStatus: !1, DelayNode: !1, DeviceMotionEvent: !1, DeviceOrientationEvent: !1, devicePixelRatio: !1, dispatchEvent: !1, document: !1, Document: !1, DocumentFragment: !1, DocumentType: !1, DOMError: !1, DOMException: !1, DOMImplementation: !1, DOMMatrix: !1, DOMMatrixReadOnly: !1, DOMParser: !1, DOMPoint: !1, DOMPointReadOnly: !1, DOMQuad: !1, DOMRect: !1, DOMRectReadOnly: !1, DOMStringList: !1, DOMStringMap: !1, DOMTokenList: !1, DragEvent: !1, DynamicsCompressorNode: !1, Element: !1, ErrorEvent: !1, event: !1, Event: !1, EventSource: !1, EventTarget: !1, external: !1, fetch: !1, File: !1, FileList: !1, FileReader: !1, find: !1, focus: !1, FocusEvent: !1, FontFace: !1, FontFaceSetLoadEvent: !1, FormData: !1, frameElement: !1, frames: !1, GainNode: !1, Gamepad: !1, GamepadButton: !1, GamepadEvent: !1, getComputedStyle: !1, getSelection: !1, HashChangeEvent: !1, Headers: !1, history: !1, History: !1, HTMLAllCollection: !1, HTMLAnchorElement: !1, HTMLAreaElement: !1, HTMLAudioElement: !1, HTMLBaseElement: !1, HTMLBodyElement: !1, HTMLBRElement: !1, HTMLButtonElement: !1, HTMLCanvasElement: !1, HTMLCollection: !1, HTMLContentElement: !1, HTMLDataElement: !1, HTMLDataListElement: !1, HTMLDetailsElement: !1, HTMLDialogElement: !1, HTMLDirectoryElement: !1, HTMLDivElement: !1, HTMLDListElement: !1, HTMLDocument: !1, HTMLElement: !1, HTMLEmbedElement: !1, HTMLFieldSetElement: !1, HTMLFontElement: !1, HTMLFormControlsCollection: !1, HTMLFormElement: !1, HTMLFrameElement: !1, HTMLFrameSetElement: !1, HTMLHeadElement: !1, HTMLHeadingElement: !1, HTMLHRElement: !1, HTMLHtmlElement: !1, HTMLIFrameElement: !1, HTMLImageElement: !1, HTMLInputElement: !1, HTMLLabelElement: !1, HTMLLegendElement: !1, HTMLLIElement: !1, HTMLLinkElement: !1, HTMLMapElement: !1, HTMLMarqueeElement: !1, HTMLMediaElement: !1, HTMLMenuElement: !1, HTMLMetaElement: !1, HTMLMeterElement: !1, HTMLModElement: !1, HTMLObjectElement: !1, HTMLOListElement: !1, HTMLOptGroupElement: !1, HTMLOptionElement: !1, HTMLOptionsCollection: !1, HTMLOutputElement: !1, HTMLParagraphElement: !1, HTMLParamElement: !1, HTMLPictureElement: !1, HTMLPreElement: !1, HTMLProgressElement: !1, HTMLQuoteElement: !1, HTMLScriptElement: !1, HTMLSelectElement: !1, HTMLShadowElement: !1, HTMLSlotElement: !1, HTMLSourceElement: !1, HTMLSpanElement: !1, HTMLStyleElement: !1, HTMLTableCaptionElement: !1, HTMLTableCellElement: !1, HTMLTableColElement: !1, HTMLTableElement: !1, HTMLTableRowElement: !1, HTMLTableSectionElement: !1, HTMLTemplateElement: !1, HTMLTextAreaElement: !1, HTMLTimeElement: !1, HTMLTitleElement: !1, HTMLTrackElement: !1, HTMLUListElement: !1, HTMLUnknownElement: !1, HTMLVideoElement: !1, IDBCursor: !1, IDBCursorWithValue: !1, IDBDatabase: !1, IDBFactory: !1, IDBIndex: !1, IDBKeyRange: !1, IDBObjectStore: !1, IDBOpenDBRequest: !1, IDBRequest: !1, IDBTransaction: !1, IDBVersionChangeEvent: !1, IdleDeadline: !1, IIRFilterNode: !1, Image: !1, ImageBitmap: !1, ImageBitmapRenderingContext: !1, ImageCapture: !1, ImageData: !1, indexedDB: !1, innerHeight: !1, innerWidth: !1, InputEvent: !1, IntersectionObserver: !1, IntersectionObserverEntry: !1, Intl: !1, isSecureContext: !1, KeyboardEvent: !1, KeyframeEffect: !1, KeyframeEffectReadOnly: !1, length: !1, localStorage: !1, location: !0, Location: !1, locationbar: !1, matchMedia: !1, MediaDeviceInfo: !1, MediaDevices: !1, MediaElementAudioSourceNode: !1, MediaEncryptedEvent: !1, MediaError: !1, MediaKeyMessageEvent: !1, MediaKeySession: !1, MediaKeyStatusMap: !1, MediaKeySystemAccess: !1, MediaList: !1, MediaQueryList: !1, MediaQueryListEvent: !1, MediaRecorder: !1, MediaSettingsRange: !1, MediaSource: !1, MediaStream: !1, MediaStreamAudioDestinationNode: !1, MediaStreamAudioSourceNode: !1, MediaStreamEvent: !1, MediaStreamTrack: !1, MediaStreamTrackEvent: !1, menubar: !1, MessageChannel: !1, MessageEvent: !1, MessagePort: !1, MIDIAccess: !1, MIDIConnectionEvent: !1, MIDIInput: !1, MIDIInputMap: !1, MIDIMessageEvent: !1, MIDIOutput: !1, MIDIOutputMap: !1, MIDIPort: !1, MimeType: !1, MimeTypeArray: !1, MouseEvent: !1, moveBy: !1, moveTo: !1, MutationEvent: !1, MutationObserver: !1, MutationRecord: !1, name: !1, NamedNodeMap: !1, NavigationPreloadManager: !1, navigator: !1, Navigator: !1, NetworkInformation: !1, Node: !1, NodeFilter: !1, NodeIterator: !1, NodeList: !1, Notification: !1, OfflineAudioCompletionEvent: !1, OfflineAudioContext: !1, offscreenBuffering: !1, OffscreenCanvas: !0, onabort: !0, onafterprint: !0, onanimationend: !0, onanimationiteration: !0, onanimationstart: !0, onappinstalled: !0, onauxclick: !0, onbeforeinstallprompt: !0, onbeforeprint: !0, onbeforeunload: !0, onblur: !0, oncancel: !0, oncanplay: !0, oncanplaythrough: !0, onchange: !0, onclick: !0, onclose: !0, oncontextmenu: !0, oncuechange: !0, ondblclick: !0, ondevicemotion: !0, ondeviceorientation: !0, ondeviceorientationabsolute: !0, ondrag: !0, ondragend: !0, ondragenter: !0, ondragleave: !0, ondragover: !0, ondragstart: !0, ondrop: !0, ondurationchange: !0, onemptied: !0, onended: !0, onerror: !0, onfocus: !0, ongotpointercapture: !0, onhashchange: !0, oninput: !0, oninvalid: !0, onkeydown: !0, onkeypress: !0, onkeyup: !0, onlanguagechange: !0, onload: !0, onloadeddata: !0, onloadedmetadata: !0, onloadstart: !0, onlostpointercapture: !0, onmessage: !0, onmessageerror: !0, onmousedown: !0, onmouseenter: !0, onmouseleave: !0, onmousemove: !0, onmouseout: !0, onmouseover: !0, onmouseup: !0, onmousewheel: !0, onoffline: !0, ononline: !0, onpagehide: !0, onpageshow: !0, onpause: !0, onplay: !0, onplaying: !0, onpointercancel: !0, onpointerdown: !0, onpointerenter: !0, onpointerleave: !0, onpointermove: !0, onpointerout: !0, onpointerover: !0, onpointerup: !0, onpopstate: !0, onprogress: !0, onratechange: !0, onrejectionhandled: !0, onreset: !0, onresize: !0, onscroll: !0, onsearch: !0, onseeked: !0, onseeking: !0, onselect: !0, onstalled: !0, onstorage: !0, onsubmit: !0, onsuspend: !0, ontimeupdate: !0, ontoggle: !0, ontransitionend: !0, onunhandledrejection: !0, onunload: !0, onvolumechange: !0, onwaiting: !0, onwheel: !0, open: !1, openDatabase: !1, opener: !1, Option: !1, origin: !1, OscillatorNode: !1, outerHeight: !1, outerWidth: !1, PageTransitionEvent: !1, pageXOffset: !1, pageYOffset: !1, PannerNode: !1, parent: !1, Path2D: !1, PaymentAddress: !1, PaymentRequest: !1, PaymentRequestUpdateEvent: !1, PaymentResponse: !1, performance: !1, Performance: !1, PerformanceEntry: !1, PerformanceLongTaskTiming: !1, PerformanceMark: !1, PerformanceMeasure: !1, PerformanceNavigation: !1, PerformanceNavigationTiming: !1, PerformanceObserver: !1, PerformanceObserverEntryList: !1, PerformancePaintTiming: !1, PerformanceResourceTiming: !1, PerformanceTiming: !1, PeriodicWave: !1, Permissions: !1, PermissionStatus: !1, personalbar: !1, PhotoCapabilities: !1, Plugin: !1, PluginArray: !1, PointerEvent: !1, PopStateEvent: !1, postMessage: !1, Presentation: !1, PresentationAvailability: !1, PresentationConnection: !1, PresentationConnectionAvailableEvent: !1, PresentationConnectionCloseEvent: !1, PresentationConnectionList: !1, PresentationReceiver: !1, PresentationRequest: !1, print: !1, ProcessingInstruction: !1, ProgressEvent: !1, PromiseRejectionEvent: !1, prompt: !1, PushManager: !1, PushSubscription: !1, PushSubscriptionOptions: !1, queueMicrotask: !1, RadioNodeList: !1, Range: !1, ReadableStream: !1, registerProcessor: !1, RemotePlayback: !1, removeEventListener: !1, Request: !1, requestAnimationFrame: !1, requestIdleCallback: !1, resizeBy: !1, ResizeObserver: !1, ResizeObserverEntry: !1, resizeTo: !1, Response: !1, RTCCertificate: !1, RTCDataChannel: !1, RTCDataChannelEvent: !1, RTCDtlsTransport: !1, RTCIceCandidate: !1, RTCIceGatherer: !1, RTCIceTransport: !1, RTCPeerConnection: !1, RTCPeerConnectionIceEvent: !1, RTCRtpContributingSource: !1, RTCRtpReceiver: !1, RTCRtpSender: !1, RTCSctpTransport: !1, RTCSessionDescription: !1, RTCStatsReport: !1, RTCTrackEvent: !1, screen: !1, Screen: !1, screenLeft: !1, ScreenOrientation: !1, screenTop: !1, screenX: !1, screenY: !1, ScriptProcessorNode: !1, scroll: !1, scrollbars: !1, scrollBy: !1, scrollTo: !1, scrollX: !1, scrollY: !1, SecurityPolicyViolationEvent: !1, Selection: !1, self: !1, ServiceWorker: !1, ServiceWorkerContainer: !1, ServiceWorkerRegistration: !1, sessionStorage: !1, setInterval: !1, setTimeout: !1, ShadowRoot: !1, SharedWorker: !1, SourceBuffer: !1, SourceBufferList: !1, speechSynthesis: !1, SpeechSynthesisEvent: !1, SpeechSynthesisUtterance: !1, StaticRange: !1, status: !1, statusbar: !1, StereoPannerNode: !1, stop: !1, Storage: !1, StorageEvent: !1, StorageManager: !1, styleMedia: !1, StyleSheet: !1, StyleSheetList: !1, SubtleCrypto: !1, SVGAElement: !1, SVGAngle: !1, SVGAnimatedAngle: !1, SVGAnimatedBoolean: !1, SVGAnimatedEnumeration: !1, SVGAnimatedInteger: !1, SVGAnimatedLength: !1, SVGAnimatedLengthList: !1, SVGAnimatedNumber: !1, SVGAnimatedNumberList: !1, SVGAnimatedPreserveAspectRatio: !1, SVGAnimatedRect: !1, SVGAnimatedString: !1, SVGAnimatedTransformList: !1, SVGAnimateElement: !1, SVGAnimateMotionElement: !1, SVGAnimateTransformElement: !1, SVGAnimationElement: !1, SVGCircleElement: !1, SVGClipPathElement: !1, SVGComponentTransferFunctionElement: !1, SVGDefsElement: !1, SVGDescElement: !1, SVGDiscardElement: !1, SVGElement: !1, SVGEllipseElement: !1, SVGFEBlendElement: !1, SVGFEColorMatrixElement: !1, SVGFEComponentTransferElement: !1, SVGFECompositeElement: !1, SVGFEConvolveMatrixElement: !1, SVGFEDiffuseLightingElement: !1, SVGFEDisplacementMapElement: !1, SVGFEDistantLightElement: !1, SVGFEDropShadowElement: !1, SVGFEFloodElement: !1, SVGFEFuncAElement: !1, SVGFEFuncBElement: !1, SVGFEFuncGElement: !1, SVGFEFuncRElement: !1, SVGFEGaussianBlurElement: !1, SVGFEImageElement: !1, SVGFEMergeElement: !1, SVGFEMergeNodeElement: !1, SVGFEMorphologyElement: !1, SVGFEOffsetElement: !1, SVGFEPointLightElement: !1, SVGFESpecularLightingElement: !1, SVGFESpotLightElement: !1, SVGFETileElement: !1, SVGFETurbulenceElement: !1, SVGFilterElement: !1, SVGForeignObjectElement: !1, SVGGElement: !1, SVGGeometryElement: !1, SVGGradientElement: !1, SVGGraphicsElement: !1, SVGImageElement: !1, SVGLength: !1, SVGLengthList: !1, SVGLinearGradientElement: !1, SVGLineElement: !1, SVGMarkerElement: !1, SVGMaskElement: !1, SVGMatrix: !1, SVGMetadataElement: !1, SVGMPathElement: !1, SVGNumber: !1, SVGNumberList: !1, SVGPathElement: !1, SVGPatternElement: !1, SVGPoint: !1, SVGPointList: !1, SVGPolygonElement: !1, SVGPolylineElement: !1, SVGPreserveAspectRatio: !1, SVGRadialGradientElement: !1, SVGRect: !1, SVGRectElement: !1, SVGScriptElement: !1, SVGSetElement: !1, SVGStopElement: !1, SVGStringList: !1, SVGStyleElement: !1, SVGSVGElement: !1, SVGSwitchElement: !1, SVGSymbolElement: !1, SVGTextContentElement: !1, SVGTextElement: !1, SVGTextPathElement: !1, SVGTextPositioningElement: !1, SVGTitleElement: !1, SVGTransform: !1, SVGTransformList: !1, SVGTSpanElement: !1, SVGUnitTypes: !1, SVGUseElement: !1, SVGViewElement: !1, TaskAttributionTiming: !1, Text: !1, TextDecoder: !1, TextEncoder: !1, TextEvent: !1, TextMetrics: !1, TextTrack: !1, TextTrackCue: !1, TextTrackCueList: !1, TextTrackList: !1, TimeRanges: !1, toolbar: !1, top: !1, Touch: !1, TouchEvent: !1, TouchList: !1, TrackEvent: !1, TransitionEvent: !1, TreeWalker: !1, UIEvent: !1, URL: !1, URLSearchParams: !1, ValidityState: !1, visualViewport: !1, VisualViewport: !1, VTTCue: !1, WaveShaperNode: !1, WebAssembly: !1, WebGL2RenderingContext: !1, WebGLActiveInfo: !1, WebGLBuffer: !1, WebGLContextEvent: !1, WebGLFramebuffer: !1, WebGLProgram: !1, WebGLQuery: !1, WebGLRenderbuffer: !1, WebGLRenderingContext: !1, WebGLSampler: !1, WebGLShader: !1, WebGLShaderPrecisionFormat: !1, WebGLSync: !1, WebGLTexture: !1, WebGLTransformFeedback: !1, WebGLUniformLocation: !1, WebGLVertexArrayObject: !1, WebSocket: !1, WheelEvent: !1, window: !1, Window: !1, Worker: !1, WritableStream: !1, XMLDocument: !1, XMLHttpRequest: !1, XMLHttpRequestEventTarget: !1, XMLHttpRequestUpload: !1, XMLSerializer: !1, XPathEvaluator: !1, XPathExpression: !1, XPathResult: !1, XSLTProcessor: !1 }, Pk = { addEventListener: !1, applicationCache: !1, atob: !1, Blob: !1, BroadcastChannel: !1, btoa: !1, Cache: !1, caches: !1, clearInterval: !1, clearTimeout: !1, close: !0, console: !1, fetch: !1, FileReaderSync: !1, FormData: !1, Headers: !1, IDBCursor: !1, IDBCursorWithValue: !1, IDBDatabase: !1, IDBFactory: !1, IDBIndex: !1, IDBKeyRange: !1, IDBObjectStore: !1, IDBOpenDBRequest: !1, IDBRequest: !1, IDBTransaction: !1, IDBVersionChangeEvent: !1, ImageData: !1, importScripts: !0, indexedDB: !1, location: !1, MessageChannel: !1, MessagePort: !1, name: !1, navigator: !1, Notification: !1, onclose: !0, onconnect: !0, onerror: !0, onlanguagechange: !0, onmessage: !0, onoffline: !0, ononline: !0, onrejectionhandled: !0, onunhandledrejection: !0, performance: !1, Performance: !1, PerformanceEntry: !1, PerformanceMark: !1, PerformanceMeasure: !1, PerformanceNavigation: !1, PerformanceResourceTiming: !1, PerformanceTiming: !1, postMessage: !0, Promise: !1, queueMicrotask: !1, removeEventListener: !1, Request: !1, Response: !1, self: !0, ServiceWorkerRegistration: !1, setInterval: !1, setTimeout: !1, TextDecoder: !1, TextEncoder: !1, URL: !1, URLSearchParams: !1, WebSocket: !1, Worker: !1, WorkerGlobalScope: !1, XMLHttpRequest: !1 }, Ik = { __dirname: !1, __filename: !1, Buffer: !1, clearImmediate: !1, clearInterval: !1, clearTimeout: !1, console: !1, exports: !0, global: !1, Intl: !1, module: !1, process: !1, queueMicrotask: !1, require: !1, setImmediate: !1, setInterval: !1, setTimeout: !1, TextDecoder: !1, TextEncoder: !1, URL: !1, URLSearchParams: !1 }, Bk = { exports: !0, global: !1, module: !1, require: !1 }, Ok = { define: !1, require: !1 }, Lk = { after: !1, afterEach: !1, before: !1, beforeEach: !1, context: !1, describe: !1, it: !1, mocha: !1, run: !1, setup: !1, specify: !1, suite: !1, suiteSetup: !1, suiteTeardown: !1, teardown: !1, test: !1, xcontext: !1, xdescribe: !1, xit: !1, xspecify: !1 }, Nk = { afterAll: !1, afterEach: !1, beforeAll: !1, beforeEach: !1, describe: !1, expect: !1, expectAsync: !1, fail: !1, fdescribe: !1, fit: !1, it: !1, jasmine: !1, pending: !1, runs: !1, spyOn: !1, spyOnAllFunctions: !1, spyOnProperty: !1, waits: !1, waitsFor: !1, xdescribe: !1, xit: !1 }, jk = { afterAll: !1, afterEach: !1, beforeAll: !1, beforeEach: !1, describe: !1, expect: !1, fdescribe: !1, fit: !1, it: !1, jest: !1, pit: !1, require: !1, test: !1, xdescribe: !1, xit: !1, xtest: !1 }, Rk = { asyncTest: !1, deepEqual: !1, equal: !1, expect: !1, module: !1, notDeepEqual: !1, notEqual: !1, notOk: !1, notPropEqual: !1, notStrictEqual: !1, ok: !1, propEqual: !1, QUnit: !1, raises: !1, start: !1, stop: !1, strictEqual: !1, test: !1, throws: !1 }, Mk = { console: !0, exports: !0, phantom: !0, require: !0, WebPage: !0 }, Vk = { emit: !1, exports: !1, getRow: !1, log: !1, module: !1, provides: !1, require: !1, respond: !1, send: !1, start: !1, sum: !1 }, Uk = { defineClass: !1, deserialize: !1, gc: !1, help: !1, importClass: !1, importPackage: !1, java: !1, load: !1, loadClass: !1, Packages: !1, print: !1, quit: !1, readFile: !1, readUrl: !1, runCommand: !1, seal: !1, serialize: !1, spawn: !1, sync: !1, toint32: !1, version: !1 }, qk = { __DIR__: !1, __FILE__: !1, __LINE__: !1, com: !1, edu: !1, exit: !1, java: !1, Java: !1, javafx: !1, JavaImporter: !1, javax: !1, JSAdapter: !1, load: !1, loadWithNewGlobal: !1, org: !1, Packages: !1, print: !1, quit: !1 }, Wk = { ActiveXObject: !0, CollectGarbage: !0, Debug: !0, Enumerator: !0, GetObject: !0, RuntimeObject: !0, ScriptEngine: !0, ScriptEngineBuildVersion: !0, ScriptEngineMajorVersion: !0, ScriptEngineMinorVersion: !0, VBArray: !0, WScript: !0, WSH: !0, XDomainRequest: !0 }, $k = { $: !1, jQuery: !1 }, Gk = { YAHOO: !1, YAHOO_config: !1, YUI: !1, YUI_config: !1 }, zk = { cat: !1, cd: !1, chmod: !1, config: !1, cp: !1, dirs: !1, echo: !1, env: !1, error: !1, exec: !1, exit: !1, find: !1, grep: !1, ln: !1, ls: !1, mkdir: !1, mv: !1, popd: !1, pushd: !1, pwd: !1, rm: !1, sed: !1, set: !1, target: !1, tempdir: !1, test: !1, touch: !1, which: !1 }, Hk = { $: !1, $$: !1, $A: !1, $break: !1, $continue: !1, $F: !1, $H: !1, $R: !1, $w: !1, Abstract: !1, Ajax: !1, Autocompleter: !1, Builder: !1, Class: !1, Control: !1, Draggable: !1, Draggables: !1, Droppables: !1, Effect: !1, Element: !1, Enumerable: !1, Event: !1, Field: !1, Form: !1, Hash: !1, Insertion: !1, ObjectRange: !1, PeriodicalExecuter: !1, Position: !1, Prototype: !1, Scriptaculous: !1, Selector: !1, Sortable: !1, SortableObserver: !1, Sound: !1, Template: !1, Toggle: !1, Try: !1 }, Kk = { _: !1, $: !1, Accounts: !1, AccountsClient: !1, AccountsCommon: !1, AccountsServer: !1, App: !1, Assets: !1, Blaze: !1, check: !1, Cordova: !1, DDP: !1, DDPRateLimiter: !1, DDPServer: !1, Deps: !1, EJSON: !1, Email: !1, HTTP: !1, Log: !1, Match: !1, Meteor: !1, Mongo: !1, MongoInternals: !1, Npm: !1, Package: !1, Plugin: !1, process: !1, Random: !1, ReactiveDict: !1, ReactiveVar: !1, Router: !1, ServiceConfiguration: !1, Session: !1, share: !1, Spacebars: !1, Template: !1, Tinytest: !1, Tracker: !1, UI: !1, Utils: !1, WebApp: !1, WebAppInternals: !1 }, Jk = { _isWindows: !1, _rand: !1, BulkWriteResult: !1, cat: !1, cd: !1, connect: !1, db: !1, getHostName: !1, getMemInfo: !1, hostname: !1, ISODate: !1, listFiles: !1, load: !1, ls: !1, md5sumFile: !1, mkdir: !1, Mongo: !1, NumberInt: !1, NumberLong: !1, ObjectId: !1, PlanCache: !1, print: !1, printjson: !1, pwd: !1, quit: !1, removeFile: !1, rs: !1, sh: !1, UUID: !1, version: !1, WriteResult: !1 }, Qk = { $: !1, Application: !1, Automation: !1, console: !1, delay: !1, Library: !1, ObjC: !1, ObjectSpecifier: !1, Path: !1, Progress: !1, Ref: !1 }, Xk = { addEventListener: !1, applicationCache: !1, atob: !1, Blob: !1, BroadcastChannel: !1, btoa: !1, Cache: !1, caches: !1, CacheStorage: !1, clearInterval: !1, clearTimeout: !1, Client: !1, clients: !1, Clients: !1, close: !0, console: !1, ExtendableEvent: !1, ExtendableMessageEvent: !1, fetch: !1, FetchEvent: !1, FileReaderSync: !1, FormData: !1, Headers: !1, IDBCursor: !1, IDBCursorWithValue: !1, IDBDatabase: !1, IDBFactory: !1, IDBIndex: !1, IDBKeyRange: !1, IDBObjectStore: !1, IDBOpenDBRequest: !1, IDBRequest: !1, IDBTransaction: !1, IDBVersionChangeEvent: !1, ImageData: !1, importScripts: !1, indexedDB: !1, location: !1, MessageChannel: !1, MessagePort: !1, name: !1, navigator: !1, Notification: !1, onclose: !0, onconnect: !0, onerror: !0, onfetch: !0, oninstall: !0, onlanguagechange: !0, onmessage: !0, onmessageerror: !0, onnotificationclick: !0, onnotificationclose: !0, onoffline: !0, ononline: !0, onpush: !0, onpushsubscriptionchange: !0, onrejectionhandled: !0, onsync: !0, onunhandledrejection: !0, performance: !1, Performance: !1, PerformanceEntry: !1, PerformanceMark: !1, PerformanceMeasure: !1, PerformanceNavigation: !1, PerformanceResourceTiming: !1, PerformanceTiming: !1, postMessage: !0, Promise: !1, queueMicrotask: !1, registration: !1, removeEventListener: !1, Request: !1, Response: !1, self: !1, ServiceWorker: !1, ServiceWorkerContainer: !1, ServiceWorkerGlobalScope: !1, ServiceWorkerMessageEvent: !1, ServiceWorkerRegistration: !1, setInterval: !1, setTimeout: !1, skipWaiting: !1, TextDecoder: !1, TextEncoder: !1, URL: !1, URLSearchParams: !1, WebSocket: !1, WindowClient: !1, Worker: !1, WorkerGlobalScope: !1, XMLHttpRequest: !1 }, Yk = { advanceClock: !1, fakeClearInterval: !1, fakeClearTimeout: !1, fakeSetInterval: !1, fakeSetTimeout: !1, resetTimeouts: !1, waitsForPromise: !1 }, Zk = { andThen: !1, click: !1, currentPath: !1, currentRouteName: !1, currentURL: !1, fillIn: !1, find: !1, findAll: !1, findWithAssert: !1, keyEvent: !1, pauseTest: !1, resumeTest: !1, triggerEvent: !1, visit: !1, wait: !1 }, eD = { $: !1, $$: !1, browser: !1, by: !1, By: !1, DartObject: !1, element: !1, protractor: !1 }, tD = { browser: !1, chrome: !1, opr: !1 }, nD = { cloneInto: !1, createObjectIn: !1, exportFunction: !1, GM: !1, GM_addStyle: !1, GM_deleteValue: !1, GM_getResourceText: !1, GM_getResourceURL: !1, GM_getValue: !1, GM_info: !1, GM_listValues: !1, GM_log: !1, GM_openInTab: !1, GM_registerMenuCommand: !1, GM_setClipboard: !1, GM_setValue: !1, GM_xmlhttpRequest: !1, unsafeWindow: !1 }, rD = { $: !1, $_: !1, $$: !1, $0: !1, $1: !1, $2: !1, $3: !1, $4: !1, $x: !1, chrome: !1, clear: !1, copy: !1, debug: !1, dir: !1, dirxml: !1, getEventListeners: !1, inspect: !1, keys: !1, monitor: !1, monitorEvents: !1, profile: !1, profileEnd: !1, queryObjects: !1, table: !1, undebug: !1, unmonitor: !1, unmonitorEvents: !1, values: !1 }, i8 = { builtin: Fk, es5: wk, es2015: Ak, es2017: _k, browser: Tk, worker: Pk, node: Ik, commonjs: Bk, amd: Ok, mocha: Lk, jasmine: Nk, jest: jk, qunit: Rk, phantomjs: Mk, couch: Vk, rhino: Uk, nashorn: qk, wsh: Wk, jquery: $k, yui: Gk, shelljs: zk, prototypejs: Hk, meteor: Kk, mongo: Jk, applescript: Qk, serviceworker: Xk, atomtest: Yk, embertest: Zk, protractor: eD, "shared-node-browser": { clearInterval: !1, clearTimeout: !1, console: !1, setInterval: !1, setTimeout: !1, URL: !1, URLSearchParams: !1 }, webextensions: tD, greasemonkey: nD, devtools: rD }, a8 = Cr(Object.freeze({ __proto__: null, builtin: Fk, es5: wk, es2015: Ak, es2017: _k, browser: Tk, worker: Pk, node: Ik, commonjs: Bk, amd: Ok, mocha: Lk, jasmine: Nk, jest: jk, qunit: Rk, phantomjs: Mk, couch: Vk, rhino: Uk, nashorn: qk, wsh: Wk, jquery: $k, yui: Gk, shelljs: zk, prototypejs: Hk, meteor: Kk, mongo: Jk, applescript: Qk, serviceworker: Xk, atomtest: Yk, embertest: Zk, protractor: eD, webextensions: tD, greasemonkey: nD, devtools: rD, default: i8 })), ms = 1e3, gs = 60 * ms, ys = 60 * gs, To = 24 * ys, o8 = 7 * To, s8 = 365.25 * To, u8 = function(e, t) {
  t = t || {};
  var n = xe(e);
  if (n === "string" && e.length > 0)
    return function(r) {
      if (!((r = String(r)).length > 100)) {
        var i = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(r);
        if (i) {
          var a = parseFloat(i[1]);
          switch ((i[2] || "ms").toLowerCase()) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return a * s8;
            case "weeks":
            case "week":
            case "w":
              return a * o8;
            case "days":
            case "day":
            case "d":
              return a * To;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return a * ys;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return a * gs;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return a * ms;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return a;
            default:
              return;
          }
        }
      }
    }(e);
  if (n === "number" && isFinite(e))
    return t.long ? function(r) {
      var i = Math.abs(r);
      return i >= To ? Vl(r, i, To, "day") : i >= ys ? Vl(r, i, ys, "hour") : i >= gs ? Vl(r, i, gs, "minute") : i >= ms ? Vl(r, i, ms, "second") : r + " ms";
    }(e) : function(r) {
      var i = Math.abs(r);
      return i >= To ? Math.round(r / To) + "d" : i >= ys ? Math.round(r / ys) + "h" : i >= gs ? Math.round(r / gs) + "m" : i >= ms ? Math.round(r / ms) + "s" : r + "ms";
    }(e);
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
};
function Vl(e, t, n, r) {
  var i = t >= 1.5 * n;
  return Math.round(e / n) + " " + r + (i ? "s" : "");
}
var c8 = function(e) {
  function t(s) {
    for (var o = 0, u = 0; u < s.length; u++)
      o = (o << 5) - o + s.charCodeAt(u), o |= 0;
    return n.colors[Math.abs(o) % n.colors.length];
  }
  function n(s) {
    var o;
    function u() {
      for (var c = arguments.length, f = new Array(c), p = 0; p < c; p++)
        f[p] = arguments[p];
      if (u.enabled) {
        var d = u, m = Number(/* @__PURE__ */ new Date()), y = m - (o || m);
        d.diff = y, d.prev = o, d.curr = m, o = m, f[0] = n.coerce(f[0]), typeof f[0] != "string" && f.unshift("%O");
        var v = 0;
        f[0] = f[0].replace(/%([a-zA-Z%])/g, function(b, x) {
          if (b === "%%")
            return b;
          v++;
          var C = n.formatters[x];
          if (typeof C == "function") {
            var k = f[v];
            b = C.call(d, k), f.splice(v, 1), v--;
          }
          return b;
        }), n.formatArgs.call(d, f), (d.log || n.log).apply(d, f);
      }
    }
    return u.namespace = s, u.enabled = n.enabled(s), u.useColors = n.useColors(), u.color = t(s), u.destroy = r, u.extend = i, typeof n.init == "function" && n.init(u), n.instances.push(u), u;
  }
  function r() {
    var s = n.instances.indexOf(this);
    return s !== -1 && (n.instances.splice(s, 1), !0);
  }
  function i(s, o) {
    var u = n(this.namespace + (o === void 0 ? ":" : o) + s);
    return u.log = this.log, u;
  }
  function a(s) {
    return s.toString().substring(2, s.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  return n.debug = n, n.default = n, n.coerce = function(s) {
    return s instanceof Error ? s.stack || s.message : s;
  }, n.disable = function() {
    var s = [].concat(Mt(n.names.map(a)), Mt(n.skips.map(a).map(function(o) {
      return "-" + o;
    }))).join(",");
    return n.enable(""), s;
  }, n.enable = function(s) {
    var o;
    n.save(s), n.names = [], n.skips = [];
    var u = (typeof s == "string" ? s : "").split(/[\s,]+/), c = u.length;
    for (o = 0; o < c; o++)
      u[o] && ((s = u[o].replace(/\*/g, ".*?"))[0] === "-" ? n.skips.push(new RegExp("^" + s.substr(1) + "$")) : n.names.push(new RegExp("^" + s + "$")));
    for (o = 0; o < n.instances.length; o++) {
      var f = n.instances[o];
      f.enabled = n.enabled(f.namespace);
    }
  }, n.enabled = function(s) {
    if (s[s.length - 1] === "*")
      return !0;
    var o, u;
    for (o = 0, u = n.skips.length; o < u; o++)
      if (n.skips[o].test(s))
        return !1;
    for (o = 0, u = n.names.length; o < u; o++)
      if (n.names[o].test(s))
        return !0;
    return !1;
  }, n.humanize = u8, Object.keys(e).forEach(function(s) {
    n[s] = e[s];
  }), n.instances = [], n.names = [], n.skips = [], n.formatters = {}, n.selectColor = t, n.enable(n.load()), n;
}, Ka = gt(function(e, t) {
  t.log = function() {
    var n;
    return (typeof console > "u" ? "undefined" : xe(console)) === "object" && console.log && (n = console).log.apply(n, arguments);
  }, t.formatArgs = function(n) {
    if (n[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + n[0] + (this.useColors ? "%c " : " ") + "+" + e.exports.humanize(this.diff), !!this.useColors) {
      var r = "color: " + this.color;
      n.splice(1, 0, r, "color: inherit");
      var i = 0, a = 0;
      n[0].replace(/%[a-zA-Z%]/g, function(s) {
        s !== "%%" && (i++, s === "%c" && (a = i));
      }), n.splice(a, 0, r);
    }
  }, t.save = function(n) {
    try {
      n ? t.storage.setItem("debug", n) : t.storage.removeItem("debug");
    } catch {
    }
  }, t.load = function() {
    var n;
    try {
      n = t.storage.getItem("debug");
    } catch {
    }
    return !n && typeof process < "u" && "env" in process && (n = process.env.DEBUG), n;
  }, t.useColors = function() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, t.storage = function() {
    try {
      return localStorage;
    } catch {
    }
  }(), t.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.exports = c8(t), e.exports.formatters.j = function(n) {
    try {
      return JSON.stringify(n);
    } catch (r) {
      return "[UnexpectedJSONParseError]: " + r.message;
    }
  };
});
Ka.log, Ka.formatArgs, Ka.save, Ka.load, Ka.useColors, Ka.storage, Ka.colors;
function H0(e, t) {
  var n = t.range[0], r = e, i = !1;
  do {
    i = !1;
    var a = !0, s = !1, o = void 0;
    try {
      for (var u, c = r.childScopes[Symbol.iterator](); !(a = (u = c.next()).done); a = !0) {
        var f = u.value, p = f.block.range;
        if (p[0] <= n && n < p[1]) {
          r = f, i = !0;
          break;
        }
      }
    } catch (d) {
      s = !0, o = d;
    } finally {
      try {
        a || c.return == null || c.return();
      } finally {
        if (s)
          throw o;
      }
    }
  } while (i);
  return r;
}
function Ps(e, t) {
  var n = "", r = e;
  for (typeof t == "string" ? n = t : (n = t.name, r = H0(r, t)); r != null; ) {
    var i = r.set.get(n);
    if (i != null)
      return i;
    r = r.upper;
  }
  return null;
}
function l8(e) {
  return !this(e);
}
function Di(e) {
  return l8.bind(e);
}
function gf(e) {
  return e.value === "=>" && e.type === "Punctuator";
}
function K0(e) {
  return e.value === "," && e.type === "Punctuator";
}
function J0(e) {
  return e.value === ";" && e.type === "Punctuator";
}
function Q0(e) {
  return e.value === ":" && e.type === "Punctuator";
}
function ro(e) {
  return e.value === "(" && e.type === "Punctuator";
}
function yf(e) {
  return e.value === ")" && e.type === "Punctuator";
}
function X0(e) {
  return e.value === "[" && e.type === "Punctuator";
}
function Y0(e) {
  return e.value === "]" && e.type === "Punctuator";
}
function Z0(e) {
  return e.value === "{" && e.type === "Punctuator";
}
function eg(e) {
  return e.value === "}" && e.type === "Punctuator";
}
function tg(e) {
  return e.type === "Line" || e.type === "Block" || e.type === "Shebang";
}
var iD = Di(gf), aD = Di(K0), oD = Di(J0), sD = Di(Q0), uD = Di(ro), cD = Di(yf), lD = Di(X0), pD = Di(Y0), fD = Di(Z0), hD = Di(eg), dD = Di(tg);
function Ox(e, t) {
  return e.id ? t.getTokenAfter(e.id, ro) : t.getFirstToken(e, ro);
}
function mD(e, t) {
  var n = e.parent, r = null, i = null;
  if (e.type === "ArrowFunctionExpression") {
    var a = t.getTokenBefore(e.body, gf);
    r = a.loc.start, i = a.loc.end;
  } else
    n.type === "Property" || n.type === "MethodDefinition" ? (r = n.loc.start, i = Ox(e, t).loc.start) : (r = e.loc.start, i = Ox(e, t).loc.start);
  return { start: Object.assign({}, r), end: Object.assign({}, i) };
}
var Lx = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {}, p8 = Object.freeze(/* @__PURE__ */ new Set(["Array", "ArrayBuffer", "BigInt", "BigInt64Array", "BigUint64Array", "Boolean", "DataView", "Date", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "Float32Array", "Float64Array", "Function", "Infinity", "Int16Array", "Int32Array", "Int8Array", "isFinite", "isNaN", "isPrototypeOf", "JSON", "Map", "Math", "NaN", "Number", "Object", "parseFloat", "parseInt", "Promise", "Proxy", "Reflect", "RegExp", "Set", "String", "Symbol", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray", "undefined", "unescape", "WeakMap", "WeakSet"])), Ad = new Set([Array.isArray, typeof BigInt == "function" ? BigInt : void 0, Boolean, Date, Date.parse, decodeURI, decodeURIComponent, encodeURI, encodeURIComponent, escape, isFinite, isNaN, isPrototypeOf].concat(Mt(Object.getOwnPropertyNames(Math).map(function(e) {
  return Math[e];
}).filter(function(e) {
  return typeof e == "function";
})), [Number, Number.isFinite, Number.isNaN, Number.parseFloat, Number.parseInt, Object, Object.entries, Object.is, Object.isExtensible, Object.isFrozen, Object.isSealed, Object.keys, Object.values, parseFloat, parseInt, RegExp, String, String.fromCharCode, String.fromCodePoint, String.raw, Symbol, Symbol.for, Symbol.keyFor, unescape]).filter(function(e) {
  return typeof e == "function";
})), Nx = /* @__PURE__ */ new Set([Object.freeze, Object.preventExtensions, Object.seal]);
function f8(e, t) {
  var n = function(r, i) {
    for (var a = r; (xe(a) === "object" || typeof a == "function") && a !== null; ) {
      var s = Object.getOwnPropertyDescriptor(a, i);
      if (s)
        return s;
      a = Object.getPrototypeOf(a);
    }
    return null;
  }(e, t);
  return n != null && n.get != null;
}
function Fu(e, t) {
  for (var n = [], r = 0; r < e.length; ++r) {
    var i = e[r];
    if (i == null)
      n.length = r + 1;
    else if (i.type === "SpreadElement") {
      var a = nn(i.argument, t);
      if (a == null)
        return null;
      n.push.apply(n, Mt(a.value));
    } else {
      var s = nn(i, t);
      if (s == null)
        return null;
      n.push(s.value);
    }
  }
  return n;
}
var jx = Object.freeze({ ArrayExpression: function(e, t) {
  var n = Fu(e.elements, t);
  return n != null ? { value: n } : null;
}, AssignmentExpression: function(e, t) {
  return e.operator === "=" ? nn(e.right, t) : null;
}, BinaryExpression: function(e, t) {
  if (e.operator === "in" || e.operator === "instanceof")
    return null;
  var n = nn(e.left, t), r = nn(e.right, t);
  if (n != null && r != null)
    switch (e.operator) {
      case "==":
        return { value: n.value == r.value };
      case "!=":
        return { value: n.value != r.value };
      case "===":
        return { value: n.value === r.value };
      case "!==":
        return { value: n.value !== r.value };
      case "<":
        return { value: n.value < r.value };
      case "<=":
        return { value: n.value <= r.value };
      case ">":
        return { value: n.value > r.value };
      case ">=":
        return { value: n.value >= r.value };
      case "<<":
        return { value: n.value << r.value };
      case ">>":
        return { value: n.value >> r.value };
      case ">>>":
        return { value: n.value >>> r.value };
      case "+":
        return { value: n.value + r.value };
      case "-":
        return { value: n.value - r.value };
      case "*":
        return { value: n.value * r.value };
      case "/":
        return { value: n.value / r.value };
      case "%":
        return { value: n.value % r.value };
      case "**":
        return { value: Math.pow(n.value, r.value) };
      case "|":
        return { value: n.value | r.value };
      case "^":
        return { value: n.value ^ r.value };
      case "&":
        return { value: n.value & r.value };
    }
  return null;
}, CallExpression: function(e, t) {
  var n = e.callee, r = Fu(e.arguments, t);
  if (r != null)
    if (n.type === "MemberExpression") {
      var i = nn(n.object, t), a = n.computed ? nn(n.property, t) : { value: n.property.name };
      if (i != null && a != null) {
        var s = i.value, o = a.value;
        if (Ad.has(s[o]))
          return { value: s[o].apply(s, Mt(r)) };
        if (Nx.has(s[o]))
          return { value: r[0] };
      }
    } else {
      var u = nn(n, t);
      if (u != null) {
        var c = u.value;
        if (Ad.has(c))
          return { value: c.apply(void 0, Mt(r)) };
        if (Nx.has(c))
          return { value: r[0] };
      }
    }
  return null;
}, ConditionalExpression: function(e, t) {
  var n = nn(e.test, t);
  return n != null ? n.value ? nn(e.consequent, t) : nn(e.alternate, t) : null;
}, ExpressionStatement: function(e, t) {
  return nn(e.expression, t);
}, Identifier: function(e, t) {
  if (t != null) {
    var n = Ps(t, e);
    if (n != null && n.defs.length === 0 && p8.has(n.name) && n.name in Lx)
      return { value: Lx[n.name] };
    if (n != null && n.defs.length === 1) {
      var r = n.defs[0];
      if (r.parent && r.parent.kind === "const" && r.node.id.type === "Identifier")
        return nn(r.node.init, t);
    }
  }
  return null;
}, Literal: function(e) {
  return e.regex == null && e.bigint == null || e.value != null ? { value: e.value } : null;
}, LogicalExpression: function(e, t) {
  var n = nn(e.left, t);
  if (n != null) {
    if (e.operator === "||" && n.value || e.operator === "&&" && !n.value)
      return n;
    var r = nn(e.right, t);
    if (r != null)
      return r;
  }
  return null;
}, MemberExpression: function(e, t) {
  var n = nn(e.object, t), r = e.computed ? nn(e.property, t) : { value: e.property.name };
  return n == null || r == null || f8(n.value, r.value) ? null : { value: n.value[r.value] };
}, NewExpression: function(e, t) {
  var n = nn(e.callee, t), r = Fu(e.arguments, t);
  if (n != null && r != null) {
    var i = n.value;
    if (Ad.has(i))
      return { value: g0(i, Mt(r)) };
  }
  return null;
}, ObjectExpression: function(e, t) {
  var n = {}, r = !0, i = !1, a = void 0;
  try {
    for (var s, o = e.properties[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
      var u = s.value;
      if (u.type === "Property") {
        if (u.kind !== "init")
          return null;
        var c = u.computed ? nn(u.key, t) : { value: u.key.name }, f = nn(u.value, t);
        if (c == null || f == null)
          return null;
        n[c.value] = f.value;
      } else {
        if (u.type !== "SpreadElement" && u.type !== "ExperimentalSpreadProperty")
          return null;
        var p = nn(u.argument, t);
        if (p == null)
          return null;
        Object.assign(n, p.value);
      }
    }
  } catch (d) {
    i = !0, a = d;
  } finally {
    try {
      r || o.return == null || o.return();
    } finally {
      if (i)
        throw a;
    }
  }
  return { value: n };
}, SequenceExpression: function(e, t) {
  return nn(e.expressions[e.expressions.length - 1], t);
}, TaggedTemplateExpression: function(e, t) {
  var n = nn(e.tag, t), r = Fu(e.quasi.expressions, t);
  if (n != null && r != null) {
    var i = n.value, a = e.quasi.quasis.map(function(s) {
      return s.value.cooked;
    });
    if (a.raw = e.quasi.quasis.map(function(s) {
      return s.value.raw;
    }), i === String.raw)
      return { value: i.apply(void 0, [a].concat(Mt(r))) };
  }
  return null;
}, TemplateLiteral: function(e, t) {
  var n = Fu(e.expressions, t);
  if (n != null) {
    for (var r = e.quasis[0].value.cooked, i = 0; i < n.length; ++i)
      r += n[i], r += e.quasis[i + 1].value.cooked;
    return { value: r };
  }
  return null;
}, UnaryExpression: function(e, t) {
  if (e.operator === "delete")
    return null;
  if (e.operator === "void")
    return { value: void 0 };
  var n = nn(e.argument, t);
  if (n != null)
    switch (e.operator) {
      case "-":
        return { value: -n.value };
      case "+":
        return { value: +n.value };
      case "!":
        return { value: !n.value };
      case "~":
        return { value: ~n.value };
      case "typeof":
        return { value: xe(n.value) };
    }
  return null;
} });
function nn(e, t) {
  return e != null && Object.hasOwnProperty.call(jx, e.type) ? jx[e.type](e, t) : null;
}
function ng(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  try {
    return nn(e, t);
  } catch {
    return null;
  }
}
function hc(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (e && e.type === "Literal" && e.value === null) {
    if (e.regex)
      return "/".concat(e.regex.pattern, "/").concat(e.regex.flags);
    if (e.bigint)
      return e.bigint;
  }
  var n = ng(e, t);
  return n && String(n.value);
}
function dc(e, t) {
  switch (e.type) {
    case "MemberExpression":
      return e.computed ? hc(e.property, t) : e.property.name;
    case "Property":
    case "MethodDefinition":
      return e.computed ? hc(e.key, t) : e.key.type === "Literal" ? String(e.key.value) : e.key.name;
  }
  return null;
}
function gD(e) {
  var t = e.parent, n = [];
  if (t.type === "MethodDefinition" && t.static && n.push("static"), e.async && n.push("async"), e.generator && n.push("generator"), e.type === "ArrowFunctionExpression")
    n.push("arrow", "function");
  else if (t.type === "Property" || t.type === "MethodDefinition") {
    if (t.kind === "constructor")
      return "constructor";
    t.kind === "get" ? n.push("getter") : t.kind === "set" ? n.push("setter") : n.push("method");
  } else
    n.push("function");
  if (e.id)
    n.push("'".concat(e.id.name, "'"));
  else {
    var r = dc(t);
    r && n.push("'".concat(r, "'"));
  }
  return n.join(" ");
}
var h8 = Object.freeze(/* @__PURE__ */ new Set(["==", "!=", "<", "<=", ">", ">=", "<<", ">>", ">>>", "+", "-", "*", "/", "%", "|", "^", "&", "in"])), d8 = Object.freeze(/* @__PURE__ */ new Set(["-", "+", "!", "~"])), m8 = Object.freeze(Object.assign(/* @__PURE__ */ Object.create(null), { $visit: function(e, t, n) {
  var r = e.type;
  return typeof this[r] == "function" ? this[r](e, t, n) : this.$visitChildren(e, t, n);
}, $visitChildren: function(e, t, n) {
  var r = e.type, i = !0, a = !1, s = void 0;
  try {
    for (var o, u = (n[r] || pf.getKeys(e))[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
      var c = e[o.value];
      if (Array.isArray(c)) {
        var f = !0, p = !1, d = void 0;
        try {
          for (var m, y = c[Symbol.iterator](); !(f = (m = y.next()).done); f = !0) {
            var v = m.value;
            if (v && this.$visit(v, t, n))
              return !0;
          }
        } catch (b) {
          p = !0, d = b;
        } finally {
          try {
            f || y.return == null || y.return();
          } finally {
            if (p)
              throw d;
          }
        }
      } else if (c && this.$visit(c, t, n))
        return !0;
    }
  } catch (b) {
    a = !0, s = b;
  } finally {
    try {
      i || u.return == null || u.return();
    } finally {
      if (a)
        throw s;
    }
  }
  return !1;
}, ArrowFunctionExpression: function() {
  return !1;
}, AssignmentExpression: function() {
  return !0;
}, AwaitExpression: function() {
  return !0;
}, BinaryExpression: function(e, t, n) {
  return !(!t.considerImplicitTypeConversion || !h8.has(e.operator) || e.left.type === "Literal" && e.right.type === "Literal") || this.$visitChildren(e, t, n);
}, CallExpression: function() {
  return !0;
}, FunctionExpression: function() {
  return !1;
}, ImportExpression: function() {
  return !0;
}, MemberExpression: function(e, t, n) {
  return !!t.considerGetters || !(!t.considerImplicitTypeConversion || !e.computed || e.property.type === "Literal") || this.$visitChildren(e, t, n);
}, MethodDefinition: function(e, t, n) {
  return !(!t.considerImplicitTypeConversion || !e.computed || e.key.type === "Literal") || this.$visitChildren(e, t, n);
}, NewExpression: function() {
  return !0;
}, Property: function(e, t, n) {
  return !(!t.considerImplicitTypeConversion || !e.computed || e.key.type === "Literal") || this.$visitChildren(e, t, n);
}, UnaryExpression: function(e, t, n) {
  return e.operator === "delete" || !(!t.considerImplicitTypeConversion || !d8.has(e.operator) || e.argument.type === "Literal") || this.$visitChildren(e, t, n);
}, UpdateExpression: function() {
  return !0;
}, YieldExpression: function() {
  return !0;
} }));
function yD(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.considerGetters, i = r !== void 0 && r, a = n.considerImplicitTypeConversion, s = a !== void 0 && a;
  return m8.$visit(e, { considerGetters: i, considerImplicitTypeConversion: s }, t.visitorKeys || pf.KEYS);
}
function g8(e, t) {
  var n = e.parent;
  switch (n.type) {
    case "CallExpression":
    case "NewExpression":
      return n.arguments.length === 1 && n.arguments[0] === e ? t.getTokenAfter(n.callee, ro) : null;
    case "DoWhileStatement":
      return n.test === e ? t.getTokenAfter(n.body, ro) : null;
    case "IfStatement":
    case "WhileStatement":
      return n.test === e ? t.getFirstToken(n, 1) : null;
    case "ImportExpression":
      return n.source === e ? t.getFirstToken(n, 1) : null;
    case "SwitchStatement":
      return n.discriminant === e ? t.getFirstToken(n, 1) : null;
    case "WithStatement":
      return n.object === e ? t.getFirstToken(n, 1) : null;
    default:
      return null;
  }
}
function vD(e, t, n) {
  var r, i, a, s, o;
  if (typeof e == "number") {
    if (i = t, a = n, !((r = 0 | e) >= 1))
      throw new TypeError("'times' should be a positive integer.");
  } else
    r = 1, i = e, a = t;
  if (i == null)
    return !1;
  s = o = i;
  do
    s = a.getTokenBefore(s), o = a.getTokenAfter(o);
  while (s != null && o != null && ro(s) && yf(o) && s !== g8(i, a) && --r > 0);
  return r === 0;
}
var y8 = /\$(?:[\$&'`]|[1-9][0-9]?)/g, Rx = /* @__PURE__ */ new WeakMap();
function v8(e, t) {
  for (var n = !1, r = t - 1; r >= 0 && e.charCodeAt(r) === 92; --r)
    n = !n;
  return n;
}
var xD = function() {
  function e(t) {
    var n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).escaped, r = n !== void 0 && n;
    if (We(this, e), !(t instanceof RegExp))
      throw new TypeError("'pattern' should be a RegExp instance.");
    if (!t.flags.includes("g"))
      throw new Error("'pattern' should contains 'g' flag.");
    Rx.set(this, { pattern: new RegExp(t.source, t.flags), escaped: !!r });
  }
  return Xe(e, [{ key: "execAll", value: regeneratorRuntime.mark(function t(n) {
    var r, i, a, s, o;
    return regeneratorRuntime.wrap(function(u) {
      for (; ; )
        switch (u.prev = u.next) {
          case 0:
            r = Rx.get(this), i = r.pattern, a = r.escaped, s = null, o = 0, i.lastIndex = 0;
          case 4:
            if ((s = i.exec(n)) == null) {
              u.next = 12;
              break;
            }
            if (!a && v8(n, s.index)) {
              u.next = 10;
              break;
            }
            return o = i.lastIndex, u.next = 9, s;
          case 9:
            i.lastIndex = o;
          case 10:
            u.next = 4;
            break;
          case 12:
          case "end":
            return u.stop();
        }
    }, t, this);
  }) }, { key: "test", value: function(t) {
    return !this.execAll(t).next().done;
  } }, { key: Symbol.replace, value: function(t, n) {
    return typeof n == "function" ? function(r, i, a) {
      var s = [], o = 0, u = !0, c = !1, f = void 0;
      try {
        for (var p, d = r.execAll(i)[Symbol.iterator](); !(u = (p = d.next()).done); u = !0) {
          var m = p.value;
          s.push(i.slice(o, m.index)), s.push(String(a.apply(void 0, Mt(m).concat([m.index, m.input])))), o = m.index + m[0].length;
        }
      } catch (y) {
        c = !0, f = y;
      } finally {
        try {
          u || d.return == null || d.return();
        } finally {
          if (c)
            throw f;
        }
      }
      return s.push(i.slice(o)), s.join("");
    }(this, String(t), n) : function(r, i, a) {
      var s = [], o = 0, u = null;
      function c(v) {
        switch (v) {
          case "$$":
            return "$";
          case "$&":
            return u[0];
          case "$`":
            return i.slice(0, u.index);
          case "$'":
            return i.slice(u.index + u[0].length);
          default:
            var b = v.slice(1);
            return b in u ? u[b] : v;
        }
      }
      var f = !0, p = !1, d = void 0;
      try {
        for (var m, y = r.execAll(i)[Symbol.iterator](); !(f = (m = y.next()).done); f = !0)
          u = m.value, s.push(i.slice(o, u.index)), s.push(a.replace(y8, c)), o = u.index + u[0].length;
      } catch (v) {
        p = !0, d = v;
      } finally {
        try {
          f || y.return == null || y.return();
        } finally {
          if (p)
            throw d;
        }
      }
      return s.push(i.slice(o)), s.join("");
    }(this, String(t), String(n));
  } }]), e;
}(), x8 = /^(?:Import|Export(?:All|Default|Named))Declaration$/, Co = Function.call.bind(Object.hasOwnProperty), Wt = Symbol("read"), Lo = Symbol("call"), Is = Symbol("construct"), vf = Symbol("esm"), b8 = { require: Fn({}, Lo, !0) };
function Mx(e) {
  return e == null || e.defs.length !== 0 || e.references.some(function(t) {
    return t.isWrite();
  });
}
function E8(e) {
  var t = e.parent;
  switch (t && t.type) {
    case "ConditionalExpression":
      return t.consequent === e || t.alternate === e;
    case "LogicalExpression":
      return !0;
    case "SequenceExpression":
      return t.expressions[t.expressions.length - 1] === e;
    default:
      return !1;
  }
}
var Fs = function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.mode, i = r === void 0 ? "strict" : r, a = n.globalObjectNames, s = a === void 0 ? ["global", "self", "window"] : a;
    We(this, e), this.variableStack = [], this.globalScope = t, this.mode = i, this.globalObjectNames = s.slice(0);
  }
  return Xe(e, [{ key: "iterateGlobalReferences", value: regeneratorRuntime.mark(function t(n) {
    var r, i, a, s, o, u, c, f, p, d, m, y, v, b;
    return regeneratorRuntime.wrap(function(x) {
      for (; ; )
        switch (x.prev = x.next) {
          case 0:
            r = 0, i = Object.keys(n);
          case 1:
            if (!(r < i.length)) {
              x.next = 12;
              break;
            }
            if (a = i[r], s = n[a], o = [a], !Mx(u = this.globalScope.set.get(a))) {
              x.next = 8;
              break;
            }
            return x.abrupt("continue", 9);
          case 8:
            return x.delegateYield(this._iterateVariableReferences(u, o, s, !0), "t0", 9);
          case 9:
            r++, x.next = 1;
            break;
          case 12:
            c = !0, f = !1, p = void 0, x.prev = 15, d = this.globalObjectNames[Symbol.iterator]();
          case 17:
            if (c = (m = d.next()).done) {
              x.next = 27;
              break;
            }
            if (y = m.value, v = [], !Mx(b = this.globalScope.set.get(y))) {
              x.next = 23;
              break;
            }
            return x.abrupt("continue", 24);
          case 23:
            return x.delegateYield(this._iterateVariableReferences(b, v, n, !1), "t1", 24);
          case 24:
            c = !0, x.next = 17;
            break;
          case 27:
            x.next = 33;
            break;
          case 29:
            x.prev = 29, x.t2 = x.catch(15), f = !0, p = x.t2;
          case 33:
            x.prev = 33, x.prev = 34, c || d.return == null || d.return();
          case 36:
            if (x.prev = 36, !f) {
              x.next = 39;
              break;
            }
            throw p;
          case 39:
            return x.finish(36);
          case 40:
            return x.finish(33);
          case 41:
          case "end":
            return x.stop();
        }
    }, t, this, [[15, 29, 33, 41], [34, , 36, 40]]);
  }) }, { key: "iterateCjsReferences", value: regeneratorRuntime.mark(function t(n) {
    var r, i, a, s, o, u, c, f, p;
    return regeneratorRuntime.wrap(function(d) {
      for (; ; )
        switch (d.prev = d.next) {
          case 0:
            r = !0, i = !1, a = void 0, d.prev = 3, s = this.iterateGlobalReferences(b8)[Symbol.iterator]();
          case 5:
            if (r = (o = s.next()).done) {
              d.next = 19;
              break;
            }
            if (u = o.value.node, (c = hc(u.arguments[0])) != null && Co(n, c)) {
              d.next = 10;
              break;
            }
            return d.abrupt("continue", 16);
          case 10:
            if (f = n[c], p = [c], !f[Wt]) {
              d.next = 15;
              break;
            }
            return d.next = 15, { node: u, path: p, type: Wt, info: f[Wt] };
          case 15:
            return d.delegateYield(this._iteratePropertyReferences(u, p, f), "t0", 16);
          case 16:
            r = !0, d.next = 5;
            break;
          case 19:
            d.next = 25;
            break;
          case 21:
            d.prev = 21, d.t1 = d.catch(3), i = !0, a = d.t1;
          case 25:
            d.prev = 25, d.prev = 26, r || s.return == null || s.return();
          case 28:
            if (d.prev = 28, !i) {
              d.next = 31;
              break;
            }
            throw a;
          case 31:
            return d.finish(28);
          case 32:
            return d.finish(25);
          case 33:
          case "end":
            return d.stop();
        }
    }, t, this, [[3, 21, 25, 33], [26, , 28, 32]]);
  }) }, { key: "iterateEsmReferences", value: regeneratorRuntime.mark(function t(n) {
    var r, i, a, s, o, u, c, f, p, d, m, y, v, b, x, C, k, F, B, O, S, w, D, I, L, V, K, W;
    return regeneratorRuntime.wrap(function(R) {
      for (; ; )
        switch (R.prev = R.next) {
          case 0:
            r = this.globalScope.block, i = !0, a = !1, s = void 0, R.prev = 4, o = r.body[Symbol.iterator]();
          case 6:
            if (i = (u = o.next()).done) {
              R.next = 92;
              break;
            }
            if (c = u.value, x8.test(c.type) && c.source != null) {
              R.next = 10;
              break;
            }
            return R.abrupt("continue", 89);
          case 10:
            if (f = c.source.value, Co(n, f)) {
              R.next = 13;
              break;
            }
            return R.abrupt("continue", 89);
          case 13:
            if (p = n[f], d = [f], !p[Wt]) {
              R.next = 18;
              break;
            }
            return R.next = 18, { node: c, path: d, type: Wt, info: p[Wt] };
          case 18:
            if (c.type !== "ExportAllDeclaration") {
              R.next = 31;
              break;
            }
            m = 0, y = Object.keys(p);
          case 20:
            if (!(m < y.length)) {
              R.next = 29;
              break;
            }
            if (v = y[m], !(b = p[v])[Wt]) {
              R.next = 26;
              break;
            }
            return R.next = 26, { node: c, path: d.concat(v), type: Wt, info: b[Wt] };
          case 26:
            m++, R.next = 20;
            break;
          case 29:
            R.next = 89;
            break;
          case 31:
            x = !0, C = !1, k = void 0, R.prev = 34, F = c.specifiers[Symbol.iterator]();
          case 36:
            if (x = (B = F.next()).done) {
              R.next = 75;
              break;
            }
            if (O = B.value, S = Co(p, vf), w = this._iterateImportReferences(O, d, S ? p : this.mode === "legacy" ? Object.assign({ default: p }, p) : { default: p }), !S) {
              R.next = 44;
              break;
            }
            return R.delegateYield(w, "t0", 42);
          case 42:
            R.next = 72;
            break;
          case 44:
            D = !0, I = !1, L = void 0, R.prev = 47, V = w[Symbol.iterator]();
          case 49:
            if (D = (K = V.next()).done) {
              R.next = 58;
              break;
            }
            if ((W = K.value).path = W.path.filter(C8), !(W.path.length >= 2 || W.type !== Wt)) {
              R.next = 55;
              break;
            }
            return R.next = 55, W;
          case 55:
            D = !0, R.next = 49;
            break;
          case 58:
            R.next = 64;
            break;
          case 60:
            R.prev = 60, R.t1 = R.catch(47), I = !0, L = R.t1;
          case 64:
            R.prev = 64, R.prev = 65, D || V.return == null || V.return();
          case 67:
            if (R.prev = 67, !I) {
              R.next = 70;
              break;
            }
            throw L;
          case 70:
            return R.finish(67);
          case 71:
            return R.finish(64);
          case 72:
            x = !0, R.next = 36;
            break;
          case 75:
            R.next = 81;
            break;
          case 77:
            R.prev = 77, R.t2 = R.catch(34), C = !0, k = R.t2;
          case 81:
            R.prev = 81, R.prev = 82, x || F.return == null || F.return();
          case 84:
            if (R.prev = 84, !C) {
              R.next = 87;
              break;
            }
            throw k;
          case 87:
            return R.finish(84);
          case 88:
            return R.finish(81);
          case 89:
            i = !0, R.next = 6;
            break;
          case 92:
            R.next = 98;
            break;
          case 94:
            R.prev = 94, R.t3 = R.catch(4), a = !0, s = R.t3;
          case 98:
            R.prev = 98, R.prev = 99, i || o.return == null || o.return();
          case 101:
            if (R.prev = 101, !a) {
              R.next = 104;
              break;
            }
            throw s;
          case 104:
            return R.finish(101);
          case 105:
            return R.finish(98);
          case 106:
          case "end":
            return R.stop();
        }
    }, t, this, [[4, 94, 98, 106], [34, 77, 81, 89], [47, 60, 64, 72], [65, , 67, 71], [82, , 84, 88], [99, , 101, 105]]);
  }) }, { key: "_iterateVariableReferences", value: regeneratorRuntime.mark(function t(n, r, i, a) {
    var s, o, u, c, f, p, d;
    return regeneratorRuntime.wrap(function(m) {
      for (; ; )
        switch (m.prev = m.next) {
          case 0:
            if (!this.variableStack.includes(n)) {
              m.next = 2;
              break;
            }
            return m.abrupt("return");
          case 2:
            this.variableStack.push(n), m.prev = 3, s = !0, o = !1, u = void 0, m.prev = 7, c = n.references[Symbol.iterator]();
          case 9:
            if (s = (f = c.next()).done) {
              m.next = 21;
              break;
            }
            if ((p = f.value).isRead()) {
              m.next = 13;
              break;
            }
            return m.abrupt("continue", 18);
          case 13:
            if (d = p.identifier, !a || !i[Wt]) {
              m.next = 17;
              break;
            }
            return m.next = 17, { node: d, path: r, type: Wt, info: i[Wt] };
          case 17:
            return m.delegateYield(this._iteratePropertyReferences(d, r, i), "t0", 18);
          case 18:
            s = !0, m.next = 9;
            break;
          case 21:
            m.next = 27;
            break;
          case 23:
            m.prev = 23, m.t1 = m.catch(7), o = !0, u = m.t1;
          case 27:
            m.prev = 27, m.prev = 28, s || c.return == null || c.return();
          case 30:
            if (m.prev = 30, !o) {
              m.next = 33;
              break;
            }
            throw u;
          case 33:
            return m.finish(30);
          case 34:
            return m.finish(27);
          case 35:
            return m.prev = 35, this.variableStack.pop(), m.finish(35);
          case 38:
          case "end":
            return m.stop();
        }
    }, t, this, [[3, , 35, 38], [7, 23, 27, 35], [28, , 30, 34]]);
  }) }, { key: "_iteratePropertyReferences", value: regeneratorRuntime.mark(function t(n, r, i) {
    var a, s, o, u;
    return regeneratorRuntime.wrap(function(c) {
      for (; ; )
        switch (c.prev = c.next) {
          case 0:
            for (a = n; E8(a); )
              a = a.parent;
            if ((s = a.parent).type !== "MemberExpression") {
              c.next = 15;
              break;
            }
            if (s.object !== a) {
              c.next = 14;
              break;
            }
            if ((o = dc(s)) != null && Co(i, o)) {
              c.next = 8;
              break;
            }
            return c.abrupt("return");
          case 8:
            if (r = r.concat(o), !(u = i[o])[Wt]) {
              c.next = 13;
              break;
            }
            return c.next = 13, { node: s, path: r, type: Wt, info: u[Wt] };
          case 13:
            return c.delegateYield(this._iteratePropertyReferences(s, r, u), "t0", 14);
          case 14:
            return c.abrupt("return");
          case 15:
            if (s.type !== "CallExpression") {
              c.next = 20;
              break;
            }
            if (s.callee !== a || !i[Lo]) {
              c.next = 19;
              break;
            }
            return c.next = 19, { node: s, path: r, type: Lo, info: i[Lo] };
          case 19:
            return c.abrupt("return");
          case 20:
            if (s.type !== "NewExpression") {
              c.next = 25;
              break;
            }
            if (s.callee !== a || !i[Is]) {
              c.next = 24;
              break;
            }
            return c.next = 24, { node: s, path: r, type: Is, info: i[Is] };
          case 24:
            return c.abrupt("return");
          case 25:
            if (s.type !== "AssignmentExpression") {
              c.next = 30;
              break;
            }
            if (s.right !== a) {
              c.next = 29;
              break;
            }
            return c.delegateYield(this._iterateLhsReferences(s.left, r, i), "t1", 28);
          case 28:
            return c.delegateYield(this._iteratePropertyReferences(s, r, i), "t2", 29);
          case 29:
            return c.abrupt("return");
          case 30:
            if (s.type !== "AssignmentPattern") {
              c.next = 34;
              break;
            }
            if (s.right !== a) {
              c.next = 33;
              break;
            }
            return c.delegateYield(this._iterateLhsReferences(s.left, r, i), "t3", 33);
          case 33:
            return c.abrupt("return");
          case 34:
            if (s.type !== "VariableDeclarator") {
              c.next = 37;
              break;
            }
            if (s.init !== a) {
              c.next = 37;
              break;
            }
            return c.delegateYield(this._iterateLhsReferences(s.id, r, i), "t4", 37);
          case 37:
          case "end":
            return c.stop();
        }
    }, t, this);
  }) }, { key: "_iterateLhsReferences", value: regeneratorRuntime.mark(function t(n, r, i) {
    var a, s, o, u, c, f, p, d, m, y;
    return regeneratorRuntime.wrap(function(v) {
      for (; ; )
        switch (v.prev = v.next) {
          case 0:
            if (n.type !== "Identifier") {
              v.next = 5;
              break;
            }
            if ((a = Ps(this.globalScope, n)) == null) {
              v.next = 4;
              break;
            }
            return v.delegateYield(this._iterateVariableReferences(a, r, i, !1), "t0", 4);
          case 4:
            return v.abrupt("return");
          case 5:
            if (n.type !== "ObjectPattern") {
              v.next = 40;
              break;
            }
            s = !0, o = !1, u = void 0, v.prev = 9, c = n.properties[Symbol.iterator]();
          case 11:
            if (s = (f = c.next()).done) {
              v.next = 25;
              break;
            }
            if (p = f.value, (d = dc(p)) != null && Co(i, d)) {
              v.next = 16;
              break;
            }
            return v.abrupt("continue", 22);
          case 16:
            if (m = r.concat(d), !(y = i[d])[Wt]) {
              v.next = 21;
              break;
            }
            return v.next = 21, { node: p, path: m, type: Wt, info: y[Wt] };
          case 21:
            return v.delegateYield(this._iterateLhsReferences(p.value, m, y), "t1", 22);
          case 22:
            s = !0, v.next = 11;
            break;
          case 25:
            v.next = 31;
            break;
          case 27:
            v.prev = 27, v.t2 = v.catch(9), o = !0, u = v.t2;
          case 31:
            v.prev = 31, v.prev = 32, s || c.return == null || c.return();
          case 34:
            if (v.prev = 34, !o) {
              v.next = 37;
              break;
            }
            throw u;
          case 37:
            return v.finish(34);
          case 38:
            return v.finish(31);
          case 39:
            return v.abrupt("return");
          case 40:
            if (n.type !== "AssignmentPattern") {
              v.next = 42;
              break;
            }
            return v.delegateYield(this._iterateLhsReferences(n.left, r, i), "t3", 42);
          case 42:
          case "end":
            return v.stop();
        }
    }, t, this, [[9, 27, 31, 39], [32, , 34, 38]]);
  }) }, { key: "_iterateImportReferences", value: regeneratorRuntime.mark(function t(n, r, i) {
    var a, s, o, u, c;
    return regeneratorRuntime.wrap(function(f) {
      for (; ; )
        switch (f.prev = f.next) {
          case 0:
            if ((a = n.type) !== "ImportSpecifier" && a !== "ImportDefaultSpecifier") {
              f.next = 12;
              break;
            }
            if (s = a === "ImportDefaultSpecifier" ? "default" : n.imported.name, Co(i, s)) {
              f.next = 5;
              break;
            }
            return f.abrupt("return");
          case 5:
            if (r = r.concat(s), !(o = i[s])[Wt]) {
              f.next = 10;
              break;
            }
            return f.next = 10, { node: n, path: r, type: Wt, info: o[Wt] };
          case 10:
            return f.delegateYield(this._iterateVariableReferences(Ps(this.globalScope, n.local), r, o, !1), "t0", 11);
          case 11:
            return f.abrupt("return");
          case 12:
            if (a !== "ImportNamespaceSpecifier") {
              f.next = 15;
              break;
            }
            return f.delegateYield(this._iterateVariableReferences(Ps(this.globalScope, n.local), r, i, !1), "t1", 14);
          case 14:
            return f.abrupt("return");
          case 15:
            if (a !== "ExportSpecifier") {
              f.next = 24;
              break;
            }
            if (u = n.local.name, Co(i, u)) {
              f.next = 19;
              break;
            }
            return f.abrupt("return");
          case 19:
            if (r = r.concat(u), !(c = i[u])[Wt]) {
              f.next = 24;
              break;
            }
            return f.next = 24, { node: n, path: r, type: Wt, info: c[Wt] };
          case 24:
          case "end":
            return f.stop();
        }
    }, t, this);
  }) }]), e;
}();
function C8(e, t) {
  return !(t === 1 && e === "default");
}
Fs.READ = Wt, Fs.CALL = Lo, Fs.CONSTRUCT = Is, Fs.ESM = vf;
var S8 = { CALL: Lo, CONSTRUCT: Is, ESM: vf, findVariable: Ps, getFunctionHeadLocation: mD, getFunctionNameWithKind: gD, getInnermostScope: H0, getPropertyName: dc, getStaticValue: ng, getStringIfConstant: hc, hasSideEffect: yD, isArrowToken: gf, isClosingBraceToken: eg, isClosingBracketToken: Y0, isClosingParenToken: yf, isColonToken: Q0, isCommaToken: K0, isCommentToken: tg, isNotArrowToken: iD, isNotClosingBraceToken: hD, isNotClosingBracketToken: pD, isNotClosingParenToken: cD, isNotColonToken: sD, isNotCommaToken: aD, isNotCommentToken: dD, isNotOpeningBraceToken: fD, isNotOpeningBracketToken: lD, isNotOpeningParenToken: uD, isNotSemicolonToken: oD, isOpeningBraceToken: Z0, isOpeningBracketToken: X0, isOpeningParenToken: ro, isParenthesized: vD, isSemicolonToken: J0, PatternMatcher: xD, READ: Wt, ReferenceTracker: Fs }, k8 = Cr(Object.freeze({ __proto__: null, default: S8, CALL: Lo, CONSTRUCT: Is, ESM: vf, PatternMatcher: xD, READ: Wt, ReferenceTracker: Fs, findVariable: Ps, getFunctionHeadLocation: mD, getFunctionNameWithKind: gD, getInnermostScope: H0, getPropertyName: dc, getStaticValue: ng, getStringIfConstant: hc, hasSideEffect: yD, isArrowToken: gf, isClosingBraceToken: eg, isClosingBracketToken: Y0, isClosingParenToken: yf, isColonToken: Q0, isCommaToken: K0, isCommentToken: tg, isNotArrowToken: iD, isNotClosingBraceToken: hD, isNotClosingBracketToken: pD, isNotClosingParenToken: cD, isNotColonToken: sD, isNotCommaToken: aD, isNotCommentToken: dD, isNotOpeningBraceToken: fD, isNotOpeningBracketToken: lD, isNotOpeningParenToken: uD, isNotSemicolonToken: oD, isOpeningBraceToken: Z0, isOpeningBracketToken: X0, isOpeningParenToken: ro, isParenthesized: vD, isSemicolonToken: J0 })), ye = gt(function(e, t) {
  function n(y) {
    return y && xe(y) == "object" && "default" in y ? y.default : y;
  }
  var r = n(pf), i = n(n8), a = n(r8), s = n(a8), o = n(Ka), u = n(k8), c = /\r\n|[\n\r\u2028\u2029]/, f = { breakableTypePattern: /^(?:(?:Do)?While|For(?:In|Of)?|Switch)Statement$/, lineBreakPattern: c, createGlobalLinebreakMatcher: function() {
    return new RegExp(c.source, "gu");
  }, shebangPattern: /^#!((?:[\0-\t\x0B\f\x0E-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/ }, p = o("eslint:traverser");
  function d() {
  }
  var m = function() {
    function y() {
      We(this, y), this._current = null, this._parents = [], this._skipped = !1, this._broken = !1, this._visitorKeys = null, this._enter = null, this._leave = null;
    }
    return Xe(y, [{ key: "current", value: function() {
      return this._current;
    } }, { key: "parents", value: function() {
      return this._parents.slice(0);
    } }, { key: "break", value: function() {
      this._broken = !0;
    } }, { key: "skip", value: function() {
      this._skipped = !0;
    } }, { key: "traverse", value: function(v, b) {
      this._current = null, this._parents = [], this._skipped = !1, this._broken = !1, this._visitorKeys = b.visitorKeys || r.KEYS, this._enter = b.enter || d, this._leave = b.leave || d, this._traverse(v, null);
    } }, { key: "_traverse", value: function(v, b) {
      if (function(B) {
        return B !== null && xe(B) == "object" && typeof B.type == "string";
      }(v)) {
        if (this._current = v, this._skipped = !1, this._enter(v, b), !this._skipped && !this._broken) {
          var x = function(B, O) {
            var S = B[O.type];
            return S || (S = r.getKeys(O), p('Unknown node type "%s": Estimated visitor keys %j', O.type, S)), S;
          }(this._visitorKeys, v);
          if (1 <= x.length) {
            this._parents.push(v);
            for (var C = 0; C < x.length && !this._broken; ++C) {
              var k = v[x[C]];
              if (Array.isArray(k))
                for (var F = 0; F < k.length && !this._broken; ++F)
                  this._traverse(k[F], v);
              else
                this._traverse(k, v);
            }
            this._parents.pop();
          }
        }
        this._broken || this._leave(v, b), this._current = b;
      }
    } }], [{ key: "getKeys", value: function(v) {
      return r.getKeys(v);
    } }, { key: "traverse", value: function(v, b) {
      new y().traverse(v, b);
    } }, { key: "DEFAULT_VISITOR_KEYS", get: function() {
      return r.KEYS;
    } }]), y;
  }();
  t.Traverser = m, t.createCommonjsModule = function(y, v) {
    return y(v = { exports: {} }, v.exports), v.exports;
  }, t.espree = i, t.evk = r, t.getCjsExportFromNamespace = function(y) {
    return y && y.default || y;
  }, t.globals = s, t.lodash = a, t.require$$0 = u, t.require$$0$1 = f, t.require$$1 = o;
}), Zs = (ye.Traverser, ye.createCommonjsModule, ye.espree, ye.evk, ye.getCjsExportFromNamespace, ye.globals, ye.lodash, ye.require$$0, ye.require$$0$1, ye.require$$1, gt(function(e, t) {
  /** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
  (function(n) {
    function r() {
      for (var Z = arguments.length, ee = Array(Z), oe = 0; oe < Z; oe++)
        ee[oe] = arguments[oe];
      if (ee.length > 1) {
        ee[0] = ee[0].slice(0, -1);
        for (var le = ee.length - 1, we = 1; we < le; ++we)
          ee[we] = ee[we].slice(1, -1);
        return ee[le] = ee[le].slice(1), ee.join("");
      }
      return ee[0];
    }
    function i(Z) {
      return "(?:" + Z + ")";
    }
    function a(Z) {
      return Z === void 0 ? "undefined" : Z === null ? "null" : Object.prototype.toString.call(Z).split(" ").pop().split("]").shift().toLowerCase();
    }
    function s(Z) {
      return Z.toUpperCase();
    }
    function o(Z) {
      var ee = r("[0-9]", "[A-Fa-f]"), oe = i(i("%[EFef]" + ee + "%" + ee + ee + "%" + ee + ee) + "|" + i("%[89A-Fa-f]" + ee + "%" + ee + ee) + "|" + i("%" + ee + ee)), le = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", we = r("[\\:\\/\\?\\#\\[\\]\\@]", le), Me = Z ? "[\\uE000-\\uF8FF]" : "[]", Ve = r("[A-Za-z]", "[0-9]", "[\\-\\.\\_\\~]", Z ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]"), $e = (i("[A-Za-z]" + r("[A-Za-z]", "[0-9]", "[\\+\\-\\.]") + "*"), i(i(oe + "|" + r(Ve, le, "[\\:]")) + "*"), i(i("25[0-5]") + "|" + i("2[0-4][0-9]") + "|" + i("1[0-9][0-9]") + "|" + i("0?[1-9][0-9]") + "|0?0?[0-9]")), yt = i($e + "\\." + $e + "\\." + $e + "\\." + $e), ze = i(ee + "{1,4}"), vt = i(i(ze + "\\:" + ze) + "|" + yt), Nt = i(i(ze + "\\:") + "{6}" + vt), Qt = i("\\:\\:" + i(ze + "\\:") + "{5}" + vt), bt = i(i(ze) + "?\\:\\:" + i(ze + "\\:") + "{4}" + vt), at = i(i(i(ze + "\\:") + "{0,1}" + ze) + "?\\:\\:" + i(ze + "\\:") + "{3}" + vt), jt = i(i(i(ze + "\\:") + "{0,2}" + ze) + "?\\:\\:" + i(ze + "\\:") + "{2}" + vt), dn = i(i(i(ze + "\\:") + "{0,3}" + ze) + "?\\:\\:" + ze + "\\:" + vt), Rn = i(i(i(ze + "\\:") + "{0,4}" + ze) + "?\\:\\:" + vt), qn = i(i(i(ze + "\\:") + "{0,5}" + ze) + "?\\:\\:" + ze), Sr = i(i(i(ze + "\\:") + "{0,6}" + ze) + "?\\:\\:"), pi = i([Nt, Qt, bt, at, jt, dn, Rn, qn, Sr].join("|")), Bn = i(i(Ve + "|" + oe) + "+"), er = (i("[vV]" + ee + "+\\." + r(Ve, le, "[\\:]") + "+"), i(i(oe + "|" + r(Ve, le)) + "*"), i(oe + "|" + r(Ve, le, "[\\:\\@]")));
      return i(i(oe + "|" + r(Ve, le, "[\\@]")) + "+"), i(i(er + "|" + r("[\\/\\?]", Me)) + "*"), { NOT_SCHEME: new RegExp(r("[^]", "[A-Za-z]", "[0-9]", "[\\+\\-\\.]"), "g"), NOT_USERINFO: new RegExp(r("[^\\%\\:]", Ve, le), "g"), NOT_HOST: new RegExp(r("[^\\%\\[\\]\\:]", Ve, le), "g"), NOT_PATH: new RegExp(r("[^\\%\\/\\:\\@]", Ve, le), "g"), NOT_PATH_NOSCHEME: new RegExp(r("[^\\%\\/\\@]", Ve, le), "g"), NOT_QUERY: new RegExp(r("[^\\%]", Ve, le, "[\\:\\@\\/\\?]", Me), "g"), NOT_FRAGMENT: new RegExp(r("[^\\%]", Ve, le, "[\\:\\@\\/\\?]"), "g"), ESCAPE: new RegExp(r("[^]", Ve, le), "g"), UNRESERVED: new RegExp(Ve, "g"), OTHER_CHARS: new RegExp(r("[^\\%]", Ve, we), "g"), PCT_ENCODED: new RegExp(oe, "g"), IPV4ADDRESS: new RegExp("^(" + yt + ")$"), IPV6ADDRESS: new RegExp("^\\[?(" + pi + ")" + i(i("\\%25|\\%(?!" + ee + "{2})") + "(" + Bn + ")") + "?\\]?$") };
    }
    var u = o(!1), c = o(!0), f = function(Z, ee) {
      if (Array.isArray(Z))
        return Z;
      if (Symbol.iterator in Object(Z))
        return function(oe, le) {
          var we = [], Me = !0, Ve = !1, $e = void 0;
          try {
            for (var yt, ze = oe[Symbol.iterator](); !(Me = (yt = ze.next()).done) && (we.push(yt.value), !le || we.length !== le); Me = !0)
              ;
          } catch (vt) {
            Ve = !0, $e = vt;
          } finally {
            try {
              !Me && ze.return && ze.return();
            } finally {
              if (Ve)
                throw $e;
            }
          }
          return we;
        }(Z, ee);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }, p = 2147483647, d = /^xn--/, m = /[^\0-\x7E]/, y = /[\x2E\u3002\uFF0E\uFF61]/g, v = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, b = Math.floor, x = String.fromCharCode;
    function C(Z) {
      throw new RangeError(v[Z]);
    }
    function k(Z, ee) {
      var oe = Z.split("@"), le = "";
      oe.length > 1 && (le = oe[0] + "@", Z = oe[1]);
      var we = function(Me, Ve) {
        for (var $e = [], yt = Me.length; yt--; )
          $e[yt] = Ve(Me[yt]);
        return $e;
      }((Z = Z.replace(y, ".")).split("."), ee).join(".");
      return le + we;
    }
    function F(Z) {
      for (var ee = [], oe = 0, le = Z.length; oe < le; ) {
        var we = Z.charCodeAt(oe++);
        if (we >= 55296 && we <= 56319 && oe < le) {
          var Me = Z.charCodeAt(oe++);
          (64512 & Me) == 56320 ? ee.push(((1023 & we) << 10) + (1023 & Me) + 65536) : (ee.push(we), oe--);
        } else
          ee.push(we);
      }
      return ee;
    }
    var B = function(Z, ee) {
      return Z + 22 + 75 * (Z < 26) - ((ee != 0) << 5);
    }, O = function(Z, ee, oe) {
      var le = 0;
      for (Z = oe ? b(Z / 700) : Z >> 1, Z += b(Z / ee); Z > 455; le += 36)
        Z = b(Z / 35);
      return b(le + 36 * Z / (Z + 38));
    }, S = function(Z) {
      var ee, oe = [], le = Z.length, we = 0, Me = 128, Ve = 72, $e = Z.lastIndexOf("-");
      $e < 0 && ($e = 0);
      for (var yt = 0; yt < $e; ++yt)
        Z.charCodeAt(yt) >= 128 && C("not-basic"), oe.push(Z.charCodeAt(yt));
      for (var ze = $e > 0 ? $e + 1 : 0; ze < le; ) {
        for (var vt = we, Nt = 1, Qt = 36; ; Qt += 36) {
          ze >= le && C("invalid-input");
          var bt = (ee = Z.charCodeAt(ze++)) - 48 < 10 ? ee - 22 : ee - 65 < 26 ? ee - 65 : ee - 97 < 26 ? ee - 97 : 36;
          (bt >= 36 || bt > b((p - we) / Nt)) && C("overflow"), we += bt * Nt;
          var at = Qt <= Ve ? 1 : Qt >= Ve + 26 ? 26 : Qt - Ve;
          if (bt < at)
            break;
          var jt = 36 - at;
          Nt > b(p / jt) && C("overflow"), Nt *= jt;
        }
        var dn = oe.length + 1;
        Ve = O(we - vt, dn, vt == 0), b(we / dn) > p - Me && C("overflow"), Me += b(we / dn), we %= dn, oe.splice(we++, 0, Me);
      }
      return String.fromCodePoint.apply(String, oe);
    }, w = function(Z) {
      var ee = [], oe = (Z = F(Z)).length, le = 128, we = 0, Me = 72, Ve = !0, $e = !1, yt = void 0;
      try {
        for (var ze, vt = Z[Symbol.iterator](); !(Ve = (ze = vt.next()).done); Ve = !0) {
          var Nt = ze.value;
          Nt < 128 && ee.push(x(Nt));
        }
      } catch (Ze) {
        $e = !0, yt = Ze;
      } finally {
        try {
          !Ve && vt.return && vt.return();
        } finally {
          if ($e)
            throw yt;
        }
      }
      var Qt = ee.length, bt = Qt;
      for (Qt && ee.push("-"); bt < oe; ) {
        var at = p, jt = !0, dn = !1, Rn = void 0;
        try {
          for (var qn, Sr = Z[Symbol.iterator](); !(jt = (qn = Sr.next()).done); jt = !0) {
            var pi = qn.value;
            pi >= le && pi < at && (at = pi);
          }
        } catch (Ze) {
          dn = !0, Rn = Ze;
        } finally {
          try {
            !jt && Sr.return && Sr.return();
          } finally {
            if (dn)
              throw Rn;
          }
        }
        var Bn = bt + 1;
        at - le > b((p - we) / Bn) && C("overflow"), we += (at - le) * Bn, le = at;
        var er = !0, fi = !1, kr = void 0;
        try {
          for (var oo, Fi = Z[Symbol.iterator](); !(er = (oo = Fi.next()).done); er = !0) {
            var so = oo.value;
            if (so < le && ++we > p && C("overflow"), so == le) {
              for (var Hi = we, Ki = 36; ; Ki += 36) {
                var Wn = Ki <= Me ? 1 : Ki >= Me + 26 ? 26 : Ki - Me;
                if (Hi < Wn)
                  break;
                var Ie = Hi - Wn, je = 36 - Wn;
                ee.push(x(B(Wn + Ie % je, 0))), Hi = b(Ie / je);
              }
              ee.push(x(B(Hi, 0))), Me = O(we, Bn, bt == Qt), we = 0, ++bt;
            }
          }
        } catch (Ze) {
          fi = !0, kr = Ze;
        } finally {
          try {
            !er && Fi.return && Fi.return();
          } finally {
            if (fi)
              throw kr;
          }
        }
        ++we, ++le;
      }
      return ee.join("");
    }, D = { version: "2.1.0", ucs2: { decode: F, encode: function(Z) {
      return String.fromCodePoint.apply(String, function(ee) {
        if (Array.isArray(ee)) {
          for (var oe = 0, le = Array(ee.length); oe < ee.length; oe++)
            le[oe] = ee[oe];
          return le;
        }
        return Array.from(ee);
      }(Z));
    } }, decode: S, encode: w, toASCII: function(Z) {
      return k(Z, function(ee) {
        return m.test(ee) ? "xn--" + w(ee) : ee;
      });
    }, toUnicode: function(Z) {
      return k(Z, function(ee) {
        return d.test(ee) ? S(ee.slice(4).toLowerCase()) : ee;
      });
    } }, I = {};
    function L(Z) {
      var ee = Z.charCodeAt(0);
      return ee < 16 ? "%0" + ee.toString(16).toUpperCase() : ee < 128 ? "%" + ee.toString(16).toUpperCase() : ee < 2048 ? "%" + (ee >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & ee | 128).toString(16).toUpperCase() : "%" + (ee >> 12 | 224).toString(16).toUpperCase() + "%" + (ee >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & ee | 128).toString(16).toUpperCase();
    }
    function V(Z) {
      for (var ee = "", oe = 0, le = Z.length; oe < le; ) {
        var we = parseInt(Z.substr(oe + 1, 2), 16);
        if (we < 128)
          ee += String.fromCharCode(we), oe += 3;
        else if (we >= 194 && we < 224) {
          if (le - oe >= 6) {
            var Me = parseInt(Z.substr(oe + 4, 2), 16);
            ee += String.fromCharCode((31 & we) << 6 | 63 & Me);
          } else
            ee += Z.substr(oe, 6);
          oe += 6;
        } else if (we >= 224) {
          if (le - oe >= 9) {
            var Ve = parseInt(Z.substr(oe + 4, 2), 16), $e = parseInt(Z.substr(oe + 7, 2), 16);
            ee += String.fromCharCode((15 & we) << 12 | (63 & Ve) << 6 | 63 & $e);
          } else
            ee += Z.substr(oe, 9);
          oe += 9;
        } else
          ee += Z.substr(oe, 3), oe += 3;
      }
      return ee;
    }
    function K(Z, ee) {
      function oe(le) {
        var we = V(le);
        return we.match(ee.UNRESERVED) ? we : le;
      }
      return Z.scheme && (Z.scheme = String(Z.scheme).replace(ee.PCT_ENCODED, oe).toLowerCase().replace(ee.NOT_SCHEME, "")), Z.userinfo !== void 0 && (Z.userinfo = String(Z.userinfo).replace(ee.PCT_ENCODED, oe).replace(ee.NOT_USERINFO, L).replace(ee.PCT_ENCODED, s)), Z.host !== void 0 && (Z.host = String(Z.host).replace(ee.PCT_ENCODED, oe).toLowerCase().replace(ee.NOT_HOST, L).replace(ee.PCT_ENCODED, s)), Z.path !== void 0 && (Z.path = String(Z.path).replace(ee.PCT_ENCODED, oe).replace(Z.scheme ? ee.NOT_PATH : ee.NOT_PATH_NOSCHEME, L).replace(ee.PCT_ENCODED, s)), Z.query !== void 0 && (Z.query = String(Z.query).replace(ee.PCT_ENCODED, oe).replace(ee.NOT_QUERY, L).replace(ee.PCT_ENCODED, s)), Z.fragment !== void 0 && (Z.fragment = String(Z.fragment).replace(ee.PCT_ENCODED, oe).replace(ee.NOT_FRAGMENT, L).replace(ee.PCT_ENCODED, s)), Z;
    }
    function W(Z) {
      return Z.replace(/^0*(.*)/, "$1") || "0";
    }
    function R(Z, ee) {
      var oe = Z.match(ee.IPV4ADDRESS) || [], le = f(oe, 2)[1];
      return le ? le.split(".").map(W).join(".") : Z;
    }
    function q(Z, ee) {
      var oe = Z.match(ee.IPV6ADDRESS) || [], le = f(oe, 3), we = le[1], Me = le[2];
      if (we) {
        for (var Ve = we.toLowerCase().split("::").reverse(), $e = f(Ve, 2), yt = $e[0], ze = $e[1], vt = ze ? ze.split(":").map(W) : [], Nt = yt.split(":").map(W), Qt = ee.IPV4ADDRESS.test(Nt[Nt.length - 1]), bt = Qt ? 7 : 8, at = Nt.length - bt, jt = Array(bt), dn = 0; dn < bt; ++dn)
          jt[dn] = vt[dn] || Nt[at + dn] || "";
        Qt && (jt[bt - 1] = R(jt[bt - 1], ee));
        var Rn = jt.reduce(function(Bn, er, fi) {
          if (!er || er === "0") {
            var kr = Bn[Bn.length - 1];
            kr && kr.index + kr.length === fi ? kr.length++ : Bn.push({ index: fi, length: 1 });
          }
          return Bn;
        }, []).sort(function(Bn, er) {
          return er.length - Bn.length;
        })[0], qn = void 0;
        if (Rn && Rn.length > 1) {
          var Sr = jt.slice(0, Rn.index), pi = jt.slice(Rn.index + Rn.length);
          qn = Sr.join(":") + "::" + pi.join(":");
        } else
          qn = jt.join(":");
        return Me && (qn += "%" + Me), qn;
      }
      return Z;
    }
    var J = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, X = "".match(/(){0}/)[1] === void 0;
    function ce(Z) {
      var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, oe = {}, le = ee.iri !== !1 ? c : u;
      ee.reference === "suffix" && (Z = (ee.scheme ? ee.scheme + ":" : "") + "//" + Z);
      var we = Z.match(J);
      if (we) {
        X ? (oe.scheme = we[1], oe.userinfo = we[3], oe.host = we[4], oe.port = parseInt(we[5], 10), oe.path = we[6] || "", oe.query = we[7], oe.fragment = we[8], isNaN(oe.port) && (oe.port = we[5])) : (oe.scheme = we[1] || void 0, oe.userinfo = Z.indexOf("@") !== -1 ? we[3] : void 0, oe.host = Z.indexOf("//") !== -1 ? we[4] : void 0, oe.port = parseInt(we[5], 10), oe.path = we[6] || "", oe.query = Z.indexOf("?") !== -1 ? we[7] : void 0, oe.fragment = Z.indexOf("#") !== -1 ? we[8] : void 0, isNaN(oe.port) && (oe.port = Z.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? we[4] : void 0)), oe.host && (oe.host = q(R(oe.host, le), le)), oe.scheme !== void 0 || oe.userinfo !== void 0 || oe.host !== void 0 || oe.port !== void 0 || oe.path || oe.query !== void 0 ? oe.scheme === void 0 ? oe.reference = "relative" : oe.fragment === void 0 ? oe.reference = "absolute" : oe.reference = "uri" : oe.reference = "same-document", ee.reference && ee.reference !== "suffix" && ee.reference !== oe.reference && (oe.error = oe.error || "URI is not a " + ee.reference + " reference.");
        var Me = I[(ee.scheme || oe.scheme || "").toLowerCase()];
        if (ee.unicodeSupport || Me && Me.unicodeSupport)
          K(oe, le);
        else {
          if (oe.host && (ee.domainHost || Me && Me.domainHost))
            try {
              oe.host = D.toASCII(oe.host.replace(le.PCT_ENCODED, V).toLowerCase());
            } catch (Ve) {
              oe.error = oe.error || "Host's domain name can not be converted to ASCII via punycode: " + Ve;
            }
          K(oe, u);
        }
        Me && Me.parse && Me.parse(oe, ee);
      } else
        oe.error = oe.error || "URI can not be parsed.";
      return oe;
    }
    var A = /^\.\.?\//, M = /^\/\.(\/|$)/, ne = /^\/\.\.(\/|$)/, de = /^\/?(?:.|\n)*?(?=\/|$)/;
    function he(Z) {
      for (var ee = []; Z.length; )
        if (Z.match(A))
          Z = Z.replace(A, "");
        else if (Z.match(M))
          Z = Z.replace(M, "/");
        else if (Z.match(ne))
          Z = Z.replace(ne, "/"), ee.pop();
        else if (Z === "." || Z === "..")
          Z = "";
        else {
          var oe = Z.match(de);
          if (!oe)
            throw new Error("Unexpected dot segment condition");
          var le = oe[0];
          Z = Z.slice(le.length), ee.push(le);
        }
      return ee.join("");
    }
    function j(Z) {
      var ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, oe = ee.iri ? c : u, le = [], we = I[(ee.scheme || Z.scheme || "").toLowerCase()];
      if (we && we.serialize && we.serialize(Z, ee), Z.host && !oe.IPV6ADDRESS.test(Z.host)) {
        if (ee.domainHost || we && we.domainHost)
          try {
            Z.host = ee.iri ? D.toUnicode(Z.host) : D.toASCII(Z.host.replace(oe.PCT_ENCODED, V).toLowerCase());
          } catch ($e) {
            Z.error = Z.error || "Host's domain name can not be converted to " + (ee.iri ? "Unicode" : "ASCII") + " via punycode: " + $e;
          }
      }
      K(Z, oe), ee.reference !== "suffix" && Z.scheme && (le.push(Z.scheme), le.push(":"));
      var Me = function($e, yt) {
        var ze = yt.iri !== !1 ? c : u, vt = [];
        return $e.userinfo !== void 0 && (vt.push($e.userinfo), vt.push("@")), $e.host !== void 0 && vt.push(q(R(String($e.host), ze), ze).replace(ze.IPV6ADDRESS, function(Nt, Qt, bt) {
          return "[" + Qt + (bt ? "%25" + bt : "") + "]";
        })), typeof $e.port == "number" && (vt.push(":"), vt.push($e.port.toString(10))), vt.length ? vt.join("") : void 0;
      }(Z, ee);
      if (Me !== void 0 && (ee.reference !== "suffix" && le.push("//"), le.push(Me), Z.path && Z.path.charAt(0) !== "/" && le.push("/")), Z.path !== void 0) {
        var Ve = Z.path;
        ee.absolutePath || we && we.absolutePath || (Ve = he(Ve)), Me === void 0 && (Ve = Ve.replace(/^\/\//, "/%2F")), le.push(Ve);
      }
      return Z.query !== void 0 && (le.push("?"), le.push(Z.query)), Z.fragment !== void 0 && (le.push("#"), le.push(Z.fragment)), le.join("");
    }
    function ie(Z, ee) {
      var oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, le = {};
      return arguments[3] || (Z = ce(j(Z, oe), oe), ee = ce(j(ee, oe), oe)), !(oe = oe || {}).tolerant && ee.scheme ? (le.scheme = ee.scheme, le.userinfo = ee.userinfo, le.host = ee.host, le.port = ee.port, le.path = he(ee.path || ""), le.query = ee.query) : (ee.userinfo !== void 0 || ee.host !== void 0 || ee.port !== void 0 ? (le.userinfo = ee.userinfo, le.host = ee.host, le.port = ee.port, le.path = he(ee.path || ""), le.query = ee.query) : (ee.path ? (ee.path.charAt(0) === "/" ? le.path = he(ee.path) : (Z.userinfo === void 0 && Z.host === void 0 && Z.port === void 0 || Z.path ? Z.path ? le.path = Z.path.slice(0, Z.path.lastIndexOf("/") + 1) + ee.path : le.path = ee.path : le.path = "/" + ee.path, le.path = he(le.path)), le.query = ee.query) : (le.path = Z.path, ee.query !== void 0 ? le.query = ee.query : le.query = Z.query), le.userinfo = Z.userinfo, le.host = Z.host, le.port = Z.port), le.scheme = Z.scheme), le.fragment = ee.fragment, le;
    }
    function fe(Z, ee) {
      return Z && Z.toString().replace(ee && ee.iri ? c.PCT_ENCODED : u.PCT_ENCODED, V);
    }
    var ge = { scheme: "http", domainHost: !0, parse: function(Z, ee) {
      return Z.host || (Z.error = Z.error || "HTTP URIs must have a host."), Z;
    }, serialize: function(Z, ee) {
      return Z.port !== (String(Z.scheme).toLowerCase() !== "https" ? 80 : 443) && Z.port !== "" || (Z.port = void 0), Z.path || (Z.path = "/"), Z;
    } }, Fe = { scheme: "https", domainHost: ge.domainHost, parse: ge.parse, serialize: ge.serialize }, Pe = {}, _ = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", Q = "[0-9A-Fa-f]", Y = i(i("%[EFef][0-9A-Fa-f]%" + Q + Q + "%" + Q + Q) + "|" + i("%[89A-Fa-f][0-9A-Fa-f]%" + Q + Q) + "|" + i("%" + Q + Q)), ae = r("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), ue = new RegExp(_, "g"), De = new RegExp(Y, "g"), Ee = new RegExp(r("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', ae), "g"), _e = new RegExp(r("[^]", _, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), Oe = _e;
    function Ye(Z) {
      var ee = V(Z);
      return ee.match(ue) ? ee : Z;
    }
    var _t = { scheme: "mailto", parse: function(Z, ee) {
      var oe = Z, le = oe.to = oe.path ? oe.path.split(",") : [];
      if (oe.path = void 0, oe.query) {
        for (var we = !1, Me = {}, Ve = oe.query.split("&"), $e = 0, yt = Ve.length; $e < yt; ++$e) {
          var ze = Ve[$e].split("=");
          switch (ze[0]) {
            case "to":
              for (var vt = ze[1].split(","), Nt = 0, Qt = vt.length; Nt < Qt; ++Nt)
                le.push(vt[Nt]);
              break;
            case "subject":
              oe.subject = fe(ze[1], ee);
              break;
            case "body":
              oe.body = fe(ze[1], ee);
              break;
            default:
              we = !0, Me[fe(ze[0], ee)] = fe(ze[1], ee);
          }
        }
        we && (oe.headers = Me);
      }
      oe.query = void 0;
      for (var bt = 0, at = le.length; bt < at; ++bt) {
        var jt = le[bt].split("@");
        if (jt[0] = fe(jt[0]), ee.unicodeSupport)
          jt[1] = fe(jt[1], ee).toLowerCase();
        else
          try {
            jt[1] = D.toASCII(fe(jt[1], ee).toLowerCase());
          } catch (dn) {
            oe.error = oe.error || "Email address's domain name can not be converted to ASCII via punycode: " + dn;
          }
        le[bt] = jt.join("@");
      }
      return oe;
    }, serialize: function(Z, ee) {
      var oe, le = Z, we = (oe = Z.to) != null ? oe instanceof Array ? oe : typeof oe.length != "number" || oe.split || oe.setInterval || oe.call ? [oe] : Array.prototype.slice.call(oe) : [];
      if (we) {
        for (var Me = 0, Ve = we.length; Me < Ve; ++Me) {
          var $e = String(we[Me]), yt = $e.lastIndexOf("@"), ze = $e.slice(0, yt).replace(De, Ye).replace(De, s).replace(Ee, L), vt = $e.slice(yt + 1);
          try {
            vt = ee.iri ? D.toUnicode(vt) : D.toASCII(fe(vt, ee).toLowerCase());
          } catch (at) {
            le.error = le.error || "Email address's domain name can not be converted to " + (ee.iri ? "Unicode" : "ASCII") + " via punycode: " + at;
          }
          we[Me] = ze + "@" + vt;
        }
        le.path = we.join(",");
      }
      var Nt = Z.headers = Z.headers || {};
      Z.subject && (Nt.subject = Z.subject), Z.body && (Nt.body = Z.body);
      var Qt = [];
      for (var bt in Nt)
        Nt[bt] !== Pe[bt] && Qt.push(bt.replace(De, Ye).replace(De, s).replace(_e, L) + "=" + Nt[bt].replace(De, Ye).replace(De, s).replace(Oe, L));
      return Qt.length && (le.query = Qt.join("&")), le;
    } }, Kt = /^([^\:]+)\:(.*)/, Jt = { scheme: "urn", parse: function(Z, ee) {
      var oe = Z.path && Z.path.match(Kt), le = Z;
      if (oe) {
        var we = ee.scheme || le.scheme || "urn", Me = oe[1].toLowerCase(), Ve = oe[2], $e = we + ":" + (ee.nid || Me), yt = I[$e];
        le.nid = Me, le.nss = Ve, le.path = void 0, yt && (le = yt.parse(le, ee));
      } else
        le.error = le.error || "URN can not be parsed.";
      return le;
    }, serialize: function(Z, ee) {
      var oe = ee.scheme || Z.scheme || "urn", le = Z.nid, we = oe + ":" + (ee.nid || le), Me = I[we];
      Me && (Z = Me.serialize(Z, ee));
      var Ve = Z, $e = Z.nss;
      return Ve.path = (le || ee.nid) + ":" + $e, Ve;
    } }, zt = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, wn = { scheme: "urn:uuid", parse: function(Z, ee) {
      var oe = Z;
      return oe.uuid = oe.nss, oe.nss = void 0, ee.tolerant || oe.uuid && oe.uuid.match(zt) || (oe.error = oe.error || "UUID is not valid."), oe;
    }, serialize: function(Z, ee) {
      var oe = Z;
      return oe.nss = (Z.uuid || "").toLowerCase(), oe;
    } };
    I[ge.scheme] = ge, I[Fe.scheme] = Fe, I[_t.scheme] = _t, I[Jt.scheme] = Jt, I[wn.scheme] = wn, n.SCHEMES = I, n.pctEncChar = L, n.pctDecChars = V, n.parse = ce, n.removeDotSegments = he, n.serialize = j, n.resolveComponents = ie, n.resolve = function(Z, ee, oe) {
      var le = function(we, Me) {
        var Ve = we;
        if (Me)
          for (var $e in Me)
            Ve[$e] = Me[$e];
        return Ve;
      }({ scheme: "null" }, oe);
      return j(ie(ce(Z, le), ce(ee, le), le, !0), le);
    }, n.normalize = function(Z, ee) {
      return typeof Z == "string" ? Z = j(ce(Z, ee), ee) : a(Z) === "object" && (Z = ce(j(Z, ee), ee)), Z;
    }, n.equal = function(Z, ee, oe) {
      return typeof Z == "string" ? Z = j(ce(Z, oe), oe) : a(Z) === "object" && (Z = j(Z, oe)), typeof ee == "string" ? ee = j(ce(ee, oe), oe) : a(ee) === "object" && (ee = j(ee, oe)), Z === ee;
    }, n.escapeComponent = function(Z, ee) {
      return Z && Z.toString().replace(ee && ee.iri ? c.ESCAPE : u.ESCAPE, L);
    }, n.unescapeComponent = fe, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
}));
Z2(Zs);
var Vx = Array.isArray, Ux = Object.keys, D8 = Object.prototype.hasOwnProperty, Vp = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && xe(t) == "object" && xe(n) == "object") {
    var r, i, a, s = Vx(t), o = Vx(n);
    if (s && o) {
      if ((i = t.length) != n.length)
        return !1;
      for (r = i; r-- != 0; )
        if (!e(t[r], n[r]))
          return !1;
      return !0;
    }
    if (s != o)
      return !1;
    var u = t instanceof Date, c = n instanceof Date;
    if (u != c)
      return !1;
    if (u && c)
      return t.getTime() == n.getTime();
    var f = t instanceof RegExp, p = n instanceof RegExp;
    if (f != p)
      return !1;
    if (f && p)
      return t.toString() == n.toString();
    var d = Ux(t);
    if ((i = d.length) !== Ux(n).length)
      return !1;
    for (r = i; r-- != 0; )
      if (!D8.call(n, d[r]))
        return !1;
    for (r = i; r-- != 0; )
      if (!e(t[a = d[r]], n[a]))
        return !1;
    return !0;
  }
  return t != t && n != n;
}, Mr = { copy: function(e, t) {
  for (var n in t = t || {}, e)
    t[n] = e[n];
  return t;
}, checkDataType: _d, checkDataTypes: function(e, t) {
  switch (e.length) {
    case 1:
      return _d(e[0], t, !0);
    default:
      var n = "", r = Wm(e);
      for (var i in r.array && r.object && (n = r.null ? "(" : "(!" + t + " || ", n += "typeof " + t + ' !== "object")', delete r.null, delete r.array, delete r.object), r.number && delete r.integer, r)
        n += (n ? " && " : "") + _d(i, t, !0);
      return n;
  }
}, coerceToTypes: function(e, t) {
  if (Array.isArray(t)) {
    for (var n = [], r = 0; r < t.length; r++) {
      var i = t[r];
      (qx[i] || e === "array" && i === "array") && (n[n.length] = i);
    }
    if (n.length)
      return n;
  } else {
    if (qx[t])
      return [t];
    if (e === "array" && t === "array")
      return ["array"];
  }
}, toHash: Wm, getProperty: Td, escapeQuotes: rg, equal: Vp, ucs2length: function(e) {
  for (var t, n = 0, r = e.length, i = 0; i < r; )
    n++, (t = e.charCodeAt(i++)) >= 55296 && t <= 56319 && i < r && (64512 & (t = e.charCodeAt(i))) == 56320 && i++;
  return n;
}, varOccurences: function(e, t) {
  t += "[^0-9]";
  var n = e.match(new RegExp(t, "g"));
  return n ? n.length : 0;
}, varReplace: function(e, t, n) {
  return t += "([^0-9])", n = n.replace(/\$/g, "$$$$"), e.replace(new RegExp(t, "g"), n + "$1");
}, cleanUpCode: function(e) {
  return e.replace(A8, "").replace(_8, "").replace(T8, "if (!($1))");
}, finalCleanUpCode: function(e, t) {
  var n = e.match(P8);
  return n && n.length == 2 && (e = t ? e.replace(B8, "").replace(N8, j8) : e.replace(I8, "").replace(O8, L8)), (n = e.match(R8)) && n.length === 3 ? e.replace(M8, "") : e;
}, schemaHasRules: function(e, t) {
  if (typeof e == "boolean")
    return !e;
  for (var n in e)
    if (t[n])
      return !0;
}, schemaHasRulesExcept: function(e, t, n) {
  if (typeof e == "boolean")
    return !e && n != "not";
  for (var r in e)
    if (r != n && t[r])
      return !0;
}, schemaUnknownRules: function(e, t) {
  if (typeof e != "boolean") {
    for (var n in e)
      if (!t[n])
        return n;
  }
}, toQuotedString: Wx, getPathExpr: function(e, t, n, r) {
  return $x(e, n ? "'/' + " + t + (r ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : r ? "'[' + " + t + " + ']'" : "'[\\'' + " + t + " + '\\']'");
}, getPath: function(e, t, n) {
  var r = Wx(n ? "/" + Pd(t) : Td(t));
  return $x(e, r);
}, getData: function(e, t, n) {
  var r, i, a, s;
  if (e === "")
    return "rootData";
  if (e[0] == "/") {
    if (!V8.test(e))
      throw new Error("Invalid JSON-pointer: " + e);
    i = e, a = "rootData";
  } else {
    if (!(s = e.match(U8)))
      throw new Error("Invalid JSON-pointer: " + e);
    if (r = +s[1], (i = s[2]) == "#") {
      if (r >= t)
        throw new Error("Cannot access property/index " + r + " levels up, current level is " + t);
      return n[t - r];
    }
    if (r > t)
      throw new Error("Cannot access data " + r + " levels up, current level is " + t);
    if (a = "data" + (t - r || ""), !i)
      return a;
  }
  for (var o = a, u = i.split("/"), c = 0; c < u.length; c++) {
    var f = u[c];
    f && (a += Td(Id(f)), o += " && " + a);
  }
  return o;
}, unescapeFragment: function(e) {
  return Id(decodeURIComponent(e));
}, unescapeJsonPointer: Id, escapeFragment: function(e) {
  return encodeURIComponent(Pd(e));
}, escapeJsonPointer: Pd };
function _d(e, t, n) {
  var r = n ? " !== " : " === ", i = n ? " || " : " && ", a = n ? "!" : "", s = n ? "" : "!";
  switch (e) {
    case "null":
      return t + r + "null";
    case "array":
      return a + "Array.isArray(" + t + ")";
    case "object":
      return "(" + a + t + i + "typeof " + t + r + '"object"' + i + s + "Array.isArray(" + t + "))";
    case "integer":
      return "(typeof " + t + r + '"number"' + i + s + "(" + t + " % 1)" + i + t + r + t + ")";
    default:
      return "typeof " + t + r + '"' + e + '"';
  }
}
var qx = Wm(["string", "number", "integer", "boolean", "null"]);
function Wm(e) {
  for (var t = {}, n = 0; n < e.length; n++)
    t[e[n]] = !0;
  return t;
}
var F8 = /^[a-z$_][a-z$_0-9]*$/i, w8 = /'|\\/g;
function Td(e) {
  return typeof e == "number" ? "[" + e + "]" : F8.test(e) ? "." + e : "['" + rg(e) + "']";
}
function rg(e) {
  return e.replace(w8, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
var A8 = /else\s*{\s*}/g, _8 = /if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g, T8 = /if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g, P8 = /[^v.]errors/g, I8 = /var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g, B8 = /var errors = 0;|var vErrors = null;/g, O8 = "return errors === 0;", L8 = "validate.errors = null; return true;", N8 = /if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/, j8 = "return data;", R8 = /[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g, M8 = /if \(rootData === undefined\) rootData = data;/;
function Wx(e) {
  return "'" + rg(e) + "'";
}
var V8 = /^\/(?:[^~]|~0|~1)*$/, U8 = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $x(e, t) {
  return e == '""' ? t : (e + " + " + t).replace(/' \+ '/g, "");
}
function Pd(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Id(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
var Ks = function(e) {
  Mr.copy(e, this);
}, q8 = gt(function(e) {
  var t = e.exports = function(n, r, i) {
    typeof r == "function" && (i = r, r = {}), function a(s, o, u, c, f, p, d, m, y, v) {
      if (c && xe(c) == "object" && !Array.isArray(c)) {
        for (var b in o(c, f, p, d, m, y, v), c) {
          var x = c[b];
          if (Array.isArray(x)) {
            if (b in t.arrayKeywords)
              for (var C = 0; C < x.length; C++)
                a(s, o, u, x[C], f + "/" + b + "/" + C, p, f, b, c, C);
          } else if (b in t.propsKeywords) {
            if (x && xe(x) == "object")
              for (var k in x)
                a(s, o, u, x[k], f + "/" + b + "/" + k.replace(/~/g, "~0").replace(/\//g, "~1"), p, f, b, c, k);
          } else
            (b in t.keywords || s.allKeys && !(b in t.skipKeywords)) && a(s, o, u, x, f + "/" + b, p, f, b, c);
        }
        u(c, f, p, d, m, y, v);
      }
    }(r, typeof (i = r.cb || i) == "function" ? i : i.pre || function() {
    }, i.post || function() {
    }, n, "", n);
  };
  t.keywords = { additionalItems: !0, items: !0, contains: !0, additionalProperties: !0, propertyNames: !0, not: !0 }, t.arrayKeywords = { items: !0, allOf: !0, anyOf: !0, oneOf: !0 }, t.propsKeywords = { definitions: !0, properties: !0, patternProperties: !0, dependencies: !0 }, t.skipKeywords = { default: !0, enum: !0, const: !0, required: !0, maximum: !0, minimum: !0, exclusiveMaximum: !0, exclusiveMinimum: !0, multipleOf: !0, maxLength: !0, minLength: !0, pattern: !0, format: !0, maxItems: !0, minItems: !0, uniqueItems: !0, maxProperties: !0, minProperties: !0 };
}), xr = Ja;
function Ja(e, t, n) {
  var r = this._refs[n];
  if (typeof r == "string") {
    if (!this._refs[r])
      return Ja.call(this, e, t, r);
    r = this._refs[r];
  }
  if ((r = r || this._schemas[n]) instanceof Ks)
    return $m(r.schema, this._opts.inlineRefs) ? r.schema : r.validate || this._compile(r);
  var i, a, s, o = xf.call(this, t, n);
  return o && (i = o.schema, t = o.root, s = o.baseId), i instanceof Ks ? a = i.validate || e.call(this, i.schema, t, void 0, s) : i !== void 0 && (a = $m(i, this._opts.inlineRefs) ? i : e.call(this, i, t, void 0, s)), a;
}
function xf(e, t) {
  var n = Zs.parse(t), r = ED(n), i = Up(this._getId(e.schema));
  if (Object.keys(e.schema).length === 0 || r !== i) {
    var a = Za(r), s = this._refs[a];
    if (typeof s == "string")
      return W8.call(this, e, s, n);
    if (s instanceof Ks)
      s.validate || this._compile(s), e = s;
    else {
      if (!((s = this._schemas[a]) instanceof Ks))
        return;
      if (s.validate || this._compile(s), a == Za(t))
        return { schema: s, root: e, baseId: i };
      e = s;
    }
    if (!e.schema)
      return;
    i = Up(this._getId(e.schema));
  }
  return bD.call(this, n, i, e.schema, e);
}
function W8(e, t, n) {
  var r = xf.call(this, e, t);
  if (r) {
    var i = r.schema, a = r.baseId;
    e = r.root;
    var s = this._getId(i);
    return s && (a = qp(a, s)), bD.call(this, n, a, i, e);
  }
}
Ja.normalizeId = Za, Ja.fullPath = Up, Ja.url = qp, Ja.ids = function(e) {
  var t = Za(this._getId(e)), n = { "": t }, r = { "": Up(t, !1) }, i = {}, a = this;
  return q8(e, { allKeys: !0 }, function(s, o, u, c, f, p, d) {
    if (o !== "") {
      var m = a._getId(s), y = n[c], v = r[c] + "/" + f;
      if (d !== void 0 && (v += "/" + (typeof d == "number" ? d : Mr.escapeFragment(d))), typeof m == "string") {
        m = y = Za(y ? Zs.resolve(y, m) : m);
        var b = a._refs[m];
        if (typeof b == "string" && (b = a._refs[b]), b && b.schema) {
          if (!Vp(s, b.schema))
            throw new Error('id "' + m + '" resolves to more than one schema');
        } else if (m != Za(v))
          if (m[0] == "#") {
            if (i[m] && !Vp(s, i[m]))
              throw new Error('id "' + m + '" resolves to more than one schema');
            i[m] = s;
          } else
            a._refs[m] = v;
      }
      n[o] = y, r[o] = v;
    }
  }), i;
}, Ja.inlineRef = $m, Ja.schema = xf;
var $8 = Mr.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
function bD(e, t, n, r) {
  if (e.fragment = e.fragment || "", e.fragment.slice(0, 1) == "/") {
    for (var i = e.fragment.split("/"), a = 1; a < i.length; a++) {
      var s = i[a];
      if (s) {
        if ((n = n[s = Mr.unescapeFragment(s)]) === void 0)
          break;
        var o;
        if (!$8[s] && ((o = this._getId(n)) && (t = qp(t, o)), n.$ref)) {
          var u = qp(t, n.$ref), c = xf.call(this, r, u);
          c && (n = c.schema, r = c.root, t = c.baseId);
        }
      }
    }
    return n !== void 0 && n !== r.schema ? { schema: n, root: r, baseId: t } : void 0;
  }
}
var G8 = Mr.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
function $m(e, t) {
  return t !== !1 && (t === void 0 || t === !0 ? function n(r) {
    var i;
    if (Array.isArray(r)) {
      for (var a = 0; a < r.length; a++)
        if (xe(i = r[a]) == "object" && !n(i))
          return !1;
    } else
      for (var s in r)
        if (s == "$ref" || xe(i = r[s]) == "object" && !n(i))
          return !1;
    return !0;
  }(e) : t ? function n(r) {
    var i, a = 0;
    if (Array.isArray(r)) {
      for (var s = 0; s < r.length; s++)
        if (xe(i = r[s]) == "object" && (a += n(i)), a == 1 / 0)
          return 1 / 0;
    } else
      for (var o in r) {
        if (o == "$ref")
          return 1 / 0;
        if (G8[o])
          a++;
        else if (xe(i = r[o]) == "object" && (a += n(i) + 1), a == 1 / 0)
          return 1 / 0;
      }
    return a;
  }(e) <= t : void 0);
}
function Up(e, t) {
  return t !== !1 && (e = Za(e)), ED(Zs.parse(e));
}
function ED(e) {
  return Zs.serialize(e).split("#")[0] + "#";
}
var z8 = /#\/?$/;
function Za(e) {
  return e ? e.replace(z8, "") : "";
}
function qp(e, t) {
  return t = Za(t), Zs.resolve(e, t);
}
var mc = { Validation: Gx(function(e) {
  this.message = "validation failed", this.errors = e, this.ajv = this.validation = !0;
}), MissingRef: Gx(ig) };
function ig(e, t, n) {
  this.message = n || ig.message(e, t), this.missingRef = xr.url(e, t), this.missingSchema = xr.normalizeId(xr.fullPath(this.missingRef));
}
function Gx(e) {
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
ig.message = function(e, t) {
  return "can't resolve reference " + t + " from id " + e;
};
var CD = function(e, t) {
  t || (t = {}), typeof t == "function" && (t = { cmp: t });
  var n = typeof t.cycles == "boolean" && t.cycles, r = t.cmp && function(a) {
    return function(s) {
      return function(o, u) {
        var c = { key: o, value: s[o] }, f = { key: u, value: s[u] };
        return a(c, f);
      };
    };
  }(t.cmp), i = [];
  return function a(s) {
    if (s && s.toJSON && typeof s.toJSON == "function" && (s = s.toJSON()), s !== void 0) {
      if (typeof s == "number")
        return isFinite(s) ? "" + s : "null";
      if (xe(s) !== "object")
        return JSON.stringify(s);
      var o, u;
      if (Array.isArray(s)) {
        for (u = "[", o = 0; o < s.length; o++)
          o && (u += ","), u += a(s[o]) || "null";
        return u + "]";
      }
      if (s === null)
        return "null";
      if (i.indexOf(s) !== -1) {
        if (n)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var c = i.push(s) - 1, f = Object.keys(s).sort(r && r(s));
      for (u = "", o = 0; o < f.length; o++) {
        var p = f[o], d = a(s[p]);
        d && (u && (u += ","), u += JSON.stringify(p) + ":" + d);
      }
      return i.splice(c, 1), "{" + u + "}";
    }
  }(e);
}, Gm = function(e, t, n) {
  var r = "", i = e.schema.$async === !0, a = e.util.schemaHasRulesExcept(e.schema, e.RULES.all, "$ref"), s = e.self._getId(e.schema);
  if (e.opts.strictKeywords) {
    var o = e.util.schemaUnknownRules(e.schema, e.RULES.keywords);
    if (o) {
      var u = "unknown keyword: " + o;
      if (e.opts.strictKeywords !== "log")
        throw new Error(u);
      e.logger.warn(u);
    }
  }
  if (e.isTop && (r += " var validate = ", i && (e.async = !0, r += "async "), r += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", s && (e.opts.sourceCode || e.opts.processCode) && (r += " /*# sourceURL=" + s + " */ ")), typeof e.schema == "boolean" || !a && !e.schema.$ref) {
    var c = e.level, f = e.dataLevel, p = e.schema["false schema"], d = e.schemaPath + e.util.getProperty("false schema"), m = e.errSchemaPath + "/false schema", y = !e.opts.allErrors, v = "data" + (f || ""), b = "valid" + c;
    if (e.schema === !1) {
      e.isTop ? y = !0 : r += " var " + b + " = false; ", (ue = ue || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(m) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'boolean schema is false' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), r += " } ") : r += " {} ";
      var x = r;
      r = ue.pop(), !e.compositeRule && y ? e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    } else
      e.isTop ? r += i ? " return data; " : " validate.errors = null; return true; " : r += " var " + b + " = true; ";
    return e.isTop && (r += " }; return validate; "), r;
  }
  if (e.isTop) {
    var C = e.isTop;
    if (c = e.level = 0, f = e.dataLevel = 0, v = "data", e.rootId = e.resolve.fullPath(e.self._getId(e.root.schema)), e.baseId = e.baseId || e.rootId, delete e.isTop, e.dataPathArr = [void 0], e.schema.default !== void 0 && e.opts.useDefaults && e.opts.strictDefaults) {
      var k = "default is ignored in the schema root";
      if (e.opts.strictDefaults !== "log")
        throw new Error(k);
      e.logger.warn(k);
    }
    r += " var vErrors = null; ", r += " var errors = 0;     ", r += " if (rootData === undefined) rootData = data; ";
  } else {
    if (c = e.level, v = "data" + ((f = e.dataLevel) || ""), s && (e.baseId = e.resolve.url(e.baseId, s)), i && !e.async)
      throw new Error("async schema in sync schema");
    r += " var errs_" + c + " = errors;";
  }
  b = "valid" + c, y = !e.opts.allErrors;
  var F = "", B = "", O = e.schema.type, S = Array.isArray(O);
  if (O && e.opts.nullable && e.schema.nullable === !0 && (S ? O.indexOf("null") == -1 && (O = O.concat("null")) : O != "null" && (O = [O, "null"], S = !0)), S && O.length == 1 && (O = O[0], S = !1), e.schema.$ref && a) {
    if (e.opts.extendRefs == "fail")
      throw new Error('$ref: validation keywords used in schema at path "' + e.errSchemaPath + '" (see option extendRefs)');
    e.opts.extendRefs !== !0 && (a = !1, e.logger.warn('$ref: keywords ignored in schema at path "' + e.errSchemaPath + '"'));
  }
  if (e.schema.$comment && e.opts.$comment && (r += " " + e.RULES.all.$comment.code(e, "$comment")), O) {
    if (e.opts.coerceTypes)
      var w = e.util.coerceToTypes(e.opts.coerceTypes, O);
    var D = e.RULES.types[O];
    if (w || S || D === !0 || D && !De(D)) {
      d = e.schemaPath + ".type", m = e.errSchemaPath + "/type", d = e.schemaPath + ".type", m = e.errSchemaPath + "/type";
      var I = S ? "checkDataTypes" : "checkDataType";
      if (r += " if (" + e.util[I](O, v, !0) + ") { ", w) {
        var L = "dataType" + c, V = "coerced" + c;
        r += " var " + L + " = typeof " + v + "; ", e.opts.coerceTypes == "array" && (r += " if (" + L + " == 'object' && Array.isArray(" + v + ")) " + L + " = 'array'; "), r += " var " + V + " = undefined; ";
        var K = "", W = w;
        if (W)
          for (var R, q = -1, J = W.length - 1; q < J; )
            R = W[q += 1], q && (r += " if (" + V + " === undefined) { ", K += "}"), e.opts.coerceTypes == "array" && R != "array" && (r += " if (" + L + " == 'array' && " + v + ".length == 1) { " + V + " = " + v + " = " + v + "[0]; " + L + " = typeof " + v + ";  } "), R == "string" ? r += " if (" + L + " == 'number' || " + L + " == 'boolean') " + V + " = '' + " + v + "; else if (" + v + " === null) " + V + " = ''; " : R == "number" || R == "integer" ? (r += " if (" + L + " == 'boolean' || " + v + " === null || (" + L + " == 'string' && " + v + " && " + v + " == +" + v + " ", R == "integer" && (r += " && !(" + v + " % 1)"), r += ")) " + V + " = +" + v + "; ") : R == "boolean" ? r += " if (" + v + " === 'false' || " + v + " === 0 || " + v + " === null) " + V + " = false; else if (" + v + " === 'true' || " + v + " === 1) " + V + " = true; " : R == "null" ? r += " if (" + v + " === '' || " + v + " === 0 || " + v + " === false) " + V + " = null; " : e.opts.coerceTypes == "array" && R == "array" && (r += " if (" + L + " == 'string' || " + L + " == 'number' || " + L + " == 'boolean' || " + v + " == null) " + V + " = [" + v + "]; ");
        r += " " + K + " if (" + V + " === undefined) {   ", (ue = ue || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(m) + " , params: { type: '", r += S ? "" + O.join(",") : "" + O, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += S ? "" + O.join(",") : "" + O, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + d + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), r += " } ") : r += " {} ", x = r, r = ue.pop(), !e.compositeRule && y ? e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  ";
        var X = f ? "data" + (f - 1 || "") : "parentData";
        r += " " + v + " = " + V + "; ", f || (r += "if (" + X + " !== undefined)"), r += " " + X + "[" + (f ? e.dataPathArr[f] : "parentDataProperty") + "] = " + V + "; } ";
      } else
        (ue = ue || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(m) + " , params: { type: '", r += S ? "" + O.join(",") : "" + O, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += S ? "" + O.join(",") : "" + O, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + d + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), r += " } ") : r += " {} ", x = r, r = ue.pop(), !e.compositeRule && y ? e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      r += " } ";
    }
  }
  if (e.schema.$ref && !a)
    r += " " + e.RULES.all.$ref.code(e, "$ref") + " ", y && (r += " } if (errors === ", r += C ? "0" : "errs_" + c, r += ") { ", B += "}");
  else {
    var ce = e.RULES;
    if (ce) {
      for (var A = -1, M = ce.length - 1; A < M; )
        if (De(D = ce[A += 1])) {
          if (D.type && (r += " if (" + e.util.checkDataType(D.type, v) + ") { "), e.opts.useDefaults) {
            if (D.type == "object" && e.schema.properties) {
              p = e.schema.properties;
              var ne = Object.keys(p);
              if (ne) {
                for (var de, he = -1, j = ne.length - 1; he < j; )
                  if ((ge = p[de = ne[he += 1]]).default !== void 0) {
                    var ie = v + e.util.getProperty(de);
                    if (e.compositeRule) {
                      if (e.opts.strictDefaults) {
                        if (k = "default is ignored for: " + ie, e.opts.strictDefaults !== "log")
                          throw new Error(k);
                        e.logger.warn(k);
                      }
                    } else
                      r += " if (" + ie + " === undefined ", e.opts.useDefaults == "empty" && (r += " || " + ie + " === null || " + ie + " === '' "), r += " ) " + ie + " = ", e.opts.useDefaults == "shared" ? r += " " + e.useDefault(ge.default) + " " : r += " " + JSON.stringify(ge.default) + " ", r += "; ";
                  }
              }
            } else if (D.type == "array" && Array.isArray(e.schema.items)) {
              var fe = e.schema.items;
              if (fe) {
                q = -1;
                for (var ge, Fe = fe.length - 1; q < Fe; )
                  if ((ge = fe[q += 1]).default !== void 0)
                    if (ie = v + "[" + q + "]", e.compositeRule) {
                      if (e.opts.strictDefaults) {
                        if (k = "default is ignored for: " + ie, e.opts.strictDefaults !== "log")
                          throw new Error(k);
                        e.logger.warn(k);
                      }
                    } else
                      r += " if (" + ie + " === undefined ", e.opts.useDefaults == "empty" && (r += " || " + ie + " === null || " + ie + " === '' "), r += " ) " + ie + " = ", e.opts.useDefaults == "shared" ? r += " " + e.useDefault(ge.default) + " " : r += " " + JSON.stringify(ge.default) + " ", r += "; ";
              }
            }
          }
          var Pe = D.rules;
          if (Pe) {
            for (var _, Q = -1, Y = Pe.length - 1; Q < Y; )
              if (Ee(_ = Pe[Q += 1])) {
                var ae = _.code(e, _.keyword, D.type);
                ae && (r += " " + ae + " ", y && (F += "}"));
              }
          }
          if (y && (r += " " + F + " ", F = ""), D.type && (r += " } ", O && O === D.type && !w)) {
            r += " else { ";
            var ue;
            d = e.schemaPath + ".type", m = e.errSchemaPath + "/type", (ue = ue || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'type' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(m) + " , params: { type: '", r += S ? "" + O.join(",") : "" + O, r += "' } ", e.opts.messages !== !1 && (r += " , message: 'should be ", r += S ? "" + O.join(",") : "" + O, r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + d + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + v + " "), r += " } ") : r += " {} ", x = r, r = ue.pop(), !e.compositeRule && y ? e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ";
          }
          y && (r += " if (errors === ", r += C ? "0" : "errs_" + c, r += ") { ", B += "}");
        }
    }
  }
  function De(_e) {
    for (var Oe = _e.rules, Ye = 0; Ye < Oe.length; Ye++)
      if (Ee(Oe[Ye]))
        return !0;
  }
  function Ee(_e) {
    return e.schema[_e.keyword] !== void 0 || _e.implements && function(Oe) {
      for (var Ye = Oe.implements, _t = 0; _t < Ye.length; _t++)
        if (e.schema[Ye[_t]] !== void 0)
          return !0;
    }(_e);
  }
  return y && (r += " " + B + " "), C ? (i ? (r += " if (errors === 0) return data;           ", r += " else throw new ValidationError(vErrors); ") : (r += " validate.errors = vErrors; ", r += " return errors === 0;       "), r += " }; return validate;") : r += " var " + b + " = errors === errs_" + c + ";", r = e.util.cleanUpCode(r), C && (r = e.util.finalCleanUpCode(r, i)), r;
}, H8 = Mr.ucs2length, K8 = mc.Validation, zx = function e(t, n, r, i) {
  var a = this, s = this._opts, o = [void 0], u = {}, c = [], f = {}, p = [], d = {}, m = [];
  n = n || { schema: t, refVal: o, refs: u };
  var y = J8.call(this, t, n, i), v = this._compilations[y.index];
  if (y.compiling)
    return v.callValidate = function L() {
      var V = v.validate, K = V.apply(this, arguments);
      return L.errors = V.errors, K;
    };
  var b = this._formats, x = this.RULES;
  try {
    var C = F(t, n, r, i);
    v.validate = C;
    var k = v.callValidate;
    return k && (k.schema = C.schema, k.errors = null, k.refs = C.refs, k.refVal = C.refVal, k.root = C.root, k.$async = C.$async, s.sourceCode && (k.source = C.source)), C;
  } finally {
    Q8.call(this, t, n, i);
  }
  function F(L, V, K, W) {
    var R = !V || V && V.schema == L;
    if (V.schema != n.schema)
      return e.call(a, L, V, K, W);
    var q, J = L.$async === !0, X = Gm({ isTop: !0, schema: L, isRoot: R, baseId: W, root: V, schemaPath: "", errSchemaPath: "#", errorPath: '""', MissingRefError: mc.MissingRef, RULES: x, validate: Gm, util: Mr, resolve: xr, resolveRef: B, usePattern: w, useDefault: D, useCustomRule: I, opts: s, formats: b, logger: a.logger, self: a });
    X = Ul(o, Z8) + Ul(c, X8) + Ul(p, Y8) + Ul(m, eT) + X, s.processCode && (X = s.processCode(X));
    try {
      q = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", X)(a, x, b, n, o, p, m, Vp, H8, K8), o[0] = q;
    } catch (ce) {
      throw a.logger.error("Error compiling schema, function code:", X), ce;
    }
    return q.schema = L, q.errors = null, q.refs = u, q.refVal = o, q.root = R ? q : V, J && (q.$async = !0), s.sourceCode === !0 && (q.source = { code: X, patterns: c, defaults: p }), q;
  }
  function B(L, V, K) {
    V = xr.url(L, V);
    var W, R, q = u[V];
    if (q !== void 0)
      return S(W = o[q], R = "refVal[" + q + "]");
    if (!K && n.refs) {
      var J = n.refs[V];
      if (J !== void 0)
        return S(W = n.refVal[J], R = O(V, W));
    }
    R = O(V);
    var X = xr.call(a, F, n, V);
    if (X === void 0) {
      var ce = r && r[V];
      ce && (X = xr.inlineRef(ce, s.inlineRefs) ? ce : e.call(a, ce, n, r, L));
    }
    if (X !== void 0)
      return function(A, M) {
        var ne = u[A];
        o[ne] = M;
      }(V, X), S(X, R);
    (function(A) {
      delete u[A];
    })(V);
  }
  function O(L, V) {
    var K = o.length;
    return o[K] = V, u[L] = K, "refVal" + K;
  }
  function S(L, V) {
    return xe(L) == "object" || typeof L == "boolean" ? { code: V, schema: L, inline: !0 } : { code: V, $async: L && !!L.$async };
  }
  function w(L) {
    var V = f[L];
    return V === void 0 && (V = f[L] = c.length, c[V] = L), "pattern" + V;
  }
  function D(L) {
    switch (xe(L)) {
      case "boolean":
      case "number":
        return "" + L;
      case "string":
        return Mr.toQuotedString(L);
      case "object":
        if (L === null)
          return "null";
        var V = CD(L), K = d[V];
        return K === void 0 && (K = d[V] = p.length, p[K] = L), "default" + K;
    }
  }
  function I(L, V, K, W) {
    if (a._opts.validateSchema !== !1) {
      var R = L.definition.dependencies;
      if (R && !R.every(function(de) {
        return Object.prototype.hasOwnProperty.call(K, de);
      }))
        throw new Error("parent schema must have all required keywords: " + R.join(","));
      var q = L.definition.validateSchema;
      if (q && !q(V)) {
        var J = "keyword schema is invalid: " + a.errorsText(q.errors);
        if (a._opts.validateSchema != "log")
          throw new Error(J);
        a.logger.error(J);
      }
    }
    var X, ce = L.definition.compile, A = L.definition.inline, M = L.definition.macro;
    if (ce)
      X = ce.call(a, V, K, W);
    else if (M)
      X = M.call(a, V, K, W), s.validateSchema !== !1 && a.validateSchema(X, !0);
    else if (A)
      X = A.call(a, W, L.keyword, V, K);
    else if (!(X = L.definition.validate))
      return;
    if (X === void 0)
      throw new Error('custom keyword "' + L.keyword + '"failed to compile');
    var ne = m.length;
    return m[ne] = X, { code: "customRule" + ne, validate: X };
  }
};
function J8(e, t, n) {
  var r = SD.call(this, e, t, n);
  return r >= 0 ? { index: r, compiling: !0 } : (r = this._compilations.length, this._compilations[r] = { schema: e, root: t, baseId: n }, { index: r, compiling: !1 });
}
function Q8(e, t, n) {
  var r = SD.call(this, e, t, n);
  r >= 0 && this._compilations.splice(r, 1);
}
function SD(e, t, n) {
  for (var r = 0; r < this._compilations.length; r++) {
    var i = this._compilations[r];
    if (i.schema == e && i.root == t && i.baseId == n)
      return r;
  }
  return -1;
}
function X8(e, t) {
  return "var pattern" + e + " = new RegExp(" + Mr.toQuotedString(t[e]) + ");";
}
function Y8(e) {
  return "var default" + e + " = defaults[" + e + "];";
}
function Z8(e, t) {
  return t[e] === void 0 ? "" : "var refVal" + e + " = refVal[" + e + "];";
}
function eT(e) {
  return "var customRule" + e + " = customRules[" + e + "];";
}
function Ul(e, t) {
  if (!e.length)
    return "";
  for (var n = "", r = 0; r < e.length; r++)
    n += t(r, e);
  return n;
}
var tT = gt(function(e) {
  var t = e.exports = function() {
    this._cache = {};
  };
  t.prototype.put = function(n, r) {
    this._cache[n] = r;
  }, t.prototype.get = function(n) {
    return this._cache[n];
  }, t.prototype.del = function(n) {
    delete this._cache[n];
  }, t.prototype.clear = function() {
    this._cache = {};
  };
}), nT = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, rT = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iT = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i, Hx = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i, aT = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, Kx = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, Jx = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, Qx = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, Xx = /^(?:\/(?:[^~/]|~0|~1)*)*$/, Yx = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, Zx = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/, oT = Wp;
function Wp(e) {
  return e = e == "full" ? "full" : "fast", Mr.copy(Wp[e]);
}
function eb(e) {
  var t = e.match(nT);
  if (!t)
    return !1;
  var n = +t[1], r = +t[2], i = +t[3];
  return r >= 1 && r <= 12 && i >= 1 && i <= (r == 2 && function(a) {
    return a % 4 == 0 && (a % 100 != 0 || a % 400 == 0);
  }(n) ? 29 : rT[r]);
}
function tb(e, t) {
  var n = e.match(iT);
  if (!n)
    return !1;
  var r = n[1], i = n[2], a = n[3], s = n[5];
  return (r <= 23 && i <= 59 && a <= 59 || r == 23 && i == 59 && a == 60) && (!t || s);
}
Wp.fast = { date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/, time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i, "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i, uri: /^(?:[a-z][a-z0-9+-.]*:)(?:\/?\/)?[^\s]*$/i, "uri-reference": /^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i, "uri-template": Kx, url: Jx, email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i, hostname: Hx, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: nb, uuid: Qx, "json-pointer": Xx, "json-pointer-uri-fragment": Yx, "relative-json-pointer": Zx }, Wp.full = { date: eb, time: tb, "date-time": function(e) {
  var t = e.split(sT);
  return t.length == 2 && eb(t[0]) && tb(t[1], !0);
}, uri: function(e) {
  return uT.test(e) && aT.test(e);
}, "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, "uri-template": Kx, url: Jx, email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i, hostname: function(e) {
  return e.length <= 255 && Hx.test(e);
}, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: nb, uuid: Qx, "json-pointer": Xx, "json-pointer-uri-fragment": Yx, "relative-json-pointer": Zx };
var sT = /t|\s/i, uT = /\/|:/, cT = /[^\\]\\Z/;
function nb(e) {
  if (cT.test(e))
    return !1;
  try {
    return new RegExp(e), !0;
  } catch {
    return !1;
  }
}
var rb = function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o;
  var m = t == "maximum", y = m ? "exclusiveMaximum" : "exclusiveMinimum", v = e.schema[y], b = e.opts.$data && v && v.$data, x = m ? "<" : ">", C = m ? ">" : "<", k = void 0;
  if (b) {
    var F = e.util.getData(v.$data, s, e.dataPathArr), B = "exclusive" + a, O = "exclType" + a, S = "exclIsNumber" + a, w = "' + " + (L = "op" + a) + " + '";
    i += " var schemaExcl" + a + " = " + F + "; ", i += " var " + B + "; var " + O + " = typeof " + (F = "schemaExcl" + a) + "; if (" + O + " != 'boolean' && " + O + " != 'undefined' && " + O + " != 'number') { ";
    var D;
    k = y, (D = D || []).push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: '" + (k || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: {} ", e.opts.messages !== !1 && (i += " , message: '" + y + " should be boolean' "), e.opts.verbose && (i += " , schema: validate.schema" + u + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
    var I = i;
    i = D.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + I + "]); " : i += " validate.errors = [" + I + "]; return false; " : i += " var err = " + I + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } else if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), i += " " + O + " == 'number' ? ( (" + B + " = " + r + " === undefined || " + F + " " + x + "= " + r + ") ? " + p + " " + C + "= " + F + " : " + p + " " + C + " " + r + " ) : ( (" + B + " = " + F + " === true) ? " + p + " " + C + "= " + r + " : " + p + " " + C + " " + r + " ) || " + p + " !== " + p + ") { var op" + a + " = " + B + " ? '" + x + "' : '" + x + "='; ", o === void 0 && (k = y, c = e.errSchemaPath + "/" + y, r = F, d = b);
  } else if (w = x, (S = typeof v == "number") && d) {
    var L = "'" + w + "'";
    i += " if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), i += " ( " + r + " === undefined || " + v + " " + x + "= " + r + " ? " + p + " " + C + "= " + v + " : " + p + " " + C + " " + r + " ) || " + p + " !== " + p + ") { ";
  } else
    S && o === void 0 ? (B = !0, k = y, c = e.errSchemaPath + "/" + y, r = v, C += "=") : (S && (r = Math[m ? "min" : "max"](v, o)), v === (!S || r) ? (B = !0, k = y, c = e.errSchemaPath + "/" + y, C += "=") : (B = !1, w += "=")), L = "'" + w + "'", i += " if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), i += " " + p + " " + C + " " + r + " || " + p + " !== " + p + ") { ";
  return k = k || t, (D = D || []).push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: '" + (k || "_limit") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { comparison: " + L + ", limit: " + r + ", exclusive: " + B + " } ", e.opts.messages !== !1 && (i += " , message: 'should be " + w + " ", i += d ? "' + " + r : r + "'"), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ", I = i, i = D.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + I + "]); " : i += " validate.errors = [" + I + "]; return false; " : i += " var err = " + I + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", f && (i += " else { "), i;
}, ib = function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o, i += "if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), i += " " + p + ".length " + (t == "maxItems" ? ">" : "<") + " " + r + ") { ";
  var m = t, y = y || [];
  y.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: '" + (m || "_limitItems") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + r + " } ", e.opts.messages !== !1 && (i += " , message: 'should NOT have ", i += t == "maxItems" ? "more" : "fewer", i += " than ", i += d ? "' + " + r + " + '" : "" + o, i += " items' "), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
  var v = i;
  return i = y.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + v + "]); " : i += " validate.errors = [" + v + "]; return false; " : i += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f && (i += " else { "), i;
}, ab = function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o;
  var m = t == "maxLength" ? ">" : "<";
  i += "if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), e.opts.unicode === !1 ? i += " " + p + ".length " : i += " ucs2length(" + p + ") ", i += " " + m + " " + r + ") { ";
  var y = t, v = v || [];
  v.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: '" + (y || "_limitLength") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + r + " } ", e.opts.messages !== !1 && (i += " , message: 'should NOT be ", i += t == "maxLength" ? "longer" : "shorter", i += " than ", i += d ? "' + " + r + " + '" : "" + o, i += " characters' "), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
  var b = i;
  return i = v.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + b + "]); " : i += " validate.errors = [" + b + "]; return false; " : i += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f && (i += " else { "), i;
}, ob = function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o, i += "if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'number') || "), i += " Object.keys(" + p + ").length " + (t == "maxProperties" ? ">" : "<") + " " + r + ") { ";
  var m = t, y = y || [];
  y.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: '" + (m || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { limit: " + r + " } ", e.opts.messages !== !1 && (i += " , message: 'should NOT have ", i += t == "maxProperties" ? "more" : "fewer", i += " than ", i += d ? "' + " + r + " + '" : "" + o, i += " properties' "), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
  var v = i;
  return i = y.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + v + "]); " : i += " validate.errors = [" + v + "]; return false; " : i += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f && (i += " else { "), i;
}, sb = { $ref: function(e, t, n) {
  var r, i, a = " ", s = e.level, o = e.dataLevel, u = e.schema[t], c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (o || ""), d = "valid" + s;
  if (u == "#" || u == "#/")
    e.isRoot ? (r = e.async, i = "validate") : (r = e.root.schema.$async === !0, i = "root.refVal[0]");
  else {
    var m = e.resolveRef(e.baseId, u, e.isRoot);
    if (m === void 0) {
      var y = e.MissingRefError.message(e.baseId, u);
      if (e.opts.missingRefs == "fail") {
        e.logger.error(y), (C = C || []).push(a), a = "", e.createErrors !== !1 ? (a += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { ref: '" + e.util.escapeQuotes(u) + "' } ", e.opts.messages !== !1 && (a += " , message: 'can\\'t resolve reference " + e.util.escapeQuotes(u) + "' "), e.opts.verbose && (a += " , schema: " + e.util.toQuotedString(u) + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), a += " } ") : a += " {} ";
        var v = a;
        a = C.pop(), !e.compositeRule && f ? e.async ? a += " throw new ValidationError([" + v + "]); " : a += " validate.errors = [" + v + "]; return false; " : a += " var err = " + v + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", f && (a += " if (false) { ");
      } else {
        if (e.opts.missingRefs != "ignore")
          throw new e.MissingRefError(e.baseId, u, y);
        e.logger.warn(y), f && (a += " if (true) { ");
      }
    } else if (m.inline) {
      var b = e.util.copy(e);
      b.level++;
      var x = "valid" + b.level;
      b.schema = m.schema, b.schemaPath = "", b.errSchemaPath = u, a += " " + e.validate(b).replace(/validate\.schema/g, m.code) + " ", f && (a += " if (" + x + ") { ");
    } else
      r = m.$async === !0 || e.async && m.$async !== !1, i = m.code;
  }
  if (i) {
    var C;
    (C = C || []).push(a), a = "", e.opts.passContext ? a += " " + i + ".call(this, " : a += " " + i + "( ", a += " " + p + ", (dataPath || '')", e.errorPath != '""' && (a += " + " + e.errorPath);
    var k = a += " , " + (o ? "data" + (o - 1 || "") : "parentData") + " , " + (o ? e.dataPathArr[o] : "parentDataProperty") + ", rootData)  ";
    if (a = C.pop(), r) {
      if (!e.async)
        throw new Error("async schema referenced by sync schema");
      f && (a += " var " + d + "; "), a += " try { await " + k + "; ", f && (a += " " + d + " = true; "), a += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", f && (a += " " + d + " = false; "), a += " } ", f && (a += " if (" + d + ") { ");
    } else
      a += " if (!" + k + ") { if (vErrors === null) vErrors = " + i + ".errors; else vErrors = vErrors.concat(" + i + ".errors); errors = vErrors.length; } ", f && (a += " else { ");
  }
  return a;
}, allOf: function(e, t, n) {
  var r = " ", i = e.schema[t], a = e.schemaPath + e.util.getProperty(t), s = e.errSchemaPath + "/" + t, o = !e.opts.allErrors, u = e.util.copy(e), c = "";
  u.level++;
  var f = "valid" + u.level, p = u.baseId, d = !0, m = i;
  if (m)
    for (var y, v = -1, b = m.length - 1; v < b; )
      y = m[v += 1], (e.opts.strictKeywords ? xe(y) == "object" && Object.keys(y).length > 0 : e.util.schemaHasRules(y, e.RULES.all)) && (d = !1, u.schema = y, u.schemaPath = a + "[" + v + "]", u.errSchemaPath = s + "/" + v, r += "  " + e.validate(u) + " ", u.baseId = p, o && (r += " if (" + f + ") { ", c += "}"));
  return o && (r += d ? " if (true) { " : " " + c.slice(0, -1) + " "), r = e.util.cleanUpCode(r);
}, anyOf: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = "errs__" + i, m = e.util.copy(e), y = "";
  m.level++;
  var v = "valid" + m.level;
  if (s.every(function(O) {
    return e.opts.strictKeywords ? xe(O) == "object" && Object.keys(O).length > 0 : e.util.schemaHasRules(O, e.RULES.all);
  })) {
    var b = m.baseId;
    r += " var " + d + " = errors; var " + p + " = false;  ";
    var x = e.compositeRule;
    e.compositeRule = m.compositeRule = !0;
    var C = s;
    if (C)
      for (var k, F = -1, B = C.length - 1; F < B; )
        k = C[F += 1], m.schema = k, m.schemaPath = o + "[" + F + "]", m.errSchemaPath = u + "/" + F, r += "  " + e.validate(m) + " ", m.baseId = b, r += " " + p + " = " + p + " || " + v + "; if (!" + p + ") { ", y += "}";
    e.compositeRule = m.compositeRule = x, r += " " + y + " if (!" + p + ") {   var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should match some schema in anyOf' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " } else {  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; } ", e.opts.allErrors && (r += " } "), r = e.util.cleanUpCode(r);
  } else
    c && (r += " if (true) { ");
  return r;
}, $comment: function(e, t, n) {
  var r = " ", i = e.schema[t], a = e.errSchemaPath + "/" + t, s = (e.opts.allErrors, e.util.toQuotedString(i));
  return e.opts.$comment === !0 ? r += " console.log(" + s + ");" : typeof e.opts.$comment == "function" && (r += " self._opts.$comment(" + s + ", " + e.util.toQuotedString(a) + ", validate.root.schema);"), r;
}, const: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = e.opts.$data && s && s.$data;
  d && (r += " var schema" + i + " = " + e.util.getData(s.$data, a, e.dataPathArr) + "; "), d || (r += " var schema" + i + " = validate.schema" + o + ";"), r += "var " + p + " = equal(" + f + ", schema" + i + "); if (!" + p + ") {   ";
  var m = m || [];
  m.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'const' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { allowedValue: schema" + i + " } ", e.opts.messages !== !1 && (r += " , message: 'should be equal to constant' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
  var y = r;
  return r = m.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + y + "]); " : r += " validate.errors = [" + y + "]; return false; " : r += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", c && (r += " else { "), r;
}, contains: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = "errs__" + i, m = e.util.copy(e);
  m.level++;
  var y = "valid" + m.level, v = "i" + i, b = m.dataLevel = e.dataLevel + 1, x = "data" + b, C = e.baseId, k = e.opts.strictKeywords ? xe(s) == "object" && Object.keys(s).length > 0 : e.util.schemaHasRules(s, e.RULES.all);
  if (r += "var " + d + " = errors;var " + p + ";", k) {
    var F = e.compositeRule;
    e.compositeRule = m.compositeRule = !0, m.schema = s, m.schemaPath = o, m.errSchemaPath = u, r += " var " + y + " = false; for (var " + v + " = 0; " + v + " < " + f + ".length; " + v + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers, !0);
    var B = f + "[" + v + "]";
    m.dataPathArr[b] = v;
    var O = e.validate(m);
    m.baseId = C, e.util.varOccurences(O, x) < 2 ? r += " " + e.util.varReplace(O, x, B) + " " : r += " var " + x + " = " + B + "; " + O + " ", r += " if (" + y + ") break; }  ", e.compositeRule = m.compositeRule = F, r += "  if (!" + y + ") {";
  } else
    r += " if (" + f + ".length == 0) {";
  var S = S || [];
  S.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should contain a valid item' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
  var w = r;
  return r = S.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + w + "]); " : r += " validate.errors = [" + w + "]; return false; " : r += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ", k && (r += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; } "), e.opts.allErrors && (r += " } "), r = e.util.cleanUpCode(r);
}, dependencies: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "errs__" + i, d = e.util.copy(e), m = "";
  d.level++;
  var y = "valid" + d.level, v = {}, b = {}, x = e.opts.ownProperties;
  for (B in s) {
    var C = s[B], k = Array.isArray(C) ? b : v;
    k[B] = C;
  }
  r += "var " + p + " = errors;";
  var F = e.errorPath;
  for (var B in r += "var missing" + i + ";", b)
    if ((k = b[B]).length) {
      if (r += " if ( " + f + e.util.getProperty(B) + " !== undefined ", x && (r += " && Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(B) + "') "), c) {
        r += " && ( ";
        var O = k;
        if (O)
          for (var S = -1, w = O.length - 1; S < w; )
            W = O[S += 1], S && (r += " || "), r += " ( ( " + (X = f + (J = e.util.getProperty(W))) + " === undefined ", x && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(W) + "') "), r += ") && (missing" + i + " = " + e.util.toQuotedString(e.opts.jsonPointers ? W : J) + ") ) ";
        r += ")) {  ";
        var D = "missing" + i, I = "' + " + D + " + '";
        e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(F, D, !0) : F + " + " + D);
        var L = L || [];
        L.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { property: '" + e.util.escapeQuotes(B) + "', missingProperty: '" + I + "', depsCount: " + k.length + ", deps: '" + e.util.escapeQuotes(k.length == 1 ? k[0] : k.join(", ")) + "' } ", e.opts.messages !== !1 && (r += " , message: 'should have ", k.length == 1 ? r += "property " + e.util.escapeQuotes(k[0]) : r += "properties " + e.util.escapeQuotes(k.join(", ")), r += " when property " + e.util.escapeQuotes(B) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
        var V = r;
        r = L.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + V + "]); " : r += " validate.errors = [" + V + "]; return false; " : r += " var err = " + V + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else {
        r += " ) { ";
        var K = k;
        if (K)
          for (var W, R = -1, q = K.length - 1; R < q; ) {
            W = K[R += 1];
            var J = e.util.getProperty(W), X = (I = e.util.escapeQuotes(W), f + J);
            e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(F, W, e.opts.jsonPointers)), r += " if ( " + X + " === undefined ", x && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(W) + "') "), r += ") {  var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { property: '" + e.util.escapeQuotes(B) + "', missingProperty: '" + I + "', depsCount: " + k.length + ", deps: '" + e.util.escapeQuotes(k.length == 1 ? k[0] : k.join(", ")) + "' } ", e.opts.messages !== !1 && (r += " , message: 'should have ", k.length == 1 ? r += "property " + e.util.escapeQuotes(k[0]) : r += "properties " + e.util.escapeQuotes(k.join(", ")), r += " when property " + e.util.escapeQuotes(B) + " is present' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
      }
      r += " }   ", c && (m += "}", r += " else { ");
    }
  e.errorPath = F;
  var ce = d.baseId;
  for (var B in v)
    C = v[B], (e.opts.strictKeywords ? xe(C) == "object" && Object.keys(C).length > 0 : e.util.schemaHasRules(C, e.RULES.all)) && (r += " " + y + " = true; if ( " + f + e.util.getProperty(B) + " !== undefined ", x && (r += " && Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(B) + "') "), r += ") { ", d.schema = C, d.schemaPath = o + e.util.getProperty(B), d.errSchemaPath = u + "/" + e.util.escapeFragment(B), r += "  " + e.validate(d) + " ", d.baseId = ce, r += " }  ", c && (r += " if (" + y + ") { ", m += "}"));
  return c && (r += "   " + m + " if (" + p + " == errors) {"), r = e.util.cleanUpCode(r);
}, enum: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = e.opts.$data && s && s.$data;
  d && (r += " var schema" + i + " = " + e.util.getData(s.$data, a, e.dataPathArr) + "; ");
  var m = "i" + i, y = "schema" + i;
  d || (r += " var " + y + " = validate.schema" + o + ";"), r += "var " + p + ";", d && (r += " if (schema" + i + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + i + ")) " + p + " = false; else {"), r += p + " = false;for (var " + m + "=0; " + m + "<" + y + ".length; " + m + "++) if (equal(" + f + ", " + y + "[" + m + "])) { " + p + " = true; break; }", d && (r += "  }  "), r += " if (!" + p + ") {   ";
  var v = v || [];
  v.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { allowedValues: schema" + i + " } ", e.opts.messages !== !1 && (r += " , message: 'should be equal to one of the allowed values' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
  var b = r;
  return r = v.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + b + "]); " : r += " validate.errors = [" + b + "]; return false; " : r += " var err = " + b + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " }", c && (r += " else { "), r;
}, format: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || "");
  if (e.opts.format === !1)
    return c && (r += " if (true) { "), r;
  var p, d = e.opts.$data && s && s.$data;
  d ? (r += " var schema" + i + " = " + e.util.getData(s.$data, a, e.dataPathArr) + "; ", p = "schema" + i) : p = s;
  var m = e.opts.unknownFormats, y = Array.isArray(m);
  if (d)
    r += " var " + (v = "format" + i) + " = formats[" + p + "]; var " + (b = "isObject" + i) + " = typeof " + v + " == 'object' && !(" + v + " instanceof RegExp) && " + v + ".validate; var " + (x = "formatType" + i) + " = " + b + " && " + v + ".type || 'string'; if (" + b + ") { ", e.async && (r += " var async" + i + " = " + v + ".async; "), r += " " + v + " = " + v + ".validate; } if (  ", d && (r += " (" + p + " !== undefined && typeof " + p + " != 'string') || "), r += " (", m != "ignore" && (r += " (" + p + " && !" + v + " ", y && (r += " && self._opts.unknownFormats.indexOf(" + p + ") == -1 "), r += ") || "), r += " (" + v + " && " + x + " == '" + n + "' && !(typeof " + v + " == 'function' ? ", e.async ? r += " (async" + i + " ? await " + v + "(" + f + ") : " + v + "(" + f + ")) " : r += " " + v + "(" + f + ") ", r += " : " + v + ".test(" + f + "))))) {";
  else {
    var v;
    if (!(v = e.formats[s])) {
      if (m == "ignore")
        return e.logger.warn('unknown format "' + s + '" ignored in schema at path "' + e.errSchemaPath + '"'), c && (r += " if (true) { "), r;
      if (y && m.indexOf(s) >= 0)
        return c && (r += " if (true) { "), r;
      throw new Error('unknown format "' + s + '" is used in schema at path "' + e.errSchemaPath + '"');
    }
    var b, x = (b = xe(v) == "object" && !(v instanceof RegExp) && v.validate) && v.type || "string";
    if (b) {
      var C = v.async === !0;
      v = v.validate;
    }
    if (x != n)
      return c && (r += " if (true) { "), r;
    if (C) {
      if (!e.async)
        throw new Error("async format in sync schema");
      r += " if (!(await " + (k = "formats" + e.util.getProperty(s) + ".validate") + "(" + f + "))) { ";
    } else {
      r += " if (! ";
      var k = "formats" + e.util.getProperty(s);
      b && (k += ".validate"), r += typeof v == "function" ? " " + k + "(" + f + ") " : " " + k + ".test(" + f + ") ", r += ") { ";
    }
  }
  var F = F || [];
  F.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'format' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { format:  ", r += d ? "" + p : "" + e.util.toQuotedString(s), r += "  } ", e.opts.messages !== !1 && (r += ` , message: 'should match format "`, r += d ? "' + " + p + " + '" : "" + e.util.escapeQuotes(s), r += `"' `), e.opts.verbose && (r += " , schema:  ", r += d ? "validate.schema" + o : "" + e.util.toQuotedString(s), r += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
  var B = r;
  return r = F.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + B + "]); " : r += " validate.errors = [" + B + "]; return false; " : r += " var err = " + B + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", c && (r += " else { "), r;
}, if: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = "errs__" + i, m = e.util.copy(e);
  m.level++;
  var y = "valid" + m.level, v = e.schema.then, b = e.schema.else, x = v !== void 0 && (e.opts.strictKeywords ? xe(v) == "object" && Object.keys(v).length > 0 : e.util.schemaHasRules(v, e.RULES.all)), C = b !== void 0 && (e.opts.strictKeywords ? xe(b) == "object" && Object.keys(b).length > 0 : e.util.schemaHasRules(b, e.RULES.all)), k = m.baseId;
  if (x || C) {
    var F;
    m.createErrors = !1, m.schema = s, m.schemaPath = o, m.errSchemaPath = u, r += " var " + d + " = errors; var " + p + " = true;  ";
    var B = e.compositeRule;
    e.compositeRule = m.compositeRule = !0, r += "  " + e.validate(m) + " ", m.baseId = k, m.createErrors = !0, r += "  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }  ", e.compositeRule = m.compositeRule = B, x ? (r += " if (" + y + ") {  ", m.schema = e.schema.then, m.schemaPath = e.schemaPath + ".then", m.errSchemaPath = e.errSchemaPath + "/then", r += "  " + e.validate(m) + " ", m.baseId = k, r += " " + p + " = " + y + "; ", x && C ? r += " var " + (F = "ifClause" + i) + " = 'then'; " : F = "'then'", r += " } ", C && (r += " else { ")) : r += " if (!" + y + ") { ", C && (m.schema = e.schema.else, m.schemaPath = e.schemaPath + ".else", m.errSchemaPath = e.errSchemaPath + "/else", r += "  " + e.validate(m) + " ", m.baseId = k, r += " " + p + " = " + y + "; ", x && C ? r += " var " + (F = "ifClause" + i) + " = 'else'; " : F = "'else'", r += " } "), r += " if (!" + p + ") {   var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'if' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { failingKeyword: " + F + " } ", e.opts.messages !== !1 && (r += ` , message: 'should match "' + ` + F + ` + '" schema' `), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += " }   ", c && (r += " else { "), r = e.util.cleanUpCode(r);
  } else
    c && (r += " if (true) { ");
  return r;
}, items: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = "errs__" + i, m = e.util.copy(e), y = "";
  m.level++;
  var v = "valid" + m.level, b = "i" + i, x = m.dataLevel = e.dataLevel + 1, C = "data" + x, k = e.baseId;
  if (r += "var " + d + " = errors;var " + p + ";", Array.isArray(s)) {
    var F = e.schema.additionalItems;
    if (F === !1) {
      r += " " + p + " = " + f + ".length <= " + s.length + "; ";
      var B = u;
      u = e.errSchemaPath + "/additionalItems", r += "  if (!" + p + ") {   ";
      var O = O || [];
      O.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { limit: " + s.length + " } ", e.opts.messages !== !1 && (r += " , message: 'should NOT have more than " + s.length + " items' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
      var S = r;
      r = O.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + S + "]); " : r += " validate.errors = [" + S + "]; return false; " : r += " var err = " + S + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } ", u = B, c && (y += "}", r += " else { ");
    }
    var w = s;
    if (w) {
      for (var D, I = -1, L = w.length - 1; I < L; )
        if (D = w[I += 1], e.opts.strictKeywords ? xe(D) == "object" && Object.keys(D).length > 0 : e.util.schemaHasRules(D, e.RULES.all)) {
          r += " " + v + " = true; if (" + f + ".length > " + I + ") { ";
          var V = f + "[" + I + "]";
          m.schema = D, m.schemaPath = o + "[" + I + "]", m.errSchemaPath = u + "/" + I, m.errorPath = e.util.getPathExpr(e.errorPath, I, e.opts.jsonPointers, !0), m.dataPathArr[x] = I;
          var K = e.validate(m);
          m.baseId = k, e.util.varOccurences(K, C) < 2 ? r += " " + e.util.varReplace(K, C, V) + " " : r += " var " + C + " = " + V + "; " + K + " ", r += " }  ", c && (r += " if (" + v + ") { ", y += "}");
        }
    }
    xe(F) == "object" && (e.opts.strictKeywords ? xe(F) == "object" && Object.keys(F).length > 0 : e.util.schemaHasRules(F, e.RULES.all)) && (m.schema = F, m.schemaPath = e.schemaPath + ".additionalItems", m.errSchemaPath = e.errSchemaPath + "/additionalItems", r += " " + v + " = true; if (" + f + ".length > " + s.length + ") {  for (var " + b + " = " + s.length + "; " + b + " < " + f + ".length; " + b + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), V = f + "[" + b + "]", m.dataPathArr[x] = b, K = e.validate(m), m.baseId = k, e.util.varOccurences(K, C) < 2 ? r += " " + e.util.varReplace(K, C, V) + " " : r += " var " + C + " = " + V + "; " + K + " ", c && (r += " if (!" + v + ") break; "), r += " } }  ", c && (r += " if (" + v + ") { ", y += "}"));
  } else
    (e.opts.strictKeywords ? xe(s) == "object" && Object.keys(s).length > 0 : e.util.schemaHasRules(s, e.RULES.all)) && (m.schema = s, m.schemaPath = o, m.errSchemaPath = u, r += "  for (var " + b + " = 0; " + b + " < " + f + ".length; " + b + "++) { ", m.errorPath = e.util.getPathExpr(e.errorPath, b, e.opts.jsonPointers, !0), V = f + "[" + b + "]", m.dataPathArr[x] = b, K = e.validate(m), m.baseId = k, e.util.varOccurences(K, C) < 2 ? r += " " + e.util.varReplace(K, C, V) + " " : r += " var " + C + " = " + V + "; " + K + " ", c && (r += " if (!" + v + ") break; "), r += " }");
  return c && (r += " " + y + " if (" + d + " == errors) {"), r = e.util.cleanUpCode(r);
}, maximum: rb, minimum: rb, maxItems: ib, minItems: ib, maxLength: ab, minLength: ab, maxProperties: ob, minProperties: ob, multipleOf: function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o, i += "var division" + a + ";if (", d && (i += " " + r + " !== undefined && ( typeof " + r + " != 'number' || "), i += " (division" + a + " = " + p + " / " + r + ", ", e.opts.multipleOfPrecision ? i += " Math.abs(Math.round(division" + a + ") - division" + a + ") > 1e-" + e.opts.multipleOfPrecision + " " : i += " division" + a + " !== parseInt(division" + a + ") ", i += " ) ", d && (i += "  )  "), i += " ) {   ";
  var m = m || [];
  m.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { multipleOf: " + r + " } ", e.opts.messages !== !1 && (i += " , message: 'should be multiple of ", i += d ? "' + " + r : r + "'"), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
  var y = i;
  return i = m.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + y + "]); " : i += " validate.errors = [" + y + "]; return false; " : i += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f && (i += " else { "), i;
}, not: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "errs__" + i, d = e.util.copy(e);
  d.level++;
  var m = "valid" + d.level;
  if (e.opts.strictKeywords ? xe(s) == "object" && Object.keys(s).length > 0 : e.util.schemaHasRules(s, e.RULES.all)) {
    d.schema = s, d.schemaPath = o, d.errSchemaPath = u, r += " var " + p + " = errors;  ";
    var y, v = e.compositeRule;
    e.compositeRule = d.compositeRule = !0, d.createErrors = !1, d.opts.allErrors && (y = d.opts.allErrors, d.opts.allErrors = !1), r += " " + e.validate(d) + " ", d.createErrors = !0, y && (d.opts.allErrors = y), e.compositeRule = d.compositeRule = v, r += " if (" + m + ") {   ";
    var b = b || [];
    b.push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
    var x = r;
    r = b.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + x + "]); " : r += " validate.errors = [" + x + "]; return false; " : r += " var err = " + x + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else {  errors = " + p + "; if (vErrors !== null) { if (" + p + ") vErrors.length = " + p + "; else vErrors = null; } ", e.opts.allErrors && (r += " } ");
  } else
    r += "  var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'not' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: {} ", e.opts.messages !== !1 && (r += " , message: 'should NOT be valid' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c && (r += " if (false) { ");
  return r;
}, oneOf: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = "errs__" + i, m = e.util.copy(e), y = "";
  m.level++;
  var v = "valid" + m.level, b = m.baseId, x = "prevValid" + i, C = "passingSchemas" + i;
  r += "var " + d + " = errors , " + x + " = false , " + p + " = false , " + C + " = null; ";
  var k = e.compositeRule;
  e.compositeRule = m.compositeRule = !0;
  var F = s;
  if (F)
    for (var B, O = -1, S = F.length - 1; O < S; )
      B = F[O += 1], (e.opts.strictKeywords ? xe(B) == "object" && Object.keys(B).length > 0 : e.util.schemaHasRules(B, e.RULES.all)) ? (m.schema = B, m.schemaPath = o + "[" + O + "]", m.errSchemaPath = u + "/" + O, r += "  " + e.validate(m) + " ", m.baseId = b) : r += " var " + v + " = true; ", O && (r += " if (" + v + " && " + x + ") { " + p + " = false; " + C + " = [" + C + ", " + O + "]; } else { ", y += "}"), r += " if (" + v + ") { " + p + " = " + x + " = true; " + C + " = " + O + "; }";
  return e.compositeRule = m.compositeRule = k, r += y + "if (!" + p + ") {   var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { passingSchemas: " + C + " } ", e.opts.messages !== !1 && (r += " , message: 'should match exactly one schema in oneOf' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), r += "} else {  errors = " + d + "; if (vErrors !== null) { if (" + d + ") vErrors.length = " + d + "; else vErrors = null; }", e.opts.allErrors && (r += " } "), r;
}, pattern: function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = e.opts.$data && o && o.$data;
  d ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o, i += "if ( ", d && (i += " (" + r + " !== undefined && typeof " + r + " != 'string') || "), i += " !" + (d ? "(new RegExp(" + r + "))" : e.usePattern(o)) + ".test(" + p + ") ) {   ";
  var m = m || [];
  m.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { pattern:  ", i += d ? "" + r : "" + e.util.toQuotedString(o), i += "  } ", e.opts.messages !== !1 && (i += ` , message: 'should match pattern "`, i += d ? "' + " + r + " + '" : "" + e.util.escapeQuotes(o), i += `"' `), e.opts.verbose && (i += " , schema:  ", i += d ? "validate.schema" + u : "" + e.util.toQuotedString(o), i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
  var y = i;
  return i = m.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + y + "]); " : i += " validate.errors = [" + y + "]; return false; " : i += " var err = " + y + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += "} ", f && (i += " else { "), i;
}, properties: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "errs__" + i, d = e.util.copy(e), m = "";
  d.level++;
  var y = "valid" + d.level, v = "key" + i, b = "idx" + i, x = d.dataLevel = e.dataLevel + 1, C = "data" + x, k = "dataProperties" + i, F = Object.keys(s || {}), B = e.schema.patternProperties || {}, O = Object.keys(B), S = e.schema.additionalProperties, w = F.length || O.length, D = S === !1, I = xe(S) == "object" && Object.keys(S).length, L = e.opts.removeAdditional, V = D || I || L, K = e.opts.ownProperties, W = e.baseId, R = e.schema.required;
  if (R && (!e.opts.$data || !R.$data) && R.length < e.opts.loopRequired)
    var q = e.util.toHash(R);
  if (r += "var " + p + " = errors;var " + y + " = true;", K && (r += " var " + k + " = undefined;"), V) {
    if (r += K ? " " + k + " = " + k + " || Object.keys(" + f + "); for (var " + b + "=0; " + b + "<" + k + ".length; " + b + "++) { var " + v + " = " + k + "[" + b + "]; " : " for (var " + v + " in " + f + ") { ", w) {
      if (r += " var isAdditional" + i + " = !(false ", F.length)
        if (F.length > 8)
          r += " || validate.schema" + o + ".hasOwnProperty(" + v + ") ";
        else {
          var J = F;
          if (J)
            for (var X = -1, ce = J.length - 1; X < ce; )
              Q = J[X += 1], r += " || " + v + " == " + e.util.toQuotedString(Q) + " ";
        }
      if (O.length) {
        var A = O;
        if (A)
          for (var M = -1, ne = A.length - 1; M < ne; )
            Kt = A[M += 1], r += " || " + e.usePattern(Kt) + ".test(" + v + ") ";
      }
      r += " ); if (isAdditional" + i + ") { ";
    }
    if (L == "all")
      r += " delete " + f + "[" + v + "]; ";
    else {
      var de = e.errorPath, he = "' + " + v + " + '";
      if (e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers)), D)
        if (L)
          r += " delete " + f + "[" + v + "]; ";
        else {
          r += " " + y + " = false; ";
          var j = u;
          u = e.errSchemaPath + "/additionalProperties", (Oe = Oe || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { additionalProperty: '" + he + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is an invalid additional property" : r += "should NOT have additional properties", r += "' "), e.opts.verbose && (r += " , schema: false , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
          var ie = r;
          r = Oe.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + ie + "]); " : r += " validate.errors = [" + ie + "]; return false; " : r += " var err = " + ie + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = j, c && (r += " break; ");
        }
      else if (I)
        if (L == "failing") {
          r += " var " + p + " = errors;  ";
          var fe = e.compositeRule;
          e.compositeRule = d.compositeRule = !0, d.schema = S, d.schemaPath = e.schemaPath + ".additionalProperties", d.errSchemaPath = e.errSchemaPath + "/additionalProperties", d.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers);
          var ge = f + "[" + v + "]";
          d.dataPathArr[x] = v;
          var Fe = e.validate(d);
          d.baseId = W, e.util.varOccurences(Fe, C) < 2 ? r += " " + e.util.varReplace(Fe, C, ge) + " " : r += " var " + C + " = " + ge + "; " + Fe + " ", r += " if (!" + y + ") { errors = " + p + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + f + "[" + v + "]; }  ", e.compositeRule = d.compositeRule = fe;
        } else
          d.schema = S, d.schemaPath = e.schemaPath + ".additionalProperties", d.errSchemaPath = e.errSchemaPath + "/additionalProperties", d.errorPath = e.opts._errorDataPathProperty ? e.errorPath : e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers), ge = f + "[" + v + "]", d.dataPathArr[x] = v, Fe = e.validate(d), d.baseId = W, e.util.varOccurences(Fe, C) < 2 ? r += " " + e.util.varReplace(Fe, C, ge) + " " : r += " var " + C + " = " + ge + "; " + Fe + " ", c && (r += " if (!" + y + ") break; ");
      e.errorPath = de;
    }
    w && (r += " } "), r += " }  ", c && (r += " if (" + y + ") { ", m += "}");
  }
  var Pe = e.opts.useDefaults && !e.compositeRule;
  if (F.length) {
    var _ = F;
    if (_)
      for (var Q, Y = -1, ae = _.length - 1; Y < ae; ) {
        var ue = s[Q = _[Y += 1]];
        if (e.opts.strictKeywords ? xe(ue) == "object" && Object.keys(ue).length > 0 : e.util.schemaHasRules(ue, e.RULES.all)) {
          var De = e.util.getProperty(Q), Ee = (ge = f + De, Pe && ue.default !== void 0);
          if (d.schema = ue, d.schemaPath = o + De, d.errSchemaPath = u + "/" + e.util.escapeFragment(Q), d.errorPath = e.util.getPath(e.errorPath, Q, e.opts.jsonPointers), d.dataPathArr[x] = e.util.toQuotedString(Q), Fe = e.validate(d), d.baseId = W, e.util.varOccurences(Fe, C) < 2) {
            Fe = e.util.varReplace(Fe, C, ge);
            var _e = ge;
          } else
            _e = C, r += " var " + C + " = " + ge + "; ";
          if (Ee)
            r += " " + Fe + " ";
          else {
            if (q && q[Q]) {
              r += " if ( " + _e + " === undefined ", K && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(Q) + "') "), r += ") { " + y + " = false; ", de = e.errorPath, j = u;
              var Oe, Ye = e.util.escapeQuotes(Q);
              e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(de, Q, e.opts.jsonPointers)), u = e.errSchemaPath + "/required", (Oe = Oe || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + Ye + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + Ye + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", ie = r, r = Oe.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + ie + "]); " : r += " validate.errors = [" + ie + "]; return false; " : r += " var err = " + ie + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", u = j, e.errorPath = de, r += " } else { ";
            } else
              c ? (r += " if ( " + _e + " === undefined ", K && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(Q) + "') "), r += ") { " + y + " = true; } else { ") : (r += " if (" + _e + " !== undefined ", K && (r += " &&   Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(Q) + "') "), r += " ) { ");
            r += " " + Fe + " } ";
          }
        }
        c && (r += " if (" + y + ") { ", m += "}");
      }
  }
  if (O.length) {
    var _t = O;
    if (_t)
      for (var Kt, Jt = -1, zt = _t.length - 1; Jt < zt; )
        ue = B[Kt = _t[Jt += 1]], (e.opts.strictKeywords ? xe(ue) == "object" && Object.keys(ue).length > 0 : e.util.schemaHasRules(ue, e.RULES.all)) && (d.schema = ue, d.schemaPath = e.schemaPath + ".patternProperties" + e.util.getProperty(Kt), d.errSchemaPath = e.errSchemaPath + "/patternProperties/" + e.util.escapeFragment(Kt), r += K ? " " + k + " = " + k + " || Object.keys(" + f + "); for (var " + b + "=0; " + b + "<" + k + ".length; " + b + "++) { var " + v + " = " + k + "[" + b + "]; " : " for (var " + v + " in " + f + ") { ", r += " if (" + e.usePattern(Kt) + ".test(" + v + ")) { ", d.errorPath = e.util.getPathExpr(e.errorPath, v, e.opts.jsonPointers), ge = f + "[" + v + "]", d.dataPathArr[x] = v, Fe = e.validate(d), d.baseId = W, e.util.varOccurences(Fe, C) < 2 ? r += " " + e.util.varReplace(Fe, C, ge) + " " : r += " var " + C + " = " + ge + "; " + Fe + " ", c && (r += " if (!" + y + ") break; "), r += " } ", c && (r += " else " + y + " = true; "), r += " }  ", c && (r += " if (" + y + ") { ", m += "}"));
  }
  return c && (r += " " + m + " if (" + p + " == errors) {"), r = e.util.cleanUpCode(r);
}, propertyNames: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "errs__" + i, d = e.util.copy(e);
  d.level++;
  var m = "valid" + d.level;
  if (r += "var " + p + " = errors;", e.opts.strictKeywords ? xe(s) == "object" && Object.keys(s).length > 0 : e.util.schemaHasRules(s, e.RULES.all)) {
    d.schema = s, d.schemaPath = o, d.errSchemaPath = u;
    var y = "key" + i, v = "idx" + i, b = "i" + i, x = "' + " + y + " + '", C = "data" + (d.dataLevel = e.dataLevel + 1), k = "dataProperties" + i, F = e.opts.ownProperties, B = e.baseId;
    F && (r += " var " + k + " = undefined; "), r += F ? " " + k + " = " + k + " || Object.keys(" + f + "); for (var " + v + "=0; " + v + "<" + k + ".length; " + v + "++) { var " + y + " = " + k + "[" + v + "]; " : " for (var " + y + " in " + f + ") { ", r += " var startErrs" + i + " = errors; ";
    var O = y, S = e.compositeRule;
    e.compositeRule = d.compositeRule = !0;
    var w = e.validate(d);
    d.baseId = B, e.util.varOccurences(w, C) < 2 ? r += " " + e.util.varReplace(w, C, O) + " " : r += " var " + C + " = " + O + "; " + w + " ", e.compositeRule = d.compositeRule = S, r += " if (!" + m + ") { for (var " + b + "=startErrs" + i + "; " + b + "<errors; " + b + "++) { vErrors[" + b + "].propertyName = " + y + "; }   var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { propertyName: '" + x + "' } ", e.opts.messages !== !1 && (r += " , message: 'property name \\'" + x + "\\' is invalid' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && c && (e.async ? r += " throw new ValidationError(vErrors); " : r += " validate.errors = vErrors; return false; "), c && (r += " break; "), r += " } }";
  }
  return c && (r += "  if (" + p + " == errors) {"), r = e.util.cleanUpCode(r);
}, required: function(e, t, n) {
  var r = " ", i = e.level, a = e.dataLevel, s = e.schema[t], o = e.schemaPath + e.util.getProperty(t), u = e.errSchemaPath + "/" + t, c = !e.opts.allErrors, f = "data" + (a || ""), p = "valid" + i, d = e.opts.$data && s && s.$data;
  d && (r += " var schema" + i + " = " + e.util.getData(s.$data, a, e.dataPathArr) + "; ");
  var m = "schema" + i;
  if (!d)
    if (s.length < e.opts.loopRequired && e.schema.properties && Object.keys(e.schema.properties).length) {
      var y = [], v = s;
      if (v)
        for (var b, x = -1, C = v.length - 1; x < C; ) {
          b = v[x += 1];
          var k = e.schema.properties[b];
          k && (e.opts.strictKeywords ? xe(k) == "object" && Object.keys(k).length > 0 : e.util.schemaHasRules(k, e.RULES.all)) || (y[y.length] = b);
        }
    } else
      y = s;
  if (d || y.length) {
    var F = e.errorPath, B = d || y.length >= e.opts.loopRequired, O = e.opts.ownProperties;
    if (c)
      if (r += " var missing" + i + "; ", B) {
        d || (r += " var " + m + " = validate.schema" + o + "; ");
        var S = "' + " + (K = "schema" + i + "[" + (I = "i" + i) + "]") + " + '";
        e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(F, K, e.opts.jsonPointers)), r += " var " + p + " = true; ", d && (r += " if (schema" + i + " === undefined) " + p + " = true; else if (!Array.isArray(schema" + i + ")) " + p + " = false; else {"), r += " for (var " + I + " = 0; " + I + " < " + m + ".length; " + I + "++) { " + p + " = " + f + "[" + m + "[" + I + "]] !== undefined ", O && (r += " &&   Object.prototype.hasOwnProperty.call(" + f + ", " + m + "[" + I + "]) "), r += "; if (!" + p + ") break; } ", d && (r += "  }  "), r += "  if (!" + p + ") {   ", (V = V || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + S + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + S + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ";
        var w = r;
        r = V.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + w + "]); " : r += " validate.errors = [" + w + "]; return false; " : r += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
      } else {
        r += " if ( ";
        var D = y;
        if (D)
          for (var I = -1, L = D.length - 1; I < L; )
            R = D[I += 1], I && (r += " || "), r += " ( ( " + (ce = f + (X = e.util.getProperty(R))) + " === undefined ", O && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(R) + "') "), r += ") && (missing" + i + " = " + e.util.toQuotedString(e.opts.jsonPointers ? R : X) + ") ) ";
        r += ") {  ";
        var V;
        S = "' + " + (K = "missing" + i) + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.opts.jsonPointers ? e.util.getPathExpr(F, K, !0) : F + " + " + K), (V = V || []).push(r), r = "", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + S + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + S + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", w = r, r = V.pop(), !e.compositeRule && c ? e.async ? r += " throw new ValidationError([" + w + "]); " : r += " validate.errors = [" + w + "]; return false; " : r += " var err = " + w + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", r += " } else { ";
      }
    else if (B) {
      d || (r += " var " + m + " = validate.schema" + o + "; ");
      var K;
      S = "' + " + (K = "schema" + i + "[" + (I = "i" + i) + "]") + " + '", e.opts._errorDataPathProperty && (e.errorPath = e.util.getPathExpr(F, K, e.opts.jsonPointers)), d && (r += " if (" + m + " && !Array.isArray(" + m + ")) {  var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + S + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + S + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + m + " !== undefined) { "), r += " for (var " + I + " = 0; " + I + " < " + m + ".length; " + I + "++) { if (" + f + "[" + m + "[" + I + "]] === undefined ", O && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", " + m + "[" + I + "]) "), r += ") {  var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + S + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + S + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", d && (r += "  }  ");
    } else {
      var W = y;
      if (W)
        for (var R, q = -1, J = W.length - 1; q < J; ) {
          R = W[q += 1];
          var X = e.util.getProperty(R), ce = (S = e.util.escapeQuotes(R), f + X);
          e.opts._errorDataPathProperty && (e.errorPath = e.util.getPath(F, R, e.opts.jsonPointers)), r += " if ( " + ce + " === undefined ", O && (r += " || ! Object.prototype.hasOwnProperty.call(" + f + ", '" + e.util.escapeQuotes(R) + "') "), r += ") {  var err =   ", e.createErrors !== !1 ? (r += " { keyword: 'required' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(u) + " , params: { missingProperty: '" + S + "' } ", e.opts.messages !== !1 && (r += " , message: '", e.opts._errorDataPathProperty ? r += "is a required property" : r += "should have required property \\'" + S + "\\'", r += "' "), e.opts.verbose && (r += " , schema: validate.schema" + o + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + f + " "), r += " } ") : r += " {} ", r += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
        }
    }
    e.errorPath = F;
  } else
    c && (r += " if (true) {");
  return r;
}, uniqueItems: function(e, t, n) {
  var r, i = " ", a = e.level, s = e.dataLevel, o = e.schema[t], u = e.schemaPath + e.util.getProperty(t), c = e.errSchemaPath + "/" + t, f = !e.opts.allErrors, p = "data" + (s || ""), d = "valid" + a, m = e.opts.$data && o && o.$data;
  if (m ? (i += " var schema" + a + " = " + e.util.getData(o.$data, s, e.dataPathArr) + "; ", r = "schema" + a) : r = o, (o || m) && e.opts.uniqueItems !== !1) {
    m && (i += " var " + d + "; if (" + r + " === false || " + r + " === undefined) " + d + " = true; else if (typeof " + r + " != 'boolean') " + d + " = false; else { "), i += " var i = " + p + ".length , " + d + " = true , j; if (i > 1) { ";
    var y = e.schema.items && e.schema.items.type, v = Array.isArray(y);
    if (!y || y == "object" || y == "array" || v && (y.indexOf("object") >= 0 || y.indexOf("array") >= 0))
      i += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + p + "[i], " + p + "[j])) { " + d + " = false; break outer; } } } ";
    else {
      i += " var itemIndices = {}, item; for (;i--;) { var item = " + p + "[i]; ";
      var b = "checkDataType" + (v ? "s" : "");
      i += " if (" + e.util[b](y, "item", !0) + ") continue; ", v && (i += ` if (typeof item == 'string') item = '"' + item; `), i += " if (typeof itemIndices[item] == 'number') { " + d + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
    }
    i += " } ", m && (i += "  }  "), i += " if (!" + d + ") {   ";
    var x = x || [];
    x.push(i), i = "", e.createErrors !== !1 ? (i += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(c) + " , params: { i: i, j: j } ", e.opts.messages !== !1 && (i += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e.opts.verbose && (i += " , schema:  ", i += m ? "validate.schema" + u : "" + o, i += "         , parentSchema: validate.schema" + e.schemaPath + " , data: " + p + " "), i += " } ") : i += " {} ";
    var C = i;
    i = x.pop(), !e.compositeRule && f ? e.async ? i += " throw new ValidationError([" + C + "]); " : i += " validate.errors = [" + C + "]; return false; " : i += " var err = " + C + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i += " } ", f && (i += " else { ");
  } else
    f && (i += " if (true) { ");
  return i;
}, validate: Gm }, Bd = Mr.toHash, lT = function() {
  var e = [{ type: "number", rules: [{ maximum: ["exclusiveMaximum"] }, { minimum: ["exclusiveMinimum"] }, "multipleOf", "format"] }, { type: "string", rules: ["maxLength", "minLength", "pattern", "format"] }, { type: "array", rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"] }, { type: "object", rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", { properties: ["additionalProperties", "patternProperties"] }] }, { rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"] }], t = ["type", "$comment"];
  return e.all = Bd(t), e.types = Bd(["number", "integer", "string", "array", "object", "boolean", "null"]), e.forEach(function(n) {
    n.rules = n.rules.map(function(r) {
      var i;
      if (xe(r) == "object") {
        var a = Object.keys(r)[0];
        i = r[a], r = a, i.forEach(function(s) {
          t.push(s), e.all[s] = !0;
        });
      }
      return t.push(r), e.all[r] = { keyword: r, code: sb[r], implements: i };
    }), e.all.$comment = { keyword: "$comment", code: sb.$comment }, n.type && (e.types[n.type] = n);
  }), e.keywords = Bd(t.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), e.custom = {}, e;
}, ub = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"], kD = function(e, t) {
  for (var n = 0; n < t.length; n++) {
    e = JSON.parse(JSON.stringify(e));
    var r, i = t[n].split("/"), a = e;
    for (r = 1; r < i.length; r++)
      a = a[i[r]];
    for (r = 0; r < ub.length; r++) {
      var s = ub[r], o = a[s];
      o && (a[s] = { anyOf: [o, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] });
    }
  }
  return e;
}, pT = mc.MissingRef, fT = function e(t, n, r) {
  var i = this;
  if (typeof this._opts.loadSchema != "function")
    throw new Error("options.loadSchema should be a function");
  typeof n == "function" && (r = n, n = void 0);
  var a = s(t).then(function() {
    var o = i._addSchema(t, void 0, n);
    return o.validate || function u(c) {
      try {
        return i._compile(c);
      } catch (f) {
        if (f instanceof pT)
          return function(p) {
            var d = p.missingSchema;
            if (v(d))
              throw new Error("Schema " + d + " is loaded but " + p.missingRef + " cannot be resolved");
            var m = i._loadingSchemas[d];
            return m || (m = i._loadingSchemas[d] = i._opts.loadSchema(d)).then(y, y), m.then(function(b) {
              if (!v(d))
                return s(b).then(function() {
                  v(d) || i.addSchema(b, d, void 0, n);
                });
            }).then(function() {
              return u(c);
            });
            function y() {
              delete i._loadingSchemas[d];
            }
            function v(b) {
              return i._refs[b] || i._schemas[b];
            }
          }(f);
        throw f;
      }
    }(o);
  });
  return r && a.then(function(o) {
    r(null, o);
  }, r), a;
  function s(o) {
    var u = o.$schema;
    return u && !i.getSchema(u) ? e.call(i, { $ref: u }, !0) : Promise.resolve();
  }
}, hT = function(e, t, n) {
  var r, i, a = " ", s = e.level, o = e.dataLevel, u = e.schema[t], c = e.schemaPath + e.util.getProperty(t), f = e.errSchemaPath + "/" + t, p = !e.opts.allErrors, d = "data" + (o || ""), m = "valid" + s, y = "errs__" + s, v = e.opts.$data && u && u.$data;
  v ? (a += " var schema" + s + " = " + e.util.getData(u.$data, o, e.dataPathArr) + "; ", i = "schema" + s) : i = u;
  var b, x, C, k, F, B = "definition" + s, O = this.definition, S = "";
  if (v && O.$data) {
    F = "keywordValidate" + s;
    var w = O.validateSchema;
    a += " var " + B + " = RULES.custom['" + t + "'].definition; var " + F + " = " + B + ".validate;";
  } else {
    if (!(k = e.useCustomRule(this, u, e.schema, e)))
      return;
    i = "validate.schema" + c, F = k.code, b = O.compile, x = O.inline, C = O.macro;
  }
  var D = F + ".errors", I = "i" + s, L = "ruleErr" + s, V = O.async;
  if (V && !e.async)
    throw new Error("async keyword in sync schema");
  if (x || C || (a += D + " = null;"), a += "var " + y + " = errors;var " + m + ";", v && O.$data && (S += "}", a += " if (" + i + " === undefined) { " + m + " = true; } else { ", w && (S += "}", a += " " + m + " = " + B + ".validateSchema(" + i + "); if (" + m + ") { ")), x)
    O.statements ? a += " " + k.validate + " " : a += " " + m + " = " + k.validate + "; ";
  else if (C) {
    var K = e.util.copy(e);
    S = "", K.level++;
    var W = "valid" + K.level;
    K.schema = k.validate, K.schemaPath = "";
    var R = e.compositeRule;
    e.compositeRule = K.compositeRule = !0;
    var q = e.validate(K).replace(/validate\.schema/g, F);
    e.compositeRule = K.compositeRule = R, a += " " + q;
  } else {
    (A = A || []).push(a), a = "", a += "  " + F + ".call( ", e.opts.passContext ? a += "this" : a += "self", b || O.schema === !1 ? a += " , " + d + " " : a += " , " + i + " , " + d + " , validate.schema" + e.schemaPath + " ", a += " , (dataPath || '')", e.errorPath != '""' && (a += " + " + e.errorPath);
    var J = o ? "data" + (o - 1 || "") : "parentData", X = o ? e.dataPathArr[o] : "parentDataProperty", ce = a += " , " + J + " , " + X + " , rootData )  ";
    a = A.pop(), O.errors === !1 ? (a += " " + m + " = ", V && (a += "await "), a += ce + "; ") : a += V ? " var " + (D = "customErrors" + s) + " = null; try { " + m + " = await " + ce + "; } catch (e) { " + m + " = false; if (e instanceof ValidationError) " + D + " = e.errors; else throw e; } " : " " + D + " = null; " + m + " = " + ce + "; ";
  }
  if (O.modifying && (a += " if (" + J + ") " + d + " = " + J + "[" + X + "];"), a += "" + S, O.valid)
    p && (a += " if (true) { ");
  else {
    var A;
    a += " if ( ", O.valid === void 0 ? (a += " !", a += C ? "" + W : "" + m) : a += " " + !O.valid + " ", a += ") { ", r = this.keyword, (A = A || []).push(a), a = "", (A = A || []).push(a), a = "", e.createErrors !== !1 ? (a += " { keyword: '" + (r || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(f) + " , params: { keyword: '" + this.keyword + "' } ", e.opts.messages !== !1 && (a += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e.opts.verbose && (a += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), a += " } ") : a += " {} ";
    var M = a;
    a = A.pop(), !e.compositeRule && p ? e.async ? a += " throw new ValidationError([" + M + "]); " : a += " validate.errors = [" + M + "]; return false; " : a += " var err = " + M + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    var ne = a;
    a = A.pop(), x ? O.errors ? O.errors != "full" && (a += "  for (var " + I + "=" + y + "; " + I + "<errors; " + I + "++) { var " + L + " = vErrors[" + I + "]; if (" + L + ".dataPath === undefined) " + L + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + L + ".schemaPath === undefined) { " + L + '.schemaPath = "' + f + '"; } ', e.opts.verbose && (a += " " + L + ".schema = " + i + "; " + L + ".data = " + d + "; "), a += " } ") : O.errors === !1 ? a += " " + ne + " " : (a += " if (" + y + " == errors) { " + ne + " } else {  for (var " + I + "=" + y + "; " + I + "<errors; " + I + "++) { var " + L + " = vErrors[" + I + "]; if (" + L + ".dataPath === undefined) " + L + ".dataPath = (dataPath || '') + " + e.errorPath + "; if (" + L + ".schemaPath === undefined) { " + L + '.schemaPath = "' + f + '"; } ', e.opts.verbose && (a += " " + L + ".schema = " + i + "; " + L + ".data = " + d + "; "), a += " } } ") : C ? (a += "   var err =   ", e.createErrors !== !1 ? (a += " { keyword: '" + (r || "custom") + "' , dataPath: (dataPath || '') + " + e.errorPath + " , schemaPath: " + e.util.toQuotedString(f) + " , params: { keyword: '" + this.keyword + "' } ", e.opts.messages !== !1 && (a += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e.opts.verbose && (a += " , schema: validate.schema" + c + " , parentSchema: validate.schema" + e.schemaPath + " , data: " + d + " "), a += " } ") : a += " {} ", a += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e.compositeRule && p && (e.async ? a += " throw new ValidationError(vErrors); " : a += " validate.errors = vErrors; return false; ")) : O.errors === !1 ? a += " " + ne + " " : (a += " if (Array.isArray(" + D + ")) { if (vErrors === null) vErrors = " + D + "; else vErrors = vErrors.concat(" + D + "); errors = vErrors.length;  for (var " + I + "=" + y + "; " + I + "<errors; " + I + "++) { var " + L + " = vErrors[" + I + "]; if (" + L + ".dataPath === undefined) " + L + ".dataPath = (dataPath || '') + " + e.errorPath + ";  " + L + '.schemaPath = "' + f + '";  ', e.opts.verbose && (a += " " + L + ".schema = " + i + "; " + L + ".data = " + d + "; "), a += " } } else { " + ne + " } "), a += " } ", p && (a += " else { ");
  }
  return a;
}, DD = "http://json-schema.org/draft-07/schema#", FD = "http://json-schema.org/draft-07/schema#", wD = "Core schema meta-schema", AD = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } }, _D = ["object", "boolean"], TD = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: !0, readOnly: { type: "boolean", default: !1 }, examples: { type: "array", items: !0 }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, dT = { $schema: DD, $id: FD, title: wD, definitions: AD, type: _D, properties: TD, default: !0 }, zm = Cr(Object.freeze({ __proto__: null, $schema: DD, $id: FD, title: wD, definitions: AD, type: _D, properties: TD, default: dT })), mT = { $id: "https://github.com/epoberezkin/ajv/blob/master/lib/definition_schema.js", definitions: { simpleTypes: zm.definitions.simpleTypes }, type: "object", dependencies: { schema: ["validate"], $data: ["validate"], statements: ["inline"], valid: { not: { required: ["macro"] } } }, properties: { type: zm.properties.type, schema: { type: "boolean" }, statements: { type: "boolean" }, dependencies: { type: "array", items: { type: "string" } }, metaSchema: { type: "object" }, modifying: { type: "boolean" }, valid: { type: "boolean" }, $data: { type: "boolean" }, async: { type: "boolean" }, errors: { anyOf: [{ type: "boolean" }, { const: "full" }] } } }, gT = /^[a-z_$][a-z0-9_$-]*$/i, yT = function(e, t) {
  var n = this.RULES;
  if (n.keywords[e])
    throw new Error("Keyword " + e + " is already defined");
  if (!gT.test(e))
    throw new Error("Keyword " + e + " is not a valid identifier");
  if (t) {
    this.validateKeyword(t, !0);
    var r = t.type;
    if (Array.isArray(r))
      for (var i = 0; i < r.length; i++)
        s(e, r[i], t);
    else
      s(e, r, t);
    var a = t.metaSchema;
    a && (t.$data && this._opts.$data && (a = { anyOf: [a, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] }), t.validateSchema = this.compile(a, !0));
  }
  function s(o, u, c) {
    for (var f, p = 0; p < n.length; p++) {
      var d = n[p];
      if (d.type == u) {
        f = d;
        break;
      }
    }
    f || (f = { type: u, rules: [] }, n.push(f));
    var m = { keyword: o, definition: c, custom: !0, code: hT, implements: c.implements };
    f.rules.push(m), n.custom[o] = m;
  }
  return n.keywords[e] = n.all[e] = !0, this;
}, vT = function(e) {
  var t = this.RULES.custom[e];
  return t ? t.definition : this.RULES.keywords[e] || !1;
}, xT = function(e) {
  var t = this.RULES;
  delete t.keywords[e], delete t.all[e], delete t.custom[e];
  for (var n = 0; n < t.length; n++)
    for (var r = t[n].rules, i = 0; i < r.length; i++)
      if (r[i].keyword == e) {
        r.splice(i, 1);
        break;
      }
  return this;
}, bT = function e(t, n) {
  e.errors = null;
  var r = this._validateKeyword = this._validateKeyword || this.compile(mT, !0);
  if (r(t))
    return !0;
  if (e.errors = r.errors, n)
    throw new Error("custom keyword definition is invalid: " + this.errorsText(r.errors));
  return !1;
}, PD = "http://json-schema.org/draft-07/schema#", ID = "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#", BD = "Meta-schema for $data reference (JSON Schema extension proposal)", OD = ["$data"], LD = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, ET = { $schema: PD, $id: ID, description: BD, type: "object", required: OD, properties: LD, additionalProperties: !1 }, CT = Cr(Object.freeze({ __proto__: null, $schema: PD, $id: ID, description: BD, type: "object", required: OD, properties: LD, additionalProperties: !1, default: ET })), ST = vn;
vn.prototype.validate = function(e, t) {
  var n;
  if (typeof e == "string") {
    if (!(n = this.getSchema(e)))
      throw new Error('no schema with key or ref "' + e + '"');
  } else {
    var r = this._addSchema(e);
    n = r.validate || this._compile(r);
  }
  var i = n(t);
  return n.$async !== !0 && (this.errors = n.errors), i;
}, vn.prototype.compile = function(e, t) {
  var n = this._addSchema(e, void 0, t);
  return n.validate || this._compile(n);
}, vn.prototype.addSchema = function(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i = 0; i < e.length; i++)
      this.addSchema(e[i], void 0, n, r);
    return this;
  }
  var a = this._getId(e);
  if (a !== void 0 && typeof a != "string")
    throw new Error("schema id must be string");
  return pb(this, t = xr.normalizeId(t || a)), this._schemas[t] = this._addSchema(e, n, r, !0), this;
}, vn.prototype.addMetaSchema = function(e, t, n) {
  return this.addSchema(e, t, n, !0), this;
}, vn.prototype.validateSchema = function(e, t) {
  var n = e.$schema;
  if (n !== void 0 && typeof n != "string")
    throw new Error("$schema must be a string");
  if (!(n = n || this._opts.defaultMeta || function(a) {
    var s = a._opts.meta;
    return a._opts.defaultMeta = xe(s) == "object" ? a._getId(s) || s : a.getSchema($p) ? $p : void 0, a._opts.defaultMeta;
  }(this)))
    return this.logger.warn("meta-schema not available"), this.errors = null, !0;
  var r = this.validate(n, e);
  if (!r && t) {
    var i = "schema is invalid: " + this.errorsText();
    if (this._opts.validateSchema != "log")
      throw new Error(i);
    this.logger.error(i);
  }
  return r;
}, vn.prototype.getSchema = function(e) {
  var t = lb(this, e);
  switch (xe(t)) {
    case "object":
      return t.validate || this._compile(t);
    case "string":
      return this.getSchema(t);
    case "undefined":
      return function(n, r) {
        var i = xr.schema.call(n, { schema: {} }, r);
        if (i) {
          var a = i.schema, s = i.root, o = i.baseId, u = zx.call(n, a, s, void 0, o);
          return n._fragments[r] = new Ks({ ref: r, fragment: !0, schema: a, root: s, baseId: o, validate: u }), u;
        }
      }(this, e);
  }
}, vn.prototype.removeSchema = function(e) {
  if (e instanceof RegExp)
    return ql(this, this._schemas, e), ql(this, this._refs, e), this;
  switch (xe(e)) {
    case "undefined":
      return ql(this, this._schemas), ql(this, this._refs), this._cache.clear(), this;
    case "string":
      var t = lb(this, e);
      return t && this._cache.del(t.cacheKey), delete this._schemas[e], delete this._refs[e], this;
    case "object":
      var n = this._opts.serialize, r = n ? n(e) : e;
      this._cache.del(r);
      var i = this._getId(e);
      i && (i = xr.normalizeId(i), delete this._schemas[i], delete this._refs[i]);
  }
  return this;
}, vn.prototype.addFormat = function(e, t) {
  return typeof t == "string" && (t = new RegExp(t)), this._formats[e] = t, this;
}, vn.prototype.errorsText = function(e, t) {
  if (!(e = e || this.errors))
    return "No errors";
  for (var n = (t = t || {}).separator === void 0 ? ", " : t.separator, r = t.dataVar === void 0 ? "data" : t.dataVar, i = "", a = 0; a < e.length; a++) {
    var s = e[a];
    s && (i += r + s.dataPath + " " + s.message + n);
  }
  return i.slice(0, -n.length);
}, vn.prototype._addSchema = function(e, t, n, r) {
  if (xe(e) != "object" && typeof e != "boolean")
    throw new Error("schema should be object or boolean");
  var i = this._opts.serialize, a = i ? i(e) : e, s = this._cache.get(a);
  if (s)
    return s;
  r = r || this._opts.addUsedSchema !== !1;
  var o = xr.normalizeId(this._getId(e));
  o && r && pb(this, o);
  var u, c = this._opts.validateSchema !== !1 && !t;
  c && !(u = o && o == xr.normalizeId(e.$schema)) && this.validateSchema(e, !0);
  var f = xr.ids.call(this, e), p = new Ks({ id: o, schema: e, localRefs: f, cacheKey: a, meta: n });
  return o[0] != "#" && r && (this._refs[o] = p), this._cache.put(a, p), c && u && this.validateSchema(e, !0), p;
}, vn.prototype._compile = function(e, t) {
  if (e.compiling)
    return e.validate = i, i.schema = e.schema, i.errors = null, i.root = t || i, e.schema.$async === !0 && (i.$async = !0), i;
  var n, r;
  e.compiling = !0, e.meta && (n = this._opts, this._opts = this._metaOpts);
  try {
    r = zx.call(this, e.schema, t, e.localRefs);
  } catch (a) {
    throw delete e.validate, a;
  } finally {
    e.compiling = !1, e.meta && (this._opts = n);
  }
  return e.validate = r, e.refs = r.refs, e.refVal = r.refVal, e.root = r.root, r;
  function i() {
    var a = e.validate, s = a.apply(this, arguments);
    return i.errors = a.errors, s;
  }
}, vn.prototype.compileAsync = fT, vn.prototype.addKeyword = yT, vn.prototype.getKeyword = vT, vn.prototype.removeKeyword = xT, vn.prototype.validateKeyword = bT, vn.ValidationError = mc.Validation, vn.MissingRefError = mc.MissingRef, vn.$dataMetaSchema = kD;
var $p = "http://json-schema.org/draft-07/schema", cb = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"], kT = ["/properties"];
function vn(e) {
  if (!(this instanceof vn))
    return new vn(e);
  e = this._opts = Mr.copy(e) || {}, function(t) {
    var n = t._opts.logger;
    if (n === !1)
      t.logger = { log: Od, warn: Od, error: Od };
    else {
      if (n === void 0 && (n = console), !(xe(n) == "object" && n.log && n.warn && n.error))
        throw new Error("logger must implement log, warn and error methods");
      t.logger = n;
    }
  }(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = oT(e.format), this._cache = e.cache || new tT(), this._loadingSchemas = {}, this._compilations = [], this.RULES = lT(), this._getId = function(t) {
    switch (t.schemaId) {
      case "auto":
        return wT;
      case "id":
        return DT;
      default:
        return FT;
    }
  }(e), e.loopRequired = e.loopRequired || 1 / 0, e.errorDataPath == "property" && (e._errorDataPathProperty = !0), e.serialize === void 0 && (e.serialize = CD), this._metaOpts = function(t) {
    for (var n = Mr.copy(t._opts), r = 0; r < cb.length; r++)
      delete n[cb[r]];
    return n;
  }(this), e.formats && function(t) {
    for (var n in t._opts.formats) {
      var r = t._opts.formats[n];
      t.addFormat(n, r);
    }
  }(this), function(t) {
    var n;
    if (t._opts.$data && (n = CT, t.addMetaSchema(n, n.$id, !0)), t._opts.meta !== !1) {
      var r = zm;
      t._opts.$data && (r = kD(r, kT)), t.addMetaSchema(r, $p, !0), t._refs["http://json-schema.org/schema"] = $p;
    }
  }(this), xe(e.meta) == "object" && this.addMetaSchema(e.meta), e.nullable && this.addKeyword("nullable", { metaSchema: { type: "boolean" } }), function(t) {
    var n = t._opts.schemas;
    if (n)
      if (Array.isArray(n))
        t.addSchema(n);
      else
        for (var r in n)
          t.addSchema(n[r], r);
  }(this);
}
function lb(e, t) {
  return t = xr.normalizeId(t), e._schemas[t] || e._refs[t] || e._fragments[t];
}
function ql(e, t, n) {
  for (var r in t) {
    var i = t[r];
    i.meta || n && !n.test(r) || (e._cache.del(i.cacheKey), delete t[r]);
  }
}
function DT(e) {
  return e.$id && this.logger.warn("schema $id ignored", e.$id), e.id;
}
function FT(e) {
  return e.id && this.logger.warn("schema id ignored", e.id), e.$id;
}
function wT(e) {
  if (e.$id && e.id && e.$id != e.id)
    throw new Error("schema $id is different from id");
  return e.$id || e.id;
}
function pb(e, t) {
  if (e._schemas[t] || e._refs[t])
    throw new Error('schema with key or id "' + t + '" already exists');
}
function Od() {
}
var ND, jD = "http://json-schema.org/draft-04/schema#", RD = "http://json-schema.org/draft-04/schema#", MD = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, positiveInteger: { type: "integer", minimum: 0 }, positiveIntegerDefault0: { allOf: [{ $ref: "#/definitions/positiveInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: !0 } }, VD = { id: { type: "string" }, $schema: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: {}, multipleOf: { type: "number", minimum: 0, exclusiveMinimum: !0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "boolean", default: !1 }, minimum: { type: "number" }, exclusiveMinimum: { type: "boolean", default: !1 }, maxLength: { $ref: "#/definitions/positiveInteger" }, minLength: { $ref: "#/definitions/positiveIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: {} }, maxItems: { $ref: "#/definitions/positiveInteger" }, minItems: { $ref: "#/definitions/positiveIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, maxProperties: { $ref: "#/definitions/positiveInteger" }, minProperties: { $ref: "#/definitions/positiveIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, enum: { type: "array", minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, UD = { exclusiveMaximum: ["maximum"], exclusiveMinimum: ["minimum"] }, AT = { id: jD, $schema: RD, description: "Core schema meta-schema", definitions: MD, type: "object", properties: VD, dependencies: UD, default: {} }, _T = Object.freeze({ __proto__: null, id: jD, $schema: RD, description: "Core schema meta-schema", definitions: MD, type: "object", properties: VD, dependencies: UD, default: AT }), TT = [].slice, PT = {}.toString;
ND = cp(function(e, t) {
  return e.apply(null, t);
});
var IT = { curry: function(e) {
  return cp(e);
}, flip: cp(function(e, t, n) {
  return e(n, t);
}), fix: function(e) {
  return function(t) {
    return function() {
      return e(t(t)).apply(null, arguments);
    };
  }(function(t) {
    return function() {
      return e(t(t)).apply(null, arguments);
    };
  });
}, apply: ND, over: cp(function(e, t, n, r) {
  return e(t(n), t(r));
}), memoize: function(e) {
  var t;
  return t = {}, function() {
    var n, r, i;
    return n = TT.call(arguments), r = function() {
      var a, s, o, u = [];
      for (a = 0, o = (s = n).length; a < o; ++a)
        i = s[a], u.push(i + PT.call(i).slice(8, -1));
      return u;
    }().join(""), t[r] = r in t ? t[r] : e.apply(null, n);
  };
} };
function cp(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
var qD, WD, $D, GD, zD, HD, KD, JD, QD, XD, YD, ZD, eF, tF, nF, rF, Hm, iF, aF, oF, Km, sF, uF, cF, lF, Jm, pF, fF, hF, dF, mF, gF, yF, vF, xF, bF, EF, CF, SF, kF, DF, FF, wF, AF, _F, TF, $u, PF, IF, BF, OF, LF, NF, Qm, Xm, jF, Ym, Zm, e0, RF, MF, VF, UF, qF, WF, $F, GF, zF, HF, BT = {}.toString, wu = [].slice;
qD = dt(function(e, t) {
  var n, r;
  for (n = 0, r = t.length; n < r; ++n)
    e(t[n]);
  return t;
}), WD = dt(function(e, t) {
  var n, r, i, a = [];
  for (n = 0, r = t.length; n < r; ++n)
    i = t[n], a.push(e(i));
  return a;
}), $D = function(e) {
  var t, n, r, i = [];
  for (t = 0, n = e.length; t < n; ++t)
    (r = e[t]) && i.push(r);
  return i;
}, GD = dt(function(e, t) {
  var n, r, i, a = [];
  for (n = 0, r = t.length; n < r; ++n)
    e(i = t[n]) && a.push(i);
  return a;
}), zD = dt(function(e, t) {
  var n, r, i, a = [];
  for (n = 0, r = t.length; n < r; ++n)
    e(i = t[n]) || a.push(i);
  return a;
}), HD = dt(function(e, t) {
  var n, r, i, a, s;
  for (n = [], r = [], i = 0, a = t.length; i < a; ++i)
    (e(s = t[i]) ? n : r).push(s);
  return [n, r];
}), KD = dt(function(e, t) {
  var n, r, i;
  for (n = 0, r = t.length; n < r; ++n)
    if (e(i = t[n]))
      return i;
}), JD = QD = function(e) {
  return e[0];
}, XD = function(e) {
  if (e.length)
    return e.slice(1);
}, YD = function(e) {
  return e[e.length - 1];
}, ZD = function(e) {
  if (e.length)
    return e.slice(0, -1);
}, eF = function(e) {
  return !e.length;
}, tF = function(e) {
  return e.concat().reverse();
}, nF = function(e) {
  var t, n, r, i;
  for (t = [], n = 0, r = e.length; n < r; ++n)
    Au(i = e[n], t) || t.push(i);
  return t;
}, rF = dt(function(e, t) {
  var n, r, i, a, s, o = [];
  for (n = [], r = 0, i = t.length; r < i; ++r)
    Au(s = e(a = t[r]), n) || (n.push(s), o.push(a));
  return o;
}), Hm = iF = dt(function(e, t, n) {
  var r, i;
  for (r = 0, i = n.length; r < i; ++r)
    t = e(t, n[r]);
  return t;
}), aF = oF = dt(function(e, t) {
  return Hm(e, t[0], t.slice(1));
}), Km = dt(function(e, t, n) {
  var r;
  for (r = n.length - 1; r >= 0; --r)
    t = e(n[r], t);
  return t;
}), sF = dt(function(e, t) {
  return Km(e, t[t.length - 1], t.slice(0, -1));
}), uF = dt(function(e, t) {
  var n, r, i;
  for (n = [], r = t; (i = e(r)) != null; )
    n.push(i[0]), r = i[1];
  return n;
}), cF = function(e) {
  return [].concat.apply([], e);
}, lF = dt(function(e, t) {
  var n;
  return [].concat.apply([], function() {
    var r, i, a, s = [];
    for (r = 0, a = (i = t).length; r < a; ++r)
      n = i[r], s.push(e(n));
    return s;
  }());
}), Jm = function(e) {
  var t;
  return [].concat.apply([], function() {
    var n, r, i, a = [];
    for (n = 0, i = (r = e).length; n < i; ++n)
      t = r[n], BT.call(t).slice(8, -1) === "Array" ? a.push(Jm(t)) : a.push(t);
    return a;
  }());
}, pF = function(e) {
  var t, n, r, i, a, s, o;
  t = wu.call(arguments, 1), n = [];
  e:
    for (r = 0, i = e.length; r < i; ++r) {
      for (a = e[r], s = 0, o = t.length; s < o; ++s)
        if (Au(a, t[s]))
          continue e;
      n.push(a);
    }
  return n;
}, fF = function(e) {
  var t, n, r, i, a, s, o;
  t = wu.call(arguments, 1), n = [];
  e:
    for (r = 0, i = e.length; r < i; ++r) {
      for (a = e[r], s = 0, o = t.length; s < o; ++s)
        if (!Au(a, t[s]))
          continue e;
      n.push(a);
    }
  return n;
}, hF = function() {
  var e, t, n, r, i, a, s, o;
  for (t = [], n = 0, r = (e = wu.call(arguments)).length; n < r; ++n)
    for (a = 0, s = (i = e[n]).length; a < s; ++a)
      Au(o = i[a], t) || t.push(o);
  return t;
}, dF = dt(function(e, t) {
  var n, r, i, a;
  for (n = {}, r = 0, i = t.length; r < i; ++r)
    (a = e(t[r])) in n ? n[a] += 1 : n[a] = 1;
  return n;
}), mF = dt(function(e, t) {
  var n, r, i, a, s;
  for (n = {}, r = 0, i = t.length; r < i; ++r)
    (s = e(a = t[r])) in n ? n[s].push(a) : n[s] = [a];
  return n;
}), gF = function(e) {
  var t, n;
  for (t = 0, n = e.length; t < n; ++t)
    if (!e[t])
      return !1;
  return !0;
}, yF = function(e) {
  var t, n;
  for (t = 0, n = e.length; t < n; ++t)
    if (e[t])
      return !0;
  return !1;
}, vF = dt(function(e, t) {
  var n, r;
  for (n = 0, r = t.length; n < r; ++n)
    if (e(t[n]))
      return !0;
  return !1;
}), xF = dt(function(e, t) {
  var n, r;
  for (n = 0, r = t.length; n < r; ++n)
    if (!e(t[n]))
      return !1;
  return !0;
}), bF = function(e) {
  return e.concat().sort(function(t, n) {
    return t > n ? 1 : t < n ? -1 : 0;
  });
}, EF = dt(function(e, t) {
  return t.concat().sort(e);
}), CF = dt(function(e, t) {
  return t.concat().sort(function(n, r) {
    return e(n) > e(r) ? 1 : e(n) < e(r) ? -1 : 0;
  });
}), SF = function(e) {
  var t, n, r;
  for (t = 0, n = 0, r = e.length; n < r; ++n)
    t += e[n];
  return t;
}, kF = function(e) {
  var t, n, r;
  for (t = 1, n = 0, r = e.length; n < r; ++n)
    t *= e[n];
  return t;
}, DF = FF = function(e) {
  var t, n, r;
  for (t = 0, n = 0, r = e.length; n < r; ++n)
    t += e[n];
  return t / e.length;
}, wF = function(e) {
  var t, n, r, i, a;
  for (t = e[0], n = 0, i = (r = e.slice(1)).length; n < i; ++n)
    (a = r[n]) > t && (t = a);
  return t;
}, AF = function(e) {
  var t, n, r, i, a;
  for (t = e[0], n = 0, i = (r = e.slice(1)).length; n < i; ++n)
    (a = r[n]) < t && (t = a);
  return t;
}, _F = dt(function(e, t) {
  var n, r, i, a, s;
  for (n = t[0], r = 0, a = (i = t.slice(1)).length; r < a; ++r)
    e(s = i[r]) > e(n) && (n = s);
  return n;
}), TF = dt(function(e, t) {
  var n, r, i, a, s;
  for (n = t[0], r = 0, a = (i = t.slice(1)).length; r < a; ++r)
    e(s = i[r]) < e(n) && (n = s);
  return n;
}), $u = PF = dt(function(e, t, n) {
  var r, i;
  return r = t, [t].concat(function() {
    var a, s, o, u = [];
    for (a = 0, o = (s = n).length; a < o; ++a)
      i = s[a], u.push(r = e(r, i));
    return u;
  }());
}), IF = BF = dt(function(e, t) {
  if (t.length)
    return $u(e, t[0], t.slice(1));
}), OF = dt(function(e, t, n) {
  return n = n.concat().reverse(), $u(e, t, n).reverse();
}), LF = dt(function(e, t) {
  if (t.length)
    return t = t.concat().reverse(), $u(e, t[0], t.slice(1)).reverse();
}), NF = dt(function(e, t, n) {
  return n.slice(e, t);
}), Qm = dt(function(e, t) {
  return e <= 0 ? t.slice(0, 0) : t.slice(0, e);
}), Xm = dt(function(e, t) {
  return e <= 0 ? t : t.slice(e);
}), jF = dt(function(e, t) {
  return [Qm(e, t), Xm(e, t)];
}), Ym = dt(function(e, t) {
  var n, r;
  if (!(n = t.length))
    return t;
  for (r = 0; r < n && e(t[r]); )
    r += 1;
  return t.slice(0, r);
}), Zm = dt(function(e, t) {
  var n, r;
  if (!(n = t.length))
    return t;
  for (r = 0; r < n && e(t[r]); )
    r += 1;
  return t.slice(r);
}), e0 = dt(function(e, t) {
  return [Ym(e, t), Zm(e, t)];
}), RF = dt(function(e, t) {
  return e0(function() {
    var n = arguments;
    return function() {
      var r, i;
      for (i = n[0].apply(this, arguments), r = 1; r < n.length; ++r)
        i = n[r](i);
      return i;
    };
  }(e, LT), t);
}), MF = dt(function(e, t) {
  var n, r, i, a, s, o;
  for (n = [], r = t.length, i = 0, a = e.length; i < a && (s = i, o = e[i], s !== r); ++i)
    n.push([o, t[s]]);
  return n;
}), VF = dt(function(e, t, n) {
  var r, i, a, s, o, u;
  for (r = [], i = n.length, a = 0, s = t.length; a < s && (o = a, u = t[a], o !== i); ++a)
    r.push(e(u, n[o]));
  return r;
}), UF = function() {
  var e, t, n, r, i, a, s, o, u, c = [];
  for (t = void 0, n = 0, r = (e = wu.call(arguments)).length; n < r; ++n)
    t <= (a = (i = e[n]).length) || (t = a);
  for (n = 0; n < t; ++n) {
    for (s = n, o = [], u = 0, r = e.length; u < r; ++u)
      i = e[u], o.push(i[s]);
    c.push(o);
  }
  return c;
}, qF = function(e) {
  var t, n, r, i, a, s, o, u = [];
  for (n = void 0, r = 0, i = (t = wu.call(arguments, 1)).length; r < i; ++r)
    n <= (s = (a = t[r]).length) || (n = s);
  for (r = 0; r < n; ++r)
    o = r, u.push(e.apply(null, c()));
  return u;
  function c() {
    var f, p, d, m = [];
    for (f = 0, d = (p = t).length; f < d; ++f)
      a = p[f], m.push(a[o]);
    return m;
  }
}, WF = dt(function(e, t) {
  return e < 0 ? t[t.length + e] : t[e];
}), $F = dt(function(e, t) {
  var n, r, i;
  for (n = 0, r = t.length; n < r; ++n)
    if (i = n, t[n] === e)
      return i;
}), GF = dt(function(e, t) {
  var n, r, i, a = [];
  for (n = 0, r = t.length; n < r; ++n)
    i = n, t[n] === e && a.push(i);
  return a;
}), zF = dt(function(e, t) {
  var n, r, i;
  for (n = 0, r = t.length; n < r; ++n)
    if (i = n, e(t[n]))
      return i;
}), HF = dt(function(e, t) {
  var n, r, i, a = [];
  for (n = 0, r = t.length; n < r; ++n)
    i = n, e(t[n]) && a.push(i);
  return a;
});
var KF, OT = { each: qD, map: WD, filter: GD, compact: $D, reject: zD, partition: HD, find: KD, head: JD, first: QD, tail: XD, last: YD, initial: ZD, empty: eF, reverse: tF, difference: pF, intersection: fF, union: hF, countBy: dF, groupBy: mF, fold: Hm, fold1: aF, foldl: iF, foldl1: oF, foldr: Km, foldr1: sF, unfoldr: uF, andList: gF, orList: yF, any: vF, all: xF, unique: nF, uniqueBy: rF, sort: bF, sortWith: EF, sortBy: CF, sum: SF, product: kF, mean: DF, average: FF, concat: cF, concatMap: lF, flatten: Jm, maximum: wF, minimum: AF, maximumBy: _F, minimumBy: TF, scan: $u, scan1: IF, scanl: PF, scanl1: BF, scanr: OF, scanr1: LF, slice: NF, take: Qm, drop: Xm, splitAt: jF, takeWhile: Ym, dropWhile: Zm, span: e0, breakList: RF, zip: MF, zipWith: VF, zipAll: UF, zipAllWith: qF, at: WF, elemIndex: $F, elemIndices: GF, findIndex: zF, findIndices: HF };
function dt(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
function Au(e, t) {
  for (var n = -1, r = t.length >>> 0; ++n < r; )
    if (e === t[n])
      return !0;
  return !1;
}
function LT(e) {
  return !e;
}
KF = function(e) {
  var t, n, r = {};
  for (t in e)
    (n = e[t]) && (r[t] = n);
  return r;
};
var NT = { values: function(e) {
  var t, n, r = [];
  for (t in e)
    n = e[t], r.push(n);
  return r;
}, keys: function(e) {
  var t, n = [];
  for (t in e)
    n.push(t);
  return n;
}, pairsToObj: function(e) {
  var t, n, r, i = {};
  for (t = 0, n = e.length; t < n; ++t)
    i[(r = e[t])[0]] = r[1];
  return i;
}, objToPairs: function(e) {
  var t, n, r = [];
  for (t in e)
    n = e[t], r.push([t, n]);
  return r;
}, listsToObj: So(function(e, t) {
  var n, r, i, a = {};
  for (n = 0, r = e.length; n < r; ++n)
    i = n, a[e[n]] = t[i];
  return a;
}), objToLists: function(e) {
  var t, n, r, i;
  for (r in t = [], n = [], e)
    i = e[r], t.push(r), n.push(i);
  return [t, n];
}, empty: function(e) {
  var t;
  for (t in e)
    return !1;
  return !0;
}, each: So(function(e, t) {
  var n;
  for (n in t)
    e(t[n]);
  return t;
}), map: So(function(e, t) {
  var n, r, i = {};
  for (n in t)
    r = t[n], i[n] = e(r);
  return i;
}), filter: So(function(e, t) {
  var n, r, i = {};
  for (n in t)
    e(r = t[n]) && (i[n] = r);
  return i;
}), compact: KF, reject: So(function(e, t) {
  var n, r, i = {};
  for (n in t)
    e(r = t[n]) || (i[n] = r);
  return i;
}), partition: So(function(e, t) {
  var n, r, i, a;
  for (i in n = {}, r = {}, t)
    (e(a = t[i]) ? n : r)[i] = a;
  return [n, r];
}), find: So(function(e, t) {
  var n, r;
  for (n in t)
    if (e(r = t[n]))
      return r;
}) };
function So(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
var JF, QF, XF, YF, ZF, ew, tw, nw, rw, iw, aw, ow, sw, uw, cw, lw, pw, fw, hw, dw, mw, gw, yw, vw, xw, bw, Ew, Cw, Sw, kw, t0, Dw, jT = { split: Ld(function(e, t) {
  return t.split(e);
}), join: Ld(function(e, t) {
  return t.join(e);
}), lines: function(e) {
  return e.length ? e.split(`
`) : [];
}, unlines: function(e) {
  return e.join(`
`);
}, words: function(e) {
  return e.length ? e.split(/[ ]+/) : [];
}, unwords: function(e) {
  return e.join(" ");
}, chars: function(e) {
  return e.split("");
}, unchars: function(e) {
  return e.join("");
}, reverse: function(e) {
  return e.split("").reverse().join("");
}, repeat: Ld(function(e, t) {
  var n, r;
  for (n = "", r = 0; r < e; ++r)
    n += t;
  return n;
}), capitalize: function(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}, camelize: function(e) {
  return e.replace(/[-_]+(.)?/g, function(t, n) {
    return (n ?? "").toUpperCase();
  });
}, dasherize: function(e) {
  return e.replace(/([^-A-Z])([A-Z]+)/g, function(t, n, r) {
    return n + "-" + (r.length > 1 ? r : r.toLowerCase());
  }).replace(/^([A-Z]+)/, function(t, n) {
    return n.length > 1 ? n + "-" : n.toLowerCase();
  });
} };
function Ld(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
function Bi(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
JF = Bi(function(e, t) {
  return e > t ? e : t;
}), QF = Bi(function(e, t) {
  return e < t ? e : t;
}), XF = function(e) {
  return -e;
}, YF = Math.abs, ZF = function(e) {
  return e < 0 ? -1 : e > 0 ? 1 : 0;
}, ew = Bi(function(e, t) {
  return ~~(e / t);
}), tw = Bi(function(e, t) {
  return e % t;
}), nw = Bi(function(e, t) {
  return Math.floor(e / t);
}), rw = Bi(function(e, t) {
  var n;
  return (e % (n = t) + n) % n;
}), iw = function(e) {
  return 1 / e;
}, ow = 2 * (aw = Math.PI), sw = Math.exp, uw = Math.sqrt, cw = Math.log, lw = Bi(function(e, t) {
  return Math.pow(e, t);
}), pw = Math.sin, fw = Math.tan, hw = Math.cos, dw = Math.asin, mw = Math.acos, gw = Math.atan, yw = Bi(function(e, t) {
  return Math.atan2(e, t);
}), vw = function(e) {
  return ~~e;
}, xw = Math.round, bw = Math.ceil, Ew = Math.floor, Cw = function(e) {
  return e != e;
}, Sw = function(e) {
  return e % 2 == 0;
}, kw = function(e) {
  return e % 2 != 0;
}, t0 = Bi(function(e, t) {
  var n;
  for (e = Math.abs(e), t = Math.abs(t); t !== 0; )
    n = e % t, e = t, t = n;
  return e;
}), Dw = Bi(function(e, t) {
  return Math.abs(Math.floor(e / t0(e, t) * t));
});
var ko, Be, $a, ln, Tt, fb, hb, db, me, RT = {}.toString;
ko = IT, Be = OT, $a = NT, ln = jT, Tt = { max: JF, min: QF, negate: XF, abs: YF, signum: ZF, quot: ew, rem: tw, div: nw, mod: rw, recip: iw, pi: aw, tau: ow, exp: sw, sqrt: uw, ln: cw, pow: lw, sin: pw, tan: fw, cos: hw, acos: mw, asin: dw, atan: gw, atan2: yw, truncate: vw, round: xw, ceiling: bw, floor: Ew, isItNaN: Cw, even: Sw, odd: kw, gcd: t0, lcm: Dw }, fb = function(e) {
  return e;
}, hb = mb(function(e, t) {
  return RT.call(t).slice(8, -1) === e;
}), db = mb(function(e, t) {
  var n, r = [];
  for (n = 0; n < e; ++n)
    r.push(t);
  return r;
}), ln.empty = Be.empty, ln.slice = Be.slice, ln.take = Be.take, ln.drop = Be.drop, ln.splitAt = Be.splitAt, ln.takeWhile = Be.takeWhile, ln.dropWhile = Be.dropWhile, ln.span = Be.span, ln.breakStr = Be.breakList, (me = { Func: ko, List: Be, Obj: $a, Str: ln, Num: Tt, id: fb, isType: hb, replicate: db }).each = Be.each, me.map = Be.map, me.filter = Be.filter, me.compact = Be.compact, me.reject = Be.reject, me.partition = Be.partition, me.find = Be.find, me.head = Be.head, me.first = Be.first, me.tail = Be.tail, me.last = Be.last, me.initial = Be.initial, me.empty = Be.empty, me.reverse = Be.reverse, me.difference = Be.difference, me.intersection = Be.intersection, me.union = Be.union, me.countBy = Be.countBy, me.groupBy = Be.groupBy, me.fold = Be.fold, me.foldl = Be.foldl, me.fold1 = Be.fold1, me.foldl1 = Be.foldl1, me.foldr = Be.foldr, me.foldr1 = Be.foldr1, me.unfoldr = Be.unfoldr, me.andList = Be.andList, me.orList = Be.orList, me.any = Be.any, me.all = Be.all, me.unique = Be.unique, me.uniqueBy = Be.uniqueBy, me.sort = Be.sort, me.sortWith = Be.sortWith, me.sortBy = Be.sortBy, me.sum = Be.sum, me.product = Be.product, me.mean = Be.mean, me.average = Be.average, me.concat = Be.concat, me.concatMap = Be.concatMap, me.flatten = Be.flatten, me.maximum = Be.maximum, me.minimum = Be.minimum, me.maximumBy = Be.maximumBy, me.minimumBy = Be.minimumBy, me.scan = Be.scan, me.scanl = Be.scanl, me.scan1 = Be.scan1, me.scanl1 = Be.scanl1, me.scanr = Be.scanr, me.scanr1 = Be.scanr1, me.slice = Be.slice, me.take = Be.take, me.drop = Be.drop, me.splitAt = Be.splitAt, me.takeWhile = Be.takeWhile, me.dropWhile = Be.dropWhile, me.span = Be.span, me.breakList = Be.breakList, me.zip = Be.zip, me.zipWith = Be.zipWith, me.zipAll = Be.zipAll, me.zipAllWith = Be.zipAllWith, me.at = Be.at, me.elemIndex = Be.elemIndex, me.elemIndices = Be.elemIndices, me.findIndex = Be.findIndex, me.findIndices = Be.findIndices, me.apply = ko.apply, me.curry = ko.curry, me.flip = ko.flip, me.fix = ko.fix, me.over = ko.over, me.split = ln.split, me.join = ln.join, me.lines = ln.lines, me.unlines = ln.unlines, me.words = ln.words, me.unwords = ln.unwords, me.chars = ln.chars, me.unchars = ln.unchars, me.repeat = ln.repeat, me.capitalize = ln.capitalize, me.camelize = ln.camelize, me.dasherize = ln.dasherize, me.values = $a.values, me.keys = $a.keys, me.pairsToObj = $a.pairsToObj, me.objToPairs = $a.objToPairs, me.listsToObj = $a.listsToObj, me.objToLists = $a.objToLists, me.max = Tt.max, me.min = Tt.min, me.negate = Tt.negate, me.abs = Tt.abs, me.signum = Tt.signum, me.quot = Tt.quot, me.rem = Tt.rem, me.div = Tt.div, me.mod = Tt.mod, me.recip = Tt.recip, me.pi = Tt.pi, me.tau = Tt.tau, me.exp = Tt.exp, me.sqrt = Tt.sqrt, me.ln = Tt.ln, me.pow = Tt.pow, me.sin = Tt.sin, me.tan = Tt.tan, me.cos = Tt.cos, me.acos = Tt.acos, me.asin = Tt.asin, me.atan = Tt.atan, me.atan2 = Tt.atan2, me.truncate = Tt.truncate, me.round = Tt.round, me.ceiling = Tt.ceiling, me.floor = Tt.floor, me.isItNaN = Tt.isItNaN, me.even = Tt.even, me.odd = Tt.odd, me.gcd = Tt.gcd, me.lcm = Tt.lcm, me.VERSION = "1.1.2";
var Fw = me;
function mb(e, t) {
  var n;
  return function r(i) {
    return e.length > 1 ? function() {
      var a = i ? i.concat() : [];
      return n = t && n || this, a.push.apply(a, arguments) < e.length && arguments.length ? r.call(n, a) : e.apply(n, a);
    } : e;
  }();
}
var MT = gt(function(e) {
  (function() {
    var t, n, r;
    function i(m, y) {
      if (m[0] === y)
        return m.shift();
      throw new Error("Expected '" + y + "', but got '" + m[0] + "' instead in " + JSON.stringify(m) + ".");
    }
    function a(m, y) {
      if (m[0] === y)
        return m.shift();
    }
    function s(m, y, v) {
      var b, x, C, k;
      for (b = y[0], x = y[1], v && i(m, b), C = [], k = "," + (v ? x : ""); m.length && v && m[0] !== x; )
        C.push(p(m, k)), a(m, ",");
      return v && i(m, x), C;
    }
    function o(m, y) {
      return s(m, ["[", "]"], y);
    }
    function u(m, y) {
      return s(m, ["(", ")"], y);
    }
    function c(m, y) {
      var v, b, x;
      for (y && i(m, "{"), v = {}, b = "," + (y ? "}" : ""); m.length && (!y || m[0] !== "}"); )
        x = f(m, ":"), i(m, ":"), v[x] = p(m, b), a(m, ",");
      return y && i(m, "}"), v;
    }
    function f(m, y) {
      var v;
      for (y == null && (y = ""), v = ""; m.length && y.indexOf(m[0]) === -1; )
        v += m.shift();
      return v;
    }
    function p(m, y) {
      switch (m[0]) {
        case "[":
          return o(m, !0);
        case "(":
          return u(m, !0);
        case "{":
          return c(m, !0);
        default:
          return f(m, y);
      }
    }
    function d(m) {
      return !m;
    }
    t = Fw.reject, n = /\[\]\(\)}{:,/.source, r = RegExp(`("(?:\\\\"|[^"])*")|('(?:\\\\'|[^'])*')|(/(?:\\\\/|[^/])*/[a-zA-Z]*)|(#.*#)|([` + n + "])|([^\\s" + n + "](?:\\s*[^\\s" + n + "]+)*)|\\s*"), e.exports = function(m, y, v) {
      var b;
      if (v == null && (v = {}), !v.explicit && m.length === 1 && m[0].type === "String")
        return "'" + y.replace(/\\'/g, "\\\\'") + "'";
      if (!(b = function(x, C, k) {
        var F, B, O, S, w, D, I, L;
        return B = (F = C[0]).type, O = F.structure, S = x.concat(), k.explicit || C.length !== 1 || (B || !O) && B !== "Array" && B !== "Object" ? D = p(x) : (w = O === "array" || B === "Array" ? o(x, x[0] === "[") : O === "tuple" ? u(x, x[0] === "(") : c(x, x[0] === "{"), D = x.length ? p(O === "array" || B === "Array" ? ((I = S).unshift("["), I.push("]"), I) : ((L = S).unshift("("), L.push(")"), L)) : w), D;
      }(t(d, y.split(r)), m, v)))
        throw new Error("Error parsing '" + y + "'.");
      return b;
    };
  }).call(ni);
}), VT = gt(function(e) {
  (function() {
    var t, n;
    function r(p) {
      var d;
      if ((d = p[0]) == null)
        throw new Error("Unexpected end of input.");
      return d;
    }
    function i(p) {
      var d;
      if (d = r(p), !t.test(d))
        throw new Error("Expected text, got '" + d + "' instead.");
      return p.shift();
    }
    function a(p, d) {
      var m;
      if ((m = r(p)) !== d)
        throw new Error("Expected '" + d + "', got '" + m + "' instead.");
      return p.shift();
    }
    function s(p, d) {
      return p[0] === d ? p.shift() : null;
    }
    function o(p) {
      var d;
      return d = i(p), a(p, ":"), [d, f(p)];
    }
    function u(p) {
      switch (p[0]) {
        case "[":
          return function(d) {
            var m;
            if (a(d, "["), r(d) === "]")
              throw new Error("Must specify type of Array - eg. [Type], got [] instead.");
            return m = f(d), a(d, "]"), { structure: "array", of: m };
          }(p);
        case "(":
          return function(d) {
            var m;
            if (m = [], a(d, "("), r(d) === ")")
              throw new Error("Tuple must be of at least length 1 - eg. (Type), got () instead.");
            for (; m.push(f(d)), s(d, ","), r(d) !== ")"; )
              ;
            return a(d, ")"), { structure: "tuple", of: m };
          }(p);
        case "{":
          return function(d) {
            var m, y, v, b, x;
            for (m = {}, a(d, "{"), y = !1; ; ) {
              if (s(d, "...")) {
                y = !0;
                break;
              }
              if (b = (v = o(d))[0], x = v[1], m[b] = x, s(d, ","), r(d) === "}")
                break;
            }
            return a(d, "}"), { structure: "fields", of: m, subset: y };
          }(p);
      }
    }
    function c(p) {
      var d, m, y, v;
      if ((m = (d = r(p)) === "*") || t.test(d))
        return y = m ? a(p, "*") : i(p), (v = u(p)) ? (v.type = y, v) : { type: y };
      if (!(v = u(p)))
        throw new Error("Unexpected character: " + d);
      return v;
    }
    function f(p) {
      var d, m, y, v, b;
      if (r(p) === "::")
        throw new Error("No comment before comment separator '::' found.");
      for ((d = p[1]) != null && d === "::" && (p.shift(), p.shift()), m = [], y = {}, r(p) === "Maybe" && (p.shift(), m = [{ type: "Undefined" }, { type: "Null" }], y = { Undefined: !0, Null: !0 }); y[b = (v = c(p)).type] || m.push(v), y[b] = !0, s(p, "|"); )
        ;
      return m;
    }
    t = /[\$\w]+/, n = RegExp("\\.\\.\\.|::|->|" + t.source + "|\\S", "g"), e.exports = function(p) {
      var d;
      if (!p.length)
        throw new Error("No type specified.");
      if (function(m, y) {
        for (var v = -1, b = y.length >>> 0; ++v < b; )
          if (m === y[v])
            return !0;
        return !1;
      }("->", d = p.match(n) || []))
        throw new Error("Function types are not supported. To validate that something is a function, you may use 'Function'.");
      try {
        return f(d);
      } catch (m) {
        throw new Error(m.message + " - Remaining tokens: " + JSON.stringify(d) + " - Initial input: '" + p + "'");
      }
    };
  }).call(ni);
}), UT = gt(function(e) {
  (function() {
    var t, n, r, i, a, s, o, u = {}.toString;
    function c(d, m) {
      if (!(d instanceof Object))
        return !1;
      switch (m.structure) {
        case "fields":
          return function(y, v) {
            var b, x, C, k, F, B, O;
            for (C in b = {}, x = 0, y)
              b[C] = !0, x++;
            for (F in k = 0, B = v.of) {
              if (O = B[F], !p(y[F], O))
                return !1;
              b[F] && k++;
            }
            return v.subset || x === k;
          }(d, m);
        case "array":
          return function(y, v) {
            return r(function(b) {
              return p(b, v.of);
            }, y);
          }(d, m);
        case "tuple":
          return function(y, v) {
            var b, x, C, k, F;
            for (b = 0, x = 0, k = (C = v.of).length; x < k; ++x) {
              if (F = C[x], !p(y[b], F))
                return !1;
              b++;
            }
            return y.length <= b;
          }(d, m);
      }
    }
    function f(d, m) {
      var y, v, b, x;
      if (y = m.type, v = m.structure, y)
        return y === "*" || ((b = o[y] || a[y]) ? b.typeOf === u.call(d).slice(8, -1) && b.validate(d) : y === u.call(d).slice(8, -1) && (!v || c(d, m)));
      if (v)
        return (!(x = s[v]) || x === u.call(d).slice(8, -1)) && c(d, m);
      throw new Error("No type defined. Input: " + d + ".");
    }
    function p(d, m) {
      if (u.call(m).slice(8, -1) !== "Array")
        throw new Error("Types must be in an array. Input: " + d + ".");
      return n(function(y) {
        return f(d, y);
      }, m);
    }
    n = (t = Fw).any, r = t.all, i = t.isItNaN, a = { Number: { typeOf: "Number", validate: function(d) {
      return !i(d);
    } }, NaN: { typeOf: "Number", validate: i }, Int: { typeOf: "Number", validate: function(d) {
      return !i(d) && d % 1 == 0;
    } }, Float: { typeOf: "Number", validate: function(d) {
      return !i(d);
    } }, Date: { typeOf: "Date", validate: function(d) {
      return !i(d.getTime());
    } } }, s = { array: "Array", tuple: "Array" }, e.exports = function(d, m, y) {
      return y == null && (y = {}), o = y.customTypes || {}, p(m, d);
    };
  }).call(ni);
}), vs = gt(function(e) {
  (function() {
    var t, n, r;
    t = VT, n = UT, r = function(i, a, s) {
      return n(t(i), a, s);
    }, e.exports = { VERSION: "0.3.2", typeCheck: r, parsedTypeCheck: n, parseType: t };
  }).call(ni);
}), qT = (vs.VERSION, vs.typeCheck, vs.parsedTypeCheck, vs.parseType, gt(function(e) {
  (function() {
    var t, n, r = {}.toString;
    function i(u, c, f) {
      var p, d;
      return r.call(u).slice(8, -1) !== "Array" ? { type: "Nothing" } : (p = c.of, { type: "Just", value: function() {
        var m, y, v, b = [];
        for (m = 0, v = (y = u).length; m < v; ++m)
          d = y[m], b.push(o(d, p, f));
        return b;
      }() });
    }
    function a(u, c, f) {
      var p, d, m;
      return r.call(u).slice(8, -1) !== "Object" ? { type: "Nothing" } : (p = c.of, { type: "Just", value: function() {
        var y, v = {};
        for (d in y = u)
          m = y[d], v[o(d, [{ type: "String" }], f)] = o(m, p[d] || [{ type: "*" }], f);
        return v;
      }() });
    }
    function s(u, c, f) {
      var p, d, m, y;
      if (p = c.type, d = c.structure, p) {
        if (!(m = ((y = f.customTypes[p]) != null ? y.cast : void 0) || n[p]))
          throw new Error("Type not defined: " + p + ".");
        return m(u, f, o);
      }
      switch (d) {
        case "array":
          return i(u, c, f);
        case "tuple":
          return function(v, b, x) {
            var C, k, F, B, O, S, w;
            if (r.call(v).slice(8, -1) !== "Array")
              return { type: "Nothing" };
            for (C = [], k = 0, F = 0, O = (B = b.of).length; F < O; ++F)
              S = B[F], w = o(v[k], S, x), r.call(w).slice(8, -1) !== "Undefined" && C.push(w), k++;
            return v.length <= k ? { type: "Just", value: C } : { type: "Nothing" };
          }(u, c, f);
        case "fields":
          return a(u, c, f);
      }
    }
    function o(u, c, f) {
      var p, d, m, y, v, b;
      for (p = 0, d = c.length; p < d; ++p)
        if (v = (y = s(u, m = c[p], f)).type, b = y.value, v !== "Nothing" && t([m], b, { customTypes: f.customTypes }))
          return b;
      throw new Error("Value " + JSON.stringify(u) + " does not type check against " + JSON.stringify(c) + ".");
    }
    t = vs.parsedTypeCheck, n = { "*": function(u, c) {
      switch (r.call(u).slice(8, -1)) {
        case "Array":
          return s(u, { type: "Array" }, c);
        case "Object":
          return s(u, { type: "Object" }, c);
        default:
          return { type: "Just", value: o(u, [{ type: "Undefined" }, { type: "Null" }, { type: "NaN" }, { type: "Boolean" }, { type: "Number" }, { type: "Date" }, { type: "RegExp" }, { type: "Array" }, { type: "Object" }, { type: "String" }], (c.explicit = !0, c)) };
      }
    }, Undefined: function(u) {
      return u === "undefined" || u === void 0 ? { type: "Just", value: void 0 } : { type: "Nothing" };
    }, Null: function(u) {
      return u === "null" ? { type: "Just", value: null } : { type: "Nothing" };
    }, NaN: function(u) {
      function c(f) {
        return u.apply(this, arguments);
      }
      return c.toString = function() {
        return u.toString();
      }, c;
    }(function(u) {
      return u === "NaN" ? { type: "Just", value: NaN } : { type: "Nothing" };
    }), Boolean: function(u) {
      return u === "true" ? { type: "Just", value: !0 } : u === "false" ? { type: "Just", value: !1 } : { type: "Nothing" };
    }, Number: function(u) {
      return { type: "Just", value: +u };
    }, Int: function(u) {
      return { type: "Just", value: +u };
    }, Float: function(u) {
      return { type: "Just", value: +u };
    }, Date: function(u) {
      function c(f, p) {
        return u.apply(this, arguments);
      }
      return c.toString = function() {
        return u.toString();
      }, c;
    }(function(u, c) {
      var f;
      return (f = /^\#([\s\S]*)\#$/.exec(u)) ? { type: "Just", value: new Date(+f[1] || f[1]) } : c.explicit ? { type: "Nothing" } : { type: "Just", value: new Date(+u || u) };
    }), RegExp: function(u) {
      function c(f, p) {
        return u.apply(this, arguments);
      }
      return c.toString = function() {
        return u.toString();
      }, c;
    }(function(u, c) {
      var f;
      return (f = /^\/([\s\S]*)\/([gimy]*)$/.exec(u)) ? { type: "Just", value: new RegExp(f[1], f[2]) } : c.explicit ? { type: "Nothing" } : { type: "Just", value: new RegExp(u) };
    }), Array: function(u, c) {
      return i(u, { of: [{ type: "*" }] }, c);
    }, Object: function(u, c) {
      return a(u, { of: {} }, c);
    }, String: function(u) {
      var c;
      return r.call(u).slice(8, -1) !== "String" ? { type: "Nothing" } : (c = u.match(/^'([\s\S]*)'$/)) ? { type: "Just", value: c[1].replace(/\\'/g, "'") } : (c = u.match(/^"([\s\S]*)"$/)) ? { type: "Just", value: c[1].replace(/\\"/g, '"') } : { type: "Just", value: u };
    } }, e.exports = o;
  }).call(ni);
})), lp = gt(function(e) {
  (function() {
    var t, n, r, i, a;
    t = MT, n = qT, r = vs.parseType, i = function(s, o, u) {
      return u == null && (u = {}), u.explicit == null && (u.explicit = !1), u.customTypes == null && (u.customTypes = {}), n(t(s, o, u), s, u);
    }, a = function(s, o, u) {
      return i(r(s), o, u);
    }, e.exports = { VERSION: "0.3.0", parse: a, parsedTypeParse: i };
  }).call(ni);
}), WT = (lp.VERSION, lp.parse, lp.parsedTypeParse, gt(function(e) {
  var t = function() {
    function n(i) {
      return '"' + i.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g, escape) + '"';
    }
    var r = { parse: function(i, a) {
      var s = { start: function() {
        var _, Q, Y, ae, ue, De = "start@" + o, Ee = f[De];
        if (Ee)
          return o = Ee.nextPos, Ee.result;
        ae = o, ue = o, (_ = d()) !== null && (Q = v()) !== null && (Y = d()) !== null ? _ = [_, Q, Y] : (_ = null, o = ue), _ !== null && (_e = _[1], _ = _e.length === 1 ? _e[0] : { type: "matches", selectors: _e });
        var _e;
        return _ === null && (o = ae), _ === null && (ae = o, (_ = d()) !== null && (_ = void 0), _ === null && (o = ae)), f[De] = { nextPos: o, result: _ }, _;
      }, _: d, identifierName: m, binaryOp: y, selectors: v, selector: b, sequence: x, atom: C, wildcard: k, identifier: F, attr: B, attrOps: O, attrEqOps: S, attrName: w, attrValue: D, string: I, number: L, path: V, type: K, regex: W, field: R, negation: q, matches: J, has: X, firstChild: ce, lastChild: A, nthChild: M, nthLastChild: ne, class: de };
      if (a !== void 0) {
        if (s[a] === void 0)
          throw new Error("Invalid rule name: " + n(a) + ".");
      } else
        a = "start";
      var o = 0, u = 0, c = [], f = {};
      function p(_) {
        o < u || (o > u && (u = o, c = []), c.push(_));
      }
      function d() {
        var _, Q, Y = "_@" + o, ae = f[Y];
        if (ae)
          return o = ae.nextPos, ae.result;
        for (_ = [], i.charCodeAt(o) === 32 ? (Q = " ", o++) : (Q = null, p('" "')); Q !== null; )
          _.push(Q), i.charCodeAt(o) === 32 ? (Q = " ", o++) : (Q = null, p('" "'));
        return f[Y] = { nextPos: o, result: _ }, _;
      }
      function m() {
        var _, Q, Y, ae = "identifierName@" + o, ue = f[ae];
        if (ue)
          return o = ue.nextPos, ue.result;
        if (Y = o, /^[^ [\],():#!=><~+.]/.test(i.charAt(o)) ? (Q = i.charAt(o), o++) : (Q = null, p("[^ [\\],():#!=><~+.]")), Q !== null)
          for (_ = []; Q !== null; )
            _.push(Q), /^[^ [\],():#!=><~+.]/.test(i.charAt(o)) ? (Q = i.charAt(o), o++) : (Q = null, p("[^ [\\],():#!=><~+.]"));
        else
          _ = null;
        return _ !== null && (_ = function(De, Ee) {
          return Ee.join("");
        }(0, _)), _ === null && (o = Y), f[ae] = { nextPos: o, result: _ }, _;
      }
      function y() {
        var _, Q, Y, ae, ue, De = "binaryOp@" + o, Ee = f[De];
        return Ee ? (o = Ee.nextPos, Ee.result) : (ae = o, ue = o, (_ = d()) !== null ? (i.charCodeAt(o) === 62 ? (Q = ">", o++) : (Q = null, p('">"')), Q !== null && (Y = d()) !== null ? _ = [_, Q, Y] : (_ = null, o = ue)) : (_ = null, o = ue), _ !== null && (_ = "child"), _ === null && (o = ae), _ === null && (ae = o, ue = o, (_ = d()) !== null ? (i.charCodeAt(o) === 126 ? (Q = "~", o++) : (Q = null, p('"~"')), Q !== null && (Y = d()) !== null ? _ = [_, Q, Y] : (_ = null, o = ue)) : (_ = null, o = ue), _ !== null && (_ = "sibling"), _ === null && (o = ae), _ === null && (ae = o, ue = o, (_ = d()) !== null ? (i.charCodeAt(o) === 43 ? (Q = "+", o++) : (Q = null, p('"+"')), Q !== null && (Y = d()) !== null ? _ = [_, Q, Y] : (_ = null, o = ue)) : (_ = null, o = ue), _ !== null && (_ = "adjacent"), _ === null && (o = ae), _ === null && (ae = o, ue = o, i.charCodeAt(o) === 32 ? (_ = " ", o++) : (_ = null, p('" "')), _ !== null && (Q = d()) !== null ? _ = [_, Q] : (_ = null, o = ue), _ !== null && (_ = "descendant"), _ === null && (o = ae)))), f[De] = { nextPos: o, result: _ }, _);
      }
      function v() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe, Ye = "selectors@" + o, _t = f[Ye];
        if (_t)
          return o = _t.nextPos, _t.result;
        if (Ee = o, _e = o, (_ = b()) !== null) {
          for (Q = [], Oe = o, (Y = d()) !== null ? (i.charCodeAt(o) === 44 ? (ae = ",", o++) : (ae = null, p('","')), ae !== null && (ue = d()) !== null && (De = b()) !== null ? Y = [Y, ae, ue, De] : (Y = null, o = Oe)) : (Y = null, o = Oe); Y !== null; )
            Q.push(Y), Oe = o, (Y = d()) !== null ? (i.charCodeAt(o) === 44 ? (ae = ",", o++) : (ae = null, p('","')), ae !== null && (ue = d()) !== null && (De = b()) !== null ? Y = [Y, ae, ue, De] : (Y = null, o = Oe)) : (Y = null, o = Oe);
          Q !== null ? _ = [_, Q] : (_ = null, o = _e);
        } else
          _ = null, o = _e;
        return _ !== null && (_ = function(Kt, Jt, zt) {
          return [Jt].concat(zt.map(function(wn) {
            return wn[3];
          }));
        }(0, _[0], _[1])), _ === null && (o = Ee), f[Ye] = { nextPos: o, result: _ }, _;
      }
      function b() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "selector@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        if (ue = o, De = o, (_ = x()) !== null) {
          for (Q = [], Ee = o, (Y = y()) !== null && (ae = x()) !== null ? Y = [Y, ae] : (Y = null, o = Ee); Y !== null; )
            Q.push(Y), Ee = o, (Y = y()) !== null && (ae = x()) !== null ? Y = [Y, ae] : (Y = null, o = Ee);
          Q !== null ? _ = [_, Q] : (_ = null, o = De);
        } else
          _ = null, o = De;
        return _ !== null && (_e = _[0], _ = _[1].reduce(function(_t, Kt) {
          return { type: Kt[0], left: _t, right: Kt[1] };
        }, _e)), _ === null && (o = ue), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function x() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "sequence@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        if (ae = o, ue = o, i.charCodeAt(o) === 33 ? (_ = "!", o++) : (_ = null, p('"!"')), (_ = _ !== null ? _ : "") !== null) {
          if ((Y = C()) !== null)
            for (Q = []; Y !== null; )
              Q.push(Y), Y = C();
          else
            Q = null;
          Q !== null ? _ = [_, Q] : (_ = null, o = ue);
        } else
          _ = null, o = ue;
        return _ !== null && (De = _[0], Ee = _[1], _e = Ee.length === 1 ? Ee[0] : { type: "compound", selectors: Ee }, De && (_e.subject = !0), _ = _e), _ === null && (o = ae), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function C() {
        var _, Q = "atom@" + o, Y = f[Q];
        return Y ? (o = Y.nextPos, Y.result) : ((_ = k()) === null && (_ = F()) === null && (_ = B()) === null && (_ = R()) === null && (_ = q()) === null && (_ = J()) === null && (_ = X()) === null && (_ = ce()) === null && (_ = A()) === null && (_ = M()) === null && (_ = ne()) === null && (_ = de()), f[Q] = { nextPos: o, result: _ }, _);
      }
      function k() {
        var _, Q, Y = "wildcard@" + o, ae = f[Y];
        return ae ? (o = ae.nextPos, ae.result) : (Q = o, i.charCodeAt(o) === 42 ? (_ = "*", o++) : (_ = null, p('"*"')), _ !== null && (_ = { type: "wildcard", value: _ }), _ === null && (o = Q), f[Y] = { nextPos: o, result: _ }, _);
      }
      function F() {
        var _, Q, Y, ae, ue = "identifier@" + o, De = f[ue];
        return De ? (o = De.nextPos, De.result) : (Y = o, ae = o, i.charCodeAt(o) === 35 ? (_ = "#", o++) : (_ = null, p('"#"')), (_ = _ !== null ? _ : "") !== null && (Q = m()) !== null ? _ = [_, Q] : (_ = null, o = ae), _ !== null && (_ = function(Ee, _e) {
          return { type: "identifier", value: _e };
        }(0, _[1])), _ === null && (o = Y), f[ue] = { nextPos: o, result: _ }, _);
      }
      function B() {
        var _, Q, Y, ae, ue, De, Ee, _e = "attr@" + o, Oe = f[_e];
        return Oe ? (o = Oe.nextPos, Oe.result) : (De = o, Ee = o, i.charCodeAt(o) === 91 ? (_ = "[", o++) : (_ = null, p('"["')), _ !== null && (Q = d()) !== null && (Y = D()) !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 93 ? (ue = "]", o++) : (ue = null, p('"]"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = _[2]), _ === null && (o = De), f[_e] = { nextPos: o, result: _ }, _);
      }
      function O() {
        var _, Q, Y, ae, ue = "attrOps@" + o, De = f[ue];
        return De ? (o = De.nextPos, De.result) : (Y = o, ae = o, /^[><!]/.test(i.charAt(o)) ? (_ = i.charAt(o), o++) : (_ = null, p("[><!]")), (_ = _ !== null ? _ : "") !== null ? (i.charCodeAt(o) === 61 ? (Q = "=", o++) : (Q = null, p('"="')), Q !== null ? _ = [_, Q] : (_ = null, o = ae)) : (_ = null, o = ae), _ !== null && (_ = _[0] + "="), _ === null && (o = Y), _ === null && (/^[><]/.test(i.charAt(o)) ? (_ = i.charAt(o), o++) : (_ = null, p("[><]"))), f[ue] = { nextPos: o, result: _ }, _);
      }
      function S() {
        var _, Q, Y, ae, ue = "attrEqOps@" + o, De = f[ue];
        return De ? (o = De.nextPos, De.result) : (Y = o, ae = o, i.charCodeAt(o) === 33 ? (_ = "!", o++) : (_ = null, p('"!"')), (_ = _ !== null ? _ : "") !== null ? (i.charCodeAt(o) === 61 ? (Q = "=", o++) : (Q = null, p('"="')), Q !== null ? _ = [_, Q] : (_ = null, o = ae)) : (_ = null, o = ae), _ !== null && (_ = _[0] + "="), _ === null && (o = Y), f[ue] = { nextPos: o, result: _ }, _);
      }
      function w() {
        var _, Q, Y, ae = "attrName@" + o, ue = f[ae];
        if (ue)
          return o = ue.nextPos, ue.result;
        if (Y = o, (Q = m()) === null && (i.charCodeAt(o) === 46 ? (Q = ".", o++) : (Q = null, p('"."'))), Q !== null)
          for (_ = []; Q !== null; )
            _.push(Q), (Q = m()) === null && (i.charCodeAt(o) === 46 ? (Q = ".", o++) : (Q = null, p('"."')));
        else
          _ = null;
        return _ !== null && (_ = function(De, Ee) {
          return Ee.join("");
        }(0, _)), _ === null && (o = Y), f[ae] = { nextPos: o, result: _ }, _;
      }
      function D() {
        var _, Q, Y, ae, ue, De, Ee, _e = "attrValue@" + o, Oe = f[_e];
        return Oe ? (o = Oe.nextPos, Oe.result) : (De = o, Ee = o, (_ = w()) !== null && (Q = d()) !== null && (Y = S()) !== null && (ae = d()) !== null ? ((ue = K()) === null && (ue = W()), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = function(Ye, _t, Kt, Jt) {
          return { type: "attribute", name: _t, operator: Kt, value: Jt };
        }(0, _[0], _[2], _[4])), _ === null && (o = De), _ === null && (De = o, Ee = o, (_ = w()) !== null && (Q = d()) !== null && (Y = O()) !== null && (ae = d()) !== null ? ((ue = I()) === null && (ue = L()) === null && (ue = V()), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = function(Ye, _t, Kt, Jt) {
          return { type: "attribute", name: _t, operator: Kt, value: Jt };
        }(0, _[0], _[2], _[4])), _ === null && (o = De), _ === null && (De = o, (_ = w()) !== null && (_ = function(Ye, _t) {
          return { type: "attribute", name: _t };
        }(0, _)), _ === null && (o = De))), f[_e] = { nextPos: o, result: _ }, _);
      }
      function I() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe, Ye, _t = "string@" + o, Kt = f[_t];
        if (Kt)
          return o = Kt.nextPos, Kt.result;
        if (ue = o, De = o, i.charCodeAt(o) === 34 ? (_ = '"', o++) : (_ = null, p('"\\""')), _ !== null) {
          for (Q = [], /^[^\\"]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p('[^\\\\"]')), Y === null && (Ee = o, _e = o, i.charCodeAt(o) === 92 ? (Y = "\\", o++) : (Y = null, p('"\\\\"')), Y !== null ? (i.length > o ? (ae = i.charAt(o), o++) : (ae = null, p("any character")), ae !== null ? Y = [Y, ae] : (Y = null, o = _e)) : (Y = null, o = _e), Y !== null && (Oe = Y[0], Ye = Y[1], Y = Oe + Ye), Y === null && (o = Ee)); Y !== null; )
            Q.push(Y), /^[^\\"]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p('[^\\\\"]')), Y === null && (Ee = o, _e = o, i.charCodeAt(o) === 92 ? (Y = "\\", o++) : (Y = null, p('"\\\\"')), Y !== null ? (i.length > o ? (ae = i.charAt(o), o++) : (ae = null, p("any character")), ae !== null ? Y = [Y, ae] : (Y = null, o = _e)) : (Y = null, o = _e), Y !== null && (Y = function(Jt, zt, wn) {
              return zt + wn;
            }(0, Y[0], Y[1])), Y === null && (o = Ee));
          Q !== null ? (i.charCodeAt(o) === 34 ? (Y = '"', o++) : (Y = null, p('"\\""')), Y !== null ? _ = [_, Q, Y] : (_ = null, o = De)) : (_ = null, o = De);
        } else
          _ = null, o = De;
        if (_ !== null && (_ = function(Jt, zt) {
          return { type: "literal", value: ie(zt.join("")) };
        }(0, _[1])), _ === null && (o = ue), _ === null) {
          if (ue = o, De = o, i.charCodeAt(o) === 39 ? (_ = "'", o++) : (_ = null, p(`"'"`)), _ !== null) {
            for (Q = [], /^[^\\']/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[^\\\\']")), Y === null && (Ee = o, _e = o, i.charCodeAt(o) === 92 ? (Y = "\\", o++) : (Y = null, p('"\\\\"')), Y !== null ? (i.length > o ? (ae = i.charAt(o), o++) : (ae = null, p("any character")), ae !== null ? Y = [Y, ae] : (Y = null, o = _e)) : (Y = null, o = _e), Y !== null && (Y = function(Jt, zt, wn) {
              return zt + wn;
            }(0, Y[0], Y[1])), Y === null && (o = Ee)); Y !== null; )
              Q.push(Y), /^[^\\']/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[^\\\\']")), Y === null && (Ee = o, _e = o, i.charCodeAt(o) === 92 ? (Y = "\\", o++) : (Y = null, p('"\\\\"')), Y !== null ? (i.length > o ? (ae = i.charAt(o), o++) : (ae = null, p("any character")), ae !== null ? Y = [Y, ae] : (Y = null, o = _e)) : (Y = null, o = _e), Y !== null && (Y = function(Jt, zt, wn) {
                return zt + wn;
              }(0, Y[0], Y[1])), Y === null && (o = Ee));
            Q !== null ? (i.charCodeAt(o) === 39 ? (Y = "'", o++) : (Y = null, p(`"'"`)), Y !== null ? _ = [_, Q, Y] : (_ = null, o = De)) : (_ = null, o = De);
          } else
            _ = null, o = De;
          _ !== null && (_ = function(Jt, zt) {
            return { type: "literal", value: ie(zt.join("")) };
          }(0, _[1])), _ === null && (o = ue);
        }
        return f[_t] = { nextPos: o, result: _ }, _;
      }
      function L() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "number@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        for (ae = o, ue = o, De = o, _ = [], /^[0-9]/.test(i.charAt(o)) ? (Q = i.charAt(o), o++) : (Q = null, p("[0-9]")); Q !== null; )
          _.push(Q), /^[0-9]/.test(i.charAt(o)) ? (Q = i.charAt(o), o++) : (Q = null, p("[0-9]"));
        if (_ !== null ? (i.charCodeAt(o) === 46 ? (Q = ".", o++) : (Q = null, p('"."')), Q !== null ? _ = [_, Q] : (_ = null, o = De)) : (_ = null, o = De), (_ = _ !== null ? _ : "") !== null) {
          if (/^[0-9]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[0-9]")), Y !== null)
            for (Q = []; Y !== null; )
              Q.push(Y), /^[0-9]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[0-9]"));
          else
            Q = null;
          Q !== null ? _ = [_, Q] : (_ = null, o = ue);
        } else
          _ = null, o = ue;
        return _ !== null && (Ee = _[0], _e = _[1], _ = { type: "literal", value: parseFloat((Ee ? Ee.join("") : "") + _e.join("")) }), _ === null && (o = ae), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function V() {
        var _, Q, Y = "path@" + o, ae = f[Y];
        return ae ? (o = ae.nextPos, ae.result) : (Q = o, (_ = m()) !== null && (_ = function(ue, De) {
          return { type: "literal", value: De };
        }(0, _)), _ === null && (o = Q), f[Y] = { nextPos: o, result: _ }, _);
      }
      function K() {
        var _, Q, Y, ae, ue, De, Ee, _e = "type@" + o, Oe = f[_e];
        if (Oe)
          return o = Oe.nextPos, Oe.result;
        if (De = o, Ee = o, i.substr(o, 5) === "type(" ? (_ = "type(", o += 5) : (_ = null, p('"type("')), _ !== null)
          if ((Q = d()) !== null) {
            if (/^[^ )]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[^ )]")), ae !== null)
              for (Y = []; ae !== null; )
                Y.push(ae), /^[^ )]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[^ )]"));
            else
              Y = null;
            Y !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee);
          } else
            _ = null, o = Ee;
        else
          _ = null, o = Ee;
        return _ !== null && (_ = { type: "type", value: _[2].join("") }), _ === null && (o = De), f[_e] = { nextPos: o, result: _ }, _;
      }
      function W() {
        var _, Q, Y, ae, ue, De = "regex@" + o, Ee = f[De];
        if (Ee)
          return o = Ee.nextPos, Ee.result;
        if (ae = o, ue = o, i.charCodeAt(o) === 47 ? (_ = "/", o++) : (_ = null, p('"/"')), _ !== null) {
          if (/^[^\/]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[^\\/]")), Y !== null)
            for (Q = []; Y !== null; )
              Q.push(Y), /^[^\/]/.test(i.charAt(o)) ? (Y = i.charAt(o), o++) : (Y = null, p("[^\\/]"));
          else
            Q = null;
          Q !== null ? (i.charCodeAt(o) === 47 ? (Y = "/", o++) : (Y = null, p('"/"')), Y !== null ? _ = [_, Q, Y] : (_ = null, o = ue)) : (_ = null, o = ue);
        } else
          _ = null, o = ue;
        return _ !== null && (_ = function(_e, Oe) {
          return { type: "regexp", value: new RegExp(Oe.join("")) };
        }(0, _[1])), _ === null && (o = ae), f[De] = { nextPos: o, result: _ }, _;
      }
      function R() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "field@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        if (De = o, Ee = o, i.charCodeAt(o) === 46 ? (_ = ".", o++) : (_ = null, p('"."')), _ !== null)
          if ((Q = m()) !== null) {
            for (Y = [], _e = o, i.charCodeAt(o) === 46 ? (ae = ".", o++) : (ae = null, p('"."')), ae !== null && (ue = m()) !== null ? ae = [ae, ue] : (ae = null, o = _e); ae !== null; )
              Y.push(ae), _e = o, i.charCodeAt(o) === 46 ? (ae = ".", o++) : (ae = null, p('"."')), ae !== null && (ue = m()) !== null ? ae = [ae, ue] : (ae = null, o = _e);
            Y !== null ? _ = [_, Q, Y] : (_ = null, o = Ee);
          } else
            _ = null, o = Ee;
        else
          _ = null, o = Ee;
        return _ !== null && (_ = function(_t, Kt, Jt) {
          return { type: "field", name: Jt.reduce(function(zt, wn) {
            return zt + wn[0] + wn[1];
          }, Kt) };
        }(0, _[1], _[2])), _ === null && (o = De), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function q() {
        var _, Q, Y, ae, ue, De, Ee, _e = "negation@" + o, Oe = f[_e];
        return Oe ? (o = Oe.nextPos, Oe.result) : (De = o, Ee = o, i.substr(o, 5) === ":not(" ? (_ = ":not(", o += 5) : (_ = null, p('":not("')), _ !== null && (Q = d()) !== null && (Y = v()) !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = { type: "not", selectors: _[2] }), _ === null && (o = De), f[_e] = { nextPos: o, result: _ }, _);
      }
      function J() {
        var _, Q, Y, ae, ue, De, Ee, _e = "matches@" + o, Oe = f[_e];
        return Oe ? (o = Oe.nextPos, Oe.result) : (De = o, Ee = o, i.substr(o, 9) === ":matches(" ? (_ = ":matches(", o += 9) : (_ = null, p('":matches("')), _ !== null && (Q = d()) !== null && (Y = v()) !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = { type: "matches", selectors: _[2] }), _ === null && (o = De), f[_e] = { nextPos: o, result: _ }, _);
      }
      function X() {
        var _, Q, Y, ae, ue, De, Ee, _e = "has@" + o, Oe = f[_e];
        return Oe ? (o = Oe.nextPos, Oe.result) : (De = o, Ee = o, i.substr(o, 5) === ":has(" ? (_ = ":has(", o += 5) : (_ = null, p('":has("')), _ !== null && (Q = d()) !== null && (Y = v()) !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee), _ !== null && (_ = { type: "has", selectors: _[2] }), _ === null && (o = De), f[_e] = { nextPos: o, result: _ }, _);
      }
      function ce() {
        var _, Q, Y = "firstChild@" + o, ae = f[Y];
        return ae ? (o = ae.nextPos, ae.result) : (Q = o, i.substr(o, 12) === ":first-child" ? (_ = ":first-child", o += 12) : (_ = null, p('":first-child"')), _ !== null && (_ = he(1)), _ === null && (o = Q), f[Y] = { nextPos: o, result: _ }, _);
      }
      function A() {
        var _, Q, Y = "lastChild@" + o, ae = f[Y];
        return ae ? (o = ae.nextPos, ae.result) : (Q = o, i.substr(o, 11) === ":last-child" ? (_ = ":last-child", o += 11) : (_ = null, p('":last-child"')), _ !== null && (_ = j(1)), _ === null && (o = Q), f[Y] = { nextPos: o, result: _ }, _);
      }
      function M() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "nthChild@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        if (De = o, Ee = o, i.substr(o, 11) === ":nth-child(" ? (_ = ":nth-child(", o += 11) : (_ = null, p('":nth-child("')), _ !== null)
          if ((Q = d()) !== null) {
            if (/^[0-9]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[0-9]")), ae !== null)
              for (Y = []; ae !== null; )
                Y.push(ae), /^[0-9]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[0-9]"));
            else
              Y = null;
            Y !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee);
          } else
            _ = null, o = Ee;
        else
          _ = null, o = Ee;
        return _ !== null && (_e = _[2], _ = he(parseInt(_e.join(""), 10))), _ === null && (o = De), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function ne() {
        var _, Q, Y, ae, ue, De, Ee, _e, Oe = "nthLastChild@" + o, Ye = f[Oe];
        if (Ye)
          return o = Ye.nextPos, Ye.result;
        if (De = o, Ee = o, i.substr(o, 16) === ":nth-last-child(" ? (_ = ":nth-last-child(", o += 16) : (_ = null, p('":nth-last-child("')), _ !== null)
          if ((Q = d()) !== null) {
            if (/^[0-9]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[0-9]")), ae !== null)
              for (Y = []; ae !== null; )
                Y.push(ae), /^[0-9]/.test(i.charAt(o)) ? (ae = i.charAt(o), o++) : (ae = null, p("[0-9]"));
            else
              Y = null;
            Y !== null && (ae = d()) !== null ? (i.charCodeAt(o) === 41 ? (ue = ")", o++) : (ue = null, p('")"')), ue !== null ? _ = [_, Q, Y, ae, ue] : (_ = null, o = Ee)) : (_ = null, o = Ee);
          } else
            _ = null, o = Ee;
        else
          _ = null, o = Ee;
        return _ !== null && (_e = _[2], _ = j(parseInt(_e.join(""), 10))), _ === null && (o = De), f[Oe] = { nextPos: o, result: _ }, _;
      }
      function de() {
        var _, Q, Y, ae, ue = "class@" + o, De = f[ue];
        return De ? (o = De.nextPos, De.result) : (Y = o, ae = o, i.charCodeAt(o) === 58 ? (_ = ":", o++) : (_ = null, p('":"')), _ !== null ? (i.substr(o, 9).toLowerCase() === "statement" ? (Q = i.substr(o, 9), o += 9) : (Q = null, p('"statement"')), Q === null && (i.substr(o, 10).toLowerCase() === "expression" ? (Q = i.substr(o, 10), o += 10) : (Q = null, p('"expression"')), Q === null && (i.substr(o, 11).toLowerCase() === "declaration" ? (Q = i.substr(o, 11), o += 11) : (Q = null, p('"declaration"')), Q === null && (i.substr(o, 8).toLowerCase() === "function" ? (Q = i.substr(o, 8), o += 8) : (Q = null, p('"function"')), Q === null && (i.substr(o, 7).toLowerCase() === "pattern" ? (Q = i.substr(o, 7), o += 7) : (Q = null, p('"pattern"')))))), Q !== null ? _ = [_, Q] : (_ = null, o = ae)) : (_ = null, o = ae), _ !== null && (_ = { type: "class", name: _[1] }), _ === null && (o = Y), f[ue] = { nextPos: o, result: _ }, _);
      }
      function he(_) {
        return { type: "nth-child", index: { type: "literal", value: _ } };
      }
      function j(_) {
        return { type: "nth-last-child", index: { type: "literal", value: _ } };
      }
      function ie(_) {
        return _.replace(/\\(.)/g, function(Q, Y) {
          switch (Y) {
            case "a":
              return "a";
            case "b":
              return "\b";
            case "f":
              return "\f";
            case "n":
              return `
`;
            case "r":
              return "\r";
            case "t":
              return "	";
            case "v":
              return "\v";
            default:
              return Y;
          }
        });
      }
      var fe = s[a]();
      if (fe === null || o !== i.length) {
        var ge = Math.max(o, u), Fe = ge < i.length ? i.charAt(ge) : null, Pe = function() {
          for (var _ = 1, Q = 1, Y = !1, ae = 0; ae < Math.max(o, u); ae++) {
            var ue = i.charAt(ae);
            ue === `
` ? (Y || _++, Q = 1, Y = !1) : ue === "\r" || ue === "\u2028" || ue === "\u2029" ? (_++, Q = 1, Y = !0) : (Q++, Y = !1);
          }
          return { line: _, column: Q };
        }();
        throw new this.SyntaxError(function(_) {
          _.sort();
          for (var Q = null, Y = [], ae = 0; ae < _.length; ae++)
            _[ae] !== Q && (Y.push(_[ae]), Q = _[ae]);
          return Y;
        }(c), Fe, ge, Pe.line, Pe.column);
      }
      return fe;
    }, toSource: function() {
      return this._source;
    }, SyntaxError: function(i, a, s, o, u) {
      this.name = "SyntaxError", this.expected = i, this.found = a, this.message = function(c, f) {
        var p;
        switch (c.length) {
          case 0:
            p = "end of input";
            break;
          case 1:
            p = c[0];
            break;
          default:
            p = c.slice(0, c.length - 1).join(", ") + " or " + c[c.length - 1];
        }
        return "Expected " + p + " but " + (f ? n(f) : "end of input") + " found.";
      }(i, a), this.offset = s, this.line = o, this.column = u;
    } };
    return r.SyntaxError.prototype = Error.prototype, r;
  }();
  e.exports ? e.exports = t : ni.esquery = t;
})), $T = gt(function(e) {
  (function() {
    var t = Cc, n = WT, r = Array.isArray || function(o) {
      return {}.toString.call(o) === "[object Array]";
    }, i = {}, a = {};
    function s() {
      function o(v, b, x) {
        var C, k, F;
        if (x.length === 0)
          return v === b;
        if (b == null)
          return !1;
        if (C = b[x[0]], k = x.slice(1), r(C)) {
          for (F = 0, l = C.length; F < l; ++F)
            if (o(v, C[F], k))
              return !0;
          return !1;
        }
        return o(v, C, k);
      }
      function u(v, b, x) {
        var C, k, F, B;
        if (!b)
          return !0;
        if (!v)
          return !1;
        switch (x || (x = []), b.type) {
          case "wildcard":
            return !0;
          case "identifier":
            return b.value.toLowerCase() === v.type.toLowerCase();
          case "field":
            return o(v, x[(C = b.name.split(".")).length - 1], C);
          case "matches":
            for (k = 0, F = b.selectors.length; k < F; ++k)
              if (u(v, b.selectors[k], x))
                return !0;
            return !1;
          case "compound":
            for (k = 0, F = b.selectors.length; k < F; ++k)
              if (!u(v, b.selectors[k], x))
                return !1;
            return !0;
          case "not":
            for (k = 0, F = b.selectors.length; k < F; ++k)
              if (u(v, b.selectors[k], x))
                return !1;
            return !0;
          case "has":
            var O, S = [];
            for (k = 0, F = b.selectors.length; k < F; ++k)
              O = [], t.traverse(v, { enter: function(w, D) {
                D != null && O.unshift(D), u(w, b.selectors[k], O) && S.push(w);
              }, leave: function() {
                O.shift();
              } });
            return S.length !== 0;
          case "child":
            return !!u(v, b.right, x) && u(x[0], b.left, x.slice(1));
          case "descendant":
            if (u(v, b.right, x)) {
              for (k = 0, F = x.length; k < F; ++k)
                if (u(x[k], b.left, x.slice(k + 1)))
                  return !0;
            }
            return !1;
          case "attribute":
            switch (B = function(w, D) {
              var I, L = D.split(".");
              for (I = 0; I < L.length; I++) {
                if (w == null)
                  return w;
                w = w[L[I]];
              }
              return w;
            }(v, b.name), b.operator) {
              case null:
              case void 0:
                return B != null;
              case "=":
                switch (b.value.type) {
                  case "regexp":
                    return typeof B == "string" && b.value.value.test(B);
                  case "literal":
                    return "" + b.value.value == "" + B;
                  case "type":
                    return b.value.value === xe(B);
                }
              case "!=":
                switch (b.value.type) {
                  case "regexp":
                    return !b.value.value.test(B);
                  case "literal":
                    return "" + b.value.value != "" + B;
                  case "type":
                    return b.value.value !== xe(B);
                }
              case "<=":
                return B <= b.value.value;
              case "<":
                return B < b.value.value;
              case ">":
                return B > b.value.value;
              case ">=":
                return B >= b.value.value;
            }
          case "sibling":
            return u(v, b.right, x) && c(v, b.left, x, i) || b.left.subject && u(v, b.left, x) && c(v, b.right, x, a);
          case "adjacent":
            return u(v, b.right, x) && f(v, b.left, x, i) || b.right.subject && u(v, b.left, x) && f(v, b.right, x, a);
          case "nth-child":
            return u(v, b.right, x) && p(v, x, function(w) {
              return b.index.value - 1;
            });
          case "nth-last-child":
            return u(v, b.right, x) && p(v, x, function(w) {
              return w - b.index.value;
            });
          case "class":
            if (!v.type)
              return !1;
            switch (b.name.toLowerCase()) {
              case "statement":
                if (v.type.slice(-9) === "Statement")
                  return !0;
              case "declaration":
                return v.type.slice(-11) === "Declaration";
              case "pattern":
                if (v.type.slice(-7) === "Pattern")
                  return !0;
              case "expression":
                return v.type.slice(-10) === "Expression" || v.type.slice(-7) === "Literal" || v.type === "Identifier" && (x.length === 0 || x[0].type !== "MetaProperty") || v.type === "MetaProperty";
              case "function":
                return v.type.slice(0, 8) === "Function" || v.type === "ArrowFunctionExpression";
            }
            throw new Error("Unknown class name: " + b.name);
        }
        throw new Error("Unknown selector type: " + b.type);
      }
      function c(v, b, x, C) {
        var k, F, B, O, S, w, D, I, L = x[0];
        if (!L)
          return !1;
        for (O = 0, S = (B = t.VisitorKeys[L.type]).length; O < S; ++O)
          if (k = L[B[O]], r(k)) {
            if ((F = k.indexOf(v)) < 0)
              continue;
            for (C === i ? (D = 0, I = F) : (D = F + 1, I = k.length), w = D; w < I; ++w)
              if (u(k[w], b, x))
                return !0;
          }
        return !1;
      }
      function f(v, b, x, C) {
        var k, F, B, O, S, w = x[0];
        if (!w)
          return !1;
        for (B = 0, O = (F = t.VisitorKeys[w.type]).length; B < O; ++B)
          if (k = w[F[B]], r(k)) {
            if ((S = k.indexOf(v)) < 0)
              continue;
            if (C === i && S > 0 && u(k[S - 1], b, x) || C === a && S < k.length - 1 && u(k[S + 1], b, x))
              return !0;
          }
        return !1;
      }
      function p(v, b, x) {
        var C, k, F, B, O, S = b[0];
        if (!S)
          return !1;
        for (F = 0, B = (k = t.VisitorKeys[S.type]).length; F < B; ++F)
          if (C = S[k[F]], r(C) && (O = C.indexOf(v)) >= 0 && O === x(C.length))
            return !0;
        return !1;
      }
      function d(v, b) {
        var x, C, k, F, B, O = [], S = [];
        return b && (x = function w(D, I) {
          var L, V;
          if (D == null || xe(D) != "object")
            return [];
          for (V in I == null && (I = D), L = D.subject ? [I] : [], D)
            ({}).hasOwnProperty.call(D, V) && [].push.apply(L, w(D[V], V === "left" ? D[V] : I));
          return L;
        }(b), t.traverse(v, { enter: function(w, D) {
          if (D != null && O.unshift(D), u(w, b, O))
            if (x.length)
              for (C = 0, k = x.length; C < k; ++C)
                for (u(w, x[C], O) && S.push(w), F = 0, B = O.length; F < B; ++F)
                  u(O[F], x[C], O.slice(F + 1)) && S.push(O[F]);
            else
              S.push(w);
        }, leave: function() {
          O.shift();
        } })), S;
      }
      function m(v) {
        return n.parse(v);
      }
      function y(v, b) {
        return d(v, m(b));
      }
      return y.parse = m, y.match = d, y.matches = u, y.query = y;
    }
    e.exports ? e.exports = s() : this.esquery = s();
  })();
}), GT = Cr(_T);
function io(e) {
  return e && xe(e) == "object" && "default" in e ? e.default : e;
}
var Bs = io(P4), ww = io(a9), zT = io(j4), HT = io(ST), gb = io(GT), Rr = io(xn), KT = io(lp), Aw = io($T), Nd, Wl = function(e, t) {
  for (var n = {}, r = 0, i = Object.entries(e); r < i.length; r++) {
    var a = bn(i[r], 2), s = a[0], o = a[1];
    Object.hasOwnProperty.call(t, s) || (n[s] = o);
  }
  return n;
}(ye.globals.es2015, ye.globals.es5), yb = { Atomics: !1, SharedArrayBuffer: !1 }, _w = new Map(Object.entries({ builtin: { globals: ye.globals.es5 }, es6: { globals: Wl, parserOptions: { ecmaVersion: 6 } }, es2015: { globals: Wl, parserOptions: { ecmaVersion: 6 } }, es2017: { globals: Sa({}, Wl, {}, yb), parserOptions: { ecmaVersion: 8 } }, es2020: { globals: Sa({}, Wl, {}, yb, {}, { BigInt: !1, BigInt64Array: !1, BigUint64Array: !1 }), parserOptions: { ecmaVersion: 11 } }, browser: { globals: ye.globals.browser }, node: { globals: ye.globals.node, parserOptions: { ecmaFeatures: { globalReturn: !0 } } }, "shared-node-browser": { globals: ye.globals["shared-node-browser"] }, worker: { globals: ye.globals.worker }, serviceworker: { globals: ye.globals.serviceworker }, commonjs: { globals: ye.globals.commonjs, parserOptions: { ecmaFeatures: { globalReturn: !0 } } }, amd: { globals: ye.globals.amd }, mocha: { globals: ye.globals.mocha }, jasmine: { globals: ye.globals.jasmine }, jest: { globals: ye.globals.jest }, phantomjs: { globals: ye.globals.phantomjs }, jquery: { globals: ye.globals.jquery }, qunit: { globals: ye.globals.qunit }, prototypejs: { globals: ye.globals.prototypejs }, shelljs: { globals: ye.globals.shelljs }, meteor: { globals: ye.globals.meteor }, mongo: { globals: ye.globals.mongo }, protractor: { globals: ye.globals.protractor }, applescript: { globals: ye.globals.applescript }, nashorn: { globals: ye.globals.nashorn }, atomtest: { globals: ye.globals.atomtest }, embertest: { globals: ye.globals.embertest }, webextensions: { globals: ye.globals.webextensions }, greasemonkey: { globals: ye.globals.greasemonkey } })), Tw = "eslint@6.7.1", Pw = "sha512-UWzBS79pNcsDSxgxbdjkmzn/B6BhsXMfUaOHnNwyE8nD+Q6pyT96ow2MccVayUTV4yMid4qLhMiQaywctRkBLA==", Iw = {}, Bw = { type: "range", registry: !0, raw: "eslint@^6.0.0", name: "eslint", escapedName: "eslint", rawSpec: "^6.0.0", saveSpec: null, fetchSpec: "^6.0.0" }, Ow = ["#DEV:/"], Lw = "https://registry.npmjs.org/eslint/-/eslint-6.7.1.tgz", Nw = "269ccccec3ef60ab32358a44d147ac209154b919", jw = "/home/runner/work/eslint4b/eslint4b", Rw = { name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com" }, Mw = { eslint: "./bin/eslint.js" }, Vw = { url: "https://github.com/eslint/eslint/issues/" }, Uw = { "@babel/code-frame": "^7.0.0", ajv: "^6.10.0", chalk: "^2.1.0", "cross-spawn": "^6.0.5", debug: "^4.0.1", doctrine: "^3.0.0", "eslint-scope": "^5.0.0", "eslint-utils": "^1.4.3", "eslint-visitor-keys": "^1.1.0", espree: "^6.1.2", esquery: "^1.0.1", esutils: "^2.0.2", "file-entry-cache": "^5.0.1", "functional-red-black-tree": "^1.0.1", "glob-parent": "^5.0.0", globals: "^12.1.0", ignore: "^4.0.6", "import-fresh": "^3.0.0", imurmurhash: "^0.1.4", inquirer: "^7.0.0", "is-glob": "^4.0.0", "js-yaml": "^3.13.1", "json-stable-stringify-without-jsonify": "^1.0.1", levn: "^0.3.0", lodash: "^4.17.14", minimatch: "^3.0.4", mkdirp: "^0.5.1", "natural-compare": "^1.4.0", optionator: "^0.8.3", progress: "^2.0.0", regexpp: "^2.0.1", semver: "^6.1.2", "strip-ansi": "^5.2.0", "strip-json-comments": "^3.0.1", table: "^5.2.3", "text-table": "^0.2.0", "v8-compile-cache": "^2.0.3" }, qw = "An AST-based pattern checker for JavaScript.", Ww = { "@babel/core": "^7.4.3", "@babel/preset-env": "^7.4.3", acorn: "^7.1.0", "babel-loader": "^8.0.5", chai: "^4.0.1", cheerio: "^0.22.0", "common-tags": "^1.8.0", "core-js": "^3.1.3", dateformat: "^3.0.3", ejs: "^2.6.1", eslint: "file:.", "eslint-config-eslint": "file:packages/eslint-config-eslint", "eslint-plugin-eslint-plugin": "^2.0.1", "eslint-plugin-internal-rules": "file:tools/internal-rules", "eslint-plugin-jsdoc": "^15.9.5", "eslint-plugin-node": "^9.0.0", "eslint-release": "^1.2.0", eslump: "^2.0.0", esprima: "^4.0.1", glob: "^7.1.3", jsdoc: "^3.5.5", karma: "^4.0.1", "karma-chrome-launcher": "^2.2.0", "karma-mocha": "^1.3.0", "karma-mocha-reporter": "^2.2.3", "karma-webpack": "^4.0.0-rc.6", leche: "^2.2.3", "lint-staged": "^8.1.5", "load-perf": "^0.2.0", markdownlint: "^0.15.0", "markdownlint-cli": "^0.17.0", "metro-memory-fs": "^0.54.1", mocha: "^6.1.2", "mocha-junit-reporter": "^1.23.0", "npm-license": "^0.3.3", nyc: "^14.1.1", proxyquire: "^2.0.1", puppeteer: "^1.18.0", recast: "^0.18.1", "regenerator-runtime": "^0.13.2", shelljs: "^0.8.2", sinon: "^7.3.2", temp: "^0.9.0", webpack: "^4.35.0", "webpack-cli": "^3.3.5", yorkie: "^2.0.0" }, $w = { node: "^8.10.0 || ^10.13.0 || >=11.10.1" }, Gw = ["LICENSE", "README.md", "bin", "conf", "lib", "messages"], zw = "https://opencollective.com/eslint", Hw = { "pre-commit": "lint-staged" }, Kw = ["ast", "lint", "javascript", "ecmascript", "espree"], Jw = { type: "git", url: "git+https://github.com/eslint/eslint.git" }, Qw = { docs: "node Makefile.js docs", fix: "node Makefile.js lint -- fix", fuzz: "node Makefile.js fuzz", "generate-alpharelease": "node Makefile.js generatePrerelease -- alpha", "generate-betarelease": "node Makefile.js generatePrerelease -- beta", "generate-rcrelease": "node Makefile.js generatePrerelease -- rc", "generate-release": "node Makefile.js generateRelease", gensite: "node Makefile.js gensite", lint: "node Makefile.js lint", perf: "node Makefile.js perf", "publish-release": "node Makefile.js publishRelease", test: "node Makefile.js test", "test:cli": "mocha", webpack: "node Makefile.js webpack" }, JT = { _from: "eslint@^6.0.0", _id: Tw, _inBundle: !1, _integrity: Pw, _location: "/eslint", _phantomChildren: Iw, _requested: Bw, _requiredBy: Ow, _resolved: Lw, _shasum: Nw, _spec: "eslint@^6.0.0", _where: jw, author: Rw, bin: Mw, bugs: Vw, bundleDependencies: !1, dependencies: Uw, deprecated: !1, description: qw, devDependencies: Ww, engines: $w, files: Gw, funding: zw, gitHooks: Hw, homepage: "https://eslint.org", keywords: Kw, license: "MIT", "lint-staged": { "*.js": ["eslint --fix", "git add"], "*.md": "markdownlint" }, main: "./lib/api.js", name: "eslint", repository: Jw, scripts: Qw, version: "6.7.1" }, QT = Object.freeze({ __proto__: null, _from: "eslint@^6.0.0", _id: Tw, _inBundle: !1, _integrity: Pw, _location: "/eslint", _phantomChildren: Iw, _requested: Bw, _requiredBy: Ow, _resolved: Lw, _shasum: Nw, _spec: "eslint@^6.0.0", _where: jw, author: Rw, bin: Mw, bugs: Vw, bundleDependencies: !1, dependencies: Uw, deprecated: !1, description: qw, devDependencies: Ww, engines: $w, files: Gw, funding: zw, gitHooks: Hw, homepage: "https://eslint.org", keywords: Kw, license: "MIT", main: "./lib/api.js", name: "eslint", repository: Jw, scripts: Qw, version: "6.7.1", default: JT }), bi = ye.createCommonjsModule(function(e) {
  var t = ["off", "warn", "error"], n = t.reduce(function(i, a, s) {
    return i[a] = s, i;
  }, {}), r = [0, 1, 2, "off", "warn", "error"];
  e.exports = { getRuleSeverity: function(i) {
    var a = Array.isArray(i) ? i[0] : i;
    return a === 0 || a === 1 || a === 2 ? a : typeof a == "string" && n[a.toLowerCase()] || 0;
  }, normalizeToStrings: function(i) {
    i.rules && Object.keys(i.rules).forEach(function(a) {
      var s = i.rules[a];
      typeof s == "number" ? i.rules[a] = t[s] || t[0] : Array.isArray(s) && typeof s[0] == "number" && (s[0] = t[s[0]] || t[0]);
    });
  }, isErrorSeverity: function(i) {
    return e.exports.getRuleSeverity(i) === 2;
  }, isValidSeverity: function(i) {
    var a = Array.isArray(i) ? i[0] : i;
    return typeof a == "string" && (a = a.toLowerCase()), r.indexOf(a) !== -1;
  }, isEverySeverityValid: function(i) {
    var a = this;
    return Object.keys(i).every(function(s) {
      return a.isValidSeverity(i[s]);
    });
  }, normalizeConfigGlobal: function(i) {
    switch (i) {
      case "off":
        return "off";
      case !0:
      case "true":
      case "writeable":
      case "writable":
        return "writable";
      case null:
      case !1:
      case "false":
      case "readable":
      case "readonly":
        return "readonly";
      default:
        throw new Error("'".concat(i, "' is not a valid configuration for a global (use 'readonly', 'writable', or 'off')"));
    }
  } };
}), vb = (bi.getRuleSeverity, bi.normalizeToStrings, bi.isErrorSeverity, bi.isValidSeverity, bi.isEverySeverityValid, bi.normalizeConfigGlobal, { env: { type: "object" }, extends: { $ref: "#/definitions/stringOrStrings" }, globals: { type: "object" }, overrides: { type: "array", items: { $ref: "#/definitions/overrideConfig" }, additionalItems: !1 }, parser: { type: ["string", "null"] }, parserOptions: { type: "object" }, plugins: { type: "array" }, processor: { type: "string" }, rules: { type: "object" }, settings: { type: "object" }, noInlineConfig: { type: "boolean" }, reportUnusedDisableDirectives: { type: "boolean" }, ecmaFeatures: { type: "object" } }), XT = { definitions: { stringOrStrings: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: !1 }] }, stringOrStringsRequired: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: !1, minItems: 1 }] }, objectConfig: { type: "object", properties: Sa({ root: { type: "boolean" }, ignorePatterns: { $ref: "#/definitions/stringOrStrings" } }, vb), additionalProperties: !1 }, overrideConfig: { type: "object", properties: Sa({ excludedFiles: { $ref: "#/definitions/stringOrStrings" }, files: { $ref: "#/definitions/stringOrStringsRequired" } }, vb), required: ["files"], additionalProperties: !1 } }, $ref: "#/definitions/objectConfig" }, pp = /* @__PURE__ */ new Map(), Xw = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = new HT(Sa({ meta: !1, useDefaults: !0, validateSchema: !1, missingRefs: "ignore", verbose: !0, schemaId: "auto" }, e));
  return t.addMetaSchema(gb), t._opts.defaultMeta = gb.id, t;
}(), jd = /* @__PURE__ */ new WeakMap(), Yw = Function.prototype, YT = { ESLINT_LEGACY_ECMAFEATURES: "The 'ecmaFeatures' config file property is deprecated, and has no effect." }, ZT = { error: 2, warn: 1, off: 0 };
function Zw(e) {
  if (!e)
    return null;
  var t = e.schema || e.meta && e.meta.schema;
  return Array.isArray(t) ? t.length ? { type: "array", items: t, minItems: 0, maxItems: t.length } : { type: "array", minItems: 0, maxItems: 0 } : t || null;
}
function eA(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  try {
    (function(a) {
      var s = Array.isArray(a) ? a[0] : a, o = typeof s == "string" ? ZT[s.toLowerCase()] : s;
      if (o === 0 || o === 1 || o === 2)
        return o;
      throw new Error("	Severity should be one of the following: 0 = off, 1 = warn, 2 = error (you passed '".concat(zT.inspect(s).replace(/'/g, '"').replace(/\n/g, ""), `').
`));
    })(n) !== 0 && function(a, s) {
      if (!jd.has(a)) {
        var o = Zw(a);
        o && jd.set(a, Xw.compile(o));
      }
      var u = jd.get(a);
      if (u && (u(s), u.errors))
        throw new Error(u.errors.map(function(c) {
          return "	Value ".concat(JSON.stringify(c.data), " ").concat(c.message, `.
`);
        }).join(""));
    }(e, Array.isArray(n) ? n.slice(1) : []);
  } catch (a) {
    var i = 'Configuration for rule "'.concat(t, `" is invalid:
`).concat(a.message);
    throw typeof r == "string" ? new Error("".concat(r, `:
	`).concat(i)) : new Error(i);
  }
}
function Rd(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Yw;
  e && Object.keys(e).forEach(function(r) {
    if (!(n(r) || _w.get(r)))
      throw new Error("".concat(t, `:
	Environment key "`).concat(r, `" is unknown
`));
  });
}
function Md(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Yw;
  e && Object.keys(e).forEach(function(r) {
    eA(n(r) || pp.get(r) || null, r, e[r], t);
  });
}
function Vd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  e && Object.entries(e).forEach(function(n) {
    var r = bn(n, 2), i = r[0], a = r[1];
    try {
      bi.normalizeConfigGlobal(a);
    } catch (s) {
      throw new Error("ESLint configuration of global '".concat(i, "' in ").concat(t, ` is invalid:
`).concat(s.message));
    }
  });
}
function eP(e, t, n) {
  if (e && !n(e))
    throw new Error("ESLint configuration of processor in '".concat(t, "' is invalid: '").concat(e, "' was not found."));
}
var tP = ye.lodash.memoize(function(e, t) {
  var n = Bs.relative(process.cwd(), e), r = YT[t];
  process.emitWarning("".concat(r, ' (found in "').concat(n, '")'), "DeprecationWarning", t);
});
function xb(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!(Nd = Nd || Xw.compile(XT))(e))
    throw new Error("ESLint configuration in ".concat(t, ` is invalid:
`).concat(function(n) {
      return n.map(function(r) {
        if (r.keyword === "additionalProperties") {
          var i = r.dataPath.length ? "".concat(r.dataPath.slice(1), ".").concat(r.params.additionalProperty) : r.params.additionalProperty;
          return 'Unexpected top-level property "'.concat(i, '"');
        }
        if (r.keyword === "type") {
          var a = r.dataPath.slice(1), s = Array.isArray(r.schema) ? r.schema.join("/") : r.schema, o = JSON.stringify(r.data);
          return 'Property "'.concat(a, '" is the wrong type (expected ').concat(s, " but got `").concat(o, "`)");
        }
        var u = r.dataPath[0] === "." ? r.dataPath.slice(1) : r.dataPath;
        return '"'.concat(u, '" ').concat(r.message, ". Value: ").concat(JSON.stringify(r.data));
      }).map(function(r) {
        return "	- ".concat(r, `.
`);
      }).join("");
    }(Nd.errors)));
  Object.hasOwnProperty.call(e, "ecmaFeatures") && tP(t, "ESLINT_LEGACY_ECMAFEATURES");
}
var bb = /* @__PURE__ */ new WeakSet(), nP = { getRuleOptionsSchema: Zw, validate: function(e, t, n, r) {
  xb(e, t), Md(e.rules, t, n), Rd(e.env, t, r), Vd(e.globals, t);
  var i = !0, a = !1, s = void 0;
  try {
    for (var o, u = (e.overrides || [])[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
      var c = o.value;
      Md(c.rules, t, n), Rd(c.env, t, r), Vd(e.globals, t);
    }
  } catch (f) {
    a = !0, s = f;
  } finally {
    try {
      i || u.return == null || u.return();
    } finally {
      if (a)
        throw s;
    }
  }
}, validateConfigArray: function(e) {
  var t = Map.prototype.get.bind(e.pluginEnvironments), n = Map.prototype.get.bind(e.pluginProcessors), r = Map.prototype.get.bind(e.pluginRules), i = !0, a = !1, s = void 0;
  try {
    for (var o, u = e[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
      var c = o.value;
      bb.has(c) || (bb.add(c), Rd(c.env, c.name, t), Vd(c.globals, c.name), eP(c.processor, c.name, n), Md(c.rules, c.name, r));
    }
  } catch (f) {
    a = !0, s = f;
  } finally {
    try {
      i || u.return == null || u.return();
    } finally {
      if (a)
        throw s;
    }
  }
}, validateConfigSchema: xb, validateRuleOptions: eA }, Dc = function() {
  function e() {
    We(this, e), this.current = null;
  }
  return Xe(e, [{ key: "getOneToken", value: function() {
    return this.moveNext() ? this.current : null;
  } }, { key: "getAllTokens", value: function() {
    for (var t = []; this.moveNext(); )
      t.push(this.current);
    return t;
  } }, { key: "moveNext", value: function() {
    throw new Error("Not implemented.");
  } }]), e;
}();
function rP(e) {
  return e.range[0];
}
var _a = { search: function(e, t) {
  return ye.lodash.sortedIndexBy(e, { range: [t] }, rP);
}, getFirstIndex: function(e, t, n) {
  if (n in t)
    return t[n];
  if (n - 1 in t) {
    var r = t[n - 1], i = 0 <= r && r < e.length ? e[r] : null;
    return i && i.range[0] >= n ? r : r + 1;
  }
  return 0;
}, getLastIndex: function(e, t, n) {
  if (n in t)
    return t[n] - 1;
  if (n - 1 in t) {
    var r = t[n - 1], i = 0 <= r && r < e.length ? e[r] : null;
    return i && i.range[1] > n ? r - 1 : r;
  }
  return e.length - 1;
} }, iP = function(e) {
  function t(n, r, i, a, s) {
    var o;
    return We(this, t), (o = Gt(this, rt(t).call(this))).tokens = n, o.comments = r, o.tokenIndex = _a.getLastIndex(n, i, s), o.commentIndex = _a.search(r, s) - 1, o.border = a, o;
  }
  return $t(t, Dc), Xe(t, [{ key: "moveNext", value: function() {
    var n = 0 <= this.tokenIndex ? this.tokens[this.tokenIndex] : null, r = 0 <= this.commentIndex ? this.comments[this.commentIndex] : null;
    return n && (!r || n.range[1] > r.range[1]) ? (this.current = n, this.tokenIndex -= 1) : r ? (this.current = r, this.commentIndex -= 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[0] >= this.border);
  } }]), t;
}(), aP = function(e) {
  function t(n, r, i, a, s) {
    var o;
    return We(this, t), (o = Gt(this, rt(t).call(this))).tokens = n, o.index = _a.getLastIndex(n, i, s), o.indexEnd = _a.getFirstIndex(n, i, a), o;
  }
  return $t(t, Dc), Xe(t, [{ key: "moveNext", value: function() {
    return this.index >= this.indexEnd && (this.current = this.tokens[this.index], this.index -= 1, !0);
  } }, { key: "getOneToken", value: function() {
    return this.index >= this.indexEnd ? this.tokens[this.index] : null;
  } }]), t;
}(), ag = function(e) {
  function t(n) {
    var r;
    return We(this, t), (r = Gt(this, rt(t).call(this))).cursor = n, r;
  }
  return $t(t, Dc), Xe(t, [{ key: "moveNext", value: function() {
    var n = this.cursor.moveNext();
    return this.current = this.cursor.current, n;
  } }]), t;
}(), oP = function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, n))).predicate = r, i;
  }
  return $t(t, ag), Xe(t, [{ key: "moveNext", value: function() {
    for (var n = this.predicate; Yn(rt(t.prototype), "moveNext", this).call(this); )
      if (n(this.current))
        return !0;
    return !1;
  } }]), t;
}(), sP = function(e) {
  function t(n, r, i, a, s) {
    var o;
    return We(this, t), (o = Gt(this, rt(t).call(this))).tokens = n, o.comments = r, o.tokenIndex = _a.getFirstIndex(n, i, a), o.commentIndex = _a.search(r, a), o.border = s, o;
  }
  return $t(t, Dc), Xe(t, [{ key: "moveNext", value: function() {
    var n = this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex] : null, r = this.commentIndex < this.comments.length ? this.comments[this.commentIndex] : null;
    return n && (!r || n.range[0] < r.range[0]) ? (this.current = n, this.tokenIndex += 1) : r ? (this.current = r, this.commentIndex += 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[1] <= this.border);
  } }]), t;
}(), og = function(e) {
  function t(n, r, i, a, s) {
    var o;
    return We(this, t), (o = Gt(this, rt(t).call(this))).tokens = n, o.index = _a.getFirstIndex(n, i, a), o.indexEnd = _a.getLastIndex(n, i, s), o;
  }
  return $t(t, Dc), Xe(t, [{ key: "moveNext", value: function() {
    return this.index <= this.indexEnd && (this.current = this.tokens[this.index], this.index += 1, !0);
  } }, { key: "getOneToken", value: function() {
    return this.index <= this.indexEnd ? this.tokens[this.index] : null;
  } }, { key: "getAllTokens", value: function() {
    return this.tokens.slice(this.index, this.indexEnd + 1);
  } }]), t;
}(), uP = function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, n))).count = r, i;
  }
  return $t(t, ag), Xe(t, [{ key: "moveNext", value: function() {
    return 0 < this.count && (this.count -= 1, Yn(rt(t.prototype), "moveNext", this).call(this));
  } }]), t;
}(), cP = function(e) {
  function t(n, r) {
    var i;
    return We(this, t), (i = Gt(this, rt(t).call(this, n))).count = r, i;
  }
  return $t(t, ag), Xe(t, [{ key: "moveNext", value: function() {
    for (; 0 < this.count; )
      if (this.count -= 1, !Yn(rt(t.prototype), "moveNext", this).call(this))
        return !1;
    return Yn(rt(t.prototype), "moveNext", this).call(this);
  } }]), t;
}(), Eb = function() {
  function e(t, n) {
    We(this, e), this.TokenCursor = t, this.TokenCommentCursor = n;
  }
  return Xe(e, [{ key: "createBaseCursor", value: function(t, n, r, i, a, s) {
    return new (s ? this.TokenCommentCursor : this.TokenCursor)(t, n, r, i, a);
  } }, { key: "createCursor", value: function(t, n, r, i, a, s, o, u, c) {
    var f = this.createBaseCursor(t, n, r, i, a, s);
    return o && (f = new oP(f, o)), 1 <= u && (f = new cP(f, u)), 0 <= c && (f = new uP(f, c)), f;
  } }]), e;
}(), Qn = { forward: new Eb(og, sP), backward: new Eb(aP, iP) }, lP = function(e) {
  function t(n, r, i, a, s, o, u) {
    var c;
    return We(this, t), (c = Gt(this, rt(t).call(this, n, r, i, a, s))).index = Math.max(0, c.index - o), c.indexEnd = Math.min(n.length - 1, c.indexEnd + u), c;
  }
  return $t(t, og), t;
}(), tA = ye.require$$0.isCommentToken, Nn = Symbol("tokens"), kn = Symbol("comments"), jn = Symbol("indexMap");
function ps(e, t, n, r, i, a, s) {
  var o = !1, u = 0, c = null;
  return typeof s == "number" ? u = 0 | s : typeof s == "function" ? c = s : s && (o = !!s.includeComments, u = 0 | s.skip, c = s.filter || null), Rr(0 <= u, "options.skip should be zero or a positive integer."), Rr(!c || typeof c == "function", "options.filter should be a function."), e.createCursor(t, n, r, i, a, o, c, u, -1);
}
function ma(e, t, n, r, i, a, s) {
  var o = !1, u = 0, c = !1, f = null;
  return typeof s == "number" ? (u = 0 | s, c = !0) : typeof s == "function" ? f = s : s && (o = !!s.includeComments, u = 0 | s.count, c = typeof s.count == "number", f = s.filter || null), Rr(0 <= u, "options.count should be zero or a positive integer."), Rr(!f || typeof f == "function", "options.filter should be a function."), e.createCursor(t, n, r, i, a, o, f, 0, c ? u : -1);
}
function Cb(e, t, n, r, i, a, s) {
  return a === void 0 && s === void 0 ? new og(e, t, n, r, i) : typeof a == "number" || a === void 0 ? new lP(e, t, n, r, i, 0 | a, 0 | s) : ma(Qn.forward, e, t, n, r, i, a);
}
function Sb(e) {
  for (var t = [], n = e.getOneToken(); n && tA(n); )
    t.push(n), n = e.getOneToken();
  return t;
}
var pP = function() {
  function e(t, n) {
    We(this, e), this[Nn] = t, this[kn] = n, this[jn] = function(r, i) {
      for (var a = Number.MAX_SAFE_INTEGER, s = /* @__PURE__ */ Object.create(null), o = 0, u = 0, c = 0, f = null; o < r.length || u < i.length; ) {
        for (c = u < i.length ? i[u].range[0] : a; o < r.length && (f = r[o].range)[0] < c; )
          s[f[0]] = o, s[f[1] - 1] = o, o += 1;
        for (c = o < r.length ? r[o].range[0] : a; u < i.length && (f = i[u].range)[0] < c; )
          s[f[0]] = o, s[f[1] - 1] = o, u += 1;
      }
      return s;
    }(t, n);
  }
  return Xe(e, [{ key: "getTokenByRangeStart", value: function(t, n) {
    var r = n && n.includeComments, i = Qn.forward.createBaseCursor(this[Nn], this[kn], this[jn], t, -1, r).getOneToken();
    return i && i.range[0] === t ? i : null;
  } }, { key: "getFirstToken", value: function(t, n) {
    return ps(Qn.forward, this[Nn], this[kn], this[jn], t.range[0], t.range[1], n).getOneToken();
  } }, { key: "getLastToken", value: function(t, n) {
    return ps(Qn.backward, this[Nn], this[kn], this[jn], t.range[0], t.range[1], n).getOneToken();
  } }, { key: "getTokenBefore", value: function(t, n) {
    return ps(Qn.backward, this[Nn], this[kn], this[jn], -1, t.range[0], n).getOneToken();
  } }, { key: "getTokenAfter", value: function(t, n) {
    return ps(Qn.forward, this[Nn], this[kn], this[jn], t.range[1], -1, n).getOneToken();
  } }, { key: "getFirstTokenBetween", value: function(t, n, r) {
    return ps(Qn.forward, this[Nn], this[kn], this[jn], t.range[1], n.range[0], r).getOneToken();
  } }, { key: "getLastTokenBetween", value: function(t, n, r) {
    return ps(Qn.backward, this[Nn], this[kn], this[jn], t.range[1], n.range[0], r).getOneToken();
  } }, { key: "getTokenOrCommentBefore", value: function(t, n) {
    return this.getTokenBefore(t, { includeComments: !0, skip: n });
  } }, { key: "getTokenOrCommentAfter", value: function(t, n) {
    return this.getTokenAfter(t, { includeComments: !0, skip: n });
  } }, { key: "getFirstTokens", value: function(t, n) {
    return ma(Qn.forward, this[Nn], this[kn], this[jn], t.range[0], t.range[1], n).getAllTokens();
  } }, { key: "getLastTokens", value: function(t, n) {
    return ma(Qn.backward, this[Nn], this[kn], this[jn], t.range[0], t.range[1], n).getAllTokens().reverse();
  } }, { key: "getTokensBefore", value: function(t, n) {
    return ma(Qn.backward, this[Nn], this[kn], this[jn], -1, t.range[0], n).getAllTokens().reverse();
  } }, { key: "getTokensAfter", value: function(t, n) {
    return ma(Qn.forward, this[Nn], this[kn], this[jn], t.range[1], -1, n).getAllTokens();
  } }, { key: "getFirstTokensBetween", value: function(t, n, r) {
    return ma(Qn.forward, this[Nn], this[kn], this[jn], t.range[1], n.range[0], r).getAllTokens();
  } }, { key: "getLastTokensBetween", value: function(t, n, r) {
    return ma(Qn.backward, this[Nn], this[kn], this[jn], t.range[1], n.range[0], r).getAllTokens().reverse();
  } }, { key: "getTokens", value: function(t, n, r) {
    return Cb(this[Nn], this[kn], this[jn], t.range[0], t.range[1], n, r).getAllTokens();
  } }, { key: "getTokensBetween", value: function(t, n, r) {
    return Cb(this[Nn], this[kn], this[jn], t.range[1], n.range[0], r, r).getAllTokens();
  } }, { key: "commentsExistBetween", value: function(t, n) {
    var r = _a.search(this[kn], t.range[1]);
    return r < this[kn].length && this[kn][r].range[1] <= n.range[0];
  } }, { key: "getCommentsBefore", value: function(t) {
    return Sb(ma(Qn.backward, this[Nn], this[kn], this[jn], -1, t.range[0], { includeComments: !0 })).reverse();
  } }, { key: "getCommentsAfter", value: function(t) {
    return Sb(ma(Qn.forward, this[Nn], this[kn], this[jn], t.range[1], -1, { includeComments: !0 }));
  } }, { key: "getCommentsInside", value: function(t) {
    return this.getTokens(t, { includeComments: !0, filter: tA });
  } }]), e;
}(), $l = ye.require$$0.isCommentToken, fP = { SourceCode: function(e) {
  function t(n, r) {
    var i, a, s, o, u, c;
    We(this, t), typeof n == "string" ? (a = n, s = r) : xe(n) == "object" && n !== null && (a = n.text, s = n.ast, o = n.parserServices, u = n.scopeManager, c = n.visitorKeys), function(m) {
      if (!m.tokens)
        throw new Error("AST is missing the tokens array.");
      if (!m.comments)
        throw new Error("AST is missing the comments array.");
      if (!m.loc)
        throw new Error("AST is missing location information.");
      if (!m.range)
        throw new Error("AST is missing range information");
    }(s), (i = Gt(this, rt(t).call(this, s.tokens, s.comments))).hasBOM = a.charCodeAt(0) === 65279, i.text = i.hasBOM ? a.slice(1) : a, i.ast = s, i.parserServices = o || {}, i.scopeManager = u || null, i.visitorKeys = c || ye.Traverser.DEFAULT_VISITOR_KEYS;
    var f = i.text.match(ye.require$$0$1.shebangPattern);
    f && s.comments.length && s.comments[0].value === f[1] && (s.comments[0].type = "Shebang"), i.tokensAndComments = function(m, y) {
      for (var v = [], b = 0, x = 0; b < m.length || x < y.length; )
        x >= y.length || b < m.length && m[b].range[0] < y[x].range[0] ? v.push(m[b++]) : v.push(y[x++]);
      return v;
    }(s.tokens, s.comments), i.lines = [], i.lineStartIndices = [0];
    for (var p, d = ye.require$$0$1.createGlobalLinebreakMatcher(); p = d.exec(i.text); )
      i.lines.push(i.text.slice(i.lineStartIndices[i.lineStartIndices.length - 1], p.index)), i.lineStartIndices.push(p.index + p[0].length);
    return i.lines.push(i.text.slice(i.lineStartIndices[i.lineStartIndices.length - 1])), i._commentCache = /* @__PURE__ */ new WeakMap(), Object.freeze(tE(i)), Object.freeze(i.lines), i;
  }
  return $t(t, pP), Xe(t, [{ key: "getText", value: function(n, r, i) {
    return n ? this.text.slice(Math.max(n.range[0] - (r || 0), 0), n.range[1] + (i || 0)) : this.text;
  } }, { key: "getLines", value: function() {
    return this.lines;
  } }, { key: "getAllComments", value: function() {
    return this.ast.comments;
  } }, { key: "getComments", value: function(n) {
    if (this._commentCache.has(n))
      return this._commentCache.get(n);
    var r = { leading: [], trailing: [] };
    if (n.type === "Program")
      n.body.length === 0 && (r.leading = n.comments);
    else {
      ((n.type === "BlockStatement" || n.type === "ClassBody") && n.body.length === 0 || n.type === "ObjectExpression" && n.properties.length === 0 || n.type === "ArrayExpression" && n.elements.length === 0 || n.type === "SwitchStatement" && n.cases.length === 0) && (r.trailing = this.getTokens(n, { includeComments: !0, filter: $l }));
      for (var i = this.getTokenBefore(n, { includeComments: !0 }); i && $l(i) && !(n.parent && i.start < n.parent.start); )
        r.leading.push(i), i = this.getTokenBefore(i, { includeComments: !0 });
      for (r.leading.reverse(), i = this.getTokenAfter(n, { includeComments: !0 }); i && $l(i) && !(n.parent && i.end > n.parent.end); )
        r.trailing.push(i), i = this.getTokenAfter(i, { includeComments: !0 });
    }
    return this._commentCache.set(n, r), r;
  } }, { key: "getJSDocComment", value: function(n) {
    var r = this, i = function(s) {
      var o = r.getTokenBefore(s, { includeComments: !0 });
      return o && $l(o) && o.type === "Block" && o.value.charAt(0) === "*" && 1 >= s.loc.start.line - o.loc.end.line ? o : null;
    }, a = n.parent;
    switch (n.type) {
      case "ClassDeclaration":
      case "FunctionDeclaration":
        return i(function(s) {
          return s.type === "ExportDefaultDeclaration" || s.type === "ExportNamedDeclaration" || s.type === "ExportAllDeclaration" || s.type === "ExportSpecifier";
        }(a) ? a : n);
      case "ClassExpression":
        return i(a.parent);
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        if (a.type !== "CallExpression" && a.type !== "NewExpression") {
          for (; !this.getCommentsBefore(a).length && !/Function/.test(a.type) && a.type !== "MethodDefinition" && a.type !== "Property" && (a = a.parent); )
            ;
          if (a && a.type !== "FunctionDeclaration" && a.type !== "Program")
            return i(a);
        }
        return i(n);
      default:
        return null;
    }
  } }, { key: "getNodeByRangeIndex", value: function(n) {
    var r = null;
    return ye.Traverser.traverse(this.ast, { visitorKeys: this.visitorKeys, enter: function(i) {
      i.range[0] <= n && n < i.range[1] ? r = i : this.skip();
    }, leave: function(i) {
      i === r && this.break();
    } }), r;
  } }, { key: "isSpaceBetween", value: function(n, r) {
    if (function(p, d) {
      return p.range[0] <= d.range[0] && p.range[1] >= d.range[0] || d.range[0] <= p.range[0] && d.range[1] >= p.range[0];
    }(n, r))
      return !1;
    for (var i = bn(n.range[1] <= r.range[0] ? [n, r] : [r, n], 2), a = i[0], s = i[1], o = this.getLastToken(a) || a, u = this.getFirstToken(s) || s, c = o; c !== u; ) {
      var f = this.getTokenAfter(c, { includeComments: !0 });
      if (c.range[1] !== f.range[0])
        return !0;
      c = f;
    }
    return !1;
  } }, { key: "isSpaceBetweenTokens", value: function() {
    return this.isSpaceBetween.apply(this, arguments);
  } }, { key: "getLocFromIndex", value: function(n) {
    if (typeof n != "number")
      throw new TypeError("Expected `index` to be a number.");
    if (0 > n || n > this.text.length)
      throw new RangeError("Index out of range (requested index ".concat(n, ", but source text has length ").concat(this.text.length, ")."));
    if (n === this.text.length)
      return { line: this.lines.length, column: this.lines[this.lines.length - 1].length };
    var r = ye.lodash.sortedLastIndex(this.lineStartIndices, n);
    return { line: r, column: n - this.lineStartIndices[r - 1] };
  } }, { key: "getIndexFromLoc", value: function(n) {
    if (xe(n) != "object" || typeof n.line != "number" || typeof n.column != "number")
      throw new TypeError("Expected `loc` to be an object with numeric `line` and `column` properties.");
    if (0 >= n.line)
      throw new RangeError("Line number out of range (line ".concat(n.line, " requested). Line numbers should be 1-based."));
    if (n.line > this.lineStartIndices.length)
      throw new RangeError("Line number out of range (line ".concat(n.line, " requested, but only ").concat(this.lineStartIndices.length, " lines present)."));
    var r = this.lineStartIndices[n.line - 1], i = n.line === this.lineStartIndices.length ? this.text.length : this.lineStartIndices[n.line], a = r + n.column;
    if (n.line === this.lineStartIndices.length && a > i || n.line < this.lineStartIndices.length && a >= i)
      throw new RangeError("Column number out of range (column ".concat(n.column, " requested, but the length of line ").concat(n.line, " is ").concat(i - r, ")."));
    return a;
  } }], [{ key: "splitLines", value: function(n) {
    return n.split(ye.require$$0$1.createGlobalLinebreakMatcher());
  } }]), t;
}() }, Ga = ye.require$$1("eslint:code-path");
function hP(e) {
  return e.id + (e.reachable ? "" : "!");
}
var ii = { enabled: Ga.enabled, dump: Ga, dumpState: Ga.enabled ? function(e, t, n) {
  for (var r = 0; r < t.currentSegments.length; ++r) {
    var i = t.currentSegments[r].internal;
    n ? i.exitNodes.push(e) : i.nodes.push(e);
  }
  Ga(["".concat(t.currentSegments.map(hP).join(","), ")"), "".concat(e.type).concat(n ? ":exit" : "")].join(" "));
} : Ga, dumpDot: Ga.enabled ? function(e) {
  var t = `
digraph {
node[shape=box,style="rounded,filled",fillcolor=white];
initial[label="",shape=circle,style=filled,fillcolor=black,width=0.25,height=0.25];
`;
  0 < e.returnedSegments.length && (t += `final[label="",shape=doublecircle,style=filled,fillcolor=black,width=0.25,height=0.25];
`), 0 < e.thrownSegments.length && (t += `thrown[label="✘",shape=circle,width=0.3,height=0.3,fixedsize];
`);
  var n = /* @__PURE__ */ Object.create(null), r = this.makeDotArrows(e, n);
  for (var i in n) {
    var a = n[i];
    t += "".concat(i, "["), t += a.reachable ? 'label="' : 'style="rounded,dashed,filled",fillcolor="#FF9800",label="<<unreachable>>\\n', t += 0 < a.internal.nodes.length || 0 < a.internal.exitNodes.length ? [].concat(a.internal.nodes.map(function(s) {
      switch (s.type) {
        case "Identifier":
          return "".concat(s.type, " (").concat(s.name, ")");
        case "Literal":
          return "".concat(s.type, " (").concat(s.value, ")");
        default:
          return s.type;
      }
    }), a.internal.exitNodes.map(function(s) {
      switch (s.type) {
        case "Identifier":
          return "".concat(s.type, ":exit (").concat(s.name, ")");
        case "Literal":
          return "".concat(s.type, ":exit (").concat(s.value, ")");
        default:
          return "".concat(s.type, ":exit");
      }
    })).join("\\n") : "????", t += `"];
`;
  }
  t += "".concat(r, `
`), Ga("DOT", t += "}");
} : Ga, makeDotArrows: function(e, t) {
  for (var n = [[e.initialSegment, 0]], r = t || /* @__PURE__ */ Object.create(null), i = e.initialSegment.id, a = "initial->".concat(e.initialSegment.id); 0 < n.length; ) {
    var s = n.pop(), o = s[0], u = s[1];
    if (!r[o.id] || u !== 0) {
      r[o.id] = o;
      var c = o.allNextSegments[u];
      c && (a += i === o.id ? "->".concat(c.id) : `;
`.concat(o.id, "->").concat(c.id), i = c.id, n.unshift([o, 1 + u]), n.push([c, 0]));
    }
  }
  return e.returnedSegments.forEach(function(f) {
    a += i === f.id ? "->final" : `;
`.concat(f.id, "->final"), i = null;
  }), e.thrownSegments.forEach(function(f) {
    a += i === f.id ? "->thrown" : `;
`.concat(f.id, "->thrown"), i = null;
  }), "".concat(a, ";");
} };
function Ud(e) {
  return e.reachable;
}
var qi = function() {
  function e(t, n, r) {
    We(this, e), this.id = t, this.nextSegments = [], this.prevSegments = n.filter(Ud), this.allNextSegments = [], this.allPrevSegments = n, this.reachable = r, Object.defineProperty(this, "internal", { value: { used: !1, loopedPrevSegments: [] } }), ii.enabled && (this.internal.nodes = [], this.internal.exitNodes = []);
  }
  return Xe(e, [{ key: "isLoopedPrevSegment", value: function(t) {
    return this.internal.loopedPrevSegments.indexOf(t) !== -1;
  } }], [{ key: "newRoot", value: function(t) {
    return new e(t, [], !0);
  } }, { key: "newNext", value: function(t, n) {
    return new e(t, e.flattenUnusedSegments(n), n.some(Ud));
  } }, { key: "newUnreachable", value: function(t, n) {
    var r = new e(t, e.flattenUnusedSegments(n), !1);
    return e.markUsed(r), r;
  } }, { key: "newDisconnected", value: function(t, n) {
    return new e(t, [], n.some(Ud));
  } }, { key: "markUsed", value: function(t) {
    var n;
    if (!t.internal.used)
      if (t.internal.used = !0, t.reachable)
        for (n = 0; n < t.allPrevSegments.length; ++n) {
          var r = t.allPrevSegments[n];
          r.allNextSegments.push(t), r.nextSegments.push(t);
        }
      else
        for (n = 0; n < t.allPrevSegments.length; ++n)
          t.allPrevSegments[n].allNextSegments.push(t);
  } }, { key: "markPrevSegmentAsLooped", value: function(t, n) {
    t.internal.loopedPrevSegments.push(n);
  } }, { key: "flattenUnusedSegments", value: function(t) {
    for (var n = /* @__PURE__ */ Object.create(null), r = [], i = 0; i < t.length; ++i) {
      var a = t[i];
      if (!n[a.id])
        if (a.internal.used)
          n[a.id] = !0, r.push(a);
        else
          for (var s = 0; s < a.allPrevSegments.length; ++s) {
            var o = a.allPrevSegments[s];
            n[o.id] || (n[o.id] = !0, r.push(o));
          }
    }
    return r;
  } }]), e;
}();
function dP(e) {
  return e.reachable;
}
function qd(e, t, n, r) {
  for (var i = e.segmentsList, a = 0 <= t ? t : i.length + t, s = 0 <= n ? n : i.length + n, o = [], u = 0; u < e.count; ++u) {
    for (var c = [], f = a; f <= s; ++f)
      c.push(i[f][u]);
    o.push(r(e.idGenerator.next(), c));
  }
  return o;
}
function kb(e, t) {
  for (var n = t; n.length > e.count; ) {
    for (var r = [], i = 0, a = 0 | n.length / 2; i < a; ++i)
      r.push(qi.newNext(e.idGenerator.next(), [n[i], n[i + a]]));
    n = r;
  }
  return n;
}
var Xr = function() {
  function e(t, n, r) {
    We(this, e), this.idGenerator = t, this.upper = n, this.count = r, this.segmentsList = [];
  }
  return Xe(e, [{ key: "makeNext", value: function(t, n) {
    return qd(this, t, n, qi.newNext);
  } }, { key: "makeUnreachable", value: function(t, n) {
    return qd(this, t, n, qi.newUnreachable);
  } }, { key: "makeDisconnected", value: function(t, n) {
    return qd(this, t, n, qi.newDisconnected);
  } }, { key: "add", value: function(t) {
    Rr(t.length >= this.count, "".concat(t.length, " >= ").concat(this.count)), this.segmentsList.push(kb(this, t));
  } }, { key: "replaceHead", value: function(t) {
    Rr(t.length >= this.count, "".concat(t.length, " >= ").concat(this.count)), this.segmentsList.splice(-1, 1, kb(this, t));
  } }, { key: "addAll", value: function(t) {
    Rr(t.count === this.count);
    for (var n = t.segmentsList, r = 0; r < n.length; ++r)
      this.segmentsList.push(n[r]);
  } }, { key: "clear", value: function() {
    this.segmentsList = [];
  } }, { key: "head", get: function() {
    var t = this.segmentsList;
    return t.length === 0 ? [] : t[t.length - 1];
  } }, { key: "empty", get: function() {
    return this.segmentsList.length === 0;
  } }, { key: "reachable", get: function() {
    var t = this.head;
    return 0 < t.length && t.some(dP);
  } }], [{ key: "newRoot", value: function(t) {
    var n = new e(t, null, 1);
    return n.add([qi.newRoot(t.next())]), n;
  } }, { key: "newEmpty", value: function(t, n) {
    return new e(t.idGenerator, t, (n ? 2 : 1) * t.count);
  } }]), e;
}();
function Db(e, t, n, r) {
  for (var i = 0; i < r.length; ++i) {
    var a = r[i];
    e.push(a), t.indexOf(a) === -1 && n.push(a);
  }
}
function Fb(e) {
  for (var t = e.tryContext; t; ) {
    if (t.hasFinalizer && t.position !== "finally")
      return t;
    t = t.upper;
  }
  return e;
}
function Wd(e) {
  for (var t = e.tryContext; t; ) {
    if (t.position === "try" || t.hasFinalizer && t.position === "catch")
      return t;
    t = t.upper;
  }
  return e;
}
function Gl(e, t) {
  e.splice(e.indexOf(t), 1);
}
function Do(e, t, n) {
  for (var r = qi.flattenUnusedSegments(t), i = qi.flattenUnusedSegments(n), a = Math.min(r.length, i.length), s = 0; s < a; ++s) {
    var o = r[s], u = i[s];
    u.reachable && o.nextSegments.push(u), o.reachable && u.prevSegments.push(o), o.allNextSegments.push(u), u.allPrevSegments.push(o), 2 <= u.allPrevSegments.length && qi.markPrevSegmentAsLooped(u, o), e.notifyLooped(o, u);
  }
}
function wb(e, t, n) {
  t.processed || (t.trueForkContext.add(n), t.falseForkContext.add(n)), e.test !== !0 && e.brokenForkContext.addAll(t.falseForkContext), e.endOfTestSegments = t.trueForkContext.makeNext(0, -1);
}
var mP = function() {
  function e(t, n) {
    We(this, e), this.idGenerator = t, this.notifyLooped = n, this.forkContext = Xr.newRoot(t), this.choiceContext = null, this.switchContext = null, this.tryContext = null, this.loopContext = null, this.breakContext = null, this.currentSegments = [], this.initialSegment = this.forkContext.head[0];
    var r = this.finalSegments = [], i = this.returnedForkContext = [], a = this.thrownForkContext = [];
    i.add = Db.bind(null, i, a, r), a.add = Db.bind(null, a, i, r);
  }
  return Xe(e, [{ key: "pushForkContext", value: function(t) {
    return this.forkContext = Xr.newEmpty(this.forkContext, t), this.forkContext;
  } }, { key: "popForkContext", value: function() {
    var t = this.forkContext;
    return this.forkContext = t.upper, this.forkContext.replaceHead(t.makeNext(0, -1)), t;
  } }, { key: "forkPath", value: function() {
    this.forkContext.add(this.parentForkContext.makeNext(-1, -1));
  } }, { key: "forkBypassPath", value: function() {
    this.forkContext.add(this.parentForkContext.head);
  } }, { key: "pushChoiceContext", value: function(t, n) {
    this.choiceContext = { upper: this.choiceContext, kind: t, isForkingAsResult: n, trueForkContext: Xr.newEmpty(this.forkContext), falseForkContext: Xr.newEmpty(this.forkContext), processed: !1 };
  } }, { key: "popChoiceContext", value: function() {
    var t = this.choiceContext;
    this.choiceContext = t.upper;
    var n = this.forkContext, r = n.head;
    switch (t.kind) {
      case "&&":
      case "||":
        if (t.processed || (t.trueForkContext.add(r), t.falseForkContext.add(r)), t.isForkingAsResult) {
          var i = this.choiceContext;
          return i.trueForkContext.addAll(t.trueForkContext), i.falseForkContext.addAll(t.falseForkContext), i.processed = !0, t;
        }
        break;
      case "test":
        t.processed ? (t.falseForkContext.clear(), t.falseForkContext.add(r)) : (t.trueForkContext.clear(), t.trueForkContext.add(r));
        break;
      case "loop":
        return t;
      default:
        throw new Error("unreachable");
    }
    var a = t.trueForkContext;
    return a.addAll(t.falseForkContext), n.replaceHead(a.makeNext(0, -1)), t;
  } }, { key: "makeLogicalRight", value: function() {
    var t = this.choiceContext, n = this.forkContext;
    if (t.processed) {
      var r = t.kind === "&&" ? t.trueForkContext : t.falseForkContext;
      n.replaceHead(r.makeNext(0, -1)), r.clear(), t.processed = !1;
    } else
      t.kind === "&&" ? t.falseForkContext.add(n.head) : t.trueForkContext.add(n.head), n.replaceHead(n.makeNext(-1, -1));
  } }, { key: "makeIfConsequent", value: function() {
    var t = this.choiceContext, n = this.forkContext;
    t.processed || (t.trueForkContext.add(n.head), t.falseForkContext.add(n.head)), t.processed = !1, n.replaceHead(t.trueForkContext.makeNext(0, -1));
  } }, { key: "makeIfAlternate", value: function() {
    var t = this.choiceContext, n = this.forkContext;
    t.trueForkContext.clear(), t.trueForkContext.add(n.head), t.processed = !0, n.replaceHead(t.falseForkContext.makeNext(0, -1));
  } }, { key: "pushSwitchContext", value: function(t, n) {
    this.switchContext = { upper: this.switchContext, hasCase: t, defaultSegments: null, defaultBodySegments: null, foundDefault: !1, lastIsDefault: !1, countForks: 0 }, this.pushBreakContext(!0, n);
  } }, { key: "popSwitchContext", value: function() {
    var t = this.switchContext;
    this.switchContext = t.upper;
    var n = this.forkContext, r = this.popBreakContext().brokenForkContext;
    if (t.countForks !== 0) {
      var i = n.head;
      this.forkBypassPath();
      var a = n.head;
      r.add(i), t.lastIsDefault || (t.defaultBodySegments ? (function(o, u) {
        for (var c = 0; c < o.length; ++c) {
          var f = o[c], p = u[c];
          Gl(f.nextSegments, p), Gl(f.allNextSegments, p), Gl(p.prevSegments, f), Gl(p.allPrevSegments, f);
        }
      }(t.defaultSegments, t.defaultBodySegments), Do(this, a, t.defaultBodySegments)) : r.add(a));
      for (var s = 0; s < t.countForks; ++s)
        this.forkContext = this.forkContext.upper;
      this.forkContext.replaceHead(r.makeNext(0, -1));
    } else
      r.empty || (r.add(n.makeNext(-1, -1)), n.replaceHead(r.makeNext(0, -1)));
  } }, { key: "makeSwitchCaseBody", value: function(t, n) {
    var r = this.switchContext;
    if (r.hasCase) {
      var i = this.forkContext, a = this.pushForkContext();
      a.add(i.makeNext(0, -1)), n ? (r.defaultSegments = i.head, t ? r.foundDefault = !0 : r.defaultBodySegments = a.head) : !t && r.foundDefault && (r.foundDefault = !1, r.defaultBodySegments = a.head), r.lastIsDefault = n, r.countForks += 1;
    }
  } }, { key: "pushTryContext", value: function(t) {
    this.tryContext = { upper: this.tryContext, position: "try", hasFinalizer: t, returnedForkContext: t ? Xr.newEmpty(this.forkContext) : null, thrownForkContext: Xr.newEmpty(this.forkContext), lastOfTryIsReachable: !1, lastOfCatchIsReachable: !1 };
  } }, { key: "popTryContext", value: function() {
    var t = this.tryContext;
    if (this.tryContext = t.upper, t.position !== "catch") {
      var n = t.returnedForkContext, r = t.thrownForkContext;
      if (!n.empty || !r.empty) {
        var i = this.forkContext.head;
        this.forkContext = this.forkContext.upper;
        var a = i.slice(0, 0 | i.length / 2), s = i.slice(0 | i.length / 2);
        n.empty || Fb(this).returnedForkContext.add(s), r.empty || Wd(this).thrownForkContext.add(s), this.forkContext.replaceHead(a), t.lastOfTryIsReachable || t.lastOfCatchIsReachable || this.forkContext.makeUnreachable();
      }
    } else
      this.popForkContext();
  } }, { key: "makeCatchBlock", value: function() {
    var t = this.tryContext, n = this.forkContext, r = t.thrownForkContext;
    t.position = "catch", t.thrownForkContext = Xr.newEmpty(n), t.lastOfTryIsReachable = n.reachable, r.add(n.head);
    var i = r.makeNext(0, -1);
    this.pushForkContext(), this.forkBypassPath(), this.forkContext.add(i);
  } }, { key: "makeFinallyBlock", value: function() {
    var t = this.tryContext, n = this.forkContext, r = t.returnedForkContext, i = t.thrownForkContext, a = n.head;
    if (t.position === "catch" ? (this.popForkContext(), n = this.forkContext, t.lastOfCatchIsReachable = n.reachable) : t.lastOfTryIsReachable = n.reachable, t.position = "finally", !r.empty || !i.empty) {
      for (var s = n.makeNext(-1, -1), o = 0; o < n.count; ++o) {
        for (var u = [a[o]], c = 0; c < r.segmentsList.length; ++c)
          u.push(r.segmentsList[c][o]);
        for (var f = 0; f < i.segmentsList.length; ++f)
          u.push(i.segmentsList[f][o]);
        s.push(qi.newNext(this.idGenerator.next(), u));
      }
      this.pushForkContext(!0), this.forkContext.add(s);
    }
  } }, { key: "makeFirstThrowablePathInTryBlock", value: function() {
    var t = this.forkContext;
    if (t.reachable) {
      var n = Wd(this);
      n !== this && n.position === "try" && n.thrownForkContext.empty && (n.thrownForkContext.add(t.head), t.replaceHead(t.makeNext(-1, -1)));
    }
  } }, { key: "pushLoopContext", value: function(t, n) {
    var r = this.forkContext, i = this.pushBreakContext(!0, n);
    switch (t) {
      case "WhileStatement":
        this.pushChoiceContext("loop", !1), this.loopContext = { upper: this.loopContext, type: t, label: n, test: void 0, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      case "DoWhileStatement":
        this.pushChoiceContext("loop", !1), this.loopContext = { upper: this.loopContext, type: t, label: n, test: void 0, entrySegments: null, continueForkContext: Xr.newEmpty(r), brokenForkContext: i.brokenForkContext };
        break;
      case "ForStatement":
        this.pushChoiceContext("loop", !1), this.loopContext = { upper: this.loopContext, type: t, label: n, test: void 0, endOfInitSegments: null, testSegments: null, endOfTestSegments: null, updateSegments: null, endOfUpdateSegments: null, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      case "ForInStatement":
      case "ForOfStatement":
        this.loopContext = { upper: this.loopContext, type: t, label: n, prevSegments: null, leftSegments: null, endOfLeftSegments: null, continueDestSegments: null, brokenForkContext: i.brokenForkContext };
        break;
      default:
        throw new Error('unknown type: "'.concat(t, '"'));
    }
  } }, { key: "popLoopContext", value: function() {
    var t = this.loopContext;
    this.loopContext = t.upper;
    var n = this.forkContext, r = this.popBreakContext().brokenForkContext;
    switch (t.type) {
      case "WhileStatement":
      case "ForStatement":
        this.popChoiceContext(), Do(this, n.head, t.continueDestSegments);
        break;
      case "DoWhileStatement":
        var i = this.popChoiceContext();
        i.processed || (i.trueForkContext.add(n.head), i.falseForkContext.add(n.head)), t.test !== !0 && r.addAll(i.falseForkContext);
        for (var a = i.trueForkContext.segmentsList, s = 0; s < a.length; ++s)
          Do(this, a[s], t.entrySegments);
        break;
      case "ForInStatement":
      case "ForOfStatement":
        r.add(n.head), Do(this, n.head, t.leftSegments);
        break;
      default:
        throw new Error("unreachable");
    }
    r.empty ? n.replaceHead(n.makeUnreachable(-1, -1)) : n.replaceHead(r.makeNext(0, -1));
  } }, { key: "makeWhileTest", value: function(t) {
    var n = this.loopContext, r = this.forkContext, i = r.makeNext(0, -1);
    n.test = t, n.continueDestSegments = i, r.replaceHead(i);
  } }, { key: "makeWhileBody", value: function() {
    var t = this.loopContext, n = this.choiceContext, r = this.forkContext;
    n.processed || (n.trueForkContext.add(r.head), n.falseForkContext.add(r.head)), t.test !== !0 && t.brokenForkContext.addAll(n.falseForkContext), r.replaceHead(n.trueForkContext.makeNext(0, -1));
  } }, { key: "makeDoWhileBody", value: function() {
    var t = this.loopContext, n = this.forkContext, r = n.makeNext(-1, -1);
    t.entrySegments = r, n.replaceHead(r);
  } }, { key: "makeDoWhileTest", value: function(t) {
    var n = this.loopContext, r = this.forkContext;
    if (n.test = t, !n.continueForkContext.empty) {
      n.continueForkContext.add(r.head);
      var i = n.continueForkContext.makeNext(0, -1);
      r.replaceHead(i);
    }
  } }, { key: "makeForTest", value: function(t) {
    var n = this.loopContext, r = this.forkContext, i = r.head, a = r.makeNext(-1, -1);
    n.test = t, n.endOfInitSegments = i, n.continueDestSegments = n.testSegments = a, r.replaceHead(a);
  } }, { key: "makeForUpdate", value: function() {
    var t = this.loopContext, n = this.choiceContext, r = this.forkContext;
    t.testSegments ? wb(t, n, r.head) : t.endOfInitSegments = r.head;
    var i = r.makeDisconnected(-1, -1);
    t.continueDestSegments = t.updateSegments = i, r.replaceHead(i);
  } }, { key: "makeForBody", value: function() {
    var t = this.loopContext, n = this.choiceContext, r = this.forkContext;
    t.updateSegments ? (t.endOfUpdateSegments = r.head, t.testSegments && Do(this, t.endOfUpdateSegments, t.testSegments)) : t.testSegments ? wb(t, n, r.head) : t.endOfInitSegments = r.head;
    var i = t.endOfTestSegments;
    if (!i) {
      var a = Xr.newEmpty(r);
      a.add(t.endOfInitSegments), t.endOfUpdateSegments && a.add(t.endOfUpdateSegments), i = a.makeNext(0, -1);
    }
    t.continueDestSegments = t.continueDestSegments || i, r.replaceHead(i);
  } }, { key: "makeForInOfLeft", value: function() {
    var t = this.loopContext, n = this.forkContext, r = n.makeDisconnected(-1, -1);
    t.prevSegments = n.head, t.leftSegments = t.continueDestSegments = r, n.replaceHead(r);
  } }, { key: "makeForInOfRight", value: function() {
    var t = this.loopContext, n = this.forkContext, r = Xr.newEmpty(n);
    r.add(t.prevSegments);
    var i = r.makeNext(-1, -1);
    t.endOfLeftSegments = n.head, n.replaceHead(i);
  } }, { key: "makeForInOfBody", value: function() {
    var t = this.loopContext, n = this.forkContext, r = Xr.newEmpty(n);
    r.add(t.endOfLeftSegments);
    var i = r.makeNext(-1, -1);
    Do(this, n.head, t.leftSegments), t.brokenForkContext.add(n.head), n.replaceHead(i);
  } }, { key: "pushBreakContext", value: function(t, n) {
    return this.breakContext = { upper: this.breakContext, breakable: t, label: n, brokenForkContext: Xr.newEmpty(this.forkContext) }, this.breakContext;
  } }, { key: "popBreakContext", value: function() {
    var t = this.breakContext, n = this.forkContext;
    if (this.breakContext = t.upper, !t.breakable) {
      var r = t.brokenForkContext;
      r.empty || (r.add(n.head), n.replaceHead(r.makeNext(0, -1)));
    }
    return t;
  } }, { key: "makeBreak", value: function(t) {
    var n = this.forkContext;
    if (n.reachable) {
      var r = function(i, a) {
        for (var s = i.breakContext; s; ) {
          if (a ? s.label === a : s.breakable)
            return s;
          s = s.upper;
        }
        return null;
      }(this, t);
      r && r.brokenForkContext.add(n.head), n.replaceHead(n.makeUnreachable(-1, -1));
    }
  } }, { key: "makeContinue", value: function(t) {
    var n = this.forkContext;
    if (n.reachable) {
      var r = function(i, a) {
        if (!a)
          return i.loopContext;
        for (var s = i.loopContext; s; ) {
          if (s.label === a)
            return s;
          s = s.upper;
        }
        return null;
      }(this, t);
      r && (r.continueDestSegments ? (Do(this, n.head, r.continueDestSegments), (r.type === "ForInStatement" || r.type === "ForOfStatement") && r.brokenForkContext.add(n.head)) : r.continueForkContext.add(n.head)), n.replaceHead(n.makeUnreachable(-1, -1));
    }
  } }, { key: "makeReturn", value: function() {
    var t = this.forkContext;
    t.reachable && (Fb(this).returnedForkContext.add(t.head), t.replaceHead(t.makeUnreachable(-1, -1)));
  } }, { key: "makeThrow", value: function() {
    var t = this.forkContext;
    t.reachable && (Wd(this).thrownForkContext.add(t.head), t.replaceHead(t.makeUnreachable(-1, -1)));
  } }, { key: "makeFinal", value: function() {
    var t = this.currentSegments;
    0 < t.length && t[0].reachable && this.returnedForkContext.add(t);
  } }, { key: "headSegments", get: function() {
    return this.forkContext.head;
  } }, { key: "parentForkContext", get: function() {
    var t = this.forkContext;
    return t && t.upper;
  } }]), e;
}(), nA = function() {
  function e(t) {
    We(this, e), this.prefix = t + "", this.n = 0;
  }
  return Xe(e, [{ key: "next", value: function() {
    return this.n = 0 | 1 + this.n, 0 > this.n && (this.n = 1), this.prefix + this.n;
  } }]), e;
}(), Fa = function() {
  function e(t, n, r) {
    We(this, e), this.id = t, this.upper = n, this.childCodePaths = [], Object.defineProperty(this, "internal", { value: new mP(new nA("".concat(t, "_")), r) }), n && n.childCodePaths.push(this);
  }
  return Xe(e, [{ key: "traverseSegments", value: function(t, n) {
    function r(x) {
      return d[x.id] || p.isLoopedPrevSegment(x);
    }
    var i, a;
    typeof t == "function" ? (a = t, i = {}) : (i = t || {}, a = n);
    for (var s = i.first || this.internal.initialSegment, o = i.last, u = null, c = 0, f = 0, p = null, d = /* @__PURE__ */ Object.create(null), m = [[s, 0]], y = null, v = !1, b = { skip: function() {
      1 >= m.length ? v = !0 : y = m[m.length - 2][0];
    }, break: function() {
      v = !0;
    } }; 0 < m.length; ) {
      if (u = m[m.length - 1], p = u[0], (c = u[1]) === 0) {
        if (d[p.id]) {
          m.pop();
          continue;
        }
        if (p !== s && 0 < p.prevSegments.length && !p.prevSegments.every(r)) {
          m.pop();
          continue;
        }
        if (y && p.prevSegments.indexOf(y) !== -1 && (y = null), d[p.id] = !0, !y && (a.call(this, p, b), p === o && b.skip(), v))
          break;
      }
      c < (f = p.nextSegments.length - 1) ? (u[1] += 1, m.push([p.nextSegments[c], 0])) : c === f ? (u[0] = p.nextSegments[c], u[1] = 0) : m.pop();
    }
  } }, { key: "initialSegment", get: function() {
    return this.internal.initialSegment;
  } }, { key: "finalSegments", get: function() {
    return this.internal.finalSegments;
  } }, { key: "returnedSegments", get: function() {
    return this.internal.returnedForkContext;
  } }, { key: "thrownSegments", get: function() {
    return this.internal.thrownForkContext;
  } }, { key: "currentSegments", get: function() {
    return this.internal.currentSegments;
  } }], [{ key: "getState", value: function(t) {
    return t.internal;
  } }]), e;
}(), rA = ye.require$$0$1.breakableTypePattern;
function gP(e) {
  return !!e.test;
}
function Gp(e) {
  return e === "&&" || e === "||";
}
function Ab(e) {
  return e.parent.type === "LabeledStatement" ? e.parent.label.name : null;
}
function $d(e) {
  return e.type === "Literal" ? !!e.value : void 0;
}
function Po(e, t) {
  var n, r, i, a = e.codePath, s = Fa.getState(a), o = s.currentSegments, u = s.headSegments, c = Math.max(o.length, u.length);
  for (n = 0; n < c; ++n)
    (r = o[n]) !== (i = u[n]) && r && (ii.dump("onCodePathSegmentEnd ".concat(r.id)), r.reachable && e.emitter.emit("onCodePathSegmentEnd", r, t));
  for (s.currentSegments = u, n = 0; n < c; ++n)
    (r = o[n]) !== (i = u[n]) && i && (ii.dump("onCodePathSegmentStart ".concat(i.id)), qi.markUsed(i), i.reachable && e.emitter.emit("onCodePathSegmentStart", i, t));
}
function yP(e, t) {
  var n = e.codePath, r = n && Fa.getState(n), i = t.parent;
  switch (t.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      n && (Po(e, t), ii.dumpState(t, r, !1)), n = e.codePath = new Fa(e.idGenerator.next(), n, e.onLooped), r = Fa.getState(n), ii.dump("onCodePathStart ".concat(n.id)), e.emitter.emit("onCodePathStart", n, t);
      break;
    case "LogicalExpression":
      Gp(t.operator) && r.pushChoiceContext(t.operator, function(a) {
        var s = a.parent;
        switch (s.type) {
          case "ConditionalExpression":
          case "IfStatement":
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForStatement":
            return s.test === a;
          case "LogicalExpression":
            return Gp(s.operator);
          default:
            return !1;
        }
      }(t));
      break;
    case "ConditionalExpression":
    case "IfStatement":
      r.pushChoiceContext("test", !1);
      break;
    case "SwitchStatement":
      r.pushSwitchContext(t.cases.some(gP), Ab(t));
      break;
    case "TryStatement":
      r.pushTryContext(!!t.finalizer);
      break;
    case "SwitchCase":
      i.discriminant !== t && i.cases[0] !== t && r.forkPath();
      break;
    case "WhileStatement":
    case "DoWhileStatement":
    case "ForStatement":
    case "ForInStatement":
    case "ForOfStatement":
      r.pushLoopContext(t.type, Ab(t));
      break;
    case "LabeledStatement":
      rA.test(t.body.type) || r.pushBreakContext(!1, t.label.name);
  }
  Po(e, t), ii.dumpState(t, r, !1);
}
function vP(e, t) {
  switch (t.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      var n = e.codePath;
      Fa.getState(n).makeFinal(), function(r, i) {
        for (var a = Fa.getState(r.codePath), s = a.currentSegments, o = 0; o < s.length; ++o) {
          var u = s[o];
          ii.dump("onCodePathSegmentEnd ".concat(u.id)), u.reachable && r.emitter.emit("onCodePathSegmentEnd", u, i);
        }
        a.currentSegments = [];
      }(e, t), ii.dump("onCodePathEnd ".concat(n.id)), e.emitter.emit("onCodePathEnd", n, t), ii.dumpDot(n), (n = e.codePath = e.codePath.upper) && ii.dumpState(t, Fa.getState(n), !0);
  }
}
var xP = function() {
  function e(t) {
    We(this, e), this.original = t, this.emitter = t.emitter, this.codePath = null, this.idGenerator = new nA("s"), this.currentNode = null, this.onLooped = this.onLooped.bind(this);
  }
  return Xe(e, [{ key: "enterNode", value: function(t) {
    this.currentNode = t, t.parent && function(n, r) {
      var i = n.codePath, a = Fa.getState(i), s = r.parent;
      switch (s.type) {
        case "LogicalExpression":
          s.right === r && Gp(s.operator) && a.makeLogicalRight();
          break;
        case "ConditionalExpression":
        case "IfStatement":
          s.consequent === r ? a.makeIfConsequent() : s.alternate === r && a.makeIfAlternate();
          break;
        case "SwitchCase":
          s.consequent[0] === r && a.makeSwitchCaseBody(!1, !s.test);
          break;
        case "TryStatement":
          s.handler === r ? a.makeCatchBlock() : s.finalizer === r && a.makeFinallyBlock();
          break;
        case "WhileStatement":
          s.test === r ? a.makeWhileTest($d(r)) : (Rr(s.body === r), a.makeWhileBody());
          break;
        case "DoWhileStatement":
          s.body === r ? a.makeDoWhileBody() : (Rr(s.test === r), a.makeDoWhileTest($d(r)));
          break;
        case "ForStatement":
          s.test === r ? a.makeForTest($d(r)) : s.update === r ? a.makeForUpdate() : s.body === r && a.makeForBody();
          break;
        case "ForInStatement":
        case "ForOfStatement":
          s.left === r ? a.makeForInOfLeft() : s.right === r ? a.makeForInOfRight() : (Rr(s.body === r), a.makeForInOfBody());
          break;
        case "AssignmentPattern":
          s.right === r && (a.pushForkContext(), a.forkBypassPath(), a.forkPath());
      }
    }(this, t), yP(this, t), this.original.enterNode(t), this.currentNode = null;
  } }, { key: "leaveNode", value: function(t) {
    this.currentNode = t, function(n, r) {
      var i = n.codePath, a = Fa.getState(i), s = !1;
      switch (r.type) {
        case "IfStatement":
        case "ConditionalExpression":
          a.popChoiceContext();
          break;
        case "LogicalExpression":
          Gp(r.operator) && a.popChoiceContext();
          break;
        case "SwitchStatement":
          a.popSwitchContext();
          break;
        case "SwitchCase":
          r.consequent.length === 0 && a.makeSwitchCaseBody(!0, !r.test), a.forkContext.reachable && (s = !0);
          break;
        case "TryStatement":
          a.popTryContext();
          break;
        case "BreakStatement":
          Po(n, r), a.makeBreak(r.label && r.label.name), s = !0;
          break;
        case "ContinueStatement":
          Po(n, r), a.makeContinue(r.label && r.label.name), s = !0;
          break;
        case "ReturnStatement":
          Po(n, r), a.makeReturn(), s = !0;
          break;
        case "ThrowStatement":
          Po(n, r), a.makeThrow(), s = !0;
          break;
        case "Identifier":
          (function(o) {
            var u = o.parent;
            switch (u.type) {
              case "LabeledStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "ArrayPattern":
              case "RestElement":
              case "ImportSpecifier":
              case "ImportDefaultSpecifier":
              case "ImportNamespaceSpecifier":
              case "CatchClause":
                return !1;
              case "FunctionDeclaration":
              case "FunctionExpression":
              case "ArrowFunctionExpression":
              case "ClassDeclaration":
              case "ClassExpression":
              case "VariableDeclarator":
                return u.id !== o;
              case "Property":
              case "MethodDefinition":
                return u.key !== o || u.computed || u.shorthand;
              case "AssignmentPattern":
                return u.key !== o;
              default:
                return !0;
            }
          })(r) && (a.makeFirstThrowablePathInTryBlock(), s = !0);
          break;
        case "CallExpression":
        case "ImportExpression":
        case "MemberExpression":
        case "NewExpression":
          a.makeFirstThrowablePathInTryBlock();
          break;
        case "WhileStatement":
        case "DoWhileStatement":
        case "ForStatement":
        case "ForInStatement":
        case "ForOfStatement":
          a.popLoopContext();
          break;
        case "AssignmentPattern":
          a.popForkContext();
          break;
        case "LabeledStatement":
          rA.test(r.body.type) || a.popBreakContext();
      }
      s || Po(n, r), ii.dumpState(r, a, !0);
    }(this, t), this.original.leaveNode(t), vP(this, t), this.currentNode = null;
  } }, { key: "onLooped", value: function(t, n) {
    t.reachable && n.reachable && (ii.dump("onCodePathSegmentLoop ".concat(t.id, " -> ").concat(n.id)), this.emitter.emit("onCodePathSegmentLoop", t, n, this.currentNode));
  } }]), e;
}();
function fp(e, t) {
  return e.line - t.line || e.column - t.column;
}
function _b(e) {
  var t = [], n = 0, r = null, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), o = !0, u = !1, c = void 0;
  try {
    for (var f, p = e.problems[Symbol.iterator](); !(o = (f = p.next()).done); o = !0) {
      for (var d = f.value; n < e.directives.length && 0 >= fp(e.directives[n], d); ) {
        var m = e.directives[n++];
        switch (m.type) {
          case "disable":
            m.ruleId === null ? (r = m, i.clear(), a.clear()) : (r && a.delete(m.ruleId), i.set(m.ruleId, m));
            break;
          case "enable":
            m.ruleId === null ? (r = null, i.clear()) : (r && a.add(m.ruleId), i.delete(m.ruleId));
        }
      }
      i.has(d.ruleId) ? s.add(i.get(d.ruleId)) : r && !a.has(d.ruleId) ? s.add(r) : t.push(d);
    }
  } catch (y) {
    u = !0, c = y;
  } finally {
    try {
      o || p.return == null || p.return();
    } finally {
      if (u)
        throw c;
    }
  }
  return { problems: t, unusedDisableDirectives: e.directives.filter(function(y) {
    return y.type === "disable" && !s.has(y);
  }).map(function(y) {
    return { ruleId: null, message: y.ruleId ? "Unused eslint-disable directive (no problems were reported from '".concat(y.ruleId, "').") : "Unused eslint-disable directive (no problems were reported).", line: y.unprocessedDirective.line, column: y.unprocessedDirective.column, severity: e.reportUnusedDisableDirectives === "warn" ? 1 : 2, nodeType: null };
  }) };
}
var _u = ye.require$$1("eslint:config-comment-parser"), bP = function() {
  function e() {
    We(this, e);
  }
  return Xe(e, [{ key: "parseStringConfig", value: function(t, n) {
    _u("Parsing String config");
    var r = {};
    return t.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([,:])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, "$1").split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|,+/).forEach(function(i) {
      if (i) {
        var a = bn(i.split(":"), 2), s = a[0], o = a[1], u = o === void 0 ? null : o;
        r[s] = { value: u, comment: n };
      }
    }), r;
  } }, { key: "parseJsonConfig", value: function(t, n) {
    _u("Parsing JSON config");
    var r = {};
    try {
      if (r = KT.parse("Object", t) || {}, bi.isEverySeverityValid(r))
        return { success: !0, config: r };
    } catch {
      _u("Levn parsing failed; falling back to manual parsing.");
    }
    r = {};
    var i = t.replace(/([\x2D\/-9A-Za-z]+):/g, '"$1":').replace(/(\]|[0-9])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+(?=")/, "$1,");
    try {
      r = JSON.parse("{".concat(i, "}"));
    } catch (a) {
      return _u("Manual parsing failed."), { success: !1, error: { ruleId: null, fatal: !0, severity: 2, message: "Failed to parse JSON from '".concat(i, "': ").concat(a.message), line: n.start.line, column: n.start.column + 1 } };
    }
    return { success: !0, config: r };
  } }, { key: "parseListConfig", value: function(t) {
    _u("Parsing list config");
    var n = {};
    return t.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, ",").split(/,+/).forEach(function(r) {
      var i = r.trim();
      i && (n[i] = !0);
    }), n;
  } }]), e;
}();
function hp(e) {
  switch (e.type) {
    case "identifier":
      return [e.value];
    case "matches":
      var t, n = e.selectors.map(hp);
      return n.every(Boolean) ? (t = ye.lodash).union.apply(t, Mt(n)) : null;
    case "compound":
      var r, i = e.selectors.map(hp).filter(function(a) {
        return a;
      });
      return i.length ? (r = ye.lodash).intersection.apply(r, Mt(i)) : null;
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return hp(e.right);
    default:
      return null;
  }
}
function dp(e) {
  switch (e.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return dp(e.left) + dp(e.right);
    case "compound":
    case "not":
    case "matches":
      return e.selectors.reduce(function(t, n) {
        return t + dp(n);
      }, 0);
    case "attribute":
    case "field":
    case "nth-child":
    case "nth-last-child":
      return 1;
    default:
      return 0;
  }
}
function mp(e) {
  switch (e.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return mp(e.left) + mp(e.right);
    case "compound":
    case "not":
    case "matches":
      return e.selectors.reduce(function(t, n) {
        return t + mp(n);
      }, 0);
    case "identifier":
      return 1;
    default:
      return 0;
  }
}
function Tu(e, t) {
  return e.attributeCount - t.attributeCount || e.identifierCount - t.identifierCount || (e.rawSelector <= t.rawSelector ? -1 : 1);
}
var EP = ye.lodash.memoize(function(e) {
  var t = function(n) {
    try {
      return Aw.parse(n.replace(/:exit$/, ""));
    } catch (r) {
      throw typeof r.offset == "number" ? new SyntaxError('Syntax error in selector "'.concat(n, '" at position ').concat(r.offset, ": ").concat(r.message)) : r;
    }
  }(e);
  return { rawSelector: e, isExit: e.endsWith(":exit"), parsedSelector: t, listenerTypes: hp(t), attributeCount: dp(t), identifierCount: mp(t) };
}), CP = function() {
  function e(t) {
    var n = this;
    We(this, e), this.emitter = t, this.currentAncestry = [], this.enterSelectorsByNodeType = /* @__PURE__ */ new Map(), this.exitSelectorsByNodeType = /* @__PURE__ */ new Map(), this.anyTypeEnterSelectors = [], this.anyTypeExitSelectors = [], t.eventNames().forEach(function(r) {
      var i = EP(r);
      if (i.listenerTypes) {
        var a = i.isExit ? n.exitSelectorsByNodeType : n.enterSelectorsByNodeType;
        i.listenerTypes.forEach(function(s) {
          a.has(s) || a.set(s, []), a.get(s).push(i);
        });
      } else
        (i.isExit ? n.anyTypeExitSelectors : n.anyTypeEnterSelectors).push(i);
    }), this.anyTypeEnterSelectors.sort(Tu), this.anyTypeExitSelectors.sort(Tu), this.enterSelectorsByNodeType.forEach(function(r) {
      return r.sort(Tu);
    }), this.exitSelectorsByNodeType.forEach(function(r) {
      return r.sort(Tu);
    });
  }
  return Xe(e, [{ key: "applySelector", value: function(t, n) {
    Aw.matches(t, n.parsedSelector, this.currentAncestry) && this.emitter.emit(n.rawSelector, t);
  } }, { key: "applySelectors", value: function(t, n) {
    for (var r = (n ? this.exitSelectorsByNodeType : this.enterSelectorsByNodeType).get(t.type) || [], i = n ? this.anyTypeExitSelectors : this.anyTypeEnterSelectors, a = 0, s = 0; a < r.length || s < i.length; )
      a >= r.length || s < i.length && 0 > Tu(i[s], r[a]) ? this.applySelector(t, i[s++]) : this.applySelector(t, r[a++]);
  } }, { key: "enterNode", value: function(t) {
    t.parent && this.currentAncestry.unshift(t.parent), this.applySelectors(t, !1);
  } }, { key: "leaveNode", value: function(t) {
    this.applySelectors(t, !0), this.currentAncestry.shift();
  } }]), e;
}();
function Tb(e, t) {
  return { range: [e, e], text: t };
}
var SP = Object.freeze({ insertTextAfter: function(e, t) {
  return this.insertTextAfterRange(e.range, t);
}, insertTextAfterRange: function(e, t) {
  return Tb(e[1], t);
}, insertTextBefore: function(e, t) {
  return this.insertTextBeforeRange(e.range, t);
}, insertTextBeforeRange: function(e, t) {
  return Tb(e[0], t);
}, replaceText: function(e, t) {
  return this.replaceTextRange(e.range, t);
}, replaceTextRange: function(e, t) {
  return { range: e, text: t };
}, remove: function(e) {
  return this.removeRange(e.range);
}, removeRange: function(e) {
  return { range: e, text: "" };
} }), sg = function(e, t) {
  return t ? e.replace(/\{\{((?:[\0-z\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}\}/g, function(n, r) {
    var i = r.trim();
    return i in t ? t[i] : n;
  }) : e;
};
function kP() {
  return arguments.length === 1 ? Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]) : typeof (arguments.length <= 1 ? void 0 : arguments[1]) == "string" ? { node: arguments.length <= 0 ? void 0 : arguments[0], message: arguments.length <= 1 ? void 0 : arguments[1], data: arguments.length <= 2 ? void 0 : arguments[2], fix: arguments.length <= 3 ? void 0 : arguments[3] } : { node: arguments.length <= 0 ? void 0 : arguments[0], loc: arguments.length <= 1 ? void 0 : arguments[1], message: arguments.length <= 2 ? void 0 : arguments[2], data: arguments.length <= 3 ? void 0 : arguments[3], fix: arguments.length <= 4 ? void 0 : arguments[4] };
}
function DP(e) {
  e.node ? Rr(xe(e.node) == "object", "Node must be an object") : Rr(e.loc, "Node must be provided when reporting error if location is not provided");
}
function FP(e) {
  return e.loc ? e.loc.start ? e.loc : { start: e.loc, end: null } : e.node.loc;
}
function wP(e, t) {
  return e.range[0] - t.range[0] || e.range[1] - t.range[1];
}
function iA(e, t) {
  if (typeof e.fix != "function")
    return null;
  var n = e.fix(SP);
  return n && Symbol.iterator in n ? function(r, i) {
    var a = Math.max;
    if (r.length === 0)
      return null;
    if (r.length === 1)
      return r[0];
    r.sort(wP);
    var s = i.text, o = r[0].range[0], u = r[r.length - 1].range[1], c = "", f = Number.MIN_SAFE_INTEGER, p = !0, d = !1, m = void 0;
    try {
      for (var y, v = r[Symbol.iterator](); !(p = (y = v.next()).done); p = !0) {
        var b = y.value;
        Rr(b.range[0] >= f, "Fix objects must not be overlapped in a report."), 0 <= b.range[0] && (c += s.slice(a(0, o, f), b.range[0])), c += b.text, f = b.range[1];
      }
    } catch (x) {
      d = !0, m = x;
    } finally {
      try {
        p || v.return == null || v.return();
      } finally {
        if (d)
          throw m;
      }
    }
    return { range: [o, u], text: c += s.slice(a(0, o, f), u) };
  }(Array.from(n), t) : n;
}
function AP(e, t, n) {
  return e.suggest && Array.isArray(e.suggest) ? e.suggest.map(function(r) {
    var i = r.desc || n[r.messageId];
    return Sa({}, r, { desc: sg(i, r.data), fix: iA(r, t) });
  }) : [];
}
function _P(e) {
  var t = { ruleId: e.ruleId, severity: e.severity, message: e.message, line: e.loc.start.line, column: e.loc.start.column + 1, nodeType: e.node && e.node.type || null };
  return e.messageId && (t.messageId = e.messageId), e.loc.end && (t.endLine = e.loc.end.line, t.endColumn = e.loc.end.column + 1), e.fix && (t.fix = e.fix), e.suggestions && 0 < e.suggestions.length && (t.suggestions = e.suggestions), t;
}
function TP(e, t) {
  e && Array.isArray(e) && e.forEach(function(n) {
    if (n.messageId) {
      var r = n.messageId;
      if (!t)
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r, "', but no messages were present in the rule metadata."));
      if (!t[r])
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r, "' which is not present in the 'messages' config: ").concat(JSON.stringify(t, null, 2)));
      if (n.desc)
        throw new TypeError("context.report() called with a suggest option that defines both a 'messageId' and an 'desc'. Please only pass one.");
    } else if (!n.desc)
      throw new TypeError("context.report() called with a suggest option that doesn't have either a `desc` or `messageId`");
    if (typeof n.fix != "function")
      throw new TypeError("context.report() called with a suggest option without a fix function. See: ".concat(n));
  });
}
var PP = function(e) {
  return function() {
    var t, n = kP.apply(void 0, arguments), r = e.messageIds;
    if (DP(n), n.messageId) {
      if (!r)
        throw new TypeError("context.report() called with a messageId, but no messages were present in the rule metadata.");
      var i = n.messageId;
      if (n.message)
        throw new TypeError("context.report() called with a message and a messageId. Please only pass one.");
      if (!r || !Object.prototype.hasOwnProperty.call(r, i))
        throw new TypeError("context.report() called with a messageId of '".concat(i, "' which is not present in the 'messages' config: ").concat(JSON.stringify(r, null, 2)));
      t = r[i];
    } else {
      if (!n.message)
        throw new TypeError("Missing `message` property in report() call; add a message that describes the linting problem.");
      t = n.message;
    }
    return TP(n.suggest, r), _P({ ruleId: e.ruleId, severity: e.severity, node: n.node, message: sg(t, n.data), messageId: n.messageId, loc: FP(n), fix: e.disableFixes ? null : iA(n, e.sourceCode), suggestions: e.disableFixes ? [] : AP(n, e.sourceCode, r) });
  };
}, IP = function() {
  function e() {
    We(this, e), this._rules = /* @__PURE__ */ Object.create(null);
  }
  return Xe(e, [{ key: "define", value: function(t, n) {
    this._rules[t] = function(r) {
      return typeof r == "function" ? Object.assign({ create: r }, r) : r;
    }(n);
  } }, { key: "get", value: function(t) {
    return typeof this._rules[t] == "string" && this.define(t, null), this._rules[t] ? this._rules[t] : pp.has(t) ? pp.get(t) : null;
  } }, { key: Symbol.iterator, value: regeneratorRuntime.mark(function t() {
    var n, r, i;
    return regeneratorRuntime.wrap(function(a) {
      for (; ; )
        switch (a.prev = a.next) {
          case 0:
            return a.delegateYield(pp, "t0", 1);
          case 1:
            n = 0, r = Object.keys(this._rules);
          case 2:
            if (!(n < r.length)) {
              a.next = 9;
              break;
            }
            return i = r[n], a.next = 6, [i, this.get(i)];
          case 6:
            n++, a.next = 2;
            break;
          case 9:
          case "end":
            return a.stop();
        }
    }, t, this);
  }) }]), e;
}(), BP = function() {
  var e = /* @__PURE__ */ Object.create(null);
  return Object.freeze({ on: function(t, n) {
    t in e ? e[t].push(n) : e[t] = [n];
  }, emit: function(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    t in e && e[t].forEach(function(a) {
      return a.apply(void 0, r);
    });
  }, eventNames: function() {
    return Object.keys(e);
  } });
}, zl = ye.require$$1("eslint:source-code-fixer"), Gd = "\uFEFF";
function OP(e, t) {
  return e.fix.range[0] - t.fix.range[0] || e.fix.range[1] - t.fix.range[1];
}
function LP(e, t) {
  return e.line - t.line || e.column - t.column;
}
function aA() {
  Object.freeze(this);
}
aA.applyFixes = function(e, t, n) {
  function r(C) {
    var k = C.fix, F = k.range[0], B = k.range[1];
    return c >= F || F > B ? (a.push(C), !1) : ((0 > F && 0 <= B || F === 0 && k.text.startsWith(Gd)) && (f = ""), f += u.slice(i(0, c), i(0, F)), f += k.text, c = B, !0);
  }
  var i = Math.max;
  if (zl("Applying fixes"), n === !1)
    return zl("shouldFix parameter was false, not attempting fixes"), { fixed: !1, messages: t, output: e };
  var a = [], s = [], o = e.startsWith(Gd) ? Gd : "", u = o ? e.slice(1) : e, c = Number.NEGATIVE_INFINITY, f = o;
  if (t.forEach(function(C) {
    Object.prototype.hasOwnProperty.call(C, "fix") ? s.push(C) : a.push(C);
  }), s.length) {
    zl("Found fixes to apply");
    var p = !1, d = !0, m = !1, y = void 0;
    try {
      for (var v, b = s.sort(OP)[Symbol.iterator](); !(d = (v = b.next()).done); d = !0) {
        var x = v.value;
        typeof n != "function" || n(x) ? (r(x), p = !0) : a.push(x);
      }
    } catch (C) {
      m = !0, y = C;
    } finally {
      try {
        d || b.return == null || b.return();
      } finally {
        if (m)
          throw y;
      }
    }
    return f += u.slice(i(0, c)), { fixed: p, messages: a.sort(LP), output: f };
  }
  return zl("No fixes to apply"), { fixed: !1, messages: t, output: o + u };
};
var Pb = aA, oA = { "generator-star": ["generator-star-spacing"], "global-strict": ["strict"], "no-arrow-condition": ["no-confusing-arrow", "no-constant-condition"], "no-comma-dangle": ["comma-dangle"], "no-empty-class": ["no-empty-character-class"], "no-empty-label": ["no-labels"], "no-extra-strict": ["strict"], "no-reserved-keys": ["quote-props"], "no-space-before-semi": ["semi-spacing"], "no-wrap-func": ["no-extra-parens"], "space-after-function-name": ["space-before-function-paren"], "space-after-keywords": ["keyword-spacing"], "space-before-function-parentheses": ["space-before-function-paren"], "space-before-keywords": ["keyword-spacing"], "space-in-brackets": ["object-curly-spacing", "array-bracket-spacing", "computed-property-spacing"], "space-return-throw-case": ["keyword-spacing"], "space-unary-word-ops": ["space-unary-ops"], "spaced-line-comment": ["spaced-comment"] }, NP = { rules: oA }, jP = Object.freeze({ __proto__: null, rules: oA, default: NP }), Ib = ye.getCjsExportFromNamespace(QT), Bb = ye.getCjsExportFromNamespace(jP), Ob = fP.SourceCode, sr = ye.require$$1("eslint:linter"), Gu = new bP(), RP = { start: { line: 1, column: 0 }, end: { line: 1, column: 1 } };
function Fo(e) {
  var t = e.ruleId, n = t === void 0 ? null : t, r = e.loc, i = r === void 0 ? RP : r, a = e.message, s = a === void 0 ? function(c) {
    return Object.prototype.hasOwnProperty.call(Bb.rules, c) ? "Rule '".concat(c, "' was removed and replaced by: ").concat(Bb.rules[c].join(", ")) : "Definition for rule '".concat(c, "' was not found.");
  }(e.ruleId) : a, o = e.severity, u = o === void 0 ? 2 : o;
  return { ruleId: n, message: s, line: i.start.line, column: i.start.column + 1, endLine: i.end.line, endColumn: i.end.column + 1, severity: u, nodeType: null };
}
function MP(e, t, n, r) {
  var i = {}, a = /* @__PURE__ */ Object.create(null), s = {}, o = [], u = [];
  return t.comments.filter(function(c) {
    return c.type !== "Shebang";
  }).forEach(function(c) {
    var f = c.value.trim(), p = /^(eslint(?:\x2Denv|\x2Denable|\x2Ddisable(?:(?:\x2Dnext)?\x2Dline)?)?|exported|globals?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|$)/.exec(f);
    if (p) {
      var d = p[1], m = /^eslint\x2Ddisable\x2D(next\x2D)?line$/.test(d);
      if (c.type !== "Line" || m) {
        if (r) {
          var y = c.type === "Block" ? "/*".concat(d, "*/") : "//".concat(d);
          return void o.push(Fo({ ruleId: null, message: "'".concat(y, "' has no effect because you have 'noInlineConfig' setting in ").concat(r, "."), loc: c.loc, severity: 1 }));
        }
        if (m && c.loc.start.line !== c.loc.end.line)
          return void o.push(Fo({ ruleId: null, message: "".concat(d, " comment should not span multiple lines."), loc: c.loc }));
        var v = f.slice(p.index + d.length);
        switch (d) {
          case "eslint-disable":
          case "eslint-enable":
          case "eslint-disable-next-line":
          case "eslint-disable-line":
            var b = function(I) {
              var L = I.type, V = I.loc, K = I.value, W = I.ruleMapper, R = Object.keys(Gu.parseListConfig(K)), q = R.length ? R : [null], J = { directives: [], directiveProblems: [] }, X = !0, ce = !1, A = void 0;
              try {
                for (var M, ne = q[Symbol.iterator](); !(X = (M = ne.next()).done); X = !0) {
                  var de = M.value;
                  de === null || W(de) !== null ? J.directives.push({ type: L, line: V.start.line, column: V.start.column + 1, ruleId: de }) : J.directiveProblems.push(Fo({ ruleId: de, loc: V }));
                }
              } catch (he) {
                ce = !0, A = he;
              } finally {
                try {
                  X || ne.return == null || ne.return();
                } finally {
                  if (ce)
                    throw A;
                }
              }
              return J;
            }({ type: d.slice(7), loc: c.loc, value: v, ruleMapper: n }), x = b.directives, C = b.directiveProblems;
            u.push.apply(u, Mt(x)), o.push.apply(o, Mt(C));
            break;
          case "exported":
            Object.assign(s, Gu.parseStringConfig(v, c));
            break;
          case "globals":
          case "global":
            for (var k = 0, F = Object.entries(Gu.parseStringConfig(v, c)); k < F.length; k++) {
              var B = bn(F[k], 2), O = B[0], S = B[1].value, w = void 0;
              try {
                w = bi.normalizeConfigGlobal(S);
              } catch (I) {
                o.push(Fo({ ruleId: null, loc: c.loc, message: I.message }));
                continue;
              }
              a[O] ? (a[O].comments.push(c), a[O].value = w) : a[O] = { comments: [c], value: w };
            }
            break;
          case "eslint":
            var D = Gu.parseJsonConfig(v, c.loc);
            D.success ? Object.keys(D.config).forEach(function(I) {
              var L = n(I), V = D.config[I];
              if (L !== null) {
                try {
                  nP.validateRuleOptions(L, I, V);
                } catch (K) {
                  return void o.push(Fo({ ruleId: I, message: K.message, loc: c.loc }));
                }
                i[I] = V;
              } else
                o.push(Fo({ ruleId: I, loc: c.loc }));
            }) : o.push(D.error);
        }
      }
    }
  }), { configuredRules: i, enabledGlobals: a, exportedVariables: s, problems: o, disableDirectives: u };
}
var Lb = /\/\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*eslint\x2Denv[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\*\//g;
function Nb(e) {
  var t = e.split(Bs.sep), n = t.lastIndexOf("<text>");
  return n === -1 ? e : t.slice(n).join(Bs.sep);
}
function VP(e) {
  return Array.isArray(e) ? e.slice(1) : [];
}
function jb(e, t, n) {
  var r = t.ecmaFeatures || {}, i = t.ecmaVersion || 5;
  return ww.analyze(e, { ignoreEval: !0, nodejsScope: r.globalReturn, impliedStrict: r.impliedStrict, ecmaVersion: i, sourceType: t.sourceType || "script", childVisitorKeys: n || ye.evk.KEYS, fallback: ye.Traverser.getKeys });
}
function Rb(e, t) {
  for (var n = t.type !== "Program", r = t; r; r = r.parent) {
    var i = e.acquire(r, n);
    if (i)
      return i.type === "function-expression-name" ? i.childScopes[0] : i;
  }
  return e.scopes[0];
}
var Mb = { getSource: "getText", getSourceLines: "getLines", getAllComments: "getAllComments", getNodeByRangeIndex: "getNodeByRangeIndex", getComments: "getComments", getCommentsBefore: "getCommentsBefore", getCommentsAfter: "getCommentsAfter", getCommentsInside: "getCommentsInside", getJSDocComment: "getJSDocComment", getFirstToken: "getFirstToken", getFirstTokens: "getFirstTokens", getLastToken: "getLastToken", getLastTokens: "getLastTokens", getTokenAfter: "getTokenAfter", getTokenBefore: "getTokenBefore", getTokenByRangeStart: "getTokenByRangeStart", getTokens: "getTokens", getTokensAfter: "getTokensAfter", getTokensBefore: "getTokensBefore", getTokensBetween: "getTokensBetween" }, UP = Object.freeze(Object.keys(Mb).reduce(function(e, t) {
  return Object.assign(e, Fn({}, t, function() {
    var n;
    return (n = this.getSourceCode())[Mb[t]].apply(n, arguments);
  }));
}, {}));
function qP(e, t, n, r, i, a, s, o, u) {
  var c = BP(), f = [], p = e.ast;
  ye.Traverser.traverse(e.ast, { enter: function(v, b) {
    v.parent = b, f.push({ isEntering: !0, node: v });
  }, leave: function(v) {
    f.push({ isEntering: !1, node: v });
  }, visitorKeys: e.visitorKeys });
  var d = Object.freeze(Object.assign(Object.create(UP), { getAncestors: function() {
    return function(v) {
      for (var b = [], x = v.parent; x; x = x.parent)
        b.push(x);
      return b.reverse();
    }(p);
  }, getDeclaredVariables: e.scopeManager.getDeclaredVariables.bind(e.scopeManager), getCwd: function() {
    return u;
  }, getFilename: function() {
    return s;
  }, getScope: function() {
    return Rb(e.scopeManager, p);
  }, getSourceCode: function() {
    return e;
  }, markVariableAsUsed: function(v) {
    return function(b, x, C, k) {
      for (var F = C.ecmaFeatures && C.ecmaFeatures.globalReturn || C.sourceType === "module", B = Rb(b, x), O = B.type === "global" && F ? B.childScopes[0] : B; O; O = O.upper) {
        var S = O.variables.find(function(w) {
          return w.name === k;
        });
        if (S)
          return S.eslintUsed = !0, !0;
      }
      return !1;
    }(e.scopeManager, p, r, v);
  }, parserOptions: r, parserPath: i, parserServices: e.parserServices, settings: a })), m = [];
  Object.keys(t).forEach(function(v) {
    var b = bi.getRuleSeverity(t[v]);
    if (b !== 0) {
      var x = n(v);
      if (x !== null) {
        var C = x.meta && x.meta.messages, k = null, F = Object.freeze(Object.assign(Object.create(d), { id: v, options: VP(t[v]), report: function() {
          k === null && (k = PP({ ruleId: v, severity: b, sourceCode: e, messageIds: C, disableFixes: o }));
          var O = k.apply(void 0, arguments);
          if (O.fix && x.meta && !x.meta.fixable)
            throw new Error("Fixable rules should export a `meta.fixable` property.");
          m.push(O);
        } })), B = function(O, S) {
          try {
            return O.create(S);
          } catch (w) {
            throw w.message = "Error while loading rule '".concat(S.id, "': ").concat(w.message), w;
          }
        }(x, F);
        Object.keys(B).forEach(function(O) {
          c.on(O, B[O]);
        });
      } else
        m.push(Fo({ ruleId: v }));
    }
  });
  var y = new xP(new CP(c));
  return f.forEach(function(v) {
    p = v.node;
    try {
      v.isEntering ? y.enterNode(p) : y.leaveNode(p);
    } catch (b) {
      throw b.currentNode = p, b;
    }
  }), m;
}
function Vb(e, t) {
  return e.lastConfigArray && e.lastConfigArray.pluginRules.get(t) || e.ruleMap.get(t);
}
function WP(e) {
  return e || ((typeof process > "u" ? "undefined" : xe(process)) == "object" ? process.cwd() : void 0);
}
var za = /* @__PURE__ */ new WeakMap(), $P = { linter_1: { Linter: { Linter: function() {
  function e() {
    var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cwd;
    We(this, e), za.set(this, { cwd: WP(t), lastConfigArray: null, lastSourceCode: null, parserMap: /* @__PURE__ */ new Map([["espree", ye.espree]]), ruleMap: new IP() }), this.version = Ib.version;
  }
  return Xe(e, [{ key: "_verifyWithoutProcessors", value: function(t, n, r) {
    var i, a = za.get(this), s = n || {}, o = function(O, S) {
      var w = S.noInlineConfig === !0, D = O.allowInlineConfig === !1, I = S.configNameOfNoInlineConfig ? " (".concat(S.configNameOfNoInlineConfig, ")") : "", L = O.reportUnusedDisableDirectives;
      return typeof L == "boolean" && (L = L ? "error" : "off"), typeof L != "string" && (L = S.reportUnusedDisableDirectives ? "warn" : "off"), { filename: Nb(O.filename || "<input>"), allowInlineConfig: !D, warnInlineConfig: w && !D ? "your config".concat(I) : null, reportUnusedDisableDirectives: L, disableFixes: !!O.disableFixes };
    }(r, s);
    typeof t == "string" ? (a.lastSourceCode = null, i = t) : (a.lastSourceCode = t, i = t.text);
    var u = "espree", c = ye.espree;
    if (xe(s.parser) == "object" && s.parser !== null)
      u = s.parser.filePath, c = s.parser.definition;
    else if (typeof s.parser == "string") {
      if (!a.parserMap.has(s.parser))
        return [{ ruleId: null, fatal: !0, severity: 2, message: "Configured parser '".concat(s.parser, "' was not found."), line: 0, column: 0 }];
      u = s.parser, c = a.parserMap.get(s.parser);
    }
    var f = o.allowInlineConfig && !o.warnInlineConfig ? function(O) {
      var S, w;
      for (Lb.lastIndex = 0; S = Lb.exec(O); )
        w = Object.assign(w || {}, Gu.parseListConfig(S[1]));
      return w;
    }(i) : {}, p = Object.assign({ builtin: !0 }, s.env, f), d = Object.keys(p).filter(function(O) {
      return p[O];
    }).map(function(O) {
      return function(S, w) {
        return S.lastConfigArray && S.lastConfigArray.pluginEnvironments.get(w) || _w.get(w) || null;
      }(a, O);
    }).filter(function(O) {
      return O;
    }), m = function(O, S, w) {
      var D = w.filter(function(L) {
        return L.parserOptions;
      }).reduce(function(L, V) {
        return ye.lodash.merge(L, V.parserOptions);
      }, {}), I = ye.lodash.merge(D, S || {});
      return I.sourceType === "module" && (I.ecmaFeatures = Object.assign({}, I.ecmaFeatures, { globalReturn: !1 })), I.ecmaVersion = function(L) {
        return 2015 <= L ? L - 2009 : L;
      }(I.ecmaVersion), I;
    }(0, s.parserOptions || {}, d), y = function(O, S) {
      return Object.assign.apply(Object, [{}].concat(Mt(S.filter(function(w) {
        return w.globals;
      }).map(function(w) {
        return w.globals;
      })), [O]));
    }(s.globals || {}, d), v = s.settings || {};
    if (a.lastSourceCode)
      a.lastSourceCode.scopeManager || (a.lastSourceCode = new Ob({ text: a.lastSourceCode.text, ast: a.lastSourceCode.ast, parserServices: a.lastSourceCode.parserServices, visitorKeys: a.lastSourceCode.visitorKeys, scopeManager: jb(a.lastSourceCode.ast, m) }));
    else {
      var b = function(O, S, w, D) {
        var I = function(X) {
          return X.charCodeAt(0) === 65279 ? X.slice(1) : X;
        }(O).replace(ye.require$$0$1.shebangPattern, function(X, ce) {
          return "//".concat(ce);
        }), L = Object.assign({}, w, { loc: !0, range: !0, raw: !0, tokens: !0, comment: !0, eslintVisitorKeys: !0, eslintScopeManager: !0, filePath: D });
        try {
          var V = typeof S.parseForESLint == "function" ? S.parseForESLint(I, L) : { ast: S.parse(I, L) }, K = V.ast, W = V.services || {}, R = V.visitorKeys || ye.evk.KEYS, q = V.scopeManager || jb(K, L, R);
          return { success: !0, sourceCode: new Ob({ text: O, ast: K, parserServices: W, scopeManager: q, visitorKeys: R }) };
        } catch (X) {
          var J = "Parsing error: ".concat(X.message.replace(/^line [0-9]+:/i, "").trim());
          return sr(`%s
%s`, J, X.stack), { success: !1, error: { ruleId: null, fatal: !0, severity: 2, message: J, line: X.lineNumber, column: X.column } };
        }
      }(i, c, m, o.filename);
      if (!b.success)
        return [b.error];
      a.lastSourceCode = b.sourceCode;
    }
    var x = a.lastSourceCode, C = o.allowInlineConfig ? MP(o.filename, x.ast, function(O) {
      return Vb(a, O);
    }, o.warnInlineConfig) : { configuredRules: {}, enabledGlobals: {}, exportedVariables: {}, problems: [], disableDirectives: [] };
    (function(O, S, w) {
      var D = w.exportedVariables, I = w.enabledGlobals, L = !0, V = !1, K = void 0;
      try {
        for (var W, R = new Set([].concat(Mt(Object.keys(S)), Mt(Object.keys(I))))[Symbol.iterator](); !(L = (W = R.next()).done); L = !0) {
          var q = W.value, J = S[q] === void 0 ? void 0 : bi.normalizeConfigGlobal(S[q]), X = I[q] && I[q].value || J, ce = I[q] && I[q].comments;
          if (X !== "off") {
            var A = O.set.get(q);
            A || (A = new ww.Variable(q, O), O.variables.push(A), O.set.set(q, A)), A.eslintImplicitGlobalSetting = J, A.eslintExplicitGlobal = ce !== void 0, A.eslintExplicitGlobalComments = ce, A.writeable = X === "writable";
          }
        }
      } catch (M) {
        V = !0, K = M;
      } finally {
        try {
          L || R.return == null || R.return();
        } finally {
          if (V)
            throw K;
        }
      }
      Object.keys(D).forEach(function(M) {
        var ne = O.set.get(M);
        ne && (ne.eslintUsed = !0);
      }), O.through = O.through.filter(function(M) {
        var ne = M.identifier.name, de = O.set.get(ne);
        return !de || (M.resolved = de, de.references.push(M), !1);
      });
    })(x.scopeManager.scopes[0], y, { exportedVariables: C.exportedVariables, enabledGlobals: C.enabledGlobals });
    var k, F = Object.assign({}, s.rules, C.configuredRules);
    try {
      k = qP(x, F, function(O) {
        return Vb(a, O);
      }, m, u, v, o.filename, o.disableFixes, a.cwd);
    } catch (O) {
      if (O.message += `
Occurred while linting `.concat(o.filename), sr("An error occurred while traversing"), sr("Filename:", o.filename), O.currentNode) {
        var B = O.currentNode.loc.start.line;
        sr("Line:", B), O.message += ":".concat(B);
      }
      throw sr("Parser Options:", m), sr("Parser Path:", u), sr("Settings:", v), O;
    }
    return function(O) {
      var S = O.directives, w = O.problems, D = O.reportUnusedDisableDirectives, I = D === void 0 ? "off" : D, L = S.filter(function(R) {
        return R.type === "disable" || R.type === "enable";
      }).map(function(R) {
        return Object.assign({}, R, { unprocessedDirective: R });
      }).sort(fp), V = ye.lodash.flatMap(S, function(R) {
        switch (R.type) {
          case "disable":
          case "enable":
            return [];
          case "disable-line":
            return [{ type: "disable", line: R.line, column: 1, ruleId: R.ruleId, unprocessedDirective: R }, { type: "enable", line: R.line + 1, column: 0, ruleId: R.ruleId, unprocessedDirective: R }];
          case "disable-next-line":
            return [{ type: "disable", line: R.line + 1, column: 1, ruleId: R.ruleId, unprocessedDirective: R }, { type: "enable", line: R.line + 2, column: 0, ruleId: R.ruleId, unprocessedDirective: R }];
          default:
            throw new TypeError("Unrecognized directive type '".concat(R.type, "'"));
        }
      }).sort(fp), K = _b({ problems: w, directives: L, reportUnusedDisableDirectives: I }), W = _b({ problems: K.problems, directives: V, reportUnusedDisableDirectives: I });
      return I === "off" ? W.problems : W.problems.concat(K.unusedDisableDirectives).concat(W.unusedDisableDirectives).sort(fp);
    }({ directives: C.disableDirectives, problems: k.concat(C.problems).sort(function(O, S) {
      return O.line - S.line || O.column - S.column;
    }), reportUnusedDisableDirectives: o.reportUnusedDisableDirectives });
  } }, { key: "verify", value: function(t, n, r) {
    sr("Verify");
    var i = typeof r == "string" ? { filename: r } : r || {};
    return n && typeof n.extractConfig == "function" ? this._verifyWithConfigArray(t, n, i) : i.preprocess || i.postprocess ? this._verifyWithProcessor(t, n, i) : this._verifyWithoutProcessors(t, n, i);
  } }, { key: "_verifyWithConfigArray", value: function(t, n, r) {
    sr("With ConfigArray: %s", r.filename), za.get(this).lastConfigArray = n;
    var i = n.extractConfig(r.filename), a = i.processor && n.pluginProcessors.get(i.processor);
    if (a) {
      sr("Apply the processor: %o", i.processor);
      var s = a.preprocess, o = a.postprocess, u = a.supportsAutofix, c = r.disableFixes || !u;
      return this._verifyWithProcessor(t, i, Sa({}, r, { disableFixes: c, postprocess: o, preprocess: s }), n);
    }
    return this._verifyWithoutProcessors(t, i, r);
  } }, { key: "_verifyWithProcessor", value: function(t, n, r, i) {
    var a = this, s = r.filename || "<input>", o = Nb(s), u = function(m) {
      return xe(m) == "object" ? (m.hasBOM ? "\uFEFF" : "") + m.text : m + "";
    }(t), c = r.preprocess || function(m) {
      return [m];
    }, f = r.postprocess || ye.lodash.flatten, p = r.filterCodeBlock || function(m) {
      return m.endsWith(".js");
    }, d = Bs.extname(s);
    return f(c(u, o).map(function(m, y) {
      if (sr("A code block was found: %o", m.filename || "(unnamed)"), typeof m == "string")
        return a._verifyWithoutProcessors(m, n, r);
      var v = m.text, b = Bs.join(s, "".concat(y, "_").concat(m.filename));
      return p(b, v) ? i && Bs.extname(b) !== d ? (sr("Resolving configuration again because the file extension was changed."), a._verifyWithConfigArray(v, i, Sa({}, r, { filename: b }))) : a._verifyWithoutProcessors(v, n, Sa({}, r, { filename: b })) : (sr("This code block was skipped."), []);
    }), o);
  } }, { key: "getSourceCode", value: function() {
    return za.get(this).lastSourceCode;
  } }, { key: "defineRule", value: function(t, n) {
    za.get(this).ruleMap.define(t, n);
  } }, { key: "defineRules", value: function(t) {
    var n = this;
    Object.getOwnPropertyNames(t).forEach(function(r) {
      n.defineRule(r, t[r]);
    });
  } }, { key: "getRules", value: function() {
    var t = za.get(this), n = t.lastConfigArray, r = t.ruleMap;
    return new Map(regeneratorRuntime.mark(function i() {
      return regeneratorRuntime.wrap(function(a) {
        for (; ; )
          switch (a.prev = a.next) {
            case 0:
              return a.delegateYield(r, "t0", 1);
            case 1:
              if (a.t1 = n, !a.t1) {
                a.next = 4;
                break;
              }
              return a.delegateYield(n.pluginRules, "t2", 4);
            case 4:
            case "end":
              return a.stop();
          }
      }, i);
    })());
  } }, { key: "defineParser", value: function(t, n) {
    za.get(this).parserMap.set(t, n);
  } }, { key: "verifyAndFix", value: function(t, n, r) {
    var i, a = [], s = !1, o = 0, u = t, c = r && r.filename || "".concat(t.slice(0, 10), "..."), f = !(r && r.fix !== void 0) || r.fix;
    do {
      if (o++, sr("Linting code for ".concat(c, " (pass ").concat(o, ")")), a = this.verify(u, n, r), sr("Generating fixed text for ".concat(c, " (pass ").concat(o, ")")), i = Pb.applyFixes(u, a, f), a.length === 1 && a[0].fatal)
        break;
      s = s || i.fixed, u = i.output;
    } while (i.fixed && o < 10);
    return i.fixed && (i.messages = this.verify(u, n, r)), i.fixed = s, i.output = u, i;
  } }], [{ key: "version", get: function() {
    return Ib.version;
  } }]), e;
}(), getLinterInternalSlots: function(e) {
  return za.get(e);
} }.Linter, SourceCodeFixer: Pb, interpolate: sg }.Linter }, wo = gt(function(e) {
  (function() {
    function t(r) {
      if (r == null)
        return !1;
      switch (r.type) {
        case "BlockStatement":
        case "BreakStatement":
        case "ContinueStatement":
        case "DebuggerStatement":
        case "DoWhileStatement":
        case "EmptyStatement":
        case "ExpressionStatement":
        case "ForInStatement":
        case "ForStatement":
        case "IfStatement":
        case "LabeledStatement":
        case "ReturnStatement":
        case "SwitchStatement":
        case "ThrowStatement":
        case "TryStatement":
        case "VariableDeclaration":
        case "WhileStatement":
        case "WithStatement":
          return !0;
      }
      return !1;
    }
    function n(r) {
      switch (r.type) {
        case "IfStatement":
          return r.alternate != null ? r.alternate : r.consequent;
        case "LabeledStatement":
        case "ForStatement":
        case "ForInStatement":
        case "WhileStatement":
        case "WithStatement":
          return r.body;
      }
      return null;
    }
    e.exports = { isExpression: function(r) {
      if (r == null)
        return !1;
      switch (r.type) {
        case "ArrayExpression":
        case "AssignmentExpression":
        case "BinaryExpression":
        case "CallExpression":
        case "ConditionalExpression":
        case "FunctionExpression":
        case "Identifier":
        case "Literal":
        case "LogicalExpression":
        case "MemberExpression":
        case "NewExpression":
        case "ObjectExpression":
        case "SequenceExpression":
        case "ThisExpression":
        case "UnaryExpression":
        case "UpdateExpression":
          return !0;
      }
      return !1;
    }, isStatement: t, isIterationStatement: function(r) {
      if (r == null)
        return !1;
      switch (r.type) {
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "WhileStatement":
          return !0;
      }
      return !1;
    }, isSourceElement: function(r) {
      return t(r) || r != null && r.type === "FunctionDeclaration";
    }, isProblematicIfStatement: function(r) {
      var i;
      if (r.type !== "IfStatement" || r.alternate == null)
        return !1;
      i = r.consequent;
      do {
        if (i.type === "IfStatement" && i.alternate == null)
          return !0;
        i = n(i);
      } while (i);
      return !1;
    }, trailingStatement: n };
  })();
}), xi = (wo.isExpression, wo.isStatement, wo.isIterationStatement, wo.isSourceElement, wo.isProblematicIfStatement, wo.trailingStatement, gt(function(e) {
  (function() {
    var t, n, r, i, a, s;
    function o(u) {
      return u <= 65535 ? String.fromCharCode(u) : String.fromCharCode(Math.floor((u - 65536) / 1024) + 55296) + String.fromCharCode((u - 65536) % 1024 + 56320);
    }
    for (n = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ }, r = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279], i = new Array(128), s = 0; s < 128; ++s)
      i[s] = s >= 97 && s <= 122 || s >= 65 && s <= 90 || s === 36 || s === 95;
    for (a = new Array(128), s = 0; s < 128; ++s)
      a[s] = s >= 97 && s <= 122 || s >= 65 && s <= 90 || s >= 48 && s <= 57 || s === 36 || s === 95;
    e.exports = { isDecimalDigit: function(u) {
      return 48 <= u && u <= 57;
    }, isHexDigit: function(u) {
      return 48 <= u && u <= 57 || 97 <= u && u <= 102 || 65 <= u && u <= 70;
    }, isOctalDigit: function(u) {
      return u >= 48 && u <= 55;
    }, isWhiteSpace: function(u) {
      return u === 32 || u === 9 || u === 11 || u === 12 || u === 160 || u >= 5760 && r.indexOf(u) >= 0;
    }, isLineTerminator: function(u) {
      return u === 10 || u === 13 || u === 8232 || u === 8233;
    }, isIdentifierStartES5: function(u) {
      return u < 128 ? i[u] : n.NonAsciiIdentifierStart.test(o(u));
    }, isIdentifierPartES5: function(u) {
      return u < 128 ? a[u] : n.NonAsciiIdentifierPart.test(o(u));
    }, isIdentifierStartES6: function(u) {
      return u < 128 ? i[u] : t.NonAsciiIdentifierStart.test(o(u));
    }, isIdentifierPartES6: function(u) {
      return u < 128 ? a[u] : t.NonAsciiIdentifierPart.test(o(u));
    } };
  })();
})), Oi = (xi.isDecimalDigit, xi.isHexDigit, xi.isOctalDigit, xi.isWhiteSpace, xi.isLineTerminator, xi.isIdentifierStartES5, xi.isIdentifierPartES5, xi.isIdentifierStartES6, xi.isIdentifierPartES6, gt(function(e) {
  (function() {
    var t = xi;
    function n(u, c) {
      return !(!c && u === "yield") && r(u, c);
    }
    function r(u, c) {
      if (c && function(f) {
        switch (f) {
          case "implements":
          case "interface":
          case "package":
          case "private":
          case "protected":
          case "public":
          case "static":
          case "let":
            return !0;
          default:
            return !1;
        }
      }(u))
        return !0;
      switch (u.length) {
        case 2:
          return u === "if" || u === "in" || u === "do";
        case 3:
          return u === "var" || u === "for" || u === "new" || u === "try";
        case 4:
          return u === "this" || u === "else" || u === "case" || u === "void" || u === "with" || u === "enum";
        case 5:
          return u === "while" || u === "break" || u === "catch" || u === "throw" || u === "const" || u === "yield" || u === "class" || u === "super";
        case 6:
          return u === "return" || u === "typeof" || u === "delete" || u === "switch" || u === "export" || u === "import";
        case 7:
          return u === "default" || u === "finally" || u === "extends";
        case 8:
          return u === "function" || u === "continue" || u === "debugger";
        case 10:
          return u === "instanceof";
        default:
          return !1;
      }
    }
    function i(u, c) {
      return u === "null" || u === "true" || u === "false" || n(u, c);
    }
    function a(u, c) {
      return u === "null" || u === "true" || u === "false" || r(u, c);
    }
    function s(u) {
      var c, f, p;
      if (u.length === 0 || (p = u.charCodeAt(0), !t.isIdentifierStartES5(p)))
        return !1;
      for (c = 1, f = u.length; c < f; ++c)
        if (p = u.charCodeAt(c), !t.isIdentifierPartES5(p))
          return !1;
      return !0;
    }
    function o(u) {
      var c, f, p, d, m;
      if (u.length === 0)
        return !1;
      for (m = t.isIdentifierStartES6, c = 0, f = u.length; c < f; ++c) {
        if (55296 <= (p = u.charCodeAt(c)) && p <= 56319) {
          if (++c >= f || !(56320 <= (d = u.charCodeAt(c)) && d <= 57343))
            return !1;
          p = 1024 * (p - 55296) + (d - 56320) + 65536;
        }
        if (!m(p))
          return !1;
        m = t.isIdentifierPartES6;
      }
      return !0;
    }
    e.exports = { isKeywordES5: n, isKeywordES6: r, isReservedWordES5: i, isReservedWordES6: a, isRestrictedWord: function(u) {
      return u === "eval" || u === "arguments";
    }, isIdentifierNameES5: s, isIdentifierNameES6: o, isIdentifierES5: function(u, c) {
      return s(u) && !i(u, c);
    }, isIdentifierES6: function(u, c) {
      return o(u) && !a(u, c);
    } };
  })();
})), Os = (Oi.isKeywordES5, Oi.isKeywordES6, Oi.isReservedWordES5, Oi.isReservedWordES6, Oi.isRestrictedWord, Oi.isIdentifierNameES5, Oi.isIdentifierNameES6, Oi.isIdentifierES5, Oi.isIdentifierES6, gt(function(e, t) {
  t.ast = wo, t.code = xi, t.keyword = Oi;
})), GP = (Os.ast, Os.code, Os.keyword, function(e) {
  return new Qa(e || zP, null);
}), Yt = 0, It = 1;
function Lr(e, t, n, r, i, a) {
  this._color = e, this.key = t, this.value = n, this.left = r, this.right = i, this._count = a;
}
function Li(e) {
  return new Lr(e._color, e.key, e.value, e.left, e.right, e._count);
}
function eo(e, t) {
  return new Lr(e, t.key, t.value, t.left, t.right, t._count);
}
function on(e) {
  e._count = 1 + (e.left ? e.left._count : 0) + (e.right ? e.right._count : 0);
}
function Qa(e, t) {
  this._compare = e, this.root = t;
}
var ur = Qa.prototype;
function n0(e, t) {
  var n;
  return t.left && (n = n0(e, t.left)) ? n : (n = e(t.key, t.value)) || (t.right ? n0(e, t.right) : void 0);
}
function r0(e, t, n, r) {
  if (t(e, r.key) <= 0) {
    var i;
    if (r.left && (i = r0(e, t, n, r.left)) || (i = n(r.key, r.value)))
      return i;
  }
  if (r.right)
    return r0(e, t, n, r.right);
}
function i0(e, t, n, r, i) {
  var a, s = n(e, i.key), o = n(t, i.key);
  if (s <= 0 && (i.left && (a = i0(e, t, n, r, i.left)) || o > 0 && (a = r(i.key, i.value))))
    return a;
  if (o > 0 && i.right)
    return i0(e, t, n, r, i.right);
}
function Or(e, t) {
  this.tree = e, this._stack = t;
}
Object.defineProperty(ur, "keys", { get: function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push(t);
  }), e;
} }), Object.defineProperty(ur, "values", { get: function() {
  var e = [];
  return this.forEach(function(t, n) {
    e.push(n);
  }), e;
} }), Object.defineProperty(ur, "length", { get: function() {
  return this.root ? this.root._count : 0;
} }), ur.insert = function(e, t) {
  for (var n = this._compare, r = this.root, i = [], a = []; r; ) {
    var s = n(e, r.key);
    i.push(r), a.push(s), r = s <= 0 ? r.left : r.right;
  }
  i.push(new Lr(Yt, e, t, null, null, 1));
  for (var o = i.length - 2; o >= 0; --o)
    r = i[o], a[o] <= 0 ? i[o] = new Lr(r._color, r.key, r.value, i[o + 1], r.right, r._count + 1) : i[o] = new Lr(r._color, r.key, r.value, r.left, i[o + 1], r._count + 1);
  for (o = i.length - 1; o > 1; --o) {
    var u = i[o - 1];
    if (r = i[o], u._color === It || r._color === It)
      break;
    var c = i[o - 2];
    if (c.left === u)
      if (u.left === r) {
        if (!(f = c.right) || f._color !== Yt) {
          c._color = Yt, c.left = u.right, u._color = It, u.right = c, i[o - 2] = u, i[o - 1] = r, on(c), on(u), o >= 3 && ((p = i[o - 3]).left === c ? p.left = u : p.right = u);
          break;
        }
        u._color = It, c.right = eo(It, f), c._color = Yt, o -= 1;
      } else {
        if (!(f = c.right) || f._color !== Yt) {
          u.right = r.left, c._color = Yt, c.left = r.right, r._color = It, r.left = u, r.right = c, i[o - 2] = r, i[o - 1] = u, on(c), on(u), on(r), o >= 3 && ((p = i[o - 3]).left === c ? p.left = r : p.right = r);
          break;
        }
        u._color = It, c.right = eo(It, f), c._color = Yt, o -= 1;
      }
    else if (u.right === r) {
      if (!(f = c.left) || f._color !== Yt) {
        c._color = Yt, c.right = u.left, u._color = It, u.left = c, i[o - 2] = u, i[o - 1] = r, on(c), on(u), o >= 3 && ((p = i[o - 3]).right === c ? p.right = u : p.left = u);
        break;
      }
      u._color = It, c.left = eo(It, f), c._color = Yt, o -= 1;
    } else {
      var f;
      if (!(f = c.left) || f._color !== Yt) {
        var p;
        u.left = r.right, c._color = Yt, c.right = r.left, r._color = It, r.right = u, r.left = c, i[o - 2] = r, i[o - 1] = u, on(c), on(u), on(r), o >= 3 && ((p = i[o - 3]).right === c ? p.right = r : p.left = r);
        break;
      }
      u._color = It, c.left = eo(It, f), c._color = Yt, o -= 1;
    }
  }
  return i[0]._color = It, new Qa(n, i[0]);
}, ur.forEach = function(e, t, n) {
  if (this.root)
    switch (arguments.length) {
      case 1:
        return n0(e, this.root);
      case 2:
        return r0(t, this._compare, e, this.root);
      case 3:
        return this._compare(t, n) >= 0 ? void 0 : i0(t, n, this._compare, e, this.root);
    }
}, Object.defineProperty(ur, "begin", { get: function() {
  for (var e = [], t = this.root; t; )
    e.push(t), t = t.left;
  return new Or(this, e);
} }), Object.defineProperty(ur, "end", { get: function() {
  for (var e = [], t = this.root; t; )
    e.push(t), t = t.right;
  return new Or(this, e);
} }), ur.at = function(e) {
  if (e < 0)
    return new Or(this, []);
  for (var t = this.root, n = []; ; ) {
    if (n.push(t), t.left) {
      if (e < t.left._count) {
        t = t.left;
        continue;
      }
      e -= t.left._count;
    }
    if (!e)
      return new Or(this, n);
    if (e -= 1, !t.right || e >= t.right._count)
      break;
    t = t.right;
  }
  return new Or(this, []);
}, ur.ge = function(e) {
  for (var t = this._compare, n = this.root, r = [], i = 0; n; ) {
    var a = t(e, n.key);
    r.push(n), a <= 0 && (i = r.length), n = a <= 0 ? n.left : n.right;
  }
  return r.length = i, new Or(this, r);
}, ur.gt = function(e) {
  for (var t = this._compare, n = this.root, r = [], i = 0; n; ) {
    var a = t(e, n.key);
    r.push(n), a < 0 && (i = r.length), n = a < 0 ? n.left : n.right;
  }
  return r.length = i, new Or(this, r);
}, ur.lt = function(e) {
  for (var t = this._compare, n = this.root, r = [], i = 0; n; ) {
    var a = t(e, n.key);
    r.push(n), a > 0 && (i = r.length), n = a <= 0 ? n.left : n.right;
  }
  return r.length = i, new Or(this, r);
}, ur.le = function(e) {
  for (var t = this._compare, n = this.root, r = [], i = 0; n; ) {
    var a = t(e, n.key);
    r.push(n), a >= 0 && (i = r.length), n = a < 0 ? n.left : n.right;
  }
  return r.length = i, new Or(this, r);
}, ur.find = function(e) {
  for (var t = this._compare, n = this.root, r = []; n; ) {
    var i = t(e, n.key);
    if (r.push(n), i === 0)
      return new Or(this, r);
    n = i <= 0 ? n.left : n.right;
  }
  return new Or(this, []);
}, ur.remove = function(e) {
  var t = this.find(e);
  return t ? t.remove() : this;
}, ur.get = function(e) {
  for (var t = this._compare, n = this.root; n; ) {
    var r = t(e, n.key);
    if (r === 0)
      return n.value;
    n = r <= 0 ? n.left : n.right;
  }
};
var Yr = Or.prototype;
function Ub(e, t) {
  e.key = t.key, e.value = t.value, e.left = t.left, e.right = t.right, e._color = t._color, e._count = t._count;
}
function zP(e, t) {
  return e < t ? -1 : e > t ? 1 : 0;
}
Object.defineProperty(Yr, "valid", { get: function() {
  return this._stack.length > 0;
} }), Object.defineProperty(Yr, "node", { get: function() {
  return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
}, enumerable: !0 }), Yr.clone = function() {
  return new Or(this.tree, this._stack.slice());
}, Yr.remove = function() {
  var e = this._stack;
  if (e.length === 0)
    return this.tree;
  var t = new Array(e.length), n = e[e.length - 1];
  t[t.length - 1] = new Lr(n._color, n.key, n.value, n.left, n.right, n._count);
  for (var r = e.length - 2; r >= 0; --r)
    (n = e[r]).left === e[r + 1] ? t[r] = new Lr(n._color, n.key, n.value, t[r + 1], n.right, n._count) : t[r] = new Lr(n._color, n.key, n.value, n.left, t[r + 1], n._count);
  if ((n = t[t.length - 1]).left && n.right) {
    var i = t.length;
    for (n = n.left; n.right; )
      t.push(n), n = n.right;
    var a = t[i - 1];
    for (t.push(new Lr(n._color, a.key, a.value, n.left, n.right, n._count)), t[i - 1].key = n.key, t[i - 1].value = n.value, r = t.length - 2; r >= i; --r)
      n = t[r], t[r] = new Lr(n._color, n.key, n.value, n.left, t[r + 1], n._count);
    t[i - 1].left = t[i];
  }
  if ((n = t[t.length - 1])._color === Yt) {
    var s = t[t.length - 2];
    for (s.left === n ? s.left = null : s.right === n && (s.right = null), t.pop(), r = 0; r < t.length; ++r)
      t[r]._count--;
    return new Qa(this.tree._compare, t[0]);
  }
  if (n.left || n.right) {
    for (n.left ? Ub(n, n.left) : n.right && Ub(n, n.right), n._color = It, r = 0; r < t.length - 1; ++r)
      t[r]._count--;
    return new Qa(this.tree._compare, t[0]);
  }
  if (t.length === 1)
    return new Qa(this.tree._compare, null);
  for (r = 0; r < t.length; ++r)
    t[r]._count--;
  var o = t[t.length - 2];
  return function(u) {
    for (var c, f, p, d, m = u.length - 1; m >= 0; --m) {
      if (c = u[m], m === 0)
        return void (c._color = It);
      if ((f = u[m - 1]).left === c) {
        if ((p = f.right).right && p.right._color === Yt)
          return d = (p = f.right = Li(p)).right = Li(p.right), f.right = p.left, p.left = f, p.right = d, p._color = f._color, c._color = It, f._color = It, d._color = It, on(f), on(p), m > 1 && ((y = u[m - 2]).left === f ? y.left = p : y.right = p), void (u[m - 1] = p);
        if (p.left && p.left._color === Yt)
          return d = (p = f.right = Li(p)).left = Li(p.left), f.right = d.left, p.left = d.right, d.left = f, d.right = p, d._color = f._color, f._color = It, p._color = It, c._color = It, on(f), on(p), on(d), m > 1 && ((y = u[m - 2]).left === f ? y.left = d : y.right = d), void (u[m - 1] = d);
        if (p._color === It) {
          if (f._color === Yt)
            return f._color = It, void (f.right = eo(Yt, p));
          f.right = eo(Yt, p);
          continue;
        }
        p = Li(p), f.right = p.left, p.left = f, p._color = f._color, f._color = Yt, on(f), on(p), m > 1 && ((y = u[m - 2]).left === f ? y.left = p : y.right = p), u[m - 1] = p, u[m] = f, m + 1 < u.length ? u[m + 1] = c : u.push(c), m += 2;
      } else {
        if ((p = f.left).left && p.left._color === Yt)
          return d = (p = f.left = Li(p)).left = Li(p.left), f.left = p.right, p.right = f, p.left = d, p._color = f._color, c._color = It, f._color = It, d._color = It, on(f), on(p), m > 1 && ((y = u[m - 2]).right === f ? y.right = p : y.left = p), void (u[m - 1] = p);
        if (p.right && p.right._color === Yt)
          return d = (p = f.left = Li(p)).right = Li(p.right), f.left = d.right, p.right = d.left, d.right = f, d.left = p, d._color = f._color, f._color = It, p._color = It, c._color = It, on(f), on(p), on(d), m > 1 && ((y = u[m - 2]).right === f ? y.right = d : y.left = d), void (u[m - 1] = d);
        if (p._color === It) {
          if (f._color === Yt)
            return f._color = It, void (f.left = eo(Yt, p));
          f.left = eo(Yt, p);
          continue;
        }
        var y;
        p = Li(p), f.left = p.right, p.right = f, p._color = f._color, f._color = Yt, on(f), on(p), m > 1 && ((y = u[m - 2]).right === f ? y.right = p : y.left = p), u[m - 1] = p, u[m] = f, m + 1 < u.length ? u[m + 1] = c : u.push(c), m += 2;
      }
    }
  }(t), o.left === n ? o.left = null : o.right = null, new Qa(this.tree._compare, t[0]);
}, Object.defineProperty(Yr, "key", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].key;
}, enumerable: !0 }), Object.defineProperty(Yr, "value", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].value;
}, enumerable: !0 }), Object.defineProperty(Yr, "index", { get: function() {
  var e = 0, t = this._stack;
  if (t.length === 0) {
    var n = this.tree.root;
    return n ? n._count : 0;
  }
  t[t.length - 1].left && (e = t[t.length - 1].left._count);
  for (var r = t.length - 2; r >= 0; --r)
    t[r + 1] === t[r].right && (++e, t[r].left && (e += t[r].left._count));
  return e;
}, enumerable: !0 }), Yr.next = function() {
  var e = this._stack;
  if (e.length !== 0) {
    var t = e[e.length - 1];
    if (t.right)
      for (t = t.right; t; )
        e.push(t), t = t.left;
    else
      for (e.pop(); e.length > 0 && e[e.length - 1].right === t; )
        t = e[e.length - 1], e.pop();
  }
}, Object.defineProperty(Yr, "hasNext", { get: function() {
  var e = this._stack;
  if (e.length === 0)
    return !1;
  if (e[e.length - 1].right)
    return !0;
  for (var t = e.length - 1; t > 0; --t)
    if (e[t - 1].left === e[t])
      return !0;
  return !1;
} }), Yr.update = function(e) {
  var t = this._stack;
  if (t.length === 0)
    throw new Error("Can't update empty node!");
  var n = new Array(t.length), r = t[t.length - 1];
  n[n.length - 1] = new Lr(r._color, r.key, e, r.left, r.right, r._count);
  for (var i = t.length - 2; i >= 0; --i)
    (r = t[i]).left === t[i + 1] ? n[i] = new Lr(r._color, r.key, r.value, n[i + 1], r.right, r._count) : n[i] = new Lr(r._color, r.key, r.value, r.left, n[i + 1], r._count);
  return new Qa(this.tree._compare, n[0]);
}, Yr.prev = function() {
  var e = this._stack;
  if (e.length !== 0) {
    var t = e[e.length - 1];
    if (t.left)
      for (t = t.left; t; )
        e.push(t), t = t.right;
    else
      for (e.pop(); e.length > 0 && e[e.length - 1].left === t; )
        t = e[e.length - 1], e.pop();
  }
}, Object.defineProperty(Yr, "hasPrev", { get: function() {
  var e = this._stack;
  if (e.length === 0)
    return !1;
  if (e[e.length - 1].left)
    return !0;
  for (var t = e.length - 1; t > 0; --t)
    if (e[t - 1].right === e[t])
      return !0;
  return !1;
} });
var HP = Object.freeze({});
function qb(e) {
  return !(e < 48) && (e < 58 || !(e < 65) && (e < 91 || e === 95 || !(e < 97) && (e < 123 || sA(e) || function(t) {
    return t < 7376 ? t < 3458 ? t < 2691 ? t < 2363 ? t < 1770 ? t < 1479 ? t === 183 || !(t < 768) && (t < 880 || t === 903 || !(t < 1155) && (t < 1160 || !(t < 1425) && (t < 1470 || t === 1471 || !(t < 1473) && (t < 1475 || !(t < 1476) && t < 1478)))) : t === 1479 || !(t < 1552) && (t < 1563 || !(t < 1611) && (t < 1632 || !(t < 1632) && (t < 1642 || t === 1648 || !(t < 1750) && (t < 1757 || !(t < 1759) && (t < 1765 || !(t < 1767) && t < 1769))))) : t < 2070 ? !(t < 1770) && (t < 1774 || !(t < 1776) && (t < 1786 || t === 1809 || !(t < 1840) && (t < 1867 || !(t < 1958) && (t < 1969 || !(t < 1984) && (t < 1994 || !(t < 2027) && (t < 2036 || t === 2045)))))) : t < 2074 || !(t < 2075) && (t < 2084 || !(t < 2085) && (t < 2088 || !(t < 2089) && (t < 2094 || !(t < 2137) && (t < 2140 || !(t < 2259) && (t < 2274 || !(t < 2275) && (t < 2307 || t === 2307 || t === 2362)))))) : t < 2509 ? t < 2402 ? t === 2363 || t === 2364 || !(t < 2366) && (t < 2369 || !(t < 2369) && (t < 2377 || !(t < 2377) && (t < 2381 || t === 2381 || !(t < 2382) && (t < 2384 || !(t < 2385) && t < 2392)))) : t < 2404 || !(t < 2406) && (t < 2416 || t === 2433 || !(t < 2434) && (t < 2436 || t === 2492 || !(t < 2494) && (t < 2497 || !(t < 2497) && (t < 2501 || !(t < 2503) && (t < 2505 || !(t < 2507) && t < 2509))))) : t < 2622 ? t === 2509 || t === 2519 || !(t < 2530) && (t < 2532 || !(t < 2534) && (t < 2544 || t === 2558 || !(t < 2561) && (t < 2563 || t === 2563 || t === 2620))) : t < 2625 || !(t < 2625) && (t < 2627 || !(t < 2631) && (t < 2633 || !(t < 2635) && (t < 2638 || t === 2641 || !(t < 2662) && (t < 2672 || !(t < 2672) && (t < 2674 || t === 2677 || !(t < 2689) && t < 2691))))) : t < 3072 ? t < 2881 ? t < 2786 ? t === 2691 || t === 2748 || !(t < 2750) && (t < 2753 || !(t < 2753) && (t < 2758 || !(t < 2759) && (t < 2761 || t === 2761 || !(t < 2763) && (t < 2765 || t === 2765)))) : t < 2788 || !(t < 2790) && (t < 2800 || !(t < 2810) && (t < 2816 || t === 2817 || !(t < 2818) && (t < 2820 || t === 2876 || t === 2878 || t === 2879 || t === 2880))) : t < 2946 ? !(t < 2881) && (t < 2885 || !(t < 2887) && (t < 2889 || !(t < 2891) && (t < 2893 || t === 2893 || t === 2902 || t === 2903 || !(t < 2914) && (t < 2916 || !(t < 2918) && t < 2928)))) : t === 2946 || !(t < 3006) && (t < 3008 || t === 3008 || !(t < 3009) && (t < 3011 || !(t < 3014) && (t < 3017 || !(t < 3018) && (t < 3021 || t === 3021 || t === 3031 || !(t < 3046) && t < 3056)))) : t < 3271 ? t < 3170 ? t === 3072 || !(t < 3073) && (t < 3076 || t === 3076 || !(t < 3134) && (t < 3137 || !(t < 3137) && (t < 3141 || !(t < 3142) && (t < 3145 || !(t < 3146) && (t < 3150 || !(t < 3157) && t < 3159))))) : t < 3172 || !(t < 3174) && (t < 3184 || t === 3201 || !(t < 3202) && (t < 3204 || t === 3260 || t === 3262 || t === 3263 || !(t < 3264) && (t < 3269 || t === 3270))) : t < 3387 ? !(t < 3271) && (t < 3273 || !(t < 3274) && (t < 3276 || !(t < 3276) && (t < 3278 || !(t < 3285) && (t < 3287 || !(t < 3298) && (t < 3300 || !(t < 3302) && (t < 3312 || !(t < 3328) && (t < 3330 || !(t < 3330) && t < 3332))))))) : t < 3389 || !(t < 3390) && (t < 3393 || !(t < 3393) && (t < 3397 || !(t < 3398) && (t < 3401 || !(t < 3402) && (t < 3405 || t === 3405 || t === 3415 || !(t < 3426) && (t < 3428 || !(t < 3430) && t < 3440))))) : t < 6112 ? t < 4152 ? t < 3864 ? t < 3633 ? !(t < 3458) && (t < 3460 || t === 3530 || !(t < 3535) && (t < 3538 || !(t < 3538) && (t < 3541 || t === 3542 || !(t < 3544) && (t < 3552 || !(t < 3558) && (t < 3568 || !(t < 3570) && t < 3572))))) : t === 3633 || !(t < 3636) && (t < 3643 || !(t < 3655) && (t < 3663 || !(t < 3664) && (t < 3674 || t === 3761 || !(t < 3764) && (t < 3770 || !(t < 3771) && (t < 3773 || !(t < 3784) && (t < 3790 || !(t < 3792) && t < 3802)))))) : t < 3968 ? !(t < 3864) && (t < 3866 || !(t < 3872) && (t < 3882 || t === 3893 || t === 3895 || t === 3897 || !(t < 3902) && (t < 3904 || !(t < 3953) && (t < 3967 || t === 3967)))) : t < 3973 || !(t < 3974) && (t < 3976 || !(t < 3981) && (t < 3992 || !(t < 3993) && (t < 4029 || t === 4038 || !(t < 4139) && (t < 4141 || !(t < 4141) && (t < 4145 || t === 4145 || !(t < 4146) && t < 4152))))) : t < 4240 ? t < 4194 ? t === 4152 || !(t < 4153) && (t < 4155 || !(t < 4155) && (t < 4157 || !(t < 4157) && (t < 4159 || !(t < 4160) && (t < 4170 || !(t < 4182) && (t < 4184 || !(t < 4184) && (t < 4186 || !(t < 4190) && t < 4193)))))) : t < 4197 || !(t < 4199) && (t < 4206 || !(t < 4209) && (t < 4213 || t === 4226 || !(t < 4227) && (t < 4229 || !(t < 4229) && (t < 4231 || !(t < 4231) && (t < 4237 || t === 4237 || t === 4239))))) : t < 6002 ? !(t < 4240) && (t < 4250 || !(t < 4250) && (t < 4253 || t === 4253 || !(t < 4957) && (t < 4960 || !(t < 4969) && (t < 4978 || !(t < 5906) && (t < 5909 || !(t < 5938) && (t < 5941 || !(t < 5970) && t < 5972)))))) : t < 6004 || !(t < 6068) && (t < 6070 || t === 6070 || !(t < 6071) && (t < 6078 || !(t < 6078) && (t < 6086 || t === 6086 || !(t < 6087) && (t < 6089 || !(t < 6089) && (t < 6100 || t === 6109))))) : t < 6916 ? t < 6683 ? t < 6448 ? !(t < 6112) && (t < 6122 || !(t < 6155) && (t < 6158 || !(t < 6160) && (t < 6170 || t === 6313 || !(t < 6432) && (t < 6435 || !(t < 6435) && (t < 6439 || !(t < 6439) && (t < 6441 || !(t < 6441) && t < 6444)))))) : t < 6450 || t === 6450 || !(t < 6451) && (t < 6457 || !(t < 6457) && (t < 6460 || !(t < 6470) && (t < 6480 || !(t < 6608) && (t < 6618 || t === 6618 || !(t < 6679) && (t < 6681 || !(t < 6681) && t < 6683))))) : t < 6755 ? t === 6683 || t === 6741 || t === 6742 || t === 6743 || !(t < 6744) && (t < 6751 || t === 6752 || t === 6753 || t === 6754) : t < 6757 || !(t < 6757) && (t < 6765 || !(t < 6765) && (t < 6771 || !(t < 6771) && (t < 6781 || t === 6783 || !(t < 6784) && (t < 6794 || !(t < 6800) && (t < 6810 || !(t < 6832) && (t < 6846 || !(t < 6912) && t < 6916)))))) : t < 7082 ? t < 6979 ? t === 6916 || t === 6964 || t === 6965 || !(t < 6966) && (t < 6971 || t === 6971 || t === 6972 || !(t < 6973) && (t < 6978 || t === 6978)) : t < 6981 || !(t < 6992) && (t < 7002 || !(t < 7019) && (t < 7028 || !(t < 7040) && (t < 7042 || t === 7042 || t === 7073 || !(t < 7074) && (t < 7078 || !(t < 7078) && (t < 7080 || !(t < 7080) && t < 7082))))) : t < 7150 ? t === 7082 || !(t < 7083) && (t < 7086 || !(t < 7088) && (t < 7098 || t === 7142 || t === 7143 || !(t < 7144) && (t < 7146 || !(t < 7146) && (t < 7149 || t === 7149)))) : t === 7150 || !(t < 7151) && (t < 7154 || !(t < 7154) && (t < 7156 || !(t < 7204) && (t < 7212 || !(t < 7212) && (t < 7220 || !(t < 7220) && (t < 7222 || !(t < 7222) && (t < 7224 || !(t < 7232) && (t < 7242 || !(t < 7248) && t < 7258))))))) : t < 70206 ? t < 43703 ? t < 43188 ? t < 11647 ? t < 7416 ? !(t < 7376) && (t < 7379 || !(t < 7380) && (t < 7393 || t === 7393 || !(t < 7394) && (t < 7401 || t === 7405 || !(t < 7410) && (t < 7412 || t === 7412 || t === 7415)))) : t < 7418 || !(t < 7616) && (t < 7674 || !(t < 7675) && (t < 7680 || !(t < 8255) && (t < 8257 || t === 8276 || !(t < 8400) && (t < 8413 || t === 8417 || !(t < 8421) && (t < 8433 || !(t < 11503) && t < 11506))))) : t < 42654 ? t === 11647 || !(t < 11744) && (t < 11776 || !(t < 12330) && (t < 12334 || !(t < 12334) && (t < 12336 || !(t < 12441) && (t < 12443 || !(t < 42528) && (t < 42538 || t === 42607 || !(t < 42612) && t < 42622))))) : t < 42656 || !(t < 42736) && (t < 42738 || t === 43010 || t === 43014 || t === 43019 || !(t < 43043) && (t < 43045 || !(t < 43045) && (t < 43047 || t === 43047 || !(t < 43136) && t < 43138))) : t < 43472 ? t < 43346 ? !(t < 43188) && (t < 43204 || !(t < 43204) && (t < 43206 || !(t < 43216) && (t < 43226 || !(t < 43232) && (t < 43250 || t === 43263 || !(t < 43264) && (t < 43274 || !(t < 43302) && (t < 43310 || !(t < 43335) && t < 43346)))))) : t < 43348 || !(t < 43392) && (t < 43395 || t === 43395 || t === 43443 || !(t < 43444) && (t < 43446 || !(t < 43446) && (t < 43450 || !(t < 43450) && (t < 43452 || t === 43452 || !(t < 43453) && t < 43457)))) : t < 43587 ? !(t < 43472) && (t < 43482 || t === 43493 || !(t < 43504) && (t < 43514 || !(t < 43561) && (t < 43567 || !(t < 43567) && (t < 43569 || !(t < 43569) && (t < 43571 || !(t < 43571) && (t < 43573 || !(t < 43573) && t < 43575)))))) : t === 43587 || t === 43596 || t === 43597 || !(t < 43600) && (t < 43610 || t === 43643 || t === 43644 || t === 43645 || t === 43696 || !(t < 43698) && t < 43701) : t < 68912 ? t < 65024 ? t < 44003 ? !(t < 43703) && (t < 43705 || !(t < 43710) && (t < 43712 || t === 43713 || t === 43755 || !(t < 43756) && (t < 43758 || !(t < 43758) && (t < 43760 || t === 43765 || t === 43766)))) : t < 44005 || t === 44005 || !(t < 44006) && (t < 44008 || t === 44008 || !(t < 44009) && (t < 44011 || t === 44012 || t === 44013 || !(t < 44016) && (t < 44026 || t === 64286))) : t < 66422 ? !(t < 65024) && (t < 65040 || !(t < 65056) && (t < 65072 || !(t < 65075) && (t < 65077 || !(t < 65101) && (t < 65104 || !(t < 65296) && (t < 65306 || t === 65343 || t === 66045 || t === 66272))))) : t < 66427 || !(t < 66720) && (t < 66730 || !(t < 68097) && (t < 68100 || !(t < 68101) && (t < 68103 || !(t < 68108) && (t < 68112 || !(t < 68152) && (t < 68155 || t === 68159 || !(t < 68325) && (t < 68327 || !(t < 68900) && t < 68904)))))) : t < 69933 ? t < 69762 ? !(t < 68912) && (t < 68922 || !(t < 69446) && (t < 69457 || t === 69632 || t === 69633 || t === 69634 || !(t < 69688) && (t < 69703 || !(t < 69734) && (t < 69744 || !(t < 69759) && t < 69762)))) : t === 69762 || !(t < 69808) && (t < 69811 || !(t < 69811) && (t < 69815 || !(t < 69815) && (t < 69817 || !(t < 69817) && (t < 69819 || !(t < 69872) && (t < 69882 || !(t < 69888) && (t < 69891 || !(t < 69927) && (t < 69932 || t === 69932))))))) : t < 70079 ? !(t < 69933) && (t < 69941 || !(t < 69942) && (t < 69952 || !(t < 69957) && (t < 69959 || t === 70003 || !(t < 70016) && (t < 70018 || t === 70018 || !(t < 70067) && (t < 70070 || !(t < 70070) && t < 70079))))) : t < 70081 || !(t < 70089) && (t < 70093 || !(t < 70096) && (t < 70106 || !(t < 70188) && (t < 70191 || !(t < 70191) && (t < 70194 || !(t < 70194) && (t < 70196 || t === 70196 || t === 70197 || !(t < 70198) && t < 70200))))) : t < 72243 ? t < 71087 ? t < 70709 ? t < 70462 ? t === 70206 || t === 70367 || !(t < 70368) && (t < 70371 || !(t < 70371) && (t < 70379 || !(t < 70384) && (t < 70394 || !(t < 70400) && (t < 70402 || !(t < 70402) && (t < 70404 || !(t < 70459) && t < 70461))))) : t < 70464 || t === 70464 || !(t < 70465) && (t < 70469 || !(t < 70471) && (t < 70473 || !(t < 70475) && (t < 70478 || t === 70487 || !(t < 70498) && (t < 70500 || !(t < 70502) && (t < 70509 || !(t < 70512) && t < 70517))))) : t < 70832 ? !(t < 70709) && (t < 70712 || !(t < 70712) && (t < 70720 || !(t < 70720) && (t < 70722 || !(t < 70722) && (t < 70725 || t === 70725 || t === 70726 || !(t < 70736) && (t < 70746 || t === 70750))))) : t < 70835 || !(t < 70835) && (t < 70841 || t === 70841 || t === 70842 || !(t < 70843) && (t < 70847 || !(t < 70847) && (t < 70849 || t === 70849 || !(t < 70850) && (t < 70852 || !(t < 70864) && t < 70874)))) : t < 71342 ? t < 71219 ? !(t < 71087) && (t < 71090 || !(t < 71090) && (t < 71094 || !(t < 71096) && (t < 71100 || !(t < 71100) && (t < 71102 || t === 71102 || !(t < 71103) && (t < 71105 || !(t < 71132) && (t < 71134 || !(t < 71216) && t < 71219)))))) : t < 71227 || !(t < 71227) && (t < 71229 || t === 71229 || t === 71230 || !(t < 71231) && (t < 71233 || !(t < 71248) && (t < 71258 || t === 71339 || t === 71340 || t === 71341))) : t < 71462 ? !(t < 71342) && (t < 71344 || !(t < 71344) && (t < 71350 || t === 71350 || t === 71351 || !(t < 71360) && (t < 71370 || !(t < 71453) && (t < 71456 || !(t < 71456) && (t < 71458 || !(t < 71458) && t < 71462))))) : t === 71462 || !(t < 71463) && (t < 71468 || !(t < 71472) && (t < 71482 || !(t < 71724) && (t < 71727 || !(t < 71727) && (t < 71736 || t === 71736 || !(t < 71737) && (t < 71739 || !(t < 71904) && (t < 71914 || !(t < 72193) && t < 72203)))))) : t < 73111 ? t < 72873 ? t < 72343 ? !(t < 72243) && (t < 72249 || t === 72249 || !(t < 72251) && (t < 72255 || t === 72263 || !(t < 72273) && (t < 72279 || !(t < 72279) && (t < 72281 || !(t < 72281) && (t < 72284 || !(t < 72330) && t < 72343))))) : t === 72343 || !(t < 72344) && (t < 72346 || t === 72751 || !(t < 72752) && (t < 72759 || !(t < 72760) && (t < 72766 || t === 72766 || t === 72767 || !(t < 72784) && (t < 72794 || !(t < 72850) && t < 72872)))) : t < 73020 ? t === 72873 || !(t < 72874) && (t < 72881 || t === 72881 || !(t < 72882) && (t < 72884 || t === 72884 || !(t < 72885) && (t < 72887 || !(t < 73009) && (t < 73015 || t === 73018)))) : t < 73022 || !(t < 73023) && (t < 73030 || t === 73031 || !(t < 73040) && (t < 73050 || !(t < 73098) && (t < 73103 || !(t < 73104) && (t < 73106 || !(t < 73107) && (t < 73109 || t === 73109 || t === 73110))))) : t < 119362 ? t < 94033 ? t === 73111 || !(t < 73120) && (t < 73130 || !(t < 73459) && (t < 73461 || !(t < 73461) && (t < 73463 || !(t < 92768) && (t < 92778 || !(t < 92912) && (t < 92917 || !(t < 92976) && (t < 92983 || !(t < 93008) && t < 93018)))))) : t < 94079 || !(t < 94095) && (t < 94099 || !(t < 113821) && (t < 113823 || !(t < 119141) && (t < 119143 || !(t < 119143) && (t < 119146 || !(t < 119149) && (t < 119155 || !(t < 119163) && (t < 119171 || !(t < 119173) && (t < 119180 || !(t < 119210) && t < 119214))))))) : t < 122880 ? !(t < 119362) && (t < 119365 || !(t < 120782) && (t < 120832 || !(t < 121344) && (t < 121399 || !(t < 121403) && (t < 121453 || t === 121461 || t === 121476 || !(t < 121499) && (t < 121504 || !(t < 121505) && t < 121520))))) : t < 122887 || !(t < 122888) && (t < 122905 || !(t < 122907) && (t < 122914 || !(t < 122915) && (t < 122917 || !(t < 122918) && (t < 122923 || !(t < 125136) && (t < 125143 || !(t < 125252) && (t < 125259 || !(t < 125264) && (t < 125274 || !(t < 917760) && t < 918e3)))))));
  }(e))));
}
function sA(e) {
  return e < 12449 ? e < 3776 ? e < 2613 ? e < 1765 ? e < 890 ? e < 660 ? e < 248 ? e === 170 || e === 181 || e === 186 || !(e < 192) && (e < 215 || !(e < 216) && e < 247) : e < 443 || e === 443 || !(e < 444) && (e < 448 || !(e < 448) && (e < 452 || !(e < 452) && e < 660)) : e < 748 ? e === 660 || !(e < 661) && (e < 688 || !(e < 688) && (e < 706 || !(e < 710) && (e < 722 || !(e < 736) && e < 741))) : e === 748 || e === 750 || !(e < 880) && (e < 884 || e === 884 || !(e < 886) && e < 888) : e < 1329 ? e < 908 ? e === 890 || !(e < 891) && (e < 894 || e === 895 || e === 902 || !(e < 904) && e < 907) : e === 908 || !(e < 910) && (e < 930 || !(e < 931) && (e < 1014 || !(e < 1015) && (e < 1154 || !(e < 1162) && e < 1328))) : e < 1568 ? !(e < 1329) && (e < 1367 || e === 1369 || !(e < 1376) && (e < 1417 || !(e < 1488) && (e < 1515 || !(e < 1519) && e < 1523))) : e < 1600 || e === 1600 || !(e < 1601) && (e < 1611 || !(e < 1646) && (e < 1648 || !(e < 1649) && (e < 1748 || e === 1749))) : e < 2384 ? e < 2042 ? e < 1810 ? !(e < 1765) && (e < 1767 || !(e < 1774) && (e < 1776 || !(e < 1786) && (e < 1789 || e === 1791 || e === 1808))) : e < 1840 || !(e < 1869) && (e < 1958 || e === 1969 || !(e < 1994) && (e < 2027 || !(e < 2036) && e < 2038)) : e < 2112 ? e === 2042 || !(e < 2048) && (e < 2070 || e === 2074 || e === 2084 || e === 2088) : e < 2137 || !(e < 2144) && (e < 2155 || !(e < 2208) && (e < 2229 || !(e < 2230) && (e < 2238 || !(e < 2308) && (e < 2362 || e === 2365)))) : e < 2493 ? e < 2447 ? e === 2384 || !(e < 2392) && (e < 2402 || e === 2417 || !(e < 2418) && (e < 2433 || !(e < 2437) && e < 2445)) : e < 2449 || !(e < 2451) && (e < 2473 || !(e < 2474) && (e < 2481 || e === 2482 || !(e < 2486) && e < 2490)) : e < 2556 ? e === 2493 || e === 2510 || !(e < 2524) && (e < 2526 || !(e < 2527) && (e < 2530 || !(e < 2544) && e < 2546)) : e === 2556 || !(e < 2565) && (e < 2571 || !(e < 2575) && (e < 2577 || !(e < 2579) && (e < 2601 || !(e < 2602) && (e < 2609 || !(e < 2610) && e < 2612)))) : e < 3168 ? e < 2877 ? e < 2741 ? e < 2693 ? !(e < 2613) && (e < 2615 || !(e < 2616) && (e < 2618 || !(e < 2649) && (e < 2653 || e === 2654 || !(e < 2674) && e < 2677))) : e < 2702 || !(e < 2703) && (e < 2706 || !(e < 2707) && (e < 2729 || !(e < 2730) && (e < 2737 || !(e < 2738) && e < 2740))) : e < 2821 ? !(e < 2741) && (e < 2746 || e === 2749 || e === 2768 || !(e < 2784) && (e < 2786 || e === 2809)) : e < 2829 || !(e < 2831) && (e < 2833 || !(e < 2835) && (e < 2857 || !(e < 2858) && (e < 2865 || !(e < 2866) && (e < 2868 || !(e < 2869) && e < 2874)))) : e < 2974 ? e < 2949 ? e === 2877 || !(e < 2908) && (e < 2910 || !(e < 2911) && (e < 2914 || e === 2929 || e === 2947)) : e < 2955 || !(e < 2958) && (e < 2961 || !(e < 2962) && (e < 2966 || !(e < 2969) && (e < 2971 || e === 2972))) : e < 3077 ? !(e < 2974) && (e < 2976 || !(e < 2979) && (e < 2981 || !(e < 2984) && (e < 2987 || !(e < 2990) && (e < 3002 || e === 3024)))) : e < 3085 || !(e < 3086) && (e < 3089 || !(e < 3090) && (e < 3113 || !(e < 3114) && (e < 3130 || e === 3133 || !(e < 3160) && e < 3163))) : e < 3507 ? e < 3313 ? e < 3242 ? !(e < 3168) && (e < 3170 || e === 3200 || !(e < 3205) && (e < 3213 || !(e < 3214) && (e < 3217 || !(e < 3218) && e < 3241))) : e < 3252 || !(e < 3253) && (e < 3258 || e === 3261 || e === 3294 || !(e < 3296) && e < 3298) : e < 3406 ? !(e < 3313) && (e < 3315 || !(e < 3333) && (e < 3341 || !(e < 3342) && (e < 3345 || !(e < 3346) && (e < 3387 || e === 3389)))) : e === 3406 || !(e < 3412) && (e < 3415 || !(e < 3423) && (e < 3426 || !(e < 3450) && (e < 3456 || !(e < 3461) && (e < 3479 || !(e < 3482) && e < 3506)))) : e < 3722 ? e < 3648 ? !(e < 3507) && (e < 3516 || e === 3517 || !(e < 3520) && (e < 3527 || !(e < 3585) && (e < 3633 || !(e < 3634) && e < 3636))) : e < 3654 || e === 3654 || !(e < 3713) && (e < 3715 || e === 3716 || !(e < 3719) && e < 3721) : e < 3749 ? e === 3722 || e === 3725 || !(e < 3732) && (e < 3736 || !(e < 3737) && (e < 3744 || !(e < 3745) && e < 3748)) : e === 3749 || e === 3751 || !(e < 3754) && (e < 3756 || !(e < 3757) && (e < 3761 || !(e < 3762) && (e < 3764 || e === 3773))) : e < 7401 ? e < 5743 ? e < 4349 ? e < 4186 ? e < 3913 ? !(e < 3776) && (e < 3781 || e === 3782 || !(e < 3804) && (e < 3808 || e === 3840 || !(e < 3904) && e < 3912)) : e < 3949 || !(e < 3976) && (e < 3981 || !(e < 4096) && (e < 4139 || e === 4159 || !(e < 4176) && e < 4182)) : e < 4238 ? !(e < 4186) && (e < 4190 || e === 4193 || !(e < 4197) && (e < 4199 || !(e < 4206) && (e < 4209 || !(e < 4213) && e < 4226))) : e === 4238 || !(e < 4256) && (e < 4294 || e === 4295 || e === 4301 || !(e < 4304) && (e < 4347 || e === 4348)) : e < 4792 ? e < 4698 ? !(e < 4349) && (e < 4352 || !(e < 4352) && (e < 4681 || !(e < 4682) && (e < 4686 || !(e < 4688) && (e < 4695 || e === 4696)))) : e < 4702 || !(e < 4704) && (e < 4745 || !(e < 4746) && (e < 4750 || !(e < 4752) && (e < 4785 || !(e < 4786) && e < 4790))) : e < 4882 ? !(e < 4792) && (e < 4799 || e === 4800 || !(e < 4802) && (e < 4806 || !(e < 4808) && (e < 4823 || !(e < 4824) && e < 4881))) : e < 4886 || !(e < 4888) && (e < 4955 || !(e < 4992) && (e < 5008 || !(e < 5024) && (e < 5110 || !(e < 5112) && (e < 5118 || !(e < 5121) && e < 5741)))) : e < 6320 ? e < 5998 ? e < 5888 ? !(e < 5743) && (e < 5760 || !(e < 5761) && (e < 5787 || !(e < 5792) && (e < 5867 || !(e < 5870) && (e < 5873 || !(e < 5873) && e < 5881)))) : e < 5901 || !(e < 5902) && (e < 5906 || !(e < 5920) && (e < 5938 || !(e < 5952) && (e < 5970 || !(e < 5984) && e < 5997))) : e < 6211 ? !(e < 5998) && (e < 6001 || !(e < 6016) && (e < 6068 || e === 6103 || e === 6108 || !(e < 6176) && e < 6211)) : e === 6211 || !(e < 6212) && (e < 6265 || !(e < 6272) && (e < 6277 || !(e < 6277) && (e < 6279 || !(e < 6279) && (e < 6313 || e === 6314)))) : e < 6981 ? e < 6576 ? !(e < 6320) && (e < 6390 || !(e < 6400) && (e < 6431 || !(e < 6480) && (e < 6510 || !(e < 6512) && (e < 6517 || !(e < 6528) && e < 6572)))) : e < 6602 || !(e < 6656) && (e < 6679 || !(e < 6688) && (e < 6741 || e === 6823 || !(e < 6917) && e < 6964)) : e < 7245 ? !(e < 6981) && (e < 6988 || !(e < 7043) && (e < 7073 || !(e < 7086) && (e < 7088 || !(e < 7098) && (e < 7142 || !(e < 7168) && e < 7204)))) : e < 7248 || !(e < 7258) && (e < 7288 || !(e < 7288) && (e < 7294 || !(e < 7296) && (e < 7305 || !(e < 7312) && (e < 7355 || !(e < 7357) && e < 7360)))) : e < 8495 ? e < 8130 ? e < 7960 ? e < 7531 ? !(e < 7401) && (e < 7405 || !(e < 7406) && (e < 7410 || !(e < 7413) && (e < 7415 || !(e < 7424) && (e < 7468 || !(e < 7468) && e < 7531)))) : e < 7544 || e === 7544 || !(e < 7545) && (e < 7579 || !(e < 7579) && (e < 7616 || !(e < 7680) && e < 7958)) : e < 8027 ? !(e < 7960) && (e < 7966 || !(e < 7968) && (e < 8006 || !(e < 8008) && (e < 8014 || !(e < 8016) && (e < 8024 || e === 8025)))) : e === 8027 || e === 8029 || !(e < 8031) && (e < 8062 || !(e < 8064) && (e < 8117 || !(e < 8118) && (e < 8125 || e === 8126))) : e < 8450 ? e < 8178 ? !(e < 8130) && (e < 8133 || !(e < 8134) && (e < 8141 || !(e < 8144) && (e < 8148 || !(e < 8150) && (e < 8156 || !(e < 8160) && e < 8173)))) : e < 8181 || !(e < 8182) && (e < 8189 || e === 8305 || e === 8319 || !(e < 8336) && e < 8349) : e < 8473 ? e === 8450 || e === 8455 || !(e < 8458) && (e < 8468 || e === 8469 || e === 8472) : e < 8478 || e === 8484 || e === 8486 || e === 8488 || !(e < 8490) && (e < 8494 || e === 8494) : e < 11648 ? e < 11312 ? e < 8526 ? !(e < 8495) && (e < 8501 || !(e < 8501) && (e < 8505 || e === 8505 || !(e < 8508) && (e < 8512 || !(e < 8517) && e < 8522))) : e === 8526 || !(e < 8544) && (e < 8579 || !(e < 8579) && (e < 8581 || !(e < 8581) && (e < 8585 || !(e < 11264) && e < 11311))) : e < 11506 ? !(e < 11312) && (e < 11359 || !(e < 11360) && (e < 11388 || !(e < 11388) && (e < 11390 || !(e < 11390) && (e < 11493 || !(e < 11499) && e < 11503)))) : e < 11508 || !(e < 11520) && (e < 11558 || e === 11559 || e === 11565 || !(e < 11568) && (e < 11624 || e === 11631)) : e < 12294 ? e < 11712 ? !(e < 11648) && (e < 11671 || !(e < 11680) && (e < 11687 || !(e < 11688) && (e < 11695 || !(e < 11696) && (e < 11703 || !(e < 11704) && e < 11711)))) : e < 11719 || !(e < 11720) && (e < 11727 || !(e < 11728) && (e < 11735 || !(e < 11736) && (e < 11743 || e === 12293))) : e < 12347 ? e === 12294 || e === 12295 || !(e < 12321) && (e < 12330 || !(e < 12337) && (e < 12342 || !(e < 12344) && e < 12347)) : e === 12347 || e === 12348 || !(e < 12353) && (e < 12439 || !(e < 12443) && (e < 12445 || !(e < 12445) && (e < 12447 || e === 12447))) : e < 68448 ? e < 55216 ? e < 43138 ? e < 42623 ? e < 40981 ? e < 12704 ? !(e < 12449) && (e < 12539 || !(e < 12540) && (e < 12543 || e === 12543 || !(e < 12549) && (e < 12592 || !(e < 12593) && e < 12687))) : e < 12731 || !(e < 12784) && (e < 12800 || !(e < 13312) && (e < 19894 || !(e < 19968) && (e < 40944 || !(e < 40960) && e < 40981))) : e < 42508 ? e === 40981 || !(e < 40982) && (e < 42125 || !(e < 42192) && (e < 42232 || !(e < 42232) && (e < 42238 || !(e < 42240) && e < 42508))) : e === 42508 || !(e < 42512) && (e < 42528 || !(e < 42538) && (e < 42540 || !(e < 42560) && (e < 42606 || e === 42606))) : e < 42891 ? e < 42775 ? e === 42623 || !(e < 42624) && (e < 42652 || !(e < 42652) && (e < 42654 || !(e < 42656) && (e < 42726 || !(e < 42726) && e < 42736))) : e < 42784 || !(e < 42786) && (e < 42864 || e === 42864 || !(e < 42865) && (e < 42888 || e === 42888)) : e < 43002 ? !(e < 42891) && (e < 42895 || e === 42895 || !(e < 42896) && (e < 42938 || e === 42999 || !(e < 43e3) && e < 43002)) : e === 43002 || !(e < 43003) && (e < 43010 || !(e < 43011) && (e < 43014 || !(e < 43015) && (e < 43019 || !(e < 43020) && (e < 43043 || !(e < 43072) && e < 43124)))) : e < 43697 ? e < 43494 ? e < 43312 ? !(e < 43138) && (e < 43188 || !(e < 43250) && (e < 43256 || e === 43259 || !(e < 43261) && (e < 43263 || !(e < 43274) && e < 43302))) : e < 43335 || !(e < 43360) && (e < 43389 || !(e < 43396) && (e < 43443 || e === 43471 || !(e < 43488) && e < 43493)) : e < 43588 ? e === 43494 || !(e < 43495) && (e < 43504 || !(e < 43514) && (e < 43519 || !(e < 43520) && (e < 43561 || !(e < 43584) && e < 43587))) : e < 43596 || !(e < 43616) && (e < 43632 || e === 43632 || !(e < 43633) && (e < 43639 || e === 43642 || !(e < 43646) && e < 43696)) : e < 43777 ? e < 43739 ? e === 43697 || !(e < 43701) && (e < 43703 || !(e < 43705) && (e < 43710 || e === 43712 || e === 43714)) : e < 43741 || e === 43741 || !(e < 43744) && (e < 43755 || e === 43762 || !(e < 43763) && e < 43765) : e < 43824 ? !(e < 43777) && (e < 43783 || !(e < 43785) && (e < 43791 || !(e < 43793) && (e < 43799 || !(e < 43808) && (e < 43815 || !(e < 43816) && e < 43823)))) : e < 43867 || !(e < 43868) && (e < 43872 || !(e < 43872) && (e < 43878 || !(e < 43888) && (e < 43968 || !(e < 43968) && (e < 44003 || !(e < 44032) && e < 55204)))) : e < 66349 ? e < 65345 ? e < 64318 ? e < 64275 ? !(e < 55216) && (e < 55239 || !(e < 55243) && (e < 55292 || !(e < 63744) && (e < 64110 || !(e < 64112) && (e < 64218 || !(e < 64256) && e < 64263)))) : e < 64280 || e === 64285 || !(e < 64287) && (e < 64297 || !(e < 64298) && (e < 64311 || !(e < 64312) && e < 64317)) : e < 64848 ? e === 64318 || !(e < 64320) && (e < 64322 || !(e < 64323) && (e < 64325 || !(e < 64326) && (e < 64434 || !(e < 64467) && e < 64830))) : e < 64912 || !(e < 64914) && (e < 64968 || !(e < 65008) && (e < 65020 || !(e < 65136) && (e < 65141 || !(e < 65142) && (e < 65277 || !(e < 65313) && e < 65339)))) : e < 65536 ? e < 65440 ? !(e < 65345) && (e < 65371 || !(e < 65382) && (e < 65392 || e === 65392 || !(e < 65393) && (e < 65438 || !(e < 65438) && e < 65440))) : e < 65471 || !(e < 65474) && (e < 65480 || !(e < 65482) && (e < 65488 || !(e < 65490) && (e < 65496 || !(e < 65498) && e < 65501))) : e < 65616 ? !(e < 65536) && (e < 65548 || !(e < 65549) && (e < 65575 || !(e < 65576) && (e < 65595 || !(e < 65596) && (e < 65598 || !(e < 65599) && e < 65614)))) : e < 65630 || !(e < 65664) && (e < 65787 || !(e < 65856) && (e < 65909 || !(e < 66176) && (e < 66205 || !(e < 66208) && (e < 66257 || !(e < 66304) && e < 66336)))) : e < 67639 ? e < 66640 ? e < 66432 ? !(e < 66349) && (e < 66369 || e === 66369 || !(e < 66370) && (e < 66378 || e === 66378 || !(e < 66384) && e < 66422)) : e < 66462 || !(e < 66464) && (e < 66500 || !(e < 66504) && (e < 66512 || !(e < 66513) && (e < 66518 || !(e < 66560) && e < 66640))) : e < 67072 ? !(e < 66640) && (e < 66718 || !(e < 66736) && (e < 66772 || !(e < 66776) && (e < 66812 || !(e < 66816) && (e < 66856 || !(e < 66864) && e < 66916)))) : e < 67383 || !(e < 67392) && (e < 67414 || !(e < 67424) && (e < 67432 || !(e < 67584) && (e < 67590 || e === 67592 || !(e < 67594) && e < 67638))) : e < 68030 ? e < 67808 ? !(e < 67639) && (e < 67641 || e === 67644 || !(e < 67647) && (e < 67670 || !(e < 67680) && (e < 67703 || !(e < 67712) && e < 67743))) : e < 67827 || !(e < 67828) && (e < 67830 || !(e < 67840) && (e < 67862 || !(e < 67872) && (e < 67898 || !(e < 67968) && e < 68024))) : e < 68192 ? !(e < 68030) && (e < 68032 || e === 68096 || !(e < 68112) && (e < 68116 || !(e < 68117) && (e < 68120 || !(e < 68121) && e < 68150))) : e < 68221 || !(e < 68224) && (e < 68253 || !(e < 68288) && (e < 68296 || !(e < 68297) && (e < 68325 || !(e < 68352) && (e < 68406 || !(e < 68416) && e < 68438)))) : e < 93760 ? e < 71040 ? e < 70163 ? e < 69763 ? e < 68864 ? !(e < 68448) && (e < 68467 || !(e < 68480) && (e < 68498 || !(e < 68608) && (e < 68681 || !(e < 68736) && (e < 68787 || !(e < 68800) && e < 68851)))) : e < 68900 || !(e < 69376) && (e < 69405 || e === 69415 || !(e < 69424) && (e < 69446 || !(e < 69635) && e < 69688)) : e < 70006 ? !(e < 69763) && (e < 69808 || !(e < 69840) && (e < 69865 || !(e < 69891) && (e < 69927 || e === 69956 || !(e < 69968) && e < 70003))) : e === 70006 || !(e < 70019) && (e < 70067 || !(e < 70081) && (e < 70085 || e === 70106 || e === 70108 || !(e < 70144) && e < 70162)) : e < 70442 ? e < 70303 ? !(e < 70163) && (e < 70188 || !(e < 70272) && (e < 70279 || e === 70280 || !(e < 70282) && (e < 70286 || !(e < 70287) && e < 70302))) : e < 70313 || !(e < 70320) && (e < 70367 || !(e < 70405) && (e < 70413 || !(e < 70415) && (e < 70417 || !(e < 70419) && e < 70441))) : e < 70493 ? !(e < 70442) && (e < 70449 || !(e < 70450) && (e < 70452 || !(e < 70453) && (e < 70458 || e === 70461 || e === 70480))) : e < 70498 || !(e < 70656) && (e < 70709 || !(e < 70727) && (e < 70731 || !(e < 70784) && (e < 70832 || !(e < 70852) && (e < 70854 || e === 70855)))) : e < 72960 ? e < 72203 ? e < 71424 ? !(e < 71040) && (e < 71087 || !(e < 71128) && (e < 71132 || !(e < 71168) && (e < 71216 || e === 71236 || !(e < 71296) && e < 71339))) : e < 71451 || !(e < 71680) && (e < 71724 || !(e < 71840) && (e < 71904 || e === 71935 || e === 72192)) : e < 72349 ? !(e < 72203) && (e < 72243 || e === 72250 || e === 72272 || !(e < 72284) && (e < 72324 || !(e < 72326) && e < 72330)) : e === 72349 || !(e < 72384) && (e < 72441 || !(e < 72704) && (e < 72713 || !(e < 72714) && (e < 72751 || e === 72768 || !(e < 72818) && e < 72848))) : e < 74752 ? e < 73063 ? !(e < 72960) && (e < 72967 || !(e < 72968) && (e < 72970 || !(e < 72971) && (e < 73009 || e === 73030 || !(e < 73056) && e < 73062))) : e < 73065 || !(e < 73066) && (e < 73098 || e === 73112 || !(e < 73440) && (e < 73459 || !(e < 73728) && e < 74650)) : e < 92736 ? !(e < 74752) && (e < 74863 || !(e < 74880) && (e < 75076 || !(e < 77824) && (e < 78895 || !(e < 82944) && (e < 83527 || !(e < 92160) && e < 92729)))) : e < 92767 || !(e < 92880) && (e < 92910 || !(e < 92928) && (e < 92976 || !(e < 92992) && (e < 92996 || !(e < 93027) && (e < 93048 || !(e < 93053) && e < 93072)))) : e < 120772 ? e < 119997 ? e < 113776 ? e < 94208 ? !(e < 93760) && (e < 93824 || !(e < 93952) && (e < 94021 || e === 94032 || !(e < 94099) && (e < 94112 || !(e < 94176) && e < 94178))) : e < 100338 || !(e < 100352) && (e < 101107 || !(e < 110592) && (e < 110879 || !(e < 110960) && (e < 111356 || !(e < 113664) && e < 113771))) : e < 119966 ? !(e < 113776) && (e < 113789 || !(e < 113792) && (e < 113801 || !(e < 113808) && (e < 113818 || !(e < 119808) && (e < 119893 || !(e < 119894) && e < 119965)))) : e < 119968 || e === 119970 || !(e < 119973) && (e < 119975 || !(e < 119977) && (e < 119981 || !(e < 119982) && (e < 119994 || e === 119995))) : e < 120146 ? e < 120094 ? !(e < 119997) && (e < 120004 || !(e < 120005) && (e < 120070 || !(e < 120071) && (e < 120075 || !(e < 120077) && (e < 120085 || !(e < 120086) && e < 120093)))) : e < 120122 || !(e < 120123) && (e < 120127 || !(e < 120128) && (e < 120133 || e === 120134 || !(e < 120138) && e < 120145)) : e < 120598 ? !(e < 120146) && (e < 120486 || !(e < 120488) && (e < 120513 || !(e < 120514) && (e < 120539 || !(e < 120540) && (e < 120571 || !(e < 120572) && e < 120597)))) : e < 120629 || !(e < 120630) && (e < 120655 || !(e < 120656) && (e < 120687 || !(e < 120688) && (e < 120713 || !(e < 120714) && (e < 120745 || !(e < 120746) && e < 120771)))) : e < 126555 ? e < 126521 ? e < 126497 ? !(e < 120772) && (e < 120780 || !(e < 124928) && (e < 125125 || !(e < 125184) && (e < 125252 || !(e < 126464) && (e < 126468 || !(e < 126469) && e < 126496)))) : e < 126499 || e === 126500 || e === 126503 || !(e < 126505) && (e < 126515 || !(e < 126516) && e < 126520) : e < 126539 ? e === 126521 || e === 126523 || e === 126530 || e === 126535 || e === 126537 : e === 126539 || !(e < 126541) && (e < 126544 || !(e < 126545) && (e < 126547 || e === 126548 || e === 126551 || e === 126553)) : e < 126592 ? e < 126567 ? e === 126555 || e === 126557 || e === 126559 || !(e < 126561) && (e < 126563 || e === 126564) : e < 126571 || !(e < 126572) && (e < 126579 || !(e < 126580) && (e < 126584 || !(e < 126585) && (e < 126589 || e === 126590))) : e < 131072 ? !(e < 126592) && (e < 126602 || !(e < 126603) && (e < 126620 || !(e < 126625) && (e < 126628 || !(e < 126629) && (e < 126634 || !(e < 126635) && e < 126652)))) : e < 173783 || !(e < 173824) && (e < 177973 || !(e < 177984) && (e < 178206 || !(e < 178208) && (e < 183970 || !(e < 183984) && (e < 191457 || !(e < 194560) && e < 195102))));
}
var va = { $LONE: /* @__PURE__ */ new Set(["ASCII", "ASCII_Hex_Digit", "AHex", "Alphabetic", "Alpha", "Any", "Assigned", "Bidi_Control", "Bidi_C", "Bidi_Mirrored", "Bidi_M", "Case_Ignorable", "CI", "Cased", "Changes_When_Casefolded", "CWCF", "Changes_When_Casemapped", "CWCM", "Changes_When_Lowercased", "CWL", "Changes_When_NFKC_Casefolded", "CWKCF", "Changes_When_Titlecased", "CWT", "Changes_When_Uppercased", "CWU", "Dash", "Default_Ignorable_Code_Point", "DI", "Deprecated", "Dep", "Diacritic", "Dia", "Emoji", "Emoji_Component", "Emoji_Modifier", "Emoji_Modifier_Base", "Emoji_Presentation", "Extender", "Ext", "Grapheme_Base", "Gr_Base", "Grapheme_Extend", "Gr_Ext", "Hex_Digit", "Hex", "IDS_Binary_Operator", "IDSB", "IDS_Trinary_Operator", "IDST", "ID_Continue", "IDC", "ID_Start", "IDS", "Ideographic", "Ideo", "Join_Control", "Join_C", "Logical_Order_Exception", "LOE", "Lowercase", "Lower", "Math", "Noncharacter_Code_Point", "NChar", "Pattern_Syntax", "Pat_Syn", "Pattern_White_Space", "Pat_WS", "Quotation_Mark", "QMark", "Radical", "Regional_Indicator", "RI", "Sentence_Terminal", "STerm", "Soft_Dotted", "SD", "Terminal_Punctuation", "Term", "Unified_Ideograph", "UIdeo", "Uppercase", "Upper", "Variation_Selector", "VS", "White_Space", "space", "XID_Continue", "XIDC", "XID_Start", "XIDS"]), General_Category: /* @__PURE__ */ new Set(["Cased_Letter", "LC", "Close_Punctuation", "Pe", "Connector_Punctuation", "Pc", "Control", "Cc", "cntrl", "Currency_Symbol", "Sc", "Dash_Punctuation", "Pd", "Decimal_Number", "Nd", "digit", "Enclosing_Mark", "Me", "Final_Punctuation", "Pf", "Format", "Cf", "Initial_Punctuation", "Pi", "Letter", "L", "Letter_Number", "Nl", "Line_Separator", "Zl", "Lowercase_Letter", "Ll", "Mark", "M", "Combining_Mark", "Math_Symbol", "Sm", "Modifier_Letter", "Lm", "Modifier_Symbol", "Sk", "Nonspacing_Mark", "Mn", "Number", "N", "Open_Punctuation", "Ps", "Other", "C", "Other_Letter", "Lo", "Other_Number", "No", "Other_Punctuation", "Po", "Other_Symbol", "So", "Paragraph_Separator", "Zp", "Private_Use", "Co", "Punctuation", "P", "punct", "Separator", "Z", "Space_Separator", "Zs", "Spacing_Mark", "Mc", "Surrogate", "Cs", "Symbol", "S", "Titlecase_Letter", "Lt", "Unassigned", "Cn", "Uppercase_Letter", "Lu"]), Script: /* @__PURE__ */ new Set(["Adlam", "Adlm", "Ahom", "Anatolian_Hieroglyphs", "Hluw", "Arabic", "Arab", "Armenian", "Armn", "Avestan", "Avst", "Balinese", "Bali", "Bamum", "Bamu", "Bassa_Vah", "Bass", "Batak", "Batk", "Bengali", "Beng", "Bhaiksuki", "Bhks", "Bopomofo", "Bopo", "Brahmi", "Brah", "Braille", "Brai", "Buginese", "Bugi", "Buhid", "Buhd", "Canadian_Aboriginal", "Cans", "Carian", "Cari", "Caucasian_Albanian", "Aghb", "Chakma", "Cakm", "Cham", "Cherokee", "Cher", "Common", "Zyyy", "Coptic", "Copt", "Qaac", "Cuneiform", "Xsux", "Cypriot", "Cprt", "Cyrillic", "Cyrl", "Deseret", "Dsrt", "Devanagari", "Deva", "Duployan", "Dupl", "Egyptian_Hieroglyphs", "Egyp", "Elbasan", "Elba", "Ethiopic", "Ethi", "Georgian", "Geor", "Glagolitic", "Glag", "Gothic", "Goth", "Grantha", "Gran", "Greek", "Grek", "Gujarati", "Gujr", "Gurmukhi", "Guru", "Han", "Hani", "Hangul", "Hang", "Hanunoo", "Hano", "Hatran", "Hatr", "Hebrew", "Hebr", "Hiragana", "Hira", "Imperial_Aramaic", "Armi", "Inherited", "Zinh", "Qaai", "Inscriptional_Pahlavi", "Phli", "Inscriptional_Parthian", "Prti", "Javanese", "Java", "Kaithi", "Kthi", "Kannada", "Knda", "Katakana", "Kana", "Kayah_Li", "Kali", "Kharoshthi", "Khar", "Khmer", "Khmr", "Khojki", "Khoj", "Khudawadi", "Sind", "Lao", "Laoo", "Latin", "Latn", "Lepcha", "Lepc", "Limbu", "Limb", "Linear_A", "Lina", "Linear_B", "Linb", "Lisu", "Lycian", "Lyci", "Lydian", "Lydi", "Mahajani", "Mahj", "Malayalam", "Mlym", "Mandaic", "Mand", "Manichaean", "Mani", "Marchen", "Marc", "Masaram_Gondi", "Gonm", "Meetei_Mayek", "Mtei", "Mende_Kikakui", "Mend", "Meroitic_Cursive", "Merc", "Meroitic_Hieroglyphs", "Mero", "Miao", "Plrd", "Modi", "Mongolian", "Mong", "Mro", "Mroo", "Multani", "Mult", "Myanmar", "Mymr", "Nabataean", "Nbat", "New_Tai_Lue", "Talu", "Newa", "Nko", "Nkoo", "Nushu", "Nshu", "Ogham", "Ogam", "Ol_Chiki", "Olck", "Old_Hungarian", "Hung", "Old_Italic", "Ital", "Old_North_Arabian", "Narb", "Old_Permic", "Perm", "Old_Persian", "Xpeo", "Old_South_Arabian", "Sarb", "Old_Turkic", "Orkh", "Oriya", "Orya", "Osage", "Osge", "Osmanya", "Osma", "Pahawh_Hmong", "Hmng", "Palmyrene", "Palm", "Pau_Cin_Hau", "Pauc", "Phags_Pa", "Phag", "Phoenician", "Phnx", "Psalter_Pahlavi", "Phlp", "Rejang", "Rjng", "Runic", "Runr", "Samaritan", "Samr", "Saurashtra", "Saur", "Sharada", "Shrd", "Shavian", "Shaw", "Siddham", "Sidd", "SignWriting", "Sgnw", "Sinhala", "Sinh", "Sora_Sompeng", "Sora", "Soyombo", "Soyo", "Sundanese", "Sund", "Syloti_Nagri", "Sylo", "Syriac", "Syrc", "Tagalog", "Tglg", "Tagbanwa", "Tagb", "Tai_Le", "Tale", "Tai_Tham", "Lana", "Tai_Viet", "Tavt", "Takri", "Takr", "Tamil", "Taml", "Tangut", "Tang", "Telugu", "Telu", "Thaana", "Thaa", "Thai", "Tibetan", "Tibt", "Tifinagh", "Tfng", "Tirhuta", "Tirh", "Ugaritic", "Ugar", "Vai", "Vaii", "Warang_Citi", "Wara", "Yi", "Yiii", "Zanabazar_Square", "Zanb"]) };
va.gc = va.General_Category, va.sc = va.Script_Extensions = va.scx = va.Script;
var uA = 10, cA = 13, tc = 36, xs = 40, bs = 41, gp = 42, a0 = 43, o0 = 46, Xa = 48, KP = 55, zp = 57, ga = 63, Hp = 65, lA = 70, JP = 90, Kp = 95, Jp = 97, ug = 102, QP = 122, zu = 91, gr = 92, Es = 93, yp = 94, Hu = 123, s0 = 124, Ku = 125, XP = 8204, YP = 8205, ZP = 8232, eI = 8233, tI = 0, nI = 1114111;
function pA(e) {
  return e >= Hp && e <= JP || e >= Jp && e <= QP;
}
function Hl(e) {
  return e >= Xa && e <= zp;
}
function Wb(e) {
  return e >= Xa && e <= zp || e >= Hp && e <= lA || e >= Jp && e <= ug;
}
function rI(e) {
  return e === uA || e === cA || e === ZP || e === eI;
}
function zd(e) {
  return e >= Jp && e <= ug ? e - Jp + 10 : e >= Hp && e <= lA ? e - Hp + 10 : e - Xa;
}
var $b = { at: function(e, t, n) {
  return n < t ? e.charCodeAt(n) : -1;
}, width: function(e) {
  return 1;
} }, iI = { at: function(e, t, n) {
  return n < t ? e.codePointAt(n) : -1;
}, width: function(e) {
  return e > 65535 ? 2 : 1;
} }, aI = function() {
  function e() {
    We(this, e), this._impl = $b, this._s = "", this._i = 0, this._end = 0, this._cp1 = -1, this._w1 = 1, this._cp2 = -1, this._w2 = 1, this._cp3 = -1, this._w3 = 1, this._cp4 = -1;
  }
  return Xe(e, [{ key: "reset", value: function(t, n, r, i) {
    this._impl = i ? iI : $b, this._s = t, this._end = r, this.rewind(n);
  } }, { key: "rewind", value: function(t) {
    var n = this._impl;
    this._i = t, this._cp1 = n.at(this._s, this._end, t), this._w1 = n.width(this._cp1), this._cp2 = n.at(this._s, this._end, t + this._w1), this._w2 = n.width(this._cp2), this._cp3 = n.at(this._s, this._end, t + this._w1 + this._w2), this._w3 = n.width(this._cp3), this._cp4 = n.at(this._s, this._end, t + this._w1 + this._w2 + this._w3);
  } }, { key: "advance", value: function() {
    if (this._cp1 !== -1) {
      var t = this._impl;
      this._i += this._w1, this._cp1 = this._cp2, this._w1 = this._w2, this._cp2 = this._cp3, this._w2 = t.width(this._cp2), this._cp3 = this._cp4, this._w3 = t.width(this._cp3), this._cp4 = t.at(this._s, this._end, this._i + this._w1 + this._w2 + this._w3);
    }
  } }, { key: "eat", value: function(t) {
    return this._cp1 === t && (this.advance(), !0);
  } }, { key: "eat2", value: function(t, n) {
    return this._cp1 === t && this._cp2 === n && (this.advance(), this.advance(), !0);
  } }, { key: "eat3", value: function(t, n, r) {
    return this._cp1 === t && this._cp2 === n && this._cp3 === r && (this.advance(), this.advance(), this.advance(), !0);
  } }, { key: "source", get: function() {
    return this._s;
  } }, { key: "index", get: function() {
    return this._i;
  } }, { key: "currentCodePoint", get: function() {
    return this._cp1;
  } }, { key: "nextCodePoint", get: function() {
    return this._cp2;
  } }, { key: "nextCodePoint2", get: function() {
    return this._cp3;
  } }, { key: "nextCodePoint3", get: function() {
    return this._cp4;
  } }]), e;
}(), oI = function(e) {
  function t(n, r, i, a) {
    var s;
    return We(this, t), n && (n[0] !== "/" && (n = "/".concat(n, "/").concat(r ? "u" : "")), n = ": ".concat(n)), (s = Gt(this, rt(t).call(this, "Invalid regular expression".concat(n, ": ").concat(a)))).index = i, s;
  }
  return $t(t, eE(SyntaxError)), t;
}();
function Gb(e) {
  return e === yp || e === tc || e === gr || e === o0 || e === gp || e === a0 || e === ga || e === xs || e === bs || e === zu || e === Es || e === Hu || e === Ku || e === s0;
}
function sI(e) {
  return function(t) {
    return !(t < 65) && (t < 91 || !(t < 97) && (t < 123 || sA(t)));
  }(e) || e === tc || e === Kp;
}
function zb(e) {
  return pA(e) || e === Kp;
}
function Hb(e, t) {
  return va.hasOwnProperty(e) && va[e].has(t);
}
var u0 = function() {
  function e(t) {
    We(this, e), this._reader = new aI(), this._uFlag = !1, this._nFlag = !1, this._lastIntValue = 0, this._lastMinValue = 0, this._lastMaxValue = 0, this._lastStrValue = "", this._lastKeyValue = "", this._lastValValue = "", this._lastAssertionIsQuantifiable = !1, this._numCapturingParens = 0, this._groupNames = /* @__PURE__ */ new Set(), this._backreferenceNames = /* @__PURE__ */ new Set(), this._options = t || {};
  }
  return Xe(e, [{ key: "validateLiteral", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length;
    if (this._uFlag = this._nFlag = !1, this.reset(t, n, r), this.onLiteralEnter(n), this.eat(47) && this.eatRegExpBody() && this.eat(47)) {
      var i = this.index, a = t.indexOf("u", i) !== -1;
      this.validateFlags(t, i, r), this.validatePattern(t, n + 1, i - 1, a);
    } else if (n >= r)
      this.raise("Empty");
    else {
      var s = String.fromCodePoint(this.currentCodePoint);
      this.raise("Unexpected character '".concat(s, "'"));
    }
    this.onLiteralLeave(n, r);
  } }, { key: "validateFlags", value: function(t) {
    for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length, i = /* @__PURE__ */ new Set(), a = !1, s = !1, o = !1, u = !1, c = !1, f = !1, p = n; p < r; ++p) {
      var d = t.charCodeAt(p);
      i.has(d) && this.raise("Duplicated flag '".concat(t[p], "'")), i.add(d), d === 103 ? a = !0 : d === 105 ? s = !0 : d === 109 ? o = !0 : d === 117 && this.ecmaVersion >= 2015 ? c = !0 : d === 121 && this.ecmaVersion >= 2015 ? u = !0 : d === 115 && this.ecmaVersion >= 2018 ? f = !0 : this.raise("Invalid flag '".concat(t[p], "'"));
    }
    this.onFlags(n, r, a, s, o, c, u, f);
  } }, { key: "validatePattern", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length, i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    this._uFlag = i && this.ecmaVersion >= 2015, this._nFlag = i && this.ecmaVersion >= 2018, this.reset(t, n, r), this.pattern(), !this._nFlag && this.ecmaVersion >= 2018 && this._groupNames.size > 0 && (this._nFlag = !0, this.rewind(n), this.pattern());
  } }, { key: "onLiteralEnter", value: function(t) {
    this._options.onLiteralEnter && this._options.onLiteralEnter(t);
  } }, { key: "onLiteralLeave", value: function(t, n) {
    this._options.onLiteralLeave && this._options.onLiteralLeave(t, n);
  } }, { key: "onFlags", value: function(t, n, r, i, a, s, o, u) {
    this._options.onFlags && this._options.onFlags(t, n, r, i, a, s, o, u);
  } }, { key: "onPatternEnter", value: function(t) {
    this._options.onPatternEnter && this._options.onPatternEnter(t);
  } }, { key: "onPatternLeave", value: function(t, n) {
    this._options.onPatternLeave && this._options.onPatternLeave(t, n);
  } }, { key: "onDisjunctionEnter", value: function(t) {
    this._options.onDisjunctionEnter && this._options.onDisjunctionEnter(t);
  } }, { key: "onDisjunctionLeave", value: function(t, n) {
    this._options.onDisjunctionLeave && this._options.onDisjunctionLeave(t, n);
  } }, { key: "onAlternativeEnter", value: function(t, n) {
    this._options.onAlternativeEnter && this._options.onAlternativeEnter(t, n);
  } }, { key: "onAlternativeLeave", value: function(t, n, r) {
    this._options.onAlternativeLeave && this._options.onAlternativeLeave(t, n, r);
  } }, { key: "onGroupEnter", value: function(t) {
    this._options.onGroupEnter && this._options.onGroupEnter(t);
  } }, { key: "onGroupLeave", value: function(t, n) {
    this._options.onGroupLeave && this._options.onGroupLeave(t, n);
  } }, { key: "onCapturingGroupEnter", value: function(t, n) {
    this._options.onCapturingGroupEnter && this._options.onCapturingGroupEnter(t, n);
  } }, { key: "onCapturingGroupLeave", value: function(t, n, r) {
    this._options.onCapturingGroupLeave && this._options.onCapturingGroupLeave(t, n, r);
  } }, { key: "onQuantifier", value: function(t, n, r, i, a) {
    this._options.onQuantifier && this._options.onQuantifier(t, n, r, i, a);
  } }, { key: "onLookaroundAssertionEnter", value: function(t, n, r) {
    this._options.onLookaroundAssertionEnter && this._options.onLookaroundAssertionEnter(t, n, r);
  } }, { key: "onLookaroundAssertionLeave", value: function(t, n, r, i) {
    this._options.onLookaroundAssertionLeave && this._options.onLookaroundAssertionLeave(t, n, r, i);
  } }, { key: "onEdgeAssertion", value: function(t, n, r) {
    this._options.onEdgeAssertion && this._options.onEdgeAssertion(t, n, r);
  } }, { key: "onWordBoundaryAssertion", value: function(t, n, r, i) {
    this._options.onWordBoundaryAssertion && this._options.onWordBoundaryAssertion(t, n, r, i);
  } }, { key: "onAnyCharacterSet", value: function(t, n, r) {
    this._options.onAnyCharacterSet && this._options.onAnyCharacterSet(t, n, r);
  } }, { key: "onEscapeCharacterSet", value: function(t, n, r, i) {
    this._options.onEscapeCharacterSet && this._options.onEscapeCharacterSet(t, n, r, i);
  } }, { key: "onUnicodePropertyCharacterSet", value: function(t, n, r, i, a, s) {
    this._options.onUnicodePropertyCharacterSet && this._options.onUnicodePropertyCharacterSet(t, n, r, i, a, s);
  } }, { key: "onCharacter", value: function(t, n, r) {
    this._options.onCharacter && this._options.onCharacter(t, n, r);
  } }, { key: "onBackreference", value: function(t, n, r) {
    this._options.onBackreference && this._options.onBackreference(t, n, r);
  } }, { key: "onCharacterClassEnter", value: function(t, n) {
    this._options.onCharacterClassEnter && this._options.onCharacterClassEnter(t, n);
  } }, { key: "onCharacterClassLeave", value: function(t, n, r) {
    this._options.onCharacterClassLeave && this._options.onCharacterClassLeave(t, n, r);
  } }, { key: "onCharacterClassRange", value: function(t, n, r, i) {
    this._options.onCharacterClassRange && this._options.onCharacterClassRange(t, n, r, i);
  } }, { key: "reset", value: function(t, n, r) {
    this._reader.reset(t, n, r, this._uFlag);
  } }, { key: "rewind", value: function(t) {
    this._reader.rewind(t);
  } }, { key: "advance", value: function() {
    this._reader.advance();
  } }, { key: "eat", value: function(t) {
    return this._reader.eat(t);
  } }, { key: "eat2", value: function(t, n) {
    return this._reader.eat2(t, n);
  } }, { key: "eat3", value: function(t, n, r) {
    return this._reader.eat3(t, n, r);
  } }, { key: "raise", value: function(t) {
    throw new oI(this.source, this._uFlag, this.index, t);
  } }, { key: "eatRegExpBody", value: function() {
    for (var t = this.index, n = !1, r = !1; ; ) {
      var i = this.currentCodePoint;
      if (i === -1 || rI(i)) {
        var a = n ? "character class" : "regular expression";
        this.raise("Unterminated ".concat(a));
      }
      if (r)
        r = !1;
      else if (i === gr)
        r = !0;
      else if (i === zu)
        n = !0;
      else if (i === Es)
        n = !1;
      else if (i === 47 && !n || i === gp && this.index === t)
        break;
      this.advance();
    }
    return this.index !== t;
  } }, { key: "pattern", value: function() {
    var t = this.index;
    this._numCapturingParens = this.countCapturingParens(), this._groupNames.clear(), this._backreferenceNames.clear(), this.onPatternEnter(t), this.disjunction();
    var n = this.currentCodePoint;
    if (this.currentCodePoint !== -1) {
      n === bs && this.raise("Unmatched ')'"), n === gr && this.raise("\\ at end of pattern"), n !== Es && n !== Ku || this.raise("Lone quantifier brackets");
      var r = String.fromCodePoint(n);
      this.raise("Unexpected character '".concat(r, "'"));
    }
    var i = !0, a = !1, s = void 0;
    try {
      for (var o, u = this._backreferenceNames[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
        var c = o.value;
        this._groupNames.has(c) || this.raise("Invalid named capture referenced");
      }
    } catch (f) {
      a = !0, s = f;
    } finally {
      try {
        i || u.return == null || u.return();
      } finally {
        if (a)
          throw s;
      }
    }
    this.onPatternLeave(t, this.index);
  } }, { key: "countCapturingParens", value: function() {
    for (var t = this.index, n = !1, r = !1, i = 0, a = 0; (a = this.currentCodePoint) !== -1; )
      r ? r = !1 : a === gr ? r = !0 : a === zu ? n = !0 : a === Es ? n = !1 : a !== xs || n || this.nextCodePoint === ga && (this.nextCodePoint2 !== 60 || this.nextCodePoint3 === 61 || this.nextCodePoint3 === 33) || (i += 1), this.advance();
    return this.rewind(t), i;
  } }, { key: "disjunction", value: function() {
    var t = this.index, n = 0;
    for (this.onDisjunctionEnter(t), this.alternative(n++); this.eat(s0); )
      this.alternative(n++);
    this.eatQuantifier(!0) && this.raise("Nothing to repeat"), this.eat(Hu) && this.raise("Lone quantifier brackets"), this.onDisjunctionLeave(t, this.index);
  } }, { key: "alternative", value: function(t) {
    var n = this.index;
    for (this.onAlternativeEnter(n, t); this.currentCodePoint !== -1 && this.eatTerm(); )
      ;
    this.onAlternativeLeave(n, this.index, t);
  } }, { key: "eatTerm", value: function() {
    return this.eatAssertion() ? (this._lastAssertionIsQuantifiable && this.eatQuantifier(), !0) : !(this.strict ? !this.eatAtom() : !this.eatExtendedAtom()) && (this.eatQuantifier(), !0);
  } }, { key: "eatAssertion", value: function() {
    var t = this.index;
    if (this._lastAssertionIsQuantifiable = !1, this.eat(yp))
      return this.onEdgeAssertion(t, this.index, "start"), !0;
    if (this.eat(tc))
      return this.onEdgeAssertion(t, this.index, "end"), !0;
    if (this.eat2(gr, 66))
      return this.onWordBoundaryAssertion(t, this.index, "word", !0), !0;
    if (this.eat2(gr, 98))
      return this.onWordBoundaryAssertion(t, this.index, "word", !1), !0;
    if (this.eat2(xs, ga)) {
      var n = this.ecmaVersion >= 2018 && this.eat(60), r = !1;
      if (this.eat(61) || (r = this.eat(33))) {
        var i = n ? "lookbehind" : "lookahead";
        return this.onLookaroundAssertionEnter(t, i, r), this.disjunction(), this.eat(bs) || this.raise("Unterminated group"), this._lastAssertionIsQuantifiable = !n && !this.strict, this.onLookaroundAssertionLeave(t, this.index, i, r), !0;
      }
      this.rewind(t);
    }
    return !1;
  } }, { key: "eatQuantifier", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n = this.index, r = 0, i = 0, a = !1;
    if (this.eat(gp))
      r = 0, i = Number.POSITIVE_INFINITY;
    else if (this.eat(a0))
      r = 1, i = Number.POSITIVE_INFINITY;
    else if (this.eat(ga))
      r = 0, i = 1;
    else {
      if (!this.eatBracedQuantifier(t))
        return !1;
      r = this._lastMinValue, i = this._lastMaxValue;
    }
    return a = !this.eat(ga), t || this.onQuantifier(n, this.index, r, i, a), !0;
  } }, { key: "eatBracedQuantifier", value: function(t) {
    var n = this.index;
    if (this.eat(Hu)) {
      if (this._lastMinValue = 0, this._lastMaxValue = Number.POSITIVE_INFINITY, this.eatDecimalDigits() && (this._lastMinValue = this._lastMaxValue = this._lastIntValue, this.eat(44) && (this._lastMaxValue = this.eatDecimalDigits() ? this._lastIntValue : Number.POSITIVE_INFINITY), this.eat(Ku)))
        return !t && this._lastMaxValue < this._lastMinValue && this.raise("numbers out of order in {} quantifier"), !0;
      !t && this.strict && this.raise("Incomplete quantifier"), this.rewind(n);
    }
    return !1;
  } }, { key: "eatAtom", value: function() {
    return this.eatPatternCharacter() || this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup();
  } }, { key: "eatDot", value: function() {
    return !!this.eat(o0) && (this.onAnyCharacterSet(this.index - 1, this.index, "any"), !0);
  } }, { key: "eatReverseSolidusAtomEscape", value: function() {
    var t = this.index;
    if (this.eat(gr)) {
      if (this.eatAtomEscape())
        return !0;
      this.rewind(t);
    }
    return !1;
  } }, { key: "eatUncapturingGroup", value: function() {
    var t = this.index;
    return !!this.eat3(xs, ga, 58) && (this.onGroupEnter(t), this.disjunction(), this.eat(bs) || this.raise("Unterminated group"), this.onGroupLeave(t, this.index), !0);
  } }, { key: "eatCapturingGroup", value: function() {
    var t = this.index;
    if (this.eat(xs)) {
      this._lastStrValue = "", this.ecmaVersion >= 2018 ? this.groupSpecifier() : this.currentCodePoint === ga && this.raise("Invalid group");
      var n = this._lastStrValue || null;
      return this.onCapturingGroupEnter(t, n), this.disjunction(), this.eat(bs) || this.raise("Unterminated group"), this.onCapturingGroupLeave(t, this.index, n), !0;
    }
    return !1;
  } }, { key: "eatExtendedAtom", value: function() {
    return this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatReverseSolidusFollowedByC() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup() || this.eatInvalidBracedQuantifier() || this.eatExtendedPatternCharacter();
  } }, { key: "eatReverseSolidusFollowedByC", value: function() {
    return this.currentCodePoint === gr && this.nextCodePoint === 99 && (this._lastIntValue = this.currentCodePoint, this.advance(), this.onCharacter(this.index - 1, this.index, gr), !0);
  } }, { key: "eatInvalidBracedQuantifier", value: function() {
    return this.eatBracedQuantifier(!0) && this.raise("Nothing to repeat"), !1;
  } }, { key: "eatSyntaxCharacter", value: function() {
    return !!Gb(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), !0);
  } }, { key: "eatPatternCharacter", value: function() {
    var t = this.index, n = this.currentCodePoint;
    return n !== -1 && !Gb(n) && (this.advance(), this.onCharacter(t, this.index, n), !0);
  } }, { key: "eatExtendedPatternCharacter", value: function() {
    var t = this.index, n = this.currentCodePoint;
    return n !== -1 && n !== yp && n !== tc && n !== gr && n !== o0 && n !== gp && n !== a0 && n !== ga && n !== xs && n !== bs && n !== zu && n !== s0 && (this.advance(), this.onCharacter(t, this.index, n), !0);
  } }, { key: "groupSpecifier", value: function() {
    if (this._lastStrValue = "", this.eat(ga)) {
      if (this.eatGroupName()) {
        if (!this._groupNames.has(this._lastStrValue))
          return void this._groupNames.add(this._lastStrValue);
        this.raise("Duplicate capture group name");
      }
      this.raise("Invalid group");
    }
  } }, { key: "eatGroupName", value: function() {
    if (this._lastStrValue = "", this.eat(60)) {
      if (this.eatRegExpIdentifierName() && this.eat(62))
        return !0;
      this.raise("Invalid capture group name");
    }
    return !1;
  } }, { key: "eatRegExpIdentifierName", value: function() {
    if (this._lastStrValue = "", this.eatRegExpIdentifierStart()) {
      for (this._lastStrValue += String.fromCodePoint(this._lastIntValue); this.eatRegExpIdentifierPart(); )
        this._lastStrValue += String.fromCodePoint(this._lastIntValue);
      return !0;
    }
    return !1;
  } }, { key: "eatRegExpIdentifierStart", value: function() {
    var t = this.index, n = this.currentCodePoint;
    return this.advance(), n === gr && this.eatRegExpUnicodeEscapeSequence() && (n = this._lastIntValue), sI(n) ? (this._lastIntValue = n, !0) : (this.index !== t && this.rewind(t), !1);
  } }, { key: "eatRegExpIdentifierPart", value: function() {
    var t = this.index, n = this.currentCodePoint;
    return this.advance(), n === gr && this.eatRegExpUnicodeEscapeSequence() && (n = this._lastIntValue), function(r) {
      return qb(r) || r === tc || r === Kp || r === XP || r === YP;
    }(n) ? (this._lastIntValue = n, !0) : (this.index !== t && this.rewind(t), !1);
  } }, { key: "eatAtomEscape", value: function() {
    return !!(this.eatBackreference() || this.eatCharacterClassEscape() || this.eatCharacterEscape() || this._nFlag && this.eatKGroupName()) || ((this.strict || this._uFlag) && this.raise("Invalid escape"), !1);
  } }, { key: "eatBackreference", value: function() {
    var t = this.index;
    if (this.eatDecimalEscape()) {
      var n = this._lastIntValue;
      if (n <= this._numCapturingParens)
        return this.onBackreference(t - 1, this.index, n), !0;
      this.strict && this.raise("Invalid escape"), this.rewind(t);
    }
    return !1;
  } }, { key: "eatKGroupName", value: function() {
    var t = this.index;
    if (this.eat(107)) {
      if (this.eatGroupName()) {
        var n = this._lastStrValue;
        return this._backreferenceNames.add(n), this.onBackreference(t - 1, this.index, n), !0;
      }
      this.raise("Invalid named reference");
    }
    return !1;
  } }, { key: "eatCharacterEscape", value: function() {
    var t = this.index;
    return !!(this.eatControlEscape() || this.eatCControlLetter() || this.eatZero() || this.eatHexEscapeSequence() || this.eatRegExpUnicodeEscapeSequence() || !this.strict && this.eatLegacyOctalEscapeSequence() || this.eatIdentityEscape()) && (this.onCharacter(t - 1, this.index, this._lastIntValue), !0);
  } }, { key: "eatCControlLetter", value: function() {
    var t = this.index;
    if (this.eat(99)) {
      if (this.eatControlLetter())
        return !0;
      this.rewind(t);
    }
    return !1;
  } }, { key: "eatZero", value: function() {
    return this.currentCodePoint === Xa && !Hl(this.nextCodePoint) && (this._lastIntValue = 0, this.advance(), !0);
  } }, { key: "eatControlEscape", value: function() {
    return this.eat(116) ? (this._lastIntValue = 9, !0) : this.eat(110) ? (this._lastIntValue = uA, !0) : this.eat(118) ? (this._lastIntValue = 11, !0) : this.eat(ug) ? (this._lastIntValue = 12, !0) : !!this.eat(114) && (this._lastIntValue = cA, !0);
  } }, { key: "eatControlLetter", value: function() {
    var t = this.currentCodePoint;
    return !!pA(t) && (this.advance(), this._lastIntValue = t % 32, !0);
  } }, { key: "eatRegExpUnicodeEscapeSequence", value: function() {
    var t = this.index;
    if (this.eat(117)) {
      if (this.eatFixedHexDigits(4)) {
        var n = this._lastIntValue;
        if (this._uFlag && n >= 55296 && n <= 56319) {
          var r = this.index;
          if (this.eat(gr) && this.eat(117) && this.eatFixedHexDigits(4)) {
            var i = this._lastIntValue;
            if (i >= 56320 && i <= 57343)
              return this._lastIntValue = 1024 * (n - 55296) + (i - 56320) + 65536, !0;
          }
          this.rewind(r), this._lastIntValue = n;
        }
        return !0;
      }
      if (this._uFlag && this.eat(Hu) && this.eatHexDigits() && this.eat(Ku) && function(a) {
        return a >= tI && a <= nI;
      }(this._lastIntValue))
        return !0;
      (this.strict || this._uFlag) && this.raise("Invalid unicode escape"), this.rewind(t);
    }
    return !1;
  } }, { key: "eatIdentityEscape", value: function() {
    return this._uFlag ? !!this.eatSyntaxCharacter() || !!this.eat(47) && (this._lastIntValue = 47, !0) : !!this.isValidIdentityEscape(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), !0);
  } }, { key: "isValidIdentityEscape", value: function(t) {
    return t !== -1 && (this.strict ? !qb(t) : t !== 99 && (!this._nFlag || t !== 107));
  } }, { key: "eatDecimalEscape", value: function() {
    this._lastIntValue = 0;
    var t = this.currentCodePoint;
    if (t >= 49 && t <= zp) {
      do
        this._lastIntValue = 10 * this._lastIntValue + (t - Xa), this.advance();
      while ((t = this.currentCodePoint) >= Xa && t <= zp);
      return !0;
    }
    return !1;
  } }, { key: "eatCharacterClassEscape", value: function() {
    var t = this.index;
    if (this.eat(100))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "digit", !1), !0;
    if (this.eat(68))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "digit", !0), !0;
    if (this.eat(115))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "space", !1), !0;
    if (this.eat(83))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "space", !0), !0;
    if (this.eat(119))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "word", !1), !0;
    if (this.eat(87))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(t - 1, this.index, "word", !0), !0;
    var n = !1;
    if (this._uFlag && this.ecmaVersion >= 2018 && (this.eat(112) || (n = this.eat(80)))) {
      if (this._lastIntValue = -1, this.eat(Hu) && this.eatUnicodePropertyValueExpression() && this.eat(Ku))
        return this.onUnicodePropertyCharacterSet(t - 1, this.index, "property", this._lastKeyValue, this._lastValValue || null, n), !0;
      this.raise("Invalid property name");
    }
    return !1;
  } }, { key: "eatUnicodePropertyValueExpression", value: function() {
    var t = this.index;
    if (this.eatUnicodePropertyName() && this.eat(61) && (this._lastKeyValue = this._lastStrValue, this.eatUnicodePropertyValue())) {
      if (this._lastValValue = this._lastStrValue, Hb(this._lastKeyValue, this._lastValValue))
        return !0;
      this.raise("Invalid property name");
    }
    if (this.rewind(t), this.eatLoneUnicodePropertyNameOrValue()) {
      var n = this._lastStrValue;
      if (Hb("General_Category", n))
        return this._lastKeyValue = "General_Category", this._lastValValue = n, !0;
      if (function(r) {
        return va.$LONE.has(r);
      }(n))
        return this._lastKeyValue = n, this._lastValValue = "", !0;
      this.raise("Invalid property name");
    }
    return !1;
  } }, { key: "eatUnicodePropertyName", value: function() {
    for (this._lastStrValue = ""; zb(this.currentCodePoint); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    return this._lastStrValue !== "";
  } }, { key: "eatUnicodePropertyValue", value: function() {
    for (this._lastStrValue = ""; zb(t = this.currentCodePoint) || Hl(t); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    var t;
    return this._lastStrValue !== "";
  } }, { key: "eatLoneUnicodePropertyNameOrValue", value: function() {
    return this.eatUnicodePropertyValue();
  } }, { key: "eatCharacterClass", value: function() {
    var t = this.index;
    if (this.eat(zu)) {
      var n = this.eat(yp);
      return this.onCharacterClassEnter(t, n), this.classRanges(), this.eat(Es) || this.raise("Unterminated character class"), this.onCharacterClassLeave(t, this.index, n), !0;
    }
    return !1;
  } }, { key: "classRanges", value: function() {
    for (var t = this.index; this.eatClassAtom(); ) {
      var n = this._lastIntValue, r = this.index;
      if (this.eat(45) && (this.onCharacter(r, this.index, 45), this.eatClassAtom())) {
        var i = this._lastIntValue;
        n === -1 || i === -1 ? this.strict && this.raise("Invalid character class") : n > i ? this.raise("Range out of order in character class") : this.onCharacterClassRange(t, this.index, n, i);
      }
      t = this.index;
    }
  } }, { key: "eatClassAtom", value: function() {
    var t = this.index;
    if (this.eat(gr)) {
      if (this.eatClassEscape())
        return !0;
      this._uFlag && this.raise("Invalid escape"), this.rewind(t);
    }
    var n = this.currentCodePoint;
    return n !== -1 && n !== Es && (this.advance(), this._lastIntValue = n, this.onCharacter(t, this.index, n), !0);
  } }, { key: "eatClassEscape", value: function() {
    var t = this.index;
    if (this.eat(98))
      return this._lastIntValue = 8, this.onCharacter(t - 1, this.index, 8), !0;
    if (this._uFlag && this.eat(45))
      return this._lastIntValue = 45, this.onCharacter(t - 1, this.index, 45), !0;
    if (!this._uFlag && this.eat(99)) {
      if (this.eatClassControlLetter())
        return this.onCharacter(t - 1, this.index, this._lastIntValue), !0;
      this.rewind(t);
    }
    return this.eatCharacterClassEscape() || this.eatCharacterEscape();
  } }, { key: "eatClassControlLetter", value: function() {
    var t = this.currentCodePoint;
    return !(!Hl(t) && t !== Kp) && (this.advance(), this._lastIntValue = t % 32, !0);
  } }, { key: "eatHexEscapeSequence", value: function() {
    var t = this.index;
    if (this.eat(120)) {
      if (this.eatFixedHexDigits(2))
        return !0;
      this._uFlag && this.raise("Invalid escape"), this.rewind(t);
    }
    return !1;
  } }, { key: "eatDecimalDigits", value: function() {
    var t = this.index;
    for (this._lastIntValue = 0; Hl(this.currentCodePoint); )
      this._lastIntValue = 10 * this._lastIntValue + zd(this.currentCodePoint), this.advance();
    return this.index !== t;
  } }, { key: "eatHexDigits", value: function() {
    var t = this.index;
    for (this._lastIntValue = 0; Wb(this.currentCodePoint); )
      this._lastIntValue = 16 * this._lastIntValue + zd(this.currentCodePoint), this.advance();
    return this.index !== t;
  } }, { key: "eatLegacyOctalEscapeSequence", value: function() {
    if (this.eatOctalDigit()) {
      var t = this._lastIntValue;
      if (this.eatOctalDigit()) {
        var n = this._lastIntValue;
        t <= 3 && this.eatOctalDigit() ? this._lastIntValue = 64 * t + 8 * n + this._lastIntValue : this._lastIntValue = 8 * t + n;
      } else
        this._lastIntValue = t;
      return !0;
    }
    return !1;
  } }, { key: "eatOctalDigit", value: function() {
    var t = this.currentCodePoint;
    return function(n) {
      return n >= Xa && n <= KP;
    }(t) ? (this.advance(), this._lastIntValue = t - Xa, !0) : (this._lastIntValue = 0, !1);
  } }, { key: "eatFixedHexDigits", value: function(t) {
    var n = this.index;
    this._lastIntValue = 0;
    for (var r = 0; r < t; ++r) {
      var i = this.currentCodePoint;
      if (!Wb(i))
        return this.rewind(n), !1;
      this._lastIntValue = 16 * this._lastIntValue + zd(i), this.advance();
    }
    return !0;
  } }, { key: "strict", get: function() {
    return !!(this._options.strict || this._uFlag);
  } }, { key: "ecmaVersion", get: function() {
    return this._options.ecmaVersion || 2018;
  } }, { key: "source", get: function() {
    return this._reader.source;
  } }, { key: "index", get: function() {
    return this._reader.index;
  } }, { key: "currentCodePoint", get: function() {
    return this._reader.currentCodePoint;
  } }, { key: "nextCodePoint", get: function() {
    return this._reader.nextCodePoint;
  } }, { key: "nextCodePoint2", get: function() {
    return this._reader.nextCodePoint2;
  } }, { key: "nextCodePoint3", get: function() {
    return this._reader.nextCodePoint3;
  } }]), e;
}(), uI = {}, cI = {}, lI = {}, pI = function() {
  function e(t) {
    We(this, e), this._node = uI, this._flags = cI, this._backreferences = [], this._capturingGroups = [], this.source = "", this.strict = !!(t && t.strict), this.ecmaVersion = t && t.ecmaVersion || 2018;
  }
  return Xe(e, [{ key: "onFlags", value: function(t, n, r, i, a, s, o, u) {
    this._flags = { type: "Flags", parent: null, start: t, end: n, raw: this.source.slice(t, n), global: r, ignoreCase: i, multiline: a, unicode: s, sticky: o, dotAll: u };
  } }, { key: "onPatternEnter", value: function(t) {
    this._node = { type: "Pattern", parent: null, start: t, end: t, raw: "", alternatives: [] }, this._backreferences.length = 0, this._capturingGroups.length = 0;
  } }, { key: "onPatternLeave", value: function(t, n) {
    var r = this;
    this._node.end = n, this._node.raw = this.source.slice(t, n);
    var i = !0, a = !1, s = void 0;
    try {
      for (var o, u = function() {
        var f = o.value, p = f.ref, d = typeof p == "number" ? r._capturingGroups[p - 1] : r._capturingGroups.find(function(m) {
          return m.name === p;
        });
        f.resolved = d, d.references.push(f);
      }, c = this._backreferences[Symbol.iterator](); !(i = (o = c.next()).done); i = !0)
        u();
    } catch (f) {
      a = !0, s = f;
    } finally {
      try {
        i || c.return == null || c.return();
      } finally {
        if (a)
          throw s;
      }
    }
  } }, { key: "onAlternativeEnter", value: function(t) {
    var n = this._node;
    if (n.type !== "Assertion" && n.type !== "CapturingGroup" && n.type !== "Group" && n.type !== "Pattern")
      throw new Error("UnknownError");
    this._node = { type: "Alternative", parent: n, start: t, end: t, raw: "", elements: [] }, n.alternatives.push(this._node);
  } }, { key: "onAlternativeLeave", value: function(t, n) {
    var r = this._node;
    if (r.type !== "Alternative")
      throw new Error("UnknownError");
    r.end = n, r.raw = this.source.slice(t, n), this._node = r.parent;
  } }, { key: "onGroupEnter", value: function(t) {
    var n = this._node;
    if (n.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Group", parent: n, start: t, end: t, raw: "", alternatives: [] }, n.elements.push(this._node);
  } }, { key: "onGroupLeave", value: function(t, n) {
    var r = this._node;
    if (r.type !== "Group" || r.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r.end = n, r.raw = this.source.slice(t, n), this._node = r.parent;
  } }, { key: "onCapturingGroupEnter", value: function(t, n) {
    var r = this._node;
    if (r.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CapturingGroup", parent: r, start: t, end: t, raw: "", name: n, alternatives: [], references: [] }, r.elements.push(this._node), this._capturingGroups.push(this._node);
  } }, { key: "onCapturingGroupLeave", value: function(t, n) {
    var r = this._node;
    if (r.type !== "CapturingGroup" || r.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r.end = n, r.raw = this.source.slice(t, n), this._node = r.parent;
  } }, { key: "onQuantifier", value: function(t, n, r, i, a) {
    var s = this._node;
    if (s.type !== "Alternative")
      throw new Error("UnknownError");
    var o = s.elements.pop();
    if (o == null || o.type === "Quantifier" || o.type === "Assertion" && o.kind !== "lookahead")
      throw new Error("UnknownError");
    var u = { type: "Quantifier", parent: s, start: o.start, end: n, raw: this.source.slice(o.start, n), min: r, max: i, greedy: a, element: o };
    s.elements.push(u), o.parent = u;
  } }, { key: "onLookaroundAssertionEnter", value: function(t, n, r) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Assertion", parent: i, start: t, end: t, raw: "", kind: n, negate: r, alternatives: [] }, i.elements.push(this._node);
  } }, { key: "onLookaroundAssertionLeave", value: function(t, n) {
    var r = this._node;
    if (r.type !== "Assertion" || r.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r.end = n, r.raw = this.source.slice(t, n), this._node = r.parent;
  } }, { key: "onEdgeAssertion", value: function(t, n, r) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    i.elements.push({ type: "Assertion", parent: i, start: t, end: n, raw: this.source.slice(t, n), kind: r });
  } }, { key: "onWordBoundaryAssertion", value: function(t, n, r, i) {
    var a = this._node;
    if (a.type !== "Alternative")
      throw new Error("UnknownError");
    a.elements.push({ type: "Assertion", parent: a, start: t, end: n, raw: this.source.slice(t, n), kind: r, negate: i });
  } }, { key: "onAnyCharacterSet", value: function(t, n, r) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    i.elements.push({ type: "CharacterSet", parent: i, start: t, end: n, raw: this.source.slice(t, n), kind: r });
  } }, { key: "onEscapeCharacterSet", value: function(t, n, r, i) {
    var a = this._node;
    if (a.type !== "Alternative" && a.type !== "CharacterClass")
      throw new Error("UnknownError");
    a.elements.push({ type: "CharacterSet", parent: a, start: t, end: n, raw: this.source.slice(t, n), kind: r, negate: i });
  } }, { key: "onUnicodePropertyCharacterSet", value: function(t, n, r, i, a, s) {
    var o = this._node;
    if (o.type !== "Alternative" && o.type !== "CharacterClass")
      throw new Error("UnknownError");
    o.elements.push({ type: "CharacterSet", parent: o, start: t, end: n, raw: this.source.slice(t, n), kind: r, key: i, value: a, negate: s });
  } }, { key: "onCharacter", value: function(t, n, r) {
    var i = this._node;
    if (i.type !== "Alternative" && i.type !== "CharacterClass")
      throw new Error("UnknownError");
    i.elements.push({ type: "Character", parent: i, start: t, end: n, raw: this.source.slice(t, n), value: r });
  } }, { key: "onBackreference", value: function(t, n, r) {
    var i = this._node;
    if (i.type !== "Alternative")
      throw new Error("UnknownError");
    var a = { type: "Backreference", parent: i, start: t, end: n, raw: this.source.slice(t, n), ref: r, resolved: lI };
    i.elements.push(a), this._backreferences.push(a);
  } }, { key: "onCharacterClassEnter", value: function(t, n) {
    var r = this._node;
    if (r.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CharacterClass", parent: r, start: t, end: t, raw: "", negate: n, elements: [] }, r.elements.push(this._node);
  } }, { key: "onCharacterClassLeave", value: function(t, n) {
    var r = this._node;
    if (r.type !== "CharacterClass" || r.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r.end = n, r.raw = this.source.slice(t, n), this._node = r.parent;
  } }, { key: "onCharacterClassRange", value: function(t, n) {
    var r = this._node;
    if (r.type !== "CharacterClass")
      throw new Error("UnknownError");
    var i = r.elements, a = i.pop(), s = i.pop(), o = i.pop();
    if (!o || !a || !s || o.type !== "Character" || a.type !== "Character" || s.type !== "Character" || s.value !== 45)
      throw new Error("UnknownError");
    var u = { type: "CharacterClassRange", parent: r, start: t, end: n, raw: this.source.slice(t, n), min: o, max: a };
    o.parent = u, a.parent = u, i.push(u);
  } }, { key: "pattern", get: function() {
    if (this._node.type !== "Pattern")
      throw new Error("UnknownError");
    return this._node;
  } }, { key: "flags", get: function() {
    if (this._flags.type !== "Flags")
      throw new Error("UnknownError");
    return this._flags;
  } }]), e;
}(), Kb = function() {
  function e(t) {
    We(this, e), this._state = new pI(t), this._validator = new u0(this._state);
  }
  return Xe(e, [{ key: "parseLiteral", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length;
    this._state.source = t, this._validator.validateLiteral(t, n, r);
    var i = this._state.pattern, a = this._state.flags, s = { type: "RegExpLiteral", parent: null, start: n, end: r, raw: t, pattern: i, flags: a };
    return i.parent = s, a.parent = s, s;
  } }, { key: "parseFlags", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length;
    return this._state.source = t, this._validator.validateFlags(t, n, r), this._state.flags;
  } }, { key: "parsePattern", value: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : t.length, i = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    return this._state.source = t, this._validator.validatePattern(t, n, r, i), this._state.pattern;
  } }]), e;
}(), fI = function() {
  function e(t) {
    We(this, e), this._handlers = t;
  }
  return Xe(e, [{ key: "visit", value: function(t) {
    switch (t.type) {
      case "Alternative":
        this.visitAlternative(t);
        break;
      case "Assertion":
        this.visitAssertion(t);
        break;
      case "Backreference":
        this.visitBackreference(t);
        break;
      case "CapturingGroup":
        this.visitCapturingGroup(t);
        break;
      case "Character":
        this.visitCharacter(t);
        break;
      case "CharacterClass":
        this.visitCharacterClass(t);
        break;
      case "CharacterClassRange":
        this.visitCharacterClassRange(t);
        break;
      case "CharacterSet":
        this.visitCharacterSet(t);
        break;
      case "Flags":
        this.visitFlags(t);
        break;
      case "Group":
        this.visitGroup(t);
        break;
      case "Pattern":
        this.visitPattern(t);
        break;
      case "Quantifier":
        this.visitQuantifier(t);
        break;
      case "RegExpLiteral":
        this.visitRegExpLiteral(t);
        break;
      default:
        throw new Error("Unknown type: ".concat(t.type));
    }
  } }, { key: "visitAlternative", value: function(t) {
    this._handlers.onAlternativeEnter && this._handlers.onAlternativeEnter(t), t.elements.forEach(this.visit, this), this._handlers.onAlternativeLeave && this._handlers.onAlternativeLeave(t);
  } }, { key: "visitAssertion", value: function(t) {
    this._handlers.onAssertionEnter && this._handlers.onAssertionEnter(t), t.kind !== "lookahead" && t.kind !== "lookbehind" || t.alternatives.forEach(this.visit, this), this._handlers.onAssertionLeave && this._handlers.onAssertionLeave(t);
  } }, { key: "visitBackreference", value: function(t) {
    this._handlers.onBackreferenceEnter && this._handlers.onBackreferenceEnter(t), this._handlers.onBackreferenceLeave && this._handlers.onBackreferenceLeave(t);
  } }, { key: "visitCapturingGroup", value: function(t) {
    this._handlers.onCapturingGroupEnter && this._handlers.onCapturingGroupEnter(t), t.alternatives.forEach(this.visit, this), this._handlers.onCapturingGroupLeave && this._handlers.onCapturingGroupLeave(t);
  } }, { key: "visitCharacter", value: function(t) {
    this._handlers.onCharacterEnter && this._handlers.onCharacterEnter(t), this._handlers.onCharacterLeave && this._handlers.onCharacterLeave(t);
  } }, { key: "visitCharacterClass", value: function(t) {
    this._handlers.onCharacterClassEnter && this._handlers.onCharacterClassEnter(t), t.elements.forEach(this.visit, this), this._handlers.onCharacterClassLeave && this._handlers.onCharacterClassLeave(t);
  } }, { key: "visitCharacterClassRange", value: function(t) {
    this._handlers.onCharacterClassRangeEnter && this._handlers.onCharacterClassRangeEnter(t), this.visitCharacter(t.min), this.visitCharacter(t.max), this._handlers.onCharacterClassRangeLeave && this._handlers.onCharacterClassRangeLeave(t);
  } }, { key: "visitCharacterSet", value: function(t) {
    this._handlers.onCharacterSetEnter && this._handlers.onCharacterSetEnter(t), this._handlers.onCharacterSetLeave && this._handlers.onCharacterSetLeave(t);
  } }, { key: "visitFlags", value: function(t) {
    this._handlers.onFlagsEnter && this._handlers.onFlagsEnter(t), this._handlers.onFlagsLeave && this._handlers.onFlagsLeave(t);
  } }, { key: "visitGroup", value: function(t) {
    this._handlers.onGroupEnter && this._handlers.onGroupEnter(t), t.alternatives.forEach(this.visit, this), this._handlers.onGroupLeave && this._handlers.onGroupLeave(t);
  } }, { key: "visitPattern", value: function(t) {
    this._handlers.onPatternEnter && this._handlers.onPatternEnter(t), t.alternatives.forEach(this.visit, this), this._handlers.onPatternLeave && this._handlers.onPatternLeave(t);
  } }, { key: "visitQuantifier", value: function(t) {
    this._handlers.onQuantifierEnter && this._handlers.onQuantifierEnter(t), this.visit(t.element), this._handlers.onQuantifierLeave && this._handlers.onQuantifierLeave(t);
  } }, { key: "visitRegExpLiteral", value: function(t) {
    this._handlers.onRegExpLiteralEnter && this._handlers.onRegExpLiteralEnter(t), this.visitPattern(t.pattern), this.visitFlags(t.flags), this._handlers.onRegExpLiteralLeave && this._handlers.onRegExpLiteralLeave(t);
  } }]), e;
}(), hI = Object.freeze({ __proto__: null, AST: HP, RegExpParser: Kb, RegExpValidator: u0, parseRegExpLiteral: function(e, t) {
  return new Kb(t).parseLiteral(String(e));
}, validateRegExpLiteral: function(e, t) {
  return new u0(t).validateLiteral(e);
}, visitRegExpAST: function(e, t) {
  new fI(t).visit(e);
} });
function Jb(e) {
  return Array.isArray(e) ? e : [e];
}
var dI = /^\s+$/, mI = /^\\!/, gI = /^\\#/, Qb = typeof Symbol < "u" ? Symbol.for("node-ignore") : "node-ignore", yI = function(e, t, n) {
  return Object.defineProperty(e, t, { value: n });
}, vI = /([0-z])-([0-z])/g, fA = [[/\\?\s+$/, function(e) {
  return e.indexOf("\\") === 0 ? " " : "";
}], [/\\\s/g, function() {
  return " ";
}], [/[\\^$.|*+(){]/g, function(e) {
  return "\\".concat(e);
}], [/\[([^\]/]*)($|\])/g, function(e, t, n) {
  return n === "]" ? "[".concat(t.replace(vI, function(r, i, a) {
    return i.charCodeAt(0) <= a.charCodeAt(0) ? r : "";
  }), "]") : "\\".concat(e);
}], [/(?!\\)\?/g, function() {
  return "[^/]";
}], [/^\//, function() {
  return "^";
}], [/\//g, function() {
  return "\\/";
}], [/^\^*\\\*\\\*\\\//, function() {
  return "^(?:.*\\/)?";
}]], hA = [[/^(?=[^^])/, function() {
  return /\/(?!$)/.test(this) ? "^" : "(?:^|\\/)";
}], [/\\\/\\\*\\\*(?=\\\/|$)/g, function(e, t, n) {
  return t + 6 < n.length ? "(?:\\/[^\\/]+)*" : "\\/.+";
}], [/(^|[^\\]+)\\\*(?=.+)/g, function(e, t) {
  return "".concat(t, "[^\\/]*");
}], [/(\^|\\\/)?\\\*$/, function(e, t) {
  var n = t ? "".concat(t, "[^/]+") : "[^/]*";
  return "".concat(n, "(?=$|\\/$)");
}], [/\\\\\\/g, function() {
  return "\\";
}]], xI = [].concat(fA, [[/(?:[^*/])$/, function(e) {
  return "".concat(e, "(?=$|\\/)");
}]], hA), bI = [].concat(fA, [[/(?:[^*])$/, function(e) {
  return "".concat(e, "(?=$|\\/$)");
}]], hA), Xb = /* @__PURE__ */ Object.create(null), EI = function(e, t) {
  var n = e, r = !1;
  return e.indexOf("!") === 0 && (r = !0, e = e.substr(1)), { origin: n, pattern: e = e.replace(mI, "!").replace(gI, "#"), negative: r, regex: function(i, a, s) {
    var o = Xb[i];
    if (o)
      return o;
    var u = (a ? bI : xI).reduce(function(c, f) {
      return c.replace(f[0], f[1].bind(i));
    }, i);
    return Xb[i] = s ? new RegExp(u, "i") : new RegExp(u);
  }(e, r, t) };
}, c0 = function() {
  function e() {
    var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).ignorecase, n = t === void 0 || t;
    We(this, e), this._rules = [], this._ignorecase = n, yI(this, Qb, !0), this._initCache();
  }
  return Xe(e, [{ key: "_initCache", value: function() {
    this._cache = /* @__PURE__ */ Object.create(null);
  } }, { key: "add", value: function(t) {
    return this._added = !1, typeof t == "string" && (t = t.split(/\r?\n/g)), Jb(t).forEach(this._addPattern, this), this._added && this._initCache(), this;
  } }, { key: "addPattern", value: function(t) {
    return this.add(t);
  } }, { key: "_addPattern", value: function(t) {
    if (t && t[Qb])
      return this._rules = this._rules.concat(t._rules), void (this._added = !0);
    if (function(r) {
      return r && typeof r == "string" && !dI.test(r) && r.indexOf("#") !== 0;
    }(t)) {
      var n = EI(t, this._ignorecase);
      this._added = !0, this._rules.push(n);
    }
  } }, { key: "filter", value: function(t) {
    var n = this;
    return Jb(t).filter(function(r) {
      return n._filter(r);
    });
  } }, { key: "createFilter", value: function() {
    var t = this;
    return function(n) {
      return t._filter(n);
    };
  } }, { key: "ignores", value: function(t) {
    return !this._filter(t);
  } }, { key: "_filter", value: function(t, n) {
    return !!t && (t in this._cache ? this._cache[t] : (n || (n = t.split("/")), n.pop(), this._cache[t] = n.length ? this._filter(n.join("/") + "/", n) && this._test(t) : this._test(t)));
  } }, { key: "_test", value: function(t) {
    var n = 0;
    return this._rules.forEach(function(r) {
      n ^ r.negative || (n = r.negative ^ r.regex.test(t));
    }), !n;
  } }]), e;
}();
if (typeof process < "u" && (process.env && process.env.IGNORE_TEST_WIN32 || process.platform === "win32")) {
  var CI = c0.prototype._filter;
  c0.prototype._filter = function(e, t) {
    var n;
    return e = /^\\\\\?\\/.test(n = e) || /[^\x00-\x80]+/.test(n) ? n : n.replace(/\\/g, "/"), CI.call(this, e, t);
  };
}
var SI = gt(function(e) {
  /*
     * @version    1.4.0
     * @date       2015-10-26
     * @stability  3 - Stable
     * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
     * @license    MIT License
     */
  var t = function(n, r) {
    var i, a, s = 1, o = 0, u = 0, c = String.alphabet;
    function f(p, d, m) {
      if (m) {
        for (i = d; (m = f(p, i)) < 76 && m > 65; )
          ++i;
        return +p.slice(d - 1, i);
      }
      return (m = c && c.indexOf(p.charAt(d))) > -1 ? m + 76 : (m = p.charCodeAt(d) || 0) < 45 || m > 127 ? m : m < 46 ? 65 : m < 48 ? m - 1 : m < 58 ? m + 18 : m < 65 ? m - 11 : m < 91 ? m + 11 : m < 97 ? m - 37 : m < 123 ? m + 5 : m - 63;
    }
    if ((n += "") != (r += "")) {
      for (; s; )
        if (a = f(n, o++), s = f(r, u++), a < 76 && s < 76 && a > 66 && s > 66 && (a = f(n, o, o), s = f(r, u, o = i), u = i), a != s)
          return a < s ? -1 : 1;
    }
    return 0;
  };
  try {
    e.exports = t;
  } catch {
    String.naturalCompare = t;
  }
}), dA = "https://github.com/eslint/doctrine", mA = { node: ">=6.0.0" }, gA = { lib: "./lib" }, yA = ["lib"], vA = [{ name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com", web: "https://www.nczonline.net" }, { name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], xA = { coveralls: "^3.0.1", dateformat: "^1.0.11", eslint: "^1.10.3", "eslint-release": "^1.0.0", linefix: "^0.1.1", mocha: "^3.4.2", "npm-license": "^0.3.1", nyc: "^10.3.2", semver: "^5.0.3", shelljs: "^0.5.3", "shelljs-nodecli": "^0.1.1", should: "^5.0.1" }, bA = { pretest: "npm run lint", test: "nyc mocha", coveralls: "nyc report --reporter=text-lcov | coveralls", lint: "eslint lib/", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, EA = { esutils: "^2.0.2" }, kI = { name: "doctrine", description: "JSDoc parser", homepage: dA, main: "lib/doctrine.js", version: "3.0.0", engines: mA, directories: gA, files: yA, maintainers: vA, repository: "eslint/doctrine", devDependencies: xA, license: "Apache-2.0", scripts: bA, dependencies: EA }, DI = Cr(Object.freeze({ __proto__: null, name: "doctrine", description: "JSDoc parser", homepage: dA, main: "lib/doctrine.js", version: "3.0.0", engines: mA, directories: gA, files: yA, maintainers: vA, repository: "eslint/doctrine", devDependencies: xA, license: "Apache-2.0", scripts: bA, dependencies: EA, default: kI })), Cs = gt(function(e, t) {
  (function() {
    var n, r;
    function i(a) {
      this.name = "DoctrineError", this.message = a;
    }
    n = DI.version, t.VERSION = n, i.prototype = ((r = function() {
    }).prototype = Error.prototype, new r()), i.prototype.constructor = i, t.DoctrineError = i, t.throwError = function(a) {
      throw new i(a);
    }, t.assert = xn;
  })();
}), Pu = (Cs.VERSION, Cs.DoctrineError, Cs.throwError, Cs.assert, gt(function(e, t) {
  (function() {
    var n, r, i, a, s, o, u, c, f, p, d, m;
    function y(W) {
      return "><(){}[],:*|?!=".indexOf(String.fromCharCode(W)) === -1 && !f.code.isWhiteSpace(W) && !f.code.isLineTerminator(W);
    }
    function v(W, R, q, J) {
      this._previous = W, this._index = R, this._token = q, this._value = J;
    }
    function b(W, R) {
      return m && (W.range = [R[0] + d, R[1] + d]), W;
    }
    function x() {
      var W = i.charAt(s);
      return s += 1, W;
    }
    function C(W) {
      var R, q, J, X = 0;
      for (q = W === "u" ? 4 : 2, R = 0; R < q; ++R) {
        if (!(s < a && f.code.isHexDigit(i.charCodeAt(s))))
          return "";
        J = x(), X = 16 * X + "0123456789abcdef".indexOf(J.toLowerCase());
      }
      return String.fromCharCode(X);
    }
    function k() {
      var W, R;
      if (W = "", (R = i.charCodeAt(s)) !== 46) {
        if (W = x(), R = i.charCodeAt(s), W === "0") {
          if (R === 120 || R === 88) {
            for (W += x(); s < a && (R = i.charCodeAt(s), f.code.isHexDigit(R)); )
              W += x();
            return W.length <= 2 && p.throwError("unexpected token"), s < a && (R = i.charCodeAt(s), f.code.isIdentifierStartES5(R) && p.throwError("unexpected token")), c = parseInt(W, 16), r.NUMBER;
          }
          if (f.code.isOctalDigit(R)) {
            for (W += x(); s < a && (R = i.charCodeAt(s), f.code.isOctalDigit(R)); )
              W += x();
            return s < a && (R = i.charCodeAt(s), (f.code.isIdentifierStartES5(R) || f.code.isDecimalDigit(R)) && p.throwError("unexpected token")), c = parseInt(W, 8), r.NUMBER;
          }
          f.code.isDecimalDigit(R) && p.throwError("unexpected token");
        }
        for (; s < a && (R = i.charCodeAt(s), f.code.isDecimalDigit(R)); )
          W += x();
      }
      if (R === 46)
        for (W += x(); s < a && (R = i.charCodeAt(s), f.code.isDecimalDigit(R)); )
          W += x();
      if (R === 101 || R === 69)
        if (W += x(), (R = i.charCodeAt(s)) !== 43 && R !== 45 || (W += x()), R = i.charCodeAt(s), f.code.isDecimalDigit(R))
          for (W += x(); s < a && (R = i.charCodeAt(s), f.code.isDecimalDigit(R)); )
            W += x();
        else
          p.throwError("unexpected token");
      return s < a && (R = i.charCodeAt(s), f.code.isIdentifierStartES5(R) && p.throwError("unexpected token")), c = parseFloat(W), r.NUMBER;
    }
    function F() {
      var W;
      for (o = s; s < a && f.code.isWhiteSpace(i.charCodeAt(s)); )
        x();
      if (s >= a)
        return u = r.EOF;
      switch (W = i.charCodeAt(s)) {
        case 39:
        case 34:
          return u = function() {
            var R, q, J, X, ce, A = "";
            for (R = i.charAt(s), ++s; s < a; ) {
              if ((q = x()) === R) {
                R = "";
                break;
              }
              if (q === "\\")
                if (q = x(), f.code.isLineTerminator(q.charCodeAt(0)))
                  q === "\r" && i.charCodeAt(s) === 10 && ++s;
                else
                  switch (q) {
                    case "n":
                      A += `
`;
                      break;
                    case "r":
                      A += "\r";
                      break;
                    case "t":
                      A += "	";
                      break;
                    case "u":
                    case "x":
                      ce = s, (X = C(q)) ? A += X : (s = ce, A += q);
                      break;
                    case "b":
                      A += "\b";
                      break;
                    case "f":
                      A += "\f";
                      break;
                    case "v":
                      A += "\v";
                      break;
                    default:
                      f.code.isOctalDigit(q.charCodeAt(0)) ? (J = "01234567".indexOf(q), s < a && f.code.isOctalDigit(i.charCodeAt(s)) && (J = 8 * J + "01234567".indexOf(x()), "0123".indexOf(q) >= 0 && s < a && f.code.isOctalDigit(i.charCodeAt(s)) && (J = 8 * J + "01234567".indexOf(x()))), A += String.fromCharCode(J)) : A += q;
                  }
              else {
                if (f.code.isLineTerminator(q.charCodeAt(0)))
                  break;
                A += q;
              }
            }
            return R !== "" && p.throwError("unexpected quote"), c = A, r.STRING;
          }();
        case 58:
          return x(), u = r.COLON;
        case 44:
          return x(), u = r.COMMA;
        case 40:
          return x(), u = r.LPAREN;
        case 41:
          return x(), u = r.RPAREN;
        case 91:
          return x(), u = r.LBRACK;
        case 93:
          return x(), u = r.RBRACK;
        case 123:
          return x(), u = r.LBRACE;
        case 125:
          return x(), u = r.RBRACE;
        case 46:
          if (s + 1 < a) {
            if ((W = i.charCodeAt(s + 1)) === 60)
              return x(), x(), u = r.DOT_LT;
            if (W === 46 && s + 2 < a && i.charCodeAt(s + 2) === 46)
              return x(), x(), x(), u = r.REST;
            if (f.code.isDecimalDigit(W))
              return u = k();
          }
          return u = r.ILLEGAL;
        case 60:
          return x(), u = r.LT;
        case 62:
          return x(), u = r.GT;
        case 42:
          return x(), u = r.STAR;
        case 124:
          return x(), u = r.PIPE;
        case 63:
          return x(), u = r.QUESTION;
        case 33:
          return x(), u = r.BANG;
        case 61:
          return x(), u = r.EQUAL;
        case 45:
          return u = k();
        default:
          return f.code.isDecimalDigit(W) ? u = k() : (p.assert(y(W)), u = function() {
            for (c = x(); s < a && y(i.charCodeAt(s)); ) {
              if (i.charCodeAt(s) === 46) {
                if (s + 1 >= a)
                  return r.ILLEGAL;
                if (i.charCodeAt(s + 1) === 60)
                  break;
              }
              c += x();
            }
            return r.NAME;
          }());
      }
    }
    function B(W, R) {
      p.assert(u === W, R || "consumed token not matched"), F();
    }
    function O(W, R) {
      u !== W && p.throwError(R || "unexpected token"), F();
    }
    function S() {
      var W, R, q = o;
      return R = c, W = u === r.NAME || u === r.STRING ? (F(), R) : u === r.NUMBER ? (B(r.NUMBER), String(R)) : void p.throwError("unexpected token"), u === r.COLON ? (B(r.COLON), b({ type: n.FieldType, key: W, value: V() }, [q, o])) : b({ type: n.FieldType, key: W, value: null }, [q, o]);
    }
    function w() {
      var W, R, q = s - c.length;
      return W = function() {
        var J = c, X = s - J.length;
        return O(r.NAME), u !== r.COLON || J !== "module" && J !== "external" && J !== "event" || (B(r.COLON), J += ":" + c, O(r.NAME)), b({ type: n.NameExpression, name: J }, [X, o]);
      }(), u === r.DOT_LT || u === r.LT ? (F(), R = function() {
        var J = [];
        for (J.push(K()); u === r.COMMA; )
          B(r.COMMA), J.push(K());
        return J;
      }(), O(r.GT), b({ type: n.TypeApplication, expression: W, applications: R }, [q, o])) : W;
    }
    function D() {
      for (var W, R, q, J = [], X = !1, ce = !1, A = s - 3; u !== r.RPAREN; )
        u === r.REST && (B(r.REST), ce = !0), R = o, (W = V()).type === n.NameExpression && u === r.COLON && (q = o - W.name.length, B(r.COLON), W = b({ type: n.ParameterType, name: W.name, expression: V() }, [q, o])), u === r.EQUAL ? (B(r.EQUAL), W = b({ type: n.OptionalType, expression: W }, [R, o]), X = !0) : X && p.throwError("unexpected token"), ce && (W = b({ type: n.RestType, expression: W }, [A, o])), J.push(W), u !== r.RPAREN && O(r.COMMA);
      return J;
    }
    function I() {
      var W, R, q, J, X, ce = s - c.length;
      return p.assert(u === r.NAME && c === "function", "FunctionType should start with 'function'"), B(r.NAME), O(r.LPAREN), W = !1, q = [], R = null, u !== r.RPAREN && (u !== r.NAME || c !== "this" && c !== "new" ? q = D() : (W = c === "new", B(r.NAME), O(r.COLON), R = w(), u === r.COMMA && (B(r.COMMA), q = D()))), O(r.RPAREN), J = null, u === r.COLON && (B(r.COLON, "ResultType should start with :"), J = u === r.NAME && c === "void" ? (B(r.NAME), { type: n.VoidLiteral }) : V()), X = b({ type: n.FunctionType, params: q, result: J }, [ce, o]), R && (X.this = R, W && (X.new = !0)), X;
    }
    function L() {
      var W, R;
      switch (u) {
        case r.STAR:
          return B(r.STAR), b({ type: n.AllLiteral }, [o - 1, o]);
        case r.LPAREN:
          return function() {
            var q, J = s - 1;
            if (B(r.LPAREN, "UnionType should start with ("), q = [], u !== r.RPAREN)
              for (; q.push(V()), u !== r.RPAREN; )
                O(r.PIPE);
            return B(r.RPAREN, "UnionType should end with )"), b({ type: n.UnionType, elements: q }, [J, o]);
          }();
        case r.LBRACK:
          return function() {
            var q, J, X = s - 1;
            for (B(r.LBRACK, "ArrayType should start with ["), q = []; u !== r.RBRACK; ) {
              if (u === r.REST) {
                J = s - 3, B(r.REST), q.push(b({ type: n.RestType, expression: V() }, [J, o]));
                break;
              }
              q.push(V()), u !== r.RBRACK && O(r.COMMA);
            }
            return O(r.RBRACK), b({ type: n.ArrayType, elements: q }, [X, o]);
          }();
        case r.LBRACE:
          return function() {
            var q, J, X = s - 1;
            if (B(r.LBRACE, "RecordType should start with {"), q = [], u === r.COMMA)
              B(r.COMMA);
            else
              for (; u !== r.RBRACE; )
                q.push(S()), u !== r.RBRACE && O(r.COMMA);
            return J = s, O(r.RBRACE), b({ type: n.RecordType, fields: q }, [X, J]);
          }();
        case r.NAME:
          if (R = s - c.length, c === "null")
            return B(r.NAME), b({ type: n.NullLiteral }, [R, o]);
          if (c === "undefined")
            return B(r.NAME), b({ type: n.UndefinedLiteral }, [R, o]);
          if (c === "true" || c === "false")
            return B(r.NAME), b({ type: n.BooleanLiteralType, value: c === "true" }, [R, o]);
          if (W = v.save(), c === "function")
            try {
              return I();
            } catch {
              W.restore();
            }
          return w();
        case r.STRING:
          return F(), b({ type: n.StringLiteralType, value: c }, [o - c.length - 2, o]);
        case r.NUMBER:
          return F(), b({ type: n.NumericLiteralType, value: c }, [o - String(c).length, o]);
        default:
          p.throwError("unexpected token");
      }
    }
    function V() {
      var W, R;
      return u === r.QUESTION ? (R = s - 1, B(r.QUESTION), u === r.COMMA || u === r.EQUAL || u === r.RBRACE || u === r.RPAREN || u === r.PIPE || u === r.EOF || u === r.RBRACK || u === r.GT ? b({ type: n.NullableLiteral }, [R, o]) : b({ type: n.NullableType, expression: L(), prefix: !0 }, [R, o])) : u === r.BANG ? (R = s - 1, B(r.BANG), b({ type: n.NonNullableType, expression: L(), prefix: !0 }, [R, o])) : (R = o, W = L(), u === r.BANG ? (B(r.BANG), b({ type: n.NonNullableType, expression: W, prefix: !1 }, [R, o])) : u === r.QUESTION ? (B(r.QUESTION), b({ type: n.NullableType, expression: W, prefix: !1 }, [R, o])) : u === r.LBRACK ? (B(r.LBRACK), O(r.RBRACK, "expected an array-style type declaration (" + c + "[])"), b({ type: n.TypeApplication, expression: b({ type: n.NameExpression, name: "Array" }, [R, o]), applications: [W] }, [R, o])) : W);
    }
    function K() {
      var W, R;
      if (W = V(), u !== r.PIPE)
        return W;
      for (R = [W], B(r.PIPE); R.push(V()), u === r.PIPE; )
        B(r.PIPE);
      return b({ type: n.UnionType, elements: R }, [0, s]);
    }
    f = Os, p = Cs, n = { NullableLiteral: "NullableLiteral", AllLiteral: "AllLiteral", NullLiteral: "NullLiteral", UndefinedLiteral: "UndefinedLiteral", VoidLiteral: "VoidLiteral", UnionType: "UnionType", ArrayType: "ArrayType", RecordType: "RecordType", FieldType: "FieldType", FunctionType: "FunctionType", ParameterType: "ParameterType", RestType: "RestType", NonNullableType: "NonNullableType", OptionalType: "OptionalType", NullableType: "NullableType", NameExpression: "NameExpression", TypeApplication: "TypeApplication", StringLiteralType: "StringLiteralType", NumericLiteralType: "NumericLiteralType", BooleanLiteralType: "BooleanLiteralType" }, r = { ILLEGAL: 0, DOT_LT: 1, REST: 2, LT: 3, GT: 4, LPAREN: 5, RPAREN: 6, LBRACE: 7, RBRACE: 8, LBRACK: 9, RBRACK: 10, COMMA: 11, COLON: 12, STAR: 13, PIPE: 14, QUESTION: 15, BANG: 16, EQUAL: 17, NAME: 18, STRING: 19, NUMBER: 20, EOF: 21 }, v.prototype.restore = function() {
      o = this._previous, s = this._index, u = this._token, c = this._value;
    }, v.save = function() {
      return new v(o, s, u, c);
    }, t.parseType = function(W, R) {
      var q;
      return a = (i = W).length, s = 0, o = 0, m = R && R.range, d = R && R.startIndex || 0, F(), q = K(), R && R.midstream ? { expression: q, index: o } : (u !== r.EOF && p.throwError("not reach to EOF"), q);
    }, t.parseParamType = function(W, R) {
      var q;
      return a = (i = W).length, s = 0, o = 0, m = R && R.range, d = R && R.startIndex || 0, F(), q = function() {
        var J;
        return u === r.REST ? (B(r.REST), b({ type: n.RestType, expression: K() }, [0, s])) : (J = K(), u === r.EQUAL ? (B(r.EQUAL), b({ type: n.OptionalType, expression: J }, [0, s])) : J);
      }(), R && R.midstream ? { expression: q, index: o } : (u !== r.EOF && p.throwError("not reach to EOF"), q);
    }, t.stringify = function(W, R) {
      return R == null && (R = {}), function q(J, X, ce) {
        var A, M, ne;
        switch (J.type) {
          case n.NullableLiteral:
            A = "?";
            break;
          case n.AllLiteral:
            A = "*";
            break;
          case n.NullLiteral:
            A = "null";
            break;
          case n.UndefinedLiteral:
            A = "undefined";
            break;
          case n.VoidLiteral:
            A = "void";
            break;
          case n.UnionType:
            for (A = ce ? "" : "(", M = 0, ne = J.elements.length; M < ne; ++M)
              A += q(J.elements[M], X), M + 1 !== ne && (A += X ? "|" : " | ");
            ce || (A += ")");
            break;
          case n.ArrayType:
            for (A = "[", M = 0, ne = J.elements.length; M < ne; ++M)
              A += q(J.elements[M], X), M + 1 !== ne && (A += X ? "," : ", ");
            A += "]";
            break;
          case n.RecordType:
            for (A = "{", M = 0, ne = J.fields.length; M < ne; ++M)
              A += q(J.fields[M], X), M + 1 !== ne && (A += X ? "," : ", ");
            A += "}";
            break;
          case n.FieldType:
            A = J.value ? J.key + (X ? ":" : ": ") + q(J.value, X) : J.key;
            break;
          case n.FunctionType:
            for (A = X ? "function(" : "function (", J.this && (J.new ? A += X ? "new:" : "new: " : A += X ? "this:" : "this: ", A += q(J.this, X), J.params.length !== 0 && (A += X ? "," : ", ")), M = 0, ne = J.params.length; M < ne; ++M)
              A += q(J.params[M], X), M + 1 !== ne && (A += X ? "," : ", ");
            A += ")", J.result && (A += (X ? ":" : ": ") + q(J.result, X));
            break;
          case n.ParameterType:
            A = J.name + (X ? ":" : ": ") + q(J.expression, X);
            break;
          case n.RestType:
            A = "...", J.expression && (A += q(J.expression, X));
            break;
          case n.NonNullableType:
            A = J.prefix ? "!" + q(J.expression, X) : q(J.expression, X) + "!";
            break;
          case n.OptionalType:
            A = q(J.expression, X) + "=";
            break;
          case n.NullableType:
            A = J.prefix ? "?" + q(J.expression, X) : q(J.expression, X) + "?";
            break;
          case n.NameExpression:
            A = J.name;
            break;
          case n.TypeApplication:
            for (A = q(J.expression, X) + ".<", M = 0, ne = J.applications.length; M < ne; ++M)
              A += q(J.applications[M], X), M + 1 !== ne && (A += X ? "," : ", ");
            A += ">";
            break;
          case n.StringLiteralType:
            A = '"' + J.value + '"';
            break;
          case n.NumericLiteralType:
          case n.BooleanLiteralType:
            A = String(J.value);
            break;
          default:
            p.throwError("Unknown type " + J.type);
        }
        return A;
      }(W, R.compact, R.topLevel);
    }, t.Syntax = n;
  })();
})), ya = (Pu.parseType, Pu.parseParamType, Pu.stringify, Pu.Syntax, gt(function(e, t) {
  (function() {
    var n, r, i, a, s, o;
    function u(C, k, F) {
      return C.slice(k, F);
    }
    function c(C) {
      return C === "param" || C === "argument" || C === "arg";
    }
    function f(C) {
      return C === "return" || C === "returns";
    }
    function p(C) {
      return C === "property" || C === "prop";
    }
    function d(C) {
      return c(C) || p(C) || C === "alias" || C === "this" || C === "mixes" || C === "requires";
    }
    function m(C) {
      return p(C) || c(C);
    }
    function y(C) {
      return c(C) || f(C) || C === "define" || C === "enum" || C === "implements" || C === "this" || C === "type" || C === "typedef" || p(C);
    }
    a = Os, n = Pu, r = Cs, o = Object.prototype.hasOwnProperty, s = function(C, k) {
      return o.call(C, k);
    };
    var v = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]", b = "(" + v + "*(?:\\*" + v + `?)?)(.+|[\r
\u2028\u2029])`;
    function x(C) {
      return C.replace(/^\/\*\*?/, "").replace(/\*\/$/, "").replace(new RegExp(b, "g"), "$2").replace(/\s*$/, "");
    }
    (function(C) {
      var k, F, B, O, S, w, D, I, L;
      function V() {
        var A = S.charCodeAt(F);
        return F += 1, !a.code.isLineTerminator(A) || A === 13 && S.charCodeAt(F) === 10 || (B += 1), String.fromCharCode(A);
      }
      function K(A, M, ne) {
        for (var de, he, j, ie, fe = !1; F < M; ) {
          if (de = S.charCodeAt(F), !a.code.isWhiteSpace(de)) {
            if (de === 123) {
              V();
              break;
            }
            fe = !0;
            break;
          }
          V();
        }
        if (fe)
          return null;
        for (he = 1, j = ""; F < M; )
          if (de = S.charCodeAt(F), a.code.isLineTerminator(de))
            V();
          else {
            if (de === 125) {
              if ((he -= 1) === 0) {
                V();
                break;
              }
            } else
              de === 123 && (he += 1);
            j === "" && (ie = F), j += V();
          }
        return he !== 0 ? r.throwError("Braces are not balanced") : m(A) ? n.parseParamType(j, { startIndex: J(ie), range: ne }) : n.parseType(j, { startIndex: J(ie), range: ne });
      }
      function W(A) {
        var M;
        if (!a.code.isIdentifierStartES5(S.charCodeAt(F)) && !S[F].match(/[0-9]/))
          return null;
        for (M = V(); F < A && a.code.isIdentifierPartES5(S.charCodeAt(F)); )
          M += V();
        return M;
      }
      function R(A) {
        for (; F < A && (a.code.isWhiteSpace(S.charCodeAt(F)) || a.code.isLineTerminator(S.charCodeAt(F))); )
          V();
      }
      function q(A, M, ne) {
        var de, he, j = "";
        if (R(A), F >= A)
          return null;
        if (S.charCodeAt(F) === 91) {
          if (!M)
            return null;
          de = !0, j = V();
        }
        if (j += W(A), ne)
          for (S.charCodeAt(F) !== 58 || j !== "module" && j !== "external" && j !== "event" || (j += V(), j += W(A)), S.charCodeAt(F) === 91 && S.charCodeAt(F + 1) === 93 && (j += V(), j += V()); S.charCodeAt(F) === 46 || S.charCodeAt(F) === 47 || S.charCodeAt(F) === 35 || S.charCodeAt(F) === 45 || S.charCodeAt(F) === 126; )
            j += V(), j += W(A);
        if (de) {
          if (R(A), S.charCodeAt(F) === 61) {
            var ie;
            j += V(), R(A);
            for (var fe = 1; F < A; ) {
              if (ie = S.charCodeAt(F), a.code.isWhiteSpace(ie) && (he || (R(A), ie = S.charCodeAt(F))), ie === 39 && (he ? he === "'" && (he = "") : he = "'"), ie === 34 && (he ? he === '"' && (he = "") : he = '"'), ie === 91)
                fe++;
              else if (ie === 93 && --fe == 0)
                break;
              j += V();
            }
          }
          if (R(A), F >= A || S.charCodeAt(F) !== 93)
            return null;
          j += V();
        }
        return j;
      }
      function J(A) {
        return S === w ? A : function(M, ne) {
          for (var de, he = M.replace(/^\/\*\*?/, ""), j = 0, ie = new RegExp(b, "g"); de = ie.exec(he); )
            if (j += de[1].length, de.index + de[0].length > ne + j)
              return ne + j + M.length - he.length;
          return M.replace(/\*\/$/, "").replace(/\s*$/, "").length;
        }(w, A);
      }
      function X(A, M) {
        this._options = A, this._title = M.toLowerCase(), this._tag = { title: M, description: null }, this._options.lineNumbers && (this._tag.lineNumber = B), this._first = F - M.length - 1, this._last = 0, this._extra = {};
      }
      function ce(A) {
        var M, ne;
        if (!function() {
          for (; F < O && S.charCodeAt(F) !== 64; )
            V();
          return !(F >= O) && (r.assert(S.charCodeAt(F) === 64), !0);
        }())
          return null;
        for (ne = (M = new X(A, function() {
          var de, he = "";
          for (V(); F < O && ((de = S.charCodeAt(F)) >= 97 && de <= 122 || de >= 65 && de <= 90 || de >= 48 && de <= 57); )
            he += V();
          return he;
        }())).parse(); F < M._last; )
          V();
        return ne;
      }
      X.prototype.addError = function(A) {
        var M = Array.prototype.slice.call(arguments, 1), ne = A.replace(/%(\d)/g, function(de, he) {
          return r.assert(he < M.length, "Message reference must be in range"), M[he];
        });
        return this._tag.errors || (this._tag.errors = []), L && r.throwError(ne), this._tag.errors.push(ne), D;
      }, X.prototype.parseType = function() {
        if (y(this._title))
          try {
            if (this._tag.type = K(this._title, this._last, this._options.range), !(this._tag.type || c(this._title) || f(this._title) || this.addError("Missing or invalid tag type")))
              return !1;
          } catch (A) {
            if (this._tag.type = null, !this.addError(A.message))
              return !1;
          }
        else if (function(A) {
          return y(A) || A === "throws" || A === "const" || A === "constant" || A === "namespace" || A === "member" || A === "var" || A === "module" || A === "constructor" || A === "class" || A === "extends" || A === "augments" || A === "public" || A === "private" || A === "protected";
        }(this._title))
          try {
            this._tag.type = K(this._title, this._last, this._options.range);
          } catch {
          }
        return !0;
      }, X.prototype._parseNamePath = function(A) {
        var M;
        return !!((M = q(this._last, I && m(this._title), !0)) || A || this.addError("Missing or invalid tag name")) && (this._tag.name = M, !0);
      }, X.prototype.parseNamePath = function() {
        return this._parseNamePath(!1);
      }, X.prototype.parseNamePathOptional = function() {
        return this._parseNamePath(!0);
      }, X.prototype.parseName = function() {
        var A, M;
        if (function(ne) {
          return d(ne) || ne === "const" || ne === "constant";
        }(this._title))
          if (this._tag.name = q(this._last, I && m(this._title), function(ne) {
            return p(ne) || c(ne);
          }(this._title)), this._tag.name)
            (M = this._tag.name).charAt(0) === "[" && M.charAt(M.length - 1) === "]" && ((A = M.substring(1, M.length - 1).split("=")).length > 1 && (this._tag.default = A.slice(1).join("=")), this._tag.name = A[0], this._tag.type && this._tag.type.type !== "OptionalType" && (this._tag.type = { type: "OptionalType", expression: this._tag.type }));
          else {
            if (!d(this._title))
              return !0;
            if (c(this._title) && this._tag.type && this._tag.type.name)
              this._extra.name = this._tag.type, this._tag.name = this._tag.type.name, this._tag.type = null;
            else if (!this.addError("Missing or invalid tag name"))
              return !1;
          }
        return !0;
      }, X.prototype.parseDescription = function() {
        var A = u(S, F, this._last).trim();
        return A && (/^-\s+/.test(A) && (A = A.substring(2)), this._tag.description = A), !0;
      }, X.prototype.parseCaption = function() {
        var A = u(S, F, this._last).trim(), M = A.indexOf("<caption>"), ne = A.indexOf("</caption>");
        return M >= 0 && ne >= 0 ? (this._tag.caption = A.substring(M + 9, ne).trim(), this._tag.description = A.substring(ne + 10).trim()) : this._tag.description = A, !0;
      }, X.prototype.parseKind = function() {
        var A, M;
        return M = { class: !0, constant: !0, event: !0, external: !0, file: !0, function: !0, member: !0, mixin: !0, module: !0, namespace: !0, typedef: !0 }, A = u(S, F, this._last).trim(), this._tag.kind = A, !(!s(M, A) && !this.addError("Invalid kind name '%0'", A));
      }, X.prototype.parseAccess = function() {
        var A;
        return A = u(S, F, this._last).trim(), this._tag.access = A, !(A !== "private" && A !== "protected" && A !== "public" && !this.addError("Invalid access name '%0'", A));
      }, X.prototype.parseThis = function() {
        var A = u(S, F, this._last).trim();
        return A && A.charAt(0) === "{" ? this.parseType() && this._tag.type.type === "NameExpression" || this._tag.type.type === "UnionType" ? (this._tag.name = this._tag.type.name, !0) : this.addError("Invalid name for this") : this.parseNamePath();
      }, X.prototype.parseVariation = function() {
        var A, M;
        return M = u(S, F, this._last).trim(), A = parseFloat(M, 10), this._tag.variation = A, !(isNaN(A) && !this.addError("Invalid variation '%0'", M));
      }, X.prototype.ensureEnd = function() {
        var A = u(S, F, this._last).trim();
        return !(A && !this.addError("Unknown content '%0'", A));
      }, X.prototype.epilogue = function() {
        var A;
        return A = this._tag.description, !(m(this._title) && !this._tag.type && A && A.charAt(0) === "[" && (this._tag.type = this._extra.name, this._tag.name || (this._tag.name = void 0), !I && !this.addError("Missing or invalid tag name")));
      }, k = { access: ["parseAccess"], alias: ["parseNamePath", "ensureEnd"], augments: ["parseType", "parseNamePathOptional", "ensureEnd"], constructor: ["parseType", "parseNamePathOptional", "ensureEnd"], class: ["parseType", "parseNamePathOptional", "ensureEnd"], extends: ["parseType", "parseNamePathOptional", "ensureEnd"], example: ["parseCaption"], deprecated: ["parseDescription"], global: ["ensureEnd"], inner: ["ensureEnd"], instance: ["ensureEnd"], kind: ["parseKind"], mixes: ["parseNamePath", "ensureEnd"], mixin: ["parseNamePathOptional", "ensureEnd"], member: ["parseType", "parseNamePathOptional", "ensureEnd"], method: ["parseNamePathOptional", "ensureEnd"], module: ["parseType", "parseNamePathOptional", "ensureEnd"], func: ["parseNamePathOptional", "ensureEnd"], function: ["parseNamePathOptional", "ensureEnd"], var: ["parseType", "parseNamePathOptional", "ensureEnd"], name: ["parseNamePath", "ensureEnd"], namespace: ["parseType", "parseNamePathOptional", "ensureEnd"], private: ["parseType", "parseDescription"], protected: ["parseType", "parseDescription"], public: ["parseType", "parseDescription"], readonly: ["ensureEnd"], requires: ["parseNamePath", "ensureEnd"], since: ["parseDescription"], static: ["ensureEnd"], summary: ["parseDescription"], this: ["parseThis", "ensureEnd"], todo: ["parseDescription"], typedef: ["parseType", "parseNamePathOptional"], variation: ["parseVariation"], version: ["parseDescription"] }, X.prototype.parse = function() {
        var A, M, ne;
        if (!this._title && !this.addError("Missing or invalid title"))
          return null;
        for (this._last = function() {
          var de, he, j = F;
          for (he = !1; j < O; ) {
            if (de = S.charCodeAt(j), !a.code.isLineTerminator(de) || de === 13 && S.charCodeAt(j + 1) === 10) {
              if (he) {
                if (de === 64)
                  break;
                a.code.isWhiteSpace(de) || (he = !1);
              }
            } else
              he = !0;
            j += 1;
          }
          return j;
        }(this._title), this._options.range && (this._tag.range = [this._first, S.slice(0, this._last).replace(/\s*$/, "").length].map(J)), A = 0, M = (ne = s(k, this._title) ? k[this._title] : ["parseType", "parseName", "parseDescription", "epilogue"]).length; A < M; ++A)
          if (!this[ne[A]]())
            return null;
        return this._tag;
      }, C.parse = function(A, M) {
        var ne, de, he, j, ie, fe = [];
        if (M === void 0 && (M = {}), S = typeof M.unwrap == "boolean" && M.unwrap ? x(A) : A, w = A, M.tags)
          if (Array.isArray(M.tags))
            for (he = {}, j = 0, ie = M.tags.length; j < ie; j++)
              typeof M.tags[j] == "string" ? he[M.tags[j]] = !0 : r.throwError('Invalid "tags" parameter: ' + M.tags);
          else
            r.throwError('Invalid "tags" parameter: ' + M.tags);
        for (O = S.length, F = 0, B = 0, D = M.recoverable, I = M.sloppy, L = M.strict, de = function(ge) {
          var Fe, Pe, _ = "";
          for (Pe = !0; F < O && (Fe = S.charCodeAt(F), !Pe || Fe !== 64); )
            a.code.isLineTerminator(Fe) ? Pe = !0 : Pe && !a.code.isWhiteSpace(Fe) && (Pe = !1), _ += V();
          return ge ? _ : _.trim();
        }(M.preserveWhitespace); ne = ce(M); )
          he && !he.hasOwnProperty(ne.title) || fe.push(ne);
        return { description: de, tags: fe };
      };
    })(i = {}), t.version = r.VERSION, t.parse = i.parse, t.parseType = n.parseType, t.parseParamType = n.parseParamType, t.unwrapComment = x, t.Syntax = function(C) {
      var k, F = {};
      for (k in C)
        C.hasOwnProperty(k) && (F[k] = C[k]);
      return F;
    }(n.Syntax), t.Error = r.DoctrineError, t.type = { Syntax: t.Syntax, parseType: n.parseType, parseParamType: n.parseParamType, stringify: n.stringify };
  })();
})), FI = (ya.version, ya.parse, ya.parseType, ya.parseParamType, ya.unwrapComment, ya.Syntax, ya.Error, ya.type, Cr(hI)), wI = regeneratorRuntime.mark(AA);
function eu(e) {
  return e && xe(e) == "object" && "default" in e ? e.default : e;
}
var l0 = eu(Os), AI = eu(GP), ao = eu(FI), CA = eu(function(e) {
  return new c0(e);
}), Yb = eu(SI), _I = eu(ya), P = ye.createCommonjsModule(function(e) {
  function t(j, ie, fe) {
    var ge = j.identifier, Fe = ie === 0 || fe[ie - 1].identifier !== ge;
    return ge && j.init === !1 && j.isWrite() && Fe;
  }
  function n(j) {
    return j[0] !== j[0].toLocaleLowerCase();
  }
  function r(j) {
    return j.id && n(j.id.name);
  }
  function i(j) {
    for (var ie = j; ie; ie = ie.parent)
      if (R.test(ie.type))
        return ie;
    return null;
  }
  function a(j) {
    return !(!j || !R.test(j.type));
  }
  function s(j) {
    return !(!j || !q.test(j.type));
  }
  function o(j) {
    return e.exports.isNullLiteral(j) || j.type === "Identifier" && j.name === "undefined" || j.type === "UnaryExpression" && j.operator === "void";
  }
  function u(j) {
    return j.parent.type === "CallExpression" && j.parent.callee === j;
  }
  function c(j) {
    return j.type === "MemberExpression" && j.object.type === "Identifier" && j.object.name === "Reflect" && j.property.type === "Identifier" && j.property.name === "apply" && j.computed === !1;
  }
  function f(j) {
    return j.type === "MemberExpression" && j.object.type === "Identifier" && J.test(j.object.name) && j.property.type === "Identifier" && j.property.name === "from" && j.computed === !1;
  }
  function p(j) {
    for (var ie = j; ie.type === "MemberExpression" && !ie.computed; ie = ie.property)
      if (ie.property.type === "Identifier")
        return X.test(ie.property.name);
    return !1;
  }
  function d(j) {
    return function(ie) {
      return !j(ie);
    };
  }
  function m(j, ie) {
    var fe = ie.getJSDocComment(j);
    return !(!fe || !A.test(fe.value)) || ie.getCommentsBefore(j).some(function(ge) {
      return A.test(ge.value);
    });
  }
  function y(j) {
    return j.value === "=>" && j.type === "Punctuator";
  }
  function v(j) {
    return j.value === "," && j.type === "Punctuator";
  }
  function b(j) {
    return j.value === "." && j.type === "Punctuator";
  }
  function x(j) {
    return j.value === ";" && j.type === "Punctuator";
  }
  function C(j) {
    return j.value === ":" && j.type === "Punctuator";
  }
  function k(j) {
    return j.value === "(" && j.type === "Punctuator";
  }
  function F(j) {
    return j.value === ")" && j.type === "Punctuator";
  }
  function B(j) {
    return j.value === "[" && j.type === "Punctuator";
  }
  function O(j) {
    return j.value === "]" && j.type === "Punctuator";
  }
  function S(j) {
    return j.value === "{" && j.type === "Punctuator";
  }
  function w(j) {
    return j.value === "}" && j.type === "Punctuator";
  }
  function D(j, ie) {
    return j.id ? ie.getTokenAfter(j.id, k) : ie.getFirstToken(j, k);
  }
  var I = ye.require$$0$1, L = I.breakableTypePattern, V = I.createGlobalLinebreakMatcher, K = I.lineBreakPattern, W = I.shebangPattern, R = /^(?:Function(?:Declaration|Expression)|ArrowFunctionExpression)$/, q = /^(?:DoWhile|For|ForIn|ForOf|While)Statement$/, J = /Array$/, X = /^(?:every|filter|find|findIndex|forEach|map|some)$/, ce = /^(?:bind|call|apply)$/, A = /^[\t-\r \*\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*@this/m, M = /* @__PURE__ */ new Set([`\r
`, "\r", `
`, "\u2028", "\u2029"]), ne = /* @__PURE__ */ new Set(["Program", "BlockStatement", "SwitchCase"]), de = /^(0|[1-9][0-9]*)$/, he = /^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\/8-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\0(?![0-9]))*\\(?:[1-7]|0[0-9])/;
  e.exports = { COMMENTS_IGNORE_PATTERN: /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:eslint|jshint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jslint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|istanbul[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|globals?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|exported[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jscs)/, LINEBREAKS: M, LINEBREAK_MATCHER: K, SHEBANG_MATCHER: W, STATEMENT_LIST_PARENTS: ne, isTokenOnSameLine: function(j, ie) {
    return j.loc.end.line === ie.loc.start.line;
  }, isNullOrUndefined: o, isCallee: u, isES5Constructor: r, getUpperFunction: i, isFunction: a, isLoop: s, isInLoop: function(j) {
    for (var ie = j; ie && !a(ie); ie = ie.parent)
      if (s(ie))
        return !0;
    return !1;
  }, isArrayFromMethod: f, isParenthesised: function(j, ie) {
    var fe = j.getTokenBefore(ie), ge = j.getTokenAfter(ie);
    return !(!fe || !ge) && fe.value === "(" && fe.range[1] <= ie.range[0] && ge.value === ")" && ge.range[0] >= ie.range[1];
  }, createGlobalLinebreakMatcher: V, equalTokens: function(j, ie, fe) {
    var ge = fe.getTokens(j), Fe = fe.getTokens(ie);
    if (ge.length !== Fe.length)
      return !1;
    for (var Pe = 0; Pe < ge.length; ++Pe)
      if (ge[Pe].type !== Fe[Pe].type || ge[Pe].value !== Fe[Pe].value)
        return !1;
    return !0;
  }, isArrowToken: y, isClosingBraceToken: w, isClosingBracketToken: O, isClosingParenToken: F, isColonToken: C, isCommaToken: v, isCommentToken: function(j) {
    return j.type === "Line" || j.type === "Block" || j.type === "Shebang";
  }, isDotToken: b, isKeywordToken: function(j) {
    return j.type === "Keyword";
  }, isNotClosingBraceToken: d(w), isNotClosingBracketToken: d(O), isNotClosingParenToken: d(F), isNotColonToken: d(C), isNotCommaToken: d(v), isNotDotToken: d(b), isNotOpeningBraceToken: d(S), isNotOpeningBracketToken: d(B), isNotOpeningParenToken: d(k), isNotSemicolonToken: d(x), isOpeningBraceToken: S, isOpeningBracketToken: B, isOpeningParenToken: k, isSemicolonToken: x, isStringLiteral: function(j) {
    return j.type === "Literal" && typeof j.value == "string" || j.type === "TemplateLiteral";
  }, isBreakableStatement: function(j) {
    return L.test(j.type);
  }, getModifyingReferences: function(j) {
    return j.filter(t);
  }, isSurroundedBy: function(j, ie) {
    return j[0] === ie && j[j.length - 1] === ie;
  }, isDirectiveComment: function(j) {
    var ie = j.value.trim();
    return j.type === "Line" && ie.indexOf("eslint-") === 0 || j.type === "Block" && (ie.indexOf("global ") === 0 || ie.indexOf("eslint ") === 0 || ie.indexOf("eslint-") === 0);
  }, getTrailingStatement: l0.ast.trailingStatement, getVariableByName: function(j, ie) {
    for (var fe = j; fe; ) {
      var ge = fe.set.get(ie);
      if (ge)
        return ge;
      fe = fe.upper;
    }
    return null;
  }, isDefaultThisBinding: function(j, ie) {
    var fe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ge = fe.capIsConstructor, Fe = ge === void 0 || ge;
    if (Fe && r(j) || m(j, ie))
      return !1;
    for (var Pe = j.id === null, _ = j; _; ) {
      var Q = _.parent;
      switch (Q.type) {
        case "LogicalExpression":
        case "ConditionalExpression":
          _ = Q;
          break;
        case "ReturnStatement":
          var Y = i(Q);
          if (Y === null || !u(Y))
            return !0;
          _ = Y.parent;
          break;
        case "ArrowFunctionExpression":
          if (_ !== Q.body || !u(Q))
            return !0;
          _ = Q.parent;
          break;
        case "Property":
        case "MethodDefinition":
          return Q.value !== _;
        case "AssignmentExpression":
        case "AssignmentPattern":
          return Q.left.type !== "MemberExpression" && !(Fe && Pe && Q.left.type === "Identifier" && n(Q.left.name));
        case "VariableDeclarator":
          return !(Fe && Pe && Q.init === _ && Q.id.type === "Identifier" && n(Q.id.name));
        case "MemberExpression":
          return Q.object !== _ || Q.property.type !== "Identifier" || !ce.test(Q.property.name) || !u(Q) || Q.parent.arguments.length === 0 || o(Q.parent.arguments[0]);
        case "CallExpression":
          return c(Q.callee) ? Q.arguments.length !== 3 || Q.arguments[0] !== _ || o(Q.arguments[1]) : f(Q.callee) ? Q.arguments.length !== 3 || Q.arguments[1] !== _ || o(Q.arguments[2]) : !p(Q.callee) || Q.arguments.length !== 2 || Q.arguments[0] !== _ || o(Q.arguments[1]);
        default:
          return !0;
      }
    }
    return !0;
  }, getPrecedence: function(j) {
    switch (j.type) {
      case "SequenceExpression":
        return 0;
      case "AssignmentExpression":
      case "ArrowFunctionExpression":
      case "YieldExpression":
        return 1;
      case "ConditionalExpression":
        return 3;
      case "LogicalExpression":
        switch (j.operator) {
          case "||":
            return 4;
          case "&&":
            return 5;
        }
      case "BinaryExpression":
        switch (j.operator) {
          case "|":
            return 6;
          case "^":
            return 7;
          case "&":
            return 8;
          case "==":
          case "!=":
          case "===":
          case "!==":
            return 9;
          case "<":
          case "<=":
          case ">":
          case ">=":
          case "in":
          case "instanceof":
            return 10;
          case "<<":
          case ">>":
          case ">>>":
            return 11;
          case "+":
          case "-":
            return 12;
          case "*":
          case "/":
          case "%":
            return 13;
          case "**":
            return 15;
        }
      case "UnaryExpression":
      case "AwaitExpression":
        return 16;
      case "UpdateExpression":
        return 17;
      case "CallExpression":
      case "ImportExpression":
        return 18;
      case "NewExpression":
        return 19;
      default:
        return 20;
    }
  }, isEmptyBlock: function(j) {
    return !(!j || j.type !== "BlockStatement" || j.body.length !== 0);
  }, isEmptyFunction: function(j) {
    return a(j) && e.exports.isEmptyBlock(j.body);
  }, getStaticPropertyName: function(j) {
    var ie;
    switch (j && j.type) {
      case "Property":
      case "MethodDefinition":
        ie = j.key;
        break;
      case "MemberExpression":
        ie = j.property;
    }
    switch (ie && ie.type) {
      case "Literal":
        return ie.value + "";
      case "TemplateLiteral":
        if (ie.expressions.length === 0 && ie.quasis.length === 1)
          return ie.quasis[0].value.cooked;
        break;
      case "Identifier":
        if (!j.computed)
          return ie.name;
    }
    return null;
  }, getDirectivePrologue: function(j) {
    var ie = [];
    if (j.type === "Program" || j.type === "FunctionDeclaration" || j.type === "FunctionExpression" || j.type === "ArrowFunctionExpression" && j.body.type === "BlockStatement") {
      var fe = j.type === "Program" ? j.body : j.body.body, ge = !0, Fe = !1, Pe = void 0;
      try {
        for (var _, Q = fe[Symbol.iterator](); !(ge = (_ = Q.next()).done); ge = !0) {
          var Y = _.value;
          if (Y.type !== "ExpressionStatement" || Y.expression.type !== "Literal")
            break;
          ie.push(Y);
        }
      } catch (ae) {
        Fe = !0, Pe = ae;
      } finally {
        try {
          ge || Q.return == null || Q.return();
        } finally {
          if (Fe)
            throw Pe;
        }
      }
    }
    return ie;
  }, isDecimalInteger: function(j) {
    return j.type === "Literal" && typeof j.value == "number" && de.test(j.raw);
  }, isDecimalIntegerNumericToken: function(j) {
    return j.type === "Numeric" && de.test(j.value);
  }, getFunctionNameWithKind: function(j) {
    var ie = j.parent, fe = [];
    if (ie.type === "MethodDefinition" && ie.static && fe.push("static"), j.async && fe.push("async"), j.generator && fe.push("generator"), j.type === "ArrowFunctionExpression")
      fe.push("arrow", "function");
    else if (ie.type === "Property" || ie.type === "MethodDefinition") {
      if (ie.kind === "constructor")
        return "constructor";
      ie.kind === "get" ? fe.push("getter") : ie.kind === "set" ? fe.push("setter") : fe.push("method");
    } else
      fe.push("function");
    if (j.id)
      fe.push("'".concat(j.id.name, "'"));
    else {
      var ge = e.exports.getStaticPropertyName(ie);
      ge !== null && fe.push("'".concat(ge, "'"));
    }
    return fe.join(" ");
  }, getFunctionHeadLoc: function(j, ie) {
    var fe = j.parent, ge = null, Fe = null;
    if (j.type === "ArrowFunctionExpression") {
      var Pe = ie.getTokenBefore(j.body, y);
      ge = Pe.loc.start, Fe = Pe.loc.end;
    } else
      fe.type === "Property" || fe.type === "MethodDefinition" ? (ge = fe.loc.start, Fe = D(j, ie).loc.start) : (ge = j.loc.start, Fe = D(j, ie).loc.start);
    return { start: Object.assign({}, ge), end: Object.assign({}, Fe) };
  }, getNextLocation: function(j, ie) {
    var fe = j.getIndexFromLoc(ie);
    return fe + 1 > j.text.length ? null : j.getLocFromIndex(fe + 1);
  }, getParenthesisedText: function(j, ie) {
    for (var fe = j.getFirstToken(ie), ge = j.getLastToken(ie); j.getTokenBefore(fe) && j.getTokenBefore(fe).type === "Punctuator" && j.getTokenBefore(fe).value === "(" && j.getTokenAfter(ge) && j.getTokenAfter(ge).type === "Punctuator" && j.getTokenAfter(ge).value === ")"; )
      fe = j.getTokenBefore(fe), ge = j.getTokenAfter(ge);
    return j.getText().slice(fe.range[0], ge.range[1]);
  }, couldBeError: function(j) {
    switch (j.type) {
      case "Identifier":
      case "CallExpression":
      case "NewExpression":
      case "MemberExpression":
      case "TaggedTemplateExpression":
      case "YieldExpression":
      case "AwaitExpression":
        return !0;
      case "AssignmentExpression":
        return e.exports.couldBeError(j.right);
      case "SequenceExpression":
        var ie = j.expressions;
        return ie.length !== 0 && e.exports.couldBeError(ie[ie.length - 1]);
      case "LogicalExpression":
        return e.exports.couldBeError(j.left) || e.exports.couldBeError(j.right);
      case "ConditionalExpression":
        return e.exports.couldBeError(j.consequent) || e.exports.couldBeError(j.alternate);
      default:
        return !1;
    }
  }, isNullLiteral: function(j) {
    return j.type === "Literal" && j.value === null && !j.regex && !j.bigint;
  }, canTokensBeAdjacent: function(j, ie) {
    var fe;
    if (typeof j == "string") {
      var ge = ye.espree.tokenize(j, { ecmaVersion: 2015 });
      fe = ge[ge.length - 1];
    } else
      fe = j;
    var Fe = typeof ie == "string" ? ye.espree.tokenize(ie, { ecmaVersion: 2015 })[0] : ie;
    if (fe.type === "Punctuator" || Fe.type === "Punctuator") {
      if (fe.type === "Punctuator" && Fe.type === "Punctuator") {
        var Pe = /* @__PURE__ */ new Set(["+", "++"]), _ = /* @__PURE__ */ new Set(["-", "--"]);
        return !(Pe.has(fe.value) && Pe.has(Fe.value) || _.has(fe.value) && _.has(Fe.value));
      }
      return !0;
    }
    return fe.type === "String" || Fe.type === "String" || fe.type === "Template" || Fe.type === "Template" || !(fe.type === "Numeric" || Fe.type !== "Numeric" || !Fe.value.startsWith("."));
  }, getNameLocationInGlobalDirectiveComment: function(j, ie, fe) {
    var ge = new RegExp("[\\s,]".concat(ye.lodash.escapeRegExp(fe), "(?:$|[\\s,:])"), "gu");
    ge.lastIndex = ie.value.indexOf("global") + 6;
    var Fe = ge.exec(ie.value);
    return j.getLocFromIndex(ie.range[0] + 2 + (Fe ? Fe.index + 1 : 0));
  }, hasOctalEscapeSequence: function(j) {
    return he.test(j);
  } };
});
P.COMMENTS_IGNORE_PATTERN, P.LINEBREAKS, P.LINEBREAK_MATCHER, P.SHEBANG_MATCHER, P.STATEMENT_LIST_PARENTS, P.isTokenOnSameLine, P.isNullOrUndefined, P.isCallee, P.isES5Constructor, P.getUpperFunction, P.isFunction, P.isLoop, P.isInLoop, P.isArrayFromMethod, P.isParenthesised, P.createGlobalLinebreakMatcher, P.equalTokens, P.isArrowToken, P.isClosingBraceToken, P.isClosingBracketToken, P.isClosingParenToken, P.isColonToken, P.isCommaToken, P.isCommentToken, P.isDotToken, P.isKeywordToken, P.isNotClosingBraceToken, P.isNotClosingBracketToken, P.isNotClosingParenToken, P.isNotColonToken, P.isNotCommaToken, P.isNotDotToken, P.isNotOpeningBraceToken, P.isNotOpeningBracketToken, P.isNotOpeningParenToken, P.isNotSemicolonToken, P.isOpeningBraceToken, P.isOpeningBracketToken, P.isOpeningParenToken, P.isSemicolonToken, P.isStringLiteral, P.isBreakableStatement, P.getModifyingReferences, P.isSurroundedBy, P.isDirectiveComment, P.getTrailingStatement, P.getVariableByName, P.isDefaultThisBinding, P.getPrecedence, P.isEmptyBlock, P.isEmptyFunction, P.getStaticPropertyName, P.getDirectivePrologue, P.isDecimalInteger, P.isDecimalIntegerNumericToken, P.getFunctionNameWithKind, P.getFunctionHeadLoc, P.getNextLocation, P.getParenthesisedText, P.couldBeError, P.isNullLiteral, P.canTokensBeAdjacent, P.getNameLocationInGlobalDirectiveComment, P.hasOctalEscapeSequence;
function TI(e) {
  return e.kind === "get" || e.kind === "set";
}
function Zb(e, t) {
  return e.type === "Identifier" && e.name === t;
}
function Kl(e, t, n, r) {
  var i = e.parent;
  return i.type === "CallExpression" && i.callee.type === "MemberExpression" && i.callee.computed === !1 && Zb(i.callee.object, n) && Zb(i.callee.property, r) && i.arguments[t] === e;
}
var PI = { meta: { type: "suggestion", docs: { description: "enforce getter and setter pairs in objects and classes", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/accessor-pairs" }, schema: [{ type: "object", properties: { getWithoutSet: { type: "boolean", default: !1 }, setWithoutGet: { type: "boolean", default: !0 }, enforceForClassMembers: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { missingGetterInPropertyDescriptor: "Getter is not present in property descriptor.", missingSetterInPropertyDescriptor: "Setter is not present in property descriptor.", missingGetterInObjectLiteral: "Getter is not present for {{ name }}.", missingSetterInObjectLiteral: "Setter is not present for {{ name }}.", missingGetterInClass: "Getter is not present for class {{ name }}.", missingSetterInClass: "Setter is not present for class {{ name }}." } }, create: function(e) {
  function t(d, m) {
    d.type === "Property" ? e.report({ node: d, messageId: "".concat(m, "InObjectLiteral"), loc: P.getFunctionHeadLoc(d.value, f), data: { name: P.getFunctionNameWithKind(d.value) } }) : d.type === "MethodDefinition" ? e.report({ node: d, messageId: "".concat(m, "InClass"), loc: P.getFunctionHeadLoc(d.value, f), data: { name: P.getFunctionNameWithKind(d.value) } }) : e.report({ node: d, messageId: "".concat(m, "InPropertyDescriptor") });
  }
  function n(d, m) {
    var y = !0, v = !1, b = void 0;
    try {
      for (var x, C = d[Symbol.iterator](); !(y = (x = C.next()).done); y = !0)
        t(x.value, m);
    } catch (k) {
      v = !0, b = k;
    } finally {
      try {
        y || C.return == null || C.return();
      } finally {
        if (v)
          throw b;
      }
    }
  }
  function r(d) {
    var m = P.getStaticPropertyName(d);
    return { key: m === null ? f.getTokens(d.key) : m, getters: d.kind === "get" ? [d] : [], setters: d.kind === "set" ? [d] : [] };
  }
  function i(d, m) {
    var y, v, b = d.find(function(x) {
      return function(C, k) {
        return typeof C == "string" && typeof k == "string" ? C == k : !(!Array.isArray(C) || !Array.isArray(k)) && function(F, B) {
          if (F.length !== B.length)
            return !1;
          for (var O = 0; O < F.length; O++) {
            var S = F[O], w = B[O];
            if (S.type !== w.type || S.value !== w.value)
              return !1;
          }
          return !0;
        }(C, k);
      }(x.key, m.key);
    });
    return b ? ((y = b.getters).push.apply(y, Mt(m.getters)), (v = b.setters).push.apply(v, Mt(m.setters))) : d.push(m), d;
  }
  function a(d) {
    var m = d.filter(TI).map(r).reduce(i, []), y = !0, v = !1, b = void 0;
    try {
      for (var x, C = m[Symbol.iterator](); !(y = (x = C.next()).done); y = !0) {
        var k = x.value, F = k.getters, B = k.setters;
        u && B.length && !F.length && n(B, "missingGetter"), o && F.length && !B.length && n(F, "missingSetter");
      }
    } catch (O) {
      v = !0, b = O;
    } finally {
      try {
        y || C.return == null || C.return();
      } finally {
        if (v)
          throw b;
      }
    }
  }
  var s = e.options[0] || {}, o = s.getWithoutSet === !0, u = s.setWithoutGet !== !1, c = s.enforceForClassMembers === !0, f = e.getSourceCode(), p = {};
  return (u || o) && (p.ObjectExpression = function(d) {
    (function(m) {
      a(m.properties.filter(function(y) {
        return y.type === "Property";
      }));
    })(d), function(m) {
      if (Kl(m, 2, "Object", "defineProperty") || Kl(m, 2, "Reflect", "defineProperty"))
        return !0;
      var y = m.parent.parent;
      return y.type === "ObjectExpression" && (Kl(y, 1, "Object", "create") || Kl(y, 1, "Object", "defineProperties"));
    }(d) && function(m) {
      var y = m.properties.filter(function(x) {
        return x.type === "Property" && x.kind === "init" && !x.computed;
      }).map(function(x) {
        return x.key.name;
      }), v = y.includes("get"), b = y.includes("set");
      u && b && !v && t(m, "missingGetter"), o && v && !b && t(m, "missingSetter");
    }(d);
  }, c && (p.ClassBody = function(d) {
    var m = d.body.filter(function(y) {
      return y.type === "MethodDefinition";
    });
    a(m.filter(function(y) {
      return y.static;
    })), a(m.filter(function(y) {
      return !y.static;
    }));
  })), p;
} }, II = { meta: { type: "layout", docs: { description: "enforce linebreaks after opening and before closing array brackets", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/array-bracket-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: !1 }] }], messages: { unexpectedOpeningLinebreak: "There should be no linebreak after '['.", unexpectedClosingLinebreak: "There should be no linebreak before ']'.", missingOpeningLinebreak: "A linebreak is required after '['.", missingClosingLinebreak: "A linebreak is required before ']'." } }, create: function(e) {
  function t(a) {
    var s = function(o) {
      var u = !1, c = !1, f = 0;
      return o ? o === "consistent" ? (u = !0, f = r) : o === "always" || o.minItems === 0 ? f = 0 : o === "never" ? f = r : (c = !!o.multiline, f = o.minItems || r) : (u = !1, c = !0, f = r), { consistent: u, multiline: c, minItems: f };
    }(a);
    return { ArrayExpression: s, ArrayPattern: s };
  }
  function n(a) {
    var s = a.elements, o = t(e.options[0])[a.type], u = i.getFirstToken(a), c = i.getLastToken(a), f = i.getTokenAfter(u, { includeComments: !0 }), p = i.getTokenBefore(c, { includeComments: !0 }), d = i.getTokenAfter(u), m = i.getTokenBefore(c);
    s.length >= o.minItems || o.multiline && 0 < s.length && f.loc.start.line !== p.loc.end.line || s.length === 0 && f.type === "Block" && f.loc.start.line !== p.loc.end.line && f === p || o.consistent && u.loc.end.line !== d.loc.start.line ? (P.isTokenOnSameLine(u, d) && function(y, v) {
      e.report({ node: y, loc: v.loc, messageId: "missingOpeningLinebreak", fix: function(b) {
        return b.insertTextAfter(v, `
`);
      } });
    }(a, u), P.isTokenOnSameLine(m, c) && function(y, v) {
      e.report({ node: y, loc: v.loc, messageId: "missingClosingLinebreak", fix: function(b) {
        return b.insertTextBefore(v, `
`);
      } });
    }(a, c)) : (!P.isTokenOnSameLine(u, d) && function(y, v) {
      e.report({ node: y, loc: v.loc, messageId: "unexpectedOpeningLinebreak", fix: function(b) {
        var x = i.getTokenAfter(v, { includeComments: !0 });
        return P.isCommentToken(x) ? null : b.removeRange([v.range[1], x.range[0]]);
      } });
    }(a, u), !P.isTokenOnSameLine(m, c) && function(y, v) {
      e.report({ node: y, loc: v.loc, messageId: "unexpectedClosingLinebreak", fix: function(b) {
        var x = i.getTokenBefore(v, { includeComments: !0 });
        return P.isCommentToken(x) ? null : b.removeRange([x.range[1], v.range[0]]);
      } });
    }(a, c));
  }
  var r = Number.POSITIVE_INFINITY, i = e.getSourceCode();
  return { ArrayPattern: n, ArrayExpression: n };
} }, BI = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside array brackets", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/array-bracket-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { singleValue: { type: "boolean" }, objectsInArrays: { type: "boolean" }, arraysInArrays: { type: "boolean" } }, additionalProperties: !1 }], messages: { unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'." } }, create: function(e) {
  function t(d) {
    return !!e.options[1] && e.options[1][d] === !c;
  }
  function n(d, m) {
    e.report({ node: d, loc: m.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: m.value }, fix: function(y) {
      var v = f.getTokenAfter(m);
      return y.removeRange([m.range[1], v.range[0]]);
    } });
  }
  function r(d, m) {
    e.report({ node: d, loc: m.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: m.value }, fix: function(y) {
      var v = f.getTokenBefore(m);
      return y.removeRange([v.range[1], m.range[0]]);
    } });
  }
  function i(d, m) {
    e.report({ node: d, loc: m.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: m.value }, fix: function(y) {
      return y.insertTextAfter(m, " ");
    } });
  }
  function a(d, m) {
    e.report({ node: d, loc: m.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: m.value }, fix: function(y) {
      return y.insertTextBefore(m, " ");
    } });
  }
  function s(d) {
    return d && (d.type === "ObjectExpression" || d.type === "ObjectPattern");
  }
  function o(d) {
    return d && (d.type === "ArrayExpression" || d.type === "ArrayPattern");
  }
  function u(d) {
    if (!p.spaced || d.elements.length !== 0) {
      var m = f.getFirstToken(d), y = f.getFirstToken(d, 1), v = d.typeAnnotation ? f.getTokenBefore(d.typeAnnotation) : f.getLastToken(d), b = f.getTokenBefore(v), x = d.elements[0], C = d.elements[d.elements.length - 1], k = p.objectsInArraysException && s(x) || p.arraysInArraysException && o(x) || p.singleElementException && d.elements.length === 1 ? !p.spaced : p.spaced, F = p.objectsInArraysException && s(C) || p.arraysInArraysException && o(C) || p.singleElementException && d.elements.length === 1 ? !p.spaced : p.spaced;
      P.isTokenOnSameLine(m, y) && (k && !f.isSpaceBetweenTokens(m, y) && i(d, m), !k && f.isSpaceBetweenTokens(m, y) && n(d, m)), m !== b && P.isTokenOnSameLine(b, v) && (F && !f.isSpaceBetweenTokens(b, v) && a(d, v), !F && f.isSpaceBetweenTokens(b, v) && r(d, v));
    }
  }
  var c = e.options[0] === "always", f = e.getSourceCode(), p = { spaced: c, singleElementException: t("singleValue"), objectsInArraysException: t("objectsInArrays"), arraysInArraysException: t("arraysInArrays") };
  return { ArrayPattern: u, ArrayExpression: u };
} }, OI = /^(?:Arrow)?FunctionExpression$/, LI = /^(?:every|filter|find(?:Index)?|map|reduce(?:Right)?|some|sort)$/;
function NI(e) {
  return e.reachable;
}
function jI(e, t) {
  return e.type === "ArrowFunctionExpression" ? t.getTokenBefore(e.body) : e.id || e;
}
function RI(e) {
  return e.type === "MemberExpression" && LI.test(P.getStaticPropertyName(e) || "");
}
function MI(e) {
  for (var t = e; t; ) {
    var n = t.parent;
    switch (n.type) {
      case "LogicalExpression":
      case "ConditionalExpression":
        t = n;
        break;
      case "ReturnStatement":
        var r = P.getUpperFunction(n);
        if (r === null || !P.isCallee(r))
          return !1;
        t = r.parent;
        break;
      case "CallExpression":
        return P.isArrayFromMethod(n.callee) ? 2 <= n.arguments.length && n.arguments[1] === t : !!RI(n.callee) && 1 <= n.arguments.length && n.arguments[0] === t;
      default:
        return !1;
    }
  }
  return !1;
}
var VI = { meta: { type: "problem", docs: { description: "enforce `return` statements in callbacks of array methods", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/array-callback-return" }, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { expectedAtEnd: "Expected to return a value at the end of {{name}}.", expectedInside: "Expected to return a value in {{name}}.", expectedReturnValue: "{{name}} expected a return value." } }, create: function(e) {
  function t(i) {
    r.shouldCheck && r.codePath.currentSegments.some(NI) && e.report({ node: i, loc: jI(i, e.getSourceCode()).loc.start, messageId: r.hasReturn ? "expectedAtEnd" : "expectedInside", data: { name: P.getFunctionNameWithKind(r.node) } });
  }
  var n = e.options[0] || { allowImplicit: !1 }, r = { upper: null, codePath: null, hasReturn: !1, shouldCheck: !1, node: null };
  return { onCodePathStart: function(i, a) {
    r = { upper: r, codePath: i, hasReturn: !1, shouldCheck: OI.test(a.type) && a.body.type === "BlockStatement" && MI(a) && !a.async && !a.generator, node: a };
  }, onCodePathEnd: function() {
    r = r.upper;
  }, ReturnStatement: function(i) {
    r.shouldCheck && (r.hasReturn = !0, !n.allowImplicit && !i.argument && e.report({ node: i, messageId: "expectedReturnValue", data: { name: ye.lodash.upperFirst(P.getFunctionNameWithKind(r.node)) } }));
  }, "FunctionExpression:exit": t, "ArrowFunctionExpression:exit": t };
} }, UI = { meta: { type: "layout", docs: { description: "enforce line breaks after each array element", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/array-element-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: !1 }] }], messages: { unexpectedLineBreak: "There should be no linebreak here.", missingLineBreak: "There should be a linebreak after this element." } }, create: function(e) {
  function t(o) {
    var u = function(c) {
      var f, p = !1, d = !1, m = c || "always";
      return m && m !== "always" && m.minItems !== 0 ? m === "never" ? f = a : m === "consistent" ? (p = !0, f = a) : (d = !!m.multiline, f = m.minItems || a) : f = 0, { consistent: p, multiline: d, minItems: f };
    }(o);
    return { ArrayExpression: u, ArrayPattern: u };
  }
  function n(o) {
    var u = s.getTokenBefore(o, { includeComments: !0 });
    e.report({ loc: { start: u.loc.end, end: o.loc.start }, messageId: "unexpectedLineBreak", fix: function(c) {
      if (P.isCommentToken(u))
        return null;
      if (!P.isTokenOnSameLine(u, o))
        return c.replaceTextRange([u.range[1], o.range[0]], " ");
      var f = s.getTokenBefore(u, { includeComments: !0 });
      return P.isCommentToken(f) ? null : c.replaceTextRange([f.range[1], u.range[0]], "");
    } });
  }
  function r(o) {
    var u = s.getTokenBefore(o, { includeComments: !0 });
    e.report({ loc: { start: u.loc.end, end: o.loc.start }, messageId: "missingLineBreak", fix: function(c) {
      return c.replaceTextRange([u.range[1], o.range[0]], `
`);
    } });
  }
  function i(o) {
    var u = o.elements, c = t(e.options[0])[o.type], f = !1;
    c.multiline && (f = u.filter(function(m) {
      return m !== null;
    }).some(function(m) {
      return m.loc.start.line !== m.loc.end.line;
    }));
    var p = o.elements.map(function(m, y) {
      var v = u[y - 1];
      if (y === 0 || m === null || v === null)
        return !1;
      var b = s.getFirstTokenBetween(v, m, P.isCommaToken), x = s.getTokenBefore(b), C = s.getTokenAfter(b);
      return !P.isTokenOnSameLine(x, C);
    }).filter(function(m) {
      return m === !0;
    }).length, d = u.length >= c.minItems || c.multiline && f || c.consistent && 0 < p && p < o.elements.length;
    u.forEach(function(m, y) {
      var v = u[y - 1];
      if (y !== 0 && m !== null && v !== null) {
        var b = s.getFirstTokenBetween(v, m, P.isCommaToken), x = s.getTokenBefore(b), C = s.getTokenAfter(b);
        d ? P.isTokenOnSameLine(x, C) && r(C) : !P.isTokenOnSameLine(x, C) && n(C);
      }
    });
  }
  var a = Number.POSITIVE_INFINITY, s = e.getSourceCode();
  return { ArrayPattern: i, ArrayExpression: i };
} }, qI = { meta: { type: "suggestion", docs: { description: "require braces around arrow function bodies", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/arrow-body-style" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["as-needed"] }, { type: "object", properties: { requireReturnForObjectLiteral: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { unexpectedOtherBlock: "Unexpected block statement surrounding arrow body.", unexpectedEmptyBlock: "Unexpected block statement surrounding arrow body; put a value of `undefined` immediately after the `=>`.", unexpectedObjectBlock: "Unexpected block statement surrounding arrow body; parenthesize the returned value and move it immediately after the `=>`.", unexpectedSingleBlock: "Unexpected block statement surrounding arrow body; move the returned value immediately after the `=>`.", expectedBlock: "Expected block statement surrounding arrow body." } }, create: function(e) {
  var t = e.options, n = t[0] === "always", r = !t[0] || t[0] === "as-needed", i = t[0] === "never", a = t[1] && t[1].requireReturnForObjectLiteral, s = e.getSourceCode();
  return { "ArrowFunctionExpression:exit": function(o) {
    var u = o.body;
    if (u.type === "BlockStatement") {
      var c, f = u.body;
      if (f.length !== 1 && !i || r && a && f[0].type === "ReturnStatement" && f[0].argument && f[0].argument.type === "ObjectExpression")
        return;
      (i || r && f[0].type === "ReturnStatement") && (c = f.length === 0 ? "unexpectedEmptyBlock" : 1 < f.length ? "unexpectedOtherBlock" : f[0].argument === null ? "unexpectedSingleBlock" : P.isOpeningBraceToken(s.getFirstToken(f[0], { skip: 1 })) ? "unexpectedObjectBlock" : "unexpectedSingleBlock", e.report({ node: o, loc: u.loc.start, messageId: c, fix: function(p) {
        var d = [];
        if (f.length !== 1 || f[0].type !== "ReturnStatement" || !f[0].argument || function(x) {
          return x && x.type === "Punctuator" && /^[\(\+\x2D\/\[`]/.test(x.value);
        }(s.getTokenAfter(u)))
          return d;
        var m = s.getFirstToken(u), y = s.getLastToken(u), v = s.getFirstToken(f[0], 1), b = s.getLastToken(f[0]);
        return s.commentsExistBetween(m, v) || s.commentsExistBetween(b, y) ? d.push(p.remove(m), p.remove(y), p.remove(s.getTokenAfter(m))) : d.push(p.removeRange([m.range[0], v.range[0]]), p.removeRange([b.range[1], y.range[1]])), (P.isOpeningBraceToken(v) || f[0].argument.type === "SequenceExpression") && d.push(p.insertTextBefore(v, "("), p.insertTextAfter(b, ")")), P.isSemicolonToken(b) && d.push(p.remove(b)), d;
      } }));
    } else
      (n || r && a && u.type === "ObjectExpression") && e.report({ node: o, loc: u.loc.start, messageId: "expectedBlock", fix: function(p) {
        var d = [], m = s.getTokenBefore(u, P.isArrowToken), y = s.getTokenAfter(m), v = s.getLastToken(o), b = P.isOpeningParenToken(y) && P.isOpeningBraceToken(s.getTokenAfter(y));
        return d.push(p.insertTextBefore(y, "{return "), p.insertTextAfter(v, "}")), b && d.push(p.remove(y), p.remove(function(x) {
          for (var C = s.getNodeByRangeIndex(x.range[1]); !P.isParenthesised(s, C); )
            C = C.parent;
          return s.getTokenAfter(C);
        }(y))), d;
      } });
  } };
} };
function Jl(e) {
  return { start: e.params[0].loc.start, end: e.params[e.params.length - 1].loc.end };
}
var WI = { meta: { type: "layout", docs: { description: "require parentheses around arrow function arguments", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/arrow-parens" }, fixable: "code", schema: [{ enum: ["always", "as-needed"] }, { type: "object", properties: { requireForBlockBody: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { unexpectedParens: "Unexpected parentheses around single function argument.", expectedParens: "Expected parentheses around arrow function argument.", unexpectedParensInline: "Unexpected parentheses around single function argument having a body with no curly braces.", expectedParensBlock: "Expected parentheses around arrow function argument having a body with curly braces." } }, create: function(e) {
  var t = e.options[0] === "as-needed", n = t && e.options[1] && e.options[1].requireForBlockBody === !0, r = e.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    function a(u) {
      var c = r.getTokenAfter(o), f = r.getTokenAfter(c, P.isClosingParenToken), p = s ? r.getTokenBefore(o) : null, d = p && p.range[1] === o.range[0];
      return u.replaceTextRange([o.range[0], f.range[1]], "".concat(d ? " " : "").concat(c.value));
    }
    var s = i.async, o = r.getFirstToken(i, s ? 1 : 0);
    !n || i.params.length !== 1 || i.params[0].type !== "Identifier" || i.params[0].typeAnnotation || i.body.type === "BlockStatement" || i.returnType ? n && i.body.type === "BlockStatement" ? P.isOpeningParenToken(o) || e.report({ node: i, messageId: "expectedParensBlock", loc: Jl(i), fix: function(u) {
      return u.replaceText(o, "(".concat(o.value, ")"));
    } }) : !t || i.params.length !== 1 || i.params[0].type !== "Identifier" || i.params[0].typeAnnotation || i.returnType ? o.type === "Identifier" && r.getTokenAfter(o).value !== ")" && e.report({ node: i, messageId: "expectedParens", loc: Jl(i), fix: function(u) {
      return u.replaceText(o, "(".concat(o.value, ")"));
    } }) : P.isOpeningParenToken(o) && e.report({ node: i, messageId: "unexpectedParens", loc: Jl(i), fix: a }) : P.isOpeningParenToken(o) && e.report({ node: i, messageId: "unexpectedParensInline", loc: Jl(i), fix: a });
  } };
} }, $I = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after the arrow in arrow functions", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/arrow-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: !0 }, after: { type: "boolean", default: !0 } }, additionalProperties: !1 }], messages: { expectedBefore: "Missing space before =>.", unexpectedBefore: "Unexpected space before =>.", expectedAfter: "Missing space after =>.", unexpectedAfter: "Unexpected space after =>." } }, create: function(e) {
  function t(i) {
    var a = r.getTokenBefore(i.body, P.isArrowToken);
    return { before: r.getTokenBefore(a), arrow: a, after: r.getTokenAfter(a) };
  }
  var n = Object.assign({}, e.options[0]);
  n.before = n.before !== !1, n.after = n.after !== !1;
  var r = e.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    var a = t(i), s = function(o) {
      return { before: o.arrow.range[0] - o.before.range[1], after: o.after.range[0] - o.arrow.range[1] };
    }(a);
    n.before ? s.before === 0 && e.report({ node: a.before, messageId: "expectedBefore", fix: function(o) {
      return o.insertTextBefore(a.arrow, " ");
    } }) : 0 < s.before && e.report({ node: a.before, messageId: "unexpectedBefore", fix: function(o) {
      return o.removeRange([a.before.range[1], a.arrow.range[0]]);
    } }), n.after ? s.after === 0 && e.report({ node: a.after, messageId: "expectedAfter", fix: function(o) {
      return o.insertTextAfter(a.arrow, " ");
    } }) : 0 < s.after && e.report({ node: a.after, messageId: "unexpectedAfter", fix: function(o) {
      return o.removeRange([a.arrow.range[1], a.after.range[0]]);
    } });
  } };
} }, GI = { meta: { type: "layout", docs: { description: "disallow or enforce spaces inside of blocks after opening block and before closing block", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/block-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { missing: "Requires a space {{location}} '{{token}}'.", extra: "Unexpected space(s) {{location}} '{{token}}'." } }, create: function(e) {
  function t(s, o) {
    return !P.isTokenOnSameLine(s, o) || a.isSpaceBetweenTokens(s, o) === r;
  }
  function n(s) {
    var o = function(p) {
      return p.type === "SwitchStatement" ? 0 < p.cases.length ? a.getTokenBefore(p.cases[0]) : a.getLastToken(p, 1) : a.getFirstToken(p);
    }(s), u = a.getLastToken(s), c = a.getTokenAfter(o, { includeComments: !0 }), f = a.getTokenBefore(u, { includeComments: !0 });
    o.type === "Punctuator" && o.value === "{" && u.type === "Punctuator" && u.value === "}" && c !== u && (r || c.type !== "Line") && (!t(o, c) && e.report({ node: s, loc: o.loc.start, messageId: i, data: { location: "after", token: o.value }, fix: function(p) {
      return r ? p.insertTextBefore(c, " ") : p.removeRange([o.range[1], c.range[0]]);
    } }), !t(f, u) && e.report({ node: s, loc: u.loc.start, messageId: i, data: { location: "before", token: u.value }, fix: function(p) {
      return r ? p.insertTextAfter(f, " ") : p.removeRange([f.range[1], u.range[0]]);
    } }));
  }
  var r = e.options[0] !== "never", i = r ? "missing" : "extra", a = e.getSourceCode();
  return { BlockStatement: n, SwitchStatement: n };
} }, zI = { meta: { type: "layout", docs: { description: "enforce consistent brace style for blocks", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/brace-style" }, schema: [{ enum: ["1tbs", "stroustrup", "allman"] }, { type: "object", properties: { allowSingleLine: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "whitespace", messages: { nextLineOpen: "Opening curly brace does not appear on the same line as controlling statement.", sameLineOpen: "Opening curly brace appears on the same line as controlling statement.", blockSameLine: "Statement inside of curly braces should be on next line.", nextLineClose: "Closing curly brace does not appear on the same line as the subsequent block.", singleLineClose: "Closing curly brace should be on the same line as opening curly brace or on the line after the previous block.", sameLineClose: "Closing curly brace appears on the same line as the subsequent block." } }, create: function(e) {
  function t(o, u) {
    var c = [o.range[1], u.range[0]];
    return s.text.slice(c[0], c[1]).trim() ? null : function(f) {
      return f.replaceTextRange(c, " ");
    };
  }
  function n(o, u) {
    var c = s.getTokenBefore(o), f = s.getTokenAfter(o), p = s.getTokenBefore(u), d = a.allowSingleLine && P.isTokenOnSameLine(o, u);
    i === "allman" || P.isTokenOnSameLine(c, o) || e.report({ node: o, messageId: "nextLineOpen", fix: t(c, o) }), i === "allman" && P.isTokenOnSameLine(c, o) && !d && e.report({ node: o, messageId: "sameLineOpen", fix: function(m) {
      return m.insertTextBefore(o, `
`);
    } }), P.isTokenOnSameLine(o, f) && f !== u && !d && e.report({ node: o, messageId: "blockSameLine", fix: function(m) {
      return m.insertTextAfter(o, `
`);
    } }), p !== o && !d && P.isTokenOnSameLine(p, u) && e.report({ node: u, messageId: "singleLineClose", fix: function(m) {
      return m.insertTextBefore(u, `
`);
    } });
  }
  function r(o) {
    var u = s.getTokenAfter(o);
    i !== "1tbs" || P.isTokenOnSameLine(o, u) || e.report({ node: o, messageId: "nextLineClose", fix: t(o, u) }), i !== "1tbs" && P.isTokenOnSameLine(o, u) && e.report({ node: o, messageId: "sameLineClose", fix: function(c) {
      return c.insertTextAfter(o, `
`);
    } });
  }
  var i = e.options[0] || "1tbs", a = e.options[1] || {}, s = e.getSourceCode();
  return { BlockStatement: function(o) {
    P.STATEMENT_LIST_PARENTS.has(o.parent.type) || n(s.getFirstToken(o), s.getLastToken(o));
  }, ClassBody: function(o) {
    n(s.getFirstToken(o), s.getLastToken(o));
  }, SwitchStatement: function(o) {
    var u = s.getLastToken(o);
    n(s.getTokenBefore(o.cases.length ? o.cases[0] : u), u);
  }, IfStatement: function(o) {
    o.consequent.type === "BlockStatement" && o.alternate && r(s.getLastToken(o.consequent));
  }, TryStatement: function(o) {
    r(s.getLastToken(o.block)), o.handler && o.finalizer && r(s.getLastToken(o.handler.body));
  } };
} }, HI = { meta: { type: "suggestion", docs: { description: "enforce camelcase naming convention", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/camelcase" }, schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: !1 }, ignoreImports: { type: "boolean", default: !1 }, properties: { enum: ["always", "never"] }, allow: { type: "array", items: [{ type: "string" }], minItems: 0, uniqueItems: !0 } }, additionalProperties: !1 }], messages: { notCamelCase: "Identifier '{{name}}' is not in camel case." } }, create: function(e) {
  function t(p) {
    return p.includes("_") && p !== p.toUpperCase();
  }
  function n(p) {
    return u.some(function(d) {
      return p === d || p.match(new RegExp(d, "u"));
    });
  }
  function r(p) {
    c.includes(p) || (c.push(p), e.report({ node: p, messageId: "notCamelCase", data: { name: p.name } }));
  }
  var i = e.options[0] || {}, a = i.properties || "", s = i.ignoreDestructuring, o = i.ignoreImports, u = i.allow || [];
  a !== "always" && a !== "never" && (a = "always");
  var c = [], f = /* @__PURE__ */ new Set(["CallExpression", "NewExpression"]);
  return { Identifier: function(p) {
    var d = p.name, m = t(d.replace(/^_+|_+$/g, "")), y = p.parent.type === "MemberExpression" ? p.parent.parent : p.parent;
    if (!n(d))
      if (p.parent.type === "MemberExpression") {
        if (a === "never")
          return;
        (p.parent.object.type === "Identifier" && p.parent.object.name === p.name && m || y.type === "AssignmentExpression" && m && (y.right.type !== "MemberExpression" || y.left.type === "MemberExpression" && y.left.property.name === p.name)) && r(p);
      } else if (p.parent.type === "Property" || p.parent.type === "AssignmentPattern") {
        if (p.parent.parent && p.parent.parent.type === "ObjectPattern") {
          p.parent.shorthand && p.parent.value.left && m && r(p);
          var v = p.parent.key.name === p.parent.value.name;
          if (t(d) && p.parent.computed && r(p), p.parent.key === p && p.parent.value !== p)
            return;
          p.parent.value.name && m && (!v || !s) && r(p);
        }
        if (a === "never" || s && function(b) {
          for (var x = b; x; ) {
            var C = x.parent;
            if (C && C.type === "Property" && C.computed && C.key === x)
              return !1;
            if (x.type === "ObjectPattern")
              return !0;
            x = C;
          }
          return !1;
        }(p))
          return;
        !m || f.has(y.type) || p.parent.right === p || r(p);
      } else if (["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"].includes(p.parent.type)) {
        if (p.parent.type === "ImportSpecifier" && o)
          return;
        p.parent.local && p.parent.local.name === p.name && m && r(p);
      } else
        m && !f.has(y.type) && r(p);
  } };
} }, e2 = /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|(?:\uD800(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF])|(?:\uD801(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67])|(?:\uD802(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91])|(?:\uD803(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC48])|(?:\uD804(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61])|(?:\uD805(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA])|(?:\uD806(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8])|(?:\uD808(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF98])|(?:[\uD80C\uD840-\uD868\uD86A-\uD86C](?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|(?:\uD80D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC2E])|(?:\uD81A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F])|(?:\uD81B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDF00-\uDF44\uDF50\uDF93-\uDF9F])|(?:\uD82C(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00\uDC01])|(?:\uD82F(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99])|(?:\uD835(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB])|(?:\uD83A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDCC4])|(?:\uD83B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB])|(?:\uD869(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDED6\uDF00-\uDFFF])|(?:\uD86D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF34\uDF40-\uDFFF])|(?:\uD86E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC1D])|(?:\uD87E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE1D])/, KI = P.COMMENTS_IGNORE_PATTERN, JI = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/g, QI = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:[\0-\x08\x0E-\x1F!"\$-\.0-9;->@-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+:\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Hd = { type: "object", properties: { ignorePattern: { type: "string" }, ignoreInlineComments: { type: "boolean" }, ignoreConsecutiveComments: { type: "boolean" } }, additionalProperties: !1 }, XI = { ignorePattern: "", ignoreInlineComments: !1, ignoreConsecutiveComments: !1 };
function t2(e, t) {
  return Object.assign({}, XI, e[t] || e);
}
var YI = { meta: { type: "suggestion", docs: { description: "enforce or disallow capitalization of the first letter of a comment", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/capitalized-comments" }, fixable: "code", schema: [{ enum: ["always", "never"] }, { oneOf: [Hd, { type: "object", properties: { line: Hd, block: Hd }, additionalProperties: !1 }] }], messages: { unexpectedLowercaseComment: "Comments should not begin with a lowercase character.", unexpectedUppercaseComment: "Comments should not begin with an uppercase character." } }, create: function(e) {
  function t(u) {
    var c = o.getTokenBefore(u, { includeComments: !0 }), f = o.getTokenAfter(u, { includeComments: !0 });
    return !(!c || !f || u.loc.start.line !== c.loc.end.line || u.loc.end.line !== f.loc.start.line);
  }
  function n(u) {
    var c = o.getTokenBefore(u, { includeComments: !0 });
    return !(!c || ["Block", "Line"].indexOf(c.type) === -1);
  }
  function r(u, c) {
    if (KI.test(u.value))
      return !0;
    var f = u.value.replace(/\*/g, "");
    if (c.ignorePatternRegExp && c.ignorePatternRegExp.test(f) || c.ignoreInlineComments && t(u) || c.ignoreConsecutiveComments && n(u) || QI.test(f))
      return !0;
    var p = f.replace(JI, "");
    if (p.length === 0)
      return !0;
    var d = p[0];
    if (!e2.test(d))
      return !0;
    var m = d !== d.toLocaleLowerCase(), y = d !== d.toLocaleUpperCase();
    return !(a === "always" && y || a === "never" && m);
  }
  function i(u) {
    var c = s[u.type];
    if (!r(u, c)) {
      var f = a === "always" ? "unexpectedLowercaseComment" : "unexpectedUppercaseComment";
      e.report({ node: null, loc: u.loc, messageId: f, fix: function(p) {
        var d = u.value.match(e2);
        return p.replaceTextRange([u.range[0] + d.index + 2, u.range[0] + d.index + 3], a === "always" ? d[0].toLocaleUpperCase() : d[0].toLocaleLowerCase());
      } });
    }
  }
  var a = e.options[0] || "always", s = function() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { Line: t2(u, "line"), Block: t2(u, "block") };
  }(e.options[1]), o = e.getSourceCode();
  return function(u) {
    Object.keys(u).forEach(function(c) {
      var f = u[c].ignorePattern;
      if (f) {
        var p = RegExp("^\\s*(?:".concat(f, ")"), "u");
        u[c].ignorePatternRegExp = p;
      }
    });
  }(s), { Program: function() {
    o.getAllComments().filter(function(u) {
      return u.type !== "Shebang";
    }).forEach(i);
  } };
} }, ZI = { meta: { type: "suggestion", docs: { description: "enforce that class methods utilize `this`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/class-methods-use-this" }, schema: [{ type: "object", properties: { exceptMethods: { type: "array", items: { type: "string" } } }, additionalProperties: !1 }], messages: { missingThis: "Expected 'this' to be used by class {{name}}." } }, create: function(e) {
  function t() {
    o.push(!1);
  }
  function n(u) {
    return function(c) {
      return !c.static && c.kind !== "constructor" && c.type === "MethodDefinition";
    }(u) && (u.computed || !s.has(u.key.name));
  }
  function r(u) {
    var c = o.pop();
    n(u.parent) && !c && e.report({ node: u, messageId: "missingThis", data: { name: P.getFunctionNameWithKind(u) } });
  }
  function i() {
    o.length && (o[o.length - 1] = !0);
  }
  var a = Object.assign({}, e.options[0]), s = new Set(a.exceptMethods || []), o = [];
  return { FunctionDeclaration: t, "FunctionDeclaration:exit": r, FunctionExpression: t, "FunctionExpression:exit": r, ThisExpression: i, Super: i };
} }, fs = Object.freeze({ arrays: "never", objects: "never", imports: "never", exports: "never", functions: "never" }), e5 = { meta: { type: "layout", docs: { description: "require or disallow trailing commas", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/comma-dangle" }, fixable: "code", schema: { definitions: { value: { enum: ["always-multiline", "always", "never", "only-multiline"] }, valueWithIgnore: { enum: ["always-multiline", "always", "ignore", "never", "only-multiline"] } }, type: "array", items: [{ oneOf: [{ $ref: "#/definitions/value" }, { type: "object", properties: { arrays: { $ref: "#/definitions/valueWithIgnore" }, objects: { $ref: "#/definitions/valueWithIgnore" }, imports: { $ref: "#/definitions/valueWithIgnore" }, exports: { $ref: "#/definitions/valueWithIgnore" }, functions: { $ref: "#/definitions/valueWithIgnore" } }, additionalProperties: !1 }] }] }, messages: { unexpected: "Unexpected trailing comma.", missing: "Missing trailing comma." } }, create: function(e) {
  function t(c) {
    switch (c.type) {
      case "ObjectExpression":
      case "ObjectPattern":
        return ye.lodash.last(c.properties);
      case "ArrayExpression":
      case "ArrayPattern":
        return ye.lodash.last(c.elements);
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
        return ye.lodash.last(c.specifiers);
      case "FunctionDeclaration":
      case "FunctionExpression":
      case "ArrowFunctionExpression":
        return ye.lodash.last(c.params);
      case "CallExpression":
      case "NewExpression":
        return ye.lodash.last(c.arguments);
      default:
        return null;
    }
  }
  function n(c, f) {
    switch (c.type) {
      case "ObjectExpression":
      case "ArrayExpression":
      case "CallExpression":
      case "NewExpression":
        return o.getLastToken(c, 1);
      default:
        var p = o.getTokenAfter(f);
        return P.isCommaToken(p) ? p : o.getLastToken(f);
    }
  }
  function r(c) {
    var f = t(c);
    if (!f)
      return !1;
    var p = n(c, f);
    return o.getTokenAfter(p).loc.end.line !== p.loc.end.line;
  }
  function i(c) {
    var f = t(c);
    if (f && (c.type !== "ImportDeclaration" || f.type === "ImportSpecifier")) {
      var p = n(c, f);
      P.isCommaToken(p) && e.report({ node: f, loc: p.loc, messageId: "unexpected", fix: function(d) {
        return d.remove(p);
      } });
    }
  }
  function a(c) {
    var f = t(c);
    if (f && (c.type !== "ImportDeclaration" || f.type === "ImportSpecifier"))
      if (function(d) {
        return d.type !== "RestElement" && d.type !== "RestProperty" && d.type !== "ExperimentalRestProperty";
      }(f)) {
        var p = n(c, f);
        p.value !== "," && e.report({ node: f, loc: { start: p.loc.end, end: P.getNextLocation(o, p.loc.end) }, messageId: "missing", fix: function(d) {
          return d.insertTextAfter(p, ",");
        } });
      } else
        i(c);
  }
  var s = function(c, f) {
    return typeof c == "string" ? { arrays: c, objects: c, imports: c, exports: c, functions: !f || 8 > f ? "ignore" : c } : xe(c) == "object" && c !== null ? { arrays: c.arrays || fs.arrays, objects: c.objects || fs.objects, imports: c.imports || fs.imports, exports: c.exports || fs.exports, functions: c.functions || fs.functions } : fs;
  }(e.options[0], e.parserOptions.ecmaVersion), o = e.getSourceCode(), u = { always: a, "always-multiline": function(c) {
    r(c) ? a(c) : i(c);
  }, "only-multiline": function(c) {
    r(c) || i(c);
  }, never: i, ignore: ye.lodash.noop };
  return { ObjectExpression: u[s.objects], ObjectPattern: u[s.objects], ArrayExpression: u[s.arrays], ArrayPattern: u[s.arrays], ImportDeclaration: u[s.imports], ExportNamedDeclaration: u[s.exports], FunctionDeclaration: u[s.functions], FunctionExpression: u[s.functions], ArrowFunctionExpression: u[s.functions], CallExpression: u[s.functions], NewExpression: u[s.functions] };
} }, t5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after commas", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/comma-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: !1 }, after: { type: "boolean", default: !0 } }, additionalProperties: !1 }], messages: { missing: "A space is required {{loc}} ','.", unexpected: "There should be no space {{loc}} ','." } }, create: function(e) {
  function t(u, c, f) {
    e.report({ node: u, fix: function(p) {
      return s[c] ? c === "before" ? p.insertTextBefore(u, " ") : p.insertTextAfter(u, " ") : (c === "before" ? (d = f.range[1], m = u.range[0]) : (d = u.range[1], m = f.range[0]), p.replaceTextRange([d, m], ""));
      var d, m;
    }, messageId: s[c] ? "missing" : "unexpected", data: { loc: c } });
  }
  function n(u, c) {
    u.left && P.isTokenOnSameLine(u.left, u.comma) && s.before !== i.isSpaceBetweenTokens(u.left, u.comma) && t(c, "before", u.left), u.right && P.isClosingParenToken(u.right) || u.right && !s.after && u.right.type === "Line" || u.right && P.isTokenOnSameLine(u.comma, u.right) && s.after !== i.isSpaceBetweenTokens(u.comma, u.right) && t(c, "after", u.right);
  }
  function r(u) {
    var c = i.getFirstToken(u);
    u.elements.forEach(function(f) {
      var p;
      f === null ? (p = i.getTokenAfter(c), P.isCommaToken(p) && o.push(p)) : p = i.getTokenAfter(f), c = p;
    });
  }
  var i = e.getSourceCode(), a = i.tokensAndComments, s = { before: !!e.options[0] && e.options[0].before, after: !e.options[0] || e.options[0].after }, o = [];
  return { "Program:exit": function() {
    a.forEach(function(u, c) {
      if (P.isCommaToken(u) && (!u || u.type !== "JSXText")) {
        var f = a[c - 1], p = a[c + 1];
        n({ comma: u, left: P.isCommaToken(f) || -1 < o.indexOf(u) ? null : f, right: P.isCommaToken(p) ? null : p }, u);
      }
    });
  }, ArrayExpression: r, ArrayPattern: r };
} }, n5 = { meta: { type: "layout", docs: { description: "enforce consistent comma style", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/comma-style" }, fixable: "code", schema: [{ enum: ["first", "last"] }, { type: "object", properties: { exceptions: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: !1 }], messages: { unexpectedLineBeforeAndAfterComma: "Bad line breaking before and after ','.", expectedCommaFirst: "',' should be placed first.", expectedCommaLast: "',' should be placed last." } }, create: function(e) {
  function t(f, p, d, m) {
    var y = a.text.slice(p.range[1], d.range[0]) + a.text.slice(d.range[1], m.range[0]), v = [p.range[1], m.range[0]];
    return function(b) {
      return b.replaceTextRange(v, function(x, C) {
        return x === "between" ? ",".concat(C.replace(P.LINEBREAK_MATCHER, "")) : x === "first" ? "".concat(C, ",") : x === "last" ? ",".concat(C) : "";
      }(f, y));
    };
  }
  function n(f, p, d, m) {
    if (!(P.isTokenOnSameLine(p, d) && P.isTokenOnSameLine(f, p)))
      if (P.isTokenOnSameLine(p, d) || P.isTokenOnSameLine(f, p))
        i !== "first" || P.isTokenOnSameLine(p, d) ? i === "last" && P.isTokenOnSameLine(p, d) && e.report({ node: m, loc: { line: p.loc.end.line, column: p.loc.end.column }, messageId: "expectedCommaLast", fix: t(i, f, p, d) }) : e.report({ node: m, messageId: "expectedCommaFirst", fix: t(i, f, p, d) });
      else {
        var y = a.getCommentsAfter(p)[0], v = y && y.type === "Block" && P.isTokenOnSameLine(p, y) ? i : "between";
        e.report({ node: m, loc: { line: p.loc.end.line, column: p.loc.start.column }, messageId: "unexpectedLineBeforeAndAfterComma", fix: t(v, f, p, d) });
      }
  }
  function r(f, p) {
    var d = f[p], m = f.type === "ArrayExpression" || f.type === "ArrayPattern";
    if (1 < d.length || m) {
      var y = a.getFirstToken(f);
      if (d.forEach(function(x) {
        var C = x ? a.getTokenBefore(x) : y, k = x ? a.getFirstToken(x) : a.getTokenAfter(C);
        if (P.isCommaToken(C) && n(y, C, k, x || k), x) {
          var F = a.getTokenAfter(x, P.isNotClosingParenToken);
          y = F ? a.getTokenBefore(F) : a.ast.tokens[a.ast.tokens.length - 1];
        }
      }), m) {
        var v = a.getLastToken(f), b = a.getTokenBefore(v);
        P.isCommaToken(b) && n(a.getTokenBefore(b), b, v, v);
      }
    }
  }
  var i = e.options[0] || "last", a = e.getSourceCode(), s = { ArrayPattern: !0, ArrowFunctionExpression: !0, CallExpression: !0, FunctionDeclaration: !0, FunctionExpression: !0, ImportDeclaration: !0, ObjectPattern: !0, NewExpression: !0 };
  if (e.options.length === 2 && Object.prototype.hasOwnProperty.call(e.options[1], "exceptions"))
    for (var o = Object.keys(e.options[1].exceptions), u = 0; u < o.length; u++)
      s[o[u]] = e.options[1].exceptions[o[u]];
  var c = {};
  return s.VariableDeclaration || (c.VariableDeclaration = function(f) {
    r(f, "declarations");
  }), s.ObjectExpression || (c.ObjectExpression = function(f) {
    r(f, "properties");
  }), s.ObjectPattern || (c.ObjectPattern = function(f) {
    r(f, "properties");
  }), s.ArrayExpression || (c.ArrayExpression = function(f) {
    r(f, "elements");
  }), s.ArrayPattern || (c.ArrayPattern = function(f) {
    r(f, "elements");
  }), s.FunctionDeclaration || (c.FunctionDeclaration = function(f) {
    r(f, "params");
  }), s.FunctionExpression || (c.FunctionExpression = function(f) {
    r(f, "params");
  }), s.ArrowFunctionExpression || (c.ArrowFunctionExpression = function(f) {
    r(f, "params");
  }), s.CallExpression || (c.CallExpression = function(f) {
    r(f, "arguments");
  }), s.ImportDeclaration || (c.ImportDeclaration = function(f) {
    r(f, "specifiers");
  }), s.NewExpression || (c.NewExpression = function(f) {
    r(f, "arguments");
  }), c;
} }, r5 = { meta: { type: "suggestion", docs: { description: "enforce a maximum cyclomatic complexity allowed in a program", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/complexity" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }], messages: { complex: "{{name}} has a complexity of {{complexity}}. Maximum allowed is {{max}}." } }, create: function(e) {
  function t() {
    s.push(1);
  }
  function n(o) {
    var u = ye.lodash.upperFirst(P.getFunctionNameWithKind(o)), c = s.pop();
    c > a && e.report({ node: o, messageId: "complex", data: { name: u, complexity: c, max: a } });
  }
  function r() {
    s.length && s[s.length - 1]++;
  }
  var i = e.options[0], a = 20;
  xe(i) == "object" && (Object.prototype.hasOwnProperty.call(i, "maximum") || Object.prototype.hasOwnProperty.call(i, "max")) ? a = i.maximum || i.max : typeof i == "number" && (a = i);
  var s = [];
  return { FunctionDeclaration: t, FunctionExpression: t, ArrowFunctionExpression: t, "FunctionDeclaration:exit": n, "FunctionExpression:exit": n, "ArrowFunctionExpression:exit": n, CatchClause: r, ConditionalExpression: r, LogicalExpression: r, ForStatement: r, ForInStatement: r, ForOfStatement: r, IfStatement: r, SwitchCase: function(o) {
    o.test && r();
  }, WhileStatement: r, DoWhileStatement: r };
} }, i5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside computed property brackets", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/computed-property-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { enforceForClassMembers: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'." } }, create: function(e) {
  function t(f, p, d) {
    e.report({ node: f, loc: p.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: p.value }, fix: function(m) {
      return m.removeRange([p.range[1], d.range[0]]);
    } });
  }
  function n(f, p, d) {
    e.report({ node: f, loc: p.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: p.value }, fix: function(m) {
      return m.removeRange([d.range[1], p.range[0]]);
    } });
  }
  function r(f, p) {
    e.report({ node: f, loc: p.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: p.value }, fix: function(d) {
      return d.insertTextAfter(p, " ");
    } });
  }
  function i(f, p) {
    e.report({ node: f, loc: p.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: p.value }, fix: function(d) {
      return d.insertTextBefore(p, " ");
    } });
  }
  function a(f) {
    return function(p) {
      if (p.computed) {
        var d = p[f], m = s.getTokenBefore(d, P.isOpeningBracketToken), y = s.getTokenAfter(m, { includeComments: !0 }), v = s.getTokenAfter(d, P.isClosingBracketToken), b = s.getTokenBefore(v, { includeComments: !0 });
        P.isTokenOnSameLine(m, y) && (o ? !s.isSpaceBetweenTokens(m, y) && P.isTokenOnSameLine(m, y) && r(p, m) : s.isSpaceBetweenTokens(m, y) && t(p, m, y)), P.isTokenOnSameLine(b, v) && (o ? !s.isSpaceBetweenTokens(b, v) && P.isTokenOnSameLine(b, v) && i(p, v) : s.isSpaceBetweenTokens(b, v) && n(p, v, b));
      }
    };
  }
  var s = e.getSourceCode(), o = e.options[0] === "always", u = e.options[1] && e.options[1].enforceForClassMembers, c = { Property: a("key"), MemberExpression: a("property") };
  return u && (c.MethodDefinition = a("key")), c;
} };
function a5(e) {
  return !e.reachable;
}
var o5 = { meta: { type: "suggestion", docs: { description: "require `return` statements to either always or never specify values", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/consistent-return" }, schema: [{ type: "object", properties: { treatUndefinedAsUnspecified: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { missingReturn: "Expected to return a value at the end of {{name}}.", missingReturnValue: "{{name}} expected a return value.", unexpectedReturnValue: "{{name}} expected no return value." } }, create: function(e) {
  function t(i) {
    var a, s;
    !r.hasReturnValue || r.codePath.currentSegments.every(a5) || P.isES5Constructor(i) || function(o) {
      return o.type === "FunctionExpression" && o.parent && o.parent.type === "MethodDefinition" && o.parent.kind === "constructor";
    }(i) || (i.type === "Program" ? (a = { line: 1, column: 0 }, s = "program") : a = i.type === "ArrowFunctionExpression" ? e.getSourceCode().getTokenBefore(i.body, P.isArrowToken).loc.start : i.parent.type === "MethodDefinition" || i.parent.type === "Property" && i.parent.method ? i.parent.key.loc.start : (i.id || i).loc.start, !s && (s = P.getFunctionNameWithKind(i)), e.report({ node: i, loc: a, messageId: "missingReturn", data: { name: s } }));
  }
  var n = (e.options[0] || {}).treatUndefinedAsUnspecified === !0, r = null;
  return { onCodePathStart: function(i, a) {
    r = { upper: r, codePath: i, hasReturn: !1, hasReturnValue: !1, messageId: "", node: a };
  }, onCodePathEnd: function() {
    r = r.upper;
  }, ReturnStatement: function(i) {
    var a = i.argument, s = !!a;
    n && s && (s = !function(o, u) {
      return o.type === "Identifier" && o.name === u;
    }(a, "undefined") && a.operator !== "void"), r.hasReturn ? r.hasReturnValue !== s && e.report({ node: i, messageId: r.messageId, data: r.data }) : (r.hasReturn = !0, r.hasReturnValue = s, r.messageId = s ? "missingReturnValue" : "unexpectedReturnValue", r.data = { name: r.node.type === "Program" ? "Program" : ye.lodash.upperFirst(P.getFunctionNameWithKind(r.node)) });
  }, "Program:exit": t, "FunctionDeclaration:exit": t, "FunctionExpression:exit": t, "ArrowFunctionExpression:exit": t };
} };
function s5(e) {
  return e.reachable;
}
function Ao(e) {
  if (!e)
    return !1;
  switch (e.type) {
    case "ClassExpression":
    case "FunctionExpression":
    case "ThisExpression":
    case "MemberExpression":
    case "CallExpression":
    case "NewExpression":
    case "YieldExpression":
    case "TaggedTemplateExpression":
    case "MetaProperty":
      return !0;
    case "Identifier":
      return e.name !== "undefined";
    case "AssignmentExpression":
      return Ao(e.right);
    case "LogicalExpression":
      return Ao(e.left) || Ao(e.right);
    case "ConditionalExpression":
      return Ao(e.alternate) || Ao(e.consequent);
    case "SequenceExpression":
      return Ao(e.expressions[e.expressions.length - 1]);
    default:
      return !1;
  }
}
var u5 = { meta: { type: "problem", docs: { description: "require `super()` calls in constructors", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/constructor-super" }, schema: [], messages: { missingSome: "Lacked a call of 'super()' in some code paths.", missingAll: "Expected to call 'super()'.", duplicate: "Unexpected duplicate 'super()'.", badSuper: "Unexpected 'super()' because 'super' is not a constructor.", unexpected: "Unexpected 'super()'." } }, create: function(e) {
  function t(a) {
    return a.reachable && i[a.id].calledInSomePaths;
  }
  function n(a) {
    return !(a.nextSegments.length !== 1 || !a.nextSegments[0].isLoopedPrevSegment(a)) || a.reachable && i[a.id].calledInEveryPaths;
  }
  var r = null, i = /* @__PURE__ */ Object.create(null);
  return { onCodePathStart: function(a, s) {
    if (function(u) {
      return u.type === "FunctionExpression" && u.parent.type === "MethodDefinition" && u.parent.kind === "constructor";
    }(s)) {
      var o = s.parent.parent.parent.superClass;
      r = { upper: r, isConstructor: !0, hasExtends: !!o, superIsConstructor: Ao(o), codePath: a };
    } else
      r = { upper: r, isConstructor: !1, hasExtends: !1, superIsConstructor: !1, codePath: a };
  }, onCodePathEnd: function(a, s) {
    var o = r.hasExtends;
    if (r = r.upper, o) {
      var u = a.returnedSegments, c = u.every(n), f = u.some(t);
      c || e.report({ messageId: f ? "missingSome" : "missingAll", node: s.parent });
    }
  }, onCodePathSegmentStart: function(a) {
    if (r && r.isConstructor && r.hasExtends) {
      var s = i[a.id] = { calledInSomePaths: !1, calledInEveryPaths: !1, validNodes: [] }, o = a.prevSegments;
      0 < o.length && (s.calledInSomePaths = o.some(t), s.calledInEveryPaths = o.every(n));
    }
  }, onCodePathSegmentLoop: function(a, s) {
    if (r && r.isConstructor && r.hasExtends) {
      var o = 2 <= s.prevSegments.length;
      r.codePath.traverseSegments({ first: s, last: a }, function(u) {
        var c = i[u.id], f = u.prevSegments;
        if (c.calledInSomePaths = f.some(t), c.calledInEveryPaths = f.every(n), c.calledInSomePaths || o) {
          var p = c.validNodes;
          c.validNodes = [];
          for (var d = 0; d < p.length; ++d) {
            var m = p[d];
            e.report({ messageId: "duplicate", node: m });
          }
        }
      });
    }
  }, "CallExpression:exit": function(a) {
    if (r && r.isConstructor && a.callee.type === "Super")
      if (r.hasExtends) {
        for (var s = r.codePath.currentSegments, o = !1, u = null, c = 0; c < s.length; ++c) {
          var f = s[c];
          f.reachable && (u = i[f.id], o = o || u.calledInSomePaths, u.calledInSomePaths = u.calledInEveryPaths = !0);
        }
        u && (o ? e.report({ messageId: "duplicate", node: a }) : r.superIsConstructor ? u.validNodes.push(a) : e.report({ messageId: "badSuper", node: a }));
      } else
        r.codePath.currentSegments.some(s5) && e.report({ messageId: "unexpected", node: a });
  }, ReturnStatement: function(a) {
    if (r && r.isConstructor && r.hasExtends && a.argument)
      for (var s = r.codePath.currentSegments, o = 0; o < s.length; ++o) {
        var u = s[o];
        if (u.reachable) {
          var c = i[u.id];
          c.calledInSomePaths = c.calledInEveryPaths = !0;
        }
      }
  }, "Program:exit": function() {
    i = /* @__PURE__ */ Object.create(null);
  } };
} }, c5 = { meta: { type: "suggestion", docs: { description: "enforce consistent brace style for all control statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/curly" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["all"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["multi", "multi-line", "multi-or-nest"] }, { enum: ["consistent"] }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { missingCurlyAfter: "Expected { after '{{name}}'.", missingCurlyAfterCondition: "Expected { after '{{name}}' condition.", unexpectedCurlyAfter: "Unnecessary { after '{{name}}'.", unexpectedCurlyAfterCondition: "Unnecessary { after '{{name}}' condition." } }, create: function(e) {
  function t(p) {
    if (p.type === "EmptyStatement")
      return !0;
    var d = f.getFirstToken(p), m = f.getLastToken(p), y = P.isSemicolonToken(m) ? f.getTokenBefore(m) : m;
    return d.loc.start.line === y.loc.end.line;
  }
  function n(p) {
    return p.type === "VariableDeclaration" ? p.kind === "const" || p.kind === "let" : p.type === "FunctionDeclaration" || p.type === "ClassDeclaration";
  }
  function r(p) {
    return p.value === "else" && p.type === "Keyword";
  }
  function i(p) {
    return p.alternate && f.getFirstTokenBetween(p.consequent, p.alternate, r);
  }
  function a(p, d, m, y) {
    var v = d.type === "BlockStatement", b = null;
    if (p.type === "IfStatement" && p.consequent === d && function(C) {
      if (C.alternate && C.consequent.type === "BlockStatement") {
        if (2 <= C.consequent.body.length)
          return !0;
        for (var k = C.consequent.body[0]; k; k = P.getTrailingStatement(k))
          if (k.type === "IfStatement" && !k.alternate)
            return !0;
      }
      return !1;
    }(p))
      b = !0;
    else if (s)
      v && d.body.length === 1 && !n(d.body[0]) && (b = !1);
    else if (o)
      (function(C) {
        var k = f.getTokenBefore(C), F = f.getLastToken(C), B = P.isSemicolonToken(F) ? f.getTokenBefore(F) : F;
        return k.loc.start.line === B.loc.end.line;
      })(d) || (b = !0);
    else if (u)
      if (v && d.body.length === 1 && t(d.body[0])) {
        var x = f.getCommentsBefore(d.body[0]);
        b = !!n(d.body[0]) || 0 < x.length;
      } else
        t(d) || (b = !0);
    else
      b = !0;
    return { actual: v, expected: b, check: function() {
      this.expected !== null && this.expected !== this.actual && (this.expected ? e.report({ node: p, loc: (m === "else" ? i(p) : p).loc.start, messageId: y && y.condition ? "missingCurlyAfterCondition" : "missingCurlyAfter", data: { name: m }, fix: function(C) {
        return C.replaceText(d, "{".concat(f.getText(d), "}"));
      } }) : e.report({ node: p, loc: (m === "else" ? i(p) : p).loc.start, messageId: y && y.condition ? "unexpectedCurlyAfterCondition" : "unexpectedCurlyAfter", data: { name: m }, fix: function(C) {
        var k = p.type === "DoWhileStatement" && f.getTokenBefore(d).range[1] === d.range[0] && !P.canTokensBeAdjacent("do", f.getFirstToken(d, { skip: 1 })), F = f.getFirstToken(d), B = f.getLastToken(d), O = f.getTokenBefore(B);
        if (function(w) {
          var D = f.getTokenBefore(w), I = f.getTokenAfter(w), L = f.getNodeByRangeIndex(D.range[0]);
          return !(P.isSemicolonToken(D) || !I || L.type === "BlockStatement" && L.parent.type !== "FunctionExpression" && L.parent.type !== "ArrowFunctionExpression" || D.loc.end.line !== I.loc.start.line && !/^[\(\+\x2D\/\[`]/.test(I.value) && (D.type !== "Punctuator" || D.value !== "++" && D.value !== "--"));
        }(B))
          return null;
        var S = f.getText().slice(F.range[1], O.range[0]) + f.getText(O) + f.getText().slice(O.range[1], B.range[0]);
        return C.replaceText(d, (k ? " " : "") + S);
      } }));
    } };
  }
  var s = e.options[0] === "multi", o = e.options[0] === "multi-line", u = e.options[0] === "multi-or-nest", c = e.options[1] === "consistent", f = e.getSourceCode();
  return { IfStatement: function(p) {
    p.parent.type !== "IfStatement" && function(d) {
      for (var m = [], y = d; y; y = y.alternate)
        if (m.push(a(y, y.consequent, "if", { condition: !0 })), y.alternate && y.alternate.type !== "IfStatement") {
          m.push(a(y, y.alternate, "else"));
          break;
        }
      if (c) {
        var v = m.some(function(b) {
          return b.expected === null ? b.actual : b.expected;
        });
        m.forEach(function(b) {
          b.expected = v;
        });
      }
      return m;
    }(p).forEach(function(d) {
      d.check();
    });
  }, WhileStatement: function(p) {
    a(p, p.body, "while", { condition: !0 }).check();
  }, DoWhileStatement: function(p) {
    a(p, p.body, "do").check();
  }, ForStatement: function(p) {
    a(p, p.body, "for", { condition: !0 }).check();
  }, ForInStatement: function(p) {
    a(p, p.body, "for-in").check();
  }, ForOfStatement: function(p) {
    a(p, p.body, "for-of").check();
  } };
} }, l5 = /^no default$/i, p5 = { meta: { type: "suggestion", docs: { description: "require `default` cases in `switch` statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/default-case" }, schema: [{ type: "object", properties: { commentPattern: { type: "string" } }, additionalProperties: !1 }], messages: { missingDefaultCase: "Expected a default case." } }, create: function(e) {
  function t(a) {
    return a[a.length - 1];
  }
  var n = e.options[0] || {}, r = n.commentPattern ? new RegExp(n.commentPattern, "u") : l5, i = e.getSourceCode();
  return { SwitchStatement: function(a) {
    if (a.cases.length && !a.cases.some(function(c) {
      return c.test === null;
    })) {
      var s, o = t(a.cases), u = i.getCommentsAfter(o);
      u.length && (s = t(u)), s && r.test(s.value.trim()) || e.report({ node: a, messageId: "missingDefaultCase" });
    }
  } };
} }, f5 = { meta: { type: "layout", docs: { description: "enforce consistent newlines before and after dots", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/dot-location" }, schema: [{ enum: ["object", "property"] }], fixable: "code", messages: { expectedDotAfterObject: "Expected dot to be on same line as object.", expectedDotBeforeProperty: "Expected dot to be on same line as property." } }, create: function(e) {
  function t(a) {
    var s = a.property, o = i.getTokenBefore(s), u = i.getTokenBefore(o), c = i.getText().slice(u.range[1], o.range[0]), f = i.getText().slice(o.range[1], s.range[0]);
    if (r) {
      if (!P.isTokenOnSameLine(u, o)) {
        var p = P.isDecimalIntegerNumericToken(u) ? " " : "";
        e.report({ node: a, loc: o.loc, messageId: "expectedDotAfterObject", fix: function(d) {
          return d.replaceTextRange([u.range[1], s.range[0]], "".concat(p, ".").concat(c).concat(f));
        } });
      }
    } else
      P.isTokenOnSameLine(o, s) || e.report({ node: a, loc: o.loc, messageId: "expectedDotBeforeProperty", fix: function(d) {
        return d.replaceTextRange([u.range[1], s.range[0]], "".concat(c).concat(f, "."));
      } });
  }
  var n = e.options[0], r = n === "object" || !n, i = e.getSourceCode();
  return { MemberExpression: function(a) {
    a.computed || t(a);
  } };
} }, Qp = ["abstract", "boolean", "break", "byte", "case", "catch", "char", "class", "const", "continue", "debugger", "default", "delete", "do", "double", "else", "enum", "export", "extends", "false", "final", "finally", "float", "for", "function", "goto", "if", "implements", "import", "in", "instanceof", "int", "interface", "long", "native", "new", "null", "package", "private", "protected", "public", "return", "short", "static", "super", "switch", "synchronized", "this", "throw", "throws", "transient", "true", "try", "typeof", "var", "void", "volatile", "while", "with"], h5 = /^[\$A-Z_a-z][\$0-9A-Z_a-z]*$/, d5 = /* @__PURE__ */ new Set(["string", "boolean"]), m5 = { meta: { type: "suggestion", docs: { description: "enforce dot notation whenever possible", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/dot-notation" }, schema: [{ type: "object", properties: { allowKeywords: { type: "boolean", default: !0 }, allowPattern: { type: "string", default: "" } }, additionalProperties: !1 }], fixable: "code", messages: { useDot: "[{{key}}] is better written in dot notation.", useBrackets: ".{{key}} is a syntax error." } }, create: function(e) {
  function t(s, o) {
    if (h5.test(o) && (i || Qp.indexOf(o + "") === -1) && (!n || !n.test(o))) {
      var u = s.property.type === "Literal" ? JSON.stringify(o) : "`".concat(o, "`");
      e.report({ node: s.property, messageId: "useDot", data: { key: u }, fix: function(c) {
        var f = a.getTokenAfter(s.object, P.isOpeningBracketToken), p = a.getLastToken(s);
        if (a.getFirstTokenBetween(f, p, { includeComments: !0, filter: P.isCommentToken }))
          return null;
        var d = a.getTokenAfter(p), m = d && p.range[1] === d.range[0] && !P.canTokensBeAdjacent(o + "", d), y = P.isDecimalInteger(s.object) ? " " : "", v = m ? " " : "";
        return c.replaceTextRange([f.range[0], p.range[1]], "".concat(y, ".").concat(o).concat(v));
      } });
    }
  }
  var n, r = e.options[0] || {}, i = r.allowKeywords === void 0 || r.allowKeywords, a = e.getSourceCode();
  return r.allowPattern && (n = new RegExp(r.allowPattern, "u")), { MemberExpression: function(s) {
    s.computed && s.property.type === "Literal" && (d5.has(xe(s.property.value)) || P.isNullLiteral(s.property)) && t(s, s.property.value), s.computed && s.property.type === "TemplateLiteral" && s.property.expressions.length === 0 && t(s, s.property.quasis[0].value.cooked), i || s.computed || Qp.indexOf(s.property.name + "") === -1 || e.report({ node: s.property, messageId: "useBrackets", data: { key: s.property.name }, fix: function(o) {
      var u = a.getTokenBefore(s.property), c = a.text.slice(u.range[1], s.property.range[0]);
      return c.trim() || s.object.type === "Identifier" && s.object.name === "let" ? null : o.replaceTextRange([u.range[0], s.property.range[1]], "[".concat(c, '"').concat(s.property.name, '"]'));
    } });
  } };
} }, g5 = { meta: { type: "layout", docs: { description: "require or disallow newline at the end of files", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/eol-last" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "unix", "windows"] }], messages: { missing: "Newline required at end of file but not found.", unexpected: "Newline not allowed at end of file." } }, create: function(e) {
  return { Program: function(t) {
    var n = e.getSourceCode(), r = n.getText(), i = { column: ye.lodash.last(n.lines).length, line: n.lines.length }, a = ye.lodash.endsWith(r, `
`);
    if (r.length) {
      var s = e.options[0] || "always", o = !1;
      s === "unix" && (s = "always"), s === "windows" && (s = "always", o = !0), s !== "always" || a ? s === "never" && a && e.report({ node: t, loc: i, messageId: "unexpected", fix: function(u) {
        var c = /(?:\r?\n)+$/.exec(n.text).index, f = n.text.length;
        return u.replaceTextRange([c, f], "");
      } }) : e.report({ node: t, loc: i, messageId: "missing", fix: function(u) {
        return u.insertTextAfterRange([0, r.length], o ? "\r".concat(`
`) : `
`);
      } });
    }
  } };
} }, y5 = { meta: { type: "suggestion", docs: { description: "require the use of `===` and `!==`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/eqeqeq" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { null: { enum: ["always", "never", "ignore"] } }, additionalProperties: !1 }], additionalItems: !1 }, { type: "array", items: [{ enum: ["smart", "allow-null"] }], additionalItems: !1 }] }, fixable: "code", messages: { unexpected: "Expected '{{expectedOperator}}' and instead saw '{{actualOperator}}'." } }, create: function(e) {
  function t(c) {
    return c.type === "UnaryExpression" && c.operator === "typeof";
  }
  function n(c) {
    return t(c.left) || t(c.right);
  }
  function r(c) {
    return c.left.type === "Literal" && c.right.type === "Literal" && xe(c.left.value) == xe(c.right.value);
  }
  function i(c, f) {
    var p = o.getFirstTokenBetween(c.left, c.right, function(d) {
      return d.value === c.operator;
    });
    e.report({ node: c, loc: p.loc, messageId: "unexpected", data: { expectedOperator: f, actualOperator: c.operator }, fix: function(d) {
      return n(c) || r(c) ? d.replaceText(p, f) : null;
    } });
  }
  var a = e.options[0] || "always", s = e.options[1] || {}, o = e.getSourceCode(), u = a === "always" ? s.null || "always" : "ignore";
  return { BinaryExpression: function(c) {
    var f = function(p) {
      return P.isNullLiteral(p.right) || P.isNullLiteral(p.left);
    }(c);
    return c.operator !== "==" && c.operator !== "!=" ? void (u === "never" && f && i(c, c.operator.slice(0, -1))) : void (a === "smart" && (n(c) || r(c) || f) || u !== "always" && f || i(c, "".concat(c.operator, "=")));
  } };
} }, v5 = { meta: { type: "layout", docs: { description: "require or disallow spacing between function identifiers and their invocations", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/func-call-spacing" }, fixable: "whitespace", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { allowNewlines: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unexpected newline between function name and paren.", missing: "Missing space between function name and paren." } }, create: function(e) {
  function t(s, o, u) {
    var c = a.slice(o.range[1], u.range[0]).replace(/\/\*(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\*\//g, ""), f = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/.test(c), p = f && P.LINEBREAK_MATCHER.test(c);
    n && f ? e.report({ node: s, loc: o.loc.start, messageId: "unexpected", fix: function(d) {
      return p ? null : d.removeRange([o.range[1], u.range[0]]);
    } }) : n || f ? !n && !r && p && e.report({ node: s, loc: o.loc.start, messageId: "unexpected", fix: function(d) {
      return d.replaceTextRange([o.range[1], u.range[0]], " ");
    } }) : e.report({ node: s, loc: o.loc.start, messageId: "missing", fix: function(d) {
      return d.insertTextBefore(u, " ");
    } });
  }
  var n = e.options[0] !== "always", r = !n && e.options[1] && e.options[1].allowNewlines, i = e.getSourceCode(), a = i.getText();
  return { "CallExpression, NewExpression": function(s) {
    var o = i.getLastToken(s), u = i.getLastToken(s.callee), c = i.getFirstTokenBetween(u, o, P.isOpeningParenToken), f = c && i.getTokenBefore(c);
    c && c.range[1] < s.range[1] && t(s, f, c);
  }, ImportExpression: function(s) {
    var o = i.getFirstToken(s);
    t(s, o, i.getTokenAfter(o));
  } };
} };
function n2(e, t) {
  return 6 <= t ? l0.keyword.isIdentifierES6(e) : l0.keyword.isIdentifierES5(e);
}
var r2 = { type: "object", properties: { considerPropertyDescriptor: { type: "boolean" }, includeCommonJSModuleExports: { type: "boolean" } }, additionalProperties: !1 }, x5 = { meta: { type: "suggestion", docs: { description: "require function names to match the name of the variable or property to which they are assigned", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/func-name-matching" }, schema: { anyOf: [{ type: "array", additionalItems: !1, items: [{ enum: ["always", "never"] }, r2] }, { type: "array", additionalItems: !1, items: [r2] }] }, messages: { matchProperty: "Function name `{{funcName}}` should match property name `{{name}}`.", matchVariable: "Function name `{{funcName}}` should match variable name `{{name}}`.", notMatchProperty: "Function name `{{funcName}}` should not match property name `{{name}}`.", notMatchVariable: "Function name `{{funcName}}` should not match variable name `{{name}}`." } }, create: function(e) {
  function t(f, p, d) {
    return !!d && d.type === "CallExpression" && d.callee.type === "MemberExpression" && d.callee.object.name === f && d.callee.property.name === p;
  }
  function n(f, p) {
    return s === "always" && f !== p || s === "never" && f === p;
  }
  function r(f, p, d, m) {
    var y;
    y = s === "always" && m ? "matchProperty" : s === "always" ? "matchVariable" : m ? "notMatchProperty" : "notMatchVariable", e.report({ node: f, messageId: y, data: { name: p, funcName: d } });
  }
  function i(f) {
    return f.type === "Literal" && typeof f.value == "string";
  }
  var a = (xe(e.options[0]) == "object" ? e.options[0] : e.options[1]) || {}, s = typeof e.options[0] == "string" ? e.options[0] : "always", o = a.considerPropertyDescriptor, u = a.includeCommonJSModuleExports, c = e.parserOptions && e.parserOptions.ecmaVersion ? e.parserOptions.ecmaVersion : 5;
  return { VariableDeclarator: function(f) {
    !f.init || f.init.type !== "FunctionExpression" || f.id.type !== "Identifier" || f.init.id && n(f.id.name, f.init.id.name) && r(f, f.id.name, f.init.id.name, !1);
  }, AssignmentExpression: function(f) {
    if (!(f.right.type !== "FunctionExpression" || f.left.computed && f.left.property.type !== "Literal" || !u && function(m) {
      return m.type === "MemberExpression" && m.object.type === "Identifier" && m.object.name === "module" && (m.property.type === "Identifier" && m.property.name === "exports" || m.property.type === "Literal" && m.property.value === "exports");
    }(f.left) || f.left.type !== "Identifier" && f.left.type !== "MemberExpression")) {
      var p = f.left.type === "MemberExpression", d = p ? P.getStaticPropertyName(f.left) : f.left.name;
      f.right.id && n2(d) && n(d, f.right.id.name) && r(f, d, f.right.id.name, p);
    }
  }, Property: function(f) {
    if (f.value.type === "FunctionExpression" && f.value.id && (!f.computed || i(f.key))) {
      if (f.key.type === "Identifier") {
        var p = f.value.id.name, d = f.key.name;
        if (o && d === "value")
          if (t("Object", "defineProperty", f.parent.parent) || t("Reflect", "defineProperty", f.parent.parent)) {
            var m = f.parent.parent.arguments[1];
            i(m) && n(m.value, p) && r(f, m.value, p, !0);
          } else
            t("Object", "defineProperties", f.parent.parent.parent.parent) || t("Object", "create", f.parent.parent.parent.parent) ? (d = f.parent.parent.key.name, !f.parent.parent.computed && n(d, p) && r(f, d, p, !0)) : n(d, p) && r(f, d, p, !0);
        else
          n(d, p) && r(f, d, p, !0);
        return;
      }
      i(f.key) && n2(f.key.value, c) && n(f.key.value, f.value.id.name) && r(f, f.key.value, f.value.id.name, !0);
    }
  } };
} }, b5 = { meta: { type: "suggestion", docs: { description: "require or disallow named `function` expressions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/func-names" }, schema: { definitions: { value: { enum: ["always", "as-needed", "never"] } }, items: [{ $ref: "#/definitions/value" }, { type: "object", properties: { generators: { $ref: "#/definitions/value" } }, additionalProperties: !1 }] }, messages: { unnamed: "Unexpected unnamed {{name}}.", named: "Unexpected named {{name}}." } }, create: function(e) {
  function t(a) {
    var s = a.parent;
    return s.type === "MethodDefinition" || s.type === "Property" && (s.method || s.kind === "get" || s.kind === "set");
  }
  function n(a) {
    e.report({ node: a, messageId: "unnamed", loc: P.getFunctionHeadLoc(a, i), data: { name: P.getFunctionNameWithKind(a) } });
  }
  function r(a) {
    e.report({ node: a, messageId: "named", loc: P.getFunctionHeadLoc(a, i), data: { name: P.getFunctionNameWithKind(a) } });
  }
  var i = e.getSourceCode();
  return { "FunctionExpression:exit": function(a) {
    var s = e.getDeclaredVariables(a)[0];
    if (!(function(c) {
      return c && c.defs[0].type === "FunctionName";
    }(s) && 0 < s.references.length)) {
      var o = !(!a.id || !a.id.name), u = function(c) {
        return c.generator && 1 < e.options.length && e.options[1].generators ? e.options[1].generators : e.options[0] || "always";
      }(a);
      u === "never" ? o && r(a) : u === "as-needed" ? !o && !function(c) {
        var f = c.parent;
        return t(c) || f.type === "VariableDeclarator" && f.id.type === "Identifier" && f.init === c || f.type === "Property" && f.value === c || f.type === "AssignmentExpression" && f.left.type === "Identifier" && f.right === c || f.type === "ExportDefaultDeclaration" && f.declaration === c || f.type === "AssignmentPattern" && f.right === c;
      }(a) && n(a) : !o && !t(a) && n(a);
    }
  } };
} }, E5 = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside function parentheses", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/function-paren-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent", "multiline", "multiline-arguments"] }, { type: "object", properties: { minItems: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }], messages: { expectedBefore: "Expected newline before ')'.", expectedAfter: "Expected newline after '('.", expectedBetween: "Expected newline between arguments/params.", unexpectedBefore: "Unexpected newline before ')'.", unexpectedAfter: "Unexpected newline after '('." } }, create: function(e) {
  function t(p, d) {
    return c && p.length === 1 ? d : u || c ? p.some(function(m, y) {
      return y !== p.length - 1 && m.loc.end.line !== p[y + 1].loc.start.line;
    }) : f ? d : p.length >= a;
  }
  function n(p, d) {
    var m = p.leftParen, y = p.rightParen, v = s.getTokenAfter(m), b = s.getTokenBefore(y), x = !P.isTokenOnSameLine(m, v), C = !P.isTokenOnSameLine(b, y), k = t(d, x);
    x && !k ? e.report({ node: m, messageId: "unexpectedAfter", fix: function(F) {
      return s.getText().slice(m.range[1], v.range[0]).trim() ? null : F.removeRange([m.range[1], v.range[0]]);
    } }) : !x && k && e.report({ node: m, messageId: "expectedAfter", fix: function(F) {
      return F.insertTextAfter(m, `
`);
    } }), C && !k ? e.report({ node: y, messageId: "unexpectedBefore", fix: function(F) {
      return s.getText().slice(b.range[1], y.range[0]).trim() ? null : F.removeRange([b.range[1], y.range[0]]);
    } }) : !C && k && e.report({ node: y, messageId: "expectedBefore", fix: function(F) {
      return F.insertTextBefore(y, `
`);
    } });
  }
  function r(p, d) {
    for (var m = p.leftParen, y = s.getTokenAfter(m), v = !P.isTokenOnSameLine(m, y), b = t(d, v), x = function(k) {
      var F = d[k], B = d[k + 1];
      F.loc.end.line === B.loc.start.line && b && e.report({ node: F, messageId: "expectedBetween", fix: function(O) {
        return O.insertTextBefore(B, `
`);
      } });
    }, C = 0; C <= d.length - 2; C++)
      x(C);
  }
  function i(p) {
    switch (p.type) {
      case "NewExpression":
        if (!(p.arguments.length || P.isOpeningParenToken(s.getLastToken(p, { skip: 1 })) && P.isClosingParenToken(s.getLastToken(p))))
          return null;
      case "CallExpression":
        return { leftParen: s.getTokenAfter(p.callee, P.isOpeningParenToken), rightParen: s.getLastToken(p) };
      case "FunctionDeclaration":
      case "FunctionExpression":
        var d = s.getFirstToken(p, P.isOpeningParenToken);
        return { leftParen: d, rightParen: p.params.length ? s.getTokenAfter(p.params[p.params.length - 1], P.isClosingParenToken) : s.getTokenAfter(d) };
      case "ArrowFunctionExpression":
        var m = s.getFirstToken(p);
        return P.isOpeningParenToken(m) ? { leftParen: m, rightParen: s.getTokenBefore(p.body, P.isClosingParenToken) } : null;
      case "ImportExpression":
        return { leftParen: s.getFirstToken(p, 1), rightParen: s.getLastToken(p) };
      default:
        throw new TypeError("unexpected node with type ".concat(p.type));
    }
  }
  var a, s = e.getSourceCode(), o = e.options[0] || "multiline", u = o === "multiline", c = o === "multiline-arguments", f = o === "consistent";
  return a = xe(o) == "object" ? o.minItems : o === "always" ? 0 : o === "never" ? 1 / 0 : null, Fn({}, ["ArrowFunctionExpression", "CallExpression", "FunctionDeclaration", "FunctionExpression", "ImportExpression", "NewExpression"], function(p) {
    var d, m = i(p);
    d = p.type === "ImportExpression" ? [p.source] : P.isFunction(p) ? p.params : p.arguments, m && (n(m, d), c && r(m, d));
  });
} }, Kd = { oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: !1 }] }, C5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing around `*` operators in generator functions", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/generator-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" }, named: Kd, anonymous: Kd, method: Kd }, additionalProperties: !1 }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e) {
  function t(c, f) {
    return c ? typeof c == "string" ? s[c] : Object.assign({}, f, c) : f;
  }
  function n(c) {
    return c.value === "*" && c.type === "Punctuator";
  }
  function r(c) {
    return u.getFirstToken(c.parent.method || c.parent.type === "MethodDefinition" ? c.parent : c, n);
  }
  function i(c, f, p, d) {
    if (!!(d.range[0] - p.range[1]) !== o[c][f]) {
      var m = p.value === "*", y = o[c][f], v = m ? p : d, b = "".concat(y ? "missing" : "unexpected").concat(function(x) {
        return x[0].toUpperCase() + x.slice(1);
      }(f));
      e.report({ node: v, messageId: b, fix: function(x) {
        return y ? m ? x.insertTextAfter(v, " ") : x.insertTextBefore(v, " ") : x.removeRange([p.range[1], d.range[0]]);
      } });
    }
  }
  function a(c) {
    if (c.generator) {
      var f = r(c), p = u.getTokenBefore(f), d = u.getTokenAfter(f), m = "named";
      c.parent.type === "MethodDefinition" || c.parent.type === "Property" && c.parent.method ? m = "method" : !c.id && (m = "anonymous"), m == "method" && f === u.getFirstToken(c.parent) || i(m, "before", p, f), i(m, "after", f, d);
    }
  }
  var s = { before: { before: !0, after: !1 }, after: { before: !1, after: !0 }, both: { before: !0, after: !0 }, neither: { before: !1, after: !1 } }, o = function(c) {
    var f = t(c, s.before);
    return { named: t(c.named, f), anonymous: t(c.anonymous, f), method: t(c.method, f) };
  }(e.options[0] || {}), u = e.getSourceCode();
  return { FunctionDeclaration: a, FunctionExpression: a };
} }, S5 = /^(?:Arrow)?FunctionExpression$/;
function k5(e) {
  return e.reachable;
}
function D5(e) {
  return e.id || e;
}
var F5 = { meta: { type: "problem", docs: { description: "enforce `return` statements in getters", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/getter-return" }, fixable: null, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { expected: "Expected to return a value in {{name}}.", expectedAlways: "Expected {{name}} to always return a value." } }, create: function(e) {
  function t(a) {
    i.shouldCheck && i.codePath.currentSegments.some(k5) && e.report({ node: a, loc: D5(a).loc.start, messageId: i.hasReturn ? "expectedAlways" : "expected", data: { name: P.getFunctionNameWithKind(i.node) } });
  }
  function n(a) {
    var s = a.parent;
    return !!(S5.test(a.type) && a.body.type === "BlockStatement" && (s.kind === "get" || s.type === "Property" && P.getStaticPropertyName(s) === "get" && s.parent.type === "ObjectExpression" && (s.parent.parent.type === "CallExpression" && P.getStaticPropertyName(s.parent.parent.callee) === "defineProperty" || s.parent.parent.type === "Property" && s.parent.parent.parent.type === "ObjectExpression" && s.parent.parent.parent.parent.type === "CallExpression" && P.getStaticPropertyName(s.parent.parent.parent.parent.callee) === "defineProperties")));
  }
  var r = e.options[0] || { allowImplicit: !1 }, i = { upper: null, codePath: null, hasReturn: !1, shouldCheck: !1, node: null };
  return { onCodePathStart: function(a, s) {
    i = { upper: i, codePath: a, hasReturn: !1, shouldCheck: n(s), node: s };
  }, onCodePathEnd: function() {
    i = i.upper;
  }, ReturnStatement: function(a) {
    i.shouldCheck && (i.hasReturn = !0, !r.allowImplicit && !a.argument && e.report({ node: a, messageId: "expected", data: { name: P.getFunctionNameWithKind(i.node) } }));
  }, "FunctionExpression:exit": t, "ArrowFunctionExpression:exit": t };
} }, w5 = ["AssignmentExpression", "VariableDeclarator", "MemberExpression", "ExpressionStatement", "CallExpression", "ConditionalExpression", "Program", "VariableDeclaration"], A5 = { meta: { type: "suggestion", docs: { description: "require `require()` calls to be placed at top-level module scope", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/global-require" }, schema: [], messages: { unexpected: "Unexpected require()." } }, create: function(e) {
  return { CallExpression: function(t) {
    var n = e.getScope();
    t.callee.name !== "require" || function(r, i) {
      var a = function(s, o) {
        var u = s.references.filter(function(c) {
          return c.identifier.range[0] === o.range[0] && c.identifier.range[1] === o.range[1];
        });
        return u.length === 1 ? u[0] : null;
      }(r, i);
      return a && a.resolved && 0 < a.resolved.defs.length;
    }(n, t.callee) || e.getAncestors().every(function(r) {
      return -1 < w5.indexOf(r.type);
    }) || e.report({ node: t, messageId: "unexpected" });
  } };
} };
function _5(e) {
  return e.kind === "get" || e.kind === "set";
}
var T5 = { meta: { type: "suggestion", docs: { description: "require grouped accessor pairs in object literals and classes", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/grouped-accessor-pairs" }, schema: [{ enum: ["anyOrder", "getBeforeSet", "setBeforeGet"] }], messages: { notGrouped: "Accessor pair {{ formerName }} and {{ latterName }} should be grouped.", invalidOrder: "Expected {{ latterName }} to be before {{ formerName }}." } }, create: function(e) {
  function t(o, u, c) {
    e.report({ node: c, messageId: o, loc: P.getFunctionHeadLoc(c.value, s), data: { formerName: P.getFunctionNameWithKind(u.value), latterName: P.getFunctionNameWithKind(c.value) } });
  }
  function n(o) {
    var u = P.getStaticPropertyName(o);
    return { key: u === null ? s.getTokens(o.key) : u, getters: o.kind === "get" ? [o] : [], setters: o.kind === "set" ? [o] : [] };
  }
  function r(o, u) {
    var c, f, p = o.find(function(d) {
      return function(m, y) {
        return typeof m == "string" && typeof y == "string" ? m == y : !(!Array.isArray(m) || !Array.isArray(y)) && function(v, b) {
          if (v.length !== b.length)
            return !1;
          for (var x = 0; x < v.length; x++) {
            var C = v[x], k = b[x];
            if (C.type !== k.type || C.value !== k.value)
              return !1;
          }
          return !0;
        }(m, y);
      }(d.key, u.key);
    });
    return p ? ((c = p.getters).push.apply(c, Mt(u.getters)), (f = p.setters).push.apply(f, Mt(u.setters))) : o.push(u), o;
  }
  function i(o, u) {
    var c = o.filter(u).filter(_5).map(n).reduce(r, []), f = !0, p = !1, d = void 0;
    try {
      for (var m, y = c[Symbol.iterator](); !(f = (m = y.next()).done); f = !0) {
        var v = m.value, b = v.getters, x = v.setters;
        if (b.length === 1 && x.length === 1) {
          var C = bn(b, 1)[0], k = bn(x, 1)[0], F = o.indexOf(C), B = o.indexOf(k), O = F < B ? C : k, S = F < B ? k : C;
          1 < Math.abs(F - B) ? t("notGrouped", O, S) : (a === "getBeforeSet" && F > B || a === "setBeforeGet" && F < B) && t("invalidOrder", O, S);
        }
      }
    } catch (w) {
      p = !0, d = w;
    } finally {
      try {
        f || y.return == null || y.return();
      } finally {
        if (p)
          throw d;
      }
    }
  }
  var a = e.options[0] || "anyOrder", s = e.getSourceCode();
  return { ObjectExpression: function(o) {
    i(o.properties, function(u) {
      return u.type === "Property";
    });
  }, ClassBody: function(o) {
    i(o.body, function(u) {
      return u.type === "MethodDefinition" && !u.static;
    }), i(o.body, function(u) {
      return u.type === "MethodDefinition" && u.static;
    });
  } };
} }, P5 = { meta: { type: "suggestion", docs: { description: "require error handling in callbacks", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/handle-callback-err" }, schema: [{ type: "string" }], messages: { expected: "Expected error to be handled." } }, create: function(e) {
  function t(i) {
    return function(a) {
      return a[0] === "^";
    }(r) ? new RegExp(r, "u").test(i) : i === r;
  }
  function n(i) {
    var a = function(s) {
      return s.variables.filter(function(o) {
        return o.defs[0] && o.defs[0].type === "Parameter";
      });
    }(e.getScope())[0];
    a && t(a.name) && a.references.length === 0 && e.report({ node: i, messageId: "expected" });
  }
  var r = e.options[0] || "err";
  return { FunctionDeclaration: n, FunctionExpression: n, ArrowFunctionExpression: n };
} }, I5 = { meta: { type: "suggestion", docs: { description: "require identifiers to match a specified regular expression", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/id-match" }, schema: [{ type: "string" }, { type: "object", properties: { properties: { type: "boolean", default: !1 }, onlyDeclarations: { type: "boolean", default: !1 }, ignoreDestructuring: { type: "boolean", default: !1 } } }], messages: { notMatch: "Identifier '{{name}}' does not match the pattern '{{pattern}}'." } }, create: function(e) {
  function t(y) {
    return !a.test(y);
  }
  function n(y, v) {
    return (!u || d.has(y.type)) && !p.has(y.type) && t(v);
  }
  function r(y) {
    f.has(y) || (e.report({ node: y, messageId: "notMatch", data: { name: y.name, pattern: i } }), f.set(y, !0));
  }
  var i = e.options[0] || "^.+$", a = new RegExp(i, "u"), s = e.options[1] || {}, o = !!s.properties, u = !!s.onlyDeclarations, c = !!s.ignoreDestructuring, f = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Set(["CallExpression", "NewExpression"]), d = /* @__PURE__ */ new Set(["FunctionDeclaration", "VariableDeclarator"]), m = /* @__PURE__ */ new Set(["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"]);
  return { Identifier: function(y) {
    var v = y.name, b = y.parent, x = b.type === "MemberExpression" ? b.parent : b;
    if (b.type === "MemberExpression") {
      if (!o)
        return;
      b.object.type === "Identifier" && b.object.name === v || x.type === "AssignmentExpression" && x.left.type === "MemberExpression" && x.left.property.name === y.name ? t(v) && r(y) : x.type === "AssignmentExpression" && x.right.type !== "MemberExpression" && t(v) && r(y);
    } else if (b.type === "Property" || b.type === "AssignmentPattern") {
      if (b.parent && b.parent.type === "ObjectPattern") {
        b.shorthand && b.value.left && t(v) && r(y);
        var C = b.key.name === b.value.name;
        if (!C && b.key === y)
          return;
        b.value.name && t(v) && (!C || !c) && r(y);
      }
      if (!o || c && function(k) {
        for (var F = k.parent; F; ) {
          if (F.type === "ObjectPattern")
            return !0;
          F = F.parent;
        }
        return !1;
      }(y))
        return;
      b.right !== y && n(x, v) && r(y);
    } else
      m.has(b.type) ? b.local && b.local.name === y.name && t(v) && r(y) : n(x, v) && r(y);
  } };
} }, B5 = P.isCommentToken, O5 = P.isNotOpeningParenToken, L5 = { meta: { type: "layout", docs: { description: "enforce the location of arrow function bodies", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/implicit-arrow-linebreak" }, fixable: "whitespace", schema: [{ enum: ["beside", "below"] }], messages: { expected: "Expected a linebreak before this expression.", unexpected: "Expected no linebreak before this expression." } }, create: function(e) {
  function t(i) {
    if (i.body.type !== "BlockStatement") {
      var a = n.getTokenBefore(i.body, O5), s = n.getTokenAfter(a);
      a.loc.end.line === s.loc.start.line && r === "below" ? e.report({ node: s, messageId: "expected", fix: function(o) {
        return o.insertTextBefore(s, `
`);
      } }) : a.loc.end.line !== s.loc.start.line && r === "beside" && e.report({ node: s, messageId: "unexpected", fix: function(o) {
        return n.getFirstTokenBetween(a, s, { includeComments: !0, filter: B5 }) ? null : o.replaceTextRange([a.range[1], s.range[0]], " ");
      } });
    }
  }
  var n = e.getSourceCode(), r = e.options[0] || "beside";
  return { ArrowFunctionExpression: function(i) {
    return t(i);
  } };
} }, N5 = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/indent-legacy" }, deprecated: !0, replacedBy: ["indent"], fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0 }, VariableDeclarator: { oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { var: { type: "integer", minimum: 0 }, let: { type: "integer", minimum: 0 }, const: { type: "integer", minimum: 0 } } }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { type: "integer", minimum: 0 }, FunctionDeclaration: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, FunctionExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, CallExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } } }, ArrayExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, ObjectExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } }, additionalProperties: !1 }], messages: { expected: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e) {
  function t(D, I, L) {
    var V = "".concat(D, " ").concat(C).concat(D === 1 ? "" : "s"), K = "space".concat(I === 1 ? "" : "s"), W = "tab".concat(L === 1 ? "" : "s");
    return { expected: V, actual: 0 < I && 0 < L ? "".concat(I, " ").concat(K, " and ").concat(L, " ").concat(W) : 0 < I ? C === "space" ? I : "".concat(I, " ").concat(K) : 0 < L ? C === "tab" ? L : "".concat(L, " ").concat(W) : "0" };
  }
  function n(D, I, L, V, K, W) {
    if (!L || !V) {
      var R = (C === "space" ? " " : "	").repeat(I), q = W ? [D.range[1] - D.loc.end.column, D.range[1] - D.loc.end.column + L + V] : [D.range[0] - D.loc.start.column, D.range[0] - D.loc.start.column + L + V];
      e.report({ node: D, loc: K, messageId: "expected", data: t(I, L, V), fix: function(J) {
        return J.replaceTextRange(q, R);
      } });
    }
  }
  function r(D, I) {
    var L = I ? B.getLastToken(D) : B.getFirstToken(D), V = B.getText(L, L.loc.start.column).split(""), K = V.slice(0, V.findIndex(function(q) {
      return q !== " " && q !== "	";
    })), W = K.filter(function(q) {
      return q === " ";
    }).length, R = K.filter(function(q) {
      return q === "	";
    }).length;
    return { space: W, tab: R, goodChar: C === "space" ? W : R, badChar: C === "space" ? R : W };
  }
  function i(D, I) {
    var L = I === !0 ? B.getLastToken(D, 1) : B.getTokenBefore(D);
    return (I === !0 ? D.loc.end.line : D.loc.start.line) !== (L ? L.loc.end.line : -1);
  }
  function a(D, I) {
    var L = r(D, !1);
    D.type !== "ArrayExpression" && D.type !== "ObjectExpression" && (L.goodChar !== I || L.badChar !== 0) && i(D) && n(D, I, L.space, L.tab), D.type === "IfStatement" && D.alternate && (a(B.getTokenBefore(D.alternate), I), i(D.alternate) || a(D.alternate, I)), D.type === "TryStatement" && D.handler && a(B.getFirstToken(D.handler), I), D.type === "TryStatement" && D.finalizer && a(B.getTokenBefore(D.finalizer), I), D.type === "DoWhileStatement" && a(B.getTokenAfter(D.body), I);
  }
  function s(D, I) {
    D.forEach(function(L) {
      return a(L, I);
    });
  }
  function o(D, I) {
    var L = B.getLastToken(D), V = r(L, !0);
    (V.goodChar !== I || V.badChar !== 0) && i(D, !0) && n(D, I, V.space, V.tab, { line: L.loc.start.line, column: L.loc.start.column }, !0);
  }
  function u(D, I) {
    var L = r(D, !1);
    (L.goodChar !== I || L.badChar !== 0) && i(D) && n(D, I, L.space, L.tab, { line: D.loc.start.line, column: D.loc.start.column });
  }
  function c(D, I, L) {
    for (var V = D.parent, K = new Set(L || ["Program"]); V.type !== I && !K.has(V.type) && V.type !== "Program"; )
      V = V.parent;
    return V.type === I ? V : null;
  }
  function f(D) {
    return c(D, "VariableDeclarator");
  }
  function p(D, I) {
    return I && I.parent.loc.start.line === D.loc.start.line && 1 < I.parent.declarations.length;
  }
  function d(D) {
    var I = B.getLastToken(D);
    return D.loc.start.line === I.loc.end.line;
  }
  function m(D) {
    if (!d(D)) {
      var I, L, V = D.type === "ArrayExpression" ? D.elements : D.properties;
      V = V.filter(function(q) {
        return q !== null;
      });
      var K = f(D);
      if (i(D)) {
        var W = D.parent;
        if (I = r(W).goodChar, K && K.loc.start.line === D.loc.start.line)
          K || function(q) {
            return !(q.type !== "ArrayExpression" || !q.elements[0]) && q.elements[0].loc.start.line === q.loc.start.line && q.elements[0].type === "ObjectExpression";
          }(W) || W.type === "MemberExpression" || W.type === "ExpressionStatement" || W.type === "AssignmentExpression" || W.type === "Property" || (I += k);
        else if (W.type !== "VariableDeclarator" || K === K.parent.declarations[0])
          if (W.type === "VariableDeclarator" && K.loc.start.line === W.loc.start.line)
            I += k * F.VariableDeclarator[K.parent.kind];
          else if (W.type === "ObjectExpression" || W.type === "ArrayExpression") {
            var R = D.parent.type === "ObjectExpression" ? D.parent.properties : D.parent.elements;
            R[0] && R[0].loc.start.line === W.loc.start.line && R[0].loc.end.line !== W.loc.start.line || (typeof F[W.type] == "number" ? I += F[W.type] * k : I = R[0].loc.start.column);
          } else
            W.type === "CallExpression" || W.type === "NewExpression" ? typeof F.CallExpression.arguments == "number" ? I += F.CallExpression.arguments * k : F.CallExpression.arguments === "first" ? W.arguments.indexOf(D) !== -1 && (I = W.arguments[0].loc.start.column) : I += k : (W.type === "LogicalExpression" || W.type === "ArrowFunctionExpression") && (I += k);
        u(D, I);
      } else
        I = r(D).goodChar;
      L = F[D.type] === "first" ? V.length ? V[0].loc.start.column : 0 : I + k * F[D.type], p(D, K) && (L += k * F.VariableDeclarator[K.parent.kind]), s(V, L), 0 < V.length && V[V.length - 1].loc.end.line === D.loc.end.line || o(D, I + (p(D, K) ? F.VariableDeclarator[K.parent.kind] * k : 0));
    }
  }
  function y(D) {
    if (!d(D))
      if (!D.parent || D.parent.type !== "FunctionExpression" && D.parent.type !== "FunctionDeclaration" && D.parent.type !== "ArrowFunctionExpression") {
        var I, L;
        L = D.parent && ["IfStatement", "WhileStatement", "ForStatement", "ForInStatement", "ForOfStatement", "DoWhileStatement", "ClassDeclaration", "TryStatement"].indexOf(D.parent.type) !== -1 && function(V) {
          return V.type === "BlockStatement" || V.type === "ClassBody" || V.body && V.body.type === "BlockStatement" || V.consequent && V.consequent.type === "BlockStatement";
        }(D) ? r(D.parent).goodChar : D.parent && D.parent.type === "CatchClause" ? r(D.parent.parent).goodChar : r(D).goodChar, 0 < (I = D.type === "IfStatement" && D.consequent.type !== "BlockStatement" ? [D.consequent] : Array.isArray(D.body) ? D.body : [D.body]).length && s(I, L + k), D.type === "BlockStatement" && o(D, L);
      } else
        (function(V) {
          var K, W = V.parent;
          if (K = !W.parent || W.parent.type !== "Property" && W.parent.type !== "ArrayExpression" ? r(W).goodChar : r(W, !1).goodChar, W.parent.type === "CallExpression") {
            var R = W.parent;
            W.type !== "FunctionExpression" && W.type !== "ArrowFunctionExpression" ? R && R.loc.start.line < V.loc.start.line && (K = r(R).goodChar) : function(X) {
              var ce = X.parent;
              return 2 <= ce.arguments.length && ce.arguments[1] === X && ce.arguments[0].loc.end.line > ce.arguments[0].loc.start.line;
            }(W) && R.callee.loc.start.line === R.callee.loc.end.line && !i(W) && (K = r(R).goodChar);
          }
          var q = k;
          F.outerIIFEBody !== null && function(X) {
            var ce = X.parent, A = ce.parent;
            if (ce.type !== "CallExpression" || ce.callee !== X)
              return !1;
            for (; A.type === "UnaryExpression" && (A.operator === "!" || A.operator === "~" || A.operator === "+" || A.operator === "-") || A.type === "AssignmentExpression" || A.type === "LogicalExpression" || A.type === "SequenceExpression" || A.type === "VariableDeclarator"; )
              A = A.parent;
            return (A.type === "ExpressionStatement" || A.type === "VariableDeclaration") && A.parent && A.parent.type === "Program";
          }(W) ? q = F.outerIIFEBody * k : W.type === "FunctionExpression" ? q = F.FunctionExpression.body * k : W.type === "FunctionDeclaration" && (q = F.FunctionDeclaration.body * k), K += q;
          var J = f(V);
          J && p(V, J) && (K += k * F.VariableDeclarator[J.parent.kind]), 0 < V.body.length && s(V.body, K), o(V, K - q);
        })(D);
  }
  function v(D) {
    D.body.type !== "BlockStatement" && y(D);
  }
  function b(D, I) {
    var L, V = D.type === "SwitchStatement" ? D : D.parent, K = I === void 0 ? r(V).goodChar : I;
    return w[V.loc.start.line] ? w[V.loc.start.line] : (L = 0 < V.cases.length && F.SwitchCase === 0 ? K : K + k * F.SwitchCase, w[V.loc.start.line] = L, L);
  }
  var x = null, C = "space", k = 4, F = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: null, FunctionDeclaration: { parameters: x, body: 1 }, FunctionExpression: { parameters: x, body: 1 }, CallExpression: { arguments: x }, ArrayExpression: 1, ObjectExpression: 1 }, B = e.getSourceCode();
  if (e.options.length && (e.options[0] === "tab" ? (k = 1, C = "tab") : typeof e.options[0] == "number" && (k = e.options[0], C = "space"), e.options[1])) {
    var O = e.options[1];
    F.SwitchCase = O.SwitchCase || 0;
    var S = O.VariableDeclarator;
    typeof S == "number" ? F.VariableDeclarator = { var: S, let: S, const: S } : xe(S) == "object" && Object.assign(F.VariableDeclarator, S), typeof O.outerIIFEBody == "number" && (F.outerIIFEBody = O.outerIIFEBody), typeof O.MemberExpression == "number" && (F.MemberExpression = O.MemberExpression), xe(O.FunctionDeclaration) == "object" && Object.assign(F.FunctionDeclaration, O.FunctionDeclaration), xe(O.FunctionExpression) == "object" && Object.assign(F.FunctionExpression, O.FunctionExpression), xe(O.CallExpression) == "object" && Object.assign(F.CallExpression, O.CallExpression), (typeof O.ArrayExpression == "number" || typeof O.ArrayExpression == "string") && (F.ArrayExpression = O.ArrayExpression), (typeof O.ObjectExpression == "number" || typeof O.ObjectExpression == "string") && (F.ObjectExpression = O.ObjectExpression);
  }
  var w = {};
  return { Program: function(D) {
    0 < D.body.length && s(D.body, r(D).goodChar);
  }, ClassBody: y, BlockStatement: y, WhileStatement: v, ForStatement: v, ForInStatement: v, ForOfStatement: v, DoWhileStatement: v, IfStatement: function(D) {
    D.consequent.type !== "BlockStatement" && D.consequent.loc.start.line > D.loc.start.line && y(D);
  }, VariableDeclaration: function(D) {
    D.declarations[D.declarations.length - 1].loc.start.line > D.declarations[0].loc.start.line && function(I) {
      var L = function(q) {
        return q.declarations.reduce(function(J, X) {
          var ce = J[J.length - 1];
          return (X.loc.start.line !== q.loc.start.line && !ce || ce && ce.loc.start.line !== X.loc.start.line) && J.push(X), J;
        }, []);
      }(I), V = r(I).goodChar, K = L[L.length - 1], W = V + k * F.VariableDeclarator[I.kind];
      if (s(L, W), !(B.getLastToken(I).loc.end.line <= K.loc.end.line)) {
        var R = B.getTokenBefore(K);
        R.value === "," ? o(I, r(R).goodChar) : o(I, W - k);
      }
    }(D);
  }, ObjectExpression: function(D) {
    m(D);
  }, ArrayExpression: function(D) {
    m(D);
  }, MemberExpression: function(D) {
    if (F.MemberExpression !== void 0 && !d(D) && !c(D, "VariableDeclarator", ["FunctionExpression", "ArrowFunctionExpression"]) && !c(D, "AssignmentExpression", ["FunctionExpression"])) {
      var I = r(D).goodChar + k * F.MemberExpression, L = [D.property], V = B.getTokenBefore(D.property);
      V.type === "Punctuator" && V.value === "." && L.push(V), s(L, I);
    }
  }, SwitchStatement: function(D) {
    var I = r(D).goodChar, L = b(D, I);
    s(D.cases, L), o(D, I);
  }, SwitchCase: function(D) {
    if (!d(D)) {
      var I = b(D);
      s(D.consequent, I + k);
    }
  }, FunctionDeclaration: function(D) {
    d(D) || (F.FunctionDeclaration.parameters === "first" && D.params.length ? s(D.params.slice(1), D.params[0].loc.start.column) : F.FunctionDeclaration.parameters !== null && s(D.params, r(D).goodChar + k * F.FunctionDeclaration.parameters));
  }, FunctionExpression: function(D) {
    d(D) || (F.FunctionExpression.parameters === "first" && D.params.length ? s(D.params.slice(1), D.params[0].loc.start.column) : F.FunctionExpression.parameters !== null && s(D.params, r(D).goodChar + k * F.FunctionExpression.parameters));
  }, ReturnStatement: function(D) {
    if (!d(D)) {
      var I = r(D).goodChar;
      (function(L) {
        var V = B.getText(L).replace(B.getText(L.argument), "");
        return /^return[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\);*?/.test(V);
      })(D) ? function(L, V) {
        var K = B.getLastToken(L, P.isClosingParenToken);
        if (!B.getText(K, K.loc.start.column).slice(0, -1).trim()) {
          var W = r(K, !0);
          W.goodChar !== V && n(L, V, W.space, W.tab, { line: K.loc.start.line, column: K.loc.start.column }, !0);
        }
      }(D, I) : a(D, I);
    }
  }, CallExpression: function(D) {
    d(D) || (F.CallExpression.arguments === "first" && D.arguments.length ? s(D.arguments.slice(1), D.arguments[0].loc.start.column) : F.CallExpression.arguments !== null && s(D.arguments, r(D).goodChar + k * F.CallExpression.arguments));
  } };
} }, j5 = /* @__PURE__ */ new Set(["AssignmentExpression", "AssignmentPattern", "ArrayExpression", "ArrayPattern", "ArrowFunctionExpression", "AwaitExpression", "BlockStatement", "BinaryExpression", "BreakStatement", "CallExpression", "CatchClause", "ClassBody", "ClassDeclaration", "ClassExpression", "ConditionalExpression", "ContinueStatement", "DoWhileStatement", "DebuggerStatement", "EmptyStatement", "ExperimentalRestProperty", "ExperimentalSpreadProperty", "ExpressionStatement", "ForStatement", "ForInStatement", "ForOfStatement", "FunctionDeclaration", "FunctionExpression", "Identifier", "IfStatement", "Literal", "LabeledStatement", "LogicalExpression", "MemberExpression", "MetaProperty", "MethodDefinition", "NewExpression", "ObjectExpression", "ObjectPattern", "Program", "Property", "RestElement", "ReturnStatement", "SequenceExpression", "SpreadElement", "Super", "SwitchCase", "SwitchStatement", "TaggedTemplateExpression", "TemplateElement", "TemplateLiteral", "ThisExpression", "ThrowStatement", "TryStatement", "UnaryExpression", "UpdateExpression", "VariableDeclaration", "VariableDeclarator", "WhileStatement", "WithStatement", "YieldExpression", "JSXFragment", "JSXOpeningFragment", "JSXClosingFragment", "JSXIdentifier", "JSXNamespacedName", "JSXMemberExpression", "JSXEmptyExpression", "JSXExpressionContainer", "JSXElement", "JSXClosingElement", "JSXOpeningElement", "JSXAttribute", "JSXSpreadAttribute", "JSXText", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration", "ExportSpecifier", "ImportDeclaration", "ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier", "ImportExpression"]), R5 = function() {
  function e() {
    We(this, e), this._rbTree = AI();
  }
  return Xe(e, [{ key: "insert", value: function(t, n) {
    var r = this._rbTree.find(t);
    this._rbTree = r.valid ? r.update(n) : this._rbTree.insert(t, n);
  } }, { key: "findLe", value: function(t) {
    var n = this._rbTree.le(t);
    return n && { key: n.key, value: n.value };
  } }, { key: "deleteRange", value: function(t, n) {
    if (t !== n)
      for (var r = this._rbTree.ge(t); r.valid && r.key < n; )
        this._rbTree = this._rbTree.remove(r.key), r.next();
  } }]), e;
}(), M5 = function() {
  function e(t) {
    We(this, e), this.sourceCode = t, this.firstTokensByLineNumber = t.tokensAndComments.reduce(function(n, r) {
      return n.has(r.loc.start.line) || n.set(r.loc.start.line, r), !n.has(r.loc.end.line) && t.text.slice(r.range[1] - r.loc.end.column, r.range[1]).trim() && n.set(r.loc.end.line, r), n;
    }, /* @__PURE__ */ new Map());
  }
  return Xe(e, [{ key: "getFirstTokenOfLine", value: function(t) {
    return this.firstTokensByLineNumber.get(t.loc.start.line);
  } }, { key: "isFirstTokenOfLine", value: function(t) {
    return this.getFirstTokenOfLine(t) === t;
  } }, { key: "getTokenIndent", value: function(t) {
    return this.sourceCode.text.slice(t.range[0] - t.loc.start.column, t.range[0]);
  } }]), e;
}(), V5 = function() {
  function e(t, n, r) {
    We(this, e), this._tokenInfo = t, this._indentSize = n, this._indentType = r, this._tree = new R5(), this._tree.insert(0, { offset: 0, from: null, force: !1 }), this._lockedFirstTokens = /* @__PURE__ */ new WeakMap(), this._desiredIndentCache = /* @__PURE__ */ new WeakMap(), this._ignoredTokens = /* @__PURE__ */ new WeakSet();
  }
  return Xe(e, [{ key: "_getOffsetDescriptor", value: function(t) {
    return this._tree.findLe(t.range[0]).value;
  } }, { key: "matchOffsetOf", value: function(t, n) {
    this._lockedFirstTokens.set(n, t);
  } }, { key: "setDesiredOffset", value: function(t, n, r) {
    return this.setDesiredOffsets(t.range, n, r);
  } }, { key: "setDesiredOffsets", value: function(t, n, r, i) {
    var a = { offset: r, from: n, force: i }, s = this._tree.findLe(t[1]).value, o = n && n.range[0] >= t[0] && n.range[1] <= t[1], u = o && this._getOffsetDescriptor(n);
    this._tree.deleteRange(t[0] + 1, t[1]), this._tree.insert(t[0], a), o && (this._tree.insert(n.range[0], u), this._tree.insert(n.range[1], a)), this._tree.insert(t[1], s);
  } }, { key: "getDesiredIndent", value: function(t) {
    if (!this._desiredIndentCache.has(t))
      if (this._ignoredTokens.has(t))
        this._desiredIndentCache.set(t, this._tokenInfo.getTokenIndent(t));
      else if (this._lockedFirstTokens.has(t)) {
        var n = this._lockedFirstTokens.get(t);
        this._desiredIndentCache.set(t, this.getDesiredIndent(this._tokenInfo.getFirstTokenOfLine(n)) + this._indentType.repeat(n.loc.start.column - this._tokenInfo.getFirstTokenOfLine(n).loc.start.column));
      } else {
        var r = this._getOffsetDescriptor(t), i = !r.from || r.from.loc.start.line !== t.loc.start.line || /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\n/.test(t.value) || r.force ? r.offset * this._indentSize : 0;
        this._desiredIndentCache.set(t, (r.from ? this.getDesiredIndent(r.from) : "") + this._indentType.repeat(i));
      }
    return this._desiredIndentCache.get(t);
  } }, { key: "ignoreToken", value: function(t) {
    this._tokenInfo.isFirstTokenOfLine(t) && this._ignoredTokens.add(t);
  } }, { key: "getFirstDependency", value: function(t) {
    return this._getOffsetDescriptor(t).from;
  } }]), e;
}(), Ni = { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first", "off"] }] }, U5 = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/indent" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0, default: 0 }, VariableDeclarator: { oneOf: [Ni, { type: "object", properties: { var: Ni, let: Ni, const: Ni }, additionalProperties: !1 }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["off"] }] }, FunctionDeclaration: { type: "object", properties: { parameters: Ni, body: { type: "integer", minimum: 0 } }, additionalProperties: !1 }, FunctionExpression: { type: "object", properties: { parameters: Ni, body: { type: "integer", minimum: 0 } }, additionalProperties: !1 }, CallExpression: { type: "object", properties: { arguments: Ni }, additionalProperties: !1 }, ArrayExpression: Ni, ObjectExpression: Ni, ImportDeclaration: Ni, flatTernaryExpressions: { type: "boolean", default: !1 }, ignoredNodes: { type: "array", items: { type: "string", not: { pattern: ":exit$" } } }, ignoreComments: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { wrongIndentation: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e) {
  function t(S, w, D) {
    var I = "".concat(S, " ").concat(f).concat(S === 1 ? "" : "s"), L = "space".concat(w === 1 ? "" : "s"), V = "tab".concat(D === 1 ? "" : "s");
    return { expected: I, actual: 0 < w ? f === "space" ? w : "".concat(w, " ").concat(L) : 0 < D ? f === "tab" ? D : "".concat(D, " ").concat(V) : "0" };
  }
  function n(S, w) {
    var D = Array.from(y.getTokenIndent(S)), I = D.filter(function(V) {
      return V === " ";
    }).length, L = D.filter(function(V) {
      return V === "	";
    }).length;
    e.report({ node: S, messageId: "wrongIndentation", data: t(w.length, I, L), loc: { start: { line: S.loc.start.line, column: 0 }, end: { line: S.loc.start.line, column: S.loc.start.column } }, fix: function(V) {
      var K = [S.range[0] - S.loc.start.column, S.range[0]];
      return V.replaceTextRange(K, w);
    } });
  }
  function r(S, w) {
    var D = y.getTokenIndent(S);
    return D === w || D.includes(" ") && D.includes("	");
  }
  function i(S, w, D, I) {
    function L(V) {
      for (var K = m.getTokenBefore(V); P.isOpeningParenToken(K) && K !== w; )
        K = m.getTokenBefore(K);
      return m.getTokenAfter(K);
    }
    v.setDesiredOffsets([w.range[1], D.range[0]], w, typeof I == "number" ? I : 1), v.setDesiredOffset(D, w, 0), I === "first" && S.length && !S[0] || S.forEach(function(V, K) {
      if (V && (I === "off" && v.ignoreToken(L(V)), K !== 0))
        if (I === "first" && y.isFirstTokenOfLine(L(V)))
          v.matchOffsetOf(L(S[0]), L(V));
        else {
          var W = S[K - 1], R = W && L(W), q = W && m.getLastToken(W);
          W && q.loc.end.line - function(J) {
            var X = J.match(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/)[0].match(P.createGlobalLinebreakMatcher());
            return X === null ? 0 : X.length;
          }(q.value) > w.loc.end.line && v.setDesiredOffsets([W.range[1], V.range[1]], R, 0);
        }
    });
  }
  function a(S) {
    if (S.type !== "BlockStatement") {
      for (var w = m.getTokenBefore(S, P.isNotOpeningParenToken), D = m.getFirstToken(S), I = m.getLastToken(S); P.isOpeningParenToken(m.getTokenBefore(D)) && P.isClosingParenToken(m.getTokenAfter(I)); )
        D = m.getTokenBefore(D), I = m.getTokenAfter(I);
      v.setDesiredOffsets([D.range[0], I.range[1]], w, 1);
      var L = m.getLastToken(S);
      S.type !== "EmptyStatement" && P.isSemicolonToken(L) && v.setDesiredOffset(L, w, 0);
    }
  }
  function s(S) {
    var w = S.arguments.length ? m.getFirstTokenBetween(S.callee, S.arguments[0], P.isOpeningParenToken) : m.getLastToken(S, 1), D = m.getLastToken(S);
    b.add(w), b.add(D), v.setDesiredOffset(w, m.getTokenBefore(w), 0), i(S.arguments, w, D, d.CallExpression.arguments);
  }
  function o(S) {
    var w = new Set(m.getTokens(S, { includeComments: !0 }));
    w.forEach(function(D) {
      if (!w.has(v.getFirstDependency(D))) {
        var I = y.getFirstTokenOfLine(D);
        D === I ? v.ignoreToken(D) : v.setDesiredOffset(D, I, 0);
      }
    });
  }
  function u(S, w) {
    var D = S.loc.end.line, I = w.loc.start.line;
    if (D === I || D === I - 1)
      return !1;
    for (var L = D + 1; L < I; ++L)
      if (!y.firstTokensByLineNumber.has(L))
        return !0;
    return !1;
  }
  function c(S) {
    B.add(S), x.add(m.getFirstToken(S));
  }
  var f = "space", p = 4, d = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: 1, FunctionDeclaration: { parameters: 1, body: 1 }, FunctionExpression: { parameters: 1, body: 1 }, CallExpression: { arguments: 1 }, MemberExpression: 1, ArrayExpression: 1, ObjectExpression: 1, ImportDeclaration: 1, flatTernaryExpressions: !1, ignoredNodes: [], ignoreComments: !1 };
  e.options.length && (e.options[0] === "tab" ? (p = 1, f = "tab") : (p = e.options[0], f = "space"), e.options[1] && (Object.assign(d, e.options[1]), (typeof d.VariableDeclarator == "number" || d.VariableDeclarator === "first") && (d.VariableDeclarator = { var: d.VariableDeclarator, let: d.VariableDeclarator, const: d.VariableDeclarator })));
  var m = e.getSourceCode(), y = new M5(m), v = new V5(y, p, f == "space" ? " " : "	"), b = /* @__PURE__ */ new WeakSet(), x = /* @__PURE__ */ new Set(), C = { "ArrayExpression, ArrayPattern": function(S) {
    var w = m.getFirstToken(S), D = m.getTokenAfter(ye.lodash.findLast(S.elements) || w, P.isClosingBracketToken);
    i(S.elements, w, D, d.ArrayExpression);
  }, "ObjectExpression, ObjectPattern": function(S) {
    var w = m.getFirstToken(S), D = m.getTokenAfter(S.properties.length ? S.properties[S.properties.length - 1] : w, P.isClosingBraceToken);
    i(S.properties, w, D, d.ObjectExpression);
  }, ArrowFunctionExpression: function(S) {
    var w = m.getFirstToken(S);
    if (P.isOpeningParenToken(w)) {
      var D = w, I = m.getTokenBefore(S.body, P.isClosingParenToken);
      b.add(D), b.add(I), i(S.params, D, I, d.FunctionExpression.parameters);
    }
    a(S.body);
  }, AssignmentExpression: function(S) {
    var w = m.getFirstTokenBetween(S.left, S.right, function(D) {
      return D.value === S.operator;
    });
    v.setDesiredOffsets([w.range[0], S.range[1]], m.getLastToken(S.left), 1), v.ignoreToken(w), v.ignoreToken(m.getTokenAfter(w));
  }, "BinaryExpression, LogicalExpression": function(S) {
    var w = m.getFirstTokenBetween(S.left, S.right, function(I) {
      return I.value === S.operator;
    }), D = m.getTokenAfter(w);
    v.ignoreToken(w), v.ignoreToken(D), v.setDesiredOffset(D, w, 0);
  }, "BlockStatement, ClassBody": function(S) {
    var w;
    w = S.parent && function(D) {
      if (!D.parent || D.parent.type !== "CallExpression" || D.parent.callee !== D)
        return !1;
      for (var I = D.parent && D.parent.parent; I.type === "UnaryExpression" && -1 < ["!", "~", "+", "-"].indexOf(I.operator) || I.type === "AssignmentExpression" || I.type === "LogicalExpression" || I.type === "SequenceExpression" || I.type === "VariableDeclarator"; )
        I = I.parent;
      return (I.type === "ExpressionStatement" || I.type === "VariableDeclaration") && I.parent.type === "Program";
    }(S.parent) ? d.outerIIFEBody : !S.parent || S.parent.type !== "FunctionExpression" && S.parent.type !== "ArrowFunctionExpression" ? S.parent && S.parent.type === "FunctionDeclaration" ? d.FunctionDeclaration.body : 1 : d.FunctionExpression.body, P.STATEMENT_LIST_PARENTS.has(S.parent.type) || v.setDesiredOffset(m.getFirstToken(S), m.getFirstToken(S.parent), 0), i(S.body, m.getFirstToken(S), m.getLastToken(S), w);
  }, CallExpression: s, "ClassDeclaration[superClass], ClassExpression[superClass]": function(S) {
    var w = m.getFirstToken(S), D = m.getTokenBefore(S.superClass, P.isNotOpeningParenToken);
    v.setDesiredOffsets([D.range[0], S.body.range[0]], w, 1);
  }, ConditionalExpression: function(S) {
    var w = m.getFirstToken(S);
    if (!d.flatTernaryExpressions || !P.isTokenOnSameLine(S.test, S.consequent) || function(W, R) {
      for (var q = R; q.parent && !q.parent.type.endsWith("Statement") && !q.parent.type.endsWith("Declaration"); )
        q = q.parent;
      return !(q = q.parent) || q.loc.start.line === W.loc.start.line;
    }(w, S)) {
      var D = m.getFirstTokenBetween(S.test, S.consequent, function(W) {
        return W.type === "Punctuator" && W.value === "?";
      }), I = m.getFirstTokenBetween(S.consequent, S.alternate, function(W) {
        return W.type === "Punctuator" && W.value === ":";
      }), L = m.getTokenAfter(D), V = m.getTokenBefore(I), K = m.getTokenAfter(I);
      v.setDesiredOffset(D, w, 1), v.setDesiredOffset(I, w, 1), v.setDesiredOffset(L, w, 1), V.loc.end.line === K.loc.start.line ? v.setDesiredOffset(K, L, 0) : v.setDesiredOffset(K, w, 1);
    }
  }, "DoWhileStatement, WhileStatement, ForInStatement, ForOfStatement": function(S) {
    return a(S.body);
  }, ExportNamedDeclaration: function(S) {
    if (S.declaration === null) {
      var w = m.getLastToken(S, P.isClosingBraceToken);
      i(S.specifiers, m.getFirstToken(S, { skip: 1 }), w, 1), S.source && v.setDesiredOffsets([w.range[1], S.range[1]], m.getFirstToken(S), 1);
    }
  }, ForStatement: function(S) {
    var w = m.getFirstToken(S, 1);
    S.init && v.setDesiredOffsets(S.init.range, w, 1), S.test && v.setDesiredOffsets(S.test.range, w, 1), S.update && v.setDesiredOffsets(S.update.range, w, 1), a(S.body);
  }, "FunctionDeclaration, FunctionExpression": function(S) {
    var w = m.getTokenBefore(S.body), D = m.getTokenBefore(S.params.length ? S.params[0] : w);
    b.add(D), b.add(w), i(S.params, D, w, d[S.type].parameters);
  }, IfStatement: function(S) {
    a(S.consequent), S.alternate && S.alternate.type !== "IfStatement" && a(S.alternate);
  }, ImportDeclaration: function(S) {
    if (S.specifiers.some(function(W) {
      return W.type === "ImportSpecifier";
    })) {
      var w = m.getFirstToken(S, P.isOpeningBraceToken), D = m.getLastToken(S, P.isClosingBraceToken);
      i(S.specifiers.filter(function(W) {
        return W.type === "ImportSpecifier";
      }), w, D, d.ImportDeclaration);
    }
    var I = m.getLastToken(S, function(W) {
      return W.type === "Identifier" && W.value === "from";
    }), L = m.getLastToken(S, function(W) {
      return W.type === "String";
    }), V = m.getLastToken(S, function(W) {
      return W.type === "Punctuator" && W.value === ";";
    });
    if (I) {
      var K = V && V.range[1] === L.range[1] ? S.range[1] : L.range[1];
      v.setDesiredOffsets([I.range[0], K], m.getFirstToken(S), 1);
    }
  }, ImportExpression: function(S) {
    var w = m.getFirstToken(S, 1), D = m.getLastToken(S);
    b.add(w), b.add(D), v.setDesiredOffset(w, m.getTokenBefore(w), 0), i([S.source], w, D, d.CallExpression.arguments);
  }, "MemberExpression, JSXMemberExpression, MetaProperty": function(S) {
    var w = S.type === "MetaProperty" ? S.meta : S.object, D = m.getFirstTokenBetween(w, S.property, P.isNotClosingParenToken), I = m.getTokenAfter(D), L = m.getTokensBetween(w, S.property, { filter: P.isClosingParenToken }).length, V = L ? m.getTokenBefore(w, { skip: L - 1 }) : m.getFirstToken(w), K = m.getTokenBefore(D), W = S.computed ? D : I;
    S.computed && (v.setDesiredOffset(m.getLastToken(S), D, 0), v.setDesiredOffsets(S.property.range, D, 1));
    var R = K.loc.end.line === W.loc.start.line ? K : V;
    typeof d.MemberExpression == "number" ? (v.setDesiredOffset(D, R, d.MemberExpression), v.setDesiredOffset(I, S.computed ? D : R, d.MemberExpression)) : (v.ignoreToken(D), v.ignoreToken(I), v.setDesiredOffset(D, R, 0), v.setDesiredOffset(I, D, 0));
  }, NewExpression: function(S) {
    (0 < S.arguments.length || P.isClosingParenToken(m.getLastToken(S)) && P.isOpeningParenToken(m.getLastToken(S, 1))) && s(S);
  }, Property: function(S) {
    if (!S.shorthand && !S.method && S.kind === "init") {
      var w = m.getFirstTokenBetween(S.key, S.value, P.isColonToken);
      v.ignoreToken(m.getTokenAfter(w));
    }
  }, SwitchStatement: function(S) {
    var w = m.getTokenAfter(S.discriminant, P.isOpeningBraceToken), D = m.getLastToken(S);
    v.setDesiredOffsets([w.range[1], D.range[0]], w, d.SwitchCase), S.cases.length && m.getTokensBetween(S.cases[S.cases.length - 1], D, { includeComments: !0, filter: P.isCommentToken }).forEach(function(I) {
      return v.ignoreToken(I);
    });
  }, SwitchCase: function(S) {
    if (S.consequent.length !== 1 || S.consequent[0].type !== "BlockStatement") {
      var w = m.getFirstToken(S), D = m.getTokenAfter(S);
      v.setDesiredOffsets([w.range[1], D.range[0]], w, 1);
    }
  }, TemplateLiteral: function(S) {
    S.expressions.forEach(function(w, D) {
      var I = S.quasis[D], L = S.quasis[D + 1], V = I.loc.start.line === I.loc.end.line ? m.getFirstToken(I) : null;
      v.setDesiredOffsets([I.range[1], L.range[0]], V, 1), v.setDesiredOffset(m.getFirstToken(L), V, 0);
    });
  }, VariableDeclaration: function(S) {
    var w = Object.prototype.hasOwnProperty.call(d.VariableDeclarator, S.kind) ? d.VariableDeclarator[S.kind] : 1, D = m.getFirstToken(S), I = m.getLastToken(S);
    if (d.VariableDeclarator[S.kind] === "first") {
      if (1 < S.declarations.length)
        return void i(S.declarations, D, I, "first");
      w = 1;
    }
    S.declarations[S.declarations.length - 1].loc.start.line > S.loc.start.line ? v.setDesiredOffsets(S.range, D, w, !0) : v.setDesiredOffsets(S.range, D, w), P.isSemicolonToken(I) && v.ignoreToken(I);
  }, VariableDeclarator: function(S) {
    if (S.init) {
      var w = m.getTokenBefore(S.init, P.isNotOpeningParenToken), D = m.getTokenAfter(w);
      v.ignoreToken(w), v.ignoreToken(D), v.setDesiredOffsets([D.range[0], S.range[1]], w, 1), v.setDesiredOffset(w, m.getLastToken(S.id), 0);
    }
  }, "JSXAttribute[value]": function(S) {
    var w = m.getFirstTokenBetween(S.name, S.value, function(D) {
      return D.type === "Punctuator" && D.value === "=";
    });
    v.setDesiredOffsets([w.range[0], S.value.range[1]], m.getFirstToken(S.name), 1);
  }, JSXElement: function(S) {
    S.closingElement && i(S.children, m.getFirstToken(S.openingElement), m.getFirstToken(S.closingElement), 1);
  }, JSXOpeningElement: function(S) {
    var w, D = m.getFirstToken(S);
    S.selfClosing ? (w = m.getLastToken(S, { skip: 1 }), v.setDesiredOffset(m.getLastToken(S), w, 0)) : w = m.getLastToken(S), v.setDesiredOffsets(S.name.range, m.getFirstToken(S)), i(S.attributes, D, w, 1);
  }, JSXClosingElement: function(S) {
    var w = m.getFirstToken(S);
    v.setDesiredOffsets(S.name.range, w, 1);
  }, JSXFragment: function(S) {
    var w = m.getFirstToken(S.openingFragment), D = m.getFirstToken(S.closingFragment);
    i(S.children, w, D, 1);
  }, JSXOpeningFragment: function(S) {
    var w = m.getFirstToken(S), D = m.getLastToken(S);
    v.setDesiredOffsets(S.range, w, 1), v.matchOffsetOf(w, D);
  }, JSXClosingFragment: function(S) {
    var w = m.getFirstToken(S), D = m.getLastToken(S, { skip: 1 }), I = m.getLastToken(S), L = P.isTokenOnSameLine(D, I) ? D : I;
    v.setDesiredOffsets(S.range, w, 1), v.matchOffsetOf(w, L);
  }, JSXExpressionContainer: function(S) {
    var w = m.getFirstToken(S), D = m.getLastToken(S);
    v.setDesiredOffsets([w.range[1], D.range[0]], w, 1);
  }, JSXSpreadAttribute: function(S) {
    var w = m.getFirstToken(S), D = m.getLastToken(S);
    v.setDesiredOffsets([w.range[1], D.range[0]], w, 1);
  }, "*": function(S) {
    var w = m.getFirstToken(S);
    w && !x.has(w) && v.setDesiredOffsets(S.range, w, 0);
  } }, k = [], F = ye.lodash.mapValues(C, function(S) {
    return function(w) {
      return k.push({ listener: S, node: w });
    };
  }), B = /* @__PURE__ */ new Set(), O = d.ignoredNodes.reduce(function(S, w) {
    return Object.assign(S, Fn({}, w, c));
  }, {});
  return Object.assign(F, O, { "*:exit": function(S) {
    j5.has(S.type) || c(S);
  }, "Program:exit": function() {
    d.ignoreComments && m.getAllComments().forEach(function(w) {
      return v.ignoreToken(w);
    }), k.filter(function(w) {
      return !B.has(w.node);
    }).forEach(function(w) {
      return w.listener(w.node);
    }), B.forEach(o), function(w) {
      var D = [], I = [];
      w.forEach(function(L) {
        P.isOpeningParenToken(L) ? D.push(L) : P.isClosingParenToken(L) && I.unshift({ left: D.pop(), right: L });
      }), I.forEach(function(L) {
        var V = L.left, K = L.right;
        if (!b.has(V) && !b.has(K)) {
          var W = new Set(m.getTokensBetween(V, K));
          W.forEach(function(R) {
            W.has(v.getFirstDependency(R)) || v.setDesiredOffset(R, V, 1);
          });
        }
        v.setDesiredOffset(K, V, 0);
      });
    }(m.ast.tokens);
    var S = m.ast.comments.reduce(function(w, D) {
      var I = m.getTokenBefore(D, { includeComments: !0 });
      return w.set(D, w.has(I) ? w.get(I) : I);
    }, /* @__PURE__ */ new WeakMap());
    m.lines.forEach(function(w, D) {
      var I = D + 1;
      if (y.firstTokensByLineNumber.has(I)) {
        var L = y.firstTokensByLineNumber.get(I);
        if (L.loc.start.line === I) {
          if (P.isCommentToken(L)) {
            var V = S.get(L), K = V ? m.getTokenAfter(V) : m.ast.tokens[0], W = V && !u(V, L), R = K && !u(L, K);
            if (K && P.isSemicolonToken(K) && !P.isTokenOnSameLine(L, K) && v.setDesiredOffset(L, K, 0), W && r(L, v.getDesiredIndent(V)) || R && r(L, v.getDesiredIndent(K)))
              return;
          }
          r(L, v.getDesiredIndent(L)) || n(L, v.getDesiredIndent(L));
        }
      }
    });
  } });
} };
function SA(e) {
  return e.type === "ForInStatement" || e.type === "ForOfStatement" || e.type === "ForStatement";
}
function q5(e) {
  var t = e.parent, n = t.parent;
  return SA(n) ? n.type === "ForStatement" ? n.init === t : n.left === t : !!e.init;
}
var W5 = { meta: { type: "suggestion", docs: { description: "require or disallow initialization in variable declarations", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/init-declarations" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { ignoreForLoopInit: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] }, messages: { initialized: "Variable '{{idName}}' should be initialized on declaration.", notInitialized: "Variable '{{idName}}' should not be initialized on declaration." } }, create: function(e) {
  var t = e.options[0] || "always", n = e.options[1] || {};
  return { "VariableDeclaration:exit": function(r) {
    for (var i = r.kind, a = r.declarations, s = 0; s < a.length; ++s) {
      var o = a[s], u = o.id, c = q5(o), f = n.ignoreForLoopInit && SA(r.parent), p = "";
      t !== "always" || c ? t === "never" && i !== "const" && c && !f && (p = "notInitialized") : p = "initialized", u.type === "Identifier" && p && e.report({ node: o, messageId: p, data: { idName: u.name } });
    }
  } };
} }, $5 = { "prefer-double": { quote: '"', description: "singlequote", convert: function(e) {
  return e.replace(/'/g, '"');
} }, "prefer-single": { quote: "'", description: "doublequote", convert: function(e) {
  return e.replace(/"/g, "'");
} } }, G5 = { meta: { type: "layout", docs: { description: "enforce the consistent use of either double or single quotes in JSX attributes", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/jsx-quotes" }, fixable: "whitespace", schema: [{ enum: ["prefer-single", "prefer-double"] }], messages: { unexpected: "Unexpected usage of {{description}}." } }, create: function(e) {
  var t = e.options[0] || "prefer-double", n = $5[t];
  return { JSXAttribute: function(r) {
    var i = r.value;
    i && P.isStringLiteral(i) && !function(a) {
      return a.value.indexOf(n.quote) !== -1 || P.isSurroundedBy(a.raw, n.quote);
    }(i) && e.report({ node: i, messageId: "unexpected", data: { description: n.description }, fix: function(a) {
      return a.replaceText(i, n.convert(i.raw));
    } });
  } };
} };
function Jd(e) {
  return e[e.length - 1];
}
function i2(e) {
  return e.loc.end.line === e.loc.start.line;
}
function Iu(e, t) {
  return e.mode = t.mode || "strict", e.beforeColon = t.beforeColon === void 0 ? 0 : +t.beforeColon, e.afterColon = t.afterColon === void 0 ? 1 : +t.afterColon, t.align !== void 0 && (xe(t.align) == "object" ? e.align = t.align : e.align = { on: t.align, mode: e.mode, beforeColon: e.beforeColon, afterColon: e.afterColon }), e;
}
var z5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing between keys and values in object literal properties", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/key-spacing" }, fixable: "whitespace", schema: [{ anyOf: [{ type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }, multiLine: { type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 } }, additionalProperties: !1 }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }, multiLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 }, align: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: !1 } }, additionalProperties: !1 }] }], messages: { extraKey: "Extra space after {{computed}}key '{{key}}'.", extraValue: "Extra space before value for {{computed}}key '{{key}}'.", missingKey: "Missing space after {{computed}}key '{{key}}'.", missingValue: "Missing space before value for {{computed}}key '{{key}}'." } }, create: function(e) {
  function t(y) {
    return !(y.method || y.shorthand || y.kind !== "init" || y.type !== "Property");
  }
  function n(y) {
    var v = y.key;
    return y.computed ? m.getText().slice(v.range[0], v.range[1]) : y.key.name || y.key.value;
  }
  function r(y, v, b, x, C) {
    var k = b.length - x, F = function(R) {
      return m.getTokenAfter(R, P.isColonToken);
    }(y.key), B = m.getTokenBefore(F, { includeComments: !0 }), O = m.getTokenAfter(F, { includeComments: !0 }), S = v === "key", w = S ? B.loc.start : O.loc.start, D = 0 < k, I = Math.abs(k), L = Array(I + 1).join(" ");
    if ((k && C === "strict" || 0 > k && C === "minimum" || 0 < k && !x && C === "minimum") && (!x || !function(R) {
      return P.LINEBREAK_MATCHER.test(R);
    }(b))) {
      var V, K;
      D ? (K = S ? [B.range[1], B.range[1] + I] : [O.range[0] - I, O.range[0]], V = function(R) {
        return R.removeRange(K);
      }) : V = S ? function(R) {
        return R.insertTextAfter(B, L);
      } : function(R) {
        return R.insertTextBefore(O, L);
      };
      var W;
      W = D ? v === "key" ? "extraKey" : "extraValue" : v === "key" ? "missingKey" : "missingValue", e.report({ node: y[v], loc: w, messageId: W, data: { computed: y.computed ? "computed " : "", key: n(y) }, fix: V });
    }
  }
  function i(y) {
    var v = m.getFirstToken(y);
    return function(b) {
      var x = m.getTokenAfter(b, P.isColonToken);
      return m.getTokenBefore(x);
    }(y.key).range[1] - v.range[0];
  }
  function a(y) {
    var v = /([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*):([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/.exec(m.getText().slice(y.key.range[1], y.value.range[0]));
    return v ? { beforeColon: v[1], afterColon: v[2] } : null;
  }
  function s(y) {
    return y.properties.length === 1 ? [y.properties] : y.properties.reduce(function(v, b) {
      var x = Jd(v), C = Jd(x);
      return !C || function(k, F) {
        var B = k.loc.start.line, O = F.loc.start.line;
        if (1 >= O - B)
          return !0;
        var S = m.getCommentsBefore(F);
        if (S.length && 1 >= S[0].loc.start.line - B && 1 >= O - Jd(S).loc.end.line) {
          for (var w = 1; w < S.length; w++)
            if (1 < S[w].loc.start.line - S[w - 1].loc.end.line)
              return !1;
          return !0;
        }
        return !1;
      }(C, b) ? x.push(b) : v.push([b]), v;
    }, [[]]);
  }
  function o(y) {
    s(y).forEach(function(v) {
      (function(b) {
        var x, C, k, F = b.length, B = b.map(i), O = d.on, S = Math.max.apply(Math, Mt(B));
        d && 1 < F ? (x = d.beforeColon, C = d.afterColon, k = d.mode) : (x = f.beforeColon, C = f.afterColon, k = d.mode), S += O === "colon" ? x : C;
        for (var w = 0; w < F; w++) {
          var D = b[w], I = a(D);
          if (I) {
            var L = B[w];
            O === "value" ? (r(D, "key", I.beforeColon, x, k), r(D, "value", I.afterColon, S - L, k)) : (r(D, "key", I.beforeColon, S - L, k), r(D, "value", I.afterColon, C, k));
          }
        }
      })(v.filter(t));
    });
  }
  function u(y, v) {
    var b = a(y);
    b && (r(y, "key", b.beforeColon, v.beforeColon, v.mode), r(y, "value", b.afterColon, v.afterColon, v.mode));
  }
  var c = function(y, v) {
    return xe(v.align) == "object" ? (y.align = Iu({}, v.align), y.align.on = v.align.on || "colon", y.align.mode = v.align.mode || "strict", y.multiLine = Iu({}, v.multiLine || v), y.singleLine = Iu({}, v.singleLine || v)) : (y.multiLine = Iu({}, v.multiLine || v), y.singleLine = Iu({}, v.singleLine || v), y.multiLine.align && (y.align = { on: y.multiLine.align.on, mode: y.multiLine.align.mode || y.multiLine.mode, beforeColon: y.multiLine.align.beforeColon, afterColon: y.multiLine.align.afterColon })), y;
  }({}, e.options[0] || {}), f = c.multiLine, p = c.singleLine, d = c.align || null, m = e.getSourceCode();
  return d ? { ObjectExpression: function(y) {
    i2(y) ? function(v) {
      for (var b = v.length, x = 0; x < b; x++)
        u(v[x], p);
    }(y.properties.filter(t)) : o(y);
  } } : { Property: function(y) {
    u(y, i2(y.parent) ? p : f);
  } };
} }, H5 = /^[\)>\]\}]$/, K5 = /^(?:[!\(<\[\{~]|\+\+?|\x2D\x2D?)$/, Qd = /^[\)\*>\]\}]$/, a2 = /^[\*\{]$/, J5 = /\$\{$/, Q5 = /^\}/, Ql = /^(?:JSXElement|RegularExpression|String|Template)$/, Ya = Qp.concat(["as", "async", "await", "from", "get", "let", "of", "set", "yield"]);
function o2(e) {
  return e.type === "Template" && J5.test(e.value);
}
function s2(e) {
  return e.type === "Template" && Q5.test(e.value);
}
(function() {
  Ya.sort();
  for (var e = 1; e < Ya.length; ++e)
    if (Ya[e] === Ya[e - 1])
      throw new Error("Duplication was found in the keyword list: ".concat(Ya[e]));
})();
var X5 = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after keywords", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/keyword-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: !0 }, after: { type: "boolean", default: !0 }, overrides: { type: "object", properties: Ya.reduce(function(e, t) {
  return e[t] = { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: !1 }, e;
}, {}), additionalProperties: !1 } }, additionalProperties: !1 }], messages: { expectedBefore: 'Expected space(s) before "{{value}}".', expectedAfter: 'Expected space(s) after "{{value}}".', unexpectedBefore: 'Unexpected space(s) before "{{value}}".', unexpectedAfter: 'Unexpected space(s) after "{{value}}".' } }, create: function(e) {
  function t(x, C) {
    var k = v.getTokenBefore(x);
    k && (Ql.test(k.type) || C.test(k.value)) && !o2(k) && P.isTokenOnSameLine(k, x) && !v.isSpaceBetweenTokens(k, x) && e.report({ loc: x.loc.start, messageId: "expectedBefore", data: x, fix: function(F) {
      return F.insertTextBefore(x, " ");
    } });
  }
  function n(x, C) {
    var k = v.getTokenBefore(x);
    k && (Ql.test(k.type) || C.test(k.value)) && !o2(k) && P.isTokenOnSameLine(k, x) && v.isSpaceBetweenTokens(k, x) && e.report({ loc: x.loc.start, messageId: "unexpectedBefore", data: x, fix: function(F) {
      return F.removeRange([k.range[1], x.range[0]]);
    } });
  }
  function r(x, C) {
    var k = v.getTokenAfter(x);
    k && (Ql.test(k.type) || C.test(k.value)) && !s2(k) && P.isTokenOnSameLine(x, k) && !v.isSpaceBetweenTokens(x, k) && e.report({ loc: x.loc.start, messageId: "expectedAfter", data: x, fix: function(F) {
      return F.insertTextAfter(x, " ");
    } });
  }
  function i(x, C) {
    var k = v.getTokenAfter(x);
    k && (Ql.test(k.type) || C.test(k.value)) && !s2(k) && P.isTokenOnSameLine(x, k) && v.isSpaceBetweenTokens(x, k) && e.report({ loc: x.loc.start, messageId: "unexpectedAfter", data: x, fix: function(F) {
      return F.removeRange([x.range[1], k.range[0]]);
    } });
  }
  function a(x, C) {
    b[x.value].before(x, C || H5);
  }
  function s(x, C) {
    b[x.value].after(x, C || K5);
  }
  function o(x) {
    a(x), s(x);
  }
  function u(x) {
    var C = x && v.getFirstToken(x);
    C && C.type === "Keyword" && o(C);
  }
  function c(x) {
    var C = x && v.getFirstToken(x);
    C && C.type === "Keyword" && a(C);
  }
  function f(x) {
    x && o(v.getTokenBefore(x, P.isKeywordToken));
  }
  function p(x) {
    var C = x && v.getFirstToken(x);
    C && (C.type === "Keyword" && C.value === "function" || C.value === "async") && a(C);
  }
  function d(x) {
    u(x), f(x.superClass);
  }
  function m(x) {
    var C = v.getFirstToken(x);
    if (a(C, Qd), s(C, a2), x.type === "ExportDefaultDeclaration" && o(v.getTokenAfter(C)), x.source) {
      var k = v.getTokenBefore(x.source);
      a(k, Qd), s(k, a2);
    }
  }
  function y(x) {
    if (x.static && u(x), x.kind === "get" || x.kind === "set" || (x.method || x.type === "MethodDefinition") && x.value.async) {
      var C = v.getTokenBefore(x.key, function(k) {
        switch (k.value) {
          case "get":
          case "set":
          case "async":
            return !0;
          default:
            return !1;
        }
      });
      if (!C)
        throw new Error("Failed to find token get, set, or async beside method name");
      o(C);
    }
  }
  var v = e.getSourceCode(), b = function() {
    for (var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, C = x.before !== !1, k = x.after !== !1, F = { before: C ? t : n, after: k ? r : i }, B = x && x.overrides || {}, O = /* @__PURE__ */ Object.create(null), S = 0; S < Ya.length; ++S) {
      var w = Ya[S], D = B[w];
      if (D) {
        var I = "before" in D ? D.before : C, L = "after" in D ? D.after : k;
        O[w] = { before: I ? t : n, after: L ? r : i };
      } else
        O[w] = F;
    }
    return O;
  }(e.options[0]);
  return { DebuggerStatement: u, WithStatement: u, BreakStatement: u, ContinueStatement: u, ReturnStatement: u, ThrowStatement: u, TryStatement: function(x) {
    u(x), u(x.handler), f(x.finalizer);
  }, IfStatement: function(x) {
    u(x), f(x.alternate);
  }, SwitchStatement: u, SwitchCase: u, DoWhileStatement: function(x) {
    u(x), f(x.test);
  }, ForInStatement: function(x) {
    u(x), f(x.right);
  }, ForOfStatement: function(x) {
    x.await ? (a(v.getFirstToken(x, 0)), s(v.getFirstToken(x, 1))) : u(x), o(v.getTokenBefore(x.right, P.isNotOpeningParenToken));
  }, ForStatement: u, WhileStatement: u, ClassDeclaration: d, ExportNamedDeclaration: m, ExportDefaultDeclaration: m, ExportAllDeclaration: m, FunctionDeclaration: p, ImportDeclaration: m, VariableDeclaration: u, ArrowFunctionExpression: p, AwaitExpression: function(x) {
    a(v.getFirstToken(x));
  }, ClassExpression: d, FunctionExpression: p, NewExpression: c, Super: c, ThisExpression: c, UnaryExpression: c, YieldExpression: c, ImportNamespaceSpecifier: function(x) {
    a(v.getFirstToken(x, 1), Qd);
  }, MethodDefinition: y, Property: y };
} }, Y5 = { meta: { type: "layout", docs: { description: "enforce position of line comments", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/line-comment-position" }, schema: [{ oneOf: [{ enum: ["above", "beside"] }, { type: "object", properties: { position: { enum: ["above", "beside"] }, ignorePattern: { type: "string" }, applyDefaultPatterns: { type: "boolean" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: !1 }] }], messages: { above: "Expected comment to be above code.", beside: "Expected comment to be beside code." } }, create: function(e) {
  var t, n, r = e.options[0], i = !0;
  r && typeof r != "string" ? (t = !r.position || r.position === "above", n = r.ignorePattern, i = Object.prototype.hasOwnProperty.call(r, "applyDefaultIgnorePatterns") ? r.applyDefaultIgnorePatterns : r.applyDefaultPatterns !== !1) : t = !r || r === "above";
  var a = P.COMMENTS_IGNORE_PATTERN, s = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*falls?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/, o = new RegExp(n, "u"), u = e.getSourceCode();
  return { Program: function() {
    u.getAllComments().filter(function(c) {
      return c.type === "Line";
    }).forEach(function(c) {
      if (!(i && (a.test(c.value) || s.test(c.value)) || n && o.test(c.value))) {
        var f = u.getTokenBefore(c, { includeComments: !0 }), p = f && f.loc.end.line === c.loc.start.line;
        t ? p && e.report({ node: c, messageId: "above" }) : !p && e.report({ node: c, messageId: "beside" });
      }
    });
  } };
} }, Z5 = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/linebreak-style" }, fixable: "whitespace", schema: [{ enum: ["unix", "windows"] }], messages: { expectedLF: "Expected linebreaks to be 'LF' but found 'CRLF'.", expectedCRLF: "Expected linebreaks to be 'CRLF' but found 'LF'." } }, create: function(e) {
  function t(r, i) {
    return function(a) {
      return a.replaceTextRange(r, i);
    };
  }
  var n = e.getSourceCode();
  return { Program: function(r) {
    for (var i, a = (e.options[0] || "unix") === "unix", s = a ? `
` : `\r
`, o = n.getText(), u = P.createGlobalLinebreakMatcher(), c = 0; (i = u.exec(o)) !== null; )
      if (c++, i[0] !== s) {
        var f = i.index, p = [f, f + i[0].length];
        e.report({ node: r, loc: { line: c, column: n.lines[c - 1].length }, messageId: a ? "expectedLF" : "expectedCRLF", fix: t(p, s) });
      }
  } };
} }, eB = { meta: { type: "layout", docs: { description: "require empty lines around comments", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/lines-around-comment" }, fixable: "whitespace", schema: [{ type: "object", properties: { beforeBlockComment: { type: "boolean", default: !0 }, afterBlockComment: { type: "boolean", default: !1 }, beforeLineComment: { type: "boolean", default: !1 }, afterLineComment: { type: "boolean", default: !1 }, allowBlockStart: { type: "boolean", default: !1 }, allowBlockEnd: { type: "boolean", default: !1 }, allowClassStart: { type: "boolean" }, allowClassEnd: { type: "boolean" }, allowObjectStart: { type: "boolean" }, allowObjectEnd: { type: "boolean" }, allowArrayStart: { type: "boolean" }, allowArrayEnd: { type: "boolean" }, ignorePattern: { type: "string" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: !1 }], messages: { after: "Expected line after comment.", before: "Expected line before comment." } }, create: function(e) {
  function t(I, L) {
    return I.type === L || I.body && I.body.type === L || I.consequent && I.consequent.type === L;
  }
  function n(I) {
    return k.getNodeByRangeIndex(I.range[0]);
  }
  function r(I, L) {
    var V = n(I);
    return V && t(V, L) && I.loc.start.line - V.loc.start.line == 1;
  }
  function i(I, L) {
    var V = n(I);
    return V && t(V, L) && V.loc.end.line - I.loc.end.line == 1;
  }
  function a(I) {
    return r(I, "ClassBody") || r(I, "BlockStatement") || r(I, "SwitchCase");
  }
  function s(I) {
    return i(I, "ClassBody") || i(I, "BlockStatement") || i(I, "SwitchCase") || i(I, "SwitchStatement");
  }
  function o(I) {
    return r(I, "ClassBody");
  }
  function u(I) {
    return i(I, "ClassBody");
  }
  function c(I) {
    return r(I, "ObjectExpression") || r(I, "ObjectPattern");
  }
  function f(I) {
    return i(I, "ObjectExpression") || i(I, "ObjectPattern");
  }
  function p(I) {
    return r(I, "ArrayExpression") || r(I, "ArrayPattern");
  }
  function d(I) {
    return i(I, "ArrayExpression") || i(I, "ArrayPattern");
  }
  function m(I, L) {
    if (!(C && b.test(I.value) || v && x.test(I.value))) {
      var V = L.after, K = L.before, W = I.loc.start.line - 1, R = I.loc.end.line + 1, q = function(Fe) {
        var Pe = Fe;
        do
          Pe = k.getTokenBefore(Pe, { includeComments: !0 });
        while (Pe && P.isCommentToken(Pe));
        if (Pe && P.isTokenOnSameLine(Pe, Fe))
          return !0;
        Pe = Fe;
        do
          Pe = k.getTokenAfter(Pe, { includeComments: !0 });
        while (Pe && P.isCommentToken(Pe));
        return !(!Pe || !P.isTokenOnSameLine(Fe, Pe));
      }(I), J = y.allowBlockStart && a(I) && !(y.allowClassStart === !1 && o(I)), X = y.allowBlockEnd && s(I) && !(y.allowClassEnd === !1 && u(I)), ce = y.allowClassStart && o(I), A = y.allowClassEnd && u(I), M = y.allowObjectStart && c(I), ne = y.allowObjectEnd && f(I), de = y.allowArrayStart && p(I), he = y.allowArrayEnd && d(I);
      if (1 > W && (K = !1), R >= B && (V = !1), !q) {
        var j = k.getTokenBefore(I, { includeComments: !0 }), ie = k.getTokenAfter(I, { includeComments: !0 });
        if (!(J || ce || M || de) && K && !ye.lodash.includes(D, W) && (!P.isCommentToken(j) || !P.isTokenOnSameLine(j, I))) {
          var fe = I.range[0] - I.loc.start.column, ge = [fe, fe];
          e.report({ node: I, messageId: "before", fix: function(Fe) {
            return Fe.insertTextBeforeRange(ge, `
`);
          } });
        }
        X || A || ne || he || !V || ye.lodash.includes(D, R) || P.isCommentToken(ie) && P.isTokenOnSameLine(I, ie) || e.report({ node: I, messageId: "after", fix: function(Fe) {
          return Fe.insertTextAfter(I, `
`);
        } });
      }
    }
  }
  var y = Object.assign({}, e.options[0]), v = y.ignorePattern, b = P.COMMENTS_IGNORE_PATTERN, x = new RegExp(v, "u"), C = y.applyDefaultIgnorePatterns !== !1;
  y.beforeBlockComment = y.beforeBlockComment === void 0 || y.beforeBlockComment;
  var k = e.getSourceCode(), F = k.lines, B = F.length + 1, O = k.getAllComments(), S = function(I) {
    var L = [];
    return I.forEach(function(V) {
      var K = V.loc.start.line, W = V.loc.end.line;
      L.push(K, W);
    }), L;
  }(O), w = function(I) {
    return I.map(function(L, V) {
      return { code: L.trim(), num: V + 1 };
    }).filter(function(L) {
      return !L.code;
    }).map(function(L) {
      return L.num;
    });
  }(F), D = S.concat(w);
  return { Program: function() {
    O.forEach(function(I) {
      I.type === "Line" ? (y.beforeLineComment || y.afterLineComment) && m(I, { after: y.afterLineComment, before: y.beforeLineComment }) : I.type === "Block" && (y.beforeBlockComment || y.afterBlockComment) && m(I, { after: y.afterBlockComment, before: y.beforeBlockComment });
    });
  } };
} }, tB = { meta: { type: "layout", docs: { description: "require or disallow newlines around directives", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/lines-around-directive" }, schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { before: { enum: ["always", "never"] }, after: { enum: ["always", "never"] } }, additionalProperties: !1, minProperties: 2 }] }], fixable: "whitespace", messages: { expected: 'Expected newline {{location}} "{{value}}" directive.', unexpected: 'Unexpected newline {{location}} "{{value}}" directive.' }, deprecated: !0, replacedBy: ["padding-line-between-statements"] }, create: function(e) {
  function t(f) {
    var p = s.getTokenBefore(f, { includeComments: !0 }), d = p ? p.loc.end.line : 0;
    return 2 <= f.loc.start.line - d;
  }
  function n(f) {
    var p = s.getLastToken(f), d = s.getTokenBefore(p);
    return P.isSemicolonToken(p) && p.loc.start.line > d.loc.end.line ? d : p;
  }
  function r(f) {
    var p = n(f);
    return 2 <= s.getTokenAfter(p, { includeComments: !0 }).loc.start.line - p.loc.end.line;
  }
  function i(f, p, d) {
    e.report({ node: f, messageId: d ? "expected" : "unexpected", data: { value: f.expression.value, location: p }, fix: function(m) {
      var y = n(f);
      return d ? p === "before" ? m.insertTextBefore(f, `
`) : m.insertTextAfter(y, `
`) : m.removeRange(p === "before" ? [f.range[0] - 1, f.range[0]] : [y.range[1], y.range[1] + 1]);
    } });
  }
  function a(f) {
    var p = P.getDirectivePrologue(f);
    if (p.length) {
      var d = p[0], m = s.getCommentsBefore(d);
      m.length ? (u === "always" && !t(d) && i(d, "before", !0), u === "never" && t(d) && i(d, "before", !1)) : f.type === "Program" && u === "never" && !m.length && t(d) && i(d, "before", !1);
      var y = p[p.length - 1], v = f.type === "Program" ? f.body : f.body.body;
      (y !== v[v.length - 1] || y.trailingComments) && (c === "always" && !r(y) && i(y, "after", !0), c === "never" && r(y) && i(y, "after", !1));
    }
  }
  var s = e.getSourceCode(), o = e.options[0] || "always", u = typeof o == "string" ? o : o.before, c = typeof o == "string" ? o : o.after;
  return { Program: a, FunctionDeclaration: a, FunctionExpression: a, ArrowFunctionExpression: a };
} }, nB = { meta: { type: "layout", docs: { description: "require or disallow an empty line between class members", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/lines-between-class-members" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptAfterSingleLine: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { never: "Unexpected blank line between class members.", always: "Expected blank line between class members." } }, create: function(e) {
  var t = [];
  t[0] = e.options[0] || "always", t[1] = e.options[1] || { exceptAfterSingleLine: !1 };
  var n = e.getSourceCode();
  return { ClassBody: function(r) {
    for (var i = r.body, a = function(o) {
      var u = n.getFirstToken(i[o]), c = n.getLastToken(i[o]), f = n.getFirstToken(i[o + 1]), p = function(m, y) {
        var v = n.getCommentsBefore(y), b = v.length;
        if (b === 0)
          return 1 <= y.loc.start.line - m.loc.end.line - 1;
        for (var x = 0, C = -1, k = 0; k < b; k++)
          x += v[k].loc.end.line - v[k].loc.start.line + 1, C === v[k].loc.start.line && (x -= 1), C = v[k].loc.end.line;
        return m.loc.end.line === v[0].loc.start.line && (x -= 1), v[b - 1].loc.end.line === y.loc.start.line && (x -= 1), 1 <= y.loc.start.line - m.loc.end.line - 1 - x;
      }(c, f), d = !!P.isTokenOnSameLine(u, c) && t[1].exceptAfterSingleLine;
      (t[0] !== "always" || d || p) && (t[0] !== "never" || !p) || e.report({ node: i[o + 1], messageId: p ? "never" : "always", fix: function(m) {
        return p ? m.replaceTextRange([c.range[1], f.range[0]], `
`) : m.insertTextAfter(c, `
`);
      } });
    }, s = 0; s < i.length - 1; s++)
      a(s);
  } };
} }, rB = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that blocks can be nested", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-depth" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }], messages: { tooDeeply: "Blocks are nested too deeply ({{depth}}). Maximum allowed is {{maxDepth}}." } }, create: function(e) {
  function t() {
    a.push(0);
  }
  function n() {
    a.pop();
  }
  function r(u) {
    var c = ++a[a.length - 1];
    c > o && e.report({ node: u, messageId: "tooDeeply", data: { depth: c, maxDepth: o } });
  }
  function i() {
    a[a.length - 1]--;
  }
  var a = [], s = e.options[0], o = 4;
  return xe(s) == "object" && (Object.prototype.hasOwnProperty.call(s, "maximum") || Object.prototype.hasOwnProperty.call(s, "max")) && (o = s.maximum || s.max), typeof s == "number" && (o = s), { Program: t, FunctionDeclaration: t, FunctionExpression: t, ArrowFunctionExpression: t, IfStatement: function(u) {
    u.parent.type !== "IfStatement" && r(u);
  }, SwitchStatement: r, TryStatement: r, DoWhileStatement: r, WhileStatement: r, WithStatement: r, ForStatement: r, ForInStatement: r, ForOfStatement: r, "IfStatement:exit": i, "SwitchStatement:exit": i, "TryStatement:exit": i, "DoWhileStatement:exit": i, "WhileStatement:exit": i, "WithStatement:exit": i, "ForStatement:exit": i, "ForInStatement:exit": i, "ForOfStatement:exit": i, "FunctionDeclaration:exit": n, "FunctionExpression:exit": n, "ArrowFunctionExpression:exit": n, "Program:exit": n };
} }, kA = { type: "object", properties: { code: { type: "integer", minimum: 0 }, comments: { type: "integer", minimum: 0 }, tabWidth: { type: "integer", minimum: 0 }, ignorePattern: { type: "string" }, ignoreComments: { type: "boolean" }, ignoreStrings: { type: "boolean" }, ignoreUrls: { type: "boolean" }, ignoreTemplateLiterals: { type: "boolean" }, ignoreRegExpLiterals: { type: "boolean" }, ignoreTrailingComments: { type: "boolean" } }, additionalProperties: !1 }, u2 = { anyOf: [kA, { type: "integer", minimum: 0 }] }, iB = { meta: { type: "layout", docs: { description: "enforce a maximum line length", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-len" }, schema: [u2, u2, kA], messages: { max: "This line has a length of {{lineLength}}. Maximum allowed is {{maxLength}}.", maxComment: "This line has a comment length of {{lineLength}}. Maximum allowed is {{maxCommentLength}}." } }, create: function(e) {
  function t(C, k, F) {
    return F && F.loc.start.line === k && k <= F.loc.end.line && (F.loc.end.line > k || F.loc.end.column === C.length);
  }
  function n(C, k) {
    return C.slice(0, k.loc.start.column).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+$/, "");
  }
  function r(C, k, F) {
    Array.isArray(C[k]) || (C[k] = []), C[k].push(F);
  }
  function i(C, k) {
    for (var F = k.loc.start.line; F <= k.loc.end.line; ++F)
      r(C, F, k);
    return C;
  }
  var a = /(?:[\0-"\$-\.0-9;->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]):\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, s = e.getSourceCode(), o = Object.assign({}, e.options[e.options.length - 1]);
  typeof e.options[0] == "number" && (o.code = e.options[0]), typeof e.options[1] == "number" && (o.tabWidth = e.options[1]);
  var u = typeof o.code == "number" ? o.code : 80, c = typeof o.tabWidth == "number" ? o.tabWidth : 4, f = !!o.ignoreComments, p = !!o.ignoreStrings, d = !!o.ignoreTemplateLiterals, m = !!o.ignoreRegExpLiterals, y = !!o.ignoreTrailingComments || !!o.ignoreComments, v = !!o.ignoreUrls, b = o.comments, x = o.ignorePattern || null;
  return x && (x = new RegExp(x, "u")), { Program: function(C) {
    var k = s.lines, F = f || b || y ? s.getAllComments() : [], B = 0, O = s.ast.tokens.filter(function(D) {
      return D.type === "String" || D.type === "JSXText" && s.getNodeByRangeIndex(D.range[0] - 1).type === "JSXAttribute";
    }).reduce(i, {}), S = s.ast.tokens.filter(function(D) {
      return D.type === "Template";
    }).reduce(i, {}), w = s.ast.tokens.filter(function(D) {
      return D.type === "RegularExpression";
    }).reduce(i, {});
    k.forEach(function(D, I) {
      var L, V = I + 1, K = !1;
      if (B < F.length) {
        var W = null;
        do
          W = F[++B];
        while (W && W.loc.start.line <= V);
        if (function(J, X, ce) {
          var A = ce.loc.start, M = ce.loc.end, ne = !J.slice(0, ce.loc.start.column).trim();
          return ce && (A.line < X || A.line === X && ne) && (M.line > X || M.line === X && M.column === J.length);
        }(D, V, W = F[--B]))
          K = !0, L = D;
        else if (y && t(D, V, W)) {
          L = n(D, W);
          for (var R = B; t(L, V, F[--R]); )
            L = n(L, F[R]);
        } else
          L = D;
      } else
        L = D;
      if (!(x && x.test(L) || v && a.test(L) || p && O[V] || d && S[V] || m && w[V])) {
        var q = function(J, X) {
          var ce = 0;
          return J.replace(/\t/g, function(A, M) {
            ce += X - (X ? (M + ce) % X : 0) - 1;
          }), Array.from(J).length + ce;
        }(L, c);
        K && f || (K && b ? q > b && e.report({ node: C, loc: { line: V, column: 0 }, messageId: "maxComment", data: { lineLength: q, maxCommentLength: b } }) : q > u && e.report({ node: C, loc: { line: V, column: 0 }, messageId: "max", data: { lineLength: q, maxLength: u } }));
      }
    });
  } };
} }, aB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of line of code in a function", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-lines-per-function" }, schema: [{ oneOf: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" }, IIFEs: { type: "boolean" } }, additionalProperties: !1 }, { type: "integer", minimum: 1 }] }], messages: { exceed: "{{name}} has too many lines ({{lineCount}}). Maximum allowed is {{maxLines}}." } }, create: function(e) {
  function t(p, d, m) {
    var y = m.loc.start, v = m.loc.end, b = y.line === d && !p.slice(0, y.column).trim(), x = v.line === d && !p.slice(v.column).trim();
    return m && (y.line < d || b) && (v.line > d || x);
  }
  function n(p) {
    var d = function(x) {
      return !(!x.parent || x !== x.parent.value || x.parent.type !== "MethodDefinition" && (x.parent.type !== "Property" || x.parent.method !== !0 && x.parent.kind !== "get" && x.parent.kind !== "set"));
    }(p) ? p.parent : p;
    if (c || !function(x) {
      return x.type === "FunctionExpression" && x.parent && x.parent.type === "CallExpression" && x.parent.callee === x;
    }(d)) {
      for (var m = 0, y = d.loc.start.line - 1; y < d.loc.end.line; ++y) {
        var v = i[y];
        o && f.has(y + 1) && t(v, y + 1, f.get(y + 1)) || u && v.match(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/) || m++;
      }
      if (m > s) {
        var b = ye.lodash.upperFirst(P.getFunctionNameWithKind(p));
        e.report({ node: d, messageId: "exceed", data: { name: b, lineCount: m, maxLines: s } });
      }
    }
  }
  var r = e.getSourceCode(), i = r.lines, a = e.options[0], s = 50, o = !1, u = !1, c = !1;
  xe(a) == "object" ? (s = typeof a.max == "number" ? a.max : 50, o = !!a.skipComments, u = !!a.skipBlankLines, c = !!a.IIFEs) : typeof a == "number" && (s = a);
  var f = function(p) {
    var d = /* @__PURE__ */ new Map();
    return p && p.forEach(function(m) {
      for (var y = m.loc.start.line; y <= m.loc.end.line; y++)
        d.set(y, m);
    }), d;
  }(r.getAllComments());
  return { FunctionDeclaration: n, FunctionExpression: n, ArrowFunctionExpression: n };
} }, oB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of lines per file", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-lines" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" } }, additionalProperties: !1 }] }], messages: { exceed: "File has too many lines ({{actual}}). Maximum allowed is {{max}}." } }, create: function(e) {
  function t(u) {
    return u && (u.type === "Block" || u.type === "Line");
  }
  function n(u) {
    var c, f = u.loc.start.line, p = u.loc.end.line;
    c = u;
    do
      c = o.getTokenBefore(c, { includeComments: !0 });
    while (t(c));
    c && P.isTokenOnSameLine(c, u) && (f += 1), c = u;
    do
      c = o.getTokenAfter(c, { includeComments: !0 });
    while (t(c));
    return c && P.isTokenOnSameLine(u, c) && (p -= 1), f <= p ? ye.lodash.range(f, p + 1) : [];
  }
  var r = e.options[0], i = 300;
  xe(r) == "object" && Object.prototype.hasOwnProperty.call(r, "max") ? i = r.max : typeof r == "number" && (i = r);
  var a = r && r.skipComments, s = r && r.skipBlankLines, o = e.getSourceCode();
  return { "Program:exit": function() {
    var u = o.lines.map(function(p, d) {
      return { lineNumber: d + 1, text: p };
    });
    if (s && (u = u.filter(function(p) {
      return p.text.trim() !== "";
    })), a) {
      var c = o.getAllComments(), f = ye.lodash.flatten(c.map(function(p) {
        return n(p);
      }));
      u = u.filter(function(p) {
        return !ye.lodash.includes(f, p.lineNumber);
      });
    }
    u.length > i && e.report({ loc: { line: 1, column: 0 }, messageId: "exceed", data: { max: i, actual: u.length } });
  } };
} }, sB = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that callbacks can be nested", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-nested-callbacks" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }], messages: { exceed: "Too many nested callbacks ({{num}}). Maximum allowed is {{max}}." } }, create: function(e) {
  function t(s) {
    if (s.parent.type === "CallExpression" && a.push(s), a.length > i) {
      var o = { num: a.length, max: i };
      e.report({ node: s, messageId: "exceed", data: o });
    }
  }
  function n() {
    a.pop();
  }
  var r = e.options[0], i = 10;
  xe(r) == "object" && (Object.prototype.hasOwnProperty.call(r, "maximum") || Object.prototype.hasOwnProperty.call(r, "max")) ? i = r.maximum || r.max : typeof r == "number" && (i = r);
  var a = [];
  return { ArrowFunctionExpression: t, "ArrowFunctionExpression:exit": n, FunctionExpression: t, "FunctionExpression:exit": n };
} }, uB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of parameters in function definitions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-params" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }], messages: { exceed: "{{name}} has too many parameters ({{count}}). Maximum allowed is {{max}}." } }, create: function(e) {
  function t(a) {
    a.params.length > i && e.report({ loc: P.getFunctionHeadLoc(a, n), node: a, messageId: "exceed", data: { name: ye.lodash.upperFirst(P.getFunctionNameWithKind(a)), count: a.params.length, max: i } });
  }
  var n = e.getSourceCode(), r = e.options[0], i = 3;
  return xe(r) == "object" && (Object.prototype.hasOwnProperty.call(r, "maximum") || Object.prototype.hasOwnProperty.call(r, "max")) && (i = r.maximum || r.max), typeof r == "number" && (i = r), { FunctionDeclaration: t, ArrowFunctionExpression: t, FunctionExpression: t };
} }, cB = { meta: { type: "layout", docs: { description: "enforce a maximum number of statements allowed per line", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-statements-per-line" }, schema: [{ type: "object", properties: { max: { type: "integer", minimum: 1, default: 1 } }, additionalProperties: !1 }], messages: { exceed: "This line has {{numberOfStatementsOnThisLine}} {{statements}}. Maximum allowed is {{maxStatementsPerLine}}." } }, create: function(e) {
  function t() {
    i && e.report({ node: i, messageId: "exceed", data: { numberOfStatementsOnThisLine: c, maxStatementsPerLine: o, statements: c === 1 ? "statement" : "statements" } }), i = null;
  }
  function n(p) {
    var d = p.loc.start.line;
    f.test(p.parent.type) && p.parent.alternate !== p || (d === u ? c += 1 : (t(), c = 1, u = d), c === o + 1 && (i = i || p));
  }
  function r(p) {
    var d = function(m) {
      return a.getLastToken(m, P.isNotSemicolonToken);
    }(p).loc.end.line;
    d !== u && (t(), c = 1, u = d);
  }
  var i, a = e.getSourceCode(), s = e.options[0] || {}, o = s.max === void 0 ? 1 : s.max, u = 0, c = 0, f = /^(?:(?:DoWhile|For|ForIn|ForOf|If|Labeled|While)Statement|Export(?:Default|Named)Declaration)$/;
  return { BreakStatement: n, ClassDeclaration: n, ContinueStatement: n, DebuggerStatement: n, DoWhileStatement: n, ExpressionStatement: n, ForInStatement: n, ForOfStatement: n, ForStatement: n, FunctionDeclaration: n, IfStatement: n, ImportDeclaration: n, LabeledStatement: n, ReturnStatement: n, SwitchStatement: n, ThrowStatement: n, TryStatement: n, VariableDeclaration: n, WhileStatement: n, WithStatement: n, ExportNamedDeclaration: n, ExportDefaultDeclaration: n, ExportAllDeclaration: n, "BreakStatement:exit": r, "ClassDeclaration:exit": r, "ContinueStatement:exit": r, "DebuggerStatement:exit": r, "DoWhileStatement:exit": r, "ExpressionStatement:exit": r, "ForInStatement:exit": r, "ForOfStatement:exit": r, "ForStatement:exit": r, "FunctionDeclaration:exit": r, "IfStatement:exit": r, "ImportDeclaration:exit": r, "LabeledStatement:exit": r, "ReturnStatement:exit": r, "SwitchStatement:exit": r, "ThrowStatement:exit": r, "TryStatement:exit": r, "VariableDeclaration:exit": r, "WhileStatement:exit": r, "WithStatement:exit": r, "ExportNamedDeclaration:exit": r, "ExportDefaultDeclaration:exit": r, "ExportAllDeclaration:exit": r, "Program:exit": t };
} }, lB = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of statements allowed in function blocks", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/max-statements" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: !1 }] }, { type: "object", properties: { ignoreTopLevelFunctions: { type: "boolean" } }, additionalProperties: !1 }], messages: { exceed: "{{name}} has too many statements ({{count}}). Maximum allowed is {{max}}." } }, create: function(e) {
  function t(c, f, p) {
    if (f > p) {
      var d = ye.lodash.upperFirst(P.getFunctionNameWithKind(c));
      e.report({ node: c, messageId: "exceed", data: { name: d, count: f, max: p } });
    }
  }
  function n() {
    i.push(0);
  }
  function r(c) {
    var f = i.pop();
    s && i.length === 0 ? o.push({ node: c, count: f }) : t(c, f, u);
  }
  var i = [], a = e.options[0], s = e.options[1] && e.options[1].ignoreTopLevelFunctions || !1, o = [], u = 10;
  return xe(a) == "object" && (Object.prototype.hasOwnProperty.call(a, "maximum") || Object.prototype.hasOwnProperty.call(a, "max")) ? u = a.maximum || a.max : typeof a == "number" && (u = a), { FunctionDeclaration: n, FunctionExpression: n, ArrowFunctionExpression: n, BlockStatement: function(c) {
    i[i.length - 1] += c.body.length;
  }, "FunctionDeclaration:exit": r, "FunctionExpression:exit": r, "ArrowFunctionExpression:exit": r, "Program:exit": function() {
    o.length === 1 || o.forEach(function(c) {
      var f = c.count;
      t(c.node, f, u);
    });
  } };
} }, pB = { meta: { type: "suggestion", docs: { description: "enforce a particular style for multiline comments", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/multiline-comment-style" }, fixable: "whitespace", schema: [{ enum: ["starred-block", "separate-lines", "bare-block"] }], messages: { expectedBlock: "Expected a block comment instead of consecutive line comments.", expectedBareBlock: "Expected a block comment without padding stars.", startNewline: "Expected a linebreak after '/*'.", endNewline: "Expected a linebreak before '*/'.", missingStar: "Expected a '*' at the start of this line.", alignment: "Expected this line to be aligned with the start of the comment.", expectedLines: "Expected multiple line comments instead of a block comment." } }, create: function(e) {
  function t(c) {
    var f = bn(c, 1)[0];
    if (f.type !== "Block")
      return !1;
    var p = f.value.split(P.LINEBREAK_MATCHER);
    return 0 < p.length && p.every(function(d, m) {
      return (m === 0 || m === p.length - 1 ? /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/ : /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/).test(d);
    });
  }
  function n(c) {
    var f = bn(c, 1)[0];
    if (f.type !== "Block")
      return !1;
    var p = f.value.split(P.LINEBREAK_MATCHER);
    return /^\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(p[0]) && p.slice(1, -1).every(function(d) {
      return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]* /.test(d);
    }) && /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(p[p.length - 1]);
  }
  function r(c) {
    var f = bn(c, 1)[0];
    return f.type === "Line" ? function(p) {
      var d = p.map(function(m) {
        return m.value;
      }).filter(function(m) {
        return m.trim().length;
      }).every(function(m) {
        return m.startsWith(" ");
      });
      return p.map(function(m) {
        var y = m.value;
        return d ? y.replace(/^ /, "") : y;
      });
    }(c) : t(c) ? function(p) {
      var d = p.value.split(P.LINEBREAK_MATCHER).filter(function(y, v, b) {
        return v !== 0 && v !== b.length - 1;
      }).map(function(y) {
        return y.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), m = d.map(function(y) {
        return y.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      }).filter(function(y) {
        return y.trim().length;
      }).every(function(y) {
        return y.startsWith(" ");
      });
      return d.map(function(y) {
        return y.replace(m ? /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\* ?/ : /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      });
    }(f) : function(p) {
      var d = p.value.split(P.LINEBREAK_MATCHER).map(function(D) {
        return D.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), m = "".concat(s.text.slice(p.range[0] - p.loc.start.column, p.range[0]), "   "), y = "", v = !0, b = !1, x = void 0;
      try {
        for (var C, k = d.entries()[Symbol.iterator](); !(v = (C = k.next()).done); v = !0) {
          var F = bn(C.value, 2), B = F[0], O = F[1];
          if (O.trim().length && B !== 0) {
            var S = bn(O.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/), 2)[1];
            if (S.length < m.length) {
              var w = m.slice(S.length - m.length);
              w.length > y.length && (y = w);
            }
          }
        }
      } catch (D) {
        b = !0, x = D;
      } finally {
        try {
          v || k.return == null || k.return();
        } finally {
          if (b)
            throw x;
        }
      }
      return d.map(function(D) {
        var I = bn(D.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)/), 3), L = I[1], V = I[2];
        return L.length > m.length ? "".concat(L.slice(m.length - (y.length + L.length))).concat(V) : L.length < m.length ? "".concat(L.slice(m.length)).concat(V) : V;
      });
    }(f);
  }
  function i(c) {
    return s.text.slice(c.range[0] - c.loc.start.column, c.range[0]);
  }
  function a(c, f) {
    return "/* ".concat(f.join(`
`.concat(i(c), "   ")), " */");
  }
  var s = e.getSourceCode(), o = e.options[0] || "starred-block", u = { "starred-block": function(c) {
    var f = bn(c, 1)[0], p = r(c);
    p.some(function(d) {
      return d.includes("*/");
    }) || (1 < c.length ? e.report({ loc: { start: f.loc.start, end: c[c.length - 1].loc.end }, messageId: "expectedBlock", fix: function(d) {
      var m = [f.range[0], c[c.length - 1].range[1]];
      return p.some(function(y) {
        return y.startsWith("/");
      }) ? null : d.replaceTextRange(m, function(y, v) {
        var b = i(y);
        return `/*
`.concat(v.map(function(x) {
          return "".concat(b, " * ").concat(x);
        }).join(`
`), `
`).concat(b, " */");
      }(f, p));
    } }) : function() {
      var d = f.value.split(P.LINEBREAK_MATCHER), m = i(f), y = "".concat(m, " *");
      if (!/^\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(d[0])) {
        var v = f.value.startsWith("*") ? f.range[0] + 1 : f.range[0];
        e.report({ loc: { start: f.loc.start, end: { line: f.loc.start.line, column: f.loc.start.column + 2 } }, messageId: "startNewline", fix: function(C) {
          return C.insertTextAfterRange([v, v + 2], `
`.concat(y));
        } });
      }
      /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(d[d.length - 1]) || e.report({ loc: { start: { line: f.loc.end.line, column: f.loc.end.column - 2 }, end: f.loc.end }, messageId: "endNewline", fix: function(C) {
        return C.replaceTextRange([f.range[1] - 2, f.range[1]], `
`.concat(y, "/"));
      } });
      for (var b = function(C) {
        var k = s.lines[C - 1], F = function(B) {
          return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/.test(B);
        }(k) ? "alignment" : "missingStar";
        k.startsWith(y) || e.report({ loc: { start: { line: C, column: 0 }, end: { line: C, column: k.length } }, messageId: F, fix: function(B) {
          var O = s.getIndexFromLoc({ line: C, column: 0 });
          if (F === "alignment") {
            var S = bn(k.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*)/) || [], 2)[1], w = O + (S === void 0 ? "" : S).length;
            return B.replaceTextRange([O, w], y);
          }
          var D, I = bn(k.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/) || [], 2)[1], L = I === void 0 ? "" : I, V = O + L.length, K = !0, W = !1, R = void 0;
          try {
            for (var q, J = d.entries()[Symbol.iterator](); !(K = (q = J.next()).done); K = !0) {
              var X = bn(q.value, 2), ce = X[0], A = X[1];
              if (/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/.test(A)) {
                var M = bn(s.lines[f.loc.start.line - 1 + ce].match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:\/?\*)?([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*))/) || [], 3), ne = M[1], de = ne === void 0 ? "" : ne, he = M[2], j = he === void 0 ? "" : he;
                D = "".concat(L.slice(de.length)).concat(j);
                break;
              }
            }
          } catch (ie) {
            W = !0, R = ie;
          } finally {
            try {
              K || J.return == null || J.return();
            } finally {
              if (W)
                throw R;
            }
          }
          return B.replaceTextRange([O, V], "".concat(y).concat(D));
        } });
      }, x = f.loc.start.line + 1; x <= f.loc.end.line; x++)
        b(x);
    }());
  }, "separate-lines": function(c) {
    var f = bn(c, 1)[0];
    if (f.type === "Block" && !n(c)) {
      var p = r(c), d = s.getTokenAfter(f, { includeComments: !0 });
      d && f.loc.end.line === d.loc.start.line || e.report({ loc: { start: f.loc.start, end: { line: f.loc.start.line, column: f.loc.start.column + 2 } }, messageId: "expectedLines", fix: function(m) {
        return m.replaceText(f, function(y, v) {
          return v.map(function(b) {
            return "// ".concat(b);
          }).join(`
`.concat(i(y)));
        }(f, p));
      } });
    }
  }, "bare-block": function(c) {
    if (!n(c)) {
      var f = bn(c, 1)[0], p = r(c);
      f.type === "Line" && 1 < p.length && !p.some(function(d) {
        return d.includes("*/");
      }) && e.report({ loc: { start: f.loc.start, end: c[c.length - 1].loc.end }, messageId: "expectedBlock", fix: function(d) {
        return d.replaceTextRange([f.range[0], c[c.length - 1].range[1]], a(f, p));
      } }), t(c) && e.report({ loc: { start: f.loc.start, end: { line: f.loc.start.line, column: f.loc.start.column + 2 } }, messageId: "expectedBareBlock", fix: function(d) {
        return d.replaceText(f, a(f, p));
      } });
    }
  } };
  return { Program: function() {
    return s.getAllComments().filter(function(c) {
      return c.type !== "Shebang";
    }).filter(function(c) {
      return !P.COMMENTS_IGNORE_PATTERN.test(c.value);
    }).filter(function(c) {
      var f = s.getTokenBefore(c, { includeComments: !0 });
      return !f || f.loc.end.line < c.loc.start.line;
    }).reduce(function(c, f, p, d) {
      var m = s.getTokenBefore(f, { includeComments: !0 });
      return f.type === "Line" && p && d[p - 1].type === "Line" && m && m.loc.end.line === f.loc.start.line - 1 && m === d[p - 1] ? c[c.length - 1].push(f) : c.push([f]), c;
    }, []).filter(function(c) {
      return c.length !== 1 || c[0].loc.start.line !== c[0].loc.end.line;
    }).forEach(u[o]);
  } };
} }, fB = { meta: { type: "layout", docs: { description: "enforce newlines between operands of ternary expressions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/multiline-ternary" }, schema: [{ enum: ["always", "always-multiline", "never"] }], messages: { expectedTestCons: "Expected newline between test and consequent of ternary expression.", expectedConsAlt: "Expected newline between consequent and alternate of ternary expression.", unexpectedTestCons: "Unexpected newline between test and consequent of ternary expression.", unexpectedConsAlt: "Unexpected newline between consequent and alternate of ternary expression." } }, create: function(e) {
  function t(r, i, a) {
    e.report({ node: r, messageId: "".concat(a ? "expected" : "unexpected").concat(r === i.test ? "TestCons" : "ConsAlt") });
  }
  var n = e.options[0];
  return { ConditionalExpression: function(r) {
    var i = P.isTokenOnSameLine(r.test, r.consequent), a = P.isTokenOnSameLine(r.consequent, r.alternate);
    if (n === "never")
      i || t(r.test, r, !1), a || t(r.consequent, r, !1);
    else {
      if (n === "always-multiline" && r.loc.start.line === r.loc.end.line)
        return;
      i && t(r.test, r, !0), a && t(r.consequent, r, !0);
    }
  } };
} }, Xd = ["Array", "Boolean", "Date", "Error", "Function", "Number", "Object", "RegExp", "String", "Symbol", "BigInt"];
function c2(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t) && !Array.isArray(e[t]))
    throw new TypeError("".concat(t, ", if provided, must be an Array"));
  return e[t] || n;
}
function l2(e, t) {
  return e[t] = !0, e;
}
var hB = { meta: { type: "suggestion", docs: { description: "require constructor names to begin with a capital letter", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/new-cap" }, schema: [{ type: "object", properties: { newIsCap: { type: "boolean", default: !0 }, capIsNew: { type: "boolean", default: !0 }, newIsCapExceptions: { type: "array", items: { type: "string" } }, newIsCapExceptionPattern: { type: "string" }, capIsNewExceptions: { type: "array", items: { type: "string" } }, capIsNewExceptionPattern: { type: "string" }, properties: { type: "boolean", default: !0 } }, additionalProperties: !1 }], messages: { upper: "A function with a name starting with an uppercase letter should only be used as a constructor.", lower: "A constructor name should not start with a lowercase letter." } }, create: function(e) {
  function t(m) {
    var y = "";
    if (m.callee.type === "MemberExpression") {
      var v = m.callee.property;
      v.type === "Literal" && typeof v.value == "string" ? y = v.value : v.type === "Identifier" && !m.callee.computed && (y = v.name);
    } else
      y = m.callee.name;
    return y;
  }
  function n(m) {
    var y = m.charAt(0), v = y.toLowerCase();
    return v === y.toUpperCase() ? "non-alpha" : y === v ? "lower" : "upper";
  }
  function r(m, y, v, b) {
    var x = d.getText(y.callee);
    return !(!m[v] && !m[x]) || !(!b || !b.test(x)) || (v === "UTC" && y.callee.type === "MemberExpression" ? y.callee.object.type === "Identifier" && y.callee.object.name === "Date" : s && y.callee.type === "MemberExpression");
  }
  function i(m, y) {
    var v = m.callee;
    v.type === "MemberExpression" && (v = v.property), e.report({ node: m, loc: v.loc.start, messageId: y });
  }
  var a = Object.assign({}, e.options[0]);
  a.newIsCap = a.newIsCap !== !1, a.capIsNew = a.capIsNew !== !1;
  var s = a.properties === !1, o = c2(a, "newIsCapExceptions", []).reduce(l2, {}), u = a.newIsCapExceptionPattern ? new RegExp(a.newIsCapExceptionPattern, "u") : null, c = function(m) {
    var y = c2(m, "capIsNewExceptions", Xd);
    return y !== Xd && (y = y.concat(Xd)), y.reduce(l2, {});
  }(a), f = a.capIsNewExceptionPattern ? new RegExp(a.capIsNewExceptionPattern, "u") : null, p = {}, d = e.getSourceCode();
  return a.newIsCap && (p.NewExpression = function(m) {
    var y = t(m);
    y && (n(y) !== "lower" || r(o, m, y, u) || i(m, "lower"));
  }), a.capIsNew && (p.CallExpression = function(m) {
    var y = t(m);
    y && (n(y) !== "upper" || r(c, m, y, f) || i(m, "upper"));
  }), p;
} }, dB = { meta: { type: "layout", docs: { description: "enforce or disallow parentheses when invoking a constructor with no arguments", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/new-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }] }, messages: { missing: "Missing '()' invoking a constructor.", unnecessary: "Unnecessary '()' invoking a constructor with no arguments." } }, create: function(e) {
  var t = e.options[0] !== "never", n = e.getSourceCode();
  return { NewExpression: function(r) {
    if (r.arguments.length === 0) {
      var i = n.getLastToken(r), a = i && P.isClosingParenToken(i) && P.isOpeningParenToken(n.getTokenBefore(i)) && r.callee.range[1] < r.range[1];
      t ? !a && e.report({ node: r, messageId: "missing", fix: function(s) {
        return s.insertTextAfter(r, "()");
      } }) : a && e.report({ node: r, messageId: "unnecessary", fix: function(s) {
        return [s.remove(n.getTokenBefore(i)), s.remove(i), s.insertTextBefore(r, "("), s.insertTextAfter(r, ")")];
      } });
    }
  } };
} }, mB = { meta: { type: "layout", docs: { description: "require or disallow an empty line after variable declarations", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/newline-after-var" }, schema: [{ enum: ["never", "always"] }], fixable: "whitespace", messages: { expected: "Expected blank line after variable declarations.", unexpected: "Unexpected blank line after variable declarations." }, deprecated: !0, replacedBy: ["padding-line-between-statements"] }, create: function(e) {
  function t(a) {
    var s = i[a];
    return i[s + 1] ? t(s + 1) : s;
  }
  var n = e.getSourceCode(), r = e.options[0] === "never" ? "never" : "always", i = n.getAllComments().reduce(function(a, s) {
    return a[s.loc.start.line] = s.loc.end.line, a;
  }, {});
  return { VariableDeclaration: function(a) {
    var s = function(p) {
      var d = n.getLastToken(p);
      if (d.type === "Punctuator" && d.value === ";") {
        var m = n.getTokenBefore(d);
        if (m.loc.end.line !== d.loc.start.line)
          return m;
      }
      return d;
    }(a), o = s === n.getLastToken(a) ? n.getTokenAfter(a) : n.getLastToken(a), u = s.loc.end.line + 1;
    if (o && !function(p) {
      return p === "ForStatement" || p === "ForInStatement" || p === "ForOfStatement";
    }(a.parent.type) && !function(p) {
      return p === "ExportNamedDeclaration" || p === "ExportSpecifier" || p === "ExportDefaultDeclaration" || p === "ExportAllDeclaration";
    }(a.parent.type) && !(o.type === "Keyword" && function(p) {
      return p === "var" || p === "let" || p === "const";
    }(o.value) || function(p) {
      var d = n.getTokenAfter(p);
      return !d || d.type === "Punctuator" && d.value === "}";
    }(a))) {
      var c = o.loc.start.line > u, f = i[u] !== void 0;
      r === "never" && c && !f && e.report({ node: a, messageId: "unexpected", data: { identifier: a.name }, fix: function(p) {
        var d = n.getText().slice(s.range[1], o.range[0]).split(P.LINEBREAK_MATCHER);
        return p.replaceTextRange([s.range[1], o.range[0]], "".concat(d.slice(0, -1).join(""), `
`).concat(d[d.length - 1]));
      } }), r !== "always" || c && (!f || function(p, d) {
        return p.loc.start.line > t(d) + 1;
      }(o, u)) || e.report({ node: a, messageId: "expected", data: { identifier: a.name }, fix: function(p) {
        return (c ? t(u) : s.loc.end.line) === o.loc.start.line ? p.insertTextBefore(o, `

`) : p.insertTextBeforeRange([o.range[0] - o.loc.start.column, o.range[1]], `
`);
      } });
    }
  } };
} }, gB = { meta: { type: "layout", docs: { description: "require an empty line before `return` statements", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/newline-before-return" }, fixable: "whitespace", schema: [], messages: { expected: "Expected newline before return statement." }, deprecated: !0, replacedBy: ["padding-line-between-statements"] }, create: function(e) {
  function t(a, s) {
    var o = i.getTokenBefore(a);
    return s.some(function(u) {
      return o.value === u;
    });
  }
  function n(a) {
    var s = a.parent.type;
    return a.parent.body ? Array.isArray(a.parent.body) ? a.parent.body[0] === a : a.parent.body === a : t(a, s === "IfStatement" ? ["else", ")"] : s === "DoWhileStatement" ? ["do"] : s === "SwitchCase" ? [":"] : [")"]);
  }
  function r(a) {
    var s = a.loc.start.line, o = function(c) {
      var f = i.getTokenBefore(c);
      return f ? f.loc.end.line : 0;
    }(a), u = function(c, f) {
      var p = i.getCommentsBefore(c), d = 0;
      return p.length && p.forEach(function(m) {
        d++, m.type === "Block" && (d += m.loc.end.line - m.loc.start.line), m.loc.start.line === f && d--, m.loc.end.line === c.loc.start.line && d--;
      }), d;
    }(a, o);
    return 1 < s - o - u;
  }
  var i = e.getSourceCode();
  return { ReturnStatement: function(a) {
    n(a) || r(a) || e.report({ node: a, messageId: "expected", fix: function(s) {
      if (function(c) {
        var f = i.getCommentsBefore(c), p = f[f.length - 1], d = i.getTokenBefore(c);
        return !(f.length !== 0 && (p.loc.end.line !== d.loc.end.line || p.loc.end.line === c.loc.start.line));
      }(a)) {
        var o = i.getTokenBefore(a), u = a.loc.start.line === o.loc.end.line ? `

` : `
`;
        return s.insertTextBefore(a, u);
      }
      return null;
    } });
  } };
} }, yB = { meta: { type: "layout", docs: { description: "require a newline after each call in a method chain", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/newline-per-chained-call" }, fixable: "whitespace", schema: [{ type: "object", properties: { ignoreChainWithDepth: { type: "integer", minimum: 1, maximum: 10, default: 2 } }, additionalProperties: !1 }], messages: { expected: "Expected line break before `{{callee}}`." } }, create: function(e) {
  function t(i) {
    var a = function(u) {
      return u.computed ? "[" : ".";
    }(i), s = r.getText(i.property).split(P.LINEBREAK_MATCHER), o = i.computed && s.length === 1 ? "]" : "";
    return a + s[0] + o;
  }
  var n = (e.options[0] || {}).ignoreChainWithDepth || 2, r = e.getSourceCode();
  return { "CallExpression:exit": function(i) {
    if (i.callee && i.callee.type === "MemberExpression") {
      for (var a = i.callee, s = a.object, o = 1; s && s.callee; )
        o += 1, s = s.callee.object;
      o > n && P.isTokenOnSameLine(a.object, a.property) && e.report({ node: a.property, loc: a.property.loc.start, messageId: "expected", data: { callee: t(a) }, fix: function(u) {
        var c = r.getTokenAfter(a.object, P.isNotClosingParenToken);
        return u.insertTextBefore(c, `
`);
      } });
    }
  } };
} }, vB = P.getStaticPropertyName;
function p2(e) {
  return /^(alert|confirm|prompt)$/.test(e);
}
function f2(e, t) {
  var n = function(r, i) {
    var a = r.references.filter(function(s) {
      return s.identifier.range[0] === i.range[0] && s.identifier.range[1] === i.range[1];
    });
    return a.length === 1 ? a[0] : null;
  }(e, t);
  return n && n.resolved && 0 < n.resolved.defs.length;
}
var xB = { meta: { type: "suggestion", docs: { description: "disallow the use of `alert`, `confirm`, and `prompt`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-alert" }, schema: [], messages: { unexpected: "Unexpected {{name}}." } }, create: function(e) {
  return { CallExpression: function(t) {
    var n = t.callee, r = e.getScope();
    if (n.type === "Identifier") {
      var i = n.name;
      !f2(r, n) && p2(n.name) && e.report({ node: t, messageId: "unexpected", data: { name: i } });
    } else if (n.type === "MemberExpression" && function(s, o) {
      return !(s.type !== "global" || o.type !== "ThisExpression") || o.name === "window" && !f2(s, o);
    }(r, n.object)) {
      var a = vB(n);
      p2(a) && e.report({ node: t, messageId: "unexpected", data: { name: a } });
    }
  } };
} };
function bB(e) {
  var t = e.type;
  return t === "FunctionDeclaration" || t === "FunctionExpression" || t === "ArrowFunctionExpression" || t === "ForOfStatement" && e.await === !0;
}
function EB(e, t) {
  switch (t.type) {
    case "ForStatement":
      return e === t.test || e === t.update || e === t.body;
    case "ForOfStatement":
    case "ForInStatement":
      return e === t.body;
    case "WhileStatement":
    case "DoWhileStatement":
      return e === t.test || e === t.body;
    default:
      return !1;
  }
}
var CB = { meta: { type: "problem", docs: { description: "disallow `await` inside of loops", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-await-in-loop" }, schema: [], messages: { unexpectedAwait: "Unexpected `await` inside a loop." } }, create: function(e) {
  function t(n) {
    if (n.type !== "ForOfStatement" || n.await)
      for (var r = n, i = r.parent; i && !bB(i); ) {
        if (EB(r, i))
          return void e.report({ node: n, messageId: "unexpectedAwait" });
        r = i, i = i.parent;
      }
  }
  return { AwaitExpression: t, ForOfStatement: t };
} }, h2 = ["^", "|", "&", "<<", ">>", ">>>", "^=", "|=", "&=", "<<=", ">>=", ">>>=", "~"], SB = { meta: { type: "suggestion", docs: { description: "disallow bitwise operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-bitwise" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: h2 }, uniqueItems: !0 }, int32Hint: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { unexpected: "Unexpected use of '{{operator}}'." } }, create: function(e) {
  function t(s) {
    e.report({ node: s, messageId: "unexpected", data: { operator: s.operator } });
  }
  function n(s) {
    !function(o) {
      return h2.indexOf(o.operator) !== -1;
    }(s) || function(o) {
      return i.indexOf(o.operator) !== -1;
    }(s) || function(o) {
      return a && o.operator === "|" && o.right && o.right.type === "Literal" && o.right.value === 0;
    }(s) || t(s);
  }
  var r = e.options[0] || {}, i = r.allow || [], a = r.int32Hint === !0;
  return { AssignmentExpression: n, BinaryExpression: n, UnaryExpression: n };
} }, kB = { meta: { type: "suggestion", docs: { description: "disallow `catch` clause parameters from shadowing variables in the outer scope", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-catch-shadow" }, replacedBy: ["no-shadow"], deprecated: !0, schema: [], messages: { mutable: "Value of '{{name}}' may be overwritten in IE 8 and earlier." } }, create: function(e) {
  return { "CatchClause[param!=null]": function(t) {
    var n = e.getScope();
    n.block === t && (n = n.upper), function(r, i) {
      return P.getVariableByName(r, i) !== null;
    }(n, t.param.name) && e.report({ node: t, messageId: "mutable", data: { name: t.param.name } });
  } };
} }, DB = { meta: { type: "problem", docs: { description: "disallow reassigning class members", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/no-class-assign" }, schema: [], messages: { class: "'{{name}}' is a class." } }, create: function(e) {
  function t(r) {
    P.getModifyingReferences(r.references).forEach(function(i) {
      e.report({ node: i.identifier, messageId: "class", data: { name: i.identifier.name } });
    });
  }
  function n(r) {
    e.getDeclaredVariables(r).forEach(t);
  }
  return { ClassDeclaration: n, ClassExpression: n };
} }, FB = { meta: { type: "problem", docs: { description: "disallow comparing against -0", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-compare-neg-zero" }, fixable: null, schema: [], messages: { unexpected: "Do not use the '{{operator}}' operator to compare against -0." } }, create: function(e) {
  function t(r) {
    return r.type === "UnaryExpression" && r.operator === "-" && r.argument.type === "Literal" && r.argument.value === 0;
  }
  var n = /* @__PURE__ */ new Set([">", ">=", "<", "<=", "==", "===", "!=", "!=="]);
  return { BinaryExpression: function(r) {
    n.has(r.operator) && (t(r.left) || t(r.right)) && e.report({ node: r, messageId: "unexpected", data: { operator: r.operator } });
  } };
} }, wB = /* @__PURE__ */ new Set(["IfStatement", "WhileStatement", "DoWhileStatement", "ForStatement", "ConditionalExpression"]), AB = { DoWhileStatement: "a 'do...while' statement", ForStatement: "a 'for' statement", IfStatement: "an 'if' statement", WhileStatement: "a 'while' statement" }, _B = { meta: { type: "problem", docs: { description: "disallow assignment operators in conditional expressions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-cond-assign" }, schema: [{ enum: ["except-parens", "always"] }], messages: { unexpected: "Unexpected assignment within {{type}}.", missing: "Expected a conditional expression and instead saw an assignment." } }, create: function(e) {
  function t(s) {
    return s.parent && wB.has(s.parent.type) && s === s.parent.test;
  }
  function n(s) {
    var o = s;
    do
      if (t(o))
        return o.parent;
    while ((o = o.parent) && !P.isFunction(o));
    return null;
  }
  function r(s) {
    s.test && s.test.type === "AssignmentExpression" && (s.type === "ForStatement" ? !P.isParenthesised(a, s.test) : !function(o) {
      var u = a.getTokenBefore(o, 1), c = a.getTokenAfter(o, 1);
      return P.isParenthesised(a, o) && u && P.isOpeningParenToken(u) && u.range[1] <= o.range[0] && P.isClosingParenToken(c) && c.range[0] >= o.range[1];
    }(s.test)) && e.report({ node: s.test, messageId: "missing" });
  }
  var i = e.options[0] || "except-parens", a = e.getSourceCode();
  return i === "always" ? { AssignmentExpression: function(s) {
    var o = n(s);
    o && e.report({ node: s, messageId: "unexpected", data: { type: AB[o.type] || o.type } });
  } } : { DoWhileStatement: r, ForStatement: r, IfStatement: r, WhileStatement: r, ConditionalExpression: r };
} }, TB = { meta: { type: "suggestion", docs: { description: "disallow arrow functions where they could be confused with comparisons", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-confusing-arrow" }, fixable: "code", schema: [{ type: "object", properties: { allowParens: { type: "boolean", default: !0 } }, additionalProperties: !1 }], messages: { confusing: "Arrow function used ambiguously with a conditional expression." } }, create: function(e) {
  var t = e.options[0] || {}, n = t.allowParens || t.allowParens === void 0, r = e.getSourceCode();
  return { ArrowFunctionExpression: function(i) {
    var a = i.body;
    (function(s) {
      return s && s.type === "ConditionalExpression";
    })(a) && (!n || !P.isParenthesised(r, a)) && e.report({ node: i, messageId: "confusing", fix: function(s) {
      return n && s.replaceText(i.body, "(".concat(r.getText(i.body), ")"));
    } });
  } };
} }, PB = { meta: { type: "suggestion", docs: { description: "disallow the use of `console`", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-console" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: !0 } }, additionalProperties: !1 }], messages: { unexpected: "Unexpected console statement." } }, create: function(e) {
  function t(a) {
    var s = a.identifier;
    return s && s.name === "console";
  }
  function n(a) {
    var s = a.identifier, o = s.parent;
    return o.type === "MemberExpression" && o.object === s && !function(u) {
      var c = P.getStaticPropertyName(u);
      return c && i.indexOf(c) !== -1;
    }(o);
  }
  function r(a) {
    var s = a.identifier.parent;
    e.report({ node: s, loc: s.loc, messageId: "unexpected" });
  }
  var i = (e.options[0] || {}).allow || [];
  return { "Program:exit": function() {
    var a = e.getScope(), s = P.getVariableByName(a, "console"), o = s && 0 < s.defs.length, u = s ? s.references : a.through.filter(t);
    o || u.filter(n).forEach(r);
  } };
} }, IB = { meta: { type: "problem", docs: { description: "disallow reassigning `const` variables", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/no-const-assign" }, schema: [], messages: { const: "'{{name}}' is constant." } }, create: function(e) {
  function t(n) {
    P.getModifyingReferences(n.references).forEach(function(r) {
      e.report({ node: r.identifier, messageId: "const", data: { name: r.identifier.name } });
    });
  }
  return { VariableDeclaration: function(n) {
    n.kind === "const" && e.getDeclaredVariables(n).forEach(t);
  } };
} }, BB = ["===", "!==", "==", "!="], OB = [">", "<", ">=", "<=", "in", "instanceof"], LB = { meta: { type: "problem", docs: { description: "disallow constant expressions in conditions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-constant-condition" }, schema: [{ type: "object", properties: { checkLoops: { type: "boolean", default: !0 } }, additionalProperties: !1 }], messages: { unexpected: "Unexpected constant condition." } }, create: function(e) {
  function t(p, d) {
    switch (p.type) {
      case "Literal":
        return d === "||" && p.value === !0 || d === "&&" && p.value === !1;
      case "UnaryExpression":
        return d === "&&" && p.operator === "void";
      case "LogicalExpression":
        return t(p.left, p.operator) || t(p.right, p.operator);
    }
    return !1;
  }
  function n(p, d) {
    switch (p.type) {
      case "Literal":
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "ObjectExpression":
      case "ArrayExpression":
        return !0;
      case "UnaryExpression":
        return p.operator === "void" || p.operator === "typeof" && d || n(p.argument, !0);
      case "BinaryExpression":
        return n(p.left, !1) && n(p.right, !1) && p.operator !== "in";
      case "LogicalExpression":
        var m = n(p.left, d), y = n(p.right, d), v = m && t(p.left, p.operator), b = y && t(p.right, p.operator);
        return m && y || p.operator === "||" && y && p.right.value && (!p.parent || p.parent.type !== "BinaryExpression" || !(BB.includes(p.parent.operator) || OB.includes(p.parent.operator))) || v || b;
      case "AssignmentExpression":
        return p.operator === "=" && n(p.right, d);
      case "SequenceExpression":
        return n(p.expressions[p.expressions.length - 1], d);
    }
    return !1;
  }
  function r(p) {
    f.has(p) && (f.delete(p), e.report({ node: p.test, messageId: "unexpected" }));
  }
  function i(p) {
    p.test && n(p.test, !0) && e.report({ node: p.test, messageId: "unexpected" });
  }
  function a() {
    c.push(f), f = /* @__PURE__ */ new Set();
  }
  function s() {
    f = c.pop();
  }
  function o(p) {
    u && function(d) {
      d.test && n(d.test, !0) && f.add(d);
    }(p);
  }
  var u = (e.options[0] || {}).checkLoops !== !1, c = [], f = /* @__PURE__ */ new Set();
  return { ConditionalExpression: i, IfStatement: i, WhileStatement: o, "WhileStatement:exit": r, DoWhileStatement: o, "DoWhileStatement:exit": r, ForStatement: o, "ForStatement > .test": function(p) {
    return o(p.parent);
  }, "ForStatement:exit": r, FunctionDeclaration: a, "FunctionDeclaration:exit": s, FunctionExpression: a, "FunctionExpression:exit": s, YieldExpression: function() {
    return f.clear();
  } };
} }, NB = ao.RegExpValidator, jB = new (function() {
  function e() {
    We(this, e), this.ecmaVersion = 2018, this._source = "", this._controlChars = [], this._validator = new NB(this);
  }
  return Xe(e, [{ key: "onPatternEnter", value: function() {
    this._controlChars = [];
  } }, { key: "onCharacter", value: function(t, n, r) {
    0 <= r && 31 >= r && (this._source.codePointAt(t) === r || this._source.slice(t, n).startsWith("\\x") || this._source.slice(t, n).startsWith("\\u")) && this._controlChars.push("\\x".concat("0".concat(r.toString(16)).slice(-2)));
  } }, { key: "collectControlChars", value: function(t) {
    try {
      this._source = t, this._validator.validatePattern(t);
    } catch {
    }
    return this._controlChars;
  } }]), e;
}())(), RB = { meta: { type: "problem", docs: { description: "disallow control characters in regular expressions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-control-regex" }, schema: [], messages: { unexpected: "Unexpected control character(s) in regular expression: {{controlChars}}." } }, create: function(e) {
  return { Literal: function(t) {
    var n = function(i) {
      return i.regex ? i.regex.pattern : typeof i.value != "string" || i.parent.type !== "NewExpression" && i.parent.type !== "CallExpression" || i.parent.callee.type !== "Identifier" || i.parent.callee.name !== "RegExp" || i.parent.arguments[0] !== i ? null : i.value;
    }(t);
    if (n) {
      var r = jB.collectControlChars(n);
      0 < r.length && e.report({ node: t, messageId: "unexpected", data: { controlChars: r.join(", ") } });
    }
  } };
} }, MB = { meta: { type: "problem", docs: { description: "disallow duplicate class members", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/no-dupe-class-members" }, schema: [], messages: { unexpected: "Duplicate name '{{name}}'." } }, create: function(e) {
  function t(r, i) {
    var a = n[n.length - 1], s = "$".concat(r);
    return a[s] || (a[s] = { nonStatic: { init: !1, get: !1, set: !1 }, static: { init: !1, get: !1, set: !1 } }), a[s][i ? "static" : "nonStatic"];
  }
  var n = [];
  return { Program: function() {
    n = [];
  }, ClassBody: function() {
    n.push(/* @__PURE__ */ Object.create(null));
  }, "ClassBody:exit": function() {
    n.pop();
  }, MethodDefinition: function(r) {
    if (!r.computed) {
      var i = function(o) {
        switch (o.type) {
          case "Identifier":
            return o.name;
          case "Literal":
            return o.value + "";
          default:
            return "";
        }
      }(r.key), a = t(i, r.static), s = !1;
      r.kind === "get" ? (s = a.init || a.get, a.get = !0) : r.kind === "set" ? (s = a.init || a.set, a.set = !0) : (s = a.init || a.get || a.set, a.init = !0), s && e.report({ node: r, messageId: "unexpected", data: { name: i } });
    }
  } };
} };
function VB(e, t, n) {
  return t.every(function(r) {
    return n.some(function(i) {
      return e(r, i);
    });
  });
}
function Xp(e, t) {
  return t.type === "LogicalExpression" && t.operator === e ? [].concat(Mt(Xp(e, t.left)), Mt(Xp(e, t.right))) : [t];
}
var d2 = Xp.bind(null, "||"), Yd = Xp.bind(null, "&&"), UB = { meta: { type: "problem", docs: { description: "disallow duplicate conditions in if-else-if chains", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-dupe-else-if" }, schema: [], messages: { unexpected: "This branch can never execute. Its condition is a duplicate or covered by previous conditions in the if-else-if chain." } }, create: function(e) {
  var t = e.getSourceCode(), n = VB.bind(null, function r(i, a) {
    return i.type === a.type && (i.type !== "LogicalExpression" || i.operator !== "||" && i.operator !== "&&" || i.operator !== a.operator ? P.equalTokens(i, a, t) : r(i.left, a.left) && r(i.right, a.right) || r(i.left, a.right) && r(i.right, a.left));
  });
  return { IfStatement: function(r) {
    for (var i = r.test, a = i.type === "LogicalExpression" && i.operator === "&&" ? [i].concat(Mt(Yd(i))) : [i], s = function(c, f) {
      c = c.parent;
      var p = d2(c.test).map(Yd);
      if ((f = f.map(function(d) {
        return d.filter(function(m) {
          return !p.some(function(y) {
            return n(y, m);
          });
        });
      })).some(function(d) {
        return d.length === 0;
      }))
        return e.report({ node: i, messageId: "unexpected" }), o = c, u = f, "break";
      o = c, u = f;
    }, o = r, u = a.map(function(c) {
      return d2(c).map(Yd);
    }); o.parent && o.parent.type === "IfStatement" && o.parent.alternate === o && s(o, u) !== "break"; )
      ;
  } };
} }, m2 = /^(?:init|get)$/, g2 = /^(?:init|set)$/, qB = function() {
  function e(t, n) {
    We(this, e), this.upper = t, this.node = n, this.properties = /* @__PURE__ */ new Map();
  }
  return Xe(e, [{ key: "getPropertyInfo", value: function(t) {
    var n = P.getStaticPropertyName(t);
    return this.properties.has(n) || this.properties.set(n, { get: !1, set: !1 }), this.properties.get(n);
  } }, { key: "isPropertyDefined", value: function(t) {
    var n = this.getPropertyInfo(t);
    return m2.test(t.kind) && n.get || g2.test(t.kind) && n.set;
  } }, { key: "defineProperty", value: function(t) {
    var n = this.getPropertyInfo(t);
    m2.test(t.kind) && (n.get = !0), g2.test(t.kind) && (n.set = !0);
  } }]), e;
}(), WB = { meta: { type: "problem", docs: { description: "disallow duplicate keys in object literals", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-dupe-keys" }, schema: [], messages: { unexpected: "Duplicate key '{{name}}'." } }, create: function(e) {
  var t = null;
  return { ObjectExpression: function(n) {
    t = new qB(t, n);
  }, "ObjectExpression:exit": function() {
    t = t.upper;
  }, Property: function(n) {
    var r = P.getStaticPropertyName(n);
    n.parent.type !== "ObjectExpression" || r === null || (t.isPropertyDefined(n) && e.report({ node: t.node, loc: n.key.loc, messageId: "unexpected", data: { name: r } }), t.defineProperty(n));
  } };
} }, $B = { meta: { type: "problem", docs: { description: "disallow duplicate case labels", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-duplicate-case" }, schema: [], messages: { unexpected: "Duplicate case label." } }, create: function(e) {
  var t = e.getSourceCode();
  return { SwitchStatement: function(n) {
    var r = /* @__PURE__ */ new Set(), i = !0, a = !1, s = void 0;
    try {
      for (var o, u = n.cases[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
        var c = o.value;
        if (c.test) {
          var f = t.getText(c.test);
          r.has(f) ? e.report({ node: c, messageId: "unexpected" }) : r.add(f);
        }
      }
    } catch (p) {
      a = !0, s = p;
    } finally {
      try {
        i || u.return == null || u.return();
      } finally {
        if (a)
          throw s;
      }
    }
  } };
} };
function DA(e) {
  return e && e.source && e.source.value ? e.source.value.trim() : "";
}
function Yp(e, t, n, r, i) {
  r.indexOf(n) !== -1 && e.report({ node: t, messageId: i, data: { module: n } });
}
function GB(e, t, n, r) {
  return function(i) {
    var a = DA(i);
    a && (Yp(e, i, a, n, "import"), t && Yp(e, i, a, r, "importAs"), n.push(a));
  };
}
function y2(e, t, n) {
  return function(r) {
    var i = DA(r);
    i && (Yp(e, r, i, n, "export"), Yp(e, r, i, t, "exportAs"), n.push(i));
  };
}
var zB = { meta: { type: "problem", docs: { description: "disallow duplicate module imports", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-duplicate-imports" }, schema: [{ type: "object", properties: { includeExports: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { import: "'{{module}}' import is duplicated.", importAs: "'{{module}}' import is duplicated as export.", export: "'{{module}}' export is duplicated.", exportAs: "'{{module}}' export is duplicated as import." } }, create: function(e) {
  var t = (e.options[0] || {}).includeExports, n = [], r = [], i = { ImportDeclaration: GB(e, t, n, r) };
  return t && (i.ExportNamedDeclaration = y2(e, n, r), i.ExportAllDeclaration = y2(e, n, r)), i;
} }, bf = function() {
  function e(t, n) {
    We(this, e), this.fixer = t, this.sourceCode = n, this.retainedRange = null;
  }
  return Xe(e, [{ key: "retainRange", value: function(t) {
    return this.retainedRange = t, this;
  } }, { key: "retainEnclosingFunction", value: function(t) {
    var n = P.getUpperFunction(t);
    return this.retainRange(n ? n.range : this.sourceCode.ast.range);
  } }, { key: "retainSurroundingTokens", value: function(t) {
    var n = this.sourceCode.getTokenBefore(t) || t, r = this.sourceCode.getTokenAfter(t) || t;
    return this.retainRange([n.range[0], r.range[1]]);
  } }, { key: "replaceTextRange", value: function(t, n) {
    var r;
    return r = this.retainedRange ? [Math.min(this.retainedRange[0], t[0]), Math.max(this.retainedRange[1], t[1])] : t, this.fixer.replaceTextRange(r, this.sourceCode.text.slice(r[0], t[0]) + n + this.sourceCode.text.slice(t[1], r[1]));
  } }, { key: "remove", value: function(t) {
    return this.replaceTextRange(t.range, "");
  } }]), e;
}(), HB = { meta: { type: "suggestion", docs: { description: "disallow `else` blocks after `return` statements in `if` statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-else-return" }, schema: [{ type: "object", properties: { allowElseIf: { type: "boolean", default: !0 } }, additionalProperties: !1 }], fixable: "code", messages: { unexpected: "Unnecessary 'else' after 'return'." } }, create: function(e) {
  function t(o, u) {
    if (o.type === "FunctionDeclaration")
      return !1;
    if (o.type !== "BlockStatement")
      return !0;
    var c = u.childScopes.find(function(f) {
      return f.block === o;
    });
    return !c || function(f, p) {
      if (f.length === 0)
        return !0;
      var d = p.variableScope;
      if (p.variables.filter(function(y) {
        return 0 < y.defs.length;
      }).some(function(y) {
        var v = y.name;
        return f.includes(v);
      }) || p !== d && p.upper.type === "catch" && p.upper.variables.some(function(y) {
        var v = y.name;
        return f.includes(v);
      }) || p.variables.filter(function(y) {
        var v = y.defs, b = y.references;
        return v.length === 0 && 0 < b.length;
      }).some(function(y) {
        var v = y.name;
        return f.includes(v);
      }) || p.through.some(function(y) {
        return f.includes(y.identifier.name);
      }))
        return !1;
      if (p !== d) {
        var m = p.block.range;
        if (d.variables.filter(function(y) {
          var v = y.name;
          return f.includes(v);
        }).some(function(y) {
          return y.defs.some(function(v) {
            var b = v.node.range;
            return m[0] <= b[0] && b[1] <= m[1];
          });
        }))
          return !1;
      }
      return !0;
    }(c.variables.map(function(f) {
      return f.name;
    }), u);
  }
  function n(o) {
    var u = e.getScope();
    e.report({ node: o, messageId: "unexpected", fix: function(c) {
      if (!t(o, u))
        return null;
      var f, p, d = e.getSourceCode(), m = d.getFirstToken(o), y = d.getTokenBefore(m), v = d.getText(o), b = d.getTokenBefore(y);
      p = m.type === "Punctuator" && m.value === "{" ? d.getTokenAfter(m) : m;
      var x = o.parent.consequent.type !== "BlockStatement" && b.value !== ";", C = /^[\(\+\x2D\/\[`]/.test(p.value);
      if (x && C)
        return null;
      var k = d.getLastToken(o), F = d.getTokenBefore(k);
      if (F.value !== ";") {
        var B = d.getTokenAfter(k), O = B && /^[\(\+\x2D\/\[`]/.test(B.value), S = B && B.loc.start.line === F.loc.start.line;
        if (O || S && B.value !== "}")
          return null;
      }
      return f = m.type === "Punctuator" && m.value === "{" ? v.slice(1, -1) : v, new bf(c, d).retainEnclosingFunction(o).replaceTextRange([y.range[0], o.range[1]], f);
    } });
  }
  function r(o) {
    return o.type === "ReturnStatement";
  }
  function i(o) {
    if (o.type === "BlockStatement") {
      var u = o.body, c = u[u.length - 1];
      return c && r(c);
    }
    return r(o);
  }
  function a(o) {
    return r(o) || function(u) {
      return u.type === "IfStatement" && function(c) {
        return c.alternate && c.consequent;
      }(u) && i(u.alternate) && i(u.consequent);
    }(o);
  }
  function s(o) {
    return o.type === "BlockStatement" ? o.body.some(a) : a(o);
  }
  return { "IfStatement:exit": e.options[0] && e.options[0].allowElseIf === !1 ? function(o) {
    var u = o.parent;
    if (P.STATEMENT_LIST_PARENTS.has(u.type)) {
      var c = o.alternate;
      c && s(o.consequent) && n(c);
    }
  } : function(o) {
    var u = o.parent;
    if (P.STATEMENT_LIST_PARENTS.has(u.type)) {
      for (var c, f = [], p = o; p.type === "IfStatement"; p = p.alternate) {
        if (!p.alternate)
          return;
        f.push(p.consequent), c = p.alternate;
      }
      f.every(s) && n(c);
    }
  } };
} }, KB = /^\/((?:[\0-Z\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\[((?:[\0-\[\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+\])*\/[gimsuy]*$/, JB = { meta: { type: "problem", docs: { description: "disallow empty character classes in regular expressions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-empty-character-class" }, schema: [], messages: { unexpected: "Empty class." } }, create: function(e) {
  var t = e.getSourceCode();
  return { Literal: function(n) {
    var r = t.getFirstToken(n);
    r.type !== "RegularExpression" || KB.test(r.value) || e.report({ node: n, messageId: "unexpected" });
  } };
} }, QB = { meta: { type: "suggestion", docs: { description: "disallow empty functions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-empty-function" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: Object.freeze(["functions", "arrowFunctions", "generatorFunctions", "methods", "generatorMethods", "getters", "setters", "constructors"]) }, uniqueItems: !0 } }, additionalProperties: !1 }], messages: { unexpected: "Unexpected empty {{name}}." } }, create: function(e) {
  function t(i) {
    var a = function(u) {
      var c = u.parent, f = "";
      if (u.type === "ArrowFunctionExpression")
        return "arrowFunctions";
      if (c.type === "Property") {
        if (c.kind === "get")
          return "getters";
        if (c.kind === "set")
          return "setters";
        f = c.method ? "methods" : "functions";
      } else if (c.type === "MethodDefinition") {
        if (c.kind === "get")
          return "getters";
        if (c.kind === "set")
          return "setters";
        if (c.kind === "constructor")
          return "constructors";
        f = "methods";
      } else
        f = "functions";
      var p = "";
      if (u.generator)
        p = "generator";
      else {
        if (!u.async)
          return f;
        p = "async";
      }
      return p + f[0].toUpperCase() + f.slice(1);
    }(i), s = P.getFunctionNameWithKind(i), o = r.getTokens(i.body, { includeComments: !0, filter: P.isCommentToken });
    n.indexOf(a) === -1 && i.body.type === "BlockStatement" && i.body.body.length === 0 && o.length === 0 && e.report({ node: i, loc: i.body.loc.start, messageId: "unexpected", data: { name: s } });
  }
  var n = (e.options[0] || {}).allow || [], r = e.getSourceCode();
  return { ArrowFunctionExpression: t, FunctionDeclaration: t, FunctionExpression: t };
} }, XB = { meta: { type: "suggestion", docs: { description: "disallow empty block statements", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-empty" }, schema: [{ type: "object", properties: { allowEmptyCatch: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { unexpected: "Empty {{type}} statement." } }, create: function(e) {
  var t = (e.options[0] || {}).allowEmptyCatch || !1, n = e.getSourceCode();
  return { BlockStatement: function(r) {
    r.body.length !== 0 || P.isFunction(r.parent) || t && r.parent.type === "CatchClause" || 0 < n.getCommentsInside(r).length || e.report({ node: r, messageId: "unexpected", data: { type: "block" } });
  }, SwitchStatement: function(r) {
    (r.cases === void 0 || r.cases.length === 0) && e.report({ node: r, messageId: "unexpected", data: { type: "switch" } });
  } };
} }, v2 = Object.freeze(["global", "window"]);
function p0(e, t) {
  return e.type === "Identifier" && e.name === t;
}
function YB(e, t) {
  switch (e.type) {
    case "Literal":
      return e.value === t;
    case "TemplateLiteral":
      return e.expressions.length === 0 && e.quasis[0].value.cooked === t;
    default:
      return !1;
  }
}
function Zd(e, t) {
  return e.type === "MemberExpression" && (e.computed ? YB : p0)(e.property, t);
}
var ZB = { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-eval" }, schema: [{ type: "object", properties: { allowIndirect: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { unexpected: "eval can be harmful." } }, create: function(e) {
  function t(o) {
    var u = e.getScope().isStrict;
    s = { upper: s, node: o, strict: u, defaultThis: !1, initialized: u };
  }
  function n() {
    s = s.upper;
  }
  function r(o) {
    var u = o.parent, c = o.type === "MemberExpression" ? o.property : o, f = u.type === "CallExpression" && u.callee === o ? u : o;
    e.report({ node: f, loc: c.loc.start, messageId: "unexpected" });
  }
  var i = !(!e.options[0] || !e.options[0].allowIndirect), a = e.getSourceCode(), s = null;
  return i ? { "CallExpression:exit": function(o) {
    var u = o.callee;
    p0(u, "eval") && r(u);
  } } : { "CallExpression:exit": function(o) {
    var u = o.callee;
    p0(u, "eval") && r(u);
  }, Program: function(o) {
    var u = e.getScope(), c = e.parserOptions.ecmaFeatures || {}, f = u.isStrict || o.sourceType === "module" || c.globalReturn && u.childScopes[0].isStrict;
    s = { upper: null, node: o, strict: f, defaultThis: !0, initialized: !0 };
  }, "Program:exit": function() {
    var o = e.getScope();
    n(), function(u) {
      var c = P.getVariableByName(u, "eval");
      if (c)
        for (var f = c.references, p = 0; p < f.length; ++p) {
          var d = f[p].identifier;
          d.name !== "eval" || P.isCallee(d) || r(d);
        }
    }(o), function(u) {
      for (var c = 0; c < v2.length; ++c) {
        var f = v2[c], p = P.getVariableByName(u, f);
        if (p)
          for (var d = p.references, m = 0; m < d.length; ++m) {
            for (var y = d[m].identifier.parent; Zd(y, f); )
              y = y.parent;
            Zd(y, "eval") && r(y);
          }
      }
    }(o);
  }, FunctionDeclaration: t, "FunctionDeclaration:exit": n, FunctionExpression: t, "FunctionExpression:exit": n, ArrowFunctionExpression: t, "ArrowFunctionExpression:exit": n, ThisExpression: function(o) {
    Zd(o.parent, "eval") && (!s.initialized && (s.initialized = !0, s.defaultThis = P.isDefaultThisBinding(s.node, a)), !s.strict && s.defaultThis && r(o.parent));
  } };
} }, eO = { meta: { type: "problem", docs: { description: "disallow reassigning exceptions in `catch` clauses", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-ex-assign" }, schema: [], messages: { unexpected: "Do not assign to the exception parameter." } }, create: function(e) {
  function t(n) {
    P.getModifyingReferences(n.references).forEach(function(r) {
      e.report({ node: r.identifier, messageId: "unexpected" });
    });
  }
  return { CatchClause: function(n) {
    e.getDeclaredVariables(n).forEach(t);
  } };
} }, tO = /* @__PURE__ */ new Set(["defineProperty", "defineProperties"]), nO = { meta: { type: "suggestion", docs: { description: "disallow extending native types", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-extend-native" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }], messages: { unexpected: "{{builtin}} prototype is read only, properties should not be added." } }, create: function(e) {
  function t(o, u) {
    e.report({ node: o, messageId: "unexpected", data: { builtin: u } });
  }
  function n(o) {
    return !(!o || !o.parent || o.parent.type !== "MemberExpression" || o.parent.object !== o || P.getStaticPropertyName(o.parent) !== "prototype");
  }
  function r(o) {
    (function(u) {
      return !(!n(u) || u.parent.parent.type !== "MemberExpression" || u.parent.parent.parent.type !== "AssignmentExpression" || u.parent.parent.parent.left !== u.parent.parent);
    })(o) ? t(o.parent.parent.parent, o.name) : function(u) {
      return !(!n(u) || u.parent.parent.type !== "CallExpression" || u.parent.parent.arguments[0] !== u.parent || u.parent.parent.callee.type !== "MemberExpression" || u.parent.parent.callee.object.type !== "Identifier" || u.parent.parent.callee.object.name !== "Object" || u.parent.parent.callee.property.type !== "Identifier" || !tO.has(u.parent.parent.callee.property.name));
    }(o) && t(o.parent.parent, o.name);
  }
  var i = e.options[0] || {}, a = new Set(i.exceptions || []), s = new Set(Object.keys(ye.globals.builtin).filter(function(o) {
    return o[0].toUpperCase() === o[0];
  }).filter(function(o) {
    return !a.has(o);
  }));
  return { "Program:exit": function() {
    var o = e.getScope();
    s.forEach(function(u) {
      var c = o.set.get(u);
      c && c.references && c.references.map(function(f) {
        return f.identifier;
      }).forEach(r);
    });
  } };
} }, rO = /* @__PURE__ */ new Set(["Literal", "Identifier", "ThisExpression", "FunctionExpression"]), iO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.bind()`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-extra-bind" }, schema: [], fixable: "code", messages: { unexpected: "The function binding is unnecessary." } }, create: function(e) {
  function t(o) {
    e.report({ node: o.parent.parent, messageId: "unexpected", loc: o.parent.property.loc.start, fix: function(u) {
      if (o.parent.parent.arguments.length && !function(p) {
        return rO.has(p.type);
      }(o.parent.parent.arguments[0]))
        return null;
      var c = a.getFirstTokenBetween(o.parent.object, o.parent.property, P.isNotClosingParenToken), f = a.getLastToken(o.parent.parent);
      return a.commentsExistBetween(c, f) ? null : u.removeRange([c.range[0], o.parent.parent.range[1]]);
    } });
  }
  function n(o) {
    var u = o.parent, c = u.parent;
    return c && c.type === "CallExpression" && c.callee === u && c.arguments.length === 1 && c.arguments[0].type !== "SpreadElement" && u.type === "MemberExpression" && u.object === o && P.getStaticPropertyName(u) === "bind";
  }
  function r(o) {
    s = { isBound: n(o), thisFound: !1, upper: s };
  }
  function i(o) {
    s.isBound && !s.thisFound && t(o), s = s.upper;
  }
  var a = e.getSourceCode(), s = null;
  return { "ArrowFunctionExpression:exit": function(o) {
    n(o) && t(o);
  }, FunctionDeclaration: r, "FunctionDeclaration:exit": i, FunctionExpression: r, "FunctionExpression:exit": i, ThisExpression: function() {
    s && (s.thisFound = !0);
  } };
} }, aO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary boolean casts", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-extra-boolean-cast" }, schema: [], fixable: "code", messages: { unexpectedCall: "Redundant Boolean call.", unexpectedNegation: "Redundant double negation." } }, create: function(e) {
  function t(a, s) {
    return i.indexOf(s.type) !== -1 && a === s.test || s.type === "UnaryExpression" && s.operator === "!";
  }
  function n(a) {
    return !!r.getCommentsInside(a).length;
  }
  var r = e.getSourceCode(), i = ["IfStatement", "DoWhileStatement", "WhileStatement", "ConditionalExpression", "ForStatement"];
  return { UnaryExpression: function(a) {
    var s = e.getAncestors(), o = s.pop(), u = s.pop();
    a.operator !== "!" || o.type !== "UnaryExpression" || o.operator !== "!" || (t(o, u) || (u.type === "CallExpression" || u.type === "NewExpression") && u.callee.type === "Identifier" && u.callee.name === "Boolean") && e.report({ node: o, messageId: "unexpectedNegation", fix: function(c) {
      if (n(o))
        return null;
      var f = "", p = r.getTokenBefore(o), d = r.getFirstToken(a.argument);
      return p && p.range[1] === o.range[0] && !P.canTokensBeAdjacent(p, d) && (f = " "), c.replaceText(o, f + r.getText(a.argument));
    } });
  }, CallExpression: function(a) {
    var s = a.parent;
    a.callee.type !== "Identifier" || a.callee.name !== "Boolean" || t(a, s) && e.report({ node: a, messageId: "unexpectedCall", fix: function(o) {
      if (!a.arguments.length) {
        if (s.type === "UnaryExpression" && s.operator === "!") {
          if (n(s))
            return null;
          var u = "", c = r.getTokenBefore(s);
          return c && c.range[1] === s.range[0] && !P.canTokensBeAdjacent(c, "true") && (u = " "), o.replaceText(s, u + "true");
        }
        return n(a) ? null : o.replaceText(a, "false");
      }
      if (1 < a.arguments.length || a.arguments[0].type === "SpreadElement" || n(a))
        return null;
      var f = a.arguments[0];
      return P.getPrecedence(f) < P.getPrecedence(a.parent) ? o.replaceText(a, "(".concat(r.getText(f), ")")) : o.replaceText(a, r.getText(f));
    } });
  } };
} }, oO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary labels", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-extra-label" }, schema: [], fixable: "code", messages: { unexpected: "This label '{{name}}' is unnecessary." } }, create: function(e) {
  function t(s) {
    a = { label: s.parent.type === "LabeledStatement" ? s.parent.label : null, breakable: !0, upper: a };
  }
  function n() {
    a = a.upper;
  }
  function r(s) {
    if (s.label) {
      for (var o = s.label, u = a; u !== null; u = u.upper)
        if (u.breakable || u.label && u.label.name === o.name)
          return void (u.breakable && u.label && u.label.name === o.name && e.report({ node: o, messageId: "unexpected", data: o, fix: function(c) {
            var f = i.getFirstToken(s);
            return i.commentsExistBetween(f, o) ? null : c.removeRange([f.range[1], o.range[1]]);
          } }));
    }
  }
  var i = e.getSourceCode(), a = null;
  return { WhileStatement: t, "WhileStatement:exit": n, DoWhileStatement: t, "DoWhileStatement:exit": n, ForStatement: t, "ForStatement:exit": n, ForInStatement: t, "ForInStatement:exit": n, ForOfStatement: t, "ForOfStatement:exit": n, SwitchStatement: t, "SwitchStatement:exit": n, LabeledStatement: function(s) {
    P.isBreakableStatement(s.body) || (a = { label: s.label, breakable: !1, upper: a });
  }, "LabeledStatement:exit": function(s) {
    P.isBreakableStatement(s.body) || (a = a.upper);
  }, BreakStatement: r, ContinueStatement: r };
} }, x2 = ye.require$$0.isParenthesized, sO = { meta: { type: "layout", docs: { description: "disallow unnecessary parentheses", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-extra-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["functions"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["all"] }, { type: "object", properties: { conditionalAssign: { type: "boolean" }, nestedBinaryExpressions: { type: "boolean" }, returnAssign: { type: "boolean" }, ignoreJSX: { enum: ["none", "all", "single-line", "multi-line"] }, enforceForArrowConditionals: { type: "boolean" }, enforceForSequenceExpressions: { type: "boolean" }, enforceForNewInMemberExpressions: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unnecessary parentheses around expression." } }, create: function(e) {
  function t(A) {
    if (A.type === "JSXElement" || A.type === "JSXFragment") {
      var M = A.loc.start.line === A.loc.end.line;
      switch (W) {
        case "all":
          return !1;
        case "multi-line":
          return M;
        case "single-line":
          return !M;
      }
    }
    return !(A.type === "SequenceExpression" && q) && (I || A.type === "FunctionExpression" || A.type === "ArrowFunctionExpression");
  }
  function n(A) {
    return x2(1, A, S);
  }
  function r(A) {
    return x2(2, A, S);
  }
  function i(A) {
    return t(A) && n(A);
  }
  function a(A) {
    return t(A) && r(A);
  }
  function s(A) {
    return L && A.test.type === "AssignmentExpression";
  }
  function o(A) {
    var M = S.getLastToken(A), ne = S.getTokenBefore(M);
    return 0 < A.arguments.length || P.isOpeningParenToken(ne) && P.isClosingParenToken(M) && A.callee.range[1] < A.range[1];
  }
  function u(A) {
    return !(A.type !== "AssignmentExpression" && (A.type !== "ConditionalExpression" || A.consequent.type !== "AssignmentExpression" && A.alternate.type !== "AssignmentExpression") && !(A.left && A.left.type === "AssignmentExpression" || A.right && A.right.type === "AssignmentExpression"));
  }
  function c(A) {
    return !(!K || !function(M) {
      for (var ne = M; ne; ne = ne.parent)
        if (ne.type === "ReturnStatement" || ne.type === "ArrowFunctionExpression" && ne.body.type !== "BlockStatement")
          return !0;
      return !1;
    }(A)) && (A.type === "ReturnStatement" ? A.argument && u(A.argument) : A.type === "ArrowFunctionExpression" && A.body.type !== "BlockStatement" ? u(A.body) : u(A));
  }
  function f(A, M) {
    return A.loc.end.line === M.loc.start.line ? i(M) : a(M);
  }
  function p(A) {
    return A.type === "CallExpression" && A.callee.type === "FunctionExpression";
  }
  function d(A) {
    function M() {
      e.report({ node: A, loc: ne.loc, messageId: "unexpected", fix: function(he) {
        var j = S.text.slice(ne.range[1], de.range[0]);
        return he.replaceTextRange([ne.range[0], de.range[1]], (function(ie) {
          var fe = S.getTokenBefore(ie), ge = S.getTokenBefore(ie, 1), Fe = S.getFirstToken(ie);
          return ge && ge.range[1] === fe.range[0] && fe.range[1] === Fe.range[0] && !P.canTokensBeAdjacent(ge, Fe);
        }(A) ? " " : "") + j + (function(ie) {
          var fe = S.getTokensAfter(ie, { count: 2 }), ge = fe[0], Fe = fe[1], Pe = S.getLastToken(ie);
          return ge && Fe && !S.isSpaceBetweenTokens(ge, Fe) && !P.canTokensBeAdjacent(Pe, Fe);
        }(A) ? " " : ""));
      } });
    }
    var ne = S.getTokenBefore(A), de = S.getTokenAfter(A);
    if (!(!r(A) && (w.has(S.getFirstToken(A)) || p(A) && !n(A.callee))))
      return O ? void O.reports.push({ node: A, finishReport: M }) : void M();
  }
  function m(A) {
    A.type === "UnaryExpression" && A.argument.type === "BinaryExpression" && A.argument.operator === "**" || i(A.argument) && D(A.argument) >= D(A) && d(A.argument);
  }
  function y(A) {
    var M = A.callee;
    if (i(M) && D(M) >= D(A)) {
      var ne = M.type === "NewExpression" && !o(M);
      !a(M) && (p(A) || ne || M.type === "MemberExpression" && function(de) {
        for (var he = de.object, j = de.object.type; j === "MemberExpression"; )
          j = (he = he.object).type;
        return j === "CallExpression";
      }(M)) || d(A.callee);
    }
    A.arguments.filter(function(de) {
      return i(de) && D(de) >= X;
    }).forEach(d);
  }
  function v(A) {
    var M = D(A), ne = D(A.left), de = D(A.right), he = A.operator === "**", j = V && (A.left.type === "BinaryExpression" || A.left.type === "LogicalExpression") || A.left.type === "UnaryExpression" && he, ie = V && (A.right.type === "BinaryExpression" || A.right.type === "LogicalExpression");
    !j && i(A.left) && (ne > M || ne === M && !he) && d(A.left), !ie && i(A.right) && (de > M || de === M && he) && d(A.right);
  }
  function b(A) {
    A.superClass && (D(A.superClass) > ce ? i(A.superClass) : a(A.superClass)) && d(A.superClass);
  }
  function x(A) {
    (D(A.argument) >= X ? i(A.argument) : a(A.argument)) && d(A.argument);
  }
  function C(A) {
    var M = n(A) ? S.getTokenBefore(A) : S.getFirstToken(A), ne = S.getTokenAfter(M, P.isNotOpeningParenToken), de = ne ? S.getTokenAfter(ne) : null, he = ne ? S.getTokenAfter(ne, P.isNotClosingParenToken) : null;
    P.isOpeningParenToken(M) && (P.isOpeningBraceToken(ne) || ne.type === "Keyword" && (ne.value === "function" || ne.value === "class" || ne.value === "let" && he && (P.isOpeningBracketToken(he) || he.type === "Identifier")) || ne && ne.type === "Identifier" && ne.value === "async" && de && de.type === "Keyword" && de.value === "function") && w.add(ne), i(A) && d(A);
  }
  function k(A, M) {
    return function(ne, de) {
      for (var he = [ne], j = ne; j !== de; ) {
        if ((j = j.parent) === null)
          throw new Error("Nodes are not in the ancestor-descendant relationship.");
        he.push(j);
      }
      return he;
    }(M, A).reverse();
  }
  function F(A, M) {
    switch (A.type) {
      case "ArrayExpression":
      case "ArrayPattern":
      case "BlockStatement":
      case "ObjectExpression":
      case "ObjectPattern":
      case "TemplateLiteral":
        return !0;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return A.params.includes(M);
      case "CallExpression":
      case "NewExpression":
        return A.arguments.includes(M);
      case "MemberExpression":
        return A.computed && A.property === M;
      case "ConditionalExpression":
        return A.consequent === M;
      default:
        return !1;
    }
  }
  function B(A) {
    return O.reports.some(function(M) {
      return M.node === A;
    });
  }
  var O, S = e.getSourceCode(), w = /* @__PURE__ */ new WeakSet(), D = P.getPrecedence, I = e.options[0] !== "functions", L = I && e.options[1] && e.options[1].conditionalAssign === !1, V = I && e.options[1] && e.options[1].nestedBinaryExpressions === !1, K = I && e.options[1] && e.options[1].returnAssign === !1, W = I && e.options[1] && e.options[1].ignoreJSX, R = I && e.options[1] && e.options[1].enforceForArrowConditionals === !1, q = I && e.options[1] && e.options[1].enforceForSequenceExpressions === !1, J = I && e.options[1] && e.options[1].enforceForNewInMemberExpressions === !1, X = D({ type: "AssignmentExpression" }), ce = D({ type: "UpdateExpression" });
  return { ArrayExpression: function(A) {
    A.elements.filter(function(M) {
      return M && i(M) && D(M) >= X;
    }).forEach(d);
  }, ArrowFunctionExpression: function(A) {
    if (!c(A) && (A.body.type !== "ConditionalExpression" || !R || r(A.body)) && A.body.type !== "BlockStatement") {
      var M = S.getFirstToken(A.body, P.isNotOpeningParenToken), ne = S.getTokenBefore(M);
      P.isOpeningParenToken(ne) && P.isOpeningBraceToken(M) && w.add(M), i(A.body) && D(A.body) >= X && d(A.body);
    }
  }, AssignmentExpression: function(A) {
    c(A) || i(A.right) && D(A.right) >= D(A) && d(A.right);
  }, BinaryExpression: function(A) {
    O && A.operator === "in" && O.inExpressionNodes.push(A), v(A);
  }, CallExpression: y, ClassBody: function(A) {
    A.body.filter(function(M) {
      return M.type === "MethodDefinition" && M.computed && M.key && i(M.key) && D(M.key) >= X;
    }).forEach(function(M) {
      return d(M.key);
    });
  }, ConditionalExpression: function(A) {
    c(A) || (i(A.test) && D(A.test) >= D({ type: "LogicalExpression", operator: "||" }) && d(A.test), i(A.consequent) && D(A.consequent) >= X && d(A.consequent), i(A.alternate) && D(A.alternate) >= X && d(A.alternate));
  }, DoWhileStatement: function(A) {
    i(A.test) && !s(A) && d(A.test);
  }, ExportDefaultDeclaration: function(A) {
    return C(A.declaration);
  }, ExpressionStatement: function(A) {
    return C(A.expression);
  }, "ForInStatement, ForOfStatement": function(A) {
    if (A.left.type !== "VariableDeclarator") {
      var M = S.getFirstToken(A.left, P.isNotOpeningParenToken);
      M.value === "let" && (M.range[1] === A.left.range[1] || P.isOpeningBracketToken(S.getTokenAfter(M, P.isNotClosingParenToken))) && w.add(M);
    }
    (A.type !== "ForOfStatement" || A.right.type !== "SequenceExpression") && i(A.right) && d(A.right), i(A.left) && d(A.left);
  }, ForStatement: function(A) {
    A.test && i(A.test) && !s(A) && d(A.test), A.update && i(A.update) && d(A.update), A.init && (O = { upper: O, inExpressionNodes: [], reports: [] }, i(A.init) && d(A.init));
  }, "ForStatement > *.init:exit": function(A) {
    O.reports.length && O.inExpressionNodes.forEach(function(M) {
      for (var ne, de = k(A, M), he = 0; he < de.length; he++) {
        var j = de[he];
        if (he < de.length - 1 && F(j, de[he + 1]))
          return;
        if (n(j)) {
          if (!B(j) || r(j))
            return;
          ne || (ne = j);
        }
      }
      (function(ie) {
        O.reports = O.reports.filter(function(fe) {
          return fe.node !== ie;
        });
      })(ne);
    }), function() {
      var M, ne, de = O, he = de.upper, j = de.inExpressionNodes, ie = de.reports;
      he ? ((M = he.inExpressionNodes).push.apply(M, Mt(j)), (ne = he.reports).push.apply(ne, Mt(ie))) : ie.forEach(function(fe) {
        return (0, fe.finishReport)();
      }), O = he;
    }();
  }, IfStatement: function(A) {
    i(A.test) && !s(A) && d(A.test);
  }, ImportExpression: function(A) {
    var M = A.source;
    M.type === "SequenceExpression" ? a(M) && d(M) : i(M) && d(M);
  }, LogicalExpression: v, MemberExpression: function(A) {
    var M = i(A.object);
    M && D(A.object) >= D(A) && (A.computed || !(P.isDecimalInteger(A.object) || A.object.type === "Literal" && A.object.regex)) && d(A.object), M && A.object.type === "CallExpression" && A.parent.type !== "NewExpression" && d(A.object), M && !J && A.object.type === "NewExpression" && o(A.object) && d(A.object), A.computed && i(A.property) && d(A.property);
  }, NewExpression: y, ObjectExpression: function(A) {
    A.properties.filter(function(M) {
      var ne = M.value;
      return ne && i(ne) && D(ne) >= X;
    }).forEach(function(M) {
      return d(M.value);
    });
  }, Property: function(A) {
    if (A.computed) {
      var M = A.key;
      M && i(M) && D(M) >= X && d(M);
    }
  }, ReturnStatement: function(A) {
    var M = S.getFirstToken(A);
    c(A) || A.argument && f(M, A.argument) && (A.argument.type !== "Literal" || !A.argument.regex) && d(A.argument);
  }, SequenceExpression: function(A) {
    A.expressions.filter(function(M) {
      return i(M) && D(M) >= D(A);
    }).forEach(d);
  }, SwitchCase: function(A) {
    A.test && i(A.test) && d(A.test);
  }, SwitchStatement: function(A) {
    i(A.discriminant) && d(A.discriminant);
  }, ThrowStatement: function(A) {
    f(S.getFirstToken(A), A.argument) && d(A.argument);
  }, UnaryExpression: m, UpdateExpression: m, AwaitExpression: m, VariableDeclarator: function(A) {
    A.init && i(A.init) && D(A.init) >= X && (A.init.type !== "Literal" || !A.init.regex) && d(A.init);
  }, WhileStatement: function(A) {
    i(A.test) && !s(A) && d(A.test);
  }, WithStatement: function(A) {
    i(A.object) && d(A.object);
  }, YieldExpression: function(A) {
    if (A.argument) {
      var M = S.getFirstToken(A);
      (D(A.argument) >= D(A) && f(M, A.argument) || a(A.argument)) && d(A.argument);
    }
  }, ClassDeclaration: b, ClassExpression: b, SpreadElement: x, SpreadProperty: x, ExperimentalSpreadProperty: x, TemplateLiteral: function(A) {
    A.expressions.filter(function(M) {
      return M && i(M);
    }).forEach(d);
  }, AssignmentPattern: function(A) {
    var M = A.right;
    M && i(M) && D(M) >= X && d(M);
  } };
} }, uO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary semicolons", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-extra-semi" }, fixable: "code", schema: [], messages: { unexpected: "Unnecessary semicolon." } }, create: function(e) {
  function t(i) {
    e.report({ node: i, messageId: "unexpected", fix: function(a) {
      return new bf(a, e.getSourceCode()).retainSurroundingTokens(i).remove(i);
    } });
  }
  function n(i) {
    for (var a = i; a.type === "Punctuator" && !P.isClosingBraceToken(a); a = r.getTokenAfter(a))
      P.isSemicolonToken(a) && t(a);
  }
  var r = e.getSourceCode();
  return { EmptyStatement: function(i) {
    var a = i.parent;
    ["ForStatement", "ForInStatement", "ForOfStatement", "WhileStatement", "DoWhileStatement", "IfStatement", "LabeledStatement", "WithStatement"].indexOf(a.type) === -1 && t(i);
  }, ClassBody: function(i) {
    n(r.getFirstToken(i, 1));
  }, MethodDefinition: function(i) {
    n(r.getTokenAfter(i));
  } };
} }, cO = /fall[s\u017F]?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/i;
function lO(e) {
  return e.reachable;
}
var pO = { meta: { type: "problem", docs: { description: "disallow fallthrough of `case` statements", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-fallthrough" }, schema: [{ type: "object", properties: { commentPattern: { type: "string", default: "" } }, additionalProperties: !1 }], messages: { case: "Expected a 'break' statement before 'case'.", default: "Expected a 'break' statement before 'default'." } }, create: function(e) {
  var t, n = e.options[0] || {}, r = null, i = e.getSourceCode(), a = null;
  return t = n.commentPattern ? new RegExp(n.commentPattern, "u") : cO, { onCodePathStart: function(s) {
    r = s;
  }, onCodePathEnd: function() {
    r = r.upper;
  }, SwitchCase: function(s) {
    a && !function(o, u, c) {
      var f = u.getSourceCode(), p = ye.lodash.last(f.getCommentsBefore(o));
      return !(!p || !c.test(p.value));
    }(s, e, t) && e.report({ messageId: s.test ? "case" : "default", node: s }), a = null;
  }, "SwitchCase:exit": function(s) {
    var o = i.getTokenAfter(s);
    r.currentSegments.some(lO) && (0 < s.consequent.length || function(u, c) {
      return c.loc.start.line > u.loc.end.line + 1;
    }(s, o)) && ye.lodash.last(s.parent.cases) !== s && (a = s);
  } };
} }, fO = { meta: { type: "suggestion", docs: { description: "disallow leading or trailing decimal points in numeric literals", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-floating-decimal" }, schema: [], fixable: "code", messages: { leading: "A leading decimal point can be confused with a dot.", trailing: "A trailing decimal point can be confused with a dot." } }, create: function(e) {
  var t = e.getSourceCode();
  return { Literal: function(n) {
    typeof n.value == "number" && (n.raw.startsWith(".") && e.report({ node: n, messageId: "leading", fix: function(r) {
      var i = t.getTokenBefore(n), a = i && i.range[1] === n.range[0] && !P.canTokensBeAdjacent(i, "0".concat(n.raw));
      return r.insertTextBefore(n, a ? " 0" : "0");
    } }), n.raw.indexOf(".") === n.raw.length - 1 && e.report({ node: n, messageId: "trailing", fix: function(r) {
      return r.insertTextAfter(n, "0");
    } }));
  } };
} }, hO = { meta: { type: "problem", docs: { description: "disallow reassigning `function` declarations", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-func-assign" }, schema: [] }, create: function(e) {
  function t(i) {
    P.getModifyingReferences(i).forEach(function(a) {
      e.report({ node: a.identifier, message: "'{{name}}' is a function.", data: { name: a.identifier.name } });
    });
  }
  function n(i) {
    i.defs[0].type === "FunctionName" && t(i.references);
  }
  function r(i) {
    e.getDeclaredVariables(i).forEach(n);
  }
  return { FunctionDeclaration: r, FunctionExpression: r };
} }, dO = /^(?:i|lastI)ndexOf$/;
function em(e) {
  return e.type === "Literal" && typeof e.value == "number" || e.type === "CallExpression" && (e.callee.name === "Number" || e.callee.name === "parseInt" || e.callee.name === "parseFloat");
}
function vp(e) {
  return P.isStringLiteral(e) && (e.value === "" || e.type === "TemplateLiteral" && e.quasis.length === 1 && e.quasis[0].value.cooked === "");
}
function b2(e) {
  return vp(e.left) ? e.right : e.left;
}
var mO = { meta: { type: "suggestion", docs: { description: "disallow shorthand type conversions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-implicit-coercion" }, fixable: "code", schema: [{ type: "object", properties: { boolean: { type: "boolean", default: !0 }, number: { type: "boolean", default: !0 }, string: { type: "boolean", default: !0 }, allow: { type: "array", items: { enum: ["~", "!!", "+", "*"] }, uniqueItems: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(i, a, s) {
    e.report({ node: i, message: "use `{{recommendation}}` instead.", data: { recommendation: a }, fix: function(o) {
      if (!s)
        return null;
      var u = r.getTokenBefore(i);
      return u && u.range[1] === i.range[0] && !P.canTokensBeAdjacent(u, a) ? o.replaceText(i, " ".concat(a)) : o.replaceText(i, a);
    } });
  }
  var n = function(i) {
    return { boolean: !("boolean" in i) || i.boolean, number: !("number" in i) || i.number, string: !("string" in i) || i.string, allow: i.allow || [] };
  }(e.options[0] || {}), r = e.getSourceCode();
  return { UnaryExpression: function(i) {
    0 <= n.allow.indexOf("!!") || !n.boolean || !function(a) {
      return a.operator === "!" && a.argument.type === "UnaryExpression" && a.argument.operator === "!";
    }(i) || t(i, "Boolean(".concat(r.getText(i.argument.argument), ")"), !0), 0 <= n.allow.indexOf("~") || !n.boolean || !function(a) {
      return a.operator === "~" && a.argument.type === "CallExpression" && a.argument.callee.type === "MemberExpression" && a.argument.callee.property.type === "Identifier" && dO.test(a.argument.callee.property.name);
    }(i) || t(i, "".concat(r.getText(i.argument), " !== -1"), !1), 0 <= n.allow.indexOf("+") || !n.number || i.operator !== "+" || em(i.argument) || t(i, "Number(".concat(r.getText(i.argument), ")"), !0);
  }, "BinaryExpression:exit": function(i) {
    var a = 0 <= n.allow.indexOf("*"), s = !a && n.number && function(o) {
      return o.operator === "*" && (o.left.type === "Literal" && o.left.value === 1 || o.right.type === "Literal" && o.right.value === 1);
    }(i) && function(o) {
      var u = o.left, c = o.right;
      return c.type === "BinaryExpression" || em(c) ? u.type === "BinaryExpression" || em(u) ? null : u : c;
    }(i);
    s && t(i, "Number(".concat(r.getText(s), ")"), !0), !(a = 0 <= n.allow.indexOf("+")) && n.string && function(o) {
      return o.operator === "+" && (vp(o.left) && !P.isStringLiteral(o.right) || vp(o.right) && !P.isStringLiteral(o.left));
    }(i) && t(i, "String(".concat(r.getText(b2(i)), ")"), !0);
  }, AssignmentExpression: function(i) {
    if (!(0 <= n.allow.indexOf("+")) && n.string && function(s) {
      return s.operator === "+=" && vp(s.right);
    }(i)) {
      var a = r.getText(b2(i));
      t(i, "".concat(a, " = String(").concat(a, ")"), !0);
    }
  } };
} }, FA = ye.require$$0, gO = FA.findVariable, yO = FA.getPropertyName, E2 = { Object: /* @__PURE__ */ new Set(["assign", "defineProperties", "defineProperty", "freeze", "setPrototypeOf"]), Reflect: /* @__PURE__ */ new Set(["defineProperty", "deleteProperty", "set", "setPrototypeOf"]) };
function vO(e, t) {
  var n = e.parent;
  return n.type === "MemberExpression" && n.object === e && (function(r) {
    var i = r.parent;
    return i.type === "AssignmentExpression" && i.left === r || i.type === "ArrayPattern" || i.type === "Property" && i.value === r && i.parent.type === "ObjectPattern" || i.type === "RestElement" || i.type === "AssignmentPattern" && i.left === r;
  }(n) || function(r) {
    var i = r.parent;
    return i.type === "UpdateExpression" && i.argument === r || i.type === "UnaryExpression" && i.operator === "delete" && i.argument === r;
  }(n) || function(r) {
    var i = r.parent;
    return i.type === "ForInStatement" && i.left === r || i.type === "ForOfStatement" && i.left === r;
  }(n)) || function(r, i) {
    var a = r.parent;
    if (a.type === "CallExpression" && a.arguments[0] === r && a.callee.type === "MemberExpression" && a.callee.object.type === "Identifier") {
      var s = a.callee, o = s.object;
      if (Object.keys(E2).includes(o.name)) {
        var u = gO(i, o);
        return u !== null && u.scope.type === "global" && E2[o.name].has(yO(s, i));
      }
    }
    return !1;
  }(e, t);
}
function C2(e) {
  for (var t = e.parent; t && t.type !== "AssignmentExpression" && t.type !== "UpdateExpression" && t.type !== "UnaryExpression" && t.type !== "CallExpression" && t.type !== "ForInStatement" && t.type !== "ForOfStatement"; )
    t = t.parent;
  return t || e;
}
var xO = { meta: { type: "problem", docs: { description: "disallow assigning to imported bindings", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-import-assign" }, schema: [], messages: { readonly: "'{{name}}' is read-only.", readonlyMember: "The members of '{{name}}' are read-only." } }, create: function(e) {
  return { ImportDeclaration: function(t) {
    var n = e.getScope(), r = !0, i = !1, a = void 0;
    try {
      for (var s, o = e.getDeclaredVariables(t)[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
        var u = s.value, c = u.defs.some(function(C) {
          return C.node.type === "ImportNamespaceSpecifier";
        }), f = null, p = !0, d = !1, m = void 0;
        try {
          for (var y, v = u.references[Symbol.iterator](); !(p = (y = v.next()).done); p = !0) {
            var b = y.value, x = b.identifier;
            x !== f && (f = x, b.isWrite() ? e.report({ node: C2(x), messageId: "readonly", data: { name: x.name } }) : c && vO(x, n) && e.report({ node: C2(x), messageId: "readonlyMember", data: { name: x.name } }));
          }
        } catch (C) {
          d = !0, m = C;
        } finally {
          try {
            p || v.return == null || v.return();
          } finally {
            if (d)
              throw m;
          }
        }
      }
    } catch (C) {
      i = !0, a = C;
    } finally {
      try {
        r || o.return == null || o.return();
      } finally {
        if (i)
          throw a;
      }
    }
  } };
} }, bO = { meta: { type: "suggestion", docs: { description: "disallow inline comments after code", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-inline-comments" }, schema: [] }, create: function(e) {
  function t(r) {
    var i = n.lines[r.loc.start.line - 1] + "", a = n.lines[r.loc.end.line - 1] + "", s = i.slice(0, r.loc.start.column).trim(), o = a.slice(r.loc.end.column).trim(), u = !s, c = !o;
    if (!u || !c) {
      if ((u || s === "{") && (c || o === "}")) {
        var f = n.getNodeByRangeIndex(r.range[0]);
        if (f && f.type === "JSXEmptyExpression")
          return;
      }
      P.isDirectiveComment(r) || e.report({ node: r, message: "Unexpected comment inline with code." });
    }
  }
  var n = e.getSourceCode();
  return { Program: function() {
    n.getAllComments().filter(function(r) {
      return r.type !== "Shebang";
    }).forEach(t);
  } };
} }, S2 = new ao.RegExpValidator({ ecmaVersion: 2018 }), EO = /[gimsuy]/g, k2 = void 0, CO = { meta: { type: "problem", docs: { description: "disallow invalid regular expression strings in `RegExp` constructors", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-invalid-regexp" }, schema: [{ type: "object", properties: { allowConstructorFlags: { type: "array", items: { type: "string" } } }, additionalProperties: !1 }] }, create: function(e) {
  function t(s) {
    return s && s.type === "Literal" && typeof s.value == "string";
  }
  function n(s, o) {
    try {
      return S2.validatePattern(s, k2, k2, o), null;
    } catch (u) {
      return u.message;
    }
  }
  var r = e.options[0], i = null;
  if (r && r.allowConstructorFlags) {
    var a = r.allowConstructorFlags.join("").replace(EO, "");
    a && (i = new RegExp("[".concat(a, "]"), "giu"));
  }
  return { "CallExpression, NewExpression": function(s) {
    if (s.callee.type === "Identifier" && s.callee.name === "RegExp" && t(s.arguments[0])) {
      var o = s.arguments[0].value, u = t(s.arguments[1]) ? s.arguments[1].value : "";
      i && (u = u.replace(i, ""));
      var c = function(f) {
        try {
          return S2.validateFlags(f), null;
        } catch {
          return "Invalid flags supplied to RegExp constructor '".concat(f, "'");
        }
      }(u) || (u ? n(o, u.indexOf("u") !== -1) : n(o, !0) && n(o, !1));
      c && e.report({ node: s, message: "{{message}}.", data: { message: c } });
    }
  } };
} }, SO = { meta: { type: "suggestion", docs: { description: "disallow `this` keywords outside of classes or class-like objects", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-invalid-this" }, schema: [{ type: "object", properties: { capIsConstructor: { type: "boolean", default: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(s) {
    i.push({ init: !e.getScope().isStrict, node: s, valid: !0 });
  }
  function n() {
    i.pop();
  }
  var r = (e.options[0] || {}).capIsConstructor !== !1, i = [], a = e.getSourceCode();
  return i.getCurrent = function() {
    var s = this[this.length - 1];
    return s.init || (s.init = !0, s.valid = !P.isDefaultThisBinding(s.node, a, { capIsConstructor: r })), s;
  }, { Program: function(s) {
    var o = e.getScope(), u = e.parserOptions.ecmaFeatures || {};
    i.push({ init: !0, node: s, valid: !(o.isStrict || s.sourceType === "module" || u.globalReturn && o.childScopes[0].isStrict) });
  }, "Program:exit": function() {
    i.pop();
  }, FunctionDeclaration: t, "FunctionDeclaration:exit": n, FunctionExpression: t, "FunctionExpression:exit": n, ThisExpression: function(s) {
    var o = i.getCurrent();
    o && !o.valid && e.report({ node: s, message: "Unexpected 'this'." });
  } };
} }, Xl = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u2028\u2029\u202F\u205F\u3000\uFEFF]/, kO = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]+/gm, DO = /[\u2028\u2029]/gm, FO = P.createGlobalLinebreakMatcher(), wO = { meta: { type: "problem", docs: { description: "disallow irregular whitespace", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-irregular-whitespace" }, schema: [{ type: "object", properties: { skipComments: { type: "boolean", default: !1 }, skipStrings: { type: "boolean", default: !0 }, skipTemplates: { type: "boolean", default: !1 }, skipRegExps: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(y) {
    var v = y.loc.start, b = y.loc.end;
    a = a.filter(function(x) {
      var C = x.loc;
      return !(C.line >= v.line && C.line <= b.line && C.column >= v.column && (C.column <= b.column || C.line < b.line));
    });
  }
  function n(y) {
    var v = u && typeof y.value == "string", b = c && !!y.regex;
    (v || b) && Xl.test(y.raw) && t(y);
  }
  function r(y) {
    Xl.test(y.value) && t(y);
  }
  function i() {
  }
  var a = [], s = e.options[0] || {}, o = !!s.skipComments, u = s.skipStrings !== !1, c = !!s.skipRegExps, f = !!s.skipTemplates, p = e.getSourceCode(), d = p.getAllComments(), m = {};
  return Xl.test(p.getText()) ? (m.Program = function(y) {
    (function(v) {
      p.lines.forEach(function(b, x) {
        for (var C; (C = kO.exec(b)) !== null; ) {
          var k = { line: x + 1, column: C.index };
          a.push({ node: v, message: "Irregular whitespace not allowed.", loc: k });
        }
      });
    })(y), function(v) {
      for (var b, x = p.getText(), C = p.lines, k = x.match(FO), F = -1; (b = DO.exec(x)) !== null; ) {
        var B = k.indexOf(b[0], F + 1) || 0, O = { line: B + 1, column: C[B].length };
        a.push({ node: v, message: "Irregular whitespace not allowed.", loc: O }), F = B;
      }
    }(y);
  }, m.Identifier = n, m.Literal = n, m.TemplateElement = f ? function(y) {
    typeof y.value.raw == "string" && Xl.test(y.value.raw) && t(y);
  } : i, m["Program:exit"] = function() {
    o && d.forEach(r), a.forEach(function(y) {
      return e.report(y);
    });
  }) : m.Program = i, m;
} }, AO = { meta: { type: "suggestion", docs: { description: "disallow labels that share a name with a variable", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-label-var" }, schema: [] }, create: function(e) {
  return { LabeledStatement: function(t) {
    (function(n, r) {
      return P.getVariableByName(n, r) !== null;
    })(e.getScope(), t.label.name) && e.report({ node: t, message: "Found identifier with same name as label." });
  } };
} }, _O = { meta: { type: "suggestion", docs: { description: "disallow labeled statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-labels" }, schema: [{ type: "object", properties: { allowLoop: { type: "boolean", default: !1 }, allowSwitch: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(u) {
    return P.isLoop(u) ? "loop" : u.type === "SwitchStatement" ? "switch" : "other";
  }
  function n(u) {
    return u === "loop" ? a : u == "switch" && s;
  }
  function r(u) {
    for (var c = o; c; ) {
      if (c.label === u)
        return c.kind;
      c = c.upper;
    }
    return "other";
  }
  var i = e.options[0], a = i && i.allowLoop, s = i && i.allowSwitch, o = null;
  return { LabeledStatement: function(u) {
    o = { label: u.label.name, kind: t(u.body), upper: o };
  }, "LabeledStatement:exit": function(u) {
    n(o.kind) || e.report({ node: u, message: "Unexpected labeled statement." }), o = o.upper;
  }, BreakStatement: function(u) {
    u.label && !n(r(u.label.name)) && e.report({ node: u, message: "Unexpected label in break statement." });
  }, ContinueStatement: function(u) {
    u.label && !n(r(u.label.name)) && e.report({ node: u, message: "Unexpected label in continue statement." });
  } };
} };
function wA(e) {
  for (var t = e; t.parent; t = t.parent) {
    var n = t.parent;
    switch (n.type) {
      case "WhileStatement":
      case "DoWhileStatement":
        return n;
      case "ForStatement":
        if (n.init !== t)
          return n;
        break;
      case "ForInStatement":
      case "ForOfStatement":
        if (n.right !== t)
          return n;
        break;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "FunctionDeclaration":
        return null;
    }
  }
  return null;
}
function TO(e, t) {
  var n = t.resolved, r = n && n.defs[0], i = r && r.parent, a = i && i.type === "VariableDeclaration" ? i.kind : "";
  if (a === "const" || a === "let" && i.range[0] > e.range[0] && i.range[1] < e.range[1])
    return !0;
  var s = function(o, u) {
    for (var c = u ? u.range[1] : 0, f = o, p = o; p && p.range[0] >= c; )
      f = p, p = wA(p);
    return f;
  }(e, a === "let" ? i : null).range[0];
  return !!n && n.references.every(function(o) {
    var u = o.identifier;
    return !o.isWrite() || n.scope.variableScope === o.from.variableScope && u.range[0] < s;
  });
}
var PO = { meta: { type: "suggestion", docs: { description: "disallow function declarations that contain unsafe references inside loop statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-loop-func" }, schema: [], messages: { unsafeRefs: "Function declared in a loop contains unsafe references to variable(s) {{ varNames }}." } }, create: function(e) {
  function t(n) {
    var r = wA(n);
    if (r) {
      var i = e.getScope().through.filter(function(a) {
        return !TO(r, a);
      }).map(function(a) {
        return a.identifier.name;
      });
      0 < i.length && e.report({ node: n, messageId: "unsafeRefs", data: { varNames: "'".concat(i.join("', '"), "'") } });
    }
  }
  return { ArrowFunctionExpression: t, FunctionExpression: t, FunctionDeclaration: t };
} }, IO = /* @__PURE__ */ new Set([768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1425, 1426, 1427, 1428, 1429, 1430, 1431, 1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444, 1445, 1446, 1447, 1448, 1449, 1450, 1451, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1471, 1473, 1474, 1476, 1477, 1479, 1552, 1553, 1554, 1555, 1556, 1557, 1558, 1559, 1560, 1561, 1562, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1629, 1630, 1631, 1648, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1759, 1760, 1761, 1762, 1763, 1764, 1767, 1768, 1770, 1771, 1772, 1773, 1809, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2070, 2071, 2072, 2073, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2085, 2086, 2087, 2089, 2090, 2091, 2092, 2093, 2137, 2138, 2139, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2275, 2276, 2277, 2278, 2279, 2280, 2281, 2282, 2283, 2284, 2285, 2286, 2287, 2288, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 2362, 2363, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2402, 2403, 2433, 2434, 2435, 2492, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2503, 2504, 2507, 2508, 2509, 2519, 2530, 2531, 2561, 2562, 2563, 2620, 2622, 2623, 2624, 2625, 2626, 2631, 2632, 2635, 2636, 2637, 2641, 2672, 2673, 2677, 2689, 2690, 2691, 2748, 2750, 2751, 2752, 2753, 2754, 2755, 2756, 2757, 2759, 2760, 2761, 2763, 2764, 2765, 2786, 2787, 2810, 2811, 2812, 2813, 2814, 2815, 2817, 2818, 2819, 2876, 2878, 2879, 2880, 2881, 2882, 2883, 2884, 2887, 2888, 2891, 2892, 2893, 2902, 2903, 2914, 2915, 2946, 3006, 3007, 3008, 3009, 3010, 3014, 3015, 3016, 3018, 3019, 3020, 3021, 3031, 3072, 3073, 3074, 3075, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3142, 3143, 3144, 3146, 3147, 3148, 3149, 3157, 3158, 3170, 3171, 3201, 3202, 3203, 3260, 3262, 3263, 3264, 3265, 3266, 3267, 3268, 3270, 3271, 3272, 3274, 3275, 3276, 3277, 3285, 3286, 3298, 3299, 3328, 3329, 3330, 3331, 3387, 3388, 3390, 3391, 3392, 3393, 3394, 3395, 3396, 3398, 3399, 3400, 3402, 3403, 3404, 3405, 3415, 3426, 3427, 3458, 3459, 3530, 3535, 3536, 3537, 3538, 3539, 3540, 3542, 3544, 3545, 3546, 3547, 3548, 3549, 3550, 3551, 3570, 3571, 3633, 3636, 3637, 3638, 3639, 3640, 3641, 3642, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3761, 3764, 3765, 3766, 3767, 3768, 3769, 3771, 3772, 3784, 3785, 3786, 3787, 3788, 3789, 3864, 3865, 3893, 3895, 3897, 3902, 3903, 3953, 3954, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3962, 3963, 3964, 3965, 3966, 3967, 3968, 3969, 3970, 3971, 3972, 3974, 3975, 3981, 3982, 3983, 3984, 3985, 3986, 3987, 3988, 3989, 3990, 3991, 3993, 3994, 3995, 3996, 3997, 3998, 3999, 4e3, 4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4014, 4015, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4027, 4028, 4038, 4139, 4140, 4141, 4142, 4143, 4144, 4145, 4146, 4147, 4148, 4149, 4150, 4151, 4152, 4153, 4154, 4155, 4156, 4157, 4158, 4182, 4183, 4184, 4185, 4190, 4191, 4192, 4194, 4195, 4196, 4199, 4200, 4201, 4202, 4203, 4204, 4205, 4209, 4210, 4211, 4212, 4226, 4227, 4228, 4229, 4230, 4231, 4232, 4233, 4234, 4235, 4236, 4237, 4239, 4250, 4251, 4252, 4253, 4957, 4958, 4959, 5906, 5907, 5908, 5938, 5939, 5940, 5970, 5971, 6002, 6003, 6068, 6069, 6070, 6071, 6072, 6073, 6074, 6075, 6076, 6077, 6078, 6079, 6080, 6081, 6082, 6083, 6084, 6085, 6086, 6087, 6088, 6089, 6090, 6091, 6092, 6093, 6094, 6095, 6096, 6097, 6098, 6099, 6109, 6155, 6156, 6157, 6277, 6278, 6313, 6432, 6433, 6434, 6435, 6436, 6437, 6438, 6439, 6440, 6441, 6442, 6443, 6448, 6449, 6450, 6451, 6452, 6453, 6454, 6455, 6456, 6457, 6458, 6459, 6679, 6680, 6681, 6682, 6683, 6741, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6749, 6750, 6752, 6753, 6754, 6755, 6756, 6757, 6758, 6759, 6760, 6761, 6762, 6763, 6764, 6765, 6766, 6767, 6768, 6769, 6770, 6771, 6772, 6773, 6774, 6775, 6776, 6777, 6778, 6779, 6780, 6783, 6832, 6833, 6834, 6835, 6836, 6837, 6838, 6839, 6840, 6841, 6842, 6843, 6844, 6845, 6846, 6912, 6913, 6914, 6915, 6916, 6964, 6965, 6966, 6967, 6968, 6969, 6970, 6971, 6972, 6973, 6974, 6975, 6976, 6977, 6978, 6979, 6980, 7019, 7020, 7021, 7022, 7023, 7024, 7025, 7026, 7027, 7040, 7041, 7042, 7073, 7074, 7075, 7076, 7077, 7078, 7079, 7080, 7081, 7082, 7083, 7084, 7085, 7142, 7143, 7144, 7145, 7146, 7147, 7148, 7149, 7150, 7151, 7152, 7153, 7154, 7155, 7204, 7205, 7206, 7207, 7208, 7209, 7210, 7211, 7212, 7213, 7214, 7215, 7216, 7217, 7218, 7219, 7220, 7221, 7222, 7223, 7376, 7377, 7378, 7380, 7381, 7382, 7383, 7384, 7385, 7386, 7387, 7388, 7389, 7390, 7391, 7392, 7393, 7394, 7395, 7396, 7397, 7398, 7399, 7400, 7405, 7410, 7411, 7412, 7415, 7416, 7417, 7616, 7617, 7618, 7619, 7620, 7621, 7622, 7623, 7624, 7625, 7626, 7627, 7628, 7629, 7630, 7631, 7632, 7633, 7634, 7635, 7636, 7637, 7638, 7639, 7640, 7641, 7642, 7643, 7644, 7645, 7646, 7647, 7648, 7649, 7650, 7651, 7652, 7653, 7654, 7655, 7656, 7657, 7658, 7659, 7660, 7661, 7662, 7663, 7664, 7665, 7666, 7667, 7668, 7669, 7670, 7671, 7672, 7673, 7675, 7676, 7677, 7678, 7679, 8400, 8401, 8402, 8403, 8404, 8405, 8406, 8407, 8408, 8409, 8410, 8411, 8412, 8413, 8414, 8415, 8416, 8417, 8418, 8419, 8420, 8421, 8422, 8423, 8424, 8425, 8426, 8427, 8428, 8429, 8430, 8431, 8432, 11503, 11504, 11505, 11647, 11744, 11745, 11746, 11747, 11748, 11749, 11750, 11751, 11752, 11753, 11754, 11755, 11756, 11757, 11758, 11759, 11760, 11761, 11762, 11763, 11764, 11765, 11766, 11767, 11768, 11769, 11770, 11771, 11772, 11773, 11774, 11775, 12330, 12331, 12332, 12333, 12334, 12335, 12441, 12442, 42607, 42608, 42609, 42610, 42612, 42613, 42614, 42615, 42616, 42617, 42618, 42619, 42620, 42621, 42654, 42655, 42736, 42737, 43010, 43014, 43019, 43043, 43044, 43045, 43046, 43047, 43136, 43137, 43188, 43189, 43190, 43191, 43192, 43193, 43194, 43195, 43196, 43197, 43198, 43199, 43200, 43201, 43202, 43203, 43204, 43205, 43232, 43233, 43234, 43235, 43236, 43237, 43238, 43239, 43240, 43241, 43242, 43243, 43244, 43245, 43246, 43247, 43248, 43249, 43302, 43303, 43304, 43305, 43306, 43307, 43308, 43309, 43335, 43336, 43337, 43338, 43339, 43340, 43341, 43342, 43343, 43344, 43345, 43346, 43347, 43392, 43393, 43394, 43395, 43443, 43444, 43445, 43446, 43447, 43448, 43449, 43450, 43451, 43452, 43453, 43454, 43455, 43456, 43493, 43561, 43562, 43563, 43564, 43565, 43566, 43567, 43568, 43569, 43570, 43571, 43572, 43573, 43574, 43587, 43596, 43597, 43643, 43644, 43645, 43696, 43698, 43699, 43700, 43703, 43704, 43710, 43711, 43713, 43755, 43756, 43757, 43758, 43759, 43765, 43766, 44003, 44004, 44005, 44006, 44007, 44008, 44009, 44010, 44012, 44013, 64286, 65024, 65025, 65026, 65027, 65028, 65029, 65030, 65031, 65032, 65033, 65034, 65035, 65036, 65037, 65038, 65039, 65056, 65057, 65058, 65059, 65060, 65061, 65062, 65063, 65064, 65065, 65066, 65067, 65068, 65069, 65070, 65071, 66045, 66272, 66422, 66423, 66424, 66425, 66426, 68097, 68098, 68099, 68101, 68102, 68108, 68109, 68110, 68111, 68152, 68153, 68154, 68159, 68325, 68326, 69632, 69633, 69634, 69688, 69689, 69690, 69691, 69692, 69693, 69694, 69695, 69696, 69697, 69698, 69699, 69700, 69701, 69702, 69759, 69760, 69761, 69762, 69808, 69809, 69810, 69811, 69812, 69813, 69814, 69815, 69816, 69817, 69818, 69888, 69889, 69890, 69927, 69928, 69929, 69930, 69931, 69932, 69933, 69934, 69935, 69936, 69937, 69938, 69939, 69940, 70003, 70016, 70017, 70018, 70067, 70068, 70069, 70070, 70071, 70072, 70073, 70074, 70075, 70076, 70077, 70078, 70079, 70080, 70090, 70091, 70092, 70188, 70189, 70190, 70191, 70192, 70193, 70194, 70195, 70196, 70197, 70198, 70199, 70206, 70367, 70368, 70369, 70370, 70371, 70372, 70373, 70374, 70375, 70376, 70377, 70378, 70400, 70401, 70402, 70403, 70460, 70462, 70463, 70464, 70465, 70466, 70467, 70468, 70471, 70472, 70475, 70476, 70477, 70487, 70498, 70499, 70502, 70503, 70504, 70505, 70506, 70507, 70508, 70512, 70513, 70514, 70515, 70516, 70709, 70710, 70711, 70712, 70713, 70714, 70715, 70716, 70717, 70718, 70719, 70720, 70721, 70722, 70723, 70724, 70725, 70726, 70832, 70833, 70834, 70835, 70836, 70837, 70838, 70839, 70840, 70841, 70842, 70843, 70844, 70845, 70846, 70847, 70848, 70849, 70850, 70851, 71087, 71088, 71089, 71090, 71091, 71092, 71093, 71096, 71097, 71098, 71099, 71100, 71101, 71102, 71103, 71104, 71132, 71133, 71216, 71217, 71218, 71219, 71220, 71221, 71222, 71223, 71224, 71225, 71226, 71227, 71228, 71229, 71230, 71231, 71232, 71339, 71340, 71341, 71342, 71343, 71344, 71345, 71346, 71347, 71348, 71349, 71350, 71351, 71453, 71454, 71455, 71456, 71457, 71458, 71459, 71460, 71461, 71462, 71463, 71464, 71465, 71466, 71467, 72193, 72194, 72195, 72196, 72197, 72198, 72199, 72200, 72201, 72202, 72243, 72244, 72245, 72246, 72247, 72248, 72249, 72251, 72252, 72253, 72254, 72263, 72273, 72274, 72275, 72276, 72277, 72278, 72279, 72280, 72281, 72282, 72283, 72330, 72331, 72332, 72333, 72334, 72335, 72336, 72337, 72338, 72339, 72340, 72341, 72342, 72343, 72344, 72345, 72751, 72752, 72753, 72754, 72755, 72756, 72757, 72758, 72760, 72761, 72762, 72763, 72764, 72765, 72766, 72767, 72850, 72851, 72852, 72853, 72854, 72855, 72856, 72857, 72858, 72859, 72860, 72861, 72862, 72863, 72864, 72865, 72866, 72867, 72868, 72869, 72870, 72871, 72873, 72874, 72875, 72876, 72877, 72878, 72879, 72880, 72881, 72882, 72883, 72884, 72885, 72886, 73009, 73010, 73011, 73012, 73013, 73014, 73018, 73020, 73021, 73023, 73024, 73025, 73026, 73027, 73028, 73029, 73031, 92912, 92913, 92914, 92915, 92916, 92976, 92977, 92978, 92979, 92980, 92981, 92982, 94033, 94034, 94035, 94036, 94037, 94038, 94039, 94040, 94041, 94042, 94043, 94044, 94045, 94046, 94047, 94048, 94049, 94050, 94051, 94052, 94053, 94054, 94055, 94056, 94057, 94058, 94059, 94060, 94061, 94062, 94063, 94064, 94065, 94066, 94067, 94068, 94069, 94070, 94071, 94072, 94073, 94074, 94075, 94076, 94077, 94078, 94095, 94096, 94097, 94098, 113821, 113822, 119141, 119142, 119143, 119144, 119145, 119149, 119150, 119151, 119152, 119153, 119154, 119163, 119164, 119165, 119166, 119167, 119168, 119169, 119170, 119173, 119174, 119175, 119176, 119177, 119178, 119179, 119210, 119211, 119212, 119213, 119362, 119363, 119364, 121344, 121345, 121346, 121347, 121348, 121349, 121350, 121351, 121352, 121353, 121354, 121355, 121356, 121357, 121358, 121359, 121360, 121361, 121362, 121363, 121364, 121365, 121366, 121367, 121368, 121369, 121370, 121371, 121372, 121373, 121374, 121375, 121376, 121377, 121378, 121379, 121380, 121381, 121382, 121383, 121384, 121385, 121386, 121387, 121388, 121389, 121390, 121391, 121392, 121393, 121394, 121395, 121396, 121397, 121398, 121403, 121404, 121405, 121406, 121407, 121408, 121409, 121410, 121411, 121412, 121413, 121414, 121415, 121416, 121417, 121418, 121419, 121420, 121421, 121422, 121423, 121424, 121425, 121426, 121427, 121428, 121429, 121430, 121431, 121432, 121433, 121434, 121435, 121436, 121437, 121438, 121439, 121440, 121441, 121442, 121443, 121444, 121445, 121446, 121447, 121448, 121449, 121450, 121451, 121452, 121461, 121476, 121499, 121500, 121501, 121502, 121503, 121505, 121506, 121507, 121508, 121509, 121510, 121511, 121512, 121513, 121514, 121515, 121516, 121517, 121518, 121519, 122880, 122881, 122882, 122883, 122884, 122885, 122886, 122888, 122889, 122890, 122891, 122892, 122893, 122894, 122895, 122896, 122897, 122898, 122899, 122900, 122901, 122902, 122903, 122904, 122907, 122908, 122909, 122910, 122911, 122912, 122913, 122915, 122916, 122918, 122919, 122920, 122921, 122922, 125136, 125137, 125138, 125139, 125140, 125141, 125142, 125252, 125253, 125254, 125255, 125256, 125257, 125258, 917760, 917761, 917762, 917763, 917764, 917765, 917766, 917767, 917768, 917769, 917770, 917771, 917772, 917773, 917774, 917775, 917776, 917777, 917778, 917779, 917780, 917781, 917782, 917783, 917784, 917785, 917786, 917787, 917788, 917789, 917790, 917791, 917792, 917793, 917794, 917795, 917796, 917797, 917798, 917799, 917800, 917801, 917802, 917803, 917804, 917805, 917806, 917807, 917808, 917809, 917810, 917811, 917812, 917813, 917814, 917815, 917816, 917817, 917818, 917819, 917820, 917821, 917822, 917823, 917824, 917825, 917826, 917827, 917828, 917829, 917830, 917831, 917832, 917833, 917834, 917835, 917836, 917837, 917838, 917839, 917840, 917841, 917842, 917843, 917844, 917845, 917846, 917847, 917848, 917849, 917850, 917851, 917852, 917853, 917854, 917855, 917856, 917857, 917858, 917859, 917860, 917861, 917862, 917863, 917864, 917865, 917866, 917867, 917868, 917869, 917870, 917871, 917872, 917873, 917874, 917875, 917876, 917877, 917878, 917879, 917880, 917881, 917882, 917883, 917884, 917885, 917886, 917887, 917888, 917889, 917890, 917891, 917892, 917893, 917894, 917895, 917896, 917897, 917898, 917899, 917900, 917901, 917902, 917903, 917904, 917905, 917906, 917907, 917908, 917909, 917910, 917911, 917912, 917913, 917914, 917915, 917916, 917917, 917918, 917919, 917920, 917921, 917922, 917923, 917924, 917925, 917926, 917927, 917928, 917929, 917930, 917931, 917932, 917933, 917934, 917935, 917936, 917937, 917938, 917939, 917940, 917941, 917942, 917943, 917944, 917945, 917946, 917947, 917948, 917949, 917950, 917951, 917952, 917953, 917954, 917955, 917956, 917957, 917958, 917959, 917960, 917961, 917962, 917963, 917964, 917965, 917966, 917967, 917968, 917969, 917970, 917971, 917972, 917973, 917974, 917975, 917976, 917977, 917978, 917979, 917980, 917981, 917982, 917983, 917984, 917985, 917986, 917987, 917988, 917989, 917990, 917991, 917992, 917993, 917994, 917995, 917996, 917997, 917998, 917999]), BO = function(e) {
  return IO.has(e);
}, OO = function(e) {
  return 127995 <= e && 127999 >= e;
}, LO = function(e) {
  return 127462 <= e && 127487 >= e;
}, NO = function(e, t) {
  return 55296 <= e && 56320 > e && 56320 <= t && 57344 > t;
}, Ef = ye.require$$0, jO = Ef.CALL, RO = Ef.CONSTRUCT, MO = Ef.ReferenceTracker, D2 = Ef.getStringIfConstant, VO = ao.RegExpParser, UO = ao.visitRegExpAST, F2 = BO, w2 = OO, A2 = LO, qO = NO;
function AA(e) {
  var t, n, r, i, a, s, o;
  return regeneratorRuntime.wrap(function(u) {
    for (; ; )
      switch (u.prev = u.next) {
        case 0:
          t = [], n = !0, r = !1, i = void 0, u.prev = 4, a = e[Symbol.iterator]();
        case 6:
          if (n = (s = a.next()).done) {
            u.next = 26;
            break;
          }
          o = s.value, u.t0 = o.type, u.next = u.t0 === "Character" ? 11 : u.t0 === "CharacterClassRange" ? 13 : u.t0 === "CharacterSet" ? 18 : 23;
          break;
        case 11:
          return t.push(o.value), u.abrupt("break", 23);
        case 13:
          return t.push(o.min.value), u.next = 16, t;
        case 16:
          return t = [o.max.value], u.abrupt("break", 23);
        case 18:
          if (u.t1 = 0 < t.length, !u.t1) {
            u.next = 23;
            break;
          }
          return u.next = 22, t;
        case 22:
          t = [];
        case 23:
          n = !0, u.next = 6;
          break;
        case 26:
          u.next = 32;
          break;
        case 28:
          u.prev = 28, u.t2 = u.catch(4), r = !0, i = u.t2;
        case 32:
          u.prev = 32, u.prev = 33, n || a.return == null || a.return();
        case 35:
          if (u.prev = 35, !r) {
            u.next = 38;
            break;
          }
          throw i;
        case 38:
          return u.finish(35);
        case 39:
          return u.finish(32);
        case 40:
          if (u.t3 = 0 < t.length, !u.t3) {
            u.next = 44;
            break;
          }
          return u.next = 44, t;
        case 44:
        case "end":
          return u.stop();
      }
  }, wI, null, [[4, 28, 32, 40], [33, , 35, 39]]);
}
var _A = { surrogatePairWithoutUFlag: function(e) {
  return e.some(function(t, n) {
    return n !== 0 && qO(e[n - 1], t);
  });
}, combiningClass: function(e) {
  return e.some(function(t, n) {
    return n !== 0 && F2(t) && !F2(e[n - 1]);
  });
}, emojiModifier: function(e) {
  return e.some(function(t, n) {
    return n !== 0 && w2(t) && !w2(e[n - 1]);
  });
}, regionalIndicatorSymbol: function(e) {
  return e.some(function(t, n) {
    return n !== 0 && A2(t) && A2(e[n - 1]);
  });
}, zwj: function(e) {
  var t = e.length - 1;
  return e.some(function(n, r) {
    return r !== 0 && r !== t && n === 8205 && e[r - 1] !== 8205 && e[r + 1] !== 8205;
  });
} }, _2 = Object.keys(_A), WO = { meta: { type: "problem", docs: { description: "disallow characters which are made with multiple code points in character class syntax", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-misleading-character-class" }, schema: [], messages: { surrogatePairWithoutUFlag: "Unexpected surrogate pair in character class. Use 'u' flag.", combiningClass: "Unexpected combined character in character class.", emojiModifier: "Unexpected modified Emoji in character class.", regionalIndicatorSymbol: "Unexpected national flag in character class.", zwj: "Unexpected joined character sequence in character class." } }, create: function(e) {
  function t(r, i, a) {
    var s, o = { surrogatePairWithoutUFlag: !1, combiningClass: !1, variationSelector: !1, emojiModifier: !1, regionalIndicatorSymbol: !1, zwj: !1 };
    try {
      s = n.parsePattern(i, 0, i.length, a.includes("u"));
    } catch {
      return;
    }
    UO(s, { onCharacterClassEnter: function(y) {
      var v = !0, b = !1, x = void 0;
      try {
        for (var C, k = AA(y.elements)[Symbol.iterator](); !(v = (C = k.next()).done); v = !0) {
          var F = C.value, B = !0, O = !1, S = void 0;
          try {
            for (var w, D = _2[Symbol.iterator](); !(B = (w = D.next()).done); B = !0) {
              var I = w.value;
              o[I] = o[I] || _A[I](F);
            }
          } catch (L) {
            O = !0, S = L;
          } finally {
            try {
              B || D.return == null || D.return();
            } finally {
              if (O)
                throw S;
            }
          }
        }
      } catch (L) {
        b = !0, x = L;
      } finally {
        try {
          v || k.return == null || k.return();
        } finally {
          if (b)
            throw x;
        }
      }
    } });
    var u = !0, c = !1, f = void 0;
    try {
      for (var p, d = _2[Symbol.iterator](); !(u = (p = d.next()).done); u = !0) {
        var m = p.value;
        o[m] && e.report({ node: r, messageId: m });
      }
    } catch (y) {
      c = !0, f = y;
    } finally {
      try {
        u || d.return == null || d.return();
      } finally {
        if (c)
          throw f;
      }
    }
  }
  var n = new VO();
  return { "Literal[regex]": function(r) {
    t(r, r.regex.pattern, r.regex.flags);
  }, Program: function() {
    var r = e.getScope(), i = new MO(r), a = !0, s = !1, o = void 0;
    try {
      for (var u, c = i.iterateGlobalReferences({ RegExp: (f = {}, Fn(f, jO, !0), Fn(f, RO, !0), f) })[Symbol.iterator](); !(a = (u = c.next()).done); a = !0) {
        var f, p = u.value.node, d = bn(p.arguments, 2), m = d[0], y = d[1], v = D2(m, r), b = D2(y, r);
        typeof v == "string" && t(p, v, b || "");
      }
    } catch (x) {
      s = !0, o = x;
    } finally {
      try {
        a || c.return == null || c.return();
      } finally {
        if (s)
          throw o;
      }
    }
  } };
} }, TA = ["+", "-", "*", "/", "%", "**"], PA = ["&", "|", "^", "~", "<<", ">>", ">>>"], IA = ["==", "!=", "===", "!==", ">", ">=", "<", "<="], BA = ["&&", "||"], OA = ["in", "instanceof"], $O = [].concat(TA, PA, IA, BA, OA, ["?:"]), GO = [TA, PA, IA, BA, OA], T2 = /^(?:Binary|Logical|Conditional)Expression$/;
function tm(e) {
  return e.type === "ConditionalExpression" ? e.test : e.left;
}
var zO = { meta: { type: "suggestion", docs: { description: "disallow mixed binary operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-mixed-operators" }, schema: [{ type: "object", properties: { groups: { type: "array", items: { type: "array", items: { enum: $O }, minItems: 2, uniqueItems: !0 }, uniqueItems: !0 }, allowSamePrecedence: { type: "boolean", default: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o) {
    var u = o, c = o.parent;
    return !function(f, p, d) {
      return f.some(function(m) {
        return m.indexOf(p) !== -1 && m.indexOf(d) !== -1;
      });
    }(s.groups, u.operator, c.type === "ConditionalExpression" ? "?:" : c.operator) || s.allowSamePrecedence && P.getPrecedence(u) === P.getPrecedence(c);
  }
  function n(o) {
    return a.getTokenAfter(tm(o), P.isNotClosingParenToken);
  }
  function r(o) {
    var u = o.parent, c = tm(u) === o ? o : u, f = tm(u) === o ? u : o, p = "Unexpected mix of '{{leftOperator}}' and '{{rightOperator}}'.", d = { leftOperator: c.operator || "?:", rightOperator: f.operator || "?:" };
    e.report({ node: c, loc: n(c).loc, message: p, data: d }), e.report({ node: f, loc: n(f).loc, message: p, data: d });
  }
  function i(o) {
    T2.test(o.parent.type) && (o.parent.type === "ConditionalExpression" && !t(o) && function(u) {
      return !P.isParenthesised(a, u) && !P.isParenthesised(a, u.test);
    }(o.parent) || T2.test(o.parent.type) && function(u) {
      return u.operator !== u.parent.operator && !P.isParenthesised(a, u);
    }(o) && !t(o)) && r(o);
  }
  var a = e.getSourceCode(), s = function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { groups: o.groups && 0 < o.groups.length ? o.groups : GO, allowSamePrecedence: o.allowSamePrecedence !== !1 };
  }(e.options[0]);
  return { BinaryExpression: i, LogicalExpression: i };
} }, HO = { meta: { type: "suggestion", docs: { description: "disallow `require` calls to be mixed with regular variable declarations", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-mixed-requires" }, schema: [{ oneOf: [{ type: "boolean" }, { type: "object", properties: { grouping: { type: "boolean" }, allowCall: { type: "boolean" } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(d) {
    return d ? d.type === "CallExpression" && d.callee.type === "Identifier" && d.callee.name === "require" ? "require" : s && d.type === "CallExpression" && d.callee.type === "CallExpression" ? t(d.callee) : d.type === "MemberExpression" ? t(d.object) : "other" : "uninitialized";
  }
  function n(d) {
    var m = {};
    return d.forEach(function(y) {
      var v = t(y.init);
      m[v] = !0;
    }), !(!m[u] || !m[c] && !m[f]);
  }
  function r(d) {
    var m = {};
    return d.forEach(function(y) {
      t(y.init) === u && (m[function v(b) {
        if (b.type === "MemberExpression")
          return v(b.object);
        if (b.arguments.length === 0)
          return p;
        var x = b.arguments[0];
        return x.type !== "Literal" || typeof x.value != "string" ? "computed" : o.indexOf(x.value) === -1 ? /^\.{0,2}\//.test(x.value) ? "file" : "module" : "core";
      }(y.init)] = !0);
    }), 1 >= Object.keys(m).length;
  }
  var i = e.options[0], a = !1, s = !1;
  xe(i) == "object" ? (a = i.grouping, s = i.allowCall) : a = !!i;
  var o = ["assert", "buffer", "child_process", "cluster", "crypto", "dgram", "dns", "domain", "events", "fs", "http", "https", "net", "os", "path", "punycode", "querystring", "readline", "repl", "smalloc", "stream", "string_decoder", "tls", "tty", "url", "util", "v8", "vm", "zlib"], u = "require", c = "uninitialized", f = "other", p = "computed";
  return { VariableDeclaration: function(d) {
    n(d.declarations) ? e.report({ node: d, message: "Do not mix 'require' and other declarations." }) : a && !r(d.declarations) && e.report({ node: d, message: "Do not mix core, module, file and computed requires." });
  } };
} }, KO = { meta: { type: "layout", docs: { description: "disallow multiple spaces", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-multi-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { exceptions: { type: "object", patternProperties: { "^([A-Z][a-z]*)+$": { type: "boolean" } }, additionalProperties: !1 }, ignoreEOLComments: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o) {
    var u = o.value.split(`
`), c = u[0], f = "".concat(c.slice(0, 12), "...");
    return u.length === 1 && 12 >= c.length ? c : f;
  }
  var n = e.getSourceCode(), r = e.options[0] || {}, i = r.ignoreEOLComments, a = Object.assign({ Property: !0 }, r.exceptions), s = 0 < Object.keys(a).filter(function(o) {
    return a[o];
  }).length;
  return { Program: function() {
    n.tokensAndComments.forEach(function(o, u, c) {
      if (u !== c.length - 1) {
        var f = c[u + 1];
        if (n.text.slice(o.range[1], f.range[0]).includes("  ") && !(o.loc.end.line < f.loc.start.line) && !(i && P.isCommentToken(f) && (u === c.length - 2 || f.loc.end.line < c[u + 2].loc.start.line))) {
          if (s) {
            var p = n.getNodeByRangeIndex(f.range[0] - 1);
            if (p && a[p.type])
              return;
          }
          var d;
          d = f.type === "Block" ? "/*".concat(t(f), "*/") : f.type === "Line" ? "//".concat(t(f)) : f.value, e.report({ node: f, loc: { start: o.loc.end, end: f.loc.start }, message: "Multiple spaces found before '{{displayValue}}'.", data: { displayValue: d }, fix: function(m) {
            return m.replaceTextRange([o.range[1], f.range[0]], " ");
          } });
        }
      }
    });
  } };
} }, JO = { meta: { type: "suggestion", docs: { description: "disallow multiline strings", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-multi-str" }, schema: [] }, create: function(e) {
  return { Literal: function(t) {
    P.LINEBREAK_MATCHER.test(t.raw) && !function(n) {
      return n.type.indexOf("JSX") === 0;
    }(t.parent) && e.report({ node: t, message: "Multiline support is limited to browsers supporting ES5 only." });
  } };
} }, QO = { meta: { type: "layout", docs: { description: "disallow multiple empty lines", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-multiple-empty-lines" }, fixable: "whitespace", schema: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, maxEOF: { type: "integer", minimum: 0 }, maxBOF: { type: "integer", minimum: 0 } }, required: ["max"], additionalProperties: !1 }] }, create: function(e) {
  var t = 2, n = t, r = t;
  e.options.length && (t = e.options[0].max, n = e.options[0].maxEOF === void 0 ? t : e.options[0].maxEOF, r = e.options[0].maxBOF === void 0 ? t : e.options[0].maxBOF);
  var i = e.getSourceCode(), a = i.lines[i.lines.length - 1] === "" ? i.lines.slice(0, -1) : i.lines, s = /* @__PURE__ */ new Set();
  return { TemplateLiteral: function(o) {
    o.quasis.forEach(function(u) {
      for (var c = u.loc.start.line; c < u.loc.end.line; c++)
        s.add(c);
    });
  }, "Program:exit": function(o) {
    return a.reduce(function(u, c, f) {
      return (c.trim() || s.has(f + 1)) && u.push(f + 1), u;
    }, []).concat(a.length + 1).reduce(function(u, c) {
      var f, p;
      return u === 0 ? (f = "Too many blank lines at the beginning of file. Max of {{max}} allowed.", p = r) : c === a.length + 1 ? (f = "Too many blank lines at the end of file. Max of {{max}} allowed.", p = n) : (f = "More than {{max}} blank {{pluralizedLines}} not allowed.", p = t), c - u - 1 > p && e.report({ node: o, loc: { start: { line: u + 1, column: 0 }, end: { line: c, column: 0 } }, message: f, data: { max: p, pluralizedLines: p === 1 ? "line" : "lines" }, fix: function(d) {
        var m = i.getIndexFromLoc({ line: u + 1, column: 0 }), y = c - p, v = y <= a.length ? i.getIndexFromLoc({ line: y, column: 0 }) : i.text.length;
        return d.removeRange([m, v]);
      } }), c;
    }, 0);
  } };
} }, LA = ye.require$$0, XO = LA.CALL, YO = LA.ReferenceTracker, ZO = ["Atomics", "JSON", "Math", "Reflect"], eL = { meta: { type: "problem", docs: { description: "disallow calling global object properties as functions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-obj-calls" }, schema: [], messages: { unexpectedCall: "'{{name}}' is not a function." } }, create: function(e) {
  return { Program: function() {
    var t = e.getScope(), n = new YO(t), r = {}, i = !0, a = !1, s = void 0;
    try {
      for (var o, u = ZO[Symbol.iterator](); !(i = (o = u.next()).done); i = !0)
        r[o.value] = Fn({}, XO, !0);
    } catch (v) {
      a = !0, s = v;
    } finally {
      try {
        i || u.return == null || u.return();
      } finally {
        if (a)
          throw s;
      }
    }
    var c = !0, f = !1, p = void 0;
    try {
      for (var d, m = n.iterateGlobalReferences(r)[Symbol.iterator](); !(c = (d = m.next()).done); c = !0) {
        var y = d.value.node;
        e.report({ node: y, messageId: "unexpectedCall", data: { name: y.callee.name } });
      }
    } catch (v) {
      f = !0, p = v;
    } finally {
      try {
        c || m.return == null || m.return();
      } finally {
        if (f)
          throw p;
      }
    }
  } };
} }, tL = /(?:Statement|Declaration|Function(?:Expression)?|Program)$/, nL = { meta: { type: "suggestion", docs: { description: "disallow reassigning `function` parameters", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-param-reassign" }, schema: [{ oneOf: [{ type: "object", properties: { props: { enum: [!1] } }, additionalProperties: !1 }, { type: "object", properties: { props: { enum: [!0] }, ignorePropertyModificationsFor: { type: "array", items: { type: "string" }, uniqueItems: !0 }, ignorePropertyModificationsForRegex: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(u) {
    return s.includes(u) || o.some(function(c) {
      return new RegExp(c, "u").test(u);
    });
  }
  function n(u, c, f) {
    var p = u.identifier;
    p && !u.init && (c === 0 || f[c - 1].identifier !== p) && (u.isWrite() ? e.report({ node: p, message: "Assignment to function parameter '{{name}}'.", data: { name: p.name } }) : a && function(d) {
      for (var m = d.identifier, y = m.parent; y && (!tL.test(y.type) || y.type === "ForInStatement" || y.type === "ForOfStatement"); ) {
        switch (y.type) {
          case "AssignmentExpression":
            return y.left === m;
          case "UpdateExpression":
            return !0;
          case "UnaryExpression":
            if (y.operator === "delete")
              return !0;
            break;
          case "ForInStatement":
          case "ForOfStatement":
            return y.left === m;
          case "CallExpression":
            if (y.callee !== m)
              return !1;
            break;
          case "MemberExpression":
            if (y.property === m)
              return !1;
            break;
          case "Property":
            if (y.key === m)
              return !1;
            break;
          case "ConditionalExpression":
            if (y.test === m)
              return !1;
        }
        y = (m = y).parent;
      }
      return !1;
    }(u) && !t(p.name) && e.report({ node: p, message: "Assignment to property of function parameter '{{name}}'.", data: { name: p.name } }));
  }
  function r(u) {
    u.defs[0].type === "Parameter" && u.references.forEach(n);
  }
  function i(u) {
    e.getDeclaredVariables(u).forEach(r);
  }
  var a = e.options[0] && e.options[0].props, s = e.options[0] && e.options[0].ignorePropertyModificationsFor || [], o = e.options[0] && e.options[0].ignorePropertyModificationsForRegex || [];
  return { "FunctionDeclaration:exit": i, "FunctionExpression:exit": i, "ArrowFunctionExpression:exit": i };
} }, rL = { meta: { type: "suggestion", docs: { description: "disallow the unary operators `++` and `--`", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-plusplus" }, schema: [{ type: "object", properties: { allowForLoopAfterthoughts: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  var t = e.options[0], n = !1;
  return xe(t) == "object" && (n = t.allowForLoopAfterthoughts === !0), { UpdateExpression: function(r) {
    n && r.parent.type === "ForStatement" || e.report({ node: r, message: "Unary operator '{{operator}}' used.", data: { operator: r.operator } });
  } };
} }, iL = { meta: { type: "suggestion", docs: { description: "disallow variable redeclaration", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-redeclare" }, messages: { redeclared: "'{{id}}' is already defined.", redeclaredAsBuiltin: "'{{id}}' is already defined as a built-in global variable.", redeclaredBySyntax: "'{{id}}' is already defined by a variable declaration." }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  var t = regeneratorRuntime.mark(n);
  function n(o) {
    var u, c, f, p, d, m, y, v, b, x, C, k;
    return regeneratorRuntime.wrap(function(F) {
      for (; ; )
        switch (F.prev = F.next) {
          case 0:
            if (F.t0 = a.builtinGlobals && (o.eslintImplicitGlobalSetting === "readonly" || o.eslintImplicitGlobalSetting === "writable"), !F.t0) {
              F.next = 4;
              break;
            }
            return F.next = 4, { type: "builtin" };
          case 4:
            u = !0, c = !1, f = void 0, F.prev = 7, p = o.identifiers[Symbol.iterator]();
          case 9:
            if (u = (d = p.next()).done) {
              F.next = 16;
              break;
            }
            return m = d.value, F.next = 13, { type: "syntax", node: m, loc: m.loc };
          case 13:
            u = !0, F.next = 9;
            break;
          case 16:
            F.next = 22;
            break;
          case 18:
            F.prev = 18, F.t1 = F.catch(7), c = !0, f = F.t1;
          case 22:
            F.prev = 22, F.prev = 23, u || p.return == null || p.return();
          case 25:
            if (F.prev = 25, !c) {
              F.next = 28;
              break;
            }
            throw f;
          case 28:
            return F.finish(25);
          case 29:
            return F.finish(22);
          case 30:
            if (!o.eslintExplicitGlobalComments) {
              F.next = 57;
              break;
            }
            y = !0, v = !1, b = void 0, F.prev = 34, x = o.eslintExplicitGlobalComments[Symbol.iterator]();
          case 36:
            if (y = (C = x.next()).done) {
              F.next = 43;
              break;
            }
            return k = C.value, F.next = 40, { type: "comment", node: k, loc: P.getNameLocationInGlobalDirectiveComment(s, k, o.name) };
          case 40:
            y = !0, F.next = 36;
            break;
          case 43:
            F.next = 49;
            break;
          case 45:
            F.prev = 45, F.t2 = F.catch(34), v = !0, b = F.t2;
          case 49:
            F.prev = 49, F.prev = 50, y || x.return == null || x.return();
          case 52:
            if (F.prev = 52, !v) {
              F.next = 55;
              break;
            }
            throw b;
          case 55:
            return F.finish(52);
          case 56:
            return F.finish(49);
          case 57:
          case "end":
            return F.stop();
        }
    }, t, null, [[7, 18, 22, 30], [23, , 25, 29], [34, 45, 49, 57], [50, , 52, 56]]);
  }
  function r(o) {
    var u, c = !0, f = !1, p = void 0;
    try {
      for (var d, m = o.variables[Symbol.iterator](); !(c = (d = m.next()).done); c = !0) {
        var y = d.value, v = n(y), b = nE(u = v) || rE(u) || iE(), x = b[0], C = b.slice(1);
        if (C.length !== 0) {
          var k = x.type === "builtin" ? "redeclaredAsBuiltin" : "redeclaredBySyntax", F = { id: y.name }, B = !0, O = !1, S = void 0;
          try {
            for (var w, D = C[Symbol.iterator](); !(B = (w = D.next()).done); B = !0) {
              var I = w.value, L = I.type, V = I.node, K = I.loc, W = L === x.type ? "redeclared" : k;
              e.report({ node: V, loc: K, messageId: W, data: F });
            }
          } catch (R) {
            O = !0, S = R;
          } finally {
            try {
              B || D.return == null || D.return();
            } finally {
              if (O)
                throw S;
            }
          }
        }
      }
    } catch (R) {
      f = !0, p = R;
    } finally {
      try {
        c || m.return == null || m.return();
      } finally {
        if (f)
          throw p;
      }
    }
  }
  function i(o) {
    var u = e.getScope();
    u.block === o && r(u);
  }
  var a = { builtinGlobals: !(e.options.length !== 0 && !e.options[0].builtinGlobals) }, s = e.getSourceCode();
  return { Program: function() {
    var o = e.getScope();
    r(o), o.type === "global" && o.childScopes[0] && o.block === o.childScopes[0].block && r(o.childScopes[0]);
  }, FunctionDeclaration: i, FunctionExpression: i, ArrowFunctionExpression: i, BlockStatement: i, ForStatement: i, ForInStatement: i, ForOfStatement: i, SwitchStatement: i };
} }, aL = new ao.RegExpParser(), oL = / {2}/;
function P2(e) {
  return e && e.type === "Literal" && typeof e.value == "string";
}
var sL = { meta: { type: "suggestion", docs: { description: "disallow multiple spaces in regular expressions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-regex-spaces" }, schema: [], fixable: "code" }, create: function(e) {
  function t(r, i, a, s, o) {
    if (oL.test(a)) {
      var u, c = [];
      try {
        u = aL.parsePattern(i, 0, i.length, o.includes("u"));
      } catch {
        return;
      }
      ao.visitRegExpAST(u, { onCharacterClassEnter: function(y) {
        c.push(y);
      } });
      for (var f, p = /( {2,})(?: [\*\+\?\{]|(?:[\0-\),->@-z\|-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|$)/g, d = function(y) {
        var v = y[1].length, b = y.index;
        if (c.every(function(x) {
          var C = x.start, k = x.end;
          return b < C || k <= b;
        }))
          return { v: void e.report({ node: r, message: "Spaces are hard to count. Use {{{length}}}.", data: { length: v }, fix: function(x) {
            return i === a ? x.replaceTextRange([s + b, s + b + v], " {".concat(v, "}")) : null;
          } }) };
      }; f = p.exec(i); ) {
        var m = d(f);
        if (xe(m) === "object")
          return m.v;
      }
    }
  }
  function n(r) {
    var i = e.getScope(), a = P.getVariableByName(i, "RegExp"), s = a && 0 < a.defs.length, o = r.arguments[0], u = r.arguments[1];
    r.callee.type === "Identifier" && r.callee.name === "RegExp" && P2(o) && !s && t(r, o.value, o.raw.slice(1, -1), o.range[0] + 1, P2(u) ? u.value : "");
  }
  return { Literal: function(r) {
    if (r.regex) {
      var i = r.regex.pattern, a = r.raw.slice(1, r.raw.lastIndexOf("/"));
      t(r, i, a, r.range[0] + 1, r.regex.flags);
    }
  }, CallExpression: n, NewExpression: n };
} }, uL = "Unexpected use of '{{name}}'.", cL = "Unexpected use of '{{name}}'. {{customMessage}}", lL = { meta: { type: "suggestion", docs: { description: "disallow specified global variables", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-restricted-globals" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string" } }, required: ["name"], additionalProperties: !1 }] }, uniqueItems: !0, minItems: 0 } }, create: function(e) {
  function t(i) {
    var a = i.identifier.name, s = r[a], o = s ? cL : uL;
    e.report({ node: i.identifier, message: o, data: { name: a, customMessage: s } });
  }
  function n(i) {
    return Object.prototype.hasOwnProperty.call(r, i);
  }
  if (e.options.length === 0)
    return {};
  var r = e.options.reduce(function(i, a) {
    return typeof a == "string" ? i[a] = null : i[a.name] = a.message, i;
  }, {});
  return { Program: function() {
    var i = e.getScope();
    i.variables.forEach(function(a) {
      !a.defs.length && n(a.name) && a.references.forEach(t);
    }), i.through.forEach(function(a) {
      n(a.identifier.name) && t(a);
    });
  } };
} }, I2 = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 }, importNames: { type: "array", items: { type: "string" } } }, additionalProperties: !1, required: ["name"] }] }, uniqueItems: !0 }, pL = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `import`", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-restricted-imports" }, messages: { path: "'{{importSource}}' import is restricted from being used.", pathWithCustomMessage: "'{{importSource}}' import is restricted from being used. {{customMessage}}", patterns: "'{{importSource}}' import is restricted from being used by a pattern.", everything: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted.", everythingWithCustomMessage: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted. {{customMessage}}" }, schema: { anyOf: [I2, { type: "array", items: { type: "object", properties: { paths: I2, patterns: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }, additionalItems: !1 }] } }, create: function(e) {
  function t(m) {
    var y = m.source.value.trim(), v = p[y] && p[y].message;
    e.report({ node: m, messageId: v ? "pathWithCustomMessage" : "path", data: { importSource: y, customMessage: v } });
  }
  function n(m) {
    var y = m.source.value.trim();
    e.report({ node: m, messageId: "patterns", data: { importSource: y } });
  }
  function r(m, y) {
    var v = p[m].importNames, b = p[m] && p[m].message;
    e.report({ node: y, messageId: b ? "everythingWithCustomMessage" : "everything", data: { importSource: m, importNames: v, customMessage: b } });
  }
  function i(m, y) {
    return Object.prototype.hasOwnProperty.call(p, m) && p[m].importNames && function(v) {
      return v.has("*");
    }(y);
  }
  function a(m, y) {
    var v = !1;
    return Object.prototype.hasOwnProperty.call(p, m) && (v = !p[m].importNames || function(b, x) {
      return x.some(function(C) {
        return b.has(C);
      });
    }(y, p[m].importNames)), v;
  }
  function s(m) {
    var y = m.source.value.trim(), v = m.specifiers ? m.specifiers.reduce(function(b, x) {
      return x.type === "ImportDefaultSpecifier" ? b.add("default") : x.type === "ImportNamespaceSpecifier" ? b.add("*") : x.imported ? b.add(x.imported.name) : x.local && b.add(x.local.name), b;
    }, /* @__PURE__ */ new Set()) : /* @__PURE__ */ new Set();
    i(y, v) && r(y, m), a(y, v) && t(m), function(b) {
      return 0 < f.length && d.ignores(b);
    }(y) && n(m);
  }
  var o = Array.isArray(e.options) ? e.options : [], u = xe(o[0]) == "object" && (Object.prototype.hasOwnProperty.call(o[0], "paths") || Object.prototype.hasOwnProperty.call(o[0], "patterns")), c = (u ? o[0].paths : e.options) || [], f = (u ? o[0].patterns : []) || [], p = c.reduce(function(m, y) {
    return typeof y == "string" ? m[y] = { message: null } : m[y.name] = { message: y.message, importNames: y.importNames }, m;
  }, {});
  if (Object.keys(c).length === 0 && f.length === 0)
    return {};
  var d = CA().add(f);
  return { ImportDeclaration: s, ExportNamedDeclaration: function(m) {
    m.source && s(m);
  }, ExportAllDeclaration: s };
} }, fL = "'{{moduleName}}' module is restricted from being used.", hL = "'{{moduleName}}' module is restricted from being used. {{customMessage}}", B2 = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 } }, additionalProperties: !1, required: ["name"] }] }, uniqueItems: !0 }, dL = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `require`", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-restricted-modules" }, schema: { anyOf: [B2, { type: "array", items: { type: "object", properties: { paths: B2, patterns: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }, additionalItems: !1 }] } }, create: function(e) {
  var t = Array.isArray(e.options) ? e.options : [], n = xe(t[0]) == "object" && (Object.prototype.hasOwnProperty.call(t[0], "paths") || Object.prototype.hasOwnProperty.call(t[0], "patterns")), r = (n ? t[0].paths : e.options) || [], i = (n ? t[0].patterns : []) || [], a = r.reduce(function(o, u) {
    return typeof u == "string" ? o[u] = null : o[u.name] = u.message, o;
  }, {});
  if (Object.keys(r).length === 0 && i.length === 0)
    return {};
  var s = CA().add(i);
  return { CallExpression: function(o) {
    if (function(c) {
      return c.callee.type === "Identifier" && c.callee.name === "require";
    }(o) && o.arguments.length && function(c) {
      return c && c.type === "Literal" && typeof c.value == "string";
    }(o.arguments[0])) {
      var u = o.arguments[0].value.trim();
      (function(c) {
        return Object.prototype.hasOwnProperty.call(a, c);
      })(u) && function(c) {
        var f = c.arguments[0].value.trim(), p = a[f], d = p ? hL : fL;
        e.report({ node: c, message: d, data: { moduleName: f, customMessage: p } });
      }(o), 0 < i.length && s.ignores(u) && e.report({ node: o, message: "'{{moduleName}}' module is restricted from being used by a pattern.", data: { moduleName: u } });
    }
  } };
} }, mL = { meta: { type: "suggestion", docs: { description: "disallow certain properties on certain objects", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-restricted-properties" }, schema: { type: "array", items: { anyOf: [{ type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: !1, required: ["object"] }, { type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: !1, required: ["property"] }] }, uniqueItems: !0 } }, create: function(e) {
  function t(o, u, c) {
    if (c !== null) {
      var f = i.get(u), p = f ? f.get(c) : a.get(u), d = s.get(c);
      if (p) {
        var m = p.message ? " ".concat(p.message) : "";
        e.report({ node: o, message: "'{{objectName}}.{{propertyName}}' is restricted from being used.{{message}}", data: { objectName: u, propertyName: c, message: m } });
      } else if (d) {
        var y = d.message ? " ".concat(d.message) : "";
        e.report({ node: o, message: "'{{propertyName}}' is restricted from being used.{{message}}", data: { propertyName: c, message: y } });
      }
    }
  }
  function n(o) {
    if (o.right.type === "Identifier") {
      var u = o.right.name;
      o.left.type === "ObjectPattern" && o.left.properties.forEach(function(c) {
        t(o.left, u, P.getStaticPropertyName(c));
      });
    }
  }
  var r = e.options;
  if (r.length === 0)
    return {};
  var i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map();
  return r.forEach(function(o) {
    var u = o.object, c = o.property;
    u === void 0 ? s.set(c, { message: o.message }) : c === void 0 ? a.set(u, { message: o.message }) : (!i.has(u) && i.set(u, /* @__PURE__ */ new Map()), i.get(u).set(c, { message: o.message }));
  }), { MemberExpression: function(o) {
    t(o, o.object && o.object.name, P.getStaticPropertyName(o));
  }, VariableDeclarator: function(o) {
    if (o.init && o.init.type === "Identifier") {
      var u = o.init.name;
      o.id.type === "ObjectPattern" && o.id.properties.forEach(function(c) {
        t(o.id, u, P.getStaticPropertyName(c));
      });
    }
  }, AssignmentExpression: n, AssignmentPattern: n };
} }, gL = { meta: { type: "suggestion", docs: { description: "disallow specified syntax", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-restricted-syntax" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { selector: { type: "string" }, message: { type: "string" } }, required: ["selector"], additionalProperties: !1 }] }, uniqueItems: !0, minItems: 0 } }, create: function(e) {
  return e.options.reduce(function(t, n) {
    var r = typeof n == "string", i = !r && !!n.message, a = r ? n : n.selector, s = i ? n.message : "Using '{{selector}}' is not allowed.";
    return Object.assign(t, Fn({}, a, function(o) {
      e.report({ node: o, message: s, data: i ? {} : { selector: a } });
    }));
  }, {});
} }, yL = /^(?:[A-Za-z]+?Statement|ArrowFunctionExpression|FunctionExpression|ClassExpression)$/, vL = { meta: { type: "suggestion", docs: { description: "disallow assignment operators in `return` statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-return-assign" }, schema: [{ enum: ["except-parens", "always"] }] }, create: function(e) {
  var t = (e.options[0] || "except-parens") !== "except-parens", n = e.getSourceCode();
  return { AssignmentExpression: function(r) {
    if (t || !P.isParenthesised(n, r)) {
      for (var i = r, a = i.parent; a && !yL.test(a.type); )
        i = a, a = a.parent;
      a && a.type === "ReturnStatement" ? e.report({ node: a, message: "Return statement should not contain assignment." }) : a && a.type === "ArrowFunctionExpression" && a.body === i && e.report({ node: a, message: "Arrow function should not return assignment." });
    }
  } };
} }, xL = "Redundant use of `await` on a return value.", bL = { meta: { type: "suggestion", docs: { description: "disallow unnecessary `return await`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-return-await" }, fixable: null, schema: [] }, create: function(e) {
  function t(r) {
    e.report({ node: e.getSourceCode().getFirstToken(r), loc: r.loc, message: xL });
  }
  function n(r) {
    for (var i = r; !P.isFunction(i) && i.type !== "Program"; ) {
      if (i.parent.type === "TryStatement" && (i === i.parent.block || i === i.parent.handler && i.parent.finalizer))
        return !0;
      i = i.parent;
    }
    return !1;
  }
  return { AwaitExpression: function(r) {
    (function i(a) {
      return a.parent.type === "ArrowFunctionExpression" || (a.parent.type === "ReturnStatement" ? !n(a.parent) : a.parent.type !== "ConditionalExpression" || a !== a.parent.consequent && a !== a.parent.alternate ? (a.parent.type === "LogicalExpression" && a === a.parent.right || !(a.parent.type !== "SequenceExpression" || a !== a.parent.expressions[a.parent.expressions.length - 1])) && i(a.parent) : i(a.parent));
    })(r) && !n(r) && t(r);
  } };
} }, EL = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g;
function NA(e, t) {
  if (!function(i, a) {
    if (i.property.type === "Identifier" && i.property.type === a.property.type && i.property.name === a.property.name && i.computed === a.computed)
      return !0;
    var s = P.getStaticPropertyName(i), o = P.getStaticPropertyName(a);
    return s !== null && s === o;
  }(e, t))
    return !1;
  var n = e.object, r = t.object;
  return n.type === r.type && (n.type === "MemberExpression" ? NA(n, r) : n.type === "ThisExpression" || n.type === "Identifier" && n.name === r.name);
}
var CL = { meta: { type: "problem", docs: { description: "disallow assignments where both sides are exactly the same", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-self-assign" }, schema: [{ type: "object", properties: { props: { type: "boolean", default: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(s) {
    e.report({ node: s, message: "'{{name}}' is assigned to itself.", data: { name: n.getText(s).replace(EL, "") } });
  }
  var n = e.getSourceCode(), r = bn(e.options, 1)[0], i = (r = r === void 0 ? {} : r).props, a = i === void 0 || i;
  return { AssignmentExpression: function(s) {
    s.operator === "=" && function o(u, c, f, p) {
      if (u && c)
        if (u.type === "Identifier" && c.type === "Identifier" && u.name === c.name)
          p(c);
        else if (u.type === "ArrayPattern" && c.type === "ArrayExpression")
          for (var d = Math.min(u.elements.length, c.elements.length), m = 0; m < d; ++m) {
            var y = u.elements[m], v = c.elements[m];
            if (y && y.type === "RestElement" && m < c.elements.length - 1 || (o(y, v, f, p), v && v.type === "SpreadElement"))
              break;
          }
        else if (u.type === "RestElement" && c.type === "SpreadElement")
          o(u.argument, c.argument, f, p);
        else if (u.type === "ObjectPattern" && c.type === "ObjectExpression" && 1 <= c.properties.length) {
          for (var b = 0, x = c.properties.length - 1; 0 <= x; --x) {
            var C = c.properties[x].type;
            if (C === "SpreadElement" || C === "ExperimentalSpreadProperty") {
              b = x + 1;
              break;
            }
          }
          for (var k = 0; k < u.properties.length; ++k)
            for (var F = b; F < c.properties.length; ++F)
              o(u.properties[k], c.properties[F], f, p);
        } else if (u.type !== "Property" || c.type !== "Property" || c.kind !== "init" || c.method)
          f && u.type === "MemberExpression" && c.type === "MemberExpression" && NA(u, c) && p(c);
        else {
          var B = P.getStaticPropertyName(u);
          B !== null && B === P.getStaticPropertyName(c) && o(u.value, c.value, f, p);
        }
    }(s.left, s.right, a, t);
  } };
} }, SL = { meta: { type: "problem", docs: { description: "disallow comparisons where both sides are exactly the same", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-self-compare" }, schema: [] }, create: function(e) {
  function t(r, i) {
    var a = n.getTokens(r), s = n.getTokens(i);
    return a.length === s.length && a.every(function(o, u) {
      return o.type === s[u].type && o.value === s[u].value;
    });
  }
  var n = e.getSourceCode();
  return { BinaryExpression: function(r) {
    (/* @__PURE__ */ new Set(["===", "==", "!==", "!=", ">", "<", ">=", "<="])).has(r.operator) && t(r.left, r.right) && e.report({ node: r, message: "Comparing to itself is potentially pointless." });
  } };
} }, kL = { meta: { type: "suggestion", docs: { description: "disallow comma operators", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-sequences" }, schema: [] }, create: function(e) {
  function t(a) {
    return a.parent && i[a.parent.type] && a === a.parent[i[a.parent.type]];
  }
  function n(a) {
    return P.isParenthesised(r, a);
  }
  var r = e.getSourceCode(), i = { DoWhileStatement: "test", IfStatement: "test", SwitchStatement: "discriminant", WhileStatement: "test", WithStatement: "object", ArrowFunctionExpression: "body" };
  return { SequenceExpression: function(a) {
    if (a.parent.type !== "ForStatement" || a !== a.parent.init && a !== a.parent.update) {
      if (t(a)) {
        if (function(o) {
          var u = r.getTokenBefore(o, 1), c = r.getTokenAfter(o, 1);
          return n(o) && u && c && P.isOpeningParenToken(u) && u.range[1] <= o.range[0] && P.isClosingParenToken(c) && c.range[0] >= o.range[1];
        }(a))
          return;
      } else if (n(a))
        return;
      var s = r.getTokenAfter(a.expressions[0], P.isCommaToken);
      e.report({ node: a, loc: s.loc, message: "Unexpected use of comma operator." });
    }
  } };
} }, DL = ye.require$$0.findVariable;
function Yl(e, t, n, r, i) {
  var a = e.parent;
  return a.type === "CallExpression" && a.arguments[i] === e && a.callee.type === "MemberExpression" && P.getStaticPropertyName(a.callee) === r && a.callee.object.type === "Identifier" && a.callee.object.name === n && function(s, o) {
    var u = DL(o, s);
    return u !== null && u.scope.type === "global" && u.defs.length === 0;
  }(a.callee.object, t);
}
function FL(e, t) {
  var n = e.parent;
  return !(n.kind !== "set" || n.value !== e) || !(n.type !== "Property" || n.value !== e || P.getStaticPropertyName(n) !== "set" || n.parent.type !== "ObjectExpression" || !function(r, i) {
    if (Yl(r, i, "Object", "defineProperty", 2) || Yl(r, i, "Reflect", "defineProperty", 2))
      return !0;
    var a = r.parent;
    if (a.type === "Property" && a.value === r) {
      var s = a.parent;
      if (s.type === "ObjectExpression" && (Yl(s, i, "Object", "create", 1) || Yl(s, i, "Object", "defineProperties", 1)))
        return !0;
    }
    return !1;
  }(n.parent, t));
}
var wL = { meta: { type: "problem", docs: { description: "disallow returning values from setters", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-setter-return" }, schema: [], messages: { returnsValue: "Setter cannot return a value." } }, create: function(e) {
  function t(a) {
    var s = function(o) {
      var u = o.upper;
      return u.type === "function-expression-name" ? u.upper : u;
    }(e.getScope());
    i = { upper: i, isSetter: FL(a, s) };
  }
  function n() {
    i = i.upper;
  }
  function r(a) {
    e.report({ node: a, messageId: "returnsValue" });
  }
  var i = null;
  return { FunctionDeclaration: t, FunctionExpression: t, ArrowFunctionExpression: function(a) {
    t(a), i.isSetter && a.expression && r(a.body);
  }, "FunctionDeclaration:exit": n, "FunctionExpression:exit": n, "ArrowFunctionExpression:exit": n, ReturnStatement: function(a) {
    i && i.isSetter && a.argument && r(a);
  } };
} };
function AL(e) {
  return e.name === "undefined" && e.references.every(function(t) {
    return !t.isWrite();
  }) && e.defs.every(function(t) {
    return t.node.type === "VariableDeclarator" && t.node.init === null;
  });
}
var _L = { meta: { type: "suggestion", docs: { description: "disallow identifiers from shadowing restricted names", category: "Variables", recommended: !0, url: "https://eslint.org/docs/rules/no-shadow-restricted-names" }, schema: [] }, create: function(e) {
  var t = /* @__PURE__ */ new Set(["undefined", "NaN", "Infinity", "arguments", "eval"]);
  return { "VariableDeclaration, :function, CatchClause": function(n) {
    var r = !0, i = !1, a = void 0;
    try {
      for (var s, o = e.getDeclaredVariables(n)[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
        var u = s.value;
        0 < u.defs.length && t.has(u.name) && !AL(u) && e.report({ node: u.defs[0].name, message: "Shadowing of global property '{{idName}}'.", data: { idName: u.name } });
      }
    } catch (c) {
      i = !0, a = c;
    } finally {
      try {
        r || o.return == null || o.return();
      } finally {
        if (i)
          throw a;
      }
    }
  } };
} }, TL = { meta: { type: "suggestion", docs: { description: "disallow variable declarations from shadowing variables declared in the outer scope", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-shadow" }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: !1 }, hoist: { enum: ["all", "functions", "never"], default: "functions" }, allow: { type: "array", items: { type: "string" } } }, additionalProperties: !1 }] }, create: function(e) {
  function t(u) {
    return o.allow.indexOf(u.name) !== -1;
  }
  function n(u) {
    var c = u.scope.block;
    return c.type === "ClassDeclaration" && c.id === u.identifiers[0];
  }
  function r(u, c) {
    var f = c.scope, p = c.defs[0], d = p && p.parent && p.parent.range, m = u.scope, y = u.defs[0], v = y && y.name.range;
    return d && v && d[0] < v[0] && v[1] < d[1] && (y.type === "FunctionName" && y.node.type === "FunctionExpression" || y.node.type === "ClassExpression") && f === m.upper;
  }
  function i(u) {
    var c = u.defs[0];
    return c && c.name.range;
  }
  function a(u, c) {
    var f = c.defs[0], p = i(u), d = i(c);
    return p && d && p[1] < d[0] && (o.hoist !== "functions" || !f || f.node.type !== "FunctionDeclaration");
  }
  function s(u) {
    for (var c = u.variables, f = 0; f < c.length; ++f) {
      var p = c[f];
      if (p.identifiers.length !== 0 && !n(p) && !t(p)) {
        var d = P.getVariableByName(u.upper, p.name);
        d && (0 < d.identifiers.length || o.builtinGlobals && "writeable" in d) && !r(p, d) && (o.hoist === "all" || !a(p, d)) && e.report({ node: p.identifiers[0], message: "'{{name}}' is already declared in the upper scope.", data: p });
      }
    }
  }
  var o = { builtinGlobals: e.options[0] && e.options[0].builtinGlobals, hoist: e.options[0] && e.options[0].hoist || "functions", allow: e.options[0] && e.options[0].allow || [] };
  return { "Program:exit": function() {
    for (var u = e.getScope().childScopes.slice(); u.length; ) {
      var c = u.pop();
      u.push.apply(u, Mt(c.childScopes)), s(c);
    }
  } };
} }, PL = { meta: { type: "suggestion", docs: { description: "disallow synchronous methods", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-sync" }, schema: [{ type: "object", properties: { allowAtRootLevel: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  return Fn({}, e.options[0] && e.options[0].allowAtRootLevel ? ":function MemberExpression[property.name=/.*Sync$/]" : "MemberExpression[property.name=/.*Sync$/]", function(t) {
    e.report({ node: t, message: "Unexpected sync method: '{{propertyName}}'.", data: { propertyName: t.property.name } });
  });
} }, IL = /\t+/g, BL = /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, OL = { meta: { type: "layout", docs: { description: "disallow all tabs", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-tabs" }, schema: [{ type: "object", properties: { allowIndentationTabs: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  var t = e.getSourceCode(), n = e.options && e.options[0] && e.options[0].allowIndentationTabs;
  return { Program: function(r) {
    t.getLines().forEach(function(i, a) {
      for (var s; (s = IL.exec(i)) !== null; )
        (!n || BL.test(i.slice(0, s.index))) && e.report({ node: r, loc: { start: { line: a + 1, column: s.index }, end: { line: a + 1, column: s.index + s[0].length } }, message: "Unexpected tab character." });
    });
  } };
} }, LL = { meta: { type: "problem", docs: { description: "disallow `this`/`super` before calling `super()` in constructors", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/no-this-before-super" }, schema: [] }, create: function(e) {
  function t(o) {
    return !o.reachable || s[o.id].superCalled;
  }
  function n() {
    return !!(a && a.isConstructor && a.hasExtends);
  }
  function r() {
    return n() && !a.codePath.currentSegments.every(t);
  }
  function i(o) {
    for (var u = a.codePath.currentSegments, c = 0; c < u.length; ++c) {
      var f = u[c];
      f.reachable && s[f.id].invalidNodes.push(o);
    }
  }
  var a = null, s = /* @__PURE__ */ Object.create(null);
  return { onCodePathStart: function(o, u) {
    if (function(f) {
      return f.type === "FunctionExpression" && f.parent.type === "MethodDefinition" && f.parent.kind === "constructor";
    }(u)) {
      var c = u.parent.parent.parent;
      a = { upper: a, isConstructor: !0, hasExtends: !(!c.superClass || P.isNullOrUndefined(c.superClass)), codePath: o };
    } else
      a = { upper: a, isConstructor: !1, hasExtends: !1, codePath: o };
  }, onCodePathEnd: function(o) {
    var u = a.hasExtends;
    a = a.upper, u && o.traverseSegments(function(c, f) {
      for (var p = s[c.id], d = 0; d < p.invalidNodes.length; ++d) {
        var m = p.invalidNodes[d];
        e.report({ message: "'{{kind}}' is not allowed before 'super()'.", node: m, data: { kind: m.type === "Super" ? "super" : "this" } });
      }
      p.superCalled && f.skip();
    });
  }, onCodePathSegmentStart: function(o) {
    n() && (s[o.id] = { superCalled: 0 < o.prevSegments.length && o.prevSegments.every(t), invalidNodes: [] });
  }, onCodePathSegmentLoop: function(o, u) {
    n() && a.codePath.traverseSegments({ first: u, last: o }, function(c, f) {
      var p = s[c.id];
      p.superCalled ? (p.invalidNodes = [], f.skip()) : 0 < c.prevSegments.length && c.prevSegments.every(t) && (p.superCalled = !0, p.invalidNodes = []);
    });
  }, ThisExpression: function(o) {
    r() && i(o);
  }, Super: function(o) {
    !P.isCallee(o) && r() && i(o);
  }, "CallExpression:exit": function(o) {
    o.callee.type === "Super" && r() && function() {
      for (var u = a.codePath.currentSegments, c = 0; c < u.length; ++c) {
        var f = u[c];
        f.reachable && (s[f.id].superCalled = !0);
      }
    }();
  }, "Program:exit": function() {
    s = /* @__PURE__ */ Object.create(null);
  } };
} }, NL = { meta: { type: "suggestion", docs: { description: "disallow throwing literals as exceptions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-throw-literal" }, schema: [], messages: { object: "Expected an error object to be thrown.", undef: "Do not throw undefined." } }, create: function(e) {
  return { ThrowStatement: function(t) {
    P.couldBeError(t.argument) ? t.argument.type === "Identifier" && t.argument.name === "undefined" && e.report({ node: t, messageId: "undef" }) : e.report({ node: t, messageId: "object" });
  } };
} }, jL = { meta: { type: "layout", docs: { description: "disallow trailing whitespace at the end of lines", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-trailing-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { skipBlankLines: { type: "boolean", default: !1 }, ignoreComments: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o, u, c) {
    e.report({ node: o, loc: u, message: "Trailing spaces not allowed.", fix: function(f) {
      return f.removeRange(c);
    } });
  }
  var n = e.getSourceCode(), r = "[ 	  -​　]", i = e.options[0] || {}, a = i.skipBlankLines || !1, s = i.ignoreComments || !1;
  return { Program: function(o) {
    for (var u = new RegExp("".concat(r, "+$"), "u"), c = new RegExp("^".concat(r, "*$"), "u"), f = n.lines, p = n.getText().match(P.createGlobalLinebreakMatcher()), d = function(D) {
      var I = /* @__PURE__ */ new Set();
      return D.forEach(function(L) {
        for (var V = L.type === "Block" ? L.loc.end.line - 1 : L.loc.end.line, K = L.loc.start.line; K <= V; K++)
          I.add(K);
      }), I;
    }(n.getAllComments()), m = 0, y = [], v = 0, b = f.length; v < b; v++) {
      var x = v + 1, C = p && p[v] ? p[v].length : 1, k = f[v].length + C, F = u.exec(f[v]);
      if (F) {
        var B = { start: { line: x, column: F.index }, end: { line: x, column: k - C } }, O = m + B.start.column, S = m + B.end.column, w = n.getNodeByRangeIndex(O);
        if (w && w.type === "TemplateElement" && O > w.parent.range[0] && S < w.parent.range[1]) {
          m += k;
          continue;
        }
        if (a && c.test(f[v])) {
          m += k;
          continue;
        }
        y = [O, S], s && d.has(x) || t(o, B, y);
      }
      m += k;
    }
  } };
} }, RL = { meta: { type: "suggestion", docs: { description: "disallow initializing variables to `undefined`", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-undef-init" }, schema: [], fixable: "code" }, create: function(e) {
  var t = e.getSourceCode();
  return { VariableDeclarator: function(n) {
    var r = t.getText(n.id), i = n.init && n.init.name, a = e.getScope(), s = P.getVariableByName(a, "undefined"), o = s && 0 < s.defs.length, u = t.getLastToken(n);
    i !== "undefined" || n.parent.kind === "const" || o || e.report({ node: n, message: "It's not necessary to initialize '{{name}}' to undefined.", data: { name: r }, fix: function(c) {
      return n.parent.kind === "var" || n.id.type === "ArrayPattern" || n.id.type === "ObjectPattern" || t.commentsExistBetween(n.id, u) ? null : c.removeRange([n.id.range[1], n.range[1]]);
    } });
  } };
} }, ML = { meta: { type: "problem", docs: { description: "disallow the use of undeclared variables unless mentioned in `/*global */` comments", category: "Variables", recommended: !0, url: "https://eslint.org/docs/rules/no-undef" }, schema: [{ type: "object", properties: { typeof: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { undef: "'{{name}}' is not defined." } }, create: function(e) {
  var t = e.options[0], n = t && t.typeof === !0 || !1;
  return { "Program:exit": function() {
    e.getScope().through.forEach(function(r) {
      var i = r.identifier;
      !n && function(a) {
        var s = a.parent;
        return s.type === "UnaryExpression" && s.operator === "typeof";
      }(i) || e.report({ node: i, messageId: "undef", data: i });
    });
  } };
} }, VL = { meta: { type: "suggestion", docs: { description: "disallow the use of `undefined` as an identifier", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-undefined" }, schema: [] }, create: function(e) {
  function t(r) {
    e.report({ node: r, message: "Unexpected use of undefined." });
  }
  function n(r) {
    var i = r.set.get("undefined");
    if (i) {
      var a = i.references, s = i.defs;
      a.filter(function(o) {
        return !o.init;
      }).forEach(function(o) {
        return t(o.identifier);
      }), s.forEach(function(o) {
        return t(o.name);
      });
    }
  }
  return { "Program:exit": function() {
    for (var r = [e.getScope()]; r.length; ) {
      var i = r.pop();
      r.push.apply(r, Mt(i.childScopes)), n(i);
    }
  } };
} }, UL = { meta: { type: "problem", docs: { description: "disallow confusing multiline expressions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-unexpected-multiline" }, schema: [], messages: { function: "Unexpected newline between function and ( of function call.", property: "Unexpected newline between object and [ of property access.", taggedTemplate: "Unexpected newline between template tag and template literal.", division: "Unexpected newline between numerator and division operator." } }, create: function(e) {
  function t(i, a) {
    var s = r.getTokenAfter(i, P.isNotClosingParenToken), o = r.getTokenBefore(s);
    s.loc.start.line !== o.loc.end.line && e.report({ node: i, loc: s.loc.start, messageId: a, data: { char: s.value } });
  }
  var n = /^[gimsuy]+$/, r = e.getSourceCode();
  return { MemberExpression: function(i) {
    i.computed && t(i.object, "property");
  }, TaggedTemplateExpression: function(i) {
    i.tag.loc.end.line === i.quasi.loc.start.line || e.report({ node: i, loc: i.loc.start, messageId: "taggedTemplate" });
  }, CallExpression: function(i) {
    i.arguments.length === 0 || t(i.callee, "function");
  }, "BinaryExpression[operator='/'] > BinaryExpression[operator='/'].left": function(i) {
    var a = r.getTokenAfter(i, function(o) {
      return o.value === "/";
    }), s = r.getTokenAfter(a);
    s.type === "Identifier" && n.test(s.value) && a.range[1] === s.range[0] && t(i.left, "division");
  } };
} }, qL = /(?:(?:Call|Class|Function|Member|New|Yield)Expression|Statement|Declaration)$/, WL = /^(?:DoWhile|For|While)Statement$/, $L = /^(?:BinaryExpression|ConditionalExpression)$/, GL = /^(?:ArrowFunction|Class|Function)Expression$/, zL = /^(?:Call|Member|New|TaggedTemplate|Yield)Expression$/;
function HL(e) {
  if (e.init) {
    var t = e.resolved && e.resolved.defs[0];
    if (!t || t.type !== "Variable" || t.parent.kind !== "var")
      return !1;
  }
  return e.isWrite();
}
function KL(e) {
  return !e.modified;
}
function JL(e) {
  return !(e.modified || e.group);
}
function Zl(e, t) {
  var n = e.range, r = t.identifier.range;
  return n[0] <= r[0] && r[1] <= n[1];
}
var QL = { WhileStatement: Zl, DoWhileStatement: Zl, ForStatement: function(e, t) {
  return Zl(e, t) && !(e.init && Zl(e.init, t));
} };
function XL(e) {
  for (var t = e.identifier; t; ) {
    if (t.type === "FunctionDeclaration")
      return t.id ? t : null;
    t = t.parent;
  }
  return null;
}
var YL = { meta: { type: "problem", docs: { description: "disallow unmodified loop conditions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-unmodified-loop-condition" }, schema: [] }, create: function(e) {
  function t(u) {
    var c = u.reference.identifier;
    e.report({ node: c, message: "'{{name}}' is not modified in this loop.", data: c });
  }
  function n(u) {
    u.every(KL) && u.forEach(t);
  }
  function r(u) {
    var c = !1;
    return ye.Traverser.traverse(u, { visitorKeys: s.visitorKeys, enter: function(f) {
      zL.test(f.type) ? (c = !0, this.break()) : GL.test(f.type) && this.skip();
    } }), c;
  }
  function i(u) {
    if (u.init)
      return null;
    for (var c = null, f = u.identifier, p = f.parent; p; ) {
      if (qL.test(p.type)) {
        if (WL.test(p.type) && p.test === f)
          return { reference: u, group: c, isInLoop: QL[p.type].bind(null, p), modified: !1 };
        break;
      }
      if ($L.test(p.type)) {
        if (r(p))
          break;
        c = p;
      }
      f = p, p = p.parent;
    }
    return null;
  }
  function a(u) {
    var c = u.references.map(i).filter(Boolean);
    if (c.length !== 0) {
      (function(p) {
        for (var d = 0; d < p.length; ++d) {
          var m = p[d];
          if (m.group) {
            var y = o.get(m.group);
            y || (y = [], o.set(m.group, y)), y.push(m);
          }
        }
      })(c);
      var f = u.references.filter(HL);
      0 < f.length && function(p, d) {
        for (var m = 0; m < p.length; ++m)
          for (var y = p[m], v = 0; !y.modified && v < d.length; ++v) {
            var b = d[v], x = void 0, C = void 0, k = y.isInLoop(b) || !!((x = XL(b)) && (C = P.getVariableByName(b.from.upper, x.id.name)) && C.references.some(y.isInLoop));
            y.modified = k;
          }
      }(c, f), c.filter(JL).forEach(t);
    }
  }
  var s = e.getSourceCode(), o = null;
  return { "Program:exit": function() {
    var u, c = [e.getScope()];
    for (o = /* @__PURE__ */ new Map(); u = c.pop(); )
      c.push.apply(c, Mt(u.childScopes)), u.variables.forEach(a);
    o.forEach(n), o = null;
  } };
} }, ZL = /* @__PURE__ */ new Set(["==", "===", "!=", "!==", ">", ">=", "<", "<=", "in", "instanceof"]), O2 = { "==": "!=", "!=": "==", "===": "!==", "!==": "===" }, eN = P.getPrecedence({ type: "LogicalExpression", operator: "||" }), tN = { meta: { type: "suggestion", docs: { description: "disallow ternary operators when simpler alternatives exist", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-unneeded-ternary" }, schema: [{ type: "object", properties: { defaultAssignment: { type: "boolean", default: !0 } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  function t(a) {
    return a.type === "Literal" && typeof a.value == "boolean";
  }
  function n(a) {
    if (a.type === "BinaryExpression" && Object.prototype.hasOwnProperty.call(O2, a.operator)) {
      var s = i.getFirstTokenBetween(a.left, a.right, function(u) {
        return u.value === a.operator;
      }), o = i.getText();
      return o.slice(a.range[0], s.range[0]) + O2[a.operator] + o.slice(s.range[1], a.range[1]);
    }
    return P.getPrecedence(a) < P.getPrecedence({ type: "UnaryExpression" }) ? "!(".concat(P.getParenthesisedText(i, a), ")") : "!".concat(P.getParenthesisedText(i, a));
  }
  var r = (e.options[0] || {}).defaultAssignment !== !1, i = e.getSourceCode();
  return { ConditionalExpression: function(a) {
    t(a.alternate) && t(a.consequent) ? e.report({ node: a, loc: a.consequent.loc.start, message: "Unnecessary use of boolean literals in conditional expression.", fix: function(s) {
      return a.consequent.value === a.alternate.value ? a.test.type === "Identifier" ? s.replaceText(a, a.consequent.value.toString()) : null : a.alternate.value ? s.replaceText(a, n(a.test)) : s.replaceText(a, function(o) {
        return o.type === "BinaryExpression" && ZL.has(o.operator) || o.type === "UnaryExpression" && o.operator === "!";
      }(a.test) ? P.getParenthesisedText(i, a.test) : "!".concat(n(a.test)));
    } }) : !r && function(s) {
      return s.test.type === "Identifier" && s.consequent.type === "Identifier" && s.test.name === s.consequent.name;
    }(a) && e.report({ node: a, loc: a.consequent.loc.start, message: "Unnecessary use of conditional expression for default assignment.", fix: function(s) {
      var o = P.getPrecedence(a.alternate) < eN && !P.isParenthesised(i, a.alternate) ? "(".concat(i.getText(a.alternate), ")") : P.getParenthesisedText(i, a.alternate), u = P.getParenthesisedText(i, a.test);
      return s.replaceText(a, "".concat(u, " || ").concat(o));
    } });
  } };
} };
function nN(e) {
  return !!e.init;
}
function rN(e) {
  return !e.reachable;
}
var iN = function() {
  function e(t) {
    We(this, e), this.sourceCode = t, this.startNode = null, this.endNode = null;
  }
  return Xe(e, [{ key: "contains", value: function(t) {
    return t.range[0] >= this.startNode.range[0] && t.range[1] <= this.endNode.range[1];
  } }, { key: "isConsecutive", value: function(t) {
    return this.contains(this.sourceCode.getTokenBefore(t));
  } }, { key: "merge", value: function(t) {
    this.endNode = t;
  } }, { key: "reset", value: function(t) {
    this.startNode = this.endNode = t;
  } }, { key: "location", get: function() {
    return { start: this.startNode.loc.start, end: this.endNode.loc.end };
  } }, { key: "isEmpty", get: function() {
    return !(this.startNode && this.endNode);
  } }]), e;
}(), aN = { meta: { type: "problem", docs: { description: "disallow unreachable code after `return`, `throw`, `continue`, and `break` statements", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-unreachable" }, schema: [] }, create: function(e) {
  function t(i) {
    var a = null;
    if (i && n.currentSegments.every(rN)) {
      if (r.isEmpty)
        return void r.reset(i);
      if (r.contains(i))
        return;
      if (r.isConsecutive(i))
        return void r.merge(i);
      a = i;
    }
    r.isEmpty || e.report({ message: "Unreachable code.", loc: r.location, node: r.startNode }), r.reset(a);
  }
  var n = null, r = new iN(e.getSourceCode());
  return { onCodePathStart: function(i) {
    n = i;
  }, onCodePathEnd: function() {
    n = n.upper;
  }, BlockStatement: t, BreakStatement: t, ClassDeclaration: t, ContinueStatement: t, DebuggerStatement: t, DoWhileStatement: t, ExpressionStatement: t, ForInStatement: t, ForOfStatement: t, ForStatement: t, IfStatement: t, ImportDeclaration: t, LabeledStatement: t, ReturnStatement: t, SwitchStatement: t, ThrowStatement: t, TryStatement: t, VariableDeclaration: function(i) {
    (i.kind !== "var" || i.declarations.some(nN)) && t(i);
  }, WhileStatement: t, WithStatement: t, ExportNamedDeclaration: t, ExportDefaultDeclaration: t, ExportAllDeclaration: t, "Program:exit": function() {
    t();
  } };
} }, oN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression)$/, sN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement|SwitchStatement)$/, uN = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement)$/, cN = { meta: { type: "problem", docs: { description: "disallow control flow statements in `finally` blocks", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-unsafe-finally" }, schema: [] }, create: function(e) {
  function t(i) {
    return i.parent.type === "TryStatement" && i.parent.finalizer === i;
  }
  function n(i, a) {
    var s, o = !1;
    s = i.type !== "BreakStatement" || i.label ? i.type === "ContinueStatement" ? uN : oN : sN;
    for (var u = i; u && !s.test(u.type); u = u.parent)
      if (u.parent.label && a && u.parent.label.name === a.name && (o = !0), t(u))
        return !(a && o);
    return !1;
  }
  function r(i) {
    n(i, i.label) && e.report({ message: "Unsafe usage of {{nodeType}}.", data: { nodeType: i.type }, node: i, line: i.loc.line, column: i.loc.column });
  }
  return { ReturnStatement: r, ThrowStatement: r, BreakStatement: r, ContinueStatement: r };
} }, lN = { meta: { type: "problem", docs: { description: "disallow negating the left operand of relational operators", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-unsafe-negation" }, schema: [{ type: "object", properties: { enforceForOrderingRelations: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: null, messages: { unexpected: "Unexpected negating the left operand of '{{operator}}' operator." } }, create: function(e) {
  var t = e.getSourceCode(), n = (e.options[0] || {}).enforceForOrderingRelations === !0;
  return { BinaryExpression: function(r) {
    var i = n && function(a) {
      return a === "<" || a === ">" || a === ">=" || a === "<=";
    }(r.operator);
    (function(a) {
      return a === "in" || a === "instanceof";
    }(r.operator) || i) && function(a) {
      return a.type === "UnaryExpression" && a.operator === "!";
    }(r.left) && !P.isParenthesised(t, r.left) && e.report({ node: r, loc: r.left.loc, messageId: "unexpected", data: { operator: r.operator } });
  } };
} }, pN = { meta: { type: "problem", docs: { description: "disallow unused variables", category: "Variables", recommended: !0, url: "https://eslint.org/docs/rules/no-unused-vars" }, schema: [{ oneOf: [{ enum: ["all", "local"] }, { type: "object", properties: { vars: { enum: ["all", "local"] }, varsIgnorePattern: { type: "string" }, args: { enum: ["all", "after-used", "none"] }, ignoreRestSiblings: { type: "boolean" }, argsIgnorePattern: { type: "string" }, caughtErrors: { enum: ["all", "none"] }, caughtErrorsIgnorePattern: { type: "string" } } }] }] }, create: function(e) {
  function t(v) {
    var b, x, C = v.defs && v.defs[0] && v.defs[0].type;
    C === "CatchClause" && d.caughtErrorsIgnorePattern ? (b = "args", x = d.caughtErrorsIgnorePattern.toString()) : C === "Parameter" && d.argsIgnorePattern ? (b = "args", x = d.argsIgnorePattern.toString()) : C !== "Parameter" && d.varsIgnorePattern && (b = "vars", x = d.varsIgnorePattern.toString());
    var k = b ? " Allowed unused ".concat(b, " must match ").concat(x, ".") : "";
    return "'{{name}}' is defined but never used.".concat(k);
  }
  function n() {
    var v = d.varsIgnorePattern ? " Allowed unused vars must match ".concat(d.varsIgnorePattern.toString(), ".") : "";
    return "'{{name}}' is assigned a value but never used.".concat(v);
  }
  function r(v) {
    var b = v.defs[0];
    if (b) {
      var x = b.node;
      if (x.type === "VariableDeclarator")
        x = x.parent;
      else if (b.type === "Parameter")
        return !1;
      return x.parent.type.indexOf("Export") === 0;
    }
    return !1;
  }
  function i(v) {
    return !!d.ignoreRestSiblings && v.defs.some(function(b) {
      var x = b.name.parent, C = x.parent;
      return x.type === "Property" && C.type === "ObjectPattern" && p.test(C.properties[C.properties.length - 1].type);
    });
  }
  function a(v, b) {
    return v.range[0] >= b.range[0] && v.range[1] <= b.range[1];
  }
  function s(v, b) {
    var x = P.getUpperFunction(v);
    return x && a(x, b) && function(C, k) {
      for (var F = C, B = C.parent; B && a(B, k); ) {
        switch (B.type) {
          case "SequenceExpression":
            if (B.expressions[B.expressions.length - 1] !== F)
              return !1;
            break;
          case "CallExpression":
          case "NewExpression":
            return B.callee !== F;
          case "AssignmentExpression":
          case "TaggedTemplateExpression":
          case "YieldExpression":
            return !0;
          default:
            if (y.test(B.type))
              return !0;
        }
        F = B, B = B.parent;
      }
      return !1;
    }(x, b);
  }
  function o(v) {
    var b = function(k) {
      var F = [];
      return k.defs.forEach(function(B) {
        var O = B.type, S = B.node;
        O === "FunctionName" && F.push(S), O === "Variable" && S.init && (S.init.type === "FunctionExpression" || S.init.type === "ArrowFunctionExpression") && F.push(S.init);
      }), F;
    }(v), x = 0 < b.length, C = null;
    return v.references.some(function(k) {
      if (function(B) {
        var O = B.identifier.parent;
        return O.type === "VariableDeclarator" && (O = O.parent.parent), O.type === "ForInStatement" && !!(O = O.body.type === "BlockStatement" ? O.body.body[0] : O.body) && O.type === "ReturnStatement";
      }(k))
        return !0;
      var F = function(B, O) {
        var S = B.identifier, w = S.parent, D = w.parent;
        return B.isRead() && (w.type === "AssignmentExpression" && D.type === "ExpressionStatement" && w.left === S || w.type === "UpdateExpression" && D.type === "ExpressionStatement" || O && a(S, O) && !s(S, O));
      }(k, C);
      return C = function(B, O) {
        var S = B.identifier, w = S.parent, D = w.parent, I = B.from.variableScope !== B.resolved.scope.variableScope || P.isInLoop(S);
        return O && a(S, O) ? O : w.type !== "AssignmentExpression" || D.type !== "ExpressionStatement" || S !== w.left || I ? null : w.right;
      }(k, C), function(B) {
        return B.isRead();
      }(k) && !F && !(x && function(B, O) {
        for (var S = B.from; S; ) {
          if (0 <= O.indexOf(S.block))
            return !0;
          S = S.upper;
        }
        return !1;
      }(k, b));
    });
  }
  function u(v) {
    var b = v.defs[0], x = e.getDeclaredVariables(b.node);
    return !x.slice(x.indexOf(v) + 1).some(function(C) {
      return 0 < C.references.length || C.eslintUsed;
    });
  }
  function c(v, b) {
    var x, C, k = v.variables, F = v.childScopes;
    if (v.type !== "global" || d.vars === "all")
      for (x = 0, C = k.length; x < C; ++x) {
        var B = k[x];
        if ((v.type !== "class" || v.block.id !== B.identifiers[0]) && !(v.functionExpressionScope || B.eslintUsed || v.type === "function" && B.name === "arguments" && B.identifiers.length === 0)) {
          var O = B.defs[0];
          if (O) {
            var S = O.type;
            if (S === "CatchClause" && (d.caughtErrors === "none" || d.caughtErrorsIgnorePattern && d.caughtErrorsIgnorePattern.test(O.name.name)))
              continue;
            if (S === "Parameter") {
              if ((O.node.parent.type === "Property" || O.node.parent.type === "MethodDefinition") && O.node.parent.kind === "set" || d.args === "none" || d.argsIgnorePattern && d.argsIgnorePattern.test(O.name.name) || d.args === "after-used" && P.isFunction(O.name.parent) && !u(B))
                continue;
            } else if (d.varsIgnorePattern && d.varsIgnorePattern.test(O.name.name))
              continue;
          }
          o(B) || r(B) || i(B) || b.push(B);
        }
      }
    for (x = 0, C = F.length; x < C; ++x)
      c(F[x], b);
    return b;
  }
  var f = e.getSourceCode(), p = /^(?:RestElement|(?:Experimental)?RestProperty)$/, d = { vars: "all", args: "after-used", ignoreRestSiblings: !1, caughtErrors: "none" }, m = e.options[0];
  m && (typeof m == "string" ? d.vars = m : (d.vars = m.vars || d.vars, d.args = m.args || d.args, d.ignoreRestSiblings = m.ignoreRestSiblings || d.ignoreRestSiblings, d.caughtErrors = m.caughtErrors || d.caughtErrors, m.varsIgnorePattern && (d.varsIgnorePattern = new RegExp(m.varsIgnorePattern, "u")), m.argsIgnorePattern && (d.argsIgnorePattern = new RegExp(m.argsIgnorePattern, "u")), m.caughtErrorsIgnorePattern && (d.caughtErrorsIgnorePattern = new RegExp(m.caughtErrorsIgnorePattern, "u"))));
  var y = /(?:Statement|Declaration)$/;
  return { "Program:exit": function(v) {
    for (var b = c(e.getScope(), []), x = 0, C = b.length; x < C; ++x) {
      var k = b[x];
      if (0 < k.defs.length)
        e.report({ node: k.identifiers[0], message: k.references.some(function(B) {
          return B.isWrite();
        }) ? n() : t(k), data: k });
      else if (k.eslintExplicitGlobalComments) {
        var F = k.eslintExplicitGlobalComments[0];
        e.report({ node: v, loc: P.getNameLocationInGlobalDirectiveComment(f, F, k.name), message: t(k), data: k });
      }
    }
  } };
} }, fN = /^(?:(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|CatchClause|ImportDeclaration|ExportNamedDeclaration)$/, hN = /^For(?:In|Of)Statement$/;
function nm(e, t) {
  return e && e.range[0] <= t && t <= e.range[1];
}
var dN = { meta: { type: "problem", docs: { description: "disallow the use of variables before they are defined", category: "Variables", recommended: !1, url: "https://eslint.org/docs/rules/no-use-before-define" }, schema: [{ oneOf: [{ enum: ["nofunc"] }, { type: "object", properties: { functions: { type: "boolean" }, classes: { type: "boolean" }, variables: { type: "boolean" } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(i, a) {
    return function(s) {
      return s.defs[0].type === "FunctionName";
    }(i) ? r.functions : function(s, o) {
      return s.defs[0].type === "ClassName" && s.scope.variableScope !== o.from.variableScope;
    }(i, a) ? r.classes : !function(s, o) {
      return s.defs[0].type === "Variable" && s.scope.variableScope !== o.from.variableScope;
    }(i, a) || r.variables;
  }
  function n(i) {
    i.references.forEach(function(a) {
      var s = a.resolved;
      !a.init && s && s.identifiers.length !== 0 && (!(s.identifiers[0].range[1] < a.identifier.range[1]) || function(o, u) {
        if (o.scope !== u.from)
          return !1;
        for (var c = o.identifiers[0].parent, f = u.identifier.range[1]; c; ) {
          if (c.type === "VariableDeclarator") {
            if (nm(c.init, f) || hN.test(c.parent.parent.type) && nm(c.parent.parent.right, f))
              return !0;
            break;
          }
          if (c.type === "AssignmentPattern") {
            if (nm(c.right, f))
              return !0;
          } else if (fN.test(c.type))
            break;
          c = c.parent;
        }
        return !1;
      }(s, a)) && t(s, a) && e.report({ node: a.identifier, message: "'{{name}}' was used before it was defined.", data: a.identifier });
    }), i.childScopes.forEach(n);
  }
  var r = function(i) {
    var a = !0, s = !0, o = !0;
    return typeof i == "string" ? a = i != "nofunc" : xe(i) == "object" && i !== null && (a = i.functions !== !1, s = i.classes !== !1, o = i.variables !== !1), { functions: a, classes: s, variables: o };
  }(e.options[0]);
  return { Program: function() {
    n(e.getScope());
  } };
} }, mN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.call()` and `.apply()`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-call" }, schema: [] }, create: function(e) {
  var t = e.getSourceCode();
  return { CallExpression: function(n) {
    if (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.property.type === "Identifier" && i.callee.computed === !1 && (i.callee.property.name === "call" && 1 <= i.arguments.length || i.callee.property.name === "apply" && i.arguments.length === 2 && i.arguments[1].type === "ArrayExpression");
    }(n)) {
      var r = n.callee.object;
      (function(i, a, s) {
        return i ? P.equalTokens(i, a, s) : P.isNullOrUndefined(a);
      })(r.type === "MemberExpression" ? r.object : null, n.arguments[0], t) && e.report({ node: n, message: "unnecessary '.{{name}}()'.", data: { name: n.callee.property.name } });
    }
  } };
} }, gN = "Unnecessarily computed property [{{property}}] found.", yN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary computed property keys in objects and classes", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-computed-key" }, schema: [{ type: "object", properties: { enforceForClassMembers: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  function t(r) {
    if (r.computed) {
      var i, a = r.key, s = xe(a.value);
      i = r.type === "MethodDefinition" ? r.static ? "prototype" : "constructor" : "__proto__", a.type === "Literal" && (s === "string" || s === "number") && a.value !== i && e.report({ node: r, message: gN, data: { property: n.getText(a) }, fix: function(o) {
        var u = n.getFirstToken(r, P.isOpeningBracketToken), c = n.getFirstTokenBetween(r.key, r.value, P.isClosingBracketToken), f = n.getTokensBetween(u, c, 1);
        if (f.slice(0, -1).some(function(m, y) {
          return n.getText().slice(m.range[1], f[y + 1].range[0]).trim();
        }))
          return null;
        var p = n.getTokenBefore(u), d = (p.range[1] === u.range[0] && !P.canTokensBeAdjacent(p, n.getFirstToken(a)) ? " " : "") + a.raw;
        return o.replaceTextRange([u.range[0], c.range[1]], d);
      } });
    }
  }
  var n = e.getSourceCode();
  return { Property: t, MethodDefinition: e.options[0] && e.options[0].enforceForClassMembers ? t : ye.lodash.noop };
} };
function L2(e) {
  return e.type === "BinaryExpression" && e.operator === "+";
}
function vN(e) {
  return e.value === "+" && e.type === "Punctuator";
}
var xN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary concatenation of literals or template literals", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-concat" }, schema: [] }, create: function(e) {
  var t = e.getSourceCode();
  return { BinaryExpression: function(n) {
    if (n.operator === "+") {
      var r = function(s) {
        for (var o = s.left; L2(o); )
          o = o.right;
        return o;
      }(n), i = function(s) {
        for (var o = s.right; L2(o); )
          o = o.left;
        return o;
      }(n);
      if (P.isStringLiteral(r) && P.isStringLiteral(i) && P.isTokenOnSameLine(r, i)) {
        var a = t.getFirstTokenBetween(r, i, vN);
        e.report({ node: n, loc: a.loc.start, message: "Unexpected string concatenation of literals." });
      }
    }
  } };
} };
function bN(e) {
  return e.type === "Identifier" || e.type === "RestElement";
}
function N2(e, t) {
  return e.type === "Identifier" && t.type === "Identifier" && e.name === t.name;
}
function EN(e, t) {
  return N2(e, t) || function(n, r) {
    return n.type === "RestElement" && r.type === "SpreadElement" && N2(n.argument, r.argument);
  }(e, t);
}
function CN(e, t) {
  return function(n) {
    return n.length === 1 && n[0].type === "ExpressionStatement" && n[0].expression.type === "CallExpression" && n[0].expression.callee.type === "Super";
  }(e) && t.every(bN) && (function(n) {
    return n.length === 1 && n[0].type === "SpreadElement" && n[0].argument.type === "Identifier" && n[0].argument.name === "arguments";
  }(e[0].expression.arguments) || function(n, r) {
    if (n.length !== r.length)
      return !1;
    for (var i = 0; i < n.length; ++i)
      if (!EN(n[i], r[i]))
        return !1;
    return !0;
  }(t, e[0].expression.arguments));
}
var SN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary constructors", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-constructor" }, schema: [] }, create: function(e) {
  return { MethodDefinition: function(t) {
    if (t.kind === "constructor") {
      var n = t.value.body.body, r = t.value.params;
      (t.parent.parent.superClass ? CN(n, r) : n.length === 0) && e.report({ node: t, message: "Useless constructor." });
    }
  } };
} };
function jA(e, t) {
  return new Set(regeneratorRuntime.mark(function n() {
    return regeneratorRuntime.wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.delegateYield(e, "t0", 1);
          case 1:
            return r.delegateYield(t, "t1", 2);
          case 2:
          case "end":
            return r.stop();
        }
    }, n);
  })());
}
var kN = jA(new Set("\\nrvtbfux"), P.LINEBREAKS), RA = new Set("\\bcdDfnpPrsStvwWxu0123456789]"), DN = jA(RA, new Set("^/.$*+?[{}|()Bk")), FN = { meta: { type: "suggestion", docs: { description: "disallow unnecessary escape characters", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-useless-escape", suggestion: !0 }, messages: { unnecessaryEscape: "Unnecessary escape character: \\{{character}}.", removeEscape: "Remove the `\\`. This maintains the current functionality.", escapeBackslash: "Replace the `\\` with `\\\\` to include the actual backslash character." }, schema: [] }, create: function(e) {
  function t(a, s, o) {
    var u = i.getLocFromIndex(i.getIndexFromLoc(a.loc.start) + s), c = i.getIndexFromLoc(a.loc.start) + s, f = [c, c + 1];
    e.report({ node: a, loc: { start: u, end: { line: u.line, column: u.column + 1 } }, messageId: "unnecessaryEscape", data: { character: o }, suggest: [{ messageId: "removeEscape", fix: function(p) {
      return p.removeRange(f);
    } }, { messageId: "escapeBackslash", fix: function(p) {
      return p.insertTextBeforeRange(f, "\\");
    } }] });
  }
  function n(a, s) {
    var o, u = a.type === "TemplateElement", c = s[0][1], f = !kN.has(c);
    u ? (o = c === "`", c === "$" ? f = s.input[s.index + 2] !== "{" : c === "{" && (f = s.input[s.index - 1] !== "$")) : o = c === a.raw[0], f && !o && t(a, s.index + 1, s[0].slice(1));
  }
  function r(a) {
    var s = a.type === "TemplateElement";
    if (!(s && a.parent && a.parent.parent && a.parent.parent.type === "TaggedTemplateExpression" && a.parent === a.parent.parent.quasi))
      if (typeof a.value == "string" || s) {
        if (a.parent.type === "JSXAttribute" || a.parent.type === "JSXElement" || a.parent.type === "JSXFragment")
          return;
        for (var o, u = s ? a.value.raw : a.raw.slice(1, -1), c = /\\(?:[\0-\/:-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g; o = c.exec(u); )
          n(a, o);
      } else
        a.regex && function(f) {
          var p = [];
          return f.split("").reduce(function(d, m, y) {
            if (!d.escapeNextChar) {
              if (m === "\\")
                return Object.assign(d, { escapeNextChar: !0 });
              if (m === "[" && !d.inCharClass)
                return Object.assign(d, { inCharClass: !0, startingCharClass: !0 });
              if (m === "]" && d.inCharClass)
                return p.length && p[p.length - 1].inCharClass && (p[p.length - 1].endsCharClass = !0), Object.assign(d, { inCharClass: !1, startingCharClass: !1 });
            }
            return p.push({ text: m, index: y, escaped: d.escapeNextChar, inCharClass: d.inCharClass, startsCharClass: d.startingCharClass, endsCharClass: !1 }), Object.assign(d, { escapeNextChar: !1, startingCharClass: !1 });
          }, { escapeNextChar: !1, inCharClass: !1, startingCharClass: !1 }), p;
        }(a.regex.pattern).filter(function(f) {
          return f.text !== "-" || !f.inCharClass || f.startsCharClass || f.endsCharClass;
        }).filter(function(f) {
          return !(f.text === "^" && f.startsCharClass);
        }).filter(function(f) {
          return f.escaped;
        }).filter(function(f) {
          return !(f.inCharClass ? RA : DN).has(f.text);
        }).forEach(function(f) {
          return t(a, f.index, f.text);
        });
  }
  var i = e.getSourceCode();
  return { Literal: r, TemplateElement: r };
} }, wN = { meta: { type: "suggestion", docs: { description: "disallow renaming import, export, and destructured assignments to the same name", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-rename" }, fixable: "code", schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: !1 }, ignoreImport: { type: "boolean", default: !1 }, ignoreExport: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o, u, c, f) {
    var p = u.type === "Identifier" ? u.name : u.value;
    return e.report({ node: o, message: "{{type}} {{name}} unnecessarily renamed.", data: { name: p, type: f }, fix: function(d) {
      if (n.commentsExistBetween(u, c))
        return null;
      var m = c.type === "AssignmentPattern" ? n.getText(c) : p;
      return d.replaceTextRange([u.range[0], c.range[1]], m);
    } });
  }
  var n = e.getSourceCode(), r = e.options[0] || {}, i = r.ignoreDestructuring === !0, a = r.ignoreImport === !0, s = r.ignoreExport === !0;
  return { ObjectPattern: function(o) {
    if (!i) {
      var u = !0, c = !1, f = void 0;
      try {
        for (var p, d = o.properties[Symbol.iterator](); !(u = (p = d.next()).done); u = !0) {
          var m = p.value;
          m.type !== "ExperimentalRestProperty" && !m.shorthand && m.type !== "RestElement" && !m.computed && (m.key.type === "Identifier" && m.key.name || m.key.type === "Literal" && m.key.value) === (m.value.type === "AssignmentPattern" ? m.value.left.name : m.value.name) && t(m, m.key, m.value, "Destructuring assignment");
        }
      } catch (y) {
        c = !0, f = y;
      } finally {
        try {
          u || d.return == null || d.return();
        } finally {
          if (c)
            throw f;
        }
      }
    }
  }, ImportSpecifier: function(o) {
    a || o.imported.name === o.local.name && o.imported.range[0] !== o.local.range[0] && t(o, o.imported, o.local, "Import");
  }, ExportSpecifier: function(o) {
    s || o.local.name === o.exported.name && o.local.range[0] !== o.exported.range[0] && t(o, o.local, o.exported, "Export");
  } };
} };
function AN(e, t) {
  var n = e.indexOf(t);
  n !== -1 && e.splice(n, 1);
}
var _N = { meta: { type: "suggestion", docs: { description: "disallow redundant return statements", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-useless-return" }, fixable: "code", schema: [] }, create: function(e) {
  function t(c) {
    var f = a.get(c);
    return !f || f.returned;
  }
  function n(c, f, p) {
    var d = p || /* @__PURE__ */ new WeakSet(), m = !0, y = !1, v = void 0;
    try {
      for (var b, x = f[Symbol.iterator](); !(m = (b = x.next()).done); m = !0) {
        var C = b.value;
        C.reachable ? c.push.apply(c, Mt(a.get(C).uselessReturns)) : d.has(C) || (d.add(C), n(c, C.allPrevSegments.filter(t), d));
      }
    } catch (k) {
      y = !0, v = k;
    } finally {
      try {
        m || x.return == null || x.return();
      } finally {
        if (y)
          throw v;
      }
    }
    return c;
  }
  function r(c) {
    if (!c.reachable)
      return s.add(c), void c.allPrevSegments.filter(t).filter(function(x) {
        return !s.has(x);
      }).forEach(r);
    var f = a.get(c), p = !0, d = !1, m = void 0;
    try {
      for (var y, v = f.uselessReturns[Symbol.iterator](); !(p = (y = v.next()).done); p = !0) {
        var b = y.value;
        AN(u.uselessReturns, b);
      }
    } catch (x) {
      d = !0, m = x;
    } finally {
      try {
        p || v.return == null || v.return();
      } finally {
        if (d)
          throw m;
      }
    }
    f.uselessReturns = [];
  }
  function i() {
    u.codePath.currentSegments.forEach(r);
  }
  var a = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakSet(), o = e.getSourceCode(), u = null;
  return { onCodePathStart: function(c) {
    u = { upper: u, uselessReturns: [], codePath: c };
  }, onCodePathEnd: function() {
    var c = !0, f = !1, p = void 0;
    try {
      for (var d, m = function() {
        var v = d.value;
        e.report({ node: v, loc: v.loc, message: "Unnecessary return statement.", fix: function(b) {
          return function(x) {
            return P.STATEMENT_LIST_PARENTS.has(x.parent.type);
          }(v) && !o.getCommentsInside(v).length ? new bf(b, o).retainEnclosingFunction(v).remove(v) : null;
        } });
      }, y = u.uselessReturns[Symbol.iterator](); !(c = (d = y.next()).done); c = !0)
        m();
    } catch (v) {
      f = !0, p = v;
    } finally {
      try {
        c || y.return == null || y.return();
      } finally {
        if (f)
          throw p;
      }
    }
    u = u.upper;
  }, onCodePathSegmentStart: function(c) {
    var f = { uselessReturns: n([], c.allPrevSegments), returned: !1 };
    a.set(c, f);
  }, ReturnStatement: function(c) {
    if (c.argument && i(), !(c.argument || P.isInLoop(c) || function(x) {
      for (var C = x; C && C.parent && !P.isFunction(C); C = C.parent)
        if (C.parent.type === "TryStatement" && C.parent.finalizer === C)
          return !0;
      return !1;
    }(c)) && u.codePath.currentSegments.some(function(x) {
      return x.reachable;
    })) {
      var f = !0, p = !1, d = void 0;
      try {
        for (var m, y = u.codePath.currentSegments[Symbol.iterator](); !(f = (m = y.next()).done); f = !0) {
          var v = m.value, b = a.get(v);
          b && (b.uselessReturns.push(c), b.returned = !0);
        }
      } catch (x) {
        p = !0, d = x;
      } finally {
        try {
          f || y.return == null || y.return();
        } finally {
          if (p)
            throw d;
        }
      }
      u.uselessReturns.push(c);
    }
  }, ClassDeclaration: i, ContinueStatement: i, DebuggerStatement: i, DoWhileStatement: i, EmptyStatement: i, ExpressionStatement: i, ForInStatement: i, ForOfStatement: i, ForStatement: i, IfStatement: i, ImportDeclaration: i, LabeledStatement: i, SwitchStatement: i, ThrowStatement: i, TryStatement: i, VariableDeclaration: i, WhileStatement: i, WithStatement: i, ExportNamedDeclaration: i, ExportDefaultDeclaration: i, ExportAllDeclaration: i };
} };
function TN(e) {
  return !!e.scope && e.scope.type === "global";
}
function j2(e) {
  for (var t = e; t.type !== "function" && t.type !== "global"; )
    t = t.upper;
  return t;
}
function PN(e) {
  var t = j2(e.scope);
  return e.references.some(function(n) {
    return j2(n.from) !== t;
  });
}
function R2(e) {
  return (e.parent.type === "ForOfStatement" || e.parent.type === "ForInStatement") && e === e.parent.left;
}
var IN = /^(?:Program|BlockStatement|SwitchStatement|ForStatement|ForInStatement|ForOfStatement)$/;
function BN(e) {
  return 2 <= e.defs.length;
}
function ON(e) {
  return e.name === "let";
}
var LN = { meta: { type: "suggestion", docs: { description: "require `let` or `const` instead of `var`", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/no-var" }, schema: [], fixable: "code" }, create: function(e) {
  function t(a) {
    return !!a.init && e.getDeclaredVariables(a).some(function(s) {
      var o = s.range[0], u = s.range[1];
      return function(c) {
        var f = c.defs[0].name, p = f.range[0], d = f.parent.type === "AssignmentPattern" ? f.parent.right : null, m = d && d.range[0], y = d && d.range[1];
        return c.references.some(function(v) {
          var b = v.identifier.range[0], x = v.identifier.range[1];
          return !v.init && (b < p || d !== null && b >= m && x <= y || b >= o && x <= u);
        });
      };
    }(a.init));
  }
  function n(a) {
    var s = e.getDeclaredVariables(a), o = function(u) {
      for (var c = u; c; c = c.parent)
        if (IN.test(c.type))
          return c;
      return null;
    }(a);
    return a.parent.type === "SwitchCase" || a.declarations.some(t) || s.some(TN) || s.some(BN) || s.some(function(u) {
      function c(f) {
        var p = u.range, d = f.identifier.range;
        return d[0] < p[0] || d[1] > p[1];
      }
      return function(f) {
        return f.references.some(c);
      };
    }(o)) || s.some(ON) || P.isInLoop(a) && (s.some(PN) || !R2(a) && !function(u) {
      return u.declarations.every(function(c) {
        return c.init !== null;
      });
    }(a)) ? !1 : !!(R2(a) || a.parent.type === "ForStatement" && a.parent.init === a || P.STATEMENT_LIST_PARENTS.has(a.parent.type));
  }
  function r(a) {
    e.report({ node: a, message: "Unexpected var, use let or const instead.", fix: function(s) {
      var o = i.getFirstToken(a, { filter: function(u) {
        return u.value === "var";
      } });
      return n(a) ? s.replaceText(o, "let") : null;
    } });
  }
  var i = e.getSourceCode();
  return { "VariableDeclaration:exit": function(a) {
    a.kind === "var" && r(a);
  } };
} }, NN = ye.lodash.escapeRegExp, jN = { meta: { type: "suggestion", docs: { description: "disallow specified warning terms in comments", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-warning-comments" }, schema: [{ type: "object", properties: { terms: { type: "array", items: { type: "string" } }, location: { enum: ["start", "anywhere"] } }, additionalProperties: !1 }] }, create: function(e) {
  function t(u) {
    P.isDirectiveComment(u) && s.test(u.value) || function(c) {
      var f = [];
      return o.forEach(function(p, d) {
        p.test(c) && f.push(i[d]);
      }), f;
    }(u.value).forEach(function(c) {
      e.report({ node: u, message: "Unexpected '{{matchedTerm}}' comment.", data: { matchedTerm: c } });
    });
  }
  var n = e.getSourceCode(), r = e.options[0] || {}, i = r.terms || ["todo", "fixme", "xxx"], a = r.location || "start", s = /\bno\x2Dwarning\x2Dcomments\b/, o = i.map(function(u) {
    var c, f = NN(u), p = "\\b", d = /[0-9A-Z_a-z]$/.test(u) ? "\\b" : "";
    return c = a === "start" ? "^\\s*" : /^[0-9A-Z_a-z]/.test(u) ? p : "", a === "start" ? new RegExp(c + f + d, "iu") : new RegExp(c + f + d + "|".concat(p) + u + p, "iu");
  });
  return { Program: function() {
    n.getAllComments().filter(function(u) {
      return u.type !== "Shebang";
    }).forEach(t);
  } };
} }, RN = { meta: { type: "layout", docs: { description: "disallow whitespace before properties", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-whitespace-before-property" }, fixable: "whitespace", schema: [] }, create: function(e) {
  function t(r, i, a) {
    var s = r.computed ? "" : ".";
    e.report({ node: r, message: "Unexpected whitespace before property {{propName}}.", data: { propName: n.getText(r.property) }, fix: function(o) {
      return !r.computed && P.isDecimalInteger(r.object) ? null : o.replaceTextRange([i.range[1], a.range[0]], s);
    } });
  }
  var n = e.getSourceCode();
  return { MemberExpression: function(r) {
    var i, a;
    P.isTokenOnSameLine(r.object, r.property) && (r.computed ? (i = n.getTokenBefore(r.property, P.isOpeningBracketToken), a = n.getTokenBefore(i)) : (i = n.getFirstToken(r.property), a = n.getTokenBefore(i, 1)), n.isSpaceBetweenTokens(a, i) && t(r, a, i));
  } };
} }, hs = { enum: ["beside", "below", "any"] }, MN = { meta: { type: "layout", docs: { description: "enforce the location of single-line statements", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/nonblock-statement-body-position" }, fixable: "whitespace", schema: [hs, { properties: { overrides: { properties: { if: hs, else: hs, while: hs, do: hs, for: hs }, additionalProperties: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(r, i) {
    var a = function(o) {
      return e.options[1] && e.options[1].overrides && e.options[1].overrides[o] || e.options[0] || "beside";
    }(i);
    if (r.type !== "BlockStatement" && a !== "any") {
      var s = n.getTokenBefore(r);
      s.loc.end.line === r.loc.start.line && a === "below" ? e.report({ node: r, message: "Expected a linebreak before this statement.", fix: function(o) {
        return o.insertTextBefore(r, `
`);
      } }) : s.loc.end.line !== r.loc.start.line && a === "beside" && e.report({ node: r, message: "Expected no linebreak before this statement.", fix: function(o) {
        return n.getText().slice(s.range[1], r.range[0]).trim() ? null : o.replaceTextRange([s.range[1], r.range[0]], " ");
      } });
    }
  }
  var n = e.getSourceCode();
  return { IfStatement: function(r) {
    t(r.consequent, "if"), r.alternate && r.alternate.type !== "IfStatement" && t(r.alternate, "else");
  }, WhileStatement: function(r) {
    return t(r.body, "while");
  }, DoWhileStatement: function(r) {
    return t(r.body, "do");
  }, ForStatement: function(r) {
    return t(r.body, "for");
  }, ForInStatement: function(r) {
    return t(r.body, "for");
  }, ForOfStatement: function(r) {
    return t(r.body, "for");
  } };
} }, Bu = { oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { multiline: { type: "boolean" }, minProperties: { type: "integer", minimum: 0 }, consistent: { type: "boolean" } }, additionalProperties: !1, minProperties: 1 }] };
function Ou(e) {
  var t = Number.POSITIVE_INFINITY, n = !1, r = t, i = !1;
  return e ? e === "always" ? r = 0 : e === "never" ? r = t : (n = !!e.multiline, r = e.minProperties || t, i = !!e.consistent) : i = !0, { multiline: n, minProperties: r, consistent: i };
}
var VN = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside braces", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/object-curly-newline" }, fixable: "whitespace", schema: [{ oneOf: [Bu, { type: "object", properties: { ObjectExpression: Bu, ObjectPattern: Bu, ImportDeclaration: Bu, ExportDeclaration: Bu }, additionalProperties: !1, minProperties: 1 }] }] }, create: function(e) {
  function t(i) {
    var a = r[i.type];
    if ((i.type !== "ImportDeclaration" || i.specifiers.some(function(b) {
      return b.type === "ImportSpecifier";
    })) && (i.type !== "ExportNamedDeclaration" || i.specifiers.some(function(b) {
      return b.type === "ExportSpecifier";
    }))) {
      var s = n.getFirstToken(i, function(b) {
        return b.value === "{";
      }), o = i.typeAnnotation ? n.getTokenBefore(i.typeAnnotation) : n.getLastToken(i, function(b) {
        return b.value === "}";
      }), u = n.getTokenAfter(s, { includeComments: !0 }), c = n.getTokenBefore(o, { includeComments: !0 }), f = function(b, x, C, k) {
        var F;
        return (F = b.type === "ObjectExpression" || b.type === "ObjectPattern" ? b.properties : b.specifiers.filter(function(B) {
          return B.type === "ImportSpecifier" || B.type === "ExportSpecifier";
        })).length >= x.minProperties || x.multiline && 0 < F.length && C.loc.start.line !== k.loc.end.line;
      }(i, a, u, c), p = P.isCommentToken(u), d = P.isCommentToken(c);
      if (u = n.getTokenAfter(s), c = n.getTokenBefore(o), f)
        P.isTokenOnSameLine(s, u) && e.report({ message: "Expected a line break after this opening brace.", node: i, loc: s.loc.start, fix: function(b) {
          return p ? null : b.insertTextAfter(s, `
`);
        } }), P.isTokenOnSameLine(c, o) && e.report({ message: "Expected a line break before this closing brace.", node: i, loc: o.loc.start, fix: function(b) {
          return d ? null : b.insertTextBefore(o, `
`);
        } });
      else {
        var m = a.consistent, y = !P.isTokenOnSameLine(s, u), v = !P.isTokenOnSameLine(c, o);
        (!m && y || m && y && !v) && e.report({ message: "Unexpected line break after this opening brace.", node: i, loc: s.loc.start, fix: function(b) {
          return p ? null : b.removeRange([s.range[1], u.range[0]]);
        } }), (!m && v || m && !y && v) && e.report({ message: "Unexpected line break before this closing brace.", node: i, loc: o.loc.start, fix: function(b) {
          return d ? null : b.removeRange([c.range[1], o.range[0]]);
        } });
      }
    }
  }
  var n = e.getSourceCode(), r = function(i) {
    var a = ye.lodash.overSome([ye.lodash.isPlainObject, ye.lodash.isString]);
    if (ye.lodash.isPlainObject(i) && ye.lodash.some(i, a))
      return { ObjectExpression: Ou(i.ObjectExpression), ObjectPattern: Ou(i.ObjectPattern), ImportDeclaration: Ou(i.ImportDeclaration), ExportNamedDeclaration: Ou(i.ExportDeclaration) };
    var s = Ou(i);
    return { ObjectExpression: s, ObjectPattern: s, ImportDeclaration: s, ExportNamedDeclaration: s };
  }(e.options[0]);
  return { ObjectExpression: t, ObjectPattern: t, ImportDeclaration: t, ExportNamedDeclaration: t };
} }, UN = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside braces", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/object-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { arraysInObjects: { type: "boolean" }, objectsInObjects: { type: "boolean" } }, additionalProperties: !1 }] }, create: function(e) {
  function t(p) {
    return !!e.options[1] && e.options[1][p] === !u;
  }
  function n(p, d) {
    var m = e.getSourceCode().getTokenAfter(d, { includeComments: !0 });
    e.report({ node: p, loc: { start: d.loc.end, end: m.loc.start }, message: "There should be no space after '{{token}}'.", data: { token: d.value }, fix: function(y) {
      return y.removeRange([d.range[1], m.range[0]]);
    } });
  }
  function r(p, d) {
    var m = e.getSourceCode().getTokenBefore(d, { includeComments: !0 });
    e.report({ node: p, loc: { start: m.loc.end, end: d.loc.start }, message: "There should be no space before '{{token}}'.", data: { token: d.value }, fix: function(y) {
      return y.removeRange([m.range[1], d.range[0]]);
    } });
  }
  function i(p, d) {
    e.report({ node: p, loc: d.loc, message: "A space is required after '{{token}}'.", data: { token: d.value }, fix: function(m) {
      return m.insertTextAfter(d, " ");
    } });
  }
  function a(p, d) {
    e.report({ node: p, loc: d.loc, message: "A space is required before '{{token}}'.", data: { token: d.value }, fix: function(m) {
      return m.insertTextBefore(d, " ");
    } });
  }
  function s(p, d, m, y, v) {
    if (P.isTokenOnSameLine(d, m)) {
      var b = c.isSpaceBetweenTokens(d, m);
      f.spaced && !b && i(p, d), !f.spaced && b && m.type !== "Line" && n(p, d);
    }
    if (P.isTokenOnSameLine(y, v)) {
      var x = (f.arraysInObjectsException && P.isClosingBracketToken(y) || f.objectsInObjectsException && P.isClosingBraceToken(y)) && c.getNodeByRangeIndex(y.range[0]).type, C = f.arraysInObjectsException && x === "ArrayExpression" || f.objectsInObjectsException && (x === "ObjectExpression" || x === "ObjectPattern") ? !f.spaced : f.spaced, k = c.isSpaceBetweenTokens(y, v);
      C && !k && a(p, v), !C && k && r(p, v);
    }
  }
  function o(p) {
    if (p.properties.length !== 0) {
      var d = c.getFirstToken(p), m = function(y) {
        var v = y.properties[y.properties.length - 1];
        return c.getTokenAfter(v, P.isClosingBraceToken);
      }(p);
      s(p, d, c.getTokenAfter(d, { includeComments: !0 }), c.getTokenBefore(m, { includeComments: !0 }), m);
    }
  }
  var u = e.options[0] === "always", c = e.getSourceCode(), f = { spaced: u, arraysInObjectsException: t("arraysInObjects"), objectsInObjectsException: t("objectsInObjects") };
  return { ObjectPattern: o, ObjectExpression: o, ImportDeclaration: function(p) {
    if (p.specifiers.length !== 0) {
      var d = p.specifiers[0], m = p.specifiers[p.specifiers.length - 1];
      if (m.type === "ImportSpecifier") {
        d.type !== "ImportSpecifier" && (d = p.specifiers[1]);
        var y = c.getTokenBefore(d), v = c.getTokenAfter(m, P.isNotCommaToken);
        s(p, y, c.getTokenAfter(y, { includeComments: !0 }), c.getTokenBefore(v, { includeComments: !0 }), v);
      }
    }
  }, ExportNamedDeclaration: function(p) {
    if (p.specifiers.length !== 0) {
      var d = p.specifiers[0], m = p.specifiers[p.specifiers.length - 1], y = c.getTokenBefore(d), v = c.getTokenAfter(m, P.isNotCommaToken);
      s(p, y, c.getTokenAfter(y, { includeComments: !0 }), c.getTokenBefore(v, { includeComments: !0 }), v);
    }
  } };
} }, rm = "always", qN = "never", WN = "methods", $N = "properties", GN = "consistent", zN = "consistent-as-needed", HN = { meta: { type: "suggestion", docs: { description: "require or disallow method and property shorthand syntax for object literals", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/object-shorthand" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "methods", "properties", "never", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "methods", "properties"] }, { type: "object", properties: { avoidQuotes: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always", "methods"] }, { type: "object", properties: { ignoreConstructors: { type: "boolean" }, avoidQuotes: { type: "boolean" }, avoidExplicitReturnArrows: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] } }, create: function(e) {
  function t(w) {
    return w.kind !== "set" && w.kind !== "get" && w.type !== "SpreadElement" && w.type !== "SpreadProperty" && w.type !== "ExperimentalSpreadProperty";
  }
  function n(w) {
    return w.type === "Literal" && typeof w.value == "string";
  }
  function r(w) {
    return w.shorthand || w.method;
  }
  function i(w) {
    var D = w.value;
    return D.type === "FunctionExpression" ? !D.id : D.type === "Identifier" && P.getStaticPropertyName(w) === D.name;
  }
  function a(w, D) {
    var I = w.properties.filter(t);
    if (0 < I.length) {
      var L = I.filter(r);
      L.length !== I.length && (0 < L.length ? e.report({ node: w, message: "Unexpected mix of shorthand and non-shorthand properties." }) : D && I.every(i) && e.report({ node: w, message: "Expected shorthand for all properties." }));
    }
  }
  function s() {
    B.unshift(/* @__PURE__ */ new Set()), e.getScope().variables.filter(function(w) {
      return w.name === "arguments";
    }).forEach(function(w) {
      w.references.map(function(D) {
        return D.identifier;
      }).forEach(function(D) {
        return S.add(D);
      });
    });
  }
  function o() {
    B.shift();
  }
  function u() {
    B[0].forEach(function(w) {
      return O.add(w);
    });
  }
  var c = e.options[0] || rm, f = c === WN || c === rm, p = c === $N || c === rm, d = c === qN, m = c === GN, y = c === zN, v = e.options[1] || {}, b = v.ignoreConstructors, x = v.avoidQuotes, C = !!v.avoidExplicitReturnArrows, k = e.getSourceCode(), F = /(?:[\0-#%-\/:-\^`-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, B = [], O = /* @__PURE__ */ new WeakSet(), S = /* @__PURE__ */ new WeakSet();
  return { Program: s, FunctionDeclaration: s, FunctionExpression: s, "Program:exit": o, "FunctionDeclaration:exit": o, "FunctionExpression:exit": o, ArrowFunctionExpression: function(w) {
    B[0].add(w);
  }, "ArrowFunctionExpression:exit": function(w) {
    B[0].delete(w);
  }, ThisExpression: u, Super: u, MetaProperty: function(w) {
    w.meta.name === "new" && w.property.name === "target" && u();
  }, Identifier: function(w) {
    S.has(w) && u();
  }, ObjectExpression: function(w) {
    m ? a(w, !1) : y && a(w, !0);
  }, "Property:exit": function(w) {
    var D = w.method || w.shorthand;
    if (w.parent.type !== "ObjectPattern" && w.kind !== "get" && w.kind !== "set" && (!w.computed || w.value.type === "FunctionExpression" || w.value.type === "ArrowFunctionExpression"))
      if (D)
        if (w.method && (d || x && n(w.key))) {
          var I = d ? "Expected longform method syntax." : "Expected longform method syntax for string literal keys.";
          e.report({ node: w, message: I, fix: function(L) {
            return function(V, K) {
              var W = K.computed ? k.getTokens(K).find(function(X) {
                return X.value === "[";
              }) : k.getFirstToken(K.key), R = K.computed ? k.getTokensBetween(K.key, K.value).find(function(X) {
                return X.value === "]";
              }) : k.getLastToken(K.key), q = k.text.slice(W.range[0], R.range[1]), J = "function";
              return K.value.async && (J = "async ".concat(J)), K.value.generator && (J = "".concat(J, "*")), V.replaceTextRange([K.range[0], R.range[1]], "".concat(q, ": ").concat(J));
            }(L, w);
          } });
        } else
          d && e.report({ node: w, message: "Expected longform property syntax.", fix: function(L) {
            return L.insertTextAfter(w.key, ": ".concat(w.key.name));
          } });
      else if (!f || w.value.id || w.value.type !== "FunctionExpression" && w.value.type !== "ArrowFunctionExpression") {
        if (w.value.type === "Identifier" && w.key.name === w.value.name && p)
          e.report({ node: w, message: "Expected property shorthand.", fix: function(L) {
            return L.replaceText(w, w.value.name);
          } });
        else if (w.value.type === "Identifier" && w.key.type === "Literal" && w.key.value === w.value.name && p) {
          if (x)
            return;
          e.report({ node: w, message: "Expected property shorthand.", fix: function(L) {
            return L.replaceText(w, w.value.name);
          } });
        }
      } else {
        if (b && w.key.type === "Identifier" && function(L) {
          var V = F.exec(L);
          if (!V)
            return !1;
          var K = L.charAt(V.index);
          return K === K.toUpperCase();
        }(w.key.name) || x && n(w.key))
          return;
        (w.value.type === "FunctionExpression" || w.value.type === "ArrowFunctionExpression" && w.value.body.type === "BlockStatement" && C && !O.has(w.value)) && e.report({ node: w, message: "Expected method shorthand.", fix: function(L) {
          return function(V, K) {
            var W = K.computed ? k.getFirstToken(K, P.isOpeningBracketToken) : k.getFirstToken(K.key), R = K.computed ? k.getFirstTokenBetween(K.key, K.value, P.isClosingBracketToken) : k.getLastToken(K.key), q = k.text.slice(W.range[0], R.range[1]), J = "";
            if (k.commentsExistBetween(R, K.value))
              return null;
            K.value.async && (J += "async "), K.value.generator && (J += "*");
            var X = [W.range[0], K.range[1]], ce = J + q;
            if (K.value.type === "FunctionExpression") {
              var A = k.getTokens(K.value).find(function(Q) {
                return Q.type === "Keyword" && Q.value === "function";
              }), M = K.value.generator ? k.getTokenAfter(A) : A;
              return V.replaceTextRange(X, ce + k.text.slice(M.range[1], K.value.range[1]));
            }
            var ne, de = k.getTokenBefore(K.value.body, P.isArrowToken), he = k.text.slice(de.range[1], K.value.range[1]), j = !1;
            if (ne = K.value.params.length === 0 ? k.getFirstToken(K.value, P.isOpeningParenToken) : k.getTokenBefore(K.value.params[0]), K.value.params.length === 1) {
              var ie = P.isOpeningParenToken(ne), fe = ne.range[0] < K.range[0];
              j = !ie || fe;
            }
            var ge = j ? K.value.params[0].range[0] : ne.range[0], Fe = k.getTokenBefore(de).range[1], Pe = k.text.slice(ge, Fe), _ = j ? "(".concat(Pe, ")") : Pe;
            return V.replaceTextRange(X, ce + _ + he);
          }(L, w);
        } });
      }
  } };
} }, KN = { meta: { type: "suggestion", docs: { description: "enforce variables to be declared either together or separately in functions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/one-var" }, fixable: "code", schema: [{ oneOf: [{ enum: ["always", "never", "consecutive"] }, { type: "object", properties: { separateRequires: { type: "boolean" }, var: { enum: ["always", "never", "consecutive"] }, let: { enum: ["always", "never", "consecutive"] }, const: { enum: ["always", "never", "consecutive"] } }, additionalProperties: !1 }, { type: "object", properties: { initialized: { enum: ["always", "never", "consecutive"] }, uninitialized: { enum: ["always", "never", "consecutive"] } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t() {
    x.push({ let: { initialized: !1, uninitialized: !1 }, const: { initialized: !1, uninitialized: !1 } });
  }
  function n() {
    b.push({ initialized: !1, uninitialized: !1 }), t();
  }
  function r() {
    x.pop();
  }
  function i() {
    b.pop(), r();
  }
  function a(C) {
    return C.init && C.init.type === "CallExpression" && C.init.callee.name === "require";
  }
  function s(C) {
    for (var k = { uninitialized: 0, initialized: 0 }, F = 0; F < C.length; F++)
      C[F].init === null ? k.uninitialized++ : k.initialized++;
    return k;
  }
  function o(C, k) {
    var F = s(k), B = y[C] || {}, O = function(w) {
      var D;
      return w === "var" ? D = b[b.length - 1] : w === "let" ? D = x[x.length - 1].let : w == "const" && (D = x[x.length - 1].const), D;
    }(C), S = k.some(a);
    return !(B.uninitialized === f && B.initialized === f && (O.uninitialized || O.initialized) && !S || 0 < F.uninitialized && B.uninitialized === f && O.uninitialized || 0 < F.initialized && B.initialized === f && O.initialized && !S || O.required && S || (function(w, D, I) {
      for (var L = 0; L < D.length; L++)
        D[L].init === null ? y[w] && y[w].uninitialized === f && (I.uninitialized = !0) : y[w] && y[w].initialized === f && (y.separateRequires && a(D[L]) ? I.required = !0 : I.initialized = !0);
    }(C, k, O), 0));
  }
  function u(C) {
    var k = C[0], F = Array.isArray(k.parent.parent.body) ? k.parent.parent.body : [], B = F.findIndex(function(S) {
      return S.range[0] === k.parent.range[0];
    }), O = F[B - 1];
    return function(S) {
      var w = v.getTokenBefore(k), D = v.getTokenBefore(w), I = [];
      return O && O.kind === v.getText(w) && (D.value === ";" ? I.push(S.replaceText(D, ",")) : I.push(S.insertTextAfter(D, ",")), I.push(S.replaceText(w, ""))), I;
    };
  }
  function c(C) {
    return function(k) {
      return C.declarations.map(function(F) {
        var B = v.getTokenAfter(F);
        if (B === null)
          return null;
        var O = v.getTokenAfter(B, { includeComments: !0 });
        if (B.value !== ",")
          return null;
        if (O.range[0] === B.range[1])
          return k.replaceText(B, "; ".concat(C.kind, " "));
        if (O.loc.start.line > B.loc.end.line || O.type === "Line" || O.type === "Block") {
          for (var S = O; S.type === "Line" || S.type === "Block"; )
            S = v.getTokenAfter(S, { includeComments: !0 });
          return k.replaceTextRange([B.range[0], S.range[0]], ";".concat(v.text.slice(B.range[1], S.range[0])).concat(C.kind, " "));
        }
        return k.replaceText(B, "; ".concat(C.kind));
      }).filter(function(F) {
        return F;
      });
    };
  }
  var f = "always", p = "never", d = "consecutive", m = e.options[0] || "always", y = {};
  typeof m == "string" ? (y.var = { uninitialized: m, initialized: m }, y.let = { uninitialized: m, initialized: m }, y.const = { uninitialized: m, initialized: m }) : xe(m) == "object" && (y.separateRequires = !!m.separateRequires, y.var = { uninitialized: m.var, initialized: m.var }, y.let = { uninitialized: m.let, initialized: m.let }, y.const = { uninitialized: m.const, initialized: m.const }, Object.prototype.hasOwnProperty.call(m, "uninitialized") && (y.var.uninitialized = m.uninitialized, y.let.uninitialized = m.uninitialized, y.const.uninitialized = m.uninitialized), Object.prototype.hasOwnProperty.call(m, "initialized") && (y.var.initialized = m.initialized, y.let.initialized = m.initialized, y.const.initialized = m.initialized));
  var v = e.getSourceCode(), b = [], x = [];
  return { Program: n, FunctionDeclaration: n, FunctionExpression: n, ArrowFunctionExpression: n, BlockStatement: t, ForStatement: t, ForInStatement: t, ForOfStatement: t, SwitchStatement: t, VariableDeclaration: function(C) {
    var k = C.parent, F = C.kind;
    if (y[F]) {
      var B = C.declarations, O = s(B), S = B.some(a) && !B.every(a);
      y[F].initialized === f && y.separateRequires && S && e.report({ node: C, message: "Split requires to be separated into a single block." });
      var w = k.body && 0 < k.body.length && k.body.indexOf(C) || 0;
      if (0 < w) {
        var D = k.body[w - 1], I = D.type === "VariableDeclaration", L = B.concat(D.declarations || []);
        if (I && D.kind === F && (!L.some(a) || L.every(a))) {
          var V = s(D.declarations);
          y[F].initialized === d && y[F].uninitialized === d ? e.report({ node: C, message: "Combine this with the previous '{{type}}' statement.", data: { type: F }, fix: u(B) }) : y[F].initialized === d && 0 < O.initialized && 0 < V.initialized ? e.report({ node: C, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: F }, fix: u(B) }) : y[F].uninitialized === d && 0 < O.uninitialized && 0 < V.uninitialized && e.report({ node: C, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: F }, fix: u(B) });
        }
      }
      if (!o(F, B)) {
        if (y[F].initialized === f && y[F].uninitialized === f)
          e.report({ node: C, message: "Combine this with the previous '{{type}}' statement.", data: { type: F }, fix: u(B) });
        else if (y[F].initialized === f && 0 < O.initialized && e.report({ node: C, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: F }, fix: u(B) }), y[F].uninitialized === f && 0 < O.uninitialized) {
          if (C.parent.left === C && (C.parent.type === "ForInStatement" || C.parent.type === "ForOfStatement"))
            return;
          e.report({ node: C, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: F }, fix: u(B) });
        }
      }
      (k.type !== "ForStatement" || k.init !== C) && 1 < O.uninitialized + O.initialized && (y[F].initialized === p && y[F].uninitialized === p ? e.report({ node: C, message: "Split '{{type}}' declarations into multiple statements.", data: { type: F }, fix: c(C) }) : y[F].initialized === p && 0 < O.initialized ? e.report({ node: C, message: "Split initialized '{{type}}' declarations into multiple statements.", data: { type: F }, fix: c(C) }) : y[F].uninitialized === p && 0 < O.uninitialized && e.report({ node: C, message: "Split uninitialized '{{type}}' declarations into multiple statements.", data: { type: F }, fix: c(C) }));
    }
  }, "ForStatement:exit": r, "ForOfStatement:exit": r, "ForInStatement:exit": r, "SwitchStatement:exit": r, "BlockStatement:exit": r, "Program:exit": i, "FunctionDeclaration:exit": i, "FunctionExpression:exit": i, "ArrowFunctionExpression:exit": i };
} };
function M2(e) {
  return 0 <= ["*", "&", "^", "|"].indexOf(e);
}
function Zp(e, t) {
  if (e.type !== t.type)
    return !1;
  switch (e.type) {
    case "Identifier":
      return e.name === t.name;
    case "Literal":
      return e.value === t.value;
    case "MemberExpression":
      return Zp(e.object, t.object) && Zp(e.property, t.property);
    case "ThisExpression":
      return !0;
    default:
      return !1;
  }
}
function V2(e) {
  return e.type === "Identifier" || e.type === "MemberExpression" && (e.object.type === "Identifier" || e.object.type === "ThisExpression") && (!e.computed || e.property.type === "Literal");
}
var JN = { meta: { type: "suggestion", docs: { description: "require or disallow assignment operator shorthand where possible", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/operator-assignment" }, schema: [{ enum: ["always", "never"] }], fixable: "code", messages: { replaced: "Assignment can be replaced with operator assignment.", unexpected: "Unexpected operator assignment shorthand." } }, create: function(e) {
  function t(r) {
    return n.getFirstTokenBetween(r.left, r.right, function(i) {
      return i.value === r.operator;
    });
  }
  var n = e.getSourceCode();
  return { AssignmentExpression: e.options[0] === "never" ? function(r) {
    r.operator !== "=" && e.report({ node: r, messageId: "unexpected", fix: function(i) {
      if (V2(r.left)) {
        var a, s = n.getFirstToken(r), o = t(r), u = n.getText().slice(r.range[0], o.range[0]), c = r.operator.slice(0, -1);
        if (n.commentsExistBetween(s, o))
          return null;
        if (P.getPrecedence(r.right) <= P.getPrecedence({ type: "BinaryExpression", operator: c }) && !P.isParenthesised(n, r.right))
          a = "".concat(n.text.slice(o.range[1], r.right.range[0]), "(").concat(n.getText(r.right), ")");
        else {
          var f = n.getFirstToken(r.right), p = "";
          o.range[1] !== f.range[0] || P.canTokensBeAdjacent(c, f) || (p = " "), a = "".concat(p).concat(n.text.slice(o.range[1], r.range[1]));
        }
        return i.replaceText(r, "".concat(u, "= ").concat(u).concat(c).concat(a));
      }
      return null;
    } });
  } : function(r) {
    if (r.operator === "=" && r.right.type === "BinaryExpression") {
      var i = r.left, a = r.right, s = a.operator;
      (M2(s) || function(o) {
        return 0 <= ["+", "-", "/", "%", "<<", ">>", ">>>", "**"].indexOf(o);
      }(s)) && (Zp(i, a.left) ? e.report({ node: r, messageId: "replaced", fix: function(o) {
        if (V2(i)) {
          var u = t(r), c = t(a), f = n.getText().slice(r.range[0], u.range[0]), p = n.getText().slice(c.range[1], r.right.range[1]);
          return n.commentsExistBetween(u, c) ? null : o.replaceText(r, "".concat(f).concat(a.operator, "=").concat(p));
        }
        return null;
      } }) : Zp(i, a.right) && M2(s) && e.report({ node: r, messageId: "replaced" }));
    }
  } };
} }, QN = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style for operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/operator-linebreak" }, schema: [{ enum: ["after", "before", "none", null] }, { type: "object", properties: { overrides: { type: "object", properties: { anyOf: { type: "string", enum: ["after", "before", "none", "ignore"] } } } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  function t(u, c) {
    var f = o.getTokenAfter(c, P.isNotClosingParenToken), p = o.getTokenBefore(f), d = o.getTokenAfter(f), m = f.value, y = s[m], v = y || i, b = function(x, C) {
      return function(k) {
        var F, B, O = o.getTokenBefore(x), S = o.getTokenAfter(x), w = o.text.slice(O.range[1], x.range[0]), D = o.text.slice(x.range[1], S.range[0]);
        if (!P.isTokenOnSameLine(O, x) != !P.isTokenOnSameLine(x, S) && C !== "none") {
          if (o.getTokenBefore(x, { includeComments: !0 }) !== O && o.getTokenAfter(x, { includeComments: !0 }) !== S)
            return null;
          F = D, B = w;
        } else {
          var I = P.createGlobalLinebreakMatcher();
          if (F = C === "before" || w.trim() ? w : w.replace(I, ""), B = C === "after" || D.trim() ? D : D.replace(I, ""), F === w && B === D)
            return null;
        }
        return B === "" && S.type === "Punctuator" && "+-".includes(x.value) && S.value === x.value && (B += " "), k.replaceTextRange([O.range[1], S.range[0]], F + x.value + B);
      };
    }(f, v);
    P.isTokenOnSameLine(p, f) && P.isTokenOnSameLine(f, d) || (y === "ignore" || P.isTokenOnSameLine(p, f) || P.isTokenOnSameLine(f, d) ? v === "before" && P.isTokenOnSameLine(p, f) ? e.report({ node: u, loc: { line: f.loc.end.line, column: f.loc.end.column }, message: "'{{operator}}' should be placed at the beginning of the line.", data: { operator: m }, fix: b }) : v === "after" && P.isTokenOnSameLine(f, d) ? e.report({ node: u, loc: { line: f.loc.end.line, column: f.loc.end.column }, message: "'{{operator}}' should be placed at the end of the line.", data: { operator: m }, fix: b }) : v === "none" && e.report({ node: u, loc: { line: f.loc.end.line, column: f.loc.end.column }, message: "There should be no line break before or after '{{operator}}'.", data: { operator: m }, fix: b }) : e.report({ node: u, loc: { line: f.loc.end.line, column: f.loc.end.column }, message: "Bad line breaking before and after '{{operator}}'.", data: { operator: m }, fix: b }));
  }
  function n(u) {
    t(u, u.left);
  }
  var r = !e.options[0], i = e.options[0] || "after", a = e.options[1] || {}, s = a.overrides ? Object.assign({}, a.overrides) : {};
  r && !s["?"] && (s["?"] = "before"), r && !s[":"] && (s[":"] = "before");
  var o = e.getSourceCode();
  return { BinaryExpression: n, LogicalExpression: n, AssignmentExpression: n, VariableDeclarator: function(u) {
    u.init && t(u, u.id);
  }, ConditionalExpression: function(u) {
    t(u, u.test), t(u, u.consequent);
  } };
} }, XN = { meta: { type: "layout", docs: { description: "require or disallow padding within blocks", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/padded-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { blocks: { enum: ["always", "never"] }, switches: { enum: ["always", "never"] }, classes: { enum: ["always", "never"] } }, additionalProperties: !1, minProperties: 1 }] }, { type: "object", properties: { allowSingleLineBlocks: { type: "boolean" } } }] }, create: function(e) {
  function t(y) {
    return y.type === "Line" || y.type === "Block";
  }
  function n(y, v) {
    return 2 <= v.loc.start.line - y.loc.end.line;
  }
  function r(y) {
    var v, b = y;
    do
      v = b, b = d.getTokenAfter(b, { includeComments: !0 });
    while (t(b) && b.loc.start.line === v.loc.end.line);
    return b;
  }
  function i(y) {
    var v, b = y;
    do
      v = b, b = d.getTokenBefore(b, { includeComments: !0 });
    while (t(b) && b.loc.end.line === v.loc.start.line);
    return b;
  }
  function a(y) {
    var v = r(function(B) {
      return B.type === "SwitchStatement" ? d.getTokenBefore(B.cases[0]) : d.getFirstToken(B);
    }(y)), b = d.getTokenBefore(v, { includeComments: !0 }), x = i(d.getLastToken(y)), C = d.getTokenAfter(x, { includeComments: !0 }), k = n(b, v), F = n(x, C);
    s.allowSingleLineBlocks && P.isTokenOnSameLine(b, C) || (function(B) {
      switch (B.type) {
        case "BlockStatement":
          return s.blocks;
        case "SwitchStatement":
          return s.switches;
        case "ClassBody":
          return s.classes;
        default:
          throw new Error("unreachable");
      }
    }(y) ? (!k && e.report({ node: y, loc: { line: b.loc.start.line, column: b.loc.start.column }, fix: function(B) {
      return B.insertTextAfter(b, `
`);
    }, message: f }), !F && e.report({ node: y, loc: { line: C.loc.end.line, column: C.loc.end.column - 1 }, fix: function(B) {
      return B.insertTextBefore(C, `
`);
    }, message: f })) : (k && e.report({ node: y, loc: { line: b.loc.start.line, column: b.loc.start.column }, fix: function(B) {
      return B.replaceTextRange([b.range[1], v.range[0] - v.loc.start.column], `
`);
    }, message: p }), F && e.report({ node: y, loc: { line: C.loc.end.line, column: C.loc.end.column - 1 }, message: p, fix: function(B) {
      return B.replaceTextRange([x.range[1], C.range[0] - C.loc.start.column], `
`);
    } })));
  }
  var s = {}, o = e.options[0] || "always", u = e.options[1] || {};
  if (typeof o == "string") {
    var c = o === "always";
    s.blocks = c, s.switches = c, s.classes = c;
  } else
    Object.prototype.hasOwnProperty.call(o, "blocks") && (s.blocks = o.blocks === "always"), Object.prototype.hasOwnProperty.call(o, "switches") && (s.switches = o.switches === "always"), Object.prototype.hasOwnProperty.call(o, "classes") && (s.classes = o.classes === "always");
  Object.prototype.hasOwnProperty.call(u, "allowSingleLineBlocks") && (s.allowSingleLineBlocks = u.allowSingleLineBlocks === !0);
  var f = "Block must be padded by blank lines.", p = "Block must not be padded by blank lines.", d = e.getSourceCode(), m = {};
  return Object.prototype.hasOwnProperty.call(s, "switches") && (m.SwitchStatement = function(y) {
    y.cases.length === 0 || a(y);
  }), Object.prototype.hasOwnProperty.call(s, "blocks") && (m.BlockStatement = function(y) {
    y.body.length === 0 || a(y);
  }), Object.prototype.hasOwnProperty.call(s, "classes") && (m.ClassBody = function(y) {
    y.body.length === 0 || a(y);
  }), m;
} }, YN = ("[".concat(Array.from(P.LINEBREAKS).join(""), "]"), /^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*;?)$/), ZN = /^(?:module[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)?exports(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\[|$)/, ej = /^require\(/;
function Dn(e) {
  return { test: function(t, n) {
    return n.getFirstToken(t).value === e;
  } };
}
function im(e) {
  return { test: function(t, n) {
    return t.loc.start.line === t.loc.end.line && n.getFirstToken(t).value === e;
  } };
}
function am(e) {
  return { test: function(t, n) {
    return t.loc.start.line !== t.loc.end.line && n.getFirstToken(t).value === e;
  } };
}
function om(e) {
  return { test: function(t) {
    return t.type === e;
  } };
}
function MA(e) {
  if (e.type === "ExpressionStatement") {
    var t = e.expression;
    return t.type === "UnaryExpression" && (t = t.argument), t.type === "CallExpression" && P.isFunction(t.callee);
  }
  return !1;
}
function U2(e, t) {
  if (t.type === "DoWhileStatement" && t.body.type === "BlockStatement" || MA(t))
    return !0;
  var n = e.getLastToken(t, P.isNotSemicolonToken), r = n && P.isClosingBraceToken(n) ? e.getNodeByRangeIndex(n.range[0]) : null;
  return !!r && (r.type === "BlockStatement" || r.type === "SwitchStatement");
}
function q2(e, t) {
  return e.type === "ExpressionStatement" && (e.parent.type === "Program" || e.parent.type === "BlockStatement" && P.isFunction(e.parent.parent)) && e.expression.type === "Literal" && typeof e.expression.value == "string" && !P.isParenthesised(t, e.expression);
}
function sm(e, t) {
  if (q2(e, t)) {
    var n = !0, r = !1, i = void 0;
    try {
      for (var a, s = e.parent.body[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
        var o = a.value;
        if (o === e)
          break;
        if (!q2(o, t))
          return !1;
      }
    } catch (u) {
      r = !0, i = u;
    } finally {
      try {
        n || s.return == null || s.return();
      } finally {
        if (r)
          throw i;
      }
    }
    return !0;
  }
  return !1;
}
function VA(e, t) {
  var n = e.getLastToken(t), r = e.getTokenBefore(n), i = e.getTokenAfter(n);
  return r && i && r.range[0] >= t.range[0] && P.isSemicolonToken(n) && n.loc.start.line !== r.loc.end.line && n.loc.end.line === i.loc.start.line ? r : n;
}
function tj(e, t, n) {
  return t + n;
}
var um = { any: { verify: function() {
} }, never: { verify: function(e, t, n, r) {
  r.length === 0 || e.report({ node: n, message: "Unexpected blank line before this statement.", fix: function(i) {
    if (2 <= r.length)
      return null;
    var a = r[0][0], s = r[0][1], o = a.range[1], u = s.range[0], c = e.getSourceCode().text.slice(o, u).replace(YN, tj);
    return i.replaceTextRange([o, u], c);
  } });
} }, always: { verify: function(e, t, n, r) {
  0 < r.length || e.report({ node: n, message: "Expected blank line before this statement.", fix: function(i) {
    var a = e.getSourceCode(), s = VA(a, t), o = a.getFirstTokenBetween(s, n, { includeComments: !0, filter: function(c) {
      return !P.isTokenOnSameLine(s, c) || (s = c, !1);
    } }) || n, u = P.isTokenOnSameLine(s, o) ? `

` : `
`;
    return i.insertTextAfter(s, u);
  } });
} } }, cm = { "*": { test: function() {
  return !0;
} }, "block-like": { test: function(e, t) {
  return U2(t, e);
} }, "cjs-export": { test: function(e, t) {
  return e.type === "ExpressionStatement" && e.expression.type === "AssignmentExpression" && ZN.test(t.getText(e.expression.left));
} }, "cjs-import": { test: function(e, t) {
  return e.type === "VariableDeclaration" && 0 < e.declarations.length && !!e.declarations[0].init && ej.test(t.getText(e.declarations[0].init));
} }, directive: { test: sm }, expression: { test: function(e, t) {
  return e.type === "ExpressionStatement" && !sm(e, t);
} }, iife: { test: MA }, "multiline-block-like": { test: function(e, t) {
  return e.loc.start.line !== e.loc.end.line && U2(t, e);
} }, "multiline-expression": { test: function(e, t) {
  return e.loc.start.line !== e.loc.end.line && e.type === "ExpressionStatement" && !sm(e, t);
} }, "multiline-const": am("const"), "multiline-let": am("let"), "multiline-var": am("var"), "singleline-const": im("const"), "singleline-let": im("let"), "singleline-var": im("var"), block: om("BlockStatement"), empty: om("EmptyStatement"), function: om("FunctionDeclaration"), break: Dn("break"), case: Dn("case"), class: Dn("class"), const: Dn("const"), continue: Dn("continue"), debugger: Dn("debugger"), default: Dn("default"), do: Dn("do"), export: Dn("export"), for: Dn("for"), if: Dn("if"), import: Dn("import"), let: Dn("let"), return: Dn("return"), switch: Dn("switch"), throw: Dn("throw"), try: Dn("try"), var: Dn("var"), while: Dn("while"), with: Dn("with") }, nj = { meta: { type: "layout", docs: { description: "require or disallow padding lines between statements", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/padding-line-between-statements" }, fixable: "whitespace", schema: { definitions: { paddingType: { enum: Object.keys(um) }, statementType: { anyOf: [{ enum: Object.keys(cm) }, { type: "array", items: { enum: Object.keys(cm) }, minItems: 1, uniqueItems: !0, additionalItems: !1 }] } }, type: "array", items: { type: "object", properties: { blankLine: { $ref: "#/definitions/paddingType" }, prev: { $ref: "#/definitions/statementType" }, next: { $ref: "#/definitions/statementType" } }, additionalProperties: !1, required: ["blankLine", "prev", "next"] }, additionalItems: !1 } }, create: function(e) {
  function t() {
    u = { upper: u, prevNode: null };
  }
  function n() {
    u = u.upper;
  }
  function r(c, f) {
    for (var p = c; p.type === "LabeledStatement"; )
      p = p.body;
    return Array.isArray(f) ? f.some(r.bind(null, p)) : cm[f].test(p, s);
  }
  function i(c, f) {
    for (var p = o.length - 1; 0 <= p; --p) {
      var d = o[p];
      if (r(c, d.prev) && r(f, d.next))
        return um[d.blankLine];
    }
    return um.any;
  }
  function a(c) {
    var f = c.parent.type;
    if (P.STATEMENT_LIST_PARENTS.has(f) || f === "SwitchStatement") {
      var p = u.prevNode;
      if (p) {
        var d = i(p, c), m = function(y, v) {
          var b = [], x = VA(s, y);
          if (2 <= v.loc.start.line - x.loc.end.line)
            do {
              var C = s.getTokenAfter(x, { includeComments: !0 });
              2 <= C.loc.start.line - x.loc.end.line && b.push([x, C]), x = C;
            } while (x.range[0] < v.range[0]);
          return b;
        }(p, c);
        d.verify(e, p, c, m);
      }
      u.prevNode = c;
    }
  }
  var s = e.getSourceCode(), o = e.options || [], u = null;
  return { Program: t, BlockStatement: t, SwitchStatement: t, "Program:exit": n, "BlockStatement:exit": n, "SwitchStatement:exit": n, ":statement": a, SwitchCase: function(c) {
    a(c), t();
  }, "SwitchCase:exit": n };
} }, rj = { meta: { type: "suggestion", docs: { description: "require using arrow functions for callbacks", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-arrow-callback" }, schema: [{ type: "object", properties: { allowNamedFunctions: { type: "boolean", default: !1 }, allowUnboundThis: { type: "boolean", default: !0 } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  function t() {
    o.push({ this: !1, super: !1, meta: !1 });
  }
  function n() {
    return o.pop();
  }
  var r = e.options[0] || {}, i = r.allowUnboundThis !== !1, a = r.allowNamedFunctions, s = e.getSourceCode(), o = [];
  return { Program: function() {
    o = [];
  }, ThisExpression: function() {
    var u = o[o.length - 1];
    u && (u.this = !0);
  }, Super: function() {
    var u = o[o.length - 1];
    u && (u.super = !0);
  }, MetaProperty: function(u) {
    var c = o[o.length - 1];
    c && function(f, p, d) {
      return f.meta.name === p && f.property.name === d;
    }(u, "new", "target") && (c.meta = !0);
  }, FunctionDeclaration: t, "FunctionDeclaration:exit": n, FunctionExpression: t, "FunctionExpression:exit": function(u) {
    var c = n();
    if (!(a && u.id && u.id.name || u.generator)) {
      var f = e.getDeclaredVariables(u)[0];
      if (!(function(m) {
        return m && m.defs[0].type === "FunctionName";
      }(f) && 0 < f.references.length)) {
        var p = function(m) {
          for (var y = m.variables, v = 0; v < y.length; ++v) {
            var b = y[v];
            if (b.name === "arguments")
              return b.identifiers.length === 0 ? b : null;
          }
          return null;
        }(e.getScope());
        if (!(p && 0 < p.references.length)) {
          var d = function(m) {
            for (var y = { isCallback: !1, isLexicalThis: !1 }, v = m, b = m.parent; v; ) {
              switch (b.type) {
                case "LogicalExpression":
                case "ConditionalExpression":
                  break;
                case "MemberExpression":
                  if (b.object !== v || b.property.computed || b.property.type !== "Identifier" || b.property.name !== "bind" || b.parent.type !== "CallExpression" || b.parent.callee !== b)
                    return y;
                  y.isLexicalThis = b.parent.arguments.length === 1 && b.parent.arguments[0].type === "ThisExpression", b = b.parent;
                  break;
                case "CallExpression":
                case "NewExpression":
                  return b.callee !== v && (y.isCallback = !0), y;
                default:
                  return y;
              }
              v = b, b = b.parent;
            }
            throw new Error("unreachable");
          }(u);
          !d.isCallback || i && c.this && !d.isLexicalThis || c.super || c.meta || e.report({ node: u, message: "Unexpected function expression.", fix: function(m) {
            if (!d.isLexicalThis && c.this || function(B) {
              return B.every(function(O) {
                return O.type === "Identifier";
              }) && B.length !== new Set(B.map(function(O) {
                return O.name;
              })).size;
            }(u.params))
              return null;
            var y = u.params.length ? s.getTokenBefore(u.params[0]) : s.getTokenBefore(u.body, 1), v = s.getTokenBefore(u.body), b = u.async ? "async " : "", x = s.text.slice(y.range[0], v.range[1]), C = "".concat(b).concat(x, " => ").concat(s.getText(u.body)), k = d.isLexicalThis ? u.parent.parent : u, F = k.parent.type !== "CallExpression" && k.parent.type !== "ConditionalExpression" ? "(".concat(C, ")") : C;
            return m.replaceText(k, F);
          } });
        }
      }
    }
  } };
} }, UA = /^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?Pattern|RestElement|SpreadProperty|ExperimentalRestProperty|Property)$/, ij = /^(?:Program|BlockStatement|SwitchCase)$/, aj = /^(?:VariableDeclarator|AssignmentExpression)$/;
function W2(e, t) {
  if (t.through.find(function(r) {
    return r.resolved && r.resolved.name === e;
  }))
    return !0;
  var n = P.getVariableByName(t, e);
  return n !== null && n.defs.some(function(r) {
    return r.type === "Parameter";
  });
}
function qA(e) {
  if (!e.isWrite())
    return null;
  for (var t = e.identifier.parent; UA.test(t.type); )
    t = t.parent;
  return aj.test(t.type) ? t : null;
}
function nc(e) {
  switch (e.type) {
    case "ObjectPattern":
      return e.properties.some(function(t) {
        return !!t && nc(t.argument || t.value);
      });
    case "ArrayPattern":
      return e.elements.some(function(t) {
        return !!t && nc(t);
      });
    case "AssignmentPattern":
      return nc(e.left);
    case "MemberExpression":
      return !0;
  }
  return !1;
}
function oj(e, t) {
  if (e.eslintUsed && e.scope.type === "global")
    return null;
  for (var n = null, r = !1, i = e.references, a = 0; a < i.length; ++a) {
    var s = i[a];
    if (s.isWrite()) {
      if (n !== null && n.identifier !== s.identifier)
        return null;
      var o = qA(s);
      if (o !== null && o.left !== void 0) {
        var u = o.left, c = !1, f = !1;
        if (u.type === "ObjectPattern" ? (c = u.properties.filter(function(p) {
          return p.value;
        }).map(function(p) {
          return p.value.name;
        }).some(function(p) {
          return W2(p, e.scope);
        }), f = nc(u)) : u.type === "ArrayPattern" && (c = u.elements.map(function(p) {
          return p && p.name;
        }).some(function(p) {
          return W2(p, e.scope);
        }), f = nc(u)), c || f)
          return null;
      }
      n = s;
    } else if (s.isRead() && n === null) {
      if (t)
        return null;
      r = !0;
    }
  }
  return n !== null && n.from === e.scope && function(p) {
    for (var d = p.parent; UA.test(d.type); )
      d = d.parent;
    return d.type === "VariableDeclarator" || d.type === "AssignmentExpression" && d.parent.type === "ExpressionStatement" && ij.test(d.parent.parent.type);
  }(n.identifier) ? r ? e.defs[0].name : n.identifier : null;
}
var sj = { meta: { type: "suggestion", docs: { description: "require `const` declarations for variables that are never reassigned after declared", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-const" }, fixable: "code", schema: [{ type: "object", properties: { destructuring: { enum: ["any", "all"], default: "any" }, ignoreReadBeforeAssign: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { useConst: "'{{name}}' is never reassigned. Use 'const' instead." } }, create: function(e) {
  function t(f) {
    var p = f.filter(Boolean);
    if (f.length && (i || p.length === f.length)) {
      var d = function x(C, k, F) {
        return !C || F(C) ? null : C.type === k ? C : x(C.parent, k, F);
      }(f[0], "VariableDeclaration", function(x) {
        return x.type.endsWith("Statement");
      }), m = d === null;
      if (!m && 0 < d.declarations.length) {
        var y = d.declarations[0];
        if (y.init) {
          var v = y.init.parent;
          v.type === "VariableDeclarator" && (v.id.name !== c && (c = v.id.name, o = 0), v.id.type === "ObjectPattern" && v.init.name !== c && (c = v.init.name, o = 0), v.id !== u && (u = v.id, o = 0));
        }
      }
      var b = d && (d.parent.type === "ForInStatement" || d.parent.type === "ForOfStatement" || d.declarations.every(function(x) {
        return x.init;
      })) && p.length === f.length;
      !m && d.declarations && d.declarations.length !== 1 && d && d.declarations && 1 <= d.declarations.length && (o += p.length, b = b && o === d.declarations.length), p.forEach(function(x) {
        e.report({ node: x, messageId: "useConst", data: x, fix: b ? function(C) {
          return C.replaceText(r.getFirstToken(d, function(k) {
            return k.value === d.kind;
          }), "const");
        } : null });
      });
    }
  }
  var n = e.options[0] || {}, r = e.getSourceCode(), i = n.destructuring !== "all", a = n.ignoreReadBeforeAssign === !0, s = [], o = 0, u = null, c = "";
  return { "Program:exit": function() {
    (function(f, p) {
      for (var d = /* @__PURE__ */ new Map(), m = 0; m < f.length; ++m)
        for (var y = f[m], v = y.references, b = oj(y, p), x = null, C = 0; C < v.length; ++C) {
          var k = v[C], F = k.identifier;
          if (F !== x) {
            x = F;
            var B = qA(k);
            B && (d.has(B) ? d.get(B).push(b) : d.set(B, [b]));
          }
        }
      return d;
    })(s, a).forEach(t);
  }, VariableDeclaration: function(f) {
    f.kind !== "let" || function(p) {
      return p.parent.type === "ForStatement" && p.parent.init === p;
    }(f) || s.push.apply(s, Mt(e.getDeclaredVariables(f)));
  } };
} }, uj = { meta: { type: "suggestion", docs: { description: "require destructuring from arrays and/or objects", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-destructuring" }, fixable: "code", schema: [{ oneOf: [{ type: "object", properties: { VariableDeclarator: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: !1 }, AssignmentExpression: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: !1 } }, additionalProperties: !1 }, { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: !1 }] }, { type: "object", properties: { enforceForRenamedProperties: { type: "boolean" } }, additionalProperties: !1 }] }, create: function(e) {
  function t(u, c) {
    return o && o[u] && o[u][c];
  }
  function n(u, c, f) {
    e.report({ node: u, message: "Use {{type}} destructuring.", data: { type: c }, fix: f });
  }
  function r(u, c) {
    var f = c.init, p = e.getSourceCode();
    return u.replaceText(c, "{".concat(f.property.name, "} = ").concat(p.getText(f.object)));
  }
  function i(u, c, f) {
    if (c.type === "MemberExpression" && c.object.type !== "Super") {
      if (function(m) {
        return Number.isInteger(m.property.value);
      }(c))
        return void (t(f.type, "array") && n(f, "array", null));
      var p = function(m) {
        return m.type === "VariableDeclarator" && m.id.type === "Identifier" && m.init.type === "MemberExpression" && m.id.name === m.init.property.name;
      }(f) ? function(m) {
        return r(m, f);
      } : null;
      if (t(f.type, "object") && s)
        return void n(f, "object", p);
      if (t(f.type, "object")) {
        var d = c.property;
        (d.type !== "Literal" || u.name !== d.value) && (d.type !== "Identifier" || u.name !== d.name || c.computed) || n(f, "object", p);
      }
    }
  }
  var a = e.options[0], s = e.options[1] && e.options[1].enforceForRenamedProperties, o = { VariableDeclarator: { array: !0, object: !0 }, AssignmentExpression: { array: !0, object: !0 } };
  return a && (o = a.array !== void 0 || a.object !== void 0 ? { VariableDeclarator: a, AssignmentExpression: a } : a), { VariableDeclarator: function(u) {
    u.init && u.init.type === "MemberExpression" && i(u.id, u.init, u);
  }, AssignmentExpression: function(u) {
    u.operator === "=" && i(u.left, u.right, u);
  } };
} }, WA = ye.require$$0, cj = WA.CALL, lj = WA.ReferenceTracker, lm = P.getPrecedence({ type: "BinaryExpression", operator: "**" });
function pm(e, t) {
  return t ? "(".concat(e, ")") : e;
}
var pj = { meta: { type: "suggestion", docs: { description: "disallow the use of `Math.pow` in favor of the `**` operator", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/prefer-exponentiation-operator" }, schema: [], fixable: "code", messages: { useExponentiation: "Use the '**' operator instead of 'Math.pow'." } }, create: function(e) {
  function t(r) {
    e.report({ node: r, messageId: "useExponentiation", fix: function(i) {
      if (r.arguments.length !== 2 || r.arguments.some(function(B) {
        return B.type === "SpreadElement";
      }) || 0 < n.getCommentsInside(r).length)
        return null;
      var a = r.arguments[0], s = r.arguments[1], o = n.getText(a), u = n.getText(s), c = function(B) {
        return P.getPrecedence(B) <= lm || B.type === "UnaryExpression";
      }(a), f = function(B) {
        return P.getPrecedence(B) < lm;
      }(s), p = function(B, O) {
        var S = B.parent;
        return (S.type === "ClassDeclaration" || S.type.endsWith("Expression") && P.getPrecedence(S) >= lm && (S.type !== "BinaryExpression" || S.operator !== "**" || S.right !== B) && !((S.type === "CallExpression" || S.type === "NewExpression") && S.arguments.includes(B)) && !(S.type === "MemberExpression" && S.computed && S.property === B) && S.type !== "ArrayExpression") && !P.isParenthesised(O, B);
      }(r, n), d = "", m = "";
      if (!p) {
        if (!c) {
          var y = n.getFirstToken(a), v = n.getTokenBefore(r);
          v && v.range[1] === r.range[0] && !P.canTokensBeAdjacent(v, y) && (d = " ");
        }
        if (!f) {
          var b = n.getLastToken(s), x = n.getTokenAfter(r);
          x && r.range[1] === x.range[0] && !P.canTokensBeAdjacent(b, x) && (m = " ");
        }
      }
      var C = pm(o, c), k = pm(u, f), F = pm("".concat(C, "**").concat(k), p);
      return i.replaceText(r, "".concat(d).concat(F).concat(m));
    } });
  }
  var n = e.getSourceCode();
  return { Program: function() {
    var r = e.getScope(), i = new lj(r), a = { Math: { pow: Fn({}, cj, !0) } }, s = !0, o = !1, u = void 0;
    try {
      for (var c, f = i.iterateGlobalReferences(a)[Symbol.iterator](); !(s = (c = f.next()).done); s = !0)
        t(c.value.node);
    } catch (p) {
      o = !0, u = p;
    } finally {
      try {
        s || f.return == null || f.return();
      } finally {
        if (o)
          throw u;
      }
    }
  } };
} }, Cf = ye.require$$0, fj = Cf.CALL, hj = Cf.CONSTRUCT, dj = Cf.ReferenceTracker, $2 = Cf.getStringIfConstant, mj = new ao.RegExpParser(), gj = { meta: { type: "suggestion", docs: { description: "enforce using named capture group in regular expression", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/prefer-named-capture-group" }, schema: [], messages: { required: "Capture group '{{group}}' should be converted to a named or non-capturing group." } }, create: function(e) {
  function t(n, r, i) {
    var a;
    try {
      a = mj.parsePattern(n, 0, n.length, i);
    } catch {
      return;
    }
    ao.visitRegExpAST(a, { onCapturingGroupEnter: function(s) {
      s.name || e.report({ node: r, messageId: "required", data: { group: s.raw } });
    } });
  }
  return { Literal: function(n) {
    n.regex && t(n.regex.pattern, n, n.regex.flags.includes("u"));
  }, Program: function() {
    var n, r = e.getScope(), i = new dj(r), a = { RegExp: (n = {}, Fn(n, fj, !0), Fn(n, hj, !0), n) }, s = !0, o = !1, u = void 0;
    try {
      for (var c, f = i.iterateGlobalReferences(a)[Symbol.iterator](); !(s = (c = f.next()).done); s = !0) {
        var p = c.value.node, d = $2(p.arguments[0]), m = $2(p.arguments[1]);
        d && t(d, p, m && m.includes("u"));
      }
    } catch (y) {
      o = !0, u = y;
    } finally {
      try {
        s || f.return == null || f.return();
      } finally {
        if (o)
          throw u;
      }
    }
  } };
} }, yj = { meta: { type: "suggestion", docs: { description: "disallow `parseInt()` and `Number.parseInt()` in favor of binary, octal, and hexadecimal literals", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-numeric-literals" }, schema: [], fixable: "code" }, create: function(e) {
  var t = e.getSourceCode(), n = { 2: "binary", 8: "octal", 16: "hexadecimal" }, r = { 2: "0b", 8: "0o", 16: "0x" };
  return { CallExpression: function(i) {
    if (i.arguments.length === 2) {
      var a = n[i.arguments[1].value];
      (function(s) {
        switch (s.type) {
          case "Identifier":
            return s.name === "parseInt";
          case "MemberExpression":
            return s.object.type === "Identifier" && s.object.name === "Number" && s.property.type === "Identifier" && s.property.name === "parseInt";
        }
        return !1;
      })(i.callee) && a && i.arguments[0].type === "Literal" && e.report({ node: i, message: "Use {{radixName}} literals instead of {{functionName}}().", data: { radixName: a, functionName: t.getText(i.callee) }, fix: function(s) {
        if (t.getCommentsInside(i).length)
          return null;
        var o = "".concat(r[i.arguments[1].value]).concat(i.arguments[0].value);
        if (+o !== parseInt(i.arguments[0].value, i.arguments[1].value))
          return null;
        var u = t.getTokenBefore(i), c = t.getTokenAfter(i), f = "", p = "";
        return u && u.range[1] === i.range[0] && !P.canTokensBeAdjacent(u, o) && (f = " "), c && i.range[1] === c.range[0] && !P.canTokensBeAdjacent(o, c) && (p = " "), s.replaceText(i, "".concat(f).concat(o).concat(p));
      } });
    }
  } };
} }, $A = ye.require$$0, vj = $A.CALL, xj = $A.ReferenceTracker, G2 = P.isCommaToken, GA = P.isOpeningParenToken, bj = P.isClosingParenToken, f0 = P.isParenthesised, zA = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
function Ej(e) {
  return e.arguments.some(function(t) {
    return t.type === "SpreadElement";
  });
}
function Cj(e, t) {
  var n = e.parent;
  switch (n.type) {
    case "VariableDeclarator":
    case "ArrayExpression":
    case "ReturnStatement":
    case "CallExpression":
    case "Property":
      return !1;
    case "AssignmentExpression":
      return n.left === e && !f0(t, e);
    default:
      return !f0(t, e);
  }
}
function Sj(e, t) {
  switch (e.type) {
    case "AssignmentExpression":
    case "ArrowFunctionExpression":
    case "ConditionalExpression":
      return !f0(t, e);
    default:
      return !1;
  }
}
function kj(e, t, n) {
  for (var r = [n.getFirstToken(e), n.getLastToken(e)], i = n.getTokenBefore(e), a = n.getTokenAfter(e); i && a && i.range[0] > t.range[0] && GA(i) && bj(a); )
    r.push(i, a), i = n.getTokenBefore(i), a = n.getTokenAfter(a);
  return r.sort(function(s, o) {
    return s.range[0] - o.range[0];
  });
}
function Dj(e, t) {
  var n = t.text, r = e.range[0], i = t.getTokenBefore(e, { includeComments: !0 });
  if (i && i.type === "Line")
    return r;
  for (; zA.test(n[r - 1] || ""); )
    r -= 1;
  return r;
}
function Fj(e, t) {
  for (var n = t.text, r = e.range[1]; zA.test(n[r] || ""); )
    r += 1;
  return r;
}
function wj(e, t) {
  return regeneratorRuntime.mark(function n(r) {
    var i, a, s, o, u, c, f, p, d, m, y, v, b, x, C, k, F, B, O, S, w;
    return regeneratorRuntime.wrap(function(D) {
      for (; ; )
        switch (D.prev = D.next) {
          case 0:
            return i = t.getTokenAfter(e.callee, GA), a = t.getLastToken(e), D.next = 3, r.remove(e.callee);
          case 3:
            if (!Cj(e, t)) {
              D.next = 10;
              break;
            }
            return D.next = 6, r.replaceText(i, "({");
          case 6:
            return D.next = 8, r.replaceText(a, "})");
          case 8:
            D.next = 14;
            break;
          case 10:
            return D.next = 12, r.replaceText(i, "{");
          case 12:
            return D.next = 14, r.replaceText(a, "}");
          case 14:
            s = !0, o = !1, u = void 0, D.prev = 17, c = e.arguments[Symbol.iterator]();
          case 19:
            if (s = (f = c.next()).done) {
              D.next = 73;
              break;
            }
            if (p = f.value, d = kj(p, i, t), m = d.shift(), y = d.pop(), p.type !== "ObjectExpression") {
              D.next = 61;
              break;
            }
            v = t.getLastToken(p, 1), b = t.getTokenAfter(y), x = !0, C = !1, k = void 0, D.prev = 27, F = d[Symbol.iterator]();
          case 29:
            if (x = (B = F.next()).done) {
              D.next = 36;
              break;
            }
            return O = B.value, D.next = 33, r.remove(O);
          case 33:
            x = !0, D.next = 29;
            break;
          case 36:
            D.next = 42;
            break;
          case 38:
            D.prev = 38, D.t0 = D.catch(27), C = !0, k = D.t0;
          case 42:
            D.prev = 42, D.prev = 43, x || F.return == null || F.return();
          case 45:
            if (D.prev = 45, !C) {
              D.next = 48;
              break;
            }
            throw k;
          case 48:
            return D.finish(45);
          case 49:
            return D.finish(42);
          case 50:
            return S = [m.range[0], Fj(m, t)], w = [Math.max(Dj(y, t), S[1]), y.range[1]], D.next = 53, r.removeRange(S);
          case 53:
            return D.next = 55, r.removeRange(w);
          case 55:
            if (D.t1 = (p.properties.length === 0 || G2(v)) && G2(b), !D.t1) {
              D.next = 59;
              break;
            }
            return D.next = 59, r.remove(b);
          case 59:
            D.next = 70;
            break;
          case 61:
            if (!Sj(p, t)) {
              D.next = 68;
              break;
            }
            return D.next = 64, r.insertTextBefore(m, "...(");
          case 64:
            return D.next = 66, r.insertTextAfter(y, ")");
          case 66:
            D.next = 70;
            break;
          case 68:
            return D.next = 70, r.insertTextBefore(m, "...");
          case 70:
            s = !0, D.next = 19;
            break;
          case 73:
            D.next = 79;
            break;
          case 75:
            D.prev = 75, D.t2 = D.catch(17), o = !0, u = D.t2;
          case 79:
            D.prev = 79, D.prev = 80, s || c.return == null || c.return();
          case 82:
            if (D.prev = 82, !o) {
              D.next = 85;
              break;
            }
            throw u;
          case 85:
            return D.finish(82);
          case 86:
            return D.finish(79);
          case 87:
          case "end":
            return D.stop();
        }
    }, n, null, [[17, 75, 79, 87], [27, 38, 42, 50], [43, , 45, 49], [80, , 82, 86]]);
  });
}
var Aj = { meta: { type: "suggestion", docs: { description: "disallow using Object.assign with an object literal as the first argument and prefer the use of object spread instead.", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/prefer-object-spread" }, schema: [], fixable: "code", messages: { useSpreadMessage: "Use an object spread instead of `Object.assign` eg: `{ ...foo }`.", useLiteralMessage: "Use an object literal instead of `Object.assign`. eg: `{ foo: bar }`." } }, create: function(e) {
  var t = e.getSourceCode();
  return { Program: function() {
    var n = e.getScope(), r = new xj(n), i = { Object: { assign: Fn({}, vj, !0) } }, a = !0, s = !1, o = void 0;
    try {
      for (var u, c = r.iterateGlobalReferences(i)[Symbol.iterator](); !(a = (u = c.next()).done); a = !0) {
        var f = u.value.node;
        if (1 <= f.arguments.length && f.arguments[0].type === "ObjectExpression" && !Ej(f)) {
          var p = f.arguments.length === 1 ? "useLiteralMessage" : "useSpreadMessage", d = wj(f, t);
          e.report({ node: f, messageId: p, fix: d });
        }
      }
    } catch (m) {
      s = !0, o = m;
    } finally {
      try {
        a || c.return == null || c.return();
      } finally {
        if (s)
          throw o;
      }
    }
  } };
} }, _j = { meta: { type: "suggestion", docs: { description: "require using Error objects as Promise rejection reasons", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/prefer-promise-reject-errors" }, fixable: null, schema: [{ type: "object", properties: { allowEmptyReject: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(r) {
    (r.arguments.length || !n) && (r.arguments.length && P.couldBeError(r.arguments[0]) && (r.arguments[0].type !== "Identifier" || r.arguments[0].name !== "undefined") || e.report({ node: r, message: "Expected the Promise rejection reason to be an Error." }));
  }
  var n = e.options.length && e.options[0].allowEmptyReject;
  return { CallExpression: function(r) {
    (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.object.type === "Identifier" && i.callee.object.name === "Promise" && i.callee.property.type === "Identifier" && i.callee.property.name === "reject";
    })(r) && t(r);
  }, "NewExpression:exit": function(r) {
    r.callee.type === "Identifier" && r.callee.name === "Promise" && r.arguments.length && P.isFunction(r.arguments[0]) && 1 < r.arguments[0].params.length && r.arguments[0].params[1].type === "Identifier" && e.getDeclaredVariables(r.arguments[0]).find(function(i) {
      return i.name === r.arguments[0].params[1].name;
    }).references.filter(function(i) {
      return i.isRead();
    }).filter(function(i) {
      return i.identifier.parent.type === "CallExpression" && i.identifier === i.identifier.parent.callee;
    }).forEach(function(i) {
      return t(i.identifier.parent);
    });
  } };
} }, Tj = { meta: { type: "suggestion", docs: { description: "require `Reflect` methods where applicable", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-reflect" }, deprecated: !0, replacedBy: [], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { enum: ["apply", "call", "delete", "defineProperty", "getOwnPropertyDescriptor", "getPrototypeOf", "setPrototypeOf", "isExtensible", "getOwnPropertyNames", "preventExtensions"] }, uniqueItems: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(a, s, o) {
    e.report({ node: a, message: "Avoid using {{existing}}, instead use {{substitute}}.", data: { existing: s, substitute: o } });
  }
  var n = { apply: "Function.prototype.apply", call: "Function.prototype.call", defineProperty: "Object.defineProperty", getOwnPropertyDescriptor: "Object.getOwnPropertyDescriptor", getPrototypeOf: "Object.getPrototypeOf", setPrototypeOf: "Object.setPrototypeOf", isExtensible: "Object.isExtensible", getOwnPropertyNames: "Object.getOwnPropertyNames", preventExtensions: "Object.preventExtensions" }, r = { apply: "Reflect.apply", call: "Reflect.apply", defineProperty: "Reflect.defineProperty", getOwnPropertyDescriptor: "Reflect.getOwnPropertyDescriptor", getPrototypeOf: "Reflect.getPrototypeOf", setPrototypeOf: "Reflect.setPrototypeOf", isExtensible: "Reflect.isExtensible", getOwnPropertyNames: "Reflect.getOwnPropertyNames", preventExtensions: "Reflect.preventExtensions" }, i = (e.options[0] || {}).exceptions || [];
  return { CallExpression: function(a) {
    var s = (a.callee.property || {}).name, o = (a.callee.object || {}).name === "Reflect", u = Object.prototype.hasOwnProperty.call(r, s), c = i.indexOf(s) !== -1;
    !u || o || c || t(a, n[s], r[s]);
  }, UnaryExpression: function(a) {
    var s = a.operator === "delete", o = a.argument.type === "Identifier", u = i.indexOf("delete") !== -1;
    !s || o || u || t(a, "the delete keyword", "Reflect.deleteProperty");
  } };
} }, Sf = ye.require$$0, Pj = Sf.CALL, Ij = Sf.CONSTRUCT, Bj = Sf.ReferenceTracker, Oj = Sf.findVariable;
function z2(e) {
  return e.type === "TemplateLiteral" && e.expressions.length === 0;
}
var Lj = { meta: { type: "suggestion", docs: { description: "disallow use of the `RegExp` constructor in favor of regular expression literals", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/prefer-regex-literals" }, schema: [], messages: { unexpectedRegExp: "Use a regular expression literal instead of the 'RegExp' constructor." } }, create: function(e) {
  function t(r) {
    var i = e.getScope(), a = Oj(i, r);
    return a !== null && a.scope.type === "global" && a.defs.length === 0;
  }
  function n(r) {
    return function(i) {
      return i.type === "Literal" && typeof i.value == "string";
    }(r) || z2(r) || function(i) {
      return i.type === "TaggedTemplateExpression" && i.tag.type === "MemberExpression" && i.tag.object.type === "Identifier" && i.tag.object.name === "String" && t(i.tag.object) && P.getStaticPropertyName(i.tag) === "raw" && z2(i.quasi);
    }(r);
  }
  return { Program: function() {
    var r, i = e.getScope(), a = new Bj(i), s = { RegExp: (r = {}, Fn(r, Pj, !0), Fn(r, Ij, !0), r) }, o = !0, u = !1, c = void 0;
    try {
      for (var f, p = a.iterateGlobalReferences(s)[Symbol.iterator](); !(o = (f = p.next()).done); o = !0) {
        var d = f.value.node, m = d.arguments;
        (m.length === 1 || m.length === 2) && m.every(n) && e.report({ node: d, messageId: "unexpectedRegExp" });
      }
    } catch (y) {
      u = !0, c = y;
    } finally {
      try {
        o || p.return == null || p.return();
      } finally {
        if (u)
          throw c;
      }
    }
  } };
} };
function Nj(e) {
  var t = e.identifier, n = t.parent;
  return n.type !== "MemberExpression" || n.object !== t || n.computed;
}
var jj = { meta: { type: "suggestion", docs: { description: "require rest parameters instead of `arguments`", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-rest-params" }, schema: [] }, create: function(e) {
  function t(r) {
    e.report({ node: r.identifier, loc: r.identifier.loc, message: "Use the rest parameters instead of 'arguments'." });
  }
  function n() {
    var r = function(i) {
      for (var a = i.variables, s = 0; s < a.length; ++s) {
        var o = a[s];
        if (o.name === "arguments")
          return o.identifiers.length === 0 ? o : null;
      }
      return null;
    }(e.getScope());
    r && r.references.filter(Nj).forEach(t);
  }
  return { "FunctionDeclaration:exit": n, "FunctionExpression:exit": n };
} }, Rj = { meta: { type: "suggestion", docs: { description: "require spread operators instead of `.apply()`", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-spread" }, schema: [], fixable: null }, create: function(e) {
  var t = e.getSourceCode();
  return { CallExpression: function(n) {
    if (function(i) {
      return i.callee.type === "MemberExpression" && i.callee.property.type === "Identifier" && i.callee.property.name === "apply" && i.callee.computed === !1 && i.arguments.length === 2 && i.arguments[1].type !== "ArrayExpression" && i.arguments[1].type !== "SpreadElement";
    }(n)) {
      var r = n.callee.object;
      (function(i, a, s) {
        return i ? P.equalTokens(i, a, s) : P.isNullOrUndefined(a);
      })(r.type === "MemberExpression" ? r.object : null, n.arguments[0], t) && e.report({ node: n, message: "Use the spread operator instead of '.apply()'." });
    }
  } };
} };
function Ls(e) {
  return e.type === "BinaryExpression" && e.operator === "+";
}
function H2(e) {
  for (var t = e; Ls(t.parent); )
    t = t.parent;
  return t;
}
function h0(e) {
  return Ls(e) ? h0(e.left) || h0(e.right) : function(t) {
    return t.type === "Literal" && typeof t.value == "string" && P.hasOctalEscapeSequence(t.raw);
  }(e);
}
function ef(e) {
  return Ls(e) ? ef(e.right) || ef(e.left) : !P.isStringLiteral(e);
}
function d0(e) {
  return e.type === "BinaryExpression" ? d0(e.left) : e.type === "TemplateLiteral" ? e.expressions.length && e.quasis.length && e.quasis[0].range[0] === e.quasis[0].range[1] : e.type !== "Literal" || typeof e.value != "string";
}
var Mj = { meta: { type: "suggestion", docs: { description: "require template literals instead of string concatenation", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/prefer-template" }, schema: [], fixable: "code" }, create: function(e) {
  function t(s, o) {
    var u = [s].concat(i.getTokensBetween(s, o)).concat(o), c = i.getText();
    return u.slice(0, -1).reduce(function(f, p, d) {
      return f + c.slice(p.range[1], u[d + 1].range[0]);
    }, "");
  }
  function n(s, o, u) {
    if (s.type === "Literal" && typeof s.value == "string")
      return "`".concat(s.raw.slice(1, -1).replace(/\\*(\$\{|`)/g, function(y) {
        return y.lastIndexOf("\\") % 2 ? "\\".concat(y) : y;
      }).replace(new RegExp("\\\\".concat(s.raw[0]), "gu"), s.raw[0]), "`");
    if (s.type === "TemplateLiteral")
      return i.getText(s);
    if (Ls(s) && function y(v) {
      return Ls(v) ? y(v.right) || y(v.left) : P.isStringLiteral(v);
    }(s) && ef(s)) {
      var c = i.getFirstTokenBetween(s.left, s.right, function(y) {
        return y.value === "+";
      }), f = t(s.left, c), p = t(c, s.right), d = function(y) {
        return y.type === "BinaryExpression" ? d0(y.right) : y.type === "TemplateLiteral" ? y.expressions.length && y.quasis.length && y.quasis[y.quasis.length - 1].range[0] === y.quasis[y.quasis.length - 1].range[1] : y.type !== "Literal" || typeof y.value != "string";
      }(s.left), m = d0(s.right);
      return d ? n(s.left, o, f + p).slice(0, -1) + n(s.right, null, u).slice(1) : m ? n(s.left, o, null).slice(0, -1) + n(s.right, f + p, u).slice(1) : "".concat(n(s.left, o, null)).concat(f, "+").concat(p).concat(n(s.right, u, null));
    }
    return "`${".concat(o || "").concat(i.getText(s)).concat(u || "", "}`");
  }
  function r(s) {
    if (P.isStringLiteral(s) && Ls(s.parent)) {
      var o = H2(s.parent);
      a[o.range[0]] || (a[o.range[0]] = !0, ef(o) && e.report({ node: o, message: "Unexpected string concatenation.", fix: function(u) {
        return function(c, f) {
          var p = H2(f.parent);
          return h0(p) ? null : c.replaceText(p, n(p, null, null));
        }(u, s);
      } }));
    }
  }
  var i = e.getSourceCode(), a = /* @__PURE__ */ Object.create(null);
  return { Program: function() {
    a = /* @__PURE__ */ Object.create(null);
  }, Literal: r, TemplateLiteral: r };
} }, Vj = { meta: { type: "suggestion", docs: { description: "require quotes around object literal property names", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/quote-props" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }, { type: "object", properties: { keywords: { type: "boolean" }, unnecessary: { type: "boolean" }, numbers: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] }, fixable: "code" }, create: function(e) {
  function t(x) {
    return 0 <= Qp.indexOf(x);
  }
  function n(x, C, k) {
    return C.length === 1 && C[0].start === 0 && C[0].end === x.length && (0 <= ["Identifier", "Keyword", "Null", "Boolean"].indexOf(C[0].type) || C[0].type === "Numeric" && !k && +C[0].value + "" === C[0].value);
  }
  function r(x) {
    return x.type === "Identifier" ? x.name : x.value;
  }
  function i(x) {
    return x.type === "Literal" && typeof x.value == "string" ? b.getText(x) : '"'.concat(x.type === "Identifier" ? x.name : x.value, '"');
  }
  function a(x) {
    var C = x.key;
    if (!(x.method || x.computed || x.shorthand))
      if (C.type === "Literal" && typeof C.value == "string") {
        var k;
        try {
          k = ye.espree.tokenize(C.value);
        } catch {
          return;
        }
        if (k.length !== 1 || t(k[0].value) && c)
          return;
        f && n(C.value, k, p) && e.report({ node: x, message: d, data: { property: C.value }, fix: function(F) {
          return F.replaceText(C, r(C));
        } });
      } else
        c && C.type === "Identifier" && t(C.name) ? e.report({ node: x, message: v, data: { property: C.name }, fix: function(F) {
          return F.replaceText(C, i(C));
        } }) : p && C.type === "Literal" && typeof C.value == "number" && e.report({ node: x, message: y, data: { property: C.value }, fix: function(F) {
          return F.replaceText(C, i(C));
        } });
  }
  function s(x) {
    var C = x.key;
    x.method || x.computed || x.shorthand || C.type === "Literal" && typeof C.value == "string" || e.report({ node: x, message: m, data: { property: C.name || C.value }, fix: function(k) {
      return k.replaceText(C, i(C));
    } });
  }
  function o(x, C) {
    var k = [], F = [], B = null, O = !1;
    x.properties.forEach(function(S) {
      var w = S.key;
      if (w && !S.method && !S.computed && !S.shorthand) {
        if (w.type !== "Literal" || typeof w.value != "string")
          c && C && w.type === "Identifier" && t(w.name) ? (F.push(S), O = !0, B = w.name) : F.push(S);
        else if (k.push(S), C) {
          var D;
          try {
            D = ye.espree.tokenize(w.value);
          } catch {
            return void (O = !0);
          }
          O = O || !n(w.value, D) || c && t(D[0].value);
        }
      }
    }), C && k.length && !O ? k.forEach(function(S) {
      e.report({ node: S, message: "Properties shouldn't be quoted as all quotes are redundant.", fix: function(w) {
        return w.replaceText(S.key, r(S.key));
      } });
    }) : F.length && B ? F.forEach(function(S) {
      e.report({ node: S, message: "Properties should be quoted as '{{property}}' is a reserved word.", data: { property: B }, fix: function(w) {
        return w.replaceText(S.key, i(S.key));
      } });
    }) : k.length && F.length && F.forEach(function(S) {
      e.report({ node: S, message: "Inconsistently quoted property '{{key}}' found.", data: { key: S.key.name || S.key.value }, fix: function(w) {
        return w.replaceText(S.key, i(S.key));
      } });
    });
  }
  var u = e.options[0], c = e.options[1] && e.options[1].keywords, f = !e.options[1] || e.options[1].unnecessary !== !1, p = e.options[1] && e.options[1].numbers, d = "Unnecessarily quoted property '{{property}}' found.", m = "Unquoted property '{{property}}' found.", y = "Unquoted number literal '{{property}}' used as key.", v = "Unquoted reserved word '{{property}}' used as key.", b = e.getSourceCode();
  return { Property: function(x) {
    u !== "always" && u || s(x), u === "as-needed" && a(x);
  }, ObjectExpression: function(x) {
    u === "consistent" && o(x, !1), u === "consistent-as-needed" && o(x, !0);
  } };
} }, xp = { double: { quote: '"', alternateQuote: "'", description: "doublequote" }, single: { quote: "'", alternateQuote: '"', description: "singlequote" }, backtick: { quote: "`", alternateQuote: '"', description: "backtick" } }, Uj = /(^|(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(\\\\)*[]/;
xp.double.convert = xp.single.convert = xp.backtick.convert = function(e) {
  var t = this.quote, n = e[0];
  return t === n ? e : t + e.slice(1, -1).replace(/\\(\$\{|\r\n?|\n|(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))|["'`]|\$\{|(\r\n?|\n)/g, function(r, i, a) {
    return i === n || n === "`" && i === "${" ? i : r === t || t === "`" && r === "${" ? "\\".concat(r) : a && n === "`" ? "\\n" : r;
  }) + t;
};
var qj = { meta: { type: "layout", docs: { description: "enforce the consistent use of either backticks, double, or single quotes", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/quotes" }, fixable: "code", schema: [{ enum: ["single", "double", "backtick"] }, { anyOf: [{ enum: ["avoid-escape"] }, { type: "object", properties: { avoidEscape: { type: "boolean" }, allowTemplateLiterals: { type: "boolean" } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(f) {
    return f.type === "ExpressionStatement" && f.expression.type === "Literal" && typeof f.expression.value == "string";
  }
  function n(f) {
    var p = f.parent.parent;
    if (p.type !== "Program" && (p.type !== "BlockStatement" || !P.isFunction(p.parent)))
      return !1;
    for (var d = 0; d < p.body.length; ++d) {
      var m = p.body[d];
      if (m === f.parent)
        return !0;
      if (!t(m))
        break;
    }
    return !1;
  }
  function r(f) {
    var p = f.parent;
    switch (p.type) {
      case "ExpressionStatement":
        return n(f);
      case "Property":
      case "MethodDefinition":
        return p.key === f && !p.computed;
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
      case "ExportAllDeclaration":
        return p.source === f;
      default:
        return !1;
    }
  }
  var i = e.options[0], a = xp[i || "double"], s = e.options[1], o = s && s.allowTemplateLiterals === !0, u = e.getSourceCode(), c = s && s.avoidEscape === !0;
  return s === "avoid-escape" && (c = !0), { Literal: function(f) {
    var p = f.value, d = f.raw;
    if (a && typeof p == "string") {
      var m = i === "backtick" && r(f) || function(y) {
        return y.parent.type === "JSXAttribute" || y.parent.type === "JSXElement" || y.parent.type === "JSXFragment";
      }(f) || P.isSurroundedBy(d, a.quote);
      !m && c && (m = P.isSurroundedBy(d, a.alternateQuote) && 0 <= d.indexOf(a.quote)), m || e.report({ node: f, message: "Strings must use {{description}}.", data: { description: a.description }, fix: function(y) {
        return i === "backtick" && P.hasOctalEscapeSequence(d) ? null : y.replaceText(f, a.convert(f.raw));
      } });
    }
  }, TemplateLiteral: function(f) {
    o || i === "backtick" || function(p) {
      return p.parent.type === "TaggedTemplateExpression" && p === p.parent.quasi || 0 < p.expressions.length || !!(1 <= p.quasis.length && Uj.test(p.quasis[0].value.raw));
    }(f) || e.report({ node: f, message: "Strings must use {{description}}.", data: { description: a.description }, fix: function(p) {
      return n(f) ? null : p.replaceText(f, a.convert(u.getText(f)));
    } });
  } };
} }, K2 = "always", Wj = "as-needed";
function J2(e) {
  return 1 <= e.defs.length;
}
var $j = { meta: { type: "suggestion", docs: { description: "enforce the consistent use of the radix argument when using `parseInt()`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/radix" }, schema: [{ enum: ["always", "as-needed"] }] }, create: function(e) {
  function t(r) {
    var i = r.arguments;
    switch (i.length) {
      case 0:
        e.report({ node: r, message: "Missing parameters." });
        break;
      case 1:
        n === K2 && e.report({ node: r, message: "Missing radix parameter." });
        break;
      default:
        n === Wj && function(a) {
          return a.type === "Literal" && a.value === 10;
        }(i[1]) ? e.report({ node: r, message: "Redundant radix parameter." }) : !function(a) {
          return !(a.type === "Literal" && typeof a.value != "number" || a.type === "Identifier" && a.name === "undefined");
        }(i[1]) && e.report({ node: r, message: "Invalid radix parameter." });
    }
  }
  var n = e.options[0] || K2;
  return { "Program:exit": function() {
    var r, i = e.getScope();
    J2(r = P.getVariableByName(i, "parseInt")) || r.references.forEach(function(a) {
      var s = a.identifier;
      P.isCallee(s) && t(s.parent);
    }), J2(r = P.getVariableByName(i, "Number")) || r.references.forEach(function(a) {
      var s = a.identifier.parent;
      (function(o) {
        return o.type === "MemberExpression" && !o.computed && o.property.type === "Identifier" && o.property.name === "parseInt";
      })(s) && P.isCallee(s) && t(s.parent);
    });
  } };
} };
function HA(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /* @__PURE__ */ new Map(), n = !0, r = !1, i = void 0;
  try {
    for (var a, s = e.references[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
      var o = a.value;
      t.set(o.identifier, o);
    }
  } catch (y) {
    r = !0, i = y;
  } finally {
    try {
      n || s.return == null || s.return();
    } finally {
      if (r)
        throw i;
    }
  }
  var u = !0, c = !1, f = void 0;
  try {
    for (var p, d = e.childScopes[Symbol.iterator](); !(u = (p = d.next()).done); u = !0) {
      var m = p.value;
      m.type !== "function" && HA(m, t);
    }
  } catch (y) {
    c = !0, f = y;
  } finally {
    try {
      u || d.return == null || d.return();
    } finally {
      if (c)
        throw f;
    }
  }
  return t;
}
var Gj = function() {
  function e() {
    We(this, e), this.info = /* @__PURE__ */ new WeakMap();
  }
  return Xe(e, [{ key: "initialize", value: function(t) {
    var n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !0, a = !1, s = void 0;
    try {
      for (var o, u = t.prevSegments[Symbol.iterator](); !(i = (o = u.next()).done); i = !0) {
        var c = o.value, f = this.info.get(c);
        f && (f.outdatedReadVariableNames.forEach(Set.prototype.add, n), f.freshReadVariableNames.forEach(Set.prototype.add, r));
      }
    } catch (p) {
      a = !0, s = p;
    } finally {
      try {
        i || u.return == null || u.return();
      } finally {
        if (a)
          throw s;
      }
    }
    this.info.set(t, { outdatedReadVariableNames: n, freshReadVariableNames: r });
  } }, { key: "markAsRead", value: function(t, n) {
    var r = !0, i = !1, a = void 0;
    try {
      for (var s, o = t[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
        var u = s.value, c = this.info.get(u);
        c && c.freshReadVariableNames.add(n);
      }
    } catch (f) {
      i = !0, a = f;
    } finally {
      try {
        r || o.return == null || o.return();
      } finally {
        if (i)
          throw a;
      }
    }
  } }, { key: "makeOutdated", value: function(t) {
    var n = !0, r = !1, i = void 0;
    try {
      for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done); n = !0) {
        var o = a.value, u = this.info.get(o);
        u && (u.freshReadVariableNames.forEach(Set.prototype.add, u.outdatedReadVariableNames), u.freshReadVariableNames.clear());
      }
    } catch (c) {
      r = !0, i = c;
    } finally {
      try {
        n || s.return == null || s.return();
      } finally {
        if (r)
          throw i;
      }
    }
  } }, { key: "isOutdated", value: function(t, n) {
    var r = !0, i = !1, a = void 0;
    try {
      for (var s, o = t[Symbol.iterator](); !(r = (s = o.next()).done); r = !0) {
        var u = s.value, c = this.info.get(u);
        if (c && c.outdatedReadVariableNames.has(n))
          return !0;
      }
    } catch (f) {
      i = !0, a = f;
    } finally {
      try {
        r || o.return == null || o.return();
      } finally {
        if (i)
          throw a;
      }
    }
    return !1;
  } }]), e;
}(), zj = { meta: { type: "problem", docs: { description: "disallow assignments that can lead to race conditions due to usage of `await` or `yield`", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/require-atomic-updates" }, fixable: null, schema: [], messages: { nonAtomicUpdate: "Possible race condition: `{{value}}` might be reassigned based on an outdated value of `{{value}}`." } }, create: function(e) {
  var t = e.getSourceCode(), n = /* @__PURE__ */ new Map(), r = new Gj(), i = null;
  return { onCodePathStart: function(a) {
    var s = e.getScope(), o = s.type === "function" && (s.block.async || s.block.generator);
    i = { upper: i, codePath: a, referenceMap: o ? HA(s) : null };
  }, onCodePathEnd: function() {
    i = i.upper;
  }, onCodePathSegmentStart: function(a) {
    r.initialize(a);
  }, Identifier: function(a) {
    var s = i, o = s.codePath, u = s.referenceMap, c = u && u.get(a);
    if (c) {
      var f = c.identifier.name, p = c.resolved, d = function(v) {
        if (v.writeExpr)
          return v.writeExpr;
        for (var b = v.identifier; b; ) {
          var x = b.parent.type;
          if (x === "AssignmentExpression" && b.parent.left === b)
            return b.parent.right;
          if (x !== "MemberExpression" || b.parent.object !== b)
            break;
          b = b.parent;
        }
        return null;
      }(c), m = c.identifier.parent.type === "MemberExpression";
      if (c.isRead() && !(d && d.parent.operator === "=") && r.markAsRead(o.currentSegments, f), d && d.parent.right === d && !function(v, b) {
        if (!v || b && v.defs.some(function(C) {
          return C.type === "Parameter";
        }))
          return !1;
        var x = v.scope.variableScope;
        return v.references.every(function(C) {
          return C.from.variableScope === x;
        });
      }(p, m)) {
        var y = n.get(d);
        y || (y = [], n.set(d, y)), y.push(c);
      }
    }
  }, ":expression:exit": function(a) {
    var s = i, o = s.codePath;
    if (s.referenceMap) {
      (a.type === "AwaitExpression" || a.type === "YieldExpression") && r.makeOutdated(o.currentSegments);
      var u = n.get(a);
      if (u) {
        n.delete(a);
        var c = !0, f = !1, p = void 0;
        try {
          for (var d, m = u[Symbol.iterator](); !(c = (d = m.next()).done); c = !0) {
            var y = d.value.identifier.name;
            r.isOutdated(o.currentSegments, y) && e.report({ node: a.parent, messageId: "nonAtomicUpdate", data: { value: t.getText(a.parent.left) } });
          }
        } catch (v) {
          f = !0, p = v;
        } finally {
          try {
            c || m.return == null || m.return();
          } finally {
            if (f)
              throw p;
          }
        }
      }
    }
  } };
} };
function Hj(e) {
  return e[0].toUpperCase() + e.slice(1);
}
var Kj = { meta: { type: "suggestion", docs: { description: "disallow async functions which have no `await` expression", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/require-await" }, schema: [] }, create: function(e) {
  function t() {
    i = { upper: i, hasAwait: !1 };
  }
  function n(a) {
    !a.async || i.hasAwait || P.isEmptyFunction(a) || e.report({ node: a, loc: P.getFunctionHeadLoc(a, r), message: "{{name}} has no 'await' expression.", data: { name: Hj(P.getFunctionNameWithKind(a)) } }), i = i.upper;
  }
  var r = e.getSourceCode(), i = null;
  return { FunctionDeclaration: t, FunctionExpression: t, ArrowFunctionExpression: t, "FunctionDeclaration:exit": n, "FunctionExpression:exit": n, "ArrowFunctionExpression:exit": n, AwaitExpression: function() {
    i && (i.hasAwait = !0);
  }, ForOfStatement: function(a) {
    !i || a.await && (i.hasAwait = !0);
  } };
} }, Jj = { meta: { type: "suggestion", docs: { description: "require JSDoc comments", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/require-jsdoc" }, schema: [{ type: "object", properties: { require: { type: "object", properties: { ClassDeclaration: { type: "boolean", default: !1 }, MethodDefinition: { type: "boolean", default: !1 }, FunctionDeclaration: { type: "boolean", default: !0 }, ArrowFunctionExpression: { type: "boolean", default: !1 }, FunctionExpression: { type: "boolean", default: !1 } }, additionalProperties: !1, default: {} } }, additionalProperties: !1 }], deprecated: !0, replacedBy: [] }, create: function(e) {
  function t(a) {
    e.report({ node: a, message: "Missing JSDoc comment." });
  }
  function n(a) {
    r.getJSDocComment(a) || t(a);
  }
  var r = e.getSourceCode(), i = Object.assign({ FunctionDeclaration: !0, MethodDefinition: !1, ClassDeclaration: !1, ArrowFunctionExpression: !1, FunctionExpression: !1 }, e.options[0] && e.options[0].require);
  return { FunctionDeclaration: function(a) {
    i.FunctionDeclaration && n(a);
  }, FunctionExpression: function(a) {
    (i.MethodDefinition && a.parent.type === "MethodDefinition" || i.FunctionExpression && (a.parent.type === "VariableDeclarator" || a.parent.type === "Property" && a === a.parent.value)) && n(a);
  }, ClassDeclaration: function(a) {
    i.ClassDeclaration && n(a);
  }, ArrowFunctionExpression: function(a) {
    i.ArrowFunctionExpression && a.parent.type === "VariableDeclarator" && n(a);
  } };
} }, kf = ye.require$$0, Qj = kf.CALL, Xj = kf.CONSTRUCT, Yj = kf.ReferenceTracker, Zj = kf.getStringIfConstant, eR = { meta: { type: "suggestion", docs: { description: "enforce the use of `u` flag on RegExp", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/require-unicode-regexp" }, messages: { requireUFlag: "Use the 'u' flag." }, schema: [] }, create: function(e) {
  return { "Literal[regex]": function(t) {
    (t.regex.flags || "").includes("u") || e.report({ node: t, messageId: "requireUFlag" });
  }, Program: function() {
    var t, n = e.getScope(), r = new Yj(n), i = { RegExp: (t = {}, Fn(t, Qj, !0), Fn(t, Xj, !0), t) }, a = !0, s = !1, o = void 0;
    try {
      for (var u, c = r.iterateGlobalReferences(i)[Symbol.iterator](); !(a = (u = c.next()).done); a = !0) {
        var f = u.value.node, p = f.arguments[1], d = Zj(p, n);
        p && (typeof d != "string" || d.includes("u")) || e.report({ node: f, messageId: "requireUFlag" });
      }
    } catch (m) {
      s = !0, o = m;
    } finally {
      try {
        a || c.return == null || c.return();
      } finally {
        if (s)
          throw o;
      }
    }
  } };
} }, tR = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after semicolons", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/semi-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: !1 }, after: { type: "boolean", default: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o, u) {
    if (P.isSemicolonToken(o)) {
      var c = o.loc.start;
      (function(f) {
        var p = i.getTokenBefore(f);
        return p && P.isTokenOnSameLine(p, f) && i.isSpaceBetweenTokens(p, f);
      })(o) ? !a && e.report({ node: u, loc: c, message: "Unexpected whitespace before semicolon.", fix: function(f) {
        var p = i.getTokenBefore(o);
        return f.removeRange([p.range[1], o.range[0]]);
      } }) : a && e.report({ node: u, loc: c, message: "Missing whitespace before semicolon.", fix: function(f) {
        return f.insertTextBefore(o, " ");
      } }), function(f) {
        var p = i.getTokenBefore(f);
        return !(p && P.isTokenOnSameLine(f, p));
      }(o) || function(f) {
        var p = i.getTokenAfter(f);
        return !(p && P.isTokenOnSameLine(f, p));
      }(o) || function(f) {
        var p = i.getTokenAfter(f);
        return p && P.isClosingBraceToken(p) || P.isClosingParenToken(p);
      }(o) || (function(f) {
        var p = i.getTokenAfter(f);
        return p && P.isTokenOnSameLine(f, p) && i.isSpaceBetweenTokens(f, p);
      }(o) ? !s && e.report({ node: u, loc: c, message: "Unexpected whitespace after semicolon.", fix: function(f) {
        var p = i.getTokenAfter(o);
        return f.removeRange([o.range[1], p.range[0]]);
      } }) : s && e.report({ node: u, loc: c, message: "Missing whitespace after semicolon.", fix: function(f) {
        return f.insertTextAfter(o, " ");
      } }));
    }
  }
  function n(o) {
    t(i.getLastToken(o), o);
  }
  var r = e.options[0], i = e.getSourceCode(), a = !1, s = !0;
  return xe(r) == "object" && (a = r.before, s = r.after), { VariableDeclaration: n, ExpressionStatement: n, BreakStatement: n, ContinueStatement: n, DebuggerStatement: n, ReturnStatement: n, ThrowStatement: n, ImportDeclaration: n, ExportNamedDeclaration: n, ExportAllDeclaration: n, ExportDefaultDeclaration: n, ForStatement: function(o) {
    o.init && t(i.getTokenAfter(o.init), o), o.test && t(i.getTokenAfter(o.test), o);
  } };
} }, nR = ":matches(".concat("BreakStatement,ContinueStatement,DebuggerStatement,DoWhileStatement,ExportAllDeclaration,ExportDefaultDeclaration,ExportNamedDeclaration,ExpressionStatement,ImportDeclaration,ReturnStatement,ThrowStatement,VariableDeclaration", ")"), Ju = { asc: function(e, t) {
  return e <= t;
}, ascI: function(e, t) {
  return e.toLowerCase() <= t.toLowerCase();
}, ascN: function(e, t) {
  return 0 >= Yb(e, t);
}, ascIN: function(e, t) {
  return 0 >= Yb(e.toLowerCase(), t.toLowerCase());
}, desc: function(e, t) {
  return Ju.asc(t, e);
}, descI: function(e, t) {
  return Ju.ascI(t, e);
}, descN: function(e, t) {
  return Ju.ascN(t, e);
}, descIN: function(e, t) {
  return Ju.ascIN(t, e);
} };
function gc(e) {
  return "(?:".concat(ye.lodash.escapeRegExp(e), ")");
}
function Q2(e) {
  return "".concat(gc(e), "+");
}
function KA(e) {
  var t = "";
  return e.length === 0 ? t += "\\s" : (t += "(?:\\s|", e.length === 1 ? t += Q2(e[0]) : (t += "(?:", t += e.map(Q2).join("|"), t += ")"), t += "(?:$|[".concat(Array.from(P.LINEBREAKS).join(""), "]))")), t;
}
function rR(e, t) {
  var n = "^";
  return e.length === 1 ? n += gc(e[0]) : (n += "(?:", n += e.map(gc).join("|"), n += ")"), n += "?", n += KA(t), new RegExp(n, "u");
}
function iR(e) {
  var t = "^(".concat(e.map(gc).join("|"), ")?[ 	]+");
  return new RegExp(t, "u");
}
function X2(e) {
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    if (r.type !== "ExpressionStatement" || r.expression.type !== "Literal" || r.expression.value !== "use strict")
      break;
    t[n] = r;
  }
  return t;
}
function aR(e) {
  return e.type === "Identifier";
}
function fm(e) {
  return e.every(aR);
}
var oR = /\$\{$/, sR = /^\}/;
function Lu(e) {
  return !!e && e.type === "Identifier" && e.name === "NaN";
}
function Y2(e) {
  return 0 <= ["<", "<="].indexOf(e);
}
function m0(e) {
  return e.type === "UnaryExpression" && e.operator === "-" && e.prefix && e.argument.type === "Literal" && typeof e.argument.value == "number";
}
function ep(e, t) {
  return e.type === "Literal" ? e : m0(e) ? { type: "Literal", value: -e.argument.value, raw: "-".concat(e.argument.value) } : t ? { type: "Literal", value: t, raw: t + "" } : null;
}
function rc(e, t) {
  if (e.type !== t.type)
    return !1;
  switch (e.type) {
    case "Identifier":
      return e.name === t.name;
    case "Literal":
      return e.value === t.value;
    case "MemberExpression":
      var n = P.getStaticPropertyName(e);
      return n === null ? e.computed === t.computed && rc(e.object, t.object) && rc(e.property, t.property) : rc(e.object, t.object) && n === P.getStaticPropertyName(t);
    case "ThisExpression":
      return !0;
    default:
      return !1;
  }
}
var uR = { "accessor-pairs": PI, "array-bracket-newline": II, "array-bracket-spacing": BI, "array-callback-return": VI, "array-element-newline": UI, "arrow-body-style": qI, "arrow-parens": WI, "arrow-spacing": $I, "block-scoped-var": { meta: { type: "suggestion", docs: { description: "enforce the use of variables within the scope they are defined", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/block-scoped-var" }, schema: [], messages: { outOfScope: "'{{name}}' used outside of binding context." } }, create: function(e) {
  function t(a) {
    i.push(a.range);
  }
  function n() {
    i.pop();
  }
  function r(a) {
    var s = a.identifier;
    e.report({ node: s, messageId: "outOfScope", data: { name: s.name } });
  }
  var i = [];
  return { Program: function(a) {
    i = [a.range];
  }, BlockStatement: t, "BlockStatement:exit": n, ForStatement: t, "ForStatement:exit": n, ForInStatement: t, "ForInStatement:exit": n, ForOfStatement: t, "ForOfStatement:exit": n, SwitchStatement: t, "SwitchStatement:exit": n, CatchClause: t, "CatchClause:exit": n, VariableDeclaration: function(a) {
    function s(f) {
      var p = f.identifier.range;
      return p[0] < o[0] || p[1] > o[1];
    }
    if (a.kind === "var")
      for (var o = i[i.length - 1], u = e.getDeclaredVariables(a), c = 0; c < u.length; ++c)
        u[c].references.filter(s).forEach(r);
  } };
} }, "block-spacing": GI, "brace-style": zI, "callback-return": { meta: { type: "suggestion", docs: { description: "require `return` statements after callbacks", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/callback-return" }, schema: [{ type: "array", items: { type: "string" } }], messages: { missingReturn: "Expected return with your callback function." } }, create: function(e) {
  function t(s, o) {
    return s.parent ? o.indexOf(s.parent.type) === -1 ? t(s.parent, o) : s.parent : null;
  }
  function n(s) {
    return function o(u) {
      if (u.type === "Identifier")
        return !0;
      if (u.type === "MemberExpression") {
        if (u.object.type === "Identifier")
          return !0;
        if (u.object.type === "MemberExpression")
          return o(u.object);
      }
      return !1;
    }(s.callee) && -1 < i.indexOf(a.getText(s.callee));
  }
  function r(s, o) {
    return !(!o || o.type !== "ExpressionStatement" || o.expression !== s && (o.expression.type !== "BinaryExpression" && o.expression.type !== "LogicalExpression" || o.expression.right !== s));
  }
  var i = e.options[0] || ["callback", "cb", "next"], a = e.getSourceCode();
  return { CallExpression: function(s) {
    if (n(s)) {
      var o = t(s, ["BlockStatement", "ReturnStatement", "ArrowFunctionExpression"]) || {};
      if (o.type !== "ReturnStatement" && o.type !== "ArrowFunctionExpression") {
        if (o.type === "BlockStatement") {
          var u = o.body[o.body.length - 1];
          if (r(s, u)) {
            var c = o.parent.type;
            if (c === "FunctionExpression" || c === "FunctionDeclaration" || c === "ArrowFunctionExpression")
              return;
          }
          if (u.type === "ReturnStatement" && r(s, o.body[o.body.length - 2]))
            return;
        }
        t(s, ["FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"]) && e.report({ node: s, messageId: "missingReturn" });
      }
    }
  } };
} }, camelcase: HI, "capitalized-comments": YI, "class-methods-use-this": ZI, "comma-dangle": e5, "comma-spacing": t5, "comma-style": n5, complexity: r5, "computed-property-spacing": i5, "consistent-return": o5, "consistent-this": { meta: { type: "suggestion", docs: { description: "enforce consistent naming when capturing the current execution context", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/consistent-this" }, schema: { type: "array", items: { type: "string", minLength: 1 }, uniqueItems: !0 }, messages: { aliasNotAssignedToThis: "Designated alias '{{name}}' is not assigned to 'this'.", unexpectedAlias: "Unexpected alias '{{name}}' for 'this'." } }, create: function(e) {
  function t(s, o) {
    e.report({ node: s, messageId: "aliasNotAssignedToThis", data: { name: o } });
  }
  function n(s, o, u) {
    var c = u.type === "ThisExpression";
    a.indexOf(o) === -1 ? c && e.report({ node: s, messageId: "unexpectedAlias", data: { name: o } }) : (!c || s.operator && s.operator !== "=") && t(s, o);
  }
  function r(s, o) {
    var u = o.set.get(s);
    u && !u.defs.some(function(c) {
      return c.node.type === "VariableDeclarator" && c.node.init !== null;
    }) && (u.references.some(function(c) {
      var f = c.writeExpr;
      return c.from === o && f && f.type === "ThisExpression" && f.parent.operator === "=";
    }) || u.defs.map(function(c) {
      return c.node;
    }).forEach(function(c) {
      t(c, s);
    }));
  }
  function i() {
    var s = e.getScope();
    a.forEach(function(o) {
      r(o, s);
    });
  }
  var a = [];
  return e.options.length === 0 ? a.push("that") : a = e.options, { "Program:exit": i, "FunctionExpression:exit": i, "FunctionDeclaration:exit": i, VariableDeclarator: function(s) {
    var o = s.id, u = o.type === "ArrayPattern" || o.type === "ObjectPattern";
    s.init === null || u || n(s, o.name, s.init);
  }, AssignmentExpression: function(s) {
    s.left.type === "Identifier" && n(s, s.left.name, s.right);
  } };
} }, "constructor-super": u5, curly: c5, "default-case": p5, "default-param-last": { meta: { type: "suggestion", docs: { description: "enforce default parameters to be last", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/default-param-last" }, schema: [], messages: { shouldBeLast: "Default parameters should be last." } }, create: function(e) {
  function t(n) {
    for (var r = !1, i = n.params.length - 1; 0 <= i; i -= 1) {
      var a = n.params[i];
      a.type === "AssignmentPattern" || a.type === "RestElement" ? r && a.type === "AssignmentPattern" && e.report({ node: a, messageId: "shouldBeLast" }) : r = !0;
    }
  }
  return { FunctionDeclaration: t, FunctionExpression: t, ArrowFunctionExpression: t };
} }, "dot-location": f5, "dot-notation": m5, "eol-last": g5, eqeqeq: y5, "for-direction": { meta: { type: "problem", docs: { description: 'enforce "for" loop update clause moving the counter in the right direction.', category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/for-direction" }, fixable: null, schema: [], messages: { incorrectDirection: "The update clause in this loop moves the variable in the wrong direction." } }, create: function(e) {
  function t(r) {
    e.report({ node: r, messageId: "incorrectDirection" });
  }
  function n(r, i) {
    if (r.right.type === "UnaryExpression") {
      if (r.right.operator === "-")
        return -i;
    } else if (r.right.type === "Identifier")
      return 0;
    return i;
  }
  return { ForStatement: function(r) {
    if (r.test && r.test.type === "BinaryExpression" && r.test.left.type === "Identifier" && r.update) {
      var i, a = r.test.left.name, s = r.test.operator, o = r.update;
      if (s === "<" || s === "<=")
        i = -1;
      else {
        if (s !== ">" && s !== ">=")
          return;
        i = 1;
      }
      o.type === "UpdateExpression" ? function(u, c) {
        if (u.argument.type === "Identifier" && u.argument.name === c) {
          if (u.operator === "++")
            return 1;
          if (u.operator === "--")
            return -1;
        }
        return 0;
      }(o, a) === i && t(r) : o.type === "AssignmentExpression" && function(u, c) {
        if (u.left.name === c) {
          if (u.operator === "+=")
            return n(u, 1);
          if (u.operator === "-=")
            return n(u, -1);
        }
        return 0;
      }(o, a) === i && t(r);
    }
  } };
} }, "func-call-spacing": v5, "func-name-matching": x5, "func-names": b5, "func-style": { meta: { type: "suggestion", docs: { description: "enforce the consistent use of either `function` declarations or expressions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/func-style" }, schema: [{ enum: ["declaration", "expression"] }, { type: "object", properties: { allowArrowFunctions: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { expression: "Expected a function expression.", declaration: "Expected a function declaration." } }, create: function(e) {
  var t = e.options[0], n = e.options[1] && e.options[1].allowArrowFunctions, r = t === "declaration", i = [], a = { FunctionDeclaration: function(s) {
    i.push(!1), r || s.parent.type === "ExportDefaultDeclaration" || e.report({ node: s, messageId: "expression" });
  }, "FunctionDeclaration:exit": function() {
    i.pop();
  }, FunctionExpression: function(s) {
    i.push(!1), r && s.parent.type === "VariableDeclarator" && e.report({ node: s.parent, messageId: "declaration" });
  }, "FunctionExpression:exit": function() {
    i.pop();
  }, ThisExpression: function() {
    0 < i.length && (i[i.length - 1] = !0);
  } };
  return n || (a.ArrowFunctionExpression = function() {
    i.push(!1);
  }, a["ArrowFunctionExpression:exit"] = function(s) {
    var o = i.pop();
    r && !o && s.parent.type === "VariableDeclarator" && e.report({ node: s.parent, messageId: "declaration" });
  }), a;
} }, "function-call-argument-newline": { meta: { type: "layout", docs: { description: "enforce line breaks between arguments of a function call", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/function-call-argument-newline" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "consistent"] }], messages: { unexpectedLineBreak: "There should be no line break here.", missingLineBreak: "There should be a line break after this argument." } }, create: function(e) {
  function t(a, s) {
    for (var o = 1; o < a.arguments.length; o++) {
      var u = r.getLastToken(a.arguments[o - 1]), c = r.getFirstToken(a.arguments[o]);
      if (s.check(u, c)) {
        var f = r.getTokenBefore(c, { includeComments: !0 }), p = f.type === "Line";
        e.report({ node: a, loc: { start: f.loc.end, end: c.loc.start }, messageId: s.messageId, fix: p ? null : s.createFix(c, f) });
      }
    }
  }
  function n(a) {
    if (!(2 > a.arguments.length)) {
      var s = e.options[0] || "always";
      if (s === "never")
        t(a, i.unexpected);
      else if (s === "always")
        t(a, i.missing);
      else if (s === "consistent") {
        var o = r.getLastToken(a.arguments[0]), u = r.getFirstToken(a.arguments[1]);
        o.loc.end.line === u.loc.start.line ? t(a, i.unexpected) : t(a, i.missing);
      }
    }
  }
  var r = e.getSourceCode(), i = { unexpected: { messageId: "unexpectedLineBreak", check: function(a, s) {
    return a.loc.end.line !== s.loc.start.line;
  }, createFix: function(a, s) {
    return function(o) {
      return o.replaceTextRange([s.range[1], a.range[0]], " ");
    };
  } }, missing: { messageId: "missingLineBreak", check: function(a, s) {
    return a.loc.end.line === s.loc.start.line;
  }, createFix: function(a, s) {
    return function(o) {
      return o.replaceTextRange([s.range[1], a.range[0]], `
`);
    };
  } } };
  return { CallExpression: n, NewExpression: n };
} }, "function-paren-newline": E5, "generator-star-spacing": C5, "getter-return": F5, "global-require": A5, "grouped-accessor-pairs": T5, "guard-for-in": { meta: { type: "suggestion", docs: { description: "require `for-in` loops to include an `if` statement", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/guard-for-in" }, schema: [], messages: { wrap: "The body of a for-in should be wrapped in an if statement to filter unwanted properties from the prototype." } }, create: function(e) {
  return { ForInStatement: function(t) {
    var n = t.body;
    if (!(n.type === "EmptyStatement" || n.type === "IfStatement" || n.type === "BlockStatement" && n.body.length === 0 || n.type === "BlockStatement" && n.body.length === 1 && n.body[0].type === "IfStatement")) {
      if (n.type === "BlockStatement" && 1 <= n.body.length && n.body[0].type === "IfStatement") {
        var r = n.body[0];
        if (r.consequent.type === "ContinueStatement" || r.consequent.type === "BlockStatement" && r.consequent.body.length === 1 && r.consequent.body[0].type === "ContinueStatement")
          return;
      }
      e.report({ node: t, messageId: "wrap" });
    }
  } };
} }, "handle-callback-err": P5, "id-blacklist": { meta: { type: "suggestion", docs: { description: "disallow specified identifiers", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/id-blacklist" }, schema: { type: "array", items: { type: "string" }, uniqueItems: !0 }, messages: { blacklisted: "Identifier '{{name}}' is blacklisted." } }, create: function(e) {
  function t(a) {
    return i.indexOf(a) !== -1;
  }
  function n(a, s) {
    return a.type !== "CallExpression" && a.type !== "NewExpression" && t(s);
  }
  function r(a) {
    e.report({ node: a, messageId: "blacklisted", data: { name: a.name } });
  }
  var i = e.options;
  return { Identifier: function(a) {
    var s = a.name, o = a.parent.type === "MemberExpression" ? a.parent.parent : a.parent;
    a.parent.type === "MemberExpression" ? a.parent.object.type === "Identifier" && a.parent.object.name === a.name ? t(s) && r(a) : o.type === "AssignmentExpression" && (o.right.type !== "MemberExpression" || o.left.type === "MemberExpression" && o.left.property.name === a.name) && t(s) && r(a) : (a.parent.type, n(o, s) && r(a));
  } };
} }, "id-length": { meta: { type: "suggestion", docs: { description: "enforce minimum and maximum identifier lengths", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/id-length" }, schema: [{ type: "object", properties: { min: { type: "integer", default: 2 }, max: { type: "integer" }, exceptions: { type: "array", uniqueItems: !0, items: { type: "string" } }, properties: { enum: ["always", "never"] } }, additionalProperties: !1 }], messages: { tooShort: "Identifier name '{{name}}' is too short (< {{min}}).", tooLong: "Identifier name '{{name}}' is too long (> {{max}})." } }, create: function(e) {
  var t = e.options[0] || {}, n = t.min === void 0 ? 2 : t.min, r = t.max === void 0 ? 1 / 0 : t.max, i = t.properties !== "never", a = (t.exceptions ? t.exceptions : []).reduce(function(o, u) {
    return o[u] = !0, o;
  }, {}), s = { MemberExpression: i && function(o) {
    return !o.computed && (o.parent.left === o && o.parent.type === "AssignmentExpression" || o.parent.type === "Property" && o.parent.value === o && o.parent.parent.type === "ObjectPattern" && o.parent.parent.parent.left === o.parent.parent);
  }, AssignmentPattern: function(o, u) {
    return o.left === u;
  }, VariableDeclarator: function(o, u) {
    return o.id === u;
  }, Property: i && function(o, u) {
    return o.key === u;
  }, ImportDefaultSpecifier: !0, RestElement: !0, FunctionExpression: !0, ArrowFunctionExpression: !0, ClassDeclaration: !0, FunctionDeclaration: !0, MethodDefinition: !0, CatchClause: !0 };
  return { Identifier: function(o) {
    var u = o.name, c = o.parent, f = u.length < n, p = u.length > r;
    if ((f || p) && !a[u]) {
      var d = s[c.type];
      d && (d === !0 || d(c, o)) && e.report({ node: o, messageId: f ? "tooShort" : "tooLong", data: { name: u, min: n, max: r } });
    }
  } };
} }, "id-match": I5, "implicit-arrow-linebreak": L5, "indent-legacy": N5, indent: U5, "init-declarations": W5, "jsx-quotes": G5, "key-spacing": z5, "keyword-spacing": X5, "line-comment-position": Y5, "linebreak-style": Z5, "lines-around-comment": eB, "lines-around-directive": tB, "lines-between-class-members": nB, "max-classes-per-file": { meta: { type: "suggestion", docs: { description: "enforce a maximum number of classes per file", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/max-classes-per-file" }, schema: [{ type: "integer", minimum: 1 }], messages: { maximumExceeded: "File has too many classes ({{ classCount }}). Maximum allowed is {{ max }}." } }, create: function(e) {
  var t = e.options[0] || 1, n = 0;
  return { Program: function() {
    n = 0;
  }, "Program:exit": function(r) {
    n > t && e.report({ node: r, messageId: "maximumExceeded", data: { classCount: n, max: t } });
  }, "ClassDeclaration, ClassExpression": function() {
    n++;
  } };
} }, "max-depth": rB, "max-len": iB, "max-lines-per-function": aB, "max-lines": oB, "max-nested-callbacks": sB, "max-params": uB, "max-statements-per-line": cB, "max-statements": lB, "multiline-comment-style": pB, "multiline-ternary": fB, "new-cap": hB, "new-parens": dB, "newline-after-var": mB, "newline-before-return": gB, "newline-per-chained-call": yB, "no-alert": xB, "no-array-constructor": { meta: { type: "suggestion", docs: { description: "disallow `Array` constructors", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-array-constructor" }, schema: [], messages: { preferLiteral: "The array literal notation [] is preferable." } }, create: function(e) {
  function t(n) {
    n.arguments.length !== 1 && n.callee.type === "Identifier" && n.callee.name === "Array" && e.report({ node: n, messageId: "preferLiteral" });
  }
  return { CallExpression: t, NewExpression: t };
} }, "no-async-promise-executor": { meta: { type: "problem", docs: { description: "disallow using an async function as a Promise executor", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-async-promise-executor" }, fixable: null, schema: [], messages: { async: "Promise executor functions should not be async." } }, create: function(e) {
  return { "NewExpression[callee.name='Promise'][arguments.0.async=true]": function(t) {
    e.report({ node: e.getSourceCode().getFirstToken(t.arguments[0], function(n) {
      return n.value === "async";
    }), messageId: "async" });
  } };
} }, "no-await-in-loop": CB, "no-bitwise": SB, "no-buffer-constructor": { meta: { type: "problem", docs: { description: "disallow use of the `Buffer()` constructor", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-buffer-constructor" }, schema: [], messages: { deprecated: "{{expr}} is deprecated. Use Buffer.from(), Buffer.alloc(), or Buffer.allocUnsafe() instead." } }, create: function(e) {
  return { "CallExpression[callee.name='Buffer'], NewExpression[callee.name='Buffer']": function(t) {
    e.report({ node: t, messageId: "deprecated", data: { expr: t.type === "CallExpression" ? "Buffer()" : "new Buffer()" } });
  } };
} }, "no-caller": { meta: { type: "suggestion", docs: { description: "disallow the use of `arguments.caller` or `arguments.callee`", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-caller" }, schema: [], messages: { unexpected: "Avoid arguments.{{prop}}." } }, create: function(e) {
  return { MemberExpression: function(t) {
    var n = t.object.name, r = t.property.name;
    n === "arguments" && !t.computed && r && r.match(/^calle[er]$/) && e.report({ node: t, messageId: "unexpected", data: { prop: r } });
  } };
} }, "no-case-declarations": { meta: { type: "suggestion", docs: { description: "disallow lexical declarations in case clauses", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-case-declarations" }, schema: [], messages: { unexpected: "Unexpected lexical declaration in case block." } }, create: function(e) {
  function t(n) {
    switch (n.type) {
      case "FunctionDeclaration":
      case "ClassDeclaration":
        return !0;
      case "VariableDeclaration":
        return n.kind !== "var";
      default:
        return !1;
    }
  }
  return { SwitchCase: function(n) {
    for (var r = 0; r < n.consequent.length; r++) {
      var i = n.consequent[r];
      t(i) && e.report({ node: i, messageId: "unexpected" });
    }
  } };
} }, "no-catch-shadow": kB, "no-class-assign": DB, "no-compare-neg-zero": FB, "no-cond-assign": _B, "no-confusing-arrow": TB, "no-console": PB, "no-const-assign": IB, "no-constant-condition": LB, "no-constructor-return": { meta: { type: "problem", docs: { description: "disallow returning value from constructor", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-constructor-return" }, schema: {}, fixable: null, messages: { unexpected: "Unexpected return statement in constructor." } }, create: function(e) {
  var t = [];
  return { onCodePathStart: function(n, r) {
    t.push(r);
  }, onCodePathEnd: function() {
    t.pop();
  }, ReturnStatement: function(n) {
    var r = t[t.length - 1];
    !r.parent || r.parent.type === "MethodDefinition" && r.parent.kind === "constructor" && (n.parent.parent === r || n.argument) && e.report({ node: n, messageId: "unexpected" });
  } };
} }, "no-continue": { meta: { type: "suggestion", docs: { description: "disallow `continue` statements", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-continue" }, schema: [], messages: { unexpected: "Unexpected use of continue statement." } }, create: function(e) {
  return { ContinueStatement: function(t) {
    e.report({ node: t, messageId: "unexpected" });
  } };
} }, "no-control-regex": RB, "no-debugger": { meta: { type: "problem", docs: { description: "disallow the use of `debugger`", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-debugger" }, fixable: null, schema: [], messages: { unexpected: "Unexpected 'debugger' statement." } }, create: function(e) {
  return { DebuggerStatement: function(t) {
    e.report({ node: t, messageId: "unexpected" });
  } };
} }, "no-delete-var": { meta: { type: "suggestion", docs: { description: "disallow deleting variables", category: "Variables", recommended: !0, url: "https://eslint.org/docs/rules/no-delete-var" }, schema: [], messages: { unexpected: "Variables should not be deleted." } }, create: function(e) {
  return { UnaryExpression: function(t) {
    t.operator === "delete" && t.argument.type === "Identifier" && e.report({ node: t, messageId: "unexpected" });
  } };
} }, "no-div-regex": { meta: { type: "suggestion", docs: { description: "disallow division operators explicitly at the beginning of regular expressions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-div-regex" }, fixable: "code", schema: [], messages: { unexpected: "A regular expression literal can be confused with '/='." } }, create: function(e) {
  var t = e.getSourceCode();
  return { Literal: function(n) {
    var r = t.getFirstToken(n);
    r.type === "RegularExpression" && r.value[1] === "=" && e.report({ node: n, messageId: "unexpected", fix: function(i) {
      return i.replaceTextRange([r.range[0] + 1, r.range[0] + 2], "[=]");
    } });
  } };
} }, "no-dupe-args": { meta: { type: "problem", docs: { description: "disallow duplicate arguments in `function` definitions", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-dupe-args" }, schema: [], messages: { unexpected: "Duplicate param '{{name}}'." } }, create: function(e) {
  function t(r) {
    return r.type === "Parameter";
  }
  function n(r) {
    for (var i = e.getDeclaredVariables(r), a = 0; a < i.length; ++a) {
      var s = i[a];
      2 <= s.defs.filter(t).length && e.report({ node: r, messageId: "unexpected", data: { name: s.name } });
    }
  }
  return { FunctionDeclaration: n, FunctionExpression: n };
} }, "no-dupe-class-members": MB, "no-dupe-else-if": UB, "no-dupe-keys": WB, "no-duplicate-case": $B, "no-duplicate-imports": zB, "no-else-return": HB, "no-empty-character-class": JB, "no-empty-function": QB, "no-empty-pattern": { meta: { type: "problem", docs: { description: "disallow empty destructuring patterns", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-empty-pattern" }, schema: [], messages: { unexpected: "Unexpected empty {{type}} pattern." } }, create: function(e) {
  return { ObjectPattern: function(t) {
    t.properties.length === 0 && e.report({ node: t, messageId: "unexpected", data: { type: "object" } });
  }, ArrayPattern: function(t) {
    t.elements.length === 0 && e.report({ node: t, messageId: "unexpected", data: { type: "array" } });
  } };
} }, "no-empty": XB, "no-eq-null": { meta: { type: "suggestion", docs: { description: "disallow `null` comparisons without type-checking operators", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-eq-null" }, schema: [], messages: { unexpected: "Use '===' to compare with null." } }, create: function(e) {
  return { BinaryExpression: function(t) {
    var n = t.operator === "==" || t.operator === "!=";
    (t.right.type === "Literal" && t.right.raw === "null" && n || t.left.type === "Literal" && t.left.raw === "null" && n) && e.report({ node: t, messageId: "unexpected" });
  } };
} }, "no-eval": ZB, "no-ex-assign": eO, "no-extend-native": nO, "no-extra-bind": iO, "no-extra-boolean-cast": aO, "no-extra-label": oO, "no-extra-parens": sO, "no-extra-semi": uO, "no-fallthrough": pO, "no-floating-decimal": fO, "no-func-assign": hO, "no-global-assign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-global-assign" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(a, s, o) {
    var u = a.identifier;
    a.init === !1 && a.isWrite() && (s === 0 || o[s - 1].identifier !== u) && e.report({ node: u, message: "Read-only global '{{name}}' should not be modified.", data: u });
  }
  function n(a) {
    a.writeable === !1 && i.indexOf(a.name) === -1 && a.references.forEach(t);
  }
  var r = e.options[0], i = r && r.exceptions || [];
  return { Program: function() {
    e.getScope().variables.forEach(n);
  } };
} }, "no-implicit-coercion": mO, "no-implicit-globals": { meta: { type: "suggestion", docs: { description: "disallow declarations in the global scope", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-implicit-globals" }, schema: [{ type: "object", properties: { lexicalBindings: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { globalNonLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in an IIFE for a local variable, assign as global property for a global variable.", globalLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in a block or in an IIFE.", globalVariableLeak: "Global variable leak, declare the variable if it is intended to be local.", assignmentToReadonlyGlobal: "Unexpected assignment to read-only global variable.", redeclarationOfReadonlyGlobal: "Unexpected redeclaration of read-only global variable." } }, create: function(e) {
  function t(r, i, a) {
    e.report({ node: r, messageId: i, data: { kind: a } });
  }
  var n = e.options[0] && e.options[0].lexicalBindings === !0;
  return { Program: function() {
    var r = e.getScope();
    r.variables.forEach(function(i) {
      var a = i.writeable === !1;
      i.writeable === !0 || i.defs.forEach(function(s) {
        var o = s.node;
        (s.type === "FunctionName" || s.type === "Variable" && s.parent.kind === "var") && (a ? t(o, "redeclarationOfReadonlyGlobal") : t(o, "globalNonLexicalBinding", s.type === "FunctionName" ? "function" : "'".concat(s.parent.kind, "'"))), n && (s.type === "ClassName" || s.type === "Variable" && (s.parent.kind === "let" || s.parent.kind === "const")) && (a ? t(o, "redeclarationOfReadonlyGlobal") : t(o, "globalLexicalBinding", s.type === "ClassName" ? "class" : "'".concat(s.parent.kind, "'")));
      });
    }), r.implicit.variables.forEach(function(i) {
      var a, s = r.set.get(i.name);
      if (s) {
        if (s.writeable)
          return;
        a = "assignmentToReadonlyGlobal";
      } else
        a = "globalVariableLeak";
      i.defs.forEach(function(o) {
        t(o.node, a);
      });
    });
  } };
} }, "no-implied-eval": { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`-like methods", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-implied-eval" }, schema: [] }, create: function(e) {
  function t(o) {
    return o ? o[o.length - 1] : null;
  }
  function n(o) {
    var u = o.callee.type === "MemberExpression";
    return (o.callee.type === "Identifier" && a.test(o.callee.name) || u && function(c) {
      var f = c.object, p = c.property, d = a.test(p.name) || a.test(p.value);
      return f.name === "window" && d;
    }(o.callee)) && o.arguments.length;
  }
  function r(o) {
    return o.parent === t(t(s)) && (o.parent.type !== "CallExpression" || o === o.parent.arguments[0]);
  }
  function i(o) {
    if (r(o)) {
      var u = s.pop();
      e.report({ node: u[0], message: "Implied eval. Consider passing a function instead of a string." });
    }
  }
  var a = /^(setTimeout|setInterval|execScript)$/, s = [];
  return { CallExpression: function(o) {
    n(o) && s.push([o]);
  }, "CallExpression:exit": function(o) {
    o === t(t(s)) && s.pop();
  }, BinaryExpression: function(o) {
    o.operator === "+" && r(o) && t(s).push(o);
  }, "BinaryExpression:exit": function(o) {
    o === t(t(s)) && t(s).pop();
  }, Literal: function(o) {
    typeof o.value == "string" && i(o);
  }, TemplateLiteral: function(o) {
    i(o);
  } };
} }, "no-import-assign": xO, "no-inline-comments": bO, "no-inner-declarations": { meta: { type: "problem", docs: { description: "disallow variable or `function` declarations in nested blocks", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-inner-declarations" }, schema: [{ enum: ["functions", "both"] }] }, create: function(e) {
  function t(n) {
    var r = function() {
      for (var i = e.getAncestors(), a = i.pop(), s = 1; a && 0 > ["Program", "FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"].indexOf(a.type); )
        s += 1, a = i.pop();
      return { type: a.type, distance: s };
    }();
    r.type === "Program" && r.distance === 1 || r.distance === 2 || e.report({ node: n, message: "Move {{type}} declaration to {{body}} root.", data: { type: n.type === "FunctionDeclaration" ? "function" : "variable", body: r.type === "Program" ? "program" : "function body" } });
  }
  return { FunctionDeclaration: t, VariableDeclaration: function(n) {
    e.options[0] === "both" && n.kind === "var" && t(n);
  } };
} }, "no-invalid-regexp": CO, "no-invalid-this": SO, "no-irregular-whitespace": wO, "no-iterator": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__iterator__` property", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-iterator" }, schema: [] }, create: function(e) {
  return { MemberExpression: function(t) {
    (t.property && t.property.type === "Identifier" && t.property.name === "__iterator__" && !t.computed || t.property.type === "Literal" && t.property.value === "__iterator__") && e.report({ node: t, message: "Reserved name '__iterator__'." });
  } };
} }, "no-label-var": AO, "no-labels": _O, "no-lone-blocks": { meta: { type: "suggestion", docs: { description: "disallow unnecessary nested blocks", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-lone-blocks" }, schema: [] }, create: function(e) {
  function t(s) {
    var o = s.parent.type === "BlockStatement" ? "Nested block is redundant." : "Block is redundant.";
    e.report({ node: s, message: o });
  }
  function n(s) {
    return s.parent.type === "BlockStatement" || s.parent.type === "Program" || s.parent.type === "SwitchCase" && (s.parent.consequent[0] !== s || s.parent.consequent.length !== 1);
  }
  function r() {
    if (a.length !== 0) {
      var s = e.getAncestors().pop();
      a[a.length - 1] === s && a.pop();
    }
  }
  var i, a = [];
  return i = { BlockStatement: function(s) {
    n(s) && t(s);
  } }, 6 <= e.parserOptions.ecmaVersion && ((i = { BlockStatement: function(s) {
    n(s) && a.push(s);
  }, "BlockStatement:exit": function(s) {
    0 < a.length && a[a.length - 1] === s ? (a.pop(), t(s)) : s.parent.type === "BlockStatement" && s.parent.body.length === 1 && t(s);
  } }).VariableDeclaration = function(s) {
    (s.kind === "let" || s.kind === "const") && r();
  }, i.FunctionDeclaration = function() {
    e.getScope().isStrict && r();
  }, i.ClassDeclaration = r), i;
} }, "no-lonely-if": { meta: { type: "suggestion", docs: { description: "disallow `if` statements as the only statement in `else` blocks", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-lonely-if" }, schema: [], fixable: "code" }, create: function(e) {
  var t = e.getSourceCode();
  return { IfStatement: function(n) {
    var r = e.getAncestors(), i = r.pop(), a = r.pop();
    i && i.type === "BlockStatement" && i.body.length === 1 && a && a.type === "IfStatement" && i === a.alternate && e.report({ node: n, message: "Unexpected if as the only statement in an else block.", fix: function(s) {
      var o = t.getFirstToken(i), u = t.getLastToken(i), c = t.getTokenBefore(o), f = t.getTokenAfter(u), p = t.getLastToken(n.consequent), d = t.getText();
      return d.slice(o.range[1], n.range[0]).trim() || d.slice(n.range[1], u.range[0]).trim() || n.consequent.type !== "BlockStatement" && p.value !== ";" && f && (n.consequent.loc.end.line === f.loc.start.line || /^[\(\+\x2D\/\[`]/.test(f.value) || p.value === "++" || p.value === "--") ? null : s.replaceTextRange([o.range[0], u.range[1]], (c.range[1] === o.range[0] ? " " : "") + t.getText(n));
    } });
  } };
} }, "no-loop-func": PO, "no-magic-numbers": { meta: { type: "suggestion", docs: { description: "disallow magic numbers", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-magic-numbers" }, schema: [{ type: "object", properties: { detectObjects: { type: "boolean", default: !1 }, enforceConst: { type: "boolean", default: !1 }, ignore: { type: "array", items: { type: "number" }, uniqueItems: !0 }, ignoreArrayIndexes: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { useConst: "Number constants declarations must use 'const'.", noMagic: "No magic number: {{raw}}." } }, create: function(e) {
  function t(u) {
    return s.indexOf(u) !== -1;
  }
  function n(u) {
    return u.type === "MemberExpression" && o;
  }
  var r = e.options[0] || {}, i = !!r.detectObjects, a = !!r.enforceConst, s = r.ignore || [], o = !!r.ignoreArrayIndexes;
  return { Literal: function(u) {
    var c, f, p, d, m = i ? [] : ["ObjectExpression", "Property", "AssignmentExpression"];
    (function(y) {
      return typeof y.value == "number";
    })(u) && (u.parent.type === "UnaryExpression" && u.parent.operator === "-" ? (f = (c = u.parent).parent, p = -u.value, d = "-".concat(u.raw)) : (c = u, f = u.parent, p = u.value, d = u.raw), t(p) || function(y, v) {
      return y.type === "CallExpression" && v === y.arguments[1] && (y.callee.name === "parseInt" || y.callee.type === "MemberExpression" && y.callee.object.name === "Number" && y.callee.property.name === "parseInt");
    }(f, c) || n(f) || function(y) {
      return y.type.indexOf("JSX") === 0;
    }(f) || (f.type === "VariableDeclarator" ? a && f.parent.kind !== "const" && e.report({ node: c, messageId: "useConst" }) : (m.indexOf(f.type) === -1 || f.type === "AssignmentExpression" && f.left.type === "Identifier") && e.report({ node: c, messageId: "noMagic", data: { raw: d } })));
  } };
} }, "no-misleading-character-class": WO, "no-mixed-operators": zO, "no-mixed-requires": HO, "no-mixed-spaces-and-tabs": { meta: { type: "layout", docs: { description: "disallow mixed spaces and tabs for indentation", category: "Stylistic Issues", recommended: !0, url: "https://eslint.org/docs/rules/no-mixed-spaces-and-tabs" }, schema: [{ enum: ["smart-tabs", !0, !1] }] }, create: function(e) {
  function t(s, o, u) {
    return o < s.start.line || o === s.start.line && u < s.start.column;
  }
  function n(s, o, u) {
    return o > s.end.line || o === s.end.line && u > s.end.column;
  }
  var r, i = e.getSourceCode(), a = [];
  switch (e.options[0]) {
    case !0:
    case "smart-tabs":
      r = !0;
      break;
    default:
      r = !1;
  }
  return { TemplateElement: function(s) {
    a.push(s.loc);
  }, "Program:exit": function(s) {
    var o = /^(?=[\t ]*(\t | \t))/, u = i.lines;
    i.getAllComments().forEach(function(c) {
      a.push(c.loc);
    }), a.sort(function(c, f) {
      return t(c, f.start.line, f.start.column) ? 1 : t(f, c.start.line, f.start.column) ? -1 : 0;
    }), r && (o = /^(?=[\t ]* \t)/), u.forEach(function(c, f) {
      var p = o.exec(c);
      if (p) {
        for (var d = f + 1, m = p.index + 1, y = 0; y < a.length; y++)
          if (!t(a[y], d, m) && !n(a[y], d, m))
            return;
        e.report({ node: s, loc: { line: d, column: m }, message: "Mixed spaces and tabs." });
      }
    });
  } };
} }, "no-multi-assign": { meta: { type: "suggestion", docs: { description: "disallow use of chained assignment expressions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-multi-assign" }, schema: [] }, create: function(e) {
  return { AssignmentExpression: function(t) {
    ["AssignmentExpression", "VariableDeclarator"].indexOf(t.parent.type) !== -1 && e.report({ node: t, message: "Unexpected chained assignment." });
  } };
} }, "no-multi-spaces": KO, "no-multi-str": JO, "no-multiple-empty-lines": QO, "no-native-reassign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-native-reassign" }, deprecated: !0, replacedBy: ["no-global-assign"], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: !0 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(a, s, o) {
    var u = a.identifier;
    a.init === !1 && a.isWrite() && (s === 0 || o[s - 1].identifier !== u) && e.report({ node: u, message: "Read-only global '{{name}}' should not be modified.", data: u });
  }
  function n(a) {
    a.writeable === !1 && i.indexOf(a.name) === -1 && a.references.forEach(t);
  }
  var r = e.options[0], i = r && r.exceptions || [];
  return { Program: function() {
    e.getScope().variables.forEach(n);
  } };
} }, "no-negated-condition": { meta: { type: "suggestion", docs: { description: "disallow negated conditions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-negated-condition" }, schema: [] }, create: function(e) {
  function t(n) {
    return function(r) {
      return r.type === "UnaryExpression" && r.operator === "!";
    }(n.test) || function(r) {
      return r.type === "BinaryExpression" && (r.operator === "!=" || r.operator === "!==");
    }(n.test);
  }
  return { IfStatement: function(n) {
    !function(r) {
      return r.alternate && r.alternate.type !== "IfStatement";
    }(n) || t(n) && e.report({ node: n, message: "Unexpected negated condition." });
  }, ConditionalExpression: function(n) {
    t(n) && e.report({ node: n, message: "Unexpected negated condition." });
  } };
} }, "no-negated-in-lhs": { meta: { type: "problem", docs: { description: "disallow negating the left operand in `in` expressions", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-negated-in-lhs" }, replacedBy: ["no-unsafe-negation"], deprecated: !0, schema: [] }, create: function(e) {
  return { BinaryExpression: function(t) {
    t.operator === "in" && t.left.type === "UnaryExpression" && t.left.operator === "!" && e.report({ node: t, message: "The 'in' expression's left operand is negated." });
  } };
} }, "no-nested-ternary": { meta: { type: "suggestion", docs: { description: "disallow nested ternary expressions", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-nested-ternary" }, schema: [] }, create: function(e) {
  return { ConditionalExpression: function(t) {
    (t.alternate.type === "ConditionalExpression" || t.consequent.type === "ConditionalExpression") && e.report({ node: t, message: "Do not nest ternary expressions." });
  } };
} }, "no-new-func": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `Function` object", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-new-func" }, schema: [] }, create: function(e) {
  function t(n) {
    e.report({ node: n, message: "The Function constructor is eval." });
  }
  return { "NewExpression[callee.name = 'Function']": t, "CallExpression[callee.name = 'Function']": t };
} }, "no-new-object": { meta: { type: "suggestion", docs: { description: "disallow `Object` constructors", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-new-object" }, schema: [] }, create: function(e) {
  return { NewExpression: function(t) {
    t.callee.name === "Object" && e.report({ node: t, message: "The object literal notation {} is preferrable." });
  } };
} }, "no-new-require": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with calls to `require`", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-new-require" }, schema: [] }, create: function(e) {
  return { NewExpression: function(t) {
    t.callee.type === "Identifier" && t.callee.name === "require" && e.report({ node: t, message: "Unexpected use of new with require." });
  } };
} }, "no-new-symbol": { meta: { type: "problem", docs: { description: "disallow `new` operators with the `Symbol` object", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/no-new-symbol" }, schema: [] }, create: function(e) {
  return { "Program:exit": function() {
    var t = e.getScope().set.get("Symbol");
    t && t.defs.length === 0 && t.references.forEach(function(n) {
      var r = n.identifier;
      r.parent && r.parent.type === "NewExpression" && e.report({ node: r, message: "`Symbol` cannot be called as a constructor." });
    });
  } };
} }, "no-new-wrappers": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `String`, `Number`, and `Boolean` objects", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-new-wrappers" }, schema: [] }, create: function(e) {
  return { NewExpression: function(t) {
    -1 < ["String", "Number", "Boolean", "Math", "JSON"].indexOf(t.callee.name) && e.report({ node: t, message: "Do not use {{fn}} as a constructor.", data: { fn: t.callee.name } });
  } };
} }, "no-new": { meta: { type: "suggestion", docs: { description: "disallow `new` operators outside of assignments or comparisons", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-new" }, schema: [] }, create: function(e) {
  return { "ExpressionStatement > NewExpression": function(t) {
    e.report({ node: t.parent, message: "Do not use 'new' for side effects." });
  } };
} }, "no-obj-calls": eL, "no-octal-escape": { meta: { type: "suggestion", docs: { description: "disallow octal escape sequences in string literals", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-octal-escape" }, schema: [], messages: { octalEscapeSequence: "Don't use octal: '\\{{sequence}}'. Use '\\u....' instead." } }, create: function(e) {
  return { Literal: function(t) {
    if (typeof t.value == "string") {
      var n = t.raw.match(/^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*?\\([0-3][0-7]{1,2}|[4-7][0-7]|0(?=[89])|[1-7])/);
      n && e.report({ node: t, messageId: "octalEscapeSequence", data: { sequence: n[1] } });
    }
  } };
} }, "no-octal": { meta: { type: "suggestion", docs: { description: "disallow octal literals", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-octal" }, schema: [] }, create: function(e) {
  return { Literal: function(t) {
    typeof t.value == "number" && /^0[0-9]/.test(t.raw) && e.report({ node: t, message: "Octal literals should not be used." });
  } };
} }, "no-param-reassign": nL, "no-path-concat": { meta: { type: "suggestion", docs: { description: "disallow string concatenation with `__dirname` and `__filename`", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-path-concat" }, schema: [] }, create: function(e) {
  var t = /^__(?:dir|file)name$/;
  return { BinaryExpression: function(n) {
    var r = n.left, i = n.right;
    n.operator === "+" && (r.type === "Identifier" && t.test(r.name) || i.type === "Identifier" && t.test(i.name)) && e.report({ node: n, message: "Use path.join() or path.resolve() instead of + to create paths." });
  } };
} }, "no-plusplus": rL, "no-process-env": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.env`", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-process-env" }, schema: [] }, create: function(e) {
  return { MemberExpression: function(t) {
    var n = t.object.name, r = t.property.name;
    n === "process" && !t.computed && r && r === "env" && e.report({ node: t, message: "Unexpected use of process.env." });
  } };
} }, "no-process-exit": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.exit()`", category: "Node.js and CommonJS", recommended: !1, url: "https://eslint.org/docs/rules/no-process-exit" }, schema: [] }, create: function(e) {
  return { "CallExpression > MemberExpression.callee[object.name = 'process'][property.name = 'exit']": function(t) {
    e.report({ node: t.parent, message: "Don't use process.exit(); throw an error instead." });
  } };
} }, "no-proto": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__proto__` property", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-proto" }, schema: [] }, create: function(e) {
  return { MemberExpression: function(t) {
    (t.property && t.property.type === "Identifier" && t.property.name === "__proto__" && !t.computed || t.property.type === "Literal" && t.property.value === "__proto__") && e.report({ node: t, message: "The '__proto__' property is deprecated." });
  } };
} }, "no-prototype-builtins": { meta: { type: "problem", docs: { description: "disallow calling some `Object.prototype` methods directly on objects", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-prototype-builtins" }, schema: [] }, create: function(e) {
  var t = ["hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable"];
  return { CallExpression: function(n) {
    if (n.callee.type === "MemberExpression" && !n.callee.computed) {
      var r = n.callee.property.name;
      -1 < t.indexOf(r) && e.report({ message: "Do not access Object.prototype method '{{prop}}' from target object.", loc: n.callee.property.loc.start, data: { prop: r }, node: n });
    }
  } };
} }, "no-redeclare": iL, "no-regex-spaces": sL, "no-restricted-globals": lL, "no-restricted-imports": pL, "no-restricted-modules": dL, "no-restricted-properties": mL, "no-restricted-syntax": gL, "no-return-assign": vL, "no-return-await": bL, "no-script-url": { meta: { type: "suggestion", docs: { description: "disallow `javascript:` urls", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-script-url" }, schema: [] }, create: function(e) {
  return { Literal: function(t) {
    t.value && typeof t.value == "string" && t.value.toLowerCase().indexOf("javascript:") === 0 && e.report({ node: t, message: "Script URL is a form of eval." });
  } };
} }, "no-self-assign": CL, "no-self-compare": SL, "no-sequences": kL, "no-setter-return": wL, "no-shadow-restricted-names": _L, "no-shadow": TL, "no-spaced-func": { meta: { type: "layout", docs: { description: "disallow spacing between function identifiers and their applications (deprecated)", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-spaced-func" }, deprecated: !0, replacedBy: ["func-call-spacing"], fixable: "whitespace", schema: [] }, create: function(e) {
  function t(r) {
    for (var i = n.getLastToken(r.callee), a = i, s = n.getTokenAfter(i); s && s.range[1] < r.range[1] && s.value !== "("; )
      a = s, s = n.getTokenAfter(s);
    s && s.range[1] < r.range[1] && n.isSpaceBetweenTokens(a, s) && e.report({ node: r, loc: i.loc.start, message: "Unexpected space between function name and paren.", fix: function(o) {
      return o.removeRange([a.range[1], s.range[0]]);
    } });
  }
  var n = e.getSourceCode();
  return { CallExpression: t, NewExpression: t };
} }, "no-sparse-arrays": { meta: { type: "problem", docs: { description: "disallow sparse arrays", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/no-sparse-arrays" }, schema: [] }, create: function(e) {
  return { ArrayExpression: function(t) {
    -1 < t.elements.indexOf(null) && e.report({ node: t, message: "Unexpected comma in middle of array." });
  } };
} }, "no-sync": PL, "no-tabs": OL, "no-template-curly-in-string": { meta: { type: "problem", docs: { description: "disallow template literal placeholder syntax in regular strings", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/no-template-curly-in-string" }, schema: [] }, create: function(e) {
  var t = /\$\{(?:[\0-\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\}/;
  return { Literal: function(n) {
    typeof n.value == "string" && t.test(n.value) && e.report({ node: n, message: "Unexpected template string expression." });
  } };
} }, "no-ternary": { meta: { type: "suggestion", docs: { description: "disallow ternary operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-ternary" }, schema: [] }, create: function(e) {
  return { ConditionalExpression: function(t) {
    e.report({ node: t, message: "Ternary operator used." });
  } };
} }, "no-this-before-super": LL, "no-throw-literal": NL, "no-trailing-spaces": jL, "no-undef-init": RL, "no-undef": ML, "no-undefined": VL, "no-underscore-dangle": { meta: { type: "suggestion", docs: { description: "disallow dangling underscores in identifiers", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/no-underscore-dangle" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" } }, allowAfterThis: { type: "boolean", default: !1 }, allowAfterSuper: { type: "boolean", default: !1 }, allowAfterThisConstructor: { type: "boolean", default: !1 }, enforceInMethodNames: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(f) {
    return a.some(function(p) {
      return p === f;
    });
  }
  function n(f) {
    var p = f.length;
    return f !== "_" && (f[0] === "_" || f[p - 1] === "_");
  }
  function r(f) {
    var p = f.key.name, d = f.type === "MethodDefinition" || f.type === "Property" && f.method;
    p !== void 0 && c && d && n(p) && e.report({ node: f, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p } });
  }
  var i = e.options[0] || {}, a = i.allow ? i.allow : [], s = i.allowAfterThis !== void 0 && i.allowAfterThis, o = i.allowAfterSuper !== void 0 && i.allowAfterSuper, u = i.allowAfterThisConstructor !== void 0 && i.allowAfterThisConstructor, c = i.enforceInMethodNames !== void 0 && i.enforceInMethodNames;
  return { FunctionDeclaration: function(f) {
    if (f.id) {
      var p = f.id.name;
      p !== void 0 && n(p) && !t(p) && e.report({ node: f, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p } });
    }
  }, VariableDeclarator: function(f) {
    var p = f.id.name;
    p === void 0 || !n(p) || function(d) {
      return d === "_";
    }(p) || t(p) || e.report({ node: f, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p } });
  }, MemberExpression: function(f) {
    var p = f.property.name, d = f.object.type === "ThisExpression", m = f.object.type === "Super", y = function(v) {
      return v.object.type === "MemberExpression" && v.object.property.name === "constructor" && v.object.object.type === "ThisExpression";
    }(f);
    p === void 0 || !n(p) || d && s || m && o || y && u || function(v) {
      return v === "__proto__";
    }(p) || t(p) || e.report({ node: f, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: p } });
  }, MethodDefinition: r, Property: r };
} }, "no-unexpected-multiline": UL, "no-unmodified-loop-condition": YL, "no-unneeded-ternary": tN, "no-unreachable": aN, "no-unsafe-finally": cN, "no-unsafe-negation": lN, "no-unused-expressions": { meta: { type: "suggestion", docs: { description: "disallow unused expressions", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-unused-expressions" }, schema: [{ type: "object", properties: { allowShortCircuit: { type: "boolean", default: !1 }, allowTernary: { type: "boolean", default: !1 }, allowTaggedTemplates: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(o) {
    return o.type === "ExpressionStatement" && o.expression.type === "Literal" && typeof o.expression.value == "string";
  }
  function n(o) {
    return function(u, c) {
      for (var f = 0; f < c.length; ++f)
        if (!u(c[f]))
          return c.slice(0, f);
      return c.slice();
    }(t, o.body);
  }
  var r = e.options[0] || {}, i = r.allowShortCircuit || !1, a = r.allowTernary || !1, s = r.allowTaggedTemplates || !1;
  return { ExpressionStatement: function(o) {
    (function u(c) {
      return a && c.type === "ConditionalExpression" ? u(c.consequent) && u(c.alternate) : i && c.type === "LogicalExpression" ? u(c.right) : !(!s || c.type !== "TaggedTemplateExpression") || /^(?:Assignment|Call|New|Update|Yield|Await)Expression$/.test(c.type) || c.type === "UnaryExpression" && 0 <= ["delete", "void"].indexOf(c.operator);
    })(o.expression) || function(u, c) {
      var f = c[c.length - 1], p = c[c.length - 2];
      return (f.type === "Program" || f.type === "BlockStatement" && /Function/.test(p.type)) && 0 <= n(f).indexOf(u);
    }(o, e.getAncestors()) || e.report({ node: o, message: "Expected an assignment or function call and instead saw an expression." });
  } };
} }, "no-unused-labels": { meta: { type: "suggestion", docs: { description: "disallow unused labels", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-unused-labels" }, schema: [], fixable: "code", messages: { unused: "'{{name}}:' is defined but never used." } }, create: function(e) {
  function t(i) {
    if (i.label)
      for (var a = i.label.name, s = r; s; ) {
        if (s.label === a) {
          s.used = !0;
          break;
        }
        s = s.upper;
      }
  }
  var n = e.getSourceCode(), r = null;
  return { LabeledStatement: function(i) {
    r = { label: i.label.name, used: !1, upper: r };
  }, "LabeledStatement:exit": function(i) {
    r.used || e.report({ node: i.label, messageId: "unused", data: i.label, fix: function(a) {
      return n.getTokenAfter(i.label, { includeComments: !0 }) === n.getTokenBefore(i.body, { includeComments: !0 }) ? a.removeRange([i.range[0], i.body.range[0]]) : null;
    } }), r = r.upper;
  }, BreakStatement: t, ContinueStatement: t };
} }, "no-unused-vars": pN, "no-use-before-define": dN, "no-useless-call": mN, "no-useless-catch": { meta: { type: "suggestion", docs: { description: "disallow unnecessary `catch` clauses", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-useless-catch" }, schema: [] }, create: function(e) {
  return { CatchClause: function(t) {
    t.param && t.param.type === "Identifier" && t.body.body.length && t.body.body[0].type === "ThrowStatement" && t.body.body[0].argument.type === "Identifier" && t.body.body[0].argument.name === t.param.name && (t.parent.finalizer ? e.report({ node: t, message: "Unnecessary catch clause." }) : e.report({ node: t.parent, message: "Unnecessary try/catch wrapper." }));
  } };
} }, "no-useless-computed-key": yN, "no-useless-concat": xN, "no-useless-constructor": SN, "no-useless-escape": FN, "no-useless-rename": wN, "no-useless-return": _N, "no-var": LN, "no-void": { meta: { type: "suggestion", docs: { description: "disallow `void` operators", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/no-void" }, schema: [] }, create: function(e) {
  return { UnaryExpression: function(t) {
    t.operator === "void" && e.report({ node: t, message: "Expected 'undefined' and instead saw 'void'." });
  } };
} }, "no-warning-comments": jN, "no-whitespace-before-property": RN, "no-with": { meta: { type: "suggestion", docs: { description: "disallow `with` statements", category: "Best Practices", recommended: !0, url: "https://eslint.org/docs/rules/no-with" }, schema: [] }, create: function(e) {
  return { WithStatement: function(t) {
    e.report({ node: t, message: "Unexpected use of 'with' statement." });
  } };
} }, "nonblock-statement-body-position": MN, "object-curly-newline": VN, "object-curly-spacing": UN, "object-property-newline": { meta: { type: "layout", docs: { description: "enforce placing object properties on separate lines", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/object-property-newline" }, schema: [{ type: "object", properties: { allowAllPropertiesOnSameLine: { type: "boolean", default: !1 }, allowMultiplePropertiesPerLine: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "whitespace" }, create: function(e) {
  var t = e.options[0] && (e.options[0].allowAllPropertiesOnSameLine || e.options[0].allowMultiplePropertiesPerLine), n = t ? "Object properties must go on a new line if they aren't all on the same line." : "Object properties must go on a new line.", r = e.getSourceCode();
  return { ObjectExpression: function(i) {
    if (t && 1 < i.properties.length) {
      var a = r.getFirstToken(i.properties[0]), s = r.getLastToken(i.properties[i.properties.length - 1]);
      if (a.loc.end.line === s.loc.start.line)
        return;
    }
    for (var o = function(c) {
      var f = r.getLastToken(i.properties[c - 1]), p = r.getFirstToken(i.properties[c]);
      f.loc.end.line === p.loc.start.line && e.report({ node: i, loc: p.loc.start, message: n, fix: function(d) {
        var m = [r.getTokenBefore(p).range[1], p.range[0]];
        return r.text.slice(m[0], m[1]).trim() ? null : d.replaceTextRange(m, `
`);
      } });
    }, u = 1; u < i.properties.length; u++)
      o(u);
  } };
} }, "object-shorthand": HN, "one-var-declaration-per-line": { meta: { type: "suggestion", docs: { description: "require or disallow newlines around variable declarations", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/one-var-declaration-per-line" }, schema: [{ enum: ["always", "initializations"] }], fixable: "whitespace" }, create: function(e) {
  var t = e.options[0] === "always";
  return { VariableDeclaration: function(n) {
    var r;
    (function(i) {
      return i === "ForStatement" || i === "ForInStatement" || i === "ForOfStatement";
    })(n.parent.type) || n.declarations.forEach(function(i) {
      r && r.loc.end.line === i.loc.start.line && (t || r.init || i.init) && e.report({ node: n, message: "Expected variable declaration to be on a new line.", loc: i.loc.start, fix: function(a) {
        return a.insertTextBefore(i, `
`);
      } }), r = i;
    });
  } };
} }, "one-var": KN, "operator-assignment": JN, "operator-linebreak": QN, "padded-blocks": XN, "padding-line-between-statements": nj, "prefer-arrow-callback": rj, "prefer-const": sj, "prefer-destructuring": uj, "prefer-exponentiation-operator": pj, "prefer-named-capture-group": gj, "prefer-numeric-literals": yj, "prefer-object-spread": Aj, "prefer-promise-reject-errors": _j, "prefer-reflect": Tj, "prefer-regex-literals": Lj, "prefer-rest-params": jj, "prefer-spread": Rj, "prefer-template": Mj, "quote-props": Vj, quotes: qj, radix: $j, "require-atomic-updates": zj, "require-await": Kj, "require-jsdoc": Jj, "require-unicode-regexp": eR, "require-yield": { meta: { type: "suggestion", docs: { description: "require generator functions to contain `yield`", category: "ECMAScript 6", recommended: !0, url: "https://eslint.org/docs/rules/require-yield" }, schema: [] }, create: function(e) {
  function t(i) {
    i.generator && r.push(0);
  }
  function n(i) {
    i.generator && r.pop() === 0 && 0 < i.body.body.length && e.report({ node: i, message: "This generator function does not have 'yield'." });
  }
  var r = [];
  return { FunctionDeclaration: t, "FunctionDeclaration:exit": n, FunctionExpression: t, "FunctionExpression:exit": n, YieldExpression: function() {
    0 < r.length && (r[r.length - 1] += 1);
  } };
} }, "rest-spread-spacing": { meta: { type: "layout", docs: { description: "enforce spacing between rest and spread operators and their expressions", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/rest-spread-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }] }, create: function(e) {
  function t(i) {
    var a, s = n.getFirstToken(i), o = n.getTokenAfter(s), u = n.isSpaceBetweenTokens(s, o);
    switch (i.type) {
      case "SpreadElement":
        a = "spread", i.parent.type === "ObjectExpression" && (a += " property");
        break;
      case "RestElement":
        a = "rest", i.parent.type === "ObjectPattern" && (a += " property");
        break;
      case "ExperimentalSpreadProperty":
        a = "spread property";
        break;
      case "ExperimentalRestProperty":
        a = "rest property";
        break;
      default:
        return;
    }
    r && !u ? e.report({ node: i, loc: { line: s.loc.end.line, column: s.loc.end.column }, message: "Expected whitespace after {{type}} operator.", data: { type: a }, fix: function(c) {
      return c.replaceTextRange([s.range[1], o.range[0]], " ");
    } }) : !r && u && e.report({ node: i, loc: { line: s.loc.end.line, column: s.loc.end.column }, message: "Unexpected whitespace after {{type}} operator.", data: { type: a }, fix: function(c) {
      return c.removeRange([s.range[1], o.range[0]]);
    } });
  }
  var n = e.getSourceCode(), r = e.options[0] === "always";
  return { SpreadElement: t, RestElement: t, ExperimentalSpreadProperty: t, ExperimentalRestProperty: t };
} }, "semi-spacing": tR, "semi-style": { meta: { type: "layout", docs: { description: "enforce location of semicolons", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/semi-style" }, schema: [{ enum: ["last", "first"] }], fixable: "whitespace" }, create: function(e) {
  var t;
  function n(a, s) {
    var o = r.getTokenBefore(a), u = r.getTokenAfter(a), c = !o || P.isTokenOnSameLine(o, a), f = !u || P.isTokenOnSameLine(a, u);
    (s !== "last" || c) && (s !== "first" || f) || e.report({ loc: a.loc, message: "Expected this semicolon to be at {{pos}}.", data: { pos: s === "last" ? "the end of the previous line" : "the beginning of the next line" }, fix: function(p) {
      if (o && u && r.commentsExistBetween(o, u))
        return null;
      var d = o ? o.range[1] : a.range[0], m = u ? u.range[0] : a.range[1], y = s === "last" ? `;
` : `
;`;
      return p.replaceTextRange([d, m], y);
    } });
  }
  var r = e.getSourceCode(), i = e.options[0] || "last";
  return Fn(t = {}, nR, function(a) {
    if (i !== "first" || !function(o) {
      var u = o.parent.type;
      if (u === "IfStatement" && o.parent.consequent === o && o.parent.alternate || u === "DoWhileStatement")
        return !0;
      var c = function(f) {
        var p = f.type;
        return p === "BlockStatement" || p === "Program" ? f.body : p === "SwitchCase" ? f.consequent : null;
      }(o.parent);
      return c !== null && c[c.length - 1] === o;
    }(a)) {
      var s = r.getLastToken(a);
      P.isSemicolonToken(s) && n(s, i);
    }
  }), Fn(t, "ForStatement", function(a) {
    var s = a.init && r.getTokenAfter(a.init, P.isSemicolonToken), o = a.test && r.getTokenAfter(a.test, P.isSemicolonToken);
    s && n(s, "last"), o && n(o, "last");
  }), t;
} }, semi: { meta: { type: "layout", docs: { description: "require or disallow semicolons instead of ASI", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/semi" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { beforeStatementContinuationChars: { enum: ["always", "any", "never"] } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { omitLastInOneLineBlock: { type: "boolean" } }, additionalProperties: !1 }], minItems: 0, maxItems: 2 }] } }, create: function(e) {
  function t(d, m) {
    var y, v, b, x = p.getLastToken(d);
    m ? (y = "Extra semicolon.", b = x.loc, v = function(C) {
      return new bf(C, p).retainSurroundingTokens(x).remove(x);
    }) : (y = "Missing semicolon.", b = { start: x.loc.end, end: P.getNextLocation(p, x.loc.end) }, v = function(C) {
      return C.insertTextAfter(x, ";");
    }), e.report({ node: d, loc: b, message: y, fix: v });
  }
  function n(d) {
    var m = d.type;
    return m !== "DoWhileStatement" && m !== "BreakStatement" && m !== "ContinueStatement" && m !== "DebuggerStatement" && m !== "ImportDeclaration" && m !== "ExportAllDeclaration" && (m === "ReturnStatement" ? !!d.argument : m === "ExportNamedDeclaration" ? !!d.declaration : !function(y) {
      if (!P.isClosingBraceToken(y))
        return !1;
      var v = p.getNodeByRangeIndex(y.range[0]);
      return v.type === "BlockStatement" && v.parent.type === "ArrowFunctionExpression";
    }(p.getLastToken(d, 1)));
  }
  function r(d) {
    return !!d && s.test(d.value) && d.value !== "++" && d.value !== "--";
  }
  function i(d) {
    return !(!function(m) {
      var y = p.getTokenAfter(m);
      return !y || P.isClosingBraceToken(y) || P.isSemicolonToken(y);
    }(p.getLastToken(d)) && (function(m) {
      var y = p.getLastToken(m, 1), v = p.getTokenAfter(m);
      return !!v && P.isTokenOnSameLine(y, v);
    }(d) || (f !== "never" || n(d)) && r(p.getTokenAfter(d))));
  }
  function a(d) {
    var m = P.isSemicolonToken(p.getLastToken(d));
    if (u)
      m && i(d) ? t(d, !0) : !m && f === "always" && r(p.getTokenAfter(d)) && t(d);
    else {
      var y = c && function(v) {
        var b = v.parent, x = p.getTokenAfter(v);
        return !(!x || x.value !== "}" || !b || b.type !== "BlockStatement" || b.loc.start.line !== b.loc.end.line);
      }(d);
      m && y ? t(d, !0) : !m && !y && t(d);
    }
  }
  var s = /^[\(\+\x2D\/\[`]/, o = e.options[1], u = e.options[0] === "never", c = !(!o || !o.omitLastInOneLineBlock), f = o && o.beforeStatementContinuationChars || "any", p = e.getSourceCode();
  return { VariableDeclaration: function(d) {
    var m = d.parent;
    m.type === "ForStatement" && m.init === d || /^For(?:In|Of)Statement/.test(m.type) && m.left === d || a(d);
  }, ExpressionStatement: a, ReturnStatement: a, ThrowStatement: a, DoWhileStatement: a, DebuggerStatement: a, BreakStatement: a, ContinueStatement: a, ImportDeclaration: a, ExportAllDeclaration: a, ExportNamedDeclaration: function(d) {
    d.declaration || a(d);
  }, ExportDefaultDeclaration: function(d) {
    /(?:Class|Function)Declaration/.test(d.declaration.type) || a(d);
  } };
} }, "sort-imports": { meta: { type: "suggestion", docs: { description: "enforce sorted import declarations within modules", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/sort-imports" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: !1 }, memberSyntaxSortOrder: { type: "array", items: { enum: ["none", "all", "multiple", "single"] }, uniqueItems: !0, minItems: 4, maxItems: 4 }, ignoreDeclarationSort: { type: "boolean", default: !1 }, ignoreMemberSort: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  function t(f) {
    return o.indexOf(function(p) {
      return p.specifiers.length === 0 ? "none" : p.specifiers[0].type === "ImportNamespaceSpecifier" ? "all" : p.specifiers.length === 1 ? "single" : "multiple";
    }(f));
  }
  function n(f) {
    return f.specifiers[0] ? f.specifiers[0].local.name : null;
  }
  var r = e.options[0] || {}, i = r.ignoreCase || !1, a = r.ignoreDeclarationSort || !1, s = r.ignoreMemberSort || !1, o = r.memberSyntaxSortOrder || ["none", "all", "multiple", "single"], u = e.getSourceCode(), c = null;
  return { ImportDeclaration: function(f) {
    if (!a) {
      if (c) {
        var p = t(f), d = t(c), m = n(f), y = n(c);
        i && (y = y && y.toLowerCase(), m = m && m.toLowerCase()), p === d ? y && m && m < y && e.report({ node: f, message: "Imports should be sorted alphabetically." }) : p < d && e.report({ node: f, message: "Expected '{{syntaxA}}' syntax before '{{syntaxB}}' syntax.", data: { syntaxA: o[p], syntaxB: o[d] } });
      }
      c = f;
    }
    if (!s) {
      var v = f.specifiers.filter(function(C) {
        return C.type === "ImportSpecifier";
      }), b = i ? function(C) {
        return C.local.name.toLowerCase();
      } : function(C) {
        return C.local.name;
      }, x = v.map(b).findIndex(function(C, k, F) {
        return F[k - 1] > C;
      });
      x !== -1 && e.report({ node: v[x], message: "Member '{{memberName}}' of the import declaration should be sorted alphabetically.", data: { memberName: v[x].local.name }, fix: function(C) {
        return v.some(function(k) {
          return u.getCommentsBefore(k).length || u.getCommentsAfter(k).length;
        }) ? null : C.replaceTextRange([v[0].range[0], v[v.length - 1].range[1]], v.slice().sort(function(k, F) {
          return b(k) > b(F) ? 1 : -1;
        }).reduce(function(k, F, B) {
          var O = B === v.length - 1 ? "" : u.getText().slice(v[B].range[1], v[B + 1].range[0]);
          return k + u.getText(F) + O;
        }, ""));
      } });
    }
  } };
} }, "sort-keys": { meta: { type: "suggestion", docs: { description: "require object keys to be sorted", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/sort-keys" }, schema: [{ enum: ["asc", "desc"] }, { type: "object", properties: { caseSensitive: { type: "boolean", default: !0 }, natural: { type: "boolean", default: !1 }, minKeys: { type: "integer", minimum: 2, default: 2 } }, additionalProperties: !1 }] }, create: function(e) {
  var t = e.options[0] || "asc", n = e.options[1], r = n && n.caseSensitive === !1, i = n && n.natural, a = n && n.minKeys, s = Ju[t + (r ? "I" : "") + (i ? "N" : "")], o = null;
  return { ObjectExpression: function(u) {
    o = { upper: o, prevName: null, numKeys: u.properties.length };
  }, "ObjectExpression:exit": function() {
    o = o.upper;
  }, SpreadElement: function(u) {
    u.parent.type === "ObjectExpression" && (o.prevName = null);
  }, Property: function(u) {
    if (u.parent.type !== "ObjectPattern") {
      var c = o.prevName, f = o.numKeys, p = function(d) {
        var m = P.getStaticPropertyName(d);
        return m === null ? d.key.name || null : m;
      }(u);
      p !== null && (o.prevName = p), c === null || p === null || f < a || !s(c, p) && e.report({ node: u, loc: u.key.loc, message: "Expected object keys to be in {{natual}}{{insensitive}}{{order}}ending order. '{{thisName}}' should be before '{{prevName}}'.", data: { thisName: p, prevName: c, order: t, insensitive: r ? "insensitive " : "", natual: i ? "natural " : "" } });
    }
  } };
} }, "sort-vars": { meta: { type: "suggestion", docs: { description: "require variables within the same declaration block to be sorted", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/sort-vars" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "code" }, create: function(e) {
  var t = (e.options[0] || {}).ignoreCase || !1, n = e.getSourceCode();
  return { VariableDeclaration: function(r) {
    var i = r.declarations.filter(function(u) {
      return u.id.type === "Identifier";
    }), a = t ? function(u) {
      return u.id.name.toLowerCase();
    } : function(u) {
      return u.id.name;
    }, s = i.some(function(u) {
      return u.init !== null && u.init.type !== "Literal";
    }), o = !1;
    i.slice(1).reduce(function(u, c) {
      var f = a(u);
      return a(c) < f ? (e.report({ node: c, message: "Variables within the same declaration block should be sorted alphabetically.", fix: function(p) {
        return s || o ? null : p.replaceTextRange([i[0].range[0], i[i.length - 1].range[1]], i.slice().sort(function(d, m) {
          return a(d) > a(m) ? 1 : -1;
        }).reduce(function(d, m, y) {
          var v = y === i.length - 1 ? "" : n.getText().slice(i[y].range[1], i[y + 1].range[0]);
          return d + n.getText(m) + v;
        }, ""));
      } }), o = !0, u) : c;
    }, i[0]);
  } };
} }, "space-before-blocks": { meta: { type: "layout", docs: { description: "enforce consistent spacing before blocks", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/space-before-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { keywords: { enum: ["always", "never", "off"] }, functions: { enum: ["always", "never", "off"] }, classes: { enum: ["always", "never", "off"] } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(f) {
    var p = r.getTokenBefore(f);
    if (p && !function(b) {
      return b.type === "Punctuator" && b.value === "=>" || b.type === "Keyword";
    }(p) && P.isTokenOnSameLine(p, f)) {
      var d, m, y = r.isSpaceBetweenTokens(p, f), v = e.getAncestors().pop();
      v.type === "FunctionExpression" || v.type === "FunctionDeclaration" ? (d = i, m = o) : f.type === "ClassBody" ? (d = s, m = c) : (d = a, m = u), d && !y ? e.report({ node: f, message: "Missing space before opening brace.", fix: function(b) {
        return b.insertTextBefore(f, " ");
      } }) : m && y && e.report({ node: f, message: "Unexpected space before opening brace.", fix: function(b) {
        return b.removeRange([p.range[1], f.range[0]]);
      } });
    }
  }
  var n = e.options[0], r = e.getSourceCode(), i = !0, a = !0, s = !0, o = !1, u = !1, c = !1;
  return xe(n) == "object" ? (i = n.functions === "always", a = n.keywords === "always", s = n.classes === "always", o = n.functions === "never", u = n.keywords === "never", c = n.classes === "never") : n === "never" && (i = !1, a = !1, s = !1, o = !0, u = !0, c = !0), { BlockStatement: t, ClassBody: t, SwitchStatement: function(f) {
    var p = f.cases;
    t(0 < p.length ? r.getTokenBefore(p[0]) : r.getLastToken(f, 1));
  } };
} }, "space-before-function-paren": { meta: { type: "layout", docs: { description: "enforce consistent spacing before `function` definition opening parenthesis", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/space-before-function-paren" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { anonymous: { enum: ["always", "never", "ignore"] }, named: { enum: ["always", "never", "ignore"] }, asyncArrow: { enum: ["always", "never", "ignore"] } }, additionalProperties: !1 }] }] }, create: function(e) {
  function t(s) {
    if (s.type !== "ArrowFunctionExpression") {
      if (function(o) {
        if (o.id)
          return !0;
        var u = o.parent;
        return u.type === "MethodDefinition" || u.type === "Property" && (u.kind === "get" || u.kind === "set" || u.method);
      }(s))
        return a.named || i;
      if (!s.generator)
        return a.anonymous || i;
    } else if (s.async && P.isOpeningParenToken(r.getFirstToken(s, { skip: 1 })))
      return a.asyncArrow || i;
    return "ignore";
  }
  function n(s) {
    var o = t(s);
    if (o !== "ignore") {
      var u = r.getFirstToken(s, P.isOpeningParenToken), c = r.getTokenBefore(u), f = r.isSpaceBetweenTokens(c, u);
      f && o === "never" ? e.report({ node: s, loc: c.loc.end, message: "Unexpected space before function parentheses.", fix: function(p) {
        var d = r.getCommentsBefore(u);
        return d.some(function(m) {
          return m.type === "Line";
        }) ? null : p.replaceTextRange([c.range[1], u.range[0]], d.reduce(function(m, y) {
          return m + r.getText(y);
        }, ""));
      } }) : !f && o === "always" && e.report({ node: s, loc: c.loc.end, message: "Missing space before function parentheses.", fix: function(p) {
        return p.insertTextAfter(c, " ");
      } });
    }
  }
  var r = e.getSourceCode(), i = typeof e.options[0] == "string" ? e.options[0] : "always", a = xe(e.options[0]) == "object" ? e.options[0] : {};
  return { ArrowFunctionExpression: n, FunctionDeclaration: n, FunctionExpression: n };
} }, "space-in-parens": { meta: { type: "layout", docs: { description: "enforce consistent spacing inside parentheses", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/space-in-parens" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { enum: ["{}", "[]", "()", "empty"] }, uniqueItems: !0 } }, additionalProperties: !1 }], messages: { missingOpeningSpace: "There must be a space after this paren.", missingClosingSpace: "There must be a space before this paren.", rejectedOpeningSpace: "There should be no space after this paren.", rejectedClosingSpace: "There should be no space before this paren." } }, create: function(e) {
  function t(d) {
    return o.openers.includes(d.value);
  }
  function n(d) {
    return o.closers.includes(d.value);
  }
  function r(d, m) {
    return !p.isSpaceBetweenTokens(d, m) && (f.empty || !P.isClosingParenToken(m)) && (u ? !t(m) : t(m));
  }
  function i(d, m) {
    return !!P.isTokenOnSameLine(d, m) && m.type !== "Line" && !!p.isSpaceBetweenTokens(d, m) && (u ? t(m) : !t(m));
  }
  function a(d, m) {
    return !p.isSpaceBetweenTokens(d, m) && (f.empty || !P.isOpeningParenToken(d)) && (u ? !n(d) : n(d));
  }
  function s(d, m) {
    return !!P.isTokenOnSameLine(d, m) && !!p.isSpaceBetweenTokens(d, m) && (u ? n(d) : !n(d));
  }
  var o, u = e.options[0] === "always", c = e.options[1] && e.options[1].exceptions || [], f = {};
  c.length && (f.braceException = c.includes("{}"), f.bracketException = c.includes("[]"), f.parenException = c.includes("()"), f.empty = c.includes("empty"));
  var p = e.getSourceCode();
  return { Program: function(d) {
    o = function() {
      var y = [], v = [];
      return f.braceException && (y.push("{"), v.push("}")), f.bracketException && (y.push("["), v.push("]")), f.parenException && (y.push("("), v.push(")")), f.empty && (y.push(")"), v.push("(")), { openers: y, closers: v };
    }();
    var m = p.tokensAndComments;
    m.forEach(function(y, v) {
      var b = m[v - 1], x = m[v + 1];
      (P.isOpeningParenToken(y) || P.isClosingParenToken(y)) && (y.value === "(" && r(y, x) && e.report({ node: d, loc: y.loc, messageId: "missingOpeningSpace", fix: function(C) {
        return C.insertTextAfter(y, " ");
      } }), y.value === "(" && i(y, x) && e.report({ node: d, loc: { start: y.loc.end, end: x.loc.start }, messageId: "rejectedOpeningSpace", fix: function(C) {
        return C.removeRange([y.range[1], x.range[0]]);
      } }), y.value === ")" && a(b, y) && e.report({ node: d, loc: y.loc, messageId: "missingClosingSpace", fix: function(C) {
        return C.insertTextBefore(y, " ");
      } }), y.value === ")" && s(b, y) && e.report({ node: d, loc: { start: b.loc.end, end: y.loc.start }, messageId: "rejectedClosingSpace", fix: function(C) {
        return C.removeRange([b.range[1], y.range[0]]);
      } }));
    });
  } };
} }, "space-infix-ops": { meta: { type: "layout", docs: { description: "require spacing around infix operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/space-infix-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { int32Hint: { type: "boolean", default: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(s, o, u) {
    var c = a.getFirstTokenBetween(s, o, function(d) {
      return d.value === u;
    }), f = a.getTokenBefore(c), p = a.getTokenAfter(c);
    return a.isSpaceBetweenTokens(f, c) && a.isSpaceBetweenTokens(c, p) ? null : c;
  }
  function n(s, o) {
    e.report({ node: s, loc: o.loc, message: "Operator '{{operator}}' must be spaced.", data: { operator: o.value }, fix: function(u) {
      var c = a.getTokenBefore(o), f = a.getTokenAfter(o), p = "";
      return o.range[0] - c.range[1] == 0 && (p = " "), p += o.value, f.range[0] - o.range[1] == 0 && (p += " "), u.replaceText(o, p);
    } });
  }
  function r(s) {
    var o = t(s.left.typeAnnotation ? s.left.typeAnnotation : s.left, s.right, s.operator || "=");
    o && (!i || !a.getText(s).endsWith("|0")) && n(s, o);
  }
  var i = !!e.options[0] && e.options[0].int32Hint === !0, a = e.getSourceCode();
  return { AssignmentExpression: r, AssignmentPattern: r, BinaryExpression: r, LogicalExpression: r, ConditionalExpression: function(s) {
    var o = t(s.test, s.consequent, "?"), u = t(s.consequent, s.alternate, ":");
    o ? n(s, o) : u && n(s, u);
  }, VariableDeclarator: function(s) {
    var o = s.id.typeAnnotation ? s.id.typeAnnotation : s.id, u = s.init;
    if (u) {
      var c = t(o, u, "=");
      c && n(s, c);
    }
  } };
} }, "space-unary-ops": { meta: { type: "layout", docs: { description: "enforce consistent spacing before or after unary operators", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/space-unary-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { words: { type: "boolean", default: !0 }, nonwords: { type: "boolean", default: !1 }, overrides: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: !1 }], messages: { unexpectedBefore: "Unexpected space before unary operator '{{operator}}'.", unexpectedAfter: "Unexpected space after unary operator '{{operator}}'.", unexpectedAfterWord: "Unexpected space after unary word operator '{{word}}'.", wordOperator: "Unary word operator '{{word}}' must be followed by whitespace.", operator: "Unary operator '{{operator}}' must be followed by whitespace.", beforeUnaryExpressions: "Space is required before unary expressions '{{token}}'." } }, create: function(e) {
  function t(p) {
    return c.overrides && Object.prototype.hasOwnProperty.call(c.overrides, p);
  }
  function n(p) {
    return c.overrides[p];
  }
  function r(p, d, m, y) {
    m.range[0] === d.range[1] && e.report({ node: p, messageId: "wordOperator", data: { word: y }, fix: function(v) {
      return v.insertTextAfter(d, " ");
    } });
  }
  function i(p, d, m, y) {
    P.canTokensBeAdjacent(d, m) && m.range[0] > d.range[1] && e.report({ node: p, messageId: "unexpectedAfterWord", data: { word: y }, fix: function(v) {
      return v.removeRange([d.range[1], m.range[0]]);
    } });
  }
  function a(p, d, m, y) {
    t(y) ? n(y) ? r(p, d, m, y) : i(p, d, m, y) : c.words ? r(p, d, m, y) : i(p, d, m, y);
  }
  function s(p, d, m) {
    if (p.prefix) {
      if (function(y) {
        return y && y.type === "UnaryExpression" && y.argument.operator === "!" && y.argument && y.argument.type === "UnaryExpression" && y.argument.operator === "!";
      }(p))
        return;
      d.range[1] === m.range[0] && e.report({ node: p, messageId: "operator", data: { operator: d.value }, fix: function(y) {
        return y.insertTextAfter(d, " ");
      } });
    } else
      d.range[1] === m.range[0] && e.report({ node: p, messageId: "beforeUnaryExpressions", data: { token: m.value }, fix: function(y) {
        return y.insertTextBefore(m, " ");
      } });
  }
  function o(p, d, m) {
    p.prefix ? m.range[0] > d.range[1] && e.report({ node: p, messageId: "unexpectedAfter", data: { operator: d.value }, fix: function(y) {
      return P.canTokensBeAdjacent(d, m) ? y.removeRange([d.range[1], m.range[0]]) : null;
    } }) : m.range[0] > d.range[1] && e.report({ node: p, messageId: "unexpectedBefore", data: { operator: m.value }, fix: function(y) {
      return y.removeRange([d.range[1], m.range[0]]);
    } });
  }
  function u(p) {
    var d = p.type !== "UpdateExpression" || p.prefix ? f.getFirstTokens(p, 2) : f.getLastTokens(p, 2), m = d[0], y = d[1];
    if (p.type !== "NewExpression" && !p.prefix || m.type !== "Keyword") {
      var v = p.prefix ? d[0].value : d[1].value;
      t(v) ? n(v) ? s(p, m, y) : o(p, m, y) : c.nonwords ? s(p, m, y) : o(p, m, y);
    } else
      a(p, m, y, m.value);
  }
  var c = e.options[0] || { words: !0, nonwords: !1 }, f = e.getSourceCode();
  return { UnaryExpression: u, UpdateExpression: u, NewExpression: u, YieldExpression: function(p) {
    var d = f.getFirstTokens(p, 3);
    !p.argument || p.delegate || a(p, d[0], d[1], "yield");
  }, AwaitExpression: function(p) {
    var d = f.getFirstTokens(p, 3);
    a(p, d[0], d[1], "await");
  } };
} }, "spaced-comment": { meta: { type: "suggestion", docs: { description: "enforce consistent spacing after the `//` or `/*` in a comment", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/spaced-comment" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, line: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } } }, additionalProperties: !1 }, block: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, balanced: { type: "boolean", default: !1 } }, additionalProperties: !1 } }, additionalProperties: !1 }] }, create: function(e) {
  function t(c, f, p, d) {
    var m = c.type.toLowerCase() === "block" ? "/*" : "//";
    e.report({ node: c, fix: function(y) {
      var v = c.range[0], b = v + 2;
      return a ? (p && (b += p[0].length), y.insertTextAfterRange([v, b], " ")) : (b += p[0].length, y.replaceTextRange([v, b], m + (p[1] ? p[1] : "")));
    }, message: f, data: { refChar: d } });
  }
  function n(c, f, p) {
    e.report({ node: c, fix: function(d) {
      if (a)
        return d.insertTextAfterRange([c.range[0], c.range[1] - 2], " ");
      var m = c.range[1] - 2, y = m - p[0].length;
      return d.replaceTextRange([y, m], "");
    }, message: f });
  }
  function r(c) {
    var f = c.type.toLowerCase(), p = u[f], d = f === "block" ? "/*" : "//";
    if (c.value.length !== 0 && !p.markers.has(c.value)) {
      var m = p.beginRegex.exec(c.value), y = p.endRegex.exec(c.value);
      if (a) {
        if (!m) {
          var v = p.captureMarker.exec(c.value), b = v ? d + v[0] : d;
          p.hasExceptions ? t(c, "Expected exception block, space or tab after '{{refChar}}' in comment.", v, b) : t(c, "Expected space or tab after '{{refChar}}' in comment.", v, b);
        }
        o && f === "block" && !y && n(c, "Expected space or tab before '*/' in comment.");
      } else
        m && (m[1] ? t(c, "Unexpected space or tab after marker ({{refChar}}) in comment.", m, m[1]) : t(c, "Unexpected space or tab after '{{refChar}}' in comment.", m, d)), o && f === "block" && y && n(c, "Unexpected space or tab before '*/' in comment.", y);
    }
  }
  var i = e.getSourceCode(), a = e.options[0] !== "never", s = e.options[1] || {}, o = s.block && s.block.balanced, u = ["block", "line"].reduce(function(c, f) {
    var p = function(m) {
      return m.indexOf("*") === -1 ? m.concat("*") : m;
    }(s[f] && s[f].markers || s.markers || []), d = s[f] && s[f].exceptions || s.exceptions || [];
    return c[f] = { beginRegex: a ? rR(p, d) : iR(p), endRegex: o && a ? new RegExp("".concat(KA(d), "$"), "u") : new RegExp("[ 	]+$", "u"), hasExceptions: 0 < d.length, captureMarker: new RegExp("^(".concat(p.map(gc).join("|"), ")"), "u"), markers: new Set(p) }, c;
  }, {});
  return { Program: function() {
    i.getAllComments().filter(function(c) {
      return c.type !== "Shebang";
    }).forEach(r);
  } };
} }, strict: { meta: { type: "suggestion", docs: { description: "require or disallow strict mode directives", category: "Strict Mode", recommended: !1, url: "https://eslint.org/docs/rules/strict" }, schema: [{ enum: ["never", "global", "function", "safe"] }], fixable: "code", messages: { function: "Use the function form of 'use strict'.", global: "Use the global form of 'use strict'.", multiple: "Multiple 'use strict' directives.", never: "Strict mode is not permitted.", unnecessary: "Unnecessary 'use strict' directive.", module: "'use strict' is unnecessary inside of modules.", implied: "'use strict' is unnecessary when implied strict mode is enabled.", unnecessaryInClasses: "'use strict' is unnecessary inside of classes.", nonSimpleParameterList: "'use strict' directive inside a function with non-simple parameter list throws a syntax error since ES2016.", wrap: "Wrap {{name}} in a function with 'use strict' directive." } }, create: function(e) {
  function t(y) {
    return y === "multiple" || y === "unnecessary" || y === "module" || y === "implied" || y === "unnecessaryInClasses";
  }
  function n(y) {
    return function(v) {
      return v.remove(y);
    };
  }
  function r(y, v, b, x, C) {
    y.slice(v, b).forEach(function(k) {
      e.report({ node: k, messageId: x, fix: C ? n(k) : null });
    });
  }
  function i(y, v, b) {
    r(y, 0, y.length, v, b);
  }
  function a(y, v, b) {
    r(y, 1, y.length, v, b);
  }
  function s(y, v) {
    var b = 0 < p.length, x = f.length === 0 && p.length === 0, C = 0 < f.length && f[f.length - 1], k = 0 < v.length;
    k ? (fm(y.params) ? C ? e.report({ node: v[0], messageId: "unnecessary", fix: n(v[0]) }) : b && e.report({ node: v[0], messageId: "unnecessaryInClasses", fix: n(v[0]) }) : e.report({ node: v[0], messageId: "nonSimpleParameterList" }), a(v, "multiple", !0)) : x && (fm(y.params) ? e.report({ node: y, messageId: "function" }) : e.report({ node: y, messageId: "wrap", data: { name: P.getFunctionNameWithKind(y) } })), f.push(C || k);
  }
  function o() {
    f.pop();
  }
  function u(y) {
    var v = y.body.type === "BlockStatement" ? X2(y.body.body) : [];
    d === "function" ? s(y, v) : 0 < v.length && (fm(y.params) ? i(v, d, t(d)) : (e.report({ node: v[0], messageId: "nonSimpleParameterList" }), a(v, "multiple", !0)));
  }
  var c = e.parserOptions.ecmaFeatures || {}, f = [], p = [], d = e.options[0] || "safe";
  c.impliedStrict ? d = "implied" : d === "safe" && (d = c.globalReturn ? "global" : "function");
  var m = { Program: function(y) {
    var v = X2(y.body);
    y.sourceType === "module" && (d = "module"), d === "global" ? (0 < y.body.length && v.length === 0 && e.report({ node: y, messageId: "global" }), a(v, "multiple", !0)) : i(v, d, t(d));
  }, FunctionDeclaration: u, FunctionExpression: u, ArrowFunctionExpression: u };
  return d === "function" && Object.assign(m, { ClassBody: function() {
    p.push(!0);
  }, "ClassBody:exit": function() {
    p.pop();
  }, "FunctionDeclaration:exit": o, "FunctionExpression:exit": o, "ArrowFunctionExpression:exit": o }), m;
} }, "switch-colon-spacing": { meta: { type: "layout", docs: { description: "enforce spacing around colons of switch statements", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/switch-colon-spacing" }, schema: [{ type: "object", properties: { before: { type: "boolean", default: !1 }, after: { type: "boolean", default: !0 } }, additionalProperties: !1 }], fixable: "whitespace", messages: { expectedBefore: "Expected space(s) before this colon.", expectedAfter: "Expected space(s) after this colon.", unexpectedBefore: "Unexpected space(s) before this colon.", unexpectedAfter: "Unexpected space(s) after this colon." } }, create: function(e) {
  function t(o, u, c) {
    return P.isClosingBraceToken(u) || !P.isTokenOnSameLine(o, u) || r.isSpaceBetweenTokens(o, u) === c;
  }
  function n(o, u, c, f) {
    return function(p, d) {
      return r.getFirstTokenBetween(p, d, { includeComments: !0, filter: P.isCommentToken }) !== null;
    }(u, c) ? null : f ? o.insertTextAfter(u, " ") : o.removeRange([u.range[1], c.range[0]]);
  }
  var r = e.getSourceCode(), i = e.options[0] || {}, a = i.before === !0, s = i.after !== !1;
  return { SwitchCase: function(o) {
    var u = function(p) {
      return p.test ? r.getTokenAfter(p.test, P.isColonToken) : r.getFirstToken(p, 1);
    }(o), c = r.getTokenBefore(u), f = r.getTokenAfter(u);
    t(c, u, a) || e.report({ node: o, loc: u.loc, messageId: a ? "expectedBefore" : "unexpectedBefore", fix: function(p) {
      return n(p, c, u, a);
    } }), t(u, f, s) || e.report({ node: o, loc: u.loc, messageId: s ? "expectedAfter" : "unexpectedAfter", fix: function(p) {
      return n(p, u, f, s);
    } });
  } };
} }, "symbol-description": { meta: { type: "suggestion", docs: { description: "require symbol descriptions", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/symbol-description" }, fixable: null, schema: [], messages: { expected: "Expected Symbol to have a description." } }, create: function(e) {
  function t(n) {
    n.arguments.length === 0 && e.report({ node: n, messageId: "expected" });
  }
  return { "Program:exit": function() {
    var n = e.getScope(), r = P.getVariableByName(n, "Symbol");
    r && r.defs.length === 0 && r.references.forEach(function(i) {
      var a = i.identifier;
      P.isCallee(a) && t(a.parent);
    });
  } };
} }, "template-curly-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around embedded expressions of template strings", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/template-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expectedBefore: "Expected space(s) before '}'.", expectedAfter: "Expected space(s) after '${'.", unexpectedBefore: "Unexpected space(s) before '}'.", unexpectedAfter: "Unexpected space(s) after '${'." } }, create: function(e) {
  function t(s) {
    var o = r.getTokenBefore(s);
    o && sR.test(s.value) && P.isTokenOnSameLine(o, s) && r.isSpaceBetweenTokens(o, s) !== i && e.report({ loc: s.loc.start, messageId: "".concat(a, "Before"), fix: function(u) {
      return i ? u.insertTextBefore(s, " ") : u.removeRange([o.range[1], s.range[0]]);
    } });
  }
  function n(s) {
    var o = r.getTokenAfter(s);
    o && oR.test(s.value) && P.isTokenOnSameLine(s, o) && r.isSpaceBetweenTokens(s, o) !== i && e.report({ loc: { line: s.loc.end.line, column: s.loc.end.column - 2 }, messageId: "".concat(a, "After"), fix: function(u) {
      return i ? u.insertTextAfter(s, " ") : u.removeRange([s.range[1], o.range[0]]);
    } });
  }
  var r = e.getSourceCode(), i = e.options[0] === "always", a = i ? "expected" : "unexpected";
  return { TemplateElement: function(s) {
    var o = r.getFirstToken(s);
    t(o), n(o);
  } };
} }, "template-tag-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing between template tags and their literals", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/template-tag-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { unexpected: "Unexpected space between template tag and template literal.", missing: "Missing space between template tag and template literal." } }, create: function(e) {
  var t = e.options[0] !== "always", n = e.getSourceCode();
  return { TaggedTemplateExpression: function(r) {
    var i = n.getTokenBefore(r.quasi), a = n.getFirstToken(r.quasi), s = n.isSpaceBetweenTokens(i, a);
    t && s ? e.report({ node: r, loc: i.loc.start, messageId: "unexpected", fix: function(o) {
      var u = n.getCommentsBefore(r.quasi);
      return u.some(function(c) {
        return c.type === "Line";
      }) ? null : o.replaceTextRange([i.range[1], a.range[0]], u.reduce(function(c, f) {
        return c + n.getText(f);
      }, ""));
    } }) : !t && !s && e.report({ node: r, loc: i.loc.start, messageId: "missing", fix: function(o) {
      return o.insertTextAfter(i, " ");
    } });
  } };
} }, "unicode-bom": { meta: { type: "layout", docs: { description: "require or disallow Unicode byte order mark (BOM)", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/unicode-bom" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expected: "Expected Unicode BOM (Byte Order Mark).", unexpected: "Unexpected Unicode BOM (Byte Order Mark)." } }, create: function(e) {
  return { Program: function(t) {
    var n = e.getSourceCode(), r = { column: 0, line: 1 }, i = e.options[0] || "never";
    n.hasBOM || i !== "always" ? n.hasBOM && i === "never" && e.report({ node: t, loc: r, messageId: "unexpected", fix: function(a) {
      return a.removeRange([-1, 0]);
    } }) : e.report({ node: t, loc: r, messageId: "expected", fix: function(a) {
      return a.insertTextBeforeRange([0, 1], "\uFEFF");
    } });
  } };
} }, "use-isnan": { meta: { type: "problem", docs: { description: "require calls to `isNaN()` when checking for `NaN`", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/use-isnan" }, schema: [{ type: "object", properties: { enforceForSwitchCase: { type: "boolean", default: !1 }, enforceForIndexOf: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { comparisonWithNaN: "Use the isNaN function to compare with NaN.", switchNaN: "'switch(NaN)' can never match a case clause. Use Number.isNaN instead of the switch.", caseNaN: "'case NaN' can never match. Use Number.isNaN before the switch.", indexOfNaN: "Array prototype method '{{ methodName }}' cannot find NaN." } }, create: function(e) {
  var t = e.options[0] && e.options[0].enforceForSwitchCase, n = e.options[0] && e.options[0].enforceForIndexOf, r = { BinaryExpression: function(i) {
    /^(?:[<>]|[!=]=)=?$/.test(i.operator) && (Lu(i.left) || Lu(i.right)) && e.report({ node: i, messageId: "comparisonWithNaN" });
  } };
  return t && (r.SwitchStatement = function(i) {
    Lu(i.discriminant) && e.report({ node: i, messageId: "switchNaN" });
    var a = !0, s = !1, o = void 0;
    try {
      for (var u, c = i.cases[Symbol.iterator](); !(a = (u = c.next()).done); a = !0) {
        var f = u.value;
        Lu(f.test) && e.report({ node: f, messageId: "caseNaN" });
      }
    } catch (p) {
      s = !0, o = p;
    } finally {
      try {
        a || c.return == null || c.return();
      } finally {
        if (s)
          throw o;
      }
    }
  }), n && (r.CallExpression = function(i) {
    var a = i.callee;
    if (a.type === "MemberExpression") {
      var s = P.getStaticPropertyName(a);
      (s === "indexOf" || s === "lastIndexOf") && i.arguments.length === 1 && Lu(i.arguments[0]) && e.report({ node: i, messageId: "indexOfNaN", data: { methodName: s } });
    }
  }), r;
} }, "valid-jsdoc": { meta: { type: "suggestion", docs: { description: "enforce valid JSDoc comments", category: "Possible Errors", recommended: !1, url: "https://eslint.org/docs/rules/valid-jsdoc" }, schema: [{ type: "object", properties: { prefer: { type: "object", additionalProperties: { type: "string" } }, preferType: { type: "object", additionalProperties: { type: "string" } }, requireReturn: { type: "boolean", default: !0 }, requireParamDescription: { type: "boolean", default: !0 }, requireReturnDescription: { type: "boolean", default: !0 }, matchDescription: { type: "string" }, requireReturnType: { type: "boolean", default: !0 }, requireParamType: { type: "boolean", default: !0 } }, additionalProperties: !1 }], fixable: "code", messages: { unexpectedTag: "Unexpected @{{title}} tag; function has no return statement.", expected: "Expected JSDoc for '{{name}}' but found '{{jsdocName}}'.", use: "Use @{{name}} instead.", useType: "Use '{{expectedTypeName}}' instead of '{{currentTypeName}}'.", syntaxError: "JSDoc syntax error.", missingBrace: "JSDoc type missing brace.", missingParamDesc: "Missing JSDoc parameter description for '{{name}}'.", missingParamType: "Missing JSDoc parameter type for '{{name}}'.", missingReturnType: "Missing JSDoc return type.", missingReturnDesc: "Missing JSDoc return description.", missingReturn: "Missing JSDoc @{{returns}} for function.", missingParam: "Missing JSDoc for parameter '{{name}}'.", duplicateParam: "Duplicate JSDoc parameter '{{name}}'.", unsatisfiedDesc: "JSDoc description does not satisfy the regex pattern." }, deprecated: !0, replacedBy: [] }, create: function(e) {
  function t(k) {
    return k.type === "ClassExpression" || k.type === "ClassDeclaration";
  }
  function n(k) {
    C.push({ returnPresent: k.type === "ArrowFunctionExpression" && k.body.type !== "BlockStatement" || t(k) || k.async });
  }
  function r(k) {
    return k.type === null || k.type.name === "void" || k.type.type === "UndefinedLiteral";
  }
  function i(k) {
    var F;
    return k.name ? F = k : k.expression && (F = k.expression), { currentType: F, expectedTypeName: F && b[F.name] };
  }
  function a(k, F) {
    return { start: f.getLocFromIndex(k.range[0] + 2 + F.range[0]), end: f.getLocFromIndex(k.range[0] + 2 + F.range[1]) };
  }
  function s(k, F) {
    if (F && function(S) {
      return S !== "UndefinedLiteral" && S !== "NullLiteral" && S !== "NullableLiteral" && S !== "FunctionType" && S !== "AllLiteral";
    }(F.type)) {
      var B = [], O = [];
      switch (F.type) {
        case "TypeApplication":
          O = F.applications[0].type === "UnionType" ? F.applications[0].elements : F.applications, B.push(i(F));
          break;
        case "RecordType":
          O = F.fields;
          break;
        case "UnionType":
        case "ArrayType":
          O = F.elements;
          break;
        case "FieldType":
          F.value && B.push(i(F.value));
          break;
        default:
          B.push(i(F));
      }
      O.forEach(s.bind(null, k)), B.forEach(function(S) {
        S.expectedTypeName && S.expectedTypeName !== S.currentType.name && e.report({ node: k, messageId: "useType", loc: a(k, S.currentType), data: { currentTypeName: S.currentType.name, expectedTypeName: S.expectedTypeName }, fix: function(w) {
          return w.replaceTextRange(S.currentType.range.map(function(D) {
            return k.range[0] + 2 + D;
          }), S.expectedTypeName);
        } });
      });
    }
  }
  function o(k) {
    var F, B = f.getJSDocComment(k), O = C.pop(), S = /* @__PURE__ */ Object.create(null), w = [], D = !1, I = !1, L = !1, V = !1, K = !1;
    if (B) {
      var W;
      try {
        W = _I.parse(B.value, { strict: !0, unwrap: !0, sloppy: !0, range: !0 });
      } catch (q) {
        return void (/brace[s\u017F]/i.test(q.message) ? e.report({ node: B, messageId: "missingBrace" }) : e.report({ node: B, messageId: "syntaxError" }));
      }
      W.tags.forEach(function(q) {
        switch (q.title.toLowerCase()) {
          case "param":
          case "arg":
          case "argument":
            w.push(q);
            break;
          case "return":
          case "returns":
            D = !0, F = q;
            break;
          case "constructor":
          case "class":
            I = !0;
            break;
          case "override":
          case "inheritdoc":
            V = !0;
            break;
          case "abstract":
          case "virtual":
            K = !0;
            break;
          case "interface":
            L = !0;
        }
        if (Object.prototype.hasOwnProperty.call(c, q.title) && q.title !== c[q.title]) {
          var J = a(B, q);
          e.report({ node: B, messageId: "use", loc: { start: J.start, end: { line: J.start.line, column: J.start.column + "@".concat(q.title).length } }, data: { name: c[q.title] }, fix: function(X) {
            return X.replaceTextRange([B.range[0] + q.range[0] + 3, B.range[0] + q.range[0] + q.title.length + 3], c[q.title]);
          } });
        }
        x && q.type && s(B, q.type);
      }), w.forEach(function(q) {
        v && !q.type && e.report({ node: B, messageId: "missingParamType", loc: a(B, q), data: { name: q.name } }), !q.description && d && e.report({ node: B, messageId: "missingParamDesc", loc: a(B, q), data: { name: q.name } }), S[q.name] ? e.report({ node: B, messageId: "duplicateParam", loc: a(B, q), data: { name: q.name } }) : q.name.indexOf(".") === -1 && (S[q.name] = q);
      }), D && (p || O.returnPresent || F.type !== null && r(F) || K ? (y && !F.type && e.report({ node: B, messageId: "missingReturnType" }), !r(F) && !F.description && m && e.report({ node: B, messageId: "missingReturnDesc" })) : e.report({ node: B, messageId: "unexpectedTag", loc: a(B, F), data: { title: F.title } })), V || D || I || L || k.parent.kind === "get" || k.parent.kind === "constructor" || k.parent.kind === "set" || t(k) || !p && (!O.returnPresent || k.async) || e.report({ node: B, messageId: "missingReturn", data: { returns: c.returns || "returns" } });
      var R = Object.keys(S);
      k.params && k.params.forEach(function(q, J) {
        var X = q.type === "AssignmentPattern" ? q.left : q;
        if (X.type === "Identifier") {
          var ce = X.name;
          R[J] && ce !== R[J] ? e.report({ node: B, messageId: "expected", loc: a(B, S[R[J]]), data: { name: ce, jsdocName: R[J] } }) : !S[ce] && !V && e.report({ node: B, messageId: "missingParam", data: { name: ce } });
        }
      }), u.matchDescription && (new RegExp(u.matchDescription, "u").test(W.description) || e.report({ node: B, messageId: "unsatisfiedDesc" }));
    }
  }
  var u = e.options[0] || {}, c = u.prefer || {}, f = e.getSourceCode(), p = u.requireReturn !== !1, d = u.requireParamDescription !== !1, m = u.requireReturnDescription !== !1, y = u.requireReturnType !== !1, v = u.requireParamType !== !1, b = u.preferType || {}, x = Object.keys(b).length !== 0, C = [];
  return { ArrowFunctionExpression: n, FunctionExpression: n, FunctionDeclaration: n, ClassExpression: n, ClassDeclaration: n, "ArrowFunctionExpression:exit": o, "FunctionExpression:exit": o, "FunctionDeclaration:exit": o, "ClassExpression:exit": o, "ClassDeclaration:exit": o, ReturnStatement: function(k) {
    var F = C[C.length - 1];
    F && k.argument !== null && (F.returnPresent = !0);
  } };
} }, "valid-typeof": { meta: { type: "problem", docs: { description: "enforce comparing `typeof` expressions against valid strings", category: "Possible Errors", recommended: !0, url: "https://eslint.org/docs/rules/valid-typeof" }, schema: [{ type: "object", properties: { requireStringLiterals: { type: "boolean", default: !1 } }, additionalProperties: !1 }], messages: { invalidValue: "Invalid typeof comparison value.", notString: "Typeof comparisons should be to string literals." } }, create: function(e) {
  function t(a) {
    return a.type === "UnaryExpression" && a.operator === "typeof";
  }
  var n = ["symbol", "undefined", "object", "boolean", "number", "string", "function", "bigint"], r = ["==", "===", "!=", "!=="], i = e.options[0] && e.options[0].requireStringLiterals;
  return { UnaryExpression: function(a) {
    if (t(a)) {
      var s = e.getAncestors().pop();
      if (s.type === "BinaryExpression" && r.indexOf(s.operator) !== -1) {
        var o = s.left === a ? s.right : s.left;
        if (o.type === "Literal" || o.type === "TemplateLiteral" && !o.expressions.length) {
          var u = o.type === "Literal" ? o.value : o.quasis[0].value.cooked;
          n.indexOf(u) === -1 && e.report({ node: o, messageId: "invalidValue" });
        } else
          i && !t(o) && e.report({ node: o, messageId: "notString" });
      }
    }
  } };
} }, "vars-on-top": { meta: { type: "suggestion", docs: { description: "require `var` declarations be placed at the top of their containing scope", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/vars-on-top" }, schema: [], messages: { top: "All 'var' declarations must be at the top of the function scope." } }, create: function(e) {
  function t(o) {
    return o.type === "ExpressionStatement" && o.expression.type === "Literal" && typeof o.expression.value == "string";
  }
  function n(o) {
    return o.type === "ImportDeclaration" || o.type === "ImportSpecifier" || o.type === "ImportDefaultSpecifier" || o.type === "ImportNamespaceSpecifier";
  }
  function r(o) {
    return o.type === "VariableDeclaration" || o.type === "ExportNamedDeclaration" && o.declaration && o.declaration.type === "VariableDeclaration";
  }
  function i(o, u) {
    for (var c = u.length, f = 0; f < c && (t(u[f]) || n(u[f])); ++f)
      ;
    for (; f < c; ++f) {
      if (!r(u[f]))
        return !1;
      if (u[f] === o)
        return !0;
    }
    return !1;
  }
  function a(o, u) {
    i(o, u.body) || e.report({ node: o, messageId: "top" });
  }
  function s(o, u, c) {
    /Function/.test(c.type) && u.type === "BlockStatement" && i(o, u.body) || e.report({ node: o, messageId: "top" });
  }
  return { "VariableDeclaration[kind='var']": function(o) {
    o.parent.type === "ExportNamedDeclaration" ? a(o.parent, o.parent.parent) : o.parent.type === "Program" ? a(o, o.parent) : s(o, o.parent, o.parent.parent);
  } };
} }, "wrap-iife": { meta: { type: "layout", docs: { description: "require parentheses around immediate `function` invocations", category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/wrap-iife" }, schema: [{ enum: ["outside", "inside", "any"] }, { type: "object", properties: { functionPrototypeMethods: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "code", messages: { wrapInvocation: "Wrap an immediate function invocation in parentheses.", wrapExpression: "Wrap only the function expression in parens.", moveInvocation: "Move the invocation into the parens that contain the function." } }, create: function(e) {
  function t(s) {
    return P.isParenthesised(a, s);
  }
  function n(s) {
    var o = s.callee;
    return o.type === "FunctionExpression" ? o : !i || o.type !== "MemberExpression" || o.object.type !== "FunctionExpression" || P.getStaticPropertyName(o) !== "call" && P.getStaticPropertyName(o) !== "apply" ? null : o.object;
  }
  var r = e.options[0] || "outside", i = e.options[1] && e.options[1].functionPrototypeMethods, a = e.getSourceCode();
  return { CallExpression: function(s) {
    var o = n(s);
    if (o) {
      var u = t(s), c = t(o);
      u || c ? r !== "inside" || c ? r === "outside" && !u && e.report({ node: s, messageId: "moveInvocation", fix: function(f) {
        var p = a.getTokenAfter(o);
        return f.replaceTextRange([p.range[0], s.range[1]], "".concat(a.getText().slice(p.range[1], s.range[1]), ")"));
      } }) : e.report({ node: s, messageId: "wrapExpression", fix: function(f) {
        var p = a.getTokenAfter(s);
        return f.replaceTextRange([o.range[1], p.range[1]], ")".concat(a.getText().slice(o.range[1], p.range[0])));
      } }) : e.report({ node: s, messageId: "wrapInvocation", fix: function(f) {
        var p = r === "inside" ? o : s;
        return f.replaceText(p, "(".concat(a.getText(p), ")"));
      } });
    }
  } };
} }, "wrap-regex": { meta: { type: "layout", docs: { description: "require parenthesis around regex literals", category: "Stylistic Issues", recommended: !1, url: "https://eslint.org/docs/rules/wrap-regex" }, schema: [], fixable: "code", messages: { requireParens: "Wrap the regexp literal in parens to disambiguate the slash." } }, create: function(e) {
  var t = e.getSourceCode();
  return { Literal: function(n) {
    if (t.getFirstToken(n).type === "RegularExpression") {
      var r = t.getTokenBefore(n), i = t.getTokenAfter(n), a = e.getAncestors(), s = a[a.length - 1];
      s.type !== "MemberExpression" || s.object !== n || r && r.value === "(" && i && i.value === ")" || e.report({ node: n, messageId: "requireParens", fix: function(o) {
        return o.replaceText(n, "(".concat(t.getText(n), ")"));
      } });
    }
  } };
} }, "yield-star-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around the `*` in `yield*` expressions", category: "ECMAScript 6", recommended: !1, url: "https://eslint.org/docs/rules/yield-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: !1 }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e) {
  function t(i, a, s) {
    if (n.isSpaceBetweenTokens(a, s) !== r[i]) {
      var o, u = a.value === "*", c = r[i], f = u ? a : s;
      o = c ? i === "before" ? "missingBefore" : "missingAfter" : i === "before" ? "unexpectedBefore" : "unexpectedAfter", e.report({ node: f, messageId: o, fix: function(p) {
        return c ? u ? p.insertTextAfter(f, " ") : p.insertTextBefore(f, " ") : p.removeRange([a.range[1], s.range[0]]);
      } });
    }
  }
  var n = e.getSourceCode(), r = function(i) {
    return i && typeof i != "string" ? i : { before: { before: !0, after: !1 }, after: { before: !1, after: !0 }, both: { before: !0, after: !0 }, neither: { before: !1, after: !1 } }[i || "after"];
  }(e.options[0]);
  return { YieldExpression: function(i) {
    if (i.delegate) {
      var a = n.getFirstTokens(i, 3), s = a[0], o = a[1], u = a[2];
      t("before", s, o), t("after", o, u);
    }
  } };
} }, yoda: { meta: { type: "suggestion", docs: { description: 'require or disallow "Yoda" conditions', category: "Best Practices", recommended: !1, url: "https://eslint.org/docs/rules/yoda" }, schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptRange: { type: "boolean", default: !1 }, onlyEquality: { type: "boolean", default: !1 } }, additionalProperties: !1 }], fixable: "code", messages: { expected: "Expected literal to be on the {{expectedSide}} side of {{operator}}." } }, create: function(e) {
  function t(u) {
    var c = u.left, f = u.right;
    return u.type === "LogicalExpression" && c.type === "BinaryExpression" && f.type === "BinaryExpression" && Y2(c.operator) && Y2(f.operator) && (function() {
      var p, d;
      return u.operator === "&&" && (p = ep(c.left)) && (d = ep(f.right, Number.POSITIVE_INFINITY)) && p.value <= d.value && rc(c.right, f.left);
    }() || function() {
      var p, d;
      return u.operator === "||" && (p = ep(c.right, Number.NEGATIVE_INFINITY)) && (d = ep(f.left)) && p.value <= d.value && rc(c.left, f.right);
    }()) && P.isParenthesised(s, u);
  }
  function n(u) {
    var c = s.getTokenBefore(u), f = s.getFirstTokenBetween(u.left, u.right, function(x) {
      return x.value === u.operator;
    }), p = s.getText().slice(s.getTokenBefore(f).range[1], f.range[0]), d = s.getText().slice(f.range[1], s.getTokenAfter(f).range[0]), m = s.getText().slice(u.range[0], s.getTokenBefore(f).range[1]), y = s.getTokenAfter(f), v = s.getText().slice(y.range[0], u.range[1]), b = "";
    return c && c.range[1] === u.range[0] && !P.canTokensBeAdjacent(c, y) && (b = " "), b + v + p + o[f.value] + d + m;
  }
  var r = e.options[0] === "always", i = e.options[1] && e.options[1].exceptRange, a = e.options[1] && e.options[1].onlyEquality, s = e.getSourceCode(), o = { "===": "===", "!==": "!==", "==": "==", "!=": "!=", "<": ">", ">": "<", "<=": ">=", ">=": "<=" };
  return { BinaryExpression: function(u) {
    var c = r ? u.left : u.right, f = r ? u.right : u.left;
    f.type !== "Literal" && !m0(f) || c.type === "Literal" || m0(c) || !function(p) {
      return /^(==|===)$/.test(p);
    }(u.operator) && a || !function(p) {
      return /^(==|===|!=|!==|<|>|<=|>=)$/.test(p);
    }(u.operator) || i && t(e.getAncestors().pop()) || e.report({ node: u, messageId: "expected", data: { operator: u.operator, expectedSide: r ? "left" : "right" }, fix: function(p) {
      return p.replaceText(u, n(u));
    } });
  } };
} } }, cR = function(e) {
  function t() {
    var n;
    return We(this, t), (n = Gt(this, rt(t).call(this))).defineRules(uR), n;
  }
  return $t(t, $P.linter_1), t;
}();
export {
  cR as default
};
